/* eslint-disable */
import {
  FieldPolicy,
  FieldReadFunction,
  TypePolicies,
  TypePolicy,
} from '@apollo/client/cache';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  ArrowField: { input: any; output: any };
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: any; output: any };
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: any; output: any };
  /**
   * Return JSON data as a Python object/dictionary rather than a string.
   *
   * Not recommended as it will have type = ANY
   */
  JSONObject: { input: any; output: any };
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: any; output: any };
  /**
   * Leverages the internal Python implmeentation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: any; output: any };
  Upload: { input: any; output: any };
};

export enum AccountCallForwardingStatus {
  ConfirmedComplete = 'CONFIRMED_COMPLETE',
  NotSetup = 'NOT_SETUP',
  SuspectedComplete = 'SUSPECTED_COMPLETE',
  UserReportedAndSuspectedComplete = 'USER_REPORTED_AND_SUSPECTED_COMPLETE',
  UserReportedComplete = 'USER_REPORTED_COMPLETE',
}

export type AccountConnection = {
  __typename?: 'AccountConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AccountEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Account` and its cursor. */
export type AccountEdge = {
  __typename?: 'AccountEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AccountQl>;
};

export type AccountModelFilter = {
  assignmentRetention?: InputMaybe<IntFilter>;
  billingIdentityId?: InputMaybe<StringFilter>;
  brand?: InputMaybe<StringFilter>;
  businessVertical?: InputMaybe<StringFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  escalationsEnabled?: InputMaybe<BooleanFilter>;
  escalationsThreshold?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  isAutotestAccount?: InputMaybe<BooleanFilter>;
  isDemo?: InputMaybe<BooleanFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  name?: InputMaybe<StringFilter>;
  nudgesEnabled?: InputMaybe<BooleanFilter>;
  nudgesThreshold?: InputMaybe<IntFilter>;
  referralUrl?: InputMaybe<StringFilter>;
  resetOngoingOptin?: InputMaybe<IntFilter>;
  resetOptinDays?: InputMaybe<IntFilter>;
  status?: InputMaybe<StringFilter>;
  twilioMessagingServiceSid?: InputMaybe<StringFilter>;
  twilioSubaccountSid?: InputMaybe<StringFilter>;
  twilioSubaccountToken?: InputMaybe<StringFilter>;
  useNewNumber?: InputMaybe<BooleanFilter>;
  verified?: InputMaybe<BooleanFilter>;
};

export enum AccountModelSortEnum {
  AssignmentRetentionAsc = 'assignment_retention_asc',
  AssignmentRetentionDesc = 'assignment_retention_desc',
  BillingIdentityIdAsc = 'billing_identity_id_asc',
  BillingIdentityIdDesc = 'billing_identity_id_desc',
  BrandAsc = 'brand_asc',
  BrandDesc = 'brand_desc',
  BusinessVerticalAsc = 'business_vertical_asc',
  BusinessVerticalDesc = 'business_vertical_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  EscalationsEnabledAsc = 'escalations_enabled_asc',
  EscalationsEnabledDesc = 'escalations_enabled_desc',
  EscalationsThresholdAsc = 'escalations_threshold_asc',
  EscalationsThresholdDesc = 'escalations_threshold_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IsAutotestAccountAsc = 'is_autotest_account_asc',
  IsAutotestAccountDesc = 'is_autotest_account_desc',
  IsDemoAsc = 'is_demo_asc',
  IsDemoDesc = 'is_demo_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  NudgesEnabledAsc = 'nudges_enabled_asc',
  NudgesEnabledDesc = 'nudges_enabled_desc',
  NudgesThresholdAsc = 'nudges_threshold_asc',
  NudgesThresholdDesc = 'nudges_threshold_desc',
  ReferralUrlAsc = 'referral_url_asc',
  ReferralUrlDesc = 'referral_url_desc',
  ResetOngoingOptinAsc = 'reset_ongoing_optin_asc',
  ResetOngoingOptinDesc = 'reset_ongoing_optin_desc',
  ResetOptinDaysAsc = 'reset_optin_days_asc',
  ResetOptinDaysDesc = 'reset_optin_days_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc',
  TwilioMessagingServiceSidAsc = 'twilio_messaging_service_sid_asc',
  TwilioMessagingServiceSidDesc = 'twilio_messaging_service_sid_desc',
  TwilioSubaccountSidAsc = 'twilio_subaccount_sid_asc',
  TwilioSubaccountSidDesc = 'twilio_subaccount_sid_desc',
  TwilioSubaccountTokenAsc = 'twilio_subaccount_token_asc',
  TwilioSubaccountTokenDesc = 'twilio_subaccount_token_desc',
  UseNewNumberAsc = 'use_new_number_asc',
  UseNewNumberDesc = 'use_new_number_desc',
  VerifiedAsc = 'verified_asc',
  VerifiedDesc = 'verified_desc',
}

export type AccountPermissionsQl = {
  __typename?: 'AccountPermissionsQL';
  accountId: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
};

export type AccountQl = BaseQl &
  Node & {
    __typename?: 'AccountQL';
    AssignmentRetention: Scalars['Int']['output'];
    EscalationsEnabled: Scalars['Boolean']['output'];
    EscalationsThreshold: Scalars['Int']['output'];
    ResetOngoingOptin: Scalars['Int']['output'];
    ResetOptinDays: Scalars['Int']['output'];
    appointments?: Maybe<AppointmentQlConnection>;
    archiveMissedCalls: Scalars['Boolean']['output'];
    assignmentRetention: Scalars['Int']['output'];
    assignmentRetentionChoices?: Maybe<Array<AssignmentRetentionChoiceQl>>;
    billingIdentity: BillingIdentityQl;
    billingIdentityId: Scalars['String']['output'];
    brand: Scalars['String']['output'];
    businessProfiles?: Maybe<BusinessProfileQlConnection>;
    businessVertical?: Maybe<Scalars['String']['output']>;
    callForwardingStatus?: Maybe<AccountCallForwardingStatus>;
    channels?: Maybe<BaseChannelConnection>;
    complianceSettings?: Maybe<ComplianceSettingsQl>;
    createdOn: Scalars['ArrowField']['output'];
    curbsideEnabledAtPlaces: Array<Maybe<Scalars['String']['output']>>;
    customers?: Maybe<CustomerQlConnection>;
    dialogFlowBotDatas?: Maybe<DialogFlowBotDataQlConnection>;
    escalationsEnabled: Scalars['Boolean']['output'];
    escalationsThreshold: Scalars['Int']['output'];
    fortellisSubscriptions?: Maybe<FortellisSubscriptionQlConnection>;
    hangupSuggestion?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    isAutotestAccount: Scalars['Boolean']['output'];
    isDemo?: Maybe<Scalars['Boolean']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
    nudgesEnabled: Scalars['Boolean']['output'];
    nudgesThreshold: Scalars['Int']['output'];
    operators?: Maybe<OperatorQlConnection>;
    owners: Array<UserQl>;
    participantCount?: Maybe<Scalars['Int']['output']>;
    participants?: Maybe<ParticipantQlConnection>;
    placeGroups?: Maybe<PlaceGroupQlConnection>;
    places?: Maybe<PlaceConnection>;
    referralUrl?: Maybe<Scalars['String']['output']>;
    resetOngoingOptin: Scalars['Int']['output'];
    resetOptinDays: Scalars['Int']['output'];
    /** @deprecated Resilience Mode is no longer supported */
    resilienceEnabledAtPlaces: Array<Maybe<Scalars['String']['output']>>;
    status: Status_Types;
    twilioMessagingServiceSid?: Maybe<Scalars['String']['output']>;
    twilioSubaccountSid?: Maybe<Scalars['String']['output']>;
    twilioSubaccountToken?: Maybe<Scalars['String']['output']>;
    useNewNumber?: Maybe<Scalars['Boolean']['output']>;
    users?: Maybe<UserConnection>;
    verified: Scalars['Boolean']['output'];
  };

export type AccountQlAppointmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountQlBusinessProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountQlChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountQlCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountQlDialogFlowBotDatasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountQlFortellisSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountQlOperatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountQlParticipantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountQlPlaceGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountQlPlacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<PlaceModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<PlaceModelSortEnum>>>;
};

export type AccountQlUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<UserModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<UserModelSortEnum>>>;
};

export type AccountSettingsQl = {
  __typename?: 'AccountSettingsQL';
  accountId: Scalars['String']['output'];
  archiveMissedCalls?: Maybe<Scalars['Boolean']['output']>;
  assignmentRetention?: Maybe<Scalars['Int']['output']>;
  assignmentRetentionChoices?: Maybe<Array<AssignmentRetentionChoiceQl>>;
  escalationsEnabled: Scalars['Boolean']['output'];
  escalationsThreshold: Scalars['Int']['output'];
  fortellisSubscriptions: Array<FortellisSubscriptionQl>;
  hangupSuggestion?: Maybe<Scalars['String']['output']>;
  nudgesEnabled?: Maybe<Scalars['Boolean']['output']>;
  nudgesThreshold?: Maybe<Scalars['Int']['output']>;
};

export type ActiveInbox = {
  __typename?: 'ActiveInbox';
  inboxId: Scalars['String']['output'];
  isOverdue?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<ActiveInboxOptions>;
  sort?: Maybe<InboxSort>;
  state: ConversationState;
};

export type ActiveInboxOptions = {
  __typename?: 'ActiveInboxOptions';
  unreadOnly?: Maybe<Scalars['Boolean']['output']>;
};

export type ActiveIntegrationQl = BaseQl &
  Node & {
    __typename?: 'ActiveIntegrationQL';
    appointmentAgentSettings: Array<AppointmentAgentSettingsQl>;
    appointmentLeads?: Maybe<AppointmentQlConnection>;
    configuration: Scalars['JSONString']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customers?: Maybe<CustomerQlConnection>;
    friendlyName: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    integration: AvailableIntegrationQl;
    integrationId: Scalars['String']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    opCodes?: Maybe<OpCodeQlConnection>;
    pendingOpcodeSync: Scalars['Boolean']['output'];
    place?: Maybe<PlaceQl>;
    placeGroup?: Maybe<PlaceGroupQl>;
    placeGroupId?: Maybe<Scalars['String']['output']>;
    placeId: Scalars['String']['output'];
    questionAgentSettings?: Maybe<QuestionAgentSettingsQlConnection>;
    repairOrders?: Maybe<RepairOrderFortellisQlConnection>;
    repairServices?: Maybe<RepairServiceQlConnection>;
    schedulerSyncs?: Maybe<SchedulerSyncConnection>;
    serviceAdvisors?: Maybe<CdkServiceAdvisorQlConnection>;
    status: IntegrationStatus;
    xtimeSyncs?: Maybe<XTimeSyncConnection>;
  };

export type ActiveIntegrationQlAppointmentLeadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ActiveIntegrationQlCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ActiveIntegrationQlOpCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ActiveIntegrationQlQuestionAgentSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ActiveIntegrationQlRepairOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ActiveIntegrationQlRepairServicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ActiveIntegrationQlSchedulerSyncsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ActiveIntegrationQlServiceAdvisorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ActiveIntegrationQlXtimeSyncsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ActiveIntegrationQlConnection = {
  __typename?: 'ActiveIntegrationQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ActiveIntegrationQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ActiveIntegrationQL` and its cursor. */
export type ActiveIntegrationQlEdge = {
  __typename?: 'ActiveIntegrationQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ActiveIntegrationQl>;
};

export type ActivePaymentsCollection = {
  __typename?: 'ActivePaymentsCollection';
  collectionId: Scalars['String']['output'];
  status: PaymentsFilterType;
};

export type AddAnsweringScriptToPolicy = {
  __typename?: 'AddAnsweringScriptToPolicy';
  phoneLinePolicy?: Maybe<PhoneLinePolicyQl>;
};

export type AddAnsweringScriptToPolicyInput = {
  answeringScriptType: AnsweringScriptType;
  phoneLinePolicyId: Scalars['String']['input'];
};

export type AddAutomationExitTrigger = {
  __typename?: 'AddAutomationExitTrigger';
  automation?: Maybe<AutomationQl>;
};

export type AddAutomationExitTriggerInput = {
  automationId: Scalars['String']['input'];
  labelsToWatch?: InputMaybe<Array<Scalars['String']['input']>>;
  rulesQuery?: InputMaybe<Scalars['String']['input']>;
  triggerType: Scalars['String']['input'];
};

export type AddAvailableIntegration = {
  __typename?: 'AddAvailableIntegration';
  availableIntegration?: Maybe<AvailableIntegrationQl>;
};

export type AddAvailableIntegrationInput = {
  categories: Array<Scalars['String']['input']>;
  configurationSchema?: InputMaybe<Scalars['JSONString']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featureFlag?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  settingsUrl?: InputMaybe<Scalars['String']['input']>;
  setupType?: InputMaybe<SetupTypeInput>;
};

export type AddCustomLink = {
  __typename?: 'AddCustomLink';
  placeInfo?: Maybe<PlaceInfoQl>;
};

export type AddCustomLinkInput = {
  name: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type AddCustomer = {
  __typename?: 'AddCustomer';
  customer?: Maybe<CustomerQl>;
};

export type AddFortellisSubscription = {
  __typename?: 'AddFortellisSubscription';
  subscription?: Maybe<FortellisSubscriptionQl>;
};

export type AddFortellisSubscriptionInput = {
  accountId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  repairOrderPlaceId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type AddLabelToConversation = {
  __typename?: 'AddLabelToConversation';
  conversation: ConversationQl;
  conversationLabel: ConversationLabelQl;
};

export type AddLabelToConversationInput = {
  conversationId: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['ArrowField']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  labelId: Scalars['String']['input'];
};

export type AddOperatorChannel = {
  __typename?: 'AddOperatorChannel';
  operator: OperatorQl;
  operatorChannel: OperatorChannelQl;
};

export type AddOperatorChannelInput = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  operatorId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type AddOperatorPlace = {
  __typename?: 'AddOperatorPlace';
  operator: OperatorQl;
  operatorPlace: OperatorPlaceQl;
};

export type AddOperatorPlaceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  operatorId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type AddOutboundCallCustomization = {
  __typename?: 'AddOutboundCallCustomization';
  outboundCallCustomization?: Maybe<OutboundCallCustomizationQl>;
};

export type AddOutboundCallCustomizationInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AddPlaceGroup = {
  __typename?: 'AddPlaceGroup';
  placeGroup?: Maybe<PlaceGroupQl>;
};

export type AddPlaceGroupInput = {
  accountId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AddServiceAdvisor = {
  __typename?: 'AddServiceAdvisor';
  serviceAdvisor?: Maybe<ServiceAdvisorQl>;
};

export type AddStage = {
  __typename?: 'AddStage';
  stage?: Maybe<StageQl>;
};

export type AddStageInput = {
  icon: Scalars['String']['input'];
  name: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type AddStatusItem = {
  __typename?: 'AddStatusItem';
  statusItem?: Maybe<StatusItemQl>;
};

export type AddStatusItemInput = {
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eta?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  stageId?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type AddSubscription = {
  __typename?: 'AddSubscription';
  billingIdentity?: Maybe<BillingIdentityQl>;
};

export type AddUserToTeam = {
  __typename?: 'AddUserToTeam';
  team?: Maybe<TeamQl>;
};

export type AddUserToTeamInput = {
  teamId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AddVoiceStep = {
  __typename?: 'AddVoiceStep';
  voiceScript?: Maybe<VoiceScriptQl>;
};

export type AddVoiceStepInput = {
  intentName?: InputMaybe<Scalars['String']['input']>;
  stepType: VoiceScriptStepType;
  uiHints?: InputMaybe<Position>;
  voiceScriptId: Scalars['String']['input'];
};

export type AddressConsentStatusModelQl = BaseQl &
  Node & {
    __typename?: 'AddressConsentStatusModelQL';
    address: Scalars['String']['output'];
    consentCategory?: Maybe<Scalars['String']['output']>;
    consentType?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    customer?: Maybe<CustomerQl>;
    customerId: Scalars['String']['output'];
    deletedAt?: Maybe<Scalars['ArrowField']['output']>;
    id: Scalars['ID']['output'];
    isActive: Scalars['Boolean']['output'];
    isDeleted?: Maybe<Scalars['String']['output']>;
    isPrimary: Scalars['Boolean']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    mediumType: Scalars['String']['output'];
    sourceEntityId: Scalars['String']['output'];
    sourceEntityType: Scalars['String']['output'];
  };

export type AddressQl = BaseQl &
  Node & {
    __typename?: 'AddressQL';
    address?: Maybe<Scalars['String']['output']>;
    addressConsentStatuses?: Maybe<Array<Maybe<AddressConsentStatusModelQl>>>;
    createdOn: Scalars['ArrowField']['output'];
    customer?: Maybe<CustomerQl>;
    customerId: Scalars['String']['output'];
    deletedAt?: Maybe<Scalars['DateTime']['output']>;
    id: Scalars['ID']['output'];
    isActive?: Maybe<Scalars['Boolean']['output']>;
    isDeleted?: Maybe<Scalars['String']['output']>;
    isPrimary?: Maybe<Scalars['Boolean']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    mediumType?: Maybe<Scalars['String']['output']>;
    sourceEntityId?: Maybe<Scalars['String']['output']>;
    sourceEntityType?: Maybe<Scalars['String']['output']>;
  };

export type AgentChitChatResponse = {
  __typename?: 'AgentChitChatResponse';
  /** Updated conversation history */
  conversation: Array<MessageType>;
  /** Index of the current step in the task's steps list */
  currentStep: Scalars['Int']['output'];
  /** Whether the conversation is complete */
  isComplete: Scalars['Boolean']['output'];
  /** Agent's response message */
  reply: Scalars['String']['output'];
  /** Session ID for this conversation */
  sessionId: Scalars['String']['output'];
  /** Updated slot values */
  slots: Scalars['JSONString']['output'];
};

export type AnswerOption = {
  __typename?: 'AnswerOption';
  /** Unique identifier for this answer within its question */
  id: Scalars['String']['output'];
  /** ID of the next question to show if this answer is selected, or NIL if this is a terminating answer */
  nextQuestionId?: Maybe<Scalars['String']['output']>;
  /** The text of the answer option */
  text: Scalars['String']['output'];
};

export enum AnsweringMode {
  Disruption = 'DISRUPTION',
  Holiday = 'HOLIDAY',
  Standard = 'STANDARD',
}

export enum AnsweringScriptType {
  AssigneeAway = 'ASSIGNEE_AWAY',
  Baseline = 'BASELINE',
  OpenRo = 'OPEN_RO',
  Operator = 'OPERATOR',
  RecentRo = 'RECENT_RO',
  RepeatCaller = 'REPEAT_CALLER',
  UpcomingAppointment = 'UPCOMING_APPOINTMENT',
}

export type AnsweringScriptsQl = BaseQl &
  Node & {
    __typename?: 'AnsweringScriptsQL';
    createdOn: Scalars['ArrowField']['output'];
    draftVoiceScript?: Maybe<VoiceScriptQl>;
    draftVoiceScriptId: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    order: Scalars['Int']['output'];
    phoneLinePolicy?: Maybe<PhoneLinePolicyQl>;
    phoneLinePolicyId: Scalars['String']['output'];
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    publishedScriptJson?: Maybe<Scalars['JSONString']['output']>;
    scriptType: AnsweringScriptType;
    voiceScript?: Maybe<VoiceScriptQl>;
    voiceScriptId: Scalars['String']['output'];
  };

export type AnsweringScriptsQlConnection = {
  __typename?: 'AnsweringScriptsQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AnsweringScriptsQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AnsweringScriptsQL` and its cursor. */
export type AnsweringScriptsQlEdge = {
  __typename?: 'AnsweringScriptsQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AnsweringScriptsQl>;
};

export type AppliedIntentQl = BaseQl &
  Node & {
    __typename?: 'AppliedIntentQL';
    autoSendConfidenceThreshold: Scalars['Float']['output'];
    createdOn: Scalars['ArrowField']['output'];
    displayName?: Maybe<Scalars['String']['output']>;
    handling?: Maybe<IntentHandling>;
    id: Scalars['ID']['output'];
    isManaged?: Maybe<Scalars['Boolean']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    libraryIntent?: Maybe<LibraryIntentQl>;
    libraryIntentId: Scalars['String']['output'];
    name?: Maybe<Scalars['String']['output']>;
    numaGeneratedResponse?: Maybe<Scalars['Boolean']['output']>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    renderedResponse?: Maybe<Scalars['String']['output']>;
    response?: Maybe<Scalars['String']['output']>;
    suggestConfidenceThreshold: Scalars['Float']['output'];
    syncInWatson?: Maybe<Scalars['Boolean']['output']>;
    voiceStep?: Maybe<IntentQuestionQlConnection>;
  };

export type AppliedIntentQlVoiceStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppliedIntentQlConnection = {
  __typename?: 'AppliedIntentQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AppliedIntentQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AppliedIntentQL` and its cursor. */
export type AppliedIntentQlEdge = {
  __typename?: 'AppliedIntentQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AppliedIntentQl>;
};

export type AppointmentAgentNoteRatingInput = {
  /** Optional freeform feedback for the rating. */
  details?: InputMaybe<Scalars['String']['input']>;
  /** The reason for the rating. Optional, and should try to be structured. Use `details` for freeform feedback. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** How the user rated the appointment agent note. Assuming a thumbs up/down system, values should be 1 for for thumbs-up, -1 for thumbs-down, 0 for indeterminate. */
  value: Scalars['Int']['input'];
};

export type AppointmentAgentNoteRatingQl = {
  __typename?: 'AppointmentAgentNoteRatingQL';
  details?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  value: Scalars['Int']['output'];
};

export type AppointmentAgentSettingLabelQl = BaseQl &
  Node & {
    __typename?: 'AppointmentAgentSettingLabelQL';
    appointmentAgentSetting?: Maybe<AppointmentAgentSettingsQl>;
    appointmentAgentSettingId: Scalars['String']['output'];
    category?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    label?: Maybe<LabelQl>;
    labelId: Scalars['String']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  };

export type AppointmentAgentSettingsQl = BaseQl &
  Node & {
    __typename?: 'AppointmentAgentSettingsQL';
    activeIntegration?: Maybe<ActiveIntegrationQl>;
    activeIntegrationId?: Maybe<Scalars['String']['output']>;
    agentProfile?: Maybe<Scalars['JSONString']['output']>;
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    defaultExternalOpcode?: Maybe<ExternalOpcodeQl>;
    defaultExternalOpcodeId?: Maybe<Scalars['String']['output']>;
    dialogFlowAgentId?: Maybe<Scalars['String']['output']>;
    enableHangupRecovery: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    labels?: Maybe<Array<Maybe<AppointmentAgentSettingLabelQl>>>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    latestSchedulerSync?: Maybe<SchedulerSyncQl>;
    /** @deprecated Use latest_scheduler_sync instead. Will be removed when mobile support is deprecated. */
    latestXtimeSync?: Maybe<XTimeSyncModelQl>;
    maximumBookingHorizonInDays: Scalars['Int']['output'];
    minimumLeadTimeInMinutes: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    numaInCallFlow: Scalars['String']['output'];
    optionalPrompts?: Maybe<Scalars['JSONString']['output']>;
    overallEmphasis: Scalars['String']['output'];
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    renderedTextingHangupRecovery?: Maybe<Scalars['String']['output']>;
    renderedTextingMessageToSend?: Maybe<Scalars['String']['output']>;
    settings?: Maybe<Scalars['JSONString']['output']>;
    textingCanWeTextSpeech?: Maybe<Scalars['String']['output']>;
    textingHangupRecovery?: Maybe<Scalars['String']['output']>;
    textingMessageToSend?: Maybe<Scalars['String']['output']>;
    textingMessageToSendEndOfCall?: Maybe<Scalars['String']['output']>;
    textingOnNoSpeechCanWeText?: Maybe<Scalars['String']['output']>;
    textingOnYesSpeechCanWeText?: Maybe<Scalars['String']['output']>;
    transportationSets?: Maybe<TransportationSetQlConnection>;
    webSchedulerReliability: Scalars['String']['output'];
  };

export type AppointmentAgentSettingsQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentSettingsQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentSettingsQlTransportationSetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentSettingsQlConnection = {
  __typename?: 'AppointmentAgentSettingsQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AppointmentAgentSettingsQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AppointmentAgentSettingsQL` and its cursor. */
export type AppointmentAgentSettingsQlEdge = {
  __typename?: 'AppointmentAgentSettingsQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AppointmentAgentSettingsQl>;
};

export type AppointmentAgentStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'AppointmentAgentStepQL';
    appointmentAgentSettings?: Maybe<AppointmentAgentSettingsQl>;
    appointmentAgentSettingsId?: Maybe<Scalars['String']['output']>;
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    appointmentLeadStepId?: Maybe<Scalars['String']['output']>;
    appointmentLeadStepRelationship?: Maybe<VoiceScriptStepQl>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    cantServiceCustomerStepId?: Maybe<Scalars['String']['output']>;
    cantServiceCustomerStepRelationship?: Maybe<VoiceScriptStepQl>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    clarifyIntentFirstEnabled: Scalars['Boolean']['output'];
    clarifySpeech: Scalars['String']['output'];
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    exceptionFoundSpeech?: Maybe<Scalars['String']['output']>;
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureSpeech: Scalars['String']['output'];
    failureStepId?: Maybe<Scalars['String']['output']>;
    failureStepRelationship?: Maybe<VoiceScriptStepQl>;
    finishedSpeech: Scalars['String']['output'];
    finishedSpeechAudioUrl: Scalars['String']['output'];
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    modelNotSupportedSpeech?: Maybe<Scalars['String']['output']>;
    nextStepId?: Maybe<Scalars['String']['output']>;
    nextStepRelationship?: Maybe<VoiceScriptStepQl>;
    noAvailableTimesSpeech?: Maybe<Scalars['String']['output']>;
    noServiceTypeSpeech?: Maybe<Scalars['String']['output']>;
    noSpeech: Scalars['String']['output'];
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    notAnAppointmentLeadStepId?: Maybe<Scalars['String']['output']>;
    notAnAppointmentLeadStepRelationship?: Maybe<VoiceScriptStepQl>;
    notBookedOtherStepId?: Maybe<Scalars['String']['output']>;
    notBookedOtherStepRelationship?: Maybe<VoiceScriptStepQl>;
    notBookedRecallStepId?: Maybe<Scalars['String']['output']>;
    notBookedRecallStepRelationship?: Maybe<VoiceScriptStepQl>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    outcomeNotBookedOtherSpeech: Scalars['String']['output'];
    outcomeNotBookedOtherSpeechAudioUrl: Scalars['String']['output'];
    outcomeNotBookedRecallSpeech: Scalars['String']['output'];
    outcomeNotBookedRecallSpeechAudioUrl: Scalars['String']['output'];
    outcomeNotBookedWantsHumanSpeech: Scalars['String']['output'];
    outcomeNotBookedWantsHumanSpeechAudioUrl: Scalars['String']['output'];
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesSpeech: Scalars['String']['output'];
  };

export type AppointmentAgentStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type AppointmentAgentStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlFailureConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type AppointmentAgentStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type AppointmentAgentStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentAgentStepQlConnection = {
  __typename?: 'AppointmentAgentStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AppointmentAgentStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AppointmentAgentStepQL` and its cursor. */
export type AppointmentAgentStepQlEdge = {
  __typename?: 'AppointmentAgentStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AppointmentAgentStepQl>;
};

export type AppointmentLeadCreatedTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'AppointmentLeadCreatedTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    rulesQuery?: Maybe<Scalars['String']['output']>;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
  };

export type AppointmentLeadUpdatedTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'AppointmentLeadUpdatedTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    rulesQuery?: Maybe<Scalars['String']['output']>;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
  };

export type AppointmentQl = BaseQl &
  Node & {
    __typename?: 'AppointmentQL';
    account?: Maybe<AccountQl>;
    accountId: Scalars['String']['output'];
    appointmentDate?: Maybe<Scalars['ArrowField']['output']>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    bookingDetails?: Maybe<Scalars['JSONString']['output']>;
    conversation?: Maybe<ConversationQl>;
    conversationId?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    customer?: Maybe<CustomerQl>;
    customerId?: Maybe<Scalars['String']['output']>;
    dialogFlowBotData?: Maybe<DialogFlowBotDataQl>;
    dialogFlowBotDataId?: Maybe<Scalars['String']['output']>;
    enrichedFrom?: Maybe<AppointmentSource>;
    expiresAt?: Maybe<Scalars['ArrowField']['output']>;
    externalId?: Maybe<Scalars['Int']['output']>;
    externalServiceAdvisorId?: Maybe<Scalars['String']['output']>;
    externalServiceAdvisorName?: Maybe<Scalars['String']['output']>;
    feedbackSubmitted?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    /** Whether an appointment is expected to happen, i.e. not an appointment lead */
    isScheduled?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    numboxAgentSession?: Maybe<NumboxAgentSessionQl>;
    participant?: Maybe<ParticipantQl>;
    participantId: Scalars['String']['output'];
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    rawData?: Maybe<Scalars['JSONString']['output']>;
    repairServices?: Maybe<RepairServiceQlConnection>;
    schedulerActiveIntegration?: Maybe<ActiveIntegrationQl>;
    schedulerActiveIntegrationId?: Maybe<Scalars['String']['output']>;
    schedulerIntegrationInternalType?: Maybe<Scalars['String']['output']>;
    source?: Maybe<AppointmentSource>;
    state: AppointmentState;
  };

export type AppointmentQlRepairServicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentQlConnection = {
  __typename?: 'AppointmentQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AppointmentQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AppointmentQL` and its cursor. */
export type AppointmentQlEdge = {
  __typename?: 'AppointmentQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AppointmentQl>;
};

export enum AppointmentSource {
  AppointmentAgent = 'APPOINTMENT_AGENT',
  Cdk = 'CDK',
  Dealerbuilt = 'DEALERBUILT',
  DealerTrack = 'DEALER_TRACK',
  Imported = 'IMPORTED',
  Manual = 'MANUAL',
  MessageIntent = 'MESSAGE_INTENT',
  Pbs = 'PBS',
  Reynolds = 'REYNOLDS',
  Tekion = 'TEKION',
  VoiceScript = 'VOICE_SCRIPT',
}

export enum AppointmentState {
  Active = 'ACTIVE',
  Booked = 'BOOKED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Inferred = 'INFERRED',
  Lost = 'LOST',
  LostNoShow = 'LOST_NO_SHOW',
  Qualified = 'QUALIFIED',
  Unqualified = 'UNQUALIFIED',
}

export type ArchiveMissedCalls = {
  __typename?: 'ArchiveMissedCalls';
  accountSettings?: Maybe<AccountSettingsQl>;
  channel?: Maybe<TwilioChannelQl>;
  currentAccount?: Maybe<AccountQl>;
  phoneLinePolicy?: Maybe<PhoneLinePolicyQl>;
};

export type ArchiveMissedCallsInput = {
  archiveMissedCalls: Scalars['Boolean']['input'];
  channelId?: InputMaybe<Scalars['String']['input']>;
  phoneLinePolicyId?: InputMaybe<Scalars['String']['input']>;
};

export type ArrowFieldFilter = {
  equal?: InputMaybe<Scalars['ArrowField']['input']>;
  greaterThan?: InputMaybe<Scalars['ArrowField']['input']>;
  ilike?: InputMaybe<Scalars['ArrowField']['input']>;
  in?: InputMaybe<Array<Scalars['ArrowField']['input']>>;
  lessThan?: InputMaybe<Scalars['ArrowField']['input']>;
  like?: InputMaybe<Scalars['ArrowField']['input']>;
  notEqual?: InputMaybe<Scalars['ArrowField']['input']>;
  notIn?: InputMaybe<Array<Scalars['ArrowField']['input']>>;
};

export type AskYesNoQuestionStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'AskYesNoQuestionStepQL';
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    clarifySpeech: Scalars['String']['output'];
    clarifySpeechUrl: Scalars['String']['output'];
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onFailureSpeech: Scalars['String']['output'];
    onFailureSpeechUrl: Scalars['String']['output'];
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    onNoSpeech: Scalars['String']['output'];
    onNoSpeechUrl: Scalars['String']['output'];
    onNoStep?: Maybe<VoiceScriptStepQl>;
    onNoStepId?: Maybe<Scalars['String']['output']>;
    onYesSpeech: Scalars['String']['output'];
    onYesSpeechUrl: Scalars['String']['output'];
    onYesStep?: Maybe<VoiceScriptStepQl>;
    onYesStepId?: Maybe<Scalars['String']['output']>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type AskYesNoQuestionStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type AskYesNoQuestionStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlFailureConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type AskYesNoQuestionStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type AskYesNoQuestionStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AskYesNoQuestionStepQlConnection = {
  __typename?: 'AskYesNoQuestionStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AskYesNoQuestionStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AskYesNoQuestionStepQL` and its cursor. */
export type AskYesNoQuestionStepQlEdge = {
  __typename?: 'AskYesNoQuestionStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AskYesNoQuestionStepQl>;
};

export type AssignConversationActionQl = AutomationAction &
  Node & {
    __typename?: 'AssignConversationActionQL';
    actionType: Scalars['String']['output'];
    assignee?: Maybe<UserQl>;
    assigneeId?: Maybe<Scalars['String']['output']>;
    automation: AutomationQl;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextActionId?: Maybe<Scalars['String']['output']>;
    respectExistingAssignments: Scalars['Boolean']['output'];
    team?: Maybe<TeamQl>;
    teamId?: Maybe<Scalars['String']['output']>;
    uiHints?: Maybe<AutomationUiHints>;
  };

export type AssignConversations = {
  __typename?: 'AssignConversations';
  conversations?: Maybe<Array<Maybe<ConversationQl>>>;
};

export type AssignConversationsInput = {
  allowAssignmentToAwayUsers?: InputMaybe<Scalars['Boolean']['input']>;
  conversationIds: Array<InputMaybe<Scalars['String']['input']>>;
  inboxId: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum AssignmentClaimInput {
  Always = 'ALWAYS',
  Never = 'NEVER',
  WhenUnassigned = 'WHEN_UNASSIGNED',
}

export enum AssignmentClaimSettings {
  Always = 'ALWAYS',
  Never = 'NEVER',
  WhenUnassigned = 'WHEN_UNASSIGNED',
}

export type AssignmentDetailsAttachment = Attachment &
  Node & {
    __typename?: 'AssignmentDetailsAttachment';
    after?: Maybe<Scalars['JSONString']['output']>;
    attachmentType: Scalars['String']['output'];
    before?: Maybe<Scalars['JSONString']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    message?: Maybe<MessageQl>;
    messageId?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
  };

export enum AssignmentEntity {
  Team = 'TEAM',
  Unassigned = 'UNASSIGNED',
  User = 'USER',
}

export type AssignmentFilterInput = {
  /** The ID of the assigned user or team. Not required for checking unassigned conversations. */
  entityId?: InputMaybe<Scalars['String']['input']>;
  /** What kind of assignable entity to filter by (e.g. user, team). For unassigned conversations, set this to UNASSIGNED. */
  entityType: AssignmentEntity;
};

export type AssignmentRetentionChoiceQl = {
  __typename?: 'AssignmentRetentionChoiceQL';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type AssignmentRoutingSettingQl = BaseQl &
  Node & {
    __typename?: 'AssignmentRoutingSettingQL';
    callTimeout: Scalars['Int']['output'];
    createdOn: Scalars['ArrowField']['output'];
    /** @deprecated Use globalOverride instead */
    enabled: Scalars['Boolean']['output'];
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    enabledWhenAway: Scalars['Boolean']['output'];
    forwardingMdn?: Maybe<Scalars['String']['output']>;
    globalOverride: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    placesUsers?: Maybe<PlacesUsersQl>;
    placesUsersId: Scalars['String']['output'];
    useNumaCallerId: Scalars['Boolean']['output'];
  };

export enum AssignmentStyle {
  Manual = 'MANUAL',
  RoundRobin = 'ROUND_ROBIN',
}

export enum AssignmentStyleInput {
  Manual = 'MANUAL',
  RoundRobin = 'ROUND_ROBIN',
}

export type AssistedResponseRatingInput = {
  /** Optional freeform feedback for the rating. */
  details?: InputMaybe<Scalars['String']['input']>;
  /** The question tree that was used for the assisted response, if applicable. */
  questionTree?: InputMaybe<Scalars['JSONString']['input']>;
  /** The section of the feature that the rating is for. Must be one of: 'question_tree', 'response_generation', 'both'. */
  reason: Scalars['String']['input'];
  /** The response generated, if applicable. */
  responseGeneration?: InputMaybe<Scalars['String']['input']>;
  /** How the user rated the assisted response. Assuming a thumbs up/down system, values should be 1 for for thumbs-up, -1 for thumbs-down, 0 for indeterminate. */
  value: Scalars['Int']['input'];
};

export type AssistedResponseRatingQl = {
  __typename?: 'AssistedResponseRatingQL';
  createdOn?: Maybe<Scalars['ArrowField']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  engagementId: Scalars['String']['output'];
  engagementInboxAgentResultId: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  questionTree?: Maybe<Scalars['JSONString']['output']>;
  reason: Scalars['String']['output'];
  responseGeneration?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type Attachment = {
  attachmentType: Scalars['String']['output'];
  createdOn: Scalars['ArrowField']['output'];
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
};

export type AttachmentInput = {
  attachmentType: Scalars['String']['input'];
  file?: InputMaybe<FileAttachmentInput>;
  image?: InputMaybe<ImageAttachmentInput>;
  videoUploadLink?: InputMaybe<VideoUploadLinkAttachmentInput>;
};

export type AudioInput = {
  data: Scalars['Upload']['input'];
  filename: Scalars['String']['input'];
};

export type AuthTokens = {
  __typename?: 'AuthTokens';
  accessToken?: Maybe<Scalars['String']['output']>;
  featureFlags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  refreshToken?: Maybe<Scalars['String']['output']>;
};

export type AutoAssignStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'AutoAssignStepQL';
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    assignee?: Maybe<UserQl>;
    assigneeId?: Maybe<Scalars['String']['output']>;
    autoAssignNextStepId?: Maybe<Scalars['String']['output']>;
    autoAssignNextStepRelationship?: Maybe<VoiceScriptStepQl>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    respectExistingAssignment: Scalars['Boolean']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    team?: Maybe<TeamQl>;
    teamId?: Maybe<Scalars['String']['output']>;
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type AutoAssignStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type AutoAssignStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type AutoAssignStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoAssignStepQlConnection = {
  __typename?: 'AutoAssignStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AutoAssignStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AutoAssignStepQL` and its cursor. */
export type AutoAssignStepQlEdge = {
  __typename?: 'AutoAssignStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AutoAssignStepQl>;
};

export type AutomationAction = {
  actionType: Scalars['String']['output'];
  automation: AutomationQl;
  automationId: Scalars['String']['output'];
  createdOn: Scalars['ArrowField']['output'];
  customersWaiting: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  nextActionId?: Maybe<Scalars['String']['output']>;
  uiHints?: Maybe<AutomationUiHints>;
};

export enum AutomationActionTypeInput {
  AssignConversation = 'ASSIGN_CONVERSATION',
  ChangeConversationState = 'CHANGE_CONVERSATION_STATE',
  CheckOpportunityStatus = 'CHECK_OPPORTUNITY_STATUS',
  CheckRepairOrderDetails = 'CHECK_REPAIR_ORDER_DETAILS',
  EscalateConversation = 'ESCALATE_CONVERSATION',
  HandToOpportunityAgent = 'HAND_TO_OPPORTUNITY_AGENT',
  HasLabel = 'HAS_LABEL',
  IsBusinessHours = 'IS_BUSINESS_HOURS',
  LeaveNote = 'LEAVE_NOTE',
  ManageLabel = 'MANAGE_LABEL',
  NotifyTeamMember = 'NOTIFY_TEAM_MEMBER',
  ScheduleMessage = 'SCHEDULE_MESSAGE',
  SendFeedback = 'SEND_FEEDBACK',
  SendMessage = 'SEND_MESSAGE',
  SendReview = 'SEND_REVIEW',
  SummarizeConversation = 'SUMMARIZE_CONVERSATION',
  UpdateOpportunity = 'UPDATE_OPPORTUNITY',
  Wait = 'WAIT',
}

export type AutomationChannels = {
  __typename?: 'AutomationChannels';
  id: Scalars['String']['output'];
};

export type AutomationChannelsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type AutomationConnection = {
  __typename?: 'AutomationConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AutomationEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export enum AutomationDeletionMode {
  Abort = 'abort',
  MoveToNext = 'move_to_next',
}

/** A Relay edge containing a `Automation` and its cursor. */
export type AutomationEdge = {
  __typename?: 'AutomationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AutomationQl>;
};

export type AutomationGroupQl = BaseQl &
  Node & {
    __typename?: 'AutomationGroupQL';
    automations?: Maybe<Array<Maybe<AutomationQl>>>;
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    /** Return the status of the automation group based on its automations' states. */
    status?: Maybe<Scalars['String']['output']>;
  };

export type AutomationJobConnection = {
  __typename?: 'AutomationJobConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AutomationJobEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AutomationJob` and its cursor. */
export type AutomationJobEdge = {
  __typename?: 'AutomationJobEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AutomationJobQl>;
};

export type AutomationJobModelFilter = {
  automationId?: InputMaybe<StringFilter>;
  completedAt?: InputMaybe<ArrowFieldFilter>;
  conversationId?: InputMaybe<StringFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  currentActionId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  startingEventId?: InputMaybe<StringFilter>;
  startingEventType?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  waitingUntil?: InputMaybe<ArrowFieldFilter>;
};

export enum AutomationJobModelSortEnum {
  AutomationIdAsc = 'automation_id_asc',
  AutomationIdDesc = 'automation_id_desc',
  CompletedAtAsc = 'completed_at_asc',
  CompletedAtDesc = 'completed_at_desc',
  ConversationIdAsc = 'conversation_id_asc',
  ConversationIdDesc = 'conversation_id_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  CurrentActionIdAsc = 'current_action_id_asc',
  CurrentActionIdDesc = 'current_action_id_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  StartingEventIdAsc = 'starting_event_id_asc',
  StartingEventIdDesc = 'starting_event_id_desc',
  StartingEventTypeAsc = 'starting_event_type_asc',
  StartingEventTypeDesc = 'starting_event_type_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc',
  WaitingUntilAsc = 'waiting_until_asc',
  WaitingUntilDesc = 'waiting_until_desc',
}

export type AutomationJobQl = BaseQl &
  Node & {
    __typename?: 'AutomationJobQL';
    automationId: Scalars['String']['output'];
    completedAt?: Maybe<Scalars['ArrowField']['output']>;
    conversation?: Maybe<ConversationQl>;
    conversationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    currentAction?: Maybe<AutomationAction>;
    currentActionId?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    startingEventId: Scalars['String']['output'];
    startingEventType: AutomationTriggerType;
    status?: Maybe<AutomationJobStatus>;
    waitingUntil?: Maybe<Scalars['ArrowField']['output']>;
  };

export type AutomationJobQlConnection = {
  __typename?: 'AutomationJobQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AutomationJobQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AutomationJobQL` and its cursor. */
export type AutomationJobQlEdge = {
  __typename?: 'AutomationJobQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AutomationJobQl>;
};

export enum AutomationJobStatus {
  Aborted = 'ABORTED',
  Completed = 'COMPLETED',
  CompletedEarly = 'COMPLETED_EARLY',
  Running = 'RUNNING',
  Waiting = 'WAITING',
}

export enum AutomationNodeType {
  Action = 'action',
  Trigger = 'trigger',
}

export type AutomationQl = BaseQl &
  Node & {
    __typename?: 'AutomationQL';
    actions: Array<AutomationAction>;
    automationGroupId?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    dateLastPublished?: Maybe<Scalars['ArrowField']['output']>;
    enrollmentCriteria: EnrollmentCriteriaQl;
    exitTriggers: Array<AutomationTrigger>;
    firstAction?: Maybe<AutomationAction>;
    firstActionId?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    latestVersion: Scalars['Int']['output'];
    name?: Maybe<Scalars['String']['output']>;
    placeId: Scalars['String']['output'];
    publishedVersion?: Maybe<Scalars['Int']['output']>;
    startTrigger?: Maybe<AutomationTrigger>;
    state: AutomationState;
  };

export enum AutomationState {
  Deleted = 'DELETED',
  Paused = 'PAUSED',
  Running = 'RUNNING',
}

export type AutomationTrigger = {
  createdOn: Scalars['ArrowField']['output'];
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  triggerType: Scalars['String']['output'];
  uiHints?: Maybe<AutomationUiHints>;
};

export enum AutomationTriggerType {
  AppointmentLeadCreated = 'APPOINTMENT_LEAD_CREATED',
  AppointmentLeadUpdated = 'APPOINTMENT_LEAD_UPDATED',
  CallHandled = 'CALL_HANDLED',
  ConversationArchived = 'CONVERSATION_ARCHIVED',
  ConversationMarkedAsHeatCase = 'CONVERSATION_MARKED_AS_HEAT_CASE',
  ConversationStarted = 'CONVERSATION_STARTED',
  CustomerContacted = 'CUSTOMER_CONTACTED',
  EtoCreated = 'ETO_CREATED',
  LabelAdded = 'LABEL_ADDED',
  LabelRemoved = 'LABEL_REMOVED',
  ManualOpportunity = 'MANUAL_OPPORTUNITY',
  MessageReceived = 'MESSAGE_RECEIVED',
  OpportunityServiceAppointmentConfirmation = 'OPPORTUNITY_SERVICE_APPOINTMENT_CONFIRMATION',
  OpportunityServiceAppointmentReminder = 'OPPORTUNITY_SERVICE_APPOINTMENT_REMINDER',
  RoClose = 'RO_CLOSE',
  RoOpen = 'RO_OPEN',
  RoUpdated = 'RO_UPDATED',
  StaffMemberCallGoesPoorly = 'STAFF_MEMBER_CALL_GOES_POORLY',
  SurveyAnswered = 'SURVEY_ANSWERED',
}

export type AutomationUiHint = {
  nodeId: Scalars['String']['input'];
  nodeType?: InputMaybe<AutomationNodeType>;
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type AutomationUiHints = {
  __typename?: 'AutomationUIHints';
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type AutopilotJobQl = BaseQl &
  Node & {
    __typename?: 'AutopilotJobQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    inspection?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    pickup?: Maybe<Scalars['String']['output']>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    qualityControl?: Maybe<Scalars['String']['output']>;
    service?: Maybe<Scalars['String']['output']>;
    welcome?: Maybe<Scalars['String']['output']>;
  };

export type AutopilotQl = BaseQl &
  Node & {
    __typename?: 'AutopilotQL';
    assignee?: Maybe<UserQl>;
    assigneeId?: Maybe<Scalars['String']['output']>;
    autopilotScheduleMessages: Array<AutopilotScheduledMessageQl>;
    autopilotStatus: AutopilotStatus;
    conversation: ConversationQl;
    conversationId: Scalars['String']['output'];
    createdBy?: Maybe<UserQl>;
    createdById?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    customerName?: Maybe<Scalars['String']['output']>;
    eta: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    identifier?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    previewInspection?: Maybe<Scalars['String']['output']>;
    previewPickup?: Maybe<Scalars['String']['output']>;
    previewQualityControl?: Maybe<Scalars['String']['output']>;
    previewService?: Maybe<Scalars['String']['output']>;
    previewWelcome?: Maybe<Scalars['String']['output']>;
  };

export type AutopilotQlConnection = {
  __typename?: 'AutopilotQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AutopilotQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AutopilotQL` and its cursor. */
export type AutopilotQlEdge = {
  __typename?: 'AutopilotQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AutopilotQl>;
};

export type AutopilotScheduledMessageQl = BaseQl &
  Node & {
    __typename?: 'AutopilotScheduledMessageQL';
    autopilot?: Maybe<AutopilotQl>;
    autopilotId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    milestoneName: Scalars['String']['output'];
    scheduled: ScheduledMessageQl;
    scheduledId: Scalars['String']['output'];
  };

export enum AutopilotStatus {
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  Inprogress = 'INPROGRESS',
}

export type AvailableIntegrationQl = BaseQl &
  Node & {
    __typename?: 'AvailableIntegrationQL';
    categories: Array<Scalars['String']['output']>;
    configurationSchema: Scalars['JSONString']['output'];
    createdOn: Scalars['ArrowField']['output'];
    defaultConfiguration: Scalars['JSONString']['output'];
    description: Scalars['String']['output'];
    featureFlag?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    internalId: Scalars['String']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
    settingsUrl?: Maybe<Scalars['String']['output']>;
    setupType: SetupType;
  };

export type AvailableVoiceScript = BaseQl &
  Node & {
    __typename?: 'AvailableVoiceScript';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    place: PlaceQl;
    previewScript: Array<Scalars['String']['output']>;
    scriptSteps: Array<AvailableVoiceStep>;
    scriptType: Scalars['String']['output'];
  };

export type AvailableVoiceStep = BaseQl &
  Node & {
    __typename?: 'AvailableVoiceStep';
    canToggle: Scalars['Boolean']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    label: Scalars['String']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  };

export type BandwidthChannelQl = Channel &
  Node & {
    __typename?: 'BandwidthChannelQL';
    account: AccountQl;
    accountId: Scalars['String']['output'];
    assignee?: Maybe<UserQl>;
    assigneeId?: Maybe<Scalars['String']['output']>;
    channelType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    identityPromptOption: IdentityPromptOptions;
    isActive: Scalars['Boolean']['output'];
    isBotEnabled: Scalars['Boolean']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    mdn: Scalars['String']['output'];
    name?: Maybe<Scalars['String']['output']>;
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    respectExistingAssignments?: Maybe<Scalars['Boolean']['output']>;
    team?: Maybe<TeamQl>;
    teamId?: Maybe<Scalars['String']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
  };

export type BaseChannel = Channel &
  Node & {
    __typename?: 'BaseChannel';
    Assignee?: Maybe<UserQl>;
    AssigneeId?: Maybe<Scalars['String']['output']>;
    RespectExistingAssignments?: Maybe<Scalars['Boolean']['output']>;
    Team?: Maybe<TeamQl>;
    TeamId?: Maybe<Scalars['String']['output']>;
    account: AccountQl;
    accountId: Scalars['String']['output'];
    assignTextReplies?: Maybe<Scalars['String']['output']>;
    assignee?: Maybe<UserQl>;
    assigneeId?: Maybe<Scalars['String']['output']>;
    channelType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    identityPromptAddresses?: Maybe<IdentityPromptAddressQlConnection>;
    identityPromptOption: IdentityPromptOptions;
    isActive: Scalars['Boolean']['output'];
    isBotEnabled: Scalars['Boolean']['output'];
    isNryChannel?: Maybe<Scalars['Boolean']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messages?: Maybe<MessageQlConnection>;
    name?: Maybe<Scalars['String']['output']>;
    operator?: Maybe<OperatorQl>;
    operatorId?: Maybe<Scalars['String']['output']>;
    operatorSessions?: Maybe<OperatorSessionQlConnection>;
    outboundConferenceCall?: Maybe<OutboundConferenceCallQlConnection>;
    outboundProxyCall?: Maybe<OutboundProxyCallQlConnection>;
    phonecalls?: Maybe<PhoneCallQlConnection>;
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    respectExistingAssignments?: Maybe<Scalars['Boolean']['output']>;
    scheduled?: Maybe<ScheduledMessageQlConnection>;
    smsChannel?: Maybe<BaseChannel>;
    smsPhonelines?: Maybe<PhoneLineQlConnection>;
    supportsVoicemail?: Maybe<Scalars['Boolean']['output']>;
    team?: Maybe<TeamQl>;
    teamId?: Maybe<Scalars['String']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
  };

export type BaseChannelIdentityPromptAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseChannelMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseChannelOperatorSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseChannelOutboundConferenceCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseChannelOutboundProxyCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseChannelPhonecallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseChannelScheduledArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseChannelSmsPhonelinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseChannelConnection = {
  __typename?: 'BaseChannelConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BaseChannelEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BaseChannel` and its cursor. */
export type BaseChannelEdge = {
  __typename?: 'BaseChannelEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BaseChannel>;
};

export type BaseOutboundProxyNumber = Node &
  OutboundProxyNumber & {
    __typename?: 'BaseOutboundProxyNumber';
    carrierType?: Maybe<OutboundProxyCarrierType>;
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name?: Maybe<Scalars['String']['output']>;
  };

export type BaseQl = {
  createdOn: Scalars['ArrowField']['output'];
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
};

export type BaseRepairOrder = Node &
  RepairOrder & {
    __typename?: 'BaseRepairOrder';
    activeIntegration?: Maybe<ActiveIntegrationQl>;
    activeIntegrationId?: Maybe<Scalars['String']['output']>;
    completedTime?: Maybe<Scalars['ArrowField']['output']>;
    conversation?: Maybe<ConversationQl>;
    conversationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customer?: Maybe<CustomerQl>;
    customerId?: Maybe<Scalars['String']['output']>;
    data?: Maybe<Scalars['JSONString']['output']>;
    dmsStatus?: Maybe<Scalars['String']['output']>;
    externalServiceAdvisorId?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    isActive?: Maybe<Scalars['String']['output']>;
    isCompleted?: Maybe<Scalars['String']['output']>;
    lastDmsUpdate?: Maybe<Scalars['ArrowField']['output']>;
    lastSeenAt?: Maybe<Scalars['ArrowField']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messages?: Maybe<MessageQlConnection>;
    opCodes?: Maybe<Scalars['JSONString']['output']>;
    openedTime?: Maybe<Scalars['ArrowField']['output']>;
    orderNumber?: Maybe<Scalars['String']['output']>;
    participant?: Maybe<Scalars['String']['output']>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    promisedTime?: Maybe<Scalars['ArrowField']['output']>;
    repairOrderType: RepairOrderType;
    roStatus?: Maybe<Scalars['String']['output']>;
    serviceAdvisor?: Maybe<ServiceAdvisorQl>;
    serviceAdvisorName?: Maybe<Scalars['String']['output']>;
    status: RepairOrderStatus;
    statusItem?: Maybe<StatusItemQl>;
    tagNumber?: Maybe<Scalars['String']['output']>;
    transportationFlags?: Maybe<Scalars['JSONString']['output']>;
    user?: Maybe<UserQl>;
    userId: Scalars['String']['output'];
    vehicleMake?: Maybe<Scalars['String']['output']>;
    vehicleMakeFriendly?: Maybe<Scalars['String']['output']>;
    vehicleMileage?: Maybe<Scalars['String']['output']>;
    vehicleModel?: Maybe<Scalars['String']['output']>;
    vehicleModelFriendly?: Maybe<Scalars['String']['output']>;
    vehicleVin?: Maybe<Scalars['String']['output']>;
    vehicleYear?: Maybe<Scalars['Int']['output']>;
  };

export type BaseRepairOrderMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingIdentityConnection = {
  __typename?: 'BillingIdentityConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BillingIdentityEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BillingIdentity` and its cursor. */
export type BillingIdentityEdge = {
  __typename?: 'BillingIdentityEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BillingIdentityQl>;
};

export type BillingIdentityModelFilter = {
  billingOrderId?: InputMaybe<StringFilter>;
  brand?: InputMaybe<StringFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  email?: InputMaybe<StringFilter>;
  eulaAcceptanceDate?: InputMaybe<ArrowFieldFilter>;
  firstPaymentDate?: InputMaybe<ArrowFieldFilter>;
  id?: InputMaybe<StringFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  name?: InputMaybe<StringFilter>;
  notifiedDelinquent?: InputMaybe<ArrowFieldFilter>;
  paymentSource?: InputMaybe<StringFilter>;
  paymentSourceId?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  productOffering?: InputMaybe<StringFilter>;
  resellerId?: InputMaybe<StringFilter>;
  signupMode?: InputMaybe<StringFilter>;
  signupParams?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
};

export enum BillingIdentityModelSortEnum {
  BillingOrderIdAsc = 'billing_order_id_asc',
  BillingOrderIdDesc = 'billing_order_id_desc',
  BrandAsc = 'brand_asc',
  BrandDesc = 'brand_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  EmailAsc = 'email_asc',
  EmailDesc = 'email_desc',
  EulaAcceptanceDateAsc = 'eula_acceptance_date_asc',
  EulaAcceptanceDateDesc = 'eula_acceptance_date_desc',
  FirstPaymentDateAsc = 'first_payment_date_asc',
  FirstPaymentDateDesc = 'first_payment_date_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  NotifiedDelinquentAsc = 'notified_delinquent_asc',
  NotifiedDelinquentDesc = 'notified_delinquent_desc',
  PaymentSourceAsc = 'payment_source_asc',
  PaymentSourceDesc = 'payment_source_desc',
  PaymentSourceIdAsc = 'payment_source_id_asc',
  PaymentSourceIdDesc = 'payment_source_id_desc',
  PhoneAsc = 'phone_asc',
  PhoneDesc = 'phone_desc',
  ProductOfferingAsc = 'product_offering_asc',
  ProductOfferingDesc = 'product_offering_desc',
  ResellerIdAsc = 'reseller_id_asc',
  ResellerIdDesc = 'reseller_id_desc',
  SignupModeAsc = 'signup_mode_asc',
  SignupModeDesc = 'signup_mode_desc',
  SignupParamsAsc = 'signup_params_asc',
  SignupParamsDesc = 'signup_params_desc',
  SourceAsc = 'source_asc',
  SourceDesc = 'source_desc',
}

export type BillingIdentityQl = BaseQl &
  Node & {
    __typename?: 'BillingIdentityQL';
    account?: Maybe<AccountQl>;
    billingOrderId: Scalars['String']['output'];
    brand?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    email: Scalars['String']['output'];
    eulaAcceptanceDate?: Maybe<Scalars['ArrowField']['output']>;
    firstPaymentDate?: Maybe<Scalars['ArrowField']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    notifiedDelinquent?: Maybe<Scalars['ArrowField']['output']>;
    paymentSource: PaymentSource;
    paymentSourceId?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    productOffering?: Maybe<ProductOffering>;
    resellerId?: Maybe<Scalars['String']['output']>;
    signupMode?: Maybe<Scalars['String']['output']>;
    signupParams?: Maybe<Scalars['String']['output']>;
    signupUser?: Maybe<UserQl>;
    source: Scalars['String']['output'];
    subscriptions: Array<SubscriptionQl>;
  };

export type BillingMetadataQl = BaseQl &
  Node & {
    __typename?: 'BillingMetadataQL';
    chargebeeCustomerId?: Maybe<Scalars['String']['output']>;
    chargebeeSubscriptionId?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    hubspotCompanyId?: Maybe<Scalars['String']['output']>;
    hubspotContactId?: Maybe<Scalars['String']['output']>;
    hubspotDealId: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
  };

export enum BillingStatus {
  Active = 'ACTIVE',
  CardDeclined = 'CARD_DECLINED',
  CardExpired = 'CARD_EXPIRED',
  Delinquent = 'DELINQUENT',
  GracePeriod = 'GRACE_PERIOD',
  InTrial = 'IN_TRIAL',
  Unknown = 'UNKNOWN',
}

export type BooleanFilter = {
  equal?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  ilike?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['Boolean']['input']>;
  notEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type BrandThemeQl = BaseQl &
  Node & {
    __typename?: 'BrandThemeQL';
    bodyBackgroundColor: Scalars['String']['output'];
    bodyBorderColor: Scalars['String']['output'];
    bodyTextColor: Scalars['String']['output'];
    buttonColor?: Maybe<Scalars['String']['output']>;
    buttonPrimaryBackgroundColor: Scalars['String']['output'];
    buttonPrimaryBorderColor: Scalars['String']['output'];
    buttonPrimaryTextColor: Scalars['String']['output'];
    buttonSecondaryBackgroundColor: Scalars['String']['output'];
    buttonSecondaryBorderColor: Scalars['String']['output'];
    buttonSecondaryTextColor: Scalars['String']['output'];
    buttonTextColor?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    headerBackgroundColor: Scalars['String']['output'];
    headerBorderColor: Scalars['String']['output'];
    headerTextColor: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    logoUrl?: Maybe<Scalars['String']['output']>;
    paletteType: Scalars['String']['output'];
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    stylesheetOverride?: Maybe<Scalars['String']['output']>;
    supportedPaletteTypes: Array<PaletteQl>;
  };

export type BuildRepairOrderAssistedStatusQuestionTree = {
  __typename?: 'BuildRepairOrderAssistedStatusQuestionTree';
  /** The generated question tree */
  questionTree: QuestionTree;
};

export type BuildRepairOrderAssistedStatusQuestionTreeInput = {
  conversationId: Scalars['String']['input'];
  /** What the user has written so far to send, but has not yet actually sent */
  writtenUnsentMessageText?: InputMaybe<Scalars['String']['input']>;
};

export type BuildWriteItForMeQuestionTree = {
  __typename?: 'BuildWriteItForMeQuestionTree';
  /** The generated question tree */
  questionTree: WriteItForMeQuestionTree;
  /** List of tones that can be used for the generated content */
  tones: Array<Scalars['String']['output']>;
};

export type BuildWriteItForMeQuestionTreeInput = {
  conversationId: Scalars['String']['input'];
  /** Specific aim the user seeks to achieve (e.g. is this for a status update) */
  intent: Scalars['String']['input'];
  /** What the user has written so far to send, but has not yet actually sent */
  writtenUnsentMessageText?: InputMaybe<Scalars['String']['input']>;
};

export type BulkUpdateSupportedVehicles = {
  __typename?: 'BulkUpdateSupportedVehicles';
  supportedVehicles?: Maybe<Array<SupportedVehiclesQl>>;
};

export type BulkUpdateSupportedVehiclesInput = {
  supportedVehicles: Array<InputMaybe<UpdateSupportedVehiclesInput>>;
};

export type BusinessIdentityInput = {
  businessType?: InputMaybe<BusinessType>;
  city: Scalars['String']['input'];
  country: Country;
  email: Scalars['String']['input'];
  entityType?: InputMaybe<TwilioEntityType>;
  firstName: Scalars['String']['input'];
  industry?: InputMaybe<TwilioVertical>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  secondaryStreet?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  stockExchange?: InputMaybe<StockExchange>;
  stockTickerSymbol?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
  websiteUrl: Scalars['String']['input'];
  zipCode: Scalars['Int']['input'];
};

export type BusinessIdentityModelQl = BaseQl &
  Node & {
    __typename?: 'BusinessIdentityModelQL';
    businessType: BusinessType;
    city: Scalars['String']['output'];
    country: Country;
    createdOn: Scalars['ArrowField']['output'];
    email: Scalars['String']['output'];
    entityType: TwilioEntityType;
    firstName: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    industry: TwilioVertical;
    jobTitle?: Maybe<Scalars['String']['output']>;
    lastName: Scalars['String']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    legalName: Scalars['String']['output'];
    mobilePhone: Scalars['String']['output'];
    phone: Scalars['String']['output'];
    secondaryStreet?: Maybe<Scalars['String']['output']>;
    state: Scalars['String']['output'];
    stockExchange?: Maybe<Scalars['String']['output']>;
    stockTickerSymbol?: Maybe<Scalars['String']['output']>;
    street: Scalars['String']['output'];
    taxId?: Maybe<Scalars['String']['output']>;
    twilioTrustProductId: Scalars['String']['output'];
    websiteUrl: Scalars['String']['output'];
    zipCode: Scalars['Int']['output'];
  };

export type BusinessProfileQl = BaseQl &
  Node & {
    __typename?: 'BusinessProfileQL';
    account: AccountQl;
    accountId: Scalars['String']['output'];
    brandSid?: Maybe<Scalars['String']['output']>;
    businessIndustry?: Maybe<Scalars['String']['output']>;
    businessRegionsOfOperations?: Maybe<Scalars['String']['output']>;
    businessRegistrationIdType?: Maybe<Scalars['String']['output']>;
    businessRegistrationNumber?: Maybe<Scalars['String']['output']>;
    businessRegistrationNumberType?: Maybe<Scalars['String']['output']>;
    businessType?: Maybe<Scalars['String']['output']>;
    campaignSid?: Maybe<Scalars['String']['output']>;
    companyStatus?: Maybe<Scalars['String']['output']>;
    contact1BusinessTitle?: Maybe<Scalars['String']['output']>;
    contact1Email?: Maybe<Scalars['String']['output']>;
    contact1FirstName?: Maybe<Scalars['String']['output']>;
    contact1JobPosition?: Maybe<Scalars['String']['output']>;
    contact1LastName?: Maybe<Scalars['String']['output']>;
    contact1PhoneNumber?: Maybe<Scalars['String']['output']>;
    contact2BusinessTitle?: Maybe<Scalars['String']['output']>;
    contact2Email?: Maybe<Scalars['String']['output']>;
    contact2FirstName?: Maybe<Scalars['String']['output']>;
    contact2JobPosition?: Maybe<Scalars['String']['output']>;
    contact2LastName?: Maybe<Scalars['String']['output']>;
    contact2PhoneNumber?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    legalBusinessName?: Maybe<Scalars['String']['output']>;
    physicalAddress?: Maybe<Scalars['String']['output']>;
    places?: Maybe<PlaceQlConnection>;
    registrationStatus?: Maybe<Scalars['String']['output']>;
    registrationType?: Maybe<Scalars['String']['output']>;
    socialMediaUrl?: Maybe<Scalars['String']['output']>;
    stockTickerExchange?: Maybe<Scalars['String']['output']>;
    websiteUrl?: Maybe<Scalars['String']['output']>;
  };

export type BusinessProfileQlPlacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BusinessProfileQlConnection = {
  __typename?: 'BusinessProfileQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BusinessProfileQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BusinessProfileQL` and its cursor. */
export type BusinessProfileQlEdge = {
  __typename?: 'BusinessProfileQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BusinessProfileQl>;
};

export enum BusinessType {
  CoOperative = 'Co_operative',
  Corporation = 'Corporation',
  LimitedLiabilityCorporation = 'Limited_Liability_Corporation',
  NonProfitCorporation = 'Non_profit_Corporation',
  Partnership = 'Partnership',
}

export type CdkServiceAdvisorQl = BaseQl &
  Node & {
    __typename?: 'CDKServiceAdvisorQL';
    activeIntegration?: Maybe<ActiveIntegrationQl>;
    activeIntegrationId?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    fortellisSubscription?: Maybe<FortellisSubscriptionQl>;
    fortellisSubscriptionId?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    nextFetchTime?: Maybe<Scalars['ArrowField']['output']>;
    placeId?: Maybe<Scalars['String']['output']>;
    placesUser?: Maybe<PlacesUsersQl>;
    placesUsersId: Scalars['String']['output'];
    rawData?: Maybe<Scalars['JSONString']['output']>;
    repairOrderSchedule: Scalars['JSONString']['output'];
    serviceAdvisorId?: Maybe<Scalars['String']['output']>;
    serviceAdvisorName?: Maybe<Scalars['String']['output']>;
    type?: Maybe<ServiceAdvisorType>;
    user?: Maybe<UserQl>;
    userId?: Maybe<Scalars['String']['output']>;
  };

export type CdkServiceAdvisorQlConnection = {
  __typename?: 'CDKServiceAdvisorQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CdkServiceAdvisorQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CDKServiceAdvisorQL` and its cursor. */
export type CdkServiceAdvisorQlEdge = {
  __typename?: 'CDKServiceAdvisorQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CdkServiceAdvisorQl>;
};

export type CrmEmailQl = {
  __typename?: 'CRMEmailQL';
  address: Scalars['String']['output'];
};

export enum CallForwardingMode {
  Assignee = 'ASSIGNEE',
  Dial = 'DIAL',
}

export enum CallForwardingModeInput {
  Assignee = 'ASSIGNEE',
  Dial = 'DIAL',
}

export enum CallForwardingStatus {
  ConfirmedComplete = 'CONFIRMED_COMPLETE',
  NotSetup = 'NOT_SETUP',
  SuspectedComplete = 'SUSPECTED_COMPLETE',
  UserReportedAndSuspectedComplete = 'USER_REPORTED_AND_SUSPECTED_COMPLETE',
  UserReportedComplete = 'USER_REPORTED_COMPLETE',
}

export enum CallForwardingStatusInput {
  ConfirmedComplete = 'CONFIRMED_COMPLETE',
  NotSetup = 'NOT_SETUP',
  SuspectedComplete = 'SUSPECTED_COMPLETE',
  UserReportedAndSuspectedComplete = 'USER_REPORTED_AND_SUSPECTED_COMPLETE',
  UserReportedComplete = 'USER_REPORTED_COMPLETE',
}

export type CallForwardingStepMdnQl = {
  __typename?: 'CallForwardingStepMdnQL';
  forwardingMdn?: Maybe<Scalars['String']['output']>;
  forwardingMode: CallForwardingMode;
};

export type CallForwardingStepMdnsInput = {
  forwardingMdn?: InputMaybe<Scalars['String']['input']>;
  forwardingMode?: InputMaybe<CallForwardingModeInput>;
};

export type CallForwardingStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'CallForwardingStepQL';
    ForwardingMdn?: Maybe<Scalars['String']['output']>;
    ForwardingMode: Callforwardingmode;
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    callTimeout: Scalars['Int']['output'];
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingMdn?: Maybe<Scalars['String']['output']>;
    forwardingMdns?: Maybe<Array<CallForwardingStepMdnQl>>;
    forwardingMode?: Maybe<Scalars['String']['output']>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    noAnswerSpeech: Scalars['String']['output'];
    noAnswerSpeechUrl: Scalars['String']['output'];
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onConnectedStep?: Maybe<VoiceScriptStepQl>;
    onConnectedStepId?: Maybe<Scalars['String']['output']>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoAnsweringStep?: Maybe<VoiceScriptStepQl>;
    onNoAnsweringStepId?: Maybe<Scalars['String']['output']>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    useNumaCallerId: Scalars['Boolean']['output'];
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type CallForwardingStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type CallForwardingStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlFailureConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type CallForwardingStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type CallForwardingStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallForwardingStepQlConnection = {
  __typename?: 'CallForwardingStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CallForwardingStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CallForwardingStepQL` and its cursor. */
export type CallForwardingStepQlEdge = {
  __typename?: 'CallForwardingStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CallForwardingStepQl>;
};

export enum CallIntelligencePermissionType {
  Everyone = 'EVERYONE',
  Managers = 'MANAGERS',
  ParticipantsAndManagers = 'PARTICIPANTS_AND_MANAGERS',
}

export type CallIntelligenceRatingInput = {
  /** Optional freeform feedback for the rating. */
  details?: InputMaybe<Scalars['String']['input']>;
  /** The reason for the rating. Optional, and should try to be structured. Use `details` for freeform feedback. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Optional the interaction source (ex: specific page/component, web/mobile). */
  source?: InputMaybe<Scalars['String']['input']>;
  /** How the user rated the call intelligence. Assuming a thumbs up/down system, values should be 1 for for thumbs-up, -1 for thumbs-down, 0 for indeterminate. */
  value: Scalars['Int']['input'];
};

export type CallIntelligenceRatingQl = {
  __typename?: 'CallIntelligenceRatingQL';
  createdOn?: Maybe<Scalars['ArrowField']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  transcriptAnalysisId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export enum CallIntelligenceSettingOptions {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
}

export type CallIntelligenceSettingQl = BaseQl &
  Node & {
    __typename?: 'CallIntelligenceSettingQL';
    activeUserSeatsSettings?: Maybe<PlacesUsersQlConnection>;
    availableSeats: Scalars['Int']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customDisclosureSpeech?: Maybe<CustomDisclosureSpeech>;
    customDisclosureSpeechOverride?: Maybe<CallIntelligenceSettingOptions>;
    customDisclosureSpeechUrl?: Maybe<Scalars['String']['output']>;
    disclosureContent: Scalars['String']['output'];
    disclosureSpeechUrl?: Maybe<Scalars['String']['output']>;
    enabled?: Maybe<CallIntelligenceSettingOptions>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    permissions?: Maybe<CallIntelligencePermissionType>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    playDisclosureSpeech?: Maybe<CallIntelligenceSettingOptions>;
    renderedDisclosureContent?: Maybe<Scalars['String']['output']>;
    seatLimit: Scalars['Int']['output'];
  };

export type CallIntelligenceSettingQlActiveUserSeatsSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum CallOutcomes {
  BotHandled = 'BOT_HANDLED',
  Callback = 'CALLBACK',
  Hangup = 'HANGUP',
  HangupText = 'HANGUP_TEXT',
  NoInteraction = 'NO_INTERACTION',
  Other = 'OTHER',
  Patch = 'PATCH',
  Text = 'TEXT',
  Voicemail = 'VOICEMAIL',
}

export type CallRecordConnection = {
  __typename?: 'CallRecordConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CallRecordEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CallRecord` and its cursor. */
export type CallRecordEdge = {
  __typename?: 'CallRecordEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CallRecordQl>;
};

/** A call record that contains standardized fields from PhoneCall and OutboundConferenceCall. */
export type CallRecordQl = Node & {
  __typename?: 'CallRecordQL';
  callDuration?: Maybe<Scalars['Int']['output']>;
  callType: Scalars['String']['output'];
  createdOn: Scalars['ArrowField']['output'];
  customerDisplayName?: Maybe<Scalars['String']['output']>;
  customerPhoneNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCallIntelligenceEligible?: Maybe<Scalars['Boolean']['output']>;
  placeName?: Maybe<Scalars['String']['output']>;
  returnCallsRoutingOutcome?: Maybe<Scalars['String']['output']>;
  staffDisplayName?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<TranscriptQl>;
};

export type CallRecordingQl = BaseQl &
  Node & {
    __typename?: 'CallRecordingQL';
    callRecordingSid?: Maybe<Scalars['String']['output']>;
    confidence?: Maybe<Scalars['Float']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    deepgramBlob?: Maybe<Scalars['JSONString']['output']>;
    dialog?: Maybe<Scalars['JSONString']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    numboxAgentSession?: Maybe<NumboxAgentSessionQl>;
    operatorSession?: Maybe<OperatorSessionQl>;
    outboundConferenceCall?: Maybe<OutboundConferenceCallQl>;
    outboundProxyCall?: Maybe<OutboundProxyCallQl>;
    pauseIntervals?: Maybe<Scalars['JSONString']['output']>;
    phonecall?: Maybe<PhoneCallQl>;
    sizeBytes?: Maybe<Scalars['String']['output']>;
    stereoUrl?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
  };

export type CallRecordingStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'CallRecordingStepQL';
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    disclosureContent: Scalars['String']['output'];
    disclosureContentUrl: Scalars['String']['output'];
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextStepId?: Maybe<Scalars['String']['output']>;
    nextStepRelationship?: Maybe<VoiceScriptStepQl>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    playDisclosureRecording: Scalars['Boolean']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    startRecording: Scalars['Boolean']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type CallRecordingStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type CallRecordingStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type CallRecordingStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CallRecordingStepQlConnection = {
  __typename?: 'CallRecordingStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CallRecordingStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CallRecordingStepQL` and its cursor. */
export type CallRecordingStepQlEdge = {
  __typename?: 'CallRecordingStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CallRecordingStepQl>;
};

/** Minimal Automation information for campaigns - only id and name. */
export type CampaignAutomationQl = {
  __typename?: 'CampaignAutomationQL';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Minimal Place information for campaigns - only id and name. */
export type CampaignPlaceQl = {
  __typename?: 'CampaignPlaceQL';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** GraphQL type representing a campaign, with settings, place, and automation. */
export type CampaignQl = {
  __typename?: 'CampaignQL';
  automation?: Maybe<CampaignAutomationQl>;
  automationId?: Maybe<Scalars['String']['output']>;
  campaignSettings?: Maybe<CampaignSettingsQl>;
  createdOn?: Maybe<Scalars['ArrowField']['output']>;
  id: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  name: Scalars['String']['output'];
  place?: Maybe<CampaignPlaceQl>;
  placeId?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<CampaignSettingsQl>;
  status: CampaignStatus;
};

/** Input type for optional campaign settings */
export type CampaignSettingsInput = {
  maxEnrolement?: InputMaybe<Scalars['Int']['input']>;
  maxPerPeriod?: InputMaybe<Scalars['Int']['input']>;
  periodInDays?: InputMaybe<Scalars['Int']['input']>;
};

export type CampaignSettingsQl = {
  __typename?: 'CampaignSettingsQL';
  campaign?: Maybe<CampaignQl>;
  campaignId: Scalars['String']['output'];
  createdOn?: Maybe<Scalars['ArrowField']['output']>;
  id: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  maxEnrolement?: Maybe<Scalars['Int']['output']>;
  maxPerPeriod: Scalars['Int']['output'];
  periodInDays: Scalars['Int']['output'];
};

export enum CampaignStatus {
  Draft = 'DRAFT',
  Ended = 'ENDED',
  Paused = 'PAUSED',
  Running = 'RUNNING',
}

export type CancelPaymentRequest = {
  __typename?: 'CancelPaymentRequest';
  paymentRequest: PaymentRequestQl;
};

export type CancelPaymentRequestInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  paymentRequestId: Scalars['String']['input'];
};

export type CancelScheduledMessage = {
  __typename?: 'CancelScheduledMessage';
  scheduledMessage?: Maybe<ScheduledMessageQl>;
};

export type CancelScheduledMessageInput = {
  scheduledMessageId: Scalars['String']['input'];
};

export type CapturePaymentAmount = {
  __typename?: 'CapturePaymentAmount';
  paymentRequest: PaymentRequestQl;
};

export type CapturePaymentAmountInput = {
  amountToCapture: Scalars['Int']['input'];
  attachment?: InputMaybe<AttachmentInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentRequestId: Scalars['String']['input'];
};

export type CardInfo = {
  __typename?: 'CardInfo';
  cardStatus?: Maybe<CardStatus>;
  last4?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum CardStatus {
  Expired = 'EXPIRED',
  Expiring = 'EXPIRING',
  Valid = 'VALID',
}

export type ChangeAccountSubscription = {
  __typename?: 'ChangeAccountSubscription';
  account?: Maybe<AccountQl>;
};

export type ChangeAccountSubscriptionInput = {
  accountId: Scalars['String']['input'];
  subscription: SubscriptionInputQl;
};

export type ChangeAllowCustomAudio = {
  __typename?: 'ChangeAllowCustomAudio';
  place?: Maybe<PlaceQl>;
};

export type ChangeAllowCustomAudioInput = {
  allowCustomAudio: Scalars['Boolean']['input'];
  placeId: Scalars['String']['input'];
};

export type ChangeBusinessVertical = {
  __typename?: 'ChangeBusinessVertical';
  account?: Maybe<AccountQl>;
};

export type ChangeBusinessVerticalInput = {
  accountId: Scalars['String']['input'];
  businessVertical: Scalars['String']['input'];
};

export type ChangeConversationStateActionQl = AutomationAction &
  Node & {
    __typename?: 'ChangeConversationStateActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    desiredConversationState?: Maybe<DesiredConversationState>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextActionId?: Maybe<Scalars['String']['output']>;
    uiHints?: Maybe<AutomationUiHints>;
  };

export type ChangeInboxType = {
  __typename?: 'ChangeInboxType';
  place?: Maybe<PlaceQl>;
};

export type ChangeInboxTypeInput = {
  inboxType: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type ChangeNotificationSettings = {
  __typename?: 'ChangeNotificationSettings';
  currentUser?: Maybe<UserQl>;
};

export type ChangePlaceGroup = {
  __typename?: 'ChangePlaceGroup';
  place?: Maybe<PlaceQl>;
};

export type ChangePlaceGroupInput = {
  placeGroupId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type ChangePlaceHours = {
  __typename?: 'ChangePlaceHours';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangePlaceHoursInput = {
  hours: Scalars['JSONString']['input'];
  isMessagingHours: Scalars['Boolean']['input'];
  placeId: Scalars['String']['input'];
};

export type ChangePlaceSubscription = {
  __typename?: 'ChangePlaceSubscription';
  place?: Maybe<PlaceQl>;
};

export type ChangePlaceSubscriptionInput = {
  placeId: Scalars['String']['input'];
  subscriptions: Array<InputMaybe<Scalars['String']['input']>>;
};

export type ChangeRepairOrderSchedule = {
  __typename?: 'ChangeRepairOrderSchedule';
  registeredFortellisServiceAdvisor?: Maybe<RegisteredFortellisServiceAdvisorQl>;
};

export type ChangeRepairOrderScheduleInput = {
  registeredServiceAdvisorId: Scalars['String']['input'];
  repairOrderSchedule: Array<Scalars['String']['input']>;
};

export type ChangeSignupMode = {
  __typename?: 'ChangeSignupMode';
  account?: Maybe<AccountQl>;
};

export type ChangeSignupModeInput = {
  accountId: Scalars['String']['input'];
  signupMode: Scalars['String']['input'];
};

export type ChangeSwipeActionSettings = {
  __typename?: 'ChangeSwipeActionSettings';
  currentUser?: Maybe<UserQl>;
};

export type ChangeSwipeActionSettingsInput = {
  swipeLeftActions: Array<InputMaybe<SwipeActions>>;
  swipeRightActions: Array<InputMaybe<SwipeActions>>;
};

export type ChangeTwilioChannelMdn = {
  __typename?: 'ChangeTwilioChannelMDN';
  channel?: Maybe<TwilioChannelQl>;
};

export type ChangeTwilioChannelMdnInput = {
  channelId: Scalars['String']['input'];
  mdn: Scalars['String']['input'];
  outboundSmsMdn?: InputMaybe<Scalars['String']['input']>;
  sid: Scalars['String']['input'];
};

export type ChangeUserPassword = {
  __typename?: 'ChangeUserPassword';
  currentUser?: Maybe<UserQl>;
};

export type ChangeUserPasswordInput = {
  newPassword: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeUserSettings = {
  __typename?: 'ChangeUserSettings';
  user?: Maybe<UserQl>;
};

export type ChangeUserVideoConferenceUrl = {
  __typename?: 'ChangeUserVideoConferenceUrl';
  currentUser?: Maybe<UserQl>;
};

export type ChangeUserVideoConferenceUrlInput = {
  videoConferenceUrl: Scalars['String']['input'];
};

export type Channel = {
  account: AccountQl;
  accountId: Scalars['String']['output'];
  assignee?: Maybe<UserQl>;
  assigneeId?: Maybe<Scalars['String']['output']>;
  channelType: Scalars['String']['output'];
  createdOn: Scalars['ArrowField']['output'];
  id: Scalars['ID']['output'];
  identityPromptOption: IdentityPromptOptions;
  isActive: Scalars['Boolean']['output'];
  isBotEnabled: Scalars['Boolean']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  place: PlaceQl;
  placeId: Scalars['String']['output'];
  respectExistingAssignments?: Maybe<Scalars['Boolean']['output']>;
  team?: Maybe<TeamQl>;
  teamId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeBeeSubscription = {
  __typename?: 'ChargeBeeSubscription';
  billingStatus: BillingStatus;
  cardInfo?: Maybe<CardInfo>;
  dueSince: Scalars['Int']['output'];
  trialDaysLeft?: Maybe<Scalars['Int']['output']>;
};

export type CheckBusinessHoursStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'CheckBusinessHoursStepQL';
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onClosedStep?: Maybe<VoiceScriptStepQl>;
    onClosedStepId?: Maybe<Scalars['String']['output']>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    onOpenStep?: Maybe<VoiceScriptStepQl>;
    onOpenStepId?: Maybe<Scalars['String']['output']>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type CheckBusinessHoursStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type CheckBusinessHoursStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlFailureConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type CheckBusinessHoursStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type CheckBusinessHoursStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckBusinessHoursStepQlConnection = {
  __typename?: 'CheckBusinessHoursStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CheckBusinessHoursStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CheckBusinessHoursStepQL` and its cursor. */
export type CheckBusinessHoursStepQlEdge = {
  __typename?: 'CheckBusinessHoursStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CheckBusinessHoursStepQl>;
};

export type CheckForLabelStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'CheckForLabelStepQL';
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    labelName: Scalars['String']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabel?: Maybe<VoiceScriptStepQl>;
    onHasLabelId?: Maybe<Scalars['String']['output']>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabel?: Maybe<VoiceScriptStepQl>;
    onMissingLabelId?: Maybe<Scalars['String']['output']>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type CheckForLabelStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type CheckForLabelStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type CheckForLabelStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckForLabelStepQlConnection = {
  __typename?: 'CheckForLabelStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CheckForLabelStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CheckForLabelStepQL` and its cursor. */
export type CheckForLabelStepQlEdge = {
  __typename?: 'CheckForLabelStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CheckForLabelStepQl>;
};

export type CheckOpportunityStatusActionQl = AutomationAction &
  Node & {
    __typename?: 'CheckOpportunityStatusActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextActionId?: Maybe<Scalars['String']['output']>;
    onNoActionId?: Maybe<Scalars['String']['output']>;
    onYesActionId?: Maybe<Scalars['String']['output']>;
    opportunity?: Maybe<OpportunityInfo>;
    uiHints?: Maybe<AutomationUiHints>;
  };

export type CheckRepairOrderDetailsActionQl = AutomationAction &
  Node & {
    __typename?: 'CheckRepairOrderDetailsActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextActionId?: Maybe<Scalars['String']['output']>;
    rulesQuery?: Maybe<Scalars['String']['output']>;
    uiHints?: Maybe<AutomationUiHints>;
  };

export type CloseStatusItem = {
  __typename?: 'CloseStatusItem';
  statusItem?: Maybe<StatusItemQl>;
};

export type CloseStatusItemInput = {
  newStatus: StatusItemStatus;
  statusId: Scalars['String']['input'];
};

export type CompleteAutopilot = {
  __typename?: 'CompleteAutopilot';
  autopilot: AutopilotQl;
};

export type CompleteAutopilotInput = {
  autopilotId: Scalars['String']['input'];
  messageToSend?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteTask = {
  __typename?: 'CompleteTask';
  task: TaskQl;
};

export type CompleteTaskInput = {
  taskId: Scalars['UUID']['input'];
};

export type ComplianceReminder = {
  __typename?: 'ComplianceReminder';
  guidelinesReminder?: Maybe<Scalars['String']['output']>;
};

export type ComplianceSettingsQl = BaseQl &
  Node & {
    __typename?: 'ComplianceSettingsQL';
    account?: Maybe<AccountQl>;
    accountId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    detailedGuidelines: Scalars['String']['output'];
    doubleOptInPrompt: Scalars['String']['output'];
    guidelinesReminder: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    onCompose: Scalars['Boolean']['output'];
    onHangup: Scalars['Boolean']['output'];
    onRevivedConversations: Scalars['Boolean']['output'];
    onVoicemail: Scalars['Boolean']['output'];
    ongoingOptOutInstructions: Scalars['String']['output'];
    optOutConfirmation: Scalars['String']['output'];
    optOutInstructions: Scalars['String']['output'];
    optOutResubscribe: Scalars['String']['output'];
    requireDoubleOptIn: Scalars['Boolean']['output'];
    requireExplicitOptIn: RequireExplicitOptIn;
    sendOptOutInstructions: Scalars['Boolean']['output'];
    suppressOptOutInstructions: Scalars['Boolean']['output'];
  };

export type ConnectAutomationAction = {
  __typename?: 'ConnectAutomationAction';
  automation?: Maybe<AutomationQl>;
};

export type ConnectAutomationActionEdge = {
  __typename?: 'ConnectAutomationActionEdge';
  automation?: Maybe<AutomationQl>;
};

export type ConnectAutomationActionEdgeInput = {
  actionId: Scalars['String']['input'];
  automationId: Scalars['String']['input'];
  linkName: Scalars['String']['input'];
  targetActionId: Scalars['String']['input'];
};

export type ConnectAutomationActionInput = {
  actionId: Scalars['String']['input'];
  automationId: Scalars['String']['input'];
  nextActionId?: InputMaybe<Scalars['String']['input']>;
};

/** GraphQL type for content summary */
export type ContentSummaryQl = {
  __typename?: 'ContentSummaryQL';
  contentTypes: ContentTypesQl;
  totalRecords: Scalars['Int']['output'];
};

/** GraphQL type for content types analysis */
export type ContentTypesQl = {
  __typename?: 'ContentTypesQL';
  recordsWithMakeModel: Scalars['Int']['output'];
  recordsWithPhone: Scalars['Int']['output'];
  recordsWithVin: Scalars['Int']['output'];
};

export type ConversationArchivedTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'ConversationArchivedTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    daysSinceInbound: Scalars['Int']['output'];
    daysSinceOutbound: Scalars['Int']['output'];
    id: Scalars['ID']['output'];
    includeActiveConversations: Scalars['Boolean']['output'];
    includeClosedByNuma: Scalars['Boolean']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
  };

/** GraphQL type for conversation breakdown entry */
export type ConversationBreakdownEntryQl = {
  __typename?: 'ConversationBreakdownEntryQL';
  conversationId: Scalars['String']['output'];
  customerInformation?: Maybe<ManualOpportunityCustomerInformationQl>;
  firstStarted: Scalars['String']['output'];
  hasEarlyExit: Scalars['Boolean']['output'];
  jobCount: Scalars['Int']['output'];
  lastUpdated: Scalars['String']['output'];
  statuses: Array<Maybe<Scalars['String']['output']>>;
};

export type ConversationConnection = {
  __typename?: 'ConversationConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ConversationEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `Conversation` and its cursor. */
export type ConversationEdge = {
  __typename?: 'ConversationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ConversationQl>;
};

export type ConversationLabelQl = BaseQl &
  Node & {
    __typename?: 'ConversationLabelQL';
    conversation?: Maybe<ConversationQl>;
    conversationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    expiresAt?: Maybe<Scalars['ArrowField']['output']>;
    hidden: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    label: LabelQl;
    labelId: Scalars['String']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    participant: ParticipantQl;
    participantId: Scalars['String']['output'];
  };

export type ConversationLabelQlConnection = {
  __typename?: 'ConversationLabelQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ConversationLabelQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ConversationLabelQL` and its cursor. */
export type ConversationLabelQlEdge = {
  __typename?: 'ConversationLabelQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ConversationLabelQl>;
};

export type ConversationMarkedAsHeatCaseTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'ConversationMarkedAsHeatCaseTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
  };

export type ConversationModelFilter = {
  allMessagesArchived?: InputMaybe<BooleanFilter>;
  allMessagesDeleted?: InputMaybe<BooleanFilter>;
  assigneeId?: InputMaybe<StringFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  customerId?: InputMaybe<StringFilter>;
  escalated?: InputMaybe<ArrowFieldFilter>;
  firstChannelId?: InputMaybe<StringFilter>;
  firstMessageTimestamp?: InputMaybe<ArrowFieldFilter>;
  id?: InputMaybe<StringFilter>;
  inboxId?: InputMaybe<StringFilter>;
  isOverdue?: InputMaybe<BooleanFilter>;
  language?: InputMaybe<StringFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  nudged?: InputMaybe<ArrowFieldFilter>;
  optInStatus?: InputMaybe<StringFilter>;
  placeId?: InputMaybe<StringFilter>;
  requestedOptIn?: InputMaybe<BooleanFilter>;
  snoozedUntil?: InputMaybe<ArrowFieldFilter>;
  source?: InputMaybe<StringFilter>;
  state?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<StringFilter>;
  waitingSince?: InputMaybe<ArrowFieldFilter>;
};

export enum ConversationModelSortEnum {
  AssigneeIdAsc = 'assignee_id_asc',
  AssigneeIdDesc = 'assignee_id_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  CustomerIdAsc = 'customer_id_asc',
  CustomerIdDesc = 'customer_id_desc',
  EscalatedAsc = 'escalated_asc',
  EscalatedDesc = 'escalated_desc',
  FirstChannelIdAsc = 'first_channel_id_asc',
  FirstChannelIdDesc = 'first_channel_id_desc',
  FirstMessageTimestampAsc = 'first_message_timestamp_asc',
  FirstMessageTimestampDesc = 'first_message_timestamp_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  InboxIdAsc = 'inbox_id_asc',
  InboxIdDesc = 'inbox_id_desc',
  LanguageAsc = 'language_asc',
  LanguageDesc = 'language_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  NudgedAsc = 'nudged_asc',
  NudgedDesc = 'nudged_desc',
  OptInStatusAsc = 'opt_in_status_asc',
  OptInStatusDesc = 'opt_in_status_desc',
  PlaceIdAsc = 'place_id_asc',
  PlaceIdDesc = 'place_id_desc',
  RequestedOptInAsc = 'requested_opt_in_asc',
  RequestedOptInDesc = 'requested_opt_in_desc',
  SnoozedUntilAsc = 'snoozed_until_asc',
  SnoozedUntilDesc = 'snoozed_until_desc',
  SourceAsc = 'source_asc',
  SourceDesc = 'source_desc',
  StateAsc = 'state_asc',
  StateDesc = 'state_desc',
  TeamIdAsc = 'team_id_asc',
  TeamIdDesc = 'team_id_desc',
  WaitingSinceAsc = 'waiting_since_asc',
  WaitingSinceDesc = 'waiting_since_desc',
}

export enum ConversationOptInStatus {
  ConversationalOptIn = 'CONVERSATIONAL_OPT_IN',
  OngoingOptIn = 'ONGOING_OPT_IN',
  OptedOut = 'OPTED_OUT',
  Unknown = 'UNKNOWN',
}

export type ConversationParticipantInput = {
  address: Scalars['String']['input'];
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  piplData?: InputMaybe<Scalars['JSONString']['input']>;
  source: Scalars['String']['input'];
};

export type ConversationPreviewContentQl = {
  __typename?: 'ConversationPreviewContentQL';
  preview: Scalars['String']['output'];
  previewDisplayName: Scalars['String']['output'];
  previewFormat: Scalars['String']['output'];
  previewIsInbound: Scalars['Boolean']['output'];
  previewMentions: Array<MentionQl>;
  previewServerGenerated: Scalars['Boolean']['output'];
  previewSource: Scalars['String']['output'];
  subPreview: Scalars['String']['output'];
  subPreviewDisplayName: Scalars['String']['output'];
  subPreviewFormat: Scalars['String']['output'];
  subPreviewMentions: Array<MentionQl>;
};

export type ConversationQl = BaseQl &
  Node & {
    __typename?: 'ConversationQL';
    allMessagesArchived?: Maybe<Scalars['Boolean']['output']>;
    allMessagesDeleted?: Maybe<Scalars['Boolean']['output']>;
    amIMentioned: Scalars['Boolean']['output'];
    appointments?: Maybe<AppointmentQlConnection>;
    assignee?: Maybe<UserQl>;
    assigneeId?: Maybe<Scalars['String']['output']>;
    automationJobs?: Maybe<AutomationJobQlConnection>;
    autopilots?: Maybe<AutopilotQlConnection>;
    conversationLabels?: Maybe<Array<ConversationLabelQl>>;
    conversationState: Scalars['String']['output'];
    conversationTags?: Maybe<Array<ConversationTagQl>>;
    createdOn: Scalars['ArrowField']['output'];
    /** @deprecated Use participant field instead */
    customer: ParticipantQl;
    customerId: Scalars['String']['output'];
    customerWaiting: Scalars['Boolean']['output'];
    dialogFlowBotDatas?: Maybe<DialogFlowBotDataQlConnection>;
    engagements?: Maybe<Array<Maybe<EngagementQl>>>;
    escalated?: Maybe<Scalars['ArrowField']['output']>;
    firstChannel?: Maybe<BaseChannel>;
    firstChannelId?: Maybe<Scalars['String']['output']>;
    firstMessageTimestamp?: Maybe<Scalars['ArrowField']['output']>;
    /** Whether the conversation has had a heat-case message in the last 3 days */
    hasRecentHeatCase?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    inbox?: Maybe<InboxQl>;
    inboxId: Scalars['String']['output'];
    isMentionedConversation: Scalars['Boolean']['output'];
    isNextOutboundMessageSigned: Scalars['Boolean']['output'];
    isOverdue?: Maybe<Scalars['Boolean']['output']>;
    language?: Maybe<Scalars['String']['output']>;
    lastAppointment?: Maybe<AppointmentQl>;
    lastChannel?: Maybe<Channel>;
    lastEngagement?: Maybe<EngagementQl>;
    lastInboundMessage?: Maybe<MessageQl>;
    lastMentionedTimestamp?: Maybe<Scalars['ArrowField']['output']>;
    lastMessage?: Maybe<MessageQl>;
    lastOrder?: Maybe<OrderQl>;
    lastRepairOrder?: Maybe<RepairOrder>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    mentionedDisplayName?: Maybe<Scalars['String']['output']>;
    mentionedPreview?: Maybe<Scalars['String']['output']>;
    mentions?: Maybe<MentionQlConnection>;
    messages?: Maybe<MessageQlConnection>;
    nudged?: Maybe<Scalars['ArrowField']['output']>;
    optInStatus: ConversationOptInStatus;
    outboundConferenceCalls?: Maybe<OutboundConferenceCallQlConnection>;
    outboundProxyCalls?: Maybe<OutboundProxyCallQlConnection>;
    participant: ParticipantQl;
    paymentRequests?: Maybe<PaymentRequestQlConnection>;
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    preview: Scalars['String']['output'];
    previewData: ConversationPreviewContentQl;
    repairOrderSmartStatusUpdateSettings?: Maybe<ConversationRepairOrderSmartStatusUpdateSettingsQl>;
    repairOrders?: Maybe<RepairOrderFortellisQlConnection>;
    requestedOptIn?: Maybe<Scalars['Boolean']['output']>;
    serverGeneratedPreview: Scalars['Boolean']['output'];
    snoozedUntil?: Maybe<Scalars['ArrowField']['output']>;
    source?: Maybe<Scalars['String']['output']>;
    state: ConversationState;
    team?: Maybe<TeamQl>;
    teamId?: Maybe<Scalars['String']['output']>;
    transcripts?: Maybe<TranscriptQlConnection>;
    unreadCount: Scalars['Int']['output'];
    waitingSince?: Maybe<Scalars['ArrowField']['output']>;
  };

export type ConversationQlAppointmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationQlAutomationJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationQlAutopilotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationQlDialogFlowBotDatasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationQlMentionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationQlMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationQlOutboundConferenceCallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationQlOutboundProxyCallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationQlPaymentRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationQlRepairOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationQlTranscriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationQlConnection = {
  __typename?: 'ConversationQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ConversationQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ConversationQL` and its cursor. */
export type ConversationQlEdge = {
  __typename?: 'ConversationQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ConversationQl>;
};

export type ConversationRepairOrderSmartStatusUpdateSettingsQl = BaseQl &
  Node & {
    __typename?: 'ConversationRepairOrderSmartStatusUpdateSettingsQL';
    conversation?: Maybe<ConversationQl>;
    conversationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customInstructions?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    isEnabled: Scalars['Boolean']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  };

export type ConversationStartedTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'ConversationStartedTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
  };

export enum ConversationState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED',
  Snoozed = 'SNOOZED',
}

export type ConversationStateStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'ConversationStateStepQL';
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    desiredConversationState?: Maybe<DesiredConversationState>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextStepId?: Maybe<Scalars['String']['output']>;
    nextStepRelationship?: Maybe<VoiceScriptStepQl>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type ConversationStateStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationStateStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlFailureConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationStateStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationStateStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationStateStepQlConnection = {
  __typename?: 'ConversationStateStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ConversationStateStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ConversationStateStepQL` and its cursor. */
export type ConversationStateStepQlEdge = {
  __typename?: 'ConversationStateStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ConversationStateStepQl>;
};

export type ConversationStatsQl = {
  __typename?: 'ConversationStatsQL';
  inboundInInbox?: Maybe<Scalars['Int']['output']>;
  numaHidAMessage?: Maybe<Scalars['Int']['output']>;
};

export type ConversationTagQl = BaseQl &
  Node & {
    __typename?: 'ConversationTagQL';
    createdOn: Scalars['ArrowField']['output'];
    expiresAt?: Maybe<Scalars['ArrowField']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
  };

export type ConversationalSchedulingAgentStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'ConversationalSchedulingAgentStepQl';
    appointmentAgentSettings?: Maybe<AppointmentAgentSettingsQl>;
    appointmentAgentSettingsId?: Maybe<Scalars['String']['output']>;
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    appointmentLeadStepId?: Maybe<Scalars['String']['output']>;
    appointmentLeadStepRelationship?: Maybe<VoiceScriptStepQl>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    bookedSpeech?: Maybe<Scalars['String']['output']>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    confirmIntentSpeech: Scalars['String']['output'];
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureStepId?: Maybe<Scalars['String']['output']>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSpeech?: Maybe<Scalars['String']['output']>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    humanEscalationSpeech: Scalars['String']['output'];
    humanEscalationStepId?: Maybe<Scalars['String']['output']>;
    humanEscalationStepRelationship?: Maybe<VoiceScriptStepQl>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    leadSpeech?: Maybe<Scalars['String']['output']>;
    nextStepId?: Maybe<Scalars['String']['output']>;
    nextStepRelationship?: Maybe<VoiceScriptStepQl>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    numboxAgentSessions?: Maybe<NumboxAgentSessionQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    shouldConfirmIntent: Scalars['Boolean']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    unserviceableSpeech?: Maybe<Scalars['String']['output']>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type ConversationalSchedulingAgentStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlCallForwardingConnectedStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlCantServiceCustomerAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlCheckBusinessHoursOnClosedStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlCheckBusinessHoursOnOpenStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlFailureAppointmentAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlFailureConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlFailureRecallAppointmentAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlForwardingNoAnsweringStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlIntentQuestionOnYesButNoTextStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlNotAnAppointmentLeadAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlNumboxAgentSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlOtherFailureAppointmentAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlSpecialQuestionOnYesButNoTextStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlStatusUpdaterStatusGivenStepArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlStatusUpdaterStatusGivenStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type ConversationalSchedulingAgentStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationalSchedulingAgentStepQlConnection = {
  __typename?: 'ConversationalSchedulingAgentStepQlConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ConversationalSchedulingAgentStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ConversationalSchedulingAgentStepQl` and its cursor. */
export type ConversationalSchedulingAgentStepQlEdge = {
  __typename?: 'ConversationalSchedulingAgentStepQlEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ConversationalSchedulingAgentStepQl>;
};

export enum Country {
  Ca = 'CA',
  Us = 'US',
}

export type CreateA2PCampaignForPlace = {
  __typename?: 'CreateA2PCampaignForPlace';
  tenDlcProcess?: Maybe<TenDlcProcessQl>;
};

export type CreateAgentChitChat = {
  __typename?: 'CreateAgentChitChat';
  chitchat: AgentChitChatResponse;
};

export type CreateAgentChitChatInput = {
  /** Operator ID for this conversation */
  operatorId: Scalars['String']['input'];
  /** Participant ID for this conversation */
  participantId?: InputMaybe<Scalars['String']['input']>;
  /** The type of task for this conversation */
  task: TaskType;
};

export type CreateAppointmentAgentSettingLabel = {
  __typename?: 'CreateAppointmentAgentSettingLabel';
  appointmentAgentSetting?: Maybe<AppointmentAgentSettingsQl>;
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<LabelQl>;
};

export type CreateAppointmentAgentSettingLabelInput = {
  category: Scalars['String']['input'];
  id: Scalars['String']['input'];
  labelColor?: InputMaybe<Scalars['String']['input']>;
  labelExpirationHours?: InputMaybe<Scalars['Int']['input']>;
  labelHidden?: InputMaybe<Scalars['Boolean']['input']>;
  labelIcon?: InputMaybe<Scalars['String']['input']>;
  labelName: Scalars['String']['input'];
};

export type CreateAppointmentAgentSettings = {
  __typename?: 'CreateAppointmentAgentSettings';
  appointmentAgentSettings?: Maybe<AppointmentAgentSettingsQl>;
};

export type CreateAppointmentAgentSettingsInput = {
  activeIntegrationId?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
};

export type CreateAutomation = {
  __typename?: 'CreateAutomation';
  automation?: Maybe<AutomationQl>;
};

export type CreateAutomationAction = {
  __typename?: 'CreateAutomationAction';
  automation?: Maybe<AutomationQl>;
};

export type CreateAutomationActionInput = {
  actionType: AutomationActionTypeInput;
  automationId: Scalars['String']['input'];
  uiHints?: InputMaybe<Position>;
};

export type CreateAutomationFromBlueprint = {
  __typename?: 'CreateAutomationFromBlueprint';
  automation?: Maybe<AutomationQl>;
};

export type CreateAutomationFromBlueprintInput = {
  name: Scalars['String']['input'];
  options?: InputMaybe<Scalars['JSONString']['input']>;
  placeId: Scalars['String']['input'];
  template: Scalars['String']['input'];
};

export type CreateAutomationInput = {
  labelsToWatch?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  triggerType: Scalars['String']['input'];
};

export type CreateAutopilot = {
  __typename?: 'CreateAutopilot';
  autopilot: AutopilotQl;
};

export type CreateAutopilotInput = {
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  eta: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type CreateBillingIdentity = {
  __typename?: 'CreateBillingIdentity';
  billingIdentity?: Maybe<BillingIdentityQl>;
};

/** Mutation to create a new campaign entity */
export type CreateCampaign = {
  __typename?: 'CreateCampaign';
  result?: Maybe<CreateCampaignResult>;
};

/** Input type for creating a new campaign */
export type CreateCampaignInput = {
  automationId?: InputMaybe<Scalars['String']['input']>;
  campaignSettings?: InputMaybe<CampaignSettingsInput>;
  name: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

/** Result type for create campaign mutation */
export type CreateCampaignResult = {
  __typename?: 'CreateCampaignResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateChatExpansion = {
  __typename?: 'CreateChatExpansion';
  textExpansion: TextGenerationQl;
};

export type CreateChatExpansionInput = {
  completionsCount?: InputMaybe<Scalars['Int']['input']>;
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  messages: Array<TextGenerationChatMessageInputQl>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateConversation = {
  __typename?: 'CreateConversation';
  conversation: ConversationQl;
};

export type CreateConversationInput = {
  channelId: Scalars['String']['input'];
  participant: ConversationParticipantInput;
};

export type CreateConversationSummary = {
  __typename?: 'CreateConversationSummary';
  textSummary: TextGenerationQl;
};

export type CreateConversationSummaryInput = {
  completionsCount?: InputMaybe<Scalars['Int']['input']>;
  conversationId: Scalars['String']['input'];
  extraParams?: InputMaybe<Scalars['JSONString']['input']>;
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateConversationTextExpansion = {
  __typename?: 'CreateConversationTextExpansion';
  textExpansion: TextGenerationQl;
};

export type CreateConversationTextExpansionInput = {
  completionsCount?: InputMaybe<Scalars['Int']['input']>;
  conversationId: Scalars['String']['input'];
  extraParams?: InputMaybe<Scalars['JSONString']['input']>;
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomDirectoryEntry = {
  __typename?: 'CreateCustomDirectoryEntry';
  directoryEntry: CustomDirectoryEntryQl;
};

export type CreateCustomDirectoryEntryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  mdn?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  placeGroupId: Scalars['UUID']['input'];
  sip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDepartmentDevice = {
  __typename?: 'CreateDepartmentDevice';
  device: DepartmentDeviceQl;
};

export type CreateDepartmentDeviceInput = {
  departmentId: Scalars['String']['input'];
  enabledAfterBusinessHours?: InputMaybe<Scalars['Boolean']['input']>;
  enabledDuringBusinessHours?: InputMaybe<Scalars['Boolean']['input']>;
  mdn?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sipAddress?: InputMaybe<Scalars['String']['input']>;
  sipPriorityFirst?: InputMaybe<Scalars['Boolean']['input']>;
  type: DeviceTypeInput;
};

export type CreateIdentityPromptAddress = {
  __typename?: 'CreateIdentityPromptAddress';
  identityPromptAddress: IdentityPromptAddressQl;
};

export type CreateIdentityPromptAddressInput = {
  address: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
};

export type CreateLabel = {
  __typename?: 'CreateLabel';
  label: LabelQl;
};

export type CreateLabelInput = {
  color: Scalars['String']['input'];
  expirationHours?: InputMaybe<Scalars['Int']['input']>;
  hidden: Scalars['Boolean']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  iconType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

/** Mutation to create manual campaign uploads */
export type CreateManualCampaignUpload = {
  __typename?: 'CreateManualCampaignUpload';
  result?: Maybe<CreateManualCampaignUploadResult>;
};

/** Input type for manual campaign upload creation */
export type CreateManualCampaignUploadInput = {
  campaignContacts: Array<ManualCampaignUploadDataInput>;
  campaignId: Scalars['String']['input'];
  fileUpload: ManualCampaignUploadFileUploadInput;
  hasTcpaApproval?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Result type for manual campaign upload creation */
export type CreateManualCampaignUploadResult = {
  __typename?: 'CreateManualCampaignUploadResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateNoteTaker = {
  __typename?: 'CreateNoteTaker';
  noteTaker?: Maybe<NoteTakerQl>;
};

export type CreateNoteTakerInput = {
  name: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  settings: Scalars['JSONString']['input'];
};

export type CreateOperator = {
  __typename?: 'CreateOperator';
  operator: OperatorQl;
};

export type CreateOperatorInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  spokenGreetingName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOutboundConferenceCall = {
  __typename?: 'CreateOutboundConferenceCall';
  outboundConferenceCall: OutboundConferenceCallQl;
};

export type CreateOutboundConferenceCallInput = {
  channelId: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['String']['input']>;
  hasCallAssist?: InputMaybe<Scalars['Boolean']['input']>;
  hostDeviceId?: InputMaybe<Scalars['String']['input']>;
  hostMdn: Scalars['String']['input'];
  isBeingRecorded?: InputMaybe<Scalars['Boolean']['input']>;
  leaveVoicemail?: InputMaybe<Scalars['Boolean']['input']>;
  placeId: Scalars['String']['input'];
  recipientMdn: Scalars['String']['input'];
};

export type CreateOutboundProxyCall = {
  __typename?: 'CreateOutboundProxyCall';
  outboundProxyCall: OutboundProxyCallQl;
};

export type CreateOutboundProxyCallInput = {
  channelId: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['String']['input']>;
  isBeingRecorded?: InputMaybe<Scalars['Boolean']['input']>;
  placeId: Scalars['String']['input'];
  recipientMdn: Scalars['String']['input'];
};

export type CreateParticipant = {
  __typename?: 'CreateParticipant';
  participant?: Maybe<ParticipantQl>;
};

export type CreateParticipantInput = {
  address: Scalars['String']['input'];
  source: Scalars['String']['input'];
};

export type CreateParticipantPaymentRequest = {
  __typename?: 'CreateParticipantPaymentRequest';
  paymentRequest: PaymentRequestQl;
};

export type CreateParticipantPaymentRequestInput = {
  amount: Scalars['Int']['input'];
  attachment?: InputMaybe<AttachmentInput>;
  attachmentDescription?: InputMaybe<Scalars['String']['input']>;
  captureMethod?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  participantId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type CreatePaymentRequest = {
  __typename?: 'CreatePaymentRequest';
  paymentRequest: PaymentRequestQl;
};

export type CreatePaymentRequestInput = {
  amount: Scalars['Int']['input'];
  attachment?: InputMaybe<AttachmentInput>;
  attachmentDescription?: InputMaybe<Scalars['String']['input']>;
  captureMethod?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  customerMdn: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
};

export type CreatePhoneLine = {
  __typename?: 'CreatePhoneLine';
  phoneline?: Maybe<PhoneLineQl>;
};

export enum CreatePhoneLineCategoryInput {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  User = 'USER',
}

export type CreatePhoneLineInput = {
  category?: InputMaybe<CreatePhoneLineCategoryInput>;
  isExistingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  mdn: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
  respectExistingAssignments?: InputMaybe<Scalars['Boolean']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePlace = {
  __typename?: 'CreatePlace';
  place?: Maybe<PlaceQl>;
};

export type CreatePlaceInput = {
  accountId: Scalars['String']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  appointmentUrl?: InputMaybe<Scalars['String']['input']>;
  businessHours?: InputMaybe<Scalars['JSONString']['input']>;
  chargebeeCustomerId?: InputMaybe<Scalars['String']['input']>;
  chargebeeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  hubspotCompanyId?: InputMaybe<Scalars['String']['input']>;
  hubspotContactId?: InputMaybe<Scalars['String']['input']>;
  hubspotDealId?: InputMaybe<Scalars['String']['input']>;
  inboxType?: InputMaybe<Scalars['String']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  primaryMdn: Scalars['String']['input'];
  reviewSites?: InputMaybe<Array<InputMaybe<ReviewSiteInput>>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePortalSession = {
  __typename?: 'CreatePortalSession';
  portalSession?: Maybe<Scalars['JSONString']['output']>;
};

export type CreateScheduledMessage = {
  __typename?: 'CreateScheduledMessage';
  scheduledMessage: ScheduledMessageQl;
};

export type CreateScheduledMessageInput = {
  address: Scalars['String']['input'];
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  capsLockFixed?: InputMaybe<Scalars['Boolean']['input']>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  recipientFirstName?: InputMaybe<Scalars['String']['input']>;
  recipientId?: InputMaybe<Scalars['String']['input']>;
  recipientLastName?: InputMaybe<Scalars['String']['input']>;
  sendAt: Scalars['ArrowField']['input'];
};

export type CreateShortcut = {
  __typename?: 'CreateShortcut';
  shortcut?: Maybe<ShortcutQl>;
};

export type CreateShortcutInput = {
  content: Scalars['String']['input'];
  name: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  tag: Scalars['String']['input'];
};

export type CreateStripeAccount = {
  __typename?: 'CreateStripeAccount';
  accountLinkUrl?: Maybe<Scalars['String']['output']>;
  refreshUrl?: Maybe<Scalars['String']['output']>;
  returnUrl?: Maybe<Scalars['String']['output']>;
};

export type CreateStripeAccountInput = {
  accountType: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type CreateStripeRefund = {
  __typename?: 'CreateStripeRefund';
  paymentRequest: PaymentRequestQl;
};

export type CreateStripeRefundInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentRequestId: Scalars['String']['input'];
  refundType: Scalars['String']['input'];
};

export type CreateTaskForEngagement = {
  __typename?: 'CreateTaskForEngagement';
  engagement: EngagementQl;
  task: TaskQl;
};

export type CreateTeam = {
  __typename?: 'CreateTeam';
  team?: Maybe<TeamQl>;
};

export type CreateTeamInput = {
  avatar: Scalars['String']['input'];
  name: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateTextExpansion = {
  __typename?: 'CreateTextExpansion';
  textExpansion: TextGenerationQl;
};

export type CreateTextExpansionInput = {
  completionsCount?: InputMaybe<Scalars['Int']['input']>;
  extraParams?: InputMaybe<Scalars['JSONString']['input']>;
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  temperature?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateUser = {
  __typename?: 'CreateUser';
  phoneline?: Maybe<PhoneLineQl>;
  user: UserQl;
};

export type CreateUserCallIntelligenceInput = {
  callIntelligenceEnabled: Scalars['Boolean']['input'];
  placeId: Scalars['String']['input'];
};

export type CreateUserDeviceInput = {
  enabledAfterBusinessHours: Scalars['Boolean']['input'];
  enabledDuringBusinessHours: Scalars['Boolean']['input'];
  enabledWhenAway: Scalars['Boolean']['input'];
  mdn: Scalars['String']['input'];
  sipAddress?: InputMaybe<Scalars['String']['input']>;
  sipPriorityFirst?: InputMaybe<Scalars['Boolean']['input']>;
  type: UserPhoneTypeInput;
};

export type CreateUserDirectoryEntryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateUserInput = {
  accountId: Scalars['String']['input'];
  callIntelligenceSettings?: InputMaybe<Array<CreateUserCallIntelligenceInput>>;
  directoryEntry?: InputMaybe<CreateUserDirectoryEntryInput>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  jobRole?: InputMaybe<JobRoleInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneline?: InputMaybe<CreateUserPhonelineInput>;
  placeIds: Array<Scalars['String']['input']>;
  pronouns?: InputMaybe<CreateUserPronounsInput>;
  source?: InputMaybe<SeatsUpdatedSource>;
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userPhones?: InputMaybe<Array<CreateUserDeviceInput>>;
};

export type CreateUserPhone = {
  __typename?: 'CreateUserPhone';
  userPhone: UserPhoneQl;
};

export type CreateUserPhoneInput = {
  mdn: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sipAddress?: InputMaybe<Scalars['String']['input']>;
  sipPriorityFirst?: InputMaybe<Scalars['Boolean']['input']>;
  type: UserPhoneTypeInput;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserPhonelineInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
};

export enum CreateUserPronounsInput {
  HeHim = 'HE_HIM',
  SheHer = 'SHE_HER',
  TheyThem = 'THEY_THEM',
}

export type CreateVideoUploadLink = {
  __typename?: 'CreateVideoUploadLink';
  videoUploadLink: VideoUploadLinkQl;
};

export type CreateVideoUploadLinkInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
};

export type Credentials = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  userLogin?: InputMaybe<UserLogin>;
};

export type CrmContactCdkQl = LegacyCrmContactQl &
  Node & {
    __typename?: 'CrmContactCdkQL';
    companyName?: Maybe<Scalars['String']['output']>;
    contactType?: Maybe<CrmContactType>;
    createdOn: Scalars['ArrowField']['output'];
    customerId?: Maybe<Scalars['String']['output']>;
    data?: Maybe<Scalars['JSONString']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastName?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    participant?: Maybe<ParticipantQl>;
    participantId: Scalars['String']['output'];
    phoneNumber?: Maybe<Scalars['String']['output']>;
  };

export type CrmContactCnamQl = LegacyCrmContactQl &
  Node & {
    __typename?: 'CrmContactCnamQL';
    contactType?: Maybe<CrmContactType>;
    createdOn: Scalars['ArrowField']['output'];
    customerId?: Maybe<Scalars['String']['output']>;
    data?: Maybe<Scalars['JSONString']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastName?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    participant?: Maybe<ParticipantQl>;
    participantId: Scalars['String']['output'];
  };

export type CrmContactDealertrackQl = LegacyCrmContactQl &
  Node & {
    __typename?: 'CrmContactDealertrackQL';
    companyName?: Maybe<Scalars['String']['output']>;
    contactType?: Maybe<CrmContactType>;
    createdOn: Scalars['ArrowField']['output'];
    customerId?: Maybe<Scalars['String']['output']>;
    data?: Maybe<Scalars['JSONString']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastName?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    participant?: Maybe<ParticipantQl>;
    participantId: Scalars['String']['output'];
    phoneNumber?: Maybe<Scalars['String']['output']>;
  };

export type CrmContactFortellisQl = LegacyCrmContactQl &
  Node & {
    __typename?: 'CrmContactFortellisQL';
    companyName?: Maybe<Scalars['String']['output']>;
    contactType?: Maybe<CrmContactType>;
    createdOn: Scalars['ArrowField']['output'];
    customerId?: Maybe<Scalars['String']['output']>;
    data?: Maybe<Scalars['JSONString']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastName?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    participant?: Maybe<ParticipantQl>;
    participantId: Scalars['String']['output'];
    phoneNumber?: Maybe<Scalars['String']['output']>;
  };

export type CrmContactQl = LegacyCrmContactQl &
  Node & {
    __typename?: 'CrmContactQL';
    companyName?: Maybe<Scalars['String']['output']>;
    contactType?: Maybe<CrmContactType>;
    createdOn: Scalars['ArrowField']['output'];
    customerId?: Maybe<Scalars['String']['output']>;
    data?: Maybe<Scalars['JSONString']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastName?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    participant?: Maybe<ParticipantQl>;
    participantId: Scalars['String']['output'];
    phoneNumber?: Maybe<Scalars['String']['output']>;
  };

export enum CrmContactType {
  Cdk = 'CDK',
  Cnam = 'CNAM',
  Dealerbuilt = 'DEALERBUILT',
  Dealertrack = 'DEALERTRACK',
  Fortellis = 'FORTELLIS',
  Pbs = 'PBS',
  Reynolds = 'REYNOLDS',
  Tekion = 'TEKION',
}

export type CrmUserModelQl = BaseQl &
  Node & {
    __typename?: 'CrmUserModelQL';
    createdOn: Scalars['ArrowField']['output'];
    data?: Maybe<Scalars['JSONString']['output']>;
    externalCrmUserId?: Maybe<Scalars['String']['output']>;
    externalTenantId?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    integrationInternalType?: Maybe<IntegrationInternalId>;
    lastName?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    user?: Maybe<UserQl>;
    userId?: Maybe<Scalars['String']['output']>;
  };

export type CrmUserModelQlConnection = {
  __typename?: 'CrmUserModelQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CrmUserModelQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CrmUserModelQL` and its cursor. */
export type CrmUserModelQlEdge = {
  __typename?: 'CrmUserModelQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CrmUserModelQl>;
};

export type CubeJwtTokenQl = {
  __typename?: 'CubeJwtTokenQL';
  cubeApiHost: Scalars['String']['output'];
  cubeJwtToken: Scalars['String']['output'];
};

export type CurbsideSettingsQl = BaseQl &
  Node & {
    __typename?: 'CurbsideSettingsQL';
    createdOn: Scalars['ArrowField']['output'];
    customHandoffIsAutoreply?: Maybe<Scalars['Boolean']['output']>;
    customHandoffMethod?: Maybe<Scalars['String']['output']>;
    customHereIsAutoreply?: Maybe<Scalars['Boolean']['output']>;
    customOrderIdentifier?: Maybe<Scalars['String']['output']>;
    enabled: Scalars['Boolean']['output'];
    handoffMethod?: Maybe<PlaceHandoffMethod>;
    handoffMethodIntentResponse?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    orderIdentifierIntentResponse?: Maybe<Scalars['String']['output']>;
    orderIdentifierType?: Maybe<PlaceOrderIdType>;
    pickupPattern: Scalars['String']['output'];
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
  };

export enum Currency {
  Usd = 'USD',
}

export type CustomAudioOverrides = {
  __typename?: 'CustomAudioOverrides';
  acknowledgementSpeech?: Maybe<Scalars['String']['output']>;
  afterHoursSpeech?: Maybe<Scalars['String']['output']>;
  canWeTextSpeech?: Maybe<Scalars['String']['output']>;
  clarifyCanWeTextSpeech?: Maybe<Scalars['String']['output']>;
  clarifySpeech?: Maybe<Scalars['String']['output']>;
  disclosureContent?: Maybe<Scalars['String']['output']>;
  finishedSpeech?: Maybe<Scalars['String']['output']>;
  noAnswerSpeech?: Maybe<Scalars['String']['output']>;
  onFailCanWeTextSpeech?: Maybe<Scalars['String']['output']>;
  onFailureSpeech?: Maybe<Scalars['String']['output']>;
  onNoCanWeTextSpeech?: Maybe<Scalars['String']['output']>;
  onNoSpeech?: Maybe<Scalars['String']['output']>;
  onYesCanWeTextSpeech?: Maybe<Scalars['String']['output']>;
  onYesSpeech?: Maybe<Scalars['String']['output']>;
  speech?: Maybe<Scalars['String']['output']>;
};

export type CustomDirectoryEntryModelQl = BaseQl &
  Node & {
    __typename?: 'CustomDirectoryEntryModelQL';
    createdOn: Scalars['ArrowField']['output'];
    directoryEntries?: Maybe<DepartmentDirectoryEntryQlConnection>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    mdn?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    sip?: Maybe<Scalars['String']['output']>;
  };

export type CustomDirectoryEntryModelQlDirectoryEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomDirectoryEntryQl = DirectoryEntryQl &
  Node & {
    __typename?: 'CustomDirectoryEntryQL';
    createdOn: Scalars['ArrowField']['output'];
    customDirectoryEntry?: Maybe<CustomDirectoryEntryModelQl>;
    customDirectoryEntryId?: Maybe<Scalars['String']['output']>;
    department?: Maybe<DepartmentQl>;
    departmentId?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    devices?: Maybe<Array<Maybe<DirectoryDeviceQl>>>;
    displayName?: Maybe<Scalars['String']['output']>;
    entryType?: Maybe<DirectoryEntryType>;
    id: Scalars['ID']['output'];
    isDiscoverable?: Maybe<Scalars['Boolean']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    placeGroup?: Maybe<PlaceGroupQl>;
    placeGroupId: Scalars['String']['output'];
    user?: Maybe<UserQl>;
    userId?: Maybe<Scalars['String']['output']>;
  };

export type CustomDisclosureSpeech = {
  __typename?: 'CustomDisclosureSpeech';
  data?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type CustomOutboundCallAudioOverrides = {
  __typename?: 'CustomOutboundCallAudioOverrides';
  disclosureSpeech?: Maybe<Scalars['String']['output']>;
  hostNoAnswerSpeech?: Maybe<Scalars['String']['output']>;
  voicemailSpeech?: Maybe<Scalars['String']['output']>;
};

export enum CustomerContactTypes {
  InboundCallAnswered = 'INBOUND_CALL_ANSWERED',
  LoggedCall = 'LOGGED_CALL',
  OutboundCallAnswered = 'OUTBOUND_CALL_ANSWERED',
  OutboundCallNoAnswer = 'OUTBOUND_CALL_NO_ANSWER',
  OutboundMessage = 'OUTBOUND_MESSAGE',
}

export type CustomerContactedTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'CustomerContactedTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    customerContactType: CustomerContactTypes;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
  };

export type CustomerQl = BaseQl &
  Node & {
    __typename?: 'CustomerQL';
    account?: Maybe<AccountQl>;
    accountId?: Maybe<Scalars['String']['output']>;
    activeIntegration?: Maybe<ActiveIntegrationQl>;
    activeIntegrationId?: Maybe<Scalars['String']['output']>;
    addresses?: Maybe<Array<Maybe<AddressQl>>>;
    appointments?: Maybe<AppointmentQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    displayName?: Maybe<Scalars['String']['output']>;
    duplicates?: Maybe<Array<Maybe<CustomerQl>>>;
    externalCustomerId?: Maybe<Scalars['String']['output']>;
    externalCustomerSource?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastAppointment?: Maybe<AppointmentQl>;
    lastName?: Maybe<Scalars['String']['output']>;
    lastRepairOrder?: Maybe<RepairOrder>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    participants?: Maybe<Array<Maybe<ParticipantQl>>>;
    placeGroup?: Maybe<PlaceGroupQl>;
    placeGroupId?: Maybe<Scalars['String']['output']>;
    repairOrders?: Maybe<RepairOrderFortellisQlConnection>;
    salutation?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    statusItems?: Maybe<StatusItemQlConnection>;
  };

export type CustomerQlAppointmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerQlRepairOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerQlStatusItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerQlConnection = {
  __typename?: 'CustomerQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CustomerQL` and its cursor. */
export type CustomerQlEdge = {
  __typename?: 'CustomerQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerQl>;
};

export type CustomizedIntentQl = {
  __typename?: 'CustomizedIntentQL';
  first: Scalars['Int']['output'];
  intents?: Maybe<Array<Maybe<LibraryIntentQl>>>;
  placeId: Scalars['String']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

export type DmsHistoryConnection = {
  __typename?: 'DMSHistoryConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DmsHistoryEdge>>;
  lastData?: Maybe<Scalars['JSONString']['output']>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type DmsHistoryConnectionLastDataArgs = {
  dmsType?: InputMaybe<DmsHistoryType>;
  numaObjectId: Scalars['String']['input'];
};

/** A Relay edge containing a `DMSHistory` and its cursor. */
export type DmsHistoryEdge = {
  __typename?: 'DMSHistoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DmsHistoryQl>;
};

export type DmsHistoryQl = BaseQl &
  Node & {
    __typename?: 'DMSHistoryQL';
    createdOn: Scalars['ArrowField']['output'];
    dmsHistoryType?: Maybe<DmsHistoryType>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  };

export enum DmsHistoryType {
  RepairOrder = 'REPAIR_ORDER',
}

export type DateTimeFilter = {
  equal?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  ilike?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  notEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DeactivateAccount = {
  __typename?: 'DeactivateAccount';
  account?: Maybe<AccountQl>;
};

export type DeactivateAccountInput = {
  accountId: Scalars['String']['input'];
};

export type DealerTrackServiceAdvisorQl = BaseQl &
  Node & {
    __typename?: 'DealerTrackServiceAdvisorQL';
    activeIntegration?: Maybe<ActiveIntegrationQl>;
    activeIntegrationId?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    fortellisSubscription?: Maybe<FortellisSubscriptionQl>;
    fortellisSubscriptionId?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    nextFetchTime?: Maybe<Scalars['ArrowField']['output']>;
    placeId?: Maybe<Scalars['String']['output']>;
    placesUser?: Maybe<PlacesUsersQl>;
    placesUsersId: Scalars['String']['output'];
    rawData?: Maybe<Scalars['JSONString']['output']>;
    repairOrderSchedule: Scalars['JSONString']['output'];
    serviceAdvisorId?: Maybe<Scalars['String']['output']>;
    serviceAdvisorName?: Maybe<Scalars['String']['output']>;
    type?: Maybe<ServiceAdvisorType>;
    user?: Maybe<UserQl>;
    userId?: Maybe<Scalars['String']['output']>;
  };

export type DefaultBroadcastInputsQl = {
  __typename?: 'DefaultBroadcastInputsQL';
  channelId: Scalars['String']['output'];
  participantAddresses: Array<Maybe<Scalars['String']['output']>>;
  placeId: Scalars['String']['output'];
};

export type DeleteAppointmentAgentSettingLabel = {
  __typename?: 'DeleteAppointmentAgentSettingLabel';
  id?: Maybe<Scalars['String']['output']>;
};

export type DeleteAppointmentAgentSettingLabelInput = {
  id: Scalars['String']['input'];
};

export type DeleteAppointmentAgentSettings = {
  __typename?: 'DeleteAppointmentAgentSettings';
  appointmentAgentSettings?: Maybe<AppointmentAgentSettingsQl>;
};

export type DeleteAppointmentAgentSettingsInput = {
  id: Scalars['String']['input'];
  replacementAgentId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAutomation = {
  __typename?: 'DeleteAutomation';
  automation?: Maybe<AutomationQl>;
};

export type DeleteAutomationInput = {
  automationId: Scalars['String']['input'];
};

export type DeleteConversation = {
  __typename?: 'DeleteConversation';
  conversation?: Maybe<ConversationQl>;
};

export type DeleteConversationInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  isSpam: Scalars['Boolean']['input'];
};

export type DeleteCustomDirectoryEntry = {
  __typename?: 'DeleteCustomDirectoryEntry';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteCustomLink = {
  __typename?: 'DeleteCustomLink';
  placeInfo?: Maybe<PlaceInfoQl>;
};

export type DeleteCustomLinkInput = {
  label: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type DeleteDepartmentDevice = {
  __typename?: 'DeleteDepartmentDevice';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteIdentityPromptAddress = {
  __typename?: 'DeleteIdentityPromptAddress';
  identityPromptAddress: IdentityPromptAddressQl;
};

export type DeleteIdentityPromptAddressInput = {
  id: Scalars['String']['input'];
};

export type DeleteNoteTaker = {
  __typename?: 'DeleteNoteTaker';
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteNoteTakerInput = {
  id: Scalars['String']['input'];
};

export type DeleteOutboundCallCustomization = {
  __typename?: 'DeleteOutboundCallCustomization';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteOutboundCallCustomizationInput = {
  outboundCallCustomizationId: Scalars['String']['input'];
};

export type DeletePhoneLine = {
  __typename?: 'DeletePhoneLine';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePhoneLineInput = {
  phonelineId: Scalars['String']['input'];
};

export type DeletePlace = {
  __typename?: 'DeletePlace';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePlaceInput = {
  placeId: Scalars['String']['input'];
};

export type DeleteScheduledMessage = {
  __typename?: 'DeleteScheduledMessage';
  success: Scalars['Boolean']['output'];
};

export type DeleteScheduledMessageInput = {
  placeId: Scalars['String']['input'];
  scheduledMessageId: Scalars['String']['input'];
};

export type DeleteShortcut = {
  __typename?: 'DeleteShortcut';
  response?: Maybe<Scalars['String']['output']>;
};

export type DeleteShortcutInput = {
  shortcutId: Scalars['String']['input'];
};

export type DeleteStage = {
  __typename?: 'DeleteStage';
  stage?: Maybe<StageQl>;
};

export type DeleteStageInput = {
  moveTo?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  stageId: Scalars['String']['input'];
};

export type DeleteStatusItem = {
  __typename?: 'DeleteStatusItem';
  statusItem?: Maybe<StatusItemQl>;
};

export type DeleteStatusItemInput = {
  statusId: Scalars['String']['input'];
};

export type DeleteTeam = {
  __typename?: 'DeleteTeam';
  team?: Maybe<TeamQl>;
};

export type DeleteTeamInput = {
  reassignToOtherTeam?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['String']['input'];
};

export type DeleteUserPhone = {
  __typename?: 'DeleteUserPhone';
  userPhone: UserPhoneQl;
};

export type DeleteUserPhoneInput = {
  id: Scalars['String']['input'];
};

export type DeleteVoiceStep = {
  __typename?: 'DeleteVoiceStep';
  voiceScript?: Maybe<VoiceScriptQl>;
};

export type DeleteVoiceStepInput = {
  stepId: Scalars['String']['input'];
};

export type DepartmentDeviceQl = BaseQl &
  Node & {
    __typename?: 'DepartmentDeviceQL';
    createdOn: Scalars['ArrowField']['output'];
    department?: Maybe<DepartmentQl>;
    departmentId?: Maybe<Scalars['String']['output']>;
    deviceType?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    mdn?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    sipAddress?: Maybe<Scalars['String']['output']>;
    sipPriorityFirst: Scalars['Boolean']['output'];
    type: DeviceType;
  };

export type DepartmentDeviceQlConnection = {
  __typename?: 'DepartmentDeviceQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DepartmentDeviceQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DepartmentDeviceQL` and its cursor. */
export type DepartmentDeviceQlEdge = {
  __typename?: 'DepartmentDeviceQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DepartmentDeviceQl>;
};

export type DepartmentDirectoryEntryQl = DirectoryEntryQl &
  Node & {
    __typename?: 'DepartmentDirectoryEntryQL';
    createdOn: Scalars['ArrowField']['output'];
    customDirectoryEntry?: Maybe<CustomDirectoryEntryModelQl>;
    customDirectoryEntryId?: Maybe<Scalars['String']['output']>;
    department?: Maybe<DepartmentQl>;
    departmentId?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    devices?: Maybe<Array<Maybe<DirectoryDeviceQl>>>;
    displayName?: Maybe<Scalars['String']['output']>;
    entryType?: Maybe<DirectoryEntryType>;
    id: Scalars['ID']['output'];
    isDiscoverable?: Maybe<Scalars['Boolean']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    placeGroup?: Maybe<PlaceGroupQl>;
    placeGroupId: Scalars['String']['output'];
    user?: Maybe<UserQl>;
    userId?: Maybe<Scalars['String']['output']>;
  };

export type DepartmentDirectoryEntryQlConnection = {
  __typename?: 'DepartmentDirectoryEntryQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DepartmentDirectoryEntryQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DepartmentDirectoryEntryQL` and its cursor. */
export type DepartmentDirectoryEntryQlEdge = {
  __typename?: 'DepartmentDirectoryEntryQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DepartmentDirectoryEntryQl>;
};

export type DepartmentQl = BaseQl &
  Node & {
    __typename?: 'DepartmentQL';
    createdOn: Scalars['ArrowField']['output'];
    devices?: Maybe<DepartmentDeviceQlConnection>;
    directoryEntries?: Maybe<DepartmentDirectoryEntryQlConnection>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
    phoneline?: Maybe<PhoneLineQl>;
    phonelineId?: Maybe<Scalars['String']['output']>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
  };

export type DepartmentQlDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DepartmentQlDirectoryEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DepartmentQlConnection = {
  __typename?: 'DepartmentQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DepartmentQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DepartmentQL` and its cursor. */
export type DepartmentQlEdge = {
  __typename?: 'DepartmentQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DepartmentQl>;
};

export enum DesiredConversationState {
  AlwaysClosed = 'ALWAYS_CLOSED',
  AlwaysOpen = 'ALWAYS_OPEN',
  LeaveUnchanged = 'LEAVE_UNCHANGED',
}

export enum DesiredConversationStateActionInput {
  AlwaysClosed = 'ALWAYS_CLOSED',
  AlwaysOpen = 'ALWAYS_OPEN',
  LeaveUnchanged = 'LEAVE_UNCHANGED',
}

export enum DeviceType {
  Desk = 'DESK',
  Mobile = 'MOBILE',
}

export enum DeviceTypeInput {
  Desk = 'DESK',
  Mobile = 'MOBILE',
}

export type DialogFlowBotDataQl = BaseQl &
  Node & {
    __typename?: 'DialogFlowBotDataQL';
    account?: Maybe<AccountQl>;
    accountId: Scalars['String']['output'];
    agentDuration: Scalars['Int']['output'];
    agentReason?: Maybe<DialogflowAgentReason>;
    appointment?: Maybe<AppointmentQl>;
    appointmentWasBooked: Scalars['Boolean']['output'];
    conversation?: Maybe<ConversationQl>;
    conversationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customerInDms?: Maybe<Scalars['Boolean']['output']>;
    data: Scalars['JSONString']['output'];
    dialogflowOutcome?: Maybe<Scalars['JSONString']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messages?: Maybe<MessageQlConnection>;
    outcome?: Maybe<DialogflowOutcome>;
    phonecall?: Maybe<PhoneCallQl>;
    phonecallId: Scalars['String']['output'];
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
  };

export type DialogFlowBotDataQlMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DialogFlowBotDataQlConnection = {
  __typename?: 'DialogFlowBotDataQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DialogFlowBotDataQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DialogFlowBotDataQL` and its cursor. */
export type DialogFlowBotDataQlEdge = {
  __typename?: 'DialogFlowBotDataQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DialogFlowBotDataQl>;
};

export enum DialogflowAgentReason {
  CustomerAsked = 'CUSTOMER_ASKED',
  FailedRecognition = 'FAILED_RECOGNITION',
  NoAvailableTimes = 'NO_AVAILABLE_TIMES',
  NoInputRetriesExceeded = 'NO_INPUT_RETRIES_EXCEEDED',
  SchedulingRoundTripsExceeded = 'SCHEDULING_ROUND_TRIPS_EXCEEDED',
  ServiceNotMapped = 'SERVICE_NOT_MAPPED',
  ServiceNotSupported = 'SERVICE_NOT_SUPPORTED',
  WebhookError = 'WEBHOOK_ERROR',
  WebhookTimeout = 'WEBHOOK_TIMEOUT',
}

export enum DialogflowOutcome {
  Agent = 'AGENT',
  Booked = 'BOOKED',
  CantService = 'CANT_SERVICE',
  Error = 'ERROR',
  Hangup = 'HANGUP',
  Lead = 'LEAD',
  Recall = 'RECALL',
}

/** Unified GraphQL type for directory entry devices */
export type DirectoryDeviceQl = {
  __typename?: 'DirectoryDeviceQL';
  deviceId?: Maybe<Scalars['UUID']['output']>;
  deviceType?: Maybe<DirectoryDeviceType>;
  mdn?: Maybe<Scalars['String']['output']>;
  sipAddress?: Maybe<Scalars['String']['output']>;
};

/** Type of device */
export enum DirectoryDeviceType {
  Desk = 'DESK',
  Mobile = 'MOBILE',
}

/** Interface for all directory entry types */
export type DirectoryEntryQl = {
  createdOn: Scalars['ArrowField']['output'];
  description?: Maybe<Scalars['String']['output']>;
  devices?: Maybe<Array<Maybe<DirectoryDeviceQl>>>;
  displayName?: Maybe<Scalars['String']['output']>;
  entryType?: Maybe<DirectoryEntryType>;
  id: Scalars['ID']['output'];
  isDiscoverable?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
};

/** Type of directory entry */
export enum DirectoryEntryType {
  Custom = 'CUSTOM',
  Department = 'DEPARTMENT',
  User = 'USER',
}

export type DisableAutopilot = {
  __typename?: 'DisableAutopilot';
  autopilot: AutopilotQl;
};

export type DisableAutopilotInput = {
  autopilotId: Scalars['String']['input'];
};

export type DisableFortellisSubscription = {
  __typename?: 'DisableFortellisSubscription';
  fortellisSubscription?: Maybe<FortellisSubscriptionQl>;
};

export type DisableFortellisSubscriptionInput = {
  id: Scalars['String']['input'];
};

export type DiscardAutomationEdits = {
  __typename?: 'DiscardAutomationEdits';
  automation?: Maybe<AutomationQl>;
};

export type DiscardAutomationEditsInput = {
  automationId: Scalars['String']['input'];
};

export type DiscardDisruptionVoiceScript = {
  __typename?: 'DiscardDisruptionVoiceScript';
  place?: Maybe<PlaceQl>;
};

export type DiscardDisruptionVoiceScriptInput = {
  answeringMode: AnsweringMode;
  placeId: Scalars['String']['input'];
  policyCategory: PhoneLinePolicyCategory;
  scriptId: Scalars['String']['input'];
};

export type DiscardVoiceScript = {
  __typename?: 'DiscardVoiceScript';
  answeringScript?: Maybe<AnsweringScriptsQl>;
};

export type DiscardVoiceScriptInput = {
  answeringScriptId: Scalars['String']['input'];
  scriptId: Scalars['String']['input'];
};

export type DismissTask = {
  __typename?: 'DismissTask';
  task: TaskQl;
};

export type DismissTaskInput = {
  dismissalReason?: InputMaybe<TaskDismissalReason>;
  taskId: Scalars['UUID']['input'];
};

export type DisputeQl = BaseQl &
  Node & {
    __typename?: 'DisputeQL';
    createdOn: Scalars['ArrowField']['output'];
    disputeObject: Scalars['JSONString']['output'];
    disputeObjectId: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    paymentRequest?: Maybe<PaymentRequestQl>;
    paymentRequestId: Scalars['String']['output'];
    reason: Scalars['String']['output'];
    status: Scalars['String']['output'];
  };

export type DisruptionsInput = {
  disruptionsGreeting?: InputMaybe<Scalars['String']['input']>;
};

export type DisruptionsQl = BaseQl &
  Node & {
    __typename?: 'DisruptionsQL';
    createdOn: Scalars['ArrowField']['output'];
    disruptionDepartmentVoiceScript?: Maybe<VoiceScriptQl>;
    disruptionDepartmentVoiceScriptId: Scalars['String']['output'];
    /** @deprecated Unused and will be removed soon */
    disruptionStaffVoiceScript?: Maybe<VoiceScriptQl>;
    disruptionStaffVoiceScriptId?: Maybe<Scalars['String']['output']>;
    disruptionsActive?: Maybe<Scalars['Boolean']['output']>;
    disruptionsGreeting: Scalars['String']['output'];
    draftDisruptionDepartmentVoiceScript?: Maybe<VoiceScriptQl>;
    draftDisruptionDepartmentVoiceScriptId: Scalars['String']['output'];
    /** @deprecated Unused and will be removed soon */
    draftDisruptionStaffVoiceScript?: Maybe<VoiceScriptQl>;
    draftDisruptionStaffVoiceScriptId?: Maybe<Scalars['String']['output']>;
    draftHolidayDepartmentVoiceScript?: Maybe<VoiceScriptQl>;
    draftHolidayDepartmentVoiceScriptId: Scalars['String']['output'];
    /** @deprecated Unused and will be removed soon */
    draftHolidayStaffVoiceScript?: Maybe<VoiceScriptQl>;
    draftHolidayStaffVoiceScriptId?: Maybe<Scalars['String']['output']>;
    holidayDepartmentVoiceScript?: Maybe<VoiceScriptQl>;
    holidayDepartmentVoiceScriptId: Scalars['String']['output'];
    /** @deprecated Unused and will be removed soon */
    holidayStaffVoiceScript?: Maybe<VoiceScriptQl>;
    holidayStaffVoiceScriptId?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
  };

export type DuplicateAppointmentAgentSettings = {
  __typename?: 'DuplicateAppointmentAgentSettings';
  appointmentAgentSettings?: Maybe<AppointmentAgentSettingsQl>;
};

export type DuplicateAppointmentAgentSettingsInput = {
  id: Scalars['String']['input'];
  newAgentName: Scalars['String']['input'];
};

export type EtoSettingsQl = BaseQl &
  Node & {
    __typename?: 'ETOSettingsQL';
    automationGroup?: Maybe<AutomationGroupQl>;
    automationGroupId?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    daysFrequency: Scalars['Int']['output'];
    eligibilityCriteria: Scalars['JSONString']['output'];
    id: Scalars['ID']['output'];
    isInboxLabelEnabled: Scalars['Boolean']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    leadCreationEmail?: Maybe<Scalars['String']['output']>;
    minimumQualifyingScore: Scalars['Int']['output'];
    noRepeat: Scalars['Boolean']['output'];
    oneAtATime: Scalars['Boolean']['output'];
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    qualifiedNotificationEmailRecipient: Scalars['String']['output'];
  };

/** GraphQL type for early exit analysis */
export type EarlyExitAnalysisQl = {
  __typename?: 'EarlyExitAnalysisQL';
  details: Array<Maybe<EarlyExitDetailQl>>;
  exitTypes: Scalars['JSONString']['output'];
  totalEarlyExits: Scalars['Int']['output'];
};

/** GraphQL type for early exit detail */
export type EarlyExitDetailQl = {
  __typename?: 'EarlyExitDetailQL';
  completedAt?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['String']['output'];
  customerInformation?: Maybe<ManualOpportunityCustomerInformationQl>;
  durationBeforeExit?: Maybe<Scalars['Float']['output']>;
  jobId: Scalars['String']['output'];
  possibleExitTriggers: Array<Maybe<Scalars['String']['output']>>;
};

export enum EmailNotificationSettings {
  Everything = 'EVERYTHING',
  EverythingButMuted = 'EVERYTHING_BUT_MUTED',
  None = 'NONE',
  OnlyMine = 'ONLY_MINE',
}

export enum EmailNotificationSettingsInput {
  Everything = 'EVERYTHING',
  EverythingButMuted = 'EVERYTHING_BUT_MUTED',
  None = 'NONE',
  OnlyMine = 'ONLY_MINE',
}

export type EmployeeQl = {
  __typename?: 'EmployeeQL';
  advisorId: Scalars['String']['output'];
  cdkServiceAdvisor?: Maybe<ServiceAdvisorQl>;
  dealertrackServiceAdvisor?: Maybe<ServiceAdvisorQl>;
  name: Scalars['String']['output'];
  roCount: Scalars['Int']['output'];
  serviceAdvisor?: Maybe<ServiceAdvisorQl>;
};

export type EnableInboxLanguageOverride = {
  __typename?: 'EnableInboxLanguageOverride';
  phoneline?: Maybe<PhoneLineQl>;
};

export type EnableInboxLanguageOverrideInput = {
  enable: Scalars['Boolean']['input'];
  phonelineId: Scalars['String']['input'];
};

export type EnableNudges = {
  __typename?: 'EnableNudges';
  accountSettings?: Maybe<AccountSettingsQl>;
  currentAccount?: Maybe<AccountQl>;
};

export type EnableNudgesInput = {
  nudgesEnabled: Scalars['Boolean']['input'];
  nudgesThreshold?: InputMaybe<Scalars['Int']['input']>;
};

export type EnablePlaceMessagingHours = {
  __typename?: 'EnablePlaceMessagingHours';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EnablePlaceMessagingHoursInput = {
  placeId: Scalars['String']['input'];
  useMessagingHours: Scalars['Boolean']['input'];
};

export type EndOutboundConferenceCall = {
  __typename?: 'EndOutboundConferenceCall';
  outboundConferenceCall: OutboundConferenceCallQl;
};

export type EndOutboundConferenceCallInput = {
  id: Scalars['String']['input'];
};

export enum EnforceMfa {
  Always = 'ALWAYS',
  Never = 'NEVER',
  Risky = 'RISKY',
}

export type EngagementInboxAgentResultQl = {
  __typename?: 'EngagementInboxAgentResultQL';
  createdOn?: Maybe<Scalars['ArrowField']['output']>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  /** The rating performed by requesting user for this assisted response, if any. */
  myAssistedResponseRating?: Maybe<AssistedResponseRatingQl>;
  predictedMessageIntents: Array<PredictedMessageIntentQl>;
  promptHash?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<Scalars['String']['output']>;
  sentimentValue?: Maybe<Scalars['Float']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  topics: Array<Scalars['String']['output']>;
};

export type EngagementQl = {
  __typename?: 'EngagementQL';
  boundsEnd?: Maybe<Scalars['ArrowField']['output']>;
  boundsStart: Scalars['ArrowField']['output'];
  conversation?: Maybe<ConversationQl>;
  conversationId: Scalars['String']['output'];
  createdOn?: Maybe<Scalars['ArrowField']['output']>;
  id: Scalars['String']['output'];
  lastConsideredActivityTime: Scalars['ArrowField']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  /** The latest inbox agent result for this engagement. */
  latestInboxAgentResult?: Maybe<EngagementInboxAgentResultQl>;
  /** The rating performed by requesting user for the engagement status, if any. */
  myStatusRating?: Maybe<EngagementStatusRatingQl>;
  /** The rating performed by requesting user for the current summary, if any. */
  mySummaryRating?: Maybe<EngagementSummaryRatingQl>;
  status?: Maybe<Scalars['String']['output']>;
  /** The most recently generated summary for the engagement, if any. */
  summary?: Maybe<Scalars['String']['output']>;
  summaryCreatedOn?: Maybe<Scalars['ArrowField']['output']>;
  /** Most recently generated summary's ID, if any. Used to allow rating specific summaries. */
  summaryId?: Maybe<Scalars['ID']['output']>;
  /** The tasks associated with this engagement. */
  tasks: Array<TaskQl>;
};

export type EngagementStatusRatingInput = {
  /** Optional freeform feedback for the rating. */
  details?: InputMaybe<Scalars['String']['input']>;
  /** The reason for the rating. Optional, and should try to be structured. Use `details` for freeform feedback. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** How the user rated the engagement status and tasks. Assuming a thumbs up/down system, values should be 1 for for thumbs-up, -1 for thumbs-down, 0 for indeterminate. */
  value: Scalars['Int']['input'];
};

export type EngagementStatusRatingQl = {
  __typename?: 'EngagementStatusRatingQL';
  createdOn?: Maybe<Scalars['ArrowField']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  value: Scalars['Int']['output'];
};

export type EngagementSummaryRatingInput = {
  /** Optional freeform feedback for the rating. */
  details?: InputMaybe<Scalars['String']['input']>;
  /** The reason for the rating. Optional, and should try to be structured. Use `details` for freeform feedback. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** How the user rated the summary. Assuming a thumbs up/down system, values should be 1 for for thumbs-up, -1 for thumbs-down, 0 for indeterminate. */
  value: Scalars['Int']['input'];
};

export type EngagementSummaryRatingQl = {
  __typename?: 'EngagementSummaryRatingQL';
  createdAt: Scalars['ArrowField']['output'];
  details?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ArrowField']['output'];
  value: Scalars['Int']['output'];
};

export type EnrollmentCriteriaQl = {
  __typename?: 'EnrollmentCriteriaQL';
  duration: Scalars['Int']['output'];
  executionLimit: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  preventConcurrentEnrollment: Scalars['Boolean']['output'];
};

export enum EquityTradeOpportunityCloseReason {
  Disqualified = 'DISQUALIFIED',
  RoClosed = 'RO_CLOSED',
  UserReported = 'USER_REPORTED',
}

export type EquityTradeOpportunityCreatedTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'EquityTradeOpportunityCreatedTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
  };

export type EquityTradeOpportunityQl = BaseQl &
  Node & {
    __typename?: 'EquityTradeOpportunityQL';
    closeReason?: Maybe<EquityTradeOpportunityCloseReason>;
    closedByParticipant?: Maybe<ParticipantQl>;
    closedByParticipantId?: Maybe<Scalars['String']['output']>;
    conversation?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    expirationDate?: Maybe<Scalars['ArrowField']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    qualificationSurvey?: Maybe<QualificationSurveyQl>;
    repairOrder?: Maybe<RepairOrderFortellisQl>;
    repairOrderId: Scalars['String']['output'];
    settings?: Maybe<Scalars['String']['output']>;
    source?: Maybe<EquityTradeOpportunitySource>;
    stage: EquityTradeOpportunityStage;
    status?: Maybe<Scalars['String']['output']>;
  };

export type EquityTradeOpportunityQlConnection = {
  __typename?: 'EquityTradeOpportunityQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EquityTradeOpportunityQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EquityTradeOpportunityQL` and its cursor. */
export type EquityTradeOpportunityQlEdge = {
  __typename?: 'EquityTradeOpportunityQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EquityTradeOpportunityQl>;
};

export enum EquityTradeOpportunitySource {
  RepairOrderOpen = 'REPAIR_ORDER_OPEN',
  RepairOrderReassigned = 'REPAIR_ORDER_REASSIGNED',
}

export enum EquityTradeOpportunityStage {
  Expired = 'EXPIRED',
  FollowUp = 'FOLLOW_UP',
  Ineligible = 'INELIGIBLE',
  Lost = 'LOST',
  Prospect = 'PROSPECT',
  QualificationAnswered = 'QUALIFICATION_ANSWERED',
  Qualified = 'QUALIFIED',
  Unqualified = 'UNQUALIFIED',
  Void = 'VOID',
  Won = 'WON',
}

export type EscalateConversationActionQl = AutomationAction &
  Node & {
    __typename?: 'EscalateConversationActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    /** The content to include in the escalation message */
    messageToSend?: Maybe<Scalars['String']['output']>;
    nextActionId?: Maybe<Scalars['String']['output']>;
    uiHints?: Maybe<AutomationUiHints>;
  };

export type EvaluateBusinessIdentity = {
  __typename?: 'EvaluateBusinessIdentity';
  tenDlcProcess?: Maybe<TenDlcProcessQl>;
};

export type EvaluationTimeInput = {
  /** Time in HH:mm format (24-hour) */
  time: Scalars['String']['input'];
};

export type EvaluationTimeQl = {
  __typename?: 'EvaluationTimeQL';
  time: Scalars['String']['output'];
};

export type ExportConversationToArchive = {
  __typename?: 'ExportConversationToArchive';
  taskId?: Maybe<Scalars['String']['output']>;
};

export type ExportConversationToArchiveInput = {
  conversationId: Scalars['String']['input'];
  fromDate?: InputMaybe<Scalars['ArrowField']['input']>;
  recipientEmail: Scalars['String']['input'];
  toDate?: InputMaybe<Scalars['ArrowField']['input']>;
};

export type ExternalCrmUserQl = {
  __typename?: 'ExternalCRMUserQL';
  emails: Array<CrmEmailQl>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type ExternalOpcodeInput = {
  dmsId: Scalars['String']['input'];
  serviceName: Scalars['String']['input'];
};

export type ExternalOpcodeQl = BaseQl &
  Node & {
    __typename?: 'ExternalOpcodeQL';
    createdOn: Scalars['ArrowField']['output'];
    dmsId: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    serviceName: Scalars['String']['output'];
  };

export type ExternalVehicleConnection = {
  __typename?: 'ExternalVehicleConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ExternalVehicleEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ExternalVehicle` and its cursor. */
export type ExternalVehicleEdge = {
  __typename?: 'ExternalVehicleEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ExternalVehicleQl>;
};

export type ExternalVehicleModelFilter = {
  activeIntegrationId?: InputMaybe<StringFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  id?: InputMaybe<StringFilter>;
  lastSyncTime?: InputMaybe<ArrowFieldFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  make?: InputMaybe<StringFilter>;
  manufacturerId?: InputMaybe<StringFilter>;
  model?: InputMaybe<StringFilter>;
  rawData?: InputMaybe<StringFilter>;
  year?: InputMaybe<IntFilter>;
};

export enum ExternalVehicleModelSortEnum {
  ActiveIntegrationIdAsc = 'active_integration_id_asc',
  ActiveIntegrationIdDesc = 'active_integration_id_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  LastSyncTimeAsc = 'last_sync_time_asc',
  LastSyncTimeDesc = 'last_sync_time_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  MakeAsc = 'make_asc',
  MakeDesc = 'make_desc',
  ManufacturerIdAsc = 'manufacturer_id_asc',
  ManufacturerIdDesc = 'manufacturer_id_desc',
  ModelAsc = 'model_asc',
  ModelDesc = 'model_desc',
  RawDataAsc = 'raw_data_asc',
  RawDataDesc = 'raw_data_desc',
  YearAsc = 'year_asc',
  YearDesc = 'year_desc',
}

export type ExternalVehicleOverrideQl = Node & {
  __typename?: 'ExternalVehicleOverrideQL';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  numaServiceName: Scalars['String']['output'];
  opcodes?: Maybe<Array<Maybe<ExternalOpcodeQl>>>;
  type: Scalars['String']['output'];
};

export type ExternalVehicleQl = BaseQl &
  Node & {
    __typename?: 'ExternalVehicleQL';
    activeIntegration?: Maybe<ActiveIntegrationQl>;
    activeIntegrationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastSyncTime?: Maybe<Scalars['ArrowField']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    make: Scalars['String']['output'];
    manufacturerId?: Maybe<Scalars['String']['output']>;
    model: Scalars['String']['output'];
    overrides?: Maybe<Array<Maybe<ExternalVehicleOverrideQl>>>;
    rawData?: Maybe<Scalars['String']['output']>;
    year: Scalars['Int']['output'];
  };

export type FacebookChannelQl = Channel &
  Node & {
    __typename?: 'FacebookChannelQL';
    Assignee?: Maybe<UserQl>;
    AssigneeId?: Maybe<Scalars['String']['output']>;
    RespectExistingAssignments?: Maybe<Scalars['Boolean']['output']>;
    Team?: Maybe<TeamQl>;
    TeamId?: Maybe<Scalars['String']['output']>;
    account: AccountQl;
    accountId: Scalars['String']['output'];
    assignTextReplies?: Maybe<Scalars['String']['output']>;
    assignee?: Maybe<UserQl>;
    assigneeId?: Maybe<Scalars['String']['output']>;
    channelType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    fbUserId?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    identityPromptAddresses?: Maybe<IdentityPromptAddressQlConnection>;
    identityPromptOption: IdentityPromptOptions;
    isActive: Scalars['Boolean']['output'];
    isBotEnabled: Scalars['Boolean']['output'];
    isNryChannel?: Maybe<Scalars['Boolean']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    link?: Maybe<Scalars['String']['output']>;
    messages?: Maybe<MessageQlConnection>;
    name?: Maybe<Scalars['String']['output']>;
    operator?: Maybe<OperatorQl>;
    operatorId?: Maybe<Scalars['String']['output']>;
    operatorSessions?: Maybe<OperatorSessionQlConnection>;
    outboundConferenceCall?: Maybe<OutboundConferenceCallQlConnection>;
    outboundProxyCall?: Maybe<OutboundProxyCallQlConnection>;
    page: Scalars['String']['output'];
    pageAccessToken: Scalars['String']['output'];
    phonecalls?: Maybe<PhoneCallQlConnection>;
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    respectExistingAssignments?: Maybe<Scalars['Boolean']['output']>;
    scheduled?: Maybe<ScheduledMessageQlConnection>;
    smsChannel?: Maybe<BaseChannel>;
    smsPhonelines?: Maybe<PhoneLineQlConnection>;
    supportsVoicemail?: Maybe<Scalars['Boolean']['output']>;
    team?: Maybe<TeamQl>;
    teamId?: Maybe<Scalars['String']['output']>;
    tokenExpiresOn?: Maybe<Scalars['ArrowField']['output']>;
    tokenValid?: Maybe<Scalars['Boolean']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    username?: Maybe<Scalars['String']['output']>;
  };

export type FacebookChannelQlIdentityPromptAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FacebookChannelQlMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FacebookChannelQlOperatorSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FacebookChannelQlOutboundConferenceCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FacebookChannelQlOutboundProxyCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FacebookChannelQlPhonecallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FacebookChannelQlScheduledArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FacebookChannelQlSmsPhonelinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FacebookReviewSite = ReviewSiteInterface & {
  __typename?: 'FacebookReviewSite';
  facebookPageId: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FileAttachment = Attachment &
  Node & {
    __typename?: 'FileAttachment';
    attachmentType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    filename: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    message?: Maybe<MessageQl>;
    messageId?: Maybe<Scalars['String']['output']>;
    primaryMimetype?: Maybe<Scalars['String']['output']>;
    sizeBytes: Scalars['String']['output'];
    url: Scalars['String']['output'];
    words?: Maybe<Scalars['JSONString']['output']>;
  };

export type FileAttachmentInput = {
  data: Scalars['Upload']['input'];
  filename: Scalars['String']['input'];
  sizeBytes: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** Input type for file upload information */
export type FileUploadInput = {
  content: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
};

export type FloatFilter = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  ilike?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  like?: InputMaybe<Scalars['Float']['input']>;
  notEqual?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type ForceActiveIntegrationSync = {
  __typename?: 'ForceActiveIntegrationSync';
  activeIntegration?: Maybe<ActiveIntegrationQl>;
};

export type ForceActiveIntegrationSyncInput = {
  activeIntegrationId: Scalars['String']['input'];
};

export type FortellisServiceAdvisorQl = {
  __typename?: 'FortellisServiceAdvisorQL';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  serviceAdvisorId: Scalars['String']['output'];
};

export enum FortellisStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
}

export type FortellisSubscriptionConnection = {
  __typename?: 'FortellisSubscriptionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FortellisSubscriptionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FortellisSubscription` and its cursor. */
export type FortellisSubscriptionEdge = {
  __typename?: 'FortellisSubscriptionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FortellisSubscriptionQl>;
};

export type FortellisSubscriptionModelFilter = {
  accountId?: InputMaybe<StringFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  id?: InputMaybe<StringFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  name?: InputMaybe<StringFilter>;
  serviceAdvisorCache?: InputMaybe<JsonStringFilter>;
  serviceAdvisorCacheTimestamp?: InputMaybe<ArrowFieldFilter>;
  status?: InputMaybe<StringFilter>;
  subscriptionId?: InputMaybe<StringFilter>;
};

export enum FortellisSubscriptionModelSortEnum {
  AccountIdAsc = 'account_id_asc',
  AccountIdDesc = 'account_id_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  ServiceAdvisorCacheAsc = 'service_advisor_cache_asc',
  ServiceAdvisorCacheDesc = 'service_advisor_cache_desc',
  ServiceAdvisorCacheTimestampAsc = 'service_advisor_cache_timestamp_asc',
  ServiceAdvisorCacheTimestampDesc = 'service_advisor_cache_timestamp_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc',
  SubscriptionIdAsc = 'subscription_id_asc',
  SubscriptionIdDesc = 'subscription_id_desc',
}

export type FortellisSubscriptionQl = BaseQl &
  Node & {
    __typename?: 'FortellisSubscriptionQL';
    account?: Maybe<AccountQl>;
    accountId?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    crmLookupEnabledPlaces?: Maybe<PlaceQlConnection>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
    registeredServiceAdvisors?: Maybe<CdkServiceAdvisorQlConnection>;
    repairOrderPlace?: Maybe<PlaceQl>;
    repairOrderPlaceId: Scalars['String']['output'];
    serviceAdvisorCache?: Maybe<Scalars['JSONString']['output']>;
    serviceAdvisorCacheTimestamp?: Maybe<Scalars['ArrowField']['output']>;
    serviceAdvisors: Array<FortellisServiceAdvisorQl>;
    status: FortellisStatus;
    subscriptionId: Scalars['String']['output'];
  };

export type FortellisSubscriptionQlCrmLookupEnabledPlacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FortellisSubscriptionQlRegisteredServiceAdvisorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FortellisSubscriptionQlConnection = {
  __typename?: 'FortellisSubscriptionQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FortellisSubscriptionQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FortellisSubscriptionQL` and its cursor. */
export type FortellisSubscriptionQlEdge = {
  __typename?: 'FortellisSubscriptionQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FortellisSubscriptionQl>;
};

export enum FunctionsType {
  Equals = 'equals',
  HasChanged = 'has_changed',
  OldValueToNewValue = 'old_value_to_new_value',
  OldValueWas = 'old_value_was',
}

export type GenerateRepairOrderAssistedStatusContent = {
  __typename?: 'GenerateRepairOrderAssistedStatusContent';
  /** The generated status content */
  statusContent: Scalars['String']['output'];
};

export type GenerateRepairOrderAssistedStatusContentInput = {
  /** Any other user-provided details */
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  /** Questions with answers provided by the user */
  answeredQuestions: Array<UserAnsweredQuestionInput>;
  conversationId: Scalars['String']['input'];
  /** What the user has written so far to send, but has not yet actually sent */
  writtenUnsentMessageText?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateRepairOrderNotesSummary = {
  __typename?: 'GenerateRepairOrderNotesSummary';
  repairOrderNotesSummary?: Maybe<RepairOrderNotesSummaryQl>;
};

export type GenerateRepairOrderNotesSummaryInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  repairOrderId: Scalars['UUID']['input'];
};

export type GenerateWriteItForMeContent = {
  __typename?: 'GenerateWriteItForMeContent';
  /** The generated content */
  content: Scalars['String']['output'];
};

export type GenerateWriteItForMeContentInput = {
  /** Questions with answers provided by the user */
  answeredQuestions?: InputMaybe<Array<WriteItForMeUserAnsweredQuestionInput>>;
  conversationId: Scalars['String']['input'];
  /** Specific aim the user seeks to achieve (e.g. is this for a status update) */
  intent: Scalars['String']['input'];
  /** Any user-provided details */
  textInput?: InputMaybe<Scalars['String']['input']>;
  /** The tone to use for the generated content, e.g. 'professional', 'friendly'... */
  tone?: InputMaybe<Scalars['String']['input']>;
  /** What the user has written so far to send, but has not yet actually sent */
  writtenUnsentMessageText?: InputMaybe<Scalars['String']['input']>;
};

export type GenericAddServiceAdvisorInput = {
  activeIntegrationId: Scalars['String']['input'];
  rawData?: InputMaybe<Scalars['JSONString']['input']>;
  serviceAdvisorId?: InputMaybe<Scalars['String']['input']>;
  serviceAdvisorName?: InputMaybe<Scalars['String']['input']>;
  serviceAdvisorType: ServiceAdvisorType;
  userId: Scalars['String']['input'];
};

export type GlobalSyncXtimeServices = {
  __typename?: 'GlobalSyncXtimeServices';
  activeIntegration?: Maybe<ActiveIntegrationQl>;
  latestSchedulerSync?: Maybe<SchedulerSyncQl>;
  /** @deprecated Use latest_scheduler_sync instead. */
  latestXtimeSync?: Maybe<XTimeSyncModelQl>;
  supportedVehicles?: Maybe<Array<SupportedVehiclesQl>>;
};

export type GlobalSyncXtimeServicesInput = {
  activeIntegrationId: Scalars['String']['input'];
};

export type GoogleChannelQl = Channel &
  Node & {
    __typename?: 'GoogleChannelQL';
    Assignee?: Maybe<UserQl>;
    AssigneeId?: Maybe<Scalars['String']['output']>;
    RespectExistingAssignments?: Maybe<Scalars['Boolean']['output']>;
    Team?: Maybe<TeamQl>;
    TeamId?: Maybe<Scalars['String']['output']>;
    account: AccountQl;
    accountId: Scalars['String']['output'];
    assignTextReplies?: Maybe<Scalars['String']['output']>;
    assignee?: Maybe<UserQl>;
    assigneeId?: Maybe<Scalars['String']['output']>;
    businessId?: Maybe<Scalars['String']['output']>;
    channelType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    googlePlaceId?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    identityPromptAddresses?: Maybe<IdentityPromptAddressQlConnection>;
    identityPromptOption: IdentityPromptOptions;
    isActive: Scalars['Boolean']['output'];
    isBotEnabled: Scalars['Boolean']['output'];
    isNryChannel?: Maybe<Scalars['Boolean']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messages?: Maybe<MessageQlConnection>;
    name?: Maybe<Scalars['String']['output']>;
    operator?: Maybe<OperatorQl>;
    operatorId?: Maybe<Scalars['String']['output']>;
    operatorSessions?: Maybe<OperatorSessionQlConnection>;
    outboundConferenceCall?: Maybe<OutboundConferenceCallQlConnection>;
    outboundProxyCall?: Maybe<OutboundProxyCallQlConnection>;
    phonecalls?: Maybe<PhoneCallQlConnection>;
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    respectExistingAssignments?: Maybe<Scalars['Boolean']['output']>;
    scheduled?: Maybe<ScheduledMessageQlConnection>;
    smsChannel?: Maybe<BaseChannel>;
    smsPhonelines?: Maybe<PhoneLineQlConnection>;
    supportsVoicemail?: Maybe<Scalars['Boolean']['output']>;
    team?: Maybe<TeamQl>;
    teamId?: Maybe<Scalars['String']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    version?: Maybe<Scalars['Int']['output']>;
  };

export type GoogleChannelQlIdentityPromptAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleChannelQlMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleChannelQlOperatorSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleChannelQlOutboundConferenceCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleChannelQlOutboundProxyCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleChannelQlPhonecallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleChannelQlScheduledArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleChannelQlSmsPhonelinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleReviewSite = ReviewSiteInterface & {
  __typename?: 'GoogleReviewSite';
  googlePlaceId: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum GreetingKind {
  OptIn = 'OPT_IN',
  Prospect = 'PROSPECT',
  Welcome = 'WELCOME',
}

export type GreetingQl = {
  __typename?: 'GreetingQL';
  afterHoursContent?: Maybe<Scalars['String']['output']>;
  afterHoursContentTemplate?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  contentTemplate?: Maybe<Scalars['String']['output']>;
  createdOn?: Maybe<Scalars['ArrowField']['output']>;
  id: Scalars['String']['output'];
  kind: GreetingKind;
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  place?: Maybe<PlaceQl>;
  placeId?: Maybe<Scalars['String']['output']>;
};

export type GreetingStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'GreetingStepQL';
    affirmationSpeech: Scalars['String']['output'];
    affirmationSpeechUrl: Scalars['String']['output'];
    afterHoursSpeech: Scalars['String']['output'];
    afterHoursSpeechUrl: Scalars['String']['output'];
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    clarificationSpeech: Scalars['String']['output'];
    clarificationSpeechUrl: Scalars['String']['output'];
    collectNewPhonenumberSpeech: Scalars['String']['output'];
    collectNewPhonenumberSpeechUrl: Scalars['String']['output'];
    collectPhonenumberFallbackSpeech: Scalars['String']['output'];
    confirmPhonenumberSpeech: Scalars['String']['output'];
    confirmPhonenumberSpeechUrl: Scalars['String']['output'];
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    disclosureContent: Scalars['String']['output'];
    disclosureContentUrl: Scalars['String']['output'];
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    isCorrectQuestionSpeech: Scalars['String']['output'];
    isCorrectQuestionSpeechUrl: Scalars['String']['output'];
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextStepId?: Maybe<Scalars['String']['output']>;
    nextStepRelationship?: Maybe<VoiceScriptStepQl>;
    noSpeech: Scalars['String']['output'];
    noSpeechUrl: Scalars['String']['output'];
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    playDisclosureRecording: Scalars['Boolean']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedAfterHoursSpeech: Scalars['String']['output'];
    renderedSpeech: Scalars['String']['output'];
    retrySpeech: Scalars['String']['output'];
    retrySpeechUrl: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    softOpenSpeech: Scalars['String']['output'];
    softOpenSpeechUrl: Scalars['String']['output'];
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesSpeech: Scalars['String']['output'];
    yesSpeechUrl: Scalars['String']['output'];
  };

export type GreetingStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type GreetingStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type GreetingStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GreetingStepQlConnection = {
  __typename?: 'GreetingStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GreetingStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GreetingStepQL` and its cursor. */
export type GreetingStepQlEdge = {
  __typename?: 'GreetingStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GreetingStepQl>;
};

export type GuideChecklistQl = {
  __typename?: 'GuideChecklistQL';
  customizedIntents?: Maybe<CustomizedIntentQl>;
  hasBroadcastEnabled: Scalars['Boolean']['output'];
  hasCallForwarding: Scalars['Boolean']['output'];
  hasDismissedGuideChecklist: Scalars['Boolean']['output'];
  hasViewedRefer: Scalars['Boolean']['output'];
  placeId: Scalars['String']['output'];
  textingPhonelines: Array<PhoneLineQl>;
};

export type GuideChecklistQlCustomizedIntentsArgs = {
  first: Scalars['Int']['input'];
};

export type HandToOpportunityAgentActionQl = AutomationAction &
  Node & {
    __typename?: 'HandToOpportunityAgentActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextActionId?: Maybe<Scalars['String']['output']>;
    opportunity?: Maybe<OpportunityInfo>;
    uiHints?: Maybe<AutomationUiHints>;
  };

export enum HandoffMethodInput {
  Custom = 'CUSTOM',
  NumberedParkingSpots = 'NUMBERED_PARKING_SPOTS',
  OrderId = 'ORDER_ID',
  VehicleInfo = 'VEHICLE_INFO',
}

export type HasLabelActionQl = AutomationAction &
  Node & {
    __typename?: 'HasLabelActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    labelCheckOperation: HasLabelsTypeInput;
    labelsToCheck: Array<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextActionId?: Maybe<Scalars['String']['output']>;
    onNoActionId?: Maybe<Scalars['String']['output']>;
    onYesActionId?: Maybe<Scalars['String']['output']>;
    uiHints?: Maybe<AutomationUiHints>;
  };

export enum HasLabelsTypeInput {
  All = 'ALL',
  Any = 'ANY',
}

export enum HasLabelsTypes {
  All = 'ALL',
  Any = 'ANY',
}

export type HostedPage = {
  __typename?: 'HostedPage';
  hostedPage?: Maybe<Scalars['JSONString']['output']>;
};

export type HostedSmsCompleted = {
  __typename?: 'HostedSmsCompleted';
  hostedSmsPort?: Maybe<HostedSmsPortQl>;
};

export type HostedSmsCompletedInput = {
  hostedSmsId: Scalars['String']['input'];
};

export type HostedSmsPortQl = BaseQl &
  Node & {
    __typename?: 'HostedSmsPortQL';
    addressSid?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    customerEmail: Scalars['String']['output'];
    customerName: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    loaSid?: Maybe<Scalars['String']['output']>;
    mdn: Scalars['String']['output'];
    phoneline?: Maybe<PhoneLineQl>;
    phonelineId: Scalars['String']['output'];
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    sid: Scalars['String']['output'];
    status: Scalars['String']['output'];
    twilioChannel?: Maybe<TwilioChannelQl>;
    twilioChannelId: Scalars['String']['output'];
    url?: Maybe<Scalars['String']['output']>;
    verificationAttempts?: Maybe<Scalars['Int']['output']>;
    verificationCode?: Maybe<Scalars['String']['output']>;
  };

export type HostedSmsPortQlConnection = {
  __typename?: 'HostedSmsPortQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HostedSmsPortQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `HostedSmsPortQL` and its cursor. */
export type HostedSmsPortQlEdge = {
  __typename?: 'HostedSmsPortQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HostedSmsPortQl>;
};

export type IdentityPromptAddressQl = BaseQl &
  Node & {
    __typename?: 'IdentityPromptAddressQL';
    address: Scalars['String']['output'];
    channel?: Maybe<BaseChannel>;
    channelId?: Maybe<Scalars['String']['output']>;
    createdBy: ParticipantQl;
    createdById: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  };

export type IdentityPromptAddressQlConnection = {
  __typename?: 'IdentityPromptAddressQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IdentityPromptAddressQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `IdentityPromptAddressQL` and its cursor. */
export type IdentityPromptAddressQlEdge = {
  __typename?: 'IdentityPromptAddressQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<IdentityPromptAddressQl>;
};

export enum IdentityPromptOptions {
  Always = 'ALWAYS',
  Automated = 'AUTOMATED',
  Never = 'NEVER',
}

export type ImageAttachment = Attachment &
  Node & {
    __typename?: 'ImageAttachment';
    attachmentType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    filename: Scalars['String']['output'];
    height?: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    message?: Maybe<MessageQl>;
    messageId?: Maybe<Scalars['String']['output']>;
    primaryMimetype?: Maybe<Scalars['String']['output']>;
    sizeBytes: Scalars['String']['output'];
    url: Scalars['String']['output'];
    width?: Maybe<Scalars['Int']['output']>;
    words?: Maybe<Scalars['JSONString']['output']>;
  };

export type ImageAttachmentInput = {
  data: Scalars['Upload']['input'];
  filename: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  sizeBytes: Scalars['String']['input'];
  url: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type Impersonate = {
  __typename?: 'Impersonate';
  refreshToken?: Maybe<Scalars['String']['output']>;
};

export type ImportHostedSms = {
  __typename?: 'ImportHostedSms';
  hostedSmsPort?: Maybe<HostedSmsPortQl>;
};

export type ImportHostedSmsInput = {
  hostedSmsSid: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type InboxConnection = {
  __typename?: 'InboxConnection';
  activeRos?: Maybe<Scalars['Int']['output']>;
  conversationMentions?: Maybe<Scalars['Int']['output']>;
  conversationsAssignedToMe?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InboxEdge>>;
  hideSharedInboxViews?: Maybe<Scalars['Boolean']['output']>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  statusBoardView?: Maybe<Scalars['Boolean']['output']>;
  totalConversations?: Maybe<Scalars['Int']['output']>;
  totalUnassigned?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `Inbox` and its cursor. */
export type InboxEdge = {
  __typename?: 'InboxEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<InboxQl>;
};

export type InboxModelFilter = {
  createdOn?: InputMaybe<ArrowFieldFilter>;
  id?: InputMaybe<StringFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  placeId?: InputMaybe<StringFilter>;
};

export enum InboxModelSortEnum {
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  PlaceIdAsc = 'place_id_asc',
  PlaceIdDesc = 'place_id_desc',
}

export type InboxQl = BaseQl &
  Node & {
    __typename?: 'InboxQL';
    conversationCount?: Maybe<Scalars['Int']['output']>;
    conversations?: Maybe<ConversationQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    isPlaceInbox?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    /** @deprecated use place.name instead */
    name: Scalars['String']['output'];
    place: PlaceQl;
    placeId: Scalars['String']['output'];
  };

export type InboxQlConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum InboxSort {
  Newest = 'NEWEST',
  WaitTime = 'WAIT_TIME',
}

export type IncreaseShortcutCount = {
  __typename?: 'IncreaseShortcutCount';
  shortcut?: Maybe<ShortcutQl>;
};

export type IncreaseShortcutCountInput = {
  shortcutId: Scalars['String']['input'];
};

export enum InequalityFilterTriggerValuesTypes {
  HigherThan = 'HIGHER_THAN',
  HigherThanOrEqual = 'HIGHER_THAN_OR_EQUAL',
  Is = 'IS_',
  IsNot = 'IS_NOT',
  LowerThan = 'LOWER_THAN',
  LowerThanOrEqual = 'LOWER_THAN_OR_EQUAL',
}

export type IntFilter = {
  equal?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  ilike?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  like?: InputMaybe<Scalars['Int']['input']>;
  notEqual?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**
 * Internal IDs for integrations to be used in the UI.
 *
 * Up until now, we used "magic strings" for internal IDs.
 * This enum should be used for any new integrations. (or to refactor existing ones)
 *
 * WARNING: Please do not change existing values, could break data integrity in the DB
 *
 */
export enum IntegrationInternalId {
  CdkCrmV1 = 'CDK_CRM_V1',
  CdKv1 = 'CDKv1',
  DealervaultV1 = 'DEALERVAULT_V1',
  DealerFXv1 = 'DealerFXv1',
  MyKaarmav1 = 'MyKaarmav1',
  NumaSchedulerV1 = 'NUMA_SCHEDULER_V1',
  TekionApc = 'TekionAPC',
  Tekionv1 = 'Tekionv1',
  VinsolutionsV1 = 'VINSOLUTIONS_V1',
  XTimev1 = 'XTimev1',
}

export enum IntegrationStatus {
  Active = 'ACTIVE',
  Connected = 'CONNECTED',
  Disabled = 'DISABLED',
  Loading = 'LOADING',
  NotRequested = 'NOT_REQUESTED',
  Requested = 'REQUESTED',
  WaitingDisconnect = 'WAITING_DISCONNECT',
}

export enum IntegrationStatusInput {
  Active = 'ACTIVE',
  Connected = 'CONNECTED',
  Disabled = 'DISABLED',
  Loading = 'LOADING',
  NotRequested = 'NOT_REQUESTED',
  Requested = 'REQUESTED',
  WaitingDisconnect = 'WAITING_DISCONNECT',
}

export type IntentClassifierQl = BaseQl &
  Node & {
    __typename?: 'IntentClassifierQL';
    advertiseIntents?: Maybe<Scalars['Boolean']['output']>;
    classifierConfiguration?: Maybe<Scalars['JSONString']['output']>;
    classifierName: Scalars['String']['output'];
    clientName: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
  };

export type IntentClassifierQlConnection = {
  __typename?: 'IntentClassifierQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IntentClassifierQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `IntentClassifierQL` and its cursor. */
export type IntentClassifierQlEdge = {
  __typename?: 'IntentClassifierQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<IntentClassifierQl>;
};

/** Indicates what action the bot should take. */
export enum IntentHandling {
  AutoSend = 'AUTO_SEND',
  Disabled = 'DISABLED',
  Suggest = 'SUGGEST',
}

export type IntentQuestionQl = Node &
  VoiceScriptStep & {
    __typename?: 'IntentQuestionQL';
    appliedIntent?: Maybe<AppliedIntentQl>;
    appliedIntentId?: Maybe<Scalars['String']['output']>;
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    canWeTextSpeech: Scalars['String']['output'];
    canWeTextSpeechUrl: Scalars['String']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    clarifyCanWeTextSpeech: Scalars['String']['output'];
    clarifyCanWeTextSpeechUrl: Scalars['String']['output'];
    clarifySpeech: Scalars['String']['output'];
    clarifySpeechUrl: Scalars['String']['output'];
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messageToSend: Scalars['String']['output'];
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onFailCanWeTextSpeech: Scalars['String']['output'];
    onFailCanWeTextSpeechUrl: Scalars['String']['output'];
    onFailureSpeech: Scalars['String']['output'];
    onFailureSpeechUrl: Scalars['String']['output'];
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoCanWeTextSpeech: Scalars['String']['output'];
    onNoCanWeTextSpeechUrl: Scalars['String']['output'];
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    onNoSpeech: Scalars['String']['output'];
    onNoSpeechUrl: Scalars['String']['output'];
    onNoStep?: Maybe<VoiceScriptStepQl>;
    onNoStepId?: Maybe<Scalars['String']['output']>;
    onYesButNoTextStep?: Maybe<VoiceScriptStepQl>;
    onYesButNoTextStepId?: Maybe<Scalars['String']['output']>;
    onYesCanWeTextSpeech: Scalars['String']['output'];
    onYesCanWeTextSpeechUrl: Scalars['String']['output'];
    onYesSpeech: Scalars['String']['output'];
    onYesSpeechUrl: Scalars['String']['output'];
    onYesStep?: Maybe<VoiceScriptStepQl>;
    onYesStepId?: Maybe<Scalars['String']['output']>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    purpose?: Maybe<Scalars['String']['output']>;
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedMessageToSend: Scalars['String']['output'];
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type IntentQuestionQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type IntentQuestionQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type IntentQuestionQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IntentQuestionQlConnection = {
  __typename?: 'IntentQuestionQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IntentQuestionQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `IntentQuestionQL` and its cursor. */
export type IntentQuestionQlEdge = {
  __typename?: 'IntentQuestionQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<IntentQuestionQl>;
};

export type IsBusinessHoursActionQl = AutomationAction &
  Node & {
    __typename?: 'IsBusinessHoursActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextActionId?: Maybe<Scalars['String']['output']>;
    onNoActionId?: Maybe<Scalars['String']['output']>;
    onYesActionId?: Maybe<Scalars['String']['output']>;
    uiHints?: Maybe<AutomationUiHints>;
  };

export type JsonStringFilter = {
  equal?: InputMaybe<Scalars['JSONString']['input']>;
  greaterThan?: InputMaybe<Scalars['JSONString']['input']>;
  ilike?: InputMaybe<Scalars['JSONString']['input']>;
  in?: InputMaybe<Array<Scalars['JSONString']['input']>>;
  lessThan?: InputMaybe<Scalars['JSONString']['input']>;
  like?: InputMaybe<Scalars['JSONString']['input']>;
  notEqual?: InputMaybe<Scalars['JSONString']['input']>;
  notIn?: InputMaybe<Array<Scalars['JSONString']['input']>>;
};

export enum JobRole {
  BdcManager = 'BDC_MANAGER',
  BdcRepresentative = 'BDC_REPRESENTATIVE',
  Cashier = 'CASHIER',
  Director = 'DIRECTOR',
  FinanceManager = 'FINANCE_MANAGER',
  GeneralManager = 'GENERAL_MANAGER',
  ItManager = 'IT_MANAGER',
  NumaSupport = 'NUMA_SUPPORT',
  Other = 'OTHER',
  PartsManager = 'PARTS_MANAGER',
  PartsRepresentative = 'PARTS_REPRESENTATIVE',
  Porter = 'PORTER',
  Receptionist = 'RECEPTIONIST',
  Salesperson = 'SALESPERSON',
  SalesManager = 'SALES_MANAGER',
  ServiceAdvisor = 'SERVICE_ADVISOR',
  ServiceManager = 'SERVICE_MANAGER',
  Technician = 'TECHNICIAN',
}

export enum JobRoleInput {
  BdcManager = 'BDC_MANAGER',
  BdcRepresentative = 'BDC_REPRESENTATIVE',
  Cashier = 'CASHIER',
  Director = 'DIRECTOR',
  FinanceManager = 'FINANCE_MANAGER',
  GeneralManager = 'GENERAL_MANAGER',
  ItManager = 'IT_MANAGER',
  NumaSupport = 'NUMA_SUPPORT',
  Other = 'OTHER',
  PartsManager = 'PARTS_MANAGER',
  PartsRepresentative = 'PARTS_REPRESENTATIVE',
  Porter = 'PORTER',
  Receptionist = 'RECEPTIONIST',
  Salesperson = 'SALESPERSON',
  SalesManager = 'SALES_MANAGER',
  ServiceAdvisor = 'SERVICE_ADVISOR',
  ServiceManager = 'SERVICE_MANAGER',
  Technician = 'TECHNICIAN',
}

export enum KeyType {
  StatusCode = 'status_code',
}

export type LabelAddedTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'LabelAddedTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    labelsToWatch: Array<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
  };

export enum LabelCategory {
  Appointment = 'APPOINTMENT',
  Callback = 'CALLBACK',
  NeedsReply = 'NEEDS_REPLY',
  Ro = 'RO',
  Urgent = 'URGENT',
  User = 'USER',
}

export type LabelConversationStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'LabelConversationStepQL';
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    expirationHours?: Maybe<Scalars['Int']['output']>;
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    labelName: Scalars['String']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextStepId?: Maybe<Scalars['String']['output']>;
    nextStepRelationship?: Maybe<VoiceScriptStepQl>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type LabelConversationStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type LabelConversationStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlFailureConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type LabelConversationStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type LabelConversationStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelConversationStepQlConnection = {
  __typename?: 'LabelConversationStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LabelConversationStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LabelConversationStepQL` and its cursor. */
export type LabelConversationStepQlEdge = {
  __typename?: 'LabelConversationStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LabelConversationStepQl>;
};

export type LabelQl = BaseQl &
  Node & {
    __typename?: 'LabelQL';
    archived: Scalars['Boolean']['output'];
    category: LabelCategory;
    color: Scalars['String']['output'];
    conversationLabels?: Maybe<ConversationLabelQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    expirationHours?: Maybe<Scalars['Int']['output']>;
    hidden: Scalars['Boolean']['output'];
    icon?: Maybe<Scalars['String']['output']>;
    iconType?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
  };

export type LabelQlConversationLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LabelQlConnection = {
  __typename?: 'LabelQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LabelQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LabelQL` and its cursor. */
export type LabelQlEdge = {
  __typename?: 'LabelQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LabelQl>;
};

export type LabelRemovedTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'LabelRemovedTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    labelsToWatch: Array<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
  };

export enum Language {
  English = 'ENGLISH',
  French = 'FRENCH',
  Spanish = 'SPANISH',
}

export type LanguageInput = {
  value?: InputMaybe<Language>;
};

export type LeaderboardColorsQl = {
  __typename?: 'LeaderboardColorsQL';
  green: Scalars['Int']['output'];
  red: Scalars['Int']['output'];
  yellow: Scalars['Int']['output'];
};

export type LeaveAllConversations = {
  __typename?: 'LeaveAllConversations';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LeaveConversations = {
  __typename?: 'LeaveConversations';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LeaveConversationsInput = {
  conversationIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type LeaveNoteActionQl = AutomationAction &
  Node & {
    __typename?: 'LeaveNoteActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    desiredConversationState?: Maybe<DesiredConversationState>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messageToSend?: Maybe<Scalars['String']['output']>;
    nextActionId?: Maybe<Scalars['String']['output']>;
    uiHints?: Maybe<AutomationUiHints>;
  };

export type LegacyCrmContactQl = {
  contactType?: Maybe<CrmContactType>;
  createdOn: Scalars['ArrowField']['output'];
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
};

export type LibraryIntentQl = BaseQl &
  Node & {
    __typename?: 'LibraryIntentQL';
    appliedIntents?: Maybe<AppliedIntentQlConnection>;
    categories: Scalars['JSONString']['output'];
    createdOn: Scalars['ArrowField']['output'];
    defaultAutosend?: Maybe<Scalars['Boolean']['output']>;
    defaultCategories: Scalars['JSONString']['output'];
    defaultResponse?: Maybe<Scalars['String']['output']>;
    displayExamples: Scalars['JSONString']['output'];
    displayName: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    isManagedByDefault?: Maybe<Scalars['Boolean']['output']>;
    isVisible: Scalars['Boolean']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
    source?: Maybe<LibraryIntentSource>;
    trainingExamples: Scalars['JSONString']['output'];
  };

export type LibraryIntentQlAppliedIntentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum LibraryIntentSource {
  Custom = 'CUSTOM',
  System = 'SYSTEM',
}

export type Link = {
  __typename?: 'Link';
  name: Scalars['String']['output'];
  tag: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type LinkGroup = {
  __typename?: 'LinkGroup';
  groupLabel: Scalars['String']['output'];
  links: Array<Link>;
};

export enum LoggedCallInteraction {
  Message = 'MESSAGE',
  NoAnswer = 'NO_ANSWER',
  Other = 'OTHER',
  Spam = 'SPAM',
  Spoke = 'SPOKE',
  Unknown = 'UNKNOWN',
  WrongNumber = 'WRONG_NUMBER',
}

export type ManageLabelActionQl = AutomationAction &
  Node & {
    __typename?: 'ManageLabelActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    labels: Array<ManageLabelsOperation>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextActionId?: Maybe<Scalars['String']['output']>;
    uiHints?: Maybe<AutomationUiHints>;
  };

export type ManageLabelOperationInput = {
  label: Scalars['String']['input'];
  operation: ManageLabelOperationType;
};

export enum ManageLabelOperationType {
  AddLabel = 'ADD_LABEL',
  RemoveLabel = 'REMOVE_LABEL',
}

export enum ManageLabelsInput {
  AddLabel = 'ADD_LABEL',
  RemoveLabel = 'REMOVE_LABEL',
}

export type ManageLabelsOperation = {
  __typename?: 'ManageLabelsOperation';
  label: Scalars['String']['output'];
  operation: ManageLabelsInput;
};

export type ManagerDashboard = {
  __typename?: 'ManagerDashboard';
  placeMetrics: PlaceMetricsConnection;
  /** How often, in milliseconds, the client should poll for updates. */
  pollingIntervalMs: Scalars['Int']['output'];
  userMetrics: UserMetricsConnection;
};

export type ManagerDashboardPlaceMetricsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ManagerDashboardUserMetricsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Input type for manual campaign upload data dictionary */
export type ManualCampaignUploadDataInput = {
  data: Scalars['JSONObject']['input'];
};

/** Input type for file upload information */
export type ManualCampaignUploadFileUploadInput = {
  content: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
};

/** Input type for manual opportunities by place query */
export type ManualOpportunitiesByPlaceInput = {
  placeId: Scalars['String']['input'];
};

/** Mutation to manually create opportunities with file upload support */
export type ManualOpportunity = {
  __typename?: 'ManualOpportunity';
  result?: Maybe<ManualOpportunityResult>;
};

/** GraphQL type for manual opportunity customer information */
export type ManualOpportunityCustomerInformationQl = {
  __typename?: 'ManualOpportunityCustomerInformationQL';
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Input type for opportunity data dictionary */
export type ManualOpportunityDataInput = {
  data: Scalars['JSONObject']['input'];
};

/** Input type for manual opportunity creation */
export type ManualOpportunityInput = {
  automationId: Scalars['String']['input'];
  fileUpload: FileUploadInput;
  opportunities: Array<ManualOpportunityDataInput>;
  placeId: Scalars['String']['input'];
};

/** GraphQL type for manual opportunity */
export type ManualOpportunityQl = {
  __typename?: 'ManualOpportunityQL';
  automationId: Scalars['String']['output'];
  automationName: Scalars['String']['output'];
  completeTime?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['String']['output'];
  fileContent?: Maybe<Scalars['JSONString']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  filePath?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastUpdated: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  startTime?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** Input type for manual opportunity report query */
export type ManualOpportunityReportInput = {
  manualOpportunityId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

/** GraphQL type for manual opportunity report */
export type ManualOpportunityReportQl = {
  __typename?: 'ManualOpportunityReportQL';
  automationId: Scalars['String']['output'];
  automationName: Scalars['String']['output'];
  completeTime?: Maybe<Scalars['String']['output']>;
  contentSummary: ContentSummaryQl;
  conversationBreakdown: Array<Maybe<ConversationBreakdownEntryQl>>;
  earlyExitAnalysis?: Maybe<EarlyExitAnalysisQl>;
  fileName: Scalars['String']['output'];
  manualOpportunityId: Scalars['String']['output'];
  manualOpportunityStatus: Scalars['String']['output'];
  startTime?: Maybe<Scalars['String']['output']>;
  statusSummary: StatusSummaryQl;
  totalAutomationsTriggered: Scalars['Int']['output'];
  uniqueConversationsAffected: Scalars['Int']['output'];
};

/** Result type for manual opportunity creation */
export type ManualOpportunityResult = {
  __typename?: 'ManualOpportunityResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ManualOpportunityTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'ManualOpportunityTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
  };

export type MapCrmUserToUser = {
  __typename?: 'MapCrmUserToUser';
  user?: Maybe<UserQl>;
};

export type MapCrmUserToUserInput = {
  activeIntegrationId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSONString']['input']>;
  externalCrmUserId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type MarkMessagesRead = {
  __typename?: 'MarkMessagesRead';
  messages?: Maybe<Array<Maybe<MessageQl>>>;
};

export type MarkMessagesReadInput = {
  messageIds: Array<InputMaybe<Scalars['String']['input']>>;
  placeId: Scalars['String']['input'];
};

export type MentionInput = {
  tag: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type MentionQl = BaseQl &
  Node & {
    __typename?: 'MentionQL';
    conversation?: Maybe<ConversationQl>;
    conversationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    hasLeftConversation: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    isEscalated: Scalars['Boolean']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    message?: Maybe<MessageQl>;
    messageId: Scalars['String']['output'];
    tag: Scalars['String']['output'];
    user?: Maybe<UserQl>;
    userId?: Maybe<Scalars['String']['output']>;
  };

export type MentionQlConnection = {
  __typename?: 'MentionQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MentionQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MentionQL` and its cursor. */
export type MentionQlEdge = {
  __typename?: 'MentionQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MentionQl>;
};

export type MessageConnection = {
  __typename?: 'MessageConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MessageEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Message` and its cursor. */
export type MessageEdge = {
  __typename?: 'MessageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MessageQl>;
};

export type MessageInput = {
  content: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type MessageMetadataQl = {
  __typename?: 'MessageMetadataQL';
  mdn?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MessageModelFilter = {
  callId?: InputMaybe<StringFilter>;
  capsLockFixed?: InputMaybe<BooleanFilter>;
  channelData?: InputMaybe<StringFilter>;
  channelId?: InputMaybe<StringFilter>;
  channelType?: InputMaybe<StringFilter>;
  confidence?: InputMaybe<FloatFilter>;
  content?: InputMaybe<StringFilter>;
  conversationId?: InputMaybe<StringFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  deletedById?: InputMaybe<StringFilter>;
  deliveryError?: InputMaybe<IntFilter>;
  deliveryStatus?: InputMaybe<StringFilter>;
  dialogFlowBotDataId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  intentControlId?: InputMaybe<StringFilter>;
  isArchived?: InputMaybe<BooleanFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  isInbound?: InputMaybe<BooleanFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  libraryIntentDisplayName?: InputMaybe<StringFilter>;
  libraryIntentName?: InputMaybe<StringFilter>;
  loggedCallInteraction?: InputMaybe<StringFilter>;
  messageDescription?: InputMaybe<StringFilter>;
  messageFormat?: InputMaybe<StringFilter>;
  numSegments?: InputMaybe<IntFilter>;
  numboxAgentSessionId?: InputMaybe<StringFilter>;
  paymentRequestId?: InputMaybe<StringFilter>;
  placeId?: InputMaybe<StringFilter>;
  possibleBotAction?: InputMaybe<StringFilter>;
  previewable?: InputMaybe<BooleanFilter>;
  qualificationSurveyId?: InputMaybe<StringFilter>;
  readStatus?: InputMaybe<ArrowFieldFilter>;
  recipientId?: InputMaybe<StringFilter>;
  repairOrderId?: InputMaybe<StringFilter>;
  senderId?: InputMaybe<StringFilter>;
  sentFromMdn?: InputMaybe<StringFilter>;
  sentimentInvalidatedAt?: InputMaybe<ArrowFieldFilter>;
  sentimentLabel?: InputMaybe<StringFilter>;
  sentimentValue?: InputMaybe<FloatFilter>;
  statusItemId?: InputMaybe<StringFilter>;
  timestamp?: InputMaybe<ArrowFieldFilter>;
  type?: InputMaybe<StringFilter>;
};

export enum MessageModelSortEnum {
  CallIdAsc = 'call_id_asc',
  CallIdDesc = 'call_id_desc',
  CapsLockFixedAsc = 'caps_lock_fixed_asc',
  CapsLockFixedDesc = 'caps_lock_fixed_desc',
  ChannelDataAsc = 'channel_data_asc',
  ChannelDataDesc = 'channel_data_desc',
  ChannelIdAsc = 'channel_id_asc',
  ChannelIdDesc = 'channel_id_desc',
  ChannelTypeAsc = 'channel_type_asc',
  ChannelTypeDesc = 'channel_type_desc',
  ConfidenceAsc = 'confidence_asc',
  ConfidenceDesc = 'confidence_desc',
  ContentAsc = 'content_asc',
  ContentDesc = 'content_desc',
  ConversationIdAsc = 'conversation_id_asc',
  ConversationIdDesc = 'conversation_id_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  DeletedByIdAsc = 'deleted_by_id_asc',
  DeletedByIdDesc = 'deleted_by_id_desc',
  DeliveryErrorAsc = 'delivery_error_asc',
  DeliveryErrorDesc = 'delivery_error_desc',
  DeliveryStatusAsc = 'delivery_status_asc',
  DeliveryStatusDesc = 'delivery_status_desc',
  DialogFlowBotDataIdAsc = 'dialog_flow_bot_data_id_asc',
  DialogFlowBotDataIdDesc = 'dialog_flow_bot_data_id_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IntentControlIdAsc = 'intent_control_id_asc',
  IntentControlIdDesc = 'intent_control_id_desc',
  IsArchivedAsc = 'is_archived_asc',
  IsArchivedDesc = 'is_archived_desc',
  IsDeletedAsc = 'is_deleted_asc',
  IsDeletedDesc = 'is_deleted_desc',
  IsInboundAsc = 'is_inbound_asc',
  IsInboundDesc = 'is_inbound_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  LibraryIntentDisplayNameAsc = 'library_intent_display_name_asc',
  LibraryIntentDisplayNameDesc = 'library_intent_display_name_desc',
  LibraryIntentNameAsc = 'library_intent_name_asc',
  LibraryIntentNameDesc = 'library_intent_name_desc',
  LoggedCallInteractionAsc = 'logged_call_interaction_asc',
  LoggedCallInteractionDesc = 'logged_call_interaction_desc',
  MessageDescriptionAsc = 'message_description_asc',
  MessageDescriptionDesc = 'message_description_desc',
  MessageFormatAsc = 'message_format_asc',
  MessageFormatDesc = 'message_format_desc',
  NumSegmentsAsc = 'num_segments_asc',
  NumSegmentsDesc = 'num_segments_desc',
  NumboxAgentSessionIdAsc = 'numbox_agent_session_id_asc',
  NumboxAgentSessionIdDesc = 'numbox_agent_session_id_desc',
  PaymentRequestIdAsc = 'payment_request_id_asc',
  PaymentRequestIdDesc = 'payment_request_id_desc',
  PlaceIdAsc = 'place_id_asc',
  PlaceIdDesc = 'place_id_desc',
  PossibleBotActionAsc = 'possible_bot_action_asc',
  PossibleBotActionDesc = 'possible_bot_action_desc',
  PreviewableAsc = 'previewable_asc',
  PreviewableDesc = 'previewable_desc',
  QualificationSurveyIdAsc = 'qualification_survey_id_asc',
  QualificationSurveyIdDesc = 'qualification_survey_id_desc',
  ReadStatusAsc = 'read_status_asc',
  ReadStatusDesc = 'read_status_desc',
  RecipientIdAsc = 'recipient_id_asc',
  RecipientIdDesc = 'recipient_id_desc',
  RepairOrderIdAsc = 'repair_order_id_asc',
  RepairOrderIdDesc = 'repair_order_id_desc',
  SenderIdAsc = 'sender_id_asc',
  SenderIdDesc = 'sender_id_desc',
  SentFromMdnAsc = 'sent_from_mdn_asc',
  SentFromMdnDesc = 'sent_from_mdn_desc',
  SentimentInvalidatedAtAsc = 'sentiment_invalidated_at_asc',
  SentimentInvalidatedAtDesc = 'sentiment_invalidated_at_desc',
  SentimentLabelAsc = 'sentiment_label_asc',
  SentimentLabelDesc = 'sentiment_label_desc',
  SentimentValueAsc = 'sentiment_value_asc',
  SentimentValueDesc = 'sentiment_value_desc',
  StatusItemIdAsc = 'status_item_id_asc',
  StatusItemIdDesc = 'status_item_id_desc',
  TimestampAsc = 'timestamp_asc',
  TimestampDesc = 'timestamp_desc',
  TypeAsc = 'type_asc',
  TypeDesc = 'type_desc',
}

export type MessageQl = BaseQl &
  Node & {
    __typename?: 'MessageQL';
    IsArchived?: Maybe<Scalars['Boolean']['output']>;
    attachments: Array<Attachment>;
    call?: Maybe<PhoneCallQl>;
    callId?: Maybe<Scalars['String']['output']>;
    canTeachNuma?: Maybe<Scalars['Boolean']['output']>;
    capsLockFixed: Scalars['Boolean']['output'];
    channel: Channel;
    channelData?: Maybe<Scalars['String']['output']>;
    channelId: Scalars['String']['output'];
    channelType?: Maybe<Scalars['String']['output']>;
    confidence?: Maybe<Scalars['Float']['output']>;
    content: Scalars['String']['output'];
    conversation: ConversationQl;
    conversationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    deletedBy?: Maybe<UserQl>;
    deletedById?: Maybe<Scalars['String']['output']>;
    deliveryError?: Maybe<Scalars['Int']['output']>;
    deliveryStatus: Delivery_Status;
    dialogFlowBotData?: Maybe<DialogFlowBotDataQl>;
    dialogFlowBotDataId?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    intentControlId?: Maybe<Scalars['String']['output']>;
    intentDisplayName?: Maybe<Scalars['String']['output']>;
    intentId?: Maybe<Scalars['String']['output']>;
    intentName?: Maybe<Scalars['String']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    isDeleted?: Maybe<Scalars['Boolean']['output']>;
    isFailure?: Maybe<Scalars['Boolean']['output']>;
    isFromBot?: Maybe<Scalars['String']['output']>;
    isGoldCase?: Maybe<Scalars['String']['output']>;
    isGreeting?: Maybe<Scalars['Boolean']['output']>;
    isHeatCase?: Maybe<Scalars['Boolean']['output']>;
    isInbound: Scalars['Boolean']['output'];
    isSuggestion?: Maybe<Scalars['Boolean']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    libraryIntentDisplayName?: Maybe<Scalars['String']['output']>;
    libraryIntentName?: Maybe<Scalars['String']['output']>;
    loggedCallInteraction?: Maybe<LoggedCallInteraction>;
    mentions: Array<MentionQl>;
    messageDescription?: Maybe<Scalars['String']['output']>;
    messageFormat: Message_Format;
    messageType: Scalars['String']['output'];
    notePreview?: Maybe<Scalars['String']['output']>;
    numSegments?: Maybe<Scalars['Int']['output']>;
    numboxAgentSession?: Maybe<NumboxAgentSessionQl>;
    numboxAgentSessionId?: Maybe<Scalars['String']['output']>;
    outboundConferenceCall?: Maybe<OutboundConferenceCallQl>;
    outboundProxyCall?: Maybe<OutboundProxyCallQl>;
    paymentRequest?: Maybe<PaymentRequestQl>;
    paymentRequestId?: Maybe<Scalars['String']['output']>;
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    possibleBotAction?: Maybe<PossibleBotAction>;
    previewable: Scalars['Boolean']['output'];
    qualificationSurvey?: Maybe<QualificationSurveyQl>;
    qualificationSurveyId?: Maybe<Scalars['String']['output']>;
    readStatus?: Maybe<Scalars['ArrowField']['output']>;
    reasonSent?: Maybe<ReasonSentQl>;
    recipient: ParticipantQl;
    recipientId: Scalars['String']['output'];
    repairOrder?: Maybe<RepairOrder>;
    repairOrderId?: Maybe<Scalars['String']['output']>;
    review?: Maybe<ReviewQlConnection>;
    sender: ParticipantQl;
    senderId: Scalars['String']['output'];
    sentFromMdn?: Maybe<Scalars['String']['output']>;
    sentimentInvalidatedAt?: Maybe<Scalars['ArrowField']['output']>;
    sentimentLabel?: Maybe<Scalars['String']['output']>;
    sentimentValue?: Maybe<Scalars['Float']['output']>;
    statusItem?: Maybe<StatusItemQl>;
    statusItemId?: Maybe<Scalars['String']['output']>;
    timestamp?: Maybe<Scalars['ArrowField']['output']>;
    title?: Maybe<Scalars['String']['output']>;
  };

export type MessageQlReviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageQlConnection = {
  __typename?: 'MessageQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MessageQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MessageQL` and its cursor. */
export type MessageQlEdge = {
  __typename?: 'MessageQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MessageQl>;
};

export type MessageReceivedTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'MessageReceivedTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
  };

export type MessageType = {
  __typename?: 'MessageType';
  content: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type MoveStatusItem = {
  __typename?: 'MoveStatusItem';
  statusItem?: Maybe<StatusItemQl>;
};

export type MoveStatusItemInput = {
  stageId: Scalars['String']['input'];
  statusId: Scalars['String']['input'];
};

export type MultiChoiceAttachment = Attachment &
  Node & {
    __typename?: 'MultiChoiceAttachment';
    Data?: Maybe<Scalars['String']['output']>;
    attachmentType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    data?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    message?: Maybe<MessageQl>;
    messageId?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
  };

export type Mutations = {
  __typename?: 'Mutations';
  PubNubAppointmentEnriched?: Maybe<Scalars['Boolean']['output']>;
  PubNubArchiveConversation?: Maybe<Scalars['Boolean']['output']>;
  PubNubArchiveConversations?: Maybe<Scalars['Boolean']['output']>;
  PubNubAssignConversation?: Maybe<Scalars['Boolean']['output']>;
  PubNubAwayModeChanged?: Maybe<Scalars['Boolean']['output']>;
  PubNubConversationDeleted?: Maybe<Scalars['Boolean']['output']>;
  PubNubConversationEngagementUpdated?: Maybe<Scalars['Boolean']['output']>;
  PubNubConversationLanguageReset?: Maybe<Scalars['Boolean']['output']>;
  PubNubConversationRecovered?: Maybe<Scalars['Boolean']['output']>;
  PubNubDegradedInboxExperienceUpdated?: Maybe<Scalars['Boolean']['output']>;
  PubNubDialogFlowBotDataUpdated?: Maybe<Scalars['Boolean']['output']>;
  PubNubEquityTradeOpportunityUpdated?: Maybe<Scalars['Boolean']['output']>;
  PubNubInboundCallStatusUpdated?: Maybe<Scalars['Boolean']['output']>;
  PubNubLabelCreated?: Maybe<Scalars['Boolean']['output']>;
  PubNubLabelUpdated?: Maybe<Scalars['Boolean']['output']>;
  PubNubLeaveConversations?: Maybe<Scalars['Boolean']['output']>;
  PubNubMessageReceived?: Maybe<Scalars['Boolean']['output']>;
  PubNubMessageSent?: Maybe<Scalars['Boolean']['output']>;
  PubNubNumboxAgentSessionUpdated?: Maybe<Scalars['Boolean']['output']>;
  PubNubOutboundConferenceCallStatusUpdated?: Maybe<
    Scalars['Boolean']['output']
  >;
  PubNubOutboundProxyCallStatusUpdated?: Maybe<Scalars['Boolean']['output']>;
  PubNubPaymentRequestCreated?: Maybe<Scalars['Boolean']['output']>;
  PubNubPaymentRequestUpdated?: Maybe<Scalars['Boolean']['output']>;
  PubNubPlaceUpdated?: Maybe<Scalars['Boolean']['output']>;
  PubNubRestoreConversation?: Maybe<Scalars['Boolean']['output']>;
  PubNubRestoreConversations?: Maybe<Scalars['Boolean']['output']>;
  PubNubStatusItemCreated?: Maybe<Scalars['Boolean']['output']>;
  PubNubStatusItemDeleted?: Maybe<Scalars['Boolean']['output']>;
  PubNubStatusItemUpdated?: Maybe<Scalars['Boolean']['output']>;
  PubNubStripeIntegrationUpdated?: Maybe<Scalars['Boolean']['output']>;
  PubNubTaskCreated?: Maybe<Scalars['Boolean']['output']>;
  PubNubTaskUpdated?: Maybe<Scalars['Boolean']['output']>;
  PubNubTeamCreated?: Maybe<Scalars['Boolean']['output']>;
  PubNubTeamDeleted?: Maybe<Scalars['Boolean']['output']>;
  PubNubTeamUpdated?: Maybe<Scalars['Boolean']['output']>;
  PubNubTranscriptUpdated?: Maybe<Scalars['Boolean']['output']>;
  PubNubVideoUploadLinkUpdated?: Maybe<Scalars['Boolean']['output']>;
  addAnsweringScriptToPolicy?: Maybe<AddAnsweringScriptToPolicy>;
  addAutomationExitTrigger?: Maybe<AddAutomationExitTrigger>;
  addAvailableIntegration?: Maybe<AddAvailableIntegration>;
  addCustomLink?: Maybe<AddCustomLink>;
  addCustomer?: Maybe<AddCustomer>;
  addFortellisSubscription?: Maybe<AddFortellisSubscription>;
  addLabelToConversation?: Maybe<AddLabelToConversation>;
  addOperatorChannel?: Maybe<AddOperatorChannel>;
  addOperatorPlace?: Maybe<AddOperatorPlace>;
  addOutboundCallCustomization?: Maybe<AddOutboundCallCustomization>;
  addPlaceGroup?: Maybe<AddPlaceGroup>;
  addServiceAdvisor?: Maybe<AddServiceAdvisor>;
  addStage?: Maybe<AddStage>;
  addStatusItem?: Maybe<AddStatusItem>;
  addSubscription?: Maybe<AddSubscription>;
  addUserToTeam?: Maybe<AddUserToTeam>;
  addVoiceStep?: Maybe<AddVoiceStep>;
  archiveMissedCalls?: Maybe<ArchiveMissedCalls>;
  assignConversations?: Maybe<AssignConversations>;
  buildRepairOrderAssistedStatusQuestionTree?: Maybe<BuildRepairOrderAssistedStatusQuestionTree>;
  buildWriteItForMeQuestionTree?: Maybe<BuildWriteItForMeQuestionTree>;
  bulkUpdateSupportedVehicles?: Maybe<BulkUpdateSupportedVehicles>;
  cancelPaymentRequest?: Maybe<CancelPaymentRequest>;
  cancelScheduledMessage?: Maybe<CancelScheduledMessage>;
  capturePaymentAmount?: Maybe<CapturePaymentAmount>;
  changeAccountSubscription?: Maybe<ChangeAccountSubscription>;
  changeAllowCustomAudio?: Maybe<ChangeAllowCustomAudio>;
  changeBusinessVertical?: Maybe<ChangeBusinessVertical>;
  changeInboxType?: Maybe<ChangeInboxType>;
  changeNotificationSettings?: Maybe<ChangeNotificationSettings>;
  changePlaceGroup?: Maybe<ChangePlaceGroup>;
  changePlaceHours?: Maybe<ChangePlaceHours>;
  changePlaceSubscriptions?: Maybe<ChangePlaceSubscription>;
  changeRepairOrderSchedule?: Maybe<ChangeRepairOrderSchedule>;
  changeSignupMode?: Maybe<ChangeSignupMode>;
  changeSwipeActionSettings?: Maybe<ChangeSwipeActionSettings>;
  changeTwilioChannelMdn?: Maybe<ChangeTwilioChannelMdn>;
  changeUserPassword?: Maybe<ChangeUserPassword>;
  changeUserSettings?: Maybe<ChangeUserSettings>;
  changeUserVideoConferenceUrl?: Maybe<ChangeUserVideoConferenceUrl>;
  closeStatusItem?: Maybe<CloseStatusItem>;
  completeAutopilot?: Maybe<CompleteAutopilot>;
  completeTask?: Maybe<CompleteTask>;
  connectAutomationAction?: Maybe<ConnectAutomationAction>;
  connectAutomationActionEdge?: Maybe<ConnectAutomationActionEdge>;
  createA2pCampaignForPlace?: Maybe<CreateA2PCampaignForPlace>;
  createAppointmentAgentSettingLabel?: Maybe<CreateAppointmentAgentSettingLabel>;
  createAppointmentAgentSettings?: Maybe<CreateAppointmentAgentSettings>;
  createAutomation?: Maybe<CreateAutomation>;
  createAutomationAction?: Maybe<CreateAutomationAction>;
  createAutomationFromBlueprint?: Maybe<CreateAutomationFromBlueprint>;
  createAutopilot?: Maybe<CreateAutopilot>;
  createBillingIdentity?: Maybe<CreateBillingIdentity>;
  /** Mutation to create a new campaign entity */
  createCampaign?: Maybe<CreateCampaign>;
  createChatExpansion?: Maybe<CreateChatExpansion>;
  createChitchat?: Maybe<CreateAgentChitChat>;
  createConversation?: Maybe<CreateConversation>;
  createConversationSummary?: Maybe<CreateConversationSummary>;
  createConversationTextExpansion?: Maybe<CreateConversationTextExpansion>;
  createCustomDirectoryEntry?: Maybe<CreateCustomDirectoryEntry>;
  createDepartmentDevice?: Maybe<CreateDepartmentDevice>;
  createIdentityPromptAddress?: Maybe<CreateIdentityPromptAddress>;
  createLabel?: Maybe<CreateLabel>;
  /** Mutation to create manual campaign uploads */
  createManualCampaignUpload?: Maybe<CreateManualCampaignUpload>;
  createNoteTaker?: Maybe<CreateNoteTaker>;
  createOperator?: Maybe<CreateOperator>;
  createOutboundConferenceCall?: Maybe<CreateOutboundConferenceCall>;
  createOutboundProxyCall?: Maybe<CreateOutboundProxyCall>;
  createParticipant?: Maybe<CreateParticipant>;
  createParticipantPaymentRequest?: Maybe<CreateParticipantPaymentRequest>;
  createPaymentRequest?: Maybe<CreatePaymentRequest>;
  createPhoneLine?: Maybe<CreatePhoneLine>;
  createPlace?: Maybe<CreatePlace>;
  createPortalSession?: Maybe<CreatePortalSession>;
  createScheduledMessage?: Maybe<CreateScheduledMessage>;
  createShortcut?: Maybe<CreateShortcut>;
  createStripeAccount?: Maybe<CreateStripeAccount>;
  createStripeRefund?: Maybe<CreateStripeRefund>;
  createTaskForEngagement?: Maybe<CreateTaskForEngagement>;
  createTeam?: Maybe<CreateTeam>;
  createTextExpansion?: Maybe<CreateTextExpansion>;
  createUser?: Maybe<CreateUser>;
  createUserPhone?: Maybe<CreateUserPhone>;
  createVideoUploadLink?: Maybe<CreateVideoUploadLink>;
  deactivateAccount?: Maybe<DeactivateAccount>;
  deleteAppointmentAgentSettingLabel?: Maybe<DeleteAppointmentAgentSettingLabel>;
  deleteAppointmentAgentSettings?: Maybe<DeleteAppointmentAgentSettings>;
  deleteAutomation?: Maybe<DeleteAutomation>;
  deleteConversation?: Maybe<DeleteConversation>;
  deleteCustomDirectoryEntry?: Maybe<DeleteCustomDirectoryEntry>;
  deleteCustomLink?: Maybe<DeleteCustomLink>;
  deleteDepartmentDevice?: Maybe<DeleteDepartmentDevice>;
  deleteIdentityPromptAddress?: Maybe<DeleteIdentityPromptAddress>;
  deleteNoteTaker?: Maybe<DeleteNoteTaker>;
  deleteOutboundCallCustomization?: Maybe<DeleteOutboundCallCustomization>;
  deletePhoneLine?: Maybe<DeletePhoneLine>;
  deletePlace?: Maybe<DeletePlace>;
  deleteScheduledMessage?: Maybe<DeleteScheduledMessage>;
  deleteShortcut?: Maybe<DeleteShortcut>;
  deleteStage?: Maybe<DeleteStage>;
  deleteStatusItem?: Maybe<DeleteStatusItem>;
  deleteTeam?: Maybe<DeleteTeam>;
  deleteUserPhone?: Maybe<DeleteUserPhone>;
  deleteVoiceStep?: Maybe<DeleteVoiceStep>;
  disableAutopilot?: Maybe<DisableAutopilot>;
  disableFortellisSubscription?: Maybe<DisableFortellisSubscription>;
  discardAutomationEdits?: Maybe<DiscardAutomationEdits>;
  discardDisruptionVoiceScript?: Maybe<DiscardDisruptionVoiceScript>;
  discardVoiceScript?: Maybe<DiscardVoiceScript>;
  dismissTask?: Maybe<DismissTask>;
  duplicateAppointmentAgentSettings?: Maybe<DuplicateAppointmentAgentSettings>;
  enableInboxLanguageOverride?: Maybe<EnableInboxLanguageOverride>;
  enableNudges?: Maybe<EnableNudges>;
  enablePlaceMessagingHours?: Maybe<EnablePlaceMessagingHours>;
  endOutboundConferenceCall?: Maybe<EndOutboundConferenceCall>;
  evaluateBusinessIdentity?: Maybe<EvaluateBusinessIdentity>;
  exportConversationToArchive?: Maybe<ExportConversationToArchive>;
  forceActiveIntegrationSync?: Maybe<ForceActiveIntegrationSync>;
  generateRepairOrderAssistedStatusContent?: Maybe<GenerateRepairOrderAssistedStatusContent>;
  generateRepairOrderNotesSummary?: Maybe<GenerateRepairOrderNotesSummary>;
  generateWriteItForMeContent?: Maybe<GenerateWriteItForMeContent>;
  globalSyncXtimeServices?: Maybe<GlobalSyncXtimeServices>;
  hostedPage?: Maybe<HostedPage>;
  hostedSmsCompleted?: Maybe<HostedSmsCompleted>;
  impersonate?: Maybe<Impersonate>;
  importHostedSms?: Maybe<ImportHostedSms>;
  increaseShortcutCount?: Maybe<IncreaseShortcutCount>;
  leaveAllConversations?: Maybe<LeaveAllConversations>;
  leaveConversations?: Maybe<LeaveConversations>;
  login?: Maybe<AuthTokens>;
  /** Mutation to manually create opportunities with file upload support */
  manualOpportunity?: Maybe<ManualOpportunity>;
  mapCrmUserToUser?: Maybe<MapCrmUserToUser>;
  markMessagesRead?: Maybe<MarkMessagesRead>;
  moveStatusItem?: Maybe<MoveStatusItem>;
  pokeUser?: Maybe<PokeUser>;
  populateBusinessProfileWithChargebeeInfo?: Maybe<PopulateBusinessProfileWithChargebeeInfo>;
  portInPhoneLine?: Maybe<PortInPhoneLine>;
  publishAutomation?: Maybe<PublishAutomation>;
  publishDisruptionVoiceScript?: Maybe<PublishDisruptionVoiceScript>;
  publishVoiceScript?: Maybe<PublishVoiceScript>;
  rateAppointmentAgentNote?: Maybe<AppointmentAgentNoteRatingQl>;
  rateAssistedResponse?: Maybe<EngagementQl>;
  rateCallIntelligenceSummary?: Maybe<CallIntelligenceRatingQl>;
  rateEngagementStatus?: Maybe<EngagementQl>;
  rateEngagementSummary?: Maybe<EngagementQl>;
  recoverConversation?: Maybe<RecoverConversation>;
  refreshCarrierInfo?: Maybe<RefreshCarrierInfo>;
  refreshFortellisServiceAdvisors?: Maybe<RefreshFortellisServiceAdvisors>;
  registerFortellisServiceAdvisor?: Maybe<RegisterFortellisServiceAdvisor>;
  removeAutomationAction?: Maybe<RemoveAutomationAction>;
  removeAutomationExitTrigger?: Maybe<RemoveAutomationExitTrigger>;
  removeLabelFromConversation?: Maybe<RemoveLabelFromConversation>;
  removePlaceGroup?: Maybe<RemovePlaceGroup>;
  removeServiceAdvisor?: Maybe<RemoveServiceAdvisor>;
  removeUserFromPlace?: Maybe<RemoveUserFromPlace>;
  removeUserFromTeam?: Maybe<RemoveUserFromTeam>;
  removeVideoUploadLink?: Maybe<RemoveVideoUploadLink>;
  renameAccount?: Maybe<RenameAccount>;
  /** RenamePlace renames a place's internal name */
  renamePlace?: Maybe<RenamePlace>;
  reopenStatusItem?: Maybe<ReopenStatusItem>;
  requestAvailableIntegration?: Maybe<RequestAvailableIntegration>;
  resetAppointmentAgentSettings?: Maybe<ResetAppointmentAgentSettings>;
  resetBrandTheme?: Maybe<ResetBrandTheme>;
  resetConversationLanguage?: Maybe<ResetConversationLanguage>;
  resetOutboundChannels?: Maybe<ResetOutboundChannels>;
  resetTaskStatus?: Maybe<ResetTaskStatus>;
  resetVoiceScript?: Maybe<ResetVoiceScript>;
  sendBroadcast?: Maybe<SendBroadcast>;
  sendLoa?: Maybe<SendLoa>;
  sendMessage?: Maybe<SendMessage>;
  sendReviewRequest?: Maybe<SendReviewRequest>;
  sendScheduledMessageNow?: Maybe<SendScheduledMessageNow>;
  sendStatusItemMessage?: Maybe<SendStatusItemMessage>;
  sendVcard?: Maybe<SendVCard>;
  setAssignmentRetention?: Maybe<SetAssignmentRetention>;
  setBusinessTimezone?: Maybe<SetBusinessTimezone>;
  setFortellisLookupId?: Maybe<SetFortellisLookupId>;
  setHangupSuggestion?: Maybe<SetHangupSuggestion>;
  setOptInStatus?: Maybe<SetOptInStatus>;
  setResetOngoingOptin?: Maybe<SetResetOngoingOptin>;
  setResetOptinDays?: Maybe<SetResetOptinDays>;
  setupEquityTradeOpportunityCampaign?: Maybe<SetupEquityTradeOpportunityCampaign>;
  snoozeConversation?: Maybe<SnoozeConversation>;
  startConversation?: Maybe<StartConversation>;
  startConversationWithScheduledMessage?: Maybe<StartConversationWithScheduledMessage>;
  submit10DlcStarterProfile?: Maybe<Submit10DlcStarterProfile>;
  submitBusinessIdentity?: Maybe<SubmitBusinessIdentity>;
  syncXtimeServices?: Maybe<SyncXtimeServices>;
  teachNuma?: Maybe<TeachNuma>;
  toggleCustomPhoneLinePolicy?: Maybe<ToggleCustomPhoneLinePolicy>;
  toggleOutboundProxyCallRecording?: Maybe<ToggleOutboundProxyCallRecording>;
  unmapCrmUserFromUser?: Maybe<UnmapCrmUserFromUser>;
  updateActiveIntegration?: Maybe<UpdateActiveIntegration>;
  updateAllowedSpeechLanguages?: Maybe<UpdateLanguageSettings>;
  updateAnsweringScriptOrder?: Maybe<UpdateAnsweringScriptOrder>;
  updateAppointment?: Maybe<UpdateAppointment>;
  updateAppointmentAgentSettingLabel?: Maybe<UpdateAppointmentAgentSettingLabel>;
  updateAppointmentAgentSettings?: Maybe<UpdateAppointmentAgentSettings>;
  updateAssignmentRoutingSettings?: Maybe<UpdateAssignmentRoutingSettings>;
  updateAutomation?: Maybe<UpdateAutomation>;
  updateAutomationAction?: Maybe<UpdateAutomationAction>;
  updateAutomationEnrollmentCriteria?: Maybe<UpdateAutomationEnrollmentCriteria>;
  updateAutomationExitTrigger?: Maybe<UpdateAutomationExitTrigger>;
  updateAutomationStartTrigger?: Maybe<UpdateAutomationStartTrigger>;
  updateAutomationUIHints?: Maybe<UpdateAutomationUiHints>;
  updateAutopilotEta?: Maybe<UpdateAutopilotEta>;
  updateAutopilotJob?: Maybe<UpdateAutopilotJob>;
  updateAutopilotScheduledMessage?: Maybe<UpdateAutopilotScheduledMessage>;
  updateAvailableIntegration?: Maybe<UpdateAvailableIntegration>;
  updateAwayMode?: Maybe<UpdateAwayMode>;
  updateAwayModeAssignee?: Maybe<UpdateAwayModeAssignee>;
  updateAwayModeManagingPermission?: Maybe<UpdateAwayModeManagingPermission>;
  updateAwayModeWithTime?: Maybe<UpdateAwayModeWithTime>;
  updateBillingMetadata?: Maybe<UpdateBillingMetadata>;
  updateBrandLogo?: Maybe<UpdateBrandLogo>;
  updateBrandTheme?: Maybe<UpdateBrandTheme>;
  updateBusinessIdentity?: Maybe<UpdateBusinessIdentity>;
  updateBusinessProfile?: Maybe<UpdateBusinessProfile>;
  updateCallForwardingStatus?: Maybe<UpdateCallForwardingStatus>;
  updateCallIntelligenceEnabled?: Maybe<UpdateCallIntelligenceEnabled>;
  updateCallIntelligenceSetting?: Maybe<UpdateCallIntelligenceSetting>;
  /** Mutation to update campaign status and optionally handle TCPA approval */
  updateCampaignStatus?: Maybe<UpdateCampaignStatus>;
  updateChannel?: Maybe<UpdateChannel>;
  updateChitchat?: Maybe<UpdateAgentChitChat>;
  updateComplianceSettings?: Maybe<UpdateComplianceSettings>;
  updateConversationLabel?: Maybe<UpdateConversationLabel>;
  updateConversations?: Maybe<UpdateConversations>;
  updateCurbsideSettings?: Maybe<UpdateCurbsideSettings>;
  updateCustomDirectoryEntry?: Maybe<UpdateCustomDirectoryEntry>;
  updateDefaultView?: Maybe<UpdateDefaultView>;
  updateDefaultYouView?: Maybe<UpdateDefaultYouView>;
  updateDepartmentDevice?: Maybe<UpdateDepartmentDevice>;
  updateDirectoryEntry?: Maybe<UpdateDirectoryEntry>;
  updateEdgesVoiceStep?: Maybe<UpdateEdgesVoiceStep>;
  updateEquityTradeOpportunityStage?: Maybe<UpdateEquityTradeOpportunityStage>;
  updateEscalationSettings?: Maybe<UpdateEscalationSettings>;
  updateEtoSettings?: Maybe<UpdateEtoSettings>;
  updateGreeting?: Maybe<UpdateGreeting>;
  updateHasDismissedGuideChecklist?: Maybe<UpdateHasDismissedGuideChecklist>;
  updateHasViewedRefer?: Maybe<UpdateHasViewedRefer>;
  updateHideSharedInboxViews?: Maybe<UpdateHideSharedInboxViews>;
  updateHostedSms?: Maybe<UpdateHostedSms>;
  updateIsScheduleEnabled?: Maybe<UpdateIsScheduleEnabled>;
  updateIsUnassigningInboundMessages?: Maybe<UpdateIsUnassigningInboundMessages>;
  updateLabel?: Maybe<UpdateLabel>;
  updateLink?: Maybe<UpdateLink>;
  updateLinkUrls?: Maybe<UpdateLinkUrls>;
  updateLoggedCall?: Maybe<UpdateLoggedCall>;
  updateLogos?: Maybe<UpdateLogos>;
  updateMissedCallFollowUpSetting?: Maybe<UpdateMissedCallFollowUpSetting>;
  updateNamePronunciation?: Maybe<UpdateNamePronunciation>;
  updateNewConversationsPerDay?: Maybe<UpdateNewConversationsPerDay>;
  updateOperator?: Maybe<UpdateOperator>;
  updateOperatorChannel?: Maybe<UpdateOperatorChannel>;
  updateOperatorPlaceDescription?: Maybe<UpdateOperatorPlaceDescription>;
  updateOperatorPlaceSettings?: Maybe<UpdateOperatorPlaceSettings>;
  updateOperatorSettings?: Maybe<UpdateOperatorSettings>;
  updateOutboundCallCustomization?: Maybe<UpdateOutboundCallCustomization>;
  updateOutboundConferenceCall?: Maybe<UpdateOutboundConferenceCall>;
  updateParticipant?: Maybe<UpdateParticipant>;
  updatePaymentRequestAttachment?: Maybe<UpdatePaymentRequestAttachment>;
  updatePaymentRequestCustomization?: Maybe<UpdatePaymentRequestCustomization>;
  updatePhoneCall?: Maybe<UpdatePhoneCall>;
  updatePhoneLine?: Maybe<UpdatePhoneLine>;
  updatePhoneLineLanguageSettings?: Maybe<UpdatePhoneLineLanguageSettings>;
  updatePhoneLineName?: Maybe<UpdatePhoneLineName>;
  updatePhoneLinePolicy?: Maybe<UpdatePhoneLinePolicy>;
  updatePlaceDisruptionSettings?: Maybe<UpdatePlaceDisruptionSettings>;
  updatePlaceGroup?: Maybe<UpdatePlaceGroup>;
  updatePlaceInfo?: Maybe<UpdatePlaceInfo>;
  updatePlaceMessageSettings?: Maybe<UpdatePlaceMessageSettings>;
  updatePlaceMfaSettings?: Maybe<UpdatePlaceMfaSettings>;
  updatePlaceOutboundCallSettings?: Maybe<UpdatePlaceOutboundCallSettings>;
  updatePlaceQuota?: Maybe<UpdatePlaceQuota>;
  updatePlaceStatus?: Maybe<UpdatePlaceStatus>;
  updatePlaceVoice?: Maybe<UpdatePlaceVoice>;
  updatePublicListing?: Maybe<UpdatePublicListing>;
  updateQuestionAgentSettings?: Maybe<UpdateQuestionAgentSettings>;
  updateReceivesEscalations?: Maybe<UpdateReceivesEscalations>;
  updateRepairServicesOpCodes?: Maybe<UpdateRepairServicesOpCodes>;
  updateReviewJob?: Maybe<UpdateReviewJob>;
  updateServiceAdvisor?: Maybe<UpdateServiceAdvisor>;
  updateServiceOverride?: Maybe<UpdateServiceOverride>;
  updateShortcut?: Maybe<UpdateShortcut>;
  updateShowBannerAfter?: Maybe<UpdateShowBannerAfter>;
  updateStage?: Maybe<UpdateStage>;
  updateStatusBoardView?: Maybe<UpdateStatusBoardView>;
  updateStatusItem?: Maybe<UpdateStatusItem>;
  updateSubscription?: Maybe<UpsertSubscription>;
  updateTeam?: Maybe<UpdateTeam>;
  updateTransportationSet?: Maybe<UpdateTransportationSet>;
  updateTwilioChannel?: Maybe<UpdateTwilioChannel>;
  updateUseNewNumber?: Maybe<UpdateUseNewNumber>;
  updateUser?: Maybe<UpdateUser>;
  updateUserInformation?: Maybe<UpdateUserInformation>;
  updateUserMfaSettings?: Maybe<UpdateUserMfaSettings>;
  updateUserPersonalization?: Maybe<UpdateUserPersonalization>;
  updateUserPhone?: Maybe<UpdateUserPhone>;
  updateUserPhonePreference?: Maybe<UpdateUserPhonePreference>;
  updateUserSchedule?: Maybe<UpdateUserSchedule>;
  updateUserViewPreferences?: Maybe<UpdateUserViewPreferences>;
  updateVideoUploadLink?: Maybe<UpdateVideoUploadLink>;
  updateVoiceScript?: Maybe<UpdateVoiceScript>;
  updateVoiceStep?: Maybe<UpdateVoiceStep>;
  updateVoiceStepUIHints?: Maybe<UpdateVoiceStepUiHints>;
  updateWriteItForMeConfig?: Maybe<UpdateWriteItForMeConfig>;
  uploadCustomAudio?: Maybe<UploadCustomAudio>;
  uploadCustomOutboundCallAudio?: Maybe<UploadCustomOutboundCallAudio>;
  upsertConversationRepairOrderSmartStatusUpdateSettings?: Maybe<UpsertConversationRepairOrderSmartStatusUpdateSettings>;
  upsertRepairOrderSmartStatusUpdateSettings?: Maybe<UpsertRepairOrderSmartStatusUpdateSettings>;
  useAfterHoursGreeting?: Maybe<UseAfterHoursGreeting>;
};

export type MutationsPubNubAppointmentEnrichedArgs = {
  appointment: PubNubAppointmentModel;
  conversation_id: Scalars['String']['input'];
};

export type MutationsPubNubArchiveConversationArgs = {
  conversation?: InputMaybe<PubNubConversationModel>;
};

export type MutationsPubNubArchiveConversationsArgs = {
  conversations?: InputMaybe<Array<PubNubConversationTimestamp>>;
  inbox_id: Scalars['String']['input'];
};

export type MutationsPubNubAssignConversationArgs = {
  conversation?: InputMaybe<PubNubConversationModel>;
};

export type MutationsPubNubAwayModeChangedArgs = {
  can_manage_own_away_mode_settings: Scalars['Boolean']['input'];
  is_away: Scalars['Boolean']['input'];
  is_schedule_enabled: Scalars['Boolean']['input'];
  is_unassigning_inbound_messages: Scalars['Boolean']['input'];
  next_shift_end?: InputMaybe<Scalars['String']['input']>;
  next_shift_start?: InputMaybe<Scalars['String']['input']>;
  show_away_mode_banner_after?: InputMaybe<Scalars['String']['input']>;
  status_board_view: Scalars['Boolean']['input'];
  user_id: Scalars['String']['input'];
};

export type MutationsPubNubConversationDeletedArgs = {
  conversation?: InputMaybe<PubNubConversationModel>;
};

export type MutationsPubNubConversationEngagementUpdatedArgs = {
  conversation?: InputMaybe<PubNubConversationModel>;
};

export type MutationsPubNubConversationLanguageResetArgs = {
  conversation?: InputMaybe<PubNubConversationModel>;
};

export type MutationsPubNubConversationRecoveredArgs = {
  conversation?: InputMaybe<PubNubConversationModel>;
};

export type MutationsPubNubDegradedInboxExperienceUpdatedArgs = {
  account_id: Scalars['String']['input'];
  has_degraded_inbox_experience: Scalars['Boolean']['input'];
  place_id: Scalars['String']['input'];
};

export type MutationsPubNubDialogFlowBotDataUpdatedArgs = {
  dialog_flow_bot_data?: InputMaybe<PubNubDialogFlowBotDataModel>;
};

export type MutationsPubNubEquityTradeOpportunityUpdatedArgs = {
  conversation_id: Scalars['String']['input'];
  equity_trade_opportunity: PubNubEquityTradeOpportunityModel;
};

export type MutationsPubNubInboundCallStatusUpdatedArgs = {
  call?: InputMaybe<PubNubInboundPhoneCallModel>;
  conversation_id: Scalars['String']['input'];
};

export type MutationsPubNubLabelCreatedArgs = {
  label?: InputMaybe<PubNubLabelModel>;
};

export type MutationsPubNubLabelUpdatedArgs = {
  label?: InputMaybe<PubNubLabelModel>;
};

export type MutationsPubNubLeaveConversationsArgs = {
  conversation_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationsPubNubMessageReceivedArgs = {
  conversation?: InputMaybe<PubNubConversationModel>;
  message?: InputMaybe<PubNubMessageModel>;
};

export type MutationsPubNubMessageSentArgs = {
  conversation?: InputMaybe<PubNubConversationModel>;
  message?: InputMaybe<PubNubMessageModel>;
};

export type MutationsPubNubNumboxAgentSessionUpdatedArgs = {
  numbox_agent_session?: InputMaybe<PubNubNumboxAgentSessionModel>;
};

export type MutationsPubNubOutboundConferenceCallStatusUpdatedArgs = {
  outbound_conference_call?: InputMaybe<PubNubOutboundConferenceCallModel>;
};

export type MutationsPubNubOutboundProxyCallStatusUpdatedArgs = {
  call_status: Scalars['String']['input'];
  id: Scalars['String']['input'];
  is_being_recorded: Scalars['Boolean']['input'];
  start_time?: InputMaybe<Scalars['String']['input']>;
};

export type MutationsPubNubPaymentRequestCreatedArgs = {
  payment_request?: InputMaybe<PubNubPaymentRequestModel>;
};

export type MutationsPubNubPaymentRequestUpdatedArgs = {
  payment_request?: InputMaybe<PubNubPaymentRequestModel>;
};

export type MutationsPubNubPlaceUpdatedArgs = {
  place_id?: InputMaybe<Scalars['String']['input']>;
};

export type MutationsPubNubRestoreConversationArgs = {
  conversation?: InputMaybe<PubNubConversationModel>;
};

export type MutationsPubNubRestoreConversationsArgs = {
  conversations?: InputMaybe<Array<PubNubConversationTimestamp>>;
  inbox_id: Scalars['String']['input'];
};

export type MutationsPubNubStatusItemCreatedArgs = {
  statusItem?: InputMaybe<PubNubStatusItemModel>;
};

export type MutationsPubNubStatusItemDeletedArgs = {
  statusItem?: InputMaybe<PubNubStatusItemModel>;
};

export type MutationsPubNubStatusItemUpdatedArgs = {
  statusItem?: InputMaybe<PubNubStatusItemUpdateModel>;
};

export type MutationsPubNubStripeIntegrationUpdatedArgs = {
  stripe_integration?: InputMaybe<PubNubStripeIntegrationModel>;
};

export type MutationsPubNubTaskCreatedArgs = {
  task: PubNubTaskModel;
};

export type MutationsPubNubTaskUpdatedArgs = {
  task: PubNubTaskModel;
};

export type MutationsPubNubTeamCreatedArgs = {
  team?: InputMaybe<PubNubTeamSettingsModel>;
};

export type MutationsPubNubTeamDeletedArgs = {
  place_id: Scalars['String']['input'];
  team_id: Scalars['String']['input'];
};

export type MutationsPubNubTeamUpdatedArgs = {
  team?: InputMaybe<PubNubTeamSettingsModel>;
};

export type MutationsPubNubTranscriptUpdatedArgs = {
  transcript?: InputMaybe<PubNubTranscriptModel>;
};

export type MutationsPubNubVideoUploadLinkUpdatedArgs = {
  video_upload_link?: InputMaybe<PubNubVideoUploadLinkModel>;
};

export type MutationsAddAnsweringScriptToPolicyArgs = {
  input?: InputMaybe<AddAnsweringScriptToPolicyInput>;
};

export type MutationsAddAutomationExitTriggerArgs = {
  input?: InputMaybe<AddAutomationExitTriggerInput>;
};

export type MutationsAddAvailableIntegrationArgs = {
  input?: InputMaybe<AddAvailableIntegrationInput>;
};

export type MutationsAddCustomLinkArgs = {
  input?: InputMaybe<AddCustomLinkInput>;
};

export type MutationsAddFortellisSubscriptionArgs = {
  input?: InputMaybe<AddFortellisSubscriptionInput>;
};

export type MutationsAddLabelToConversationArgs = {
  input?: InputMaybe<AddLabelToConversationInput>;
};

export type MutationsAddOperatorChannelArgs = {
  input?: InputMaybe<AddOperatorChannelInput>;
};

export type MutationsAddOperatorPlaceArgs = {
  input?: InputMaybe<AddOperatorPlaceInput>;
};

export type MutationsAddOutboundCallCustomizationArgs = {
  input?: InputMaybe<AddOutboundCallCustomizationInput>;
};

export type MutationsAddPlaceGroupArgs = {
  input: AddPlaceGroupInput;
};

export type MutationsAddServiceAdvisorArgs = {
  input?: InputMaybe<GenericAddServiceAdvisorInput>;
};

export type MutationsAddStageArgs = {
  input?: InputMaybe<AddStageInput>;
};

export type MutationsAddStatusItemArgs = {
  input?: InputMaybe<AddStatusItemInput>;
};

export type MutationsAddSubscriptionArgs = {
  billingOrderId: Scalars['String']['input'];
  subscription: SubscriptionInputQl;
};

export type MutationsAddUserToTeamArgs = {
  input?: InputMaybe<AddUserToTeamInput>;
};

export type MutationsAddVoiceStepArgs = {
  input?: InputMaybe<AddVoiceStepInput>;
};

export type MutationsArchiveMissedCallsArgs = {
  input?: InputMaybe<ArchiveMissedCallsInput>;
};

export type MutationsAssignConversationsArgs = {
  input: AssignConversationsInput;
};

export type MutationsBuildRepairOrderAssistedStatusQuestionTreeArgs = {
  input?: InputMaybe<BuildRepairOrderAssistedStatusQuestionTreeInput>;
};

export type MutationsBuildWriteItForMeQuestionTreeArgs = {
  input?: InputMaybe<BuildWriteItForMeQuestionTreeInput>;
};

export type MutationsBulkUpdateSupportedVehiclesArgs = {
  input: BulkUpdateSupportedVehiclesInput;
};

export type MutationsCancelPaymentRequestArgs = {
  input?: InputMaybe<CancelPaymentRequestInput>;
};

export type MutationsCancelScheduledMessageArgs = {
  input?: InputMaybe<CancelScheduledMessageInput>;
};

export type MutationsCapturePaymentAmountArgs = {
  input?: InputMaybe<CapturePaymentAmountInput>;
};

export type MutationsChangeAccountSubscriptionArgs = {
  input?: InputMaybe<ChangeAccountSubscriptionInput>;
};

export type MutationsChangeAllowCustomAudioArgs = {
  input?: InputMaybe<ChangeAllowCustomAudioInput>;
};

export type MutationsChangeBusinessVerticalArgs = {
  input?: InputMaybe<ChangeBusinessVerticalInput>;
};

export type MutationsChangeInboxTypeArgs = {
  input?: InputMaybe<ChangeInboxTypeInput>;
};

export type MutationsChangeNotificationSettingsArgs = {
  input?: InputMaybe<NotificationSettingsInput>;
};

export type MutationsChangePlaceGroupArgs = {
  input: ChangePlaceGroupInput;
};

export type MutationsChangePlaceHoursArgs = {
  input?: InputMaybe<ChangePlaceHoursInput>;
};

export type MutationsChangePlaceSubscriptionsArgs = {
  input?: InputMaybe<ChangePlaceSubscriptionInput>;
};

export type MutationsChangeRepairOrderScheduleArgs = {
  input?: InputMaybe<ChangeRepairOrderScheduleInput>;
};

export type MutationsChangeSignupModeArgs = {
  input?: InputMaybe<ChangeSignupModeInput>;
};

export type MutationsChangeSwipeActionSettingsArgs = {
  input?: InputMaybe<ChangeSwipeActionSettingsInput>;
};

export type MutationsChangeTwilioChannelMdnArgs = {
  input?: InputMaybe<ChangeTwilioChannelMdnInput>;
};

export type MutationsChangeUserPasswordArgs = {
  input?: InputMaybe<ChangeUserPasswordInput>;
};

export type MutationsChangeUserSettingsArgs = {
  input?: InputMaybe<NotificationSettingsInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationsChangeUserVideoConferenceUrlArgs = {
  input?: InputMaybe<ChangeUserVideoConferenceUrlInput>;
};

export type MutationsCloseStatusItemArgs = {
  input?: InputMaybe<CloseStatusItemInput>;
};

export type MutationsCompleteAutopilotArgs = {
  input?: InputMaybe<CompleteAutopilotInput>;
};

export type MutationsCompleteTaskArgs = {
  input: CompleteTaskInput;
};

export type MutationsConnectAutomationActionArgs = {
  input?: InputMaybe<ConnectAutomationActionInput>;
};

export type MutationsConnectAutomationActionEdgeArgs = {
  input?: InputMaybe<ConnectAutomationActionEdgeInput>;
};

export type MutationsCreateA2pCampaignForPlaceArgs = {
  placeId?: InputMaybe<Scalars['String']['input']>;
  trustProductId: Scalars['String']['input'];
};

export type MutationsCreateAppointmentAgentSettingLabelArgs = {
  input?: InputMaybe<CreateAppointmentAgentSettingLabelInput>;
};

export type MutationsCreateAppointmentAgentSettingsArgs = {
  input?: InputMaybe<CreateAppointmentAgentSettingsInput>;
};

export type MutationsCreateAutomationArgs = {
  input?: InputMaybe<CreateAutomationInput>;
};

export type MutationsCreateAutomationActionArgs = {
  input?: InputMaybe<CreateAutomationActionInput>;
};

export type MutationsCreateAutomationFromBlueprintArgs = {
  input?: InputMaybe<CreateAutomationFromBlueprintInput>;
};

export type MutationsCreateAutopilotArgs = {
  input?: InputMaybe<CreateAutopilotInput>;
};

export type MutationsCreateBillingIdentityArgs = {
  billingOrderId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  skus: Array<InputMaybe<SubscriptionInputQl>>;
  source: Scalars['String']['input'];
};

export type MutationsCreateCampaignArgs = {
  input?: InputMaybe<CreateCampaignInput>;
};

export type MutationsCreateChatExpansionArgs = {
  input?: InputMaybe<CreateChatExpansionInput>;
};

export type MutationsCreateChitchatArgs = {
  input: CreateAgentChitChatInput;
};

export type MutationsCreateConversationArgs = {
  input?: InputMaybe<CreateConversationInput>;
};

export type MutationsCreateConversationSummaryArgs = {
  input?: InputMaybe<CreateConversationSummaryInput>;
};

export type MutationsCreateConversationTextExpansionArgs = {
  input?: InputMaybe<CreateConversationTextExpansionInput>;
};

export type MutationsCreateCustomDirectoryEntryArgs = {
  input: CreateCustomDirectoryEntryInput;
};

export type MutationsCreateDepartmentDeviceArgs = {
  input: CreateDepartmentDeviceInput;
};

export type MutationsCreateIdentityPromptAddressArgs = {
  input?: InputMaybe<CreateIdentityPromptAddressInput>;
};

export type MutationsCreateLabelArgs = {
  input?: InputMaybe<CreateLabelInput>;
};

export type MutationsCreateManualCampaignUploadArgs = {
  input?: InputMaybe<CreateManualCampaignUploadInput>;
};

export type MutationsCreateNoteTakerArgs = {
  input?: InputMaybe<CreateNoteTakerInput>;
};

export type MutationsCreateOperatorArgs = {
  input?: InputMaybe<CreateOperatorInput>;
};

export type MutationsCreateOutboundConferenceCallArgs = {
  input?: InputMaybe<CreateOutboundConferenceCallInput>;
};

export type MutationsCreateOutboundProxyCallArgs = {
  input?: InputMaybe<CreateOutboundProxyCallInput>;
};

export type MutationsCreateParticipantArgs = {
  input?: InputMaybe<CreateParticipantInput>;
};

export type MutationsCreateParticipantPaymentRequestArgs = {
  input?: InputMaybe<CreateParticipantPaymentRequestInput>;
};

export type MutationsCreatePaymentRequestArgs = {
  input?: InputMaybe<CreatePaymentRequestInput>;
};

export type MutationsCreatePhoneLineArgs = {
  input?: InputMaybe<CreatePhoneLineInput>;
};

export type MutationsCreatePlaceArgs = {
  input?: InputMaybe<CreatePlaceInput>;
};

export type MutationsCreateScheduledMessageArgs = {
  input?: InputMaybe<CreateScheduledMessageInput>;
};

export type MutationsCreateShortcutArgs = {
  input: CreateShortcutInput;
};

export type MutationsCreateStripeAccountArgs = {
  input?: InputMaybe<CreateStripeAccountInput>;
};

export type MutationsCreateStripeRefundArgs = {
  input?: InputMaybe<CreateStripeRefundInput>;
};

export type MutationsCreateTaskForEngagementArgs = {
  input: NewTaskForEngagementInput;
};

export type MutationsCreateTeamArgs = {
  input?: InputMaybe<CreateTeamInput>;
};

export type MutationsCreateTextExpansionArgs = {
  input?: InputMaybe<CreateTextExpansionInput>;
};

export type MutationsCreateUserArgs = {
  input?: InputMaybe<CreateUserInput>;
};

export type MutationsCreateUserPhoneArgs = {
  input?: InputMaybe<CreateUserPhoneInput>;
};

export type MutationsCreateVideoUploadLinkArgs = {
  input?: InputMaybe<CreateVideoUploadLinkInput>;
};

export type MutationsDeactivateAccountArgs = {
  input?: InputMaybe<DeactivateAccountInput>;
};

export type MutationsDeleteAppointmentAgentSettingLabelArgs = {
  input?: InputMaybe<DeleteAppointmentAgentSettingLabelInput>;
};

export type MutationsDeleteAppointmentAgentSettingsArgs = {
  input?: InputMaybe<DeleteAppointmentAgentSettingsInput>;
};

export type MutationsDeleteAutomationArgs = {
  input?: InputMaybe<DeleteAutomationInput>;
};

export type MutationsDeleteConversationArgs = {
  input: DeleteConversationInput;
};

export type MutationsDeleteCustomDirectoryEntryArgs = {
  id: Scalars['String']['input'];
};

export type MutationsDeleteCustomLinkArgs = {
  input?: InputMaybe<DeleteCustomLinkInput>;
};

export type MutationsDeleteDepartmentDeviceArgs = {
  id: Scalars['String']['input'];
};

export type MutationsDeleteIdentityPromptAddressArgs = {
  input?: InputMaybe<DeleteIdentityPromptAddressInput>;
};

export type MutationsDeleteNoteTakerArgs = {
  input?: InputMaybe<DeleteNoteTakerInput>;
};

export type MutationsDeleteOutboundCallCustomizationArgs = {
  input?: InputMaybe<DeleteOutboundCallCustomizationInput>;
};

export type MutationsDeletePhoneLineArgs = {
  input?: InputMaybe<DeletePhoneLineInput>;
};

export type MutationsDeletePlaceArgs = {
  input?: InputMaybe<DeletePlaceInput>;
};

export type MutationsDeleteScheduledMessageArgs = {
  input?: InputMaybe<DeleteScheduledMessageInput>;
};

export type MutationsDeleteShortcutArgs = {
  input: DeleteShortcutInput;
};

export type MutationsDeleteStageArgs = {
  input?: InputMaybe<DeleteStageInput>;
};

export type MutationsDeleteStatusItemArgs = {
  input?: InputMaybe<DeleteStatusItemInput>;
};

export type MutationsDeleteTeamArgs = {
  input?: InputMaybe<DeleteTeamInput>;
};

export type MutationsDeleteUserPhoneArgs = {
  input?: InputMaybe<DeleteUserPhoneInput>;
};

export type MutationsDeleteVoiceStepArgs = {
  input?: InputMaybe<DeleteVoiceStepInput>;
};

export type MutationsDisableAutopilotArgs = {
  input?: InputMaybe<DisableAutopilotInput>;
};

export type MutationsDisableFortellisSubscriptionArgs = {
  input?: InputMaybe<DisableFortellisSubscriptionInput>;
};

export type MutationsDiscardAutomationEditsArgs = {
  input?: InputMaybe<DiscardAutomationEditsInput>;
};

export type MutationsDiscardDisruptionVoiceScriptArgs = {
  input?: InputMaybe<DiscardDisruptionVoiceScriptInput>;
};

export type MutationsDiscardVoiceScriptArgs = {
  input?: InputMaybe<DiscardVoiceScriptInput>;
};

export type MutationsDismissTaskArgs = {
  input: DismissTaskInput;
};

export type MutationsDuplicateAppointmentAgentSettingsArgs = {
  input?: InputMaybe<DuplicateAppointmentAgentSettingsInput>;
};

export type MutationsEnableInboxLanguageOverrideArgs = {
  input?: InputMaybe<EnableInboxLanguageOverrideInput>;
};

export type MutationsEnableNudgesArgs = {
  input?: InputMaybe<EnableNudgesInput>;
};

export type MutationsEnablePlaceMessagingHoursArgs = {
  input?: InputMaybe<EnablePlaceMessagingHoursInput>;
};

export type MutationsEndOutboundConferenceCallArgs = {
  input?: InputMaybe<EndOutboundConferenceCallInput>;
};

export type MutationsEvaluateBusinessIdentityArgs = {
  accountId: Scalars['String']['input'];
  input?: InputMaybe<BusinessIdentityInput>;
};

export type MutationsExportConversationToArchiveArgs = {
  input: ExportConversationToArchiveInput;
};

export type MutationsForceActiveIntegrationSyncArgs = {
  input?: InputMaybe<ForceActiveIntegrationSyncInput>;
};

export type MutationsGenerateRepairOrderAssistedStatusContentArgs = {
  input?: InputMaybe<GenerateRepairOrderAssistedStatusContentInput>;
};

export type MutationsGenerateRepairOrderNotesSummaryArgs = {
  input: GenerateRepairOrderNotesSummaryInput;
};

export type MutationsGenerateWriteItForMeContentArgs = {
  input?: InputMaybe<GenerateWriteItForMeContentInput>;
};

export type MutationsGlobalSyncXtimeServicesArgs = {
  input: GlobalSyncXtimeServicesInput;
};

export type MutationsHostedSmsCompletedArgs = {
  input?: InputMaybe<HostedSmsCompletedInput>;
};

export type MutationsImpersonateArgs = {
  userId: Scalars['String']['input'];
};

export type MutationsImportHostedSmsArgs = {
  input?: InputMaybe<ImportHostedSmsInput>;
};

export type MutationsIncreaseShortcutCountArgs = {
  input: IncreaseShortcutCountInput;
};

export type MutationsLeaveConversationsArgs = {
  input: LeaveConversationsInput;
};

export type MutationsLoginArgs = {
  credential: Credentials;
};

export type MutationsManualOpportunityArgs = {
  input?: InputMaybe<ManualOpportunityInput>;
};

export type MutationsMapCrmUserToUserArgs = {
  input?: InputMaybe<MapCrmUserToUserInput>;
};

export type MutationsMarkMessagesReadArgs = {
  input?: InputMaybe<MarkMessagesReadInput>;
};

export type MutationsMoveStatusItemArgs = {
  input?: InputMaybe<MoveStatusItemInput>;
};

export type MutationsPokeUserArgs = {
  input?: InputMaybe<PokeUserInput>;
};

export type MutationsPopulateBusinessProfileWithChargebeeInfoArgs = {
  input?: InputMaybe<PopulateBusinessProfileWithChargebeeInfoInput>;
};

export type MutationsPortInPhoneLineArgs = {
  input?: InputMaybe<PortInPhoneLineInput>;
};

export type MutationsPublishAutomationArgs = {
  input?: InputMaybe<PublishAutomationInput>;
};

export type MutationsPublishDisruptionVoiceScriptArgs = {
  input?: InputMaybe<PublishDisruptionVoiceScriptInput>;
};

export type MutationsPublishVoiceScriptArgs = {
  input?: InputMaybe<PublishVoiceScriptInput>;
};

export type MutationsRateAppointmentAgentNoteArgs = {
  input: RateAppointmentAgentNoteInput;
};

export type MutationsRateAssistedResponseArgs = {
  input: RateAssistedResponseInput;
};

export type MutationsRateCallIntelligenceSummaryArgs = {
  input: RateCallIntelligenceInput;
};

export type MutationsRateEngagementStatusArgs = {
  input: RateEngagementStatusInput;
};

export type MutationsRateEngagementSummaryArgs = {
  input: RateEngagementSummaryInput;
};

export type MutationsRecoverConversationArgs = {
  input: RecoverConversationInput;
};

export type MutationsRefreshCarrierInfoArgs = {
  input?: InputMaybe<RefreshCarrierInfoInput>;
};

export type MutationsRefreshFortellisServiceAdvisorsArgs = {
  input?: InputMaybe<RefreshFortellisServiceAdvisorsInput>;
};

export type MutationsRegisterFortellisServiceAdvisorArgs = {
  input?: InputMaybe<RegisterFortellisServiceAdvisorInput>;
};

export type MutationsRemoveAutomationActionArgs = {
  input?: InputMaybe<RemoveAutomationActionInput>;
};

export type MutationsRemoveAutomationExitTriggerArgs = {
  input?: InputMaybe<RemoveAutomationExitTriggerInput>;
};

export type MutationsRemoveLabelFromConversationArgs = {
  input?: InputMaybe<RemoveLabelFromConversationInput>;
};

export type MutationsRemovePlaceGroupArgs = {
  input: RemovePlaceGroupInput;
};

export type MutationsRemoveServiceAdvisorArgs = {
  input?: InputMaybe<RemoveServiceAdvisorInput>;
};

export type MutationsRemoveUserFromPlaceArgs = {
  input?: InputMaybe<RemoveUserFromPlaceInput>;
};

export type MutationsRemoveUserFromTeamArgs = {
  input?: InputMaybe<RemoveUserFromTeamInput>;
};

export type MutationsRemoveVideoUploadLinkArgs = {
  input?: InputMaybe<RemoveVideoUploadLinkInput>;
};

export type MutationsRenameAccountArgs = {
  input?: InputMaybe<RenameAccountInput>;
};

export type MutationsRenamePlaceArgs = {
  input?: InputMaybe<RenamePlaceInput>;
};

export type MutationsReopenStatusItemArgs = {
  input?: InputMaybe<ReopenStatusItemInput>;
};

export type MutationsRequestAvailableIntegrationArgs = {
  input?: InputMaybe<RequestAvailableIntegrationInput>;
};

export type MutationsResetAppointmentAgentSettingsArgs = {
  input?: InputMaybe<ResetAppointmentAgentSettingsInput>;
};

export type MutationsResetBrandThemeArgs = {
  input?: InputMaybe<ResetBrandThemeInput>;
};

export type MutationsResetConversationLanguageArgs = {
  input: ResetConversationLanguageInput;
};

export type MutationsResetOutboundChannelsArgs = {
  input?: InputMaybe<ResetOutboundChannelsInput>;
};

export type MutationsResetTaskStatusArgs = {
  input: ResetTaskStatusInput;
};

export type MutationsResetVoiceScriptArgs = {
  input?: InputMaybe<ResetVoiceScriptInput>;
};

export type MutationsSendBroadcastArgs = {
  input?: InputMaybe<SendBroadcastInput>;
};

export type MutationsSendLoaArgs = {
  input?: InputMaybe<SendLoaInput>;
};

export type MutationsSendMessageArgs = {
  input?: InputMaybe<SendMessageInput>;
};

export type MutationsSendReviewRequestArgs = {
  input?: InputMaybe<SendReviewRequestInput>;
};

export type MutationsSendScheduledMessageNowArgs = {
  input?: InputMaybe<SendScheduledMessageNowInput>;
};

export type MutationsSendStatusItemMessageArgs = {
  input: SendStatusItemMessageInput;
};

export type MutationsSendVcardArgs = {
  input?: InputMaybe<SendVCardInput>;
};

export type MutationsSetAssignmentRetentionArgs = {
  input?: InputMaybe<SetAssignmentRetentionInput>;
};

export type MutationsSetBusinessTimezoneArgs = {
  input?: InputMaybe<SetBusinessTimezoneInput>;
};

export type MutationsSetFortellisLookupIdArgs = {
  input?: InputMaybe<SetFortellisLookupIdInput>;
};

export type MutationsSetHangupSuggestionArgs = {
  input?: InputMaybe<SetHangupSuggestionInput>;
};

export type MutationsSetOptInStatusArgs = {
  input: SetOptInStatusInput;
};

export type MutationsSetResetOngoingOptinArgs = {
  input?: InputMaybe<SetResetOngoingOptinInput>;
};

export type MutationsSetResetOptinDaysArgs = {
  input?: InputMaybe<SetResetOptinDaysInput>;
};

export type MutationsSetupEquityTradeOpportunityCampaignArgs = {
  input?: InputMaybe<SetupEquityTradeOpportunityCampaignInput>;
};

export type MutationsSnoozeConversationArgs = {
  input: SnoozeConversationInput;
};

export type MutationsStartConversationArgs = {
  input?: InputMaybe<StartConversationInput>;
};

export type MutationsStartConversationWithScheduledMessageArgs = {
  input?: InputMaybe<StartConversationWithScheduledMessageInput>;
};

export type MutationsSubmit10DlcStarterProfileArgs = {
  input?: InputMaybe<Submit10DlcStarterProfileInput>;
};

export type MutationsSubmitBusinessIdentityArgs = {
  input?: InputMaybe<BusinessIdentityInput>;
  trustProductId: Scalars['String']['input'];
};

export type MutationsSyncXtimeServicesArgs = {
  input: SyncXtimeServicesInput;
};

export type MutationsTeachNumaArgs = {
  input?: InputMaybe<TeachNumaInput>;
};

export type MutationsToggleCustomPhoneLinePolicyArgs = {
  input?: InputMaybe<ToggleCustomPhoneLinePolicyInput>;
};

export type MutationsToggleOutboundProxyCallRecordingArgs = {
  input?: InputMaybe<ToggleOutboundProxyCallRecordingInput>;
};

export type MutationsUnmapCrmUserFromUserArgs = {
  input?: InputMaybe<UnmapCrmUserFromUserInput>;
};

export type MutationsUpdateActiveIntegrationArgs = {
  input?: InputMaybe<UpdateActiveIntegrationInput>;
};

export type MutationsUpdateAllowedSpeechLanguagesArgs = {
  input: UpdateLanguageSettingsInput;
};

export type MutationsUpdateAnsweringScriptOrderArgs = {
  input: Array<UpdateAnsweringScriptOrderInput>;
};

export type MutationsUpdateAppointmentArgs = {
  input?: InputMaybe<UpdateAppointmentInput>;
};

export type MutationsUpdateAppointmentAgentSettingLabelArgs = {
  input?: InputMaybe<UpdateAppointmentAgentSettingLabelInput>;
};

export type MutationsUpdateAppointmentAgentSettingsArgs = {
  input?: InputMaybe<UpdateAppointmentAgentSettingsInput>;
};

export type MutationsUpdateAssignmentRoutingSettingsArgs = {
  input?: InputMaybe<UpdateAssignmentRoutingSettingsInput>;
};

export type MutationsUpdateAutomationArgs = {
  input?: InputMaybe<UpdateAutomationInput>;
};

export type MutationsUpdateAutomationActionArgs = {
  input?: InputMaybe<UpdateAutomationActionInput>;
};

export type MutationsUpdateAutomationEnrollmentCriteriaArgs = {
  input?: InputMaybe<UpdateAutomationEnrollmentCriteriaInput>;
};

export type MutationsUpdateAutomationExitTriggerArgs = {
  input?: InputMaybe<UpdateAutomationExitTriggerInput>;
};

export type MutationsUpdateAutomationStartTriggerArgs = {
  input?: InputMaybe<UpdateAutomationStartTriggerInput>;
};

export type MutationsUpdateAutomationUiHintsArgs = {
  input?: InputMaybe<UpdateAutomationUiHintsInput>;
};

export type MutationsUpdateAutopilotEtaArgs = {
  input?: InputMaybe<UpdateAutopilotEtaInput>;
};

export type MutationsUpdateAutopilotJobArgs = {
  input?: InputMaybe<UpdateAutopilotJobInput>;
};

export type MutationsUpdateAutopilotScheduledMessageArgs = {
  input?: InputMaybe<UpdateAutopilotScheduledMessageInput>;
};

export type MutationsUpdateAvailableIntegrationArgs = {
  input?: InputMaybe<UpdateAvailableIntegrationInput>;
};

export type MutationsUpdateAwayModeArgs = {
  input?: InputMaybe<UpdateAwayModeInput>;
};

export type MutationsUpdateAwayModeAssigneeArgs = {
  input?: InputMaybe<UpdateAwayModeAssigneeInput>;
};

export type MutationsUpdateAwayModeManagingPermissionArgs = {
  input?: InputMaybe<UpdateAwayModeManagingPermissionInput>;
};

export type MutationsUpdateAwayModeWithTimeArgs = {
  input?: InputMaybe<UpdateAwayModeWithTimeInput>;
};

export type MutationsUpdateBillingMetadataArgs = {
  input?: InputMaybe<UpdateBillingMetadataInput>;
};

export type MutationsUpdateBrandLogoArgs = {
  input?: InputMaybe<UpdateBrandLogoInput>;
};

export type MutationsUpdateBrandThemeArgs = {
  input?: InputMaybe<UpdateBrandThemeInput>;
};

export type MutationsUpdateBusinessIdentityArgs = {
  input?: InputMaybe<BusinessIdentityInput>;
  trustProductId: Scalars['String']['input'];
};

export type MutationsUpdateBusinessProfileArgs = {
  input?: InputMaybe<UpdateBusinessProfileInput>;
};

export type MutationsUpdateCallForwardingStatusArgs = {
  input?: InputMaybe<UpdateCallForwardingStatusInput>;
};

export type MutationsUpdateCallIntelligenceEnabledArgs = {
  input?: InputMaybe<UpdateCallIntelligenceEnabledInput>;
};

export type MutationsUpdateCallIntelligenceSettingArgs = {
  input: UpdateCallIntelligenceSettingInput;
};

export type MutationsUpdateCampaignStatusArgs = {
  input?: InputMaybe<UpdateCampaignStatusInput>;
};

export type MutationsUpdateChannelArgs = {
  input?: InputMaybe<UpdateChannelInput>;
};

export type MutationsUpdateChitchatArgs = {
  input: UpdateAgentChitChatInput;
};

export type MutationsUpdateComplianceSettingsArgs = {
  input?: InputMaybe<UpdateComplianceSettingsInput>;
};

export type MutationsUpdateConversationLabelArgs = {
  input?: InputMaybe<UpdateConversationLabelInput>;
};

export type MutationsUpdateConversationsArgs = {
  input: UpdateConversationsInput;
};

export type MutationsUpdateCurbsideSettingsArgs = {
  input?: InputMaybe<UpdateCurbsideSettingsInput>;
};

export type MutationsUpdateCustomDirectoryEntryArgs = {
  input: UpdateCustomDirectoryEntryInput;
};

export type MutationsUpdateDefaultViewArgs = {
  input?: InputMaybe<UpdateDefaultViewInput>;
};

export type MutationsUpdateDefaultYouViewArgs = {
  input?: InputMaybe<UpdateDefaultYouViewInput>;
};

export type MutationsUpdateDepartmentDeviceArgs = {
  input: UpdateDepartmentDeviceInput;
};

export type MutationsUpdateDirectoryEntryArgs = {
  input: UpdateDirectoryEntryInput;
};

export type MutationsUpdateEdgesVoiceStepArgs = {
  input?: InputMaybe<UpdateEdgesVoiceStepInput>;
};

export type MutationsUpdateEquityTradeOpportunityStageArgs = {
  input?: InputMaybe<UpdateEquityTradeOpportunityStageInput>;
};

export type MutationsUpdateEscalationSettingsArgs = {
  input?: InputMaybe<UpdateEscalationSettingsInput>;
};

export type MutationsUpdateEtoSettingsArgs = {
  input?: InputMaybe<UpdateEtoSettingsInput>;
};

export type MutationsUpdateGreetingArgs = {
  input?: InputMaybe<UpdateGreetingInput>;
};

export type MutationsUpdateHasDismissedGuideChecklistArgs = {
  input?: InputMaybe<UpdateHasDismissedGuideChecklistInput>;
};

export type MutationsUpdateHasViewedReferArgs = {
  input?: InputMaybe<UpdateHasViewedReferInput>;
};

export type MutationsUpdateHideSharedInboxViewsArgs = {
  input?: InputMaybe<UpdateHideSharedInboxViewsInput>;
};

export type MutationsUpdateHostedSmsArgs = {
  input?: InputMaybe<UpdateHostedSmsInput>;
};

export type MutationsUpdateIsScheduleEnabledArgs = {
  input?: InputMaybe<UpdateIsScheduleEnabledInput>;
};

export type MutationsUpdateIsUnassigningInboundMessagesArgs = {
  input?: InputMaybe<UpdateIsUnassigningInboundMessagesInput>;
};

export type MutationsUpdateLabelArgs = {
  input?: InputMaybe<UpdateLabelInput>;
};

export type MutationsUpdateLinkArgs = {
  input?: InputMaybe<UpdateLinkInput>;
};

export type MutationsUpdateLinkUrlsArgs = {
  input?: InputMaybe<UpdateLinkUrlsInput>;
};

export type MutationsUpdateLoggedCallArgs = {
  input?: InputMaybe<UpdateLoggedCallInput>;
};

export type MutationsUpdateLogosArgs = {
  input?: InputMaybe<UpdateLogosInput>;
};

export type MutationsUpdateMissedCallFollowUpSettingArgs = {
  input?: InputMaybe<UpdateMissedCallFollowUpSettingInput>;
};

export type MutationsUpdateNamePronunciationArgs = {
  input?: InputMaybe<UpdateNamePronunciationInput>;
};

export type MutationsUpdateNewConversationsPerDayArgs = {
  input?: InputMaybe<UpdateNewConversationsPerDayInput>;
};

export type MutationsUpdateOperatorArgs = {
  input?: InputMaybe<UpdateOperatorInput>;
};

export type MutationsUpdateOperatorChannelArgs = {
  input?: InputMaybe<UpdateOperatorChannelInput>;
};

export type MutationsUpdateOperatorPlaceDescriptionArgs = {
  input?: InputMaybe<UpdateOperatorPlaceDescriptionInput>;
};

export type MutationsUpdateOperatorPlaceSettingsArgs = {
  input?: InputMaybe<UpdateOperatorPlaceSettingsInput>;
};

export type MutationsUpdateOperatorSettingsArgs = {
  input?: InputMaybe<UpdateOperatorSettingsInput>;
};

export type MutationsUpdateOutboundCallCustomizationArgs = {
  input?: InputMaybe<UpdateOutboundCallCustomizationInput>;
};

export type MutationsUpdateOutboundConferenceCallArgs = {
  input?: InputMaybe<UpdateOutboundConferenceCallInput>;
};

export type MutationsUpdateParticipantArgs = {
  input?: InputMaybe<UpdateParticipantInput>;
};

export type MutationsUpdatePaymentRequestAttachmentArgs = {
  input?: InputMaybe<UpdatePaymentRequestAttachmentInput>;
};

export type MutationsUpdatePaymentRequestCustomizationArgs = {
  input?: InputMaybe<UpdatePaymentRequestCustomizationInput>;
};

export type MutationsUpdatePhoneCallArgs = {
  input: UpdatePhoneCallInput;
};

export type MutationsUpdatePhoneLineArgs = {
  input?: InputMaybe<UpdatePhoneLineInput>;
};

export type MutationsUpdatePhoneLineLanguageSettingsArgs = {
  input: UpdatePhoneLineLanguageSettingsInput;
};

export type MutationsUpdatePhoneLineNameArgs = {
  input?: InputMaybe<UpdatePhoneLineNameInput>;
};

export type MutationsUpdatePhoneLinePolicyArgs = {
  input?: InputMaybe<UpdatePhoneLinePolicyInput>;
};

export type MutationsUpdatePlaceDisruptionSettingsArgs = {
  input?: InputMaybe<UpdatePlaceDisruptionSettingsInput>;
};

export type MutationsUpdatePlaceGroupArgs = {
  input: UpdatePlaceGroupInput;
};

export type MutationsUpdatePlaceInfoArgs = {
  input?: InputMaybe<UpdatePlaceInfoInput>;
};

export type MutationsUpdatePlaceMessageSettingsArgs = {
  input?: InputMaybe<UpdatePlaceMessageSettingsInput>;
};

export type MutationsUpdatePlaceMfaSettingsArgs = {
  input?: InputMaybe<UpdatePlaceMfaSettingsInput>;
};

export type MutationsUpdatePlaceOutboundCallSettingsArgs = {
  input?: InputMaybe<UpdatePlaceOutboundCallSettingsInput>;
};

export type MutationsUpdatePlaceQuotaArgs = {
  input?: InputMaybe<UpdatePlaceQuotaInput>;
};

export type MutationsUpdatePlaceStatusArgs = {
  input?: InputMaybe<UpdatePlaceStatusInput>;
};

export type MutationsUpdatePlaceVoiceArgs = {
  input?: InputMaybe<UpdatePlaceVoiceInput>;
};

export type MutationsUpdatePublicListingArgs = {
  input?: InputMaybe<UpdatePublicListingInput>;
};

export type MutationsUpdateQuestionAgentSettingsArgs = {
  input?: InputMaybe<UpdateQuestionAgentSettingsInput>;
};

export type MutationsUpdateReceivesEscalationsArgs = {
  input?: InputMaybe<UpdateReceivesEscalationsInput>;
};

export type MutationsUpdateRepairServicesOpCodesArgs = {
  input?: InputMaybe<Array<InputMaybe<UpdateRepairServiceOpCodesInput>>>;
};

export type MutationsUpdateReviewJobArgs = {
  input?: InputMaybe<UpdateReviewJobInput>;
};

export type MutationsUpdateServiceAdvisorArgs = {
  input?: InputMaybe<UpdateServiceAdvisorInput>;
};

export type MutationsUpdateServiceOverrideArgs = {
  input: UpdateServiceOverrideInputQl;
};

export type MutationsUpdateShortcutArgs = {
  input: UpdateShortcutInput;
};

export type MutationsUpdateStageArgs = {
  input?: InputMaybe<UpdateStageInput>;
};

export type MutationsUpdateStatusBoardViewArgs = {
  input?: InputMaybe<UpdateStatusBoardViewInput>;
};

export type MutationsUpdateStatusItemArgs = {
  input?: InputMaybe<UpdateStatusItemInput>;
};

export type MutationsUpdateSubscriptionArgs = {
  billingIdentityId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  skuName: Scalars['String']['input'];
};

export type MutationsUpdateTeamArgs = {
  input?: InputMaybe<UpdateTeamInput>;
};

export type MutationsUpdateTransportationSetArgs = {
  input: UpdateTransportationSetInput;
};

export type MutationsUpdateTwilioChannelArgs = {
  input?: InputMaybe<UpdateTwilioChannelInput>;
};

export type MutationsUpdateUseNewNumberArgs = {
  input?: InputMaybe<UpdateUseNewNumberInput>;
};

export type MutationsUpdateUserArgs = {
  input?: InputMaybe<UpdateUserInput>;
};

export type MutationsUpdateUserInformationArgs = {
  input?: InputMaybe<UpdateUserInformationInput>;
};

export type MutationsUpdateUserMfaSettingsArgs = {
  input?: InputMaybe<UpdateUserMfaSettingsInput>;
};

export type MutationsUpdateUserPersonalizationArgs = {
  input?: InputMaybe<UpdateUserPersonalizationInput>;
};

export type MutationsUpdateUserPhoneArgs = {
  input?: InputMaybe<UpdateUserPhoneInput>;
};

export type MutationsUpdateUserPhonePreferenceArgs = {
  input?: InputMaybe<UpdateUserPhonePreferenceInput>;
};

export type MutationsUpdateUserScheduleArgs = {
  input?: InputMaybe<UpdateUserScheduleInput>;
};

export type MutationsUpdateUserViewPreferencesArgs = {
  input?: InputMaybe<UpdateUserViewPreferencesInput>;
};

export type MutationsUpdateVideoUploadLinkArgs = {
  input?: InputMaybe<UpdateVideoUploadLinkInput>;
};

export type MutationsUpdateVoiceScriptArgs = {
  input?: InputMaybe<UpdateVoiceScriptInput>;
};

export type MutationsUpdateVoiceStepArgs = {
  input?: InputMaybe<UpdateVoiceStepInput>;
};

export type MutationsUpdateVoiceStepUiHintsArgs = {
  input?: InputMaybe<UpdateVoiceStepUiHintsInput>;
};

export type MutationsUpdateWriteItForMeConfigArgs = {
  input?: InputMaybe<UpdateWriteItForMeConfigInput>;
};

export type MutationsUploadCustomAudioArgs = {
  input?: InputMaybe<UploadCustomAudioInput>;
};

export type MutationsUploadCustomOutboundCallAudioArgs = {
  input?: InputMaybe<UploadCustomOutboundCallAudioInput>;
};

export type MutationsUpsertConversationRepairOrderSmartStatusUpdateSettingsArgs =
  {
    input?: InputMaybe<UpsertConversationRepairOrderSmartStatusUpdateSettingsInput>;
  };

export type MutationsUpsertRepairOrderSmartStatusUpdateSettingsArgs = {
  input?: InputMaybe<RepairOrderSmartStatusUpdateSettingsInput>;
};

export type MutationsUseAfterHoursGreetingArgs = {
  input?: InputMaybe<UseAfterHoursGreetingInput>;
};

export type NewTaskForEngagementInput = {
  engagementId: Scalars['UUID']['input'];
  title: Scalars['String']['input'];
};

/** An object with an ID */
export type Node = {
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

export type NoteAttachment = Attachment &
  Node & {
    __typename?: 'NoteAttachment';
    attachmentType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    message?: Maybe<MessageQl>;
    messageId?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
  };

export type NoteChannelQl = Channel &
  Node & {
    __typename?: 'NoteChannelQL';
    Assignee?: Maybe<UserQl>;
    AssigneeId?: Maybe<Scalars['String']['output']>;
    RespectExistingAssignments?: Maybe<Scalars['Boolean']['output']>;
    Team?: Maybe<TeamQl>;
    TeamId?: Maybe<Scalars['String']['output']>;
    account: AccountQl;
    accountId: Scalars['String']['output'];
    assignTextReplies?: Maybe<Scalars['String']['output']>;
    assignee?: Maybe<UserQl>;
    assigneeId?: Maybe<Scalars['String']['output']>;
    channelType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    identityPromptAddresses?: Maybe<IdentityPromptAddressQlConnection>;
    identityPromptOption: IdentityPromptOptions;
    isActive: Scalars['Boolean']['output'];
    isBotEnabled: Scalars['Boolean']['output'];
    isNryChannel?: Maybe<Scalars['Boolean']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messages?: Maybe<MessageQlConnection>;
    name?: Maybe<Scalars['String']['output']>;
    operator?: Maybe<OperatorQl>;
    operatorId?: Maybe<Scalars['String']['output']>;
    operatorSessions?: Maybe<OperatorSessionQlConnection>;
    outboundConferenceCall?: Maybe<OutboundConferenceCallQlConnection>;
    outboundProxyCall?: Maybe<OutboundProxyCallQlConnection>;
    phonecalls?: Maybe<PhoneCallQlConnection>;
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    respectExistingAssignments?: Maybe<Scalars['Boolean']['output']>;
    scheduled?: Maybe<ScheduledMessageQlConnection>;
    smsChannel?: Maybe<BaseChannel>;
    smsPhonelines?: Maybe<PhoneLineQlConnection>;
    supportsVoicemail?: Maybe<Scalars['Boolean']['output']>;
    team?: Maybe<TeamQl>;
    teamId?: Maybe<Scalars['String']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
  };

export type NoteChannelQlIdentityPromptAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteChannelQlMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteChannelQlOperatorSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteChannelQlOutboundConferenceCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteChannelQlOutboundProxyCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteChannelQlPhonecallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteChannelQlScheduledArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteChannelQlSmsPhonelinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerConnection = {
  __typename?: 'NoteTakerConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NoteTakerEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `NoteTaker` and its cursor. */
export type NoteTakerEdge = {
  __typename?: 'NoteTakerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NoteTakerQl>;
};

export type NoteTakerModelFilter = {
  createdOn?: InputMaybe<ArrowFieldFilter>;
  id?: InputMaybe<StringFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  name?: InputMaybe<StringFilter>;
  placeId?: InputMaybe<StringFilter>;
  settings?: InputMaybe<JsonStringFilter>;
};

export enum NoteTakerModelSortEnum {
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  PlaceIdAsc = 'place_id_asc',
  PlaceIdDesc = 'place_id_desc',
  SettingsAsc = 'settings_asc',
  SettingsDesc = 'settings_desc',
}

export type NoteTakerQl = BaseQl &
  Node & {
    __typename?: 'NoteTakerQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    settings: Scalars['JSONString']['output'];
  };

export type NoteTakerQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerQlConnection = {
  __typename?: 'NoteTakerQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NoteTakerQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `NoteTakerQL` and its cursor. */
export type NoteTakerQlEdge = {
  __typename?: 'NoteTakerQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NoteTakerQl>;
};

export type NoteTakerStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'NoteTakerStepQL';
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureStepId?: Maybe<Scalars['String']['output']>;
    failureStepRelationship?: Maybe<VoiceScriptStepQl>;
    finishedSpeech: Scalars['String']['output'];
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextStepId?: Maybe<Scalars['String']['output']>;
    nextStepRelationship?: Maybe<VoiceScriptStepQl>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTaker?: Maybe<NoteTakerQl>;
    noteTakerId?: Maybe<Scalars['String']['output']>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type NoteTakerStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type NoteTakerStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type NoteTakerStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteTakerStepQlConnection = {
  __typename?: 'NoteTakerStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NoteTakerStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `NoteTakerStepQL` and its cursor. */
export type NoteTakerStepQlEdge = {
  __typename?: 'NoteTakerStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NoteTakerStepQl>;
};

export type NotificationSettingsInput = {
  assignmentClaimSetting?: InputMaybe<AssignmentClaimInput>;
  browserNotificationSetting?: InputMaybe<PushNotificationSettingsInput>;
  emailNotificationSetting?: InputMaybe<EmailNotificationSettingsInput>;
  pushNotificationSetting?: InputMaybe<PushNotificationSettingsInput>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotifyTeamMemberActionQl = AutomationAction &
  Node & {
    __typename?: 'NotifyTeamMemberActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    desiredConversationState?: Maybe<DesiredConversationState>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messageToSend?: Maybe<Scalars['String']['output']>;
    nextActionId?: Maybe<Scalars['String']['output']>;
    notifyOwner: Scalars['Boolean']['output'];
    teamIdsMentioned: Array<Scalars['String']['output']>;
    uiHints?: Maybe<AutomationUiHints>;
    userIdsMentioned: Array<Scalars['String']['output']>;
  };

export type NumaServiceQl = BaseQl &
  Node & {
    __typename?: 'NumaServiceQL';
    createdOn: Scalars['ArrowField']['output'];
    description: Scalars['String']['output'];
    howIsHandled?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    manualCodeSelection?: Maybe<Scalars['Boolean']['output']>;
    name: Scalars['String']['output'];
  };

export type NumboxAgentSessionQl = BaseQl &
  Node & {
    __typename?: 'NumboxAgentSessionQL';
    appointment?: Maybe<AppointmentQl>;
    appointmentId?: Maybe<Scalars['String']['output']>;
    conversationalSchedulingAgentStep?: Maybe<ConversationalSchedulingAgentStepQl>;
    conversationalSchedulingAgentStepId?: Maybe<Scalars['String']['output']>;
    covalRunId?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    endTime?: Maybe<Scalars['ArrowField']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messages?: Maybe<MessageQlConnection>;
    operatorSession?: Maybe<OperatorSessionQl>;
    operatorSessionId?: Maybe<Scalars['String']['output']>;
    outcome?: Maybe<SessionOutcome>;
    phonecall?: Maybe<PhoneCallQl>;
    phonecallId: Scalars['String']['output'];
    sessionRecording?: Maybe<CallRecordingQl>;
    sessionRecordingId?: Maybe<Scalars['String']['output']>;
    slots: Scalars['JSONString']['output'];
    startTime?: Maybe<Scalars['ArrowField']['output']>;
    summary?: Maybe<Scalars['String']['output']>;
    taskId?: Maybe<Scalars['String']['output']>;
  };

export type NumboxAgentSessionQlMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NumboxAgentSessionQlConnection = {
  __typename?: 'NumboxAgentSessionQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NumboxAgentSessionQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `NumboxAgentSessionQL` and its cursor. */
export type NumboxAgentSessionQlEdge = {
  __typename?: 'NumboxAgentSessionQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NumboxAgentSessionQl>;
};

export type NumboxChannelQl = Channel &
  Node & {
    __typename?: 'NumboxChannelQL';
    Assignee?: Maybe<UserQl>;
    AssigneeId?: Maybe<Scalars['String']['output']>;
    RespectExistingAssignments?: Maybe<Scalars['Boolean']['output']>;
    Team?: Maybe<TeamQl>;
    TeamId?: Maybe<Scalars['String']['output']>;
    account: AccountQl;
    accountId: Scalars['String']['output'];
    assignTextReplies?: Maybe<Scalars['String']['output']>;
    assignee?: Maybe<UserQl>;
    assigneeId?: Maybe<Scalars['String']['output']>;
    channelType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    identityPromptAddresses?: Maybe<IdentityPromptAddressQlConnection>;
    identityPromptOption: IdentityPromptOptions;
    isActive: Scalars['Boolean']['output'];
    isBotEnabled: Scalars['Boolean']['output'];
    isNryChannel?: Maybe<Scalars['Boolean']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messages?: Maybe<MessageQlConnection>;
    name?: Maybe<Scalars['String']['output']>;
    operator?: Maybe<OperatorQl>;
    operatorId?: Maybe<Scalars['String']['output']>;
    operatorSessions?: Maybe<OperatorSessionQlConnection>;
    outboundConferenceCall?: Maybe<OutboundConferenceCallQlConnection>;
    outboundProxyCall?: Maybe<OutboundProxyCallQlConnection>;
    phonecalls?: Maybe<PhoneCallQlConnection>;
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    respectExistingAssignments?: Maybe<Scalars['Boolean']['output']>;
    scheduled?: Maybe<ScheduledMessageQlConnection>;
    smsChannel?: Maybe<BaseChannel>;
    smsPhonelines?: Maybe<PhoneLineQlConnection>;
    supportsVoicemail?: Maybe<Scalars['Boolean']['output']>;
    team?: Maybe<TeamQl>;
    teamId?: Maybe<Scalars['String']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
  };

export type NumboxChannelQlIdentityPromptAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NumboxChannelQlMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NumboxChannelQlOperatorSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NumboxChannelQlOutboundConferenceCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NumboxChannelQlOutboundProxyCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NumboxChannelQlPhonecallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NumboxChannelQlScheduledArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type NumboxChannelQlSmsPhonelinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Objection = {
  __typename?: 'Objection';
  objection: Scalars['String']['output'];
  resolution: Array<Maybe<ResolutionStep>>;
};

export type OpCodeInput = {
  correctionCode?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  dmsId: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Float']['input']>;
  flatCostRate?: InputMaybe<Scalars['Float']['input']>;
  flatHours?: InputMaybe<Scalars['Float']['input']>;
  flatSellRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  rawData?: InputMaybe<Scalars['String']['input']>;
};

export type OpCodeQl = BaseQl &
  Node & {
    __typename?: 'OpCodeQL';
    activeIntegration: ActiveIntegrationQl;
    activeIntegrationId: Scalars['String']['output'];
    correctionCode?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    description: Scalars['String']['output'];
    dmsId: Scalars['String']['output'];
    duration?: Maybe<Scalars['Float']['output']>;
    flatCostRate?: Maybe<Scalars['Float']['output']>;
    flatHours?: Maybe<Scalars['Float']['output']>;
    flatSellRate?: Maybe<Scalars['Float']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    rawData?: Maybe<Scalars['String']['output']>;
    repairServices?: Maybe<RepairServiceQlConnection>;
    supportedVehiclesOpcodes?: Maybe<SupportedVehiclesOpcodesQlConnection>;
    xtimeLogs?: Maybe<XTimeLogModelQlConnection>;
  };

export type OpCodeQlRepairServicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OpCodeQlSupportedVehiclesOpcodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OpCodeQlXtimeLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OpCodeQlConnection = {
  __typename?: 'OpCodeQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OpCodeQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OpCodeQL` and its cursor. */
export type OpCodeQlEdge = {
  __typename?: 'OpCodeQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OpCodeQl>;
};

export type OpCodesFilter = {
  __typename?: 'OpCodesFilter';
  category: OpCodesFilterInput;
  code: Scalars['String']['output'];
};

export enum OpCodesFilterInput {
  Any = 'any',
  Fee = 'fee',
  Lbr = 'lbr',
  Mls = 'mls',
  Vis = 'vis',
}

export type OpcodeInputQl = {
  dmsId?: InputMaybe<Scalars['String']['input']>;
  serviceName?: InputMaybe<Scalars['String']['input']>;
};

export type OpcodeOutputQl = {
  __typename?: 'OpcodeOutputQL';
  dmsId?: Maybe<Scalars['String']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
};

export type OpcodesFilterInput = {
  category: OpcodesTypes;
  code: Scalars['String']['input'];
};

export enum OpcodesTypes {
  Any = 'any',
  Fee = 'fee',
  Lbr = 'lbr',
  Mls = 'mls',
  Vis = 'vis',
}

export type OpenVoiceQuestionAttachment = Attachment &
  Node & {
    __typename?: 'OpenVoiceQuestionAttachment';
    attachmentType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    filename: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    message?: Maybe<MessageQl>;
    messageId?: Maybe<Scalars['String']['output']>;
    primaryMimetype?: Maybe<Scalars['String']['output']>;
    shorthandPrompt: Scalars['String']['output'];
    sizeBytes: Scalars['String']['output'];
    url: Scalars['String']['output'];
    words?: Maybe<Scalars['JSONString']['output']>;
  };

export type OperatorAgentStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'OperatorAgentStepQL';
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextStepId?: Maybe<Scalars['String']['output']>;
    nextStepRelationship?: Maybe<VoiceScriptStepQl>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operator?: Maybe<OperatorQl>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    operatorId?: Maybe<Scalars['String']['output']>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type OperatorAgentStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type OperatorAgentStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type OperatorAgentStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAgentStepQlConnection = {
  __typename?: 'OperatorAgentStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OperatorAgentStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OperatorAgentStepQL` and its cursor. */
export type OperatorAgentStepQlEdge = {
  __typename?: 'OperatorAgentStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OperatorAgentStepQl>;
};

export type OperatorChannelQl = BaseQl &
  Node & {
    __typename?: 'OperatorChannelQL';
    channel: Channel;
    channelId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    description?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    operator: OperatorQl;
    operatorId: Scalars['String']['output'];
    settings: Scalars['JSONString']['output'];
  };

export type OperatorPlaceQl = BaseQl &
  Node & {
    __typename?: 'OperatorPlaceQL';
    createdOn: Scalars['ArrowField']['output'];
    description?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    operator: OperatorQl;
    operatorId: Scalars['String']['output'];
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    settings: Scalars['JSONString']['output'];
  };

export type OperatorQl = BaseQl &
  Node & {
    __typename?: 'OperatorQL';
    account: AccountQl;
    accountId: Scalars['String']['output'];
    channels: Array<Channel>;
    createdOn: Scalars['ArrowField']['output'];
    dealershipInfoBlob: Scalars['JSONString']['output'];
    faq?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
    operatorFaq: Scalars['JSONString']['output'];
    operatorSessions: Array<OperatorSessionQl>;
    operatorSettings?: Maybe<OperatorSettingsQl>;
    operatorSettingsId?: Maybe<Scalars['String']['output']>;
    places: Array<PlaceQl>;
    spokenGreetingName?: Maybe<Scalars['String']['output']>;
  };

export type OperatorQlConnection = {
  __typename?: 'OperatorQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OperatorQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OperatorQL` and its cursor. */
export type OperatorQlEdge = {
  __typename?: 'OperatorQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OperatorQl>;
};

export type OperatorSessionConnection = {
  __typename?: 'OperatorSessionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OperatorSessionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `OperatorSession` and its cursor. */
export type OperatorSessionEdge = {
  __typename?: 'OperatorSessionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OperatorSessionQl>;
};

export type OperatorSessionModelFilter = {
  callDuration?: InputMaybe<IntFilter>;
  callRecordingId?: InputMaybe<StringFilter>;
  callSid?: InputMaybe<StringFilter>;
  channelId?: InputMaybe<StringFilter>;
  covalRunId?: InputMaybe<StringFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  endTime?: InputMaybe<ArrowFieldFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  operatorId?: InputMaybe<StringFilter>;
  operatorTranscriptId?: InputMaybe<StringFilter>;
  outcome?: InputMaybe<StringFilter>;
  participantId?: InputMaybe<StringFilter>;
  phonecallId?: InputMaybe<StringFilter>;
  slots?: InputMaybe<JsonStringFilter>;
  startTime?: InputMaybe<ArrowFieldFilter>;
  summary?: InputMaybe<StringFilter>;
  transferredToMdn?: InputMaybe<StringFilter>;
  transferredToName?: InputMaybe<StringFilter>;
};

export enum OperatorSessionModelSortEnum {
  CallDurationAsc = 'call_duration_asc',
  CallDurationDesc = 'call_duration_desc',
  CallRecordingIdAsc = 'call_recording_id_asc',
  CallRecordingIdDesc = 'call_recording_id_desc',
  CallSidAsc = 'call_sid_asc',
  CallSidDesc = 'call_sid_desc',
  ChannelIdAsc = 'channel_id_asc',
  ChannelIdDesc = 'channel_id_desc',
  CovalRunIdAsc = 'coval_run_id_asc',
  CovalRunIdDesc = 'coval_run_id_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  EndTimeAsc = 'end_time_asc',
  EndTimeDesc = 'end_time_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IsActiveAsc = 'is_active_asc',
  IsActiveDesc = 'is_active_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  OperatorIdAsc = 'operator_id_asc',
  OperatorIdDesc = 'operator_id_desc',
  OperatorTranscriptIdAsc = 'operator_transcript_id_asc',
  OperatorTranscriptIdDesc = 'operator_transcript_id_desc',
  OutcomeAsc = 'outcome_asc',
  OutcomeDesc = 'outcome_desc',
  ParticipantIdAsc = 'participant_id_asc',
  ParticipantIdDesc = 'participant_id_desc',
  PhonecallIdAsc = 'phonecall_id_asc',
  PhonecallIdDesc = 'phonecall_id_desc',
  SlotsAsc = 'slots_asc',
  SlotsDesc = 'slots_desc',
  StartTimeAsc = 'start_time_asc',
  StartTimeDesc = 'start_time_desc',
  SummaryAsc = 'summary_asc',
  SummaryDesc = 'summary_desc',
  TransferredToMdnAsc = 'transferred_to_mdn_asc',
  TransferredToMdnDesc = 'transferred_to_mdn_desc',
  TransferredToNameAsc = 'transferred_to_name_asc',
  TransferredToNameDesc = 'transferred_to_name_desc',
}

export enum OperatorSessionOutcome {
  Handled = 'HANDLED',
  Hangup = 'HANGUP',
  Human = 'HUMAN',
  NeedsFollowUp = 'NEEDS_FOLLOW_UP',
}

export type OperatorSessionQl = BaseQl &
  Node & {
    __typename?: 'OperatorSessionQL';
    callDuration?: Maybe<Scalars['Int']['output']>;
    callRecording?: Maybe<CallRecordingQl>;
    callRecordingId?: Maybe<Scalars['String']['output']>;
    callSid: Scalars['String']['output'];
    channel?: Maybe<BaseChannel>;
    channelId: Scalars['String']['output'];
    covalRunId?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    endTime?: Maybe<Scalars['ArrowField']['output']>;
    id: Scalars['ID']['output'];
    isActive?: Maybe<Scalars['Boolean']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    numboxAgentSessions?: Maybe<NumboxAgentSessionQlConnection>;
    operator?: Maybe<OperatorQl>;
    operatorId: Scalars['String']['output'];
    operatorTranscript?: Maybe<OperatorTranscriptQl>;
    operatorTranscriptId?: Maybe<Scalars['String']['output']>;
    outcome?: Maybe<OperatorSessionOutcome>;
    participant?: Maybe<ParticipantQl>;
    participantId?: Maybe<Scalars['String']['output']>;
    phonecall?: Maybe<PhoneCallQl>;
    phonecallId?: Maybe<Scalars['String']['output']>;
    slots?: Maybe<Scalars['JSONString']['output']>;
    startTime?: Maybe<Scalars['ArrowField']['output']>;
    summary?: Maybe<Scalars['String']['output']>;
    transferredToMdn?: Maybe<Scalars['String']['output']>;
    transferredToName?: Maybe<Scalars['String']['output']>;
  };

export type OperatorSessionQlNumboxAgentSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorSessionQlConnection = {
  __typename?: 'OperatorSessionQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OperatorSessionQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OperatorSessionQL` and its cursor. */
export type OperatorSessionQlEdge = {
  __typename?: 'OperatorSessionQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OperatorSessionQl>;
};

export type OperatorSettingsQl = BaseQl &
  Node & {
    __typename?: 'OperatorSettingsQL';
    appointmentAgentSettings?: Maybe<AppointmentAgentSettingsQl>;
    appointmentAgentSettingsId?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    enableEvaluation: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    operator: OperatorQl;
    settings: Scalars['JSONString']['output'];
    voiceId?: Maybe<Scalars['String']['output']>;
    voiceProvider?: Maybe<Scalars['String']['output']>;
  };

export type OperatorTranscriptQl = BaseQl &
  Node & {
    __typename?: 'OperatorTranscriptQL';
    createdOn: Scalars['ArrowField']['output'];
    events: Array<TranscriptEventQl>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    operatorSession?: Maybe<OperatorSessionQl>;
  };

export enum OperatorType {
  And = 'and_',
  Or = 'or_',
}

export type OpportunityInfo = {
  __typename?: 'OpportunityInfo';
  closeReason?: Maybe<EquityTradeOpportunityCloseReason>;
  createIfNotExists?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<EquityTradeOpportunityStage>;
  type: OpportunityType;
};

export type OpportunityInfoInput = {
  closeReason?: InputMaybe<Scalars['String']['input']>;
  createIfNotExists?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type OpportunityServiceAppointmentConfirmationTriggerQl =
  AutomationTrigger &
    Node & {
      __typename?: 'OpportunityServiceAppointmentConfirmationTriggerQL';
      createdOn: Scalars['ArrowField']['output'];
      id: Scalars['ID']['output'];
      lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
      triggerType: Scalars['String']['output'];
      uiHints?: Maybe<AutomationUiHints>;
    };

export type OpportunityServiceAppointmentReminderTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'OpportunityServiceAppointmentReminderTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
  };

export enum OpportunityType {
  EquityTrade = 'EQUITY_TRADE',
}

export enum OrderIdTypeInput {
  Custom = 'CUSTOM',
  CustomerName = 'CUSTOMER_NAME',
  OrderNumber = 'ORDER_NUMBER',
}

export type OrderQl = {
  __typename?: 'OrderQL';
  status?: Maybe<Scalars['String']['output']>;
};

export type OutboundCallCustomizationQl = BaseQl &
  Node & {
    __typename?: 'OutboundCallCustomizationQL';
    createdOn: Scalars['ArrowField']['output'];
    customAudioOverrides: CustomOutboundCallAudioOverrides;
    disclosureSpeech: Scalars['String']['output'];
    disclosureSpeechUrl: Scalars['String']['output'];
    hostNoAnswerSpeech: Scalars['String']['output'];
    hostNoAnswerSpeechUrl: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    leaveVoicemail: Scalars['Boolean']['output'];
    outboundConferenceCalls?: Maybe<OutboundConferenceCallQlConnection>;
    renderedDisclosureSpeech: Scalars['String']['output'];
    renderedHostNoAnswerSpeech: Scalars['String']['output'];
    renderedVoicemailSpeech: Scalars['String']['output'];
    user: UserQl;
    userId: Scalars['String']['output'];
    voice: Scalars['String']['output'];
    voicemailSpeech: Scalars['String']['output'];
    voicemailSpeechUrl: Scalars['String']['output'];
  };

export type OutboundCallCustomizationQlOutboundConferenceCallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OutboundCallCustomizationQlConnection = {
  __typename?: 'OutboundCallCustomizationQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OutboundCallCustomizationQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OutboundCallCustomizationQL` and its cursor. */
export type OutboundCallCustomizationQlEdge = {
  __typename?: 'OutboundCallCustomizationQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OutboundCallCustomizationQl>;
};

export type OutboundCallSettingQl = {
  __typename?: 'OutboundCallSettingQL';
  id: Scalars['String']['output'];
  mdn?: Maybe<Scalars['String']['output']>;
};

export type OutboundConferenceCallQl = BaseQl &
  Node & {
    __typename?: 'OutboundConferenceCallQL';
    amdAnsweredBy?: Maybe<Scalars['String']['output']>;
    amdDurationMs?: Maybe<Scalars['Int']['output']>;
    answeredByVoicemail?: Maybe<Scalars['Boolean']['output']>;
    callDuration?: Maybe<Scalars['Int']['output']>;
    callRecording?: Maybe<CallRecordingQl>;
    callRecordingId?: Maybe<Scalars['String']['output']>;
    callSid?: Maybe<Scalars['String']['output']>;
    callStatus?: Maybe<Scalars['String']['output']>;
    caller: UserQl;
    callerId: Scalars['String']['output'];
    channel: TwilioChannelQl;
    channelId: Scalars['String']['output'];
    conversation: ConversationQl;
    conversationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    endTime?: Maybe<Scalars['ArrowField']['output']>;
    hasCallAssist: Scalars['Boolean']['output'];
    hostConnectedTo?: Maybe<Scalars['String']['output']>;
    hostMdn: Scalars['String']['output'];
    hostSipAddress?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    isBeingRecorded: Scalars['Boolean']['output'];
    isCallIntelligenceEligible?: Maybe<Scalars['Boolean']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    leaveVoicemail: Scalars['Boolean']['output'];
    message?: Maybe<MessageQl>;
    messageId?: Maybe<Scalars['String']['output']>;
    outboundCallCustomization?: Maybe<OutboundCallCustomizationQl>;
    outboundCallCustomizationId?: Maybe<Scalars['String']['output']>;
    outboundCallSid?: Maybe<Scalars['String']['output']>;
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    recipientDisplayName: Scalars['String']['output'];
    recipientMdn: Scalars['String']['output'];
    startTime?: Maybe<Scalars['ArrowField']['output']>;
    transcript?: Maybe<TranscriptQl>;
    transcriptId?: Maybe<Scalars['String']['output']>;
    userDevice?: Maybe<UserPhoneQl>;
    userDeviceId?: Maybe<Scalars['String']['output']>;
  };

export type OutboundConferenceCallQlConnection = {
  __typename?: 'OutboundConferenceCallQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OutboundConferenceCallQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OutboundConferenceCallQL` and its cursor. */
export type OutboundConferenceCallQlEdge = {
  __typename?: 'OutboundConferenceCallQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OutboundConferenceCallQl>;
};

export type OutboundProxyCallQl = BaseQl &
  Node & {
    __typename?: 'OutboundProxyCallQL';
    callDuration?: Maybe<Scalars['Int']['output']>;
    callRecording?: Maybe<CallRecordingQl>;
    callRecordingId?: Maybe<Scalars['String']['output']>;
    callSid?: Maybe<Scalars['String']['output']>;
    callStatus?: Maybe<Scalars['String']['output']>;
    caller: UserQl;
    callerId: Scalars['String']['output'];
    channel: TwilioChannelQl;
    channelId: Scalars['String']['output'];
    conversation: ConversationQl;
    conversationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    endtime?: Maybe<Scalars['ArrowField']['output']>;
    id: Scalars['ID']['output'];
    isBeingRecorded: Scalars['Boolean']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    mdnWithCode: Scalars['String']['output'];
    message?: Maybe<MessageQl>;
    messageId?: Maybe<Scalars['String']['output']>;
    outboundCallSid?: Maybe<Scalars['String']['output']>;
    outboundProxyNumber: OutboundProxyTwilioNumberQl;
    outboundProxyNumberId: Scalars['String']['output'];
    pinCode: Scalars['String']['output'];
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    recipientMdn: Scalars['String']['output'];
    startTime?: Maybe<Scalars['ArrowField']['output']>;
    transcript?: Maybe<TranscriptQl>;
    transcriptId?: Maybe<Scalars['String']['output']>;
  };

export type OutboundProxyCallQlConnection = {
  __typename?: 'OutboundProxyCallQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OutboundProxyCallQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OutboundProxyCallQL` and its cursor. */
export type OutboundProxyCallQlEdge = {
  __typename?: 'OutboundProxyCallQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OutboundProxyCallQl>;
};

export enum OutboundProxyCarrierType {
  Twilio = 'TWILIO',
}

export type OutboundProxyNumber = {
  carrierType?: Maybe<OutboundProxyCarrierType>;
  createdOn: Scalars['ArrowField']['output'];
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OutboundProxyTwilioNumberQl = Node &
  OutboundProxyNumber & {
    __typename?: 'OutboundProxyTwilioNumberQL';
    accountSid: Scalars['String']['output'];
    apiKey?: Maybe<Scalars['String']['output']>;
    carrierType?: Maybe<OutboundProxyCarrierType>;
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    mdn: Scalars['String']['output'];
    name?: Maybe<Scalars['String']['output']>;
    sid?: Maybe<Scalars['String']['output']>;
    token: Scalars['String']['output'];
  };

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaletteQl = {
  __typename?: 'PaletteQL';
  bodyBackgroundColor: Scalars['String']['output'];
  bodyBorderColor: Scalars['String']['output'];
  bodyTextColor: Scalars['String']['output'];
  buttonPrimaryBackgroundColor: Scalars['String']['output'];
  buttonPrimaryBorderColor: Scalars['String']['output'];
  buttonPrimaryTextColor: Scalars['String']['output'];
  buttonSecondaryBackgroundColor: Scalars['String']['output'];
  buttonSecondaryBorderColor: Scalars['String']['output'];
  buttonSecondaryTextColor: Scalars['String']['output'];
  headerBackgroundColor: Scalars['String']['output'];
  headerBorderColor: Scalars['String']['output'];
  headerTextColor: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ParticipantConnection = {
  __typename?: 'ParticipantConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ParticipantEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export enum ParticipantDataConfidence {
  High = 'HIGH',
  Low = 'LOW',
}

/** A Relay edge containing a `Participant` and its cursor. */
export type ParticipantEdge = {
  __typename?: 'ParticipantEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ParticipantQl>;
};

export type ParticipantInput = {
  address: Scalars['String']['input'];
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  piplData?: InputMaybe<Scalars['JSONString']['input']>;
  source: Scalars['String']['input'];
};

export type ParticipantModelFilter = {
  accountId?: InputMaybe<StringFilter>;
  address?: InputMaybe<StringFilter>;
  avatarUrl?: InputMaybe<StringFilter>;
  comment?: InputMaybe<StringFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  customerId?: InputMaybe<StringFilter>;
  deliveryAddress?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isEmployee?: InputMaybe<BooleanFilter>;
  language?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  lastNomoroboDate?: InputMaybe<ArrowFieldFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  nomoroboScore?: InputMaybe<IntFilter>;
  piplData?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  spamStatus?: InputMaybe<StringFilter>;
};

export enum ParticipantModelSortEnum {
  AccountIdAsc = 'account_id_asc',
  AccountIdDesc = 'account_id_desc',
  AddressAsc = 'address_asc',
  AddressDesc = 'address_desc',
  AvatarUrlAsc = 'avatar_url_asc',
  AvatarUrlDesc = 'avatar_url_desc',
  CommentAsc = 'comment_asc',
  CommentDesc = 'comment_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  CustomerIdAsc = 'customer_id_asc',
  CustomerIdDesc = 'customer_id_desc',
  DeliveryAddressAsc = 'delivery_address_asc',
  DeliveryAddressDesc = 'delivery_address_desc',
  FirstNameAsc = 'first_name_asc',
  FirstNameDesc = 'first_name_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IsEmployeeAsc = 'is_employee_asc',
  IsEmployeeDesc = 'is_employee_desc',
  LanguageAsc = 'language_asc',
  LanguageDesc = 'language_desc',
  LastNameAsc = 'last_name_asc',
  LastNameDesc = 'last_name_desc',
  LastNomoroboDateAsc = 'last_nomorobo_date_asc',
  LastNomoroboDateDesc = 'last_nomorobo_date_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  NomoroboScoreAsc = 'nomorobo_score_asc',
  NomoroboScoreDesc = 'nomorobo_score_desc',
  PiplDataAsc = 'pipl_data_asc',
  PiplDataDesc = 'pipl_data_desc',
  SourceAsc = 'source_asc',
  SourceDesc = 'source_desc',
  SpamStatusAsc = 'spam_status_asc',
  SpamStatusDesc = 'spam_status_desc',
}

export type ParticipantQl = BaseQl &
  Node & {
    __typename?: 'ParticipantQL';
    account?: Maybe<AccountQl>;
    accountId: Scalars['String']['output'];
    address: Scalars['String']['output'];
    appointments?: Maybe<AppointmentQlConnection>;
    avatarUrl?: Maybe<Scalars['String']['output']>;
    canceledByPaymentRequests?: Maybe<PaymentRequestQlConnection>;
    cdkContact?: Maybe<CrmContactCdkQl>;
    chargedByPaymentRequests?: Maybe<PaymentRequestQlConnection>;
    closedEquityTradeOpportunities?: Maybe<EquityTradeOpportunityQlConnection>;
    cnamContact?: Maybe<CrmContactCnamQl>;
    comment?: Maybe<Scalars['String']['output']>;
    completedTasks?: Maybe<Array<Maybe<TaskQl>>>;
    conversationLabels?: Maybe<ConversationLabelQlConnection>;
    conversations?: Maybe<ConversationQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    createdTasks?: Maybe<Array<Maybe<TaskQl>>>;
    crmContacts?: Maybe<Array<Maybe<CrmContactQl>>>;
    customer?: Maybe<CustomerQl>;
    customerCount: Scalars['Int']['output'];
    customerId?: Maybe<Scalars['String']['output']>;
    customerPaymentRequests?: Maybe<PaymentRequestQlConnection>;
    dealerbuiltContact?: Maybe<Scalars['String']['output']>;
    dealertrackContact?: Maybe<CrmContactDealertrackQl>;
    deletedByVideoUploadLinks?: Maybe<VideoUploadLinkQlConnection>;
    deliveryAddress: Scalars['String']['output'];
    dismissedTasks?: Maybe<Array<Maybe<TaskQl>>>;
    displayName: Scalars['String']['output'];
    displayNameConfidence: ParticipantDataConfidence;
    firstName?: Maybe<Scalars['String']['output']>;
    fortellisContact?: Maybe<CrmContactFortellisQl>;
    id: Scalars['ID']['output'];
    identityPromptAddresses?: Maybe<IdentityPromptAddressQlConnection>;
    isEmployee?: Maybe<Scalars['Boolean']['output']>;
    language?: Maybe<Language>;
    lastName?: Maybe<Scalars['String']['output']>;
    lastNomoroboDate?: Maybe<Scalars['ArrowField']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    latestCustomer?: Maybe<CustomerQl>;
    nomoroboScore?: Maybe<Scalars['Int']['output']>;
    operatorSession?: Maybe<OperatorSessionQl>;
    pbsContact?: Maybe<Scalars['String']['output']>;
    phonecalls?: Maybe<PhoneCallQlConnection>;
    piplData?: Maybe<Scalars['String']['output']>;
    redirectedPhonecalls?: Maybe<PhoneCallQlConnection>;
    refunds?: Maybe<RefundQlConnection>;
    reynoldsContact?: Maybe<Scalars['String']['output']>;
    senderPaymentRequests?: Maybe<PaymentRequestQlConnection>;
    source: Source_Types;
    spamStatus: SpamStatus;
    tekionContact?: Maybe<Scalars['String']['output']>;
    uploadedVideoUploadLinks?: Maybe<VideoUploadLinkQlConnection>;
    user?: Maybe<UserQl>;
    videoUploadLinks?: Maybe<VideoUploadLinkQlConnection>;
  };

export type ParticipantQlAppointmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ParticipantQlCanceledByPaymentRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ParticipantQlChargedByPaymentRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ParticipantQlClosedEquityTradeOpportunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ParticipantQlConversationLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ParticipantQlConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ParticipantQlCustomerPaymentRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ParticipantQlDeletedByVideoUploadLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ParticipantQlIdentityPromptAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ParticipantQlPhonecallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ParticipantQlRedirectedPhonecallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ParticipantQlRefundsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ParticipantQlSenderPaymentRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ParticipantQlUploadedVideoUploadLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ParticipantQlVideoUploadLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ParticipantQlConnection = {
  __typename?: 'ParticipantQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ParticipantQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ParticipantQL` and its cursor. */
export type ParticipantQlEdge = {
  __typename?: 'ParticipantQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ParticipantQl>;
};

export enum PaymentCancellationReason {
  Abandoned = 'ABANDONED',
  Duplicate = 'DUPLICATE',
  Fraudulent = 'FRAUDULENT',
  RequestedByCustomer = 'REQUESTED_BY_CUSTOMER',
}

export type PaymentRequestConnection = {
  __typename?: 'PaymentRequestConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentRequestEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type PaymentRequestCustomizationQl = BaseQl &
  Node & {
    __typename?: 'PaymentRequestCustomizationQL';
    canceledAutoSend: Scalars['Boolean']['output'];
    canceledTemplate: Scalars['String']['output'];
    createAutoSend: Scalars['Boolean']['output'];
    createHoldAutoSend: Scalars['Boolean']['output'];
    createHoldTemplate: Scalars['String']['output'];
    createTemplate: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    partialRefundAutoSend: Scalars['Boolean']['output'];
    partialRefundTemplate: Scalars['String']['output'];
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    refundAutoSend: Scalars['Boolean']['output'];
    refundTemplate: Scalars['String']['output'];
    renderedCanceledTemplate: Scalars['String']['output'];
    renderedCreateHoldTemplate: Scalars['String']['output'];
    renderedCreateTemplate: Scalars['String']['output'];
    renderedPartialRefundTemplate: Scalars['String']['output'];
    renderedRefundTemplate: Scalars['String']['output'];
    renderedSuccessTemplate: Scalars['String']['output'];
    successAutoSend: Scalars['Boolean']['output'];
    successTemplate: Scalars['String']['output'];
  };

/** A Relay edge containing a `PaymentRequest` and its cursor. */
export type PaymentRequestEdge = {
  __typename?: 'PaymentRequestEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PaymentRequestQl>;
};

export type PaymentRequestModelFilter = {
  amount?: InputMaybe<IntFilter>;
  amountCaptured?: InputMaybe<IntFilter>;
  applicationId?: InputMaybe<StringFilter>;
  attachmentFilename?: InputMaybe<StringFilter>;
  attachmentUrl?: InputMaybe<StringFilter>;
  billingAddressObject?: InputMaybe<JsonStringFilter>;
  billingEmail?: InputMaybe<StringFilter>;
  billingLastFourDigits?: InputMaybe<StringFilter>;
  billingMethod?: InputMaybe<StringFilter>;
  billingName?: InputMaybe<StringFilter>;
  canceledAt?: InputMaybe<ArrowFieldFilter>;
  canceledById?: InputMaybe<StringFilter>;
  cancellationReason?: InputMaybe<StringFilter>;
  captureMethod?: InputMaybe<StringFilter>;
  charged?: InputMaybe<ArrowFieldFilter>;
  chargedById?: InputMaybe<StringFilter>;
  clientSecret?: InputMaybe<StringFilter>;
  conversationId?: InputMaybe<StringFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  currency?: InputMaybe<StringFilter>;
  customerId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  externalId?: InputMaybe<IntFilter>;
  failureCode?: InputMaybe<StringFilter>;
  failureMessage?: InputMaybe<StringFilter>;
  holdApproved?: InputMaybe<ArrowFieldFilter>;
  holdExpiration?: InputMaybe<ArrowFieldFilter>;
  id?: InputMaybe<StringFilter>;
  lastOpened?: InputMaybe<ArrowFieldFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  note?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringFilter>;
  outcomeReason?: InputMaybe<StringFilter>;
  outcomeSellerMessage?: InputMaybe<StringFilter>;
  outcomeType?: InputMaybe<StringFilter>;
  paymentIntentId?: InputMaybe<StringFilter>;
  paymentIntentObject?: InputMaybe<JsonStringFilter>;
  paymentIntentStatus?: InputMaybe<StringFilter>;
  placeId?: InputMaybe<StringFilter>;
  receiptUrl?: InputMaybe<StringFilter>;
  requested?: InputMaybe<ArrowFieldFilter>;
  senderId?: InputMaybe<StringFilter>;
  sessionId?: InputMaybe<StringFilter>;
  sessionObject?: InputMaybe<JsonStringFilter>;
  status?: InputMaybe<StringFilter>;
  stripeIntegrationId?: InputMaybe<StringFilter>;
};

export enum PaymentRequestModelSortEnum {
  AmountAsc = 'amount_asc',
  AmountCapturedAsc = 'amount_captured_asc',
  AmountCapturedDesc = 'amount_captured_desc',
  AmountDesc = 'amount_desc',
  ApplicationIdAsc = 'application_id_asc',
  ApplicationIdDesc = 'application_id_desc',
  AttachmentFilenameAsc = 'attachment_filename_asc',
  AttachmentFilenameDesc = 'attachment_filename_desc',
  AttachmentUrlAsc = 'attachment_url_asc',
  AttachmentUrlDesc = 'attachment_url_desc',
  BillingAddressObjectAsc = 'billing_address_object_asc',
  BillingAddressObjectDesc = 'billing_address_object_desc',
  BillingEmailAsc = 'billing_email_asc',
  BillingEmailDesc = 'billing_email_desc',
  BillingLastFourDigitsAsc = 'billing_last_four_digits_asc',
  BillingLastFourDigitsDesc = 'billing_last_four_digits_desc',
  BillingMethodAsc = 'billing_method_asc',
  BillingMethodDesc = 'billing_method_desc',
  BillingNameAsc = 'billing_name_asc',
  BillingNameDesc = 'billing_name_desc',
  CanceledAtAsc = 'canceled_at_asc',
  CanceledAtDesc = 'canceled_at_desc',
  CanceledByIdAsc = 'canceled_by_id_asc',
  CanceledByIdDesc = 'canceled_by_id_desc',
  CancellationReasonAsc = 'cancellation_reason_asc',
  CancellationReasonDesc = 'cancellation_reason_desc',
  CaptureMethodAsc = 'capture_method_asc',
  CaptureMethodDesc = 'capture_method_desc',
  ChargedAsc = 'charged_asc',
  ChargedByIdAsc = 'charged_by_id_asc',
  ChargedByIdDesc = 'charged_by_id_desc',
  ChargedDesc = 'charged_desc',
  ClientSecretAsc = 'client_secret_asc',
  ClientSecretDesc = 'client_secret_desc',
  ConversationIdAsc = 'conversation_id_asc',
  ConversationIdDesc = 'conversation_id_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  CurrencyAsc = 'currency_asc',
  CurrencyDesc = 'currency_desc',
  CustomerIdAsc = 'customer_id_asc',
  CustomerIdDesc = 'customer_id_desc',
  DescriptionAsc = 'description_asc',
  DescriptionDesc = 'description_desc',
  ExternalIdAsc = 'external_id_asc',
  ExternalIdDesc = 'external_id_desc',
  FailureCodeAsc = 'failure_code_asc',
  FailureCodeDesc = 'failure_code_desc',
  FailureMessageAsc = 'failure_message_asc',
  FailureMessageDesc = 'failure_message_desc',
  HoldApprovedAsc = 'hold_approved_asc',
  HoldApprovedDesc = 'hold_approved_desc',
  HoldExpirationAsc = 'hold_expiration_asc',
  HoldExpirationDesc = 'hold_expiration_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  LastOpenedAsc = 'last_opened_asc',
  LastOpenedDesc = 'last_opened_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  NoteAsc = 'note_asc',
  NoteDesc = 'note_desc',
  OrderIdAsc = 'order_id_asc',
  OrderIdDesc = 'order_id_desc',
  OutcomeReasonAsc = 'outcome_reason_asc',
  OutcomeReasonDesc = 'outcome_reason_desc',
  OutcomeSellerMessageAsc = 'outcome_seller_message_asc',
  OutcomeSellerMessageDesc = 'outcome_seller_message_desc',
  OutcomeTypeAsc = 'outcome_type_asc',
  OutcomeTypeDesc = 'outcome_type_desc',
  PaymentIntentIdAsc = 'payment_intent_id_asc',
  PaymentIntentIdDesc = 'payment_intent_id_desc',
  PaymentIntentObjectAsc = 'payment_intent_object_asc',
  PaymentIntentObjectDesc = 'payment_intent_object_desc',
  PaymentIntentStatusAsc = 'payment_intent_status_asc',
  PaymentIntentStatusDesc = 'payment_intent_status_desc',
  PlaceIdAsc = 'place_id_asc',
  PlaceIdDesc = 'place_id_desc',
  ReceiptUrlAsc = 'receipt_url_asc',
  ReceiptUrlDesc = 'receipt_url_desc',
  RequestedAsc = 'requested_asc',
  RequestedDesc = 'requested_desc',
  SenderIdAsc = 'sender_id_asc',
  SenderIdDesc = 'sender_id_desc',
  SessionIdAsc = 'session_id_asc',
  SessionIdDesc = 'session_id_desc',
  SessionObjectAsc = 'session_object_asc',
  SessionObjectDesc = 'session_object_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc',
  StripeIntegrationIdAsc = 'stripe_integration_id_asc',
  StripeIntegrationIdDesc = 'stripe_integration_id_desc',
}

export type PaymentRequestQl = BaseQl &
  Node & {
    __typename?: 'PaymentRequestQL';
    amount: Scalars['Int']['output'];
    amountCaptured: Scalars['Int']['output'];
    applicationId?: Maybe<Scalars['String']['output']>;
    attachmentFilename?: Maybe<Scalars['String']['output']>;
    attachmentUrl?: Maybe<Scalars['String']['output']>;
    billingAddress?: Maybe<Scalars['String']['output']>;
    billingAddressObject?: Maybe<Scalars['JSONString']['output']>;
    billingEmail?: Maybe<Scalars['String']['output']>;
    billingLastFourDigits?: Maybe<Scalars['String']['output']>;
    billingMethod?: Maybe<Scalars['String']['output']>;
    billingName?: Maybe<Scalars['String']['output']>;
    canceledAt?: Maybe<Scalars['ArrowField']['output']>;
    canceledBy?: Maybe<ParticipantQl>;
    canceledById?: Maybe<Scalars['String']['output']>;
    cancellationReason?: Maybe<PaymentCancellationReason>;
    captureMethod: Scalars['String']['output'];
    charged?: Maybe<Scalars['ArrowField']['output']>;
    chargedBy?: Maybe<ParticipantQl>;
    chargedById?: Maybe<Scalars['String']['output']>;
    clientSecret?: Maybe<Scalars['String']['output']>;
    conversation?: Maybe<ConversationQl>;
    conversationId?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    currency?: Maybe<Currency>;
    customer: ParticipantQl;
    customerId: Scalars['String']['output'];
    description?: Maybe<Scalars['String']['output']>;
    disputes?: Maybe<Array<DisputeQl>>;
    encodedId: Scalars['String']['output'];
    externalId?: Maybe<Scalars['Int']['output']>;
    failureCode?: Maybe<Scalars['String']['output']>;
    failureMessage?: Maybe<Scalars['String']['output']>;
    holdApproved?: Maybe<Scalars['ArrowField']['output']>;
    holdExpiration?: Maybe<Scalars['ArrowField']['output']>;
    id: Scalars['ID']['output'];
    lastOpened?: Maybe<Scalars['ArrowField']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messages?: Maybe<MessageQlConnection>;
    netAmount: Scalars['Int']['output'];
    note?: Maybe<Scalars['String']['output']>;
    orderId?: Maybe<Scalars['String']['output']>;
    outcomeReason?: Maybe<Scalars['String']['output']>;
    outcomeSellerMessage?: Maybe<Scalars['String']['output']>;
    outcomeType?: Maybe<Scalars['String']['output']>;
    paymentIntentId?: Maybe<Scalars['String']['output']>;
    paymentIntentObject?: Maybe<Scalars['JSONString']['output']>;
    paymentIntentStatus?: Maybe<Scalars['String']['output']>;
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    receiptMessage?: Maybe<Scalars['String']['output']>;
    receiptUrl?: Maybe<Scalars['String']['output']>;
    refunds?: Maybe<Array<RefundQl>>;
    requested?: Maybe<Scalars['ArrowField']['output']>;
    sender: ParticipantQl;
    senderId: Scalars['String']['output'];
    sessionId?: Maybe<Scalars['String']['output']>;
    sessionObject?: Maybe<Scalars['JSONString']['output']>;
    status: PaymentRequestStatus;
    stripeIntegration?: Maybe<StripeIntegrationQl>;
    stripeIntegrationId: Scalars['String']['output'];
    stripeUrl?: Maybe<Scalars['String']['output']>;
    totalRefundedAmount: Scalars['Int']['output'];
  };

export type PaymentRequestQlMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentRequestQlConnection = {
  __typename?: 'PaymentRequestQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentRequestQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PaymentRequestQL` and its cursor. */
export type PaymentRequestQlEdge = {
  __typename?: 'PaymentRequestQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PaymentRequestQl>;
};

export enum PaymentRequestStatus {
  Canceled = 'CANCELED',
  Disputed = 'DISPUTED',
  Failed = 'FAILED',
  Hold = 'HOLD',
  PartialRefund = 'PARTIAL_REFUND',
  Refund = 'REFUND',
  Success = 'SUCCESS',
  Waiting = 'WAITING',
}

export enum PaymentSource {
  Chargebee = 'CHARGEBEE',
  Numberai = 'NUMBERAI',
  Sprint = 'SPRINT',
}

export enum PaymentsFilterType {
  All = 'ALL',
  Attention = 'ATTENTION',
  Holds = 'HOLDS',
  Refunds = 'REFUNDS',
  Requests = 'REQUESTS',
  Success = 'SUCCESS',
}

export enum PhoneCallChannelReceivedOptions {
  Forwarding = 'FORWARDING',
  Reply = 'REPLY',
}

export type PhoneCallQl = BaseQl &
  Node & {
    __typename?: 'PhoneCallQL';
    answeredByScriptType?: Maybe<Scalars['String']['output']>;
    callCount?: Maybe<Scalars['Int']['output']>;
    callDuration?: Maybe<Scalars['Int']['output']>;
    callOutcome?: Maybe<CallOutcomes>;
    callPurpose?: Maybe<Scalars['String']['output']>;
    callQualityRecordingSid?: Maybe<Scalars['String']['output']>;
    callRecording?: Maybe<CallRecordingQl>;
    callRecordingId?: Maybe<Scalars['String']['output']>;
    callSid?: Maybe<Scalars['String']['output']>;
    channel?: Maybe<TwilioChannelQl>;
    channelId?: Maybe<Scalars['String']['output']>;
    channelReceivedType?: Maybe<PhoneCallChannelReceivedOptions>;
    childCallDuration?: Maybe<Scalars['Int']['output']>;
    childCallSid?: Maybe<Scalars['String']['output']>;
    childCallStatus?: Maybe<Scalars['String']['output']>;
    conversation: ConversationQl;
    conversationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    dialogFlowBotData?: Maybe<DialogFlowBotDataQl>;
    endtime?: Maybe<Scalars['ArrowField']['output']>;
    hasIdentityPrompt: Scalars['Boolean']['output'];
    hasReturnCallsRouting: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    identityPromptAttempts?: Maybe<Scalars['Int']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    isBeingRecorded: Scalars['Boolean']['output'];
    isCallIntelligenceEligible?: Maybe<Scalars['Boolean']['output']>;
    language: Scalars['String']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messages?: Maybe<MessageQlConnection>;
    numboxAgentSession?: Maybe<NumboxAgentSessionQl>;
    onHold?: Maybe<Scalars['Boolean']['output']>;
    operatorSession?: Maybe<OperatorSessionQl>;
    operatorSessionId?: Maybe<Scalars['String']['output']>;
    optedInForText?: Maybe<Scalars['Boolean']['output']>;
    originalScriptType?: Maybe<Scalars['String']['output']>;
    participant: ParticipantQl;
    participantId?: Maybe<Scalars['String']['output']>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    redirectReason?: Maybe<RedirectReason>;
    redirectedFrom?: Maybe<ParticipantQl>;
    redirectedFromId?: Maybe<Scalars['String']['output']>;
    returnCallsRoutedTo?: Maybe<Scalars['String']['output']>;
    returnCallsRoutedUser?: Maybe<UserQl>;
    returnCallsRoutedUserId?: Maybe<Scalars['String']['output']>;
    returnCallsRoutingOutcome?: Maybe<PhoneCallReturnCallOutcome>;
    sentGreeting?: Maybe<Scalars['Boolean']['output']>;
    startTime?: Maybe<Scalars['ArrowField']['output']>;
    tagsApplied?: Maybe<Scalars['String']['output']>;
    transcript?: Maybe<TranscriptQl>;
    transcriptId?: Maybe<Scalars['String']['output']>;
  };

export type PhoneCallQlMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PhoneCallQlConnection = {
  __typename?: 'PhoneCallQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PhoneCallQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PhoneCallQL` and its cursor. */
export type PhoneCallQlEdge = {
  __typename?: 'PhoneCallQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PhoneCallQl>;
};

export enum PhoneCallReturnCallOutcome {
  FallbackToScript = 'FALLBACK_TO_SCRIPT',
  UserAnswered = 'USER_ANSWERED',
}

export enum PhoneLineCategory {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  User = 'USER',
}

export enum PhoneLineKind {
  Department = 'DEPARTMENT',
  Staff = 'STAFF',
}

export enum PhoneLinePolicyCategory {
  Custom = 'CUSTOM',
  Department = 'DEPARTMENT',
  Staff = 'STAFF',
}

export type PhoneLinePolicyQl = BaseQl &
  Node & {
    __typename?: 'PhoneLinePolicyQL';
    allowDisruptions: Scalars['Boolean']['output'];
    answerWithKeys?: Maybe<Scalars['String']['output']>;
    answeringScripts: Array<AnsweringScriptsQl>;
    archiveMissedCalls: Scalars['Boolean']['output'];
    assistantPhrase: Scalars['String']['output'];
    autoOptin: Scalars['Boolean']['output'];
    autoOptinMessage?: Maybe<Scalars['String']['output']>;
    autoSendHangupReplies: Scalars['Boolean']['output'];
    category: PhoneLinePolicyCategory;
    createdOn: Scalars['ArrowField']['output'];
    delayAnswerDuration: Scalars['Int']['output'];
    fixInternalDialing: Scalars['Boolean']['output'];
    hangupSuggestion?: Maybe<Scalars['String']['output']>;
    hasIdentityPrompt: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nryCallForwardingPickUpTimeoutSecs: Scalars['Int']['output'];
    nryCallForwardingUserScreenInteractionTimeoutSecs: Scalars['Int']['output'];
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    twilioChannels?: Maybe<TwilioChannelQlConnection>;
  };

export type PhoneLinePolicyQlTwilioChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PhoneLinePolicyQlConnection = {
  __typename?: 'PhoneLinePolicyQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PhoneLinePolicyQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PhoneLinePolicyQL` and its cursor. */
export type PhoneLinePolicyQlEdge = {
  __typename?: 'PhoneLinePolicyQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PhoneLinePolicyQl>;
};

export type PhoneLineQl = BaseQl &
  Node & {
    __typename?: 'PhoneLineQL';
    allowedSpeechLanguages: Array<Language>;
    canForwardReturnCalls: Scalars['Boolean']['output'];
    carrierName?: Maybe<Scalars['String']['output']>;
    category: PhoneLineCategory;
    createHostedSmsUrl?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    department?: Maybe<DepartmentQl>;
    hostedSmsPort?: Maybe<HostedSmsPortQl>;
    id: Scalars['ID']['output'];
    kind: PhoneLineKind;
    language: Scalars['String']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    lineType?: Maybe<PhoneLineType>;
    mdn: Scalars['String']['output'];
    name: Scalars['String']['output'];
    nryChannel?: Maybe<Channel>;
    nryChannelId?: Maybe<Scalars['String']['output']>;
    nryForwardingMdn?: Maybe<Scalars['String']['output']>;
    overridesInboxLanguage: Scalars['Boolean']['output'];
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    policy: PhoneLinePolicyQl;
    policyId: Scalars['String']['output'];
    returnCallsForwardingMdn?: Maybe<Scalars['String']['output']>;
    returnCallsForwardingMode: PhoneLineReturnCallForwadingOptions;
    returnCallsMdn?: Maybe<Scalars['String']['output']>;
    returnCallsMode: PhoneLineReturnCallOptions;
    returnCallsRoutingHours: PhoneLineReturnCallRoutingHours;
    smsChannel?: Maybe<Channel>;
    smsChannelId?: Maybe<Scalars['String']['output']>;
    speechLanguage?: Maybe<Language>;
    user?: Maybe<UserQl>;
    userId?: Maybe<Scalars['String']['output']>;
    voiceChannel?: Maybe<Channel>;
    voiceChannelId?: Maybe<Scalars['String']['output']>;
  };

export type PhoneLineQlConnection = {
  __typename?: 'PhoneLineQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PhoneLineQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PhoneLineQL` and its cursor. */
export type PhoneLineQlEdge = {
  __typename?: 'PhoneLineQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PhoneLineQl>;
};

export enum PhoneLineReturnCallForwadingOptions {
  CustomMdn = 'CUSTOM_MDN',
  PhonelineOwner = 'PHONELINE_OWNER',
  PrimaryMdn = 'PRIMARY_MDN',
}

export enum PhoneLineReturnCallOptions {
  BringYourOwn = 'BRING_YOUR_OWN',
  NumaHandles = 'NUMA_HANDLES',
  NumaRingsYou = 'NUMA_RINGS_YOU',
}

export enum PhoneLineReturnCallRoutingHours {
  AfterHours = 'AFTER_HOURS',
  AllHours = 'ALL_HOURS',
  BusinessHours = 'BUSINESS_HOURS',
  Disabled = 'DISABLED',
}

export enum PhoneLineType {
  Landline = 'LANDLINE',
  Mobile = 'MOBILE',
  Numa = 'NUMA',
  Voip = 'VOIP',
}

export type PickupStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'PickupStepQL';
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    callerRecognizedStep?: Maybe<VoiceScriptStepQl>;
    callerRecognizedStepId?: Maybe<Scalars['String']['output']>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type PickupStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type PickupStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type PickupStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PickupStepQlConnection = {
  __typename?: 'PickupStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PickupStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PickupStepQL` and its cursor. */
export type PickupStepQlEdge = {
  __typename?: 'PickupStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PickupStepQl>;
};

export type PlaceConnection = {
  __typename?: 'PlaceConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlaceEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Place` and its cursor. */
export type PlaceEdge = {
  __typename?: 'PlaceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PlaceQl>;
};

export type PlaceGroupConnection = {
  __typename?: 'PlaceGroupConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlaceGroupEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PlaceGroup` and its cursor. */
export type PlaceGroupEdge = {
  __typename?: 'PlaceGroupEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PlaceGroupQl>;
};

export type PlaceGroupModelFilter = {
  accountId?: InputMaybe<StringFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  id?: InputMaybe<StringFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  name?: InputMaybe<StringFilter>;
  zendeskId?: InputMaybe<FloatFilter>;
};

export enum PlaceGroupModelSortEnum {
  AccountIdAsc = 'account_id_asc',
  AccountIdDesc = 'account_id_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  ZendeskIdAsc = 'zendesk_id_asc',
  ZendeskIdDesc = 'zendesk_id_desc',
}

export type PlaceGroupQl = BaseQl &
  Node & {
    __typename?: 'PlaceGroupQL';
    account: AccountQl;
    accountId: Scalars['String']['output'];
    activeIntegrations?: Maybe<ActiveIntegrationQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customers?: Maybe<CustomerQlConnection>;
    directoryEntries?: Maybe<DepartmentDirectoryEntryQlConnection>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
    places?: Maybe<PlaceQlConnection>;
    zendeskId?: Maybe<Scalars['Float']['output']>;
  };

export type PlaceGroupQlActiveIntegrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceGroupQlCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceGroupQlDirectoryEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceGroupQlPlacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceGroupQlConnection = {
  __typename?: 'PlaceGroupQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlaceGroupQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PlaceGroupQL` and its cursor. */
export type PlaceGroupQlEdge = {
  __typename?: 'PlaceGroupQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PlaceGroupQl>;
};

export enum PlaceHandoffMethod {
  Custom = 'CUSTOM',
  NumberedParkingSpots = 'NUMBERED_PARKING_SPOTS',
  OrderId = 'ORDER_ID',
  VehicleInfo = 'VEHICLE_INFO',
}

export type PlaceInfoQl = BaseQl &
  Node & {
    __typename?: 'PlaceInfoQL';
    WebsiteUrl?: Maybe<Scalars['String']['output']>;
    address?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    email?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    imageUrl?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    linkGroups: Array<Maybe<LinkGroup>>;
    logoUrl?: Maybe<Scalars['String']['output']>;
    meta?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    openhours?: Maybe<Scalars['String']['output']>;
    phonenumber?: Maybe<Scalars['String']['output']>;
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    price?: Maybe<Scalars['String']['output']>;
    rating?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress1?: Maybe<Scalars['String']['output']>;
    streetAddress2?: Maybe<Scalars['String']['output']>;
    websiteUrl?: Maybe<Scalars['String']['output']>;
    yelpAttachments?: Maybe<YelpAttachmentConnection>;
    yelpCategories?: Maybe<Scalars['String']['output']>;
    yelpUrl?: Maybe<Scalars['String']['output']>;
    zipCode?: Maybe<Scalars['String']['output']>;
  };

export type PlaceInfoQlYelpAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A collection of place-specific metrics */
export type PlaceMetrics = Node & {
  __typename?: 'PlaceMetrics';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  openConversationsCount: Scalars['Int']['output'];
  /** Number of overdue conversations in the place. Will be `null` if the place doesn't have an overdue treshold set. */
  overdueConversationsCount?: Maybe<Scalars['Int']['output']>;
  place: PlaceQl;
  unassignedConversationsCount: Scalars['Int']['output'];
};

export type PlaceMetricsConnection = {
  __typename?: 'PlaceMetricsConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlaceMetricsEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PlaceMetrics` and its cursor. */
export type PlaceMetricsEdge = {
  __typename?: 'PlaceMetricsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PlaceMetrics;
};

export type PlaceModelFilter = {
  BusinessTz?: InputMaybe<StringFilter>;
  accountId?: InputMaybe<StringFilter>;
  address?: InputMaybe<StringFilter>;
  allowCustomAudio?: InputMaybe<BooleanFilter>;
  allowedSpeechLanguages?: InputMaybe<JsonStringFilter>;
  answeringMode?: InputMaybe<StringFilter>;
  answeringModeFrom?: InputMaybe<ArrowFieldFilter>;
  answeringModeUntil?: InputMaybe<ArrowFieldFilter>;
  assignmentRetention?: InputMaybe<IntFilter>;
  botParticipantId?: InputMaybe<StringFilter>;
  businessProfileId?: InputMaybe<StringFilter>;
  callForwardingStatus?: InputMaybe<StringFilter>;
  checkCallQuality?: InputMaybe<BooleanFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  discoverFaqs?: InputMaybe<BooleanFilter>;
  enforceMfa?: InputMaybe<StringFilter>;
  escalationsEnabled?: InputMaybe<BooleanFilter>;
  escalationsThreshold?: InputMaybe<IntFilter>;
  fortellisLookupId?: InputMaybe<StringFilter>;
  fortellisRepairOrderSubscriptionId?: InputMaybe<StringFilter>;
  hasDismissedGuideChecklist?: InputMaybe<BooleanFilter>;
  hasExternalIdentity?: InputMaybe<BooleanFilter>;
  hasViewedRefer?: InputMaybe<BooleanFilter>;
  hours?: InputMaybe<JsonStringFilter>;
  id?: InputMaybe<StringFilter>;
  inboxType?: InputMaybe<StringFilter>;
  language?: InputMaybe<StringFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  messagingHours?: InputMaybe<JsonStringFilter>;
  name?: InputMaybe<StringFilter>;
  namePronunciation?: InputMaybe<StringFilter>;
  newConversationsPerDay?: InputMaybe<IntFilter>;
  numaTrained?: InputMaybe<BooleanFilter>;
  outboundCallSettings?: InputMaybe<JsonStringFilter>;
  participantId?: InputMaybe<StringFilter>;
  placeGroupId?: InputMaybe<StringFilter>;
  primaryMdn?: InputMaybe<StringFilter>;
  primaryVoiceScriptId?: InputMaybe<StringFilter>;
  publicListings?: InputMaybe<JsonStringFilter>;
  reportingTimezone?: InputMaybe<StringFilter>;
  resetOngoingOptin?: InputMaybe<IntFilter>;
  resetOptinDays?: InputMaybe<IntFilter>;
  speechLanguage?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  translationEnabled?: InputMaybe<BooleanFilter>;
  twilioBrandRegistrationId?: InputMaybe<StringFilter>;
  twilioMessagingServiceSid?: InputMaybe<StringFilter>;
  unreadEscalationsThreshold?: InputMaybe<IntFilter>;
  useAfterHoursGreeting?: InputMaybe<BooleanFilter>;
  useMessagingHours?: InputMaybe<BooleanFilter>;
  voice?: InputMaybe<StringFilter>;
  voiceFrench?: InputMaybe<StringFilter>;
  voiceSpanish?: InputMaybe<StringFilter>;
};

export enum PlaceModelSortEnum {
  BusinessTzAsc = '_business_tz_asc',
  BusinessTzDesc = '_business_tz_desc',
  AccountIdAsc = 'account_id_asc',
  AccountIdDesc = 'account_id_desc',
  AddressAsc = 'address_asc',
  AddressDesc = 'address_desc',
  AllowCustomAudioAsc = 'allow_custom_audio_asc',
  AllowCustomAudioDesc = 'allow_custom_audio_desc',
  AllowedSpeechLanguagesAsc = 'allowed_speech_languages_asc',
  AllowedSpeechLanguagesDesc = 'allowed_speech_languages_desc',
  AnsweringModeAsc = 'answering_mode_asc',
  AnsweringModeDesc = 'answering_mode_desc',
  AnsweringModeFromAsc = 'answering_mode_from_asc',
  AnsweringModeFromDesc = 'answering_mode_from_desc',
  AnsweringModeUntilAsc = 'answering_mode_until_asc',
  AnsweringModeUntilDesc = 'answering_mode_until_desc',
  AssignmentRetentionAsc = 'assignment_retention_asc',
  AssignmentRetentionDesc = 'assignment_retention_desc',
  BotParticipantIdAsc = 'bot_participant_id_asc',
  BotParticipantIdDesc = 'bot_participant_id_desc',
  BusinessProfileIdAsc = 'business_profile_id_asc',
  BusinessProfileIdDesc = 'business_profile_id_desc',
  CallForwardingStatusAsc = 'call_forwarding_status_asc',
  CallForwardingStatusDesc = 'call_forwarding_status_desc',
  CheckCallQualityAsc = 'check_call_quality_asc',
  CheckCallQualityDesc = 'check_call_quality_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  DiscoverFaqsAsc = 'discover_faqs_asc',
  DiscoverFaqsDesc = 'discover_faqs_desc',
  EnforceMfaAsc = 'enforce_mfa_asc',
  EnforceMfaDesc = 'enforce_mfa_desc',
  EscalationsEnabledAsc = 'escalations_enabled_asc',
  EscalationsEnabledDesc = 'escalations_enabled_desc',
  EscalationsThresholdAsc = 'escalations_threshold_asc',
  EscalationsThresholdDesc = 'escalations_threshold_desc',
  FortellisLookupIdAsc = 'fortellis_lookup_id_asc',
  FortellisLookupIdDesc = 'fortellis_lookup_id_desc',
  FortellisRepairOrderSubscriptionIdAsc = 'fortellis_repair_order_subscription_id_asc',
  FortellisRepairOrderSubscriptionIdDesc = 'fortellis_repair_order_subscription_id_desc',
  HasDismissedGuideChecklistAsc = 'has_dismissed_guide_checklist_asc',
  HasDismissedGuideChecklistDesc = 'has_dismissed_guide_checklist_desc',
  HasExternalIdentityAsc = 'has_external_identity_asc',
  HasExternalIdentityDesc = 'has_external_identity_desc',
  HasViewedReferAsc = 'has_viewed_refer_asc',
  HasViewedReferDesc = 'has_viewed_refer_desc',
  HoursAsc = 'hours_asc',
  HoursDesc = 'hours_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  InboxTypeAsc = 'inbox_type_asc',
  InboxTypeDesc = 'inbox_type_desc',
  LanguageAsc = 'language_asc',
  LanguageDesc = 'language_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  MessagingHoursAsc = 'messaging_hours_asc',
  MessagingHoursDesc = 'messaging_hours_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  NamePronunciationAsc = 'name_pronunciation_asc',
  NamePronunciationDesc = 'name_pronunciation_desc',
  NewConversationsPerDayAsc = 'new_conversations_per_day_asc',
  NewConversationsPerDayDesc = 'new_conversations_per_day_desc',
  NumaTrainedAsc = 'numa_trained_asc',
  NumaTrainedDesc = 'numa_trained_desc',
  OutboundCallSettingsAsc = 'outbound_call_settings_asc',
  OutboundCallSettingsDesc = 'outbound_call_settings_desc',
  ParticipantIdAsc = 'participant_id_asc',
  ParticipantIdDesc = 'participant_id_desc',
  PlaceGroupIdAsc = 'place_group_id_asc',
  PlaceGroupIdDesc = 'place_group_id_desc',
  PrimaryMdnAsc = 'primary_mdn_asc',
  PrimaryMdnDesc = 'primary_mdn_desc',
  PrimaryVoiceScriptIdAsc = 'primary_voice_script_id_asc',
  PrimaryVoiceScriptIdDesc = 'primary_voice_script_id_desc',
  PublicListingsAsc = 'public_listings_asc',
  PublicListingsDesc = 'public_listings_desc',
  ReportingTimezoneAsc = 'reporting_timezone_asc',
  ReportingTimezoneDesc = 'reporting_timezone_desc',
  ResetOngoingOptinAsc = 'reset_ongoing_optin_asc',
  ResetOngoingOptinDesc = 'reset_ongoing_optin_desc',
  ResetOptinDaysAsc = 'reset_optin_days_asc',
  ResetOptinDaysDesc = 'reset_optin_days_desc',
  SpeechLanguageAsc = 'speech_language_asc',
  SpeechLanguageDesc = 'speech_language_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc',
  TranslationEnabledAsc = 'translation_enabled_asc',
  TranslationEnabledDesc = 'translation_enabled_desc',
  TwilioBrandRegistrationIdAsc = 'twilio_brand_registration_id_asc',
  TwilioBrandRegistrationIdDesc = 'twilio_brand_registration_id_desc',
  TwilioMessagingServiceSidAsc = 'twilio_messaging_service_sid_asc',
  TwilioMessagingServiceSidDesc = 'twilio_messaging_service_sid_desc',
  UnreadEscalationsThresholdAsc = 'unread_escalations_threshold_asc',
  UnreadEscalationsThresholdDesc = 'unread_escalations_threshold_desc',
  UseAfterHoursGreetingAsc = 'use_after_hours_greeting_asc',
  UseAfterHoursGreetingDesc = 'use_after_hours_greeting_desc',
  UseMessagingHoursAsc = 'use_messaging_hours_asc',
  UseMessagingHoursDesc = 'use_messaging_hours_desc',
  VoiceAsc = 'voice_asc',
  VoiceDesc = 'voice_desc',
  VoiceFrenchAsc = 'voice_french_asc',
  VoiceFrenchDesc = 'voice_french_desc',
  VoiceSpanishAsc = 'voice_spanish_asc',
  VoiceSpanishDesc = 'voice_spanish_desc',
}

export enum PlaceOrderIdType {
  Custom = 'CUSTOM',
  CustomerName = 'CUSTOMER_NAME',
  OrderNumber = 'ORDER_NUMBER',
}

export type PlacePermissionsQl = {
  __typename?: 'PlacePermissionsQL';
  permissions: Array<Scalars['String']['output']>;
  placeId: Scalars['String']['output'];
};

export type PlaceQl = BaseQl &
  Node & {
    __typename?: 'PlaceQL';
    BusinessTz?: Maybe<Scalars['String']['output']>;
    account: AccountQl;
    accountId: Scalars['String']['output'];
    activeIntegrations?: Maybe<ActiveIntegrationQlConnection>;
    address?: Maybe<Scalars['String']['output']>;
    allowCustomAudio: Scalars['Boolean']['output'];
    allowedSpeechLanguages: Array<Language>;
    answeringMode: AnsweringMode;
    answeringModeFrom?: Maybe<Scalars['ArrowField']['output']>;
    answeringModeUntil?: Maybe<Scalars['ArrowField']['output']>;
    answeringScripts?: Maybe<AnsweringScriptsQlConnection>;
    appliedIntents?: Maybe<AppliedIntentQlConnection>;
    appointmentAgentSettings?: Maybe<AppointmentAgentSettingsQlConnection>;
    appointments?: Maybe<AppointmentQlConnection>;
    assignmentRetention: Scalars['Int']['output'];
    autopilotJob?: Maybe<AutopilotJobQl>;
    billingMetadata?: Maybe<BillingMetadataQl>;
    botParticipant?: Maybe<ParticipantQl>;
    botParticipantId?: Maybe<Scalars['String']['output']>;
    brandTheme?: Maybe<BrandThemeQl>;
    businessProfile?: Maybe<BusinessProfileQl>;
    businessProfileId?: Maybe<Scalars['String']['output']>;
    businessTz?: Maybe<Scalars['String']['output']>;
    callForwardingStatus: CallForwardingStatus;
    callIntelligenceSetting?: Maybe<CallIntelligenceSettingQl>;
    campaigns?: Maybe<Array<Maybe<CampaignQl>>>;
    channels?: Maybe<Array<Maybe<Channel>>>;
    checkCallQuality: Scalars['Boolean']['output'];
    conversations?: Maybe<ConversationQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    curbsideSettings?: Maybe<CurbsideSettingsQl>;
    departmentPhoneLinePolicy: PhoneLinePolicyQl;
    departments?: Maybe<DepartmentQlConnection>;
    dialogFlowBotDatas?: Maybe<DialogFlowBotDataQlConnection>;
    discoverFaqs: Scalars['Boolean']['output'];
    disruptions?: Maybe<DisruptionsQl>;
    enforceMfa: EnforceMfa;
    escalationUsers?: Maybe<UserQlConnection>;
    escalationsEnabled: Scalars['Boolean']['output'];
    escalationsThreshold: Scalars['Int']['output'];
    externalName: Scalars['String']['output'];
    externalPlaceInfo?: Maybe<PlaceInfoQl>;
    fortellisLookup?: Maybe<FortellisSubscriptionQl>;
    fortellisLookupId?: Maybe<Scalars['String']['output']>;
    fortellisRepairOrderSubscription?: Maybe<FortellisSubscriptionQl>;
    fortellisRepairOrderSubscriptionId?: Maybe<Scalars['String']['output']>;
    fortellisSubscriptions?: Maybe<Array<FortellisSubscriptionQl>>;
    greetings?: Maybe<Array<Maybe<GreetingQl>>>;
    hasDegradedInboxExperience?: Maybe<Scalars['Boolean']['output']>;
    hasDismissedGuideChecklist: Scalars['Boolean']['output'];
    hasExternalIdentity: Scalars['Boolean']['output'];
    hasViewedRefer: Scalars['Boolean']['output'];
    hours?: Maybe<Scalars['JSONString']['output']>;
    id: Scalars['ID']['output'];
    inbox?: Maybe<InboxQl>;
    inboxType: Scalars['String']['output'];
    intentClassifiers?: Maybe<IntentClassifierQlConnection>;
    labels?: Maybe<LabelQlConnection>;
    language?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    managers?: Maybe<Array<Maybe<UserQl>>>;
    messages?: Maybe<MessageQlConnection>;
    messagingHours?: Maybe<Scalars['JSONString']['output']>;
    name: Scalars['String']['output'];
    namePronunciation?: Maybe<Scalars['String']['output']>;
    namePronunciationUrl?: Maybe<Scalars['String']['output']>;
    newConversationsPerDay: Scalars['Int']['output'];
    noteTakers?: Maybe<NoteTakerQlConnection>;
    numaTrained: Scalars['Boolean']['output'];
    operators?: Maybe<OperatorQlConnection>;
    outboundCallSettings?: Maybe<Array<OutboundCallSettingQl>>;
    outboundConversationsToday?: Maybe<Scalars['Int']['output']>;
    participant?: Maybe<ParticipantQl>;
    participantId?: Maybe<Scalars['String']['output']>;
    paymentRequests?: Maybe<PaymentRequestQlConnection>;
    phoneCalls?: Maybe<PhoneCallQlConnection>;
    phonelinePolicies?: Maybe<PhoneLinePolicyQlConnection>;
    phonelines?: Maybe<Array<Maybe<PhoneLineQl>>>;
    placeGroup: PlaceGroupQl;
    placeGroupId: Scalars['String']['output'];
    /** @deprecated use external_place_info */
    placeInfo?: Maybe<PlaceInfoQl>;
    placePaymentRequestCustomization?: Maybe<PaymentRequestCustomizationQl>;
    placesUsers?: Maybe<PlacesUsersQlConnection>;
    primaryMdn?: Maybe<Scalars['String']['output']>;
    primaryVoiceScript?: Maybe<VoiceScriptQl>;
    primaryVoiceScriptId?: Maybe<Scalars['String']['output']>;
    publicListings: Array<PublicListingQl>;
    questionAgentSettings?: Maybe<QuestionAgentSettingsQlConnection>;
    repairOrderSmartStatusUpdateSettings?: Maybe<RepairOrderSmartStatusUpdateSettingsQl>;
    repairServices?: Maybe<RepairServiceQlConnection>;
    reportingTimezone?: Maybe<Scalars['String']['output']>;
    resetOngoingOptin: Scalars['Int']['output'];
    resetOptinDays: Scalars['Int']['output'];
    review?: Maybe<ReviewQlConnection>;
    reviewJob?: Maybe<ReviewJobQlConnection>;
    scheduledMessages?: Maybe<ScheduledMessageQlConnection>;
    shortcuts?: Maybe<Array<Maybe<ShortcutQl>>>;
    speechLanguage: Language;
    staffPhoneLinePolicy: PhoneLinePolicyQl;
    stages?: Maybe<StageQlConnection>;
    status: Status;
    statusItems?: Maybe<StatusItemQlConnection>;
    stripeIntegrations?: Maybe<StripeIntegrationQlConnection>;
    subscriptions?: Maybe<Array<Maybe<SubscriptionQl>>>;
    teams?: Maybe<TeamQlConnection>;
    translationEnabled?: Maybe<Scalars['Boolean']['output']>;
    transportationSets?: Maybe<TransportationSetQlConnection>;
    twilioBrandRegistration?: Maybe<TwilioBrandRegistrationQl>;
    twilioBrandRegistrationId?: Maybe<Scalars['String']['output']>;
    twilioMessagingServiceSid?: Maybe<Scalars['String']['output']>;
    unreadEscalationsThreshold?: Maybe<Scalars['Int']['output']>;
    useAfterHoursGreeting: Scalars['Boolean']['output'];
    useMessagingHours: Scalars['Boolean']['output'];
    videos?: Maybe<VideoUploadLinkQlConnection>;
    voice: Scalars['String']['output'];
    voiceFrench?: Maybe<Scalars['String']['output']>;
    voiceScripts?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    voiceSpanish?: Maybe<Scalars['String']['output']>;
    voiceSteps?: Maybe<VoiceScriptStepQlConnection>;
    watsonClassifier?: Maybe<IntentClassifierQl>;
  };

export type PlaceQlActiveIntegrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlAnsweringScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlAppliedIntentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlAppointmentAgentSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlAppointmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlDepartmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlDialogFlowBotDatasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlEscalationUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlIntentClassifiersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlNoteTakersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlOperatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlPaymentRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlPhoneCallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlPhonelinePoliciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlPlacesUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlQuestionAgentSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlRepairServicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlReviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlReviewJobArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlScheduledMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlStagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlStatusItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlStripeIntegrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlTransportationSetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlVoiceStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PlaceQlConnection = {
  __typename?: 'PlaceQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlaceQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PlaceQL` and its cursor. */
export type PlaceQlEdge = {
  __typename?: 'PlaceQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PlaceQl>;
};

export enum PlaceStatusInput {
  Active = 'ACTIVE',
  Degraded = 'DEGRADED',
  Disabled = 'DISABLED',
}

export type PlaceVoiceSettingsQl = {
  __typename?: 'PlaceVoiceSettingsQL';
  allowedSpeechLanguages?: Maybe<Array<Maybe<Language>>>;
  id: Scalars['String']['output'];
  speechLanguage: Language;
  voice: Scalars['String']['output'];
  voiceFrench?: Maybe<Scalars['String']['output']>;
  voiceSpanish?: Maybe<Scalars['String']['output']>;
};

export type PlacesUsersQl = BaseQl &
  Node & {
    __typename?: 'PlacesUsersQL';
    assignmentRoutingSettings?: Maybe<AssignmentRoutingSettingQl>;
    awayModeAssigneeTeam?: Maybe<TeamQl>;
    awayModeAssigneeTeamId?: Maybe<Scalars['String']['output']>;
    awayModeAssigneeUser?: Maybe<UserQl>;
    awayModeAssigneeUserId?: Maybe<Scalars['String']['output']>;
    callIntelligenceEnabled: Scalars['Boolean']['output'];
    cdkServiceAdvisors?: Maybe<Array<Maybe<CdkServiceAdvisorQl>>>;
    createdOn: Scalars['ArrowField']['output'];
    dealertrackServiceAdvisors?: Maybe<
      Array<Maybe<DealerTrackServiceAdvisorQl>>
    >;
    id: Scalars['ID']['output'];
    isReassigningInboundMessages?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    receivesEscalations: Scalars['Boolean']['output'];
    registeredFortellisServiceAdvisor?: Maybe<RegisteredFortellisServiceAdvisorQl>;
    role: Scalars['String']['output'];
    serviceAdvisors?: Maybe<Array<Maybe<ServiceAdvisors>>>;
    status?: Maybe<PlacesUsersStatus>;
    user: UserQl;
    userId: Scalars['String']['output'];
  };

export type PlacesUsersQlServiceAdvisorsArgs = {
  serviceAdvisorType?: InputMaybe<ServiceAdvisorType>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type PlacesUsersQlConnection = {
  __typename?: 'PlacesUsersQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlacesUsersQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PlacesUsersQL` and its cursor. */
export type PlacesUsersQlEdge = {
  __typename?: 'PlacesUsersQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PlacesUsersQl>;
};

export enum PlacesUsersStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Pending = 'PENDING',
}

export type PokeUser = {
  __typename?: 'PokeUser';
  user?: Maybe<UserQl>;
};

export type PokeUserInput = {
  placeId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type PopulateBusinessProfileWithChargebeeInfo = {
  __typename?: 'PopulateBusinessProfileWithChargebeeInfo';
  businessProfile?: Maybe<BusinessProfileQl>;
};

export type PopulateBusinessProfileWithChargebeeInfoInput = {
  accountId: Scalars['String']['input'];
};

export type PortInPhoneLine = {
  __typename?: 'PortInPhoneLine';
  channel?: Maybe<Channel>;
  phoneline?: Maybe<PhoneLineQl>;
};

export type PortInPhoneLineInput = {
  placeId: Scalars['String']['input'];
  twilioSid: Scalars['String']['input'];
};

export type Position = {
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export enum PossibleBotAction {
  Autosend = 'AUTOSEND',
  BotProtected = 'BOT_PROTECTED',
  None = 'NONE',
  Suggest = 'SUGGEST',
}

export type PredictedMessageIntentQl = {
  __typename?: 'PredictedMessageIntentQL';
  confidence: Scalars['Float']['output'];
  intent: Scalars['String']['output'];
};

export type PressAnyKeyStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'PressAnyKeyStepQL';
    afterHoursSpeech: Scalars['String']['output'];
    afterHoursSpeechUrl: Scalars['String']['output'];
    afterHoursTextMessage?: Maybe<Scalars['String']['output']>;
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    optinGreetingId?: Maybe<Scalars['String']['output']>;
    optinTextMessage?: Maybe<Scalars['String']['output']>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedAfterHoursSpeech: Scalars['String']['output'];
    renderedAfterHoursTextMessage?: Maybe<Scalars['String']['output']>;
    renderedOptinTextMessage?: Maybe<Scalars['String']['output']>;
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    /** @deprecated Use optinTextMessage instead of the global place greeting */
    textOptinGreeting?: Maybe<GreetingQl>;
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    useAfterHoursTextMessage: Scalars['Boolean']['output'];
    useCustomAudio: Scalars['Boolean']['output'];
    useCustomAudioForAfterHours: Scalars['Boolean']['output'];
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type PressAnyKeyStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type PressAnyKeyStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type PressAnyKeyStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PressAnyKeyStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProductOffering {
  Amex = 'AMEX',
  Auto_500Trial30 = 'AUTO_500_TRIAL30',
  Auto_1000Disc50Trial30 = 'AUTO_1000_DISC50_TRIAL30',
  Auto_1000Trial30 = 'AUTO_1000_TRIAL30',
  Auto_1250Trial30 = 'AUTO_1250_TRIAL30',
  Auto_1500Trial30 = 'AUTO_1500_TRIAL30',
  AutoExternalBilling = 'AUTO_EXTERNAL_BILLING',
  CovidEssentials = 'COVID_ESSENTIALS',
  CovidPro = 'COVID_PRO',
  CovidSalon = 'COVID_SALON',
  Essentials = 'ESSENTIALS',
  EssentialsTrial7 = 'ESSENTIALS_TRIAL7',
  EssentialsTrial14 = 'ESSENTIALS_TRIAL14',
  Experimax = 'EXPERIMAX',
  NumaSalon = 'NUMA_SALON',
  Ordering = 'ORDERING',
  Pro = 'PRO',
  ProTrial7 = 'PRO_TRIAL7',
  ProTrial14 = 'PRO_TRIAL14',
}

export enum Pronouns {
  HeHim = 'HE_HIM',
  SheHer = 'SHE_HER',
  TheyThem = 'THEY_THEM',
}

export enum PubNubAddressMediumType {
  Email = 'EMAIL',
  PhoneFax = 'PHONE_FAX',
  PhoneHome = 'PHONE_HOME',
  PhoneMobile = 'PHONE_MOBILE',
  PhoneOther = 'PHONE_OTHER',
  PhoneWork = 'PHONE_WORK',
  SocialFacebook = 'SOCIAL_FACEBOOK',
  SocialGoogle = 'SOCIAL_GOOGLE',
  SocialX = 'SOCIAL_X',
}

export type PubNubAddressModel = {
  address: Scalars['String']['input'];
  deleted_at?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  medium_type?: InputMaybe<PubNubAddressMediumType>;
  source_entity_id?: InputMaybe<Scalars['String']['input']>;
  source_entity_type?: InputMaybe<PubNubAddressSourceEntityType>;
};

export enum PubNubAddressSourceEntityType {
  CnamCnam = 'CNAM_CNAM',
  CrmSalesforce = 'CRM_SALESFORCE',
  DmsCdk = 'DMS_CDK',
  DmsDealertrack = 'DMS_DEALERTRACK',
  DmsPbs = 'DMS_PBS',
  DmsReynolds = 'DMS_REYNOLDS',
  DmsTekion = 'DMS_TEKION',
  ManualNuma = 'MANUAL_NUMA',
}

export enum PubNubAppointmentEnrichedFrom {
  AppointmentAgent = 'APPOINTMENT_AGENT',
  Cdk = 'CDK',
  DealerTrack = 'DEALER_TRACK',
  Imported = 'IMPORTED',
  Manual = 'MANUAL',
  MessageIntent = 'MESSAGE_INTENT',
  Tekion = 'TEKION',
  VoiceScript = 'VOICE_SCRIPT',
}

export type PubNubAppointmentModel = {
  appointment_date?: InputMaybe<Scalars['DateTime']['input']>;
  appointment_id?: InputMaybe<Scalars['String']['input']>;
  created_on: Scalars['DateTime']['input'];
  dialog_flow_bot_data?: InputMaybe<PubNubDialogFlowBotDataModel>;
  enriched_from?: InputMaybe<PubNubAppointmentEnrichedFrom>;
  expires_at?: InputMaybe<Scalars['DateTime']['input']>;
  external_service_advisor_id?: InputMaybe<Scalars['String']['input']>;
  external_service_advisor_name?: InputMaybe<Scalars['String']['input']>;
  feedback_submitted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  numbox_agent_session?: InputMaybe<PubNubNumboxAgentSessionModel>;
  state: PubNubAppointmentState;
};

export enum PubNubAppointmentState {
  Active = 'ACTIVE',
  Booked = 'BOOKED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Inferred = 'INFERRED',
  Lost = 'LOST',
  Qualified = 'QUALIFIED',
  Unqualified = 'UNQUALIFIED',
}

export type PubNubAttachmentType = {
  after?: InputMaybe<Scalars['String']['input']>;
  attachment_type: Scalars['String']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  message_id: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  place_id?: InputMaybe<Scalars['String']['input']>;
  place_info_id?: InputMaybe<Scalars['String']['input']>;
  size_bytes?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  video_microsite_link_id?: InputMaybe<Scalars['String']['input']>;
  video_upload_link_id?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type PubNubCdkContactModel = {
  company_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

export type PubNubCnamContactModel = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
};

export type PubNubConfigQl = {
  __typename?: 'PubNubConfigQL';
  browserPushChannels: Array<Maybe<Scalars['String']['output']>>;
  channelGroups: Array<Maybe<Scalars['String']['output']>>;
  channels: Array<Maybe<Scalars['String']['output']>>;
  deviceToken: Scalars['String']['output'];
  /** @deprecated Unused and will always return `null`, will be removed */
  pamKey?: Maybe<Scalars['String']['output']>;
  pamToken: Scalars['String']['output'];
  publishKey: Scalars['String']['output'];
  pushChannels: Array<Maybe<Scalars['String']['output']>>;
  subscribeKey: Scalars['String']['output'];
  typingIndicator: TypingIndicatorQl;
  userId: Scalars['String']['output'];
  userParticipantId: Scalars['String']['output'];
};

export type PubNubConversationEngagement = {
  id: Scalars['String']['input'];
  latest_inbox_agent_result?: InputMaybe<PubNubInboxAgentResult>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_created_on?: InputMaybe<Scalars['DateTime']['input']>;
  summary_id?: InputMaybe<Scalars['String']['input']>;
};

export type PubNubConversationLabelParticipantModel = {
  display_name: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type PubNubConversationLabels = {
  created_on: Scalars['DateTime']['input'];
  expires_at?: InputMaybe<Scalars['DateTime']['input']>;
  hidden: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  label: PubNubLabelModel;
  participant: PubNubConversationLabelParticipantModel;
};

export type PubNubConversationLabelsStub = {
  id: Scalars['String']['input'];
  label: PubNubLabelModel;
};

export type PubNubConversationLastChannel = {
  id: Scalars['String']['input'];
};

export type PubNubConversationModel = {
  am_i_mentioned: Scalars['Boolean']['input'];
  assignee?: InputMaybe<PubNubUser>;
  conversation_labels?: InputMaybe<Array<PubNubConversationLabels>>;
  created_on: Scalars['DateTime']['input'];
  customer_waiting: Scalars['Boolean']['input'];
  escalated?: InputMaybe<Scalars['DateTime']['input']>;
  first_message_timestamp: Scalars['DateTime']['input'];
  has_recent_heat_case: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  inbox_id: Scalars['String']['input'];
  is_mentioned_conversation: Scalars['Boolean']['input'];
  is_overdue: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
  last_appointment?: InputMaybe<PubNubAppointmentModel>;
  last_channel?: InputMaybe<PubNubConversationLastChannel>;
  last_engagement?: InputMaybe<PubNubConversationEngagement>;
  last_mentioned_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  last_message?: InputMaybe<PubNubMessageModel>;
  last_repair_order?: InputMaybe<PubNubRepairOrder>;
  last_updated?: InputMaybe<Scalars['DateTime']['input']>;
  opt_in_status: PubNubConversationOptInStatus;
  participant: PubNubParticipantModel;
  place: PubNubPlaceModel;
  preview_data?: InputMaybe<PubNubConversationPreviewDataModel>;
  server_generated_preview: Scalars['Boolean']['input'];
  snoozed_until?: InputMaybe<Scalars['DateTime']['input']>;
  source: Scalars['String']['input'];
  state: ConversationState;
  team?: InputMaybe<PubNubTeamModel>;
  team_id: Scalars['String']['input'];
  top_intent?: InputMaybe<PubNubIntent>;
  unread_count: Scalars['Int']['input'];
  waiting_since?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum PubNubConversationOptInStatus {
  ConversationalOptIn = 'CONVERSATIONAL_OPT_IN',
  OngoingOptIn = 'ONGOING_OPT_IN',
  OptedOut = 'OPTED_OUT',
  Unknown = 'UNKNOWN',
}

export type PubNubConversationPreviewDataModel = {
  preview: Scalars['String']['input'];
  preview_display_name: Scalars['String']['input'];
  preview_format: Scalars['String']['input'];
  preview_is_inbound: Scalars['Boolean']['input'];
  preview_mentions: Array<PubNubMention>;
  preview_server_generated: Scalars['Boolean']['input'];
  preview_source: Scalars['String']['input'];
  sub_preview: Scalars['String']['input'];
  sub_preview_display_name: Scalars['String']['input'];
  sub_preview_format: Scalars['String']['input'];
  sub_preview_mentions: Array<PubNubMention>;
};

export type PubNubConversationTimestamp = {
  assignee_id?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  inbox_id: Scalars['String']['input'];
  last_updated: Scalars['DateTime']['input'];
  state: ConversationState;
  team?: InputMaybe<PubNubTeamModelStub>;
  timestamp: Scalars['DateTime']['input'];
  waiting_since?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PubNubCrmContactModel = {
  company_name?: InputMaybe<Scalars['String']['input']>;
  contact_type?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

export enum PubNubCurrency {
  Usd = 'USD',
}

export type PubNubCustomerModel = {
  addresses?: InputMaybe<Array<InputMaybe<PubNubAddressModel>>>;
  display_name: Scalars['String']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
};

export type PubNubDealertrackContactModel = {
  company_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

export enum PubNubDeliveryStatus {
  Delivered = 'delivered',
  Failed = 'failed',
  Inprogress = 'inprogress',
  Sent = 'sent',
}

export type PubNubDialogFlowBotDataModel = {
  agent_duration: Scalars['Int']['input'];
  agent_reason?: InputMaybe<PubNubDialogflowAgentReason>;
  appointment_was_booked: Scalars['Boolean']['input'];
  conversation_id: Scalars['String']['input'];
  customer_in_dms?: InputMaybe<Scalars['Boolean']['input']>;
  data: Scalars['String']['input'];
  id: Scalars['String']['input'];
  outcome?: InputMaybe<PubNubDialogflowOutcome>;
};

export enum PubNubDialogflowAgentReason {
  CustomerAsked = 'CUSTOMER_ASKED',
  FailedRecognition = 'FAILED_RECOGNITION',
  NoInputRetriesExceeded = 'NO_INPUT_RETRIES_EXCEEDED',
  SchedulingRoundTripsExceeded = 'SCHEDULING_ROUND_TRIPS_EXCEEDED',
  ServiceNotMapped = 'SERVICE_NOT_MAPPED',
  ServiceNotSupported = 'SERVICE_NOT_SUPPORTED',
  WebhookError = 'WEBHOOK_ERROR',
  WebhookTimeout = 'WEBHOOK_TIMEOUT',
}

export enum PubNubDialogflowOutcome {
  Agent = 'AGENT',
  Booked = 'BOOKED',
  Error = 'ERROR',
  Hangup = 'HANGUP',
  Recall = 'RECALL',
}

export type PubNubEquityTradeOpportunityModel = {
  id: Scalars['String']['input'];
  stage: Scalars['String']['input'];
};

export type PubNubInboundPhoneCallModel = {
  call_duration?: InputMaybe<Scalars['Int']['input']>;
  call_recording?: InputMaybe<PubNubInboundPhoneCallRecordingModel>;
  conversation_id: Scalars['String']['input'];
  endtime?: InputMaybe<Scalars['DateTime']['input']>;
  has_return_calls_routing: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  is_active: Scalars['Boolean']['input'];
  is_being_recorded: Scalars['Boolean']['input'];
  participant: PubNubInboundPhoneCallParticipantModel;
  redirected_from?: InputMaybe<PubNubInboundPhoneCallParticipantModel>;
  return_calls_routed_to?: InputMaybe<Scalars['String']['input']>;
  return_calls_routed_user?: InputMaybe<PubNubInboundPhoneCallRoutedUserModel>;
  return_calls_routing_outcome?: InputMaybe<PubNubInboundPhoneCallReturnCallsRoutingOutcome>;
  start_time: Scalars['DateTime']['input'];
  transcript?: InputMaybe<PubNubTranscriptModel>;
};

export type PubNubInboundPhoneCallParticipantModel = {
  address: Scalars['String']['input'];
  display_name: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type PubNubInboundPhoneCallRecordingModel = {
  id: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum PubNubInboundPhoneCallReturnCallsRoutingOutcome {
  FallbackToScript = 'FALLBACK_TO_SCRIPT',
  UserAnswered = 'USER_ANSWERED',
}

export type PubNubInboundPhoneCallRoutedUserModel = {
  display_name: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type PubNubInboxAgentResult = {
  id: Scalars['String']['input'];
  predicted_message_intents: Array<PubNubMessageIntent>;
  sentiment?: InputMaybe<Scalars['String']['input']>;
  sentiment_value?: InputMaybe<Scalars['Float']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PubNubIntent = {
  has_response: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  possible_bot_action: Scalars['String']['input'];
};

export enum PubNubLabelCategory {
  Callback = 'CALLBACK',
  Ro = 'RO',
  Urgent = 'URGENT',
  User = 'USER',
}

export type PubNubLabelModel = {
  archived: Scalars['Boolean']['input'];
  category: PubNubLabelCategory;
  color: Scalars['String']['input'];
  expiration_hours?: InputMaybe<Scalars['Int']['input']>;
  hidden: Scalars['Boolean']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_type?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  place_id: Scalars['String']['input'];
};

export type PubNubLabelModelStub = {
  category: PubNubLabelCategory;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PubNubMention = {
  tag: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export enum PubNubMessageFormat {
  Assignment = 'assignment',
  Dialogflowbot = 'dialogflowbot',
  Loggedcall = 'loggedcall',
  Media = 'media',
  Multichoice = 'multichoice',
  Note = 'note',
  Outboundconference = 'outboundconference',
  Outboundproxy = 'outboundproxy',
  Rocompleted = 'rocompleted',
  Rostarted = 'rostarted',
  Surveyanswer = 'surveyanswer',
  System = 'system',
  Text = 'text',
  Voice = 'voice',
  Yelp = 'yelp',
}

export type PubNubMessageIntent = {
  confidence: Scalars['Float']['input'];
  intent: Scalars['String']['input'];
};

export type PubNubMessageModel = {
  attachments: Array<InputMaybe<PubNubAttachmentType>>;
  call?: InputMaybe<PubNubInboundPhoneCallModel>;
  can_teach_numa?: InputMaybe<Scalars['Boolean']['input']>;
  caps_lock_fixed: Scalars['Boolean']['input'];
  channel_id: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  conversation_id: Scalars['String']['input'];
  delivery_error?: InputMaybe<Scalars['Int']['input']>;
  delivery_status: PubNubDeliveryStatus;
  dialog_flow_bot_data?: InputMaybe<PubNubDialogFlowBotDataModel>;
  id: Scalars['String']['input'];
  intent_display_name?: InputMaybe<Scalars['String']['input']>;
  intent_id?: InputMaybe<Scalars['String']['input']>;
  intent_name?: InputMaybe<Scalars['String']['input']>;
  is_archived: Scalars['Boolean']['input'];
  is_deleted: Scalars['Boolean']['input'];
  is_heat_case: Scalars['Boolean']['input'];
  is_inbound: Scalars['Boolean']['input'];
  is_suggestion?: InputMaybe<Scalars['Boolean']['input']>;
  logged_call_interaction?: InputMaybe<PubNubParticipantLoggedCallInteraction>;
  mentions: Array<PubNubMention>;
  message_format: PubNubMessageFormat;
  numbox_agent_session?: InputMaybe<PubNubNumboxAgentSessionModel>;
  outbound_conference_call?: InputMaybe<PubNubOutboundConferenceCallModel>;
  outbound_proxy_call?: InputMaybe<PubNubOutboundProxyCallModel>;
  payment_request?: InputMaybe<PubNubPaymentRequestModel>;
  qualification_survey?: InputMaybe<PubNubQualificationSurvey>;
  read_status?: InputMaybe<Scalars['DateTime']['input']>;
  reason_sent?: InputMaybe<PubNubReasonSentModel>;
  recipient: PubNubSenderModel;
  repair_order?: InputMaybe<PubNubRepairOrder>;
  reply_status?: InputMaybe<Scalars['String']['input']>;
  responds_to_id?: InputMaybe<Scalars['String']['input']>;
  sender: PubNubSenderModel;
  team_id: Scalars['String']['input'];
  thumb?: InputMaybe<Scalars['String']['input']>;
  timestamp: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
};

export type PubNubNumboxAgentSessionModel = {
  appointment?: InputMaybe<PubNubAppointmentModel>;
  feedback_submitted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  outcome?: InputMaybe<PubNubSessionOutcome>;
  slots: Scalars['String']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type PubNubOutboundConferenceCallCallerModel = {
  display_name: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type PubNubOutboundConferenceCallModel = {
  answered_by_voicemail: Scalars['Boolean']['input'];
  call_duration: Scalars['Int']['input'];
  call_recording?: InputMaybe<PubNubOutboundConferenceCallRecordingModel>;
  call_status: Scalars['String']['input'];
  caller: PubNubOutboundConferenceCallCallerModel;
  conversation_id: Scalars['String']['input'];
  created_on: Scalars['DateTime']['input'];
  end_time: Scalars['DateTime']['input'];
  has_call_assist: Scalars['Boolean']['input'];
  host_connected_to?: InputMaybe<Scalars['String']['input']>;
  host_mdn: Scalars['String']['input'];
  id: Scalars['String']['input'];
  is_being_recorded: Scalars['Boolean']['input'];
  outbound_call_sid?: InputMaybe<Scalars['String']['input']>;
  recipient_display_name: Scalars['String']['input'];
  recipient_mdn: Scalars['String']['input'];
  start_time: Scalars['DateTime']['input'];
  transcript: PubNubTranscriptModel;
};

export type PubNubOutboundConferenceCallRecordingModel = {
  id: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PubNubOutboundProxyCallModel = {
  call_duration?: InputMaybe<Scalars['Int']['input']>;
  call_status?: InputMaybe<Scalars['String']['input']>;
  endtime?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
};

export enum PubNubParticipantDataConfidence {
  High = 'HIGH',
  Low = 'LOW',
}

export enum PubNubParticipantLoggedCallInteraction {
  Message = 'MESSAGE',
  NoAnswer = 'NO_ANSWER',
  Other = 'OTHER',
  Spam = 'SPAM',
  Spoke = 'SPOKE',
  Unknown = 'UNKNOWN',
  WrongNumber = 'WRONG_NUMBER',
}

export type PubNubParticipantModel = {
  address: Scalars['String']['input'];
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  crm_contacts?: InputMaybe<Array<PubNubCrmContactModel>>;
  customerCount: Scalars['Int']['input'];
  display_name: Scalars['String']['input'];
  display_name_confidence: PubNubParticipantDataConfidence;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  is_employee: Scalars['Boolean']['input'];
  language?: InputMaybe<Language>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  latestCustomer?: InputMaybe<PubNubCustomerModel>;
  source: Scalars['String']['input'];
  spam_status: PubNubSpamStatus;
};

export enum PubNubPaymentRequestCancellationReason {
  Abandoned = 'ABANDONED',
  Duplicate = 'DUPLICATE',
  Fraudulent = 'FRAUDULENT',
  RequestedByCustomer = 'REQUESTED_BY_CUSTOMER',
}

export type PubNubPaymentRequestConversation = {
  id: Scalars['String']['input'];
};

export type PubNubPaymentRequestDispute = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type PubNubPaymentRequestModel = {
  amount: Scalars['Int']['input'];
  amount_captured: Scalars['Int']['input'];
  application_id?: InputMaybe<Scalars['String']['input']>;
  attachment_filename?: InputMaybe<Scalars['String']['input']>;
  attachment_url?: InputMaybe<Scalars['String']['input']>;
  billing_address?: InputMaybe<Scalars['String']['input']>;
  billing_email?: InputMaybe<Scalars['String']['input']>;
  billing_last_four_digits?: InputMaybe<Scalars['String']['input']>;
  billing_method?: InputMaybe<Scalars['String']['input']>;
  billing_name?: InputMaybe<Scalars['String']['input']>;
  canceled_at?: InputMaybe<Scalars['DateTime']['input']>;
  canceled_by?: InputMaybe<PubnubPaymentRequestParticipantModel>;
  cancellation_reason?: InputMaybe<PubNubPaymentRequestCancellationReason>;
  capture_method: Scalars['String']['input'];
  charged?: InputMaybe<Scalars['DateTime']['input']>;
  conversation?: InputMaybe<PubNubPaymentRequestConversation>;
  created_on: Scalars['DateTime']['input'];
  currency: PubNubCurrency;
  customer: PubnubPaymentRequestCustomerParticipantModel;
  description?: InputMaybe<Scalars['String']['input']>;
  disputes?: InputMaybe<Array<PubNubPaymentRequestDispute>>;
  encoded_id: Scalars['String']['input'];
  failure_code?: InputMaybe<Scalars['String']['input']>;
  failure_message?: InputMaybe<Scalars['String']['input']>;
  hold_expiration?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  last_opened?: InputMaybe<Scalars['DateTime']['input']>;
  last_updated: Scalars['DateTime']['input'];
  net_amount: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  order_id?: InputMaybe<Scalars['String']['input']>;
  outcome_reason?: InputMaybe<Scalars['String']['input']>;
  outcome_seller_message?: InputMaybe<Scalars['String']['input']>;
  outcome_type?: InputMaybe<Scalars['String']['input']>;
  place: PubNubPaymentRequestPlaceModel;
  receipt_url?: InputMaybe<Scalars['String']['input']>;
  refunds?: InputMaybe<Array<PubNubPaymentRequestRefund>>;
  requested?: InputMaybe<Scalars['DateTime']['input']>;
  sender: PubnubPaymentRequestParticipantModel;
  status: PubNubPaymentRequestStatus;
  stripe_url?: InputMaybe<Scalars['String']['input']>;
  total_refunded_amount: Scalars['Int']['input'];
};

export type PubNubPaymentRequestPlaceModel = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PubNubPaymentRequestRefund = {
  amount: Scalars['Int']['input'];
  completed_on: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  issuer: PubnubPaymentRequestParticipantModel;
  net_amount: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason: PubNubPaymentRequestRefundReason;
  status: PubNubPaymentRequestRefundStatus;
  type: PubNubPaymentRequestRefundType;
};

export enum PubNubPaymentRequestRefundReason {
  Duplicate = 'DUPLICATE',
  Fraudulent = 'FRAUDULENT',
  Requested = 'REQUESTED',
}

export enum PubNubPaymentRequestRefundStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
}

export enum PubNubPaymentRequestRefundType {
  Full = 'FULL',
  Partial = 'PARTIAL',
}

export enum PubNubPaymentRequestStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Hold = 'HOLD',
  PartialRefund = 'PARTIAL_REFUND',
  Refund = 'REFUND',
  Success = 'SUCCESS',
  Waiting = 'WAITING',
}

export type PubNubPlaceModel = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primary_mdn: Scalars['String']['input'];
};

export type PubNubQualificationSurvey = {
  buyout_amount_range?: InputMaybe<Scalars['String']['input']>;
  condition: Scalars['String']['input'];
  current_loan_amount_range?: InputMaybe<Scalars['String']['input']>;
  equity_trade_opportunity?: InputMaybe<PubNubQualificationSurveyOpportunityModel>;
  id: Scalars['String']['input'];
  interested_in_trading?: InputMaybe<Scalars['Boolean']['input']>;
  lease_remaining_time_range?: InputMaybe<Scalars['String']['input']>;
  ownership_status: Scalars['String']['input'];
  score?: InputMaybe<Scalars['Int']['input']>;
};

export type PubNubQualificationSurveyOpportunityModel = {
  closed_by_participant?: InputMaybe<PubNubQualificationSurveyOpportunityParticipantModel>;
  id: Scalars['String']['input'];
  stage: PubNubQualificationSurveyOpportunityStage;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PubNubQualificationSurveyOpportunityParticipantModel = {
  display_name: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export enum PubNubQualificationSurveyOpportunityStage {
  Expired = 'EXPIRED',
  FollowUp = 'FOLLOW_UP',
  Ineligible = 'INELIGIBLE',
  Lost = 'LOST',
  Prospect = 'PROSPECT',
  QualificationAnswered = 'QUALIFICATION_ANSWERED',
  Qualified = 'QUALIFIED',
  Unqualified = 'UNQUALIFIED',
  Void = 'VOID',
  Won = 'WON',
}

export type PubNubReasonSentIntentModel = {
  display_name: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PubNubReasonSentModel = {
  intent?: InputMaybe<PubNubReasonSentIntentModel>;
  kind: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PubNubRepairOrder = {
  completed_time?: InputMaybe<Scalars['DateTime']['input']>;
  created_on: Scalars['DateTime']['input'];
  dms_status?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  last_dms_update?: InputMaybe<Scalars['DateTime']['input']>;
  opened_time?: InputMaybe<Scalars['String']['input']>;
  order_number: Scalars['String']['input'];
  promised_time?: InputMaybe<Scalars['DateTime']['input']>;
  repair_order_type: PubNubRepairOrderType;
  service_advisor_name?: InputMaybe<Scalars['String']['input']>;
  status: PubNubRepairOrderStatus;
  status_item?: InputMaybe<PubNubRepairOrderStatusItem>;
  tag_number?: InputMaybe<Scalars['String']['input']>;
  transportation_flags?: InputMaybe<Scalars['String']['input']>;
  vehicle_make_friendly?: InputMaybe<Scalars['String']['input']>;
  vehicle_model_friendly?: InputMaybe<Scalars['String']['input']>;
  vehicle_vin?: InputMaybe<Scalars['String']['input']>;
  vehicle_year?: InputMaybe<Scalars['Int']['input']>;
};

export enum PubNubRepairOrderStatus {
  Active = 'ACTIVE',
  Complete = 'COMPLETE',
}

export type PubNubRepairOrderStatusItem = {
  color: PubNubStatusItemColor;
  id: Scalars['String']['input'];
  last_update_time?: InputMaybe<Scalars['DateTime']['input']>;
  status: PubNubStatusItemStatus;
};

export enum PubNubRepairOrderType {
  Cdk = 'CDK',
  Dealerbuilt = 'DEALERBUILT',
  Dealertrack = 'DEALERTRACK',
  Manual = 'MANUAL',
  Pbs = 'PBS',
  Reynolds = 'REYNOLDS',
  Tekion = 'TEKION',
}

export type PubNubSenderModel = {
  address: Scalars['String']['input'];
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  display_name: Scalars['String']['input'];
  display_name_confidence: PubNubParticipantDataConfidence;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  is_employee: Scalars['Boolean']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
};

export enum PubNubSessionOutcome {
  Booked = 'BOOKED',
  CantService = 'CANT_SERVICE',
  Hangup = 'HANGUP',
  Human = 'HUMAN',
  Lead = 'LEAD',
}

export enum PubNubSpamStatus {
  SuspectedSpam = 'SUSPECTED_SPAM',
  Unknown = 'UNKNOWN',
  UserReportedNotSpam = 'USER_REPORTED_NOT_SPAM',
  UserReportedSpam = 'USER_REPORTED_SPAM',
}

export type PubNubStageModel = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  place_id: Scalars['String']['input'];
};

export type PubNubStatusItemAssigneeModel = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  place_id?: InputMaybe<Scalars['String']['input']>;
};

export enum PubNubStatusItemColor {
  Green = 'GREEN',
  Red = 'RED',
  Yellow = 'YELLOW',
}

export type PubNubStatusItemConversationModel = {
  conversation_labels?: InputMaybe<Array<PubNubConversationLabelsStub>>;
  escalated?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  inbox_id: Scalars['String']['input'];
  last_updated: Scalars['DateTime']['input'];
  state: ConversationState;
  waiting_since?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PubNubStatusItemModel = {
  assignee: PubNubStatusItemAssigneeModel;
  color: PubNubStatusItemColor;
  conversation?: InputMaybe<PubNubStatusItemConversationModel>;
  created_on: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  eta?: InputMaybe<Scalars['String']['input']>;
  held_since?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  last_update_time: Scalars['DateTime']['input'];
  order_number: Scalars['String']['input'];
  participant?: InputMaybe<PubNubStatusItemParticipantModel>;
  stage: PubNubStageModel;
  status: PubNubStatusItemStatus;
  tag: Scalars['String']['input'];
};

export type PubNubStatusItemParticipantModel = {
  address: Scalars['String']['input'];
  display_name: Scalars['String']['input'];
  display_name_confidence: PubNubParticipantDataConfidence;
  first_name: Scalars['String']['input'];
  id: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
};

export enum PubNubStatusItemStatus {
  Active = 'ACTIVE',
  Done = 'DONE',
  Hold = 'HOLD',
}

export type PubNubStatusItemUpdateModel = {
  assignee: PubNubStatusItemAssigneeModel;
  color: PubNubStatusItemColor;
  conversation?: InputMaybe<PubNubStatusItemConversationModel>;
  created_on: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  eta?: InputMaybe<Scalars['String']['input']>;
  held_since?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  last_update_time: Scalars['DateTime']['input'];
  order_number: Scalars['String']['input'];
  participant?: InputMaybe<PubNubStatusItemParticipantModel>;
  prev_assignee_id: Scalars['String']['input'];
  prev_color: PubNubStatusItemColor;
  prev_status: PubNubStatusItemStatus;
  stage: PubNubStageModel;
  status: PubNubStatusItemStatus;
  tag: Scalars['String']['input'];
};

export enum PubNubStripeAccountType {
  AccountOnboarding = 'ACCOUNT_ONBOARDING',
  AccountUpdate = 'ACCOUNT_UPDATE',
  Custom = 'CUSTOM',
  Express = 'EXPRESS',
  Standard = 'STANDARD',
}

export type PubNubStripeIntegrationModel = {
  id: Scalars['String']['input'];
  place_id: Scalars['String']['input'];
  stripe_account_id?: InputMaybe<Scalars['String']['input']>;
  stripe_account_status?: InputMaybe<Scalars['String']['input']>;
  stripe_account_type?: InputMaybe<PubNubStripeAccountType>;
};

export type PubNubTaskModel = {
  completed_at?: InputMaybe<Scalars['DateTime']['input']>;
  completed_by_participant?: InputMaybe<PubNubTaskParticipantModel>;
  completion_source?: InputMaybe<Scalars['String']['input']>;
  created_by_participant?: InputMaybe<PubNubTaskParticipantModel>;
  created_on?: InputMaybe<Scalars['DateTime']['input']>;
  creation_source?: InputMaybe<Scalars['String']['input']>;
  dismissal_source?: InputMaybe<Scalars['String']['input']>;
  dismissed_at?: InputMaybe<Scalars['DateTime']['input']>;
  dismissed_by_participant?: InputMaybe<PubNubTaskParticipantModel>;
  engagement_id: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  status: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type PubNubTaskParticipantModel = {
  display_name: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export enum PubNubTeamAssignmentStyle {
  Manual = 'MANUAL',
  RoundRobin = 'ROUND_ROBIN',
}

export type PubNubTeamModel = {
  avatar: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  place_id: Scalars['String']['input'];
};

export type PubNubTeamModelStub = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PubNubTeamSettingsModel = {
  assignment_style: PubNubTeamAssignmentStyle;
  avatar: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  place_id: Scalars['String']['input'];
  state: PubNubTeamState;
  user_count: Scalars['Int']['input'];
};

export enum PubNubTeamState {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
}

export type PubNubTranscriptAnalysisModel = {
  call_type?: InputMaybe<Scalars['String']['input']>;
  coaching_sample?: InputMaybe<Scalars['String']['input']>;
  coaching_tip?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  next_steps?: InputMaybe<Scalars['String']['input']>;
  scores?: InputMaybe<Array<PubNubTranscriptAnalysisScoreModel>>;
  sections?: InputMaybe<Array<PubNubTranscriptAnalysisSectionModel>>;
  subject?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PubNubTranscriptAnalysisScoreModel = {
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  rating: Scalars['Float']['input'];
};

export type PubNubTranscriptAnalysisSectionModel = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
};

export type PubNubTranscriptEventModel = {
  confidence: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
  id: Scalars['String']['input'];
  speaker: Scalars['Int']['input'];
  speaker_confidence: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
  text: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
  type: PubNubTranscriptEventType;
};

export enum PubNubTranscriptEventType {
  AgentStep = 'AGENT_STEP',
  RecordedSpeech = 'RECORDED_SPEECH',
  RecordingPaused = 'RECORDING_PAUSED',
  RecordingStarted = 'RECORDING_STARTED',
  Speech = 'SPEECH',
}

export type PubNubTranscriptModel = {
  analysis?: InputMaybe<PubNubTranscriptAnalysisModel>;
  events?: InputMaybe<Array<InputMaybe<PubNubTranscriptEventModel>>>;
  id: Scalars['String']['input'];
};

export type PubNubUser = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
};

export type PubNubVideoUploadLinkModel = {
  created_on: Scalars['DateTime']['input'];
  duration?: InputMaybe<Scalars['Float']['input']>;
  external_id: Scalars['String']['input'];
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size?: InputMaybe<Scalars['Int']['input']>;
  has_been_sent: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  participant?: InputMaybe<PubNubVideoUploadLinkParticipantModel>;
  place_id: Scalars['String']['input'];
  playback_hls?: InputMaybe<Scalars['String']['input']>;
  preview_url?: InputMaybe<Scalars['String']['input']>;
  ready_to_stream: Scalars['Boolean']['input'];
  status: PubNubVideoUploadStatus;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  upload_url: Scalars['String']['input'];
  uploader?: InputMaybe<PubNubVideoUploadLinkUploaderModel>;
};

export type PubNubVideoUploadLinkParticipantModel = {
  address: Scalars['String']['input'];
  display_name: Scalars['String']['input'];
  display_name_confidence: PubNubParticipantDataConfidence;
  id: Scalars['String']['input'];
  source: Scalars['String']['input'];
};

export type PubNubVideoUploadLinkUploaderModel = {
  display_name: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export enum PubNubVideoUploadStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
}

export type PublicListingQl = {
  __typename?: 'PublicListingQL';
  id: Scalars['String']['output'];
  isPublished: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type PublishAutomation = {
  __typename?: 'PublishAutomation';
  automation?: Maybe<AutomationQl>;
};

export type PublishAutomationInput = {
  automationId: Scalars['String']['input'];
  state?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PublishDisruptionVoiceScript = {
  __typename?: 'PublishDisruptionVoiceScript';
  place?: Maybe<PlaceQl>;
};

export type PublishDisruptionVoiceScriptInput = {
  answeringMode: AnsweringMode;
  placeId: Scalars['String']['input'];
  policyCategory: PhoneLinePolicyCategory;
  scriptId: Scalars['String']['input'];
};

export type PublishVoiceScript = {
  __typename?: 'PublishVoiceScript';
  answeringScript?: Maybe<AnsweringScriptsQl>;
};

export type PublishVoiceScriptInput = {
  answeringScriptId: Scalars['String']['input'];
  scriptId: Scalars['String']['input'];
};

export type PubnubPaymentRequestCustomerParticipantModel = {
  address: Scalars['String']['input'];
  display_name: Scalars['String']['input'];
  display_name_confidence: PubNubParticipantDataConfidence;
  id: Scalars['String']['input'];
  source: Scalars['String']['input'];
};

export type PubnubPaymentRequestParticipantModel = {
  display_name: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export enum PushNotificationSettings {
  Everything = 'EVERYTHING',
  EverythingButMuted = 'EVERYTHING_BUT_MUTED',
  None = 'NONE',
  OnlyMine = 'ONLY_MINE',
}

export enum PushNotificationSettingsInput {
  Everything = 'EVERYTHING',
  EverythingButMuted = 'EVERYTHING_BUT_MUTED',
  None = 'NONE',
  OnlyMine = 'ONLY_MINE',
}

export type QualificationSurveyQl = BaseQl &
  Node & {
    __typename?: 'QualificationSurveyQL';
    buyoutAmountRange?: Maybe<Scalars['String']['output']>;
    condition?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    currentLoanAmountRange?: Maybe<Scalars['String']['output']>;
    equityTradeOpportunity?: Maybe<EquityTradeOpportunityQl>;
    equityTradeOpportunityId: Scalars['String']['output'];
    externalId?: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
    interestedInTrading?: Maybe<Scalars['Boolean']['output']>;
    isComplete?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    leaseRemainingTimeRange?: Maybe<Scalars['String']['output']>;
    messages?: Maybe<MessageQlConnection>;
    ownershipStatus?: Maybe<Scalars['String']['output']>;
    score?: Maybe<Scalars['Int']['output']>;
    status: Scalars['String']['output'];
  };

export type QualificationSurveyQlMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'QualifyStepQL';
    acknowledgeResponseSpeechUrl: Scalars['String']['output'];
    acknowledgementSpeech: Scalars['String']['output'];
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponse?: Maybe<VoiceScriptStepQl>;
    onHasResponseId?: Maybe<Scalars['String']['output']>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponse?: Maybe<VoiceScriptStepQl>;
    onNoResponseId?: Maybe<Scalars['String']['output']>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    responseMappings?: Maybe<Scalars['JSONString']['output']>;
    shorthandPrompt: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type QualifyStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type QualifyStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type QualifyStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QualifyStepQlConnection = {
  __typename?: 'QualifyStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<QualifyStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `QualifyStepQL` and its cursor. */
export type QualifyStepQlEdge = {
  __typename?: 'QualifyStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<QualifyStepQl>;
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<AccountQl>;
  /** @deprecated Use currentAccount instead. */
  accountSettings?: Maybe<AccountSettingsQl>;
  accounts?: Maybe<AccountConnection>;
  activeAdvisorId?: Maybe<Scalars['String']['output']>;
  activeInboundPhoneCalls: Array<PhoneCallQl>;
  activeInbox?: Maybe<ActiveInbox>;
  activeIntegration?: Maybe<ActiveIntegrationQl>;
  activeIntegrations?: Maybe<Array<ActiveIntegrationQl>>;
  activePaymentsCollection?: Maybe<ActivePaymentsCollection>;
  activePhoneCallsWithoutMessages: Array<PhoneCallQl>;
  answeringScript?: Maybe<AnsweringScriptsQl>;
  appointmentAgentNoteRating?: Maybe<AppointmentAgentNoteRatingQl>;
  appointmentAgentSettings?: Maybe<AppointmentAgentSettingsQl>;
  appointmentAgents: Array<AppointmentAgentSettingsQl>;
  assignmentRoutingSettings?: Maybe<AssignmentRoutingSettingQl>;
  attachment?: Maybe<Attachment>;
  autocompleteConversations?: Maybe<ConversationConnection>;
  autocompleteParticipants?: Maybe<ParticipantConnection>;
  autocompleteShortcuts?: Maybe<ShortcutConnection>;
  autocompleteTeams?: Maybe<TeamConnection>;
  autocompleteUsers?: Maybe<UserConnection>;
  automation?: Maybe<AutomationQl>;
  automationJobs?: Maybe<AutomationJobConnection>;
  automations?: Maybe<AutomationConnection>;
  autopilot?: Maybe<AutopilotQl>;
  autopilotJob?: Maybe<AutopilotJobQl>;
  availableIntegrations?: Maybe<Array<AvailableIntegrationQl>>;
  availableVoiceScripts?: Maybe<Array<AvailableVoiceScript>>;
  billingIdentities?: Maybe<BillingIdentityConnection>;
  billingMetadata?: Maybe<BillingMetadataQl>;
  brandTheme?: Maybe<BrandThemeQl>;
  businessProfile?: Maybe<BusinessProfileQl>;
  businessProfiles: Array<Maybe<BusinessProfileQl>>;
  callIntelligenceRating?: Maybe<CallIntelligenceRatingQl>;
  callIntelligenceSetting?: Maybe<CallIntelligenceSettingQl>;
  /** Get call records for the specified places. */
  callRecords?: Maybe<CallRecordConnection>;
  campaign?: Maybe<CampaignQl>;
  channel?: Maybe<Channel>;
  channels?: Maybe<Array<Maybe<Channel>>>;
  chargebeeSubscriptions?: Maybe<Array<Maybe<ChargeBeeSubscription>>>;
  complianceReminder?: Maybe<ComplianceReminder>;
  complianceSettings?: Maybe<ComplianceSettingsQl>;
  conversation?: Maybe<ConversationQl>;
  conversationByPhoneNumberAndPlace?: Maybe<ConversationQl>;
  conversationStats?: Maybe<ConversationStatsQl>;
  conversations?: Maybe<ConversationConnection>;
  cube?: Maybe<CubeJwtTokenQl>;
  currentAccount?: Maybe<AccountQl>;
  currentUser?: Maybe<UserQl>;
  customer?: Maybe<CustomerQl>;
  department?: Maybe<DepartmentQl>;
  departmentDevices?: Maybe<Array<DepartmentDeviceQl>>;
  departmentDirectoryEntry?: Maybe<DepartmentDirectoryEntryQl>;
  directoryEntries: Array<DirectoryEntryQl>;
  /** @deprecated we should switch to using userDirectoryEntry as directoryEntry should be reserved for a future query */
  directoryEntry?: Maybe<UserDirectoryEntryQl>;
  dmsObjectHistory?: Maybe<DmsHistoryConnection>;
  employees: Array<EmployeeQl>;
  equityTradeOpportunity?: Maybe<EquityTradeOpportunityQl>;
  etoSettings?: Maybe<EtoSettingsQl>;
  externalCrmUsers?: Maybe<Array<ExternalCrmUserQl>>;
  externalVehicles?: Maybe<ExternalVehicleConnection>;
  fortellisSubscription?: Maybe<FortellisSubscriptionQl>;
  fortellisSubscriptions?: Maybe<FortellisSubscriptionConnection>;
  getDefaultBroadcastInput?: Maybe<DefaultBroadcastInputsQl>;
  guideChecklist?: Maybe<GuideChecklistQl>;
  hostedSmsPorts?: Maybe<Array<Maybe<HostedSmsPortQl>>>;
  identityPromptAddresses: Array<IdentityPromptAddressQl>;
  inbox?: Maybe<InboxQl>;
  inboxes?: Maybe<InboxConnection>;
  knownIntegrationCategories: Array<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<LabelQl>>>;
  listCampaigns?: Maybe<Array<Maybe<CampaignQl>>>;
  manualOpportunitiesByPlace?: Maybe<Array<Maybe<ManualOpportunityQl>>>;
  manualOpportunityReport?: Maybe<ManualOpportunityReportQl>;
  mentionedConversations?: Maybe<ConversationConnection>;
  messageMetadata?: Maybe<MessageMetadataQl>;
  messages?: Maybe<MessageConnection>;
  myInboxes?: Maybe<InboxConnection>;
  /** Manager dashboard for current user. Null if user does not manage any places. */
  myManagerDashboard?: Maybe<ManagerDashboard>;
  noteTaker?: Maybe<NoteTakerQl>;
  noteTakers?: Maybe<NoteTakerConnection>;
  numaServices?: Maybe<Array<NumaServiceQl>>;
  operator?: Maybe<OperatorQl>;
  operatorChannel?: Maybe<OperatorChannelQl>;
  operatorChannels: Array<OperatorChannelQl>;
  operatorPlace?: Maybe<OperatorPlaceQl>;
  operatorPlaces: Array<OperatorPlaceQl>;
  operatorSession?: Maybe<OperatorSessionQl>;
  operatorSessions?: Maybe<OperatorSessionConnection>;
  operatorSettings?: Maybe<OperatorSettingsQl>;
  operators?: Maybe<Array<OperatorQl>>;
  outboundCallCustomization?: Maybe<OutboundCallCustomizationQl>;
  outboundCallCustomizationAudio?: Maybe<Scalars['String']['output']>;
  outboundCallCustomizations: Array<OutboundCallCustomizationQl>;
  outboundConferenceCall?: Maybe<OutboundConferenceCallQl>;
  outboundConferenceCalls?: Maybe<Array<Maybe<OutboundConferenceCallQl>>>;
  outboundPhoneChannels?: Maybe<Array<Maybe<Channel>>>;
  outboundProxyCall?: Maybe<OutboundProxyCallQl>;
  participant?: Maybe<ParticipantQl>;
  participantVideoUploadLinks?: Maybe<Array<Maybe<VideoUploadLinkQl>>>;
  paymentRequest?: Maybe<PaymentRequestQl>;
  paymentRequestCustomization?: Maybe<PaymentRequestCustomizationQl>;
  paymentRequests?: Maybe<PaymentRequestConnection>;
  phoneLinePolicy?: Maybe<PhoneLinePolicyQl>;
  phoneline?: Maybe<PhoneLineQl>;
  phonelines?: Maybe<Array<Maybe<PhoneLineQl>>>;
  place?: Maybe<PlaceQl>;
  placeAllowsCustomAudio?: Maybe<Scalars['Boolean']['output']>;
  placeGroup?: Maybe<PlaceGroupQl>;
  placeGroups?: Maybe<PlaceGroupConnection>;
  placeInbox?: Maybe<InboxQl>;
  placeInfo?: Maybe<PlaceInfoQl>;
  placeRepairOrderSmartStatusUpdateSettings?: Maybe<RepairOrderSmartStatusUpdateSettingsQl>;
  placeVoiceSettings?: Maybe<PlaceVoiceSettingsQl>;
  places?: Maybe<PlaceConnection>;
  placesUser?: Maybe<PlacesUsersQl>;
  placesUsers?: Maybe<Array<Maybe<PlacesUsersQl>>>;
  pubnub?: Maybe<PubNubConfigQl>;
  questionAgentSettings?: Maybe<QuestionAgentSettingsQl>;
  questionAgents: Array<QuestionAgentSettingsQl>;
  repairOrderNotes?: Maybe<Scalars['String']['output']>;
  repairOrderNotesSummary?: Maybe<RepairOrderNotesSummaryQl>;
  repairOrders?: Maybe<RepairOrderConnection>;
  repairServices?: Maybe<Array<RepairServiceQl>>;
  reviewJob?: Maybe<ReviewJobQl>;
  scheduledMessages?: Maybe<ScheduleMessageConnection>;
  schedulerLogs?: Maybe<Array<Maybe<SchedulerLogQl>>>;
  schedulerSync?: Maybe<SchedulerSyncQl>;
  searchMessagesByContent?: Maybe<MessageConnection>;
  shortcut?: Maybe<ShortcutQl>;
  shortcuts?: Maybe<ShortcutConnection>;
  skuEntitlements?: Maybe<SkuEntitlementsQl>;
  skus?: Maybe<SkuConnection>;
  stages?: Maybe<Array<Maybe<StageQl>>>;
  statusItem?: Maybe<StatusItemQl>;
  statusItems?: Maybe<StatusItemConnection>;
  stripeIntegration?: Maybe<StripeIntegrationQl>;
  supportedVehicleSet?: Maybe<SupportedVehiclesQl>;
  supportedVehicles?: Maybe<SupportedVehiclesConnection>;
  team?: Maybe<TeamQl>;
  teams?: Maybe<Array<Maybe<TeamQl>>>;
  tenDlcProcessById?: Maybe<TenDlcProcessQl>;
  tenDlcProcessByPlace?: Maybe<TenDlcProcessQl>;
  tenDlcProcesses?: Maybe<Array<Maybe<TenDlcProcessQl>>>;
  tenDlcStatus?: Maybe<TenDlcStatusQl>;
  transcript?: Maybe<TranscriptQl>;
  transportationSetOptionSpeech?: Maybe<Scalars['String']['output']>;
  transportationSetSpeech?: Maybe<Scalars['String']['output']>;
  transportationSets?: Maybe<Array<TransportationSetQl>>;
  trustProducts?: Maybe<Array<Maybe<TwilioTrustProductQl>>>;
  uploadedVideoUploadLinks?: Maybe<Array<Maybe<VideoUploadLinkQl>>>;
  user?: Maybe<UserQl>;
  userAssignedPhonelines?: Maybe<Array<Maybe<PhoneLineQl>>>;
  userDirectoryEntry?: Maybe<UserDirectoryEntryQl>;
  userIdsByTeamId?: Maybe<Array<Scalars['String']['output']>>;
  userPhones?: Maybe<Array<UserPhoneQl>>;
  users?: Maybe<UserConnection>;
  /** Retrieves users in the account of the caller, ignoring support permissions */
  usersAccount?: Maybe<UserConnection>;
  videoUploadLink?: Maybe<VideoUploadLinkQl>;
  voiceAppointmentAgentSettingsAudio?: Maybe<Scalars['String']['output']>;
  voiceConfigurations?: Maybe<Array<VoiceConfigurationQl>>;
  voiceScript?: Maybe<VoiceScriptQl>;
  voiceScripts?: Maybe<Array<VoiceScriptQl>>;
  voiceStepAppointmentAgent?: Maybe<AppointmentAgentStepQl>;
  voiceStepAudio?: Maybe<Scalars['String']['output']>;
  voiceStepConversationalSchedulingAgent?: Maybe<ConversationalSchedulingAgentStepQl>;
  voices: Array<Voice>;
  /** Get WriteItForMe configuration for a place */
  writeItForMeConfig?: Maybe<WriteItForMeConfigQl>;
  /** @deprecated Use scheduler_logs instead. */
  xtimeLogs?: Maybe<Array<Maybe<XTimeLogModelQl>>>;
  xtimeServices: Array<XtimeServiceQl>;
  /** @deprecated Use scheduler_sync instead. */
  xtimeSync?: Maybe<XTimeSyncModelQl>;
};

export type QueryAccountArgs = {
  id: Scalars['String']['input'];
};

export type QueryAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<AccountModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<AccountModelSortEnum>>>;
};

export type QueryActiveInboundPhoneCallsArgs = {
  userId: Scalars['String']['input'];
};

export type QueryActiveIntegrationArgs = {
  integrationId: Scalars['String']['input'];
};

export type QueryActiveIntegrationsArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryActivePhoneCallsWithoutMessagesArgs = {
  conversationId: Scalars['String']['input'];
};

export type QueryAnsweringScriptArgs = {
  answeringScriptId: Scalars['String']['input'];
};

export type QueryAppointmentAgentNoteRatingArgs = {
  dialogFlowBotDataId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type QueryAppointmentAgentSettingsArgs = {
  id: Scalars['String']['input'];
};

export type QueryAppointmentAgentsArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryAssignmentRoutingSettingsArgs = {
  placeId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type QueryAttachmentArgs = {
  id: Scalars['String']['input'];
};

export type QueryAutocompleteConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<ConversationModelFilter>;
  search: Scalars['String']['input'];
  sort?: InputMaybe<Array<InputMaybe<ConversationModelSortEnum>>>;
};

export type QueryAutocompleteParticipantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<ParticipantModelFilter>;
  search: Scalars['String']['input'];
  sort?: InputMaybe<Array<InputMaybe<ParticipantModelSortEnum>>>;
};

export type QueryAutocompleteShortcutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  placeId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  searchTag?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ShortcutModelSortEnum>>>;
};

export type QueryAutocompleteTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeEmptyTeams?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  search: Scalars['String']['input'];
  sort?: InputMaybe<Array<InputMaybe<TeamModelSortEnum>>>;
};

export type QueryAutocompleteUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  search: Scalars['String']['input'];
  sort?: InputMaybe<Array<InputMaybe<UserModelSortEnum>>>;
};

export type QueryAutomationArgs = {
  automationId: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAutomationJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<AutomationJobModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<AutomationJobModelSortEnum>>>;
};

export type QueryAutomationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  placeId: Scalars['String']['input'];
  triggerType?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAutopilotArgs = {
  conversationId: Scalars['String']['input'];
};

export type QueryAutopilotJobArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryAvailableVoiceScriptsArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryBillingIdentitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<BillingIdentityModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<BillingIdentityModelSortEnum>>>;
};

export type QueryBillingMetadataArgs = {
  billingMetadataId: Scalars['String']['input'];
};

export type QueryBrandThemeArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryBusinessProfileArgs = {
  businessProfileId: Scalars['String']['input'];
};

export type QueryBusinessProfilesArgs = {
  accountId: Scalars['String']['input'];
};

export type QueryCallIntelligenceRatingArgs = {
  transcriptAnalysisId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCallIntelligenceSettingArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryCallRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  callDirection?: InputMaybe<Scalars['String']['input']>;
  createdAfter?: InputMaybe<Scalars['ArrowField']['input']>;
  createdBefore?: InputMaybe<Scalars['ArrowField']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyCallIntelligenceEligible?: InputMaybe<Scalars['Boolean']['input']>;
  placeIds: Array<InputMaybe<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCampaignArgs = {
  campaignId: Scalars['String']['input'];
};

export type QueryChannelArgs = {
  id: Scalars['String']['input'];
};

export type QueryChannelsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryChargebeeSubscriptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryComplianceReminderArgs = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  isNewConversation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryConversationArgs = {
  conversationId: Scalars['String']['input'];
};

export type QueryConversationByPhoneNumberAndPlaceArgs = {
  phoneNumber: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type QueryConversationStatsArgs = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
};

export type QueryConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<AssignmentFilterInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasStatusItems?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<ConversationModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<ConversationModelSortEnum>>>;
};

export type QueryCustomerArgs = {
  customerId: Scalars['String']['input'];
};

export type QueryDepartmentArgs = {
  id: Scalars['String']['input'];
};

export type QueryDepartmentDevicesArgs = {
  departmentId: Scalars['String']['input'];
};

export type QueryDepartmentDirectoryEntryArgs = {
  departmentId: Scalars['String']['input'];
  placeGroupId: Scalars['String']['input'];
};

export type QueryDirectoryEntriesArgs = {
  entryType?: InputMaybe<DirectoryEntryType>;
  isDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  placeGroupId: Scalars['String']['input'];
};

export type QueryDirectoryEntryArgs = {
  placeGroupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type QueryDmsObjectHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dmsType?: InputMaybe<DmsHistoryType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  numaObjectId: Scalars['String']['input'];
};

export type QueryEmployeesArgs = {
  activeIntegrationId: Scalars['String']['input'];
  cdkClearCache?: InputMaybe<Scalars['Boolean']['input']>;
  clearCache?: InputMaybe<Scalars['Boolean']['input']>;
  serviceAdvisorType?: InputMaybe<ServiceAdvisorType>;
  skipRos?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryEquityTradeOpportunityArgs = {
  conversationId: Scalars['String']['input'];
};

export type QueryEtoSettingsArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryExternalCrmUsersArgs = {
  activeIntegrationId: Scalars['String']['input'];
};

export type QueryExternalVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentAgentSettingsId: Scalars['String']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<ExternalVehicleModelFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ExternalVehicleModelSortEnum>>>;
};

export type QueryFortellisSubscriptionArgs = {
  accountId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type QueryFortellisSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<FortellisSubscriptionModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<FortellisSubscriptionModelSortEnum>>>;
};

export type QueryGetDefaultBroadcastInputArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryGuideChecklistArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryHostedSmsPortsArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryIdentityPromptAddressesArgs = {
  channelId: Scalars['String']['input'];
};

export type QueryInboxArgs = {
  id: Scalars['String']['input'];
};

export type QueryInboxesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<InboxModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<InboxModelSortEnum>>>;
};

export type QueryLabelsArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryManualOpportunitiesByPlaceArgs = {
  input: ManualOpportunitiesByPlaceInput;
};

export type QueryManualOpportunityReportArgs = {
  input: ManualOpportunityReportInput;
};

export type QueryMentionedConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<ConversationModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<ConversationModelSortEnum>>>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryMessageMetadataArgs = {
  messageId: Scalars['String']['input'];
};

export type QueryMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<MessageModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<MessageModelSortEnum>>>;
};

export type QueryMyInboxesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryNoteTakerArgs = {
  id: Scalars['String']['input'];
};

export type QueryNoteTakersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  placeId: Scalars['String']['input'];
  queryFilter?: InputMaybe<NoteTakerModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<NoteTakerModelSortEnum>>>;
};

export type QueryNumaServicesArgs = {
  appointmentAgentSettingsId: Scalars['String']['input'];
};

export type QueryOperatorArgs = {
  id: Scalars['String']['input'];
};

export type QueryOperatorChannelArgs = {
  channelId: Scalars['String']['input'];
  operatorId: Scalars['String']['input'];
};

export type QueryOperatorChannelsArgs = {
  operatorId: Scalars['String']['input'];
};

export type QueryOperatorPlaceArgs = {
  operatorId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type QueryOperatorPlacesArgs = {
  operatorId: Scalars['String']['input'];
};

export type QueryOperatorSessionArgs = {
  id: Scalars['String']['input'];
};

export type QueryOperatorSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  operatorId: Scalars['String']['input'];
  placeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  queryFilter?: InputMaybe<OperatorSessionModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<OperatorSessionModelSortEnum>>>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryOperatorSettingsArgs = {
  operatorId: Scalars['String']['input'];
};

export type QueryOperatorsArgs = {
  accountId: Scalars['String']['input'];
};

export type QueryOutboundCallCustomizationArgs = {
  id: Scalars['String']['input'];
};

export type QueryOutboundCallCustomizationAudioArgs = {
  audioField: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type QueryOutboundCallCustomizationsArgs = {
  userId: Scalars['String']['input'];
};

export type QueryOutboundConferenceCallArgs = {
  id: Scalars['String']['input'];
};

export type QueryOutboundConferenceCallsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOutboundPhoneChannelsArgs = {
  placeId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOutboundProxyCallArgs = {
  id: Scalars['String']['input'];
};

export type QueryParticipantArgs = {
  id: Scalars['String']['input'];
};

export type QueryParticipantVideoUploadLinksArgs = {
  participantId: Scalars['String']['input'];
};

export type QueryPaymentRequestArgs = {
  id: Scalars['String']['input'];
};

export type QueryPaymentRequestCustomizationArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryPaymentRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  queryFilter?: InputMaybe<PaymentRequestModelFilter>;
  senderId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PaymentRequestModelSortEnum>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPhoneLinePolicyArgs = {
  phoneLinePolicyId: Scalars['String']['input'];
};

export type QueryPhonelineArgs = {
  phonelineId: Scalars['String']['input'];
};

export type QueryPhonelinesArgs = {
  placeId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPlaceArgs = {
  id: Scalars['String']['input'];
};

export type QueryPlaceAllowsCustomAudioArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryPlaceGroupArgs = {
  id: Scalars['String']['input'];
};

export type QueryPlaceGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<PlaceGroupModelFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PlaceGroupModelSortEnum>>>;
};

export type QueryPlaceInboxArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryPlaceInfoArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryPlaceRepairOrderSmartStatusUpdateSettingsArgs = {
  placeId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryPlaceVoiceSettingsArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryPlacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<PlaceModelFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PlaceModelSortEnum>>>;
};

export type QueryPlacesUserArgs = {
  placeId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type QueryPlacesUsersArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryPubnubArgs = {
  usePamV3?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryQuestionAgentSettingsArgs = {
  id: Scalars['String']['input'];
};

export type QueryQuestionAgentsArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryRepairOrderNotesArgs = {
  repairOrderId: Scalars['String']['input'];
};

export type QueryRepairOrderNotesSummaryArgs = {
  repairOrderId: Scalars['String']['input'];
};

export type QueryRepairOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<RepairOrderModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<RepairOrderModelSortEnum>>>;
  status: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRepairServicesArgs = {
  activeIntegrationId: Scalars['String']['input'];
};

export type QueryReviewJobArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryScheduledMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<ScheduledMessageModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<ScheduledMessageModelSortEnum>>>;
};

export type QuerySchedulerLogsArgs = {
  activeIntegrationId: Scalars['String']['input'];
  syncId?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySchedulerSyncArgs = {
  activeIntegrationId: Scalars['String']['input'];
};

export type QuerySearchMessagesByContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<MessageModelFilter>;
  search: Scalars['String']['input'];
  sort?: InputMaybe<Array<InputMaybe<MessageModelSortEnum>>>;
};

export type QueryShortcutArgs = {
  shortcutId: Scalars['String']['input'];
};

export type QueryShortcutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<ShortcutModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<ShortcutModelSortEnum>>>;
};

export type QuerySkusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<SkuModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<SkuModelSortEnum>>>;
};

export type QueryStagesArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryStatusItemArgs = {
  statusItemId: Scalars['String']['input'];
};

export type QueryStatusItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<StatusItemModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<StatusItemModelSortEnum>>>;
};

export type QueryStripeIntegrationArgs = {
  placeId: Scalars['String']['input'];
};

export type QuerySupportedVehicleSetArgs = {
  id: Scalars['String']['input'];
};

export type QuerySupportedVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<SupportedVehiclesModelFilter>;
  repairServiceId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SupportedVehiclesModelSortEnum>>>;
};

export type QueryTeamArgs = {
  teamId: Scalars['String']['input'];
};

export type QueryTeamsArgs = {
  includeEmptyTeams?: InputMaybe<Scalars['Boolean']['input']>;
  placeId: Scalars['String']['input'];
};

export type QueryTenDlcProcessByIdArgs = {
  trustProductId: Scalars['String']['input'];
};

export type QueryTenDlcProcessByPlaceArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryTenDlcProcessesArgs = {
  accountId: Scalars['String']['input'];
};

export type QueryTenDlcStatusArgs = {
  accountId: Scalars['String']['input'];
};

export type QueryTranscriptArgs = {
  id: Scalars['String']['input'];
};

export type QueryTransportationSetOptionSpeechArgs = {
  transportationSetOptionId: Scalars['String']['input'];
};

export type QueryTransportationSetSpeechArgs = {
  transportationSetId: Scalars['String']['input'];
};

export type QueryTransportationSetsArgs = {
  appointmentAgentSettingsId: Scalars['String']['input'];
};

export type QueryTrustProductsArgs = {
  accountId: Scalars['String']['input'];
};

export type QueryUploadedVideoUploadLinksArgs = {
  uploaderId: Scalars['String']['input'];
};

export type QueryUserArgs = {
  userId: Scalars['String']['input'];
};

export type QueryUserAssignedPhonelinesArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUserDirectoryEntryArgs = {
  placeGroupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type QueryUserIdsByTeamIdArgs = {
  teamId: Scalars['String']['input'];
};

export type QueryUserPhonesArgs = {
  userId: Scalars['String']['input'];
};

export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<UserModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<UserModelSortEnum>>>;
};

export type QueryUsersAccountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<UserModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<UserModelSortEnum>>>;
};

export type QueryVideoUploadLinkArgs = {
  id: Scalars['String']['input'];
};

export type QueryVoiceAppointmentAgentSettingsAudioArgs = {
  appointmentAgentSettingsId: Scalars['String']['input'];
  audioField: Scalars['String']['input'];
};

export type QueryVoiceConfigurationsArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryVoiceScriptArgs = {
  id: Scalars['String']['input'];
};

export type QueryVoiceScriptsArgs = {
  hideStatusUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  placeId: Scalars['String']['input'];
};

export type QueryVoiceStepAppointmentAgentArgs = {
  appointmentAgentSettingsId: Scalars['String']['input'];
};

export type QueryVoiceStepAudioArgs = {
  audioField: Scalars['String']['input'];
  stepId: Scalars['String']['input'];
};

export type QueryVoiceStepConversationalSchedulingAgentArgs = {
  appointmentAgentSettingsId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryWriteItForMeConfigArgs = {
  placeId: Scalars['String']['input'];
};

export type QueryXtimeLogsArgs = {
  activeIntegrationId: Scalars['String']['input'];
  syncId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryXtimeServicesArgs = {
  appointmentAgentSettingsId: Scalars['String']['input'];
  vehicleMake?: InputMaybe<Scalars['String']['input']>;
  vehicleModel?: InputMaybe<Scalars['String']['input']>;
};

export type QueryXtimeSyncArgs = {
  activeIntegrationId: Scalars['String']['input'];
};

export type QuestionAgentSettingsQl = BaseQl &
  Node & {
    __typename?: 'QuestionAgentSettingsQL';
    activeIntegration?: Maybe<ActiveIntegrationQl>;
    activeIntegrationId?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    dialogFlowAgentId: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    settings?: Maybe<Scalars['JSONString']['output']>;
  };

export type QuestionAgentSettingsQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionAgentSettingsQlConnection = {
  __typename?: 'QuestionAgentSettingsQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<QuestionAgentSettingsQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `QuestionAgentSettingsQL` and its cursor. */
export type QuestionAgentSettingsQlEdge = {
  __typename?: 'QuestionAgentSettingsQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<QuestionAgentSettingsQl>;
};

export type QuestionBotStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'QuestionBotStepQL';
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureStepId?: Maybe<Scalars['String']['output']>;
    failureStepRelationship?: Maybe<VoiceScriptStepQl>;
    finishedSpeech: Scalars['String']['output'];
    finishedSpeechAudioUrl: Scalars['String']['output'];
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextStepId?: Maybe<Scalars['String']['output']>;
    nextStepRelationship?: Maybe<VoiceScriptStepQl>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionAgentSettings?: Maybe<QuestionAgentSettingsQl>;
    questionAgentSettingsId?: Maybe<Scalars['String']['output']>;
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type QuestionBotStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type QuestionBotStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type QuestionBotStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBotStepQlConnection = {
  __typename?: 'QuestionBotStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<QuestionBotStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `QuestionBotStepQL` and its cursor. */
export type QuestionBotStepQlEdge = {
  __typename?: 'QuestionBotStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<QuestionBotStepQl>;
};

export type QuestionNode = {
  __typename?: 'QuestionNode';
  /** List of possible answers for this question */
  answers: Array<AnswerOption>;
  /** The answer option that is marked as the default, or NIL if no default */
  defaultAnswer?: Maybe<AnswerOption>;
  /** Unique identifier for this question */
  id: Scalars['String']['output'];
  /** The text of the question to display */
  text: Scalars['String']['output'];
};

export type QuestionTree = {
  __typename?: 'QuestionTree';
  /** A list of nodes containing a question with possible answer choices */
  questions: Array<QuestionNode>;
};

export type RateAppointmentAgentNoteInput = {
  dialogFlowBotDataId: Scalars['ID']['input'];
  rating: AppointmentAgentNoteRatingInput;
};

export type RateAssistedResponseInput = {
  engagementId: Scalars['ID']['input'];
  engagementInboxAgentResultId: Scalars['ID']['input'];
  rating: AssistedResponseRatingInput;
};

export type RateCallIntelligenceInput = {
  rating: CallIntelligenceRatingInput;
  transcriptAnalysisId: Scalars['ID']['input'];
};

export type RateEngagementStatusInput = {
  engagementId: Scalars['ID']['input'];
  rating: EngagementStatusRatingInput;
};

export type RateEngagementSummaryInput = {
  engagementId: Scalars['ID']['input'];
  rating: EngagementSummaryRatingInput;
  summaryId: Scalars['ID']['input'];
};

export type ReasonSentGreetingQl = ReasonSentQl & {
  __typename?: 'ReasonSentGreetingQL';
  kind: ReplyReason;
  name: Scalars['String']['output'];
};

export type ReasonSentHangupResponseQl = ReasonSentQl & {
  __typename?: 'ReasonSentHangupResponseQL';
  channel: Channel;
  kind: ReplyReason;
};

export type ReasonSentIntentQl = ReasonSentQl & {
  __typename?: 'ReasonSentIntentQL';
  intent: AppliedIntentQl;
  kind: ReplyReason;
};

export type ReasonSentQl = {
  kind: ReplyReason;
};

export type RecoverConversation = {
  __typename?: 'RecoverConversation';
  conversation?: Maybe<ConversationQl>;
};

export type RecoverConversationInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export enum RedirectReason {
  ConfirmPrompt = 'CONFIRM_PROMPT',
}

export type RefreshCarrierInfo = {
  __typename?: 'RefreshCarrierInfo';
  phoneline?: Maybe<PhoneLineQl>;
};

export type RefreshCarrierInfoInput = {
  phonelineId: Scalars['String']['input'];
};

export type RefreshFortellisServiceAdvisors = {
  __typename?: 'RefreshFortellisServiceAdvisors';
  fortellisSubscription?: Maybe<FortellisSubscriptionQl>;
};

export type RefreshFortellisServiceAdvisorsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type RefundQl = BaseQl &
  Node & {
    __typename?: 'RefundQL';
    amount: Scalars['Int']['output'];
    completedOn?: Maybe<Scalars['ArrowField']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    issuer?: Maybe<ParticipantQl>;
    issuerId: Scalars['String']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    netAmount: Scalars['Int']['output'];
    note?: Maybe<Scalars['String']['output']>;
    paymentRequest?: Maybe<PaymentRequestQl>;
    paymentRequestId: Scalars['String']['output'];
    reason?: Maybe<RefundReason>;
    refundObject?: Maybe<Scalars['JSONString']['output']>;
    refundObjectId?: Maybe<Scalars['String']['output']>;
    status: RefundStatus;
    type: RefundType;
  };

export type RefundQlConnection = {
  __typename?: 'RefundQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RefundQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RefundQL` and its cursor. */
export type RefundQlEdge = {
  __typename?: 'RefundQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RefundQl>;
};

export enum RefundReason {
  Duplicate = 'DUPLICATE',
  Fraudulent = 'FRAUDULENT',
  Requested = 'REQUESTED',
}

export enum RefundStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
}

export enum RefundType {
  Full = 'FULL',
  Partial = 'PARTIAL',
}

export type RegisterFortellisServiceAdvisor = {
  __typename?: 'RegisterFortellisServiceAdvisor';
  placesUser: PlacesUsersQl;
  serviceAdvisor?: Maybe<FortellisServiceAdvisorQl>;
};

export type RegisterFortellisServiceAdvisorInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  serviceAdvisorId?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RegisteredFortellisServiceAdvisorQl = BaseQl &
  Node & {
    __typename?: 'RegisteredFortellisServiceAdvisorQL';
    activeIntegration?: Maybe<ActiveIntegrationQl>;
    activeIntegrationId?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    fortellisSubscription?: Maybe<FortellisSubscriptionQl>;
    fortellisSubscriptionId?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
    nextFetchTime?: Maybe<Scalars['ArrowField']['output']>;
    placesUser?: Maybe<PlacesUsersQl>;
    placesUsersId: Scalars['String']['output'];
    rawData?: Maybe<Scalars['JSONString']['output']>;
    repairOrderSchedule?: Maybe<Array<Scalars['String']['output']>>;
    serviceAdvisorId?: Maybe<Scalars['String']['output']>;
    type?: Maybe<ServiceAdvisorType>;
  };

export enum RegistrationOption {
  BusinessProfile = 'BUSINESS_PROFILE',
  StarterProfile = 'STARTER_PROFILE',
}

export type RemoveAutomationAction = {
  __typename?: 'RemoveAutomationAction';
  automation?: Maybe<AutomationQl>;
};

export type RemoveAutomationActionInput = {
  actionId: Scalars['String']['input'];
  automationId: Scalars['String']['input'];
  deletionMode: AutomationDeletionMode;
};

export type RemoveAutomationExitTrigger = {
  __typename?: 'RemoveAutomationExitTrigger';
  automation?: Maybe<AutomationQl>;
};

export type RemoveAutomationExitTriggerInput = {
  automationId: Scalars['String']['input'];
  exitTriggerId: Scalars['String']['input'];
};

export type RemoveLabelFromConversation = {
  __typename?: 'RemoveLabelFromConversation';
  conversation: ConversationQl;
};

export type RemoveLabelFromConversationInput = {
  conversationLabelId: Scalars['String']['input'];
};

export type RemovePlaceGroup = {
  __typename?: 'RemovePlaceGroup';
  account?: Maybe<AccountQl>;
};

export type RemovePlaceGroupInput = {
  placeGroupId: Scalars['String']['input'];
};

export type RemoveServiceAdvisor = {
  __typename?: 'RemoveServiceAdvisor';
  id?: Maybe<Scalars['String']['output']>;
};

export type RemoveServiceAdvisorInput = {
  id: Scalars['String']['input'];
};

export type RemoveUserFromPlace = {
  __typename?: 'RemoveUserFromPlace';
  user?: Maybe<UserQl>;
};

export type RemoveUserFromPlaceInput = {
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type RemoveUserFromTeam = {
  __typename?: 'RemoveUserFromTeam';
  team?: Maybe<TeamQl>;
};

export type RemoveUserFromTeamInput = {
  teamId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RemoveVideoUploadLink = {
  __typename?: 'RemoveVideoUploadLink';
  videoUploadLink: VideoUploadLinkQl;
};

export type RemoveVideoUploadLinkInput = {
  id: Scalars['String']['input'];
};

export type RenameAccount = {
  __typename?: 'RenameAccount';
  account?: Maybe<AccountQl>;
};

export type RenameAccountInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** RenamePlace renames a place's internal name */
export type RenamePlace = {
  __typename?: 'RenamePlace';
  place?: Maybe<PlaceQl>;
};

export type RenamePlaceInput = {
  name: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type ReopenStatusItem = {
  __typename?: 'ReopenStatusItem';
  statusItem?: Maybe<StatusItemQl>;
};

export type ReopenStatusItemInput = {
  newStatus: StatusItemStatus;
  statusId: Scalars['String']['input'];
};

export type RepairOrder = {
  completedTime?: Maybe<Scalars['ArrowField']['output']>;
  createdOn: Scalars['ArrowField']['output'];
  dmsStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastDmsUpdate?: Maybe<Scalars['ArrowField']['output']>;
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  openedTime?: Maybe<Scalars['ArrowField']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  promisedTime?: Maybe<Scalars['ArrowField']['output']>;
  repairOrderType: RepairOrderType;
  serviceAdvisor?: Maybe<ServiceAdvisorQl>;
  serviceAdvisorName?: Maybe<Scalars['String']['output']>;
  status: RepairOrderStatus;
  statusItem?: Maybe<StatusItemQl>;
  tagNumber?: Maybe<Scalars['String']['output']>;
  transportationFlags?: Maybe<Scalars['JSONString']['output']>;
  vehicleMakeFriendly?: Maybe<Scalars['String']['output']>;
  vehicleModelFriendly?: Maybe<Scalars['String']['output']>;
  vehicleVin?: Maybe<Scalars['String']['output']>;
  vehicleYear?: Maybe<Scalars['Int']['output']>;
};

export type RepairOrderClosedTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'RepairOrderClosedTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    includeWhenMatched: Scalars['Boolean']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    opcodesFilter: Array<OpCodesFilter>;
    rulesQuery?: Maybe<Scalars['String']['output']>;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
  };

export type RepairOrderConnection = {
  __typename?: 'RepairOrderConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RepairOrderEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RepairOrder` and its cursor. */
export type RepairOrderEdge = {
  __typename?: 'RepairOrderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BaseRepairOrder>;
};

export type RepairOrderFortellisQl = Node &
  RepairOrder & {
    __typename?: 'RepairOrderFortellisQL';
    activeIntegration?: Maybe<ActiveIntegrationQl>;
    activeIntegrationId?: Maybe<Scalars['String']['output']>;
    completedTime?: Maybe<Scalars['ArrowField']['output']>;
    conversation?: Maybe<ConversationQl>;
    conversationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customer?: Maybe<CustomerQl>;
    customerId?: Maybe<Scalars['String']['output']>;
    data?: Maybe<Scalars['JSONString']['output']>;
    dmsStatus?: Maybe<Scalars['String']['output']>;
    externalServiceAdvisorId?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    isActive?: Maybe<Scalars['String']['output']>;
    isCompleted?: Maybe<Scalars['String']['output']>;
    lastDmsUpdate?: Maybe<Scalars['ArrowField']['output']>;
    lastSeenAt?: Maybe<Scalars['ArrowField']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messages?: Maybe<MessageQlConnection>;
    opCodes?: Maybe<Scalars['JSONString']['output']>;
    openedTime?: Maybe<Scalars['ArrowField']['output']>;
    orderNumber?: Maybe<Scalars['String']['output']>;
    participant?: Maybe<Scalars['String']['output']>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    promisedTime?: Maybe<Scalars['ArrowField']['output']>;
    repairOrderType: RepairOrderType;
    roStatus?: Maybe<Scalars['String']['output']>;
    serviceAdvisor?: Maybe<ServiceAdvisorQl>;
    serviceAdvisorName?: Maybe<Scalars['String']['output']>;
    status: RepairOrderStatus;
    statusItem?: Maybe<StatusItemQl>;
    tagNumber?: Maybe<Scalars['String']['output']>;
    transportationFlags?: Maybe<Scalars['JSONString']['output']>;
    user?: Maybe<UserQl>;
    userId: Scalars['String']['output'];
    vehicleMake?: Maybe<Scalars['String']['output']>;
    vehicleMakeFriendly?: Maybe<Scalars['String']['output']>;
    vehicleMileage?: Maybe<Scalars['String']['output']>;
    vehicleModel?: Maybe<Scalars['String']['output']>;
    vehicleModelFriendly?: Maybe<Scalars['String']['output']>;
    vehicleVin?: Maybe<Scalars['String']['output']>;
    vehicleYear?: Maybe<Scalars['Int']['output']>;
  };

export type RepairOrderFortellisQlMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type RepairOrderFortellisQlConnection = {
  __typename?: 'RepairOrderFortellisQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RepairOrderFortellisQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RepairOrderFortellisQL` and its cursor. */
export type RepairOrderFortellisQlEdge = {
  __typename?: 'RepairOrderFortellisQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RepairOrderFortellisQl>;
};

export type RepairOrderModelFilter = {
  activeIntegrationId?: InputMaybe<StringFilter>;
  completedTime?: InputMaybe<ArrowFieldFilter>;
  conversationId?: InputMaybe<StringFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  customerId?: InputMaybe<StringFilter>;
  data?: InputMaybe<JsonStringFilter>;
  dmsStatus?: InputMaybe<StringFilter>;
  externalServiceAdvisorId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastSeenAt?: InputMaybe<ArrowFieldFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  opCodes?: InputMaybe<JsonStringFilter>;
  openedTime?: InputMaybe<ArrowFieldFilter>;
  orderNumber?: InputMaybe<StringFilter>;
  placeId?: InputMaybe<StringFilter>;
  promisedTime?: InputMaybe<ArrowFieldFilter>;
  repairOrderType?: InputMaybe<StringFilter>;
  roStatus?: InputMaybe<StringFilter>;
  serviceAdvisorName?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  tagNumber?: InputMaybe<StringFilter>;
  transportationFlags?: InputMaybe<JsonStringFilter>;
  userId?: InputMaybe<StringFilter>;
  vehicleMake?: InputMaybe<StringFilter>;
  vehicleMakeFriendly?: InputMaybe<StringFilter>;
  vehicleMileage?: InputMaybe<StringFilter>;
  vehicleModel?: InputMaybe<StringFilter>;
  vehicleModelFriendly?: InputMaybe<StringFilter>;
  vehicleVin?: InputMaybe<StringFilter>;
  vehicleYear?: InputMaybe<IntFilter>;
};

export enum RepairOrderModelSortEnum {
  ActiveIntegrationIdAsc = 'active_integration_id_asc',
  ActiveIntegrationIdDesc = 'active_integration_id_desc',
  CompletedTimeAsc = 'completed_time_asc',
  CompletedTimeDesc = 'completed_time_desc',
  ConversationIdAsc = 'conversation_id_asc',
  ConversationIdDesc = 'conversation_id_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  CustomerIdAsc = 'customer_id_asc',
  CustomerIdDesc = 'customer_id_desc',
  DataAsc = 'data_asc',
  DataDesc = 'data_desc',
  DmsStatusAsc = 'dms_status_asc',
  DmsStatusDesc = 'dms_status_desc',
  ExternalServiceAdvisorIdAsc = 'external_service_advisor_id_asc',
  ExternalServiceAdvisorIdDesc = 'external_service_advisor_id_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  LastSeenAtAsc = 'last_seen_at_asc',
  LastSeenAtDesc = 'last_seen_at_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  OpCodesAsc = 'op_codes_asc',
  OpCodesDesc = 'op_codes_desc',
  OpenedTimeAsc = 'opened_time_asc',
  OpenedTimeDesc = 'opened_time_desc',
  OrderNumberAsc = 'order_number_asc',
  OrderNumberDesc = 'order_number_desc',
  PlaceIdAsc = 'place_id_asc',
  PlaceIdDesc = 'place_id_desc',
  PromisedTimeAsc = 'promised_time_asc',
  PromisedTimeDesc = 'promised_time_desc',
  RepairOrderTypeAsc = 'repair_order_type_asc',
  RepairOrderTypeDesc = 'repair_order_type_desc',
  RoStatusAsc = 'ro_status_asc',
  RoStatusDesc = 'ro_status_desc',
  ServiceAdvisorNameAsc = 'service_advisor_name_asc',
  ServiceAdvisorNameDesc = 'service_advisor_name_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc',
  TagNumberAsc = 'tag_number_asc',
  TagNumberDesc = 'tag_number_desc',
  TransportationFlagsAsc = 'transportation_flags_asc',
  TransportationFlagsDesc = 'transportation_flags_desc',
  UserIdAsc = 'user_id_asc',
  UserIdDesc = 'user_id_desc',
  VehicleMakeAsc = 'vehicle_make_asc',
  VehicleMakeDesc = 'vehicle_make_desc',
  VehicleMakeFriendlyAsc = 'vehicle_make_friendly_asc',
  VehicleMakeFriendlyDesc = 'vehicle_make_friendly_desc',
  VehicleMileageAsc = 'vehicle_mileage_asc',
  VehicleMileageDesc = 'vehicle_mileage_desc',
  VehicleModelAsc = 'vehicle_model_asc',
  VehicleModelDesc = 'vehicle_model_desc',
  VehicleModelFriendlyAsc = 'vehicle_model_friendly_asc',
  VehicleModelFriendlyDesc = 'vehicle_model_friendly_desc',
  VehicleVinAsc = 'vehicle_vin_asc',
  VehicleVinDesc = 'vehicle_vin_desc',
  VehicleYearAsc = 'vehicle_year_asc',
  VehicleYearDesc = 'vehicle_year_desc',
}

export type RepairOrderNotesSummaryQl = {
  __typename?: 'RepairOrderNotesSummaryQL';
  createdOn?: Maybe<Scalars['ArrowField']['output']>;
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  notEnoughInfo: Scalars['Boolean']['output'];
  notes: Scalars['String']['output'];
  repairOrderId: Scalars['String']['output'];
  serviceSummaries?: Maybe<ServiceSummariesQl>;
  upsell?: Maybe<UpsellQl>;
};

export type RepairOrderOpenedTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'RepairOrderOpenedTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    includeWhenMatched: Scalars['Boolean']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    opcodesFilter: Array<OpCodesFilter>;
    rulesQuery?: Maybe<Scalars['String']['output']>;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
  };

export type RepairOrderSmartStatusUpdateSettingsInput = {
  customInstructions?: InputMaybe<Scalars['String']['input']>;
  detailLevel?: InputMaybe<Scalars['Float']['input']>;
  evaluationTimes: Array<EvaluationTimeInput>;
  isEnabled: Scalars['Boolean']['input'];
  placeId: Scalars['UUID']['input'];
};

export type RepairOrderSmartStatusUpdateSettingsQl = BaseQl &
  Node & {
    __typename?: 'RepairOrderSmartStatusUpdateSettingsQL';
    createdOn: Scalars['ArrowField']['output'];
    customInstructions?: Maybe<Scalars['String']['output']>;
    detailLevel: Scalars['Float']['output'];
    evaluationTimes: Array<EvaluationTimeQl>;
    id: Scalars['ID']['output'];
    isEnabled: Scalars['Boolean']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
  };

export enum RepairOrderStatus {
  Active = 'ACTIVE',
  Complete = 'COMPLETE',
  Void = 'VOID',
}

export enum RepairOrderTriggerFunctionsInput {
  Equals = 'equals',
  HasChanged = 'has_changed',
  OldValueToNewValue = 'old_value_to_new_value',
  OldValueWas = 'old_value_was',
}

export enum RepairOrderTriggerKeysInput {
  StatusCode = 'status_code',
}

export enum RepairOrderTriggerOperatorsFilterInput {
  And = 'and_',
  Or = 'or_',
}

export enum RepairOrderTriggerValuesInputType {
  Any = 'any',
  None = 'none',
  String = 'string',
}

export enum RepairOrderType {
  Cdk = 'CDK',
  Dealerbuilt = 'DEALERBUILT',
  Dealertrack = 'DEALERTRACK',
  Fortellis = 'FORTELLIS',
  Pbs = 'PBS',
  Reynolds = 'REYNOLDS',
  Tekion = 'TEKION',
}

export type RepairOrderUpdateFilter = {
  __typename?: 'RepairOrderUpdateFilter';
  conditions: Array<RepairOrderUpdatedCondition>;
  operator: RepairOrderTriggerOperatorsFilterInput;
};

export type RepairOrderUpdateFilterInput = {
  conditions: Array<RepairOrderUpdatedConditionInput>;
  operator: OperatorType;
};

export type RepairOrderUpdatedCondition = {
  __typename?: 'RepairOrderUpdatedCondition';
  function: RepairOrderTriggerFunctionsInput;
  keyName: RepairOrderTriggerKeysInput;
  newValue?: Maybe<RepairOrderUpdatedConditionValue>;
  oldValue?: Maybe<RepairOrderUpdatedConditionValue>;
};

export type RepairOrderUpdatedConditionInput = {
  function: FunctionsType;
  keyName: KeyType;
  newValue?: InputMaybe<RepairOrderUpdatedConditionValueInput>;
  oldValue?: InputMaybe<RepairOrderUpdatedConditionValueInput>;
};

export type RepairOrderUpdatedConditionValue = {
  __typename?: 'RepairOrderUpdatedConditionValue';
  type: RepairOrderTriggerValuesInputType;
  value: Scalars['String']['output'];
};

export type RepairOrderUpdatedConditionValueInput = {
  type: ValueType;
  value: Scalars['String']['input'];
};

export type RepairOrderUpdatedTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'RepairOrderUpdatedTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    includeWhenMatched: Scalars['Boolean']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    opcodesFilter: Array<OpCodesFilter>;
    rulesQuery?: Maybe<Scalars['String']['output']>;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
    updateFilter: RepairOrderUpdateFilter;
  };

export type RepairServiceQl = BaseQl &
  Node & {
    __typename?: 'RepairServiceQL';
    activeIntegration: ActiveIntegrationQl;
    activeIntegrationId: Scalars['String']['output'];
    appointments: Array<AppointmentQl>;
    configuration: Scalars['JSONString']['output'];
    createdOn: Scalars['ArrowField']['output'];
    disabledSupportedVehiclesCount: Scalars['Int']['output'];
    enabledSupportedVehiclesCount: Scalars['Int']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    maxCapacity: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    opCodes: Array<OpCodeQl>;
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    supportedVehicles: Array<SupportedVehiclesQl>;
    transportationSets?: Maybe<TransportationSetRepairServiceQlConnection>;
  };

export type RepairServiceQlTransportationSetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type RepairServiceQlConnection = {
  __typename?: 'RepairServiceQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RepairServiceQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RepairServiceQL` and its cursor. */
export type RepairServiceQlEdge = {
  __typename?: 'RepairServiceQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RepairServiceQl>;
};

export enum ReplyReason {
  Automation = 'AUTOMATION',
  Greeting = 'GREETING',
  HangupResponse = 'HANGUP_RESPONSE',
  Intent = 'INTENT',
}

export type RequestAvailableIntegration = {
  __typename?: 'RequestAvailableIntegration';
  activeIntegration?: Maybe<ActiveIntegrationQl>;
};

export type RequestAvailableIntegrationInput = {
  availableIntegrationId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export enum RequireExplicitOptIn {
  Always = 'ALWAYS',
  Inactive = 'INACTIVE',
  Never = 'NEVER',
}

export type ResetAppointmentAgentSettings = {
  __typename?: 'ResetAppointmentAgentSettings';
  appointmentAgentSettings?: Maybe<AppointmentAgentSettingsQl>;
};

export type ResetAppointmentAgentSettingsInput = {
  id: Scalars['String']['input'];
};

export type ResetBrandTheme = {
  __typename?: 'ResetBrandTheme';
  brandTheme?: Maybe<BrandThemeQl>;
};

export type ResetBrandThemeInput = {
  placeId?: InputMaybe<Scalars['String']['input']>;
};

export type ResetConversationLanguage = {
  __typename?: 'ResetConversationLanguage';
  conversation?: Maybe<ConversationQl>;
};

export type ResetConversationLanguageInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type ResetOutboundChannels = {
  __typename?: 'ResetOutboundChannels';
  automation?: Maybe<AutomationQl>;
};

export type ResetOutboundChannelsInput = {
  actionId: Scalars['String']['input'];
  automationId: Scalars['String']['input'];
};

export type ResetTaskStatus = {
  __typename?: 'ResetTaskStatus';
  task: TaskQl;
};

export type ResetTaskStatusInput = {
  taskId: Scalars['UUID']['input'];
};

export type ResetVoiceScript = {
  __typename?: 'ResetVoiceScript';
  voiceScript?: Maybe<VoiceScriptQl>;
};

export type ResetVoiceScriptInput = {
  scriptId: Scalars['String']['input'];
};

export type ResolutionStep = {
  __typename?: 'ResolutionStep';
  solution: Scalars['String']['output'];
  step: Scalars['String']['output'];
};

export type ReviewAttachment = Attachment &
  Node & {
    __typename?: 'ReviewAttachment';
    attachmentType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    message?: Maybe<MessageQl>;
    messageId?: Maybe<Scalars['String']['output']>;
    review?: Maybe<ReviewQl>;
    reviewId?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
  };

export type ReviewAttachmentConnection = {
  __typename?: 'ReviewAttachmentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReviewAttachmentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReviewAttachment` and its cursor. */
export type ReviewAttachmentEdge = {
  __typename?: 'ReviewAttachmentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReviewAttachment>;
};

export type ReviewFeedbackQl = BaseQl &
  Node & {
    __typename?: 'ReviewFeedbackQL';
    completed?: Maybe<Scalars['ArrowField']['output']>;
    content?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    opened?: Maybe<Scalars['ArrowField']['output']>;
    rated?: Maybe<Scalars['ArrowField']['output']>;
    rating?: Maybe<Scalars['String']['output']>;
    review?: Maybe<ReviewQl>;
    reviewId: Scalars['String']['output'];
    serviceName?: Maybe<Scalars['String']['output']>;
    started?: Maybe<Scalars['ArrowField']['output']>;
  };

export type ReviewJobQl = BaseQl &
  Node & {
    __typename?: 'ReviewJobQL';
    backgroundColor?: Maybe<Scalars['String']['output']>;
    buttonColor?: Maybe<Scalars['String']['output']>;
    buttonTextColor?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    fallbackChannel?: Maybe<BaseChannel>;
    fallbackChannelId?: Maybe<Scalars['String']['output']>;
    headerColor?: Maybe<Scalars['String']['output']>;
    headerTextColor?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    logoUrl?: Maybe<Scalars['String']['output']>;
    messageBody: Scalars['String']['output'];
    messageImageSizeBytes?: Maybe<Scalars['String']['output']>;
    messageImageUrl?: Maybe<Scalars['String']['output']>;
    overrideStylesheet?: Maybe<Scalars['String']['output']>;
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    renderedMessageBody: Scalars['String']['output'];
    review?: Maybe<ReviewQlConnection>;
    reviewMode: ReviewMode;
    reviewSites: Array<ReviewSiteInterface>;
    skipRatingsScreen?: Maybe<Scalars['Boolean']['output']>;
    textColor?: Maybe<Scalars['String']['output']>;
  };

export type ReviewJobQlReviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ReviewJobQlConnection = {
  __typename?: 'ReviewJobQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReviewJobQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReviewJobQL` and its cursor. */
export type ReviewJobQlEdge = {
  __typename?: 'ReviewJobQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReviewJobQl>;
};

export enum ReviewMode {
  Feedback = 'FEEDBACK',
  Reputation = 'REPUTATION',
  SkipRatings = 'SKIP_RATINGS',
}

export type ReviewQl = BaseQl &
  Node & {
    __typename?: 'ReviewQL';
    attachments?: Maybe<ReviewAttachmentConnection>;
    createdOn: Scalars['ArrowField']['output'];
    externalId?: Maybe<Scalars['Int']['output']>;
    feedback?: Maybe<Array<Maybe<ReviewFeedbackQl>>>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    message?: Maybe<MessageQl>;
    messageId?: Maybe<Scalars['String']['output']>;
    participant?: Maybe<ParticipantQl>;
    participantId: Scalars['String']['output'];
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    reviewJob?: Maybe<ReviewJobQl>;
    reviewJobId: Scalars['String']['output'];
    reviewMode: ReviewMode;
    sender?: Maybe<ParticipantQl>;
    senderId?: Maybe<Scalars['String']['output']>;
    transactionId?: Maybe<Scalars['String']['output']>;
  };

export type ReviewQlAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ReviewQlConnection = {
  __typename?: 'ReviewQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReviewQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReviewQL` and its cursor. */
export type ReviewQlEdge = {
  __typename?: 'ReviewQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReviewQl>;
};

export type ReviewSite = ReviewSiteInterface & {
  __typename?: 'ReviewSite';
  serviceName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ReviewSiteInput = {
  facebookPageId?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  serviceName: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ReviewSiteInterface = {
  serviceName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ScheduleMessageActionQl = AutomationAction &
  Node & {
    __typename?: 'ScheduleMessageActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationChannels: Array<AutomationChannels>;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    desiredConversationState?: Maybe<DesiredConversationState>;
    friendlyTime?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messageToSend?: Maybe<Scalars['String']['output']>;
    minutesUntilSent: Scalars['Int']['output'];
    nextActionId?: Maybe<Scalars['String']['output']>;
    selectedChannelId?: Maybe<Scalars['String']['output']>;
    textWithCare?: Maybe<TextWithCareActionInput>;
    uiHints?: Maybe<AutomationUiHints>;
  };

export type ScheduleMessageConnection = {
  __typename?: 'ScheduleMessageConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScheduleMessageEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ScheduleMessage` and its cursor. */
export type ScheduleMessageEdge = {
  __typename?: 'ScheduleMessageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScheduledMessageQl>;
};

export type ScheduledMessageModelFilter = {
  capsLockFixed?: InputMaybe<BooleanFilter>;
  channelId?: InputMaybe<StringFilter>;
  content?: InputMaybe<StringFilter>;
  conversationId?: InputMaybe<StringFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  deliveryAttempted?: InputMaybe<ArrowFieldFilter>;
  id?: InputMaybe<StringFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  placeId?: InputMaybe<StringFilter>;
  sendAt?: InputMaybe<ArrowFieldFilter>;
  senderId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

export enum ScheduledMessageModelSortEnum {
  CapsLockFixedAsc = 'caps_lock_fixed_asc',
  CapsLockFixedDesc = 'caps_lock_fixed_desc',
  ChannelIdAsc = 'channel_id_asc',
  ChannelIdDesc = 'channel_id_desc',
  ContentAsc = 'content_asc',
  ContentDesc = 'content_desc',
  ConversationIdAsc = 'conversation_id_asc',
  ConversationIdDesc = 'conversation_id_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  DeliveryAttemptedAsc = 'delivery_attempted_asc',
  DeliveryAttemptedDesc = 'delivery_attempted_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  PlaceIdAsc = 'place_id_asc',
  PlaceIdDesc = 'place_id_desc',
  SendAtAsc = 'send_at_asc',
  SendAtDesc = 'send_at_desc',
  SenderIdAsc = 'sender_id_asc',
  SenderIdDesc = 'sender_id_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc',
}

export type ScheduledMessageQl = BaseQl &
  Node & {
    __typename?: 'ScheduledMessageQL';
    autopilotScheduleMessage?: Maybe<AutopilotScheduledMessageQl>;
    capsLockFixed: Scalars['Boolean']['output'];
    channel?: Maybe<BaseChannel>;
    channelId?: Maybe<Scalars['String']['output']>;
    content: Scalars['String']['output'];
    conversation?: Maybe<ConversationQl>;
    conversationId?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    deliveryAttempted?: Maybe<Scalars['ArrowField']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    sendAt: Scalars['ArrowField']['output'];
    sender?: Maybe<ParticipantQl>;
    senderId: Scalars['String']['output'];
    status: ScheduledMessageStatus;
  };

export type ScheduledMessageQlConnection = {
  __typename?: 'ScheduledMessageQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScheduledMessageQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ScheduledMessageQL` and its cursor. */
export type ScheduledMessageQlEdge = {
  __typename?: 'ScheduledMessageQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ScheduledMessageQl>;
};

export enum ScheduledMessageStatus {
  Canceled = 'CANCELED',
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

export type SchedulerLogQl = BaseQl &
  Node & {
    __typename?: 'SchedulerLogQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    schedulerSync?: Maybe<SchedulerSyncQl>;
    schedulerSyncId: Scalars['String']['output'];
  };

export type SchedulerSyncConnection = {
  __typename?: 'SchedulerSyncConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SchedulerSyncEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SchedulerSync` and its cursor. */
export type SchedulerSyncEdge = {
  __typename?: 'SchedulerSyncEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SchedulerSyncQl>;
};

export type SchedulerSyncQl = BaseQl &
  Node & {
    __typename?: 'SchedulerSyncQL';
    createdOn: Scalars['ArrowField']['output'];
    endDate?: Maybe<Scalars['DateTime']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    schedulerLogs?: Maybe<Array<Maybe<SchedulerLogQl>>>;
  };

export enum SeatsUpdatedSource {
  AddNewUser = 'ADD_NEW_USER',
  AddNewUserAdmin = 'ADD_NEW_USER_ADMIN',
  Settings = 'SETTINGS',
  SettingsAdmin = 'SETTINGS_ADMIN',
}

export type SendBroadcast = {
  __typename?: 'SendBroadcast';
  broadcastTask?: Maybe<Scalars['String']['output']>;
};

export type SendBroadcastInput = {
  channelId: Scalars['String']['input'];
  messages: Array<InputMaybe<Scalars['String']['input']>>;
  placeId: Scalars['String']['input'];
  recipientMdns: Array<InputMaybe<Scalars['String']['input']>>;
};

export type SendFeedbackActionQl = AutomationAction &
  Node & {
    __typename?: 'SendFeedbackActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationChannels: Array<AutomationChannels>;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    desiredConversationState?: Maybe<DesiredConversationState>;
    friendlyTime?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextActionId?: Maybe<Scalars['String']['output']>;
    selectedChannelId?: Maybe<Scalars['String']['output']>;
    textWithCare?: Maybe<TextWithCareActionInput>;
    uiHints?: Maybe<AutomationUiHints>;
  };

export type SendLoa = {
  __typename?: 'SendLoa';
  hostedSmsPort?: Maybe<HostedSmsPortQl>;
};

export type SendLoaInput = {
  hostedSmsId: Scalars['String']['input'];
};

export type SendMessage = {
  __typename?: 'SendMessage';
  message?: Maybe<MessageQl>;
};

export type SendMessageActionQl = AutomationAction &
  Node & {
    __typename?: 'SendMessageActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationChannels: Array<AutomationChannels>;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    desiredConversationState?: Maybe<DesiredConversationState>;
    friendlyTime?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messageToSend?: Maybe<Scalars['String']['output']>;
    nextActionId?: Maybe<Scalars['String']['output']>;
    selectedChannelId?: Maybe<Scalars['String']['output']>;
    textWithCare?: Maybe<TextWithCareActionInput>;
    uiHints?: Maybe<AutomationUiHints>;
  };

export type SendMessageInput = {
  attachContact?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  body: Scalars['String']['input'];
  capsLockFixed?: InputMaybe<Scalars['Boolean']['input']>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['String']['input'];
  fromBot?: InputMaybe<Scalars['Boolean']['input']>;
  leaveArchived?: InputMaybe<Scalars['Boolean']['input']>;
  loggedCallInteraction?: InputMaybe<Scalars['String']['input']>;
  mentions?: InputMaybe<Array<InputMaybe<MentionInput>>>;
  messageFormat?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  signMessage?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<ParticipantInput>;
};

export type SendReviewActionQl = AutomationAction &
  Node & {
    __typename?: 'SendReviewActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationChannels: Array<AutomationChannels>;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    desiredConversationState?: Maybe<DesiredConversationState>;
    friendlyTime?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messageToSend?: Maybe<Scalars['String']['output']>;
    nextActionId?: Maybe<Scalars['String']['output']>;
    selectedChannelId?: Maybe<Scalars['String']['output']>;
    textWithCare?: Maybe<TextWithCareActionInput>;
    uiHints?: Maybe<AutomationUiHints>;
  };

export type SendReviewRequest = {
  __typename?: 'SendReviewRequest';
  message?: Maybe<MessageQl>;
};

export type SendReviewRequestInput = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mdn?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
};

export type SendScheduledMessageNow = {
  __typename?: 'SendScheduledMessageNow';
  message?: Maybe<MessageQl>;
  scheduledMessage?: Maybe<ScheduledMessageQl>;
};

export type SendScheduledMessageNowInput = {
  scheduledMessageId: Scalars['String']['input'];
};

export type SendStatusItemMessage = {
  __typename?: 'SendStatusItemMessage';
  statusItem?: Maybe<StatusItemQl>;
};

export type SendStatusItemMessageInput = {
  content: Scalars['String']['input'];
  logCall?: InputMaybe<Scalars['Boolean']['input']>;
  statusId: Scalars['String']['input'];
};

export type SendVCard = {
  __typename?: 'SendVCard';
  message?: Maybe<MessageQl>;
};

export type SendVCardInput = {
  conversationId: Scalars['String']['input'];
};

export type ServiceAdvisorQl = BaseQl &
  Node & {
    __typename?: 'ServiceAdvisorQL';
    activeIntegration?: Maybe<ActiveIntegrationQl>;
    activeIntegrationId?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    fortellisSubscription?: Maybe<FortellisSubscriptionQl>;
    fortellisSubscriptionId?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    nextFetchTime?: Maybe<Scalars['ArrowField']['output']>;
    placeId?: Maybe<Scalars['String']['output']>;
    placesUser?: Maybe<PlacesUsersQl>;
    placesUsersId: Scalars['String']['output'];
    rawData?: Maybe<Scalars['JSONString']['output']>;
    repairOrderSchedule: Scalars['JSONString']['output'];
    serviceAdvisorId?: Maybe<Scalars['String']['output']>;
    serviceAdvisorName?: Maybe<Scalars['String']['output']>;
    type?: Maybe<ServiceAdvisorType>;
    user?: Maybe<UserQl>;
    userId?: Maybe<Scalars['String']['output']>;
  };

export enum ServiceAdvisorType {
  Cdk = 'CDK',
  Dealerbuilt = 'DEALERBUILT',
  Dealertrack = 'DEALERTRACK',
  Fortellis = 'FORTELLIS',
  Pbs = 'PBS',
  Reynolds = 'REYNOLDS',
  Tekion = 'TEKION',
}

export type ServiceAdvisors =
  | CdkServiceAdvisorQl
  | DealerTrackServiceAdvisorQl
  | ServiceAdvisorQl;

export type ServiceSubItemSummary = {
  __typename?: 'ServiceSubItemSummary';
  confidence: SubItemSummaryConfidence;
  description: Scalars['String']['output'];
  priority: SubItemSummaryPriority;
};

export type ServiceSummariesItem = {
  __typename?: 'ServiceSummariesItem';
  content: Array<Maybe<ServiceSubItemSummary>>;
  item: Scalars['String']['output'];
};

export type ServiceSummariesQl = {
  __typename?: 'ServiceSummariesQL';
  general: Scalars['String']['output'];
  serviceItems: Array<Maybe<ServiceSummariesItem>>;
};

export enum SessionOutcome {
  Booked = 'BOOKED',
  CantService = 'CANT_SERVICE',
  Handled = 'HANDLED',
  Hangup = 'HANGUP',
  Human = 'HUMAN',
  Lead = 'LEAD',
  NeedsFollowUp = 'NEEDS_FOLLOW_UP',
}

export type SetAssignmentRetention = {
  __typename?: 'SetAssignmentRetention';
  accountSettings?: Maybe<AccountSettingsQl>;
  currentAccount?: Maybe<AccountQl>;
};

export type SetAssignmentRetentionInput = {
  assignmentRetention: Scalars['Int']['input'];
};

export type SetBusinessTimezone = {
  __typename?: 'SetBusinessTimezone';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SetBusinessTimezoneInput = {
  businessTimezone: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type SetFortellisLookupId = {
  __typename?: 'SetFortellisLookupId';
  place?: Maybe<PlaceQl>;
};

export type SetFortellisLookupIdInput = {
  placeId: Scalars['String']['input'];
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type SetHangupSuggestion = {
  __typename?: 'SetHangupSuggestion';
  accountSettings?: Maybe<AccountSettingsQl>;
  channel?: Maybe<TwilioChannelQl>;
  currentAccount?: Maybe<AccountQl>;
  phoneLinePolicy?: Maybe<PhoneLinePolicyQl>;
};

export type SetHangupSuggestionInput = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  hangupSuggestion?: InputMaybe<Scalars['String']['input']>;
  phoneLinePolicyId?: InputMaybe<Scalars['String']['input']>;
};

export type SetOptInStatus = {
  __typename?: 'SetOptInStatus';
  conversation?: Maybe<ConversationQl>;
};

export type SetOptInStatusInput = {
  conversationId: Scalars['String']['input'];
  optInStatus: ConversationOptInStatus;
};

export type SetResetOngoingOptin = {
  __typename?: 'SetResetOngoingOptin';
  currentAccount?: Maybe<AccountQl>;
};

export type SetResetOngoingOptinInput = {
  resetOngoingOptin: Scalars['Int']['input'];
};

export type SetResetOptinDays = {
  __typename?: 'SetResetOptinDays';
  currentAccount?: Maybe<AccountQl>;
};

export type SetResetOptinDaysInput = {
  resetOptinDays: Scalars['Int']['input'];
};

export type SetupEquityTradeOpportunityCampaign = {
  __typename?: 'SetupEquityTradeOpportunityCampaign';
  etoSettings?: Maybe<EtoSettingsQl>;
};

export type SetupEquityTradeOpportunityCampaignInput = {
  placeId: Scalars['String']['input'];
};

export enum SetupType {
  Assisted = 'ASSISTED',
  SelfServe = 'SELF_SERVE',
}

export enum SetupTypeInput {
  Assisted = 'ASSISTED',
  SelfServe = 'SELF_SERVE',
}

export type ShortcutConnection = {
  __typename?: 'ShortcutConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ShortcutEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Shortcut` and its cursor. */
export type ShortcutEdge = {
  __typename?: 'ShortcutEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ShortcutQl>;
};

export type ShortcutModelFilter = {
  content?: InputMaybe<StringFilter>;
  count?: InputMaybe<IntFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  id?: InputMaybe<StringFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  name?: InputMaybe<StringFilter>;
  placeId?: InputMaybe<StringFilter>;
  tag?: InputMaybe<StringFilter>;
};

export enum ShortcutModelSortEnum {
  ContentAsc = 'content_asc',
  ContentDesc = 'content_desc',
  CountAsc = 'count_asc',
  CountDesc = 'count_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  PlaceIdAsc = 'place_id_asc',
  PlaceIdDesc = 'place_id_desc',
  TagAsc = 'tag_asc',
  TagDesc = 'tag_desc',
}

export type ShortcutQl = BaseQl &
  Node & {
    __typename?: 'ShortcutQL';
    content: Scalars['String']['output'];
    count?: Maybe<Scalars['Int']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    tag: Scalars['String']['output'];
  };

export enum SignaturePreferences {
  AlwaysOff = 'ALWAYS_OFF',
  AlwaysOn = 'ALWAYS_ON',
  OnlyFirst = 'ONLY_FIRST',
}

export type SkuConnection = {
  __typename?: 'SkuConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SkuEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Sku` and its cursor. */
export type SkuEdge = {
  __typename?: 'SkuEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SkuQl>;
};

export type SkuEntitlementsQl = {
  __typename?: 'SkuEntitlementsQL';
  assignmentRouting?: Maybe<Scalars['Boolean']['output']>;
  assignments?: Maybe<Scalars['Boolean']['output']>;
  awayMode?: Maybe<Scalars['Boolean']['output']>;
  doNotDisturb?: Maybe<Scalars['Boolean']['output']>;
  escalations?: Maybe<Scalars['Boolean']['output']>;
  ordering?: Maybe<Scalars['Boolean']['output']>;
  translation?: Maybe<Scalars['Boolean']['output']>;
};

export type SkuModelFilter = {
  amount?: InputMaybe<IntFilter>;
  assignmentRouting?: InputMaybe<BooleanFilter>;
  assignments?: InputMaybe<BooleanFilter>;
  awayMode?: InputMaybe<BooleanFilter>;
  callRescue?: InputMaybe<BooleanFilter>;
  callerId?: InputMaybe<BooleanFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  devicesPerPlace?: InputMaybe<IntFilter>;
  doNotDisturb?: InputMaybe<BooleanFilter>;
  employeesPerPlace?: InputMaybe<IntFilter>;
  escalations?: InputMaybe<BooleanFilter>;
  facebook?: InputMaybe<BooleanFilter>;
  googleMyBusiness?: InputMaybe<BooleanFilter>;
  hasAppointments?: InputMaybe<BooleanFilter>;
  hasReputationMgmt?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<StringFilter>;
  interval?: InputMaybe<IntFilter>;
  intervalDuration?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  managePermissions?: InputMaybe<BooleanFilter>;
  maxPhoneLines?: InputMaybe<IntFilter>;
  messageRecovery?: InputMaybe<IntFilter>;
  messageRetention?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  nativeApps?: InputMaybe<BooleanFilter>;
  numaAssistant?: InputMaybe<BooleanFilter>;
  paymentProvider?: InputMaybe<StringFilter>;
  reports?: InputMaybe<BooleanFilter>;
  skuType?: InputMaybe<StringFilter>;
  sms?: InputMaybe<BooleanFilter>;
  transcriptions?: InputMaybe<BooleanFilter>;
  translation?: InputMaybe<BooleanFilter>;
  voicemail?: InputMaybe<BooleanFilter>;
  webWidget?: InputMaybe<BooleanFilter>;
};

export enum SkuModelSortEnum {
  AmountAsc = 'amount_asc',
  AmountDesc = 'amount_desc',
  AssignmentRoutingAsc = 'assignment_routing_asc',
  AssignmentRoutingDesc = 'assignment_routing_desc',
  AssignmentsAsc = 'assignments_asc',
  AssignmentsDesc = 'assignments_desc',
  AwayModeAsc = 'away_mode_asc',
  AwayModeDesc = 'away_mode_desc',
  CallRescueAsc = 'call_rescue_asc',
  CallRescueDesc = 'call_rescue_desc',
  CallerIdAsc = 'caller_id_asc',
  CallerIdDesc = 'caller_id_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  DevicesPerPlaceAsc = 'devices_per_place_asc',
  DevicesPerPlaceDesc = 'devices_per_place_desc',
  DoNotDisturbAsc = 'do_not_disturb_asc',
  DoNotDisturbDesc = 'do_not_disturb_desc',
  EmployeesPerPlaceAsc = 'employees_per_place_asc',
  EmployeesPerPlaceDesc = 'employees_per_place_desc',
  EscalationsAsc = 'escalations_asc',
  EscalationsDesc = 'escalations_desc',
  FacebookAsc = 'facebook_asc',
  FacebookDesc = 'facebook_desc',
  GoogleMyBusinessAsc = 'google_my_business_asc',
  GoogleMyBusinessDesc = 'google_my_business_desc',
  HasAppointmentsAsc = 'has_appointments_asc',
  HasAppointmentsDesc = 'has_appointments_desc',
  HasReputationMgmtAsc = 'has_reputation_mgmt_asc',
  HasReputationMgmtDesc = 'has_reputation_mgmt_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IntervalAsc = 'interval_asc',
  IntervalDesc = 'interval_desc',
  IntervalDurationAsc = 'interval_duration_asc',
  IntervalDurationDesc = 'interval_duration_desc',
  IsActiveAsc = 'is_active_asc',
  IsActiveDesc = 'is_active_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  ManagePermissionsAsc = 'manage_permissions_asc',
  ManagePermissionsDesc = 'manage_permissions_desc',
  MaxPhoneLinesAsc = 'max_phone_lines_asc',
  MaxPhoneLinesDesc = 'max_phone_lines_desc',
  MessageRecoveryAsc = 'message_recovery_asc',
  MessageRecoveryDesc = 'message_recovery_desc',
  MessageRetentionAsc = 'message_retention_asc',
  MessageRetentionDesc = 'message_retention_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  NativeAppsAsc = 'native_apps_asc',
  NativeAppsDesc = 'native_apps_desc',
  NumaAssistantAsc = 'numa_assistant_asc',
  NumaAssistantDesc = 'numa_assistant_desc',
  PaymentProviderAsc = 'payment_provider_asc',
  PaymentProviderDesc = 'payment_provider_desc',
  ReportsAsc = 'reports_asc',
  ReportsDesc = 'reports_desc',
  SkuTypeAsc = 'sku_type_asc',
  SkuTypeDesc = 'sku_type_desc',
  SmsAsc = 'sms_asc',
  SmsDesc = 'sms_desc',
  TranscriptionsAsc = 'transcriptions_asc',
  TranscriptionsDesc = 'transcriptions_desc',
  TranslationAsc = 'translation_asc',
  TranslationDesc = 'translation_desc',
  VoicemailAsc = 'voicemail_asc',
  VoicemailDesc = 'voicemail_desc',
  WebWidgetAsc = 'web_widget_asc',
  WebWidgetDesc = 'web_widget_desc',
}

export type SkuQl = BaseQl &
  Node & {
    __typename?: 'SkuQL';
    amount: Scalars['Int']['output'];
    assignmentRouting: Scalars['Boolean']['output'];
    assignments: Scalars['Boolean']['output'];
    awayMode: Scalars['Boolean']['output'];
    callRescue: Scalars['Boolean']['output'];
    callerId: Scalars['Boolean']['output'];
    createdOn: Scalars['ArrowField']['output'];
    devicesPerPlace: Scalars['Int']['output'];
    doNotDisturb: Scalars['Boolean']['output'];
    employeesPerPlace: Scalars['Int']['output'];
    escalations: Scalars['Boolean']['output'];
    facebook: Scalars['Boolean']['output'];
    googleMyBusiness: Scalars['Boolean']['output'];
    hasAppointments: Scalars['Boolean']['output'];
    hasReputationMgmt: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    interval: Scalars['Int']['output'];
    intervalDuration: Scalars['String']['output'];
    isActive: Scalars['Boolean']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    managePermissions: Scalars['Boolean']['output'];
    maxPhoneLines: Scalars['Int']['output'];
    messageRecovery: Scalars['Int']['output'];
    messageRetention: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    nativeApps: Scalars['Boolean']['output'];
    numaAssistant: Scalars['Boolean']['output'];
    paymentProvider: Scalars['String']['output'];
    reports: Scalars['Boolean']['output'];
    skuType: SkuType;
    sms: Scalars['Boolean']['output'];
    subscriptions?: Maybe<SubscriptionQlConnection>;
    transcriptions: Scalars['Boolean']['output'];
    translation: Scalars['Boolean']['output'];
    voicemail: Scalars['Boolean']['output'];
    webWidget: Scalars['Boolean']['output'];
  };

export type SkuQlSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum SkuType {
  Addon = 'ADDON',
  Product = 'PRODUCT',
}

export type SmartTopicAttachment = Attachment &
  Node & {
    __typename?: 'SmartTopicAttachment';
    attachmentType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    message?: Maybe<MessageQl>;
    messageId?: Maybe<Scalars['String']['output']>;
    outcome?: Maybe<Scalars['String']['output']>;
    prompt?: Maybe<Scalars['String']['output']>;
    rationale?: Maybe<Scalars['String']['output']>;
    transcript?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
  };

export type SmartTopicLinksInputQl = {
  id: Scalars['String']['input'];
  nextStepId?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  topic: Scalars['String']['input'];
};

export type SmartTopicLinksQl = {
  __typename?: 'SmartTopicLinksQL';
  id: Scalars['String']['output'];
  nextStepId?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  topic: Scalars['String']['output'];
};

export type SmartTopicStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'SmartTopicStepQL';
    acknowledgementSpeech: Scalars['String']['output'];
    acknowledgementSpeechUrl: Scalars['String']['output'];
    additionalContext: Scalars['String']['output'];
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    llmModelOverride?: Maybe<Scalars['String']['output']>;
    llmPromptOverride?: Maybe<Scalars['String']['output']>;
    noMatchStep?: Maybe<VoiceScriptStepQl>;
    noMatchStepId?: Maybe<Scalars['String']['output']>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    purpose?: Maybe<Scalars['String']['output']>;
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedAcknowledgementSpeech: Scalars['String']['output'];
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    topics: Array<SmartTopicLinksQl>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type SmartTopicStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type SmartTopicStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type SmartTopicStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SmartTopicStepQlConnection = {
  __typename?: 'SmartTopicStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SmartTopicStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SmartTopicStepQL` and its cursor. */
export type SmartTopicStepQlEdge = {
  __typename?: 'SmartTopicStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SmartTopicStepQl>;
};

export type SnoozeConversation = {
  __typename?: 'SnoozeConversation';
  conversation?: Maybe<ConversationQl>;
};

export type SnoozeConversationInput = {
  id: Scalars['String']['input'];
  snoozeUntil: Scalars['ArrowField']['input'];
};

export enum SpamStatus {
  SuspectedSpam = 'SUSPECTED_SPAM',
  Unknown = 'UNKNOWN',
  UserReportedNotSpam = 'USER_REPORTED_NOT_SPAM',
  UserReportedSpam = 'USER_REPORTED_SPAM',
}

export enum SpamStatusInput {
  SuspectedSpam = 'SUSPECTED_SPAM',
  Unknown = 'UNKNOWN',
  UserReportedNotSpam = 'USER_REPORTED_NOT_SPAM',
  UserReportedSpam = 'USER_REPORTED_SPAM',
}

export type SpeakStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'SpeakStepQL';
    afterHoursSpeech: Scalars['String']['output'];
    afterHoursSpeechUrl: Scalars['String']['output'];
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextStepId?: Maybe<Scalars['String']['output']>;
    nextStepRelationship?: Maybe<VoiceScriptStepQl>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedAfterHoursSpeech: Scalars['String']['output'];
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type SpeakStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlHumanEscalationConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpeakStepQlConnection = {
  __typename?: 'SpeakStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SpeakStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SpeakStepQL` and its cursor. */
export type SpeakStepQlEdge = {
  __typename?: 'SpeakStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SpeakStepQl>;
};

export type SpecialQuestionQl = Node &
  VoiceScriptStep & {
    __typename?: 'SpecialQuestionQL';
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    canWeTextSpeech: Scalars['String']['output'];
    canWeTextSpeechUrl: Scalars['String']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    clarifyCanWeTextSpeech: Scalars['String']['output'];
    clarifyCanWeTextSpeechUrl: Scalars['String']['output'];
    clarifySpeech: Scalars['String']['output'];
    clarifySpeechUrl: Scalars['String']['output'];
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messageToSend: Scalars['String']['output'];
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onFailCanWeTextSpeech: Scalars['String']['output'];
    onFailCanWeTextSpeechUrl: Scalars['String']['output'];
    onFailureSpeech: Scalars['String']['output'];
    onFailureSpeechUrl: Scalars['String']['output'];
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoCanWeTextSpeech: Scalars['String']['output'];
    onNoCanWeTextSpeechUrl: Scalars['String']['output'];
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    onNoSpeech: Scalars['String']['output'];
    onNoSpeechUrl: Scalars['String']['output'];
    onNoStep?: Maybe<VoiceScriptStepQl>;
    onNoStepId?: Maybe<Scalars['String']['output']>;
    onYesButNoTextStep?: Maybe<VoiceScriptStepQl>;
    onYesButNoTextStepId?: Maybe<Scalars['String']['output']>;
    onYesCanWeTextSpeech: Scalars['String']['output'];
    onYesCanWeTextSpeechUrl: Scalars['String']['output'];
    onYesSpeech: Scalars['String']['output'];
    onYesSpeechUrl: Scalars['String']['output'];
    onYesStep?: Maybe<VoiceScriptStepQl>;
    onYesStepId?: Maybe<Scalars['String']['output']>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedMessageToSend: Scalars['String']['output'];
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type SpecialQuestionQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type SpecialQuestionQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type SpecialQuestionQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SpecialQuestionQlConnection = {
  __typename?: 'SpecialQuestionQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SpecialQuestionQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SpecialQuestionQL` and its cursor. */
export type SpecialQuestionQlEdge = {
  __typename?: 'SpecialQuestionQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SpecialQuestionQl>;
};

export type StaffMemberCallGoesPoorlyTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'StaffMemberCallGoesPoorlyTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
  };

export type StageQl = BaseQl &
  Node & {
    __typename?: 'StageQL';
    createdOn: Scalars['ArrowField']['output'];
    icon?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messageTemplate?: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    renderedMessageTemplate?: Maybe<Scalars['String']['output']>;
    renderedUpdateMessageTemplate?: Maybe<Scalars['String']['output']>;
    sortOrder: Scalars['Int']['output'];
    speechUpdate?: Maybe<Scalars['String']['output']>;
    speechUrl?: Maybe<Scalars['String']['output']>;
    statusItems?: Maybe<StatusItemConnection>;
    updateMessageTemplate?: Maybe<Scalars['String']['output']>;
  };

export type StageQlStatusItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<StatusItemModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<StatusItemModelSortEnum>>>;
};

export type StageQlConnection = {
  __typename?: 'StageQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StageQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StageQL` and its cursor. */
export type StageQlEdge = {
  __typename?: 'StageQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<StageQl>;
};

export type StartConversation = {
  __typename?: 'StartConversation';
  conversation: ConversationQl;
  message: MessageQl;
};

export type StartConversationInput = {
  attachContact?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  body?: InputMaybe<Scalars['String']['input']>;
  capsLockFixed?: InputMaybe<Scalars['Boolean']['input']>;
  channelId: Scalars['String']['input'];
  mentions?: InputMaybe<Array<InputMaybe<MentionInput>>>;
  messageFormat?: InputMaybe<Scalars['String']['input']>;
  signMessage?: InputMaybe<Scalars['Boolean']['input']>;
  to: ParticipantInput;
};

export type StartConversationWithScheduledMessage = {
  __typename?: 'StartConversationWithScheduledMessage';
  conversation: ConversationQl;
  scheduledMessage: ScheduledMessageQl;
};

export type StartConversationWithScheduledMessageInput = {
  capsLockFixed?: InputMaybe<Scalars['Boolean']['input']>;
  channelId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  recipientAddress: Scalars['String']['input'];
  sendAt: Scalars['ArrowField']['input'];
};

export enum Status {
  Active = 'ACTIVE',
  Degraded = 'DEGRADED',
  Disabled = 'DISABLED',
}

export enum StatusItemColor {
  Green = 'GREEN',
  Red = 'RED',
  Yellow = 'YELLOW',
}

export type StatusItemConnection = {
  __typename?: 'StatusItemConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StatusItemEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StatusItem` and its cursor. */
export type StatusItemEdge = {
  __typename?: 'StatusItemEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<StatusItemQl>;
};

export type StatusItemModelFilter = {
  assigneeId?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  customerId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  eta?: InputMaybe<ArrowFieldFilter>;
  heldSince?: InputMaybe<ArrowFieldFilter>;
  id?: InputMaybe<StringFilter>;
  lastUpdateTime?: InputMaybe<ArrowFieldFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  orderNumber?: InputMaybe<StringFilter>;
  placeId?: InputMaybe<StringFilter>;
  repairOrderId?: InputMaybe<StringFilter>;
  stageId?: InputMaybe<StringFilter>;
  stagesHaveSent?: InputMaybe<JsonStringFilter>;
  status?: InputMaybe<StringFilter>;
  tag?: InputMaybe<StringFilter>;
};

export enum StatusItemModelSortEnum {
  AssigneeIdAsc = 'assignee_id_asc',
  AssigneeIdDesc = 'assignee_id_desc',
  ColorAsc = 'color_asc',
  ColorDesc = 'color_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  CustomerIdAsc = 'customer_id_asc',
  CustomerIdDesc = 'customer_id_desc',
  DescriptionAsc = 'description_asc',
  DescriptionDesc = 'description_desc',
  EtaAsc = 'eta_asc',
  EtaDesc = 'eta_desc',
  HeldSinceAsc = 'held_since_asc',
  HeldSinceDesc = 'held_since_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  LastUpdateTimeAsc = 'last_update_time_asc',
  LastUpdateTimeDesc = 'last_update_time_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  OrderNumberAsc = 'order_number_asc',
  OrderNumberDesc = 'order_number_desc',
  PlaceIdAsc = 'place_id_asc',
  PlaceIdDesc = 'place_id_desc',
  RepairOrderIdAsc = 'repair_order_id_asc',
  RepairOrderIdDesc = 'repair_order_id_desc',
  StageIdAsc = 'stage_id_asc',
  StageIdDesc = 'stage_id_desc',
  StagesHaveSentAsc = 'stages_have_sent_asc',
  StagesHaveSentDesc = 'stages_have_sent_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc',
  TagAsc = 'tag_asc',
  TagDesc = 'tag_desc',
}

export type StatusItemQl = BaseQl &
  Node & {
    __typename?: 'StatusItemQL';
    assignee: UserQl;
    assigneeId?: Maybe<Scalars['String']['output']>;
    color: StatusItemColor;
    conversation?: Maybe<ConversationQl>;
    createdOn: Scalars['ArrowField']['output'];
    customer: CustomerQl;
    customerId: Scalars['String']['output'];
    description?: Maybe<Scalars['String']['output']>;
    eta?: Maybe<Scalars['ArrowField']['output']>;
    heldSince?: Maybe<Scalars['ArrowField']['output']>;
    id: Scalars['ID']['output'];
    lastNotification?: Maybe<MessageQl>;
    lastUpdateTime?: Maybe<Scalars['ArrowField']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    messages?: Maybe<MessageQlConnection>;
    orderNumber?: Maybe<Scalars['String']['output']>;
    participant?: Maybe<ParticipantQl>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    repairOrder?: Maybe<RepairOrderFortellisQl>;
    repairOrderId?: Maybe<Scalars['String']['output']>;
    stage: StageQl;
    stageId: Scalars['String']['output'];
    stagesHaveSent?: Maybe<Scalars['JSONString']['output']>;
    status: StatusItemStatus;
    tag?: Maybe<Scalars['String']['output']>;
  };

export type StatusItemQlMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusItemQlConnection = {
  __typename?: 'StatusItemQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StatusItemQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StatusItemQL` and its cursor. */
export type StatusItemQlEdge = {
  __typename?: 'StatusItemQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<StatusItemQl>;
};

export enum StatusItemStatus {
  Active = 'ACTIVE',
  Done = 'DONE',
  Hold = 'HOLD',
}

/** GraphQL type for status summary */
export type StatusSummaryQl = {
  __typename?: 'StatusSummaryQL';
  aborted: Scalars['Int']['output'];
  completedEarlyExit: Scalars['Int']['output'];
  completedSuccessfully: Scalars['Int']['output'];
  currentlyRunning: Scalars['Int']['output'];
  currentlyWaiting: Scalars['Int']['output'];
  totalStarted: Scalars['Int']['output'];
};

export type StatusUpdaterStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'StatusUpdaterStepQL';
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    noStatusGivenStep?: Maybe<VoiceScriptStepQl>;
    noStatusGivenStepId?: Maybe<Scalars['String']['output']>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusGivenStep?: Maybe<VoiceScriptStepQl>;
    statusGivenStepId?: Maybe<Scalars['String']['output']>;
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type StatusUpdaterStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type StatusUpdaterStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type StatusUpdaterStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StatusUpdaterStepQlConnection = {
  __typename?: 'StatusUpdaterStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StatusUpdaterStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StatusUpdaterStepQL` and its cursor. */
export type StatusUpdaterStepQlEdge = {
  __typename?: 'StatusUpdaterStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<StatusUpdaterStepQl>;
};

export enum StockExchange {
  Amex = 'AMEX',
  Amx = 'AMX',
  Asx = 'ASX',
  B3 = 'B3',
  Bme = 'BME',
  Bse = 'BSE',
  Fra = 'FRA',
  Icex = 'ICEX',
  Jpx = 'JPX',
  Jse = 'JSE',
  Krx = 'KRX',
  Lon = 'LON',
  Nasdaq = 'NASDAQ',
  Nse = 'NSE',
  Nyse = 'NYSE',
  Omx = 'OMX',
  Other = 'OTHER',
  Sehk = 'SEHK',
  Sgx = 'SGX',
  Sse = 'SSE',
  Sto = 'STO',
  Swx = 'SWX',
  Szse = 'SZSE',
  Tsx = 'TSX',
  Twse = 'TWSE',
  Vse = 'VSE',
}

export type StringFilter = {
  equal?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum StripeAccountType {
  AccountOnboarding = 'ACCOUNT_ONBOARDING',
  AccountUpdate = 'ACCOUNT_UPDATE',
  Custom = 'CUSTOM',
  Express = 'EXPRESS',
  Standard = 'STANDARD',
}

export type StripeIntegrationQl = BaseQl &
  Node & {
    __typename?: 'StripeIntegrationQL';
    closedOn?: Maybe<Scalars['ArrowField']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    openedOn?: Maybe<Scalars['ArrowField']['output']>;
    paymentRequests?: Maybe<PaymentRequestQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    stripeAccountId?: Maybe<Scalars['String']['output']>;
    stripeAccountObject?: Maybe<Scalars['String']['output']>;
    stripeAccountStatus?: Maybe<Scalars['String']['output']>;
    stripeAccountType?: Maybe<StripeAccountType>;
  };

export type StripeIntegrationQlPaymentRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type StripeIntegrationQlConnection = {
  __typename?: 'StripeIntegrationQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StripeIntegrationQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StripeIntegrationQL` and its cursor. */
export type StripeIntegrationQlEdge = {
  __typename?: 'StripeIntegrationQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<StripeIntegrationQl>;
};

export enum SubItemSummaryConfidence {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export enum SubItemSummaryPriority {
  Future = 'FUTURE',
  Maintenance = 'MAINTENANCE',
  Urgent = 'URGENT',
}

export type Submit10DlcStarterProfile = {
  __typename?: 'Submit10DLCStarterProfile';
  businessProfile?: Maybe<BusinessProfileQl>;
  campaignStatus?: Maybe<Scalars['String']['output']>;
};

export type Submit10DlcStarterProfileInput = {
  accountId: Scalars['String']['input'];
  businessProfileId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type SubmitBusinessIdentity = {
  __typename?: 'SubmitBusinessIdentity';
  tenDlcProcess?: Maybe<TenDlcProcessQl>;
};

export type SubscriptionInputQl = {
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type SubscriptionQl = BaseQl &
  Node & {
    __typename?: 'SubscriptionQL';
    available: Scalars['Boolean']['output'];
    billingIdentity?: Maybe<BillingIdentityQl>;
    billingIdentityId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    quantity: Scalars['Int']['output'];
    sku: SkuQl;
    skuId: Scalars['String']['output'];
    usedLicenses?: Maybe<PlaceQlConnection>;
  };

export type SubscriptionQlUsedLicensesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SubscriptionQlConnection = {
  __typename?: 'SubscriptionQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SubscriptionQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SubscriptionQL` and its cursor. */
export type SubscriptionQlEdge = {
  __typename?: 'SubscriptionQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SubscriptionQl>;
};

export type SummarizeConversationActionQl = AutomationAction &
  Node & {
    __typename?: 'SummarizeConversationActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    desiredConversationState?: Maybe<DesiredConversationState>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextActionId?: Maybe<Scalars['String']['output']>;
    uiHints?: Maybe<AutomationUiHints>;
  };

/**
 * States for supported vehicle opcodes
 *
 * NO_MATCH: Initial state, opcode exists but not matched
 * COLLISION: Multiple potential matches found
 * AUTO: Automatically matched with high confidence
 * INACTIVE: Opcode no longer available in XTime
 *
 */
export enum SupportedVehicleOpCodeState {
  Auto = 'AUTO',
  Collision = 'COLLISION',
  Inactive = 'INACTIVE',
  NoMatch = 'NO_MATCH',
}

export type SupportedVehiclesConnection = {
  __typename?: 'SupportedVehiclesConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SupportedVehiclesEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SupportedVehicles` and its cursor. */
export type SupportedVehiclesEdge = {
  __typename?: 'SupportedVehiclesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SupportedVehiclesQl>;
};

export type SupportedVehiclesModelFilter = {
  createdOn?: InputMaybe<ArrowFieldFilter>;
  embeddingId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  make?: InputMaybe<StringFilter>;
  model?: InputMaybe<StringFilter>;
  repairServiceId?: InputMaybe<StringFilter>;
  supportedYears?: InputMaybe<JsonStringFilter>;
  useOverrides?: InputMaybe<BooleanFilter>;
};

export enum SupportedVehiclesModelSortEnum {
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  EmbeddingIdAsc = 'embedding_id_asc',
  EmbeddingIdDesc = 'embedding_id_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  MakeAsc = 'make_asc',
  MakeDesc = 'make_desc',
  ModelAsc = 'model_asc',
  ModelDesc = 'model_desc',
  RepairServiceIdAsc = 'repair_service_id_asc',
  RepairServiceIdDesc = 'repair_service_id_desc',
  SupportedYearsAsc = 'supported_years_asc',
  SupportedYearsDesc = 'supported_years_desc',
  UseOverridesAsc = 'use_overrides_asc',
  UseOverridesDesc = 'use_overrides_desc',
}

export type SupportedVehiclesOpcodesQl = BaseQl &
  Node & {
    __typename?: 'SupportedVehiclesOpcodesQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    isEnabled: Scalars['Boolean']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    opCode: OpCodeQl;
    opCodeId: Scalars['String']['output'];
    state: SupportedVehicleOpCodeState;
    supportedVehicle?: Maybe<SupportedVehiclesQl>;
    supportedVehicleId: Scalars['String']['output'];
  };

export type SupportedVehiclesOpcodesQlConnection = {
  __typename?: 'SupportedVehiclesOpcodesQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SupportedVehiclesOpcodesQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SupportedVehiclesOpcodesQL` and its cursor. */
export type SupportedVehiclesOpcodesQlEdge = {
  __typename?: 'SupportedVehiclesOpcodesQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SupportedVehiclesOpcodesQl>;
};

export type SupportedVehiclesQl = BaseQl &
  Node & {
    __typename?: 'SupportedVehiclesQL';
    availableOpCodes: Array<SupportedVehiclesOpcodesQl>;
    createdOn: Scalars['ArrowField']['output'];
    embeddingId?: Maybe<Scalars['String']['output']>;
    firstEnabledOpCode?: Maybe<SupportedVehiclesOpcodesQl>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    make: Scalars['String']['output'];
    model: Scalars['String']['output'];
    opCodes: Array<SupportedVehiclesOpcodesQl>;
    outcome: Scalars['String']['output'];
    repairService: RepairServiceQl;
    repairServiceId: Scalars['String']['output'];
    supportedYears: Scalars['JSONString']['output'];
    useOverrides: Scalars['Boolean']['output'];
    xtimeLogs?: Maybe<XTimeLogModelQlConnection>;
  };

export type SupportedVehiclesQlXtimeLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SurveyAnsweredTriggerQl = AutomationTrigger &
  Node & {
    __typename?: 'SurveyAnsweredTriggerQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    surveyAnsweredFilter: SurveyAnsweredUpdateFilter;
    triggerType: Scalars['String']['output'];
    uiHints?: Maybe<AutomationUiHints>;
  };

export type SurveyAnsweredUpdateFilter = {
  __typename?: 'SurveyAnsweredUpdateFilter';
  inequalityFilter: InequalityFilterTriggerValuesTypes;
  ratingChoice: Scalars['Int']['output'];
  surveyType: SurveyTypeTriggerValuesTypes;
};

export enum SurveyTypeTriggerValuesTypes {
  Any = 'ANY',
  Feedback = 'FEEDBACK',
  ReviewRequest = 'REVIEW_REQUEST',
}

export enum SwipeActions {
  Close = 'CLOSE',
  Snooze = 'SNOOZE',
}

export type SyncXtimeServices = {
  __typename?: 'SyncXtimeServices';
  supportedVehicles?: Maybe<Array<SupportedVehiclesQl>>;
};

export type SyncXtimeServicesInput = {
  selectedServiceId?: InputMaybe<Scalars['String']['input']>;
  selectedVehicleId: Scalars['String']['input'];
};

export type SystemMessageSettings = {
  __typename?: 'SystemMessageSettings';
  showSystemMessages?: Maybe<Scalars['Boolean']['output']>;
};

export type TaskActionQl = {
  __typename?: 'TaskActionQL';
  actionData: Scalars['JSONObject']['output'];
  createdOn?: Maybe<Scalars['ArrowField']['output']>;
  id: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  task?: Maybe<TaskQl>;
  taskId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Represents whether the action was performed by the user or an AI automation */
export enum TaskActionSource {
  InboxAgent = 'INBOX_AGENT',
  User = 'USER',
}

/** Represents the reason for dismissing the task */
export enum TaskDismissalReason {
  Duplicate = 'duplicate',
  Inaccurate = 'inaccurate',
  NotNeeded = 'not_needed',
  Other = 'other',
}

export type TaskQl = {
  __typename?: 'TaskQL';
  DueDate?: Maybe<Scalars['ArrowField']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ArrowField']['output']>;
  completedByParticipant?: Maybe<ParticipantQl>;
  completedByParticipantId?: Maybe<Scalars['String']['output']>;
  completionSource?: Maybe<TaskActionSource>;
  createdByParticipant?: Maybe<ParticipantQl>;
  createdByParticipantId?: Maybe<Scalars['String']['output']>;
  createdOn?: Maybe<Scalars['ArrowField']['output']>;
  creationSource?: Maybe<TaskActionSource>;
  dismissalReason?: Maybe<Scalars['String']['output']>;
  dismissalSource?: Maybe<TaskActionSource>;
  dismissedAt?: Maybe<Scalars['ArrowField']['output']>;
  dismissedByParticipant?: Maybe<ParticipantQl>;
  dismissedByParticipantId?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  engagementId?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['ArrowField']['output'];
  id: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  recommendedActions?: Maybe<Array<TaskActionQl>>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum TaskType {
  AppointmentBooking = 'APPOINTMENT_BOOKING',
  AssistOnly = 'ASSIST_ONLY',
  MissedCall = 'MISSED_CALL',
  Operator = 'OPERATOR',
}

export type TeachNuma = {
  __typename?: 'TeachNuma';
  appliedIntent?: Maybe<AppliedIntentQl>;
};

export type TeachNumaInput = {
  handling: TeachNumaIntentHandlingInput;
  intentId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  response?: InputMaybe<Scalars['String']['input']>;
};

export enum TeachNumaIntentHandlingInput {
  AutoSend = 'AUTO_SEND',
  Disabled = 'DISABLED',
  Suggest = 'SUGGEST',
}

export type TeamConnection = {
  __typename?: 'TeamConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeamEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Team` and its cursor. */
export type TeamEdge = {
  __typename?: 'TeamEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TeamQl>;
};

export enum TeamModelSortEnum {
  AssignmentStyleAsc = 'assignment_style_asc',
  AssignmentStyleDesc = 'assignment_style_desc',
  AvatarAsc = 'avatar_asc',
  AvatarDesc = 'avatar_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  PlaceIdAsc = 'place_id_asc',
  PlaceIdDesc = 'place_id_desc',
  StateAsc = 'state_asc',
  StateDesc = 'state_desc',
}

export type TeamQl = BaseQl &
  Node & {
    __typename?: 'TeamQL';
    assignmentStyle: AssignmentStyle;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    avatar: Scalars['String']['output'];
    conversations?: Maybe<ConversationQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    state: TeamState;
    userCount: Scalars['Int']['output'];
    users?: Maybe<UserConnection>;
  };

export type TeamQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TeamQlConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TeamQlUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryFilter?: InputMaybe<UserModelFilter>;
  sort?: InputMaybe<Array<InputMaybe<UserModelSortEnum>>>;
};

export type TeamQlConnection = {
  __typename?: 'TeamQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeamQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TeamQL` and its cursor. */
export type TeamQlEdge = {
  __typename?: 'TeamQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TeamQl>;
};

export enum TeamState {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
}

export type TenDlcProcessQl = {
  __typename?: 'TenDLCProcessQL';
  errors?: Maybe<Array<Maybe<TwilioTrustProductError>>>;
  id?: Maybe<Scalars['String']['output']>;
  place?: Maybe<PlaceQl>;
  registrationOptions?: Maybe<Array<Maybe<RegistrationOption>>>;
  twilioA2pCampaign?: Maybe<TwilioA2PCampaignQl>;
  twilioBrandRegistration?: Maybe<TwilioBrandRegistrationQl>;
  twilioTrustProduct?: Maybe<TwilioTrustProductQl>;
};

export type TenDlcStatusQl = {
  __typename?: 'TenDLCStatusQL';
  a2pStatus: TenDlcStatus;
  businessVerificationStatus: TenDlcStatus;
};

export enum TenDlcStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NeedsAction = 'NEEDS_ACTION',
}

export type TextGenerationChatMessageInputQl = {
  content: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type TextGenerationChatMessageQl = {
  __typename?: 'TextGenerationChatMessageQL';
  content: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type TextGenerationQl = {
  __typename?: 'TextGenerationQL';
  data: Scalars['JSONString']['output'];
  messages: Array<TextGenerationChatMessageQl>;
  prompt: Scalars['String']['output'];
  responses: Array<Scalars['String']['output']>;
};

export type TextOptinStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'TextOptinStepQL';
    afterHoursTextMessage?: Maybe<Scalars['String']['output']>;
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    clarifySpeech: Scalars['String']['output'];
    clarifySpeechUrl: Scalars['String']['output'];
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onFailureSpeech: Scalars['String']['output'];
    onFailureSpeechUrl: Scalars['String']['output'];
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    onNoSpeech: Scalars['String']['output'];
    onNoSpeechUrl: Scalars['String']['output'];
    onNoStep?: Maybe<VoiceScriptStepQl>;
    onNoStepId?: Maybe<Scalars['String']['output']>;
    onYesSpeech: Scalars['String']['output'];
    onYesSpeechUrl: Scalars['String']['output'];
    onYesStep?: Maybe<VoiceScriptStepQl>;
    onYesStepId?: Maybe<Scalars['String']['output']>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    optinGreetingId?: Maybe<Scalars['String']['output']>;
    optinTextMessage?: Maybe<Scalars['String']['output']>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedAfterHoursTextMessage?: Maybe<Scalars['String']['output']>;
    renderedOptinTextMessage?: Maybe<Scalars['String']['output']>;
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    /** @deprecated Use optinTextMessage instead of the global place greeting */
    textOptinGreeting?: Maybe<GreetingQl>;
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    useAfterHoursTextMessage: Scalars['Boolean']['output'];
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type TextOptinStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type TextOptinStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type TextOptinStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TextOptinStepQlConnection = {
  __typename?: 'TextOptinStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TextOptinStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TextOptinStepQL` and its cursor. */
export type TextOptinStepQlEdge = {
  __typename?: 'TextOptinStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TextOptinStepQl>;
};

export enum TextWithCareActionInput {
  MessageThem = 'MESSAGE_THEM',
  SkipThem = 'SKIP_THEM',
}

export type ToggleCustomPhoneLinePolicy = {
  __typename?: 'ToggleCustomPhoneLinePolicy';
  phoneline?: Maybe<PhoneLineQl>;
};

export type ToggleCustomPhoneLinePolicyInput = {
  phonelineId: Scalars['String']['input'];
  useCustomPolicy: Scalars['Boolean']['input'];
};

export type ToggleOutboundProxyCallRecording = {
  __typename?: 'ToggleOutboundProxyCallRecording';
  outboundProxyCall: OutboundProxyCallQl;
};

export type ToggleOutboundProxyCallRecordingInput = {
  outboundProxyCallId: Scalars['String']['input'];
};

export type TranscriptAnalysisQl = BaseQl &
  Node & {
    __typename?: 'TranscriptAnalysisQL';
    callOutcome?: Maybe<Scalars['String']['output']>;
    callType?: Maybe<Scalars['String']['output']>;
    coachingImpact?: Maybe<Scalars['String']['output']>;
    coachingSample?: Maybe<Scalars['String']['output']>;
    coachingTip?: Maybe<Scalars['String']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextSteps?: Maybe<Scalars['String']['output']>;
    numboxMlModel?: Maybe<Scalars['String']['output']>;
    positiveCoachingImpact?: Maybe<Scalars['String']['output']>;
    positiveCoachingTip?: Maybe<Scalars['String']['output']>;
    scores?: Maybe<Array<TranscriptScoreQl>>;
    sections?: Maybe<Array<TranscriptSectionQl>>;
    subject?: Maybe<Scalars['String']['output']>;
    summary?: Maybe<Scalars['String']['output']>;
    timestamp: Scalars['ArrowField']['output'];
    transcript?: Maybe<TranscriptQl>;
    transcriptId: Scalars['String']['output'];
  };

export type TranscriptCall =
  | OutboundConferenceCallQl
  | OutboundProxyCallQl
  | PhoneCallQl;

export type TranscriptEventQl = BaseQl &
  Node & {
    __typename?: 'TranscriptEventQL';
    confidence?: Maybe<Scalars['Float']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    end?: Maybe<Scalars['Float']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    speaker?: Maybe<Scalars['Int']['output']>;
    speakerConfidence?: Maybe<Scalars['Float']['output']>;
    start?: Maybe<Scalars['Float']['output']>;
    text?: Maybe<Scalars['String']['output']>;
    timestamp: Scalars['ArrowField']['output'];
    transcript?: Maybe<TranscriptQl>;
    transcriptId: Scalars['String']['output'];
    transcriptType: Scalars['String']['output'];
    type: TranscriptEventType;
  };

export enum TranscriptEventType {
  AgentStep = 'AGENT_STEP',
  RecordedSpeech = 'RECORDED_SPEECH',
  RecordingPaused = 'RECORDING_PAUSED',
  RecordingStarted = 'RECORDING_STARTED',
  Speech = 'SPEECH',
}

export type TranscriptQl = BaseQl &
  Node & {
    __typename?: 'TranscriptQL';
    analysis?: Maybe<TranscriptAnalysisQl>;
    call: TranscriptCall;
    conversation?: Maybe<ConversationQl>;
    conversationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    events: Array<TranscriptEventQl>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    subject?: Maybe<Scalars['String']['output']>;
    summary?: Maybe<Scalars['String']['output']>;
  };

export type TranscriptQlConnection = {
  __typename?: 'TranscriptQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TranscriptQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TranscriptQL` and its cursor. */
export type TranscriptQlEdge = {
  __typename?: 'TranscriptQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TranscriptQl>;
};

export type TranscriptScoreQl = BaseQl &
  Node & {
    __typename?: 'TranscriptScoreQL';
    analysis?: Maybe<TranscriptAnalysisQl>;
    analysisId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    description: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
    rating: Scalars['Float']['output'];
  };

export type TranscriptSectionQl = BaseQl &
  Node & {
    __typename?: 'TranscriptSectionQL';
    analysis?: Maybe<TranscriptAnalysisQl>;
    analysisId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
    timestamp: Scalars['ArrowField']['output'];
  };

export type TranslatedMessage = Attachment &
  Node & {
    __typename?: 'TranslatedMessage';
    attachmentType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    fieldName?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    language?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    message?: Maybe<MessageQl>;
    messageId?: Maybe<Scalars['String']['output']>;
    text?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
  };

export enum TransportationOptionType {
  Dropoff = 'DROPOFF',
  Loaner = 'LOANER',
  Rental = 'RENTAL',
  Rideshare = 'RIDESHARE',
  Shuttle = 'SHUTTLE',
  Valet = 'VALET',
  Waiter = 'WAITER',
}

export type TransportationSetOptionQl = BaseQl &
  Node & {
    __typename?: 'TransportationSetOptionQL';
    createdOn: Scalars['ArrowField']['output'];
    enabled: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    kind: TransportationOptionType;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    minimumServiceItems: Scalars['Int']['output'];
    order: Scalars['Int']['output'];
    speechLong: Scalars['String']['output'];
    speechShort: Scalars['String']['output'];
    transportationSet?: Maybe<TransportationSetQl>;
    transportationSetId: Scalars['String']['output'];
  };

export type TransportationSetQl = BaseQl &
  Node & {
    __typename?: 'TransportationSetQL';
    appointmentAgentSettings?: Maybe<AppointmentAgentSettingsQl>;
    appointmentAgentSettingsId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    enabled: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    kind: TransportationSetType;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    name: Scalars['String']['output'];
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    repairServices: Array<TransportationSetRepairServiceQl>;
    rules: Scalars['JSONString']['output'];
    speechUtterance?: Maybe<Scalars['String']['output']>;
    transportationOptions: Array<TransportationSetOptionQl>;
  };

export type TransportationSetQlConnection = {
  __typename?: 'TransportationSetQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TransportationSetQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TransportationSetQL` and its cursor. */
export type TransportationSetQlEdge = {
  __typename?: 'TransportationSetQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TransportationSetQl>;
};

export type TransportationSetRepairServiceQl = BaseQl &
  Node & {
    __typename?: 'TransportationSetRepairServiceQL';
    createdOn: Scalars['ArrowField']['output'];
    enabled: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    repairService: RepairServiceQl;
    repairServiceId: Scalars['String']['output'];
    transportationSet?: Maybe<TransportationSetQl>;
    transportationSetId: Scalars['String']['output'];
  };

export type TransportationSetRepairServiceQlConnection = {
  __typename?: 'TransportationSetRepairServiceQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TransportationSetRepairServiceQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TransportationSetRepairServiceQL` and its cursor. */
export type TransportationSetRepairServiceQlEdge = {
  __typename?: 'TransportationSetRepairServiceQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TransportationSetRepairServiceQl>;
};

export enum TransportationSetType {
  Express = 'EXPRESS',
  NonOem = 'NON_OEM',
  Premium = 'PREMIUM',
  Standard = 'STANDARD',
}

export type TwilioA2PCampaignQl = BaseQl &
  Node & {
    __typename?: 'TwilioA2PCampaignQL';
    accountId: Scalars['String']['output'];
    campaignId?: Maybe<Scalars['String']['output']>;
    campaignStatus: TwilioA2PCampaignStatus;
    campaignVerifiedOn?: Maybe<Scalars['ArrowField']['output']>;
    createdOn: Scalars['ArrowField']['output'];
    description?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastSync?: Maybe<Scalars['ArrowField']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    twilioBrandRegistrationSid: Scalars['String']['output'];
    twilioMessagingServiceSid: Scalars['String']['output'];
  };

/**
 * For more information:
 *
 * https://www.twilio.com/docs/messaging/services/api/us-a2p-campaign-resource#us-app-to-person-campaign-resource-properties
 *
 */
export enum TwilioA2PCampaignStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Verified = 'VERIFIED',
}

export type TwilioBrandRegistrationQl = BaseQl &
  Node & {
    __typename?: 'TwilioBrandRegistrationQL';
    accountId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastSync?: Maybe<Scalars['ArrowField']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    places?: Maybe<PlaceQlConnection>;
    status: TwilioBrandRegistrationStatus;
    twilioA2pProfileBundleSid?: Maybe<Scalars['String']['output']>;
    twilioBusinessProfileSid: Scalars['String']['output'];
    twilioSid?: Maybe<Scalars['String']['output']>;
  };

export type TwilioBrandRegistrationQlPlacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum TwilioBrandRegistrationStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Failed = 'FAILED',
  InReview = 'IN_REVIEW',
  Pending = 'PENDING',
}

/**
 * Twilio Status for Trust Product validation.
 *
 * More information:
 * https://www.twilio.com/docs/phone-numbers/regulatory/api/replace-items-resource#bundle-statuses
 *
 *
 */
export enum TwilioBundleStatus {
  Draft = 'DRAFT',
  InReview = 'IN_REVIEW',
  PendingReview = 'PENDING_REVIEW',
  TwilioApproved = 'TWILIO_APPROVED',
  TwilioRejected = 'TWILIO_REJECTED',
}

export type TwilioChannelQl = Channel &
  Node & {
    __typename?: 'TwilioChannelQL';
    Assignee?: Maybe<UserQl>;
    AssigneeId?: Maybe<Scalars['String']['output']>;
    RespectExistingAssignments?: Maybe<Scalars['Boolean']['output']>;
    Team?: Maybe<TeamQl>;
    TeamId?: Maybe<Scalars['String']['output']>;
    account: AccountQl;
    accountId: Scalars['String']['output'];
    accountSid: Scalars['String']['output'];
    answerWithKeys?: Maybe<Scalars['String']['output']>;
    archiveMissedCalls?: Maybe<Scalars['Boolean']['output']>;
    assignTextReplies?: Maybe<Scalars['String']['output']>;
    assignee?: Maybe<UserQl>;
    assigneeId?: Maybe<Scalars['String']['output']>;
    assistantPhrase?: Maybe<Scalars['String']['output']>;
    autoOptin?: Maybe<Scalars['Boolean']['output']>;
    autoOptinMessage?: Maybe<Scalars['String']['output']>;
    autoSendHangupReplies?: Maybe<Scalars['Boolean']['output']>;
    channelType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    delayAnswerDuration?: Maybe<Scalars['Int']['output']>;
    hangupSuggestion?: Maybe<Scalars['String']['output']>;
    hasCustomPolicy: Scalars['Boolean']['output'];
    hasIdentityPrompt?: Maybe<Scalars['Boolean']['output']>;
    hostedSmsPorts?: Maybe<HostedSmsPortQlConnection>;
    id: Scalars['ID']['output'];
    identityPromptAddresses?: Maybe<IdentityPromptAddressQlConnection>;
    identityPromptOption: IdentityPromptOptions;
    isActive: Scalars['Boolean']['output'];
    isBotEnabled: Scalars['Boolean']['output'];
    isNryChannel?: Maybe<Scalars['Boolean']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    mdn: Scalars['String']['output'];
    messages?: Maybe<MessageQlConnection>;
    name?: Maybe<Scalars['String']['output']>;
    nryPhonelines?: Maybe<PhoneLineQlConnection>;
    operator?: Maybe<OperatorQl>;
    operatorId?: Maybe<Scalars['String']['output']>;
    operatorSessions?: Maybe<OperatorSessionQlConnection>;
    outboundConferenceCall?: Maybe<OutboundConferenceCallQlConnection>;
    outboundProxyCall?: Maybe<OutboundProxyCallQlConnection>;
    outboundSmsMdn?: Maybe<Scalars['String']['output']>;
    phoneLinePolicy?: Maybe<PhoneLinePolicyQl>;
    phoneLinePolicyId: Scalars['String']['output'];
    phonecalls?: Maybe<PhoneCallQlConnection>;
    place: PlaceQl;
    placeId: Scalars['String']['output'];
    renderedHangupSuggestion?: Maybe<Scalars['String']['output']>;
    respectExistingAssignments?: Maybe<Scalars['Boolean']['output']>;
    scheduled?: Maybe<ScheduledMessageQlConnection>;
    sendOutboundsWithShadowTollfree: Scalars['Boolean']['output'];
    shadowTollfreePhonenumber?: Maybe<Scalars['String']['output']>;
    shadowTollfreeProvisionedAt?: Maybe<Scalars['ArrowField']['output']>;
    shadowTollfreeSid?: Maybe<Scalars['String']['output']>;
    sid?: Maybe<Scalars['String']['output']>;
    smsChannel?: Maybe<BaseChannel>;
    smsPhonelines?: Maybe<PhoneLineQlConnection>;
    supportsMms?: Maybe<Scalars['Boolean']['output']>;
    supportsVoicemail?: Maybe<Scalars['Boolean']['output']>;
    team?: Maybe<TeamQl>;
    teamId?: Maybe<Scalars['String']['output']>;
    useLookup?: Maybe<Scalars['Boolean']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    voicePhonelines?: Maybe<PhoneLineQlConnection>;
  };

export type TwilioChannelQlHostedSmsPortsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TwilioChannelQlIdentityPromptAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TwilioChannelQlMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TwilioChannelQlNryPhonelinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TwilioChannelQlOperatorSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TwilioChannelQlOutboundConferenceCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TwilioChannelQlOutboundProxyCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TwilioChannelQlPhonecallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TwilioChannelQlScheduledArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TwilioChannelQlSmsPhonelinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TwilioChannelQlVoicePhonelinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TwilioChannelQlConnection = {
  __typename?: 'TwilioChannelQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TwilioChannelQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TwilioChannelQL` and its cursor. */
export type TwilioChannelQlEdge = {
  __typename?: 'TwilioChannelQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TwilioChannelQl>;
};

export enum TwilioEntityType {
  Private = 'private',
  Public = 'public',
}

export type TwilioTrustProductError = {
  __typename?: 'TwilioTrustProductError';
  errorCode?: Maybe<Scalars['Int']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  objectField?: Maybe<Scalars['String']['output']>;
  passed?: Maybe<Scalars['Boolean']['output']>;
};

export type TwilioTrustProductQl = BaseQl &
  Node & {
    __typename?: 'TwilioTrustProductQL';
    accountId: Scalars['String']['output'];
    businessIdentity?: Maybe<BusinessIdentityModelQl>;
    createdOn: Scalars['ArrowField']['output'];
    friendlyName?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    lastSync?: Maybe<Scalars['ArrowField']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    productType: TwilioTrustProductType;
    status: TwilioBundleStatus;
    twilioAccountSid: Scalars['String']['output'];
    twilioSid?: Maybe<Scalars['String']['output']>;
  };

export enum TwilioTrustProductType {
  A2P = 'A2P',
  A2PSolePropietor = 'A2P_SOLE_PROPIETOR',
  BusinessProfile = 'BUSINESS_PROFILE',
  Other = 'OTHER',
  ShakenStir = 'SHAKEN_STIR',
  StarterCustomer = 'STARTER_CUSTOMER',
}

export enum TwilioVertical {
  Agriculture = 'AGRICULTURE',
  Automotive = 'AUTOMOTIVE',
  Banking = 'BANKING',
  Communication = 'COMMUNICATION',
  Construction = 'CONSTRUCTION',
  Consumer = 'CONSUMER',
  Education = 'EDUCATION',
  Electronics = 'ELECTRONICS',
  Energy = 'ENERGY',
  Engineering = 'ENGINEERING',
  Entertainment = 'ENTERTAINMENT',
  FastMovingConsumerGoods = 'FAST_MOVING_CONSUMER_GOODS',
  Financial = 'FINANCIAL',
  Fintech = 'FINTECH',
  FoodAndBeverage = 'FOOD_AND_BEVERAGE',
  Gambling = 'GAMBLING',
  Government = 'GOVERNMENT',
  Healthcare = 'HEALTHCARE',
  Hospitality = 'HOSPITALITY',
  HumanResources = 'HUMAN_RESOURCES',
  Insurance = 'INSURANCE',
  Jewelry = 'JEWELRY',
  Legal = 'LEGAL',
  Manufacturing = 'MANUFACTURING',
  Media = 'MEDIA',
  Ngo = 'NGO',
  NotForProfit = 'NOT_FOR_PROFIT',
  OilAndGas = 'OIL_AND_GAS',
  Online = 'ONLINE',
  Political = 'POLITICAL',
  Postal = 'POSTAL',
  Professional = 'PROFESSIONAL',
  ProfessionalServices = 'PROFESSIONAL_SERVICES',
  RawMaterials = 'RAW_MATERIALS',
  RealEstate = 'REAL_ESTATE',
  Religion = 'RELIGION',
  Retail = 'RETAIL',
  Technology = 'TECHNOLOGY',
  Telecommunications = 'TELECOMMUNICATIONS',
  Transportation = 'TRANSPORTATION',
  Travel = 'TRAVEL',
}

export type TypingIndicatorQl = {
  __typename?: 'TypingIndicatorQL';
  /** Clients should ignore started typing events if they occurred before this timeout (in milliseconds) */
  discardEventTimeout: Scalars['Int']['output'];
  /** If a user stops typing for this duration, clients should send a 'Stopped Typing' event (in milliseconds) */
  inactivityTimeout: Scalars['Int']['output'];
  /** Clients should announce the user is still typing after this duration (in milliseconds) */
  sendStillTyping: Scalars['Int']['output'];
  typingIndicatorChannel: Scalars['String']['output'];
};

export type UnmapCrmUserFromUser = {
  __typename?: 'UnmapCrmUserFromUser';
  user?: Maybe<UserQl>;
};

export type UnmapCrmUserFromUserInput = {
  activeIntegrationId?: InputMaybe<Scalars['String']['input']>;
  crmUserId: Scalars['String']['input'];
};

export type UpdateActiveIntegration = {
  __typename?: 'UpdateActiveIntegration';
  activeIntegration?: Maybe<ActiveIntegrationQl>;
};

export type UpdateActiveIntegrationInput = {
  activeIntegrationId: Scalars['String']['input'];
  configuration?: InputMaybe<Scalars['JSONString']['input']>;
  status?: InputMaybe<IntegrationStatusInput>;
};

export type UpdateAgentChitChat = {
  __typename?: 'UpdateAgentChitChat';
  chitchat: AgentChitChatResponse;
};

export type UpdateAgentChitChatInput = {
  /** List of existing conversation messages */
  conversation: Array<MessageInput>;
  /** Index of the current step in the task's steps list */
  currentStep: Scalars['Int']['input'];
  /** The user input message */
  message: Scalars['String']['input'];
  /** Session ID for continuing conversations */
  sessionId: Scalars['String']['input'];
  /** Current slot values */
  slots: Scalars['JSONString']['input'];
  /** The type of task for this conversation */
  task: TaskType;
};

export type UpdateAnsweringScriptOrder = {
  __typename?: 'UpdateAnsweringScriptOrder';
  answeringScripts?: Maybe<Array<AnsweringScriptsQl>>;
};

export type UpdateAnsweringScriptOrderInput = {
  id: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type UpdateAppointment = {
  __typename?: 'UpdateAppointment';
  appointment?: Maybe<AppointmentQl>;
};

export type UpdateAppointmentAgentSettingLabel = {
  __typename?: 'UpdateAppointmentAgentSettingLabel';
  appointmentAgentSetting?: Maybe<AppointmentAgentSettingsQl>;
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<LabelQl>;
};

export type UpdateAppointmentAgentSettingLabelInput = {
  id: Scalars['String']['input'];
  labelId: Scalars['String']['input'];
};

export type UpdateAppointmentAgentSettings = {
  __typename?: 'UpdateAppointmentAgentSettings';
  appointmentAgentSettings?: Maybe<AppointmentAgentSettingsQl>;
};

export type UpdateAppointmentAgentSettingsInput = {
  activeIntegrationId: Scalars['String']['input'];
  agentProfileBlob?: InputMaybe<Scalars['JSONString']['input']>;
  defaultExternalOpcode?: InputMaybe<ExternalOpcodeInput>;
  enableHangupRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  maximumBookingHorizonInDays?: InputMaybe<Scalars['Int']['input']>;
  minimumLeadTimeInMinutes?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numaInCallFlow?: InputMaybe<Scalars['String']['input']>;
  optionalPromptsBlob?: InputMaybe<Scalars['JSONString']['input']>;
  overallEmphasis?: InputMaybe<Scalars['String']['input']>;
  settingsBlob?: InputMaybe<Scalars['JSONString']['input']>;
  textingCanWeTextSpeech?: InputMaybe<Scalars['String']['input']>;
  textingHangupRecovery?: InputMaybe<Scalars['String']['input']>;
  textingMessageToSend?: InputMaybe<Scalars['String']['input']>;
  textingOnNoSpeechCanWeText?: InputMaybe<Scalars['String']['input']>;
  textingOnYesSpeechCanWeText?: InputMaybe<Scalars['String']['input']>;
  webSchedulerReliability?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAppointmentInput = {
  id: Scalars['String']['input'];
  state?: InputMaybe<AppointmentState>;
  wasAppointmentOk?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAssignmentRoutingSettings = {
  __typename?: 'UpdateAssignmentRoutingSettings';
  assignmentRoutingSettings?: Maybe<AssignmentRoutingSettingQl>;
};

export type UpdateAssignmentRoutingSettingsInput = {
  callTimeout?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledAfterBusinessHours?: InputMaybe<Scalars['Boolean']['input']>;
  enabledDuringBusinessHours?: InputMaybe<Scalars['Boolean']['input']>;
  enabledWhenAway?: InputMaybe<Scalars['Boolean']['input']>;
  forwardingMdn?: InputMaybe<Scalars['String']['input']>;
  globalOverride?: InputMaybe<Scalars['Boolean']['input']>;
  placeId: Scalars['String']['input'];
  useNumaCallerId?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdateAutomation = {
  __typename?: 'UpdateAutomation';
  automation?: Maybe<AutomationQl>;
};

export type UpdateAutomationAction = {
  __typename?: 'UpdateAutomationAction';
  automation?: Maybe<AutomationQl>;
};

export type UpdateAutomationActionInput = {
  actionId: Scalars['String']['input'];
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  automationChannels?: InputMaybe<Array<InputMaybe<AutomationChannelsInput>>>;
  automationId: Scalars['String']['input'];
  desiredConversationState?: InputMaybe<DesiredConversationStateActionInput>;
  friendlyTime?: InputMaybe<Scalars['Boolean']['input']>;
  labelCheckOperation?: InputMaybe<HasLabelsTypes>;
  labels?: InputMaybe<Array<InputMaybe<ManageLabelOperationInput>>>;
  labelsToCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Message to add to the conversation. For example, this is used if the action notifies users or escalates a conversation. */
  messageToSend?: InputMaybe<Scalars['String']['input']>;
  minutesToWait?: InputMaybe<Scalars['Int']['input']>;
  minutesUntilSent?: InputMaybe<Scalars['Int']['input']>;
  notifyOwner?: InputMaybe<Scalars['Boolean']['input']>;
  opportunity?: InputMaybe<OpportunityInfoInput>;
  respectExistingAssignments?: InputMaybe<Scalars['Boolean']['input']>;
  rulesQuery?: InputMaybe<Scalars['String']['input']>;
  selectedChannelId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  teamIdsMentioned?: InputMaybe<Array<Scalars['String']['input']>>;
  textWithCare?: InputMaybe<TextWithCareActionInput>;
  userIdsMentioned?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAutomationEnrollmentCriteria = {
  __typename?: 'UpdateAutomationEnrollmentCriteria';
  automation?: Maybe<AutomationQl>;
};

export type UpdateAutomationEnrollmentCriteriaInput = {
  automationId: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  executionLimit?: InputMaybe<Scalars['Int']['input']>;
  preventConcurrentEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAutomationExitTrigger = {
  __typename?: 'UpdateAutomationExitTrigger';
  automation?: Maybe<AutomationQl>;
};

export type UpdateAutomationExitTriggerInput = {
  automationId: Scalars['String']['input'];
  daysSinceInbound?: InputMaybe<Scalars['Int']['input']>;
  daysSinceOutbound?: InputMaybe<Scalars['Int']['input']>;
  exitTriggerId: Scalars['String']['input'];
  includeActiveConversations?: InputMaybe<Scalars['Boolean']['input']>;
  includeClosedByNuma?: InputMaybe<Scalars['Boolean']['input']>;
  includeWhenMatched?: InputMaybe<Scalars['Boolean']['input']>;
  labelsToWatch?: InputMaybe<Array<Scalars['String']['input']>>;
  opcodesFilter?: InputMaybe<Array<InputMaybe<OpcodesFilterInput>>>;
  rulesQuery?: InputMaybe<Scalars['String']['input']>;
  surveyAnsweredFilter?: InputMaybe<UpdateSurveyAnsweredTriggerInput>;
  updateFilter?: InputMaybe<RepairOrderUpdateFilterInput>;
};

export type UpdateAutomationInput = {
  automationId: Scalars['String']['input'];
  firstActionId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAutomationStartTrigger = {
  __typename?: 'UpdateAutomationStartTrigger';
  automation?: Maybe<AutomationQl>;
};

export type UpdateAutomationStartTriggerInput = {
  automationId: Scalars['String']['input'];
  customerContactType?: InputMaybe<CustomerContactTypes>;
  daysSinceInbound?: InputMaybe<Scalars['Int']['input']>;
  daysSinceOutbound?: InputMaybe<Scalars['Int']['input']>;
  includeActiveConversations?: InputMaybe<Scalars['Boolean']['input']>;
  includeClosedByNuma?: InputMaybe<Scalars['Boolean']['input']>;
  includeWhenMatched?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opcodes?: InputMaybe<Array<InputMaybe<OpcodesFilterInput>>>;
  rulesQuery?: InputMaybe<Scalars['String']['input']>;
  surveyAnsweredFilter?: InputMaybe<UpdateSurveyAnsweredTriggerInput>;
  updateFilter?: InputMaybe<RepairOrderUpdateFilterInput>;
};

export type UpdateAutomationUiHints = {
  __typename?: 'UpdateAutomationUIHints';
  automation?: Maybe<AutomationQl>;
};

export type UpdateAutomationUiHintsInput = {
  automationId: Scalars['String']['input'];
  entries: Array<AutomationUiHint>;
};

export type UpdateAutopilotEta = {
  __typename?: 'UpdateAutopilotEta';
  autopilot: AutopilotQl;
};

export type UpdateAutopilotEtaInput = {
  autopilotId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  eta?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAutopilotJob = {
  __typename?: 'UpdateAutopilotJob';
  autopilotJob: AutopilotJobQl;
};

export type UpdateAutopilotJobInput = {
  inspection?: InputMaybe<Scalars['String']['input']>;
  pickup?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  qualityControl?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  welcome?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAutopilotScheduledMessage = {
  __typename?: 'UpdateAutopilotScheduledMessage';
  autopilot: AutopilotQl;
};

export type UpdateAutopilotScheduledMessageInput = {
  autopilotMessageId: Scalars['String']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  sendAt?: InputMaybe<Scalars['ArrowField']['input']>;
};

export type UpdateAvailableIntegration = {
  __typename?: 'UpdateAvailableIntegration';
  availableIntegration?: Maybe<AvailableIntegrationQl>;
};

export type UpdateAvailableIntegrationInput = {
  configurationSchema?: InputMaybe<Scalars['JSONString']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featureFlag?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['String']['input'];
  internalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settingsUrl?: InputMaybe<Scalars['String']['input']>;
  setupType?: InputMaybe<SetupTypeInput>;
};

export type UpdateAwayMode = {
  __typename?: 'UpdateAwayMode';
  user?: Maybe<UserQl>;
};

export type UpdateAwayModeAssignee = {
  __typename?: 'UpdateAwayModeAssignee';
  user?: Maybe<UserQl>;
};

export type UpdateAwayModeAssigneeInput = {
  awayModeAssigneeTeamId?: InputMaybe<Scalars['String']['input']>;
  awayModeAssigneeUserId?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateAwayModeInput = {
  isAway: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateAwayModeManagingPermission = {
  __typename?: 'UpdateAwayModeManagingPermission';
  user?: Maybe<UserQl>;
};

export type UpdateAwayModeManagingPermissionInput = {
  canManageOwnAwayModeSettings: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateAwayModeWithTime = {
  __typename?: 'UpdateAwayModeWithTime';
  user?: Maybe<UserQl>;
};

export type UpdateAwayModeWithTimeInput = {
  isAway: Scalars['Boolean']['input'];
  type?: InputMaybe<UpdateAwayModeWithTimeType>;
  userId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum UpdateAwayModeWithTimeType {
  Date = 'DATE',
  Indefinite = 'INDEFINITE',
  NextShift = 'NEXT_SHIFT',
}

export type UpdateBillingMetadata = {
  __typename?: 'UpdateBillingMetadata';
  place?: Maybe<PlaceQl>;
};

export type UpdateBillingMetadataInput = {
  chargebeeCustomerId?: InputMaybe<Scalars['String']['input']>;
  chargebeeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  hubspotCompanyId?: InputMaybe<Scalars['String']['input']>;
  hubspotContactId?: InputMaybe<Scalars['String']['input']>;
  hubspotDealId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type UpdateBrandLogo = {
  __typename?: 'UpdateBrandLogo';
  brandTheme?: Maybe<BrandThemeQl>;
};

export type UpdateBrandLogoInput = {
  logoData?: InputMaybe<Scalars['Upload']['input']>;
  logoName?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
};

export type UpdateBrandTheme = {
  __typename?: 'UpdateBrandTheme';
  brandTheme?: Maybe<BrandThemeQl>;
};

export type UpdateBrandThemeInput = {
  bodyBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  bodyBorderColor?: InputMaybe<Scalars['String']['input']>;
  bodyTextColor?: InputMaybe<Scalars['String']['input']>;
  buttonPrimaryBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  buttonPrimaryBorderColor?: InputMaybe<Scalars['String']['input']>;
  buttonPrimaryTextColor?: InputMaybe<Scalars['String']['input']>;
  buttonSecondaryBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  buttonSecondaryBorderColor?: InputMaybe<Scalars['String']['input']>;
  buttonSecondaryTextColor?: InputMaybe<Scalars['String']['input']>;
  headerBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  headerBorderColor?: InputMaybe<Scalars['String']['input']>;
  headerTextColor?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  paletteType?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
};

export type UpdateBusinessIdentity = {
  __typename?: 'UpdateBusinessIdentity';
  tenDlcProcess?: Maybe<TenDlcProcessQl>;
};

export type UpdateBusinessProfile = {
  __typename?: 'UpdateBusinessProfile';
  businessProfile?: Maybe<BusinessProfileQl>;
};

export type UpdateBusinessProfileInput = {
  accountId: Scalars['String']['input'];
  brandSid?: InputMaybe<Scalars['String']['input']>;
  businessIndustry?: InputMaybe<Scalars['String']['input']>;
  businessProfileId?: InputMaybe<Scalars['String']['input']>;
  businessRegionsOfOperations?: InputMaybe<Scalars['String']['input']>;
  businessRegistrationIdType?: InputMaybe<Scalars['String']['input']>;
  businessRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  businessRegistrationNumberType?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<Scalars['String']['input']>;
  campaignSid?: InputMaybe<Scalars['String']['input']>;
  companyStatus?: InputMaybe<Scalars['String']['input']>;
  contact1BusinessTitle?: InputMaybe<Scalars['String']['input']>;
  contact1Email?: InputMaybe<Scalars['String']['input']>;
  contact1FirstName?: InputMaybe<Scalars['String']['input']>;
  contact1JobPosition?: InputMaybe<Scalars['String']['input']>;
  contact1LastName?: InputMaybe<Scalars['String']['input']>;
  contact1PhoneNumber?: InputMaybe<Scalars['String']['input']>;
  contact2BusinessTitle?: InputMaybe<Scalars['String']['input']>;
  contact2Email?: InputMaybe<Scalars['String']['input']>;
  contact2FirstName?: InputMaybe<Scalars['String']['input']>;
  contact2JobPosition?: InputMaybe<Scalars['String']['input']>;
  contact2LastName?: InputMaybe<Scalars['String']['input']>;
  contact2PhoneNumber?: InputMaybe<Scalars['String']['input']>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  physicalAddress?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  registrationStatus?: InputMaybe<Scalars['String']['input']>;
  registrationType?: InputMaybe<Scalars['String']['input']>;
  socialMediaUrl?: InputMaybe<Scalars['String']['input']>;
  stockTickerExchange?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCallForwardingStatus = {
  __typename?: 'UpdateCallForwardingStatus';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCallForwardingStatusInput = {
  placeId: Scalars['String']['input'];
  status?: InputMaybe<CallForwardingStatusInput>;
};

export type UpdateCallIntelligenceEnabled = {
  __typename?: 'UpdateCallIntelligenceEnabled';
  placesUser?: Maybe<PlacesUsersQl>;
};

export type UpdateCallIntelligenceEnabledInput = {
  callIntelligenceEnabled: Scalars['Boolean']['input'];
  placeId: Scalars['String']['input'];
  source?: InputMaybe<SeatsUpdatedSource>;
  userId: Scalars['String']['input'];
};

export type UpdateCallIntelligenceSetting = {
  __typename?: 'UpdateCallIntelligenceSetting';
  callIntelligenceSetting?: Maybe<CallIntelligenceSettingQl>;
};

export type UpdateCallIntelligenceSettingInput = {
  customDisclosureSpeech?: InputMaybe<AudioInput>;
  customDisclosureSpeechOverride?: InputMaybe<CallIntelligenceSettingOptions>;
  disclosureContent?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<CallIntelligenceSettingOptions>;
  permissions?: InputMaybe<CallIntelligencePermissionType>;
  placeId: Scalars['String']['input'];
  playDisclosureSpeech?: InputMaybe<CallIntelligenceSettingOptions>;
  seatLimit?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<SeatsUpdatedSource>;
};

/** Mutation to update campaign status and optionally handle TCPA approval */
export type UpdateCampaignStatus = {
  __typename?: 'UpdateCampaignStatus';
  result?: Maybe<UpdateCampaignStatusResult>;
};

/** Input type for updating campaign status */
export type UpdateCampaignStatusInput = {
  campaignId: Scalars['String']['input'];
  status: CampaignStatus;
  tcpaApproved?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Result type for update campaign status mutation */
export type UpdateCampaignStatusResult = {
  __typename?: 'UpdateCampaignStatusResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateChannel = {
  __typename?: 'UpdateChannel';
  channel: Channel;
};

export type UpdateChannelInput = {
  channelId: Scalars['String']['input'];
  identityPromptOption?: InputMaybe<IdentityPromptOptions>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBotEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateComplianceSettings = {
  __typename?: 'UpdateComplianceSettings';
  complianceSettings?: Maybe<ComplianceSettingsQl>;
};

export type UpdateComplianceSettingsInput = {
  detailedGuidelines: Scalars['String']['input'];
  doubleOptInPrompt: Scalars['String']['input'];
  guidelinesReminder: Scalars['String']['input'];
  onCompose: Scalars['Boolean']['input'];
  onHangup: Scalars['Boolean']['input'];
  onRevivedConversations: Scalars['Boolean']['input'];
  onVoicemail: Scalars['Boolean']['input'];
  ongoingOptOutInstructions: Scalars['String']['input'];
  optOutConfirmation: Scalars['String']['input'];
  optOutInstructions: Scalars['String']['input'];
  optOutResubscribe: Scalars['String']['input'];
  requireExplicitOptIn: RequireExplicitOptIn;
  sendOptOutInstructions: Scalars['Boolean']['input'];
  suppressOptOutInstructions: Scalars['Boolean']['input'];
};

export type UpdateConversationLabel = {
  __typename?: 'UpdateConversationLabel';
  conversationLabel: ConversationLabelQl;
};

export type UpdateConversationLabelInput = {
  conversationLabelId: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['ArrowField']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateConversations = {
  __typename?: 'UpdateConversations';
  conversations?: Maybe<Array<Maybe<ConversationQl>>>;
};

export type UpdateConversationsInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state: ConversationState;
};

export type UpdateCurbsideSettings = {
  __typename?: 'UpdateCurbsideSettings';
  curbsideSettings?: Maybe<CurbsideSettingsQl>;
};

export type UpdateCurbsideSettingsInput = {
  customHandoffIsAutoreply?: InputMaybe<Scalars['Boolean']['input']>;
  customHandoffMethod?: InputMaybe<Scalars['String']['input']>;
  customHereIsAutoreply?: InputMaybe<Scalars['Boolean']['input']>;
  customOrderIdentifier?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  handoffMethod?: InputMaybe<HandoffMethodInput>;
  orderIdentifierType?: InputMaybe<OrderIdTypeInput>;
  placeId: Scalars['String']['input'];
};

export type UpdateCustomDirectoryEntry = {
  __typename?: 'UpdateCustomDirectoryEntry';
  directoryEntry: CustomDirectoryEntryQl;
};

export type UpdateCustomDirectoryEntryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  mdn?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDefaultView = {
  __typename?: 'UpdateDefaultView';
  user?: Maybe<UserQl>;
};

export type UpdateDefaultViewInput = {
  defaultView: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateDefaultYouView = {
  __typename?: 'UpdateDefaultYouView';
  user?: Maybe<UserQl>;
};

export type UpdateDefaultYouViewInput = {
  defaultYouView: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateDepartmentDevice = {
  __typename?: 'UpdateDepartmentDevice';
  device: DepartmentDeviceQl;
};

export type UpdateDepartmentDeviceInput = {
  enabledAfterBusinessHours?: InputMaybe<Scalars['Boolean']['input']>;
  enabledDuringBusinessHours?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  mdn?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sipAddress?: InputMaybe<Scalars['String']['input']>;
  sipPriorityFirst?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<DeviceTypeInput>;
};

export type UpdateDirectoryEntry = {
  __typename?: 'UpdateDirectoryEntry';
  directoryEntry: DirectoryEntryQl;
};

export type UpdateDirectoryEntryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEtoSettings = {
  __typename?: 'UpdateETOSettings';
  etoSettings?: Maybe<EtoSettingsQl>;
};

export type UpdateEtoSettingsInput = {
  daysFrequency?: InputMaybe<Scalars['Int']['input']>;
  eligibilityCriteria?: InputMaybe<Scalars['JSONString']['input']>;
  id: Scalars['String']['input'];
  isInboxLabelEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  leadCreationEmail?: InputMaybe<Scalars['String']['input']>;
  minimumQualifyingScore?: InputMaybe<Scalars['Int']['input']>;
  noRepeat?: InputMaybe<Scalars['Boolean']['input']>;
  oneAtATime?: InputMaybe<Scalars['Boolean']['input']>;
  qualifiedNotificationEmailRecipient?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEdgesVoiceStep = {
  __typename?: 'UpdateEdgesVoiceStep';
  voiceScript?: Maybe<VoiceScriptQl>;
};

export type UpdateEdgesVoiceStepInput = {
  appointmentLeadStepId?: InputMaybe<Scalars['String']['input']>;
  autoAssignNextStepId?: InputMaybe<Scalars['String']['input']>;
  callerRecognizedStepId?: InputMaybe<Scalars['String']['input']>;
  cantServiceCustomerStepId?: InputMaybe<Scalars['String']['input']>;
  connection?: InputMaybe<Scalars['String']['input']>;
  failureStepId?: InputMaybe<Scalars['String']['input']>;
  humanEscalationStepId?: InputMaybe<Scalars['String']['input']>;
  newStepId?: InputMaybe<Scalars['String']['input']>;
  nextStepId?: InputMaybe<Scalars['String']['input']>;
  noStatusGivenStepId?: InputMaybe<Scalars['String']['input']>;
  notAnAppointmentLeadStepId?: InputMaybe<Scalars['String']['input']>;
  notBookedOtherStepId?: InputMaybe<Scalars['String']['input']>;
  notBookedRecallStepId?: InputMaybe<Scalars['String']['input']>;
  onClosedStepId?: InputMaybe<Scalars['String']['input']>;
  onConnectedStepId?: InputMaybe<Scalars['String']['input']>;
  onHasLabelId?: InputMaybe<Scalars['String']['input']>;
  onHasResponseId?: InputMaybe<Scalars['String']['input']>;
  onMissingLabelId?: InputMaybe<Scalars['String']['input']>;
  onNoAnsweringStepId?: InputMaybe<Scalars['String']['input']>;
  onNoResponseId?: InputMaybe<Scalars['String']['input']>;
  onNoStepId?: InputMaybe<Scalars['String']['input']>;
  onOpenStepId?: InputMaybe<Scalars['String']['input']>;
  onYesButNoTextStepId?: InputMaybe<Scalars['String']['input']>;
  onYesStepId?: InputMaybe<Scalars['String']['input']>;
  shorthandPrompt?: InputMaybe<Scalars['String']['input']>;
  statusGivenStepId?: InputMaybe<Scalars['String']['input']>;
  stepId: Scalars['String']['input'];
};

export type UpdateEquityTradeOpportunityStage = {
  __typename?: 'UpdateEquityTradeOpportunityStage';
  equityTradeOpportunity?: Maybe<EquityTradeOpportunityQl>;
};

export type UpdateEquityTradeOpportunityStageInput = {
  equityTradeOpportunityId: Scalars['String']['input'];
  stage: Scalars['String']['input'];
};

export type UpdateEscalationSettings = {
  __typename?: 'UpdateEscalationSettings';
  accountSettings?: Maybe<AccountSettingsQl>;
  currentAccount?: Maybe<AccountQl>;
};

export type UpdateEscalationSettingsInput = {
  escalationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  escalationsThreshold?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGreeting = {
  __typename?: 'UpdateGreeting';
  greeting?: Maybe<GreetingQl>;
};

export type UpdateGreetingInput = {
  afterHoursContentTemplate?: InputMaybe<Scalars['String']['input']>;
  contentTemplate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type UpdateHasDismissedGuideChecklist = {
  __typename?: 'UpdateHasDismissedGuideChecklist';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateHasDismissedGuideChecklistInput = {
  hasDismissedGuideChecklist: Scalars['Boolean']['input'];
  placeId: Scalars['String']['input'];
};

export type UpdateHasViewedRefer = {
  __typename?: 'UpdateHasViewedRefer';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateHasViewedReferInput = {
  hasViewedRefer: Scalars['Boolean']['input'];
  placeId: Scalars['String']['input'];
};

export type UpdateHideSharedInboxViews = {
  __typename?: 'UpdateHideSharedInboxViews';
  user?: Maybe<UserQl>;
};

export type UpdateHideSharedInboxViewsInput = {
  hideSharedInboxViews: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateHostedSms = {
  __typename?: 'UpdateHostedSms';
  hostedSmsPort?: Maybe<HostedSmsPortQl>;
};

export type UpdateHostedSmsInput = {
  hostedSmsId: Scalars['String']['input'];
  sid?: InputMaybe<Scalars['String']['input']>;
  verificationAttempts?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateIsScheduleEnabled = {
  __typename?: 'UpdateIsScheduleEnabled';
  user?: Maybe<UserQl>;
};

export type UpdateIsScheduleEnabledInput = {
  isScheduleEnabled: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateIsUnassigningInboundMessages = {
  __typename?: 'UpdateIsUnassigningInboundMessages';
  user?: Maybe<UserQl>;
};

export type UpdateIsUnassigningInboundMessagesInput = {
  isUnassigningInboundMessages: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateLabel = {
  __typename?: 'UpdateLabel';
  label: LabelQl;
};

export type UpdateLabelInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  expirationHours?: InputMaybe<Scalars['Int']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconType?: InputMaybe<Scalars['String']['input']>;
  labelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLanguageSettings = {
  __typename?: 'UpdateLanguageSettings';
  place?: Maybe<PlaceQl>;
};

export type UpdateLanguageSettingsInput = {
  allowedSpeechLanguages?: InputMaybe<Array<Language>>;
  placeId: Scalars['String']['input'];
  speechLanguage?: InputMaybe<Language>;
};

export type UpdateLink = {
  __typename?: 'UpdateLink';
  placeInfo?: Maybe<PlaceInfoQl>;
};

export type UpdateLinkInput = {
  groupName: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  tag: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLinkUrls = {
  __typename?: 'UpdateLinkUrls';
  placeInfo?: Maybe<PlaceInfoQl>;
};

export type UpdateLinkUrlsInput = {
  links?: InputMaybe<Array<InputMaybe<UpdatedLink>>>;
  placeId: Scalars['String']['input'];
};

export type UpdateLoggedCall = {
  __typename?: 'UpdateLoggedCall';
  message?: Maybe<MessageQl>;
};

export type UpdateLoggedCallInput = {
  loggedCallInteraction: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
};

export type UpdateLogos = {
  __typename?: 'UpdateLogos';
  placeInfo?: Maybe<PlaceInfoQl>;
};

export type UpdateLogosInput = {
  avatarImageData?: InputMaybe<Scalars['Upload']['input']>;
  avatarImageName?: InputMaybe<Scalars['String']['input']>;
  companyLogoData?: InputMaybe<Scalars['Upload']['input']>;
  companyLogoName?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
};

export type UpdateMissedCallFollowUpSetting = {
  __typename?: 'UpdateMissedCallFollowUpSetting';
  user?: Maybe<UserQl>;
};

export type UpdateMissedCallFollowUpSettingInput = {
  missedOutboundCallFollowUpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  missedOutboundCallFollowUpMessage?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdateNamePronunciation = {
  __typename?: 'UpdateNamePronunciation';
  place?: Maybe<PlaceQl>;
};

export type UpdateNamePronunciationInput = {
  namePronunciation: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type UpdateNewConversationsPerDay = {
  __typename?: 'UpdateNewConversationsPerDay';
  place?: Maybe<PlaceQl>;
};

export type UpdateNewConversationsPerDayInput = {
  newConversationsPerDay: Scalars['Int']['input'];
  placeId: Scalars['String']['input'];
};

export type UpdateOperator = {
  __typename?: 'UpdateOperator';
  operator: OperatorQl;
};

export type UpdateOperatorChannel = {
  __typename?: 'UpdateOperatorChannel';
  operator: OperatorQl;
  operatorChannel: OperatorChannelQl;
};

export type UpdateOperatorChannelInput = {
  channelId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  operatorId: Scalars['String']['input'];
  settings?: InputMaybe<Scalars['JSONString']['input']>;
};

export type UpdateOperatorInput = {
  faq?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  operatorFaq?: InputMaybe<Scalars['JSONString']['input']>;
  spokenGreetingName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOperatorPlaceDescription = {
  __typename?: 'UpdateOperatorPlaceDescription';
  operator: OperatorQl;
  operatorPlace: OperatorPlaceQl;
};

export type UpdateOperatorPlaceDescriptionInput = {
  description: Scalars['String']['input'];
  operatorId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type UpdateOperatorPlaceSettings = {
  __typename?: 'UpdateOperatorPlaceSettings';
  operator: OperatorQl;
  operatorPlace: OperatorPlaceQl;
};

export type UpdateOperatorPlaceSettingsInput = {
  operatorId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  settings: Scalars['JSONString']['input'];
};

export type UpdateOperatorSettings = {
  __typename?: 'UpdateOperatorSettings';
  operatorSettings: OperatorSettingsQl;
};

export type UpdateOperatorSettingsInput = {
  appointmentAgentSettingsId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  settings?: InputMaybe<Scalars['JSONString']['input']>;
  voiceId?: InputMaybe<Scalars['String']['input']>;
  voiceProvider?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOpportunityActionQl = AutomationAction &
  Node & {
    __typename?: 'UpdateOpportunityActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    nextActionId?: Maybe<Scalars['String']['output']>;
    opportunity?: Maybe<OpportunityInfo>;
    uiHints?: Maybe<AutomationUiHints>;
  };

export type UpdateOutboundCallCustomization = {
  __typename?: 'UpdateOutboundCallCustomization';
  outboundCallCustomization?: Maybe<OutboundCallCustomizationQl>;
};

export type UpdateOutboundCallCustomizationInput = {
  disclosureSpeech?: InputMaybe<Scalars['String']['input']>;
  hostNoAnswerSpeech?: InputMaybe<Scalars['String']['input']>;
  leaveVoicemail?: InputMaybe<Scalars['Boolean']['input']>;
  outboundCallCustomizationId: Scalars['String']['input'];
  voice?: InputMaybe<Scalars['String']['input']>;
  voicemailSpeech?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOutboundConferenceCall = {
  __typename?: 'UpdateOutboundConferenceCall';
  outboundConferenceCall: OutboundConferenceCallQl;
};

export type UpdateOutboundConferenceCallInput = {
  id: Scalars['String']['input'];
  isBeingRecorded: Scalars['Boolean']['input'];
};

export type UpdateParticipant = {
  __typename?: 'UpdateParticipant';
  participant?: Maybe<ParticipantQl>;
};

export type UpdateParticipantInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<LanguageInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  participantId: Scalars['String']['input'];
  spamStatus?: InputMaybe<SpamStatusInput>;
};

export type UpdatePaymentRequestAttachment = {
  __typename?: 'UpdatePaymentRequestAttachment';
  paymentRequest: PaymentRequestQl;
};

export type UpdatePaymentRequestAttachmentInput = {
  attachment?: InputMaybe<AttachmentInput>;
  attachmentDescription?: InputMaybe<Scalars['String']['input']>;
  paymentRequestId: Scalars['String']['input'];
};

export type UpdatePaymentRequestCustomization = {
  __typename?: 'UpdatePaymentRequestCustomization';
  paymentRequestCustomization?: Maybe<PaymentRequestCustomizationQl>;
};

export type UpdatePaymentRequestCustomizationInput = {
  canceledAutoSend?: InputMaybe<Scalars['Boolean']['input']>;
  canceledTemplate?: InputMaybe<Scalars['String']['input']>;
  createAutoSend?: InputMaybe<Scalars['Boolean']['input']>;
  createHoldAutoSend?: InputMaybe<Scalars['Boolean']['input']>;
  createHoldTemplate?: InputMaybe<Scalars['String']['input']>;
  createTemplate?: InputMaybe<Scalars['String']['input']>;
  partialRefundAutoSend?: InputMaybe<Scalars['Boolean']['input']>;
  partialRefundTemplate?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  refundAutoSend?: InputMaybe<Scalars['Boolean']['input']>;
  refundTemplate?: InputMaybe<Scalars['String']['input']>;
  successAutoSend?: InputMaybe<Scalars['Boolean']['input']>;
  successTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePhoneCall = {
  __typename?: 'UpdatePhoneCall';
  phonecall?: Maybe<PhoneCallQl>;
};

export type UpdatePhoneCallInput = {
  id: Scalars['String']['input'];
  isBeingRecorded: Scalars['Boolean']['input'];
};

export type UpdatePhoneLine = {
  __typename?: 'UpdatePhoneLine';
  phoneline?: Maybe<PhoneLineQl>;
};

export enum UpdatePhoneLineCategoryInput {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  User = 'USER',
}

export type UpdatePhoneLineInput = {
  answerWithKeys?: InputMaybe<Scalars['String']['input']>;
  autoOptin?: InputMaybe<Scalars['Boolean']['input']>;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<UpdatePhoneLineCategoryInput>;
  delayAnswerDuration?: InputMaybe<Scalars['Int']['input']>;
  lineType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nryForwardingMdn?: InputMaybe<Scalars['String']['input']>;
  phonelineId: Scalars['String']['input'];
  returnCallsForwardingMode?: InputMaybe<PhoneLineReturnCallForwadingOptions>;
  returnCallsMode?: InputMaybe<PhoneLineReturnCallOptions>;
  returnCallsRoutingHours?: InputMaybe<PhoneLineReturnCallRoutingHours>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePhoneLineLanguageSettings = {
  __typename?: 'UpdatePhoneLineLanguageSettings';
  phoneline?: Maybe<PhoneLineQl>;
};

export type UpdatePhoneLineLanguageSettingsInput = {
  allowedSpeechLanguages?: InputMaybe<Array<Language>>;
  phonelineId: Scalars['String']['input'];
  speechLanguage?: InputMaybe<Language>;
};

export type UpdatePhoneLineName = {
  __typename?: 'UpdatePhoneLineName';
  phoneline?: Maybe<PhoneLineQl>;
};

export type UpdatePhoneLineNameInput = {
  name: Scalars['String']['input'];
  phonelineId: Scalars['String']['input'];
};

export type UpdatePhoneLinePolicy = {
  __typename?: 'UpdatePhoneLinePolicy';
  phoneLinePolicy?: Maybe<PhoneLinePolicyQl>;
};

export type UpdatePhoneLinePolicyInput = {
  allowDisruptions?: InputMaybe<Scalars['Boolean']['input']>;
  answerWithKeys?: InputMaybe<Scalars['String']['input']>;
  archiveMissedCalls?: InputMaybe<Scalars['Boolean']['input']>;
  assistantPhrase?: InputMaybe<Scalars['String']['input']>;
  autoOptin?: InputMaybe<Scalars['Boolean']['input']>;
  autoOptinMessage?: InputMaybe<Scalars['String']['input']>;
  autoSendHangupReplies?: InputMaybe<Scalars['Boolean']['input']>;
  delayAnswerDuration?: InputMaybe<Scalars['Int']['input']>;
  fixInternalDialing?: InputMaybe<Scalars['Boolean']['input']>;
  hangupSuggestion?: InputMaybe<Scalars['String']['input']>;
  hasIdentityPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  nryCallForwardingPickUpTimeoutSecs?: InputMaybe<Scalars['Int']['input']>;
  nryCallForwardingUserScreenInteractionTimeoutSecs?: InputMaybe<
    Scalars['Int']['input']
  >;
  phoneLinePolicyId: Scalars['String']['input'];
};

export type UpdatePlaceDisruptionSettings = {
  __typename?: 'UpdatePlaceDisruptionSettings';
  place?: Maybe<PlaceQl>;
};

export type UpdatePlaceDisruptionSettingsInput = {
  answeringMode: AnsweringMode;
  answeringModeFrom?: InputMaybe<Scalars['ArrowField']['input']>;
  answeringModeUntil?: InputMaybe<Scalars['ArrowField']['input']>;
  disruptions?: InputMaybe<DisruptionsInput>;
  placeId: Scalars['String']['input'];
};

export type UpdatePlaceGroup = {
  __typename?: 'UpdatePlaceGroup';
  placeGroup?: Maybe<PlaceGroupQl>;
};

export type UpdatePlaceGroupInput = {
  name: Scalars['String']['input'];
  placeGroupId: Scalars['String']['input'];
};

export type UpdatePlaceInfo = {
  __typename?: 'UpdatePlaceInfo';
  placeInfo?: Maybe<PlaceInfoQl>;
};

export type UpdatePlaceInfoInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  logoData?: InputMaybe<Scalars['Upload']['input']>;
  logoName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phonenumber?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress1?: InputMaybe<Scalars['String']['input']>;
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlaceMfaSettings = {
  __typename?: 'UpdatePlaceMFASettings';
  place?: Maybe<PlaceQl>;
};

export type UpdatePlaceMfaSettingsInput = {
  enforceMfa: EnforceMfa;
  placeId: Scalars['String']['input'];
};

export type UpdatePlaceMessageSettings = {
  __typename?: 'UpdatePlaceMessageSettings';
  place?: Maybe<PlaceQl>;
};

export type UpdatePlaceMessageSettingsInput = {
  assignmentRetention?: InputMaybe<Scalars['Int']['input']>;
  escalationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  escalationsThreshold?: InputMaybe<Scalars['Int']['input']>;
  placeId: Scalars['String']['input'];
  resetOngoingOptin?: InputMaybe<Scalars['Int']['input']>;
  resetOptinDays?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePlaceOutboundCallSettings = {
  __typename?: 'UpdatePlaceOutboundCallSettings';
  place?: Maybe<PlaceQl>;
};

export type UpdatePlaceOutboundCallSettingsInput = {
  outboundCallSettingsString: Scalars['JSONString']['input'];
  placeId: Scalars['String']['input'];
};

export type UpdatePlaceQuota = {
  __typename?: 'UpdatePlaceQuota';
  place?: Maybe<PlaceQl>;
};

export type UpdatePlaceQuotaInput = {
  newConversationsPerDay: Scalars['Int']['input'];
  placeId: Scalars['String']['input'];
};

export type UpdatePlaceStatus = {
  __typename?: 'UpdatePlaceStatus';
  place?: Maybe<PlaceQl>;
};

export type UpdatePlaceStatusInput = {
  placeId: Scalars['String']['input'];
  status?: InputMaybe<PlaceStatusInput>;
};

export type UpdatePlaceVoice = {
  __typename?: 'UpdatePlaceVoice';
  place?: Maybe<PlaceQl>;
};

export type UpdatePlaceVoiceInput = {
  language?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  voice: Scalars['String']['input'];
};

export type UpdatePublicListing = {
  __typename?: 'UpdatePublicListing';
  place?: Maybe<PlaceQl>;
};

export type UpdatePublicListingInput = {
  isPublished: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type UpdateQuestionAgentSettings = {
  __typename?: 'UpdateQuestionAgentSettings';
  questionAgentSettings?: Maybe<QuestionAgentSettingsQl>;
};

export type UpdateQuestionAgentSettingsInput = {
  id: Scalars['String']['input'];
  settingsBlob: Scalars['JSONString']['input'];
};

export type UpdateReceivesEscalations = {
  __typename?: 'UpdateReceivesEscalations';
  placesUser?: Maybe<PlacesUsersQl>;
};

export type UpdateReceivesEscalationsInput = {
  placeId: Scalars['String']['input'];
  receivesEscalations: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateRepairServiceOpCodesInput = {
  opCodes: Array<OpCodeInput>;
  repairServiceId: Scalars['String']['input'];
};

export type UpdateRepairServicesOpCodes = {
  __typename?: 'UpdateRepairServicesOpCodes';
  repairServices?: Maybe<Array<Maybe<RepairServiceQl>>>;
};

export type UpdateReviewJob = {
  __typename?: 'UpdateReviewJob';
  reviewJob?: Maybe<ReviewJobQl>;
};

export type UpdateReviewJobInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  buttonColor?: InputMaybe<Scalars['String']['input']>;
  buttonTextColor?: InputMaybe<Scalars['String']['input']>;
  fallbackChannelId?: InputMaybe<Scalars['String']['input']>;
  headerColor?: InputMaybe<Scalars['String']['input']>;
  headerTextColor?: InputMaybe<Scalars['String']['input']>;
  logoData?: InputMaybe<Scalars['Upload']['input']>;
  logoName?: InputMaybe<Scalars['String']['input']>;
  messageBody?: InputMaybe<Scalars['String']['input']>;
  messageImageData?: InputMaybe<Scalars['Upload']['input']>;
  messageImageName?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  reviewMode?: InputMaybe<Scalars['String']['input']>;
  reviewSites?: InputMaybe<Array<InputMaybe<ReviewSiteInput>>>;
  skipRatingsScreen?: InputMaybe<Scalars['Boolean']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateServiceAdvisor = {
  __typename?: 'UpdateServiceAdvisor';
  serviceAdvisor?: Maybe<ServiceAdvisorQl>;
};

export type UpdateServiceAdvisorInput = {
  id: Scalars['String']['input'];
  serviceAdvisorId?: InputMaybe<Scalars['String']['input']>;
  serviceAdvisorName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateServiceOverride = {
  __typename?: 'UpdateServiceOverride';
  allSelected?: Maybe<Scalars['Boolean']['output']>;
  appointmentAgentSettingsId?: Maybe<Scalars['String']['output']>;
  howIsHandled?: Maybe<Scalars['String']['output']>;
  numaServiceName?: Maybe<Scalars['String']['output']>;
  opcodes?: Maybe<Array<Maybe<OpcodeOutputQl>>>;
  search?: Maybe<Scalars['String']['output']>;
  vehicles?: Maybe<Array<Maybe<VehicleOutputQl>>>;
};

export type UpdateServiceOverrideInputQl = {
  allSelected?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentAgentSettingsId: Scalars['String']['input'];
  howIsHandled: Scalars['String']['input'];
  numaServiceName: Scalars['String']['input'];
  opcodes?: InputMaybe<Array<InputMaybe<OpcodeInputQl>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  vehicles?: InputMaybe<Array<InputMaybe<VehicleInputQl>>>;
};

export type UpdateShortcut = {
  __typename?: 'UpdateShortcut';
  shortcut?: Maybe<ShortcutQl>;
};

export type UpdateShortcutInput = {
  content: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shortcutId: Scalars['String']['input'];
  tag: Scalars['String']['input'];
};

export type UpdateShowBannerAfter = {
  __typename?: 'UpdateShowBannerAfter';
  currentUser?: Maybe<UserQl>;
};

export type UpdateStage = {
  __typename?: 'UpdateStage';
  stage?: Maybe<StageQl>;
};

export type UpdateStageInput = {
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
  speechUpdate?: InputMaybe<Scalars['String']['input']>;
  stageId: Scalars['String']['input'];
  updateMessageTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStatusBoardView = {
  __typename?: 'UpdateStatusBoardView';
  user?: Maybe<UserQl>;
};

export type UpdateStatusBoardViewInput = {
  statusBoardView: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateStatusItem = {
  __typename?: 'UpdateStatusItem';
  statusItem?: Maybe<StatusItemQl>;
};

export type UpdateStatusItemInput = {
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eta?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  stageId?: InputMaybe<Scalars['String']['input']>;
  statusId: Scalars['String']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupportedVehiclesInput = {
  id: Scalars['String']['input'];
  opCodes: Array<InputMaybe<UpdateSupportedVehiclesInputOpCodes>>;
  useOverrides: Scalars['Boolean']['input'];
};

export type UpdateSupportedVehiclesInputOpCodes = {
  id: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  opCodeId: Scalars['String']['input'];
};

export type UpdateSurveyAnsweredTriggerInput = {
  inequalityFilter: InequalityFilterTriggerValuesTypes;
  ratingChoice: Scalars['Int']['input'];
  surveyType: SurveyTypeTriggerValuesTypes;
};

export type UpdateSystemMessageSettingsInput = {
  showSystemMessages: Scalars['Boolean']['input'];
};

export type UpdateTeam = {
  __typename?: 'UpdateTeam';
  team?: Maybe<TeamQl>;
};

export type UpdateTeamInput = {
  assignmentStyle?: InputMaybe<AssignmentStyleInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['String']['input'];
};

export type UpdateTransportationSet = {
  __typename?: 'UpdateTransportationSet';
  transportationSet: TransportationSetQl;
};

export type UpdateTransportationSetInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  repairServices?: InputMaybe<Array<UpdateTransportationSetRepairServiceInput>>;
  rules?: InputMaybe<Scalars['JSONString']['input']>;
  transportationOptions?: InputMaybe<
    Array<UpdateTransportationSetTransportationOptionInput>
  >;
};

export type UpdateTransportationSetRepairServiceInput = {
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  repairServiceId: Scalars['String']['input'];
};

export type UpdateTransportationSetTransportationOptionInput = {
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  kind: Scalars['String']['input'];
  minimumServiceItems: Scalars['Int']['input'];
  order: Scalars['Int']['input'];
  speechLong: Scalars['String']['input'];
  speechShort: Scalars['String']['input'];
};

export type UpdateTwilioChannel = {
  __typename?: 'UpdateTwilioChannel';
  channel?: Maybe<TwilioChannelQl>;
};

export type UpdateTwilioChannelInput = {
  answerWithKeys?: InputMaybe<Scalars['String']['input']>;
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  autoOptin?: InputMaybe<Scalars['Boolean']['input']>;
  autoOptinMessage?: InputMaybe<Scalars['String']['input']>;
  autoSendHangupReplies?: InputMaybe<Scalars['Boolean']['input']>;
  channelId: Scalars['String']['input'];
  delayAnswerDuration?: InputMaybe<Scalars['Int']['input']>;
  respectExistingAssignments?: InputMaybe<Scalars['Boolean']['input']>;
  sendOutboundsWithShadowTollfree?: InputMaybe<Scalars['Boolean']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  voiceScriptId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUseNewNumber = {
  __typename?: 'UpdateUseNewNumber';
  account?: Maybe<AccountQl>;
};

export type UpdateUseNewNumberInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  updateCallScripts: Scalars['Boolean']['input'];
  useNewNumber: Scalars['Boolean']['input'];
};

export type UpdateUser = {
  __typename?: 'UpdateUser';
  user?: Maybe<UserQl>;
};

export type UpdateUserInformation = {
  __typename?: 'UpdateUserInformation';
  /** @deprecated use 'user' instead */
  currentUser?: Maybe<UserQl>;
  user?: Maybe<UserQl>;
};

export type UpdateUserInformationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  jobRole?: InputMaybe<JobRole>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mdn?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  signature?: InputMaybe<Scalars['String']['input']>;
  signaturePreference?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdateUserMfaSettings = {
  __typename?: 'UpdateUserMFASettings';
  user?: Maybe<UserQl>;
};

export type UpdateUserMfaSettingsInput = {
  enforceMfa?: InputMaybe<EnforceMfa>;
  userId: Scalars['String']['input'];
};

export type UpdateUserPersonalization = {
  __typename?: 'UpdateUserPersonalization';
  user?: Maybe<UserQl>;
};

export type UpdateUserPersonalizationInput = {
  namePronunciation?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<UpdateUserPersonalizationPronounsInput>;
  userId: Scalars['String']['input'];
};

export enum UpdateUserPersonalizationPronounsInput {
  HeHim = 'HE_HIM',
  SheHer = 'SHE_HER',
  TheyThem = 'THEY_THEM',
}

export type UpdateUserPhone = {
  __typename?: 'UpdateUserPhone';
  userPhone: UserPhoneQl;
};

export type UpdateUserPhoneInput = {
  allowRoutingCalls?: InputMaybe<Scalars['Boolean']['input']>;
  enabledAfterBusinessHours?: InputMaybe<Scalars['Boolean']['input']>;
  enabledDuringBusinessHours?: InputMaybe<Scalars['Boolean']['input']>;
  enabledWhenAway?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  mdn?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sipAddress?: InputMaybe<Scalars['String']['input']>;
  sipPriorityFirst?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<UserPhoneTypeInput>;
  useNumaCallerId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserPhonePreference = {
  __typename?: 'UpdateUserPhonePreference';
  user?: Maybe<UserQl>;
};

export type UpdateUserPhonePreferenceInput = {
  userId: Scalars['String']['input'];
  userPhonePreference: UserPhonePreference;
};

export type UpdateUserSchedule = {
  __typename?: 'UpdateUserSchedule';
  user?: Maybe<UserQl>;
};

export type UpdateUserScheduleInput = {
  schedule: Scalars['JSONString']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateUserViewPreferences = {
  __typename?: 'UpdateUserViewPreferences';
  user?: Maybe<UserQl>;
};

export type UpdateUserViewPreferencesInput = {
  systemMessageSettings?: InputMaybe<UpdateSystemMessageSettingsInput>;
  userId: Scalars['String']['input'];
};

export type UpdateVideoUploadLink = {
  __typename?: 'UpdateVideoUploadLink';
  videoUploadLink: VideoUploadLinkQl;
};

export type UpdateVideoUploadLinkInput = {
  id: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVoiceScript = {
  __typename?: 'UpdateVoiceScript';
  voiceScript?: Maybe<VoiceScriptQl>;
};

export type UpdateVoiceScriptInput = {
  afterHoursEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  allowCustomAudio?: InputMaybe<Scalars['Boolean']['input']>;
  firstStepId?: InputMaybe<Scalars['String']['input']>;
  scriptId: Scalars['String']['input'];
  scriptType?: InputMaybe<VoiceScriptType>;
  voice?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVoiceStep = {
  __typename?: 'UpdateVoiceStep';
  script?: Maybe<VoiceScriptQl>;
  step?: Maybe<VoiceScriptStep>;
};

export type UpdateVoiceStepInput = {
  acknowledgementSpeech?: InputMaybe<Scalars['String']['input']>;
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  affirmationSpeech?: InputMaybe<Scalars['String']['input']>;
  afterHoursSpeech?: InputMaybe<Scalars['String']['input']>;
  afterHoursTextMessage?: InputMaybe<Scalars['String']['input']>;
  appointmentAgentSettingsId?: InputMaybe<Scalars['String']['input']>;
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  bookedSpeech?: InputMaybe<Scalars['String']['input']>;
  callTimeout?: InputMaybe<Scalars['Int']['input']>;
  canWeTextSpeech?: InputMaybe<Scalars['String']['input']>;
  clarificationSpeech?: InputMaybe<Scalars['String']['input']>;
  clarifyCanWeTextSpeech?: InputMaybe<Scalars['String']['input']>;
  clarifyIntentFirstEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  clarifySpeech?: InputMaybe<Scalars['String']['input']>;
  collectNewPhonenumberSpeech?: InputMaybe<Scalars['String']['input']>;
  collectPhonenumberFallbackSpeech?: InputMaybe<Scalars['String']['input']>;
  confirmIntentSpeech?: InputMaybe<Scalars['String']['input']>;
  confirmPhonenumberSpeech?: InputMaybe<Scalars['String']['input']>;
  customAfterHoursAudio?: InputMaybe<VoiceInput>;
  customAfterHoursAudioUrl?: InputMaybe<Scalars['String']['input']>;
  customAudio?: InputMaybe<VoiceInput>;
  customAudioUrl?: InputMaybe<Scalars['String']['input']>;
  desiredConversationState?: InputMaybe<DesiredConversationStateActionInput>;
  disclosureContent?: InputMaybe<Scalars['String']['input']>;
  enabledAfterBusinessHours?: InputMaybe<Scalars['Boolean']['input']>;
  enabledDuringBusinessHours?: InputMaybe<Scalars['Boolean']['input']>;
  expirationHours?: InputMaybe<Scalars['Int']['input']>;
  failureSpeech?: InputMaybe<Scalars['String']['input']>;
  finishedSpeech?: InputMaybe<Scalars['String']['input']>;
  forwardingMdn?: InputMaybe<Scalars['String']['input']>;
  forwardingMdns?: InputMaybe<Array<CallForwardingStepMdnsInput>>;
  forwardingMode?: InputMaybe<CallForwardingModeInput>;
  greetingSpeech?: InputMaybe<Scalars['String']['input']>;
  humanEscalationSpeech?: InputMaybe<Scalars['String']['input']>;
  isCorrectQuestionSpeech?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  labelName?: InputMaybe<Scalars['String']['input']>;
  leadSpeech?: InputMaybe<Scalars['String']['input']>;
  llmModelOverride?: InputMaybe<Scalars['String']['input']>;
  llmPromptOverride?: InputMaybe<Scalars['String']['input']>;
  messageToSend?: InputMaybe<Scalars['String']['input']>;
  noAnswerSpeech?: InputMaybe<Scalars['String']['input']>;
  noMatchStepId?: InputMaybe<Scalars['String']['input']>;
  noSpeech?: InputMaybe<Scalars['String']['input']>;
  noteTakerId?: InputMaybe<Scalars['String']['input']>;
  onClosedStepId?: InputMaybe<Scalars['String']['input']>;
  onFailCanWeTextSpeech?: InputMaybe<Scalars['String']['input']>;
  onFailureSpeech?: InputMaybe<Scalars['String']['input']>;
  onHasLabelId?: InputMaybe<Scalars['String']['input']>;
  onHasResponseId?: InputMaybe<Scalars['String']['input']>;
  onMissingLabelId?: InputMaybe<Scalars['String']['input']>;
  onNoCanWeTextSpeech?: InputMaybe<Scalars['String']['input']>;
  onNoResponseId?: InputMaybe<Scalars['String']['input']>;
  onNoSpeech?: InputMaybe<Scalars['String']['input']>;
  onOpenStepId?: InputMaybe<Scalars['String']['input']>;
  onYesCanWeTextSpeech?: InputMaybe<Scalars['String']['input']>;
  onYesSpeech?: InputMaybe<Scalars['String']['input']>;
  operatorId?: InputMaybe<Scalars['String']['input']>;
  optinTextMessage?: InputMaybe<Scalars['String']['input']>;
  outcomeNotBookedOtherSpeech?: InputMaybe<Scalars['String']['input']>;
  outcomeNotBookedRecallSpeech?: InputMaybe<Scalars['String']['input']>;
  outcomeNotBookedWantsHumanSpeech?: InputMaybe<Scalars['String']['input']>;
  playDisclosureRecording?: InputMaybe<Scalars['Boolean']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  questionAgentSettingsId?: InputMaybe<Scalars['String']['input']>;
  respectExistingAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  retrySpeech?: InputMaybe<Scalars['String']['input']>;
  shorthandPrompt?: InputMaybe<Scalars['String']['input']>;
  shouldConfirmIntent?: InputMaybe<Scalars['Boolean']['input']>;
  softOpenSpeech?: InputMaybe<Scalars['String']['input']>;
  speech?: InputMaybe<Scalars['String']['input']>;
  startRecording?: InputMaybe<Scalars['Boolean']['input']>;
  stepId: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Array<SmartTopicLinksInputQl>>;
  unserviceableSpeech?: InputMaybe<Scalars['String']['input']>;
  useAfterHoursTextMessage?: InputMaybe<Scalars['Boolean']['input']>;
  useCustomAudio?: InputMaybe<Scalars['Boolean']['input']>;
  useCustomAudioForAfterHours?: InputMaybe<Scalars['Boolean']['input']>;
  useNumaCallerId?: InputMaybe<Scalars['Boolean']['input']>;
  yesSpeech?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVoiceStepUiHints = {
  __typename?: 'UpdateVoiceStepUIHints';
  voiceScript?: Maybe<VoiceScriptQl>;
};

export type UpdateVoiceStepUiHintsInput = {
  entries: Array<VoiceStepUiHint>;
};

export type UpdateWriteItForMeConfig = {
  __typename?: 'UpdateWriteItForMeConfig';
  writeItForMeConfig: WriteItForMeConfigQl;
};

export type UpdateWriteItForMeConfigInput = {
  instructions: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
};

export type UpdatedLink = {
  groupName: Scalars['String']['input'];
  tag: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type UploadCustomAudio = {
  __typename?: 'UploadCustomAudio';
  script?: Maybe<VoiceScriptQl>;
  step?: Maybe<VoiceScriptStep>;
};

export type UploadCustomAudioInput = {
  customAudio?: InputMaybe<VoiceInput>;
  speechAttribute: Scalars['String']['input'];
  voiceStepId: Scalars['String']['input'];
};

export type UploadCustomOutboundCallAudio = {
  __typename?: 'UploadCustomOutboundCallAudio';
  outboundCallCustomization?: Maybe<OutboundCallCustomizationQl>;
};

export type UploadCustomOutboundCallAudioInput = {
  customAudio?: InputMaybe<VoiceInput>;
  outboundCallCustomizationId: Scalars['String']['input'];
  speechAttribute: Scalars['String']['input'];
};

export type UpsellQl = {
  __typename?: 'UpsellQL';
  objections: Array<Maybe<Objection>>;
  strategies: Array<Maybe<UpsellStrategy>>;
};

export type UpsellStrategy = {
  __typename?: 'UpsellStrategy';
  name: Scalars['String']['output'];
  strategy: Scalars['String']['output'];
};

export type UpsertConversationRepairOrderSmartStatusUpdateSettings = {
  __typename?: 'UpsertConversationRepairOrderSmartStatusUpdateSettings';
  conversation: ConversationQl;
};

export type UpsertConversationRepairOrderSmartStatusUpdateSettingsInput = {
  conversationId: Scalars['String']['input'];
  /** Custom instructions on LLM context to generate the repair order smart status update */
  customInstructions?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
};

export type UpsertRepairOrderSmartStatusUpdateSettings = {
  __typename?: 'UpsertRepairOrderSmartStatusUpdateSettings';
  repairOrderSmartStatusUpdateSettings?: Maybe<RepairOrderSmartStatusUpdateSettingsQl>;
};

export type UpsertSubscription = {
  __typename?: 'UpsertSubscription';
  subscription?: Maybe<SubscriptionQl>;
};

export type UseAfterHoursGreeting = {
  __typename?: 'UseAfterHoursGreeting';
  place?: Maybe<PlaceQl>;
};

export type UseAfterHoursGreetingInput = {
  placeId: Scalars['String']['input'];
  useAfterHoursGreeting: Scalars['Boolean']['input'];
};

export type UserAnsweredQuestionInput = {
  /** The user's answer to the question */
  answer: Scalars['String']['input'];
  /** The question provided to the user */
  question: Scalars['String']['input'];
};

export type UserConnection = {
  __typename?: 'UserConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type UserDirectoryEntryQl = DirectoryEntryQl &
  Node & {
    __typename?: 'UserDirectoryEntryQL';
    createdOn: Scalars['ArrowField']['output'];
    customDirectoryEntry?: Maybe<CustomDirectoryEntryModelQl>;
    customDirectoryEntryId?: Maybe<Scalars['String']['output']>;
    department?: Maybe<DepartmentQl>;
    departmentId?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    devices?: Maybe<Array<Maybe<DirectoryDeviceQl>>>;
    displayName?: Maybe<Scalars['String']['output']>;
    entryType?: Maybe<DirectoryEntryType>;
    id: Scalars['ID']['output'];
    isDiscoverable?: Maybe<Scalars['Boolean']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    placeGroup?: Maybe<PlaceGroupQl>;
    placeGroupId: Scalars['String']['output'];
    user?: Maybe<UserQl>;
    userId?: Maybe<Scalars['String']['output']>;
  };

/** A Relay edge containing a `User` and its cursor. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserQl>;
};

export type UserLogin = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  supportToolRequested?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A collection of user-specific metrics, accross all the places the requestor has access to. */
export type UserMetrics = Node & {
  __typename?: 'UserMetrics';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  lastMessageSentAt?: Maybe<Scalars['ArrowField']['output']>;
  openConversationsCount: Scalars['Int']['output'];
  /** Number of overdue conversations the user has. Will be `null` if the user does not belong to any places which have overdue tresholds set. */
  overdueConversationsCount?: Maybe<Scalars['Int']['output']>;
  user: UserQl;
};

export type UserMetricsConnection = {
  __typename?: 'UserMetricsConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserMetricsEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserMetrics` and its cursor. */
export type UserMetricsEdge = {
  __typename?: 'UserMetricsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserMetrics;
};

export type UserModelFilter = {
  accountStatus?: InputMaybe<StringFilter>;
  active?: InputMaybe<BooleanFilter>;
  assignmentClaimSetting?: InputMaybe<StringFilter>;
  billingIdentityId?: InputMaybe<StringFilter>;
  browserNotificationSetting?: InputMaybe<StringFilter>;
  canManageOwnAwayModeSettings?: InputMaybe<BooleanFilter>;
  createdOn?: InputMaybe<ArrowFieldFilter>;
  currentLoginAt?: InputMaybe<DateTimeFilter>;
  currentLoginIp?: InputMaybe<StringFilter>;
  defaultView?: InputMaybe<StringFilter>;
  defaultYouView?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  emailNotificationSetting?: InputMaybe<StringFilter>;
  emailOnAssignment?: InputMaybe<BooleanFilter>;
  enforceMfa?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  fsUniquifier?: InputMaybe<StringFilter>;
  hasMobileLogin?: InputMaybe<BooleanFilter>;
  hideSharedInboxViews?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<StringFilter>;
  isAway?: InputMaybe<BooleanFilter>;
  isScheduleEnabled?: InputMaybe<BooleanFilter>;
  isUnassigningInboundMessages?: InputMaybe<BooleanFilter>;
  jobRole?: InputMaybe<StringFilter>;
  jobTitle?: InputMaybe<StringFilter>;
  language?: InputMaybe<StringFilter>;
  lastLoginAt?: InputMaybe<DateTimeFilter>;
  lastLoginIp?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  lastUpdated?: InputMaybe<ArrowFieldFilter>;
  loginCount?: InputMaybe<IntFilter>;
  mdn?: InputMaybe<StringFilter>;
  missedOutboundCallFollowUpEnabled?: InputMaybe<BooleanFilter>;
  missedOutboundCallFollowUpMessage?: InputMaybe<StringFilter>;
  namePronunciation?: InputMaybe<StringFilter>;
  nextShiftEnd?: InputMaybe<ArrowFieldFilter>;
  nextShiftStart?: InputMaybe<ArrowFieldFilter>;
  outboundProxyNumberId?: InputMaybe<StringFilter>;
  outboundProxyPinCode?: InputMaybe<StringFilter>;
  participantId?: InputMaybe<StringFilter>;
  password?: InputMaybe<StringFilter>;
  permissionsUpdated?: InputMaybe<ArrowFieldFilter>;
  pronouns?: InputMaybe<StringFilter>;
  pushNotificationSetting?: InputMaybe<StringFilter>;
  schedule?: InputMaybe<JsonStringFilter>;
  showAwayModeBannerAfter?: InputMaybe<ArrowFieldFilter>;
  signature?: InputMaybe<StringFilter>;
  signaturePreference?: InputMaybe<StringFilter>;
  statusBoardView?: InputMaybe<BooleanFilter>;
  swipeLeftSetting?: InputMaybe<JsonStringFilter>;
  swipeRightSetting?: InputMaybe<JsonStringFilter>;
  userPhonePreference?: InputMaybe<StringFilter>;
  videoConferenceUrl?: InputMaybe<StringFilter>;
  viewPreferences?: InputMaybe<JsonStringFilter>;
  zendeskId?: InputMaybe<FloatFilter>;
};

export enum UserModelSortEnum {
  ActiveAsc = 'active_asc',
  ActiveDesc = 'active_desc',
  AssignmentClaimSettingAsc = 'assignment_claim_setting_asc',
  AssignmentClaimSettingDesc = 'assignment_claim_setting_desc',
  BillingIdentityIdAsc = 'billing_identity_id_asc',
  BillingIdentityIdDesc = 'billing_identity_id_desc',
  BrowserNotificationSettingAsc = 'browser_notification_setting_asc',
  BrowserNotificationSettingDesc = 'browser_notification_setting_desc',
  CanManageOwnAwayModeSettingsAsc = 'can_manage_own_away_mode_settings_asc',
  CanManageOwnAwayModeSettingsDesc = 'can_manage_own_away_mode_settings_desc',
  CreatedOnAsc = 'created_on_asc',
  CreatedOnDesc = 'created_on_desc',
  CurrentLoginAtAsc = 'current_login_at_asc',
  CurrentLoginAtDesc = 'current_login_at_desc',
  CurrentLoginIpAsc = 'current_login_ip_asc',
  CurrentLoginIpDesc = 'current_login_ip_desc',
  DefaultViewAsc = 'default_view_asc',
  DefaultViewDesc = 'default_view_desc',
  DefaultYouViewAsc = 'default_you_view_asc',
  DefaultYouViewDesc = 'default_you_view_desc',
  EmailAsc = 'email_asc',
  EmailDesc = 'email_desc',
  EmailNotificationSettingAsc = 'email_notification_setting_asc',
  EmailNotificationSettingDesc = 'email_notification_setting_desc',
  EmailOnAssignmentAsc = 'email_on_assignment_asc',
  EmailOnAssignmentDesc = 'email_on_assignment_desc',
  EnforceMfaAsc = 'enforce_mfa_asc',
  EnforceMfaDesc = 'enforce_mfa_desc',
  FirstNameAsc = 'first_name_asc',
  FirstNameDesc = 'first_name_desc',
  FsUniquifierAsc = 'fs_uniquifier_asc',
  FsUniquifierDesc = 'fs_uniquifier_desc',
  HasMobileLoginAsc = 'has_mobile_login_asc',
  HasMobileLoginDesc = 'has_mobile_login_desc',
  HideSharedInboxViewsAsc = 'hide_shared_inbox_views_asc',
  HideSharedInboxViewsDesc = 'hide_shared_inbox_views_desc',
  IdAsc = 'id_asc',
  IdDesc = 'id_desc',
  IsAwayAsc = 'is_away_asc',
  IsAwayDesc = 'is_away_desc',
  IsScheduleEnabledAsc = 'is_schedule_enabled_asc',
  IsScheduleEnabledDesc = 'is_schedule_enabled_desc',
  IsUnassigningInboundMessagesAsc = 'is_unassigning_inbound_messages_asc',
  IsUnassigningInboundMessagesDesc = 'is_unassigning_inbound_messages_desc',
  JobRoleAsc = 'job_role_asc',
  JobRoleDesc = 'job_role_desc',
  JobTitleAsc = 'job_title_asc',
  JobTitleDesc = 'job_title_desc',
  LanguageAsc = 'language_asc',
  LanguageDesc = 'language_desc',
  LastLoginAtAsc = 'last_login_at_asc',
  LastLoginAtDesc = 'last_login_at_desc',
  LastLoginIpAsc = 'last_login_ip_asc',
  LastLoginIpDesc = 'last_login_ip_desc',
  LastNameAsc = 'last_name_asc',
  LastNameDesc = 'last_name_desc',
  LastUpdatedAsc = 'last_updated_asc',
  LastUpdatedDesc = 'last_updated_desc',
  LoginCountAsc = 'login_count_asc',
  LoginCountDesc = 'login_count_desc',
  MdnAsc = 'mdn_asc',
  MdnDesc = 'mdn_desc',
  MissedOutboundCallFollowUpEnabledAsc = 'missed_outbound_call_follow_up_enabled_asc',
  MissedOutboundCallFollowUpEnabledDesc = 'missed_outbound_call_follow_up_enabled_desc',
  MissedOutboundCallFollowUpMessageAsc = 'missed_outbound_call_follow_up_message_asc',
  MissedOutboundCallFollowUpMessageDesc = 'missed_outbound_call_follow_up_message_desc',
  NamePronunciationAsc = 'name_pronunciation_asc',
  NamePronunciationDesc = 'name_pronunciation_desc',
  NextShiftEndAsc = 'next_shift_end_asc',
  NextShiftEndDesc = 'next_shift_end_desc',
  NextShiftStartAsc = 'next_shift_start_asc',
  NextShiftStartDesc = 'next_shift_start_desc',
  OutboundProxyNumberIdAsc = 'outbound_proxy_number_id_asc',
  OutboundProxyNumberIdDesc = 'outbound_proxy_number_id_desc',
  OutboundProxyPinCodeAsc = 'outbound_proxy_pin_code_asc',
  OutboundProxyPinCodeDesc = 'outbound_proxy_pin_code_desc',
  ParticipantIdAsc = 'participant_id_asc',
  ParticipantIdDesc = 'participant_id_desc',
  PasswordAsc = 'password_asc',
  PasswordDesc = 'password_desc',
  PermissionsUpdatedAsc = 'permissions_updated_asc',
  PermissionsUpdatedDesc = 'permissions_updated_desc',
  PronounsAsc = 'pronouns_asc',
  PronounsDesc = 'pronouns_desc',
  PushNotificationSettingAsc = 'push_notification_setting_asc',
  PushNotificationSettingDesc = 'push_notification_setting_desc',
  ScheduleAsc = 'schedule_asc',
  ScheduleDesc = 'schedule_desc',
  ShowAwayModeBannerAfterAsc = 'show_away_mode_banner_after_asc',
  ShowAwayModeBannerAfterDesc = 'show_away_mode_banner_after_desc',
  SignatureAsc = 'signature_asc',
  SignatureDesc = 'signature_desc',
  SignaturePreferenceAsc = 'signature_preference_asc',
  SignaturePreferenceDesc = 'signature_preference_desc',
  StatusBoardViewAsc = 'status_board_view_asc',
  StatusBoardViewDesc = 'status_board_view_desc',
  SwipeLeftSettingAsc = 'swipe_left_setting_asc',
  SwipeLeftSettingDesc = 'swipe_left_setting_desc',
  SwipeRightSettingAsc = 'swipe_right_setting_asc',
  SwipeRightSettingDesc = 'swipe_right_setting_desc',
  UserPhonePreferenceAsc = 'user_phone_preference_asc',
  UserPhonePreferenceDesc = 'user_phone_preference_desc',
  VideoConferenceUrlAsc = 'video_conference_url_asc',
  VideoConferenceUrlDesc = 'video_conference_url_desc',
  ViewPreferencesAsc = 'view_preferences_asc',
  ViewPreferencesDesc = 'view_preferences_desc',
  ZendeskIdAsc = 'zendesk_id_asc',
  ZendeskIdDesc = 'zendesk_id_desc',
}

export enum UserPhonePreference {
  Desktop = 'DESKTOP',
  Disabled = 'DISABLED',
  Mobile = 'MOBILE',
  RingAll = 'RING_ALL',
}

export type UserPhoneQl = BaseQl &
  Node & {
    __typename?: 'UserPhoneQL';
    allowRoutingCalls: Scalars['Boolean']['output'];
    createdOn: Scalars['ArrowField']['output'];
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    enabledWhenAway: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    mdn: Scalars['String']['output'];
    name: Scalars['String']['output'];
    sipAddress?: Maybe<Scalars['String']['output']>;
    sipPriorityFirst: Scalars['Boolean']['output'];
    type: UserPhoneType;
    useNumaCallerId: Scalars['Boolean']['output'];
    user?: Maybe<UserQl>;
    userId: Scalars['String']['output'];
  };

export enum UserPhoneType {
  Desk = 'DESK',
  Mobile = 'MOBILE',
}

export enum UserPhoneTypeInput {
  Desk = 'DESK',
  Mobile = 'MOBILE',
}

export type UserQl = BaseQl &
  Node & {
    __typename?: 'UserQL';
    accountPermissions: Array<AccountPermissionsQl>;
    accountStatus?: Maybe<Scalars['String']['output']>;
    active?: Maybe<Scalars['Boolean']['output']>;
    assignedAutopilots?: Maybe<AutopilotQlConnection>;
    assignmentClaimSetting: AssignmentClaimSettings;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    badgeCount?: Maybe<Scalars['Int']['output']>;
    billingIdentity?: Maybe<BillingIdentityQl>;
    billingIdentityId?: Maybe<Scalars['String']['output']>;
    browserNotificationSetting: PushNotificationSettingsInput;
    canManageOwnAwayModeSettings: Scalars['Boolean']['output'];
    closedConversationCount?: Maybe<Scalars['Int']['output']>;
    createdAutopilots?: Maybe<AutopilotQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    crmUser?: Maybe<CrmUserModelQlConnection>;
    crmUsers?: Maybe<Array<CrmUserModelQl>>;
    currentLoginAt?: Maybe<Scalars['DateTime']['output']>;
    currentLoginIp?: Maybe<Scalars['String']['output']>;
    defaultView: Scalars['String']['output'];
    defaultYouView: Scalars['String']['output'];
    directoryEntries?: Maybe<DepartmentDirectoryEntryQlConnection>;
    displayName: Scalars['String']['output'];
    email?: Maybe<Scalars['String']['output']>;
    emailNotificationSetting: EmailNotificationSettings;
    emailOnAssignment: Scalars['Boolean']['output'];
    enforceMfa?: Maybe<EnforceMfa>;
    firstName?: Maybe<Scalars['String']['output']>;
    fullName?: Maybe<Scalars['String']['output']>;
    hasExternalIdentity: Scalars['Boolean']['output'];
    hasMobileLogin: Scalars['Boolean']['output'];
    hasStatusItems: Scalars['Boolean']['output'];
    hideSharedInboxViews: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    inboxes?: Maybe<Array<Maybe<InboxQl>>>;
    isAway: Scalars['Boolean']['output'];
    isScheduleEnabled: Scalars['Boolean']['output'];
    /** @deprecated No longer used as per business requirements */
    isUnassigningInboundMessages: Scalars['Boolean']['output'];
    jobRole?: Maybe<JobRoleInput>;
    jobTitle?: Maybe<Scalars['String']['output']>;
    language?: Maybe<Scalars['String']['output']>;
    lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
    lastLoginIp?: Maybe<Scalars['String']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    localTimezone?: Maybe<Scalars['String']['output']>;
    loginCount?: Maybe<Scalars['Int']['output']>;
    mdn?: Maybe<Scalars['String']['output']>;
    mentions?: Maybe<MentionQlConnection>;
    missedOutboundCallFollowUpEnabled: Scalars['Boolean']['output'];
    missedOutboundCallFollowUpMessage?: Maybe<Scalars['String']['output']>;
    missedOutboundCallFollowUpRenderedMessage?: Maybe<
      Scalars['String']['output']
    >;
    namePronunciation?: Maybe<Scalars['String']['output']>;
    namePronunciationUrl?: Maybe<Scalars['String']['output']>;
    nextShiftEnd?: Maybe<Scalars['ArrowField']['output']>;
    nextShiftStart?: Maybe<Scalars['ArrowField']['output']>;
    openConversationCount?: Maybe<Scalars['Int']['output']>;
    outboundCallCustomizations?: Maybe<OutboundCallCustomizationQlConnection>;
    outboundProxyNumber?: Maybe<BaseOutboundProxyNumber>;
    outboundProxyNumberId?: Maybe<Scalars['String']['output']>;
    outboundProxyPinCode?: Maybe<Scalars['String']['output']>;
    /** How often to poll for overdue conversations (in milliseconds) */
    overdueConversationsPollingIntervalMsec: Scalars['Int']['output'];
    participant?: Maybe<ParticipantQl>;
    participantId?: Maybe<Scalars['String']['output']>;
    permissionsUpdated?: Maybe<Scalars['ArrowField']['output']>;
    phonelines?: Maybe<Array<PhoneLineQl>>;
    placePermissions: Array<PlacePermissionsQl>;
    placesUsers?: Maybe<Array<Maybe<PlacesUsersQl>>>;
    pronouns?: Maybe<Pronouns>;
    pushNotificationSetting: PushNotificationSettings;
    roles?: Maybe<Scalars['String']['output']>;
    schedule?: Maybe<Scalars['JSONString']['output']>;
    showAwayModeBannerAfter?: Maybe<Scalars['ArrowField']['output']>;
    signature?: Maybe<Scalars['String']['output']>;
    signaturePreference: SignaturePreferences;
    status?: Maybe<Scalars['String']['output']>;
    statusBoardView: Scalars['Boolean']['output'];
    statusItems?: Maybe<StatusItemQlConnection>;
    statusLeaderboardColors: LeaderboardColorsQl;
    swipeLeftSetting: Array<Maybe<SwipeActions>>;
    swipeRightSetting: Array<Maybe<SwipeActions>>;
    userPhonePreference: UserPhonePreference;
    userPhones?: Maybe<Array<UserPhoneQl>>;
    videoConferenceUrl?: Maybe<Scalars['String']['output']>;
    viewPreferences: UserViewPreferences;
    zendeskId?: Maybe<Scalars['Float']['output']>;
  };

export type UserQlAssignedAutopilotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserQlClosedConversationCountArgs = {
  placeId?: InputMaybe<Scalars['String']['input']>;
};

export type UserQlCreatedAutopilotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserQlCrmUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserQlDirectoryEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserQlMentionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserQlMissedOutboundCallFollowUpRenderedMessageArgs = {
  placeId?: InputMaybe<Scalars['String']['input']>;
};

export type UserQlOpenConversationCountArgs = {
  placeId?: InputMaybe<Scalars['String']['input']>;
};

export type UserQlOutboundCallCustomizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserQlStatusItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserQlStatusLeaderboardColorsArgs = {
  placeId?: InputMaybe<Scalars['String']['input']>;
};

export type UserQlConnection = {
  __typename?: 'UserQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserQL` and its cursor. */
export type UserQlEdge = {
  __typename?: 'UserQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserQl>;
};

export type UserViewPreferences = {
  __typename?: 'UserViewPreferences';
  systemMessageSettings?: Maybe<SystemMessageSettings>;
};

export type VCardAttachment = Attachment &
  Node & {
    __typename?: 'VCardAttachment';
    attachmentType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    filename: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    message?: Maybe<MessageQl>;
    messageId?: Maybe<Scalars['String']['output']>;
    primaryMimetype?: Maybe<Scalars['String']['output']>;
    sizeBytes: Scalars['String']['output'];
    url: Scalars['String']['output'];
    words?: Maybe<Scalars['JSONString']['output']>;
  };

export enum ValueType {
  Any = 'any',
  None = 'none',
  String = 'string',
}

export type VehicleInputQl = {
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type VehicleOutputQl = {
  __typename?: 'VehicleOutputQL';
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type VideoUploadLinkAttachment = Attachment &
  Node & {
    __typename?: 'VideoUploadLinkAttachment';
    attachmentType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    message?: Maybe<MessageQl>;
    messageId?: Maybe<Scalars['String']['output']>;
    url: Scalars['String']['output'];
    videoMicrositeLinkId?: Maybe<Scalars['String']['output']>;
    videoUploadLink?: Maybe<VideoUploadLinkQl>;
    videoUploadLinkId: Scalars['String']['output'];
  };

export type VideoUploadLinkAttachmentConnection = {
  __typename?: 'VideoUploadLinkAttachmentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VideoUploadLinkAttachmentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `VideoUploadLinkAttachment` and its cursor. */
export type VideoUploadLinkAttachmentEdge = {
  __typename?: 'VideoUploadLinkAttachmentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VideoUploadLinkAttachment>;
};

export type VideoUploadLinkAttachmentInput = {
  generateMicrosite?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  videoUploadLinkId: Scalars['String']['input'];
};

export type VideoUploadLinkQl = BaseQl &
  Node & {
    __typename?: 'VideoUploadLinkQL';
    attachments?: Maybe<VideoUploadLinkAttachmentConnection>;
    createdOn: Scalars['ArrowField']['output'];
    deletedAt?: Maybe<Scalars['ArrowField']['output']>;
    deletedBy?: Maybe<ParticipantQl>;
    deletedById?: Maybe<Scalars['String']['output']>;
    duration?: Maybe<Scalars['Float']['output']>;
    externalId: Scalars['String']['output'];
    fileName?: Maybe<Scalars['String']['output']>;
    fileSize?: Maybe<Scalars['Int']['output']>;
    hasBeenSent: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    micrositeId?: Maybe<Scalars['Int']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    participant?: Maybe<ParticipantQl>;
    participantId?: Maybe<Scalars['String']['output']>;
    payload?: Maybe<Scalars['JSONString']['output']>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    playbackDash?: Maybe<Scalars['String']['output']>;
    playbackHls?: Maybe<Scalars['String']['output']>;
    previewUrl?: Maybe<Scalars['String']['output']>;
    readyToStream: Scalars['Boolean']['output'];
    status: VideoUploadStatus;
    thumbnailUrl?: Maybe<Scalars['String']['output']>;
    uploadUrl: Scalars['String']['output'];
    uploader?: Maybe<ParticipantQl>;
    uploaderId?: Maybe<Scalars['String']['output']>;
  };

export type VideoUploadLinkQlAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoUploadLinkQlConnection = {
  __typename?: 'VideoUploadLinkQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VideoUploadLinkQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `VideoUploadLinkQL` and its cursor. */
export type VideoUploadLinkQlEdge = {
  __typename?: 'VideoUploadLinkQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VideoUploadLinkQl>;
};

export enum VideoUploadStatus {
  Deleted = 'DELETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
}

export type Voice = {
  __typename?: 'Voice';
  displayName: Scalars['String']['output'];
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  service: Scalars['String']['output'];
};

export type VoiceConfigurationQl = {
  __typename?: 'VoiceConfigurationQL';
  imgUrl?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  voiceAudio?: Maybe<Scalars['String']['output']>;
  voiceType: Scalars['String']['output'];
};

export type VoiceInput = {
  data: Scalars['Upload']['input'];
  filename: Scalars['String']['input'];
};

export type VoiceScriptQl = {
  __typename?: 'VoiceScriptQL';
  Voice?: Maybe<Scalars['String']['output']>;
  afterHoursEnabled: Scalars['Boolean']['output'];
  allowCustomAudio?: Maybe<Scalars['Boolean']['output']>;
  answeringScripts?: Maybe<AnsweringScriptsQlConnection>;
  createdOn?: Maybe<Scalars['ArrowField']['output']>;
  dirty: Scalars['Boolean']['output'];
  disruptionDepartmentDisruption?: Maybe<DisruptionsQl>;
  /** @deprecated Unused and will be removed soon */
  disruptionStaffDisruption?: Maybe<Scalars['String']['output']>;
  draftAnsweringScripts?: Maybe<AnsweringScriptsQlConnection>;
  draftDisruptionDepartmentDisruption?: Maybe<DisruptionsQl>;
  /** @deprecated Unused and will be removed soon */
  draftDisruptionStaffDisruption?: Maybe<Scalars['String']['output']>;
  draftHolidayDepartmentDisruption?: Maybe<DisruptionsQl>;
  /** @deprecated Unused and will be removed soon */
  draftHolidayStaffDisruption?: Maybe<Scalars['String']['output']>;
  firstStep?: Maybe<VoiceScriptStepQl>;
  firstStepId?: Maybe<Scalars['String']['output']>;
  holidayDepartmentDisruption?: Maybe<DisruptionsQl>;
  /** @deprecated Unused and will be removed soon */
  holidayStaffDisruption?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  place?: Maybe<PlaceQl>;
  placeId: Scalars['String']['output'];
  previewScript: Array<Scalars['String']['output']>;
  previewVoicemailScript: Array<Scalars['String']['output']>;
  primaryVoiceScriptVoiceScripts?: Maybe<PlaceQlConnection>;
  scriptType: VoicemailScriptType;
  steps: Array<VoiceScriptStep>;
  /** @deprecated Use place.voice instead */
  voice?: Maybe<Scalars['String']['output']>;
};

export type VoiceScriptQlAnsweringScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptQlDraftAnsweringScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptQlPrimaryVoiceScriptVoiceScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStep = {
  canToggle: Scalars['Boolean']['output'];
  createdOn: Scalars['ArrowField']['output'];
  customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
  customAudioOverrides?: Maybe<CustomAudioOverrides>;
  customAudioUrl?: Maybe<Scalars['String']['output']>;
  enabledAfterBusinessHours: Scalars['Boolean']['output'];
  enabledDuringBusinessHours: Scalars['Boolean']['output'];
  executionOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  place?: Maybe<PlaceQl>;
  placeId: Scalars['String']['output'];
  renderedSpeech: Scalars['String']['output'];
  speech: Scalars['String']['output'];
  speechAudioUrl: Scalars['String']['output'];
  stepType: Scalars['String']['output'];
  uiHints?: Maybe<VoiceStepUiHints>;
  voiceScript: VoiceScriptQl;
  voiceScriptId: Scalars['String']['output'];
};

export type VoiceScriptStepQl = Node &
  VoiceScriptStep & {
    __typename?: 'VoiceScriptStepQL';
    appointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    appointmentLeadConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    autoAssignSteps?: Maybe<AutoAssignStepQlConnection>;
    callForwardingConnectedSteps?: Maybe<CallForwardingStepQlConnection>;
    callRecordingSteps?: Maybe<CallRecordingStepQlConnection>;
    canToggle: Scalars['Boolean']['output'];
    cantServiceCustomerAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    checkBusinessHoursOnClosedSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    checkBusinessHoursOnOpenSteps?: Maybe<CheckBusinessHoursStepQlConnection>;
    conversationStateSteps?: Maybe<ConversationStateStepQlConnection>;
    conversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    createdOn: Scalars['ArrowField']['output'];
    customAfterHoursAudioUrl?: Maybe<Scalars['String']['output']>;
    customAudioOverrides?: Maybe<CustomAudioOverrides>;
    customAudioUrl?: Maybe<Scalars['String']['output']>;
    enabledAfterBusinessHours: Scalars['Boolean']['output'];
    enabledDuringBusinessHours: Scalars['Boolean']['output'];
    executionOrder: Scalars['Int']['output'];
    failureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    failureConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    failureNoteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    failureQuestionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    failureRecallAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    firstInScript?: Maybe<Array<Maybe<VoiceScriptQl>>>;
    forwardingNoAnsweringSteps?: Maybe<CallForwardingStepQlConnection>;
    greetingSteps?: Maybe<GreetingStepQlConnection>;
    humanEscalationConversationalSchedulingAgentSteps?: Maybe<ConversationalSchedulingAgentStepQlConnection>;
    id: Scalars['ID']['output'];
    intentQuestionOnNoSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesButNoTextSteps?: Maybe<IntentQuestionQlConnection>;
    intentQuestionOnYesSteps?: Maybe<IntentQuestionQlConnection>;
    label: Scalars['String']['output'];
    labelConversationSteps?: Maybe<LabelConversationStepQlConnection>;
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    notAnAppointmentLeadAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    noteTakerSteps?: Maybe<NoteTakerStepQlConnection>;
    onHasLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onHasResponseSteps?: Maybe<QualifyStepQlConnection>;
    onMissingLabelSteps?: Maybe<CheckForLabelStepQlConnection>;
    onNoResponseSteps?: Maybe<QualifyStepQlConnection>;
    operatorAgentSteps?: Maybe<OperatorAgentStepQlConnection>;
    otherFailureAppointmentAgentSteps?: Maybe<AppointmentAgentStepQlConnection>;
    pickupSteps?: Maybe<PickupStepQlConnection>;
    place?: Maybe<PlaceQl>;
    placeId: Scalars['String']['output'];
    questionBotSteps?: Maybe<QuestionBotStepQlConnection>;
    renderedSpeech: Scalars['String']['output'];
    smartTopicNoMatchSteps?: Maybe<SmartTopicStepQlConnection>;
    speakSteps?: Maybe<SpeakStepQlConnection>;
    specialQuestionOnNoSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesButNoTextSteps?: Maybe<SpecialQuestionQlConnection>;
    specialQuestionOnYesSteps?: Maybe<SpecialQuestionQlConnection>;
    speech: Scalars['String']['output'];
    speechAudioUrl: Scalars['String']['output'];
    statusUpdaterStatusGivenStep?: Maybe<StatusUpdaterStepQlConnection>;
    statusUpdaterStatusGivenSteps?: Maybe<StatusUpdaterStepQlConnection>;
    stepType: Scalars['String']['output'];
    textOptinOnNoSteps?: Maybe<TextOptinStepQlConnection>;
    textOptinOnYesSteps?: Maybe<TextOptinStepQlConnection>;
    uiHints?: Maybe<VoiceStepUiHints>;
    voiceScript: VoiceScriptQl;
    voiceScriptId: Scalars['String']['output'];
    yesNoQuestionOnNoSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
    yesNoQuestionOnYesSteps?: Maybe<AskYesNoQuestionStepQlConnection>;
  };

export type VoiceScriptStepQlAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlAppointmentLeadConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type VoiceScriptStepQlAutoAssignStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlCallForwardingConnectedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlCallRecordingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlCantServiceCustomerAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlCheckBusinessHoursOnClosedStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlCheckBusinessHoursOnOpenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlConversationStateStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlFailureConversationalSchedulingAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlFailureNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlFailureQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlFailureRecallAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlForwardingNoAnsweringStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlGreetingStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlHumanEscalationConversationalSchedulingAgentStepsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
  };

export type VoiceScriptStepQlIntentQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlIntentQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlIntentQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlLabelConversationStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlNotAnAppointmentLeadAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlNoteTakerStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlOnHasLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlOnHasResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlOnMissingLabelStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlOnNoResponseStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlOperatorAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlOtherFailureAppointmentAgentStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlPickupStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlQuestionBotStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlSmartTopicNoMatchStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlSpeakStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlSpecialQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlSpecialQuestionOnYesButNoTextStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlSpecialQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlStatusUpdaterStatusGivenStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlStatusUpdaterStatusGivenStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlTextOptinOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlTextOptinOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlYesNoQuestionOnNoStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlYesNoQuestionOnYesStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type VoiceScriptStepQlConnection = {
  __typename?: 'VoiceScriptStepQLConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VoiceScriptStepQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `VoiceScriptStepQL` and its cursor. */
export type VoiceScriptStepQlEdge = {
  __typename?: 'VoiceScriptStepQLEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VoiceScriptStepQl>;
};

export enum VoiceScriptStepType {
  AppointmentAgent = 'APPOINTMENT_AGENT',
  AskYesNoQuestion = 'ASK_YES_NO_QUESTION',
  AutoAssign = 'AUTO_ASSIGN',
  CallForwarding = 'CALL_FORWARDING',
  CallRecording = 'CALL_RECORDING',
  CheckBusinessHours = 'CHECK_BUSINESS_HOURS',
  CheckForLabel = 'CHECK_FOR_LABEL',
  ConversationalSchedulingAgent = 'CONVERSATIONAL_SCHEDULING_AGENT',
  ConversationState = 'CONVERSATION_STATE',
  Greeting = 'GREETING',
  IntentQuestion = 'INTENT_QUESTION',
  LabelConversation = 'LABEL_CONVERSATION',
  NoteTaker = 'NOTE_TAKER',
  OperatorAgent = 'OPERATOR_AGENT',
  Pickup = 'PICKUP',
  PressAnyKey = 'PRESS_ANY_KEY',
  Qualify = 'QUALIFY',
  QuestionBot = 'QUESTION_BOT',
  RecordMessage = 'RECORD_MESSAGE',
  SmartTopic = 'SMART_TOPIC',
  Speak = 'SPEAK',
  SpecialQuestion = 'SPECIAL_QUESTION',
  StatusUpdate = 'STATUS_UPDATE',
  TextOptin = 'TEXT_OPTIN',
}

export enum VoiceScriptType {
  AppointmentBooking = 'APPOINTMENT_BOOKING',
  CallForwarding = 'CALL_FORWARDING',
  General = 'GENERAL',
  OnlineOrdering = 'ONLINE_ORDERING',
  PersonalAssistant = 'PERSONAL_ASSISTANT',
  PressAnyKey = 'PRESS_ANY_KEY',
  Qualify = 'QUALIFY',
  RepeatCaller = 'REPEAT_CALLER',
  StatusUpdate = 'STATUS_UPDATE',
}

export type VoiceStepUiHint = {
  stepId: Scalars['String']['input'];
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type VoiceStepUiHints = {
  __typename?: 'VoiceStepUIHints';
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export enum VoicemailScriptType {
  AppointmentBooking = 'APPOINTMENT_BOOKING',
  CallForwarding = 'CALL_FORWARDING',
  General = 'GENERAL',
  OnlineOrdering = 'ONLINE_ORDERING',
  PersonalAssistant = 'PERSONAL_ASSISTANT',
  PressAnyKey = 'PRESS_ANY_KEY',
  RepeatCaller = 'REPEAT_CALLER',
  StatusUpdate = 'STATUS_UPDATE',
}

export type WaitActionQl = AutomationAction &
  Node & {
    __typename?: 'WaitActionQL';
    actionType: Scalars['String']['output'];
    automation: AutomationQl;
    automationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    customersWaiting: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    minutesToWait: Scalars['Int']['output'];
    nextActionId?: Maybe<Scalars['String']['output']>;
    uiHints?: Maybe<AutomationUiHints>;
  };

export type WriteItForMeAnswerOption = {
  __typename?: 'WriteItForMeAnswerOption';
  /** Unique identifier for this answer within its question */
  id: Scalars['String']['output'];
  /** ID of the next question to show if this answer is selected, or NIL if this is a terminating answer */
  nextQuestionId?: Maybe<Scalars['String']['output']>;
  /** The text of the answer option */
  text: Scalars['String']['output'];
};

export type WriteItForMeConfigQl = {
  __typename?: 'WriteItForMeConfigQL';
  createdOn?: Maybe<Scalars['ArrowField']['output']>;
  id: Scalars['String']['output'];
  /** Custom instructions for write it for me */
  instructions: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
  place?: Maybe<PlaceQl>;
  /** ID of the place this config belongs to */
  placeId: Scalars['String']['output'];
};

export type WriteItForMeQuestionNode = {
  __typename?: 'WriteItForMeQuestionNode';
  /** List of possible answers for this question */
  answers: Array<WriteItForMeAnswerOption>;
  /** The answer option that is marked as the default, or NIL if no default */
  defaultAnswer?: Maybe<WriteItForMeAnswerOption>;
  /** Unique identifier for this question */
  id: Scalars['String']['output'];
  /** The text of the question to display */
  text: Scalars['String']['output'];
};

export type WriteItForMeQuestionTree = {
  __typename?: 'WriteItForMeQuestionTree';
  /** A list of nodes containing a question with possible answer choices */
  questions: Array<WriteItForMeQuestionNode>;
};

export type WriteItForMeUserAnsweredQuestionInput = {
  /** The user's answer to the question */
  answer: Scalars['String']['input'];
  /** The question provided to the user */
  question: Scalars['String']['input'];
};

export type XTimeLogModelQl = BaseQl &
  Node & {
    __typename?: 'XTimeLogModelQl';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    opCode: OpCodeQl;
    opCodeId?: Maybe<Scalars['String']['output']>;
    supportedVehicles?: Maybe<SupportedVehiclesQl>;
    supportedVehiclesId?: Maybe<Scalars['String']['output']>;
    xtimeLog: OpCodeQl;
    xtimeSync?: Maybe<XTimeSyncModelQl>;
    xtimeSyncId: Scalars['String']['output'];
  };

export type XTimeLogModelQlConnection = {
  __typename?: 'XTimeLogModelQlConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<XTimeLogModelQlEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `XTimeLogModelQl` and its cursor. */
export type XTimeLogModelQlEdge = {
  __typename?: 'XTimeLogModelQlEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<XTimeLogModelQl>;
};

export type XTimeLogQl = BaseQl &
  Node & {
    __typename?: 'XTimeLogQL';
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    opCode?: Maybe<OpCodeQl>;
    opCodeId?: Maybe<Scalars['String']['output']>;
    supportedVehicles?: Maybe<SupportedVehiclesQl>;
    supportedVehiclesId?: Maybe<Scalars['String']['output']>;
    xtimeSync?: Maybe<XTimeSyncModelQl>;
    xtimeSyncId: Scalars['String']['output'];
  };

export type XTimeSyncConnection = {
  __typename?: 'XTimeSyncConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<XTimeSyncEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `XTimeSync` and its cursor. */
export type XTimeSyncEdge = {
  __typename?: 'XTimeSyncEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<XTimeSyncQl>;
};

export type XTimeSyncModelQl = BaseQl &
  Node & {
    __typename?: 'XTimeSyncModelQL';
    Status: XTimeSyncStatus;
    activeIntegration?: Maybe<ActiveIntegrationQl>;
    activeIntegrationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    endDate?: Maybe<Scalars['ArrowField']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    startDate?: Maybe<Scalars['ArrowField']['output']>;
    status: Scalars['String']['output'];
    taskIds: Scalars['JSONString']['output'];
    xtimeLogs?: Maybe<XTimeLogModelQlConnection>;
    xtimeSync: OpCodeQl;
  };

export type XTimeSyncModelQlXtimeLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type XTimeSyncQl = BaseQl &
  Node & {
    __typename?: 'XTimeSyncQL';
    activeIntegration?: Maybe<ActiveIntegrationQl>;
    activeIntegrationId: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    endDate?: Maybe<Scalars['DateTime']['output']>;
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    startDate?: Maybe<Scalars['ArrowField']['output']>;
    status: Scalars['String']['output'];
    taskIds: Scalars['JSONString']['output'];
    xtimeLogs?: Maybe<Array<Maybe<XTimeLogQl>>>;
  };

export enum XTimeSyncStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

export type XtimeServiceQl = {
  __typename?: 'XtimeServiceQL';
  comment?: Maybe<Scalars['String']['output']>;
  opcode: Scalars['String']['output'];
  price?: Maybe<Scalars['String']['output']>;
  sabCode?: Maybe<Scalars['String']['output']>;
  serviceCategoryId?: Maybe<Scalars['String']['output']>;
  serviceCategoryName?: Maybe<Scalars['String']['output']>;
  serviceName: Scalars['String']['output'];
};

export type YelpAttachment = Attachment &
  Node & {
    __typename?: 'YelpAttachment';
    attachmentType: Scalars['String']['output'];
    createdOn: Scalars['ArrowField']['output'];
    id: Scalars['ID']['output'];
    lastUpdated?: Maybe<Scalars['ArrowField']['output']>;
    message?: Maybe<MessageQl>;
    messageId?: Maybe<Scalars['String']['output']>;
    placeInfo?: Maybe<PlaceInfoQl>;
    placeInfoId?: Maybe<Scalars['String']['output']>;
    url: Scalars['String']['output'];
  };

export type YelpAttachmentConnection = {
  __typename?: 'YelpAttachmentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<YelpAttachmentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `YelpAttachment` and its cursor. */
export type YelpAttachmentEdge = {
  __typename?: 'YelpAttachmentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<YelpAttachment>;
};

export enum Callforwardingmode {
  Assignee = 'ASSIGNEE',
  Dial = 'DIAL',
}

export enum Delivery_Status {
  Delivered = 'delivered',
  Expired = 'expired',
  Failed = 'failed',
  Inprogress = 'inprogress',
  Pending = 'pending',
  Sent = 'sent',
}

export enum Message_Format {
  Assignment = 'assignment',
  Dialogflowbot = 'dialogflowbot',
  Escalation = 'escalation',
  Loggedcall = 'loggedcall',
  Media = 'media',
  Missedcall = 'missedcall',
  Multichoice = 'multichoice',
  Note = 'note',
  Numboxagent = 'numboxagent',
  Outboundconference = 'outboundconference',
  Outboundproxy = 'outboundproxy',
  Paymentrequest = 'paymentrequest',
  Rocompleted = 'rocompleted',
  Rostarted = 'rostarted',
  Surveyanswer = 'surveyanswer',
  System = 'system',
  Text = 'text',
  Voice = 'voice',
  Yelp = 'yelp',
}

export enum Source_Types {
  Bot = 'bot',
  Facebook = 'facebook',
  Google = 'google',
  Instagram = 'instagram',
  Rcs = 'rcs',
  Sms = 'sms',
  Team = 'team',
  Twitter = 'twitter',
  User = 'user',
}

export enum Status_Types {
  Active = 'active',
  Disabled = 'disabled',
}

export type GetCurrentAccountQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentAccountQuery = {
  __typename?: 'Query';
  currentAccount?: {
    __typename?: 'AccountQL';
    id: string;
    createdOn: any;
    name: string;
    useNewNumber?: boolean | null;
    businessVertical?: string | null;
    billingIdentity: {
      __typename?: 'BillingIdentityQL';
      id: string;
      brand?: string | null;
      billingOrderId: string;
      paymentSource: PaymentSource;
    };
  } | null;
};

export type DeactivateAccountMutationVariables = Exact<{
  input: DeactivateAccountInput;
}>;

export type DeactivateAccountMutation = {
  __typename?: 'Mutations';
  deactivateAccount?: {
    __typename?: 'DeactivateAccount';
    account?: {
      __typename?: 'AccountQL';
      id: string;
      status: Status_Types;
    } | null;
  } | null;
};

export type GetRepairOrderNotesQueryVariables = Exact<{
  repairOrderId: Scalars['String']['input'];
}>;

export type GetRepairOrderNotesQuery = {
  __typename?: 'Query';
  repairOrderNotes?: string | null;
};

export type GenerateRepairOrderNotesSummaryMutationVariables = Exact<{
  input: GenerateRepairOrderNotesSummaryInput;
}>;

export type GenerateRepairOrderNotesSummaryMutation = {
  __typename?: 'Mutations';
  generateRepairOrderNotesSummary?: {
    __typename?: 'GenerateRepairOrderNotesSummary';
    repairOrderNotesSummary?: {
      __typename?: 'RepairOrderNotesSummaryQL';
      notEnoughInfo: boolean;
      serviceSummaries?: {
        __typename?: 'ServiceSummariesQL';
        general: string;
        serviceItems: Array<{
          __typename?: 'ServiceSummariesItem';
          item: string;
          content: Array<{
            __typename?: 'ServiceSubItemSummary';
            description: string;
            confidence: SubItemSummaryConfidence;
            priority: SubItemSummaryPriority;
          } | null>;
        } | null>;
      } | null;
      upsell?: {
        __typename?: 'UpsellQL';
        strategies: Array<{
          __typename?: 'UpsellStrategy';
          name: string;
          strategy: string;
        } | null>;
        objections: Array<{
          __typename?: 'Objection';
          objection: string;
          resolution: Array<{
            __typename?: 'ResolutionStep';
            step: string;
            solution: string;
          } | null>;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type GetRepairOrderNotesSummaryQueryVariables = Exact<{
  repairOrderId: Scalars['String']['input'];
}>;

export type GetRepairOrderNotesSummaryQuery = {
  __typename?: 'Query';
  repairOrderNotesSummary?: {
    __typename?: 'RepairOrderNotesSummaryQL';
    repairOrderId: string;
    notes: string;
    notEnoughInfo: boolean;
    serviceSummaries?: {
      __typename?: 'ServiceSummariesQL';
      general: string;
      serviceItems: Array<{
        __typename?: 'ServiceSummariesItem';
        item: string;
        content: Array<{
          __typename?: 'ServiceSubItemSummary';
          description: string;
          confidence: SubItemSummaryConfidence;
          priority: SubItemSummaryPriority;
        } | null>;
      } | null>;
    } | null;
    upsell?: {
      __typename?: 'UpsellQL';
      strategies: Array<{
        __typename?: 'UpsellStrategy';
        name: string;
        strategy: string;
      } | null>;
      objections: Array<{
        __typename?: 'Objection';
        objection: string;
        resolution: Array<{
          __typename?: 'ResolutionStep';
          step: string;
          solution: string;
        } | null>;
      } | null>;
    } | null;
  } | null;
};

export type ChitchatResponseFieldsFragment = {
  __typename?: 'AgentChitChatResponse';
  sessionId: string;
  reply: string;
  isComplete: boolean;
  slots: any;
  currentStep: number;
  conversation: Array<{
    __typename?: 'MessageType';
    role: string;
    content: string;
  }>;
};

export type CreateChitchatMutationVariables = Exact<{
  input: CreateAgentChitChatInput;
}>;

export type CreateChitchatMutation = {
  __typename?: 'Mutations';
  createChitchat?: {
    __typename?: 'CreateAgentChitChat';
    chitchat: {
      __typename?: 'AgentChitChatResponse';
    } & ChitchatResponseFieldsFragment;
  } | null;
};

export type UpdateChitchatMutationVariables = Exact<{
  input: UpdateAgentChitChatInput;
}>;

export type UpdateChitchatMutation = {
  __typename?: 'Mutations';
  updateChitchat?: {
    __typename?: 'UpdateAgentChitChat';
    chitchat: {
      __typename?: 'AgentChitChatResponse';
    } & ChitchatResponseFieldsFragment;
  } | null;
};

export type ApppointmentAgentSettingsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ApppointmentAgentSettingsQuery = {
  __typename?: 'Query';
  appointmentAgentSettings?: {
    __typename?: 'AppointmentAgentSettingsQL';
    labels?: Array<{
      __typename?: 'AppointmentAgentSettingLabelQL';
      id: string;
      category?: string | null;
      label?: ({ __typename?: 'LabelQL' } & LabelFieldsFragment) | null;
    } | null> | null;
  } | null;
};

export type CreateAppointmentAgentSettingLabelMutationVariables = Exact<{
  input: CreateAppointmentAgentSettingLabelInput;
}>;

export type CreateAppointmentAgentSettingLabelMutation = {
  __typename?: 'Mutations';
  createAppointmentAgentSettingLabel?: {
    __typename?: 'CreateAppointmentAgentSettingLabel';
    id?: string | null;
  } | null;
};

export type UpdateAppointmentAgentSettingLabelMutationVariables = Exact<{
  input: UpdateAppointmentAgentSettingLabelInput;
}>;

export type UpdateAppointmentAgentSettingLabelMutation = {
  __typename?: 'Mutations';
  updateAppointmentAgentSettingLabel?: {
    __typename?: 'UpdateAppointmentAgentSettingLabel';
    id?: string | null;
  } | null;
};

export type DeleteAppointmentAgentSettingLabelMutationVariables = Exact<{
  input: DeleteAppointmentAgentSettingLabelInput;
}>;

export type DeleteAppointmentAgentSettingLabelMutation = {
  __typename?: 'Mutations';
  deleteAppointmentAgentSettingLabel?: {
    __typename?: 'DeleteAppointmentAgentSettingLabel';
    id?: string | null;
  } | null;
};

export type DuplicateAppointmentAgentSettingsMutationVariables = Exact<{
  input: DuplicateAppointmentAgentSettingsInput;
}>;

export type DuplicateAppointmentAgentSettingsMutation = {
  __typename?: 'Mutations';
  duplicateAppointmentAgentSettings?: {
    __typename?: 'DuplicateAppointmentAgentSettings';
    appointmentAgentSettings?: {
      __typename?: 'AppointmentAgentSettingsQL';
      id: string;
    } | null;
  } | null;
};

export type AppointmentAgentNoteRatingQueryVariables = Exact<{
  dialogFlowBotDataId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type AppointmentAgentNoteRatingQuery = {
  __typename?: 'Query';
  appointmentAgentNoteRating?: {
    __typename?: 'AppointmentAgentNoteRatingQL';
    value: number;
    reason?: string | null;
    details?: string | null;
  } | null;
};

export type RateAppointmentAgentNoteMutationVariables = Exact<{
  input: RateAppointmentAgentNoteInput;
}>;

export type RateAppointmentAgentNoteMutation = {
  __typename?: 'Mutations';
  rateAppointmentAgentNote?: {
    __typename?: 'AppointmentAgentNoteRatingQL';
    value: number;
    reason?: string | null;
    details?: string | null;
  } | null;
};

export type UpdateServiceOverrideMutationVariables = Exact<{
  input: UpdateServiceOverrideInputQl;
}>;

export type UpdateServiceOverrideMutation = {
  __typename?: 'Mutations';
  updateServiceOverride?: {
    __typename?: 'UpdateServiceOverride';
    appointmentAgentSettingsId?: string | null;
    numaServiceName?: string | null;
    howIsHandled?: string | null;
    search?: string | null;
    allSelected?: boolean | null;
    vehicles?: Array<{
      __typename?: 'VehicleOutputQL';
      make?: string | null;
      model?: string | null;
      year?: number | null;
    } | null> | null;
    opcodes?: Array<{
      __typename?: 'OpcodeOutputQL';
      dmsId?: string | null;
      serviceName?: string | null;
    } | null> | null;
  } | null;
};

export type ListAutomationsByTriggerTypeQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
  triggerType: Scalars['String']['input'];
}>;

export type ListAutomationsByTriggerTypeQuery = {
  __typename?: 'Query';
  automations?: {
    __typename?: 'AutomationConnection';
    edges: Array<{
      __typename?: 'AutomationEdge';
      node?: {
        __typename?: 'AutomationQL';
        id: string;
        state: AutomationState;
        name?: string | null;
        lastUpdated?: any | null;
        publishedVersion?: number | null;
        latestVersion: number;
        startTrigger?:
          | {
              __typename?: 'AppointmentLeadCreatedTriggerQL';
              triggerType: string;
            }
          | {
              __typename?: 'AppointmentLeadUpdatedTriggerQL';
              triggerType: string;
            }
          | {
              __typename?: 'ConversationArchivedTriggerQL';
              triggerType: string;
            }
          | {
              __typename?: 'ConversationMarkedAsHeatCaseTriggerQL';
              triggerType: string;
            }
          | { __typename?: 'ConversationStartedTriggerQL'; triggerType: string }
          | { __typename?: 'CustomerContactedTriggerQL'; triggerType: string }
          | {
              __typename?: 'EquityTradeOpportunityCreatedTriggerQL';
              triggerType: string;
            }
          | { __typename?: 'LabelAddedTriggerQL'; triggerType: string }
          | { __typename?: 'LabelRemovedTriggerQL'; triggerType: string }
          | { __typename?: 'ManualOpportunityTriggerQL'; triggerType: string }
          | { __typename?: 'MessageReceivedTriggerQL'; triggerType: string }
          | {
              __typename?: 'OpportunityServiceAppointmentConfirmationTriggerQL';
              triggerType: string;
            }
          | {
              __typename?: 'OpportunityServiceAppointmentReminderTriggerQL';
              triggerType: string;
            }
          | { __typename?: 'RepairOrderClosedTriggerQL'; triggerType: string }
          | { __typename?: 'RepairOrderOpenedTriggerQL'; triggerType: string }
          | { __typename?: 'RepairOrderUpdatedTriggerQL'; triggerType: string }
          | {
              __typename?: 'StaffMemberCallGoesPoorlyTriggerQL';
              triggerType: string;
            }
          | { __typename?: 'SurveyAnsweredTriggerQL'; triggerType: string }
          | null;
      } | null;
    } | null>;
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
  } | null;
};

export type CallIntelligenceSettingFieldsFragment = {
  __typename?: 'CallIntelligenceSettingQL';
  id: string;
  placeId: string;
  disclosureContent: string;
  renderedDisclosureContent?: string | null;
  playDisclosureSpeech?: CallIntelligenceSettingOptions | null;
  permissions?: CallIntelligencePermissionType | null;
  enabled?: CallIntelligenceSettingOptions | null;
  disclosureSpeechUrl?: string | null;
  customDisclosureSpeechUrl?: string | null;
  customDisclosureSpeechOverride?: CallIntelligenceSettingOptions | null;
  seatLimit: number;
  availableSeats: number;
  customDisclosureSpeech?: {
    __typename?: 'CustomDisclosureSpeech';
    data?: string | null;
    filename?: string | null;
  } | null;
};

export type GetCallIntelligenceSettingQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetCallIntelligenceSettingQuery = {
  __typename?: 'Query';
  placeAllowsCustomAudio?: boolean | null;
  callIntelligenceSetting?:
    | ({
        __typename?: 'CallIntelligenceSettingQL';
      } & CallIntelligenceSettingFieldsFragment)
    | null;
};

export type GetCallIntelligenceEnabledQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetCallIntelligenceEnabledQuery = {
  __typename?: 'Query';
  callIntelligenceSetting?: {
    __typename?: 'CallIntelligenceSettingQL';
    enabled?: CallIntelligenceSettingOptions | null;
    seatLimit: number;
    availableSeats: number;
  } | null;
};

export type PlacesCallIntelligenceEnabledQueryVariables = Exact<{
  placeIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type PlacesCallIntelligenceEnabledQuery = {
  __typename?: 'Query';
  places?: {
    __typename?: 'PlaceConnection';
    edges: Array<{
      __typename?: 'PlaceEdge';
      node?: {
        __typename?: 'PlaceQL';
        id: string;
        callIntelligenceSetting?: {
          __typename?: 'CallIntelligenceSettingQL';
          enabled?: CallIntelligenceSettingOptions | null;
          seatLimit: number;
          availableSeats: number;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type UpdateCallIntelligenceSettingMutationVariables = Exact<{
  input: UpdateCallIntelligenceSettingInput;
}>;

export type UpdateCallIntelligenceSettingMutation = {
  __typename?: 'Mutations';
  updateCallIntelligenceSetting?: {
    __typename?: 'UpdateCallIntelligenceSetting';
    callIntelligenceSetting?:
      | ({
          __typename?: 'CallIntelligenceSettingQL';
        } & CallIntelligenceSettingFieldsFragment)
      | null;
  } | null;
};

export type CallIntelligenceRatingQueryVariables = Exact<{
  transcriptAnalysisId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type CallIntelligenceRatingQuery = {
  __typename?: 'Query';
  callIntelligenceRating?: {
    __typename?: 'CallIntelligenceRatingQL';
    transcriptAnalysisId: string;
    value: number;
    reason?: string | null;
    details?: string | null;
  } | null;
};

export type RateCallIntelligenceSummaryMutationVariables = Exact<{
  input: RateCallIntelligenceInput;
}>;

export type RateCallIntelligenceSummaryMutation = {
  __typename?: 'Mutations';
  rateCallIntelligenceSummary?: {
    __typename?: 'CallIntelligenceRatingQL';
    transcriptAnalysisId: string;
    value: number;
    reason?: string | null;
    details?: string | null;
    source?: string | null;
  } | null;
};

export type ComplianceSettingsFragment = {
  __typename?: 'ComplianceSettingsQL';
  onVoicemail: boolean;
  onHangup: boolean;
  onRevivedConversations: boolean;
  onCompose: boolean;
  guidelinesReminder: string;
  detailedGuidelines: string;
  sendOptOutInstructions: boolean;
  optOutInstructions: string;
  optOutConfirmation: string;
  optOutResubscribe: string;
  requireExplicitOptIn: RequireExplicitOptIn;
  doubleOptInPrompt: string;
  ongoingOptOutInstructions: string;
  suppressOptOutInstructions: boolean;
};

export type UpdateComplianceSettingsMutationVariables = Exact<{
  input: UpdateComplianceSettingsInput;
}>;

export type UpdateComplianceSettingsMutation = {
  __typename?: 'Mutations';
  updateComplianceSettings?: {
    __typename?: 'UpdateComplianceSettings';
    complianceSettings?:
      | ({ __typename?: 'ComplianceSettingsQL' } & ComplianceSettingsFragment)
      | null;
  } | null;
};

export type GetComplianceSettingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetComplianceSettingsQuery = {
  __typename?: 'Query';
  complianceSettings?:
    | ({ __typename?: 'ComplianceSettingsQL' } & ComplianceSettingsFragment)
    | null;
};

export type GetConversationRepairOrderSmartStatusUpdateSettingsQueryVariables =
  Exact<{
    conversationId: Scalars['String']['input'];
  }>;

export type GetConversationRepairOrderSmartStatusUpdateSettingsQuery = {
  __typename?: 'Query';
  conversation?: {
    __typename?: 'ConversationQL';
    id: string;
    repairOrderSmartStatusUpdateSettings?: {
      __typename?: 'ConversationRepairOrderSmartStatusUpdateSettingsQL';
      id: string;
      isEnabled: boolean;
      customInstructions?: string | null;
    } | null;
  } | null;
};

export type ConversationInboxFragmentFragment = {
  __typename?: 'ConversationQL';
  inboxId: string;
};

export type MoveConversationsMutationVariables = Exact<{
  conversationIds:
    | Array<Scalars['String']['input']>
    | Scalars['String']['input'];
  newState: ConversationState;
}>;

export type MoveConversationsMutation = {
  __typename?: 'Mutations';
  updateConversations?: {
    __typename?: 'UpdateConversations';
    conversations?: Array<
      ({ __typename?: 'ConversationQL' } & ConversationItemStubFragment) | null
    > | null;
  } | null;
};

export type UpsertConversationRepairOrderSmartStatusUpdateSettingsMutationVariables =
  Exact<{
    input: UpsertConversationRepairOrderSmartStatusUpdateSettingsInput;
  }>;

export type UpsertConversationRepairOrderSmartStatusUpdateSettingsMutation = {
  __typename?: 'Mutations';
  upsertConversationRepairOrderSmartStatusUpdateSettings?: {
    __typename?: 'UpsertConversationRepairOrderSmartStatusUpdateSettings';
    conversation: {
      __typename?: 'ConversationQL';
      id: string;
      repairOrderSmartStatusUpdateSettings?: {
        __typename?: 'ConversationRepairOrderSmartStatusUpdateSettingsQL';
        id: string;
        isEnabled: boolean;
        customInstructions?: string | null;
      } | null;
    };
  } | null;
};

export type ExportConversationToArchiveMutationVariables = Exact<{
  input: ExportConversationToArchiveInput;
}>;

export type ExportConversationToArchiveMutation = {
  __typename?: 'Mutations';
  exportConversationToArchive?: {
    __typename?: 'ExportConversationToArchive';
    taskId?: string | null;
  } | null;
};

export type GetUsersWithCrmUsersQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
  activeIntegrationId: Scalars['String']['input'];
}>;

export type GetUsersWithCrmUsersQuery = {
  __typename?: 'Query';
  placesUsers?: Array<{
    __typename?: 'PlacesUsersQL';
    id: string;
    user: {
      __typename?: 'UserQL';
      id: string;
      displayName: string;
      crmUsers?: Array<{
        __typename?: 'CrmUserModelQL';
        id: string;
        integrationInternalType?: IntegrationInternalId | null;
        externalCrmUserId?: string | null;
        externalTenantId?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      }> | null;
    };
  } | null> | null;
  externalCrmUsers?: Array<{
    __typename?: 'ExternalCRMUserQL';
    id: string;
    firstName: string;
    lastName: string;
  }> | null;
};

export type MapCrmUserToUserMutationVariables = Exact<{
  input: MapCrmUserToUserInput;
}>;

export type MapCrmUserToUserMutation = {
  __typename?: 'Mutations';
  mapCrmUserToUser?: {
    __typename?: 'MapCrmUserToUser';
    user?: {
      __typename?: 'UserQL';
      id: string;
      displayName: string;
      crmUsers?: Array<{
        __typename?: 'CrmUserModelQL';
        id: string;
        integrationInternalType?: IntegrationInternalId | null;
        externalCrmUserId?: string | null;
        externalTenantId?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      }> | null;
    } | null;
  } | null;
};

export type UnmapCrmUserFromUserMutationVariables = Exact<{
  input: UnmapCrmUserFromUserInput;
}>;

export type UnmapCrmUserFromUserMutation = {
  __typename?: 'Mutations';
  unmapCrmUserFromUser?: {
    __typename?: 'UnmapCrmUserFromUser';
    user?: {
      __typename?: 'UserQL';
      id: string;
      displayName: string;
      crmUsers?: Array<{
        __typename?: 'CrmUserModelQL';
        id: string;
        integrationInternalType?: IntegrationInternalId | null;
        externalCrmUserId?: string | null;
        externalTenantId?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      }> | null;
    } | null;
  } | null;
};

export type BaseCustomerFieldsFragment = {
  __typename?: 'CustomerQL';
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;
  addresses?: Array<{
    __typename?: 'AddressQL';
    id: string;
    address?: string | null;
    mediumType?: string | null;
    isPrimary?: boolean | null;
    isActive?: boolean | null;
    deletedAt?: any | null;
    sourceEntityId?: string | null;
    sourceEntityType?: string | null;
    addressConsentStatuses?: Array<{
      __typename?: 'AddressConsentStatusModelQL';
      consentType?: string | null;
      consentCategory?: string | null;
    } | null> | null;
  } | null> | null;
  lastAppointment?:
    | ({ __typename?: 'AppointmentQL' } & AppointmentFieldsFragment)
    | null;
  lastRepairOrder?:
    | ({
        __typename?: 'BaseRepairOrder';
      } & RepairOrderFields_BaseRepairOrder_Fragment)
    | ({
        __typename?: 'RepairOrderFortellisQL';
      } & RepairOrderFields_RepairOrderFortellisQl_Fragment)
    | null;
};

export type CustomerFieldsWithDuplicatesFragment = {
  __typename?: 'CustomerQL';
  duplicates?: Array<
    ({ __typename?: 'CustomerQL' } & BaseCustomerFieldsFragment) | null
  > | null;
} & BaseCustomerFieldsFragment;

export type CustomerFieldsWithRoAndAppointmentDuplicatesFragment = {
  __typename?: 'CustomerQL';
  duplicates?: Array<{
    __typename?: 'CustomerQL';
    lastAppointment?:
      | ({ __typename?: 'AppointmentQL' } & AppointmentFieldsFragment)
      | null;
    lastRepairOrder?:
      | ({
          __typename?: 'BaseRepairOrder';
        } & RepairOrderFields_BaseRepairOrder_Fragment)
      | ({
          __typename?: 'RepairOrderFortellisQL';
        } & RepairOrderFields_RepairOrderFortellisQl_Fragment)
      | null;
  } | null> | null;
} & BaseCustomerFieldsFragment;

export type GetCustomerByIdQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;

export type GetCustomerByIdQuery = {
  __typename?: 'Query';
  customer?:
    | ({ __typename?: 'CustomerQL' } & CustomerFieldsWithDuplicatesFragment)
    | null;
};

export type GetCustomerWithRoAndAppointmentDuplicatesByIdQueryVariables =
  Exact<{
    customerId: Scalars['String']['input'];
  }>;

export type GetCustomerWithRoAndAppointmentDuplicatesByIdQuery = {
  __typename?: 'Query';
  customer?:
    | ({
        __typename?: 'CustomerQL';
      } & CustomerFieldsWithRoAndAppointmentDuplicatesFragment)
    | null;
};

export type GetDepartmentDevicesQueryVariables = Exact<{
  departmentId: Scalars['String']['input'];
}>;

export type GetDepartmentDevicesQuery = {
  __typename?: 'Query';
  departmentDevices?: Array<{
    __typename?: 'DepartmentDeviceQL';
    id: string;
    name: string;
    mdn?: string | null;
    sipAddress?: string | null;
    type: DeviceType;
    enabledDuringBusinessHours: boolean;
    enabledAfterBusinessHours: boolean;
    createdOn: any;
    lastUpdated?: any | null;
  }> | null;
};

export type CreateDepartmentDeviceMutationVariables = Exact<{
  input: CreateDepartmentDeviceInput;
}>;

export type CreateDepartmentDeviceMutation = {
  __typename?: 'Mutations';
  createDepartmentDevice?: {
    __typename?: 'CreateDepartmentDevice';
    device: {
      __typename?: 'DepartmentDeviceQL';
      id: string;
      name: string;
      mdn?: string | null;
      sipAddress?: string | null;
      type: DeviceType;
      enabledDuringBusinessHours: boolean;
      enabledAfterBusinessHours: boolean;
      createdOn: any;
      lastUpdated?: any | null;
    };
  } | null;
};

export type UpdateDepartmentDeviceMutationVariables = Exact<{
  input: UpdateDepartmentDeviceInput;
}>;

export type UpdateDepartmentDeviceMutation = {
  __typename?: 'Mutations';
  updateDepartmentDevice?: {
    __typename?: 'UpdateDepartmentDevice';
    device: {
      __typename?: 'DepartmentDeviceQL';
      id: string;
      name: string;
      mdn?: string | null;
      sipAddress?: string | null;
      type: DeviceType;
      enabledDuringBusinessHours: boolean;
      enabledAfterBusinessHours: boolean;
      createdOn: any;
      lastUpdated?: any | null;
    };
  } | null;
};

export type DeleteDepartmentDeviceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteDepartmentDeviceMutation = {
  __typename?: 'Mutations';
  deleteDepartmentDevice?: {
    __typename?: 'DeleteDepartmentDevice';
    success: boolean;
    message?: string | null;
  } | null;
};

type DirectoryEntryFields_CustomDirectoryEntryQl_Fragment = {
  __typename?: 'CustomDirectoryEntryQL';
  id: string;
  entryType?: DirectoryEntryType | null;
  displayName?: string | null;
  isDiscoverable?: boolean | null;
  description?: string | null;
  createdOn: any;
  devices?: Array<{
    __typename?: 'DirectoryDeviceQL';
    deviceId?: any | null;
    mdn?: string | null;
    sipAddress?: string | null;
    deviceType?: DirectoryDeviceType | null;
  } | null> | null;
};

type DirectoryEntryFields_DepartmentDirectoryEntryQl_Fragment = {
  __typename?: 'DepartmentDirectoryEntryQL';
  id: string;
  entryType?: DirectoryEntryType | null;
  displayName?: string | null;
  isDiscoverable?: boolean | null;
  description?: string | null;
  createdOn: any;
  department?: {
    __typename?: 'DepartmentQL';
    phoneline?: {
      __typename?: 'PhoneLineQL';
      id: string;
      place?: { __typename?: 'PlaceQL'; name: string } | null;
    } | null;
  } | null;
  devices?: Array<{
    __typename?: 'DirectoryDeviceQL';
    deviceId?: any | null;
    mdn?: string | null;
    sipAddress?: string | null;
    deviceType?: DirectoryDeviceType | null;
  } | null> | null;
};

type DirectoryEntryFields_UserDirectoryEntryQl_Fragment = {
  __typename?: 'UserDirectoryEntryQL';
  id: string;
  entryType?: DirectoryEntryType | null;
  displayName?: string | null;
  isDiscoverable?: boolean | null;
  description?: string | null;
  createdOn: any;
  user?: {
    __typename?: 'UserQL';
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    jobRole?: JobRoleInput | null;
    inboxes?: Array<{ __typename?: 'InboxQL'; name: string } | null> | null;
  } | null;
  devices?: Array<{
    __typename?: 'DirectoryDeviceQL';
    deviceId?: any | null;
    mdn?: string | null;
    sipAddress?: string | null;
    deviceType?: DirectoryDeviceType | null;
  } | null> | null;
};

export type DirectoryEntryFieldsFragment =
  | DirectoryEntryFields_CustomDirectoryEntryQl_Fragment
  | DirectoryEntryFields_DepartmentDirectoryEntryQl_Fragment
  | DirectoryEntryFields_UserDirectoryEntryQl_Fragment;

export type GetDirectoryEntriesQueryVariables = Exact<{
  placeGroupId: Scalars['String']['input'];
  entryType?: InputMaybe<DirectoryEntryType>;
  isDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetDirectoryEntriesQuery = {
  __typename?: 'Query';
  directoryEntries: Array<
    | ({
        __typename?: 'CustomDirectoryEntryQL';
      } & DirectoryEntryFields_CustomDirectoryEntryQl_Fragment)
    | ({
        __typename?: 'DepartmentDirectoryEntryQL';
      } & DirectoryEntryFields_DepartmentDirectoryEntryQl_Fragment)
    | ({
        __typename?: 'UserDirectoryEntryQL';
      } & DirectoryEntryFields_UserDirectoryEntryQl_Fragment)
  >;
};

export type CreateCustomDirectoryEntryMutationVariables = Exact<{
  input: CreateCustomDirectoryEntryInput;
}>;

export type CreateCustomDirectoryEntryMutation = {
  __typename?: 'Mutations';
  createCustomDirectoryEntry?: {
    __typename?: 'CreateCustomDirectoryEntry';
    directoryEntry: {
      __typename?: 'CustomDirectoryEntryQL';
    } & DirectoryEntryFields_CustomDirectoryEntryQl_Fragment;
  } | null;
};

export type GetUserDirectoryEntryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  placeGroupId: Scalars['String']['input'];
}>;

export type GetUserDirectoryEntryQuery = {
  __typename?: 'Query';
  userDirectoryEntry?:
    | ({
        __typename?: 'UserDirectoryEntryQL';
      } & DirectoryEntryFields_UserDirectoryEntryQl_Fragment)
    | null;
};

export type GetDepartmentDirectoryEntryQueryVariables = Exact<{
  departmentId: Scalars['String']['input'];
  placeGroupId: Scalars['String']['input'];
}>;

export type GetDepartmentDirectoryEntryQuery = {
  __typename?: 'Query';
  departmentDirectoryEntry?:
    | ({
        __typename?: 'DepartmentDirectoryEntryQL';
      } & DirectoryEntryFields_DepartmentDirectoryEntryQl_Fragment)
    | null;
};

export type UpdateDirectoryEntryMutationVariables = Exact<{
  input: UpdateDirectoryEntryInput;
}>;

export type UpdateDirectoryEntryMutation = {
  __typename?: 'Mutations';
  updateDirectoryEntry?: {
    __typename?: 'UpdateDirectoryEntry';
    directoryEntry:
      | ({
          __typename?: 'CustomDirectoryEntryQL';
        } & DirectoryEntryFields_CustomDirectoryEntryQl_Fragment)
      | ({
          __typename?: 'DepartmentDirectoryEntryQL';
        } & DirectoryEntryFields_DepartmentDirectoryEntryQl_Fragment)
      | ({
          __typename?: 'UserDirectoryEntryQL';
        } & DirectoryEntryFields_UserDirectoryEntryQl_Fragment);
  } | null;
};

export type EngagementWithSummaryFieldsFragment = {
  __typename?: 'EngagementQL';
  id: string;
  summaryId?: string | null;
  summary?: string | null;
  mySummaryRating?: {
    __typename?: 'EngagementSummaryRatingQL';
    value: number;
    reason?: string | null;
    details?: string | null;
  } | null;
};

export type ConversationLastEngagementFragment = {
  __typename?: 'ConversationQL';
  lastEngagement?:
    | ({ __typename?: 'EngagementQL' } & EngagementWithSummaryFieldsFragment &
        EngagementTasksFragment)
    | null;
};

export type RateEngagementSummaryMutationVariables = Exact<{
  input: RateEngagementSummaryInput;
}>;

export type RateEngagementSummaryMutation = {
  __typename?: 'Mutations';
  rateEngagementSummary?:
    | ({
        __typename?: 'EngagementQL';
        conversation?: {
          __typename?: 'ConversationQL';
          id: string;
          hasRecentHeatCase?: boolean | null;
        } | null;
      } & EngagementWithSummaryFieldsFragment)
    | null;
};

export type RateEngagementStatusMutationVariables = Exact<{
  engagement_id: Scalars['ID']['input'];
  rating: EngagementStatusRatingInput;
}>;

export type RateEngagementStatusMutation = {
  __typename?: 'Mutations';
  rateEngagementStatus?: {
    __typename?: 'EngagementQL';
    id: string;
    status?: string | null;
    myStatusRating?: {
      __typename?: 'EngagementStatusRatingQL';
      value: number;
      reason?: string | null;
      details?: string | null;
    } | null;
  } | null;
};

export type GetLatestInboxAgentResultQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;

export type GetLatestInboxAgentResultQuery = {
  __typename?: 'Query';
  conversation?: {
    __typename?: 'ConversationQL';
    id: string;
    lastEngagement?: {
      __typename?: 'EngagementQL';
      id: string;
      latestInboxAgentResult?: {
        __typename?: 'EngagementInboxAgentResultQL';
        id: string;
        summary?: string | null;
        sentiment?: string | null;
        sentimentValue?: number | null;
        topics: Array<string>;
        predictedMessageIntents: Array<{
          __typename?: 'PredictedMessageIntentQL';
          intent: string;
          confidence: number;
        }>;
        myAssistedResponseRating?: {
          __typename?: 'AssistedResponseRatingQL';
          value: number;
          reason: string;
          details?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type RateAssistedResponseMutationVariables = Exact<{
  input: RateAssistedResponseInput;
}>;

export type RateAssistedResponseMutation = {
  __typename?: 'Mutations';
  rateAssistedResponse?: {
    __typename?: 'EngagementQL';
    id: string;
    latestInboxAgentResult?: {
      __typename?: 'EngagementInboxAgentResultQL';
      id: string;
      myAssistedResponseRating?: {
        __typename?: 'AssistedResponseRatingQL';
        value: number;
        reason: string;
        details?: string | null;
      } | null;
    } | null;
  } | null;
};

export type EquityTradeOpportunityWithStageFragment = {
  __typename?: 'EquityTradeOpportunityQL';
  id: string;
  stage: EquityTradeOpportunityStage;
};

export type GetEquityTradeOpportunityQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;

export type GetEquityTradeOpportunityQuery = {
  __typename?: 'Query';
  equityTradeOpportunity?:
    | ({
        __typename?: 'EquityTradeOpportunityQL';
      } & EquityTradeOpportunityWithStageFragment)
    | null;
};

export type UpdateEquityTradeOpportunityStageMutationVariables = Exact<{
  input: UpdateEquityTradeOpportunityStageInput;
}>;

export type UpdateEquityTradeOpportunityStageMutation = {
  __typename?: 'Mutations';
  updateEquityTradeOpportunityStage?: {
    __typename?: 'UpdateEquityTradeOpportunityStage';
    equityTradeOpportunity?:
      | ({
          __typename?: 'EquityTradeOpportunityQL';
        } & EquityTradeOpportunityWithStageFragment)
      | null;
  } | null;
};

export type EtoSettingsFragment = {
  __typename?: 'ETOSettingsQL';
  id: string;
  placeId: string;
  noRepeat: boolean;
  oneAtATime: boolean;
  daysFrequency: number;
  eligibilityCriteria: any;
  isInboxLabelEnabled: boolean;
  minimumQualifyingScore: number;
  qualifiedNotificationEmailRecipient: string;
  leadCreationEmail?: string | null;
  automationGroup?: {
    __typename?: 'AutomationGroupQL';
    automations?: Array<
      ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment) | null
    > | null;
  } | null;
};

export type GetEtoSettingsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetEtoSettingsQuery = {
  __typename?: 'Query';
  etoSettings?: ({ __typename?: 'ETOSettingsQL' } & EtoSettingsFragment) | null;
};

export type UpdateEtoSettingsMutationVariables = Exact<{
  input: UpdateEtoSettingsInput;
}>;

export type UpdateEtoSettingsMutation = {
  __typename?: 'Mutations';
  updateEtoSettings?: {
    __typename?: 'UpdateETOSettings';
    etoSettings?:
      | ({ __typename?: 'ETOSettingsQL' } & EtoSettingsFragment)
      | null;
  } | null;
};

export type SetupEquityTradeOpportunityCampaignMutationVariables = Exact<{
  input: SetupEquityTradeOpportunityCampaignInput;
}>;

export type SetupEquityTradeOpportunityCampaignMutation = {
  __typename?: 'Mutations';
  setupEquityTradeOpportunityCampaign?: {
    __typename?: 'SetupEquityTradeOpportunityCampaign';
    etoSettings?:
      | ({ __typename?: 'ETOSettingsQL' } & EtoSettingsFragment)
      | null;
  } | null;
};

export type LoginMutationVariables = Exact<{
  credential: Credentials;
}>;

export type LoginMutation = {
  __typename?: 'Mutations';
  login?: {
    __typename?: 'AuthTokens';
    accessToken?: string | null;
    refreshToken?: string | null;
  } | null;
};

export type UserMetricsFieldsFragment = {
  __typename?: 'UserMetrics';
  id: string;
  openConversationsCount: number;
  overdueConversationsCount?: number | null;
  lastMessageSentAt?: any | null;
  user: {
    __typename?: 'UserQL';
    id: string;
    displayName: string;
    isAway: boolean;
    nextShiftStart?: any | null;
    jobRole?: JobRoleInput | null;
  };
};

export type UserMetricsCollectionFragment = {
  __typename?: 'UserMetricsConnection';
  edges: Array<{
    __typename?: 'UserMetricsEdge';
    node: { __typename?: 'UserMetrics' } & UserMetricsFieldsFragment;
  } | null>;
};

export type PlaceMetricsFieldsFragment = {
  __typename?: 'PlaceMetrics';
  id: string;
  openConversationsCount: number;
  overdueConversationsCount?: number | null;
  unassignedConversationsCount: number;
  place: {
    __typename?: 'PlaceQL';
    id: string;
    name: string;
    inbox?: { __typename?: 'InboxQL'; id: string } | null;
  };
};

export type PlaceMetricsCollectionFragment = {
  __typename?: 'PlaceMetricsConnection';
  edges: Array<{
    __typename?: 'PlaceMetricsEdge';
    node: { __typename?: 'PlaceMetrics' } & PlaceMetricsFieldsFragment;
  } | null>;
};

export type GetMyManagerDashboardQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetMyManagerDashboardQuery = {
  __typename?: 'Query';
  myManagerDashboard?: {
    __typename?: 'ManagerDashboard';
    pollingIntervalMs: number;
    userMetrics: {
      __typename?: 'UserMetricsConnection';
    } & UserMetricsCollectionFragment;
  } | null;
};

export type GetMyManagerDashboardWithPlaceMetricsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetMyManagerDashboardWithPlaceMetricsQuery = {
  __typename?: 'Query';
  myManagerDashboard?: {
    __typename?: 'ManagerDashboard';
    pollingIntervalMs: number;
    userMetrics: {
      __typename?: 'UserMetricsConnection';
    } & UserMetricsCollectionFragment;
    placeMetrics: {
      __typename?: 'PlaceMetricsConnection';
    } & PlaceMetricsCollectionFragment;
  } | null;
};

export type OperatorFieldsFragment = {
  __typename?: 'OperatorQL';
  id: string;
  accountId: string;
  name: string;
  spokenGreetingName?: string | null;
  operatorFaq: any;
  places: Array<{ __typename?: 'PlaceQL'; id: string; name: string }>;
};

export type OperatorSettingsFieldsFragment = {
  __typename?: 'OperatorSettingsQL';
  id: string;
  voiceProvider?: string | null;
  voiceId?: string | null;
  settings: any;
  operator: { __typename?: 'OperatorQL'; id: string };
  appointmentAgentSettings?: {
    __typename?: 'AppointmentAgentSettingsQL';
    id: string;
  } | null;
};

export type OperatorPlaceFieldsFragment = {
  __typename?: 'OperatorPlaceQL';
  id: string;
  description?: string | null;
  settings: any;
  operator: { __typename?: 'OperatorQL'; id: string; name: string };
  place: { __typename?: 'PlaceQL'; id: string; name: string };
};

export type OperatorChannelFieldsFragment = {
  __typename?: 'OperatorChannelQL';
  id: string;
  operatorId: string;
  channelId: string;
  description?: string | null;
  settings: any;
  channel:
    | {
        __typename?: 'BandwidthChannelQL';
        mdn: string;
        id: string;
        name?: string | null;
      }
    | { __typename?: 'BaseChannel'; id: string; name?: string | null }
    | { __typename?: 'FacebookChannelQL'; id: string; name?: string | null }
    | { __typename?: 'GoogleChannelQL'; id: string; name?: string | null }
    | { __typename?: 'NoteChannelQL'; id: string; name?: string | null }
    | { __typename?: 'NumboxChannelQL'; id: string; name?: string | null }
    | {
        __typename?: 'TwilioChannelQL';
        mdn: string;
        id: string;
        name?: string | null;
      };
  operator: {
    __typename?: 'OperatorQL';
    id: string;
    name: string;
    places: Array<{ __typename?: 'PlaceQL'; id: string; name: string }>;
  };
};

export type OperatorSessionFieldsFragment = {
  __typename?: 'OperatorSessionQL';
  id: string;
  createdOn: any;
  callSid: string;
  isActive?: boolean | null;
  startTime?: any | null;
  endTime?: any | null;
  callDuration?: number | null;
  outcome?: OperatorSessionOutcome | null;
  slots?: any | null;
  summary?: string | null;
  participant?: {
    __typename?: 'ParticipantQL';
    id: string;
    address: string;
    displayName: string;
  } | null;
  callRecording?: {
    __typename?: 'CallRecordingQL';
    id: string;
    url?: string | null;
  } | null;
  phonecall?: {
    __typename?: 'PhoneCallQL';
    id: string;
    callDuration?: number | null;
    isActive?: boolean | null;
    endtime?: any | null;
    startTime?: any | null;
    conversationId: string;
    transcriptId?: string | null;
    returnCallsRoutingOutcome?: PhoneCallReturnCallOutcome | null;
    returnCallsRoutedTo?: string | null;
    place?: { __typename?: 'PlaceQL'; id: string; name: string } | null;
    returnCallsRoutedUser?: {
      __typename?: 'UserQL';
      id: string;
      displayName: string;
    } | null;
    participant: {
      __typename?: 'ParticipantQL';
      id: string;
      address: string;
      displayName: string;
    };
    callRecording?: {
      __typename?: 'CallRecordingQL';
      id: string;
      url?: string | null;
    } | null;
  } | null;
};

export type GetOperatorsQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;

export type GetOperatorsQuery = {
  __typename?: 'Query';
  operators?: Array<
    { __typename?: 'OperatorQL' } & OperatorFieldsFragment
  > | null;
};

export type GetOperatorQueryVariables = Exact<{
  id: Scalars['String']['input'];
  includeChannels?: InputMaybe<Scalars['Boolean']['input']>;
  includeSessions?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetOperatorQuery = {
  __typename?: 'Query';
  operator?:
    | ({
        __typename?: 'OperatorQL';
        channels?: Array<
          | {
              __typename?: 'BandwidthChannelQL';
              mdn: string;
              id: string;
              name?: string | null;
            }
          | { __typename?: 'BaseChannel'; id: string; name?: string | null }
          | {
              __typename?: 'FacebookChannelQL';
              id: string;
              name?: string | null;
            }
          | { __typename?: 'GoogleChannelQL'; id: string; name?: string | null }
          | { __typename?: 'NoteChannelQL'; id: string; name?: string | null }
          | { __typename?: 'NumboxChannelQL'; id: string; name?: string | null }
          | {
              __typename?: 'TwilioChannelQL';
              mdn: string;
              id: string;
              name?: string | null;
            }
        >;
        operatorSessions?: Array<
          { __typename?: 'OperatorSessionQL' } & OperatorSessionFieldsFragment
        >;
      } & OperatorFieldsFragment)
    | null;
};

export type CreateOperatorMutationVariables = Exact<{
  input: CreateOperatorInput;
}>;

export type CreateOperatorMutation = {
  __typename?: 'Mutations';
  createOperator?: {
    __typename?: 'CreateOperator';
    operator: { __typename?: 'OperatorQL' } & OperatorFieldsFragment;
  } | null;
};

export type GetOperatorWithDealershipInfoQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetOperatorWithDealershipInfoQuery = {
  __typename?: 'Query';
  operator?: {
    __typename?: 'OperatorQL';
    id: string;
    name: string;
    dealershipInfoBlob: any;
    places: Array<{ __typename?: 'PlaceQL'; id: string; name: string }>;
  } | null;
};

export type GetOperatorSettingsQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
}>;

export type GetOperatorSettingsQuery = {
  __typename?: 'Query';
  operatorSettings?:
    | ({ __typename?: 'OperatorSettingsQL' } & OperatorSettingsFieldsFragment)
    | null;
};

export type UpdateOperatorSettingsMutationVariables = Exact<{
  input: UpdateOperatorSettingsInput;
}>;

export type UpdateOperatorSettingsMutation = {
  __typename?: 'Mutations';
  updateOperatorSettings?: {
    __typename?: 'UpdateOperatorSettings';
    operatorSettings: {
      __typename?: 'OperatorSettingsQL';
    } & OperatorSettingsFieldsFragment;
  } | null;
};

export type GetOperatorPlacesQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
}>;

export type GetOperatorPlacesQuery = {
  __typename?: 'Query';
  operatorPlaces: Array<
    { __typename?: 'OperatorPlaceQL' } & OperatorPlaceFieldsFragment
  >;
};

export type GetOperatorPlaceQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
}>;

export type GetOperatorPlaceQuery = {
  __typename?: 'Query';
  operatorPlace?:
    | ({ __typename?: 'OperatorPlaceQL' } & OperatorPlaceFieldsFragment)
    | null;
};

export type GetOperatorChannelQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;

export type GetOperatorChannelQuery = {
  __typename?: 'Query';
  operatorChannel?:
    | ({ __typename?: 'OperatorChannelQL' } & OperatorChannelFieldsFragment)
    | null;
};

export type AddOperatorPlaceMutationVariables = Exact<{
  input: AddOperatorPlaceInput;
}>;

export type AddOperatorPlaceMutation = {
  __typename?: 'Mutations';
  addOperatorPlace?: {
    __typename?: 'AddOperatorPlace';
    operator: { __typename?: 'OperatorQL' } & OperatorFieldsFragment;
    operatorPlace: {
      __typename?: 'OperatorPlaceQL';
    } & OperatorPlaceFieldsFragment;
  } | null;
};

export type UpdateOperatorPlaceDescriptionMutationVariables = Exact<{
  input: UpdateOperatorPlaceDescriptionInput;
}>;

export type UpdateOperatorPlaceDescriptionMutation = {
  __typename?: 'Mutations';
  updateOperatorPlaceDescription?: {
    __typename?: 'UpdateOperatorPlaceDescription';
    operatorPlace: {
      __typename?: 'OperatorPlaceQL';
    } & OperatorPlaceFieldsFragment;
  } | null;
};

export type UpdateOperatorPlaceSettingsMutationVariables = Exact<{
  input: UpdateOperatorPlaceSettingsInput;
}>;

export type UpdateOperatorPlaceSettingsMutation = {
  __typename?: 'Mutations';
  updateOperatorPlaceSettings?: {
    __typename?: 'UpdateOperatorPlaceSettings';
    operatorPlace: {
      __typename?: 'OperatorPlaceQL';
    } & OperatorPlaceFieldsFragment;
  } | null;
};

export type UpdateOperatorChannelMutationVariables = Exact<{
  input: UpdateOperatorChannelInput;
}>;

export type UpdateOperatorChannelMutation = {
  __typename?: 'Mutations';
  updateOperatorChannel?: {
    __typename?: 'UpdateOperatorChannel';
    operator: { __typename?: 'OperatorQL' } & OperatorFieldsFragment;
    operatorChannel: {
      __typename?: 'OperatorChannelQL';
    } & OperatorChannelFieldsFragment;
  } | null;
};

export type AddOperatorChannelMutationVariables = Exact<{
  input: AddOperatorChannelInput;
}>;

export type AddOperatorChannelMutation = {
  __typename?: 'Mutations';
  addOperatorChannel?: {
    __typename?: 'AddOperatorChannel';
    operator: { __typename?: 'OperatorQL' } & OperatorFieldsFragment;
    operatorChannel: {
      __typename?: 'OperatorChannelQL';
    } & OperatorChannelFieldsFragment;
  } | null;
};

export type GetOperatorSessionsQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
  userIds?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  placeIds?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OperatorSessionModelFilter>;
  sort?: InputMaybe<
    | Array<InputMaybe<OperatorSessionModelSortEnum>>
    | InputMaybe<OperatorSessionModelSortEnum>
  >;
}>;

export type GetOperatorSessionsQuery = {
  __typename?: 'Query';
  operatorSessions?: {
    __typename?: 'OperatorSessionConnection';
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'OperatorSessionEdge';
      node?:
        | ({ __typename?: 'OperatorSessionQL' } & OperatorSessionFieldsFragment)
        | null;
    } | null>;
  } | null;
};

export type GetOperatorSessionQueryVariables = Exact<{
  id: Scalars['String']['input'];
  includeTranscript?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetOperatorSessionQuery = {
  __typename?: 'Query';
  operatorSession?:
    | ({
        __typename?: 'OperatorSessionQL';
        operatorTranscript?: {
          __typename?: 'OperatorTranscriptQL';
          id: string;
          events: Array<{
            __typename?: 'TranscriptEventQL';
            id: string;
            type: TranscriptEventType;
            timestamp: any;
            start?: number | null;
            end?: number | null;
            text?: string | null;
            confidence?: number | null;
            speaker?: number | null;
          }>;
        } | null;
      } & OperatorSessionFieldsFragment)
    | null;
};

export type UpdateOperatorMutationVariables = Exact<{
  input: UpdateOperatorInput;
}>;

export type UpdateOperatorMutation = {
  __typename?: 'Mutations';
  updateOperator?: {
    __typename?: 'UpdateOperator';
    operator: { __typename?: 'OperatorQL' } & OperatorFieldsFragment;
  } | null;
};

export type PlacesUsersForOperatorQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type PlacesUsersForOperatorQuery = {
  __typename?: 'Query';
  placesUsers?: Array<{
    __typename?: 'PlacesUsersQL';
    id: string;
    placeId: string;
    role: string;
    user: {
      __typename?: 'UserQL';
      id: string;
      displayName: string;
      jobRole?: JobRoleInput | null;
      userPhones?: Array<{ __typename?: 'UserPhoneQL'; id: string }> | null;
      phonelines?: Array<{
        __typename?: 'PhoneLineQL';
        id: string;
        place?: { __typename?: 'PlaceQL'; id: string } | null;
      }> | null;
    };
  } | null> | null;
};

export type ManualOpportunityResultFragment = {
  __typename?: 'ManualOpportunityResult';
  success: boolean;
  message?: string | null;
};

export type ManualOpportunityQlFragment = {
  __typename?: 'ManualOpportunityQL';
  automationId: string;
  automationName: string;
  completeTime?: string | null;
  createdOn: string;
  fileName?: string | null;
  filePath?: string | null;
  id: string;
  lastUpdated: string;
  placeId: string;
  startTime?: string | null;
  status: string;
  userId: string;
};

export type ManualOpportunityReportQlFragment = {
  __typename?: 'ManualOpportunityReportQL';
  automationId: string;
  automationName: string;
  completeTime?: string | null;
  fileName: string;
  manualOpportunityId: string;
  manualOpportunityStatus: string;
  startTime?: string | null;
  totalAutomationsTriggered: number;
  uniqueConversationsAffected: number;
  contentSummary: {
    __typename?: 'ContentSummaryQL';
    totalRecords: number;
    contentTypes: {
      __typename?: 'ContentTypesQL';
      recordsWithMakeModel: number;
      recordsWithPhone: number;
      recordsWithVin: number;
    };
  };
  conversationBreakdown: Array<{
    __typename?: 'ConversationBreakdownEntryQL';
    firstStarted: string;
    hasEarlyExit: boolean;
    jobCount: number;
    lastUpdated: string;
    statuses: Array<string | null>;
    conversationId: string;
    customerInformation?: {
      __typename?: 'ManualOpportunityCustomerInformationQL';
      name?: string | null;
      phoneNumber?: string | null;
    } | null;
  } | null>;
  earlyExitAnalysis?: {
    __typename?: 'EarlyExitAnalysisQL';
    exitTypes: any;
    totalEarlyExits: number;
    details: Array<{
      __typename?: 'EarlyExitDetailQL';
      completedAt?: string | null;
      conversationId: string;
      durationBeforeExit?: number | null;
      jobId: string;
      possibleExitTriggers: Array<string | null>;
      customerInformation?: {
        __typename?: 'ManualOpportunityCustomerInformationQL';
        name?: string | null;
        phoneNumber?: string | null;
      } | null;
    } | null>;
  } | null;
  statusSummary: {
    __typename?: 'StatusSummaryQL';
    aborted: number;
    completedEarlyExit: number;
    completedSuccessfully: number;
    currentlyRunning: number;
    currentlyWaiting: number;
    totalStarted: number;
  };
};

export type ManualOpportunityMutationVariables = Exact<{
  input?: InputMaybe<ManualOpportunityInput>;
}>;

export type ManualOpportunityMutation = {
  __typename?: 'Mutations';
  manualOpportunity?: {
    __typename?: 'ManualOpportunity';
    result?:
      | ({
          __typename?: 'ManualOpportunityResult';
        } & ManualOpportunityResultFragment)
      | null;
  } | null;
};

export type ManualOpportunitiesByPlaceQueryVariables = Exact<{
  input: ManualOpportunitiesByPlaceInput;
}>;

export type ManualOpportunitiesByPlaceQuery = {
  __typename?: 'Query';
  manualOpportunitiesByPlace?: Array<
    | ({ __typename?: 'ManualOpportunityQL' } & ManualOpportunityQlFragment)
    | null
  > | null;
};

export type ManualOpportunityReportQueryVariables = Exact<{
  input: ManualOpportunityReportInput;
}>;

export type ManualOpportunityReportQuery = {
  __typename?: 'Query';
  manualOpportunityReport?:
    | ({
        __typename?: 'ManualOpportunityReportQL';
      } & ManualOpportunityReportQlFragment)
    | null;
};

export type CreateCampaignMutationVariables = Exact<{
  input?: InputMaybe<CreateCampaignInput>;
}>;

export type CreateCampaignMutation = {
  __typename?: 'Mutations';
  createCampaign?: {
    __typename?: 'CreateCampaign';
    result?: {
      __typename?: 'CreateCampaignResult';
      message: string;
      success: boolean;
    } | null;
  } | null;
};

export type ListCampaignsQueryVariables = Exact<{ [key: string]: never }>;

export type ListCampaignsQuery = {
  __typename?: 'Query';
  listCampaigns?: Array<{
    __typename?: 'CampaignQL';
    id: string;
    name: string;
    status: CampaignStatus;
    createdOn?: any | null;
    lastUpdated?: any | null;
    automation?: {
      __typename?: 'CampaignAutomationQL';
      id: string;
      name: string;
    } | null;
    place?: { __typename?: 'CampaignPlaceQL'; id: string; name: string } | null;
    settings?: {
      __typename?: 'CampaignSettingsQL';
      maxEnrolement?: number | null;
    } | null;
  } | null> | null;
};

export type GetCampaignQueryVariables = Exact<{
  campaignId: Scalars['String']['input'];
}>;

export type GetCampaignQuery = {
  __typename?: 'Query';
  campaign?: {
    __typename?: 'CampaignQL';
    id: string;
    name: string;
    status: CampaignStatus;
    createdOn?: any | null;
    lastUpdated?: any | null;
    automation?: {
      __typename?: 'CampaignAutomationQL';
      id: string;
      name: string;
    } | null;
    place?: { __typename?: 'CampaignPlaceQL'; id: string; name: string } | null;
    settings?: {
      __typename?: 'CampaignSettingsQL';
      maxEnrolement?: number | null;
    } | null;
  } | null;
};

export type UpdatePhoneLineLanguageSettingsMutationVariables = Exact<{
  input: UpdatePhoneLineLanguageSettingsInput;
}>;

export type UpdatePhoneLineLanguageSettingsMutation = {
  __typename?: 'Mutations';
  updatePhoneLineLanguageSettings?: {
    __typename?: 'UpdatePhoneLineLanguageSettings';
    phoneline?: {
      __typename?: 'PhoneLineQL';
      id: string;
      speechLanguage?: Language | null;
      allowedSpeechLanguages: Array<Language>;
    } | null;
  } | null;
};

export type EnableInboxLanguageOverrideMutationVariables = Exact<{
  input: EnableInboxLanguageOverrideInput;
}>;

export type EnableInboxLanguageOverrideMutation = {
  __typename?: 'Mutations';
  enableInboxLanguageOverride?: {
    __typename?: 'EnableInboxLanguageOverride';
    phoneline?: {
      __typename?: 'PhoneLineQL';
      id: string;
      overridesInboxLanguage: boolean;
      speechLanguage?: Language | null;
      allowedSpeechLanguages: Array<Language>;
    } | null;
  } | null;
};

export type GetPhonelineWithDepartmentQueryVariables = Exact<{
  phonelineId: Scalars['String']['input'];
}>;

export type GetPhonelineWithDepartmentQuery = {
  __typename?: 'Query';
  phoneline?: {
    __typename?: 'PhoneLineQL';
    id: string;
    department?: {
      __typename?: 'DepartmentQL';
      id: string;
      name: string;
    } | null;
    place?: { __typename?: 'PlaceQL'; placeGroupId: string } | null;
  } | null;
};

export type UpdatablePlaceInfoFieldsFragment = {
  __typename?: 'PlaceInfoQL';
  name?: string | null;
  streetAddress1?: string | null;
  streetAddress2?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  phonenumber?: string | null;
  websiteUrl?: string | null;
  email?: string | null;
  place: {
    __typename?: 'PlaceQL';
    id: string;
    name: string;
    externalName: string;
    brandTheme?: {
      __typename?: 'BrandThemeQL';
      id: string;
      logoUrl?: string | null;
    } | null;
  };
};

export type PlaceInfoFieldsFragment = {
  __typename?: 'PlaceInfoQL';
  id: string;
  name?: string | null;
  address?: string | null;
  streetAddress1?: string | null;
  streetAddress2?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  phonenumber?: string | null;
  email?: string | null;
  websiteUrl?: string | null;
  logoUrl?: string | null;
  linkGroups: Array<{
    __typename?: 'LinkGroup';
    groupLabel: string;
    links: Array<{
      __typename?: 'Link';
      name: string;
      tag: string;
      url: string;
    }>;
  } | null>;
};

export type GetPlaceInfoQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetPlaceInfoQuery = {
  __typename?: 'Query';
  placeInfo?:
    | ({ __typename?: 'PlaceInfoQL' } & PlaceInfoFieldsFragment &
        UpdatablePlaceInfoFieldsFragment)
    | null;
};

export type UpdatePlaceInfoMutationVariables = Exact<{
  input: UpdatePlaceInfoInput;
}>;

export type UpdatePlaceInfoMutation = {
  __typename?: 'Mutations';
  updatePlaceInfo?: {
    __typename?: 'UpdatePlaceInfo';
    placeInfo?:
      | ({
          __typename?: 'PlaceInfoQL';
          id: string;
        } & UpdatablePlaceInfoFieldsFragment)
      | null;
  } | null;
};

export type UpdatePlaceMessageSettingsMutationVariables = Exact<{
  input: UpdatePlaceMessageSettingsInput;
}>;

export type UpdatePlaceMessageSettingsMutation = {
  __typename?: 'Mutations';
  updatePlaceMessageSettings?: {
    __typename?: 'UpdatePlaceMessageSettings';
    place?: {
      __typename?: 'PlaceQL';
      id: string;
      escalationsEnabled: boolean;
      escalationsThreshold: number;
    } | null;
  } | null;
};

export type UpdateLanguageSettingsMutationVariables = Exact<{
  input: UpdateLanguageSettingsInput;
}>;

export type UpdateLanguageSettingsMutation = {
  __typename?: 'Mutations';
  updateAllowedSpeechLanguages?: {
    __typename?: 'UpdateLanguageSettings';
    place?: {
      __typename?: 'PlaceQL';
      id: string;
      allowedSpeechLanguages: Array<Language>;
      speechLanguage: Language;
    } | null;
  } | null;
};

export type UpsertRepairOrderSmartStatusUpdateSettingsMutationVariables =
  Exact<{
    input: RepairOrderSmartStatusUpdateSettingsInput;
  }>;

export type UpsertRepairOrderSmartStatusUpdateSettingsMutation = {
  __typename?: 'Mutations';
  upsertRepairOrderSmartStatusUpdateSettings?: {
    __typename?: 'UpsertRepairOrderSmartStatusUpdateSettings';
    repairOrderSmartStatusUpdateSettings?: {
      __typename?: 'RepairOrderSmartStatusUpdateSettingsQL';
      id: string;
      placeId: string;
      detailLevel: number;
      customInstructions?: string | null;
      createdOn: any;
      lastUpdated?: any | null;
      isEnabled: boolean;
      evaluationTimes: Array<{ __typename?: 'EvaluationTimeQL'; time: string }>;
    } | null;
  } | null;
};

export type GetPlaceRepairOrderSmartStatusUpdateSettingsQueryVariables = Exact<{
  placeId: Scalars['UUID']['input'];
}>;

export type GetPlaceRepairOrderSmartStatusUpdateSettingsQuery = {
  __typename?: 'Query';
  placeRepairOrderSmartStatusUpdateSettings?: {
    __typename?: 'RepairOrderSmartStatusUpdateSettingsQL';
    id: string;
    placeId: string;
    detailLevel: number;
    customInstructions?: string | null;
    createdOn: any;
    lastUpdated?: any | null;
    isEnabled: boolean;
    evaluationTimes: Array<{ __typename?: 'EvaluationTimeQL'; time: string }>;
  } | null;
};

export type GenerateRepairOrderAssistedStatusContentMutationVariables = Exact<{
  input: GenerateRepairOrderAssistedStatusContentInput;
}>;

export type GenerateRepairOrderAssistedStatusContentMutation = {
  __typename?: 'Mutations';
  generateRepairOrderAssistedStatusContent?: {
    __typename?: 'GenerateRepairOrderAssistedStatusContent';
    statusContent: string;
  } | null;
};

export type BuildRepairOrderAssistedStatusQuestionTreeMutationVariables =
  Exact<{
    input: BuildRepairOrderAssistedStatusQuestionTreeInput;
  }>;

export type BuildRepairOrderAssistedStatusQuestionTreeMutation = {
  __typename?: 'Mutations';
  buildRepairOrderAssistedStatusQuestionTree?: {
    __typename?: 'BuildRepairOrderAssistedStatusQuestionTree';
    questionTree: {
      __typename?: 'QuestionTree';
      questions: Array<{
        __typename?: 'QuestionNode';
        id: string;
        text: string;
        answers: Array<{
          __typename?: 'AnswerOption';
          id: string;
          text: string;
          nextQuestionId?: string | null;
        }>;
        defaultAnswer?: {
          __typename?: 'AnswerOption';
          id: string;
          text: string;
          nextQuestionId?: string | null;
        } | null;
      }>;
    };
  } | null;
};

export type CreateShortcutMutationVariables = Exact<{
  input: CreateShortcutInput;
}>;

export type CreateShortcutMutation = {
  __typename?: 'Mutations';
  createShortcut?: {
    __typename?: 'CreateShortcut';
    shortcut?: { __typename?: 'ShortcutQL'; id: string } | null;
  } | null;
};

export type TaskFieldsFragment = {
  __typename?: 'TaskQL';
  id: string;
  engagementId?: string | null;
  title: string;
  status: string;
  completedAt?: any | null;
  completionSource?: TaskActionSource | null;
  dismissedAt?: any | null;
  dismissalSource?: TaskActionSource | null;
  expiresAt: any;
  completedByParticipant?: {
    __typename?: 'ParticipantQL';
    displayName: string;
  } | null;
  dismissedByParticipant?: {
    __typename?: 'ParticipantQL';
    displayName: string;
  } | null;
  recommendedActions?: Array<
    { __typename?: 'TaskActionQL' } & TaskActionFieldsFragment
  > | null;
};

export type TaskActionFieldsFragment = {
  __typename?: 'TaskActionQL';
  type: string;
  actionData: any;
};

export type EngagementTasksFragment = {
  __typename?: 'EngagementQL';
  tasks: Array<{ __typename?: 'TaskQL' } & TaskFieldsFragment>;
};

export type CompleteTaskMutationVariables = Exact<{
  input: CompleteTaskInput;
}>;

export type CompleteTaskMutation = {
  __typename?: 'Mutations';
  completeTask?: {
    __typename?: 'CompleteTask';
    task: {
      __typename?: 'TaskQL';
      id: string;
      status: string;
      completedAt?: any | null;
      completedByParticipant?: {
        __typename?: 'ParticipantQL';
        displayName: string;
      } | null;
    };
  } | null;
};

export type DismissTaskMutationVariables = Exact<{
  input: DismissTaskInput;
}>;

export type DismissTaskMutation = {
  __typename?: 'Mutations';
  dismissTask?: {
    __typename?: 'DismissTask';
    task: {
      __typename?: 'TaskQL';
      id: string;
      status: string;
      dismissedAt?: any | null;
      dismissalReason?: string | null;
      dismissedByParticipant?: {
        __typename?: 'ParticipantQL';
        displayName: string;
      } | null;
    };
  } | null;
};

export type CreateTaskForEngagementMutationVariables = Exact<{
  input: NewTaskForEngagementInput;
}>;

export type CreateTaskForEngagementMutation = {
  __typename?: 'Mutations';
  createTaskForEngagement?: {
    __typename?: 'CreateTaskForEngagement';
    task: { __typename?: 'TaskQL' } & TaskFieldsFragment;
  } | null;
};

export type ResetTaskStatusMutationVariables = Exact<{
  input: ResetTaskStatusInput;
}>;

export type ResetTaskStatusMutation = {
  __typename?: 'Mutations';
  resetTaskStatus?: {
    __typename?: 'ResetTaskStatus';
    task: { __typename?: 'TaskQL'; id: string; status: string };
  } | null;
};

export type ChangeUserPasswordMutationVariables = Exact<{
  input: ChangeUserPasswordInput;
}>;

export type ChangeUserPasswordMutation = {
  __typename?: 'Mutations';
  changeUserPassword?: {
    __typename?: 'ChangeUserPassword';
    currentUser?: { __typename?: 'UserQL'; id: string } | null;
  } | null;
};

export type GetVoiceConfigurationsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetVoiceConfigurationsQuery = {
  __typename?: 'Query';
  voiceConfigurations?: Array<{
    __typename?: 'VoiceConfigurationQL';
    voiceType: string;
    language?: string | null;
    service?: string | null;
    imgUrl?: string | null;
    voiceAudio?: string | null;
  }> | null;
};

export type GetPlaceVoiceSettingsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetPlaceVoiceSettingsQuery = {
  __typename?: 'Query';
  placeVoiceSettings?: {
    __typename?: 'PlaceVoiceSettingsQL';
    id: string;
    voice: string;
    voiceSpanish?: string | null;
    voiceFrench?: string | null;
    speechLanguage: Language;
    allowedSpeechLanguages?: Array<Language | null> | null;
  } | null;
};

export type WriteItForMeConfigFragment = {
  __typename?: 'WriteItForMeConfigQL';
  id: string;
  placeId: string;
  instructions: string;
};

export type BuildWriteItForMeQuestionTreeMutationVariables = Exact<{
  input: BuildWriteItForMeQuestionTreeInput;
}>;

export type BuildWriteItForMeQuestionTreeMutation = {
  __typename?: 'Mutations';
  buildWriteItForMeQuestionTree?: {
    __typename?: 'BuildWriteItForMeQuestionTree';
    tones: Array<string>;
    questionTree: {
      __typename?: 'WriteItForMeQuestionTree';
      questions: Array<{
        __typename?: 'WriteItForMeQuestionNode';
        text: string;
        id: string;
        defaultAnswer?: {
          __typename?: 'WriteItForMeAnswerOption';
          id: string;
          text: string;
          nextQuestionId?: string | null;
        } | null;
        answers: Array<{
          __typename?: 'WriteItForMeAnswerOption';
          id: string;
          text: string;
          nextQuestionId?: string | null;
        }>;
      }>;
    };
  } | null;
};

export type GenerateWriteItForMeContentMutationVariables = Exact<{
  input: GenerateWriteItForMeContentInput;
}>;

export type GenerateWriteItForMeContentMutation = {
  __typename?: 'Mutations';
  generateWriteItForMeContent?: {
    __typename?: 'GenerateWriteItForMeContent';
    content: string;
  } | null;
};

export type CreateConversationTextExpansionMutationVariables = Exact<{
  input: CreateConversationTextExpansionInput;
}>;

export type CreateConversationTextExpansionMutation = {
  __typename?: 'Mutations';
  createConversationTextExpansion?: {
    __typename?: 'CreateConversationTextExpansion';
    textExpansion: {
      __typename?: 'TextGenerationQL';
      responses: Array<string>;
      data: any;
      messages: Array<{
        __typename?: 'TextGenerationChatMessageQL';
        role: string;
        content: string;
      }>;
    };
  } | null;
};

export type WriteItForMeConfigQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type WriteItForMeConfigQuery = {
  __typename?: 'Query';
  writeItForMeConfig?:
    | ({ __typename?: 'WriteItForMeConfigQL' } & WriteItForMeConfigFragment)
    | null;
};

export type UpdateWriteItForMeConfigMutationVariables = Exact<{
  input: UpdateWriteItForMeConfigInput;
}>;

export type UpdateWriteItForMeConfigMutation = {
  __typename?: 'Mutations';
  updateWriteItForMeConfig?: {
    __typename?: 'UpdateWriteItForMeConfig';
    writeItForMeConfig: {
      __typename?: 'WriteItForMeConfigQL';
    } & WriteItForMeConfigFragment;
  } | null;
};

export type AdminAccountFieldsFragment = {
  __typename: 'AccountQL';
  id: string;
  name: string;
  businessVertical?: string | null;
  billingIdentity: {
    __typename?: 'BillingIdentityQL';
    id: string;
    signupMode?: string | null;
  };
};

export type AdminPlaceFieldsFragment = {
  __typename: 'PlaceQL';
  id: string;
  name: string;
  newConversationsPerDay: number;
  inboxType: string;
  status: Status;
  hasDegradedInboxExperience?: boolean | null;
  allowCustomAudio: boolean;
  account: { __typename?: 'AccountQL'; id: string; name: string };
  placeGroup: { __typename?: 'PlaceGroupQL'; id: string; name: string };
};

export type AssignmentOptionsFieldsFragment = {
  __typename?: 'PhoneLineQL';
  id: string;
  smsChannel?:
    | ({
        __typename?: 'BandwidthChannelQL';
      } & ChannelFields_BandwidthChannelQl_Fragment)
    | ({ __typename?: 'BaseChannel' } & ChannelFields_BaseChannel_Fragment)
    | ({
        __typename?: 'FacebookChannelQL';
      } & ChannelFields_FacebookChannelQl_Fragment)
    | ({
        __typename?: 'GoogleChannelQL';
      } & ChannelFields_GoogleChannelQl_Fragment)
    | ({ __typename?: 'NoteChannelQL' } & ChannelFields_NoteChannelQl_Fragment)
    | ({
        __typename?: 'NumboxChannelQL';
      } & ChannelFields_NumboxChannelQl_Fragment)
    | ({
        __typename?: 'TwilioChannelQL';
      } & ChannelFields_TwilioChannelQl_Fragment)
    | null;
};

type AutomationTriggerFields_AppointmentLeadCreatedTriggerQl_Fragment = {
  __typename: 'AppointmentLeadCreatedTriggerQL';
  rulesQuery?: string | null;
  id: string;
  triggerType: string;
  uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
};

type AutomationTriggerFields_AppointmentLeadUpdatedTriggerQl_Fragment = {
  __typename: 'AppointmentLeadUpdatedTriggerQL';
  rulesQuery?: string | null;
  id: string;
  triggerType: string;
  uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
};

type AutomationTriggerFields_ConversationArchivedTriggerQl_Fragment = {
  __typename: 'ConversationArchivedTriggerQL';
  includeClosedByNuma: boolean;
  includeActiveConversations: boolean;
  daysSinceOutbound: number;
  daysSinceInbound: number;
  id: string;
  triggerType: string;
  uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
};

type AutomationTriggerFields_ConversationMarkedAsHeatCaseTriggerQl_Fragment = {
  __typename: 'ConversationMarkedAsHeatCaseTriggerQL';
  id: string;
  triggerType: string;
  uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
};

type AutomationTriggerFields_ConversationStartedTriggerQl_Fragment = {
  __typename: 'ConversationStartedTriggerQL';
  id: string;
  triggerType: string;
  uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
};

type AutomationTriggerFields_CustomerContactedTriggerQl_Fragment = {
  __typename: 'CustomerContactedTriggerQL';
  customerContactType: CustomerContactTypes;
  id: string;
  triggerType: string;
  uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
};

type AutomationTriggerFields_EquityTradeOpportunityCreatedTriggerQl_Fragment = {
  __typename: 'EquityTradeOpportunityCreatedTriggerQL';
  id: string;
  triggerType: string;
  uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
};

type AutomationTriggerFields_LabelAddedTriggerQl_Fragment = {
  __typename: 'LabelAddedTriggerQL';
  labelsToWatch: Array<string>;
  id: string;
  triggerType: string;
  uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
};

type AutomationTriggerFields_LabelRemovedTriggerQl_Fragment = {
  __typename: 'LabelRemovedTriggerQL';
  labelsToWatch: Array<string>;
  id: string;
  triggerType: string;
  uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
};

type AutomationTriggerFields_ManualOpportunityTriggerQl_Fragment = {
  __typename: 'ManualOpportunityTriggerQL';
  id: string;
  triggerType: string;
  uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
};

type AutomationTriggerFields_MessageReceivedTriggerQl_Fragment = {
  __typename: 'MessageReceivedTriggerQL';
  id: string;
  triggerType: string;
  uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
};

type AutomationTriggerFields_OpportunityServiceAppointmentConfirmationTriggerQl_Fragment =
  {
    __typename: 'OpportunityServiceAppointmentConfirmationTriggerQL';
    id: string;
    triggerType: string;
    uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
  };

type AutomationTriggerFields_OpportunityServiceAppointmentReminderTriggerQl_Fragment =
  {
    __typename: 'OpportunityServiceAppointmentReminderTriggerQL';
    id: string;
    triggerType: string;
    uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
  };

type AutomationTriggerFields_RepairOrderClosedTriggerQl_Fragment = {
  __typename: 'RepairOrderClosedTriggerQL';
  includeWhenMatched: boolean;
  rulesQuery?: string | null;
  id: string;
  triggerType: string;
  opcodesFilter: Array<{
    __typename?: 'OpCodesFilter';
    category: OpCodesFilterInput;
    code: string;
  }>;
  uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
};

type AutomationTriggerFields_RepairOrderOpenedTriggerQl_Fragment = {
  __typename: 'RepairOrderOpenedTriggerQL';
  includeWhenMatched: boolean;
  rulesQuery?: string | null;
  id: string;
  triggerType: string;
  opcodesFilter: Array<{
    __typename?: 'OpCodesFilter';
    category: OpCodesFilterInput;
    code: string;
  }>;
  uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
};

type AutomationTriggerFields_RepairOrderUpdatedTriggerQl_Fragment = {
  __typename: 'RepairOrderUpdatedTriggerQL';
  includeWhenMatched: boolean;
  rulesQuery?: string | null;
  id: string;
  triggerType: string;
  opcodesFilter: Array<{
    __typename?: 'OpCodesFilter';
    category: OpCodesFilterInput;
    code: string;
  }>;
  updateFilter: {
    __typename?: 'RepairOrderUpdateFilter';
    operator: RepairOrderTriggerOperatorsFilterInput;
    conditions: Array<{
      __typename?: 'RepairOrderUpdatedCondition';
      function: RepairOrderTriggerFunctionsInput;
      keyName: RepairOrderTriggerKeysInput;
      newValue?: {
        __typename?: 'RepairOrderUpdatedConditionValue';
        value: string;
        type: RepairOrderTriggerValuesInputType;
      } | null;
      oldValue?: {
        __typename?: 'RepairOrderUpdatedConditionValue';
        value: string;
        type: RepairOrderTriggerValuesInputType;
      } | null;
    }>;
  };
  uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
};

type AutomationTriggerFields_StaffMemberCallGoesPoorlyTriggerQl_Fragment = {
  __typename: 'StaffMemberCallGoesPoorlyTriggerQL';
  id: string;
  triggerType: string;
  uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
};

type AutomationTriggerFields_SurveyAnsweredTriggerQl_Fragment = {
  __typename: 'SurveyAnsweredTriggerQL';
  id: string;
  triggerType: string;
  surveyAnsweredFilter: {
    __typename?: 'SurveyAnsweredUpdateFilter';
    surveyType: SurveyTypeTriggerValuesTypes;
    inequalityFilter: InequalityFilterTriggerValuesTypes;
    ratingChoice: number;
  };
  uiHints?: { __typename?: 'AutomationUIHints'; x: number; y: number } | null;
};

export type AutomationTriggerFieldsFragment =
  | AutomationTriggerFields_AppointmentLeadCreatedTriggerQl_Fragment
  | AutomationTriggerFields_AppointmentLeadUpdatedTriggerQl_Fragment
  | AutomationTriggerFields_ConversationArchivedTriggerQl_Fragment
  | AutomationTriggerFields_ConversationMarkedAsHeatCaseTriggerQl_Fragment
  | AutomationTriggerFields_ConversationStartedTriggerQl_Fragment
  | AutomationTriggerFields_CustomerContactedTriggerQl_Fragment
  | AutomationTriggerFields_EquityTradeOpportunityCreatedTriggerQl_Fragment
  | AutomationTriggerFields_LabelAddedTriggerQl_Fragment
  | AutomationTriggerFields_LabelRemovedTriggerQl_Fragment
  | AutomationTriggerFields_ManualOpportunityTriggerQl_Fragment
  | AutomationTriggerFields_MessageReceivedTriggerQl_Fragment
  | AutomationTriggerFields_OpportunityServiceAppointmentConfirmationTriggerQl_Fragment
  | AutomationTriggerFields_OpportunityServiceAppointmentReminderTriggerQl_Fragment
  | AutomationTriggerFields_RepairOrderClosedTriggerQl_Fragment
  | AutomationTriggerFields_RepairOrderOpenedTriggerQl_Fragment
  | AutomationTriggerFields_RepairOrderUpdatedTriggerQl_Fragment
  | AutomationTriggerFields_StaffMemberCallGoesPoorlyTriggerQl_Fragment
  | AutomationTriggerFields_SurveyAnsweredTriggerQl_Fragment;

export type AutomationFieldsFragment = {
  __typename: 'AutomationQL';
  id: string;
  state: AutomationState;
  name?: string | null;
  lastUpdated?: any | null;
  firstActionId?: string | null;
  dateLastPublished?: any | null;
  placeId: string;
  publishedVersion?: number | null;
  latestVersion: number;
  automationGroupId?: string | null;
  enrollmentCriteria: {
    __typename?: 'EnrollmentCriteriaQL';
    id: string;
    preventConcurrentEnrollment: boolean;
    executionLimit: number;
    duration: number;
  };
  exitTriggers: Array<
    | ({
        __typename?: 'AppointmentLeadCreatedTriggerQL';
      } & AutomationTriggerFields_AppointmentLeadCreatedTriggerQl_Fragment)
    | ({
        __typename?: 'AppointmentLeadUpdatedTriggerQL';
      } & AutomationTriggerFields_AppointmentLeadUpdatedTriggerQl_Fragment)
    | ({
        __typename?: 'ConversationArchivedTriggerQL';
      } & AutomationTriggerFields_ConversationArchivedTriggerQl_Fragment)
    | ({
        __typename?: 'ConversationMarkedAsHeatCaseTriggerQL';
      } & AutomationTriggerFields_ConversationMarkedAsHeatCaseTriggerQl_Fragment)
    | ({
        __typename?: 'ConversationStartedTriggerQL';
      } & AutomationTriggerFields_ConversationStartedTriggerQl_Fragment)
    | ({
        __typename?: 'CustomerContactedTriggerQL';
      } & AutomationTriggerFields_CustomerContactedTriggerQl_Fragment)
    | ({
        __typename?: 'EquityTradeOpportunityCreatedTriggerQL';
      } & AutomationTriggerFields_EquityTradeOpportunityCreatedTriggerQl_Fragment)
    | ({
        __typename?: 'LabelAddedTriggerQL';
      } & AutomationTriggerFields_LabelAddedTriggerQl_Fragment)
    | ({
        __typename?: 'LabelRemovedTriggerQL';
      } & AutomationTriggerFields_LabelRemovedTriggerQl_Fragment)
    | ({
        __typename?: 'ManualOpportunityTriggerQL';
      } & AutomationTriggerFields_ManualOpportunityTriggerQl_Fragment)
    | ({
        __typename?: 'MessageReceivedTriggerQL';
      } & AutomationTriggerFields_MessageReceivedTriggerQl_Fragment)
    | ({
        __typename?: 'OpportunityServiceAppointmentConfirmationTriggerQL';
      } & AutomationTriggerFields_OpportunityServiceAppointmentConfirmationTriggerQl_Fragment)
    | ({
        __typename?: 'OpportunityServiceAppointmentReminderTriggerQL';
      } & AutomationTriggerFields_OpportunityServiceAppointmentReminderTriggerQl_Fragment)
    | ({
        __typename?: 'RepairOrderClosedTriggerQL';
      } & AutomationTriggerFields_RepairOrderClosedTriggerQl_Fragment)
    | ({
        __typename?: 'RepairOrderOpenedTriggerQL';
      } & AutomationTriggerFields_RepairOrderOpenedTriggerQl_Fragment)
    | ({
        __typename?: 'RepairOrderUpdatedTriggerQL';
      } & AutomationTriggerFields_RepairOrderUpdatedTriggerQl_Fragment)
    | ({
        __typename?: 'StaffMemberCallGoesPoorlyTriggerQL';
      } & AutomationTriggerFields_StaffMemberCallGoesPoorlyTriggerQl_Fragment)
    | ({
        __typename?: 'SurveyAnsweredTriggerQL';
      } & AutomationTriggerFields_SurveyAnsweredTriggerQl_Fragment)
  >;
  startTrigger?:
    | ({
        __typename?: 'AppointmentLeadCreatedTriggerQL';
      } & AutomationTriggerFields_AppointmentLeadCreatedTriggerQl_Fragment)
    | ({
        __typename?: 'AppointmentLeadUpdatedTriggerQL';
      } & AutomationTriggerFields_AppointmentLeadUpdatedTriggerQl_Fragment)
    | ({
        __typename?: 'ConversationArchivedTriggerQL';
      } & AutomationTriggerFields_ConversationArchivedTriggerQl_Fragment)
    | ({
        __typename?: 'ConversationMarkedAsHeatCaseTriggerQL';
      } & AutomationTriggerFields_ConversationMarkedAsHeatCaseTriggerQl_Fragment)
    | ({
        __typename?: 'ConversationStartedTriggerQL';
      } & AutomationTriggerFields_ConversationStartedTriggerQl_Fragment)
    | ({
        __typename?: 'CustomerContactedTriggerQL';
      } & AutomationTriggerFields_CustomerContactedTriggerQl_Fragment)
    | ({
        __typename?: 'EquityTradeOpportunityCreatedTriggerQL';
      } & AutomationTriggerFields_EquityTradeOpportunityCreatedTriggerQl_Fragment)
    | ({
        __typename?: 'LabelAddedTriggerQL';
      } & AutomationTriggerFields_LabelAddedTriggerQl_Fragment)
    | ({
        __typename?: 'LabelRemovedTriggerQL';
      } & AutomationTriggerFields_LabelRemovedTriggerQl_Fragment)
    | ({
        __typename?: 'ManualOpportunityTriggerQL';
      } & AutomationTriggerFields_ManualOpportunityTriggerQl_Fragment)
    | ({
        __typename?: 'MessageReceivedTriggerQL';
      } & AutomationTriggerFields_MessageReceivedTriggerQl_Fragment)
    | ({
        __typename?: 'OpportunityServiceAppointmentConfirmationTriggerQL';
      } & AutomationTriggerFields_OpportunityServiceAppointmentConfirmationTriggerQl_Fragment)
    | ({
        __typename?: 'OpportunityServiceAppointmentReminderTriggerQL';
      } & AutomationTriggerFields_OpportunityServiceAppointmentReminderTriggerQl_Fragment)
    | ({
        __typename?: 'RepairOrderClosedTriggerQL';
      } & AutomationTriggerFields_RepairOrderClosedTriggerQl_Fragment)
    | ({
        __typename?: 'RepairOrderOpenedTriggerQL';
      } & AutomationTriggerFields_RepairOrderOpenedTriggerQl_Fragment)
    | ({
        __typename?: 'RepairOrderUpdatedTriggerQL';
      } & AutomationTriggerFields_RepairOrderUpdatedTriggerQl_Fragment)
    | ({
        __typename?: 'StaffMemberCallGoesPoorlyTriggerQL';
      } & AutomationTriggerFields_StaffMemberCallGoesPoorlyTriggerQl_Fragment)
    | ({
        __typename?: 'SurveyAnsweredTriggerQL';
      } & AutomationTriggerFields_SurveyAnsweredTriggerQl_Fragment)
    | null;
  actions: Array<
    | {
        __typename?: 'AssignConversationActionQL';
        assigneeId?: string | null;
        teamId?: string | null;
        respectExistingAssignments: boolean;
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        assignee?: {
          __typename?: 'UserQL';
          id: string;
          email?: string | null;
          fullName?: string | null;
          firstName?: string | null;
          lastName?: string | null;
        } | null;
        team?: {
          __typename?: 'TeamQL';
          id: string;
          name: string;
          avatar: string;
        } | null;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'ChangeConversationStateActionQL';
        desiredConversationState?: DesiredConversationState | null;
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'CheckOpportunityStatusActionQL';
        onYesActionId?: string | null;
        onNoActionId?: string | null;
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        opportunity?: {
          __typename?: 'OpportunityInfo';
          type: OpportunityType;
        } | null;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'CheckRepairOrderDetailsActionQL';
        rulesQuery?: string | null;
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'EscalateConversationActionQL';
        messageToSend?: string | null;
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'HandToOpportunityAgentActionQL';
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        opportunity?: {
          __typename?: 'OpportunityInfo';
          type: OpportunityType;
        } | null;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'HasLabelActionQL';
        onYesActionId?: string | null;
        onNoActionId?: string | null;
        labelsToCheck: Array<string>;
        labelCheckOperation: HasLabelsTypeInput;
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'IsBusinessHoursActionQL';
        onYesActionId?: string | null;
        onNoActionId?: string | null;
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'LeaveNoteActionQL';
        messageToSend?: string | null;
        desiredConversationState?: DesiredConversationState | null;
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'ManageLabelActionQL';
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        labels: Array<{
          __typename?: 'ManageLabelsOperation';
          operation: ManageLabelsInput;
          label: string;
        }>;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'NotifyTeamMemberActionQL';
        messageToSend?: string | null;
        desiredConversationState?: DesiredConversationState | null;
        notifyOwner: boolean;
        userIdsMentioned: Array<string>;
        teamIdsMentioned: Array<string>;
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'ScheduleMessageActionQL';
        messageToSend?: string | null;
        friendlyTime?: boolean | null;
        minutesUntilSent: number;
        desiredConversationState?: DesiredConversationState | null;
        textWithCare?: TextWithCareActionInput | null;
        selectedChannelId?: string | null;
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        automationChannels: Array<{
          __typename?: 'AutomationChannels';
          id: string;
        }>;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'SendFeedbackActionQL';
        friendlyTime?: boolean | null;
        desiredConversationState?: DesiredConversationState | null;
        textWithCare?: TextWithCareActionInput | null;
        selectedChannelId?: string | null;
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        automationChannels: Array<{
          __typename?: 'AutomationChannels';
          id: string;
        }>;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'SendMessageActionQL';
        messageToSend?: string | null;
        friendlyTime?: boolean | null;
        desiredConversationState?: DesiredConversationState | null;
        textWithCare?: TextWithCareActionInput | null;
        selectedChannelId?: string | null;
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        automationChannels: Array<{
          __typename?: 'AutomationChannels';
          id: string;
        }>;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'SendReviewActionQL';
        messageToSend?: string | null;
        friendlyTime?: boolean | null;
        desiredConversationState?: DesiredConversationState | null;
        textWithCare?: TextWithCareActionInput | null;
        selectedChannelId?: string | null;
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        automationChannels: Array<{
          __typename?: 'AutomationChannels';
          id: string;
        }>;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'SummarizeConversationActionQL';
        desiredConversationState?: DesiredConversationState | null;
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'UpdateOpportunityActionQL';
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        opportunity?: {
          __typename?: 'OpportunityInfo';
          type: OpportunityType;
          createIfNotExists?: boolean | null;
          stage?: EquityTradeOpportunityStage | null;
          closeReason?: EquityTradeOpportunityCloseReason | null;
        } | null;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
    | {
        __typename?: 'WaitActionQL';
        minutesToWait: number;
        id: string;
        actionType: string;
        customersWaiting: boolean;
        nextActionId?: string | null;
        uiHints?: {
          __typename?: 'AutomationUIHints';
          x: number;
          y: number;
        } | null;
      }
  >;
};

export type AutopilotFieldsFragment = {
  __typename: 'AutopilotQL';
  id: string;
  eta: any;
  identifier?: string | null;
  customerName?: string | null;
  autopilotStatus: AutopilotStatus;
  previewWelcome?: string | null;
  previewInspection?: string | null;
  previewService?: string | null;
  previewQualityControl?: string | null;
  previewPickup?: string | null;
  conversation: { __typename?: 'ConversationQL'; id: string };
  assignee?: { __typename?: 'UserQL'; id: string; displayName: string } | null;
  autopilotScheduleMessages: Array<{
    __typename?: 'AutopilotScheduledMessageQL';
    id: string;
    milestoneName: string;
    scheduled: {
      __typename?: 'ScheduledMessageQL';
      id: string;
      sendAt: any;
      status: ScheduledMessageStatus;
    };
  }>;
};

export type AwayModeFieldsFragment = {
  __typename?: 'UserQL';
  id: string;
  isAway: boolean;
  isScheduleEnabled: boolean;
  nextShiftStart?: any | null;
  nextShiftEnd?: any | null;
  showAwayModeBannerAfter?: any | null;
  canManageOwnAwayModeSettings: boolean;
};

export type AwayModeDetailsFieldsFragment = {
  __typename?: 'UserQL';
  id: string;
  placesUsers?: Array<{
    __typename?: 'PlacesUsersQL';
    place?: { __typename?: 'PlaceQL'; id: string } | null;
    awayModeAssigneeUser?:
      | ({ __typename?: 'UserQL' } & UserItemFieldsFragment)
      | null;
    awayModeAssigneeTeam?:
      | ({ __typename?: 'TeamQL' } & TeamFieldsFragment)
      | null;
  } | null> | null;
} & AwayModeFieldsFragment;

export type BrandThemeFieldsFragment = {
  __typename?: 'BrandThemeQL';
  id: string;
  headerBackgroundColor: string;
  headerBorderColor: string;
  headerTextColor: string;
  bodyBackgroundColor: string;
  bodyBorderColor: string;
  bodyTextColor: string;
  buttonPrimaryBackgroundColor: string;
  buttonPrimaryBorderColor: string;
  buttonPrimaryTextColor: string;
  buttonSecondaryBackgroundColor: string;
  buttonSecondaryBorderColor: string;
  buttonSecondaryTextColor: string;
  logoUrl?: string | null;
  paletteType: string;
  supportedPaletteTypes: Array<{
    __typename?: 'PaletteQL';
    name: string;
    headerBackgroundColor: string;
    headerBorderColor: string;
    headerTextColor: string;
    bodyBackgroundColor: string;
    bodyBorderColor: string;
    bodyTextColor: string;
    buttonPrimaryBackgroundColor: string;
    buttonPrimaryBorderColor: string;
    buttonPrimaryTextColor: string;
    buttonSecondaryBackgroundColor: string;
    buttonSecondaryBorderColor: string;
    buttonSecondaryTextColor: string;
  }>;
};

export type BusinessProfileFieldsFragment = {
  __typename?: 'BusinessProfileQL';
  id: string;
  legalBusinessName?: string | null;
  physicalAddress?: string | null;
  businessType?: string | null;
  businessIndustry?: string | null;
  businessRegistrationIdType?: string | null;
  businessRegistrationNumberType?: string | null;
  businessRegistrationNumber?: string | null;
  businessRegionsOfOperations?: string | null;
  companyStatus?: string | null;
  stockTickerExchange?: string | null;
  websiteUrl?: string | null;
  socialMediaUrl?: string | null;
  contact1LastName?: string | null;
  contact1FirstName?: string | null;
  contact1Email?: string | null;
  contact1BusinessTitle?: string | null;
  contact1JobPosition?: string | null;
  contact1PhoneNumber?: string | null;
  registrationType?: string | null;
  registrationStatus?: string | null;
};

export type ConversationSignatureStateFieldsFragment = {
  __typename?: 'ConversationQL';
  id: string;
  isNextOutboundMessageSigned: boolean;
};

export type HostedSmsPortFieldsFragment = {
  __typename?: 'HostedSmsPortQL';
  id: string;
  mdn: string;
  addressSid?: string | null;
  sid: string;
  status: string;
  verificationAttempts?: number | null;
  verificationCode?: string | null;
  loaSid?: string | null;
  customerName: string;
  customerEmail: string;
};

export type InboxBehaviourFieldsFragment = {
  __typename?: 'UserQL';
  id: string;
  hideSharedInboxViews: boolean;
  statusBoardView: boolean;
  defaultView: string;
  defaultYouView: string;
  emailNotificationSetting: EmailNotificationSettings;
  pushNotificationSetting: PushNotificationSettings;
  browserNotificationSetting: PushNotificationSettingsInput;
};

export type ManageHangupsFieldsFragment = {
  __typename?: 'PhoneLinePolicyQL';
  id: string;
  archiveMissedCalls: boolean;
  autoSendHangupReplies: boolean;
  hangupSuggestion?: string | null;
};

export type PhoneLineFieldsFragment = {
  __typename?: 'PhoneLineQL';
  id: string;
  mdn: string;
  name: string;
  carrierName?: string | null;
  category: PhoneLineCategory;
  lineType?: PhoneLineType | null;
  createHostedSmsUrl?: string | null;
  kind: PhoneLineKind;
  returnCallsMode: PhoneLineReturnCallOptions;
  returnCallsRoutingHours: PhoneLineReturnCallRoutingHours;
  returnCallsForwardingMode: PhoneLineReturnCallForwadingOptions;
  returnCallsMdn?: string | null;
  canForwardReturnCalls: boolean;
  nryForwardingMdn?: string | null;
  policy: {
    __typename?: 'PhoneLinePolicyQL';
    id: string;
    category: PhoneLinePolicyCategory;
  };
  user?: ({ __typename?: 'UserQL' } & UserItemFieldsFragment) | null;
  hostedSmsPort?: {
    __typename?: 'HostedSmsPortQL';
    id: string;
    url?: string | null;
    status: string;
    verificationAttempts?: number | null;
    verificationCode?: string | null;
  } | null;
};

export type PhoneLineWithChannelsFieldsFragment = {
  __typename?: 'PhoneLineQL';
  voiceChannel?:
    | ({
        __typename?: 'BandwidthChannelQL';
      } & ChannelFields_BandwidthChannelQl_Fragment)
    | ({ __typename?: 'BaseChannel' } & ChannelFields_BaseChannel_Fragment)
    | ({
        __typename?: 'FacebookChannelQL';
      } & ChannelFields_FacebookChannelQl_Fragment)
    | ({
        __typename?: 'GoogleChannelQL';
      } & ChannelFields_GoogleChannelQl_Fragment)
    | ({ __typename?: 'NoteChannelQL' } & ChannelFields_NoteChannelQl_Fragment)
    | ({
        __typename?: 'NumboxChannelQL';
      } & ChannelFields_NumboxChannelQl_Fragment)
    | ({
        __typename?: 'TwilioChannelQL';
      } & ChannelFields_TwilioChannelQl_Fragment)
    | null;
  smsChannel?:
    | ({
        __typename?: 'BandwidthChannelQL';
      } & ChannelFields_BandwidthChannelQl_Fragment)
    | ({ __typename?: 'BaseChannel' } & ChannelFields_BaseChannel_Fragment)
    | ({
        __typename?: 'FacebookChannelQL';
      } & ChannelFields_FacebookChannelQl_Fragment)
    | ({
        __typename?: 'GoogleChannelQL';
      } & ChannelFields_GoogleChannelQl_Fragment)
    | ({ __typename?: 'NoteChannelQL' } & ChannelFields_NoteChannelQl_Fragment)
    | ({
        __typename?: 'NumboxChannelQL';
      } & ChannelFields_NumboxChannelQl_Fragment)
    | ({
        __typename?: 'TwilioChannelQL';
      } & ChannelFields_TwilioChannelQl_Fragment)
    | null;
} & PhoneLineFieldsFragment;

export type PhoneLinePolicyFieldsFragment = {
  __typename?: 'PhoneLinePolicyQL';
  id: string;
  category: PhoneLinePolicyCategory;
  autoOptin: boolean;
  autoOptinMessage?: string | null;
  delayAnswerDuration: number;
  answerWithKeys?: string | null;
  fixInternalDialing: boolean;
  assistantPhrase: string;
  archiveMissedCalls: boolean;
  hangupSuggestion?: string | null;
  autoSendHangupReplies: boolean;
  hasIdentityPrompt: boolean;
  allowDisruptions: boolean;
  nryCallForwardingPickUpTimeoutSecs: number;
  nryCallForwardingUserScreenInteractionTimeoutSecs: number;
  answeringScripts: Array<{
    __typename?: 'AnsweringScriptsQL';
    id: string;
    scriptType: AnsweringScriptType;
    order: number;
  }>;
};

export type PhonelineCategorySettingsFieldsFragment = {
  __typename?: 'PhoneLineQL';
  id: string;
  name: string;
  category: PhoneLineCategory;
  returnCallsMode: PhoneLineReturnCallOptions;
  returnCallsRoutingHours: PhoneLineReturnCallRoutingHours;
  returnCallsForwardingMode: PhoneLineReturnCallForwadingOptions;
  returnCallsMdn?: string | null;
  canForwardReturnCalls: boolean;
  nryForwardingMdn?: string | null;
  user?: { __typename?: 'UserQL'; id: string; fullName?: string | null } | null;
  smsChannel?:
    | { __typename?: 'BandwidthChannelQL'; id: string }
    | { __typename?: 'BaseChannel'; id: string }
    | { __typename?: 'FacebookChannelQL'; id: string }
    | { __typename?: 'GoogleChannelQL'; id: string }
    | { __typename?: 'NoteChannelQL'; id: string }
    | { __typename?: 'NumboxChannelQL'; id: string }
    | { __typename?: 'TwilioChannelQL'; id: string }
    | null;
};

export type PlaceDegradedInboxExperienceFieldsFragment = {
  __typename?: 'PlaceQL';
  id: string;
  hasDegradedInboxExperience?: boolean | null;
};

export type ScheduledMessageFieldsFragment = {
  __typename?: 'ScheduledMessageQL';
  id: string;
  createdOn: any;
  content: string;
  sendAt: any;
  status: ScheduledMessageStatus;
  deliveryAttempted?: any | null;
  channelId?: string | null;
  conversationId?: string | null;
  sender?:
    | ({ __typename?: 'ParticipantQL' } & ParticipantFieldsFragment)
    | null;
};

export type StageStubFragment = {
  __typename?: 'StageQL';
  id: string;
  placeId: string;
  name: string;
  icon?: string | null;
  sortOrder: number;
  messageTemplate?: string | null;
  renderedMessageTemplate?: string | null;
  updateMessageTemplate?: string | null;
  renderedUpdateMessageTemplate?: string | null;
  speechUpdate?: string | null;
  speechUrl?: string | null;
};

export type StatusItemStubFragment = {
  __typename?: 'StatusItemQL';
  id: string;
  eta?: any | null;
  orderNumber?: string | null;
  tag?: string | null;
  color: StatusItemColor;
  status: StatusItemStatus;
  description?: string | null;
  createdOn: any;
  lastUpdateTime?: any | null;
  heldSince?: any | null;
  participant?: {
    __typename?: 'ParticipantQL';
    id: string;
    displayName: string;
    displayNameConfidence: ParticipantDataConfidence;
    firstName?: string | null;
    lastName?: string | null;
    address: string;
  } | null;
  conversation?:
    | ({
        __typename?: 'ConversationQL';
        escalated?: any | null;
        conversationLabels?: Array<
          {
            __typename?: 'ConversationLabelQL';
          } & ConversationLabelStubFieldsFragment
        > | null;
      } & ConversationItemStubFragment)
    | null;
};

export type StatusItemDetailsFragment = {
  __typename?: 'StatusItemQL';
  id: string;
  eta?: any | null;
  orderNumber?: string | null;
  tag?: string | null;
  status: StatusItemStatus;
  description?: string | null;
  createdOn: any;
  color: StatusItemColor;
  lastUpdateTime?: any | null;
  heldSince?: any | null;
  participant?: {
    __typename?: 'ParticipantQL';
    id: string;
    displayName: string;
    displayNameConfidence: ParticipantDataConfidence;
    firstName?: string | null;
    lastName?: string | null;
    address: string;
  } | null;
  conversation?:
    | ({
        __typename?: 'ConversationQL';
        escalated?: any | null;
        conversationLabels?: Array<
          {
            __typename?: 'ConversationLabelQL';
          } & ConversationLabelStubFieldsFragment
        > | null;
      } & ConversationItemStubFragment)
    | null;
  stage: { __typename?: 'StageQL'; id: string; name: string; placeId: string };
  assignee: { __typename?: 'UserQL'; id: string; displayName: string };
};

export type SubscriptionFieldsFragment = {
  __typename?: 'SubscriptionQL';
  id: string;
  quantity: number;
  sku: { __typename?: 'SkuQL'; id: string; name: string };
};

export type TeamFieldsFragment = {
  __typename?: 'TeamQL';
  id: string;
  name: string;
  avatar: string;
};

export type TeamSettingsFieldsFragment = {
  __typename?: 'TeamQL';
  id: string;
  name: string;
  avatar: string;
  assignmentStyle: AssignmentStyle;
  userCount: number;
};

export type TeamWithUsersFragment = {
  __typename?: 'TeamQL';
  users?: {
    __typename?: 'UserConnection';
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean };
    edges: Array<{
      __typename?: 'UserEdge';
      node?: {
        __typename?: 'UserQL';
        id: string;
        displayName: string;
        isAway: boolean;
      } | null;
    } | null>;
  } | null;
} & TeamFieldsFragment;

export type SystemMessageSettingsFieldsFragment = {
  __typename: 'SystemMessageSettings';
  showSystemMessages?: boolean | null;
};

export type UserViewPreferencesFieldsFragment = {
  __typename: 'UserViewPreferences';
  systemMessageSettings?:
    | ({
        __typename?: 'SystemMessageSettings';
      } & SystemMessageSettingsFieldsFragment)
    | null;
};

export type VoiceScriptFieldsFragment = {
  __typename: 'VoiceScriptQL';
  id: string;
  createdOn?: any | null;
  afterHoursEnabled: boolean;
  scriptType: VoicemailScriptType;
  placeId: string;
  voice?: string | null;
  allowCustomAudio?: boolean | null;
  firstStepId?: string | null;
  dirty: boolean;
  steps: Array<
    | ({
        __typename?: 'AppointmentAgentStepQL';
      } & VoiceStepFields_AppointmentAgentStepQl_Fragment)
    | ({
        __typename?: 'AskYesNoQuestionStepQL';
      } & VoiceStepFields_AskYesNoQuestionStepQl_Fragment)
    | ({
        __typename?: 'AutoAssignStepQL';
      } & VoiceStepFields_AutoAssignStepQl_Fragment)
    | ({
        __typename?: 'CallForwardingStepQL';
      } & VoiceStepFields_CallForwardingStepQl_Fragment)
    | ({
        __typename?: 'CallRecordingStepQL';
      } & VoiceStepFields_CallRecordingStepQl_Fragment)
    | ({
        __typename?: 'CheckBusinessHoursStepQL';
      } & VoiceStepFields_CheckBusinessHoursStepQl_Fragment)
    | ({
        __typename?: 'CheckForLabelStepQL';
      } & VoiceStepFields_CheckForLabelStepQl_Fragment)
    | ({
        __typename?: 'ConversationStateStepQL';
      } & VoiceStepFields_ConversationStateStepQl_Fragment)
    | ({
        __typename?: 'ConversationalSchedulingAgentStepQl';
      } & VoiceStepFields_ConversationalSchedulingAgentStepQl_Fragment)
    | ({
        __typename?: 'GreetingStepQL';
      } & VoiceStepFields_GreetingStepQl_Fragment)
    | ({
        __typename?: 'IntentQuestionQL';
      } & VoiceStepFields_IntentQuestionQl_Fragment)
    | ({
        __typename?: 'LabelConversationStepQL';
      } & VoiceStepFields_LabelConversationStepQl_Fragment)
    | ({
        __typename?: 'NoteTakerStepQL';
      } & VoiceStepFields_NoteTakerStepQl_Fragment)
    | ({
        __typename?: 'OperatorAgentStepQL';
      } & VoiceStepFields_OperatorAgentStepQl_Fragment)
    | ({ __typename?: 'PickupStepQL' } & VoiceStepFields_PickupStepQl_Fragment)
    | ({
        __typename?: 'PressAnyKeyStepQL';
      } & VoiceStepFields_PressAnyKeyStepQl_Fragment)
    | ({
        __typename?: 'QualifyStepQL';
      } & VoiceStepFields_QualifyStepQl_Fragment)
    | ({
        __typename?: 'QuestionBotStepQL';
      } & VoiceStepFields_QuestionBotStepQl_Fragment)
    | ({
        __typename?: 'SmartTopicStepQL';
      } & VoiceStepFields_SmartTopicStepQl_Fragment)
    | ({ __typename?: 'SpeakStepQL' } & VoiceStepFields_SpeakStepQl_Fragment)
    | ({
        __typename?: 'SpecialQuestionQL';
      } & VoiceStepFields_SpecialQuestionQl_Fragment)
    | ({
        __typename?: 'StatusUpdaterStepQL';
      } & VoiceStepFields_StatusUpdaterStepQl_Fragment)
    | ({
        __typename?: 'TextOptinStepQL';
      } & VoiceStepFields_TextOptinStepQl_Fragment)
    | ({
        __typename?: 'VoiceScriptStepQL';
      } & VoiceStepFields_VoiceScriptStepQl_Fragment)
  >;
};

type VoiceStepFields_AppointmentAgentStepQl_Fragment = {
  __typename: 'AppointmentAgentStepQL';
  id: string;
  nextStepId?: string | null;
  failureStepId?: string | null;
  notBookedRecallStepId?: string | null;
  notBookedOtherStepId?: string | null;
  finishedSpeech: string;
  outcomeNotBookedRecallSpeech: string;
  outcomeNotBookedOtherSpeech: string;
  outcomeNotBookedWantsHumanSpeech: string;
  appointmentAgentSettingsId?: string | null;
  appointmentLeadStepId?: string | null;
  notAnAppointmentLeadStepId?: string | null;
  cantServiceCustomerStepId?: string | null;
  clarifyIntentFirstEnabled: boolean;
  clarifySpeech: string;
  yesSpeech: string;
  noSpeech: string;
  failureSpeech: string;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_AskYesNoQuestionStepQl_Fragment = {
  __typename: 'AskYesNoQuestionStepQL';
  clarifySpeech: string;
  onYesSpeech: string;
  onNoSpeech: string;
  onFailureSpeech: string;
  onYesStepId?: string | null;
  onNoStepId?: string | null;
  id: string;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_AutoAssignStepQl_Fragment = {
  __typename: 'AutoAssignStepQL';
  respectExistingAssignment: boolean;
  autoAssignNextStepId?: string | null;
  id: string;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  assignee?: ({ __typename?: 'UserQL' } & UserItemFieldsFragment) | null;
  team?: ({ __typename?: 'TeamQL' } & TeamFieldsFragment) | null;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_CallForwardingStepQl_Fragment = {
  __typename: 'CallForwardingStepQL';
  callTimeout: number;
  useNumaCallerId: boolean;
  noAnswerSpeech: string;
  onConnectedStepId?: string | null;
  onNoAnsweringStepId?: string | null;
  id: string;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  forwardingMdns?: Array<{
    __typename?: 'CallForwardingStepMdnQL';
    forwardingMdn?: string | null;
    forwardingMode: CallForwardingMode;
  }> | null;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_CallRecordingStepQl_Fragment = {
  __typename: 'CallRecordingStepQL';
  startRecording: boolean;
  playDisclosureRecording: boolean;
  disclosureContent: string;
  nextStepId?: string | null;
  id: string;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_CheckBusinessHoursStepQl_Fragment = {
  __typename: 'CheckBusinessHoursStepQL';
  id: string;
  onOpenStepId?: string | null;
  onClosedStepId?: string | null;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_CheckForLabelStepQl_Fragment = {
  __typename: 'CheckForLabelStepQL';
  id: string;
  onHasLabelId?: string | null;
  onMissingLabelId?: string | null;
  labelName: string;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_ConversationStateStepQl_Fragment = {
  __typename: 'ConversationStateStepQL';
  id: string;
  desiredConversationState?: DesiredConversationState | null;
  nextStepId?: string | null;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_ConversationalSchedulingAgentStepQl_Fragment = {
  __typename: 'ConversationalSchedulingAgentStepQl';
  id: string;
  nextStepId?: string | null;
  appointmentLeadStepId?: string | null;
  failureStepId?: string | null;
  humanEscalationStepId?: string | null;
  humanEscalationSpeech: string;
  confirmIntentSpeech: string;
  shouldConfirmIntent: boolean;
  greetingSpeech?: string | null;
  leadSpeech?: string | null;
  bookedSpeech?: string | null;
  appointmentAgentSettingsId?: string | null;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_GreetingStepQl_Fragment = {
  __typename: 'GreetingStepQL';
  afterHoursSpeech: string;
  renderedAfterHoursSpeech: string;
  playDisclosureRecording: boolean;
  disclosureContent: string;
  softOpenSpeech: string;
  confirmPhonenumberSpeech: string;
  collectNewPhonenumberSpeech: string;
  collectPhonenumberFallbackSpeech: string;
  clarificationSpeech: string;
  isCorrectQuestionSpeech: string;
  yesSpeech: string;
  noSpeech: string;
  retrySpeech: string;
  affirmationSpeech: string;
  nextStepId?: string | null;
  id: string;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_IntentQuestionQl_Fragment = {
  __typename: 'IntentQuestionQL';
  messageToSend: string;
  renderedMessageToSend: string;
  purpose?: string | null;
  canWeTextSpeech: string;
  onYesCanWeTextSpeech: string;
  onNoCanWeTextSpeech: string;
  onFailCanWeTextSpeech: string;
  clarifyCanWeTextSpeech: string;
  clarifySpeech: string;
  onYesSpeech: string;
  onNoSpeech: string;
  onFailureSpeech: string;
  onYesStepId?: string | null;
  onNoStepId?: string | null;
  onYesButNoTextStepId?: string | null;
  id: string;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_LabelConversationStepQl_Fragment = {
  __typename: 'LabelConversationStepQL';
  id: string;
  nextStepId?: string | null;
  labelName: string;
  expirationHours?: number | null;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_NoteTakerStepQl_Fragment = {
  __typename: 'NoteTakerStepQL';
  id: string;
  nextStepId?: string | null;
  finishedSpeech: string;
  noteTakerId?: string | null;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_OperatorAgentStepQl_Fragment = {
  __typename: 'OperatorAgentStepQL';
  id: string;
  nextStepId?: string | null;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  operator?: { __typename?: 'OperatorQL'; id: string; name: string } | null;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_PickupStepQl_Fragment = {
  __typename: 'PickupStepQL';
  id: string;
  callerRecognizedStepId?: string | null;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_PressAnyKeyStepQl_Fragment = {
  __typename: 'PressAnyKeyStepQL';
  afterHoursSpeech: string;
  renderedAfterHoursSpeech: string;
  renderedOptinTextMessage?: string | null;
  renderedAfterHoursTextMessage?: string | null;
  optinTextMessage?: string | null;
  useAfterHoursTextMessage: boolean;
  afterHoursTextMessage?: string | null;
  useCustomAudio: boolean;
  useCustomAudioForAfterHours: boolean;
  id: string;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_QualifyStepQl_Fragment = {
  __typename: 'QualifyStepQL';
  onHasResponseId?: string | null;
  onNoResponseId?: string | null;
  shorthandPrompt: string;
  acknowledgementSpeech: string;
  id: string;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_QuestionBotStepQl_Fragment = {
  __typename: 'QuestionBotStepQL';
  id: string;
  nextStepId?: string | null;
  finishedSpeech: string;
  questionAgentSettingsId?: string | null;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_SmartTopicStepQl_Fragment = {
  __typename: 'SmartTopicStepQL';
  id: string;
  llmPromptOverride?: string | null;
  llmModelOverride?: string | null;
  purpose?: string | null;
  additionalContext: string;
  acknowledgementSpeech: string;
  noMatchStepId?: string | null;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  topics: Array<{
    __typename?: 'SmartTopicLinksQL';
    id: string;
    topic: string;
    nextStepId?: string | null;
    order: number;
  }>;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_SpeakStepQl_Fragment = {
  __typename: 'SpeakStepQL';
  id: string;
  afterHoursSpeech: string;
  renderedAfterHoursSpeech: string;
  nextStepId?: string | null;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_SpecialQuestionQl_Fragment = {
  __typename: 'SpecialQuestionQL';
  renderedMessageToSend: string;
  messageToSend: string;
  canWeTextSpeech: string;
  onYesCanWeTextSpeech: string;
  onNoCanWeTextSpeech: string;
  onFailCanWeTextSpeech: string;
  clarifyCanWeTextSpeech: string;
  clarifySpeech: string;
  onYesSpeech: string;
  onNoSpeech: string;
  onFailureSpeech: string;
  onYesStepId?: string | null;
  onNoStepId?: string | null;
  onYesButNoTextStepId?: string | null;
  id: string;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_StatusUpdaterStepQl_Fragment = {
  __typename: 'StatusUpdaterStepQL';
  id: string;
  statusGivenStepId?: string | null;
  noStatusGivenStepId?: string | null;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_TextOptinStepQl_Fragment = {
  __typename: 'TextOptinStepQL';
  renderedOptinTextMessage?: string | null;
  renderedAfterHoursTextMessage?: string | null;
  optinTextMessage?: string | null;
  useAfterHoursTextMessage: boolean;
  afterHoursTextMessage?: string | null;
  clarifySpeech: string;
  onYesSpeech: string;
  onNoSpeech: string;
  onFailureSpeech: string;
  onYesStepId?: string | null;
  onNoStepId?: string | null;
  id: string;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

type VoiceStepFields_VoiceScriptStepQl_Fragment = {
  __typename: 'VoiceScriptStepQL';
  id: string;
  canToggle: boolean;
  enabledAfterBusinessHours: boolean;
  enabledDuringBusinessHours: boolean;
  executionOrder: number;
  label: string;
  speech: string;
  renderedSpeech: string;
  stepType: string;
  uiHints?: { __typename?: 'VoiceStepUIHints'; x: number; y: number } | null;
  customAudioOverrides?: {
    __typename?: 'CustomAudioOverrides';
    speech?: string | null;
    afterHoursSpeech?: string | null;
    canWeTextSpeech?: string | null;
    onYesCanWeTextSpeech?: string | null;
    onNoCanWeTextSpeech?: string | null;
    onFailCanWeTextSpeech?: string | null;
    clarifyCanWeTextSpeech?: string | null;
    clarifySpeech?: string | null;
    onYesSpeech?: string | null;
    onNoSpeech?: string | null;
    onFailureSpeech?: string | null;
    noAnswerSpeech?: string | null;
    disclosureContent?: string | null;
  } | null;
};

export type VoiceStepFieldsFragment =
  | VoiceStepFields_AppointmentAgentStepQl_Fragment
  | VoiceStepFields_AskYesNoQuestionStepQl_Fragment
  | VoiceStepFields_AutoAssignStepQl_Fragment
  | VoiceStepFields_CallForwardingStepQl_Fragment
  | VoiceStepFields_CallRecordingStepQl_Fragment
  | VoiceStepFields_CheckBusinessHoursStepQl_Fragment
  | VoiceStepFields_CheckForLabelStepQl_Fragment
  | VoiceStepFields_ConversationStateStepQl_Fragment
  | VoiceStepFields_ConversationalSchedulingAgentStepQl_Fragment
  | VoiceStepFields_GreetingStepQl_Fragment
  | VoiceStepFields_IntentQuestionQl_Fragment
  | VoiceStepFields_LabelConversationStepQl_Fragment
  | VoiceStepFields_NoteTakerStepQl_Fragment
  | VoiceStepFields_OperatorAgentStepQl_Fragment
  | VoiceStepFields_PickupStepQl_Fragment
  | VoiceStepFields_PressAnyKeyStepQl_Fragment
  | VoiceStepFields_QualifyStepQl_Fragment
  | VoiceStepFields_QuestionBotStepQl_Fragment
  | VoiceStepFields_SmartTopicStepQl_Fragment
  | VoiceStepFields_SpeakStepQl_Fragment
  | VoiceStepFields_SpecialQuestionQl_Fragment
  | VoiceStepFields_StatusUpdaterStepQl_Fragment
  | VoiceStepFields_TextOptinStepQl_Fragment
  | VoiceStepFields_VoiceScriptStepQl_Fragment;

export type AppointmentFieldsFragment = {
  __typename?: 'AppointmentQL';
  id: string;
  state: AppointmentState;
  createdOn: any;
  expiresAt?: any | null;
  appointmentDate?: any | null;
  appointmentId?: string | null;
  externalServiceAdvisorName?: string | null;
  externalServiceAdvisorId?: string | null;
  enrichedFrom?: AppointmentSource | null;
  feedbackSubmitted?: boolean | null;
  numboxAgentSession?: {
    __typename?: 'NumboxAgentSessionQL';
    id: string;
    slots: any;
    outcome?: SessionOutcome | null;
  } | null;
  dialogFlowBotData?:
    | ({ __typename?: 'DialogFlowBotDataQL' } & DialogFlowBotDataFieldsFragment)
    | null;
};

export type AppointmentAgentSettingsFieldsFragment = {
  __typename?: 'AppointmentAgentSettingsQL';
  settings?: any | null;
  agentProfile?: any | null;
  optionalPrompts?: any | null;
  overallEmphasis: string;
  numaInCallFlow: string;
  webSchedulerReliability: string;
  textingCanWeTextSpeech?: string | null;
  textingOnYesSpeechCanWeText?: string | null;
  textingOnNoSpeechCanWeText?: string | null;
  textingMessageToSend?: string | null;
  textingHangupRecovery?: string | null;
  renderedTextingMessageToSend?: string | null;
  renderedTextingHangupRecovery?: string | null;
  minimumLeadTimeInMinutes: number;
  maximumBookingHorizonInDays: number;
  enableHangupRecovery: boolean;
  defaultExternalOpcode?:
    | ({ __typename?: 'ExternalOpcodeQL' } & ExternalOpcodeFieldsFragment)
    | null;
};

export type AppointmentAgentSettingsPlaceFieldsFragment = {
  __typename?: 'PlaceQL';
  id: string;
  externalPlaceInfo?: {
    __typename?: 'PlaceInfoQL';
    id: string;
    linkGroups: Array<{
      __typename?: 'LinkGroup';
      groupLabel: string;
      links: Array<{
        __typename?: 'Link';
        name: string;
        tag: string;
        url: string;
      }>;
    } | null>;
  } | null;
};

export type AppointmentAgentSettingsActiveIntegrationFieldsFragment = {
  __typename?: 'ActiveIntegrationQL';
  id: string;
  pendingOpcodeSync: boolean;
  integrationId: string;
};

type AttachmentItemFields_AssignmentDetailsAttachment_Fragment = {
  __typename: 'AssignmentDetailsAttachment';
  id: string;
  attachmentType: string;
};

type AttachmentItemFields_FileAttachment_Fragment = {
  __typename: 'FileAttachment';
  id: string;
  attachmentType: string;
  filename: string;
  sizeBytes: string;
  url: string;
  words?: any | null;
};

type AttachmentItemFields_ImageAttachment_Fragment = {
  __typename: 'ImageAttachment';
  id: string;
  attachmentType: string;
  width?: number | null;
  height?: number | null;
  url: string;
};

type AttachmentItemFields_MultiChoiceAttachment_Fragment = {
  __typename: 'MultiChoiceAttachment';
  id: string;
  attachmentType: string;
};

type AttachmentItemFields_NoteAttachment_Fragment = {
  __typename: 'NoteAttachment';
  id: string;
  attachmentType: string;
};

type AttachmentItemFields_OpenVoiceQuestionAttachment_Fragment = {
  __typename: 'OpenVoiceQuestionAttachment';
  id: string;
  attachmentType: string;
  words?: any | null;
  url: string;
  shorthandPrompt: string;
};

type AttachmentItemFields_ReviewAttachment_Fragment = {
  __typename: 'ReviewAttachment';
  id: string;
  attachmentType: string;
  review?: {
    __typename?: 'ReviewQL';
    reviewMode: ReviewMode;
    feedback?: Array<{
      __typename?: 'ReviewFeedbackQL';
      id: string;
      opened?: any | null;
    } | null> | null;
  } | null;
};

type AttachmentItemFields_SmartTopicAttachment_Fragment = {
  __typename: 'SmartTopicAttachment';
  id: string;
  attachmentType: string;
  prompt?: string | null;
  transcript?: string | null;
  rationale?: string | null;
  outcome?: string | null;
};

type AttachmentItemFields_TranslatedMessage_Fragment = {
  __typename: 'TranslatedMessage';
  id: string;
  attachmentType: string;
  text?: string | null;
  language?: string | null;
  fieldName?: string | null;
};

type AttachmentItemFields_VCardAttachment_Fragment = {
  __typename: 'VCardAttachment';
  id: string;
  attachmentType: string;
  filename: string;
  sizeBytes: string;
  url: string;
  message?: {
    __typename?: 'MessageQL';
    place: { __typename?: 'PlaceQL'; name: string; externalName: string };
  } | null;
};

type AttachmentItemFields_VideoUploadLinkAttachment_Fragment = {
  __typename: 'VideoUploadLinkAttachment';
  id: string;
  attachmentType: string;
  videoUploadLinkId: string;
  videoMicrositeLinkId?: string | null;
};

type AttachmentItemFields_YelpAttachment_Fragment = {
  __typename: 'YelpAttachment';
  id: string;
  attachmentType: string;
  url: string;
};

export type AttachmentItemFieldsFragment =
  | AttachmentItemFields_AssignmentDetailsAttachment_Fragment
  | AttachmentItemFields_FileAttachment_Fragment
  | AttachmentItemFields_ImageAttachment_Fragment
  | AttachmentItemFields_MultiChoiceAttachment_Fragment
  | AttachmentItemFields_NoteAttachment_Fragment
  | AttachmentItemFields_OpenVoiceQuestionAttachment_Fragment
  | AttachmentItemFields_ReviewAttachment_Fragment
  | AttachmentItemFields_SmartTopicAttachment_Fragment
  | AttachmentItemFields_TranslatedMessage_Fragment
  | AttachmentItemFields_VCardAttachment_Fragment
  | AttachmentItemFields_VideoUploadLinkAttachment_Fragment
  | AttachmentItemFields_YelpAttachment_Fragment;

type ChannelFields_BandwidthChannelQl_Fragment = {
  __typename: 'BandwidthChannelQL';
  id: string;
  isActive: boolean;
  isBotEnabled: boolean;
  identityPromptOption: IdentityPromptOptions;
  place: { __typename?: 'PlaceQL'; id: string; name: string };
};

type ChannelFields_BaseChannel_Fragment = {
  __typename: 'BaseChannel';
  id: string;
  isActive: boolean;
  isBotEnabled: boolean;
  identityPromptOption: IdentityPromptOptions;
  place: { __typename?: 'PlaceQL'; id: string; name: string };
};

type ChannelFields_FacebookChannelQl_Fragment = {
  __typename: 'FacebookChannelQL';
  name?: string | null;
  id: string;
  isActive: boolean;
  isBotEnabled: boolean;
  identityPromptOption: IdentityPromptOptions;
  place: { __typename?: 'PlaceQL'; id: string; name: string };
};

type ChannelFields_GoogleChannelQl_Fragment = {
  __typename: 'GoogleChannelQL';
  id: string;
  isActive: boolean;
  isBotEnabled: boolean;
  identityPromptOption: IdentityPromptOptions;
  place: { __typename?: 'PlaceQL'; id: string; name: string };
};

type ChannelFields_NoteChannelQl_Fragment = {
  __typename: 'NoteChannelQL';
  id: string;
  isActive: boolean;
  isBotEnabled: boolean;
  identityPromptOption: IdentityPromptOptions;
  place: { __typename?: 'PlaceQL'; id: string; name: string };
};

type ChannelFields_NumboxChannelQl_Fragment = {
  __typename: 'NumboxChannelQL';
  id: string;
  isActive: boolean;
  isBotEnabled: boolean;
  identityPromptOption: IdentityPromptOptions;
  place: { __typename?: 'PlaceQL'; id: string; name: string };
};

type ChannelFields_TwilioChannelQl_Fragment = {
  __typename: 'TwilioChannelQL';
  mdn: string;
  sid?: string | null;
  outboundSmsMdn?: string | null;
  sendOutboundsWithShadowTollfree: boolean;
  shadowTollfreePhonenumber?: string | null;
  shadowTollfreeSid?: string | null;
  accountSid: string;
  respectExistingAssignments?: boolean | null;
  archiveMissedCalls?: boolean | null;
  autoSendHangupReplies?: boolean | null;
  hangupSuggestion?: string | null;
  phoneLinePolicyId: string;
  id: string;
  isActive: boolean;
  isBotEnabled: boolean;
  identityPromptOption: IdentityPromptOptions;
  assignee?: ({ __typename?: 'UserQL' } & UserItemFieldsFragment) | null;
  team?: ({ __typename?: 'TeamQL' } & TeamFieldsFragment) | null;
  place: { __typename?: 'PlaceQL'; id: string; name: string };
};

export type ChannelFieldsFragment =
  | ChannelFields_BandwidthChannelQl_Fragment
  | ChannelFields_BaseChannel_Fragment
  | ChannelFields_FacebookChannelQl_Fragment
  | ChannelFields_GoogleChannelQl_Fragment
  | ChannelFields_NoteChannelQl_Fragment
  | ChannelFields_NumboxChannelQl_Fragment
  | ChannelFields_TwilioChannelQl_Fragment;

export type ConversationItemStubFragment = {
  __typename?: 'ConversationQL';
  id: string;
  state: ConversationState;
  inboxId: string;
  lastUpdated?: any | null;
  waitingSince?: any | null;
};

export type ConversationItemFieldsFragment = {
  __typename?: 'ConversationQL';
  language?: string | null;
  serverGeneratedPreview: boolean;
  id: string;
  inboxId: string;
  lastUpdated?: any | null;
  waitingSince?: any | null;
  isOverdue?: boolean | null;
  snoozedUntil?: any | null;
  state: ConversationState;
  amIMentioned: boolean;
  isMentionedConversation: boolean;
  lastMentionedTimestamp?: any | null;
  mentionedPreview?: string | null;
  mentionedDisplayName?: string | null;
  escalated?: any | null;
  source?: string | null;
  optInStatus: ConversationOptInStatus;
  hasRecentHeatCase?: boolean | null;
  place: {
    __typename?: 'PlaceQL';
    id: string;
    name: string;
    primaryMdn?: string | null;
  };
  participant: { __typename?: 'ParticipantQL' } & ParticipantFieldsFragment;
  previewData: {
    __typename?: 'ConversationPreviewContentQL';
    preview: string;
    previewFormat: string;
    previewIsInbound: boolean;
    previewServerGenerated: boolean;
    previewDisplayName: string;
    previewSource: string;
    subPreview: string;
    subPreviewFormat: string;
    subPreviewDisplayName: string;
    previewMentions: Array<{
      __typename?: 'MentionQL';
      userId?: string | null;
      tag: string;
    }>;
    subPreviewMentions: Array<{
      __typename?: 'MentionQL';
      userId?: string | null;
      tag: string;
    }>;
  };
  assignee?: ({ __typename?: 'UserQL' } & UserItemFieldsFragment) | null;
  lastMessage?:
    | ({ __typename?: 'MessageQL' } & MessageItemFieldsFragment)
    | null;
  lastAppointment?:
    | ({ __typename?: 'AppointmentQL' } & AppointmentFieldsFragment)
    | null;
  lastChannel?:
    | { __typename?: 'BandwidthChannelQL'; id: string }
    | { __typename?: 'BaseChannel'; id: string }
    | { __typename?: 'FacebookChannelQL'; id: string }
    | { __typename?: 'GoogleChannelQL'; id: string }
    | { __typename?: 'NoteChannelQL'; id: string }
    | { __typename?: 'NumboxChannelQL'; id: string }
    | { __typename?: 'TwilioChannelQL'; id: string }
    | null;
  lastRepairOrder?:
    | ({
        __typename?: 'BaseRepairOrder';
        statusItem?: {
          __typename?: 'StatusItemQL';
          id: string;
          status: StatusItemStatus;
          lastUpdateTime?: any | null;
          color: StatusItemColor;
        } | null;
      } & RepairOrderFields_BaseRepairOrder_Fragment)
    | ({
        __typename?: 'RepairOrderFortellisQL';
        statusItem?: {
          __typename?: 'StatusItemQL';
          id: string;
          status: StatusItemStatus;
          lastUpdateTime?: any | null;
          color: StatusItemColor;
        } | null;
      } & RepairOrderFields_RepairOrderFortellisQl_Fragment)
    | null;
  lastEngagement?: {
    __typename?: 'EngagementQL';
    id: string;
    summary?: string | null;
    summaryId?: string | null;
    status?: string | null;
    mySummaryRating?: {
      __typename?: 'EngagementSummaryRatingQL';
      value: number;
      reason?: string | null;
      details?: string | null;
    } | null;
    myStatusRating?: {
      __typename?: 'EngagementStatusRatingQL';
      value: number;
      reason?: string | null;
      details?: string | null;
    } | null;
    tasks: Array<{
      __typename?: 'TaskQL';
      id: string;
      title: string;
      status: string;
      engagementId?: string | null;
      completedAt?: any | null;
      completionSource?: TaskActionSource | null;
      dismissedAt?: any | null;
      dismissalSource?: TaskActionSource | null;
      expiresAt: any;
      completedByParticipant?: {
        __typename?: 'ParticipantQL';
        displayName: string;
      } | null;
      dismissedByParticipant?: {
        __typename?: 'ParticipantQL';
        displayName: string;
      } | null;
      recommendedActions?: Array<{
        __typename?: 'TaskActionQL';
        type: string;
        actionData: any;
      }> | null;
    }>;
  } | null;
  conversationLabels?: Array<
    { __typename?: 'ConversationLabelQL' } & ConversationLabelFieldsFragment
  > | null;
  team?: ({ __typename?: 'TeamQL' } & TeamFieldsFragment) | null;
};

export type DialogFlowBotDataFieldsFragment = {
  __typename?: 'DialogFlowBotDataQL';
  id: string;
  conversationId: string;
  data: any;
  appointmentWasBooked: boolean;
  outcome?: DialogflowOutcome | null;
  agentReason?: DialogflowAgentReason | null;
  agentDuration: number;
  customerInDms?: boolean | null;
};

export type ExternalOpcodeFieldsFragment = {
  __typename?: 'ExternalOpcodeQL';
  id: string;
  dmsId: string;
  serviceName: string;
};

export type LabelFieldsFragment = {
  __typename?: 'LabelQL';
  id: string;
  placeId: string;
  category: LabelCategory;
  name: string;
  color: string;
  icon?: string | null;
  iconType?: string | null;
  hidden: boolean;
  expirationHours?: number | null;
  archived: boolean;
};

export type ConversationLabelFieldsFragment = {
  __typename?: 'ConversationLabelQL';
  id: string;
  createdOn: any;
  expiresAt?: any | null;
  hidden: boolean;
  label: { __typename?: 'LabelQL' } & LabelFieldsFragment;
  participant: {
    __typename?: 'ParticipantQL';
    id: string;
    displayName: string;
  };
};

export type LabelStubFieldsFragment = {
  __typename?: 'LabelQL';
  id: string;
  category: LabelCategory;
  name: string;
};

export type ConversationLabelStubFieldsFragment = {
  __typename?: 'ConversationLabelQL';
  id: string;
  label: { __typename?: 'LabelQL' } & LabelStubFieldsFragment;
};

export type MessageItemFieldsFragment = {
  __typename?: 'MessageQL';
  id: string;
  canTeachNuma?: boolean | null;
  intentDisplayName?: string | null;
  intentId?: string | null;
  channelId: string;
  title?: string | null;
  deliveryStatus: Delivery_Status;
  deliveryError?: number | null;
  isInbound: boolean;
  isSuggestion?: boolean | null;
  messageFormat: Message_Format;
  content: string;
  timestamp?: any | null;
  capsLockFixed: boolean;
  loggedCallInteraction?: LoggedCallInteraction | null;
  isHeatCase?: boolean | null;
  mentions: Array<{
    __typename?: 'MentionQL';
    userId?: string | null;
    tag: string;
  }>;
  attachments: Array<
    | ({
        __typename?: 'AssignmentDetailsAttachment';
      } & AttachmentItemFields_AssignmentDetailsAttachment_Fragment)
    | ({
        __typename?: 'FileAttachment';
      } & AttachmentItemFields_FileAttachment_Fragment)
    | ({
        __typename?: 'ImageAttachment';
      } & AttachmentItemFields_ImageAttachment_Fragment)
    | ({
        __typename?: 'MultiChoiceAttachment';
      } & AttachmentItemFields_MultiChoiceAttachment_Fragment)
    | ({
        __typename?: 'NoteAttachment';
      } & AttachmentItemFields_NoteAttachment_Fragment)
    | ({
        __typename?: 'OpenVoiceQuestionAttachment';
      } & AttachmentItemFields_OpenVoiceQuestionAttachment_Fragment)
    | ({
        __typename?: 'ReviewAttachment';
      } & AttachmentItemFields_ReviewAttachment_Fragment)
    | ({
        __typename?: 'SmartTopicAttachment';
      } & AttachmentItemFields_SmartTopicAttachment_Fragment)
    | ({
        __typename?: 'TranslatedMessage';
      } & AttachmentItemFields_TranslatedMessage_Fragment)
    | ({
        __typename?: 'VCardAttachment';
      } & AttachmentItemFields_VCardAttachment_Fragment)
    | ({
        __typename?: 'VideoUploadLinkAttachment';
      } & AttachmentItemFields_VideoUploadLinkAttachment_Fragment)
    | ({
        __typename?: 'YelpAttachment';
      } & AttachmentItemFields_YelpAttachment_Fragment)
  >;
  sender: {
    __typename?: 'ParticipantQL';
    id: string;
    address: string;
    firstName?: string | null;
    lastName?: string | null;
    source: Source_Types;
    displayName: string;
    displayNameConfidence: ParticipantDataConfidence;
  };
  conversation: {
    __typename?: 'ConversationQL';
    id: string;
    lastAppointment?: {
      __typename?: 'AppointmentQL';
      state: AppointmentState;
      feedbackSubmitted?: boolean | null;
      numboxAgentSession?: {
        __typename?: 'NumboxAgentSessionQL';
        id: string;
        outcome?: SessionOutcome | null;
      } | null;
    } | null;
  };
  reasonSent?:
    | ({
        __typename?: 'ReasonSentGreetingQL';
      } & ReasonSentFields_ReasonSentGreetingQl_Fragment)
    | ({
        __typename?: 'ReasonSentHangupResponseQL';
      } & ReasonSentFields_ReasonSentHangupResponseQl_Fragment)
    | ({
        __typename?: 'ReasonSentIntentQL';
      } & ReasonSentFields_ReasonSentIntentQl_Fragment)
    | null;
  call?: ({ __typename?: 'PhoneCallQL' } & PhoneCallFieldsFragment) | null;
  outboundProxyCall?: {
    __typename?: 'OutboundProxyCallQL';
    id: string;
    endtime?: any | null;
    startTime?: any | null;
    callStatus?: string | null;
    callDuration?: number | null;
    transcript?: {
      __typename?: 'TranscriptQL';
      id: string;
      subject?: string | null;
      summary?: string | null;
      events: Array<{
        __typename?: 'TranscriptEventQL';
        id: string;
        type: TranscriptEventType;
      }>;
      analysis?:
        | ({
            __typename?: 'TranscriptAnalysisQL';
          } & TranscriptAnalysisFieldsFragment)
        | null;
    } | null;
    callRecording?: {
      __typename?: 'CallRecordingQL';
      id: string;
      url?: string | null;
    } | null;
  } | null;
  outboundConferenceCall?:
    | ({
        __typename?: 'OutboundConferenceCallQL';
      } & OutboundConferenceCallFieldsFragment)
    | null;
  repairOrder?:
    | ({
        __typename?: 'BaseRepairOrder';
      } & RepairOrderFields_BaseRepairOrder_Fragment)
    | ({
        __typename?: 'RepairOrderFortellisQL';
      } & RepairOrderFields_RepairOrderFortellisQl_Fragment)
    | null;
  paymentRequest?:
    | ({ __typename?: 'PaymentRequestQL' } & PaymentRequestFieldsFragment)
    | null;
  dialogFlowBotData?:
    | ({ __typename?: 'DialogFlowBotDataQL' } & DialogFlowBotDataFieldsFragment)
    | null;
  numboxAgentSession?:
    | ({
        __typename?: 'NumboxAgentSessionQL';
      } & NumboxAgentSessionFieldsFragment)
    | null;
  qualificationSurvey?:
    | ({
        __typename?: 'QualificationSurveyQL';
      } & QualificationSurveyFieldsFragment)
    | null;
};

export type NoteTakerFieldsFragment = {
  __typename?: 'NoteTakerQL';
  id: string;
  name: string;
  settings: any;
  placeId: string;
};

export type NumboxAgentSessionFieldsFragment = {
  __typename?: 'NumboxAgentSessionQL';
  id: string;
  slots: any;
  outcome?: SessionOutcome | null;
  summary?: string | null;
  appointment?: {
    __typename?: 'AppointmentQL';
    id: string;
    state: AppointmentState;
  } | null;
};

export type OutboundConferenceCallFieldsFragment = {
  __typename?: 'OutboundConferenceCallQL';
  id: string;
  createdOn: any;
  conversationId: string;
  outboundCallSid?: string | null;
  hostMdn: string;
  recipientMdn: string;
  recipientDisplayName: string;
  endTime?: any | null;
  startTime?: any | null;
  callStatus?: string | null;
  callDuration?: number | null;
  isBeingRecorded: boolean;
  hasCallAssist: boolean;
  answeredByVoicemail?: boolean | null;
  hostConnectedTo?: string | null;
  caller: { __typename?: 'UserQL'; id: string; displayName: string };
  transcript?: {
    __typename?: 'TranscriptQL';
    id: string;
    subject?: string | null;
    summary?: string | null;
    events: Array<{
      __typename?: 'TranscriptEventQL';
      id: string;
      type: TranscriptEventType;
    }>;
    analysis?:
      | ({
          __typename?: 'TranscriptAnalysisQL';
        } & TranscriptAnalysisFieldsFragment)
      | null;
  } | null;
  callRecording?: {
    __typename?: 'CallRecordingQL';
    id: string;
    url?: string | null;
  } | null;
};

export type ParticipantFieldsFragment = {
  __typename?: 'ParticipantQL';
  id: string;
  address: string;
  displayName: string;
  displayNameConfidence: ParticipantDataConfidence;
  source: Source_Types;
  avatarUrl?: string | null;
  comment?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  spamStatus: SpamStatus;
  customerCount: number;
  language?: Language | null;
  crmContacts?: Array<{
    __typename?: 'CrmContactQL';
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    companyName?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    contactType?: CrmContactType | null;
  } | null> | null;
  latestCustomer?: {
    __typename?: 'CustomerQL';
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    displayName?: string | null;
    addresses?: Array<{
      __typename?: 'AddressQL';
      id: string;
      address?: string | null;
      mediumType?: string | null;
      isPrimary?: boolean | null;
      isActive?: boolean | null;
      deletedAt?: any | null;
      sourceEntityId?: string | null;
      sourceEntityType?: string | null;
    } | null> | null;
  } | null;
};

export type PaymentRequestStubFieldsFragment = {
  __typename?: 'PaymentRequestQL';
  id: string;
  encodedId: string;
  status: PaymentRequestStatus;
  lastUpdated?: any | null;
  captureMethod: string;
  amount: number;
  amountCaptured: number;
  currency?: Currency | null;
  description?: string | null;
  totalRefundedAmount: number;
  netAmount: number;
  place: { __typename?: 'PlaceQL'; id: string; name: string };
  sender: { __typename?: 'ParticipantQL'; id: string; displayName: string };
  customer: {
    __typename?: 'ParticipantQL';
    id: string;
    displayName: string;
    displayNameConfidence: ParticipantDataConfidence;
    address: string;
    source: Source_Types;
  };
  canceledBy?: {
    __typename?: 'ParticipantQL';
    id: string;
    displayName: string;
  } | null;
  conversation?: { __typename?: 'ConversationQL'; id: string } | null;
};

export type PaymentRequestFieldsFragment = {
  __typename?: 'PaymentRequestQL';
  id: string;
  encodedId: string;
  captureMethod: string;
  amount: number;
  amountCaptured: number;
  currency?: Currency | null;
  applicationId?: string | null;
  description?: string | null;
  note?: string | null;
  orderId?: string | null;
  status: PaymentRequestStatus;
  lastUpdated?: any | null;
  createdOn: any;
  lastOpened?: any | null;
  charged?: any | null;
  requested?: any | null;
  canceledAt?: any | null;
  cancellationReason?: PaymentCancellationReason | null;
  holdExpiration?: any | null;
  billingName?: string | null;
  billingAddress?: string | null;
  billingEmail?: string | null;
  billingMethod?: string | null;
  billingLastFourDigits?: string | null;
  totalRefundedAmount: number;
  netAmount: number;
  failureCode?: string | null;
  failureMessage?: string | null;
  outcomeSellerMessage?: string | null;
  outcomeType?: string | null;
  outcomeReason?: string | null;
  stripeUrl?: string | null;
  receiptUrl?: string | null;
  attachmentUrl?: string | null;
  attachmentFilename?: string | null;
  refunds?: Array<{
    __typename?: 'RefundQL';
    id: string;
    completedOn?: any | null;
    status: RefundStatus;
    amount: number;
    netAmount: number;
    type: RefundType;
    reason?: RefundReason | null;
    note?: string | null;
    issuer?: {
      __typename?: 'ParticipantQL';
      id: string;
      displayName: string;
    } | null;
  }> | null;
  disputes?: Array<{
    __typename?: 'DisputeQL';
    id: string;
    reason: string;
    status: string;
  }> | null;
  place: { __typename?: 'PlaceQL'; id: string; name: string };
  sender: { __typename?: 'ParticipantQL'; id: string; displayName: string };
  customer: {
    __typename?: 'ParticipantQL';
    id: string;
    displayName: string;
    displayNameConfidence: ParticipantDataConfidence;
    address: string;
    source: Source_Types;
  };
  canceledBy?: {
    __typename?: 'ParticipantQL';
    id: string;
    displayName: string;
  } | null;
  conversation?: { __typename?: 'ConversationQL'; id: string } | null;
};

export type PhoneCallFieldsFragment = {
  __typename?: 'PhoneCallQL';
  id: string;
  callDuration?: number | null;
  isActive?: boolean | null;
  endtime?: any | null;
  startTime?: any | null;
  conversationId: string;
  hasReturnCallsRouting: boolean;
  isBeingRecorded: boolean;
  returnCallsRoutingOutcome?: PhoneCallReturnCallOutcome | null;
  returnCallsRoutedTo?: string | null;
  transcript?: {
    __typename?: 'TranscriptQL';
    id: string;
    subject?: string | null;
    summary?: string | null;
    events: Array<{
      __typename?: 'TranscriptEventQL';
      id: string;
      type: TranscriptEventType;
    }>;
    analysis?:
      | ({
          __typename?: 'TranscriptAnalysisQL';
        } & TranscriptAnalysisFieldsFragment)
      | null;
  } | null;
  returnCallsRoutedUser?: {
    __typename?: 'UserQL';
    id: string;
    displayName: string;
  } | null;
  participant: {
    __typename?: 'ParticipantQL';
    id: string;
    address: string;
    displayName: string;
  };
  redirectedFrom?: {
    __typename?: 'ParticipantQL';
    id: string;
    address: string;
    displayName: string;
  } | null;
  callRecording?: {
    __typename?: 'CallRecordingQL';
    id: string;
    url?: string | null;
  } | null;
};

export type QualificationSurveyFieldsFragment = {
  __typename?: 'QualificationSurveyQL';
  id: string;
  buyoutAmountRange?: string | null;
  condition?: string | null;
  currentLoanAmountRange?: string | null;
  interestedInTrading?: boolean | null;
  leaseRemainingTimeRange?: string | null;
  ownershipStatus?: string | null;
  score?: number | null;
  equityTradeOpportunity?: {
    __typename?: 'EquityTradeOpportunityQL';
    id: string;
    stage: EquityTradeOpportunityStage;
    status?: string | null;
    closedByParticipant?: {
      __typename?: 'ParticipantQL';
      id: string;
      displayName: string;
    } | null;
  } | null;
};

type ReasonSentFields_ReasonSentGreetingQl_Fragment = {
  __typename: 'ReasonSentGreetingQL';
  kind: ReplyReason;
  name: string;
};

type ReasonSentFields_ReasonSentHangupResponseQl_Fragment = {
  __typename: 'ReasonSentHangupResponseQL';
  kind: ReplyReason;
};

type ReasonSentFields_ReasonSentIntentQl_Fragment = {
  __typename: 'ReasonSentIntentQL';
  kind: ReplyReason;
  intent: {
    __typename?: 'AppliedIntentQL';
    name?: string | null;
    displayName?: string | null;
  };
};

export type ReasonSentFieldsFragment =
  | ReasonSentFields_ReasonSentGreetingQl_Fragment
  | ReasonSentFields_ReasonSentHangupResponseQl_Fragment
  | ReasonSentFields_ReasonSentIntentQl_Fragment;

type RepairOrderFields_BaseRepairOrder_Fragment = {
  __typename?: 'BaseRepairOrder';
  id: string;
  repairOrderType: RepairOrderType;
  status: RepairOrderStatus;
  createdOn: any;
  orderNumber?: string | null;
  tagNumber?: string | null;
  completedTime?: any | null;
  openedTime?: any | null;
  dmsStatus?: string | null;
  promisedTime?: any | null;
  transportationFlags?: any | null;
  lastDmsUpdate?: any | null;
  serviceAdvisorName?: string | null;
  vehicleMakeFriendly?: string | null;
  vehicleModelFriendly?: string | null;
  vehicleVin?: string | null;
  vehicleYear?: number | null;
  serviceAdvisor?: {
    __typename?: 'ServiceAdvisorQL';
    serviceAdvisorId?: string | null;
    name?: string | null;
  } | null;
};

type RepairOrderFields_RepairOrderFortellisQl_Fragment = {
  __typename?: 'RepairOrderFortellisQL';
  id: string;
  repairOrderType: RepairOrderType;
  status: RepairOrderStatus;
  createdOn: any;
  orderNumber?: string | null;
  tagNumber?: string | null;
  completedTime?: any | null;
  openedTime?: any | null;
  dmsStatus?: string | null;
  promisedTime?: any | null;
  transportationFlags?: any | null;
  lastDmsUpdate?: any | null;
  serviceAdvisorName?: string | null;
  vehicleMakeFriendly?: string | null;
  vehicleModelFriendly?: string | null;
  vehicleVin?: string | null;
  vehicleYear?: number | null;
  serviceAdvisor?: {
    __typename?: 'ServiceAdvisorQL';
    serviceAdvisorId?: string | null;
    name?: string | null;
  } | null;
};

export type RepairOrderFieldsFragment =
  | RepairOrderFields_BaseRepairOrder_Fragment
  | RepairOrderFields_RepairOrderFortellisQl_Fragment;

export type SkuEntitlementsFieldsFragment = {
  __typename?: 'SkuEntitlementsQL';
  assignments?: boolean | null;
  translation?: boolean | null;
  escalations?: boolean | null;
  assignmentRouting?: boolean | null;
  awayMode?: boolean | null;
};

export type TranscriptAnalysisFieldsFragment = {
  __typename?: 'TranscriptAnalysisQL';
  id: string;
  timestamp: any;
  callType?: string | null;
  subject?: string | null;
  summary?: string | null;
  nextSteps?: string | null;
  coachingTip?: string | null;
  coachingSample?: string | null;
  sections?: Array<{
    __typename?: 'TranscriptSectionQL';
    id: string;
    name: string;
    timestamp: any;
  }> | null;
  scores?: Array<{
    __typename?: 'TranscriptScoreQL';
    id: string;
    name: string;
    rating: number;
    description: string;
  }> | null;
};

export type UserItemFieldsFragment = {
  __typename?: 'UserQL';
  id: string;
  email?: string | null;
  fullName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
};

export type UserItemAndNotificationFieldsFragment = {
  __typename?: 'UserQL';
  id: string;
  email?: string | null;
  fullName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  mdn?: string | null;
  emailOnAssignment: boolean;
  emailNotificationSetting: EmailNotificationSettings;
  pushNotificationSetting: PushNotificationSettings;
  browserNotificationSetting: PushNotificationSettingsInput;
  assignmentClaimSetting: AssignmentClaimSettings;
  swipeRightSetting: Array<SwipeActions | null>;
  swipeLeftSetting: Array<SwipeActions | null>;
};

export type UserDetailFieldsFragment = {
  __typename?: 'UserQL';
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  accountStatus?: string | null;
  placesUsers?: Array<{
    __typename?: 'PlacesUsersQL';
    role: string;
  } | null> | null;
};

export type VideoUploadLinkFieldsFragment = {
  __typename?: 'VideoUploadLinkQL';
  id: string;
  createdOn: any;
  status: VideoUploadStatus;
  placeId: string;
  externalId: string;
  uploadUrl: string;
  fileName?: string | null;
  fileSize?: number | null;
  note?: string | null;
  readyToStream: boolean;
  duration?: number | null;
  thumbnailUrl?: string | null;
  previewUrl?: string | null;
  playbackHls?: string | null;
  hasBeenSent: boolean;
  uploader?: {
    __typename?: 'ParticipantQL';
    id: string;
    displayName: string;
  } | null;
  participant?: {
    __typename?: 'ParticipantQL';
    id: string;
    displayName: string;
    displayNameConfidence: ParticipantDataConfidence;
    address: string;
    source: Source_Types;
  } | null;
};

export type ForceActiveIntegrationSyncMutationVariables = Exact<{
  input: ForceActiveIntegrationSyncInput;
}>;

export type ForceActiveIntegrationSyncMutation = {
  __typename?: 'Mutations';
  forceActiveIntegrationSync?: {
    __typename?: 'ForceActiveIntegrationSync';
    activeIntegration?: {
      __typename?: 'ActiveIntegrationQL';
      id: string;
    } | null;
  } | null;
};

export type AddAnsweringScriptToPolicyMutationVariables = Exact<{
  input: AddAnsweringScriptToPolicyInput;
}>;

export type AddAnsweringScriptToPolicyMutation = {
  __typename?: 'Mutations';
  addAnsweringScriptToPolicy?: {
    __typename?: 'AddAnsweringScriptToPolicy';
    phoneLinePolicy?: {
      __typename?: 'PhoneLinePolicyQL';
      id: string;
      answeringScripts: Array<{
        __typename?: 'AnsweringScriptsQL';
        id: string;
        scriptType: AnsweringScriptType;
        order: number;
      }>;
    } | null;
  } | null;
};

export type AddAutomationExitTriggerMutationVariables = Exact<{
  input: AddAutomationExitTriggerInput;
}>;

export type AddAutomationExitTriggerMutation = {
  __typename?: 'Mutations';
  addAutomationExitTrigger?: {
    __typename?: 'AddAutomationExitTrigger';
    automation?:
      | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
      | null;
  } | null;
};

export type AddLabelToConversationMutationVariables = Exact<{
  input: AddLabelToConversationInput;
  withLastAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  withLastChannel?: InputMaybe<Scalars['Boolean']['input']>;
  withLastRepairOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AddLabelToConversationMutation = {
  __typename?: 'Mutations';
  addLabelToConversation?: {
    __typename?: 'AddLabelToConversation';
    conversationLabel: {
      __typename?: 'ConversationLabelQL';
    } & ConversationLabelFieldsFragment;
    conversation: {
      __typename?: 'ConversationQL';
    } & ConversationItemFieldsFragment;
  } | null;
};

export type AddCustomLinkMutationVariables = Exact<{
  input?: InputMaybe<AddCustomLinkInput>;
}>;

export type AddCustomLinkMutation = {
  __typename?: 'Mutations';
  addCustomLink?: {
    __typename?: 'AddCustomLink';
    placeInfo?: {
      __typename?: 'PlaceInfoQL';
      id: string;
      linkGroups: Array<{
        __typename?: 'LinkGroup';
        groupLabel: string;
        links: Array<{
          __typename?: 'Link';
          name: string;
          tag: string;
          url: string;
        }>;
      } | null>;
    } | null;
  } | null;
};

export type CreateNoteTakerMutationVariables = Exact<{
  input: CreateNoteTakerInput;
}>;

export type CreateNoteTakerMutation = {
  __typename?: 'Mutations';
  createNoteTaker?: {
    __typename?: 'CreateNoteTaker';
    noteTaker?:
      | ({ __typename?: 'NoteTakerQL' } & NoteTakerFieldsFragment)
      | null;
  } | null;
};

export type AddPlaceGroupMutationVariables = Exact<{
  input: AddPlaceGroupInput;
}>;

export type AddPlaceGroupMutation = {
  __typename?: 'Mutations';
  addPlaceGroup?: {
    __typename?: 'AddPlaceGroup';
    placeGroup?: {
      __typename: 'PlaceGroupQL';
      id: string;
      name: string;
      account: { __typename?: 'AccountQL'; id: string; name: string };
    } | null;
  } | null;
};

export type AddStatusItemMutationVariables = Exact<{
  input?: InputMaybe<AddStatusItemInput>;
}>;

export type AddStatusItemMutation = {
  __typename?: 'Mutations';
  addStatusItem?: {
    __typename?: 'AddStatusItem';
    statusItem?:
      | ({ __typename?: 'StatusItemQL' } & StatusItemDetailsFragment)
      | null;
  } | null;
};

export type AddVoiceStepMutationVariables = Exact<{
  input: AddVoiceStepInput;
}>;

export type AddVoiceStepMutation = {
  __typename?: 'Mutations';
  addVoiceStep?: {
    __typename?: 'AddVoiceStep';
    voiceScript?:
      | ({ __typename?: 'VoiceScriptQL' } & VoiceScriptFieldsFragment)
      | null;
  } | null;
};

export type ArchiveConversationsMutationVariables = Exact<{
  input: UpdateConversationsInput;
}>;

export type ArchiveConversationsMutation = {
  __typename?: 'Mutations';
  updateConversations?: {
    __typename?: 'UpdateConversations';
    conversations?: Array<
      ({ __typename?: 'ConversationQL' } & ConversationItemStubFragment) | null
    > | null;
  } | null;
};

export type ArchiveMissedCallsMutationVariables = Exact<{
  input: ArchiveMissedCallsInput;
}>;

export type ArchiveMissedCallsMutation = {
  __typename?: 'Mutations';
  archiveMissedCalls?: {
    __typename?: 'ArchiveMissedCalls';
    phoneLinePolicy?: {
      __typename?: 'PhoneLinePolicyQL';
      id: string;
      archiveMissedCalls: boolean;
    } | null;
  } | null;
};

export type AssignConversationsMutationVariables = Exact<{
  input: AssignConversationsInput;
  withLastAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  withLastChannel?: InputMaybe<Scalars['Boolean']['input']>;
  withLastRepairOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AssignConversationsMutation = {
  __typename?: 'Mutations';
  assignConversations?: {
    __typename?: 'AssignConversations';
    conversations?: Array<
      | ({ __typename?: 'ConversationQL' } & ConversationItemFieldsFragment)
      | null
    > | null;
  } | null;
};

export type BulkUpdateSupportedVehiclesMutationVariables = Exact<{
  input: BulkUpdateSupportedVehiclesInput;
}>;

export type BulkUpdateSupportedVehiclesMutation = {
  __typename?: 'Mutations';
  bulkUpdateSupportedVehicles?: {
    __typename?: 'BulkUpdateSupportedVehicles';
    supportedVehicles?: Array<{
      __typename?: 'SupportedVehiclesQL';
      id: string;
      useOverrides: boolean;
      outcome: string;
      repairService: {
        __typename?: 'RepairServiceQL';
        id: string;
        name: string;
        enabledSupportedVehiclesCount: number;
        disabledSupportedVehiclesCount: number;
      };
      firstEnabledOpCode?: {
        __typename?: 'SupportedVehiclesOpcodesQL';
        id: string;
        isEnabled: boolean;
        opCode: {
          __typename?: 'OpCodeQL';
          id: string;
          dmsId: string;
          description: string;
        };
      } | null;
      opCodes: Array<{
        __typename?: 'SupportedVehiclesOpcodesQL';
        id: string;
        isEnabled: boolean;
        opCodeId: string;
      }>;
    }> | null;
  } | null;
};

export type CancelPaymentRequestMutationVariables = Exact<{
  input?: InputMaybe<CancelPaymentRequestInput>;
}>;

export type CancelPaymentRequestMutation = {
  __typename?: 'Mutations';
  cancelPaymentRequest?: {
    __typename?: 'CancelPaymentRequest';
    paymentRequest: {
      __typename?: 'PaymentRequestQL';
    } & PaymentRequestFieldsFragment;
  } | null;
};

export type CancelScheduledMessageMutationVariables = Exact<{
  input: CancelScheduledMessageInput;
}>;

export type CancelScheduledMessageMutation = {
  __typename?: 'Mutations';
  cancelScheduledMessage?: {
    __typename?: 'CancelScheduledMessage';
    scheduledMessage?: {
      __typename?: 'ScheduledMessageQL';
      id: string;
      status: ScheduledMessageStatus;
    } | null;
  } | null;
};

export type CapturePaymentAmountMutationVariables = Exact<{
  input: CapturePaymentAmountInput;
}>;

export type CapturePaymentAmountMutation = {
  __typename?: 'Mutations';
  capturePaymentAmount?: {
    __typename?: 'CapturePaymentAmount';
    paymentRequest: {
      __typename?: 'PaymentRequestQL';
    } & PaymentRequestFieldsFragment;
  } | null;
};

export type ChangeAccountSubscriptionMutationVariables = Exact<{
  input: ChangeAccountSubscriptionInput;
}>;

export type ChangeAccountSubscriptionMutation = {
  __typename?: 'Mutations';
  changeAccountSubscription?: {
    __typename?: 'ChangeAccountSubscription';
    account?: {
      __typename?: 'AccountQL';
      billingIdentity: {
        __typename?: 'BillingIdentityQL';
        id: string;
        subscriptions: Array<{
          __typename?: 'SubscriptionQL';
          id: string;
          available: boolean;
          quantity: number;
          sku: {
            __typename?: 'SkuQL';
            id: string;
            skuType: SkuType;
            isActive: boolean;
            name: string;
          };
        }>;
      };
    } | null;
  } | null;
};

export type ChangeAllowCustomAudioMutationVariables = Exact<{
  input: ChangeAllowCustomAudioInput;
}>;

export type ChangeAllowCustomAudioMutation = {
  __typename?: 'Mutations';
  changeAllowCustomAudio?: {
    __typename?: 'ChangeAllowCustomAudio';
    place?: {
      __typename?: 'PlaceQL';
      id: string;
      allowCustomAudio: boolean;
    } | null;
  } | null;
};

export type ChangeBusinessVerticalMutationVariables = Exact<{
  input: ChangeBusinessVerticalInput;
}>;

export type ChangeBusinessVerticalMutation = {
  __typename?: 'Mutations';
  changeBusinessVertical?: {
    __typename?: 'ChangeBusinessVertical';
    account?: {
      __typename?: 'AccountQL';
      id: string;
      name: string;
      businessVertical?: string | null;
    } | null;
  } | null;
};

export type ChangeInboxTypeMutationVariables = Exact<{
  input: ChangeInboxTypeInput;
}>;

export type ChangeInboxTypeMutation = {
  __typename?: 'Mutations';
  changeInboxType?: {
    __typename?: 'ChangeInboxType';
    place?: {
      __typename?: 'PlaceQL';
      id: string;
      name: string;
      inboxType: string;
    } | null;
  } | null;
};

export type ChangeNotificationSettingsMutationVariables = Exact<{
  input: NotificationSettingsInput;
}>;

export type ChangeNotificationSettingsMutation = {
  __typename?: 'Mutations';
  changeNotificationSettings?: {
    __typename?: 'ChangeNotificationSettings';
    currentUser?:
      | ({ __typename?: 'UserQL' } & UserItemAndNotificationFieldsFragment)
      | null;
  } | null;
};

export type ChangePlaceGroupMutationVariables = Exact<{
  input: ChangePlaceGroupInput;
}>;

export type ChangePlaceGroupMutation = {
  __typename?: 'Mutations';
  changePlaceGroup?: {
    __typename?: 'ChangePlaceGroup';
    place?: ({ __typename?: 'PlaceQL' } & AdminPlaceFieldsFragment) | null;
  } | null;
};

export type ChangePlaceHoursMutationVariables = Exact<{
  input: ChangePlaceHoursInput;
}>;

export type ChangePlaceHoursMutation = {
  __typename?: 'Mutations';
  changePlaceHours?: {
    __typename?: 'ChangePlaceHours';
    success?: boolean | null;
  } | null;
};

export type ChangeSignupModeMutationVariables = Exact<{
  input: ChangeSignupModeInput;
}>;

export type ChangeSignupModeMutation = {
  __typename?: 'Mutations';
  changeSignupMode?: {
    __typename?: 'ChangeSignupMode';
    account?:
      | ({ __typename?: 'AccountQL' } & AdminAccountFieldsFragment)
      | null;
  } | null;
};

export type ChangeSwipeActionSettingsMutationVariables = Exact<{
  input: ChangeSwipeActionSettingsInput;
}>;

export type ChangeSwipeActionSettingsMutation = {
  __typename?: 'Mutations';
  changeSwipeActionSettings?: {
    __typename?: 'ChangeSwipeActionSettings';
    currentUser?:
      | ({ __typename?: 'UserQL' } & UserItemAndNotificationFieldsFragment)
      | null;
  } | null;
};

export type ChangeTwilioChannelMdnMutationVariables = Exact<{
  input: ChangeTwilioChannelMdnInput;
}>;

export type ChangeTwilioChannelMdnMutation = {
  __typename?: 'Mutations';
  changeTwilioChannelMdn?: {
    __typename?: 'ChangeTwilioChannelMDN';
    channel?: {
      __typename?: 'TwilioChannelQL';
      id: string;
      mdn: string;
      sid?: string | null;
      outboundSmsMdn?: string | null;
    } | null;
  } | null;
};

export type ChangeUserSettingsMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  input: NotificationSettingsInput;
}>;

export type ChangeUserSettingsMutation = {
  __typename?: 'Mutations';
  changeUserSettings?: {
    __typename?: 'ChangeUserSettings';
    user?:
      | ({ __typename?: 'UserQL' } & UserItemAndNotificationFieldsFragment)
      | null;
  } | null;
};

export type ChangeUserVideoConferenceUrlMutationVariables = Exact<{
  input: ChangeUserVideoConferenceUrlInput;
}>;

export type ChangeUserVideoConferenceUrlMutation = {
  __typename?: 'Mutations';
  changeUserVideoConferenceUrl?: {
    __typename?: 'ChangeUserVideoConferenceUrl';
    currentUser?: {
      __typename?: 'UserQL';
      videoConferenceUrl?: string | null;
    } | null;
  } | null;
};

export type CloseStatusItemMutationVariables = Exact<{
  input?: InputMaybe<CloseStatusItemInput>;
}>;

export type CloseStatusItemMutation = {
  __typename?: 'Mutations';
  closeStatusItem?: {
    __typename?: 'CloseStatusItem';
    statusItem?:
      | ({ __typename?: 'StatusItemQL' } & StatusItemDetailsFragment)
      | null;
  } | null;
};

export type CompleteAutopilotMutationVariables = Exact<{
  input: CompleteAutopilotInput;
}>;

export type CompleteAutopilotMutation = {
  __typename?: 'Mutations';
  completeAutopilot?: {
    __typename?: 'CompleteAutopilot';
    autopilot: { __typename?: 'AutopilotQL' } & AutopilotFieldsFragment;
  } | null;
};

export type ConnectAutomationActionEdgeMutationVariables = Exact<{
  input: ConnectAutomationActionEdgeInput;
}>;

export type ConnectAutomationActionEdgeMutation = {
  __typename?: 'Mutations';
  connectAutomationActionEdge?: {
    __typename?: 'ConnectAutomationActionEdge';
    automation?:
      | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
      | null;
  } | null;
};

export type CreateA2pCampaignForPlaceMutationVariables = Exact<{
  placeId: Scalars['String']['input'];
  trustProductId: Scalars['String']['input'];
}>;

export type CreateA2pCampaignForPlaceMutation = {
  __typename?: 'Mutations';
  createA2pCampaignForPlace?: {
    __typename?: 'CreateA2PCampaignForPlace';
    tenDlcProcess?: {
      __typename?: 'TenDLCProcessQL';
      twilioA2pCampaign?: {
        __typename?: 'TwilioA2PCampaignQL';
        id: string;
        campaignStatus: TwilioA2PCampaignStatus;
      } | null;
      twilioBrandRegistration?: {
        __typename?: 'TwilioBrandRegistrationQL';
        id: string;
        status: TwilioBrandRegistrationStatus;
      } | null;
      twilioTrustProduct?: {
        __typename?: 'TwilioTrustProductQL';
        friendlyName?: string | null;
        id: string;
        status: TwilioBundleStatus;
      } | null;
    } | null;
  } | null;
};

export type CreateAppointmentAgentSettingsMutationVariables = Exact<{
  input: CreateAppointmentAgentSettingsInput;
}>;

export type CreateAppointmentAgentSettingsMutation = {
  __typename?: 'Mutations';
  createAppointmentAgentSettings?: {
    __typename?: 'CreateAppointmentAgentSettings';
    appointmentAgentSettings?: {
      __typename?: 'AppointmentAgentSettingsQL';
      id: string;
      name: string;
      settings?: any | null;
    } | null;
  } | null;
};

export type CreateAutomationMutationVariables = Exact<{
  input: CreateAutomationInput;
}>;

export type CreateAutomationMutation = {
  __typename?: 'Mutations';
  createAutomation?: {
    __typename?: 'CreateAutomation';
    automation?:
      | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
      | null;
  } | null;
};

export type CreateAutomationActionMutationVariables = Exact<{
  input: CreateAutomationActionInput;
}>;

export type CreateAutomationActionMutation = {
  __typename?: 'Mutations';
  createAutomationAction?: {
    __typename?: 'CreateAutomationAction';
    automation?:
      | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
      | null;
  } | null;
};

export type CreateAutomationFromBlueprintMutationVariables = Exact<{
  input: CreateAutomationFromBlueprintInput;
}>;

export type CreateAutomationFromBlueprintMutation = {
  __typename?: 'Mutations';
  createAutomationFromBlueprint?: {
    __typename?: 'CreateAutomationFromBlueprint';
    automation?:
      | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
      | null;
  } | null;
};

export type CreateAutopilotMutationVariables = Exact<{
  input: CreateAutopilotInput;
}>;

export type CreateAutopilotMutation = {
  __typename?: 'Mutations';
  createAutopilot?: {
    __typename?: 'CreateAutopilot';
    autopilot: { __typename?: 'AutopilotQL' } & AutopilotFieldsFragment;
  } | null;
};

export type CreateChatExpansionMutationVariables = Exact<{
  input: CreateChatExpansionInput;
}>;

export type CreateChatExpansionMutation = {
  __typename?: 'Mutations';
  createChatExpansion?: {
    __typename?: 'CreateChatExpansion';
    textExpansion: {
      __typename?: 'TextGenerationQL';
      responses: Array<string>;
      data: any;
      messages: Array<{
        __typename?: 'TextGenerationChatMessageQL';
        role: string;
        content: string;
      }>;
    };
  } | null;
};

export type CreateConversationMutationVariables = Exact<{
  input: CreateConversationInput;
  withLastAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  withLastChannel?: InputMaybe<Scalars['Boolean']['input']>;
  withLastRepairOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CreateConversationMutation = {
  __typename?: 'Mutations';
  createConversation?: {
    __typename?: 'CreateConversation';
    conversation: {
      __typename?: 'ConversationQL';
    } & ConversationItemFieldsFragment;
  } | null;
};

export type CreateConversationSummaryMutationVariables = Exact<{
  input: CreateConversationSummaryInput;
}>;

export type CreateConversationSummaryMutation = {
  __typename?: 'Mutations';
  createConversationSummary?: {
    __typename?: 'CreateConversationSummary';
    textSummary: {
      __typename?: 'TextGenerationQL';
      responses: Array<string>;
      data: any;
      messages: Array<{
        __typename?: 'TextGenerationChatMessageQL';
        role: string;
        content: string;
      }>;
    };
  } | null;
};

export type CreateIdentityPromptAddressMutationVariables = Exact<{
  input: CreateIdentityPromptAddressInput;
}>;

export type CreateIdentityPromptAddressMutation = {
  __typename?: 'Mutations';
  createIdentityPromptAddress?: {
    __typename?: 'CreateIdentityPromptAddress';
    identityPromptAddress: {
      __typename?: 'IdentityPromptAddressQL';
      id: string;
      createdOn: any;
      address: string;
      channelId?: string | null;
      createdBy: {
        __typename?: 'ParticipantQL';
        id: string;
        displayName: string;
      };
    };
  } | null;
};

export type CreateLabelMutationVariables = Exact<{
  input: CreateLabelInput;
}>;

export type CreateLabelMutation = {
  __typename?: 'Mutations';
  createLabel?: {
    __typename?: 'CreateLabel';
    label: { __typename?: 'LabelQL' } & LabelFieldsFragment;
  } | null;
};

export type CreateOutboundConferenceCallMutationVariables = Exact<{
  input: CreateOutboundConferenceCallInput;
}>;

export type CreateOutboundConferenceCallMutation = {
  __typename?: 'Mutations';
  createOutboundConferenceCall?: {
    __typename?: 'CreateOutboundConferenceCall';
    outboundConferenceCall: {
      __typename?: 'OutboundConferenceCallQL';
    } & OutboundConferenceCallFieldsFragment;
  } | null;
};

export type CreateParticipantPaymentRequestMutationVariables = Exact<{
  input: CreateParticipantPaymentRequestInput;
}>;

export type CreateParticipantPaymentRequestMutation = {
  __typename?: 'Mutations';
  createParticipantPaymentRequest?: {
    __typename?: 'CreateParticipantPaymentRequest';
    paymentRequest: {
      __typename?: 'PaymentRequestQL';
    } & PaymentRequestFieldsFragment;
  } | null;
};

export type CreatePaymentRequestMutationVariables = Exact<{
  input: CreatePaymentRequestInput;
}>;

export type CreatePaymentRequestMutation = {
  __typename?: 'Mutations';
  createPaymentRequest?: {
    __typename?: 'CreatePaymentRequest';
    paymentRequest: {
      __typename?: 'PaymentRequestQL';
    } & PaymentRequestFieldsFragment;
  } | null;
};

export type CreatePhoneLineMutationVariables = Exact<{
  input: CreatePhoneLineInput;
}>;

export type CreatePhoneLineMutation = {
  __typename?: 'Mutations';
  createPhoneLine?: {
    __typename?: 'CreatePhoneLine';
    phoneline?:
      | ({ __typename?: 'PhoneLineQL' } & PhoneLineFieldsFragment)
      | null;
  } | null;
};

export type CreatePlaceMutationVariables = Exact<{
  input: CreatePlaceInput;
}>;

export type CreatePlaceMutation = {
  __typename?: 'Mutations';
  createPlace?: {
    __typename?: 'CreatePlace';
    place?: { __typename?: 'PlaceQL'; id: string; name: string } | null;
  } | null;
};

export type CreatePortalSessionMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CreatePortalSessionMutation = {
  __typename?: 'Mutations';
  createPortalSession?: {
    __typename?: 'CreatePortalSession';
    portalSession?: any | null;
  } | null;
};

export type CreateScheduledMessageMutationVariables = Exact<{
  input: CreateScheduledMessageInput;
}>;

export type CreateScheduledMessageMutation = {
  __typename?: 'Mutations';
  createScheduledMessage?: {
    __typename?: 'CreateScheduledMessage';
    scheduledMessage: {
      __typename?: 'ScheduledMessageQL';
    } & ScheduledMessageFieldsFragment;
  } | null;
};

export type CreateStripeAccountMutationVariables = Exact<{
  input?: InputMaybe<CreateStripeAccountInput>;
}>;

export type CreateStripeAccountMutation = {
  __typename?: 'Mutations';
  createStripeAccount?: {
    __typename?: 'CreateStripeAccount';
    accountLinkUrl?: string | null;
    refreshUrl?: string | null;
    returnUrl?: string | null;
  } | null;
};

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;

export type CreateUserMutation = {
  __typename?: 'Mutations';
  createUser?: {
    __typename?: 'CreateUser';
    user: {
      __typename?: 'UserQL';
      id: string;
      email?: string | null;
      jobRole?: JobRoleInput | null;
    };
    phoneline?: {
      __typename?: 'PhoneLineQL';
      id: string;
      mdn: string;
      name: string;
      returnCallsMdn?: string | null;
      place?: { __typename?: 'PlaceQL'; id: string; name: string } | null;
    } | null;
  } | null;
};

export type CreateUserPhoneMutationVariables = Exact<{
  input: CreateUserPhoneInput;
}>;

export type CreateUserPhoneMutation = {
  __typename?: 'Mutations';
  createUserPhone?: {
    __typename?: 'CreateUserPhone';
    userPhone: {
      __typename?: 'UserPhoneQL';
      id: string;
      mdn: string;
      type: UserPhoneType;
      sipAddress?: string | null;
      sipPriorityFirst: boolean;
      enabledDuringBusinessHours: boolean;
      enabledAfterBusinessHours: boolean;
      enabledWhenAway: boolean;
    };
  } | null;
};

export type CreateVideoUploadLinkMutationVariables = Exact<{
  input: CreateVideoUploadLinkInput;
}>;

export type CreateVideoUploadLinkMutation = {
  __typename?: 'Mutations';
  createVideoUploadLink?: {
    __typename?: 'CreateVideoUploadLink';
    videoUploadLink: {
      __typename?: 'VideoUploadLinkQL';
    } & VideoUploadLinkFieldsFragment;
  } | null;
};

export type DeleteAppointmentAgentSettingsMutationVariables = Exact<{
  input: DeleteAppointmentAgentSettingsInput;
}>;

export type DeleteAppointmentAgentSettingsMutation = {
  __typename?: 'Mutations';
  deleteAppointmentAgentSettings?: {
    __typename?: 'DeleteAppointmentAgentSettings';
    appointmentAgentSettings?: {
      __typename?: 'AppointmentAgentSettingsQL';
      id: string;
    } | null;
  } | null;
};

export type DeleteAutomationMutationVariables = Exact<{
  input: DeleteAutomationInput;
}>;

export type DeleteAutomationMutation = {
  __typename?: 'Mutations';
  deleteAutomation?: {
    __typename?: 'DeleteAutomation';
    automation?: {
      __typename?: 'AutomationQL';
      id: string;
      state: AutomationState;
    } | null;
  } | null;
};

export type DeleteConversationMutationVariables = Exact<{
  input: DeleteConversationInput;
  withLastAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  withLastChannel?: InputMaybe<Scalars['Boolean']['input']>;
  withLastRepairOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type DeleteConversationMutation = {
  __typename?: 'Mutations';
  deleteConversation?: {
    __typename?: 'DeleteConversation';
    conversation?:
      | ({ __typename?: 'ConversationQL' } & ConversationItemFieldsFragment)
      | null;
  } | null;
};

export type DeleteCustomLinkMutationVariables = Exact<{
  input?: InputMaybe<DeleteCustomLinkInput>;
}>;

export type DeleteCustomLinkMutation = {
  __typename?: 'Mutations';
  deleteCustomLink?: {
    __typename?: 'DeleteCustomLink';
    placeInfo?: {
      __typename?: 'PlaceInfoQL';
      id: string;
      linkGroups: Array<{
        __typename?: 'LinkGroup';
        groupLabel: string;
        links: Array<{
          __typename?: 'Link';
          name: string;
          tag: string;
          url: string;
        }>;
      } | null>;
    } | null;
  } | null;
};

export type DeleteIdentityPromptAddressMutationVariables = Exact<{
  input: DeleteIdentityPromptAddressInput;
}>;

export type DeleteIdentityPromptAddressMutation = {
  __typename?: 'Mutations';
  deleteIdentityPromptAddress?: {
    __typename?: 'DeleteIdentityPromptAddress';
    identityPromptAddress: {
      __typename?: 'IdentityPromptAddressQL';
      id: string;
    };
  } | null;
};

export type DeleteNoteTakerMutationVariables = Exact<{
  input: DeleteNoteTakerInput;
}>;

export type DeleteNoteTakerMutation = {
  __typename?: 'Mutations';
  deleteNoteTaker?: {
    __typename?: 'DeleteNoteTaker';
    id: string;
    message?: string | null;
  } | null;
};

export type DeletePhoneLineMutationVariables = Exact<{
  input: DeletePhoneLineInput;
}>;

export type DeletePhoneLineMutation = {
  __typename?: 'Mutations';
  deletePhoneLine?: {
    __typename?: 'DeletePhoneLine';
    success?: boolean | null;
  } | null;
};

export type DeletePlaceMutationVariables = Exact<{
  input: DeletePlaceInput;
}>;

export type DeletePlaceMutation = {
  __typename?: 'Mutations';
  deletePlace?: { __typename?: 'DeletePlace'; success?: boolean | null } | null;
};

export type DeleteScheduledMessageMutationVariables = Exact<{
  input: DeleteScheduledMessageInput;
}>;

export type DeleteScheduledMessageMutation = {
  __typename?: 'Mutations';
  deleteScheduledMessage?: {
    __typename?: 'DeleteScheduledMessage';
    success: boolean;
  } | null;
};

export type DeleteShortcutMutationVariables = Exact<{
  input: DeleteShortcutInput;
}>;

export type DeleteShortcutMutation = {
  __typename?: 'Mutations';
  deleteShortcut?: {
    __typename?: 'DeleteShortcut';
    response?: string | null;
  } | null;
};

export type DeleteStatusItemMutationVariables = Exact<{
  input?: InputMaybe<DeleteStatusItemInput>;
}>;

export type DeleteStatusItemMutation = {
  __typename?: 'Mutations';
  deleteStatusItem?: {
    __typename?: 'DeleteStatusItem';
    statusItem?: {
      __typename?: 'StatusItemQL';
      id: string;
      stageId: string;
    } | null;
  } | null;
};

export type DeleteUserPhoneMutationVariables = Exact<{
  input: DeleteUserPhoneInput;
}>;

export type DeleteUserPhoneMutation = {
  __typename?: 'Mutations';
  deleteUserPhone?: {
    __typename?: 'DeleteUserPhone';
    userPhone: { __typename?: 'UserPhoneQL'; id: string };
  } | null;
};

export type DeleteVoiceStepMutationVariables = Exact<{
  input: DeleteVoiceStepInput;
}>;

export type DeleteVoiceStepMutation = {
  __typename?: 'Mutations';
  deleteVoiceStep?: {
    __typename?: 'DeleteVoiceStep';
    voiceScript?:
      | ({ __typename?: 'VoiceScriptQL' } & VoiceScriptFieldsFragment)
      | null;
  } | null;
};

export type DisableAutopilotMutationVariables = Exact<{
  input: DisableAutopilotInput;
}>;

export type DisableAutopilotMutation = {
  __typename?: 'Mutations';
  disableAutopilot?: {
    __typename?: 'DisableAutopilot';
    autopilot: { __typename?: 'AutopilotQL' } & AutopilotFieldsFragment;
  } | null;
};

export type DiscardAutomationEditsMutationVariables = Exact<{
  input: DiscardAutomationEditsInput;
}>;

export type DiscardAutomationEditsMutation = {
  __typename?: 'Mutations';
  discardAutomationEdits?: {
    __typename?: 'DiscardAutomationEdits';
    automation?:
      | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
      | null;
  } | null;
};

export type DiscardDisruptionVoiceScriptMutationVariables = Exact<{
  input: DiscardDisruptionVoiceScriptInput;
}>;

export type DiscardDisruptionVoiceScriptMutation = {
  __typename?: 'Mutations';
  discardDisruptionVoiceScript?: {
    __typename?: 'DiscardDisruptionVoiceScript';
    place?: {
      __typename?: 'PlaceQL';
      id: string;
      answeringMode: AnsweringMode;
      answeringModeUntil?: any | null;
      disruptions?: {
        __typename?: 'DisruptionsQL';
        id: string;
        disruptionDepartmentVoiceScriptId: string;
        draftDisruptionDepartmentVoiceScriptId: string;
        holidayDepartmentVoiceScriptId: string;
        draftHolidayDepartmentVoiceScriptId: string;
      } | null;
    } | null;
  } | null;
};

export type DiscardVoiceScriptMutationVariables = Exact<{
  input: DiscardVoiceScriptInput;
}>;

export type DiscardVoiceScriptMutation = {
  __typename?: 'Mutations';
  discardVoiceScript?: {
    __typename?: 'DiscardVoiceScript';
    answeringScript?: {
      __typename?: 'AnsweringScriptsQL';
      id: string;
      draftVoiceScript?:
        | ({ __typename?: 'VoiceScriptQL' } & VoiceScriptFieldsFragment)
        | null;
    } | null;
  } | null;
};

export type EnableNudgesMutationVariables = Exact<{
  input: EnableNudgesInput;
}>;

export type EnableNudgesMutation = {
  __typename?: 'Mutations';
  enableNudges?: {
    __typename?: 'EnableNudges';
    currentAccount?: {
      __typename?: 'AccountQL';
      nudgesEnabled: boolean;
      nudgesThreshold: number;
    } | null;
  } | null;
};

export type EnablePlaceMessageHoursMutationVariables = Exact<{
  input: EnablePlaceMessagingHoursInput;
}>;

export type EnablePlaceMessageHoursMutation = {
  __typename?: 'Mutations';
  enablePlaceMessagingHours?: {
    __typename?: 'EnablePlaceMessagingHours';
    success?: boolean | null;
  } | null;
};

export type EndOutboundConferenceCallMutationVariables = Exact<{
  input: EndOutboundConferenceCallInput;
}>;

export type EndOutboundConferenceCallMutation = {
  __typename?: 'Mutations';
  endOutboundConferenceCall?: {
    __typename?: 'EndOutboundConferenceCall';
    outboundConferenceCall: {
      __typename?: 'OutboundConferenceCallQL';
    } & OutboundConferenceCallFieldsFragment;
  } | null;
};

export type EvaluateBusinessIdentityMutationMutationVariables = Exact<{
  input: BusinessIdentityInput;
  accountId: Scalars['String']['input'];
}>;

export type EvaluateBusinessIdentityMutationMutation = {
  __typename?: 'Mutations';
  evaluateBusinessIdentity?: {
    __typename?: 'EvaluateBusinessIdentity';
    tenDlcProcess?: {
      __typename?: 'TenDLCProcessQL';
      id?: string | null;
      twilioTrustProduct?: {
        __typename?: 'TwilioTrustProductQL';
        friendlyName?: string | null;
        id: string;
        status: TwilioBundleStatus;
      } | null;
      errors?: Array<{
        __typename?: 'TwilioTrustProductError';
        objectField?: string | null;
        failureReason?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type HostedPageMutationVariables = Exact<{ [key: string]: never }>;

export type HostedPageMutation = {
  __typename?: 'Mutations';
  hostedPage?: { __typename?: 'HostedPage'; hostedPage?: any | null } | null;
};

export type HostedSmsCompletedMutationVariables = Exact<{
  input: HostedSmsCompletedInput;
}>;

export type HostedSmsCompletedMutation = {
  __typename?: 'Mutations';
  hostedSmsCompleted?: {
    __typename?: 'HostedSmsCompleted';
    hostedSmsPort?:
      | ({ __typename?: 'HostedSmsPortQL' } & HostedSmsPortFieldsFragment)
      | null;
  } | null;
};

export type ImpersonateUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type ImpersonateUserMutation = {
  __typename?: 'Mutations';
  impersonate?: {
    __typename?: 'Impersonate';
    refreshToken?: string | null;
  } | null;
};

export type ImportHostedSmsMutationVariables = Exact<{
  input?: InputMaybe<ImportHostedSmsInput>;
}>;

export type ImportHostedSmsMutation = {
  __typename?: 'Mutations';
  importHostedSms?: {
    __typename?: 'ImportHostedSms';
    hostedSmsPort?:
      | ({ __typename?: 'HostedSmsPortQL' } & HostedSmsPortFieldsFragment)
      | null;
  } | null;
};

export type IncreaseShortcutCountMutationVariables = Exact<{
  input: IncreaseShortcutCountInput;
}>;

export type IncreaseShortcutCountMutation = {
  __typename?: 'Mutations';
  increaseShortcutCount?: {
    __typename?: 'IncreaseShortcutCount';
    shortcut?: { __typename?: 'ShortcutQL'; id: string } | null;
  } | null;
};

export type LeaveAllConversationsMutationVariables = Exact<{
  [key: string]: never;
}>;

export type LeaveAllConversationsMutation = {
  __typename?: 'Mutations';
  leaveAllConversations?: {
    __typename?: 'LeaveAllConversations';
    success?: boolean | null;
  } | null;
};

export type LeaveConversationsMutationVariables = Exact<{
  input: LeaveConversationsInput;
}>;

export type LeaveConversationsMutation = {
  __typename?: 'Mutations';
  leaveConversations?: {
    __typename?: 'LeaveConversations';
    success?: boolean | null;
  } | null;
};

export type MoveAutomationNodesMutationVariables = Exact<{
  input: UpdateAutomationUiHintsInput;
}>;

export type MoveAutomationNodesMutation = {
  __typename?: 'Mutations';
  updateAutomationUIHints?: {
    __typename?: 'UpdateAutomationUIHints';
    automation?:
      | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
      | null;
  } | null;
};

export type MoveStatusItemMutationVariables = Exact<{
  input?: InputMaybe<MoveStatusItemInput>;
}>;

export type MoveStatusItemMutation = {
  __typename?: 'Mutations';
  moveStatusItem?: {
    __typename?: 'MoveStatusItem';
    statusItem?:
      | ({ __typename?: 'StatusItemQL' } & StatusItemDetailsFragment)
      | null;
  } | null;
};

export type PokeUserMutationVariables = Exact<{
  input: PokeUserInput;
}>;

export type PokeUserMutation = {
  __typename?: 'Mutations';
  pokeUser?: {
    __typename?: 'PokeUser';
    user?: { __typename?: 'UserQL'; id: string } | null;
  } | null;
};

export type PortInPhoneLineMutationVariables = Exact<{
  input: PortInPhoneLineInput;
}>;

export type PortInPhoneLineMutation = {
  __typename?: 'Mutations';
  portInPhoneLine?: {
    __typename?: 'PortInPhoneLine';
    phoneline?:
      | ({ __typename?: 'PhoneLineQL' } & PhoneLineFieldsFragment)
      | null;
    channel?:
      | ({
          __typename?: 'BandwidthChannelQL';
        } & ChannelFields_BandwidthChannelQl_Fragment)
      | ({ __typename?: 'BaseChannel' } & ChannelFields_BaseChannel_Fragment)
      | ({
          __typename?: 'FacebookChannelQL';
        } & ChannelFields_FacebookChannelQl_Fragment)
      | ({
          __typename?: 'GoogleChannelQL';
        } & ChannelFields_GoogleChannelQl_Fragment)
      | ({
          __typename?: 'NoteChannelQL';
        } & ChannelFields_NoteChannelQl_Fragment)
      | ({
          __typename?: 'NumboxChannelQL';
        } & ChannelFields_NumboxChannelQl_Fragment)
      | ({
          __typename?: 'TwilioChannelQL';
        } & ChannelFields_TwilioChannelQl_Fragment)
      | null;
  } | null;
};

export type PublishAutomationMutationVariables = Exact<{
  input: PublishAutomationInput;
}>;

export type PublishAutomationMutation = {
  __typename?: 'Mutations';
  publishAutomation?: {
    __typename?: 'PublishAutomation';
    automation?:
      | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
      | null;
  } | null;
};

export type PublishDisruptionVoiceScriptMutationVariables = Exact<{
  input: PublishDisruptionVoiceScriptInput;
}>;

export type PublishDisruptionVoiceScriptMutation = {
  __typename?: 'Mutations';
  publishDisruptionVoiceScript?: {
    __typename?: 'PublishDisruptionVoiceScript';
    place?: {
      __typename?: 'PlaceQL';
      id: string;
      answeringMode: AnsweringMode;
      answeringModeUntil?: any | null;
      disruptions?: {
        __typename?: 'DisruptionsQL';
        id: string;
        disruptionDepartmentVoiceScriptId: string;
        draftDisruptionDepartmentVoiceScriptId: string;
        holidayDepartmentVoiceScriptId: string;
        draftHolidayDepartmentVoiceScriptId: string;
      } | null;
    } | null;
  } | null;
};

export type PublishVoiceScriptMutationVariables = Exact<{
  input: PublishVoiceScriptInput;
}>;

export type PublishVoiceScriptMutation = {
  __typename?: 'Mutations';
  publishVoiceScript?: {
    __typename?: 'PublishVoiceScript';
    answeringScript?: {
      __typename?: 'AnsweringScriptsQL';
      id: string;
      voiceScript?:
        | ({ __typename?: 'VoiceScriptQL' } & VoiceScriptFieldsFragment)
        | null;
      draftVoiceScript?:
        | ({ __typename?: 'VoiceScriptQL' } & VoiceScriptFieldsFragment)
        | null;
    } | null;
  } | null;
};

export type PubNubAppointmentEnrichedMutationVariables = Exact<{
  appointment: PubNubAppointmentModel;
  conversation_id: Scalars['String']['input'];
}>;

export type PubNubAppointmentEnrichedMutation = {
  __typename?: 'Mutations';
  PubNubAppointmentEnriched?: boolean | null;
};

export type PubNubArchiveConversationMutationVariables = Exact<{
  conversation: PubNubConversationModel;
}>;

export type PubNubArchiveConversationMutation = {
  __typename?: 'Mutations';
  PubNubArchiveConversation?: boolean | null;
};

export type PubNubArchiveConversationsMutationVariables = Exact<{
  inbox_id: Scalars['String']['input'];
  conversations?: InputMaybe<
    Array<PubNubConversationTimestamp> | PubNubConversationTimestamp
  >;
}>;

export type PubNubArchiveConversationsMutation = {
  __typename?: 'Mutations';
  PubNubArchiveConversations?: boolean | null;
};

export type PubNubAssignConversationMutationVariables = Exact<{
  conversation?: InputMaybe<PubNubConversationModel>;
}>;

export type PubNubAssignConversationMutation = {
  __typename?: 'Mutations';
  PubNubAssignConversation?: boolean | null;
};

export type PubNubAwayModeChangedMutationVariables = Exact<{
  user_id: Scalars['String']['input'];
  is_away: Scalars['Boolean']['input'];
  is_schedule_enabled: Scalars['Boolean']['input'];
  status_board_view: Scalars['Boolean']['input'];
  next_shift_start?: InputMaybe<Scalars['String']['input']>;
  next_shift_end?: InputMaybe<Scalars['String']['input']>;
  can_manage_own_away_mode_settings: Scalars['Boolean']['input'];
  is_unassigning_inbound_messages: Scalars['Boolean']['input'];
  show_away_mode_banner_after?: InputMaybe<Scalars['String']['input']>;
}>;

export type PubNubAwayModeChangedMutation = {
  __typename?: 'Mutations';
  PubNubAwayModeChanged?: boolean | null;
};

export type PubNubConversationDeletedMutationVariables = Exact<{
  conversation: PubNubConversationModel;
}>;

export type PubNubConversationDeletedMutation = {
  __typename?: 'Mutations';
  PubNubConversationDeleted?: boolean | null;
};

export type PubNubConversationEngagementUpdatedMutationVariables = Exact<{
  conversation: PubNubConversationModel;
}>;

export type PubNubConversationEngagementUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubConversationEngagementUpdated?: boolean | null;
};

export type PubNubConversationLanguageResetMutationVariables = Exact<{
  conversation: PubNubConversationModel;
}>;

export type PubNubConversationLanguageResetMutation = {
  __typename?: 'Mutations';
  PubNubConversationLanguageReset?: boolean | null;
};

export type PubNubConversationRecoveredMutationVariables = Exact<{
  conversation: PubNubConversationModel;
}>;

export type PubNubConversationRecoveredMutation = {
  __typename?: 'Mutations';
  PubNubConversationRecovered?: boolean | null;
};

export type PubNubDegradedInboxExperienceUpdatedMutationVariables = Exact<{
  account_id: Scalars['String']['input'];
  place_id: Scalars['String']['input'];
  has_degraded_inbox_experience: Scalars['Boolean']['input'];
}>;

export type PubNubDegradedInboxExperienceUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubDegradedInboxExperienceUpdated?: boolean | null;
};

export type PubNubDialogFlowBotDataUpdatedMutationVariables = Exact<{
  dialog_flow_bot_data: PubNubDialogFlowBotDataModel;
}>;

export type PubNubDialogFlowBotDataUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubDialogFlowBotDataUpdated?: boolean | null;
};

export type PubNubEquityTradeOpportunityUpdatedMutationVariables = Exact<{
  conversation_id: Scalars['String']['input'];
  equity_trade_opportunity: PubNubEquityTradeOpportunityModel;
}>;

export type PubNubEquityTradeOpportunityUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubEquityTradeOpportunityUpdated?: boolean | null;
};

export type PubNubInboundCallStatusUpdatedMutationVariables = Exact<{
  call: PubNubInboundPhoneCallModel;
  conversation_id: Scalars['String']['input'];
}>;

export type PubNubInboundCallStatusUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubInboundCallStatusUpdated?: boolean | null;
};

export type PubNubLabelCreatedMutationVariables = Exact<{
  label: PubNubLabelModel;
}>;

export type PubNubLabelCreatedMutation = {
  __typename?: 'Mutations';
  PubNubLabelCreated?: boolean | null;
};

export type PubNubLabelUpdatedMutationVariables = Exact<{
  label: PubNubLabelModel;
}>;

export type PubNubLabelUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubLabelUpdated?: boolean | null;
};

export type PubNubLeaveConversationsMutationVariables = Exact<{
  conversation_ids:
    | Array<Scalars['String']['input']>
    | Scalars['String']['input'];
}>;

export type PubNubLeaveConversationsMutation = {
  __typename?: 'Mutations';
  PubNubLeaveConversations?: boolean | null;
};

export type PubNubMessageReceivedMutationVariables = Exact<{
  conversation: PubNubConversationModel;
  message?: InputMaybe<PubNubMessageModel>;
}>;

export type PubNubMessageReceivedMutation = {
  __typename?: 'Mutations';
  PubNubMessageReceived?: boolean | null;
};

export type PubNubNumboxAgentSessionUpdatedMutationVariables = Exact<{
  numbox_agent_session: PubNubNumboxAgentSessionModel;
}>;

export type PubNubNumboxAgentSessionUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubNumboxAgentSessionUpdated?: boolean | null;
};

export type PubNubOutboundConferenceCallStatusUpdatedMutationVariables = Exact<{
  outbound_conference_call: PubNubOutboundConferenceCallModel;
}>;

export type PubNubOutboundConferenceCallStatusUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubOutboundConferenceCallStatusUpdated?: boolean | null;
};

export type PubNubOutboundProxyCallStatusUpdatedMutationVariables = Exact<{
  id: Scalars['String']['input'];
  call_status: Scalars['String']['input'];
  start_time?: InputMaybe<Scalars['String']['input']>;
  is_being_recorded: Scalars['Boolean']['input'];
}>;

export type PubNubOutboundProxyCallStatusUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubOutboundProxyCallStatusUpdated?: boolean | null;
};

export type PubNubPaymentRequestCreatedMutationVariables = Exact<{
  payment_request: PubNubPaymentRequestModel;
}>;

export type PubNubPaymentRequestCreatedMutation = {
  __typename?: 'Mutations';
  PubNubPaymentRequestCreated?: boolean | null;
};

export type PubNubPaymentRequestUpdatedMutationVariables = Exact<{
  payment_request: PubNubPaymentRequestModel;
}>;

export type PubNubPaymentRequestUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubPaymentRequestUpdated?: boolean | null;
};

export type PubNubPlaceUpdatedMutationVariables = Exact<{
  [key: string]: never;
}>;

export type PubNubPlaceUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubPlaceUpdated?: boolean | null;
};

export type PubNubRestoreConversationMutationVariables = Exact<{
  conversation?: InputMaybe<PubNubConversationModel>;
}>;

export type PubNubRestoreConversationMutation = {
  __typename?: 'Mutations';
  PubNubRestoreConversation?: boolean | null;
};

export type PubNubRestoreConversationsMutationVariables = Exact<{
  inbox_id: Scalars['String']['input'];
  conversations?: InputMaybe<
    Array<PubNubConversationTimestamp> | PubNubConversationTimestamp
  >;
}>;

export type PubNubRestoreConversationsMutation = {
  __typename?: 'Mutations';
  PubNubRestoreConversations?: boolean | null;
};

export type PubNubStatusItemCreatedMutationVariables = Exact<{
  status_item: PubNubStatusItemModel;
}>;

export type PubNubStatusItemCreatedMutation = {
  __typename?: 'Mutations';
  PubNubStatusItemCreated?: boolean | null;
};

export type PubNubStatusItemDeletedMutationVariables = Exact<{
  status_item: PubNubStatusItemModel;
}>;

export type PubNubStatusItemDeletedMutation = {
  __typename?: 'Mutations';
  PubNubStatusItemDeleted?: boolean | null;
};

export type PubNubStatusItemUpdatedMutationVariables = Exact<{
  status_item: PubNubStatusItemUpdateModel;
}>;

export type PubNubStatusItemUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubStatusItemUpdated?: boolean | null;
};

export type PubNubStripeIntegrationUpdatedMutationVariables = Exact<{
  stripe_integration: PubNubStripeIntegrationModel;
}>;

export type PubNubStripeIntegrationUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubStripeIntegrationUpdated?: boolean | null;
};

export type PubNubTaskCreatedMutationVariables = Exact<{
  task: PubNubTaskModel;
}>;

export type PubNubTaskCreatedMutation = {
  __typename?: 'Mutations';
  PubNubTaskCreated?: boolean | null;
};

export type PubNubTaskUpdatedMutationVariables = Exact<{
  task: PubNubTaskModel;
}>;

export type PubNubTaskUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubTaskUpdated?: boolean | null;
};

export type PubNubTeamCreatedMutationVariables = Exact<{
  team: PubNubTeamSettingsModel;
}>;

export type PubNubTeamCreatedMutation = {
  __typename?: 'Mutations';
  PubNubTeamCreated?: boolean | null;
};

export type PubNubTeamDeletedMutationVariables = Exact<{
  team_id: Scalars['String']['input'];
  place_id: Scalars['String']['input'];
}>;

export type PubNubTeamDeletedMutation = {
  __typename?: 'Mutations';
  PubNubTeamDeleted?: boolean | null;
};

export type PubNubTeamUpdatedMutationVariables = Exact<{
  team: PubNubTeamSettingsModel;
}>;

export type PubNubTeamUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubTeamUpdated?: boolean | null;
};

export type PubNubTranscriptUpdatedMutationVariables = Exact<{
  transcript: PubNubTranscriptModel;
}>;

export type PubNubTranscriptUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubTranscriptUpdated?: boolean | null;
};

export type PubNubVideoUploadLinkUpdatedMutationVariables = Exact<{
  video_upload_link: PubNubVideoUploadLinkModel;
}>;

export type PubNubVideoUploadLinkUpdatedMutation = {
  __typename?: 'Mutations';
  PubNubVideoUploadLinkUpdated?: boolean | null;
};

export type RecoverConversationMutationVariables = Exact<{
  input: RecoverConversationInput;
  withLastAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  withLastChannel?: InputMaybe<Scalars['Boolean']['input']>;
  withLastRepairOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type RecoverConversationMutation = {
  __typename?: 'Mutations';
  recoverConversation?: {
    __typename?: 'RecoverConversation';
    conversation?:
      | ({ __typename?: 'ConversationQL' } & ConversationItemFieldsFragment)
      | null;
  } | null;
};

export type RefreshCarrierInfoMutationVariables = Exact<{
  input: RefreshCarrierInfoInput;
}>;

export type RefreshCarrierInfoMutation = {
  __typename?: 'Mutations';
  refreshCarrierInfo?: {
    __typename?: 'RefreshCarrierInfo';
    phoneline?:
      | ({ __typename?: 'PhoneLineQL' } & PhoneLineFieldsFragment)
      | null;
  } | null;
};

export type RefreshTokenMutationVariables = Exact<{
  refreshToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type RefreshTokenMutation = {
  __typename?: 'Mutations';
  login?: {
    __typename?: 'AuthTokens';
    refreshToken?: string | null;
    accessToken?: string | null;
    featureFlags?: Array<string | null> | null;
  } | null;
};

export type RefundPaymentMutationVariables = Exact<{
  input: CreateStripeRefundInput;
}>;

export type RefundPaymentMutation = {
  __typename?: 'Mutations';
  createStripeRefund?: {
    __typename?: 'CreateStripeRefund';
    paymentRequest: {
      __typename?: 'PaymentRequestQL';
    } & PaymentRequestFieldsFragment;
  } | null;
};

export type RemoveAutomationActionMutationVariables = Exact<{
  input: RemoveAutomationActionInput;
}>;

export type RemoveAutomationActionMutation = {
  __typename?: 'Mutations';
  removeAutomationAction?: {
    __typename?: 'RemoveAutomationAction';
    automation?:
      | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
      | null;
  } | null;
};

export type RemoveAutomationExitTriggerMutationVariables = Exact<{
  input: RemoveAutomationExitTriggerInput;
}>;

export type RemoveAutomationExitTriggerMutation = {
  __typename?: 'Mutations';
  removeAutomationExitTrigger?: {
    __typename?: 'RemoveAutomationExitTrigger';
    automation?:
      | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
      | null;
  } | null;
};

export type RemoveLabelFromConversationMutationVariables = Exact<{
  input: RemoveLabelFromConversationInput;
  withLastAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  withLastChannel?: InputMaybe<Scalars['Boolean']['input']>;
  withLastRepairOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type RemoveLabelFromConversationMutation = {
  __typename?: 'Mutations';
  removeLabelFromConversation?: {
    __typename?: 'RemoveLabelFromConversation';
    conversation: {
      __typename?: 'ConversationQL';
    } & ConversationItemFieldsFragment;
  } | null;
};

export type RemovePlaceGroupMutationVariables = Exact<{
  input: RemovePlaceGroupInput;
}>;

export type RemovePlaceGroupMutation = {
  __typename?: 'Mutations';
  removePlaceGroup?: {
    __typename?: 'RemovePlaceGroup';
    account?: { __typename?: 'AccountQL'; id: string } | null;
  } | null;
};

export type RemoveUserFromPlaceMutationVariables = Exact<{
  input: RemoveUserFromPlaceInput;
}>;

export type RemoveUserFromPlaceMutation = {
  __typename?: 'Mutations';
  removeUserFromPlace?: {
    __typename?: 'RemoveUserFromPlace';
    user?: {
      __typename?: 'UserQL';
      id: string;
      displayName: string;
      placesUsers?: Array<{
        __typename?: 'PlacesUsersQL';
        id: string;
        placeId: string;
      } | null> | null;
    } | null;
  } | null;
};

export type RemoveVideoUploadLinkMutationVariables = Exact<{
  input: RemoveVideoUploadLinkInput;
}>;

export type RemoveVideoUploadLinkMutation = {
  __typename?: 'Mutations';
  removeVideoUploadLink?: {
    __typename?: 'RemoveVideoUploadLink';
    videoUploadLink: {
      __typename?: 'VideoUploadLinkQL';
    } & VideoUploadLinkFieldsFragment;
  } | null;
};

export type RenameAccountMutationVariables = Exact<{
  input?: InputMaybe<RenameAccountInput>;
}>;

export type RenameAccountMutation = {
  __typename?: 'Mutations';
  renameAccount?: {
    __typename?: 'RenameAccount';
    account?: { __typename?: 'AccountQL'; id: string; name: string } | null;
  } | null;
};

export type RenamePlaceMutationVariables = Exact<{
  input?: InputMaybe<RenamePlaceInput>;
}>;

export type RenamePlaceMutation = {
  __typename?: 'Mutations';
  renamePlace?: {
    __typename?: 'RenamePlace';
    place?: { __typename?: 'PlaceQL'; id: string } | null;
  } | null;
};

export type ReopenStatusItemMutationVariables = Exact<{
  input?: InputMaybe<ReopenStatusItemInput>;
}>;

export type ReopenStatusItemMutation = {
  __typename?: 'Mutations';
  reopenStatusItem?: {
    __typename?: 'ReopenStatusItem';
    statusItem?:
      | ({ __typename?: 'StatusItemQL' } & StatusItemDetailsFragment)
      | null;
  } | null;
};

export type RequestAvailableIntegrationMutationVariables = Exact<{
  input: RequestAvailableIntegrationInput;
}>;

export type RequestAvailableIntegrationMutation = {
  __typename?: 'Mutations';
  requestAvailableIntegration?: {
    __typename?: 'RequestAvailableIntegration';
    activeIntegration?: {
      __typename?: 'ActiveIntegrationQL';
      id: string;
      integrationId: string;
      status: IntegrationStatus;
      configuration: any;
    } | null;
  } | null;
};

export type ResetAppointmentAgentSettingsMutationVariables = Exact<{
  input: ResetAppointmentAgentSettingsInput;
}>;

export type ResetAppointmentAgentSettingsMutation = {
  __typename?: 'Mutations';
  resetAppointmentAgentSettings?: {
    __typename?: 'ResetAppointmentAgentSettings';
    appointmentAgentSettings?: {
      __typename?: 'AppointmentAgentSettingsQL';
      id: string;
    } | null;
  } | null;
};

export type ResetBrandThemeMutationVariables = Exact<{
  input: ResetBrandThemeInput;
}>;

export type ResetBrandThemeMutation = {
  __typename?: 'Mutations';
  resetBrandTheme?: {
    __typename?: 'ResetBrandTheme';
    brandTheme?:
      | ({ __typename?: 'BrandThemeQL' } & BrandThemeFieldsFragment)
      | null;
  } | null;
};

export type ResetConversationLanguageMutationVariables = Exact<{
  input: ResetConversationLanguageInput;
}>;

export type ResetConversationLanguageMutation = {
  __typename?: 'Mutations';
  resetConversationLanguage?: {
    __typename?: 'ResetConversationLanguage';
    conversation?:
      | ({ __typename?: 'ConversationQL' } & ConversationItemStubFragment)
      | null;
  } | null;
};

export type ResetOutboundChannelsMutationVariables = Exact<{
  input: ResetOutboundChannelsInput;
}>;

export type ResetOutboundChannelsMutation = {
  __typename?: 'Mutations';
  resetOutboundChannels?: {
    __typename?: 'ResetOutboundChannels';
    automation?:
      | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
      | null;
  } | null;
};

export type ResetVoiceScriptMutationVariables = Exact<{
  input: ResetVoiceScriptInput;
}>;

export type ResetVoiceScriptMutation = {
  __typename?: 'Mutations';
  resetVoiceScript?: {
    __typename?: 'ResetVoiceScript';
    voiceScript?:
      | ({ __typename?: 'VoiceScriptQL' } & VoiceScriptFieldsFragment)
      | null;
  } | null;
};

export type SendLoaMutationVariables = Exact<{
  input: SendLoaInput;
}>;

export type SendLoaMutation = {
  __typename?: 'Mutations';
  sendLoa?: {
    __typename?: 'SendLoa';
    hostedSmsPort?:
      | ({ __typename?: 'HostedSmsPortQL' } & HostedSmsPortFieldsFragment)
      | null;
  } | null;
};

export type SendMessageMutationVariables = Exact<{
  input: SendMessageInput;
}>;

export type SendMessageMutation = {
  __typename?: 'Mutations';
  sendMessage?: {
    __typename?: 'SendMessage';
    message?: ({ __typename?: 'MessageQL' } & MessageItemFieldsFragment) | null;
  } | null;
};

export type SendReviewRequestMutationVariables = Exact<{
  input: SendReviewRequestInput;
}>;

export type SendReviewRequestMutation = {
  __typename?: 'Mutations';
  sendReviewRequest?: {
    __typename?: 'SendReviewRequest';
    message?: ({ __typename?: 'MessageQL' } & MessageItemFieldsFragment) | null;
  } | null;
};

export type SendScheduledMessageNowMutationVariables = Exact<{
  input: SendScheduledMessageNowInput;
}>;

export type SendScheduledMessageNowMutation = {
  __typename?: 'Mutations';
  sendScheduledMessageNow?: {
    __typename?: 'SendScheduledMessageNow';
    message?: ({ __typename?: 'MessageQL' } & MessageItemFieldsFragment) | null;
    scheduledMessage?:
      | ({ __typename?: 'ScheduledMessageQL' } & ScheduledMessageFieldsFragment)
      | null;
  } | null;
};

export type SendStatusItemMessageMutationVariables = Exact<{
  input: SendStatusItemMessageInput;
}>;

export type SendStatusItemMessageMutation = {
  __typename?: 'Mutations';
  sendStatusItemMessage?: {
    __typename?: 'SendStatusItemMessage';
    statusItem?:
      | ({ __typename?: 'StatusItemQL' } & StatusItemStubFragment)
      | null;
  } | null;
};

export type AddServiceAdvisorMutationVariables = Exact<{
  input: GenericAddServiceAdvisorInput;
}>;

export type AddServiceAdvisorMutation = {
  __typename?: 'Mutations';
  addServiceAdvisor?: {
    __typename?: 'AddServiceAdvisor';
    serviceAdvisor?: {
      __typename?: 'ServiceAdvisorQL';
      id: string;
      serviceAdvisorId?: string | null;
      placesUsersId: string;
      serviceAdvisorName?: string | null;
    } | null;
  } | null;
};

export type RemoveServiceAdvisorMutationVariables = Exact<{
  input: RemoveServiceAdvisorInput;
}>;

export type RemoveServiceAdvisorMutation = {
  __typename?: 'Mutations';
  removeServiceAdvisor?: {
    __typename?: 'RemoveServiceAdvisor';
    id?: string | null;
  } | null;
};

export type UpdateServiceAdvisorMutationVariables = Exact<{
  input: UpdateServiceAdvisorInput;
}>;

export type UpdateServiceAdvisorMutation = {
  __typename?: 'Mutations';
  updateServiceAdvisor?: {
    __typename?: 'UpdateServiceAdvisor';
    serviceAdvisor?: {
      __typename?: 'ServiceAdvisorQL';
      id: string;
      serviceAdvisorId?: string | null;
      placesUsersId: string;
      serviceAdvisorName?: string | null;
    } | null;
  } | null;
};

export type SetAssignmentRetentionMutationVariables = Exact<{
  newRetention: Scalars['Int']['input'];
}>;

export type SetAssignmentRetentionMutation = {
  __typename?: 'Mutations';
  setAssignmentRetention?: {
    __typename?: 'SetAssignmentRetention';
    currentAccount?: {
      __typename?: 'AccountQL';
      assignmentRetention: number;
    } | null;
  } | null;
};

export type SetBusinessTimezoneMutationVariables = Exact<{
  input: SetBusinessTimezoneInput;
}>;

export type SetBusinessTimezoneMutation = {
  __typename?: 'Mutations';
  setBusinessTimezone?: {
    __typename?: 'SetBusinessTimezone';
    success?: boolean | null;
  } | null;
};

export type SetHangupSuggestionMutationVariables = Exact<{
  input: SetHangupSuggestionInput;
}>;

export type SetHangupSuggestionMutation = {
  __typename?: 'Mutations';
  setHangupSuggestion?: {
    __typename?: 'SetHangupSuggestion';
    phoneLinePolicy?: {
      __typename?: 'PhoneLinePolicyQL';
      id: string;
      hangupSuggestion?: string | null;
    } | null;
  } | null;
};

export type SetOngoingOptInResetMutationVariables = Exact<{
  newOngoingResetOptinDays: Scalars['Int']['input'];
}>;

export type SetOngoingOptInResetMutation = {
  __typename?: 'Mutations';
  setResetOngoingOptin?: {
    __typename?: 'SetResetOngoingOptin';
    currentAccount?: {
      __typename?: 'AccountQL';
      resetOngoingOptin: number;
    } | null;
  } | null;
};

export type SetOptInStatusMutationVariables = Exact<{
  input: SetOptInStatusInput;
  withLastAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  withLastChannel?: InputMaybe<Scalars['Boolean']['input']>;
  withLastRepairOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SetOptInStatusMutation = {
  __typename?: 'Mutations';
  setOptInStatus?: {
    __typename?: 'SetOptInStatus';
    conversation?:
      | ({ __typename?: 'ConversationQL' } & ConversationItemFieldsFragment)
      | null;
  } | null;
};

export type SetResetOptinDaysMutationVariables = Exact<{
  newResetOptinDays: Scalars['Int']['input'];
}>;

export type SetResetOptinDaysMutation = {
  __typename?: 'Mutations';
  setResetOptinDays?: {
    __typename?: 'SetResetOptinDays';
    currentAccount?: {
      __typename?: 'AccountQL';
      resetOptinDays: number;
    } | null;
  } | null;
};

export type SnoozeConversationMutationVariables = Exact<{
  input: SnoozeConversationInput;
}>;

export type SnoozeConversationMutation = {
  __typename?: 'Mutations';
  snoozeConversation?: {
    __typename?: 'SnoozeConversation';
    conversation?:
      | ({ __typename?: 'ConversationQL' } & ConversationItemStubFragment)
      | null;
  } | null;
};

export type StartConversationMutationVariables = Exact<{
  input: StartConversationInput;
  withLastAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  withLastChannel?: InputMaybe<Scalars['Boolean']['input']>;
  withLastRepairOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type StartConversationMutation = {
  __typename?: 'Mutations';
  startConversation?: {
    __typename?: 'StartConversation';
    conversation: {
      __typename?: 'ConversationQL';
    } & ConversationItemFieldsFragment;
    message: { __typename?: 'MessageQL' } & MessageItemFieldsFragment;
  } | null;
};

export type StartConversationWithScheduledMessageMutationVariables = Exact<{
  input: StartConversationWithScheduledMessageInput;
  withLastAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  withLastChannel?: InputMaybe<Scalars['Boolean']['input']>;
  withLastRepairOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type StartConversationWithScheduledMessageMutation = {
  __typename?: 'Mutations';
  startConversationWithScheduledMessage?: {
    __typename?: 'StartConversationWithScheduledMessage';
    conversation: {
      __typename?: 'ConversationQL';
    } & ConversationItemFieldsFragment;
    scheduledMessage: {
      __typename?: 'ScheduledMessageQL';
    } & ScheduledMessageFieldsFragment;
  } | null;
};

export type SubmitBusinessIdentityMutationMutationVariables = Exact<{
  input: BusinessIdentityInput;
  trustProductId: Scalars['String']['input'];
}>;

export type SubmitBusinessIdentityMutationMutation = {
  __typename?: 'Mutations';
  submitBusinessIdentity?: {
    __typename?: 'SubmitBusinessIdentity';
    tenDlcProcess?: {
      __typename?: 'TenDLCProcessQL';
      twilioTrustProduct?: {
        __typename?: 'TwilioTrustProductQL';
        friendlyName?: string | null;
        id: string;
        status: TwilioBundleStatus;
      } | null;
      twilioBrandRegistration?: {
        __typename?: 'TwilioBrandRegistrationQL';
        id: string;
        status: TwilioBrandRegistrationStatus;
      } | null;
      errors?: Array<{
        __typename?: 'TwilioTrustProductError';
        failureReason?: string | null;
        objectField?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type TeachNumaMutationVariables = Exact<{
  input?: InputMaybe<TeachNumaInput>;
}>;

export type TeachNumaMutation = {
  __typename?: 'Mutations';
  teachNuma?: {
    __typename?: 'TeachNuma';
    appliedIntent?: { __typename?: 'AppliedIntentQL'; id: string } | null;
  } | null;
};

export type AddUserToTeamMutationVariables = Exact<{
  input: AddUserToTeamInput;
  userCount?: InputMaybe<Scalars['Int']['input']>;
  afterUser?: InputMaybe<Scalars['String']['input']>;
}>;

export type AddUserToTeamMutation = {
  __typename?: 'Mutations';
  addUserToTeam?: {
    __typename?: 'AddUserToTeam';
    team?: ({ __typename?: 'TeamQL' } & TeamWithUsersFragment) | null;
  } | null;
};

export type CreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
  userCount?: InputMaybe<Scalars['Int']['input']>;
  afterUser?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateTeamMutation = {
  __typename?: 'Mutations';
  createTeam?: {
    __typename?: 'CreateTeam';
    team?: ({ __typename?: 'TeamQL' } & TeamWithUsersFragment) | null;
  } | null;
};

export type DeleteTeamMutationVariables = Exact<{
  input: DeleteTeamInput;
}>;

export type DeleteTeamMutation = {
  __typename?: 'Mutations';
  deleteTeam?: {
    __typename?: 'DeleteTeam';
    team?: { __typename?: 'TeamQL'; id: string } | null;
  } | null;
};

export type RemoveUserFromTeamMutationVariables = Exact<{
  input: RemoveUserFromTeamInput;
  userCount?: InputMaybe<Scalars['Int']['input']>;
  afterUser?: InputMaybe<Scalars['String']['input']>;
}>;

export type RemoveUserFromTeamMutation = {
  __typename?: 'Mutations';
  removeUserFromTeam?: {
    __typename?: 'RemoveUserFromTeam';
    team?: ({ __typename?: 'TeamQL' } & TeamWithUsersFragment) | null;
  } | null;
};

export type UpdateTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;

export type UpdateTeamMutation = {
  __typename?: 'Mutations';
  updateTeam?: {
    __typename?: 'UpdateTeam';
    team?: ({ __typename?: 'TeamQL' } & TeamSettingsFieldsFragment) | null;
  } | null;
};

export type ToggleCustomPhoneLinePolicyMutationVariables = Exact<{
  input: ToggleCustomPhoneLinePolicyInput;
}>;

export type ToggleCustomPhoneLinePolicyMutation = {
  __typename?: 'Mutations';
  toggleCustomPhoneLinePolicy?: {
    __typename?: 'ToggleCustomPhoneLinePolicy';
    phoneline?: {
      __typename?: 'PhoneLineQL';
      id: string;
      policy: {
        __typename?: 'PhoneLinePolicyQL';
        id: string;
        category: PhoneLinePolicyCategory;
      };
    } | null;
  } | null;
};

export type UpdateActiveIntegrationMutationVariables = Exact<{
  input: UpdateActiveIntegrationInput;
}>;

export type UpdateActiveIntegrationMutation = {
  __typename?: 'Mutations';
  updateActiveIntegration?: {
    __typename?: 'UpdateActiveIntegration';
    activeIntegration?: {
      __typename?: 'ActiveIntegrationQL';
      id: string;
      status: IntegrationStatus;
      configuration: any;
      pendingOpcodeSync: boolean;
      appointmentAgentSettings: Array<{
        __typename?: 'AppointmentAgentSettingsQL';
        id: string;
        placeId: string;
        name: string;
        settings?: any | null;
      }>;
    } | null;
  } | null;
};

export type UpdateAnsweringScriptOrderMutationVariables = Exact<{
  input:
    | Array<UpdateAnsweringScriptOrderInput>
    | UpdateAnsweringScriptOrderInput;
}>;

export type UpdateAnsweringScriptOrderMutation = {
  __typename?: 'Mutations';
  updateAnsweringScriptOrder?: {
    __typename?: 'UpdateAnsweringScriptOrder';
    answeringScripts?: Array<{
      __typename?: 'AnsweringScriptsQL';
      id: string;
      order: number;
    }> | null;
  } | null;
};

export type UpdateAppointmentAgentSettingsMutationVariables = Exact<{
  input: UpdateAppointmentAgentSettingsInput;
}>;

export type UpdateAppointmentAgentSettingsMutation = {
  __typename?: 'Mutations';
  updateAppointmentAgentSettings?: {
    __typename?: 'UpdateAppointmentAgentSettings';
    appointmentAgentSettings?: {
      __typename: 'AppointmentAgentSettingsQL';
      id: string;
      name: string;
      settings?: any | null;
      agentProfile?: any | null;
      optionalPrompts?: any | null;
      overallEmphasis: string;
      numaInCallFlow: string;
      webSchedulerReliability: string;
      textingCanWeTextSpeech?: string | null;
      textingOnYesSpeechCanWeText?: string | null;
      textingOnNoSpeechCanWeText?: string | null;
      textingMessageToSend?: string | null;
      textingHangupRecovery?: string | null;
      renderedTextingMessageToSend?: string | null;
      renderedTextingHangupRecovery?: string | null;
      activeIntegrationId?: string | null;
      minimumLeadTimeInMinutes: number;
      maximumBookingHorizonInDays: number;
      enableHangupRecovery: boolean;
      activeIntegration?:
        | ({
            __typename?: 'ActiveIntegrationQL';
          } & AppointmentAgentSettingsActiveIntegrationFieldsFragment)
        | null;
      defaultExternalOpcode?:
        | ({ __typename?: 'ExternalOpcodeQL' } & ExternalOpcodeFieldsFragment)
        | null;
    } | null;
  } | null;
};

export type UpdateAssignmentRoutingSettingsMutationVariables = Exact<{
  input: UpdateAssignmentRoutingSettingsInput;
}>;

export type UpdateAssignmentRoutingSettingsMutation = {
  __typename?: 'Mutations';
  updateAssignmentRoutingSettings?: {
    __typename?: 'UpdateAssignmentRoutingSettings';
    assignmentRoutingSettings?: {
      __typename?: 'AssignmentRoutingSettingQL';
      id: string;
      enabled: boolean;
      forwardingMdn?: string | null;
      enabledDuringBusinessHours: boolean;
      enabledAfterBusinessHours: boolean;
      enabledWhenAway: boolean;
      callTimeout: number;
      useNumaCallerId: boolean;
    } | null;
  } | null;
};

export type UpdateAutomationMutationVariables = Exact<{
  input: UpdateAutomationInput;
}>;

export type UpdateAutomationMutation = {
  __typename?: 'Mutations';
  updateAutomation?: {
    __typename?: 'UpdateAutomation';
    automation?:
      | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
      | null;
  } | null;
};

export type UpdateAutomationActionMutationVariables = Exact<{
  input: UpdateAutomationActionInput;
}>;

export type UpdateAutomationActionMutation = {
  __typename?: 'Mutations';
  updateAutomationAction?: {
    __typename?: 'UpdateAutomationAction';
    automation?:
      | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
      | null;
  } | null;
};

export type UpdateAutomationEnrollmentCriteriaMutationVariables = Exact<{
  input: UpdateAutomationEnrollmentCriteriaInput;
}>;

export type UpdateAutomationEnrollmentCriteriaMutation = {
  __typename?: 'Mutations';
  updateAutomationEnrollmentCriteria?: {
    __typename?: 'UpdateAutomationEnrollmentCriteria';
    automation?:
      | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
      | null;
  } | null;
};

export type UpdateAutomationExitTriggerMutationVariables = Exact<{
  input: UpdateAutomationExitTriggerInput;
}>;

export type UpdateAutomationExitTriggerMutation = {
  __typename?: 'Mutations';
  updateAutomationExitTrigger?: {
    __typename?: 'UpdateAutomationExitTrigger';
    automation?:
      | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
      | null;
  } | null;
};

export type UpdateAutomationStartTriggerMutationVariables = Exact<{
  input: UpdateAutomationStartTriggerInput;
}>;

export type UpdateAutomationStartTriggerMutation = {
  __typename?: 'Mutations';
  updateAutomationStartTrigger?: {
    __typename?: 'UpdateAutomationStartTrigger';
    automation?:
      | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
      | null;
  } | null;
};

export type UpdateAutopilotJobMutationVariables = Exact<{
  input: UpdateAutopilotJobInput;
}>;

export type UpdateAutopilotJobMutation = {
  __typename?: 'Mutations';
  updateAutopilotJob?: {
    __typename?: 'UpdateAutopilotJob';
    autopilotJob: {
      __typename?: 'AutopilotJobQL';
      id: string;
      welcome?: string | null;
      inspection?: string | null;
      service?: string | null;
      qualityControl?: string | null;
      pickup?: string | null;
    };
  } | null;
};

export type UpdateAutopilotScheduledMessageMutationVariables = Exact<{
  input: UpdateAutopilotScheduledMessageInput;
}>;

export type UpdateAutopilotScheduledMessageMutation = {
  __typename?: 'Mutations';
  updateAutopilotScheduledMessage?: {
    __typename?: 'UpdateAutopilotScheduledMessage';
    autopilot: { __typename?: 'AutopilotQL' } & AutopilotFieldsFragment;
  } | null;
};

export type UpdateAwayModeMutationVariables = Exact<{
  input: UpdateAwayModeInput;
}>;

export type UpdateAwayModeMutation = {
  __typename?: 'Mutations';
  updateAwayMode?: {
    __typename?: 'UpdateAwayMode';
    user?: ({ __typename?: 'UserQL' } & AwayModeFieldsFragment) | null;
  } | null;
};

export type UpdateAwayModeAssigneeMutationVariables = Exact<{
  input: UpdateAwayModeAssigneeInput;
}>;

export type UpdateAwayModeAssigneeMutation = {
  __typename?: 'Mutations';
  updateAwayModeAssignee?: {
    __typename?: 'UpdateAwayModeAssignee';
    user?: ({ __typename?: 'UserQL' } & AwayModeDetailsFieldsFragment) | null;
  } | null;
};

export type UpdateAwayModeManagingPermissionMutationVariables = Exact<{
  input: UpdateAwayModeManagingPermissionInput;
}>;

export type UpdateAwayModeManagingPermissionMutation = {
  __typename?: 'Mutations';
  updateAwayModeManagingPermission?: {
    __typename?: 'UpdateAwayModeManagingPermission';
    user?: ({ __typename?: 'UserQL' } & AwayModeFieldsFragment) | null;
  } | null;
};

export type UpdateAwayModeWithTimeMutationVariables = Exact<{
  input: UpdateAwayModeWithTimeInput;
}>;

export type UpdateAwayModeWithTimeMutation = {
  __typename?: 'Mutations';
  updateAwayModeWithTime?: {
    __typename?: 'UpdateAwayModeWithTime';
    user?: ({ __typename?: 'UserQL' } & AwayModeFieldsFragment) | null;
  } | null;
};

export type UpdateBillingMetadataMutationVariables = Exact<{
  input: UpdateBillingMetadataInput;
}>;

export type UpdateBillingMetadataMutation = {
  __typename?: 'Mutations';
  updateBillingMetadata?: {
    __typename?: 'UpdateBillingMetadata';
    place?: {
      __typename?: 'PlaceQL';
      id: string;
      billingMetadata?: {
        __typename?: 'BillingMetadataQL';
        id: string;
        hubspotDealId: string;
        hubspotCompanyId?: string | null;
        chargebeeSubscriptionId?: string | null;
        chargebeeCustomerId?: string | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateBrandThemeMutationVariables = Exact<{
  input: UpdateBrandThemeInput;
}>;

export type UpdateBrandThemeMutation = {
  __typename?: 'Mutations';
  updateBrandTheme?: {
    __typename?: 'UpdateBrandTheme';
    brandTheme?:
      | ({ __typename?: 'BrandThemeQL' } & BrandThemeFieldsFragment)
      | null;
  } | null;
};

export type UpdateBusinessIdentityMutationMutationVariables = Exact<{
  input: BusinessIdentityInput;
  trustProductId: Scalars['String']['input'];
}>;

export type UpdateBusinessIdentityMutationMutation = {
  __typename?: 'Mutations';
  updateBusinessIdentity?: {
    __typename?: 'UpdateBusinessIdentity';
    tenDlcProcess?: {
      __typename?: 'TenDLCProcessQL';
      twilioTrustProduct?: {
        __typename?: 'TwilioTrustProductQL';
        friendlyName?: string | null;
        id: string;
        status: TwilioBundleStatus;
      } | null;
      errors?: Array<{
        __typename?: 'TwilioTrustProductError';
        friendlyName?: string | null;
        objectField?: string | null;
        failureReason?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type UpdateBusinessProfileMutationVariables = Exact<{
  input: UpdateBusinessProfileInput;
}>;

export type UpdateBusinessProfileMutation = {
  __typename?: 'Mutations';
  updateBusinessProfile?: {
    __typename?: 'UpdateBusinessProfile';
    businessProfile?:
      | ({
          __typename?: 'BusinessProfileQL';
          account: { __typename?: 'AccountQL'; id: string };
          places?: {
            __typename?: 'PlaceQLConnection';
            edges: Array<{
              __typename?: 'PlaceQLEdge';
              node?: { __typename?: 'PlaceQL'; id: string } | null;
            } | null>;
          } | null;
        } & BusinessProfileFieldsFragment)
      | null;
  } | null;
};

export type UpdateCallIntelligenceEnabledMutationVariables = Exact<{
  input: UpdateCallIntelligenceEnabledInput;
}>;

export type UpdateCallIntelligenceEnabledMutation = {
  __typename?: 'Mutations';
  updateCallIntelligenceEnabled?: {
    __typename?: 'UpdateCallIntelligenceEnabled';
    placesUser?: {
      __typename?: 'PlacesUsersQL';
      id: string;
      userId: string;
      callIntelligenceEnabled: boolean;
    } | null;
  } | null;
};

export type UpdateChannelMutationVariables = Exact<{
  input: UpdateChannelInput;
}>;

export type UpdateChannelMutation = {
  __typename?: 'Mutations';
  updateChannel?: {
    __typename?: 'UpdateChannel';
    channel:
      | ({
          __typename?: 'BandwidthChannelQL';
        } & ChannelFields_BandwidthChannelQl_Fragment)
      | ({ __typename?: 'BaseChannel' } & ChannelFields_BaseChannel_Fragment)
      | ({
          __typename?: 'FacebookChannelQL';
        } & ChannelFields_FacebookChannelQl_Fragment)
      | ({
          __typename?: 'GoogleChannelQL';
        } & ChannelFields_GoogleChannelQl_Fragment)
      | ({
          __typename?: 'NoteChannelQL';
        } & ChannelFields_NoteChannelQl_Fragment)
      | ({
          __typename?: 'NumboxChannelQL';
        } & ChannelFields_NumboxChannelQl_Fragment)
      | ({
          __typename?: 'TwilioChannelQL';
        } & ChannelFields_TwilioChannelQl_Fragment);
  } | null;
};

export type UpdateConversationLabelMutationVariables = Exact<{
  input: UpdateConversationLabelInput;
}>;

export type UpdateConversationLabelMutation = {
  __typename?: 'Mutations';
  updateConversationLabel?: {
    __typename?: 'UpdateConversationLabel';
    conversationLabel: {
      __typename?: 'ConversationLabelQL';
    } & ConversationLabelFieldsFragment;
  } | null;
};

export type UpdateCurbsideSettingsMutationVariables = Exact<{
  input: UpdateCurbsideSettingsInput;
}>;

export type UpdateCurbsideSettingsMutation = {
  __typename?: 'Mutations';
  updateCurbsideSettings?: {
    __typename?: 'UpdateCurbsideSettings';
    curbsideSettings?: {
      __typename?: 'CurbsideSettingsQL';
      enabled: boolean;
      orderIdentifierType?: PlaceOrderIdType | null;
      orderIdentifierIntentResponse?: string | null;
      customHereIsAutoreply?: boolean | null;
      handoffMethod?: PlaceHandoffMethod | null;
      handoffMethodIntentResponse?: string | null;
      customHandoffIsAutoreply?: boolean | null;
    } | null;
  } | null;
};

export type UpdateDefaultViewMutationVariables = Exact<{
  input: UpdateDefaultViewInput;
}>;

export type UpdateDefaultViewMutation = {
  __typename?: 'Mutations';
  updateDefaultView?: {
    __typename?: 'UpdateDefaultView';
    user?: { __typename?: 'UserQL'; id: string; defaultView: string } | null;
  } | null;
};

export type UpdateDefaultYouViewMutationVariables = Exact<{
  input: UpdateDefaultYouViewInput;
}>;

export type UpdateDefaultYouViewMutation = {
  __typename?: 'Mutations';
  updateDefaultYouView?: {
    __typename?: 'UpdateDefaultYouView';
    user?: { __typename?: 'UserQL'; id: string; defaultYouView: string } | null;
  } | null;
};

export type UpdateEdgesVoiceStepMutationVariables = Exact<{
  input: UpdateEdgesVoiceStepInput;
}>;

export type UpdateEdgesVoiceStepMutation = {
  __typename?: 'Mutations';
  updateEdgesVoiceStep?: {
    __typename?: 'UpdateEdgesVoiceStep';
    voiceScript?:
      | ({ __typename?: 'VoiceScriptQL' } & VoiceScriptFieldsFragment)
      | null;
  } | null;
};

export type UpdateEscalationSettingsMutationVariables = Exact<{
  input: UpdateEscalationSettingsInput;
}>;

export type UpdateEscalationSettingsMutation = {
  __typename?: 'Mutations';
  updateEscalationSettings?: {
    __typename?: 'UpdateEscalationSettings';
    currentAccount?: {
      __typename?: 'AccountQL';
      escalationsEnabled: boolean;
      escalationsThreshold: number;
    } | null;
  } | null;
};

export type UpdateGreetingMutationVariables = Exact<{
  input: UpdateGreetingInput;
}>;

export type UpdateGreetingMutation = {
  __typename?: 'Mutations';
  updateGreeting?: {
    __typename?: 'UpdateGreeting';
    greeting?: {
      __typename?: 'GreetingQL';
      id: string;
      content?: string | null;
      contentTemplate?: string | null;
      afterHoursContent?: string | null;
      afterHoursContentTemplate?: string | null;
    } | null;
  } | null;
};

export type UpdateHideSharedInboxViewsMutationVariables = Exact<{
  input: UpdateHideSharedInboxViewsInput;
}>;

export type UpdateHideSharedInboxViewsMutation = {
  __typename?: 'Mutations';
  updateHideSharedInboxViews?: {
    __typename?: 'UpdateHideSharedInboxViews';
    user?: ({ __typename?: 'UserQL' } & InboxBehaviourFieldsFragment) | null;
  } | null;
};

export type UpdateHostedSmsMutationVariables = Exact<{
  input: UpdateHostedSmsInput;
}>;

export type UpdateHostedSmsMutation = {
  __typename?: 'Mutations';
  updateHostedSms?: {
    __typename?: 'UpdateHostedSms';
    hostedSmsPort?:
      | ({ __typename?: 'HostedSmsPortQL' } & HostedSmsPortFieldsFragment)
      | null;
  } | null;
};

export type UpdateIsScheduleEnabledMutationVariables = Exact<{
  input: UpdateIsScheduleEnabledInput;
}>;

export type UpdateIsScheduleEnabledMutation = {
  __typename?: 'Mutations';
  updateIsScheduleEnabled?: {
    __typename?: 'UpdateIsScheduleEnabled';
    user?:
      | ({
          __typename?: 'UserQL';
          schedule?: any | null;
          isScheduleEnabled: boolean;
        } & AwayModeFieldsFragment)
      | null;
  } | null;
};

export type UpdateLabelMutationVariables = Exact<{
  input: UpdateLabelInput;
}>;

export type UpdateLabelMutation = {
  __typename?: 'Mutations';
  updateLabel?: {
    __typename?: 'UpdateLabel';
    label: { __typename?: 'LabelQL' } & LabelFieldsFragment;
  } | null;
};

export type UpdateLinkMutationVariables = Exact<{
  input?: InputMaybe<UpdateLinkInput>;
}>;

export type UpdateLinkMutation = {
  __typename?: 'Mutations';
  updateLink?: {
    __typename?: 'UpdateLink';
    placeInfo?: {
      __typename?: 'PlaceInfoQL';
      id: string;
      linkGroups: Array<{
        __typename?: 'LinkGroup';
        groupLabel: string;
        links: Array<{
          __typename?: 'Link';
          name: string;
          tag: string;
          url: string;
        }>;
      } | null>;
    } | null;
  } | null;
};

export type UpdateLinkUrlsMutationVariables = Exact<{
  input?: InputMaybe<UpdateLinkUrlsInput>;
}>;

export type UpdateLinkUrlsMutation = {
  __typename?: 'Mutations';
  updateLinkUrls?: {
    __typename?: 'UpdateLinkUrls';
    placeInfo?: {
      __typename?: 'PlaceInfoQL';
      id: string;
      linkGroups: Array<{
        __typename?: 'LinkGroup';
        groupLabel: string;
        links: Array<{
          __typename?: 'Link';
          name: string;
          tag: string;
          url: string;
        }>;
      } | null>;
    } | null;
  } | null;
};

export type UpdateLoggedCallMutationVariables = Exact<{
  input: UpdateLoggedCallInput;
}>;

export type UpdateLoggedCallMutation = {
  __typename?: 'Mutations';
  updateLoggedCall?: {
    __typename?: 'UpdateLoggedCall';
    message?: ({ __typename?: 'MessageQL' } & MessageItemFieldsFragment) | null;
  } | null;
};

export type UpdateMissedCallFollowUpSettingMutationVariables = Exact<{
  input: UpdateMissedCallFollowUpSettingInput;
}>;

export type UpdateMissedCallFollowUpSettingMutation = {
  __typename?: 'Mutations';
  updateMissedCallFollowUpSetting?: {
    __typename?: 'UpdateMissedCallFollowUpSetting';
    user?: {
      __typename?: 'UserQL';
      id: string;
      missedOutboundCallFollowUpEnabled: boolean;
      missedOutboundCallFollowUpMessage?: string | null;
      missedOutboundCallFollowUpRenderedMessage?: string | null;
    } | null;
  } | null;
};

export type UpdateNewConversationsPerDayMutationVariables = Exact<{
  input: UpdateNewConversationsPerDayInput;
}>;

export type UpdateNewConversationsPerDayMutation = {
  __typename?: 'Mutations';
  updateNewConversationsPerDay?: {
    __typename?: 'UpdateNewConversationsPerDay';
    place?: {
      __typename?: 'PlaceQL';
      id: string;
      name: string;
      newConversationsPerDay: number;
    } | null;
  } | null;
};

export type UpdateOutboundConferenceCallMutationVariables = Exact<{
  input: UpdateOutboundConferenceCallInput;
}>;

export type UpdateOutboundConferenceCallMutation = {
  __typename?: 'Mutations';
  updateOutboundConferenceCall?: {
    __typename?: 'UpdateOutboundConferenceCall';
    outboundConferenceCall: {
      __typename?: 'OutboundConferenceCallQL';
    } & OutboundConferenceCallFieldsFragment;
  } | null;
};

export type UpdateParticipantMutationVariables = Exact<{
  input: UpdateParticipantInput;
}>;

export type UpdateParticipantMutation = {
  __typename?: 'Mutations';
  updateParticipant?: {
    __typename?: 'UpdateParticipant';
    participant?:
      | ({ __typename?: 'ParticipantQL' } & ParticipantFieldsFragment)
      | null;
  } | null;
};

export type UpdatePaymentRequestAttachmentMutationVariables = Exact<{
  input: UpdatePaymentRequestAttachmentInput;
}>;

export type UpdatePaymentRequestAttachmentMutation = {
  __typename?: 'Mutations';
  updatePaymentRequestAttachment?: {
    __typename?: 'UpdatePaymentRequestAttachment';
    paymentRequest: {
      __typename?: 'PaymentRequestQL';
    } & PaymentRequestFieldsFragment;
  } | null;
};

export type UpdatePaymentRequestCustomizationMutationVariables = Exact<{
  input: UpdatePaymentRequestCustomizationInput;
}>;

export type UpdatePaymentRequestCustomizationMutation = {
  __typename?: 'Mutations';
  updatePaymentRequestCustomization?: {
    __typename?: 'UpdatePaymentRequestCustomization';
    paymentRequestCustomization?: {
      __typename?: 'PaymentRequestCustomizationQL';
      id: string;
      placeId: string;
      createTemplate: string;
      renderedCreateTemplate: string;
      createAutoSend: boolean;
      createHoldTemplate: string;
      renderedCreateHoldTemplate: string;
      createHoldAutoSend: boolean;
      successTemplate: string;
      renderedSuccessTemplate: string;
      successAutoSend: boolean;
      refundTemplate: string;
      renderedRefundTemplate: string;
      refundAutoSend: boolean;
      partialRefundTemplate: string;
      renderedPartialRefundTemplate: string;
      partialRefundAutoSend: boolean;
      canceledTemplate: string;
      renderedCanceledTemplate: string;
      canceledAutoSend: boolean;
    } | null;
  } | null;
};

export type UpdatePhoneCallMutationVariables = Exact<{
  input: UpdatePhoneCallInput;
}>;

export type UpdatePhoneCallMutation = {
  __typename?: 'Mutations';
  updatePhoneCall?: {
    __typename?: 'UpdatePhoneCall';
    phonecall?: {
      __typename?: 'PhoneCallQL';
      id: string;
      isBeingRecorded: boolean;
    } | null;
  } | null;
};

export type UpdatePhoneLineMutationVariables = Exact<{
  input: UpdatePhoneLineInput;
}>;

export type UpdatePhoneLineMutation = {
  __typename?: 'Mutations';
  updatePhoneLine?: {
    __typename?: 'UpdatePhoneLine';
    phoneline?:
      | ({
          __typename?: 'PhoneLineQL';
        } & PhonelineCategorySettingsFieldsFragment)
      | null;
  } | null;
};

export type UpdatePhoneLinePolicyMutationVariables = Exact<{
  input: UpdatePhoneLinePolicyInput;
}>;

export type UpdatePhoneLinePolicyMutation = {
  __typename?: 'Mutations';
  updatePhoneLinePolicy?: {
    __typename?: 'UpdatePhoneLinePolicy';
    phoneLinePolicy?:
      | ({ __typename?: 'PhoneLinePolicyQL' } & PhoneLinePolicyFieldsFragment)
      | null;
  } | null;
};

export type UpdatePlaceDisruptionSettingsMutationVariables = Exact<{
  input: UpdatePlaceDisruptionSettingsInput;
}>;

export type UpdatePlaceDisruptionSettingsMutation = {
  __typename?: 'Mutations';
  updatePlaceDisruptionSettings?: {
    __typename?: 'UpdatePlaceDisruptionSettings';
    place?: {
      __typename?: 'PlaceQL';
      id: string;
      answeringMode: AnsweringMode;
      answeringModeFrom?: any | null;
      answeringModeUntil?: any | null;
      disruptions?: {
        __typename?: 'DisruptionsQL';
        disruptionsGreeting: string;
      } | null;
    } | null;
  } | null;
};

export type UpdatePlaceGroupMutationVariables = Exact<{
  input: UpdatePlaceGroupInput;
}>;

export type UpdatePlaceGroupMutation = {
  __typename?: 'Mutations';
  updatePlaceGroup?: {
    __typename?: 'UpdatePlaceGroup';
    placeGroup?: {
      __typename?: 'PlaceGroupQL';
      id: string;
      name: string;
    } | null;
  } | null;
};

export type UpdateLogosMutationVariables = Exact<{
  input: UpdateLogosInput;
}>;

export type UpdateLogosMutation = {
  __typename?: 'Mutations';
  updateLogos?: {
    __typename?: 'UpdateLogos';
    placeInfo?: {
      __typename?: 'PlaceInfoQL';
      id: string;
      logoUrl?: string | null;
      place: {
        __typename?: 'PlaceQL';
        id: string;
        brandTheme?: {
          __typename?: 'BrandThemeQL';
          id: string;
          logoUrl?: string | null;
        } | null;
      };
    } | null;
  } | null;
};

export type UpdatePlaceMfaSettingsMutationVariables = Exact<{
  input: UpdatePlaceMfaSettingsInput;
}>;

export type UpdatePlaceMfaSettingsMutation = {
  __typename?: 'Mutations';
  updatePlaceMfaSettings?: {
    __typename?: 'UpdatePlaceMFASettings';
    place?: {
      __typename?: 'PlaceQL';
      id: string;
      enforceMfa: EnforceMfa;
    } | null;
  } | null;
};

export type UpdatePlaceNamePronunciationMutationVariables = Exact<{
  input: UpdateNamePronunciationInput;
}>;

export type UpdatePlaceNamePronunciationMutation = {
  __typename?: 'Mutations';
  updateNamePronunciation?: {
    __typename?: 'UpdateNamePronunciation';
    place?: {
      __typename?: 'PlaceQL';
      id: string;
      namePronunciation?: string | null;
      namePronunciationUrl?: string | null;
    } | null;
  } | null;
};

export type UpdatePlaceOutboundCallSettingsMutationVariables = Exact<{
  input: UpdatePlaceOutboundCallSettingsInput;
}>;

export type UpdatePlaceOutboundCallSettingsMutation = {
  __typename?: 'Mutations';
  updatePlaceOutboundCallSettings?: {
    __typename?: 'UpdatePlaceOutboundCallSettings';
    place?: {
      __typename?: 'PlaceQL';
      id: string;
      outboundCallSettings?: Array<{
        __typename?: 'OutboundCallSettingQL';
        id: string;
        mdn?: string | null;
      }> | null;
    } | null;
  } | null;
};

export type UpdatePlaceStatusMutationVariables = Exact<{
  input: UpdatePlaceStatusInput;
}>;

export type UpdatePlaceStatusMutation = {
  __typename?: 'Mutations';
  updatePlaceStatus?: {
    __typename?: 'UpdatePlaceStatus';
    place?: { __typename?: 'PlaceQL'; id: string; status: Status } | null;
  } | null;
};

export type UpdatePlaceVoiceMutationVariables = Exact<{
  input: UpdatePlaceVoiceInput;
}>;

export type UpdatePlaceVoiceMutation = {
  __typename?: 'Mutations';
  updatePlaceVoice?: {
    __typename?: 'UpdatePlaceVoice';
    place?: {
      __typename?: 'PlaceQL';
      id: string;
      voice: string;
      voiceSpanish?: string | null;
      voiceFrench?: string | null;
    } | null;
  } | null;
};

export type UpdateAppointmentMutationVariables = Exact<{
  input: UpdateAppointmentInput;
}>;

export type UpdateAppointmentMutation = {
  __typename?: 'Mutations';
  updateAppointment?: {
    __typename?: 'UpdateAppointment';
    appointment?:
      | ({ __typename?: 'AppointmentQL' } & AppointmentFieldsFragment)
      | null;
  } | null;
};

export type UpdateQuestionAgentSettingsMutationVariables = Exact<{
  input: UpdateQuestionAgentSettingsInput;
}>;

export type UpdateQuestionAgentSettingsMutation = {
  __typename?: 'Mutations';
  updateQuestionAgentSettings?: {
    __typename?: 'UpdateQuestionAgentSettings';
    questionAgentSettings?: {
      __typename?: 'QuestionAgentSettingsQL';
      id: string;
      name: string;
      settings?: any | null;
    } | null;
  } | null;
};

export type UpdateReceivesEscalationsMutationVariables = Exact<{
  input: UpdateReceivesEscalationsInput;
}>;

export type UpdateReceivesEscalationsMutation = {
  __typename?: 'Mutations';
  updateReceivesEscalations?: {
    __typename?: 'UpdateReceivesEscalations';
    placesUser?: {
      __typename?: 'PlacesUsersQL';
      userId: string;
      receivesEscalations: boolean;
    } | null;
  } | null;
};

export type UpdateReviewJobMutationVariables = Exact<{
  input: UpdateReviewJobInput;
}>;

export type UpdateReviewJobMutation = {
  __typename?: 'Mutations';
  updateReviewJob?: {
    __typename?: 'UpdateReviewJob';
    reviewJob?: {
      __typename?: 'ReviewJobQL';
      id: string;
      placeId: string;
      fallbackChannelId?: string | null;
      messageBody: string;
      messageImageUrl?: string | null;
      headerColor?: string | null;
      headerTextColor?: string | null;
      backgroundColor?: string | null;
      textColor?: string | null;
      buttonColor?: string | null;
      buttonTextColor?: string | null;
      skipRatingsScreen?: boolean | null;
      reviewSites: Array<
        | {
            __typename?: 'FacebookReviewSite';
            facebookPageId: string;
            serviceName: string;
            url: string;
          }
        | { __typename?: 'GoogleReviewSite'; serviceName: string; url: string }
        | { __typename?: 'ReviewSite'; serviceName: string; url: string }
      >;
    } | null;
  } | null;
};

export type UpdateShortcutMutationVariables = Exact<{
  input: UpdateShortcutInput;
}>;

export type UpdateShortcutMutation = {
  __typename?: 'Mutations';
  updateShortcut?: {
    __typename?: 'UpdateShortcut';
    shortcut?: { __typename?: 'ShortcutQL'; id: string } | null;
  } | null;
};

export type UpdateShowBannerAfterMutationVariables = Exact<{
  [key: string]: never;
}>;

export type UpdateShowBannerAfterMutation = {
  __typename?: 'Mutations';
  updateShowBannerAfter?: {
    __typename?: 'UpdateShowBannerAfter';
    currentUser?: {
      __typename?: 'UserQL';
      showAwayModeBannerAfter?: any | null;
    } | null;
  } | null;
};

export type UpdateStageMutationVariables = Exact<{
  input: UpdateStageInput;
}>;

export type UpdateStageMutation = {
  __typename?: 'Mutations';
  updateStage?: {
    __typename?: 'UpdateStage';
    stage?: ({ __typename?: 'StageQL' } & StageStubFragment) | null;
  } | null;
};

export type UpdateStatusBoardViewMutationVariables = Exact<{
  input: UpdateStatusBoardViewInput;
}>;

export type UpdateStatusBoardViewMutation = {
  __typename?: 'Mutations';
  updateStatusBoardView?: {
    __typename?: 'UpdateStatusBoardView';
    user?: ({ __typename?: 'UserQL' } & InboxBehaviourFieldsFragment) | null;
  } | null;
};

export type UpdateStatusItemMutationVariables = Exact<{
  input?: InputMaybe<UpdateStatusItemInput>;
}>;

export type UpdateStatusItemMutation = {
  __typename?: 'Mutations';
  updateStatusItem?: {
    __typename?: 'UpdateStatusItem';
    statusItem?:
      | ({ __typename?: 'StatusItemQL' } & StatusItemDetailsFragment)
      | null;
  } | null;
};

export type UpdateSubscriptionMutationVariables = Exact<{
  billingIdentityId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  skuName: Scalars['String']['input'];
}>;

export type UpdateSubscriptionMutation = {
  __typename?: 'Mutations';
  updateSubscription?: {
    __typename?: 'UpsertSubscription';
    subscription?: {
      __typename?: 'SubscriptionQL';
      id: string;
      quantity: number;
      sku: { __typename?: 'SkuQL'; id: string; name: string };
    } | null;
  } | null;
};

export type UpdateTransportationSetMutationVariables = Exact<{
  input: UpdateTransportationSetInput;
}>;

export type UpdateTransportationSetMutation = {
  __typename?: 'Mutations';
  updateTransportationSet?: {
    __typename?: 'UpdateTransportationSet';
    transportationSet: {
      __typename?: 'TransportationSetQL';
      id: string;
      kind: TransportationSetType;
      name: string;
      placeId: string;
      rules: any;
      enabled: boolean;
      speechUtterance?: string | null;
      transportationOptions: Array<{
        __typename?: 'TransportationSetOptionQL';
        id: string;
        enabled: boolean;
        kind: TransportationOptionType;
        order: number;
        speechShort: string;
        speechLong: string;
        minimumServiceItems: number;
      }>;
    };
  } | null;
};

export type UpdateTwilioChannelMutationVariables = Exact<{
  input: UpdateTwilioChannelInput;
}>;

export type UpdateTwilioChannelMutation = {
  __typename?: 'Mutations';
  updateTwilioChannel?: {
    __typename?: 'UpdateTwilioChannel';
    channel?:
      | ({
          __typename?: 'TwilioChannelQL';
        } & ChannelFields_TwilioChannelQl_Fragment)
      | null;
  } | null;
};

export type UpdateUseNewNumberMutationVariables = Exact<{
  input: UpdateUseNewNumberInput;
}>;

export type UpdateUseNewNumberMutation = {
  __typename?: 'Mutations';
  updateUseNewNumber?: {
    __typename?: 'UpdateUseNewNumber';
    account?: {
      __typename?: 'AccountQL';
      id: string;
      useNewNumber?: boolean | null;
    } | null;
  } | null;
};

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutations';
  updateUser?: {
    __typename?: 'UpdateUser';
    user?:
      | ({
          __typename?: 'UserQL';
          signature?: string | null;
          signaturePreference: SignaturePreferences;
        } & UserItemFieldsFragment)
      | null;
  } | null;
};

export type UpdateUserInformationMutationVariables = Exact<{
  input: UpdateUserInformationInput;
}>;

export type UpdateUserInformationMutation = {
  __typename?: 'Mutations';
  updateUserInformation?: {
    __typename?: 'UpdateUserInformation';
    user?:
      | ({
          __typename?: 'UserQL';
          jobRole?: JobRoleInput | null;
          jobTitle?: string | null;
          mdn?: string | null;
        } & UserItemFieldsFragment)
      | null;
  } | null;
};

export type UpdateUserMfaSettingsMutationVariables = Exact<{
  input: UpdateUserMfaSettingsInput;
}>;

export type UpdateUserMfaSettingsMutation = {
  __typename?: 'Mutations';
  updateUserMfaSettings?: {
    __typename?: 'UpdateUserMFASettings';
    user?: {
      __typename?: 'UserQL';
      id: string;
      enforceMfa?: EnforceMfa | null;
    } | null;
  } | null;
};

export type UpdateUserPersonalizationMutationVariables = Exact<{
  input: UpdateUserPersonalizationInput;
}>;

export type UpdateUserPersonalizationMutation = {
  __typename?: 'Mutations';
  updateUserPersonalization?: {
    __typename?: 'UpdateUserPersonalization';
    user?: {
      __typename?: 'UserQL';
      id: string;
      firstName?: string | null;
      namePronunciation?: string | null;
      namePronunciationUrl?: string | null;
      pronouns?: Pronouns | null;
    } | null;
  } | null;
};

export type UpdateUserPhoneMutationVariables = Exact<{
  input: UpdateUserPhoneInput;
}>;

export type UpdateUserPhoneMutation = {
  __typename?: 'Mutations';
  updateUserPhone?: {
    __typename?: 'UpdateUserPhone';
    userPhone: {
      __typename?: 'UserPhoneQL';
      id: string;
      mdn: string;
      type: UserPhoneType;
      sipAddress?: string | null;
      sipPriorityFirst: boolean;
      enabledDuringBusinessHours: boolean;
      enabledAfterBusinessHours: boolean;
      enabledWhenAway: boolean;
    };
  } | null;
};

export type UpdateUserScheduleMutationVariables = Exact<{
  input: UpdateUserScheduleInput;
}>;

export type UpdateUserScheduleMutation = {
  __typename?: 'Mutations';
  updateUserSchedule?: {
    __typename?: 'UpdateUserSchedule';
    user?:
      | ({
          __typename?: 'UserQL';
          schedule?: any | null;
          isScheduleEnabled: boolean;
        } & AwayModeFieldsFragment)
      | null;
  } | null;
};

export type UpdateUserViewPreferencesMutationVariables = Exact<{
  input: UpdateUserViewPreferencesInput;
}>;

export type UpdateUserViewPreferencesMutation = {
  __typename?: 'Mutations';
  updateUserViewPreferences?: {
    __typename?: 'UpdateUserViewPreferences';
    user?: {
      __typename?: 'UserQL';
      id: string;
      viewPreferences: {
        __typename?: 'UserViewPreferences';
      } & UserViewPreferencesFieldsFragment;
    } | null;
  } | null;
};

export type UpdateVideoUploadLinkMutationVariables = Exact<{
  input: UpdateVideoUploadLinkInput;
}>;

export type UpdateVideoUploadLinkMutation = {
  __typename?: 'Mutations';
  updateVideoUploadLink?: {
    __typename?: 'UpdateVideoUploadLink';
    videoUploadLink: {
      __typename?: 'VideoUploadLinkQL';
    } & VideoUploadLinkFieldsFragment;
  } | null;
};

export type UpdateVoiceScriptMutationVariables = Exact<{
  input: UpdateVoiceScriptInput;
}>;

export type UpdateVoiceScriptMutation = {
  __typename?: 'Mutations';
  updateVoiceScript?: {
    __typename?: 'UpdateVoiceScript';
    voiceScript?:
      | ({ __typename?: 'VoiceScriptQL' } & VoiceScriptFieldsFragment)
      | null;
  } | null;
};

export type UpdateVoiceStepMutationVariables = Exact<{
  input: UpdateVoiceStepInput;
}>;

export type UpdateVoiceStepMutation = {
  __typename?: 'Mutations';
  updateVoiceStep?: {
    __typename?: 'UpdateVoiceStep';
    step?:
      | ({
          __typename?: 'AppointmentAgentStepQL';
        } & VoiceStepFields_AppointmentAgentStepQl_Fragment)
      | ({
          __typename?: 'AskYesNoQuestionStepQL';
        } & VoiceStepFields_AskYesNoQuestionStepQl_Fragment)
      | ({
          __typename?: 'AutoAssignStepQL';
        } & VoiceStepFields_AutoAssignStepQl_Fragment)
      | ({
          __typename?: 'CallForwardingStepQL';
        } & VoiceStepFields_CallForwardingStepQl_Fragment)
      | ({
          __typename?: 'CallRecordingStepQL';
        } & VoiceStepFields_CallRecordingStepQl_Fragment)
      | ({
          __typename?: 'CheckBusinessHoursStepQL';
        } & VoiceStepFields_CheckBusinessHoursStepQl_Fragment)
      | ({
          __typename?: 'CheckForLabelStepQL';
        } & VoiceStepFields_CheckForLabelStepQl_Fragment)
      | ({
          __typename?: 'ConversationStateStepQL';
        } & VoiceStepFields_ConversationStateStepQl_Fragment)
      | ({
          __typename?: 'ConversationalSchedulingAgentStepQl';
        } & VoiceStepFields_ConversationalSchedulingAgentStepQl_Fragment)
      | ({
          __typename?: 'GreetingStepQL';
        } & VoiceStepFields_GreetingStepQl_Fragment)
      | ({
          __typename?: 'IntentQuestionQL';
        } & VoiceStepFields_IntentQuestionQl_Fragment)
      | ({
          __typename?: 'LabelConversationStepQL';
        } & VoiceStepFields_LabelConversationStepQl_Fragment)
      | ({
          __typename?: 'NoteTakerStepQL';
        } & VoiceStepFields_NoteTakerStepQl_Fragment)
      | ({
          __typename?: 'OperatorAgentStepQL';
        } & VoiceStepFields_OperatorAgentStepQl_Fragment)
      | ({
          __typename?: 'PickupStepQL';
        } & VoiceStepFields_PickupStepQl_Fragment)
      | ({
          __typename?: 'PressAnyKeyStepQL';
        } & VoiceStepFields_PressAnyKeyStepQl_Fragment)
      | ({
          __typename?: 'QualifyStepQL';
        } & VoiceStepFields_QualifyStepQl_Fragment)
      | ({
          __typename?: 'QuestionBotStepQL';
        } & VoiceStepFields_QuestionBotStepQl_Fragment)
      | ({
          __typename?: 'SmartTopicStepQL';
        } & VoiceStepFields_SmartTopicStepQl_Fragment)
      | ({ __typename?: 'SpeakStepQL' } & VoiceStepFields_SpeakStepQl_Fragment)
      | ({
          __typename?: 'SpecialQuestionQL';
        } & VoiceStepFields_SpecialQuestionQl_Fragment)
      | ({
          __typename?: 'StatusUpdaterStepQL';
        } & VoiceStepFields_StatusUpdaterStepQl_Fragment)
      | ({
          __typename?: 'TextOptinStepQL';
        } & VoiceStepFields_TextOptinStepQl_Fragment)
      | ({
          __typename?: 'VoiceScriptStepQL';
        } & VoiceStepFields_VoiceScriptStepQl_Fragment)
      | null;
    script?: {
      __typename?: 'VoiceScriptQL';
      id: string;
      dirty: boolean;
    } | null;
  } | null;
};

export type UpdateVoiceStepUiHintsMutationVariables = Exact<{
  input: UpdateVoiceStepUiHintsInput;
}>;

export type UpdateVoiceStepUiHintsMutation = {
  __typename?: 'Mutations';
  updateVoiceStepUIHints?: {
    __typename?: 'UpdateVoiceStepUIHints';
    voiceScript?:
      | ({ __typename?: 'VoiceScriptQL' } & VoiceScriptFieldsFragment)
      | null;
  } | null;
};

export type UploadCustomAudioMutationVariables = Exact<{
  input: UploadCustomAudioInput;
}>;

export type UploadCustomAudioMutation = {
  __typename?: 'Mutations';
  uploadCustomAudio?: {
    __typename?: 'UploadCustomAudio';
    step?:
      | ({
          __typename?: 'AppointmentAgentStepQL';
        } & VoiceStepFields_AppointmentAgentStepQl_Fragment)
      | ({
          __typename?: 'AskYesNoQuestionStepQL';
        } & VoiceStepFields_AskYesNoQuestionStepQl_Fragment)
      | ({
          __typename?: 'AutoAssignStepQL';
        } & VoiceStepFields_AutoAssignStepQl_Fragment)
      | ({
          __typename?: 'CallForwardingStepQL';
        } & VoiceStepFields_CallForwardingStepQl_Fragment)
      | ({
          __typename?: 'CallRecordingStepQL';
        } & VoiceStepFields_CallRecordingStepQl_Fragment)
      | ({
          __typename?: 'CheckBusinessHoursStepQL';
        } & VoiceStepFields_CheckBusinessHoursStepQl_Fragment)
      | ({
          __typename?: 'CheckForLabelStepQL';
        } & VoiceStepFields_CheckForLabelStepQl_Fragment)
      | ({
          __typename?: 'ConversationStateStepQL';
        } & VoiceStepFields_ConversationStateStepQl_Fragment)
      | ({
          __typename?: 'ConversationalSchedulingAgentStepQl';
        } & VoiceStepFields_ConversationalSchedulingAgentStepQl_Fragment)
      | ({
          __typename?: 'GreetingStepQL';
        } & VoiceStepFields_GreetingStepQl_Fragment)
      | ({
          __typename?: 'IntentQuestionQL';
        } & VoiceStepFields_IntentQuestionQl_Fragment)
      | ({
          __typename?: 'LabelConversationStepQL';
        } & VoiceStepFields_LabelConversationStepQl_Fragment)
      | ({
          __typename?: 'NoteTakerStepQL';
        } & VoiceStepFields_NoteTakerStepQl_Fragment)
      | ({
          __typename?: 'OperatorAgentStepQL';
        } & VoiceStepFields_OperatorAgentStepQl_Fragment)
      | ({
          __typename?: 'PickupStepQL';
        } & VoiceStepFields_PickupStepQl_Fragment)
      | ({
          __typename?: 'PressAnyKeyStepQL';
        } & VoiceStepFields_PressAnyKeyStepQl_Fragment)
      | ({
          __typename?: 'QualifyStepQL';
        } & VoiceStepFields_QualifyStepQl_Fragment)
      | ({
          __typename?: 'QuestionBotStepQL';
        } & VoiceStepFields_QuestionBotStepQl_Fragment)
      | ({
          __typename?: 'SmartTopicStepQL';
        } & VoiceStepFields_SmartTopicStepQl_Fragment)
      | ({ __typename?: 'SpeakStepQL' } & VoiceStepFields_SpeakStepQl_Fragment)
      | ({
          __typename?: 'SpecialQuestionQL';
        } & VoiceStepFields_SpecialQuestionQl_Fragment)
      | ({
          __typename?: 'StatusUpdaterStepQL';
        } & VoiceStepFields_StatusUpdaterStepQl_Fragment)
      | ({
          __typename?: 'TextOptinStepQL';
        } & VoiceStepFields_TextOptinStepQl_Fragment)
      | ({
          __typename?: 'VoiceScriptStepQL';
        } & VoiceStepFields_VoiceScriptStepQl_Fragment)
      | null;
    script?: {
      __typename?: 'VoiceScriptQL';
      id: string;
      dirty: boolean;
    } | null;
  } | null;
};

export type AutocompleteConversationFieldsFragment = {
  __typename?: 'ConversationQL';
  id: string;
  lastUpdated?: any | null;
  participant: {
    __typename?: 'ParticipantQL';
    id: string;
    address: string;
    displayName: string;
    displayNameConfidence: ParticipantDataConfidence;
    avatarUrl?: string | null;
    source: Source_Types;
    cnamContact?: {
      __typename?: 'CrmContactCnamQL';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
  };
  place: { __typename?: 'PlaceQL'; id: string; name: string };
};

export type SearchConversationsQueryVariables = Exact<{
  search: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<
    | Array<InputMaybe<ConversationModelSortEnum>>
    | InputMaybe<ConversationModelSortEnum>
  >;
}>;

export type SearchConversationsQuery = {
  __typename?: 'Query';
  autocompleteConversations?: {
    __typename?: 'ConversationConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'ConversationEdge';
      node?:
        | ({
            __typename?: 'ConversationQL';
          } & AutocompleteConversationFieldsFragment)
        | null;
    } | null>;
  } | null;
};

export type SearchParticipantsQueryVariables = Exact<{
  search: Scalars['String']['input'];
  first: Scalars['Int']['input'];
}>;

export type SearchParticipantsQuery = {
  __typename?: 'Query';
  autocompleteParticipants?: {
    __typename?: 'ParticipantConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'ParticipantEdge';
      node?: {
        __typename?: 'ParticipantQL';
        id: string;
        displayName: string;
        address: string;
        source: Source_Types;
        conversations?: {
          __typename?: 'ConversationQLConnection';
          pageInfo: {
            __typename?: 'PageInfo';
            startCursor?: string | null;
            endCursor?: string | null;
            hasNextPage: boolean;
          };
          edges: Array<{
            __typename?: 'ConversationQLEdge';
            node?: {
              __typename?: 'ConversationQL';
              id: string;
              place: { __typename?: 'PlaceQL'; id: string };
            } | null;
          } | null>;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type SearchShortcutsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  searchTag?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type SearchShortcutsQuery = {
  __typename?: 'Query';
  autocompleteShortcuts?: {
    __typename?: 'ShortcutConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'ShortcutEdge';
      node?: {
        __typename?: 'ShortcutQL';
        id: string;
        name: string;
        tag: string;
        content: string;
      } | null;
    } | null>;
  } | null;
};

export type AutoCompleteTeamsFieldsFragment = {
  __typename?: 'TeamConnection';
  pageInfo: {
    __typename?: 'PageInfo';
    startCursor?: string | null;
    endCursor?: string | null;
    hasNextPage: boolean;
  };
  edges: Array<{
    __typename?: 'TeamEdge';
    node?:
      | ({
          __typename?: 'TeamQL';
          place: { __typename?: 'PlaceQL'; id: string; name: string };
        } & TeamFieldsFragment)
      | null;
  } | null>;
};

export type SearchTeamsQueryVariables = Exact<{
  search: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  includeEmptyTeams?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SearchTeamsQuery = {
  __typename?: 'Query';
  autocompleteTeams?:
    | ({ __typename?: 'TeamConnection' } & AutoCompleteTeamsFieldsFragment)
    | null;
};

export type AutoCompleteUsersFieldsFragment = {
  __typename?: 'UserConnection';
  pageInfo: {
    __typename?: 'PageInfo';
    startCursor?: string | null;
    endCursor?: string | null;
    hasNextPage: boolean;
  };
  edges: Array<{
    __typename?: 'UserEdge';
    node?: ({ __typename?: 'UserQL' } & UserItemFieldsFragment) | null;
  } | null>;
};

export type SearchUsersQueryVariables = Exact<{
  search: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SearchUsersQuery = {
  __typename?: 'Query';
  autocompleteUsers?:
    | ({ __typename?: 'UserConnection' } & AutoCompleteUsersFieldsFragment)
    | null;
};

export type CountAllConversationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<AssignmentFilterInput>;
  newerThan?: InputMaybe<Scalars['ArrowField']['input']>;
  sort?: InputMaybe<
    | Array<InputMaybe<ConversationModelSortEnum>>
    | InputMaybe<ConversationModelSortEnum>
  >;
  isOverdue?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CountAllConversationsQuery = {
  __typename?: 'Query';
  conversations?: {
    __typename?: 'ConversationConnection';
    totalCount?: number | null;
  } | null;
};

export type CountAssignedConversationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  newerThan?: InputMaybe<Scalars['ArrowField']['input']>;
  sort?: InputMaybe<
    | Array<InputMaybe<ConversationModelSortEnum>>
    | InputMaybe<ConversationModelSortEnum>
  >;
  hasStatusItems?: InputMaybe<Scalars['Boolean']['input']>;
  isOverdue?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CountAssignedConversationsQuery = {
  __typename?: 'Query';
  conversations?: {
    __typename?: 'ConversationConnection';
    totalCount?: number | null;
  } | null;
};

export type CountFilteredConversationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  inboxId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<AssignmentFilterInput>;
  newerThan?: InputMaybe<Scalars['ArrowField']['input']>;
  sort?: InputMaybe<
    | Array<InputMaybe<ConversationModelSortEnum>>
    | InputMaybe<ConversationModelSortEnum>
  >;
  isOverdue?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CountFilteredConversationsQuery = {
  __typename?: 'Query';
  conversations?: {
    __typename?: 'ConversationConnection';
    totalCount?: number | null;
  } | null;
};

export type CountUnassignedConversationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<AssignmentFilterInput>;
  newerThan?: InputMaybe<Scalars['ArrowField']['input']>;
  sort?: InputMaybe<
    | Array<InputMaybe<ConversationModelSortEnum>>
    | InputMaybe<ConversationModelSortEnum>
  >;
  isOverdue?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CountUnassignedConversationsQuery = {
  __typename?: 'Query';
  conversations?: {
    __typename?: 'ConversationConnection';
    totalCount?: number | null;
  } | null;
};

export type AccountDetailsPlaceFragment = {
  __typename?: 'PlaceQL';
  id: string;
  name: string;
  newConversationsPerDay: number;
  status: Status;
};

export type AccountDetailsPlaceGroupFragment = {
  __typename?: 'PlaceGroupQL';
  id: string;
  name: string;
  places?: {
    __typename?: 'PlaceQLConnection';
    edges: Array<{
      __typename?: 'PlaceQLEdge';
      node?: ({ __typename?: 'PlaceQL' } & AccountDetailsPlaceFragment) | null;
    } | null>;
  } | null;
};

export type AdminSubscriptionFieldsFragment = {
  __typename?: 'SubscriptionQL';
  id: string;
  available: boolean;
  quantity: number;
  sku: {
    __typename?: 'SkuQL';
    id: string;
    skuType: SkuType;
    isActive: boolean;
    name: string;
  };
};

export type AccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  usersAfter?: InputMaybe<Scalars['String']['input']>;
}>;

export type AccountQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'AccountQL';
    id: string;
    name: string;
    status: Status_Types;
    businessVertical?: string | null;
    useNewNumber?: boolean | null;
    placeGroups?: {
      __typename?: 'PlaceGroupQLConnection';
      edges: Array<{
        __typename?: 'PlaceGroupQLEdge';
        node?:
          | ({ __typename?: 'PlaceGroupQL' } & AccountDetailsPlaceGroupFragment)
          | null;
      } | null>;
    } | null;
    users?: {
      __typename?: 'UserConnection';
      pageInfo: {
        __typename?: 'PageInfo';
        startCursor?: string | null;
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
      edges: Array<{
        __typename?: 'UserEdge';
        node?: ({ __typename?: 'UserQL' } & UserDetailFieldsFragment) | null;
      } | null>;
    } | null;
    owners: Array<{
      __typename?: 'UserQL';
      id: string;
      email?: string | null;
      firstName?: string | null;
      lastName?: string | null;
    }>;
    billingIdentity: {
      __typename?: 'BillingIdentityQL';
      id: string;
      signupMode?: string | null;
      subscriptions: Array<
        { __typename?: 'SubscriptionQL' } & AdminSubscriptionFieldsFragment
      >;
    };
  } | null;
};

export type GetAccountOwnersQueryVariables = Exact<{ [key: string]: never }>;

export type GetAccountOwnersQuery = {
  __typename?: 'Query';
  currentAccount?: {
    __typename?: 'AccountQL';
    id: string;
    owners: Array<{
      __typename?: 'UserQL';
      id: string;
      displayName: string;
      fullName?: string | null;
      email?: string | null;
      isAway: boolean;
    }>;
  } | null;
};

export type GetAccountSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAccountSettingsQuery = {
  __typename?: 'Query';
  currentAccount?: {
    __typename?: 'AccountQL';
    id: string;
    assignmentRetention: number;
    nudgesEnabled: boolean;
    nudgesThreshold: number;
    archiveMissedCalls: boolean;
    escalationsEnabled: boolean;
    escalationsThreshold: number;
    hangupSuggestion?: string | null;
    resetOptinDays: number;
    resetOngoingOptin: number;
  } | null;
};

export type AccountsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AccountModelFilter>;
  sort?: InputMaybe<
    Array<InputMaybe<AccountModelSortEnum>> | InputMaybe<AccountModelSortEnum>
  >;
}>;

export type AccountsQuery = {
  __typename?: 'Query';
  accounts?: {
    __typename?: 'AccountConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    edges: Array<{
      __typename?: 'AccountEdge';
      node?: {
        __typename?: 'AccountQL';
        id: string;
        name: string;
        status: Status_Types;
        twilioSubaccountSid?: string | null;
        billingIdentity: {
          __typename?: 'BillingIdentityQL';
          id: string;
          billingOrderId: string;
          subscriptions: Array<{
            __typename?: 'SubscriptionQL';
            id: string;
            quantity: number;
            available: boolean;
            sku: {
              __typename?: 'SkuQL';
              id: string;
              isActive: boolean;
              skuType: SkuType;
              name: string;
            };
          }>;
        };
      } | null;
    } | null>;
  } | null;
};

export type GetActiveInboundPhoneCallsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type GetActiveInboundPhoneCallsQuery = {
  __typename?: 'Query';
  activeInboundPhoneCalls: Array<
    { __typename?: 'PhoneCallQL' } & PhoneCallFieldsFragment
  >;
};

export type GetActiveInboxQueryVariables = Exact<{ [key: string]: never }>;

export type GetActiveInboxQuery = {
  __typename?: 'Query';
  activeInbox?: {
    __typename?: 'ActiveInbox';
    inboxId: string;
    state: ConversationState;
    sort?: InboxSort | null;
    isOverdue?: boolean | null;
    options?: {
      __typename?: 'ActiveInboxOptions';
      unreadOnly?: boolean | null;
    } | null;
  } | null;
};

export type GetActiveIntegrationQueryVariables = Exact<{
  integrationId: Scalars['String']['input'];
}>;

export type GetActiveIntegrationQuery = {
  __typename?: 'Query';
  activeIntegration?: {
    __typename?: 'ActiveIntegrationQL';
    id: string;
    placeId: string;
    pendingOpcodeSync: boolean;
    status: IntegrationStatus;
    configuration: any;
    integration: {
      __typename?: 'AvailableIntegrationQL';
      id: string;
      name: string;
      configurationSchema: any;
      description: string;
      internalId: string;
      categories: Array<string>;
    };
    appointmentAgentSettings: Array<{
      __typename?: 'AppointmentAgentSettingsQL';
      id: string;
      placeId: string;
      name: string;
      settings?: any | null;
    }>;
  } | null;
};

export type GetActiveIntegrationsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetActiveIntegrationsQuery = {
  __typename?: 'Query';
  knownIntegrationCategories: Array<string>;
  availableIntegrations?: Array<{
    __typename?: 'AvailableIntegrationQL';
    id: string;
    name: string;
    description: string;
    categories: Array<string>;
    setupType: SetupType;
    settingsUrl?: string | null;
    featureFlag?: string | null;
    internalId: string;
    configurationSchema: any;
  }> | null;
  activeIntegrations?: Array<{
    __typename?: 'ActiveIntegrationQL';
    id: string;
    integrationId: string;
    status: IntegrationStatus;
    friendlyName: string;
    configuration: any;
  }> | null;
};

export type GetActivePaymentsCollectionQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetActivePaymentsCollectionQuery = {
  __typename?: 'Query';
  activePaymentsCollection?: {
    __typename?: 'ActivePaymentsCollection';
    status: PaymentsFilterType;
    collectionId: string;
  } | null;
};

export type GetAdminPlaceDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetAdminPlaceDetailsQuery = {
  __typename?: 'Query';
  place?:
    | ({
        __typename?: 'PlaceQL';
        billingMetadata?: {
          __typename?: 'BillingMetadataQL';
          id: string;
          hubspotDealId: string;
          hubspotCompanyId?: string | null;
          chargebeeSubscriptionId?: string | null;
          chargebeeCustomerId?: string | null;
        } | null;
        placesUsers?: {
          __typename?: 'PlacesUsersQLConnection';
          pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            startCursor?: string | null;
            endCursor?: string | null;
          };
          edges: Array<{
            __typename?: 'PlacesUsersQLEdge';
            node?: {
              __typename?: 'PlacesUsersQL';
              user: { __typename?: 'UserQL' } & UserDetailFieldsFragment;
            } | null;
          } | null>;
        } | null;
      } & AdminPlaceFieldsFragment)
    | null;
};

export type AllConversationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<AssignmentFilterInput>;
  newerThan?: InputMaybe<Scalars['ArrowField']['input']>;
  sort?: InputMaybe<
    | Array<InputMaybe<ConversationModelSortEnum>>
    | InputMaybe<ConversationModelSortEnum>
  >;
  isOverdue?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AllConversationsQuery = {
  __typename?: 'Query';
  conversations?: {
    __typename?: 'ConversationConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'ConversationEdge';
      node?:
        | ({ __typename?: 'ConversationQL' } & ConversationItemStubFragment)
        | null;
    } | null>;
  } | null;
};

export type GetAppointmentAgentSettingsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetAppointmentAgentSettingsQuery = {
  __typename?: 'Query';
  appointmentAgentSettings?:
    | ({
        __typename: 'AppointmentAgentSettingsQL';
        id: string;
        name: string;
        placeId: string;
        activeIntegration?:
          | ({
              __typename?: 'ActiveIntegrationQL';
            } & AppointmentAgentSettingsActiveIntegrationFieldsFragment)
          | null;
        latestSchedulerSync?: {
          __typename?: 'SchedulerSyncQL';
          id: string;
          endDate?: any | null;
        } | null;
        place?:
          | ({
              __typename?: 'PlaceQL';
            } & AppointmentAgentSettingsPlaceFieldsFragment)
          | null;
      } & AppointmentAgentSettingsFieldsFragment)
    | null;
};

export type GetAppointmentAgentSettingsUseQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetAppointmentAgentSettingsUseQuery = {
  __typename?: 'Query';
  voiceStepConversationalSchedulingAgent?: {
    __typename?: 'ConversationalSchedulingAgentStepQl';
    id: string;
  } | null;
};

export type GetAppointmentAgentsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetAppointmentAgentsQuery = {
  __typename?: 'Query';
  appointmentAgents: Array<{
    __typename?: 'AppointmentAgentSettingsQL';
    id: string;
    name: string;
    lastUpdated?: any | null;
    placeId: string;
    activeIntegration?: {
      __typename?: 'ActiveIntegrationQL';
      id: string;
      pendingOpcodeSync: boolean;
      integration: {
        __typename?: 'AvailableIntegrationQL';
        id: string;
        internalId: string;
      };
    } | null;
  }>;
};

export type AssignedConversationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  newerThan?: InputMaybe<Scalars['ArrowField']['input']>;
  sort?: InputMaybe<
    | Array<InputMaybe<ConversationModelSortEnum>>
    | InputMaybe<ConversationModelSortEnum>
  >;
  hasStatusItems?: InputMaybe<Scalars['Boolean']['input']>;
  isOverdue?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AssignedConversationsQuery = {
  __typename?: 'Query';
  conversations?: {
    __typename?: 'ConversationConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'ConversationEdge';
      node?:
        | ({ __typename?: 'ConversationQL' } & ConversationItemStubFragment)
        | null;
    } | null>;
  } | null;
};

export type GetAssignmentRetentionChoicesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAssignmentRetentionChoicesQuery = {
  __typename?: 'Query';
  currentAccount?: {
    __typename?: 'AccountQL';
    id: string;
    assignmentRetentionChoices?: Array<{
      __typename?: 'AssignmentRetentionChoiceQL';
      label?: string | null;
      value?: number | null;
    }> | null;
  } | null;
};

export type GetAssignmentRoutingSettingsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export type GetAssignmentRoutingSettingsQuery = {
  __typename?: 'Query';
  assignmentRoutingSettings?: {
    __typename?: 'AssignmentRoutingSettingQL';
    id: string;
    forwardingMdn?: string | null;
    enabledDuringBusinessHours: boolean;
    enabledAfterBusinessHours: boolean;
    enabledWhenAway: boolean;
    callTimeout: number;
    useNumaCallerId: boolean;
  } | null;
};

export type GetAttachmentByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetAttachmentByIdQuery = {
  __typename?: 'Query';
  attachment?:
    | ({
        __typename?: 'AssignmentDetailsAttachment';
      } & AttachmentItemFields_AssignmentDetailsAttachment_Fragment)
    | ({
        __typename?: 'FileAttachment';
      } & AttachmentItemFields_FileAttachment_Fragment)
    | ({
        __typename?: 'ImageAttachment';
      } & AttachmentItemFields_ImageAttachment_Fragment)
    | ({
        __typename?: 'MultiChoiceAttachment';
      } & AttachmentItemFields_MultiChoiceAttachment_Fragment)
    | ({
        __typename?: 'NoteAttachment';
      } & AttachmentItemFields_NoteAttachment_Fragment)
    | ({
        __typename?: 'OpenVoiceQuestionAttachment';
      } & AttachmentItemFields_OpenVoiceQuestionAttachment_Fragment)
    | ({
        __typename?: 'ReviewAttachment';
      } & AttachmentItemFields_ReviewAttachment_Fragment)
    | ({
        __typename?: 'SmartTopicAttachment';
      } & AttachmentItemFields_SmartTopicAttachment_Fragment)
    | ({
        __typename?: 'TranslatedMessage';
      } & AttachmentItemFields_TranslatedMessage_Fragment)
    | ({
        __typename?: 'VCardAttachment';
      } & AttachmentItemFields_VCardAttachment_Fragment)
    | ({
        __typename?: 'VideoUploadLinkAttachment';
      } & AttachmentItemFields_VideoUploadLinkAttachment_Fragment)
    | ({
        __typename?: 'YelpAttachment';
      } & AttachmentItemFields_YelpAttachment_Fragment)
    | null;
};

export type GetAutomationByIdQueryVariables = Exact<{
  automationId: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetAutomationByIdQuery = {
  __typename?: 'Query';
  automation?:
    | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
    | null;
};

export type GetAutomationsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetAutomationsQuery = {
  __typename?: 'Query';
  automations?: {
    __typename?: 'AutomationConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'AutomationEdge';
      node?:
        | ({ __typename?: 'AutomationQL' } & AutomationFieldsFragment)
        | null;
    } | null>;
  } | null;
};

export type GetAutopilotForConversationQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;

export type GetAutopilotForConversationQuery = {
  __typename?: 'Query';
  autopilot?: ({ __typename?: 'AutopilotQL' } & AutopilotFieldsFragment) | null;
};

export type GetAutopilotJobQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetAutopilotJobQuery = {
  __typename?: 'Query';
  autopilotJob?: {
    __typename?: 'AutopilotJobQL';
    id: string;
    welcome?: string | null;
    inspection?: string | null;
    service?: string | null;
    qualityControl?: string | null;
    pickup?: string | null;
  } | null;
};

export type GetAvailableVoiceScriptsForPlaceQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetAvailableVoiceScriptsForPlaceQuery = {
  __typename?: 'Query';
  availableVoiceScripts?: Array<{
    __typename?: 'AvailableVoiceScript';
    scriptType: string;
    previewScript: Array<string>;
    scriptSteps: Array<{
      __typename?: 'AvailableVoiceStep';
      label: string;
      canToggle: boolean;
    }>;
  }> | null;
};

export type GetAwayModeStatusQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type GetAwayModeStatusQuery = {
  __typename?: 'Query';
  user?: ({ __typename?: 'UserQL' } & AwayModeDetailsFieldsFragment) | null;
};

export type BillingIdentitiesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BillingIdentityModelFilter>;
  sort?: InputMaybe<
    | Array<InputMaybe<BillingIdentityModelSortEnum>>
    | InputMaybe<BillingIdentityModelSortEnum>
  >;
}>;

export type BillingIdentitiesQuery = {
  __typename?: 'Query';
  billingIdentities?: {
    __typename?: 'BillingIdentityConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    edges: Array<{
      __typename?: 'BillingIdentityEdge';
      node?: {
        __typename?: 'BillingIdentityQL';
        id: string;
        billingOrderId: string;
        eulaAcceptanceDate?: any | null;
        email: string;
        name?: string | null;
        source: string;
        subscriptions: Array<{
          __typename?: 'SubscriptionQL';
          id: string;
          quantity: number;
          available: boolean;
          sku: {
            __typename?: 'SkuQL';
            id: string;
            isActive: boolean;
            name: string;
            skuType: SkuType;
          };
        }>;
      } | null;
    } | null>;
  } | null;
};

export type GetCallRecordsQueryVariables = Exact<{
  placeIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  userIds?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  createdBefore?: InputMaybe<Scalars['ArrowField']['input']>;
  createdAfter?: InputMaybe<Scalars['ArrowField']['input']>;
  onlyCallIntelligenceEligible?: InputMaybe<Scalars['Boolean']['input']>;
  callDirection?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCallRecordsQuery = {
  __typename?: 'Query';
  callRecords?: {
    __typename?: 'CallRecordConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'CallRecordEdge';
      node?: {
        __typename?: 'CallRecordQL';
        id: string;
        callType: string;
        createdOn: any;
        callDuration?: number | null;
        placeName?: string | null;
        returnCallsRoutingOutcome?: string | null;
        staffDisplayName?: string | null;
        customerDisplayName?: string | null;
        customerPhoneNumber?: string | null;
        transcript?: {
          __typename?: 'TranscriptQL';
          id: string;
          subject?: string | null;
          summary?: string | null;
          analysis?: {
            __typename?: 'TranscriptAnalysisQL';
            id: string;
            scores?: Array<{
              __typename?: 'TranscriptScoreQL';
              id: string;
              name: string;
              rating: number;
            }> | null;
          } | null;
        } | null;
      } | null;
    } | null>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      endCursor?: string | null;
    };
  } | null;
};

export type GetChannelByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetChannelByIdQuery = {
  __typename?: 'Query';
  channel?:
    | ({
        __typename?: 'BandwidthChannelQL';
      } & ChannelFields_BandwidthChannelQl_Fragment)
    | ({ __typename?: 'BaseChannel' } & ChannelFields_BaseChannel_Fragment)
    | ({
        __typename?: 'FacebookChannelQL';
      } & ChannelFields_FacebookChannelQl_Fragment)
    | ({
        __typename?: 'GoogleChannelQL';
      } & ChannelFields_GoogleChannelQl_Fragment)
    | ({ __typename?: 'NoteChannelQL' } & ChannelFields_NoteChannelQl_Fragment)
    | ({
        __typename?: 'NumboxChannelQL';
      } & ChannelFields_NumboxChannelQl_Fragment)
    | ({
        __typename?: 'TwilioChannelQL';
      } & ChannelFields_TwilioChannelQl_Fragment)
    | null;
};

export type ChannelsQueryVariables = Exact<{
  placeId?: InputMaybe<Scalars['String']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ChannelsQuery = {
  __typename?: 'Query';
  channels?: Array<
    | ({
        __typename?: 'BandwidthChannelQL';
      } & ChannelFields_BandwidthChannelQl_Fragment)
    | ({ __typename?: 'BaseChannel' } & ChannelFields_BaseChannel_Fragment)
    | ({
        __typename?: 'FacebookChannelQL';
      } & ChannelFields_FacebookChannelQl_Fragment)
    | ({
        __typename?: 'GoogleChannelQL';
      } & ChannelFields_GoogleChannelQl_Fragment)
    | ({ __typename?: 'NoteChannelQL' } & ChannelFields_NoteChannelQl_Fragment)
    | ({
        __typename?: 'NumboxChannelQL';
      } & ChannelFields_NumboxChannelQl_Fragment)
    | ({
        __typename?: 'TwilioChannelQL';
      } & ChannelFields_TwilioChannelQl_Fragment)
    | null
  > | null;
};

export type GetChargeBeeSubscriptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetChargeBeeSubscriptionsQuery = {
  __typename?: 'Query';
  chargebeeSubscriptions?: Array<{
    __typename?: 'ChargeBeeSubscription';
    trialDaysLeft?: number | null;
    dueSince: number;
    billingStatus: BillingStatus;
    cardInfo?: {
      __typename?: 'CardInfo';
      type?: string | null;
      last4?: string | null;
      cardStatus?: CardStatus | null;
    } | null;
  } | null> | null;
};

export type GetComplianceReminderQueryVariables = Exact<{
  isNewConversation?: InputMaybe<Scalars['Boolean']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetComplianceReminderQuery = {
  __typename?: 'Query';
  complianceReminder?: {
    __typename?: 'ComplianceReminder';
    guidelinesReminder?: string | null;
  } | null;
};

export type GetConversationByIdQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
  withLastAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  withLastChannel?: InputMaybe<Scalars['Boolean']['input']>;
  withLastRepairOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetConversationByIdQuery = {
  __typename?: 'Query';
  conversation?:
    | ({ __typename?: 'ConversationQL' } & ConversationItemFieldsFragment)
    | null;
};

export type GetConversationByPhoneNumberAndPlaceQueryVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  withLastAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  withLastChannel?: InputMaybe<Scalars['Boolean']['input']>;
  withLastRepairOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetConversationByPhoneNumberAndPlaceQuery = {
  __typename?: 'Query';
  conversationByPhoneNumberAndPlace?:
    | ({ __typename?: 'ConversationQL' } & ConversationItemFieldsFragment)
    | null;
};

export type GetCubeTokenQueryVariables = Exact<{ [key: string]: never }>;

export type GetCubeTokenQuery = {
  __typename?: 'Query';
  cube?: {
    __typename?: 'CubeJwtTokenQL';
    cubeJwtToken: string;
    cubeApiHost: string;
  } | null;
  currentAccount?: { __typename?: 'AccountQL'; id: string } | null;
};

export type GetCurbsideSettingsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetCurbsideSettingsQuery = {
  __typename?: 'Query';
  place?: {
    __typename?: 'PlaceQL';
    id: string;
    curbsideSettings?: {
      __typename?: 'CurbsideSettingsQL';
      enabled: boolean;
      orderIdentifierType?: PlaceOrderIdType | null;
      orderIdentifierIntentResponse?: string | null;
      customHereIsAutoreply?: boolean | null;
      handoffMethod?: PlaceHandoffMethod | null;
      handoffMethodIntentResponse?: string | null;
      customHandoffIsAutoreply?: boolean | null;
    } | null;
  } | null;
};

export type GetCurrentAccountLegacyQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCurrentAccountLegacyQuery = {
  __typename?: 'Query';
  currentAccount?: {
    __typename?: 'AccountQL';
    id: string;
    createdOn: any;
    name: string;
    useNewNumber?: boolean | null;
    businessVertical?: string | null;
    billingIdentity: {
      __typename?: 'BillingIdentityQL';
      id: string;
      brand?: string | null;
      billingOrderId: string;
      paymentSource: PaymentSource;
    };
  } | null;
};

export type GetCurrentUserQueryVariables = Exact<{
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetCurrentUserQuery = {
  __typename?: 'Query';
  currentUser?:
    | ({
        __typename?: 'UserQL';
        mdn?: string | null;
        jobRole?: JobRoleInput | null;
        jobTitle?: string | null;
        participantId?: string | null;
        videoConferenceUrl?: string | null;
        signaturePreference: SignaturePreferences;
        hasStatusItems: boolean;
        hasExternalIdentity: boolean;
        overdueConversationsPollingIntervalMsec: number;
        accountPermissions?: Array<{
          __typename?: 'AccountPermissionsQL';
          accountId: string;
          permissions: Array<string>;
        }>;
        placePermissions?: Array<{
          __typename?: 'PlacePermissionsQL';
          placeId: string;
          permissions: Array<string>;
        }>;
        viewPreferences: {
          __typename?: 'UserViewPreferences';
        } & UserViewPreferencesFieldsFragment;
      } & UserItemAndNotificationFieldsFragment &
        AwayModeFieldsFragment &
        InboxBehaviourFieldsFragment)
    | null;
  skuEntitlements?:
    | ({ __typename?: 'SkuEntitlementsQL' } & SkuEntitlementsFieldsFragment)
    | null;
};

export type GetDmsObjectHistoryQueryVariables = Exact<{
  numaObjectId: Scalars['String']['input'];
  dmsType: DmsHistoryType;
}>;

export type GetDmsObjectHistoryQuery = {
  __typename?: 'Query';
  dmsObjectHistory?: {
    __typename?: 'DMSHistoryConnection';
    lastData?: any | null;
  } | null;
};

export type GetExternalVehiclesQueryVariables = Exact<{
  appointmentAgentSettingsId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetExternalVehiclesQuery = {
  __typename?: 'Query';
  externalVehicles?: {
    __typename?: 'ExternalVehicleConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'ExternalVehicleEdge';
      node?: {
        __typename?: 'ExternalVehicleQL';
        id: string;
        make: string;
        model: string;
        year: number;
        overrides?: Array<{
          __typename?: 'ExternalVehicleOverrideQL';
          type: string;
          numaServiceName: string;
          opcodes?: Array<{
            __typename?: 'ExternalOpcodeQL';
            id: string;
            serviceName: string;
            dmsId: string;
          } | null> | null;
        } | null> | null;
      } | null;
    } | null>;
  } | null;
};

export type FilteredConversationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  inboxId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<AssignmentFilterInput>;
  newerThan?: InputMaybe<Scalars['ArrowField']['input']>;
  sort?: InputMaybe<
    | Array<InputMaybe<ConversationModelSortEnum>>
    | InputMaybe<ConversationModelSortEnum>
  >;
  isOverdue?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type FilteredConversationsQuery = {
  __typename?: 'Query';
  conversations?: {
    __typename?: 'ConversationConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'ConversationEdge';
      node?:
        | ({ __typename?: 'ConversationQL' } & ConversationItemStubFragment)
        | null;
    } | null>;
  } | null;
};

export type GetGuideChecklistQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetGuideChecklistQuery = {
  __typename?: 'Query';
  guideChecklist?: {
    __typename?: 'GuideChecklistQL';
    hasCallForwarding: boolean;
    hasDismissedGuideChecklist: boolean;
    textingPhonelines: Array<{
      __typename?: 'PhoneLineQL';
      id: string;
      mdn: string;
      lineType?: PhoneLineType | null;
      carrierName?: string | null;
      hostedSmsPort?: { __typename?: 'HostedSmsPortQL'; status: string } | null;
    }>;
  } | null;
};

export type GetHostedSmsPortsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetHostedSmsPortsQuery = {
  __typename?: 'Query';
  hostedSmsPorts?: Array<
    ({ __typename?: 'HostedSmsPortQL' } & HostedSmsPortFieldsFragment) | null
  > | null;
};

export type GetIdentityPromptAddressesQueryVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;

export type GetIdentityPromptAddressesQuery = {
  __typename?: 'Query';
  identityPromptAddresses: Array<{
    __typename?: 'IdentityPromptAddressQL';
    id: string;
    createdOn: any;
    address: string;
    channelId?: string | null;
    createdBy: {
      __typename?: 'ParticipantQL';
      id: string;
      displayName: string;
    };
  }>;
};

export type GetLabelsForPlaceQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetLabelsForPlaceQuery = {
  __typename?: 'Query';
  labels?: Array<
    ({ __typename?: 'LabelQL' } & LabelFieldsFragment) | null
  > | null;
};

export type MentionedConversationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type MentionedConversationsQuery = {
  __typename?: 'Query';
  mentionedConversations?: {
    __typename?: 'ConversationConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'ConversationEdge';
      node?:
        | ({
            __typename?: 'ConversationQL';
            lastMentionedTimestamp?: any | null;
            amIMentioned: boolean;
          } & ConversationItemStubFragment)
        | null;
    } | null>;
  } | null;
};

export type GetMessageMetadataQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetMessageMetadataQuery = {
  __typename?: 'Query';
  messageMetadata?: {
    __typename?: 'MessageMetadataQL';
    name?: string | null;
    mdn?: string | null;
  } | null;
};

export type MyInboxesQueryVariables = Exact<{ [key: string]: never }>;

export type MyInboxesQuery = {
  __typename?: 'Query';
  myInboxes?: {
    __typename?: 'InboxConnection';
    totalConversations?: number | null;
    totalUnassigned?: number | null;
    conversationsAssignedToMe?: number | null;
    conversationMentions?: number | null;
    hideSharedInboxViews?: boolean | null;
    statusBoardView?: boolean | null;
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'InboxEdge';
      node?: {
        __typename?: 'InboxQL';
        id: string;
        conversationCount?: number | null;
        place: {
          __typename?: 'PlaceQL';
          id: string;
          name: string;
          escalationsEnabled: boolean;
          escalationsThreshold: number;
        };
      } | null;
    } | null>;
  } | null;
};

export type NewerConversationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  newerThan?: InputMaybe<Scalars['ArrowField']['input']>;
  withLastAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  withLastChannel?: InputMaybe<Scalars['Boolean']['input']>;
  withLastRepairOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type NewerConversationsQuery = {
  __typename?: 'Query';
  conversations?: {
    __typename?: 'ConversationConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'ConversationEdge';
      node?:
        | ({ __typename?: 'ConversationQL' } & ConversationItemFieldsFragment)
        | null;
    } | null>;
  } | null;
};

export type GetNoteTakerQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetNoteTakerQuery = {
  __typename?: 'Query';
  noteTaker?: ({ __typename?: 'NoteTakerQL' } & NoteTakerFieldsFragment) | null;
};

export type GetNoteTakersQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  placeId: Scalars['String']['input'];
}>;

export type GetNoteTakersQuery = {
  __typename?: 'Query';
  noteTakers?: {
    __typename?: 'NoteTakerConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'NoteTakerEdge';
      node?: ({ __typename?: 'NoteTakerQL' } & NoteTakerFieldsFragment) | null;
    } | null>;
  } | null;
};

export type GetNumaServicesQueryVariables = Exact<{
  appointmentAgentSettingsId: Scalars['String']['input'];
}>;

export type GetNumaServicesQuery = {
  __typename?: 'Query';
  numaServices?: Array<{
    __typename?: 'NumaServiceQL';
    id: string;
    name: string;
    description: string;
    manualCodeSelection?: boolean | null;
    howIsHandled?: string | null;
  }> | null;
};

export type GetOutboundCallCustomizationAudioQueryVariables = Exact<{
  id: Scalars['String']['input'];
  audioField: Scalars['String']['input'];
}>;

export type GetOutboundCallCustomizationAudioQuery = {
  __typename?: 'Query';
  outboundCallCustomizationAudio?: string | null;
};

export type GetOutboundConferenceCallQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetOutboundConferenceCallQuery = {
  __typename?: 'Query';
  outboundConferenceCall?:
    | ({
        __typename?: 'OutboundConferenceCallQL';
      } & OutboundConferenceCallFieldsFragment)
    | null;
};

export type GetOutboundConferenceCallByUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type GetOutboundConferenceCallByUserQuery = {
  __typename?: 'Query';
  outboundConferenceCalls?: Array<
    | ({
        __typename?: 'OutboundConferenceCallQL';
      } & OutboundConferenceCallFieldsFragment)
    | null
  > | null;
};

export type GetOutboundPhoneChannelsQueryVariables = Exact<{
  placeId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetOutboundPhoneChannelsQuery = {
  __typename?: 'Query';
  outboundPhoneChannels?: Array<
    | ({
        __typename?: 'BandwidthChannelQL';
      } & ChannelFields_BandwidthChannelQl_Fragment)
    | ({ __typename?: 'BaseChannel' } & ChannelFields_BaseChannel_Fragment)
    | ({
        __typename?: 'FacebookChannelQL';
      } & ChannelFields_FacebookChannelQl_Fragment)
    | ({
        __typename?: 'GoogleChannelQL';
      } & ChannelFields_GoogleChannelQl_Fragment)
    | ({ __typename?: 'NoteChannelQL' } & ChannelFields_NoteChannelQl_Fragment)
    | ({
        __typename?: 'NumboxChannelQL';
      } & ChannelFields_NumboxChannelQl_Fragment)
    | ({
        __typename?: 'TwilioChannelQL';
      } & ChannelFields_TwilioChannelQl_Fragment)
    | null
  > | null;
};

export type GetOutboundProxyCallStatusQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetOutboundProxyCallStatusQuery = {
  __typename?: 'Query';
  outboundProxyCall?: {
    __typename?: 'OutboundProxyCallQL';
    id: string;
    callStatus?: string | null;
    isBeingRecorded: boolean;
    startTime?: any | null;
  } | null;
};

export type GetParticipantVideoUploadLinksQueryVariables = Exact<{
  participantId: Scalars['String']['input'];
}>;

export type GetParticipantVideoUploadLinksQuery = {
  __typename?: 'Query';
  participantVideoUploadLinks?: Array<
    | ({ __typename?: 'VideoUploadLinkQL' } & VideoUploadLinkFieldsFragment)
    | null
  > | null;
};

export type GetPaymentReceiptMessageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetPaymentReceiptMessageQuery = {
  __typename?: 'Query';
  paymentRequest?: {
    __typename?: 'PaymentRequestQL';
    id: string;
    receiptMessage?: string | null;
  } | null;
};

export type GetPaymentRequestQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetPaymentRequestQuery = {
  __typename?: 'Query';
  paymentRequest?:
    | ({ __typename?: 'PaymentRequestQL' } & PaymentRequestFieldsFragment)
    | null;
};

export type GetPaymentRequestCustomizationQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetPaymentRequestCustomizationQuery = {
  __typename?: 'Query';
  paymentRequestCustomization?: {
    __typename?: 'PaymentRequestCustomizationQL';
    id: string;
    placeId: string;
    createTemplate: string;
    renderedCreateTemplate: string;
    createAutoSend: boolean;
    createHoldTemplate: string;
    renderedCreateHoldTemplate: string;
    createHoldAutoSend: boolean;
    successTemplate: string;
    renderedSuccessTemplate: string;
    successAutoSend: boolean;
    refundTemplate: string;
    renderedRefundTemplate: string;
    refundAutoSend: boolean;
    partialRefundTemplate: string;
    renderedPartialRefundTemplate: string;
    partialRefundAutoSend: boolean;
    canceledTemplate: string;
    renderedCanceledTemplate: string;
    canceledAutoSend: boolean;
  } | null;
};

export type GetPaymentRequestsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  senderId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PaymentRequestModelFilter>;
}>;

export type GetPaymentRequestsQuery = {
  __typename?: 'Query';
  paymentRequests?: {
    __typename?: 'PaymentRequestConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'PaymentRequestEdge';
      node?:
        | ({
            __typename?: 'PaymentRequestQL';
          } & PaymentRequestStubFieldsFragment)
        | null;
    } | null>;
  } | null;
};

export type GetPhoneLinePolicyQueryVariables = Exact<{
  phoneLinePolicyId: Scalars['String']['input'];
}>;

export type GetPhoneLinePolicyQuery = {
  __typename?: 'Query';
  phoneLinePolicy?:
    | ({ __typename?: 'PhoneLinePolicyQL' } & PhoneLinePolicyFieldsFragment)
    | null;
};

export type GetPhonelineQueryVariables = Exact<{
  phonelineId: Scalars['String']['input'];
  withVoiceChannel?: InputMaybe<Scalars['Boolean']['input']>;
  withSMSChannel?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetPhonelineQuery = {
  __typename?: 'Query';
  phoneline?:
    | ({
        __typename?: 'PhoneLineQL';
        speechLanguage?: Language | null;
        allowedSpeechLanguages: Array<Language>;
        overridesInboxLanguage: boolean;
      } & PhoneLineWithChannelsFieldsFragment)
    | null;
};

export type GetPhonelinesQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
  withVoiceChannel?: InputMaybe<Scalars['Boolean']['input']>;
  withSMSChannel?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetPhonelinesQuery = {
  __typename?: 'Query';
  phonelines?: Array<
    | ({ __typename?: 'PhoneLineQL' } & PhoneLineWithChannelsFieldsFragment)
    | null
  > | null;
  place?: {
    __typename?: 'PlaceQL';
    id: string;
    departmentPhoneLinePolicy: { __typename?: 'PhoneLinePolicyQL'; id: string };
    staffPhoneLinePolicy: { __typename?: 'PhoneLinePolicyQL'; id: string };
  } | null;
};

export type GetPlaceBrandThemeQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetPlaceBrandThemeQuery = {
  __typename?: 'Query';
  place?: {
    __typename?: 'PlaceQL';
    id: string;
    externalName: string;
    inboxType: string;
  } | null;
  brandTheme?:
    | ({ __typename?: 'BrandThemeQL' } & BrandThemeFieldsFragment)
    | null;
};

export type GetPlaceByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetPlaceByIdQuery = {
  __typename?: 'Query';
  place?: {
    __typename?: 'PlaceQL';
    id: string;
    name: string;
    externalName: string;
    hours?: any | null;
    messagingHours?: any | null;
    useMessagingHours: boolean;
    businessTz?: string | null;
    businessProfileId?: string | null;
    escalationsEnabled: boolean;
    escalationsThreshold: number;
    speechLanguage: Language;
    allowedSpeechLanguages: Array<Language>;
  } | null;
};

export type GetPlaceDisruptionScriptsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetPlaceDisruptionScriptsQuery = {
  __typename?: 'Query';
  place?: {
    __typename?: 'PlaceQL';
    id: string;
    disruptions?: {
      __typename?: 'DisruptionsQL';
      id: string;
      disruptionDepartmentVoiceScript?:
        | ({ __typename?: 'VoiceScriptQL' } & VoiceScriptFieldsFragment)
        | null;
      draftDisruptionDepartmentVoiceScript?:
        | ({ __typename?: 'VoiceScriptQL' } & VoiceScriptFieldsFragment)
        | null;
      holidayDepartmentVoiceScript?:
        | ({ __typename?: 'VoiceScriptQL' } & VoiceScriptFieldsFragment)
        | null;
      draftHolidayDepartmentVoiceScript?:
        | ({ __typename?: 'VoiceScriptQL' } & VoiceScriptFieldsFragment)
        | null;
    } | null;
  } | null;
};

export type GetPlaceDisruptionSettingsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetPlaceDisruptionSettingsQuery = {
  __typename?: 'Query';
  place?: {
    __typename?: 'PlaceQL';
    id: string;
    answeringMode: AnsweringMode;
    answeringModeFrom?: any | null;
    answeringModeUntil?: any | null;
    disruptions?: {
      __typename?: 'DisruptionsQL';
      id: string;
      disruptionsGreeting: string;
      disruptionsActive?: boolean | null;
      disruptionDepartmentVoiceScriptId: string;
      draftDisruptionDepartmentVoiceScriptId: string;
      holidayDepartmentVoiceScriptId: string;
      draftHolidayDepartmentVoiceScriptId: string;
    } | null;
  } | null;
};

export type GetPlaceMfaSettingsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetPlaceMfaSettingsQuery = {
  __typename?: 'Query';
  place?: { __typename?: 'PlaceQL'; id: string; enforceMfa: EnforceMfa } | null;
};

export type GetPlaceGroupDetailsQueryVariables = Exact<{
  placeGroupId: Scalars['String']['input'];
}>;

export type GetPlaceGroupDetailsQuery = {
  __typename?: 'Query';
  placeGroup?: {
    __typename: 'PlaceGroupQL';
    id: string;
    name: string;
    account: { __typename?: 'AccountQL'; id: string; name: string };
    places?: {
      __typename?: 'PlaceQLConnection';
      edges: Array<{
        __typename?: 'PlaceQLEdge';
        node?: {
          __typename?: 'PlaceQL';
          id: string;
          name: string;
          status: Status;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetPlaceGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PlaceGroupModelFilter>;
  sort?: InputMaybe<
    | Array<InputMaybe<PlaceGroupModelSortEnum>>
    | InputMaybe<PlaceGroupModelSortEnum>
  >;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetPlaceGroupsQuery = {
  __typename?: 'Query';
  placeGroups?: {
    __typename?: 'PlaceGroupConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    edges: Array<{
      __typename?: 'PlaceGroupEdge';
      node?: {
        __typename: 'PlaceGroupQL';
        id: string;
        name: string;
        account: { __typename?: 'AccountQL'; id: string; name: string };
      } | null;
    } | null>;
  } | null;
};

export type GetPlaceManagersQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetPlaceManagersQuery = {
  __typename?: 'Query';
  place?: {
    __typename?: 'PlaceQL';
    id: string;
    managers?: Array<{
      __typename?: 'UserQL';
      id: string;
      displayName: string;
      isAway: boolean;
    } | null> | null;
  } | null;
};

export type GetPlaceNamePronunciationQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetPlaceNamePronunciationQuery = {
  __typename?: 'Query';
  place?: {
    __typename?: 'PlaceQL';
    id: string;
    namePronunciation?: string | null;
    namePronunciationUrl?: string | null;
  } | null;
};

export type GetPlaceNewConversationLimitQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetPlaceNewConversationLimitQuery = {
  __typename?: 'Query';
  place?: {
    __typename?: 'PlaceQL';
    id: string;
    newConversationsPerDay: number;
    outboundConversationsToday?: number | null;
  } | null;
};

export type GetPlaceOutboundCallSettingsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetPlaceOutboundCallSettingsQuery = {
  __typename?: 'Query';
  place?: {
    __typename?: 'PlaceQL';
    id: string;
    outboundCallSettings?: Array<{
      __typename?: 'OutboundCallSettingQL';
      id: string;
      mdn?: string | null;
    }> | null;
  } | null;
};

export type PlacesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PlacesQuery = {
  __typename?: 'Query';
  places?: {
    __typename?: 'PlaceConnection';
    edges: Array<{
      __typename?: 'PlaceEdge';
      node?: { __typename?: 'PlaceQL'; id: string; name: string } | null;
    } | null>;
  } | null;
};

export type PlacesAdminQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<
    Array<InputMaybe<PlaceModelSortEnum>> | InputMaybe<PlaceModelSortEnum>
  >;
}>;

export type PlacesAdminQuery = {
  __typename?: 'Query';
  places?: {
    __typename?: 'PlaceConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    edges: Array<{
      __typename?: 'PlaceEdge';
      node?: {
        __typename?: 'PlaceQL';
        id: string;
        name: string;
        account: { __typename?: 'AccountQL'; id: string; name: string };
      } | null;
    } | null>;
  } | null;
};

export type GetPlacesDegradedInboxExperienceStateQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;

export type GetPlacesDegradedInboxExperienceStateQuery = {
  __typename?: 'Query';
  places?: {
    __typename?: 'PlaceConnection';
    edges: Array<{
      __typename?: 'PlaceEdge';
      node?: {
        __typename?: 'PlaceQL';
        id: string;
        hasDegradedInboxExperience?: boolean | null;
      } | null;
    } | null>;
  } | null;
};

export type PlacesUsersQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type PlacesUsersQuery = {
  __typename?: 'Query';
  placesUsers?: Array<{
    __typename?: 'PlacesUsersQL';
    id: string;
    placeId: string;
    receivesEscalations: boolean;
    userId: string;
    role: string;
    user: { __typename?: 'UserQL'; email?: string | null; displayName: string };
  } | null> | null;
};

export type PlacesUsersForCallIntelligenceQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type PlacesUsersForCallIntelligenceQuery = {
  __typename?: 'Query';
  placesUsers?: Array<{
    __typename?: 'PlacesUsersQL';
    id: string;
    placeId: string;
    userId: string;
    role: string;
    callIntelligenceEnabled: boolean;
    user: { __typename?: 'UserQL'; displayName: string };
  } | null> | null;
};

export type GetPubnubConfigQueryVariables = Exact<{ [key: string]: never }>;

export type GetPubnubConfigQuery = {
  __typename?: 'Query';
  pubnub?: {
    __typename?: 'PubNubConfigQL';
    userId: string;
    userParticipantId: string;
    pamToken: string;
    channels: Array<string | null>;
    channelGroups: Array<string | null>;
    pushChannels: Array<string | null>;
    browserPushChannels: Array<string | null>;
    subscribeKey: string;
    publishKey: string;
    deviceToken: string;
  } | null;
};

export type GetquestionAgentSettingsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetquestionAgentSettingsQuery = {
  __typename?: 'Query';
  questionAgentSettings?: {
    __typename?: 'QuestionAgentSettingsQL';
    id: string;
    name: string;
    settings?: any | null;
  } | null;
};

export type GetQuestionAgentsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetQuestionAgentsQuery = {
  __typename?: 'Query';
  questionAgents: Array<{
    __typename?: 'QuestionAgentSettingsQL';
    id: string;
    name: string;
    placeId: string;
  }>;
};

export type GetRepairServicesQueryVariables = Exact<{
  activeIntegrationId: Scalars['String']['input'];
}>;

export type GetRepairServicesQuery = {
  __typename?: 'Query';
  repairServices?: Array<{
    __typename?: 'RepairServiceQL';
    id: string;
    name: string;
    enabledSupportedVehiclesCount: number;
    disabledSupportedVehiclesCount: number;
  }> | null;
};

export type GetReviewJobQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetReviewJobQuery = {
  __typename?: 'Query';
  reviewJob?: {
    __typename?: 'ReviewJobQL';
    id: string;
    placeId: string;
    fallbackChannelId?: string | null;
    buttonTextColor?: string | null;
    buttonColor?: string | null;
    headerColor?: string | null;
    headerTextColor?: string | null;
    backgroundColor?: string | null;
    textColor?: string | null;
    logoUrl?: string | null;
    messageBody: string;
    messageImageUrl?: string | null;
    renderedMessageBody: string;
    skipRatingsScreen?: boolean | null;
    reviewMode: ReviewMode;
    place: { __typename?: 'PlaceQL'; id: string; externalName: string };
    reviewSites: Array<
      | {
          __typename?: 'FacebookReviewSite';
          facebookPageId: string;
          serviceName: string;
          url: string;
        }
      | { __typename?: 'GoogleReviewSite'; serviceName: string; url: string }
      | { __typename?: 'ReviewSite'; serviceName: string; url: string }
    >;
  } | null;
};

export type GetShortcutQueryVariables = Exact<{
  shortcutId: Scalars['String']['input'];
}>;

export type GetShortcutQuery = {
  __typename?: 'Query';
  shortcut?: {
    __typename?: 'ShortcutQL';
    id: string;
    name: string;
    tag: string;
    content: string;
    place: { __typename?: 'PlaceQL'; name: string };
  } | null;
};

export type GetSkuEntitlementsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSkuEntitlementsQuery = {
  __typename?: 'Query';
  skuEntitlements?:
    | ({ __typename?: 'SkuEntitlementsQL' } & SkuEntitlementsFieldsFragment)
    | null;
};

export type SkusQueryVariables = Exact<{ [key: string]: never }>;

export type SkusQuery = {
  __typename?: 'Query';
  skus?: {
    __typename?: 'SkuConnection';
    edges: Array<{
      __typename?: 'SkuEdge';
      node?: {
        __typename?: 'SkuQL';
        id: string;
        isActive: boolean;
        name: string;
        skuType: SkuType;
      } | null;
    } | null>;
  } | null;
};

export type StagesQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
  assigneeId: Scalars['String']['input'];
}>;

export type StagesQuery = {
  __typename?: 'Query';
  stages?: Array<
    | ({
        __typename?: 'StageQL';
        statusItems?: {
          __typename?: 'StatusItemConnection';
          pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            startCursor?: string | null;
            endCursor?: string | null;
          };
          edges: Array<{
            __typename?: 'StatusItemEdge';
            node?:
              | ({ __typename?: 'StatusItemQL' } & StatusItemStubFragment)
              | null;
          } | null>;
        } | null;
      } & StageStubFragment)
    | null
  > | null;
};

export type StatusBoardUsersQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type StatusBoardUsersQuery = {
  __typename?: 'Query';
  placesUsers?: Array<{
    __typename?: 'PlacesUsersQL';
    id: string;
    placeId: string;
    user: {
      __typename?: 'UserQL';
      id: string;
      displayName: string;
      jobRole?: JobRoleInput | null;
      statusBoardView: boolean;
    };
  } | null> | null;
};

export type StatusBoardUsersForLeaderboardQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type StatusBoardUsersForLeaderboardQuery = {
  __typename?: 'Query';
  placesUsers?: Array<{
    __typename?: 'PlacesUsersQL';
    id: string;
    placeId: string;
    user: {
      __typename?: 'UserQL';
      id: string;
      displayName: string;
      jobRole?: JobRoleInput | null;
      statusBoardView: boolean;
      isAway: boolean;
      statusLeaderboardColors: {
        __typename?: 'LeaderboardColorsQL';
        green: number;
        yellow: number;
        red: number;
      };
    };
  } | null> | null;
};

export type StatusItemQueryVariables = Exact<{
  statusItemId: Scalars['String']['input'];
}>;

export type StatusItemQuery = {
  __typename?: 'Query';
  statusItem?:
    | ({ __typename?: 'StatusItemQL' } & StatusItemDetailsFragment)
    | null;
};

export type StatusItemsQueryVariables = Exact<{
  assigneeId: Scalars['String']['input'];
  first: Scalars['Int']['input'];
}>;

export type StatusItemsQuery = {
  __typename?: 'Query';
  statusItems?: {
    __typename?: 'StatusItemConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
    edges: Array<{
      __typename?: 'StatusItemEdge';
      node?: ({ __typename?: 'StatusItemQL' } & StatusItemStubFragment) | null;
    } | null>;
  } | null;
};

export type GetStripeAccountQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;

export type GetStripeAccountQuery = {
  __typename?: 'Query';
  stripeIntegration?: {
    __typename?: 'StripeIntegrationQL';
    id: string;
    placeId: string;
    stripeAccountType?: StripeAccountType | null;
    stripeAccountId?: string | null;
    stripeAccountStatus?: string | null;
  } | null;
};

export type GetSupportedVehiclesQueryVariables = Exact<{
  repairServiceId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetSupportedVehiclesQuery = {
  __typename?: 'Query';
  supportedVehicles?: {
    __typename?: 'SupportedVehiclesConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'SupportedVehiclesEdge';
      node?: {
        __typename?: 'SupportedVehiclesQL';
        id: string;
        supportedYears: any;
        make: string;
        model: string;
        outcome: string;
        useOverrides: boolean;
        firstEnabledOpCode?: {
          __typename?: 'SupportedVehiclesOpcodesQL';
          id: string;
          isEnabled: boolean;
          opCode: {
            __typename?: 'OpCodeQL';
            id: string;
            dmsId: string;
            description: string;
          };
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type GetSupportedVehiclesWithOpCodesQueryVariables = Exact<{
  repairServiceId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetSupportedVehiclesWithOpCodesQuery = {
  __typename?: 'Query';
  supportedVehicles?: {
    __typename?: 'SupportedVehiclesConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'SupportedVehiclesEdge';
      node?: {
        __typename?: 'SupportedVehiclesQL';
        id: string;
        supportedYears: any;
        make: string;
        model: string;
        outcome: string;
        useOverrides: boolean;
        opCodes: Array<{
          __typename?: 'SupportedVehiclesOpcodesQL';
          id: string;
          isEnabled: boolean;
          state: SupportedVehicleOpCodeState;
          opCode: {
            __typename?: 'OpCodeQL';
            id: string;
            dmsId: string;
            description: string;
          };
        }>;
        availableOpCodes: Array<{
          __typename?: 'SupportedVehiclesOpcodesQL';
          id: string;
          isEnabled: boolean;
          state: SupportedVehicleOpCodeState;
          opCode: {
            __typename?: 'OpCodeQL';
            id: string;
            dmsId: string;
            description: string;
          };
        }>;
        firstEnabledOpCode?: {
          __typename?: 'SupportedVehiclesOpcodesQL';
          id: string;
          isEnabled: boolean;
          opCode: {
            __typename?: 'OpCodeQL';
            id: string;
            dmsId: string;
            description: string;
          };
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type GetTeamByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  userCount?: InputMaybe<Scalars['Int']['input']>;
  afterUser?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetTeamByIdQuery = {
  __typename?: 'Query';
  team?:
    | ({
        __typename?: 'TeamQL';
        assignmentStyle: AssignmentStyle;
      } & TeamWithUsersFragment)
    | null;
};

export type GetTeamsByPlaceIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetTeamsByPlaceIdQuery = {
  __typename?: 'Query';
  teams?: Array<
    ({ __typename?: 'TeamQL' } & TeamSettingsFieldsFragment) | null
  > | null;
};

export type GetTenDlcProcessByAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;

export type GetTenDlcProcessByAccountQuery = {
  __typename?: 'Query';
  tenDlcProcesses?: Array<{
    __typename?: 'TenDLCProcessQL';
    registrationOptions?: Array<RegistrationOption | null> | null;
    place?: { __typename?: 'PlaceQL'; id: string; name: string } | null;
    twilioA2pCampaign?: {
      __typename?: 'TwilioA2PCampaignQL';
      id: string;
      campaignStatus: TwilioA2PCampaignStatus;
    } | null;
    twilioBrandRegistration?: {
      __typename?: 'TwilioBrandRegistrationQL';
      id: string;
      status: TwilioBrandRegistrationStatus;
    } | null;
    twilioTrustProduct?: {
      __typename?: 'TwilioTrustProductQL';
      id: string;
      friendlyName?: string | null;
      status: TwilioBundleStatus;
    } | null;
    errors?: Array<{
      __typename?: 'TwilioTrustProductError';
      friendlyName?: string | null;
    } | null> | null;
  } | null> | null;
};

export type GetTenDlcStatusByAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;

export type GetTenDlcStatusByAccountQuery = {
  __typename?: 'Query';
  tenDlcStatus?: {
    __typename?: 'TenDLCStatusQL';
    a2pStatus: TenDlcStatus;
    businessVerificationStatus: TenDlcStatus;
  } | null;
};

export type GetTenDlcTrustProductsByAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;

export type GetTenDlcTrustProductsByAccountQuery = {
  __typename?: 'Query';
  trustProducts?: Array<{
    __typename?: 'TwilioTrustProductQL';
    id: string;
    friendlyName?: string | null;
    productType: TwilioTrustProductType;
    status: TwilioBundleStatus;
    twilioSid?: string | null;
  } | null> | null;
};

export type EventContentFragment = {
  __typename?: 'TranscriptEventQL';
  timestamp: any;
  start?: number | null;
  end?: number | null;
  text?: string | null;
  confidence?: number | null;
  speaker?: number | null;
  speakerConfidence?: number | null;
};

export type GetTranscriptQueryVariables = Exact<{
  id: Scalars['String']['input'];
  includeEventContent: Scalars['Boolean']['input'];
}>;

export type GetTranscriptQuery = {
  __typename?: 'Query';
  transcript?: {
    __typename?: 'TranscriptQL';
    id: string;
    conversationId: string;
    summary?: string | null;
    subject?: string | null;
    events: Array<
      {
        __typename?: 'TranscriptEventQL';
        id: string;
        type: TranscriptEventType;
      } & EventContentFragment
    >;
    analysis?: {
      __typename?: 'TranscriptAnalysisQL';
      id: string;
      timestamp: any;
      callType?: string | null;
      subject?: string | null;
      summary?: string | null;
      nextSteps?: string | null;
      coachingTip?: string | null;
      coachingSample?: string | null;
      positiveCoachingTip?: string | null;
      sections?: Array<{
        __typename?: 'TranscriptSectionQL';
        id: string;
        name: string;
        timestamp: any;
      }> | null;
      scores?: Array<{
        __typename?: 'TranscriptScoreQL';
        id: string;
        name: string;
        rating: number;
        description: string;
      }> | null;
    } | null;
    call:
      | {
          __typename?: 'OutboundConferenceCallQL';
          id: string;
          createdOn: any;
          endTime?: any | null;
          startTime?: any | null;
          callDuration?: number | null;
          hostMdn: string;
          recipientMdn: string;
          recipientDisplayName: string;
          callRecording?: {
            __typename?: 'CallRecordingQL';
            id: string;
            url?: string | null;
          } | null;
          caller: { __typename?: 'UserQL'; id: string; displayName: string };
        }
      | {
          __typename?: 'OutboundProxyCallQL';
          id: string;
          createdOn: any;
          endtime?: any | null;
          startTime?: any | null;
          callDuration?: number | null;
          recipientMdn: string;
          callRecording?: {
            __typename?: 'CallRecordingQL';
            id: string;
            url?: string | null;
          } | null;
          caller: { __typename?: 'UserQL'; id: string; displayName: string };
        }
      | {
          __typename?: 'PhoneCallQL';
          id: string;
          createdOn: any;
          isActive?: boolean | null;
          endtime?: any | null;
          startTime?: any | null;
          callDuration?: number | null;
          channelId?: string | null;
          hasReturnCallsRouting: boolean;
          returnCallsRoutingOutcome?: PhoneCallReturnCallOutcome | null;
          returnCallsRoutedTo?: string | null;
          returnCallsRoutedUser?: {
            __typename?: 'UserQL';
            id: string;
            displayName: string;
          } | null;
          callRecording?: {
            __typename?: 'CallRecordingQL';
            id: string;
            url?: string | null;
          } | null;
          participant: {
            __typename?: 'ParticipantQL';
            id: string;
            address: string;
            displayName: string;
          };
          channel?: {
            __typename?: 'TwilioChannelQL';
            name?: string | null;
            mdn: string;
            id: string;
          } | null;
        };
  } | null;
};

export type GetTransportationSetOptionSpeechQueryVariables = Exact<{
  transportationSetOptionId: Scalars['String']['input'];
}>;

export type GetTransportationSetOptionSpeechQuery = {
  __typename?: 'Query';
  transportationSetOptionSpeech?: string | null;
};

export type GetTransportationSetSpeechQueryVariables = Exact<{
  transportationSetId: Scalars['String']['input'];
}>;

export type GetTransportationSetSpeechQuery = {
  __typename?: 'Query';
  transportationSetSpeech?: string | null;
};

export type GetTransportationSetsQueryVariables = Exact<{
  appointmentAgentSettingsId: Scalars['String']['input'];
}>;

export type GetTransportationSetsQuery = {
  __typename?: 'Query';
  transportationSets?: Array<{
    __typename?: 'TransportationSetQL';
    id: string;
    placeId: string;
    kind: TransportationSetType;
    name: string;
    rules: any;
    enabled: boolean;
    speechUtterance?: string | null;
    transportationOptions: Array<{
      __typename?: 'TransportationSetOptionQL';
      id: string;
      kind: TransportationOptionType;
      enabled: boolean;
      order: number;
      speechShort: string;
      speechLong: string;
      minimumServiceItems: number;
    }>;
  }> | null;
};

export type GetTrustProductByIdQueryVariables = Exact<{
  trustProductId: Scalars['String']['input'];
}>;

export type GetTrustProductByIdQuery = {
  __typename?: 'Query';
  tenDlcProcessById?: {
    __typename?: 'TenDLCProcessQL';
    twilioTrustProduct?: {
      __typename?: 'TwilioTrustProductQL';
      id: string;
      status: TwilioBundleStatus;
      businessIdentity?: {
        __typename?: 'BusinessIdentityModelQL';
        id: string;
        taxId?: string | null;
        legalName: string;
        entityType: TwilioEntityType;
        industry: TwilioVertical;
        websiteUrl: string;
        street: string;
        secondaryStreet?: string | null;
        city: string;
        state: string;
        zipCode: number;
        country: Country;
        firstName: string;
        lastName: string;
        jobTitle?: string | null;
        email: string;
        phone: string;
        mobilePhone: string;
        stockTickerSymbol?: string | null;
        stockExchange?: string | null;
        businessType: BusinessType;
      } | null;
    } | null;
  } | null;
};

export type GetTypingIndicatorTimeoutsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetTypingIndicatorTimeoutsQuery = {
  __typename?: 'Query';
  pubnub?: {
    __typename?: 'PubNubConfigQL';
    typingIndicator: {
      __typename?: 'TypingIndicatorQL';
      sendStillTyping: number;
      inactivityTimeout: number;
      discardEventTimeout: number;
      typingIndicatorChannel: string;
    };
  } | null;
};

export type UnassignedConversationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<AssignmentFilterInput>;
  newerThan?: InputMaybe<Scalars['ArrowField']['input']>;
  sort?: InputMaybe<
    | Array<InputMaybe<ConversationModelSortEnum>>
    | InputMaybe<ConversationModelSortEnum>
  >;
  isOverdue?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UnassignedConversationsQuery = {
  __typename?: 'Query';
  conversations?: {
    __typename?: 'ConversationConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'ConversationEdge';
      node?:
        | ({ __typename?: 'ConversationQL' } & ConversationItemStubFragment)
        | null;
    } | null>;
  } | null;
};

export type GetUsablePhonelinesQueryVariables = Exact<{
  placeId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetUsablePhonelinesQuery = {
  __typename?: 'Query';
  phonelines?: Array<{
    __typename?: 'PhoneLineQL';
    id: string;
    category: PhoneLineCategory;
    createdOn: any;
    name: string;
    mdn: string;
    lineType?: PhoneLineType | null;
    hostedSmsPort?: {
      __typename?: 'HostedSmsPortQL';
      id: string;
      status: string;
    } | null;
    user?: { __typename?: 'UserQL'; id: string } | null;
    smsChannel?:
      | {
          __typename?: 'BandwidthChannelQL';
          id: string;
          isActive: boolean;
          place: {
            __typename?: 'PlaceQL';
            id: string;
            createdOn: any;
            name: string;
          };
        }
      | {
          __typename?: 'BaseChannel';
          id: string;
          isActive: boolean;
          place: {
            __typename?: 'PlaceQL';
            id: string;
            createdOn: any;
            name: string;
          };
        }
      | {
          __typename?: 'FacebookChannelQL';
          id: string;
          isActive: boolean;
          place: {
            __typename?: 'PlaceQL';
            id: string;
            createdOn: any;
            name: string;
          };
        }
      | {
          __typename?: 'GoogleChannelQL';
          id: string;
          isActive: boolean;
          place: {
            __typename?: 'PlaceQL';
            id: string;
            createdOn: any;
            name: string;
          };
        }
      | {
          __typename?: 'NoteChannelQL';
          id: string;
          isActive: boolean;
          place: {
            __typename?: 'PlaceQL';
            id: string;
            createdOn: any;
            name: string;
          };
        }
      | {
          __typename?: 'NumboxChannelQL';
          id: string;
          isActive: boolean;
          place: {
            __typename?: 'PlaceQL';
            id: string;
            createdOn: any;
            name: string;
          };
        }
      | {
          __typename?: 'TwilioChannelQL';
          mdn: string;
          outboundSmsMdn?: string | null;
          id: string;
          isActive: boolean;
          place: {
            __typename?: 'PlaceQL';
            id: string;
            createdOn: any;
            name: string;
          };
        }
      | null;
    nryChannel?:
      | { __typename?: 'BandwidthChannelQL'; id: string; isActive: boolean }
      | { __typename?: 'BaseChannel'; id: string; isActive: boolean }
      | { __typename?: 'FacebookChannelQL'; id: string; isActive: boolean }
      | { __typename?: 'GoogleChannelQL'; id: string; isActive: boolean }
      | { __typename?: 'NoteChannelQL'; id: string; isActive: boolean }
      | { __typename?: 'NumboxChannelQL'; id: string; isActive: boolean }
      | {
          __typename?: 'TwilioChannelQL';
          mdn: string;
          outboundSmsMdn?: string | null;
          id: string;
          isActive: boolean;
        }
      | null;
  } | null> | null;
};

export type GetUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type GetUserQuery = {
  __typename?: 'Query';
  user?:
    | ({
        __typename?: 'UserQL';
        jobRole?: JobRoleInput | null;
        jobTitle?: string | null;
        signature?: string | null;
        signaturePreference: SignaturePreferences;
        status?: string | null;
        hasStatusItems: boolean;
        hasExternalIdentity: boolean;
        missedOutboundCallFollowUpEnabled: boolean;
        viewPreferences: {
          __typename?: 'UserViewPreferences';
        } & UserViewPreferencesFieldsFragment;
      } & UserItemAndNotificationFieldsFragment &
        AwayModeFieldsFragment &
        InboxBehaviourFieldsFragment)
    | null;
  skuEntitlements?:
    | ({ __typename?: 'SkuEntitlementsQL' } & SkuEntitlementsFieldsFragment)
    | null;
};

export type UsersWithServiceAdvisorsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
  activeIntegrationId: Scalars['String']['input'];
  serviceAdvisorType: ServiceAdvisorType;
  cdkClearCache?: InputMaybe<Scalars['Boolean']['input']>;
  skipRos?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UsersWithServiceAdvisorsQuery = {
  __typename?: 'Query';
  placesUsers?: Array<{
    __typename?: 'PlacesUsersQL';
    id: string;
    user: {
      __typename?: 'UserQL';
      id: string;
      fullName?: string | null;
      email?: string | null;
    };
    serviceAdvisors?: Array<
      | {
          __typename?: 'CDKServiceAdvisorQL';
          id: string;
          serviceAdvisorId?: string | null;
          serviceAdvisorName?: string | null;
        }
      | {
          __typename?: 'DealerTrackServiceAdvisorQL';
          id: string;
          serviceAdvisorId?: string | null;
          serviceAdvisorName?: string | null;
        }
      | {
          __typename?: 'ServiceAdvisorQL';
          id: string;
          serviceAdvisorId?: string | null;
          serviceAdvisorName?: string | null;
        }
      | null
    > | null;
  } | null> | null;
  employees: Array<{
    __typename?: 'EmployeeQL';
    advisorId: string;
    name: string;
    roCount: number;
    serviceAdvisor?: { __typename?: 'ServiceAdvisorQL'; id: string } | null;
  }>;
};

export type GetUserConversationCountsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  placeId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetUserConversationCountsQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'UserQL';
    id: string;
    openConversationCount?: number | null;
    closedConversationCount?: number | null;
  } | null;
};

export type GetUserMfaSettingsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type GetUserMfaSettingsQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'UserQL';
    id: string;
    enforceMfa?: EnforceMfa | null;
  } | null;
};

export type UserIdsByTeamIdQueryVariables = Exact<{
  teamId: Scalars['String']['input'];
}>;

export type UserIdsByTeamIdQuery = {
  __typename?: 'Query';
  userIdsByTeamId?: Array<string> | null;
};

export type GetUserMissedOutboundCallFollowUpSettingQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  placeId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetUserMissedOutboundCallFollowUpSettingQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'UserQL';
    id: string;
    missedOutboundCallFollowUpEnabled: boolean;
    missedOutboundCallFollowUpMessage?: string | null;
    missedOutboundCallFollowUpRenderedMessage?: string | null;
  } | null;
};

export type GetUserPersonalizationQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type GetUserPersonalizationQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'UserQL';
    id: string;
    firstName?: string | null;
    namePronunciation?: string | null;
    namePronunciationUrl?: string | null;
    pronouns?: Pronouns | null;
  } | null;
};

export type GetUserPhonesQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type GetUserPhonesQuery = {
  __typename?: 'Query';
  userPhones?: Array<{
    __typename?: 'UserPhoneQL';
    id: string;
    mdn: string;
    type: UserPhoneType;
    enabledDuringBusinessHours: boolean;
    enabledAfterBusinessHours: boolean;
    enabledWhenAway: boolean;
    sipAddress?: string | null;
    sipPriorityFirst: boolean;
  }> | null;
};

export type GetUserScheduleQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type GetUserScheduleQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'UserQL';
    id: string;
    schedule?: any | null;
    isScheduleEnabled: boolean;
  } | null;
};

export type UserStatusLeaderboardColorsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type UserStatusLeaderboardColorsQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'UserQL';
    id: string;
    statusLeaderboardColors: {
      __typename?: 'LeaderboardColorsQL';
      green: number;
      yellow: number;
      red: number;
    };
  } | null;
};

export type UsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserModelFilter>;
}>;

export type UsersQuery = {
  __typename?: 'Query';
  users?: {
    __typename?: 'UserConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
    edges: Array<{
      __typename?: 'UserEdge';
      node?: {
        __typename?: 'UserQL';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        mdn?: string | null;
      } | null;
    } | null>;
  } | null;
};

export type GeVideoUploadLinkQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GeVideoUploadLinkQuery = {
  __typename?: 'Query';
  videoUploadLink?:
    | ({ __typename?: 'VideoUploadLinkQL' } & VideoUploadLinkFieldsFragment)
    | null;
};

export type GetVoiceAppointmentAgentSettingsAudioQueryVariables = Exact<{
  appointmentAgentSettingsId: Scalars['String']['input'];
  audioField: Scalars['String']['input'];
}>;

export type GetVoiceAppointmentAgentSettingsAudioQuery = {
  __typename?: 'Query';
  voiceAppointmentAgentSettingsAudio?: string | null;
};

export type GetVoiceScriptQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetVoiceScriptQuery = {
  __typename?: 'Query';
  voiceScript?:
    | ({ __typename?: 'VoiceScriptQL' } & VoiceScriptFieldsFragment)
    | null;
};

export type GetVoiceScriptsForAnsweringScriptQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetVoiceScriptsForAnsweringScriptQuery = {
  __typename?: 'Query';
  answeringScript?: {
    __typename?: 'AnsweringScriptsQL';
    id: string;
    voiceScript?:
      | ({ __typename?: 'VoiceScriptQL' } & VoiceScriptFieldsFragment)
      | null;
    draftVoiceScript?:
      | ({ __typename?: 'VoiceScriptQL' } & VoiceScriptFieldsFragment)
      | null;
  } | null;
};

export type GetVoiceStepAudioQueryVariables = Exact<{
  stepId: Scalars['String']['input'];
  audioField: Scalars['String']['input'];
}>;

export type GetVoiceStepAudioQuery = {
  __typename?: 'Query';
  voiceStepAudio?: string | null;
};

export type GetXtimeServicesQueryVariables = Exact<{
  appointmentAgentSettingsId: Scalars['String']['input'];
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetXtimeServicesQuery = {
  __typename?: 'Query';
  xtimeServices: Array<{
    __typename?: 'XtimeServiceQL';
    serviceName: string;
    opcode: string;
    price?: string | null;
    comment?: string | null;
    serviceCategoryId?: string | null;
    serviceCategoryName?: string | null;
    sabCode?: string | null;
  }>;
};

export type LoadChatHistoryQueryVariables = Exact<{
  id: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  messageFormatsToExclude?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  withScheduledMessages?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type LoadChatHistoryQuery = {
  __typename?: 'Query';
  messages?: {
    __typename?: 'MessageConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'MessageEdge';
      node?: ({ __typename?: 'MessageQL' } & MessageItemFieldsFragment) | null;
    } | null>;
  } | null;
  conversation?:
    | ({
        __typename?: 'ConversationQL';
      } & ConversationSignatureStateFieldsFragment)
    | null;
  activePhoneCallsWithoutMessages: Array<
    { __typename?: 'PhoneCallQL' } & PhoneCallFieldsFragment
  >;
  scheduledMessages?: {
    __typename?: 'ScheduleMessageConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'ScheduleMessageEdge';
      node?:
        | ({
            __typename?: 'ScheduledMessageQL';
          } & ScheduledMessageFieldsFragment)
        | null;
    } | null>;
  } | null;
};

export type SearchConversationByContactQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  withLastAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  withLastChannel?: InputMaybe<Scalars['Boolean']['input']>;
  withLastRepairOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SearchConversationByContactQuery = {
  __typename?: 'Query';
  autocompleteConversations?: {
    __typename?: 'ConversationConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'ConversationEdge';
      node?:
        | ({
            __typename?: 'ConversationQL';
            place: { __typename?: 'PlaceQL'; id: string; name: string };
          } & ConversationItemFieldsFragment)
        | null;
    } | null>;
  } | null;
};

export type SearchConversationByMessageQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  withLastAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  withLastChannel?: InputMaybe<Scalars['Boolean']['input']>;
  withLastRepairOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SearchConversationByMessageQuery = {
  __typename?: 'Query';
  searchMessagesByContent?: {
    __typename?: 'MessageConnection';
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: 'MessageEdge';
      node?:
        | ({
            __typename?: 'MessageQL';
            conversation: {
              __typename?: 'ConversationQL';
            } & ConversationItemFieldsFragment;
          } & MessageItemFieldsFragment)
        | null;
    } | null>;
  } | null;
};

export type AssigneeFragment = {
  __typename?: 'ConversationQL';
  assignee?: {
    __typename?: 'UserQL';
    id: string;
    firstName?: string | null;
    fullName?: string | null;
    email?: string | null;
    lastName?: string | null;
  } | null;
};

export type AttachmentFragment = {
  __typename?: 'ConversationQL';
  lastMessage?: {
    __typename?: 'MessageQL';
    attachments: Array<
      | {
          __typename: 'AssignmentDetailsAttachment';
          id: string;
          attachmentType: string;
        }
      | {
          __typename: 'FileAttachment';
          id: string;
          attachmentType: string;
          filename: string;
          sizeBytes: string;
          url: string;
        }
      | {
          __typename: 'ImageAttachment';
          id: string;
          attachmentType: string;
          width?: number | null;
          height?: number | null;
          url: string;
        }
      | {
          __typename: 'MultiChoiceAttachment';
          id: string;
          attachmentType: string;
        }
      | { __typename: 'NoteAttachment'; id: string; attachmentType: string }
      | {
          __typename: 'OpenVoiceQuestionAttachment';
          id: string;
          attachmentType: string;
          url: string;
          words?: any | null;
          shorthandPrompt: string;
        }
      | { __typename: 'ReviewAttachment'; id: string; attachmentType: string }
      | {
          __typename: 'SmartTopicAttachment';
          id: string;
          attachmentType: string;
        }
      | {
          __typename: 'TranslatedMessage';
          id: string;
          attachmentType: string;
          text?: string | null;
          language?: string | null;
          fieldName?: string | null;
        }
      | { __typename: 'VCardAttachment'; id: string; attachmentType: string }
      | {
          __typename: 'VideoUploadLinkAttachment';
          id: string;
          attachmentType: string;
        }
      | {
          __typename: 'YelpAttachment';
          id: string;
          attachmentType: string;
          url: string;
        }
    >;
  } | null;
};

export type VerifyPubnubQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
  messageFormatsToExclude?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
}>;

export type VerifyPubnubQuery = {
  __typename?: 'Query';
  conversations?: {
    __typename?: 'ConversationConnection';
    edges: Array<{
      __typename?: 'ConversationEdge';
      node?: {
        __typename?: 'ConversationQL';
        id: string;
        lastUpdated?: any | null;
      } | null;
    } | null>;
  } | null;
  messages?: {
    __typename?: 'MessageConnection';
    edges: Array<{
      __typename?: 'MessageEdge';
      node?: { __typename?: 'MessageQL'; content: string } | null;
    } | null>;
  } | null;
  activePhoneCallsWithoutMessages: Array<{
    __typename?: 'PhoneCallQL';
    id: string;
    isActive?: boolean | null;
  }>;
};

export type ConversationsQueryVariables = Exact<{ [key: string]: never }>;

export type ConversationsQuery = {
  __typename?: 'Query';
  conversations?: {
    __typename?: 'ConversationConnection';
    edges: Array<{
      __typename?: 'ConversationEdge';
      node?:
        | ({ __typename?: 'ConversationQL' } & ConversationItemStubFragment)
        | null;
    } | null>;
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
    };
  } | null;
};

export const ChitchatResponseFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChitchatResponseFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AgentChitChatResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reply' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStep' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChitchatResponseFieldsFragment, unknown>;
export const CallIntelligenceSettingFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CallIntelligenceSettingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CallIntelligenceSettingQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclosureContent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renderedDisclosureContent' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'playDisclosureSpeech' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclosureSpeechUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customDisclosureSpeechUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customDisclosureSpeechOverride' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customDisclosureSpeech' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'seatLimit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'availableSeats' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CallIntelligenceSettingFieldsFragment, unknown>;
export const ComplianceSettingsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ComplianceSettings' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ComplianceSettingsQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'onVoicemail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'onHangup' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onRevivedConversations' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'onCompose' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guidelinesReminder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'detailedGuidelines' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendOptOutInstructions' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optOutInstructions' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optOutConfirmation' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'optOutResubscribe' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requireExplicitOptIn' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'doubleOptInPrompt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ongoingOptOutInstructions' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'suppressOptOutInstructions' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requireExplicitOptIn' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ComplianceSettingsFragment, unknown>;
export const ConversationInboxFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationInboxFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConversationInboxFragmentFragment, unknown>;
export const DialogFlowBotDataFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DialogFlowBotDataFieldsFragment, unknown>;
export const AppointmentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AppointmentFieldsFragment, unknown>;
export const RepairOrderFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RepairOrderFieldsFragment, unknown>;
export const BaseCustomerFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseCustomerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CustomerQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mediumType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sourceEntityId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sourceEntityType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addressConsentStatuses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consentType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consentCategory' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BaseCustomerFieldsFragment, unknown>;
export const CustomerFieldsWithDuplicatesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomerFieldsWithDuplicates' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CustomerQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'BaseCustomerFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'duplicates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'BaseCustomerFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseCustomerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CustomerQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mediumType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sourceEntityId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sourceEntityType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addressConsentStatuses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consentType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consentCategory' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomerFieldsWithDuplicatesFragment, unknown>;
export const CustomerFieldsWithRoAndAppointmentDuplicatesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'CustomerFieldsWithRoAndAppointmentDuplicates',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CustomerQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'BaseCustomerFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'duplicates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AppointmentFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastRepairOrder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'RepairOrderFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseCustomerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CustomerQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mediumType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sourceEntityId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sourceEntityType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addressConsentStatuses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consentType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consentCategory' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerFieldsWithRoAndAppointmentDuplicatesFragment,
  unknown
>;
export const DirectoryEntryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DirectoryEntryFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DirectoryEntryQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entryType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDiscoverable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'devices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'deviceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserDirectoryEntryQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobRole' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inboxes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DepartmentDirectoryEntryQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'department' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneline' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'place' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DirectoryEntryFieldsFragment, unknown>;
export const EngagementWithSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EngagementWithSummaryFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EngagementQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mySummaryRating' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'details' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EngagementWithSummaryFieldsFragment, unknown>;
export const TaskActionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskActionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TaskActionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actionData' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskActionFieldsFragment, unknown>;
export const TaskFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TaskQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engagementId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engagementId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedByParticipant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'completionSource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dismissedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dismissedByParticipant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dismissalSource' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedActions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TaskActionFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskActionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TaskActionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actionData' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaskFieldsFragment, unknown>;
export const EngagementTasksFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EngagementTasks' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EngagementQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tasks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TaskFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskActionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TaskActionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actionData' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TaskQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engagementId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engagementId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedByParticipant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'completionSource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dismissedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dismissedByParticipant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dismissalSource' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedActions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TaskActionFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EngagementTasksFragment, unknown>;
export const ConversationLastEngagementFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLastEngagement' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastEngagement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'EngagementWithSummaryFields' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'EngagementTasks' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskActionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TaskActionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actionData' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TaskQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engagementId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engagementId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedByParticipant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'completionSource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dismissedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dismissedByParticipant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dismissalSource' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedActions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TaskActionFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EngagementWithSummaryFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EngagementQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mySummaryRating' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'details' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EngagementTasks' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EngagementQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tasks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TaskFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConversationLastEngagementFragment, unknown>;
export const EquityTradeOpportunityWithStageFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EquityTradeOpportunityWithStage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EquityTradeOpportunityQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EquityTradeOpportunityWithStageFragment, unknown>;
export const AutomationTriggerFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AutomationTriggerFieldsFragment, unknown>;
export const AutomationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AutomationFieldsFragment, unknown>;
export const EtoSettingsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ETOSettings' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ETOSettingsQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noRepeat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oneAtATime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'daysFrequency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eligibilityCriteria' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isInboxLabelEnabled' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'minimumQualifyingScore' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'qualifiedNotificationEmailRecipient',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'leadCreationEmail' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'automationGroup' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EtoSettingsFragment, unknown>;
export const UserMetricsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserMetricsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserMetrics' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'openConversationsCount' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'overdueConversationsCount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastMessageSentAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextShiftStart' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'jobRole' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserMetricsFieldsFragment, unknown>;
export const UserMetricsCollectionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserMetricsCollection' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserMetricsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'edges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'node' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserMetricsFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserMetricsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserMetrics' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'openConversationsCount' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'overdueConversationsCount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastMessageSentAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextShiftStart' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'jobRole' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserMetricsCollectionFragment, unknown>;
export const PlaceMetricsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PlaceMetricsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceMetrics' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'openConversationsCount' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'overdueConversationsCount' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unassignedConversationsCount' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inbox' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlaceMetricsFieldsFragment, unknown>;
export const PlaceMetricsCollectionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PlaceMetricsCollection' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceMetricsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'edges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'node' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PlaceMetricsFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PlaceMetricsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceMetrics' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'openConversationsCount' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'overdueConversationsCount' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unassignedConversationsCount' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inbox' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlaceMetricsCollectionFragment, unknown>;
export const OperatorFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'spokenGreetingName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'operatorFaq' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'places' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OperatorFieldsFragment, unknown>;
export const OperatorSettingsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorSettingsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorSettingsQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentAgentSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'voiceProvider' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OperatorSettingsFieldsFragment, unknown>;
export const OperatorPlaceFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorPlaceFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorPlaceQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OperatorPlaceFieldsFragment, unknown>;
export const OperatorChannelFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorChannelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorChannelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'operatorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'channel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'TwilioChannelQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BandwidthChannelQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'places' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OperatorChannelFieldsFragment, unknown>;
export const OperatorSessionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phonecall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcriptId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returnCallsRoutedTo' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returnCallsRoutedUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OperatorSessionFieldsFragment, unknown>;
export const ManualOpportunityResultFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ManualOpportunityResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ManualOpportunityResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'success' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManualOpportunityResultFragment, unknown>;
export const ManualOpportunityQlFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ManualOpportunityQL' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ManualOpportunityQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'automationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completeTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManualOpportunityQlFragment, unknown>;
export const ManualOpportunityReportQlFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ManualOpportunityReportQL' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ManualOpportunityReportQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'automationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completeTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recordsWithMakeModel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recordsWithPhone' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recordsWithVin' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalRecords' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationBreakdown' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'firstStarted' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasEarlyExit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'jobCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'statuses' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneNumber' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'earlyExitAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'details' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversationId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'durationBeforeExit' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'possibleExitTriggers' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phoneNumber' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'exitTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalEarlyExits' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'manualOpportunityId' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'manualOpportunityStatus' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'statusSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'aborted' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedEarlyExit' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedSuccessfully' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentlyRunning' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentlyWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalStarted' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalAutomationsTriggered' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniqueConversationsAffected' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManualOpportunityReportQlFragment, unknown>;
export const UpdatablePlaceInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpdatablePlaceInfoFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceInfoQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phonenumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'brandTheme' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'logoUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatablePlaceInfoFieldsFragment, unknown>;
export const PlaceInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PlaceInfoFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceInfoQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phonenumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'linkGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'groupLabel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'links' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlaceInfoFieldsFragment, unknown>;
export const WriteItForMeConfigFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WriteItForMeConfig' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'WriteItForMeConfigQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instructions' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WriteItForMeConfigFragment, unknown>;
export const AdminAccountFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AdminAccountFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AccountQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'businessVertical' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingIdentity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signupMode' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminAccountFieldsFragment, unknown>;
export const AdminPlaceFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AdminPlaceFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newConversationsPerDay' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasDegradedInboxExperience' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'allowCustomAudio' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeGroup' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminPlaceFieldsFragment, unknown>;
export const UserItemFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserItemFieldsFragment, unknown>;
export const TeamFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamFieldsFragment, unknown>;
export const ChannelFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Channel' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBotEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityPromptOption' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TwilioChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outboundSmsMdn' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'sendOutboundsWithShadowTollfree',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreePhonenumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreeSid' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'accountSid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'archiveMissedCalls' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoSendHangupReplies' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hangupSuggestion' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneLinePolicyId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FacebookChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChannelFieldsFragment, unknown>;
export const AssignmentOptionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssignmentOptionsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLineQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'smsChannel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChannelFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Channel' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBotEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityPromptOption' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TwilioChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outboundSmsMdn' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'sendOutboundsWithShadowTollfree',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreePhonenumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreeSid' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'accountSid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'archiveMissedCalls' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoSendHangupReplies' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hangupSuggestion' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneLinePolicyId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FacebookChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignmentOptionsFieldsFragment, unknown>;
export const AutopilotFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutopilotFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutopilotQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autopilotStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'previewWelcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewInspection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewService' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewQualityControl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'previewPickup' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autopilotScheduleMessages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'milestoneName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduled' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AutopilotFieldsFragment, unknown>;
export const AwayModeFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AwayModeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isScheduleEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftEnd' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showAwayModeBannerAfter' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canManageOwnAwayModeSettings' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AwayModeFieldsFragment, unknown>;
export const AwayModeDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AwayModeDetailsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AwayModeFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placesUsers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'awayModeAssigneeUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'awayModeAssigneeTeam' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AwayModeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isScheduleEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftEnd' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showAwayModeBannerAfter' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canManageOwnAwayModeSettings' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AwayModeDetailsFieldsFragment, unknown>;
export const BrandThemeFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BrandThemeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandThemeQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'headerBackgroundColor' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'headerBorderColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headerTextColor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bodyBackgroundColor' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'bodyBorderColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bodyTextColor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonPrimaryBackgroundColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonPrimaryBorderColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonPrimaryTextColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonSecondaryBackgroundColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonSecondaryBorderColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonSecondaryTextColor' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paletteType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportedPaletteTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'headerBackgroundColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'headerBorderColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'headerTextColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bodyBackgroundColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bodyBorderColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bodyTextColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonPrimaryBackgroundColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonPrimaryBorderColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonPrimaryTextColor' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'buttonSecondaryBackgroundColor',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonSecondaryBorderColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonSecondaryTextColor' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BrandThemeFieldsFragment, unknown>;
export const BusinessProfileFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BusinessProfileFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BusinessProfileQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalBusinessName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'physicalAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'businessType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'businessIndustry' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'businessRegistrationIdType' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'businessRegistrationNumberType' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'businessRegistrationNumber' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'businessRegionsOfOperations' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'companyStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stockTickerExchange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contact1LastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contact1FirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contact1Email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contact1BusinessTitle' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contact1JobPosition' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contact1PhoneNumber' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'registrationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registrationStatus' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BusinessProfileFieldsFragment, unknown>;
export const ConversationSignatureStateFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationSignatureStateFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isNextOutboundMessageSigned' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConversationSignatureStateFieldsFragment, unknown>;
export const HostedSmsPortFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HostedSmsPortFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HostedSmsPortQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAttempts' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loaSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerEmail' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HostedSmsPortFieldsFragment, unknown>;
export const InboxBehaviourFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InboxBehaviourFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hideSharedInboxViews' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'statusBoardView' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultView' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultYouView' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pushNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserNotificationSetting' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboxBehaviourFieldsFragment, unknown>;
export const ManageHangupsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ManageHangupsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLinePolicyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveMissedCalls' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoSendHangupReplies' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hangupSuggestion' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageHangupsFieldsFragment, unknown>;
export const PhoneLineFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneLineFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLineQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carrierName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createHostedSmsUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsForwardingMode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canForwardReturnCalls' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nryForwardingMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostedSmsPort' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationAttempts' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationCode' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PhoneLineFieldsFragment, unknown>;
export const PhoneLineWithChannelsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneLineWithChannelsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLineQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'PhoneLineFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'voiceChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withVoiceChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChannelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'smsChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withSMSChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChannelFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneLineFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLineQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carrierName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createHostedSmsUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsForwardingMode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canForwardReturnCalls' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nryForwardingMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostedSmsPort' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationAttempts' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationCode' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Channel' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBotEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityPromptOption' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TwilioChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outboundSmsMdn' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'sendOutboundsWithShadowTollfree',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreePhonenumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreeSid' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'accountSid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'archiveMissedCalls' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoSendHangupReplies' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hangupSuggestion' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneLinePolicyId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FacebookChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PhoneLineWithChannelsFieldsFragment, unknown>;
export const PhoneLinePolicyFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneLinePolicyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLinePolicyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoOptin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoOptinMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delayAnswerDuration' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'answerWithKeys' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fixInternalDialing' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'assistantPhrase' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveMissedCalls' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hangupSuggestion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoSendHangupReplies' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasIdentityPrompt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowDisruptions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nryCallForwardingPickUpTimeoutSecs' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'nryCallForwardingUserScreenInteractionTimeoutSecs',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeringScripts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scriptType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'order' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PhoneLinePolicyFieldsFragment, unknown>;
export const PhonelineCategorySettingsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhonelineCategorySettingsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLineQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsForwardingMode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canForwardReturnCalls' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nryForwardingMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'smsChannel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PhonelineCategorySettingsFieldsFragment, unknown>;
export const PlaceDegradedInboxExperienceFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PlaceDegradedInboxExperienceFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasDegradedInboxExperience' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PlaceDegradedInboxExperienceFieldsFragment,
  unknown
>;
export const ParticipantFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ParticipantFieldsFragment, unknown>;
export const ScheduledMessageFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduledMessageFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ScheduledMessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sendAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryAttempted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduledMessageFieldsFragment, unknown>;
export const StageStubFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StageStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageTemplate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renderedMessageTemplate' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMessageTemplate' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renderedUpdateMessageTemplate' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'speechUpdate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speechUrl' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StageStubFragment, unknown>;
export const ConversationItemStubFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConversationItemStubFragment, unknown>;
export const LabelStubFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LabelStubFieldsFragment, unknown>;
export const ConversationLabelStubFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelStubFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConversationLabelStubFieldsFragment, unknown>;
export const StatusItemStubFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StatusItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatusItemQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heldSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationItemStub' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationLabels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ConversationLabelStubFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelStubFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StatusItemStubFragment, unknown>;
export const StatusItemDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StatusItemDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatusItemQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heldSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationItemStub' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationLabels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ConversationLabelStubFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelStubFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StatusItemDetailsFragment, unknown>;
export const SubscriptionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SubscriptionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubscriptionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sku' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubscriptionFieldsFragment, unknown>;
export const TeamSettingsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamSettingsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentStyle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamSettingsFieldsFragment, unknown>;
export const TeamWithUsersFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamWithUsers' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'TeamFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userCount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'afterUser' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isAway' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeamWithUsersFragment, unknown>;
export const SystemMessageSettingsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SystemMessageSettingsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SystemMessageSettings' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showSystemMessages' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SystemMessageSettingsFieldsFragment, unknown>;
export const UserViewPreferencesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserViewPreferencesFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserViewPreferences' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'systemMessageSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SystemMessageSettingsFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SystemMessageSettingsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SystemMessageSettings' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showSystemMessages' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserViewPreferencesFieldsFragment, unknown>;
export const VoiceStepFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canToggle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'executionOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renderedSpeech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stepType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customAudioOverrides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VoiceScriptStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TextOptinStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AskYesNoQuestionStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IntentQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpecialQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QualifyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PressAnyKeyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudio' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudioForAfterHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GreetingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softOpenSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectNewPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'collectPhonenumberFallbackSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarificationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCorrectQuestionSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retrySpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmationSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoAssignStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoAssignNextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallForwardingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'callTimeout' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'forwardingMdns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMdn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNumaCallerId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onConnectedStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoAnsweringStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallRecordingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PickupStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callerRecognizedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StatusUpdaterStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusGivenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noStatusGivenStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelConversationStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckForLabelStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasLabelId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onMissingLabelId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpeakStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QuestionBotStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NoteTakerStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'noteTakerId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedRecallStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedOtherStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedRecallSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedOtherSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'outcomeNotBookedWantsHumanSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notAnAppointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cantServiceCustomerStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyIntentFirstEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationStateStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'desiredConversationState' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckBusinessHoursStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onOpenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onClosedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmPromptOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmModelOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextStepId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalContext' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noMatchStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ConversationalSchedulingAgentStepQl',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmIntentSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shouldConfirmIntent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'greetingSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OperatorAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VoiceStepFieldsFragment, unknown>;
export const VoiceScriptFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceScriptFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'afterHoursEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scriptType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowCustomAudio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstStepId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dirty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VoiceStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canToggle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'executionOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renderedSpeech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stepType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customAudioOverrides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VoiceScriptStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TextOptinStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AskYesNoQuestionStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IntentQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpecialQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QualifyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PressAnyKeyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudio' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudioForAfterHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GreetingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softOpenSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectNewPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'collectPhonenumberFallbackSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarificationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCorrectQuestionSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retrySpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmationSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoAssignStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoAssignNextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallForwardingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'callTimeout' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'forwardingMdns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMdn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNumaCallerId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onConnectedStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoAnsweringStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallRecordingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PickupStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callerRecognizedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StatusUpdaterStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusGivenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noStatusGivenStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelConversationStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckForLabelStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasLabelId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onMissingLabelId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpeakStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QuestionBotStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NoteTakerStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'noteTakerId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedRecallStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedOtherStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedRecallSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedOtherSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'outcomeNotBookedWantsHumanSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notAnAppointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cantServiceCustomerStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyIntentFirstEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationStateStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'desiredConversationState' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckBusinessHoursStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onOpenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onClosedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmPromptOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmModelOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextStepId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalContext' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noMatchStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ConversationalSchedulingAgentStepQl',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmIntentSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shouldConfirmIntent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'greetingSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OperatorAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VoiceScriptFieldsFragment, unknown>;
export const ExternalOpcodeFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExternalOpcodeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ExternalOpcodeQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'serviceName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExternalOpcodeFieldsFragment, unknown>;
export const AppointmentAgentSettingsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentAgentSettingsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentAgentSettingsQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentProfile' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optionalPrompts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overallEmphasis' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numaInCallFlow' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'webSchedulerReliability' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textingCanWeTextSpeech' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textingOnYesSpeechCanWeText' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textingOnNoSpeechCanWeText' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textingMessageToSend' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textingHangupRecovery' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renderedTextingMessageToSend' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renderedTextingHangupRecovery' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'minimumLeadTimeInMinutes' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'maximumBookingHorizonInDays' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enableHangupRecovery' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'defaultExternalOpcode' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ExternalOpcodeFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExternalOpcodeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ExternalOpcodeQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'serviceName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AppointmentAgentSettingsFieldsFragment, unknown>;
export const AppointmentAgentSettingsPlaceFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentAgentSettingsPlaceFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalPlaceInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkGroups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'groupLabel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tag' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AppointmentAgentSettingsPlaceFieldsFragment,
  unknown
>;
export const AppointmentAgentSettingsActiveIntegrationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'AppointmentAgentSettingsActiveIntegrationFields',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ActiveIntegrationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pendingOpcodeSync' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AppointmentAgentSettingsActiveIntegrationFieldsFragment,
  unknown
>;
export const AttachmentItemFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttachmentItemFieldsFragment, unknown>;
export const ReasonSentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReasonSentFieldsFragment, unknown>;
export const TranscriptAnalysisFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TranscriptAnalysisFieldsFragment, unknown>;
export const PhoneCallFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PhoneCallFieldsFragment, unknown>;
export const OutboundConferenceCallFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OutboundConferenceCallFieldsFragment, unknown>;
export const PaymentRequestFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaymentRequestFieldsFragment, unknown>;
export const NumboxAgentSessionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NumboxAgentSessionFieldsFragment, unknown>;
export const QualificationSurveyFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QualificationSurveyFieldsFragment, unknown>;
export const MessageItemFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageItemFieldsFragment, unknown>;
export const LabelFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LabelFieldsFragment, unknown>;
export const ConversationLabelFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConversationLabelFieldsFragment, unknown>;
export const ConversationItemFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryMdn' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewIsInbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewServerGenerated' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewSource' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subPreview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serverGeneratedPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessageItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastAppointment' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastRepairOrder' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdateTime' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastEngagement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mySummaryRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myStatusRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'engagementId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completionSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissalSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actionData' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'amIMentioned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMentionedConversation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMentionedTimestamp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mentionedPreview' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentionedDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optInStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationLabels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasRecentHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConversationItemFieldsFragment, unknown>;
export const NoteTakerFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NoteTakerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NoteTakerQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NoteTakerFieldsFragment, unknown>;
export const PaymentRequestStubFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaymentRequestStubFieldsFragment, unknown>;
export const SkuEntitlementsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SkuEntitlementsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SkuEntitlementsQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'assignments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentRouting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'awayMode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SkuEntitlementsFieldsFragment, unknown>;
export const UserItemAndNotificationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemAndNotificationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailOnAssignment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pushNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignmentClaimSetting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'swipeRightSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'swipeLeftSetting' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserItemAndNotificationFieldsFragment, unknown>;
export const UserDetailFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserDetailFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placesUsers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserDetailFieldsFragment, unknown>;
export const VideoUploadLinkFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VideoUploadLinkFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoUploadLinkQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readyToStream' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'playbackHls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasBeenSent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VideoUploadLinkFieldsFragment, unknown>;
export const AutocompleteConversationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutocompleteConversationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cnamContact' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AutocompleteConversationFieldsFragment, unknown>;
export const AutoCompleteTeamsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutoCompleteTeamsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'edges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'node' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AutoCompleteTeamsFieldsFragment, unknown>;
export const AutoCompleteUsersFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutoCompleteUsersFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'edges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'node' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AutoCompleteUsersFieldsFragment, unknown>;
export const AccountDetailsPlaceFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccountDetailsPlace' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newConversationsPerDay' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountDetailsPlaceFragment, unknown>;
export const AccountDetailsPlaceGroupFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccountDetailsPlaceGroup' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceGroupQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'places' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1000' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'AccountDetailsPlace',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccountDetailsPlace' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newConversationsPerDay' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountDetailsPlaceGroupFragment, unknown>;
export const AdminSubscriptionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AdminSubscriptionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubscriptionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sku' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skuType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminSubscriptionFieldsFragment, unknown>;
export const EventContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptEventQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'start' } },
          { kind: 'Field', name: { kind: 'Name', value: 'end' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speaker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speakerConfidence' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventContentFragment, unknown>;
export const AssigneeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'assignee' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssigneeFragment, unknown>;
export const AttachmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'attachment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'Attachment' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'attachmentType' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'FileAttachment' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'filename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sizeBytes' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'OpenVoiceQuestionAttachment',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'words' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shorthandPrompt' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ImageAttachment' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'width' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'height' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'TranslatedMessage' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'language' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fieldName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'YelpAttachment' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttachmentFragment, unknown>;
export const GetCurrentAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCurrentAccount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNewNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'businessVertical' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'billingIdentity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billingOrderId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentSource' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCurrentAccountQuery,
  GetCurrentAccountQueryVariables
>;
export const DeactivateAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeactivateAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeactivateAccountInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deactivateAccount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'account' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeactivateAccountMutation,
  DeactivateAccountMutationVariables
>;
export const GetRepairOrderNotesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRepairOrderNotes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'repairOrderId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrderNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'repairOrderId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'repairOrderId' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRepairOrderNotesQuery,
  GetRepairOrderNotesQueryVariables
>;
export const GenerateRepairOrderNotesSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateRepairOrderNotesSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'GenerateRepairOrderNotesSummaryInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateRepairOrderNotesSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'repairOrderNotesSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceSummaries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'general' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'serviceItems' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'item' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'content' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'description',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'confidence',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'priority',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'upsell' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'strategies' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'strategy' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'objections' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'objection' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resolution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'step' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'solution',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notEnoughInfo' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateRepairOrderNotesSummaryMutation,
  GenerateRepairOrderNotesSummaryMutationVariables
>;
export const GetRepairOrderNotesSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getRepairOrderNotesSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'repairOrderId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrderNotesSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'repairOrderId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'repairOrderId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'repairOrderId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceSummaries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'general' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceItems' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'item' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'confidence' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'priority' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'upsell' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'strategies' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'strategy' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'objections' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'objection' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resolution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'step' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'solution' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notEnoughInfo' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRepairOrderNotesSummaryQuery,
  GetRepairOrderNotesSummaryQueryVariables
>;
export const CreateChitchatDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createChitchat' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateAgentChitChatInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createChitchat' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'chitchat' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChitchatResponseFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChitchatResponseFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AgentChitChatResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reply' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStep' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateChitchatMutation,
  CreateChitchatMutationVariables
>;
export const UpdateChitchatDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateChitchat' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateAgentChitChatInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateChitchat' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'chitchat' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChitchatResponseFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChitchatResponseFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AgentChitChatResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'sessionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reply' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStep' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateChitchatMutation,
  UpdateChitchatMutationVariables
>;
export const ApppointmentAgentSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApppointmentAgentSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentAgentSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'label' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'LabelFields' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApppointmentAgentSettingsQuery,
  ApppointmentAgentSettingsQueryVariables
>;
export const CreateAppointmentAgentSettingLabelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateAppointmentAgentSettingLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'CreateAppointmentAgentSettingLabelInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAppointmentAgentSettingLabel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateAppointmentAgentSettingLabelMutation,
  CreateAppointmentAgentSettingLabelMutationVariables
>;
export const UpdateAppointmentAgentSettingLabelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAppointmentAgentSettingLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdateAppointmentAgentSettingLabelInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAppointmentAgentSettingLabel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAppointmentAgentSettingLabelMutation,
  UpdateAppointmentAgentSettingLabelMutationVariables
>;
export const DeleteAppointmentAgentSettingLabelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAppointmentAgentSettingLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'DeleteAppointmentAgentSettingLabelInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAppointmentAgentSettingLabel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteAppointmentAgentSettingLabelMutation,
  DeleteAppointmentAgentSettingLabelMutationVariables
>;
export const DuplicateAppointmentAgentSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'duplicateAppointmentAgentSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'DuplicateAppointmentAgentSettingsInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'duplicateAppointmentAgentSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DuplicateAppointmentAgentSettingsMutation,
  DuplicateAppointmentAgentSettingsMutationVariables
>;
export const AppointmentAgentNoteRatingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AppointmentAgentNoteRating' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'dialogFlowBotDataId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentAgentNoteRating' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dialogFlowBotDataId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dialogFlowBotDataId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'details' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AppointmentAgentNoteRatingQuery,
  AppointmentAgentNoteRatingQueryVariables
>;
export const RateAppointmentAgentNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'rateAppointmentAgentNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RateAppointmentAgentNoteInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateAppointmentAgentNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'details' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RateAppointmentAgentNoteMutation,
  RateAppointmentAgentNoteMutationVariables
>;
export const UpdateServiceOverrideDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateServiceOverride' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateServiceOverrideInputQL' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateServiceOverride' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numaServiceName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'howIsHandled' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'search' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allSelected' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'make' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'dmsId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateServiceOverrideMutation,
  UpdateServiceOverrideMutationVariables
>;
export const ListAutomationsByTriggerTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListAutomationsByTriggerType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'triggerType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'automations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'triggerType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'triggerType' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '100' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastUpdated' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'publishedVersion' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'latestVersion' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startTrigger' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'triggerType',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListAutomationsByTriggerTypeQuery,
  ListAutomationsByTriggerTypeQueryVariables
>;
export const GetCallIntelligenceSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCallIntelligenceSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callIntelligenceSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CallIntelligenceSettingFields',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeAllowsCustomAudio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CallIntelligenceSettingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CallIntelligenceSettingQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclosureContent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renderedDisclosureContent' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'playDisclosureSpeech' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclosureSpeechUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customDisclosureSpeechUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customDisclosureSpeechOverride' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customDisclosureSpeech' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'seatLimit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'availableSeats' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCallIntelligenceSettingQuery,
  GetCallIntelligenceSettingQueryVariables
>;
export const GetCallIntelligenceEnabledDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCallIntelligenceEnabled' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callIntelligenceSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'seatLimit' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableSeats' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCallIntelligenceEnabledQuery,
  GetCallIntelligenceEnabledQueryVariables
>;
export const PlacesCallIntelligenceEnabledDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PlacesCallIntelligenceEnabled' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'String' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'places' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'placeIds' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'callIntelligenceSetting',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'enabled' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'seatLimit' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'availableSeats',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PlacesCallIntelligenceEnabledQuery,
  PlacesCallIntelligenceEnabledQueryVariables
>;
export const UpdateCallIntelligenceSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCallIntelligenceSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdateCallIntelligenceSettingInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCallIntelligenceSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callIntelligenceSetting' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'CallIntelligenceSettingFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CallIntelligenceSettingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CallIntelligenceSettingQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disclosureContent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renderedDisclosureContent' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'playDisclosureSpeech' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclosureSpeechUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customDisclosureSpeechUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customDisclosureSpeechOverride' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customDisclosureSpeech' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'seatLimit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'availableSeats' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCallIntelligenceSettingMutation,
  UpdateCallIntelligenceSettingMutationVariables
>;
export const CallIntelligenceRatingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CallIntelligenceRating' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'transcriptAnalysisId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callIntelligenceRating' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'transcriptAnalysisId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'transcriptAnalysisId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcriptAnalysisId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'details' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CallIntelligenceRatingQuery,
  CallIntelligenceRatingQueryVariables
>;
export const RateCallIntelligenceSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RateCallIntelligenceSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RateCallIntelligenceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateCallIntelligenceSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcriptAnalysisId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RateCallIntelligenceSummaryMutation,
  RateCallIntelligenceSummaryMutationVariables
>;
export const UpdateComplianceSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateComplianceSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateComplianceSettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateComplianceSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'complianceSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ComplianceSettings' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ComplianceSettings' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ComplianceSettingsQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'onVoicemail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'onHangup' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onRevivedConversations' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'onCompose' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guidelinesReminder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'detailedGuidelines' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendOptOutInstructions' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optOutInstructions' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optOutConfirmation' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'optOutResubscribe' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requireExplicitOptIn' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'doubleOptInPrompt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ongoingOptOutInstructions' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'suppressOptOutInstructions' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requireExplicitOptIn' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateComplianceSettingsMutation,
  UpdateComplianceSettingsMutationVariables
>;
export const GetComplianceSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getComplianceSettings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'complianceSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ComplianceSettings' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ComplianceSettings' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ComplianceSettingsQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'onVoicemail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'onHangup' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onRevivedConversations' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'onCompose' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guidelinesReminder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'detailedGuidelines' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendOptOutInstructions' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optOutInstructions' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optOutConfirmation' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'optOutResubscribe' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requireExplicitOptIn' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'doubleOptInPrompt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ongoingOptOutInstructions' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'suppressOptOutInstructions' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requireExplicitOptIn' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetComplianceSettingsQuery,
  GetComplianceSettingsQueryVariables
>;
export const GetConversationRepairOrderSmartStatusUpdateSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {
        kind: 'Name',
        value: 'getConversationRepairOrderSmartStatusUpdateSettings',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversationId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversationId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'repairOrderSmartStatusUpdateSettings',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isEnabled' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customInstructions' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetConversationRepairOrderSmartStatusUpdateSettingsQuery,
  GetConversationRepairOrderSmartStatusUpdateSettingsQueryVariables
>;
export const MoveConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MoveConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversationIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'String' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newState' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationState' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateConversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ids' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'conversationIds' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'state' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'newState' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConversationItemStub' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MoveConversationsMutation,
  MoveConversationsMutationVariables
>;
export const UpsertConversationRepairOrderSmartStatusUpdateSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'UpsertConversationRepairOrderSmartStatusUpdateSettings',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value:
                  'UpsertConversationRepairOrderSmartStatusUpdateSettingsInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'upsertConversationRepairOrderSmartStatusUpdateSettings',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'repairOrderSmartStatusUpdateSettings',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isEnabled' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'customInstructions',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertConversationRepairOrderSmartStatusUpdateSettingsMutation,
  UpsertConversationRepairOrderSmartStatusUpdateSettingsMutationVariables
>;
export const ExportConversationToArchiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExportConversationToArchive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ExportConversationToArchiveInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportConversationToArchive' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'taskId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportConversationToArchiveMutation,
  ExportConversationToArchiveMutationVariables
>;
export const GetUsersWithCrmUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUsersWithCrmUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'activeIntegrationId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placesUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'crmUsers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'integrationInternalType',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'externalCrmUserId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalTenantId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalCrmUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'activeIntegrationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'activeIntegrationId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUsersWithCrmUsersQuery,
  GetUsersWithCrmUsersQueryVariables
>;
export const MapCrmUserToUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'mapCrmUserToUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MapCrmUserToUserInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mapCrmUserToUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'crmUsers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'integrationInternalType',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'externalCrmUserId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalTenantId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MapCrmUserToUserMutation,
  MapCrmUserToUserMutationVariables
>;
export const UnmapCrmUserFromUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'unmapCrmUserFromUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UnmapCrmUserFromUserInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unmapCrmUserFromUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'crmUsers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'integrationInternalType',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'externalCrmUserId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalTenantId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnmapCrmUserFromUserMutation,
  UnmapCrmUserFromUserMutationVariables
>;
export const GetCustomerByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCustomerById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'customerId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'customerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CustomerFieldsWithDuplicates' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseCustomerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CustomerQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mediumType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sourceEntityId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sourceEntityType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addressConsentStatuses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consentType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consentCategory' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomerFieldsWithDuplicates' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CustomerQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'BaseCustomerFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'duplicates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'BaseCustomerFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCustomerByIdQuery,
  GetCustomerByIdQueryVariables
>;
export const GetCustomerWithRoAndAppointmentDuplicatesByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {
        kind: 'Name',
        value: 'getCustomerWithRoAndAppointmentDuplicatesById',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'customerId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'customerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CustomerFieldsWithRoAndAppointmentDuplicates',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseCustomerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CustomerQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addresses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mediumType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrimary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sourceEntityId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sourceEntityType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addressConsentStatuses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consentType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consentCategory' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'CustomerFieldsWithRoAndAppointmentDuplicates',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CustomerQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'BaseCustomerFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'duplicates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AppointmentFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastRepairOrder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'RepairOrderFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCustomerWithRoAndAppointmentDuplicatesByIdQuery,
  GetCustomerWithRoAndAppointmentDuplicatesByIdQueryVariables
>;
export const GetDepartmentDevicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDepartmentDevices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'departmentId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'departmentDevices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'departmentId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'departmentId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDepartmentDevicesQuery,
  GetDepartmentDevicesQueryVariables
>;
export const CreateDepartmentDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDepartmentDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateDepartmentDeviceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDepartmentDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'device' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sipAddress' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'enabledDuringBusinessHours',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'enabledAfterBusinessHours',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdOn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdated' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateDepartmentDeviceMutation,
  CreateDepartmentDeviceMutationVariables
>;
export const UpdateDepartmentDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDepartmentDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateDepartmentDeviceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDepartmentDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'device' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sipAddress' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'enabledDuringBusinessHours',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'enabledAfterBusinessHours',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdOn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdated' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDepartmentDeviceMutation,
  UpdateDepartmentDeviceMutationVariables
>;
export const DeleteDepartmentDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDepartmentDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteDepartmentDevice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteDepartmentDeviceMutation,
  DeleteDepartmentDeviceMutationVariables
>;
export const GetDirectoryEntriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDirectoryEntries' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeGroupId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entryType' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DirectoryEntryType' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isDiscoverable' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'directoryEntries' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeGroupId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeGroupId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entryType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'entryType' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isDiscoverable' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'isDiscoverable' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DirectoryEntryFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DirectoryEntryFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DirectoryEntryQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entryType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDiscoverable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'devices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'deviceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserDirectoryEntryQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobRole' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inboxes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DepartmentDirectoryEntryQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'department' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneline' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'place' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDirectoryEntriesQuery,
  GetDirectoryEntriesQueryVariables
>;
export const CreateCustomDirectoryEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCustomDirectoryEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateCustomDirectoryEntryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCustomDirectoryEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'directoryEntry' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'DirectoryEntryFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DirectoryEntryFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DirectoryEntryQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entryType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDiscoverable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'devices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'deviceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserDirectoryEntryQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobRole' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inboxes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DepartmentDirectoryEntryQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'department' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneline' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'place' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateCustomDirectoryEntryMutation,
  CreateCustomDirectoryEntryMutationVariables
>;
export const GetUserDirectoryEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUserDirectoryEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeGroupId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userDirectoryEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeGroupId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeGroupId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DirectoryEntryFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DirectoryEntryFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DirectoryEntryQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entryType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDiscoverable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'devices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'deviceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserDirectoryEntryQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobRole' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inboxes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DepartmentDirectoryEntryQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'department' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneline' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'place' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserDirectoryEntryQuery,
  GetUserDirectoryEntryQueryVariables
>;
export const GetDepartmentDirectoryEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDepartmentDirectoryEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'departmentId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeGroupId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'departmentDirectoryEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'departmentId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'departmentId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeGroupId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeGroupId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DirectoryEntryFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DirectoryEntryFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DirectoryEntryQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entryType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDiscoverable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'devices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'deviceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserDirectoryEntryQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobRole' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inboxes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DepartmentDirectoryEntryQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'department' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneline' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'place' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDepartmentDirectoryEntryQuery,
  GetDepartmentDirectoryEntryQueryVariables
>;
export const UpdateDirectoryEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDirectoryEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateDirectoryEntryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDirectoryEntry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'directoryEntry' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'DirectoryEntryFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DirectoryEntryFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DirectoryEntryQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entryType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDiscoverable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'devices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'deviceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sipAddress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceType' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserDirectoryEntryQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobRole' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inboxes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DepartmentDirectoryEntryQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'department' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneline' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'place' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDirectoryEntryMutation,
  UpdateDirectoryEntryMutationVariables
>;
export const RateEngagementSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'rateEngagementSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RateEngagementSummaryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateEngagementSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'EngagementWithSummaryFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasRecentHeatCase' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EngagementWithSummaryFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EngagementQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mySummaryRating' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'details' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RateEngagementSummaryMutation,
  RateEngagementSummaryMutationVariables
>;
export const RateEngagementStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'rateEngagementStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'engagement_id' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'rating' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'EngagementStatusRatingInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateEngagementStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'engagementId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'engagement_id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'rating' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'rating' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myStatusRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RateEngagementStatusMutation,
  RateEngagementStatusMutationVariables
>;
export const GetLatestInboxAgentResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLatestInboxAgentResult' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversationId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversationId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastEngagement' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'latestInboxAgentResult' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'summary' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sentiment' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sentimentValue' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topics' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'predictedMessageIntents',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'intent' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'confidence' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'myAssistedResponseRating',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'reason' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'details' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetLatestInboxAgentResultQuery,
  GetLatestInboxAgentResultQueryVariables
>;
export const RateAssistedResponseDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'rateAssistedResponse' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RateAssistedResponseInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateAssistedResponse' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'latestInboxAgentResult' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'myAssistedResponseRating',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'value' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reason' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'details' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RateAssistedResponseMutation,
  RateAssistedResponseMutationVariables
>;
export const GetEquityTradeOpportunityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getEquityTradeOpportunity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversationId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversationId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'EquityTradeOpportunityWithStage',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EquityTradeOpportunityWithStage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EquityTradeOpportunityQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEquityTradeOpportunityQuery,
  GetEquityTradeOpportunityQueryVariables
>;
export const UpdateEquityTradeOpportunityStageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateEquityTradeOpportunityStage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdateEquityTradeOpportunityStageInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEquityTradeOpportunityStage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'equityTradeOpportunity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'EquityTradeOpportunityWithStage',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EquityTradeOpportunityWithStage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EquityTradeOpportunityQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateEquityTradeOpportunityStageMutation,
  UpdateEquityTradeOpportunityStageMutationVariables
>;
export const GetEtoSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getETOSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'etoSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ETOSettings' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ETOSettings' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ETOSettingsQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noRepeat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oneAtATime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'daysFrequency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eligibilityCriteria' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isInboxLabelEnabled' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'minimumQualifyingScore' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'qualifiedNotificationEmailRecipient',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'leadCreationEmail' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'automationGroup' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEtoSettingsQuery, GetEtoSettingsQueryVariables>;
export const UpdateEtoSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateETOSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateETOSettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEtoSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'etoSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ETOSettings' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ETOSettings' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ETOSettingsQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noRepeat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oneAtATime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'daysFrequency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eligibilityCriteria' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isInboxLabelEnabled' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'minimumQualifyingScore' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'qualifiedNotificationEmailRecipient',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'leadCreationEmail' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'automationGroup' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateEtoSettingsMutation,
  UpdateEtoSettingsMutationVariables
>;
export const SetupEquityTradeOpportunityCampaignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setupEquityTradeOpportunityCampaign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'SetupEquityTradeOpportunityCampaignInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'setupEquityTradeOpportunityCampaign',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'etoSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ETOSettings' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ETOSettings' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ETOSettingsQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noRepeat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'oneAtATime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'daysFrequency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eligibilityCriteria' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isInboxLabelEnabled' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'minimumQualifyingScore' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'qualifiedNotificationEmailRecipient',
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'leadCreationEmail' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'automationGroup' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetupEquityTradeOpportunityCampaignMutation,
  SetupEquityTradeOpportunityCampaignMutationVariables
>;
export const LoginDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'login' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'credential' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Credentials' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'login' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'credential' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'credential' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refreshToken' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const GetMyManagerDashboardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getMyManagerDashboard' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myManagerDashboard' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pollingIntervalMs' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userMetrics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserMetricsCollection' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserMetricsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserMetrics' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'openConversationsCount' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'overdueConversationsCount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastMessageSentAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextShiftStart' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'jobRole' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserMetricsCollection' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserMetricsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'edges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'node' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserMetricsFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMyManagerDashboardQuery,
  GetMyManagerDashboardQueryVariables
>;
export const GetMyManagerDashboardWithPlaceMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getMyManagerDashboardWithPlaceMetrics' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myManagerDashboard' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pollingIntervalMs' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userMetrics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserMetricsCollection' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'placeMetrics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PlaceMetricsCollection' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserMetricsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserMetrics' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'openConversationsCount' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'overdueConversationsCount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastMessageSentAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextShiftStart' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'jobRole' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PlaceMetricsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceMetrics' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'openConversationsCount' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'overdueConversationsCount' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unassignedConversationsCount' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inbox' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserMetricsCollection' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserMetricsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'edges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'node' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserMetricsFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PlaceMetricsCollection' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceMetricsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'edges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'node' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PlaceMetricsFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMyManagerDashboardWithPlaceMetricsQuery,
  GetMyManagerDashboardWithPlaceMetricsQueryVariables
>;
export const GetOperatorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOperators' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operators' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OperatorFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'spokenGreetingName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'operatorFaq' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'places' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOperatorsQuery, GetOperatorsQueryVariables>;
export const GetOperatorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOperator' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeChannels' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeSessions' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operator' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OperatorFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channels' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeChannels' },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'TwilioChannelQL' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mdn' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'BandwidthChannelQL' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mdn' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operatorSessions' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeSessions' },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OperatorSessionFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'spokenGreetingName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'operatorFaq' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'places' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phonecall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcriptId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returnCallsRoutedTo' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returnCallsRoutedUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOperatorQuery, GetOperatorQueryVariables>;
export const CreateOperatorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createOperator' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateOperatorInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createOperator' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OperatorFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'spokenGreetingName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'operatorFaq' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'places' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOperatorMutation,
  CreateOperatorMutationVariables
>;
export const GetOperatorWithDealershipInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOperatorWithDealershipInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operator' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'places' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dealershipInfoBlob' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOperatorWithDealershipInfoQuery,
  GetOperatorWithDealershipInfoQueryVariables
>;
export const GetOperatorSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOperatorSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'operatorId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operatorSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'operatorId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'operatorId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OperatorSettingsFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorSettingsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorSettingsQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentAgentSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'voiceProvider' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOperatorSettingsQuery,
  GetOperatorSettingsQueryVariables
>;
export const UpdateOperatorSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateOperatorSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateOperatorSettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOperatorSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operatorSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OperatorSettingsFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorSettingsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorSettingsQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentAgentSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'voiceProvider' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voiceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOperatorSettingsMutation,
  UpdateOperatorSettingsMutationVariables
>;
export const GetOperatorPlacesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOperatorPlaces' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'operatorId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operatorPlaces' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'operatorId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'operatorId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OperatorPlaceFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorPlaceFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorPlaceQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOperatorPlacesQuery,
  GetOperatorPlacesQueryVariables
>;
export const GetOperatorPlaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOperatorPlace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'operatorId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operatorPlace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'operatorId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'operatorId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OperatorPlaceFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorPlaceFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorPlaceQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOperatorPlaceQuery,
  GetOperatorPlaceQueryVariables
>;
export const GetOperatorChannelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOperatorChannel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'operatorId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'channelId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operatorChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'operatorId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'operatorId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channelId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'channelId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OperatorChannelFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorChannelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorChannelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'operatorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'channel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'TwilioChannelQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BandwidthChannelQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'places' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOperatorChannelQuery,
  GetOperatorChannelQueryVariables
>;
export const AddOperatorPlaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addOperatorPlace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AddOperatorPlaceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addOperatorPlace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OperatorFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operatorPlace' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OperatorPlaceFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'spokenGreetingName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'operatorFaq' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'places' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorPlaceFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorPlaceQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddOperatorPlaceMutation,
  AddOperatorPlaceMutationVariables
>;
export const UpdateOperatorPlaceDescriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateOperatorPlaceDescription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdateOperatorPlaceDescriptionInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOperatorPlaceDescription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operatorPlace' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OperatorPlaceFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorPlaceFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorPlaceQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOperatorPlaceDescriptionMutation,
  UpdateOperatorPlaceDescriptionMutationVariables
>;
export const UpdateOperatorPlaceSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateOperatorPlaceSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateOperatorPlaceSettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOperatorPlaceSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operatorPlace' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OperatorPlaceFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorPlaceFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorPlaceQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOperatorPlaceSettingsMutation,
  UpdateOperatorPlaceSettingsMutationVariables
>;
export const UpdateOperatorChannelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateOperatorChannel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateOperatorChannelInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOperatorChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OperatorFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operatorChannel' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OperatorChannelFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'spokenGreetingName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'operatorFaq' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'places' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorChannelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorChannelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'operatorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'channel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'TwilioChannelQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BandwidthChannelQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'places' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOperatorChannelMutation,
  UpdateOperatorChannelMutationVariables
>;
export const AddOperatorChannelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addOperatorChannel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AddOperatorChannelInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addOperatorChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OperatorFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operatorChannel' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OperatorChannelFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'spokenGreetingName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'operatorFaq' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'places' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorChannelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorChannelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'operatorId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'channel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'TwilioChannelQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BandwidthChannelQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'places' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddOperatorChannelMutation,
  AddOperatorChannelMutationVariables
>;
export const GetOperatorSessionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOperatorSessions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'operatorId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userIds' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeIds' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'OperatorSessionModelFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OperatorSessionModelSortEnum' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operatorSessions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'operatorId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'operatorId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'OperatorSessionFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phonecall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcriptId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returnCallsRoutedTo' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returnCallsRoutedUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOperatorSessionsQuery,
  GetOperatorSessionsQueryVariables
>;
export const GetOperatorSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOperatorSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeTranscript' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operatorSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OperatorSessionFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operatorTranscript' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'includeTranscript' },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'timestamp' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'start' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'end' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'confidence' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'speaker' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phonecall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcriptId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returnCallsRoutedTo' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returnCallsRoutedUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOperatorSessionQuery,
  GetOperatorSessionQueryVariables
>;
export const UpdateOperatorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateOperator' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateOperatorInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOperator' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OperatorFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OperatorFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OperatorQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'spokenGreetingName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'operatorFaq' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'places' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOperatorMutation,
  UpdateOperatorMutationVariables
>;
export const PlacesUsersForOperatorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'placesUsersForOperator' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placesUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobRole' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userPhones' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phonelines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'place' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PlacesUsersForOperatorQuery,
  PlacesUsersForOperatorQueryVariables
>;
export const ManualOpportunityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'manualOpportunity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ManualOpportunityInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'manualOpportunity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ManualOpportunityResult',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ManualOpportunityResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ManualOpportunityResult' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'success' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ManualOpportunityMutation,
  ManualOpportunityMutationVariables
>;
export const ManualOpportunitiesByPlaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'manualOpportunitiesByPlace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunitiesByPlaceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'manualOpportunitiesByPlace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ManualOpportunityQL' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ManualOpportunityQL' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ManualOpportunityQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'automationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completeTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ManualOpportunitiesByPlaceQuery,
  ManualOpportunitiesByPlaceQueryVariables
>;
export const ManualOpportunityReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'manualOpportunityReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityReportInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'manualOpportunityReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ManualOpportunityReportQL' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ManualOpportunityReportQL' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ManualOpportunityReportQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'automationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completeTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recordsWithMakeModel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recordsWithPhone' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recordsWithVin' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalRecords' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationBreakdown' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'firstStarted' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasEarlyExit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'jobCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'statuses' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneNumber' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'earlyExitAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'details' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversationId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'durationBeforeExit' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'possibleExitTriggers' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phoneNumber' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'exitTypes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalEarlyExits' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'manualOpportunityId' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'manualOpportunityStatus' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'statusSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'aborted' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedEarlyExit' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedSuccessfully' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentlyRunning' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentlyWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalStarted' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalAutomationsTriggered' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniqueConversationsAffected' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ManualOpportunityReportQuery,
  ManualOpportunityReportQueryVariables
>;
export const CreateCampaignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCampaign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'CreateCampaignInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCampaign' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'success' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateCampaignMutation,
  CreateCampaignMutationVariables
>;
export const ListCampaignsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'listCampaigns' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listCampaigns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maxEnrolement' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListCampaignsQuery, ListCampaignsQueryVariables>;
export const GetCampaignDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCampaign' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'campaignId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaign' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'campaignId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'campaignId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maxEnrolement' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCampaignQuery, GetCampaignQueryVariables>;
export const UpdatePhoneLineLanguageSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePhoneLineLanguageSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdatePhoneLineLanguageSettingsInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePhoneLineLanguageSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneline' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'speechLanguage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allowedSpeechLanguages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePhoneLineLanguageSettingsMutation,
  UpdatePhoneLineLanguageSettingsMutationVariables
>;
export const EnableInboxLanguageOverrideDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'enableInboxLanguageOverride' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'EnableInboxLanguageOverrideInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enableInboxLanguageOverride' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneline' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'overridesInboxLanguage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'speechLanguage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allowedSpeechLanguages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EnableInboxLanguageOverrideMutation,
  EnableInboxLanguageOverrideMutationVariables
>;
export const GetPhonelineWithDepartmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPhonelineWithDepartment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'phonelineId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneline' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phonelineId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'phonelineId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'department' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'placeGroupId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPhonelineWithDepartmentQuery,
  GetPhonelineWithDepartmentQueryVariables
>;
export const GetPlaceInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPlaceInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PlaceInfoFields' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UpdatablePlaceInfoFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PlaceInfoFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceInfoQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phonenumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'linkGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'groupLabel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'links' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpdatablePlaceInfoFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceInfoQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phonenumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'brandTheme' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'logoUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPlaceInfoQuery, GetPlaceInfoQueryVariables>;
export const UpdatePlaceInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePlaceInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdatePlaceInfoInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePlaceInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'placeInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'UpdatablePlaceInfoFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpdatablePlaceInfoFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceInfoQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phonenumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'brandTheme' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'logoUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePlaceInfoMutation,
  UpdatePlaceInfoMutationVariables
>;
export const UpdatePlaceMessageSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePlaceMessageSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdatePlaceMessageSettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePlaceMessageSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'escalationsEnabled' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'escalationsThreshold' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePlaceMessageSettingsMutation,
  UpdatePlaceMessageSettingsMutationVariables
>;
export const UpdateLanguageSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateLanguageSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateLanguageSettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAllowedSpeechLanguages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allowedSpeechLanguages' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'speechLanguage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateLanguageSettingsMutation,
  UpdateLanguageSettingsMutationVariables
>;
export const UpsertRepairOrderSmartStatusUpdateSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'upsertRepairOrderSmartStatusUpdateSettings',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'RepairOrderSmartStatusUpdateSettingsInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'upsertRepairOrderSmartStatusUpdateSettings',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'repairOrderSmartStatusUpdateSettings',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'placeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'detailLevel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'evaluationTimes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'time' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customInstructions' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdOn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdated' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isEnabled' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertRepairOrderSmartStatusUpdateSettingsMutation,
  UpsertRepairOrderSmartStatusUpdateSettingsMutationVariables
>;
export const GetPlaceRepairOrderSmartStatusUpdateSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {
        kind: 'Name',
        value: 'getPlaceRepairOrderSmartStatusUpdateSettings',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'placeRepairOrderSmartStatusUpdateSettings',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'detailLevel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'evaluationTimes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customInstructions' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlaceRepairOrderSmartStatusUpdateSettingsQuery,
  GetPlaceRepairOrderSmartStatusUpdateSettingsQueryVariables
>;
export const GenerateRepairOrderAssistedStatusContentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateRepairOrderAssistedStatusContent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'GenerateRepairOrderAssistedStatusContentInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'generateRepairOrderAssistedStatusContent',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusContent' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateRepairOrderAssistedStatusContentMutation,
  GenerateRepairOrderAssistedStatusContentMutationVariables
>;
export const BuildRepairOrderAssistedStatusQuestionTreeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'BuildRepairOrderAssistedStatusQuestionTree',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'BuildRepairOrderAssistedStatusQuestionTreeInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'buildRepairOrderAssistedStatusQuestionTree',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionTree' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'questions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'answers' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'text' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'nextQuestionId',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'defaultAnswer' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'text' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'nextQuestionId',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BuildRepairOrderAssistedStatusQuestionTreeMutation,
  BuildRepairOrderAssistedStatusQuestionTreeMutationVariables
>;
export const CreateShortcutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createShortcut' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateShortcutInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createShortcut' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shortcut' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateShortcutMutation,
  CreateShortcutMutationVariables
>;
export const CompleteTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'completeTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompleteTaskInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completeTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'task' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompleteTaskMutation,
  CompleteTaskMutationVariables
>;
export const DismissTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'dismissTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DismissTaskInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dismissTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'task' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissalReason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DismissTaskMutation, DismissTaskMutationVariables>;
export const CreateTaskForEngagementDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createTaskForEngagement' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NewTaskForEngagementInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTaskForEngagement' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'task' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TaskFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskActionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TaskActionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'actionData' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaskFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TaskQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engagementId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'engagementId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedByParticipant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'completionSource' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dismissedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dismissedByParticipant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dismissalSource' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendedActions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TaskActionFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateTaskForEngagementMutation,
  CreateTaskForEngagementMutationVariables
>;
export const ResetTaskStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'resetTaskStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ResetTaskStatusInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetTaskStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'task' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetTaskStatusMutation,
  ResetTaskStatusMutationVariables
>;
export const ChangeUserPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChangeUserPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChangeUserPasswordInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeUserPassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeUserPasswordMutation,
  ChangeUserPasswordMutationVariables
>;
export const GetVoiceConfigurationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getVoiceConfigurations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'voiceConfigurations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'voiceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'service' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imgUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'voiceAudio' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetVoiceConfigurationsQuery,
  GetVoiceConfigurationsQueryVariables
>;
export const GetPlaceVoiceSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPlaceVoiceSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeVoiceSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'voiceSpanish' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'voiceFrench' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'speechLanguage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowedSpeechLanguages' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlaceVoiceSettingsQuery,
  GetPlaceVoiceSettingsQueryVariables
>;
export const BuildWriteItForMeQuestionTreeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BuildWriteItForMeQuestionTree' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'BuildWriteItForMeQuestionTreeInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildWriteItForMeQuestionTree' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionTree' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'questions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'defaultAnswer' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'text' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'nextQuestionId',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'answers' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'text' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'nextQuestionId',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'tones' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BuildWriteItForMeQuestionTreeMutation,
  BuildWriteItForMeQuestionTreeMutationVariables
>;
export const GenerateWriteItForMeContentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateWriteItForMeContent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GenerateWriteItForMeContentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateWriteItForMeContent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateWriteItForMeContentMutation,
  GenerateWriteItForMeContentMutationVariables
>;
export const CreateConversationTextExpansionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createConversationTextExpansion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'CreateConversationTextExpansionInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createConversationTextExpansion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'textExpansion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'responses' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messages' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateConversationTextExpansionMutation,
  CreateConversationTextExpansionMutationVariables
>;
export const WriteItForMeConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'writeItForMeConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'writeItForMeConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'WriteItForMeConfig' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WriteItForMeConfig' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'WriteItForMeConfigQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instructions' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WriteItForMeConfigQuery,
  WriteItForMeConfigQueryVariables
>;
export const UpdateWriteItForMeConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateWriteItForMeConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateWriteItForMeConfigInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWriteItForMeConfig' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'writeItForMeConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'WriteItForMeConfig' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WriteItForMeConfig' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'WriteItForMeConfigQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instructions' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateWriteItForMeConfigMutation,
  UpdateWriteItForMeConfigMutationVariables
>;
export const ForceActiveIntegrationSyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'forceActiveIntegrationSync' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ForceActiveIntegrationSyncInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'forceActiveIntegrationSync' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeIntegration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ForceActiveIntegrationSyncMutation,
  ForceActiveIntegrationSyncMutationVariables
>;
export const AddAnsweringScriptToPolicyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddAnsweringScriptToPolicy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AddAnsweringScriptToPolicyInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addAnsweringScriptToPolicy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneLinePolicy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'answeringScripts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'scriptType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'order' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddAnsweringScriptToPolicyMutation,
  AddAnsweringScriptToPolicyMutationVariables
>;
export const AddAutomationExitTriggerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addAutomationExitTrigger' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AddAutomationExitTriggerInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addAutomationExitTrigger' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddAutomationExitTriggerMutation,
  AddAutomationExitTriggerMutationVariables
>;
export const AddLabelToConversationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddLabelToConversation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AddLabelToConversationInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastAppointment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastRepairOrder' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addLabelToConversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationLabel' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ConversationLabelFields',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConversationItemFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryMdn' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewIsInbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewServerGenerated' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewSource' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subPreview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serverGeneratedPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessageItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastAppointment' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastRepairOrder' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdateTime' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastEngagement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mySummaryRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myStatusRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'engagementId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completionSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissalSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actionData' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'amIMentioned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMentionedConversation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMentionedTimestamp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mentionedPreview' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentionedDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optInStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationLabels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasRecentHeatCase' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddLabelToConversationMutation,
  AddLabelToConversationMutationVariables
>;
export const AddCustomLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddCustomLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'AddCustomLinkInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addCustomLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'placeInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkGroups' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groupLabel' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'links' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tag' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddCustomLinkMutation,
  AddCustomLinkMutationVariables
>;
export const CreateNoteTakerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createNoteTaker' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateNoteTakerInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNoteTaker' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noteTaker' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'NoteTakerFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NoteTakerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NoteTakerQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateNoteTakerMutation,
  CreateNoteTakerMutationVariables
>;
export const AddPlaceGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addPlaceGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AddPlaceGroupInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addPlaceGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'placeGroup' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'account' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddPlaceGroupMutation,
  AddPlaceGroupMutationVariables
>;
export const AddStatusItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addStatusItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'AddStatusItemInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addStatusItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'StatusItemDetails' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelStubFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StatusItemDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatusItemQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heldSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationItemStub' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationLabels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ConversationLabelStubFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddStatusItemMutation,
  AddStatusItemMutationVariables
>;
export const AddVoiceStepDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addVoiceStep' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AddVoiceStepInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addVoiceStep' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'voiceScript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'VoiceScriptFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canToggle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'executionOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renderedSpeech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stepType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customAudioOverrides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VoiceScriptStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TextOptinStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AskYesNoQuestionStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IntentQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpecialQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QualifyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PressAnyKeyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudio' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudioForAfterHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GreetingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softOpenSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectNewPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'collectPhonenumberFallbackSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarificationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCorrectQuestionSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retrySpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmationSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoAssignStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoAssignNextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallForwardingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'callTimeout' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'forwardingMdns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMdn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNumaCallerId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onConnectedStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoAnsweringStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallRecordingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PickupStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callerRecognizedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StatusUpdaterStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusGivenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noStatusGivenStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelConversationStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckForLabelStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasLabelId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onMissingLabelId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpeakStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QuestionBotStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NoteTakerStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'noteTakerId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedRecallStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedOtherStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedRecallSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedOtherSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'outcomeNotBookedWantsHumanSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notAnAppointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cantServiceCustomerStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyIntentFirstEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationStateStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'desiredConversationState' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckBusinessHoursStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onOpenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onClosedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmPromptOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmModelOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextStepId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalContext' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noMatchStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ConversationalSchedulingAgentStepQl',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmIntentSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shouldConfirmIntent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'greetingSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OperatorAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceScriptFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'afterHoursEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scriptType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowCustomAudio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstStepId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dirty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VoiceStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddVoiceStepMutation,
  AddVoiceStepMutationVariables
>;
export const ArchiveConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateConversationsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateConversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConversationItemStub' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ArchiveConversationsMutation,
  ArchiveConversationsMutationVariables
>;
export const ArchiveMissedCallsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ArchiveMissedCalls' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ArchiveMissedCallsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveMissedCalls' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneLinePolicy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'archiveMissedCalls' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ArchiveMissedCallsMutation,
  ArchiveMissedCallsMutationVariables
>;
export const AssignConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AssignConversationsInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastAppointment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastRepairOrder' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignConversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConversationItemFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryMdn' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewIsInbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewServerGenerated' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewSource' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subPreview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serverGeneratedPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessageItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastAppointment' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastRepairOrder' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdateTime' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastEngagement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mySummaryRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myStatusRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'engagementId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completionSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissalSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actionData' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'amIMentioned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMentionedConversation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMentionedTimestamp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mentionedPreview' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentionedDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optInStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationLabels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasRecentHeatCase' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignConversationsMutation,
  AssignConversationsMutationVariables
>;
export const BulkUpdateSupportedVehiclesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'bulkUpdateSupportedVehicles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BulkUpdateSupportedVehiclesInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulkUpdateSupportedVehicles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'supportedVehicles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'useOverrides' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outcome' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'repairService' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'enabledSupportedVehiclesCount',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'disabledSupportedVehiclesCount',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstEnabledOpCode' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isEnabled' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opCode' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dmsId' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opCodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isEnabled' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opCodeId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BulkUpdateSupportedVehiclesMutation,
  BulkUpdateSupportedVehiclesMutationVariables
>;
export const CancelPaymentRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelPaymentRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'CancelPaymentRequestInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelPaymentRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentRequestFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelPaymentRequestMutation,
  CancelPaymentRequestMutationVariables
>;
export const CancelScheduledMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'cancelScheduledMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CancelScheduledMessageInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelScheduledMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledMessage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelScheduledMessageMutation,
  CancelScheduledMessageMutationVariables
>;
export const CapturePaymentAmountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'capturePaymentAmount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CapturePaymentAmountInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'capturePaymentAmount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentRequestFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CapturePaymentAmountMutation,
  CapturePaymentAmountMutationVariables
>;
export const ChangeAccountSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'changeAccountSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChangeAccountSubscriptionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeAccountSubscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'account' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billingIdentity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subscriptions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'available' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sku' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'skuType',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'isActive',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'quantity' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeAccountSubscriptionMutation,
  ChangeAccountSubscriptionMutationVariables
>;
export const ChangeAllowCustomAudioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'changeAllowCustomAudio' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChangeAllowCustomAudioInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeAllowCustomAudio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allowCustomAudio' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeAllowCustomAudioMutation,
  ChangeAllowCustomAudioMutationVariables
>;
export const ChangeBusinessVerticalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'changeBusinessVertical' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChangeBusinessVerticalInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeBusinessVertical' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'account' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessVertical' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeBusinessVerticalMutation,
  ChangeBusinessVerticalMutationVariables
>;
export const ChangeInboxTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'changeInboxType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChangeInboxTypeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeInboxType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inboxType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeInboxTypeMutation,
  ChangeInboxTypeMutationVariables
>;
export const ChangeNotificationSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'changeNotificationSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NotificationSettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeNotificationSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'UserItemAndNotificationFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemAndNotificationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailOnAssignment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pushNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignmentClaimSetting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'swipeRightSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'swipeLeftSetting' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeNotificationSettingsMutation,
  ChangeNotificationSettingsMutationVariables
>;
export const ChangePlaceGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'changePlaceGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChangePlaceGroupInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changePlaceGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AdminPlaceFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AdminPlaceFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newConversationsPerDay' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasDegradedInboxExperience' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'allowCustomAudio' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeGroup' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangePlaceGroupMutation,
  ChangePlaceGroupMutationVariables
>;
export const ChangePlaceHoursDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'changePlaceHours' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChangePlaceHoursInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changePlaceHours' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangePlaceHoursMutation,
  ChangePlaceHoursMutationVariables
>;
export const ChangeSignupModeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'changeSignupMode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChangeSignupModeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeSignupMode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'account' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AdminAccountFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AdminAccountFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AccountQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'businessVertical' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingIdentity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signupMode' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeSignupModeMutation,
  ChangeSignupModeMutationVariables
>;
export const ChangeSwipeActionSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'changeSwipeActionSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChangeSwipeActionSettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeSwipeActionSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'UserItemAndNotificationFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemAndNotificationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailOnAssignment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pushNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignmentClaimSetting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'swipeRightSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'swipeLeftSetting' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeSwipeActionSettingsMutation,
  ChangeSwipeActionSettingsMutationVariables
>;
export const ChangeTwilioChannelMdnDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'changeTwilioChannelMdn' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChangeTwilioChannelMDNInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeTwilioChannelMdn' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channel' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outboundSmsMdn' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeTwilioChannelMdnMutation,
  ChangeTwilioChannelMdnMutationVariables
>;
export const ChangeUserSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'changeUserSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NotificationSettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeUserSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'UserItemAndNotificationFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemAndNotificationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailOnAssignment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pushNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignmentClaimSetting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'swipeRightSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'swipeLeftSetting' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeUserSettingsMutation,
  ChangeUserSettingsMutationVariables
>;
export const ChangeUserVideoConferenceUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChangeUserVideoConferenceUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ChangeUserVideoConferenceUrlInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeUserVideoConferenceUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'videoConferenceUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangeUserVideoConferenceUrlMutation,
  ChangeUserVideoConferenceUrlMutationVariables
>;
export const CloseStatusItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'closeStatusItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'CloseStatusItemInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'closeStatusItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'StatusItemDetails' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelStubFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StatusItemDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatusItemQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heldSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationItemStub' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationLabels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ConversationLabelStubFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CloseStatusItemMutation,
  CloseStatusItemMutationVariables
>;
export const CompleteAutopilotDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'completeAutopilot' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompleteAutopilotInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completeAutopilot' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autopilot' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutopilotFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutopilotFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutopilotQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autopilotStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'previewWelcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewInspection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewService' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewQualityControl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'previewPickup' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autopilotScheduleMessages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'milestoneName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduled' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompleteAutopilotMutation,
  CompleteAutopilotMutationVariables
>;
export const ConnectAutomationActionEdgeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'connectAutomationActionEdge' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConnectAutomationActionEdgeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'connectAutomationActionEdge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConnectAutomationActionEdgeMutation,
  ConnectAutomationActionEdgeMutationVariables
>;
export const CreateA2pCampaignForPlaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateA2pCampaignForPlace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'trustProductId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createA2pCampaignForPlace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'trustProductId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'trustProductId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenDlcProcess' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'twilioA2pCampaign' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'campaignStatus' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'twilioBrandRegistration',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'twilioTrustProduct' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'friendlyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateA2pCampaignForPlaceMutation,
  CreateA2pCampaignForPlaceMutationVariables
>;
export const CreateAppointmentAgentSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createAppointmentAgentSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'CreateAppointmentAgentSettingsInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAppointmentAgentSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'settings' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateAppointmentAgentSettingsMutation,
  CreateAppointmentAgentSettingsMutationVariables
>;
export const CreateAutomationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createAutomation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateAutomationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAutomation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateAutomationMutation,
  CreateAutomationMutationVariables
>;
export const CreateAutomationActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createAutomationAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateAutomationActionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAutomationAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateAutomationActionMutation,
  CreateAutomationActionMutationVariables
>;
export const CreateAutomationFromBlueprintDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createAutomationFromBlueprint' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'CreateAutomationFromBlueprintInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAutomationFromBlueprint' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateAutomationFromBlueprintMutation,
  CreateAutomationFromBlueprintMutationVariables
>;
export const CreateAutopilotDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createAutopilot' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateAutopilotInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAutopilot' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autopilot' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutopilotFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutopilotFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutopilotQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autopilotStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'previewWelcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewInspection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewService' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewQualityControl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'previewPickup' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autopilotScheduleMessages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'milestoneName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduled' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateAutopilotMutation,
  CreateAutopilotMutationVariables
>;
export const CreateChatExpansionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createChatExpansion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateChatExpansionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createChatExpansion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'textExpansion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'responses' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messages' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateChatExpansionMutation,
  CreateChatExpansionMutationVariables
>;
export const CreateConversationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createConversation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateConversationInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastAppointment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastRepairOrder' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createConversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConversationItemFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryMdn' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewIsInbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewServerGenerated' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewSource' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subPreview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serverGeneratedPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessageItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastAppointment' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastRepairOrder' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdateTime' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastEngagement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mySummaryRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myStatusRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'engagementId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completionSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissalSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actionData' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'amIMentioned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMentionedConversation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMentionedTimestamp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mentionedPreview' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentionedDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optInStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationLabels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasRecentHeatCase' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateConversationMutation,
  CreateConversationMutationVariables
>;
export const CreateConversationSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createConversationSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateConversationSummaryInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createConversationSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'textSummary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'responses' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messages' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateConversationSummaryMutation,
  CreateConversationSummaryMutationVariables
>;
export const CreateIdentityPromptAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createIdentityPromptAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateIdentityPromptAddressInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createIdentityPromptAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityPromptAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdOn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'channelId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateIdentityPromptAddressMutation,
  CreateIdentityPromptAddressMutationVariables
>;
export const CreateLabelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateLabelInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createLabel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'label' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'LabelFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateLabelMutation, CreateLabelMutationVariables>;
export const CreateOutboundConferenceCallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateOutboundConferenceCall' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'CreateOutboundConferenceCallInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createOutboundConferenceCall' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outboundConferenceCall' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'OutboundConferenceCallFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOutboundConferenceCallMutation,
  CreateOutboundConferenceCallMutationVariables
>;
export const CreateParticipantPaymentRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createParticipantPaymentRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'CreateParticipantPaymentRequestInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createParticipantPaymentRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentRequestFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateParticipantPaymentRequestMutation,
  CreateParticipantPaymentRequestMutationVariables
>;
export const CreatePaymentRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPaymentRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreatePaymentRequestInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPaymentRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentRequestFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePaymentRequestMutation,
  CreatePaymentRequestMutationVariables
>;
export const CreatePhoneLineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPhoneLine' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreatePhoneLineInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPhoneLine' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneline' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhoneLineFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneLineFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLineQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carrierName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createHostedSmsUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsForwardingMode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canForwardReturnCalls' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nryForwardingMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostedSmsPort' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationAttempts' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationCode' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePhoneLineMutation,
  CreatePhoneLineMutationVariables
>;
export const CreatePlaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePlace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreatePlaceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPlace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePlaceMutation, CreatePlaceMutationVariables>;
export const CreatePortalSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPortalSession' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPortalSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portalSession' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePortalSessionMutation,
  CreatePortalSessionMutationVariables
>;
export const CreateScheduledMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createScheduledMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateScheduledMessageInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createScheduledMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledMessage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ScheduledMessageFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduledMessageFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ScheduledMessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sendAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryAttempted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateScheduledMessageMutation,
  CreateScheduledMessageMutationVariables
>;
export const CreateStripeAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createStripeAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'CreateStripeAccountInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createStripeAccount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountLinkUrl' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'refreshUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'returnUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateStripeAccountMutation,
  CreateStripeAccountMutationVariables
>;
export const CreateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateUserInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobRole' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneline' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'returnCallsMdn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const CreateUserPhoneDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createUserPhone' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateUserPhoneInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUserPhone' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userPhone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sipAddress' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sipPriorityFirst' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'enabledDuringBusinessHours',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'enabledAfterBusinessHours',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enabledWhenAway' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateUserPhoneMutation,
  CreateUserPhoneMutationVariables
>;
export const CreateVideoUploadLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createVideoUploadLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateVideoUploadLinkInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createVideoUploadLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLink' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'VideoUploadLinkFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VideoUploadLinkFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoUploadLinkQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readyToStream' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'playbackHls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasBeenSent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateVideoUploadLinkMutation,
  CreateVideoUploadLinkMutationVariables
>;
export const DeleteAppointmentAgentSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteAppointmentAgentSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'DeleteAppointmentAgentSettingsInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAppointmentAgentSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteAppointmentAgentSettingsMutation,
  DeleteAppointmentAgentSettingsMutationVariables
>;
export const DeleteAutomationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteAutomation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteAutomationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAutomation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteAutomationMutation,
  DeleteAutomationMutationVariables
>;
export const DeleteConversationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteConversation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteConversationInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastAppointment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastRepairOrder' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteConversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConversationItemFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryMdn' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewIsInbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewServerGenerated' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewSource' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subPreview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serverGeneratedPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessageItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastAppointment' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastRepairOrder' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdateTime' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastEngagement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mySummaryRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myStatusRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'engagementId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completionSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissalSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actionData' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'amIMentioned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMentionedConversation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMentionedTimestamp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mentionedPreview' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentionedDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optInStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationLabels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasRecentHeatCase' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteConversationMutation,
  DeleteConversationMutationVariables
>;
export const DeleteCustomLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCustomLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DeleteCustomLinkInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCustomLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'placeInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkGroups' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groupLabel' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'links' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tag' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCustomLinkMutation,
  DeleteCustomLinkMutationVariables
>;
export const DeleteIdentityPromptAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteIdentityPromptAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteIdentityPromptAddressInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteIdentityPromptAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityPromptAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteIdentityPromptAddressMutation,
  DeleteIdentityPromptAddressMutationVariables
>;
export const DeleteNoteTakerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteNoteTaker' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteNoteTakerInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteNoteTaker' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteNoteTakerMutation,
  DeleteNoteTakerMutationVariables
>;
export const DeletePhoneLineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeletePhoneLine' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeletePhoneLineInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePhoneLine' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeletePhoneLineMutation,
  DeletePhoneLineMutationVariables
>;
export const DeletePlaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeletePlace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeletePlaceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePlace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePlaceMutation, DeletePlaceMutationVariables>;
export const DeleteScheduledMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteScheduledMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteScheduledMessageInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteScheduledMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteScheduledMessageMutation,
  DeleteScheduledMessageMutationVariables
>;
export const DeleteShortcutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteShortcut' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteShortcutInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteShortcut' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'response' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteShortcutMutation,
  DeleteShortcutMutationVariables
>;
export const DeleteStatusItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteStatusItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DeleteStatusItemInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteStatusItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stageId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteStatusItemMutation,
  DeleteStatusItemMutationVariables
>;
export const DeleteUserPhoneDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteUserPhone' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteUserPhoneInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteUserPhone' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userPhone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteUserPhoneMutation,
  DeleteUserPhoneMutationVariables
>;
export const DeleteVoiceStepDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteVoiceStep' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteVoiceStepInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteVoiceStep' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'voiceScript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'VoiceScriptFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canToggle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'executionOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renderedSpeech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stepType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customAudioOverrides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VoiceScriptStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TextOptinStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AskYesNoQuestionStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IntentQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpecialQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QualifyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PressAnyKeyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudio' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudioForAfterHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GreetingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softOpenSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectNewPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'collectPhonenumberFallbackSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarificationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCorrectQuestionSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retrySpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmationSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoAssignStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoAssignNextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallForwardingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'callTimeout' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'forwardingMdns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMdn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNumaCallerId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onConnectedStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoAnsweringStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallRecordingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PickupStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callerRecognizedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StatusUpdaterStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusGivenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noStatusGivenStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelConversationStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckForLabelStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasLabelId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onMissingLabelId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpeakStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QuestionBotStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NoteTakerStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'noteTakerId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedRecallStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedOtherStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedRecallSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedOtherSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'outcomeNotBookedWantsHumanSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notAnAppointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cantServiceCustomerStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyIntentFirstEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationStateStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'desiredConversationState' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckBusinessHoursStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onOpenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onClosedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmPromptOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmModelOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextStepId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalContext' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noMatchStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ConversationalSchedulingAgentStepQl',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmIntentSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shouldConfirmIntent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'greetingSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OperatorAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceScriptFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'afterHoursEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scriptType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowCustomAudio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstStepId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dirty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VoiceStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteVoiceStepMutation,
  DeleteVoiceStepMutationVariables
>;
export const DisableAutopilotDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'disableAutopilot' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DisableAutopilotInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disableAutopilot' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autopilot' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutopilotFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutopilotFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutopilotQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autopilotStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'previewWelcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewInspection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewService' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewQualityControl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'previewPickup' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autopilotScheduleMessages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'milestoneName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduled' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DisableAutopilotMutation,
  DisableAutopilotMutationVariables
>;
export const DiscardAutomationEditsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'discardAutomationEdits' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DiscardAutomationEditsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discardAutomationEdits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DiscardAutomationEditsMutation,
  DiscardAutomationEditsMutationVariables
>;
export const DiscardDisruptionVoiceScriptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'discardDisruptionVoiceScript' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'DiscardDisruptionVoiceScriptInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discardDisruptionVoiceScript' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'answeringMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'answeringModeUntil' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'disruptions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'disruptionDepartmentVoiceScriptId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'draftDisruptionDepartmentVoiceScriptId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'holidayDepartmentVoiceScriptId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'draftHolidayDepartmentVoiceScriptId',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DiscardDisruptionVoiceScriptMutation,
  DiscardDisruptionVoiceScriptMutationVariables
>;
export const DiscardVoiceScriptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'discardVoiceScript' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DiscardVoiceScriptInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discardVoiceScript' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'answeringScript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'draftVoiceScript' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'VoiceScriptFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canToggle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'executionOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renderedSpeech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stepType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customAudioOverrides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VoiceScriptStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TextOptinStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AskYesNoQuestionStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IntentQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpecialQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QualifyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PressAnyKeyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudio' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudioForAfterHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GreetingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softOpenSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectNewPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'collectPhonenumberFallbackSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarificationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCorrectQuestionSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retrySpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmationSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoAssignStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoAssignNextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallForwardingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'callTimeout' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'forwardingMdns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMdn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNumaCallerId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onConnectedStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoAnsweringStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallRecordingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PickupStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callerRecognizedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StatusUpdaterStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusGivenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noStatusGivenStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelConversationStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckForLabelStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasLabelId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onMissingLabelId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpeakStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QuestionBotStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NoteTakerStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'noteTakerId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedRecallStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedOtherStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedRecallSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedOtherSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'outcomeNotBookedWantsHumanSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notAnAppointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cantServiceCustomerStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyIntentFirstEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationStateStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'desiredConversationState' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckBusinessHoursStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onOpenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onClosedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmPromptOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmModelOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextStepId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalContext' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noMatchStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ConversationalSchedulingAgentStepQl',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmIntentSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shouldConfirmIntent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'greetingSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OperatorAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceScriptFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'afterHoursEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scriptType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowCustomAudio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstStepId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dirty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VoiceStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DiscardVoiceScriptMutation,
  DiscardVoiceScriptMutationVariables
>;
export const EnableNudgesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EnableNudges' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'EnableNudgesInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enableNudges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nudgesEnabled' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nudgesThreshold' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EnableNudgesMutation,
  EnableNudgesMutationVariables
>;
export const EnablePlaceMessageHoursDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'enablePlaceMessageHours' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'EnablePlaceMessagingHoursInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enablePlaceMessagingHours' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EnablePlaceMessageHoursMutation,
  EnablePlaceMessageHoursMutationVariables
>;
export const EndOutboundConferenceCallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EndOutboundConferenceCall' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'EndOutboundConferenceCallInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'endOutboundConferenceCall' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outboundConferenceCall' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'OutboundConferenceCallFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EndOutboundConferenceCallMutation,
  EndOutboundConferenceCallMutationVariables
>;
export const EvaluateBusinessIdentityMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EvaluateBusinessIdentityMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BusinessIdentityInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'evaluateBusinessIdentity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenDlcProcess' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'twilioTrustProduct' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'friendlyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'objectField' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'failureReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EvaluateBusinessIdentityMutationMutation,
  EvaluateBusinessIdentityMutationMutationVariables
>;
export const HostedPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'hostedPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostedPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hostedPage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HostedPageMutation, HostedPageMutationVariables>;
export const HostedSmsCompletedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'hostedSmsCompleted' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'HostedSmsCompletedInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostedSmsCompleted' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hostedSmsPort' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'HostedSmsPortFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HostedSmsPortFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HostedSmsPortQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAttempts' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loaSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerEmail' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HostedSmsCompletedMutation,
  HostedSmsCompletedMutationVariables
>;
export const ImpersonateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ImpersonateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'impersonate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refreshToken' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ImpersonateUserMutation,
  ImpersonateUserMutationVariables
>;
export const ImportHostedSmsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ImportHostedSMS' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ImportHostedSmsInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'importHostedSms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hostedSmsPort' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'HostedSmsPortFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HostedSmsPortFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HostedSmsPortQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAttempts' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loaSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerEmail' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ImportHostedSmsMutation,
  ImportHostedSmsMutationVariables
>;
export const IncreaseShortcutCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'increaseShortcutCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IncreaseShortcutCountInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'increaseShortcutCount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shortcut' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IncreaseShortcutCountMutation,
  IncreaseShortcutCountMutationVariables
>;
export const LeaveAllConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'leaveAllConversations' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaveAllConversations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeaveAllConversationsMutation,
  LeaveAllConversationsMutationVariables
>;
export const LeaveConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'leaveConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LeaveConversationsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaveConversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeaveConversationsMutation,
  LeaveConversationsMutationVariables
>;
export const MoveAutomationNodesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'moveAutomationNodes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateAutomationUIHintsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAutomationUIHints' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MoveAutomationNodesMutation,
  MoveAutomationNodesMutationVariables
>;
export const MoveStatusItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'moveStatusItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'MoveStatusItemInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'moveStatusItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'StatusItemDetails' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelStubFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StatusItemDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatusItemQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heldSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationItemStub' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationLabels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ConversationLabelStubFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MoveStatusItemMutation,
  MoveStatusItemMutationVariables
>;
export const PokeUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'pokeUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PokeUserInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pokeUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PokeUserMutation, PokeUserMutationVariables>;
export const PortInPhoneLineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'portInPhoneLine' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PortInPhoneLineInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portInPhoneLine' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneline' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhoneLineFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channel' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChannelFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneLineFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLineQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carrierName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createHostedSmsUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsForwardingMode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canForwardReturnCalls' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nryForwardingMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostedSmsPort' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationAttempts' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationCode' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Channel' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBotEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityPromptOption' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TwilioChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outboundSmsMdn' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'sendOutboundsWithShadowTollfree',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreePhonenumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreeSid' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'accountSid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'archiveMissedCalls' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoSendHangupReplies' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hangupSuggestion' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneLinePolicyId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FacebookChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PortInPhoneLineMutation,
  PortInPhoneLineMutationVariables
>;
export const PublishAutomationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'publishAutomation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PublishAutomationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishAutomation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishAutomationMutation,
  PublishAutomationMutationVariables
>;
export const PublishDisruptionVoiceScriptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'publishDisruptionVoiceScript' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'PublishDisruptionVoiceScriptInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishDisruptionVoiceScript' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'answeringMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'answeringModeUntil' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'disruptions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'disruptionDepartmentVoiceScriptId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'draftDisruptionDepartmentVoiceScriptId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'holidayDepartmentVoiceScriptId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'draftHolidayDepartmentVoiceScriptId',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishDisruptionVoiceScriptMutation,
  PublishDisruptionVoiceScriptMutationVariables
>;
export const PublishVoiceScriptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'publishVoiceScript' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PublishVoiceScriptInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishVoiceScript' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'answeringScript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'voiceScript' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'VoiceScriptFields',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'draftVoiceScript' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'VoiceScriptFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canToggle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'executionOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renderedSpeech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stepType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customAudioOverrides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VoiceScriptStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TextOptinStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AskYesNoQuestionStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IntentQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpecialQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QualifyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PressAnyKeyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudio' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudioForAfterHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GreetingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softOpenSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectNewPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'collectPhonenumberFallbackSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarificationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCorrectQuestionSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retrySpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmationSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoAssignStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoAssignNextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallForwardingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'callTimeout' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'forwardingMdns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMdn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNumaCallerId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onConnectedStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoAnsweringStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallRecordingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PickupStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callerRecognizedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StatusUpdaterStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusGivenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noStatusGivenStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelConversationStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckForLabelStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasLabelId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onMissingLabelId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpeakStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QuestionBotStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NoteTakerStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'noteTakerId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedRecallStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedOtherStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedRecallSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedOtherSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'outcomeNotBookedWantsHumanSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notAnAppointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cantServiceCustomerStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyIntentFirstEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationStateStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'desiredConversationState' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckBusinessHoursStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onOpenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onClosedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmPromptOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmModelOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextStepId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalContext' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noMatchStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ConversationalSchedulingAgentStepQl',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmIntentSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shouldConfirmIntent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'greetingSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OperatorAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceScriptFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'afterHoursEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scriptType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowCustomAudio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstStepId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dirty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VoiceStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishVoiceScriptMutation,
  PublishVoiceScriptMutationVariables
>;
export const PubNubAppointmentEnrichedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubAppointmentEnriched' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'appointment' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubAppointmentModel' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversation_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubAppointmentEnriched' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appointment' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'appointment' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversation_id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversation_id' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubAppointmentEnrichedMutation,
  PubNubAppointmentEnrichedMutationVariables
>;
export const PubNubArchiveConversationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubArchiveConversation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversation' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubConversationModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubArchiveConversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversation' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversation' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubArchiveConversationMutation,
  PubNubArchiveConversationMutationVariables
>;
export const PubNubArchiveConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubArchiveConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'inbox_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversations' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'PubNubConversationTimestamp' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubArchiveConversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'inbox_id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'inbox_id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversations' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversations' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubArchiveConversationsMutation,
  PubNubArchiveConversationsMutationVariables
>;
export const PubNubAssignConversationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubAssignConversation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversation' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PubNubConversationModel' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubAssignConversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversation' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversation' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubAssignConversationMutation,
  PubNubAssignConversationMutationVariables
>;
export const PubNubAwayModeChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubAwayModeChanged' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'user_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'is_away' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'is_schedule_enabled' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status_board_view' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'next_shift_start' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'next_shift_end' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'can_manage_own_away_mode_settings' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'is_unassigning_inbound_messages' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'show_away_mode_banner_after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubAwayModeChanged' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'user_id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'user_id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'is_away' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'is_away' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'is_schedule_enabled' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'is_schedule_enabled' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status_board_view' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status_board_view' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'next_shift_start' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'next_shift_start' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'next_shift_end' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'next_shift_end' },
                },
              },
              {
                kind: 'Argument',
                name: {
                  kind: 'Name',
                  value: 'can_manage_own_away_mode_settings',
                },
                value: {
                  kind: 'Variable',
                  name: {
                    kind: 'Name',
                    value: 'can_manage_own_away_mode_settings',
                  },
                },
              },
              {
                kind: 'Argument',
                name: {
                  kind: 'Name',
                  value: 'is_unassigning_inbound_messages',
                },
                value: {
                  kind: 'Variable',
                  name: {
                    kind: 'Name',
                    value: 'is_unassigning_inbound_messages',
                  },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'show_away_mode_banner_after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'show_away_mode_banner_after' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubAwayModeChangedMutation,
  PubNubAwayModeChangedMutationVariables
>;
export const PubNubConversationDeletedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubConversationDeleted' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversation' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubConversationModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubConversationDeleted' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversation' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversation' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubConversationDeletedMutation,
  PubNubConversationDeletedMutationVariables
>;
export const PubNubConversationEngagementUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubConversationEngagementUpdated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversation' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubConversationModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'PubNubConversationEngagementUpdated',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversation' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversation' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubConversationEngagementUpdatedMutation,
  PubNubConversationEngagementUpdatedMutationVariables
>;
export const PubNubConversationLanguageResetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubConversationLanguageReset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversation' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubConversationModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubConversationLanguageReset' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversation' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversation' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubConversationLanguageResetMutation,
  PubNubConversationLanguageResetMutationVariables
>;
export const PubNubConversationRecoveredDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubConversationRecovered' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversation' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubConversationModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubConversationRecovered' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversation' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversation' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubConversationRecoveredMutation,
  PubNubConversationRecoveredMutationVariables
>;
export const PubNubDegradedInboxExperienceUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubDegradedInboxExperienceUpdated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'account_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'place_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'has_degraded_inbox_experience' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'PubNubDegradedInboxExperienceUpdated',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'account_id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'account_id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'place_id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'place_id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'has_degraded_inbox_experience' },
                value: {
                  kind: 'Variable',
                  name: {
                    kind: 'Name',
                    value: 'has_degraded_inbox_experience',
                  },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubDegradedInboxExperienceUpdatedMutation,
  PubNubDegradedInboxExperienceUpdatedMutationVariables
>;
export const PubNubDialogFlowBotDataUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubDialogFlowBotDataUpdated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'dialog_flow_bot_data' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubDialogFlowBotDataModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubDialogFlowBotDataUpdated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dialog_flow_bot_data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dialog_flow_bot_data' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubDialogFlowBotDataUpdatedMutation,
  PubNubDialogFlowBotDataUpdatedMutationVariables
>;
export const PubNubEquityTradeOpportunityUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubEquityTradeOpportunityUpdated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversation_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'equity_trade_opportunity' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'PubNubEquityTradeOpportunityModel',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'PubNubEquityTradeOpportunityUpdated',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversation_id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversation_id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'equity_trade_opportunity' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'equity_trade_opportunity' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubEquityTradeOpportunityUpdatedMutation,
  PubNubEquityTradeOpportunityUpdatedMutationVariables
>;
export const PubNubInboundCallStatusUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubInboundCallStatusUpdated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'call' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubInboundPhoneCallModel' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversation_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubInboundCallStatusUpdated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'call' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'call' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversation_id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversation_id' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubInboundCallStatusUpdatedMutation,
  PubNubInboundCallStatusUpdatedMutationVariables
>;
export const PubNubLabelCreatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubLabelCreated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'label' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubLabelModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubLabelCreated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'label' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'label' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubLabelCreatedMutation,
  PubNubLabelCreatedMutationVariables
>;
export const PubNubLabelUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubLabelUpdated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'label' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubLabelModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubLabelUpdated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'label' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'label' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubLabelUpdatedMutation,
  PubNubLabelUpdatedMutationVariables
>;
export const PubNubLeaveConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubLeaveConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversation_ids' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'String' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubLeaveConversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversation_ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversation_ids' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubLeaveConversationsMutation,
  PubNubLeaveConversationsMutationVariables
>;
export const PubNubMessageReceivedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubMessageReceived' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversation' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubConversationModel' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'message' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PubNubMessageModel' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubMessageReceived' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversation' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversation' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'message' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'message' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubMessageReceivedMutation,
  PubNubMessageReceivedMutationVariables
>;
export const PubNubNumboxAgentSessionUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubNumboxAgentSessionUpdated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'numbox_agent_session' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubNumboxAgentSessionModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubNumboxAgentSessionUpdated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numbox_agent_session' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'numbox_agent_session' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubNumboxAgentSessionUpdatedMutation,
  PubNubNumboxAgentSessionUpdatedMutationVariables
>;
export const PubNubOutboundConferenceCallStatusUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'PubNubOutboundConferenceCallStatusUpdated',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'outbound_conference_call' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'PubNubOutboundConferenceCallModel',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'PubNubOutboundConferenceCallStatusUpdated',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'outbound_conference_call' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'outbound_conference_call' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubOutboundConferenceCallStatusUpdatedMutation,
  PubNubOutboundConferenceCallStatusUpdatedMutationVariables
>;
export const PubNubOutboundProxyCallStatusUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubOutboundProxyCallStatusUpdated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'call_status' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'start_time' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'is_being_recorded' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'PubNubOutboundProxyCallStatusUpdated',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'call_status' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'call_status' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'start_time' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'start_time' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'is_being_recorded' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'is_being_recorded' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubOutboundProxyCallStatusUpdatedMutation,
  PubNubOutboundProxyCallStatusUpdatedMutationVariables
>;
export const PubNubPaymentRequestCreatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubPaymentRequestCreated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'payment_request' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubPaymentRequestModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubPaymentRequestCreated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payment_request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'payment_request' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubPaymentRequestCreatedMutation,
  PubNubPaymentRequestCreatedMutationVariables
>;
export const PubNubPaymentRequestUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubPaymentRequestUpdated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'payment_request' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubPaymentRequestModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubPaymentRequestUpdated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payment_request' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'payment_request' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubPaymentRequestUpdatedMutation,
  PubNubPaymentRequestUpdatedMutationVariables
>;
export const PubNubPlaceUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubPlaceUpdated' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubPlaceUpdated' },
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubPlaceUpdatedMutation,
  PubNubPlaceUpdatedMutationVariables
>;
export const PubNubRestoreConversationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubRestoreConversation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversation' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PubNubConversationModel' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubRestoreConversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversation' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversation' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubRestoreConversationMutation,
  PubNubRestoreConversationMutationVariables
>;
export const PubNubRestoreConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubRestoreConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'inbox_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversations' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'PubNubConversationTimestamp' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubRestoreConversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'inbox_id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'inbox_id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversations' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversations' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubRestoreConversationsMutation,
  PubNubRestoreConversationsMutationVariables
>;
export const PubNubStatusItemCreatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubStatusItemCreated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status_item' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubStatusItemModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubStatusItemCreated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'statusItem' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status_item' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubStatusItemCreatedMutation,
  PubNubStatusItemCreatedMutationVariables
>;
export const PubNubStatusItemDeletedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubStatusItemDeleted' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status_item' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubStatusItemModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubStatusItemDeleted' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'statusItem' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status_item' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubStatusItemDeletedMutation,
  PubNubStatusItemDeletedMutationVariables
>;
export const PubNubStatusItemUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubStatusItemUpdated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status_item' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubStatusItemUpdateModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubStatusItemUpdated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'statusItem' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status_item' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubStatusItemUpdatedMutation,
  PubNubStatusItemUpdatedMutationVariables
>;
export const PubNubStripeIntegrationUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubStripeIntegrationUpdated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'stripe_integration' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubStripeIntegrationModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubStripeIntegrationUpdated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stripe_integration' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'stripe_integration' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubStripeIntegrationUpdatedMutation,
  PubNubStripeIntegrationUpdatedMutationVariables
>;
export const PubNubTaskCreatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubTaskCreated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'task' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubTaskModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubTaskCreated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'task' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'task' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubTaskCreatedMutation,
  PubNubTaskCreatedMutationVariables
>;
export const PubNubTaskUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubTaskUpdated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'task' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubTaskModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubTaskUpdated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'task' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'task' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubTaskUpdatedMutation,
  PubNubTaskUpdatedMutationVariables
>;
export const PubNubTeamCreatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubTeamCreated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'team' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubTeamSettingsModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubTeamCreated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'team' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'team' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubTeamCreatedMutation,
  PubNubTeamCreatedMutationVariables
>;
export const PubNubTeamDeletedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubTeamDeleted' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'team_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'place_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubTeamDeleted' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'team_id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'team_id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'place_id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'place_id' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubTeamDeletedMutation,
  PubNubTeamDeletedMutationVariables
>;
export const PubNubTeamUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubTeamUpdated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'team' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubTeamSettingsModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubTeamUpdated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'team' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'team' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubTeamUpdatedMutation,
  PubNubTeamUpdatedMutationVariables
>;
export const PubNubTranscriptUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubTranscriptUpdated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'transcript' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubTranscriptModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubTranscriptUpdated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'transcript' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'transcript' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubTranscriptUpdatedMutation,
  PubNubTranscriptUpdatedMutationVariables
>;
export const PubNubVideoUploadLinkUpdatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PubNubVideoUploadLinkUpdated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'video_upload_link' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PubNubVideoUploadLinkModel' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'PubNubVideoUploadLinkUpdated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'video_upload_link' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'video_upload_link' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PubNubVideoUploadLinkUpdatedMutation,
  PubNubVideoUploadLinkUpdatedMutationVariables
>;
export const RecoverConversationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'recoverConversation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RecoverConversationInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastAppointment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastRepairOrder' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recoverConversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConversationItemFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryMdn' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewIsInbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewServerGenerated' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewSource' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subPreview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serverGeneratedPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessageItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastAppointment' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastRepairOrder' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdateTime' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastEngagement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mySummaryRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myStatusRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'engagementId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completionSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissalSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actionData' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'amIMentioned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMentionedConversation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMentionedTimestamp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mentionedPreview' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentionedDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optInStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationLabels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasRecentHeatCase' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RecoverConversationMutation,
  RecoverConversationMutationVariables
>;
export const RefreshCarrierInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'refreshCarrierInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RefreshCarrierInfoInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refreshCarrierInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneline' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhoneLineFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneLineFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLineQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carrierName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createHostedSmsUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsForwardingMode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canForwardReturnCalls' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nryForwardingMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostedSmsPort' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationAttempts' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationCode' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RefreshCarrierInfoMutation,
  RefreshCarrierInfoMutationVariables
>;
export const RefreshTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'refreshToken' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'refreshToken' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'login' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'credential' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'refreshToken' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'refreshToken' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refreshToken' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'featureFlags' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RefreshTokenMutation,
  RefreshTokenMutationVariables
>;
export const RefundPaymentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RefundPayment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateStripeRefundInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createStripeRefund' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentRequestFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RefundPaymentMutation,
  RefundPaymentMutationVariables
>;
export const RemoveAutomationActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removeAutomationAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RemoveAutomationActionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeAutomationAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveAutomationActionMutation,
  RemoveAutomationActionMutationVariables
>;
export const RemoveAutomationExitTriggerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removeAutomationExitTrigger' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RemoveAutomationExitTriggerInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeAutomationExitTrigger' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveAutomationExitTriggerMutation,
  RemoveAutomationExitTriggerMutationVariables
>;
export const RemoveLabelFromConversationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveLabelFromConversation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RemoveLabelFromConversationInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastAppointment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastRepairOrder' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeLabelFromConversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConversationItemFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryMdn' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewIsInbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewServerGenerated' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewSource' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subPreview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serverGeneratedPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessageItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastAppointment' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastRepairOrder' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdateTime' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastEngagement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mySummaryRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myStatusRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'engagementId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completionSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissalSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actionData' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'amIMentioned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMentionedConversation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMentionedTimestamp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mentionedPreview' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentionedDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optInStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationLabels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasRecentHeatCase' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveLabelFromConversationMutation,
  RemoveLabelFromConversationMutationVariables
>;
export const RemovePlaceGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removePlaceGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RemovePlaceGroupInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removePlaceGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'account' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemovePlaceGroupMutation,
  RemovePlaceGroupMutationVariables
>;
export const RemoveUserFromPlaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveUserFromPlace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RemoveUserFromPlaceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeUserFromPlace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'placesUsers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'placeId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveUserFromPlaceMutation,
  RemoveUserFromPlaceMutationVariables
>;
export const RemoveVideoUploadLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removeVideoUploadLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RemoveVideoUploadLinkInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeVideoUploadLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLink' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'VideoUploadLinkFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VideoUploadLinkFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoUploadLinkQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readyToStream' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'playbackHls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasBeenSent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveVideoUploadLinkMutation,
  RemoveVideoUploadLinkMutationVariables
>;
export const RenameAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'renameAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'RenameAccountInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renameAccount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'account' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RenameAccountMutation,
  RenameAccountMutationVariables
>;
export const RenamePlaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'renamePlace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'RenamePlaceInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renamePlace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RenamePlaceMutation, RenamePlaceMutationVariables>;
export const ReopenStatusItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'reopenStatusItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ReopenStatusItemInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reopenStatusItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'StatusItemDetails' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelStubFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StatusItemDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatusItemQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heldSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationItemStub' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationLabels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ConversationLabelStubFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReopenStatusItemMutation,
  ReopenStatusItemMutationVariables
>;
export const RequestAvailableIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'requestAvailableIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RequestAvailableIntegrationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestAvailableIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeIntegration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'integrationId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'configuration' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestAvailableIntegrationMutation,
  RequestAvailableIntegrationMutationVariables
>;
export const ResetAppointmentAgentSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'resetAppointmentAgentSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ResetAppointmentAgentSettingsInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetAppointmentAgentSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetAppointmentAgentSettingsMutation,
  ResetAppointmentAgentSettingsMutationVariables
>;
export const ResetBrandThemeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResetBrandTheme' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ResetBrandThemeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetBrandTheme' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'brandTheme' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BrandThemeFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BrandThemeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandThemeQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'headerBackgroundColor' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'headerBorderColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headerTextColor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bodyBackgroundColor' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'bodyBorderColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bodyTextColor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonPrimaryBackgroundColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonPrimaryBorderColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonPrimaryTextColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonSecondaryBackgroundColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonSecondaryBorderColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonSecondaryTextColor' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paletteType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportedPaletteTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'headerBackgroundColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'headerBorderColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'headerTextColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bodyBackgroundColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bodyBorderColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bodyTextColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonPrimaryBackgroundColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonPrimaryBorderColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonPrimaryTextColor' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'buttonSecondaryBackgroundColor',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonSecondaryBorderColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonSecondaryTextColor' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetBrandThemeMutation,
  ResetBrandThemeMutationVariables
>;
export const ResetConversationLanguageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'resetConversationLanguage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ResetConversationLanguageInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetConversationLanguage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConversationItemStub' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetConversationLanguageMutation,
  ResetConversationLanguageMutationVariables
>;
export const ResetOutboundChannelsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'resetOutboundChannels' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ResetOutboundChannelsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetOutboundChannels' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetOutboundChannelsMutation,
  ResetOutboundChannelsMutationVariables
>;
export const ResetVoiceScriptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'resetVoiceScript' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ResetVoiceScriptInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetVoiceScript' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'voiceScript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'VoiceScriptFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canToggle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'executionOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renderedSpeech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stepType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customAudioOverrides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VoiceScriptStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TextOptinStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AskYesNoQuestionStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IntentQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpecialQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QualifyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PressAnyKeyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudio' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudioForAfterHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GreetingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softOpenSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectNewPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'collectPhonenumberFallbackSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarificationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCorrectQuestionSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retrySpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmationSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoAssignStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoAssignNextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallForwardingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'callTimeout' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'forwardingMdns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMdn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNumaCallerId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onConnectedStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoAnsweringStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallRecordingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PickupStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callerRecognizedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StatusUpdaterStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusGivenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noStatusGivenStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelConversationStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckForLabelStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasLabelId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onMissingLabelId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpeakStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QuestionBotStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NoteTakerStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'noteTakerId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedRecallStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedOtherStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedRecallSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedOtherSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'outcomeNotBookedWantsHumanSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notAnAppointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cantServiceCustomerStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyIntentFirstEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationStateStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'desiredConversationState' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckBusinessHoursStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onOpenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onClosedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmPromptOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmModelOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextStepId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalContext' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noMatchStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ConversationalSchedulingAgentStepQl',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmIntentSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shouldConfirmIntent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'greetingSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OperatorAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceScriptFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'afterHoursEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scriptType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowCustomAudio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstStepId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dirty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VoiceStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetVoiceScriptMutation,
  ResetVoiceScriptMutationVariables
>;
export const SendLoaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'sendLoa' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SendLoaInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendLoa' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hostedSmsPort' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'HostedSmsPortFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HostedSmsPortFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HostedSmsPortQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAttempts' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loaSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerEmail' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendLoaMutation, SendLoaMutationVariables>;
export const SendMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'sendMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SendMessageInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MessageItemFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendMessageMutation, SendMessageMutationVariables>;
export const SendReviewRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'sendReviewRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SendReviewRequestInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReviewRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MessageItemFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendReviewRequestMutation,
  SendReviewRequestMutationVariables
>;
export const SendScheduledMessageNowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'sendScheduledMessageNow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SendScheduledMessageNowInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendScheduledMessageNow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MessageItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledMessage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ScheduledMessageFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduledMessageFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ScheduledMessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sendAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryAttempted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendScheduledMessageNowMutation,
  SendScheduledMessageNowMutationVariables
>;
export const SendStatusItemMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'sendStatusItemMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SendStatusItemMessageInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendStatusItemMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'StatusItemStub' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelStubFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StatusItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatusItemQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heldSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationItemStub' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationLabels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ConversationLabelStubFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendStatusItemMessageMutation,
  SendStatusItemMessageMutationVariables
>;
export const AddServiceAdvisorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addServiceAdvisor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GenericAddServiceAdvisorInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addServiceAdvisor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceAdvisorId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'placesUsersId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceAdvisorName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddServiceAdvisorMutation,
  AddServiceAdvisorMutationVariables
>;
export const RemoveServiceAdvisorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removeServiceAdvisor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RemoveServiceAdvisorInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeServiceAdvisor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveServiceAdvisorMutation,
  RemoveServiceAdvisorMutationVariables
>;
export const UpdateServiceAdvisorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateServiceAdvisor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateServiceAdvisorInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateServiceAdvisor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceAdvisorId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'placesUsersId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceAdvisorName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateServiceAdvisorMutation,
  UpdateServiceAdvisorMutationVariables
>;
export const SetAssignmentRetentionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setAssignmentRetention' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newRetention' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setAssignmentRetention' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assignmentRetention' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'newRetention' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignmentRetention' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetAssignmentRetentionMutation,
  SetAssignmentRetentionMutationVariables
>;
export const SetBusinessTimezoneDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setBusinessTimezone' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SetBusinessTimezoneInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setBusinessTimezone' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetBusinessTimezoneMutation,
  SetBusinessTimezoneMutationVariables
>;
export const SetHangupSuggestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setHangupSuggestion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SetHangupSuggestionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setHangupSuggestion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneLinePolicy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hangupSuggestion' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetHangupSuggestionMutation,
  SetHangupSuggestionMutationVariables
>;
export const SetOngoingOptInResetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetOngoingOptInReset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newOngoingResetOptinDays' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setResetOngoingOptin' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'resetOngoingOptin' },
                      value: {
                        kind: 'Variable',
                        name: {
                          kind: 'Name',
                          value: 'newOngoingResetOptinDays',
                        },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resetOngoingOptin' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetOngoingOptInResetMutation,
  SetOngoingOptInResetMutationVariables
>;
export const SetOptInStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setOptInStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SetOptInStatusInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastAppointment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastRepairOrder' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setOptInStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConversationItemFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryMdn' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewIsInbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewServerGenerated' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewSource' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subPreview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serverGeneratedPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessageItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastAppointment' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastRepairOrder' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdateTime' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastEngagement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mySummaryRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myStatusRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'engagementId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completionSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissalSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actionData' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'amIMentioned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMentionedConversation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMentionedTimestamp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mentionedPreview' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentionedDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optInStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationLabels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasRecentHeatCase' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetOptInStatusMutation,
  SetOptInStatusMutationVariables
>;
export const SetResetOptinDaysDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetResetOptinDays' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newResetOptinDays' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setResetOptinDays' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'resetOptinDays' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'newResetOptinDays' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resetOptinDays' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetResetOptinDaysMutation,
  SetResetOptinDaysMutationVariables
>;
export const SnoozeConversationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'snoozeConversation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SnoozeConversationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'snoozeConversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConversationItemStub' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SnoozeConversationMutation,
  SnoozeConversationMutationVariables
>;
export const StartConversationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'startConversation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StartConversationInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastAppointment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastRepairOrder' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startConversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConversationItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MessageItemFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryMdn' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewIsInbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewServerGenerated' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewSource' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subPreview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serverGeneratedPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessageItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastAppointment' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastRepairOrder' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdateTime' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastEngagement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mySummaryRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myStatusRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'engagementId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completionSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissalSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actionData' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'amIMentioned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMentionedConversation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMentionedTimestamp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mentionedPreview' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentionedDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optInStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationLabels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasRecentHeatCase' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartConversationMutation,
  StartConversationMutationVariables
>;
export const StartConversationWithScheduledMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'startConversationWithScheduledMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'StartConversationWithScheduledMessageInput',
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastAppointment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastRepairOrder' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'startConversationWithScheduledMessage',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConversationItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduledMessage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ScheduledMessageFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryMdn' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewIsInbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewServerGenerated' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewSource' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subPreview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serverGeneratedPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessageItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastAppointment' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastRepairOrder' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdateTime' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastEngagement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mySummaryRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myStatusRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'engagementId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completionSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissalSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actionData' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'amIMentioned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMentionedConversation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMentionedTimestamp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mentionedPreview' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentionedDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optInStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationLabels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasRecentHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduledMessageFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ScheduledMessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sendAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryAttempted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartConversationWithScheduledMessageMutation,
  StartConversationWithScheduledMessageMutationVariables
>;
export const SubmitBusinessIdentityMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SubmitBusinessIdentityMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BusinessIdentityInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'trustProductId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submitBusinessIdentity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'trustProductId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'trustProductId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenDlcProcess' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'twilioTrustProduct' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'friendlyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'twilioBrandRegistration',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'failureReason' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'objectField' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubmitBusinessIdentityMutationMutation,
  SubmitBusinessIdentityMutationMutationVariables
>;
export const TeachNumaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'teachNuma' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TeachNumaInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teachNuma' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appliedIntent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeachNumaMutation, TeachNumaMutationVariables>;
export const AddUserToTeamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addUserToTeam' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AddUserToTeamInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userCount' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'afterUser' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addUserToTeam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamWithUsers' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamWithUsers' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'TeamFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userCount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'afterUser' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isAway' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddUserToTeamMutation,
  AddUserToTeamMutationVariables
>;
export const CreateTeamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTeam' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateTeamInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userCount' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'afterUser' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTeam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamWithUsers' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamWithUsers' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'TeamFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userCount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'afterUser' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isAway' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTeamMutation, CreateTeamMutationVariables>;
export const DeleteTeamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteTeam' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteTeamInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTeam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const RemoveUserFromTeamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removeUserFromTeam' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RemoveUserFromTeamInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userCount' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'afterUser' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeUserFromTeam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamWithUsers' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamWithUsers' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'TeamFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userCount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'afterUser' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isAway' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveUserFromTeamMutation,
  RemoveUserFromTeamMutationVariables
>;
export const UpdateTeamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateTeam' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTeamInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTeam' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamSettingsFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamSettingsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentStyle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const ToggleCustomPhoneLinePolicyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'toggleCustomPhoneLinePolicy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ToggleCustomPhoneLinePolicyInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'toggleCustomPhoneLinePolicy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneline' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'policy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'category' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ToggleCustomPhoneLinePolicyMutation,
  ToggleCustomPhoneLinePolicyMutationVariables
>;
export const UpdateActiveIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateActiveIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateActiveIntegrationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateActiveIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeIntegration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'configuration' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pendingOpcodeSync' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'appointmentAgentSettings',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'placeId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'settings' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateActiveIntegrationMutation,
  UpdateActiveIntegrationMutationVariables
>;
export const UpdateAnsweringScriptOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAnsweringScriptOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: {
                    kind: 'Name',
                    value: 'UpdateAnsweringScriptOrderInput',
                  },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAnsweringScriptOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'answeringScripts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAnsweringScriptOrderMutation,
  UpdateAnsweringScriptOrderMutationVariables
>;
export const UpdateAppointmentAgentSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAppointmentAgentSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdateAppointmentAgentSettingsInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAppointmentAgentSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'settings' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agentProfile' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'optionalPrompts' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'overallEmphasis' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numaInCallFlow' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'webSchedulerReliability',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textingCanWeTextSpeech' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'textingOnYesSpeechCanWeText',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'textingOnNoSpeechCanWeText',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textingMessageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textingHangupRecovery' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'renderedTextingMessageToSend',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'renderedTextingHangupRecovery',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeIntegrationId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'minimumLeadTimeInMinutes',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'maximumBookingHorizonInDays',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enableHangupRecovery' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeIntegration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value:
                                  'AppointmentAgentSettingsActiveIntegrationFields',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultExternalOpcode' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ExternalOpcodeFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'AppointmentAgentSettingsActiveIntegrationFields',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ActiveIntegrationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pendingOpcodeSync' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExternalOpcodeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ExternalOpcodeQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'serviceName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAppointmentAgentSettingsMutation,
  UpdateAppointmentAgentSettingsMutationVariables
>;
export const UpdateAssignmentRoutingSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAssignmentRoutingSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdateAssignmentRoutingSettingsInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAssignmentRoutingSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignmentRoutingSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enabled' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMdn' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'enabledDuringBusinessHours',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'enabledAfterBusinessHours',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enabledWhenAway' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'callTimeout' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'useNumaCallerId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAssignmentRoutingSettingsMutation,
  UpdateAssignmentRoutingSettingsMutationVariables
>;
export const UpdateAutomationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAutomation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateAutomationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAutomation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAutomationMutation,
  UpdateAutomationMutationVariables
>;
export const UpdateAutomationActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAutomationAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateAutomationActionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAutomationAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAutomationActionMutation,
  UpdateAutomationActionMutationVariables
>;
export const UpdateAutomationEnrollmentCriteriaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAutomationEnrollmentCriteria' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdateAutomationEnrollmentCriteriaInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAutomationEnrollmentCriteria' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAutomationEnrollmentCriteriaMutation,
  UpdateAutomationEnrollmentCriteriaMutationVariables
>;
export const UpdateAutomationExitTriggerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAutomationExitTrigger' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateAutomationExitTriggerInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAutomationExitTrigger' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAutomationExitTriggerMutation,
  UpdateAutomationExitTriggerMutationVariables
>;
export const UpdateAutomationStartTriggerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAutomationStartTrigger' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdateAutomationStartTriggerInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAutomationStartTrigger' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'automation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutomationFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAutomationStartTriggerMutation,
  UpdateAutomationStartTriggerMutationVariables
>;
export const UpdateAutopilotJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAutopilotJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateAutopilotJobInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAutopilotJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autopilotJob' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'welcome' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inspection' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'service' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'qualityControl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pickup' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAutopilotJobMutation,
  UpdateAutopilotJobMutationVariables
>;
export const UpdateAutopilotScheduledMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAutopilotScheduledMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdateAutopilotScheduledMessageInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAutopilotScheduledMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autopilot' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutopilotFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutopilotFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutopilotQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autopilotStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'previewWelcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewInspection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewService' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewQualityControl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'previewPickup' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autopilotScheduleMessages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'milestoneName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduled' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAutopilotScheduledMessageMutation,
  UpdateAutopilotScheduledMessageMutationVariables
>;
export const UpdateAwayModeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAwayMode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateAwayModeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAwayMode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AwayModeFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AwayModeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isScheduleEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftEnd' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showAwayModeBannerAfter' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canManageOwnAwayModeSettings' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAwayModeMutation,
  UpdateAwayModeMutationVariables
>;
export const UpdateAwayModeAssigneeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAwayModeAssignee' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateAwayModeAssigneeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAwayModeAssignee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AwayModeDetailsFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AwayModeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isScheduleEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftEnd' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showAwayModeBannerAfter' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canManageOwnAwayModeSettings' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AwayModeDetailsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AwayModeFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placesUsers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'awayModeAssigneeUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'awayModeAssigneeTeam' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAwayModeAssigneeMutation,
  UpdateAwayModeAssigneeMutationVariables
>;
export const UpdateAwayModeManagingPermissionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAwayModeManagingPermission' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdateAwayModeManagingPermissionInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAwayModeManagingPermission' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AwayModeFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AwayModeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isScheduleEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftEnd' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showAwayModeBannerAfter' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canManageOwnAwayModeSettings' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAwayModeManagingPermissionMutation,
  UpdateAwayModeManagingPermissionMutationVariables
>;
export const UpdateAwayModeWithTimeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAwayModeWithTime' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateAwayModeWithTimeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAwayModeWithTime' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AwayModeFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AwayModeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isScheduleEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftEnd' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showAwayModeBannerAfter' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canManageOwnAwayModeSettings' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAwayModeWithTimeMutation,
  UpdateAwayModeWithTimeMutationVariables
>;
export const UpdateBillingMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBillingMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateBillingMetadataInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBillingMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billingMetadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hubspotDealId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hubspotCompanyId' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'chargebeeSubscriptionId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'chargebeeCustomerId',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBillingMetadataMutation,
  UpdateBillingMetadataMutationVariables
>;
export const UpdateBrandThemeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateBrandTheme' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateBrandThemeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBrandTheme' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'brandTheme' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BrandThemeFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BrandThemeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandThemeQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'headerBackgroundColor' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'headerBorderColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headerTextColor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bodyBackgroundColor' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'bodyBorderColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bodyTextColor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonPrimaryBackgroundColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonPrimaryBorderColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonPrimaryTextColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonSecondaryBackgroundColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonSecondaryBorderColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonSecondaryTextColor' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paletteType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportedPaletteTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'headerBackgroundColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'headerBorderColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'headerTextColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bodyBackgroundColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bodyBorderColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bodyTextColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonPrimaryBackgroundColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonPrimaryBorderColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonPrimaryTextColor' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'buttonSecondaryBackgroundColor',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonSecondaryBorderColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonSecondaryTextColor' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBrandThemeMutation,
  UpdateBrandThemeMutationVariables
>;
export const UpdateBusinessIdentityMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBusinessIdentityMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BusinessIdentityInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'trustProductId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBusinessIdentity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'trustProductId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'trustProductId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenDlcProcess' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'twilioTrustProduct' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'friendlyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'friendlyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'objectField' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'failureReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBusinessIdentityMutationMutation,
  UpdateBusinessIdentityMutationMutationVariables
>;
export const UpdateBusinessProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateBusinessProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateBusinessProfileInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBusinessProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'businessProfile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'BusinessProfileFields' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'account' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'places' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BusinessProfileFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BusinessProfileQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalBusinessName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'physicalAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'businessType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'businessIndustry' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'businessRegistrationIdType' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'businessRegistrationNumberType' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'businessRegistrationNumber' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'businessRegionsOfOperations' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'companyStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stockTickerExchange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contact1LastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contact1FirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contact1Email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contact1BusinessTitle' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contact1JobPosition' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contact1PhoneNumber' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'registrationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registrationStatus' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBusinessProfileMutation,
  UpdateBusinessProfileMutationVariables
>;
export const UpdateCallIntelligenceEnabledDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCallIntelligenceEnabled' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdateCallIntelligenceEnabledInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCallIntelligenceEnabled' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'placesUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'callIntelligenceEnabled',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCallIntelligenceEnabledMutation,
  UpdateCallIntelligenceEnabledMutationVariables
>;
export const UpdateChannelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateChannel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateChannelInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channel' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChannelFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Channel' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBotEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityPromptOption' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TwilioChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outboundSmsMdn' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'sendOutboundsWithShadowTollfree',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreePhonenumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreeSid' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'accountSid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'archiveMissedCalls' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoSendHangupReplies' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hangupSuggestion' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneLinePolicyId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FacebookChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateChannelMutation,
  UpdateChannelMutationVariables
>;
export const UpdateConversationLabelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateConversationLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateConversationLabelInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateConversationLabel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationLabel' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ConversationLabelFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateConversationLabelMutation,
  UpdateConversationLabelMutationVariables
>;
export const UpdateCurbsideSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCurbsideSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateCurbsideSettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCurbsideSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'curbsideSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enabled' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderIdentifierType' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'orderIdentifierIntentResponse',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customHereIsAutoreply' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'handoffMethod' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'handoffMethodIntentResponse',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'customHandoffIsAutoreply',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCurbsideSettingsMutation,
  UpdateCurbsideSettingsMutationVariables
>;
export const UpdateDefaultViewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDefaultView' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateDefaultViewInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDefaultView' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultView' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDefaultViewMutation,
  UpdateDefaultViewMutationVariables
>;
export const UpdateDefaultYouViewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDefaultYouView' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateDefaultYouViewInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDefaultYouView' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultYouView' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateDefaultYouViewMutation,
  UpdateDefaultYouViewMutationVariables
>;
export const UpdateEdgesVoiceStepDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateEdgesVoiceStep' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateEdgesVoiceStepInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEdgesVoiceStep' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'voiceScript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'VoiceScriptFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canToggle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'executionOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renderedSpeech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stepType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customAudioOverrides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VoiceScriptStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TextOptinStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AskYesNoQuestionStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IntentQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpecialQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QualifyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PressAnyKeyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudio' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudioForAfterHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GreetingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softOpenSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectNewPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'collectPhonenumberFallbackSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarificationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCorrectQuestionSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retrySpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmationSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoAssignStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoAssignNextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallForwardingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'callTimeout' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'forwardingMdns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMdn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNumaCallerId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onConnectedStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoAnsweringStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallRecordingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PickupStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callerRecognizedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StatusUpdaterStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusGivenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noStatusGivenStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelConversationStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckForLabelStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasLabelId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onMissingLabelId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpeakStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QuestionBotStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NoteTakerStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'noteTakerId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedRecallStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedOtherStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedRecallSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedOtherSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'outcomeNotBookedWantsHumanSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notAnAppointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cantServiceCustomerStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyIntentFirstEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationStateStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'desiredConversationState' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckBusinessHoursStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onOpenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onClosedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmPromptOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmModelOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextStepId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalContext' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noMatchStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ConversationalSchedulingAgentStepQl',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmIntentSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shouldConfirmIntent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'greetingSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OperatorAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceScriptFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'afterHoursEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scriptType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowCustomAudio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstStepId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dirty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VoiceStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateEdgesVoiceStepMutation,
  UpdateEdgesVoiceStepMutationVariables
>;
export const UpdateEscalationSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEscalationSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateEscalationSettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEscalationSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'escalationsEnabled' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'escalationsThreshold' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateEscalationSettingsMutation,
  UpdateEscalationSettingsMutationVariables
>;
export const UpdateGreetingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateGreeting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateGreetingInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateGreeting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'greeting' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentTemplate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'afterHoursContent' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'afterHoursContentTemplate',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateGreetingMutation,
  UpdateGreetingMutationVariables
>;
export const UpdateHideSharedInboxViewsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateHideSharedInboxViews' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateHideSharedInboxViewsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateHideSharedInboxViews' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InboxBehaviourFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InboxBehaviourFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hideSharedInboxViews' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'statusBoardView' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultView' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultYouView' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pushNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserNotificationSetting' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateHideSharedInboxViewsMutation,
  UpdateHideSharedInboxViewsMutationVariables
>;
export const UpdateHostedSmsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateHostedSms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateHostedSmsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateHostedSms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hostedSmsPort' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'HostedSmsPortFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HostedSmsPortFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HostedSmsPortQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAttempts' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loaSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerEmail' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateHostedSmsMutation,
  UpdateHostedSmsMutationVariables
>;
export const UpdateIsScheduleEnabledDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateIsScheduleEnabled' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateIsScheduleEnabledInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateIsScheduleEnabled' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AwayModeFields' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'schedule' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isScheduleEnabled' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AwayModeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isScheduleEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftEnd' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showAwayModeBannerAfter' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canManageOwnAwayModeSettings' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateIsScheduleEnabledMutation,
  UpdateIsScheduleEnabledMutationVariables
>;
export const UpdateLabelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateLabelInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLabel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'label' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'LabelFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateLabelMutation, UpdateLabelMutationVariables>;
export const UpdateLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UpdateLinkInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'placeInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkGroups' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groupLabel' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'links' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tag' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateLinkMutation, UpdateLinkMutationVariables>;
export const UpdateLinkUrlsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateLinkUrls' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UpdateLinkUrlsInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLinkUrls' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'placeInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkGroups' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'groupLabel' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'links' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tag' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateLinkUrlsMutation,
  UpdateLinkUrlsMutationVariables
>;
export const UpdateLoggedCallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateLoggedCall' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateLoggedCallInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLoggedCall' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MessageItemFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateLoggedCallMutation,
  UpdateLoggedCallMutationVariables
>;
export const UpdateMissedCallFollowUpSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateMissedCallFollowUpSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdateMissedCallFollowUpSettingInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMissedCallFollowUpSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'missedOutboundCallFollowUpEnabled',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'missedOutboundCallFollowUpMessage',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'missedOutboundCallFollowUpRenderedMessage',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateMissedCallFollowUpSettingMutation,
  UpdateMissedCallFollowUpSettingMutationVariables
>;
export const UpdateNewConversationsPerDayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateNewConversationsPerDay' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdateNewConversationsPerDayInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNewConversationsPerDay' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newConversationsPerDay' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateNewConversationsPerDayMutation,
  UpdateNewConversationsPerDayMutationVariables
>;
export const UpdateOutboundConferenceCallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateOutboundConferenceCall' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdateOutboundConferenceCallInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOutboundConferenceCall' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outboundConferenceCall' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'OutboundConferenceCallFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOutboundConferenceCallMutation,
  UpdateOutboundConferenceCallMutationVariables
>;
export const UpdateParticipantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateParticipant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateParticipantInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateParticipant' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ParticipantFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateParticipantMutation,
  UpdateParticipantMutationVariables
>;
export const UpdatePaymentRequestAttachmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePaymentRequestAttachment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdatePaymentRequestAttachmentInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePaymentRequestAttachment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PaymentRequestFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePaymentRequestAttachmentMutation,
  UpdatePaymentRequestAttachmentMutationVariables
>;
export const UpdatePaymentRequestCustomizationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePaymentRequestCustomization' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdatePaymentRequestCustomizationInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePaymentRequestCustomization' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentRequestCustomization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'placeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createTemplate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'renderedCreateTemplate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createAutoSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createHoldTemplate' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'renderedCreateHoldTemplate',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createHoldAutoSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'successTemplate' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'renderedSuccessTemplate',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'successAutoSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refundTemplate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'renderedRefundTemplate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refundAutoSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'partialRefundTemplate' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'renderedPartialRefundTemplate',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'partialRefundAutoSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'canceledTemplate' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'renderedCanceledTemplate',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'canceledAutoSend' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePaymentRequestCustomizationMutation,
  UpdatePaymentRequestCustomizationMutationVariables
>;
export const UpdatePhoneCallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePhoneCall' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdatePhoneCallInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePhoneCall' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phonecall' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isBeingRecorded' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePhoneCallMutation,
  UpdatePhoneCallMutationVariables
>;
export const UpdatePhoneLineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePhoneLine' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdatePhoneLineInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePhoneLine' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneline' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'PhonelineCategorySettingsFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhonelineCategorySettingsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLineQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsForwardingMode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canForwardReturnCalls' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nryForwardingMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'smsChannel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePhoneLineMutation,
  UpdatePhoneLineMutationVariables
>;
export const UpdatePhoneLinePolicyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePhoneLinePolicy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdatePhoneLinePolicyInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePhoneLinePolicy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneLinePolicy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PhoneLinePolicyFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneLinePolicyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLinePolicyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoOptin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoOptinMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delayAnswerDuration' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'answerWithKeys' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fixInternalDialing' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'assistantPhrase' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveMissedCalls' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hangupSuggestion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoSendHangupReplies' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasIdentityPrompt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowDisruptions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nryCallForwardingPickUpTimeoutSecs' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'nryCallForwardingUserScreenInteractionTimeoutSecs',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeringScripts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scriptType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'order' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePhoneLinePolicyMutation,
  UpdatePhoneLinePolicyMutationVariables
>;
export const UpdatePlaceDisruptionSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePlaceDisruptionSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdatePlaceDisruptionSettingsInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePlaceDisruptionSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'answeringMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'answeringModeFrom' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'answeringModeUntil' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'disruptions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'disruptionsGreeting',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePlaceDisruptionSettingsMutation,
  UpdatePlaceDisruptionSettingsMutationVariables
>;
export const UpdatePlaceGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePlaceGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdatePlaceGroupInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePlaceGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'placeGroup' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePlaceGroupMutation,
  UpdatePlaceGroupMutationVariables
>;
export const UpdateLogosDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateLogos' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateLogosInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLogos' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'placeInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'logoUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'brandTheme' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'logoUrl' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateLogosMutation, UpdateLogosMutationVariables>;
export const UpdatePlaceMfaSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePlaceMFASettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdatePlaceMFASettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePlaceMfaSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enforceMfa' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePlaceMfaSettingsMutation,
  UpdatePlaceMfaSettingsMutationVariables
>;
export const UpdatePlaceNamePronunciationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePlaceNamePronunciation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateNamePronunciationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNamePronunciation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'namePronunciation' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'namePronunciationUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePlaceNamePronunciationMutation,
  UpdatePlaceNamePronunciationMutationVariables
>;
export const UpdatePlaceOutboundCallSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePlaceOutboundCallSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'UpdatePlaceOutboundCallSettingsInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePlaceOutboundCallSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outboundCallSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mdn' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePlaceOutboundCallSettingsMutation,
  UpdatePlaceOutboundCallSettingsMutationVariables
>;
export const UpdatePlaceStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePlaceStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdatePlaceStatusInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePlaceStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePlaceStatusMutation,
  UpdatePlaceStatusMutationVariables
>;
export const UpdatePlaceVoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePlaceVoice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdatePlaceVoiceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePlaceVoice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'voiceSpanish' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'voiceFrench' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePlaceVoiceMutation,
  UpdatePlaceVoiceMutationVariables
>;
export const UpdateAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateAppointmentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAppointment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AppointmentFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAppointmentMutation,
  UpdateAppointmentMutationVariables
>;
export const UpdateQuestionAgentSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateQuestionAgentSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateQuestionAgentSettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateQuestionAgentSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionAgentSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'settings' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateQuestionAgentSettingsMutation,
  UpdateQuestionAgentSettingsMutationVariables
>;
export const UpdateReceivesEscalationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateReceivesEscalations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateReceivesEscalationsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateReceivesEscalations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'placesUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'receivesEscalations' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateReceivesEscalationsMutation,
  UpdateReceivesEscalationsMutationVariables
>;
export const UpdateReviewJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateReviewJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateReviewJobInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateReviewJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reviewJob' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'placeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fallbackChannelId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageBody' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageImageUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewSites' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'serviceName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'FacebookReviewSite',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'facebookPageId',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'headerColor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'headerTextColor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'backgroundColor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textColor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'buttonColor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'buttonTextColor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'skipRatingsScreen' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateReviewJobMutation,
  UpdateReviewJobMutationVariables
>;
export const UpdateShortcutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateShortcut' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateShortcutInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateShortcut' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shortcut' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateShortcutMutation,
  UpdateShortcutMutationVariables
>;
export const UpdateShowBannerAfterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateShowBannerAfter' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateShowBannerAfter' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'showAwayModeBannerAfter',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateShowBannerAfterMutation,
  UpdateShowBannerAfterMutationVariables
>;
export const UpdateStageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateStage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateStageInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateStage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'StageStub' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StageStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageTemplate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renderedMessageTemplate' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMessageTemplate' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renderedUpdateMessageTemplate' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'speechUpdate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speechUrl' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateStageMutation, UpdateStageMutationVariables>;
export const UpdateStatusBoardViewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateStatusBoardView' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateStatusBoardViewInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateStatusBoardView' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InboxBehaviourFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InboxBehaviourFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hideSharedInboxViews' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'statusBoardView' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultView' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultYouView' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pushNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserNotificationSetting' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateStatusBoardViewMutation,
  UpdateStatusBoardViewMutationVariables
>;
export const UpdateStatusItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateStatusItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UpdateStatusItemInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateStatusItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'StatusItemDetails' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelStubFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StatusItemDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatusItemQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heldSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationItemStub' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationLabels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ConversationLabelStubFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateStatusItemMutation,
  UpdateStatusItemMutationVariables
>;
export const UpdateSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billingIdentityId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'quantity' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'skuName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSubscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billingIdentityId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billingIdentityId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'quantity' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'quantity' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skuName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'skuName' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subscription' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'quantity' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sku' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSubscriptionMutation,
  UpdateSubscriptionMutationVariables
>;
export const UpdateTransportationSetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateTransportationSet' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTransportationSetInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTransportationSet' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transportationSet' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'placeId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'rules' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enabled' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'speechUtterance' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transportationOptions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'enabled' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'kind' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'order' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'speechShort' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'speechLong' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'minimumServiceItems',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTransportationSetMutation,
  UpdateTransportationSetMutationVariables
>;
export const UpdateTwilioChannelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTwilioChannel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTwilioChannelInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTwilioChannel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channel' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ChannelFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Channel' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBotEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityPromptOption' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TwilioChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outboundSmsMdn' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'sendOutboundsWithShadowTollfree',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreePhonenumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreeSid' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'accountSid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'archiveMissedCalls' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoSendHangupReplies' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hangupSuggestion' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneLinePolicyId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FacebookChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTwilioChannelMutation,
  UpdateTwilioChannelMutationVariables
>;
export const UpdateUseNewNumberDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUseNewNumber' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateUseNewNumberInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUseNewNumber' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'account' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'useNewNumber' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUseNewNumberMutation,
  UpdateUseNewNumberMutationVariables
>;
export const UpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateUserInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'signature' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'signaturePreference' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserInformationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserInformation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateUserInformationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserInformation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobRole' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobTitle' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserInformationMutation,
  UpdateUserInformationMutationVariables
>;
export const UpdateUserMfaSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUserMFASettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateUserMFASettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserMfaSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enforceMfa' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserMfaSettingsMutation,
  UpdateUserMfaSettingsMutationVariables
>;
export const UpdateUserPersonalizationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserPersonalization' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateUserPersonalizationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserPersonalization' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'namePronunciation' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'namePronunciationUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pronouns' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserPersonalizationMutation,
  UpdateUserPersonalizationMutationVariables
>;
export const UpdateUserPhoneDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserPhone' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateUserPhoneInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserPhone' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userPhone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sipAddress' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sipPriorityFirst' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'enabledDuringBusinessHours',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'enabledAfterBusinessHours',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enabledWhenAway' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserPhoneMutation,
  UpdateUserPhoneMutationVariables
>;
export const UpdateUserScheduleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserSchedule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateUserScheduleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AwayModeFields' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'schedule' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isScheduleEnabled' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AwayModeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isScheduleEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftEnd' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showAwayModeBannerAfter' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canManageOwnAwayModeSettings' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserScheduleMutation,
  UpdateUserScheduleMutationVariables
>;
export const UpdateUserViewPreferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserViewPreferences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateUserViewPreferencesInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserViewPreferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'viewPreferences' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'UserViewPreferencesFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SystemMessageSettingsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SystemMessageSettings' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showSystemMessages' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserViewPreferencesFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserViewPreferences' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'systemMessageSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SystemMessageSettingsFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserViewPreferencesMutation,
  UpdateUserViewPreferencesMutationVariables
>;
export const UpdateVideoUploadLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateVideoUploadLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateVideoUploadLinkInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateVideoUploadLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLink' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'VideoUploadLinkFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VideoUploadLinkFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoUploadLinkQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readyToStream' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'playbackHls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasBeenSent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateVideoUploadLinkMutation,
  UpdateVideoUploadLinkMutationVariables
>;
export const UpdateVoiceScriptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateVoiceScript' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateVoiceScriptInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateVoiceScript' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'voiceScript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'VoiceScriptFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canToggle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'executionOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renderedSpeech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stepType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customAudioOverrides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VoiceScriptStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TextOptinStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AskYesNoQuestionStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IntentQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpecialQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QualifyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PressAnyKeyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudio' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudioForAfterHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GreetingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softOpenSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectNewPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'collectPhonenumberFallbackSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarificationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCorrectQuestionSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retrySpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmationSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoAssignStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoAssignNextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallForwardingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'callTimeout' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'forwardingMdns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMdn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNumaCallerId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onConnectedStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoAnsweringStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallRecordingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PickupStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callerRecognizedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StatusUpdaterStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusGivenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noStatusGivenStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelConversationStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckForLabelStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasLabelId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onMissingLabelId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpeakStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QuestionBotStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NoteTakerStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'noteTakerId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedRecallStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedOtherStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedRecallSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedOtherSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'outcomeNotBookedWantsHumanSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notAnAppointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cantServiceCustomerStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyIntentFirstEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationStateStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'desiredConversationState' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckBusinessHoursStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onOpenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onClosedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmPromptOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmModelOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextStepId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalContext' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noMatchStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ConversationalSchedulingAgentStepQl',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmIntentSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shouldConfirmIntent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'greetingSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OperatorAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceScriptFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'afterHoursEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scriptType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowCustomAudio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstStepId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dirty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VoiceStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateVoiceScriptMutation,
  UpdateVoiceScriptMutationVariables
>;
export const UpdateVoiceStepDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateVoiceStep' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateVoiceStepInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateVoiceStep' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'step' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'VoiceStepFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'script' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dirty' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canToggle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'executionOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renderedSpeech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stepType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customAudioOverrides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VoiceScriptStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TextOptinStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AskYesNoQuestionStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IntentQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpecialQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QualifyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PressAnyKeyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudio' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudioForAfterHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GreetingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softOpenSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectNewPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'collectPhonenumberFallbackSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarificationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCorrectQuestionSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retrySpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmationSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoAssignStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoAssignNextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallForwardingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'callTimeout' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'forwardingMdns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMdn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNumaCallerId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onConnectedStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoAnsweringStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallRecordingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PickupStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callerRecognizedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StatusUpdaterStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusGivenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noStatusGivenStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelConversationStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckForLabelStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasLabelId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onMissingLabelId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpeakStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QuestionBotStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NoteTakerStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'noteTakerId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedRecallStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedOtherStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedRecallSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedOtherSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'outcomeNotBookedWantsHumanSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notAnAppointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cantServiceCustomerStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyIntentFirstEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationStateStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'desiredConversationState' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckBusinessHoursStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onOpenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onClosedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmPromptOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmModelOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextStepId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalContext' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noMatchStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ConversationalSchedulingAgentStepQl',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmIntentSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shouldConfirmIntent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'greetingSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OperatorAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateVoiceStepMutation,
  UpdateVoiceStepMutationVariables
>;
export const UpdateVoiceStepUiHintsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateVoiceStepUIHints' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateVoiceStepUIHintsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateVoiceStepUIHints' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'voiceScript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'VoiceScriptFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canToggle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'executionOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renderedSpeech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stepType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customAudioOverrides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VoiceScriptStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TextOptinStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AskYesNoQuestionStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IntentQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpecialQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QualifyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PressAnyKeyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudio' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudioForAfterHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GreetingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softOpenSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectNewPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'collectPhonenumberFallbackSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarificationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCorrectQuestionSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retrySpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmationSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoAssignStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoAssignNextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallForwardingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'callTimeout' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'forwardingMdns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMdn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNumaCallerId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onConnectedStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoAnsweringStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallRecordingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PickupStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callerRecognizedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StatusUpdaterStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusGivenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noStatusGivenStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelConversationStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckForLabelStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasLabelId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onMissingLabelId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpeakStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QuestionBotStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NoteTakerStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'noteTakerId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedRecallStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedOtherStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedRecallSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedOtherSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'outcomeNotBookedWantsHumanSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notAnAppointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cantServiceCustomerStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyIntentFirstEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationStateStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'desiredConversationState' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckBusinessHoursStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onOpenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onClosedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmPromptOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmModelOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextStepId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalContext' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noMatchStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ConversationalSchedulingAgentStepQl',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmIntentSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shouldConfirmIntent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'greetingSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OperatorAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceScriptFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'afterHoursEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scriptType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowCustomAudio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstStepId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dirty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VoiceStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateVoiceStepUiHintsMutation,
  UpdateVoiceStepUiHintsMutationVariables
>;
export const UploadCustomAudioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UploadCustomAudio' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UploadCustomAudioInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploadCustomAudio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'step' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'VoiceStepFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'script' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dirty' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canToggle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'executionOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renderedSpeech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stepType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customAudioOverrides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VoiceScriptStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TextOptinStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AskYesNoQuestionStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IntentQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpecialQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QualifyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PressAnyKeyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudio' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudioForAfterHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GreetingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softOpenSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectNewPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'collectPhonenumberFallbackSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarificationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCorrectQuestionSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retrySpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmationSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoAssignStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoAssignNextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallForwardingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'callTimeout' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'forwardingMdns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMdn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNumaCallerId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onConnectedStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoAnsweringStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallRecordingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PickupStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callerRecognizedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StatusUpdaterStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusGivenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noStatusGivenStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelConversationStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckForLabelStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasLabelId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onMissingLabelId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpeakStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QuestionBotStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NoteTakerStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'noteTakerId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedRecallStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedOtherStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedRecallSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedOtherSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'outcomeNotBookedWantsHumanSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notAnAppointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cantServiceCustomerStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyIntentFirstEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationStateStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'desiredConversationState' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckBusinessHoursStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onOpenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onClosedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmPromptOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmModelOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextStepId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalContext' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noMatchStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ConversationalSchedulingAgentStepQl',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmIntentSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shouldConfirmIntent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'greetingSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OperatorAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UploadCustomAudioMutation,
  UploadCustomAudioMutationVariables
>;
export const SearchConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'search' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationModelSortEnum' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autocompleteConversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'search' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'connection' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'key' },
                    value: {
                      kind: 'StringValue',
                      value: 'autocompleteConversations',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'filter' },
                    value: { kind: 'ListValue', values: [] },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'AutocompleteConversationFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutocompleteConversationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cnamContact' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchConversationsQuery,
  SearchConversationsQueryVariables
>;
export const SearchParticipantsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchParticipants' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'search' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autocompleteParticipants' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'search' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'connection' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'key' },
                    value: {
                      kind: 'StringValue',
                      value: 'autocompleteParticipants',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'filter' },
                    value: { kind: 'ListValue', values: [] },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'source' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conversations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'startCursor',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'endCursor',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'hasNextPage',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'node' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'place',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'id',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchParticipantsQuery,
  SearchParticipantsQueryVariables
>;
export const SearchShortcutsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchShortcuts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'search' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchTag' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autocompleteShortcuts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'search' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchTag' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchTag' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '25' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'EnumValue', value: 'name_asc' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tag' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchShortcutsQuery,
  SearchShortcutsQueryVariables
>;
export const SearchTeamsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchTeams' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'search' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversationId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeEmptyTeams' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autocompleteTeams' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'search' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversationId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeEmptyTeams' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'includeEmptyTeams' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutoCompleteTeamsFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutoCompleteTeamsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'edges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'node' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchTeamsQuery, SearchTeamsQueryVariables>;
export const SearchUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'search' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversationId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autocompleteUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'search' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversationId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutoCompleteUsersFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutoCompleteUsersFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'edges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'node' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchUsersQuery, SearchUsersQueryVariables>;
export const CountAllConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'countAllConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'state' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'assignedTo' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'AssignmentFilterInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newerThan' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ArrowField' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationModelSortEnum' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isOverdue' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'state' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'state' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'lastUpdated' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'greaterThan' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'newerThan' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isOverdue' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'isOverdue' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assignedTo' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'assignedTo' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountAllConversationsQuery,
  CountAllConversationsQueryVariables
>;
export const CountAssignedConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'countAssignedConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'assigneeId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'state' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newerThan' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ArrowField' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationModelSortEnum' },
            },
          },
          defaultValue: { kind: 'EnumValue', value: 'last_updated_desc' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'hasStatusItems' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isOverdue' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hasStatusItems' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'hasStatusItems' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'state' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'state' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assigneeId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'assigneeId' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'lastUpdated' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'greaterThan' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'newerThan' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isOverdue' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'isOverdue' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountAssignedConversationsQuery,
  CountAssignedConversationsQueryVariables
>;
export const CountFilteredConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'countFilteredConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'inboxId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'state' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'assignedTo' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'AssignmentFilterInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newerThan' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ArrowField' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationModelSortEnum' },
            },
          },
          defaultValue: { kind: 'EnumValue', value: 'last_updated_desc' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isOverdue' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'state' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'state' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'inboxId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'inboxId' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'lastUpdated' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'greaterThan' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'newerThan' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isOverdue' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'isOverdue' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assignedTo' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'assignedTo' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountFilteredConversationsQuery,
  CountFilteredConversationsQueryVariables
>;
export const CountUnassignedConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'countUnassignedConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'state' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'assignedTo' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'AssignmentFilterInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newerThan' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ArrowField' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationModelSortEnum' },
            },
          },
          defaultValue: { kind: 'EnumValue', value: 'last_updated_desc' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isOverdue' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'state' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'state' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'lastUpdated' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'greaterThan' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'newerThan' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isOverdue' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'isOverdue' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assignedTo' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'assignedTo' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountUnassignedConversationsQuery,
  CountUnassignedConversationsQueryVariables
>;
export const AccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'account' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'usersAfter' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'businessVertical' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNewNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'placeGroups' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'IntValue', value: '1000' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'AccountDetailsPlaceGroup',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'users' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'IntValue', value: '200' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'after' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'usersAfter' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startCursor' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endCursor' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hasNextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hasPreviousPage' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'UserDetailFields',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owners' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'billingIdentity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'signupMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subscriptions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'AdminSubscriptionFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccountDetailsPlace' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newConversationsPerDay' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccountDetailsPlaceGroup' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceGroupQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'places' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1000' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'AccountDetailsPlace',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserDetailFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placesUsers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AdminSubscriptionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubscriptionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sku' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skuType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountQuery, AccountQueryVariables>;
export const GetAccountOwnersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAccountOwners' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owners' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isAway' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAccountOwnersQuery,
  GetAccountOwnersQueryVariables
>;
export const GetAccountSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAccountSettings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignmentRetention' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nudgesEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nudgesThreshold' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'archiveMissedCalls' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'escalationsEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'escalationsThreshold' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hangupSuggestion' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resetOptinDays' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resetOngoingOptin' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAccountSettingsQuery,
  GetAccountSettingsQueryVariables
>;
export const AccountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'accounts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'AccountModelFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AccountModelSortEnum' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accounts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasPreviousPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'twilioSubaccountSid',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'billingIdentity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'billingOrderId',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'subscriptions',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'quantity',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'available',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'sku' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'isActive',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'skuType',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'name',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountsQuery, AccountsQueryVariables>;
export const GetActiveInboundPhoneCallsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getActiveInboundPhoneCalls' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeInboundPhoneCalls' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetActiveInboundPhoneCallsQuery,
  GetActiveInboundPhoneCallsQueryVariables
>;
export const GetActiveInboxDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getActiveInbox' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeInbox' },
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'options' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unreadOnly' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActiveInboxQuery, GetActiveInboxQueryVariables>;
export const GetActiveIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getActiveIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'integrationId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'integrationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'integrationId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pendingOpcodeSync' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'integration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'configurationSchema' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'internalId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categories' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'configuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'placeId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'settings' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetActiveIntegrationQuery,
  GetActiveIntegrationQueryVariables
>;
export const GetActiveIntegrationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getActiveIntegrations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'knownIntegrationCategories' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableIntegrations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'setupType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'settingsUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featureFlag' } },
                { kind: 'Field', name: { kind: 'Name', value: 'internalId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'configurationSchema' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeIntegrations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'integrationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'friendlyName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'configuration' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetActiveIntegrationsQuery,
  GetActiveIntegrationsQueryVariables
>;
export const GetActivePaymentsCollectionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getActivePaymentsCollection' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activePaymentsCollection' },
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectionId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetActivePaymentsCollectionQuery,
  GetActivePaymentsCollectionQueryVariables
>;
export const GetAdminPlaceDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAdminPlaceDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'billingMetadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hubspotDealId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hubspotCompanyId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'chargebeeSubscriptionId',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'chargebeeCustomerId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AdminPlaceFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'placesUsers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hasNextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startCursor' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endCursor' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'user' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'UserDetailFields',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AdminPlaceFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newConversationsPerDay' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasDegradedInboxExperience' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'allowCustomAudio' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeGroup' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserDetailFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placesUsers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAdminPlaceDetailsQuery,
  GetAdminPlaceDetailsQueryVariables
>;
export const AllConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'state' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'assignedTo' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'AssignmentFilterInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newerThan' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ArrowField' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationModelSortEnum' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isOverdue' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'state' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'state' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'lastUpdated' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'greaterThan' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'newerThan' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isOverdue' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'isOverdue' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assignedTo' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'assignedTo' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'connection' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'key' },
                    value: {
                      kind: 'StringValue',
                      value: 'conversations',
                      block: false,
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ConversationItemStub',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllConversationsQuery,
  AllConversationsQueryVariables
>;
export const GetAppointmentAgentSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAppointmentAgentSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentAgentSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'AppointmentAgentSettingsFields',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeIntegration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value:
                            'AppointmentAgentSettingsActiveIntegrationFields',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'latestSchedulerSync' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDate' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'AppointmentAgentSettingsPlaceFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExternalOpcodeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ExternalOpcodeQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'serviceName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentAgentSettingsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentAgentSettingsQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentProfile' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optionalPrompts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overallEmphasis' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numaInCallFlow' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'webSchedulerReliability' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textingCanWeTextSpeech' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textingOnYesSpeechCanWeText' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textingOnNoSpeechCanWeText' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textingMessageToSend' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textingHangupRecovery' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renderedTextingMessageToSend' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renderedTextingHangupRecovery' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'minimumLeadTimeInMinutes' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'maximumBookingHorizonInDays' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enableHangupRecovery' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'defaultExternalOpcode' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ExternalOpcodeFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'AppointmentAgentSettingsActiveIntegrationFields',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ActiveIntegrationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pendingOpcodeSync' } },
          { kind: 'Field', name: { kind: 'Name', value: 'integrationId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentAgentSettingsPlaceFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlaceQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalPlaceInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkGroups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'groupLabel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tag' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAppointmentAgentSettingsQuery,
  GetAppointmentAgentSettingsQueryVariables
>;
export const GetAppointmentAgentSettingsUseDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAppointmentAgentSettingsUse' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'voiceStepConversationalSchedulingAgent',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAppointmentAgentSettingsUseQuery,
  GetAppointmentAgentSettingsUseQueryVariables
>;
export const GetAppointmentAgentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAppointmentAgents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentAgents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeIntegration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pendingOpcodeSync' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'integration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'internalId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAppointmentAgentsQuery,
  GetAppointmentAgentsQueryVariables
>;
export const AssignedConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'assignedConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'assigneeId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'state' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newerThan' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ArrowField' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationModelSortEnum' },
            },
          },
          defaultValue: { kind: 'EnumValue', value: 'last_updated_desc' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'hasStatusItems' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isOverdue' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hasStatusItems' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'hasStatusItems' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'state' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'state' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assigneeId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'assigneeId' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'lastUpdated' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'greaterThan' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'newerThan' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isOverdue' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'isOverdue' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'connection' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'key' },
                    value: {
                      kind: 'StringValue',
                      value: 'conversations',
                      block: false,
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ConversationItemStub',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignedConversationsQuery,
  AssignedConversationsQueryVariables
>;
export const GetAssignmentRetentionChoicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAssignmentRetentionChoices' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignmentRetentionChoices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAssignmentRetentionChoicesQuery,
  GetAssignmentRetentionChoicesQueryVariables
>;
export const GetAssignmentRoutingSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAssignmentRoutingSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignmentRoutingSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'forwardingMdn' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enabledWhenAway' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'callTimeout' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNumaCallerId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAssignmentRoutingSettingsQuery,
  GetAssignmentRoutingSettingsQueryVariables
>;
export const GetAttachmentByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAttachmentById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAttachmentByIdQuery,
  GetAttachmentByIdQueryVariables
>;
export const GetAutomationByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAutomationById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'automationId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'version' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'automation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'automationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'automationId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'version' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'version' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAutomationByIdQuery,
  GetAutomationByIdQueryVariables
>;
export const GetAutomationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAutomations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'automations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '100' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'AutomationFields' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationTriggerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationTrigger' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'triggerType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelAddedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelRemovedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelsToWatch' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ManualOpportunityTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MessageReceivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderOpenedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderClosedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SurveyAnsweredTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surveyAnsweredFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surveyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inequalityFilter' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingChoice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RepairOrderUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'opcodesFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updateFilter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conditions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'function' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'keyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'newValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'oldValue' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operator' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeWhenMatched' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationArchivedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeClosedByNuma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'includeActiveConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceOutbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'daysSinceInbound' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadCreatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentLeadUpdatedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'rulesQuery' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomerContactedTriggerQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerContactType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentConfirmationTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'OpportunityServiceAppointmentReminderTriggerQL',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutomationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutomationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstActionId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastPublished' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latestVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automationGroupId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enrollmentCriteria' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preventConcurrentEnrollment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'executionLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exitTriggers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startTrigger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutomationTriggerFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customersWaiting' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextActionId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uiHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ManageLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operation' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HasLabelActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelsToCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelCheckOperation' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IsBusinessHoursActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ScheduleMessageActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesUntilSent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeaveNoteActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'SummarizeConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotifyTeamMemberActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifyOwner' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userIdsMentioned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamIdsMentioned' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AssignConversationActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fullName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assigneeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'respectExistingAssignments',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendFeedbackActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SendReviewActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyTime' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'automationChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'textWithCare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedChannelId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'WaitActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minutesToWait' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ChangeConversationStateActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'desiredConversationState',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'EscalateConversationActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageToSend' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'HandToOpportunityAgentActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateOpportunityActionQL' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createIfNotExists',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeReason' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckOpportunityStatusActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onYesActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onNoActionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'opportunity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'CheckRepairOrderDetailsActionQL',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rulesQuery' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAutomationsQuery, GetAutomationsQueryVariables>;
export const GetAutopilotForConversationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAutopilotForConversation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversationId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autopilot' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversationId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AutopilotFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutopilotFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AutopilotQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autopilotStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'previewWelcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewInspection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewService' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewQualityControl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'previewPickup' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autopilotScheduleMessages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'milestoneName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scheduled' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAutopilotForConversationQuery,
  GetAutopilotForConversationQueryVariables
>;
export const GetAutopilotJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAutopilotJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autopilotJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'welcome' } },
                { kind: 'Field', name: { kind: 'Name', value: 'inspection' } },
                { kind: 'Field', name: { kind: 'Name', value: 'service' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'qualityControl' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pickup' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAutopilotJobQuery,
  GetAutopilotJobQueryVariables
>;
export const GetAvailableVoiceScriptsForPlaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAvailableVoiceScriptsForPlace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableVoiceScripts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'scriptType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewScript' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scriptSteps' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'canToggle' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAvailableVoiceScriptsForPlaceQuery,
  GetAvailableVoiceScriptsForPlaceQueryVariables
>;
export const GetAwayModeStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAwayModeStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AwayModeDetailsFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AwayModeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isScheduleEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftEnd' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showAwayModeBannerAfter' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canManageOwnAwayModeSettings' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AwayModeDetailsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'AwayModeFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placesUsers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'awayModeAssigneeUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'awayModeAssigneeTeam' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAwayModeStatusQuery,
  GetAwayModeStatusQueryVariables
>;
export const BillingIdentitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'billingIdentities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'BillingIdentityModelFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BillingIdentityModelSortEnum' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingIdentities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasPreviousPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'billingOrderId' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'eulaAcceptanceDate',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'source' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subscriptions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'quantity' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'available' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sku' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'isActive',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'skuType',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BillingIdentitiesQuery,
  BillingIdentitiesQueryVariables
>;
export const GetCallRecordsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCallRecords' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'String' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userIds' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'createdBefore' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ArrowField' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'createdAfter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ArrowField' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'onlyCallIntelligenceEligible' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'callDirection' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortBy' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortDirection' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecords' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'createdBefore' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'createdBefore' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'createdAfter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'createdAfter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'onlyCallIntelligenceEligible' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'onlyCallIntelligenceEligible' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'callDirection' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'callDirection' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortBy' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortBy' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortDirection' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortDirection' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'callType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdOn' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'callDuration' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'placeName' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'returnCallsRoutingOutcome',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'staffDisplayName' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'customerDisplayName',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'customerPhoneNumber',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transcript' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subject' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'summary' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'analysis' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'scores',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'name',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'rating',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCallRecordsQuery, GetCallRecordsQueryVariables>;
export const GetChannelByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getChannelById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'channel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChannelFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Channel' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBotEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityPromptOption' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TwilioChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outboundSmsMdn' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'sendOutboundsWithShadowTollfree',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreePhonenumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreeSid' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'accountSid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'archiveMissedCalls' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoSendHangupReplies' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hangupSuggestion' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneLinePolicyId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FacebookChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetChannelByIdQuery, GetChannelByIdQueryVariables>;
export const ChannelsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'channels' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeInactive' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'channels' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'includeInactive' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChannelFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Channel' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBotEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityPromptOption' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TwilioChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outboundSmsMdn' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'sendOutboundsWithShadowTollfree',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreePhonenumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreeSid' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'accountSid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'archiveMissedCalls' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoSendHangupReplies' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hangupSuggestion' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneLinePolicyId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FacebookChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChannelsQuery, ChannelsQueryVariables>;
export const GetChargeBeeSubscriptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getChargeBeeSubscriptions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chargebeeSubscriptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'trialDaysLeft' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'dueSince' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'billingStatus' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cardInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cardStatus' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetChargeBeeSubscriptionsQuery,
  GetChargeBeeSubscriptionsQueryVariables
>;
export const GetComplianceReminderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getComplianceReminder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isNewConversation' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversationId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'complianceReminder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isNewConversation' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'isNewConversation' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversationId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'guidelinesReminder' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetComplianceReminderQuery,
  GetComplianceReminderQueryVariables
>;
export const GetConversationByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getConversationById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversationId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastAppointment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastRepairOrder' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversationId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationItemFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryMdn' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewIsInbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewServerGenerated' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewSource' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subPreview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serverGeneratedPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessageItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastAppointment' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastRepairOrder' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdateTime' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastEngagement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mySummaryRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myStatusRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'engagementId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completionSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissalSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actionData' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'amIMentioned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMentionedConversation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMentionedTimestamp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mentionedPreview' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentionedDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optInStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationLabels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasRecentHeatCase' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetConversationByIdQuery,
  GetConversationByIdQueryVariables
>;
export const GetConversationByPhoneNumberAndPlaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getConversationByPhoneNumberAndPlace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'phoneNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastAppointment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastRepairOrder' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationByPhoneNumberAndPlace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phoneNumber' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'phoneNumber' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationItemFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryMdn' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewIsInbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewServerGenerated' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewSource' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subPreview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serverGeneratedPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessageItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastAppointment' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastRepairOrder' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdateTime' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastEngagement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mySummaryRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myStatusRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'engagementId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completionSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissalSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actionData' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'amIMentioned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMentionedConversation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMentionedTimestamp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mentionedPreview' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentionedDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optInStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationLabels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasRecentHeatCase' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetConversationByPhoneNumberAndPlaceQuery,
  GetConversationByPhoneNumberAndPlaceQueryVariables
>;
export const GetCubeTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCubeToken' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cube' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cubeJwtToken' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cubeApiHost' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCubeTokenQuery, GetCubeTokenQueryVariables>;
export const GetCurbsideSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCurbsideSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'curbsideSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enabled' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderIdentifierType' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'orderIdentifierIntentResponse',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customHereIsAutoreply' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'handoffMethod' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'handoffMethodIntentResponse',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'customHandoffIsAutoreply',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCurbsideSettingsQuery,
  GetCurbsideSettingsQueryVariables
>;
export const GetCurrentAccountLegacyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCurrentAccountLegacy' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNewNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'businessVertical' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'billingIdentity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billingOrderId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentSource' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCurrentAccountLegacyQuery,
  GetCurrentAccountLegacyQueryVariables
>;
export const GetCurrentUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCurrentUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withPermissions' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountPermissions' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'withPermissions' },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'permissions' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'placePermissions' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'if' },
                          value: {
                            kind: 'Variable',
                            name: { kind: 'Name', value: 'withPermissions' },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'placeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'permissions' },
                      },
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'UserItemAndNotificationFields',
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobRole' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'participantId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoConferenceUrl' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AwayModeFields' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'InboxBehaviourFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'signaturePreference' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasStatusItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasExternalIdentity' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewPreferences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'UserViewPreferencesFields',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'overdueConversationsPollingIntervalMsec',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'skuEntitlements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SkuEntitlementsFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SystemMessageSettingsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SystemMessageSettings' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showSystemMessages' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemAndNotificationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailOnAssignment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pushNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignmentClaimSetting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'swipeRightSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'swipeLeftSetting' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AwayModeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isScheduleEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftEnd' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showAwayModeBannerAfter' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canManageOwnAwayModeSettings' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InboxBehaviourFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hideSharedInboxViews' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'statusBoardView' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultView' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultYouView' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pushNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserNotificationSetting' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserViewPreferencesFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserViewPreferences' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'systemMessageSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SystemMessageSettingsFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SkuEntitlementsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SkuEntitlementsQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'assignments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentRouting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'awayMode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetDmsObjectHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getDMSObjectHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'numaObjectId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'dmsType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DMSHistoryType' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dmsObjectHistory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numaObjectId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'numaObjectId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dmsType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dmsType' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastData' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'numaObjectId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'numaObjectId' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'dmsType' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'dmsType' },
                      },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDmsObjectHistoryQuery,
  GetDmsObjectHistoryQueryVariables
>;
export const GetExternalVehiclesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getExternalVehicles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'search' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalVehicles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'search' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'make' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'model' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'year' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'overrides' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'numaServiceName',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'opcodes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'serviceName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'dmsId',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetExternalVehiclesQuery,
  GetExternalVehiclesQueryVariables
>;
export const FilteredConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'filteredConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'inboxId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'state' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'assignedTo' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'AssignmentFilterInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newerThan' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ArrowField' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationModelSortEnum' },
            },
          },
          defaultValue: { kind: 'EnumValue', value: 'last_updated_desc' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isOverdue' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'state' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'state' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'inboxId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'inboxId' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'lastUpdated' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'greaterThan' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'newerThan' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isOverdue' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'isOverdue' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assignedTo' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'assignedTo' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'connection' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'key' },
                    value: {
                      kind: 'StringValue',
                      value: 'conversations',
                      block: false,
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ConversationItemStub',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FilteredConversationsQuery,
  FilteredConversationsQueryVariables
>;
export const GetGuideChecklistDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getGuideChecklist' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guideChecklist' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'textingPhonelines' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lineType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'carrierName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hostedSmsPort' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasCallForwarding' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasDismissedGuideChecklist' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetGuideChecklistQuery,
  GetGuideChecklistQueryVariables
>;
export const GetHostedSmsPortsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getHostedSmsPorts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostedSmsPorts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'HostedSmsPortFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HostedSmsPortFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HostedSmsPortQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAttempts' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'verificationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loaSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerEmail' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetHostedSmsPortsQuery,
  GetHostedSmsPortsQueryVariables
>;
export const GetIdentityPromptAddressesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getIdentityPromptAddresses' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'channelId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityPromptAddresses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channelId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'channelId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetIdentityPromptAddressesQuery,
  GetIdentityPromptAddressesQueryVariables
>;
export const GetLabelsForPlaceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getLabelsForPlace' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'labels' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetLabelsForPlaceQuery,
  GetLabelsForPlaceQueryVariables
>;
export const MentionedConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'mentionedConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'unreadOnly' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentionedConversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'unreadOnly' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'unreadOnly' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'connection' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'key' },
                    value: {
                      kind: 'StringValue',
                      value: 'conversations',
                      block: false,
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ConversationItemStub',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'lastMentionedTimestamp',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amIMentioned' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MentionedConversationsQuery,
  MentionedConversationsQueryVariables
>;
export const GetMessageMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getMessageMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messageMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'messageId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMessageMetadataQuery,
  GetMessageMetadataQueryVariables
>;
export const MyInboxesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'myInboxes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myInboxes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalConversations' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalUnassigned' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationsAssignedToMe' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationMentions' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hideSharedInboxViews' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusBoardView' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'conversationCount',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'place' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'escalationsEnabled',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'escalationsThreshold',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MyInboxesQuery, MyInboxesQueryVariables>;
export const NewerConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'newerConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newerThan' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ArrowField' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastAppointment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastRepairOrder' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'EnumValue', value: 'last_updated_desc' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'lastUpdated' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'greaterThan' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'newerThan' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'connection' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'key' },
                    value: {
                      kind: 'StringValue',
                      value: 'conversations',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'filter' },
                    value: {
                      kind: 'ListValue',
                      values: [
                        {
                          kind: 'StringValue',
                          value: 'queryFilter',
                          block: false,
                        },
                      ],
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ConversationItemFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryMdn' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewIsInbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewServerGenerated' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewSource' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subPreview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serverGeneratedPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessageItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastAppointment' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastRepairOrder' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdateTime' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastEngagement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mySummaryRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myStatusRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'engagementId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completionSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissalSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actionData' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'amIMentioned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMentionedConversation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMentionedTimestamp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mentionedPreview' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentionedDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optInStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationLabels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasRecentHeatCase' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewerConversationsQuery,
  NewerConversationsQueryVariables
>;
export const GetNoteTakerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getNoteTaker' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'noteTaker' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NoteTakerFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NoteTakerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NoteTakerQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetNoteTakerQuery, GetNoteTakerQueryVariables>;
export const GetNoteTakersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getNoteTakers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'noteTakers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'NoteTakerFields' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NoteTakerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NoteTakerQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetNoteTakersQuery, GetNoteTakersQueryVariables>;
export const GetNumaServicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getNumaServices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numaServices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'manualCodeSelection' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'howIsHandled' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetNumaServicesQuery,
  GetNumaServicesQueryVariables
>;
export const GetOutboundCallCustomizationAudioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOutboundCallCustomizationAudio' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'audioField' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundCallCustomizationAudio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'audioField' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'audioField' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOutboundCallCustomizationAudioQuery,
  GetOutboundCallCustomizationAudioQueryVariables
>;
export const GetOutboundConferenceCallDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOutboundConferenceCall' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOutboundConferenceCallQuery,
  GetOutboundConferenceCallQueryVariables
>;
export const GetOutboundConferenceCallByUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOutboundConferenceCallByUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCalls' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOutboundConferenceCallByUserQuery,
  GetOutboundConferenceCallByUserQueryVariables
>;
export const GetOutboundPhoneChannelsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOutboundPhoneChannels' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundPhoneChannels' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChannelFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Channel' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBotEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityPromptOption' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TwilioChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outboundSmsMdn' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'sendOutboundsWithShadowTollfree',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreePhonenumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreeSid' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'accountSid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'archiveMissedCalls' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoSendHangupReplies' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hangupSuggestion' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneLinePolicyId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FacebookChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOutboundPhoneChannelsQuery,
  GetOutboundPhoneChannelsQueryVariables
>;
export const GetOutboundProxyCallStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOutboundProxyCallStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isBeingRecorded' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOutboundProxyCallStatusQuery,
  GetOutboundProxyCallStatusQueryVariables
>;
export const GetParticipantVideoUploadLinksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getParticipantVideoUploadLinks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'participantId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participantVideoUploadLinks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'participantId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'participantId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VideoUploadLinkFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VideoUploadLinkFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoUploadLinkQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readyToStream' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'playbackHls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasBeenSent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetParticipantVideoUploadLinksQuery,
  GetParticipantVideoUploadLinksQueryVariables
>;
export const GetPaymentReceiptMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPaymentReceiptMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'receiptMessage' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPaymentReceiptMessageQuery,
  GetPaymentReceiptMessageQueryVariables
>;
export const GetPaymentRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPaymentRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPaymentRequestQuery,
  GetPaymentRequestQueryVariables
>;
export const GetPaymentRequestCustomizationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPaymentRequestCustomization' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequestCustomization' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createTemplate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedCreateTemplate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createAutoSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createHoldTemplate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedCreateHoldTemplate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createHoldAutoSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'successTemplate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedSuccessTemplate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'successAutoSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refundTemplate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedRefundTemplate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refundAutoSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'partialRefundTemplate' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedPartialRefundTemplate',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'partialRefundAutoSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canceledTemplate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedCanceledTemplate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canceledAutoSend' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPaymentRequestCustomizationQuery,
  GetPaymentRequestCustomizationQueryVariables
>;
export const GetPaymentRequestsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPaymentRequests' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'senderId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PaymentRequestModelFilter' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequests' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'senderId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'senderId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'EnumValue', value: 'last_updated_desc' },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'connection' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'key' },
                    value: {
                      kind: 'StringValue',
                      value: 'paymentRequests',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'filter' },
                    value: {
                      kind: 'ListValue',
                      values: [
                        { kind: 'StringValue', value: 'status', block: false },
                        { kind: 'StringValue', value: 'placeId', block: false },
                        {
                          kind: 'StringValue',
                          value: 'senderId',
                          block: false,
                        },
                      ],
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'PaymentRequestStubFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPaymentRequestsQuery,
  GetPaymentRequestsQueryVariables
>;
export const GetPhoneLinePolicyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPhoneLinePolicy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'phoneLinePolicyId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneLinePolicy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phoneLinePolicyId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'phoneLinePolicyId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneLinePolicyFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneLinePolicyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLinePolicyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoOptin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoOptinMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delayAnswerDuration' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'answerWithKeys' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fixInternalDialing' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'assistantPhrase' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveMissedCalls' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hangupSuggestion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoSendHangupReplies' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasIdentityPrompt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowDisruptions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nryCallForwardingPickUpTimeoutSecs' },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'nryCallForwardingUserScreenInteractionTimeoutSecs',
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeringScripts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scriptType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'order' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPhoneLinePolicyQuery,
  GetPhoneLinePolicyQueryVariables
>;
export const GetPhonelineDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPhoneline' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'phonelineId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withVoiceChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withSMSChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneline' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phonelineId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'phonelineId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'speechLanguage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowedSpeechLanguages' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'overridesInboxLanguage' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneLineWithChannelsFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneLineFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLineQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carrierName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createHostedSmsUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsForwardingMode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canForwardReturnCalls' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nryForwardingMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostedSmsPort' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationAttempts' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationCode' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Channel' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBotEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityPromptOption' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TwilioChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outboundSmsMdn' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'sendOutboundsWithShadowTollfree',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreePhonenumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreeSid' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'accountSid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'archiveMissedCalls' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoSendHangupReplies' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hangupSuggestion' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneLinePolicyId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FacebookChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneLineWithChannelsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLineQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'PhoneLineFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'voiceChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withVoiceChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChannelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'smsChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withSMSChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChannelFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPhonelineQuery, GetPhonelineQueryVariables>;
export const GetPhonelinesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPhonelines' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withVoiceChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withSMSChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phonelines' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneLineWithChannelsFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departmentPhoneLinePolicy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staffPhoneLinePolicy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneLineFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLineQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'carrierName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lineType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createHostedSmsUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsForwardingMode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'returnCallsMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canForwardReturnCalls' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nryForwardingMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostedSmsPort' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationAttempts' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationCode' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChannelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Channel' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBotEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityPromptOption' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TwilioChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outboundSmsMdn' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'sendOutboundsWithShadowTollfree',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreePhonenumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shadowTollfreeSid' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'accountSid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignments' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'archiveMissedCalls' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoSendHangupReplies' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hangupSuggestion' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phoneLinePolicyId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FacebookChannelQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneLineWithChannelsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneLineQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'PhoneLineFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'voiceChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withVoiceChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChannelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'smsChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withSMSChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChannelFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPhonelinesQuery, GetPhonelinesQueryVariables>;
export const GetPlaceBrandThemeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPlaceBrandTheme' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'inboxType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brandTheme' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'BrandThemeFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BrandThemeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandThemeQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'headerBackgroundColor' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'headerBorderColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'headerTextColor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bodyBackgroundColor' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'bodyBorderColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bodyTextColor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonPrimaryBackgroundColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonPrimaryBorderColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonPrimaryTextColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonSecondaryBackgroundColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonSecondaryBorderColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonSecondaryTextColor' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paletteType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportedPaletteTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'headerBackgroundColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'headerBorderColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'headerTextColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bodyBackgroundColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bodyBorderColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bodyTextColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonPrimaryBackgroundColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonPrimaryBorderColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonPrimaryTextColor' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'buttonSecondaryBackgroundColor',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonSecondaryBorderColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonSecondaryTextColor' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlaceBrandThemeQuery,
  GetPlaceBrandThemeQueryVariables
>;
export const GetPlaceByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPlaceById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hours' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messagingHours' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useMessagingHours' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'businessTz' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'businessProfileId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'escalationsEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'escalationsThreshold' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'speechLanguage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowedSpeechLanguages' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPlaceByIdQuery, GetPlaceByIdQueryVariables>;
export const GetPlaceDisruptionScriptsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPlaceDisruptionScripts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disruptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'disruptionDepartmentVoiceScript',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'VoiceScriptFields',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'draftDisruptionDepartmentVoiceScript',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'VoiceScriptFields',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'holidayDepartmentVoiceScript',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'VoiceScriptFields',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'draftHolidayDepartmentVoiceScript',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'VoiceScriptFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canToggle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'executionOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renderedSpeech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stepType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customAudioOverrides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VoiceScriptStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TextOptinStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AskYesNoQuestionStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IntentQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpecialQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QualifyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PressAnyKeyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudio' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudioForAfterHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GreetingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softOpenSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectNewPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'collectPhonenumberFallbackSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarificationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCorrectQuestionSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retrySpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmationSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoAssignStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoAssignNextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallForwardingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'callTimeout' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'forwardingMdns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMdn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNumaCallerId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onConnectedStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoAnsweringStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallRecordingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PickupStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callerRecognizedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StatusUpdaterStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusGivenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noStatusGivenStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelConversationStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckForLabelStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasLabelId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onMissingLabelId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpeakStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QuestionBotStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NoteTakerStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'noteTakerId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedRecallStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedOtherStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedRecallSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedOtherSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'outcomeNotBookedWantsHumanSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notAnAppointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cantServiceCustomerStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyIntentFirstEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationStateStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'desiredConversationState' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckBusinessHoursStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onOpenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onClosedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmPromptOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmModelOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextStepId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalContext' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noMatchStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ConversationalSchedulingAgentStepQl',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmIntentSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shouldConfirmIntent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'greetingSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OperatorAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceScriptFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'afterHoursEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scriptType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowCustomAudio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstStepId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dirty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VoiceStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlaceDisruptionScriptsQuery,
  GetPlaceDisruptionScriptsQueryVariables
>;
export const GetPlaceDisruptionSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPlaceDisruptionSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'answeringMode' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'answeringModeFrom' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'answeringModeUntil' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disruptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'disruptionsGreeting' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'disruptionsActive' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'disruptionDepartmentVoiceScriptId',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'draftDisruptionDepartmentVoiceScriptId',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'holidayDepartmentVoiceScriptId',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'draftHolidayDepartmentVoiceScriptId',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlaceDisruptionSettingsQuery,
  GetPlaceDisruptionSettingsQueryVariables
>;
export const GetPlaceMfaSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPlaceMfaSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enforceMfa' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlaceMfaSettingsQuery,
  GetPlaceMfaSettingsQueryVariables
>;
export const GetPlaceGroupDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPlaceGroupDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeGroupId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeGroupId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'account' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'places' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlaceGroupDetailsQuery,
  GetPlaceGroupDetailsQueryVariables
>;
export const GetPlaceGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPlaceGroups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PlaceGroupModelFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PlaceGroupModelSortEnum' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'search' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'search' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'connection' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'key' },
                    value: {
                      kind: 'StringValue',
                      value: 'placeGroups',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'filter' },
                    value: {
                      kind: 'ListValue',
                      values: [
                        {
                          kind: 'StringValue',
                          value: 'queryFilter',
                          block: false,
                        },
                        { kind: 'StringValue', value: 'search', block: false },
                      ],
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasPreviousPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'account' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPlaceGroupsQuery, GetPlaceGroupsQueryVariables>;
export const GetPlaceManagersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPlaceManagers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isAway' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlaceManagersQuery,
  GetPlaceManagersQueryVariables
>;
export const GetPlaceNamePronunciationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPlaceNamePronunciation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'namePronunciation' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'namePronunciationUrl' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlaceNamePronunciationQuery,
  GetPlaceNamePronunciationQueryVariables
>;
export const GetPlaceNewConversationLimitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPlaceNewConversationLimit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'newConversationsPerDay' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outboundConversationsToday' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlaceNewConversationLimitQuery,
  GetPlaceNewConversationLimitQueryVariables
>;
export const GetPlaceOutboundCallSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPlaceOutboundCallSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outboundCallSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlaceOutboundCallSettingsQuery,
  GetPlaceOutboundCallSettingsQueryVariables
>;
export const PlacesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'places' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'places' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlacesQuery, PlacesQueryVariables>;
export const PlacesAdminDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'placesAdmin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'search' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PlaceModelSortEnum' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'places' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'search' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasPreviousPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'account' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlacesAdminQuery, PlacesAdminQueryVariables>;
export const GetPlacesDegradedInboxExperienceStateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPlacesDegradedInboxExperienceState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'places' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '100' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hasDegradedInboxExperience',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlacesDegradedInboxExperienceStateQuery,
  GetPlacesDegradedInboxExperienceStateQueryVariables
>;
export const PlacesUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'placesUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placesUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'receivesEscalations' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlacesUsersQuery, PlacesUsersQueryVariables>;
export const PlacesUsersForCallIntelligenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'placesUsersForCallIntelligence' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placesUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callIntelligenceEnabled' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PlacesUsersForCallIntelligenceQuery,
  PlacesUsersForCallIntelligenceQueryVariables
>;
export const GetPubnubConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPubnubConfig' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pubnub' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userParticipantId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pamToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channels' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'channelGroups' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pushChannels' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'browserPushChannels' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subscribeKey' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'publishKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceToken' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPubnubConfigQuery,
  GetPubnubConfigQueryVariables
>;
export const GetquestionAgentSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getquestionAgentSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'questionAgentSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'settings' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetquestionAgentSettingsQuery,
  GetquestionAgentSettingsQueryVariables
>;
export const GetQuestionAgentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getQuestionAgents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'questionAgents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetQuestionAgentsQuery,
  GetQuestionAgentsQueryVariables
>;
export const GetRepairServicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getRepairServices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'activeIntegrationId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairServices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'activeIntegrationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'activeIntegrationId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'enabledSupportedVehiclesCount',
                  },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'disabledSupportedVehiclesCount',
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRepairServicesQuery,
  GetRepairServicesQueryVariables
>;
export const GetReviewJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getReviewJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reviewJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fallbackChannelId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buttonTextColor' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'buttonColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'headerColor' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'headerTextColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'backgroundColor' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'textColor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageBody' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageImageUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageBody' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skipRatingsScreen' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewMode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reviewSites' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serviceName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'FacebookReviewSite' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'facebookPageId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetReviewJobQuery, GetReviewJobQueryVariables>;
export const GetShortcutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getShortcut' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'shortcutId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shortcut' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shortcutId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'shortcutId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetShortcutQuery, GetShortcutQueryVariables>;
export const GetSkuEntitlementsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSkuEntitlements' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'skuEntitlements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SkuEntitlementsFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SkuEntitlementsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SkuEntitlementsQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'assignments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentRouting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'awayMode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSkuEntitlementsQuery,
  GetSkuEntitlementsQueryVariables
>;
export const SkusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'skus' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'skus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isActive' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isActive' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'skuType' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SkusQuery, SkusQueryVariables>;
export const StagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'stages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'assigneeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StageStub' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItems' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'queryFilter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'status' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'notEqual' },
                                  value: {
                                    kind: 'StringValue',
                                    value: 'DONE',
                                    block: false,
                                  },
                                },
                              ],
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'assigneeId' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'equal' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'assigneeId' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'connection' },
                      arguments: [
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'key' },
                          value: {
                            kind: 'StringValue',
                            value: 'statusItems',
                            block: false,
                          },
                        },
                        {
                          kind: 'Argument',
                          name: { kind: 'Name', value: 'filter' },
                          value: {
                            kind: 'ListValue',
                            values: [
                              {
                                kind: 'StringValue',
                                value: 'queryFilter',
                                block: false,
                              },
                            ],
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hasNextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startCursor' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endCursor' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'StatusItemStub',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelStubFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StageStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageTemplate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renderedMessageTemplate' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMessageTemplate' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renderedUpdateMessageTemplate' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'speechUpdate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speechUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StatusItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatusItemQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heldSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationItemStub' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationLabels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ConversationLabelStubFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StagesQuery, StagesQueryVariables>;
export const StatusBoardUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'statusBoardUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placesUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobRole' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'statusBoardView' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusBoardUsersQuery,
  StatusBoardUsersQueryVariables
>;
export const StatusBoardUsersForLeaderboardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'statusBoardUsersForLeaderboard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placesUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobRole' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'statusBoardView' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isAway' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'statusLeaderboardColors',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'placeId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'placeId' },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'green' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'yellow' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'red' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusBoardUsersForLeaderboardQuery,
  StatusBoardUsersForLeaderboardQueryVariables
>;
export const StatusItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'statusItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'statusItemId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'statusItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'statusItemId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'statusItemId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StatusItemDetails' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelStubFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StatusItemDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatusItemQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heldSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationItemStub' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationLabels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ConversationLabelStubFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StatusItemQuery, StatusItemQueryVariables>;
export const StatusItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'statusItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'assigneeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'statusItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'notEqual' },
                            value: {
                              kind: 'StringValue',
                              value: 'DONE',
                              block: false,
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assigneeId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'assigneeId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'EnumValue', value: 'last_update_time_desc' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'connection' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'key' },
                    value: {
                      kind: 'StringValue',
                      value: 'statusItems',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'filter' },
                    value: {
                      kind: 'ListValue',
                      values: [
                        {
                          kind: 'StringValue',
                          value: 'assigneeId',
                          block: false,
                        },
                      ],
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'StatusItemStub' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelStubFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelStubFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StatusItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatusItemQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdateTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heldSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationItemStub' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationLabels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ConversationLabelStubFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StatusItemsQuery, StatusItemsQueryVariables>;
export const GetStripeAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getStripeAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stripeIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stripeAccountType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stripeAccountId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stripeAccountStatus' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetStripeAccountQuery,
  GetStripeAccountQueryVariables
>;
export const GetSupportedVehiclesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSupportedVehicles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'repairServiceId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchTerm' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportedVehicles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'repairServiceId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'repairServiceId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchTerm' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'supportedYears' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'make' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'model' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'useOverrides' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'firstEnabledOpCode',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isEnabled' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'opCode' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'dmsId',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'description',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSupportedVehiclesQuery,
  GetSupportedVehiclesQueryVariables
>;
export const GetSupportedVehiclesWithOpCodesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSupportedVehiclesWithOpCodes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'repairServiceId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchTerm' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'supportedVehicles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'repairServiceId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'repairServiceId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchTerm' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'supportedYears' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'make' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'model' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'useOverrides' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opCodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isEnabled' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'state' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'opCode' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'dmsId',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'description',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'availableOpCodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isEnabled' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'state' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'opCode' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'dmsId',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'description',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'firstEnabledOpCode',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isEnabled' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'opCode' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'dmsId',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'description',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSupportedVehiclesWithOpCodesQuery,
  GetSupportedVehiclesWithOpCodesQueryVariables
>;
export const GetTeamByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTeamById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userCount' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'afterUser' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'teamId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamWithUsers' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignmentStyle' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamWithUsers' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'TeamFields' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userCount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'afterUser' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isAway' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTeamByIdQuery, GetTeamByIdQueryVariables>;
export const GetTeamsByPlaceIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTeamsByPlaceId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teams' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamSettingsFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamSettingsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentStyle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTeamsByPlaceIdQuery,
  GetTeamsByPlaceIdQueryVariables
>;
export const GetTenDlcProcessByAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTenDLCProcessByAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tenDlcProcesses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'place' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'twilioA2pCampaign' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'campaignStatus' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'twilioBrandRegistration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'twilioTrustProduct' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'registrationOptions' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'friendlyName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTenDlcProcessByAccountQuery,
  GetTenDlcProcessByAccountQueryVariables
>;
export const GetTenDlcStatusByAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTenDLCStatusByAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tenDlcStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'a2pStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'businessVerificationStatus' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTenDlcStatusByAccountQuery,
  GetTenDlcStatusByAccountQueryVariables
>;
export const GetTenDlcTrustProductsByAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTenDLCTrustProductsByAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trustProducts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'friendlyName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'twilioSid' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTenDlcTrustProductsByAccountQuery,
  GetTenDlcTrustProductsByAccountQueryVariables
>;
export const GetTranscriptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTranscript' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeEventContent' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'EventContent' },
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'include' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'if' },
                                value: {
                                  kind: 'Variable',
                                  name: {
                                    kind: 'Name',
                                    value: 'includeEventContent',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timestamp' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'callType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextSteps' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coachingTip' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coachingSample' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'positiveCoachingTip' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sections' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'timestamp' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scores' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rating' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'call' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'PhoneCallQL' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdOn' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isActive' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endtime' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startTime' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'callDuration' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'channelId' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hasReturnCallsRouting',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'returnCallsRoutingOutcome',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'returnCallsRoutedTo',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'returnCallsRoutedUser',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'displayName',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'callRecording' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'participant' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'displayName',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'channel' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value: 'TwilioChannelQL',
                                      },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'mdn' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'OutboundConferenceCallQL',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdOn' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endTime' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startTime' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'callDuration' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'callRecording' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caller' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'displayName',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hostMdn' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recipientMdn' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'recipientDisplayName',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'OutboundProxyCallQL' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdOn' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endtime' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startTime' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'callDuration' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'callRecording' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caller' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'displayName',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recipientMdn' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptEventQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'start' } },
          { kind: 'Field', name: { kind: 'Name', value: 'end' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'confidence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speaker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speakerConfidence' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTranscriptQuery, GetTranscriptQueryVariables>;
export const GetTransportationSetOptionSpeechDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTransportationSetOptionSpeech' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'transportationSetOptionId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationSetOptionSpeech' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'transportationSetOptionId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'transportationSetOptionId' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTransportationSetOptionSpeechQuery,
  GetTransportationSetOptionSpeechQueryVariables
>;
export const GetTransportationSetSpeechDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTransportationSetSpeech' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'transportationSetId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationSetSpeech' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'transportationSetId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'transportationSetId' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTransportationSetSpeechQuery,
  GetTransportationSetSpeechQueryVariables
>;
export const GetTransportationSetsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTransportationSets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationSets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rules' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'speechUtterance' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transportationOptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enabled' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'speechShort' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'speechLong' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minimumServiceItems' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTransportationSetsQuery,
  GetTransportationSetsQueryVariables
>;
export const GetTrustProductByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTrustProductById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'trustProductId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tenDlcProcessById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'trustProductId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'trustProductId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'twilioTrustProduct' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessIdentity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'taxId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'legalName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entityType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'industry' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'websiteUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'street' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'secondaryStreet' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'city' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'zipCode' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'country' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'jobTitle' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mobilePhone' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'stockTickerSymbol',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stockExchange' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'businessType' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTrustProductByIdQuery,
  GetTrustProductByIdQueryVariables
>;
export const GetTypingIndicatorTimeoutsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTypingIndicatorTimeouts' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pubnub' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typingIndicator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendStillTyping' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inactivityTimeout' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discardEventTimeout' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'typingIndicatorChannel' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTypingIndicatorTimeoutsQuery,
  GetTypingIndicatorTimeoutsQueryVariables
>;
export const UnassignedConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'unassignedConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'state' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'assignedTo' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'AssignmentFilterInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newerThan' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ArrowField' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationModelSortEnum' },
            },
          },
          defaultValue: { kind: 'EnumValue', value: 'last_updated_desc' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isOverdue' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'state' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'state' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'lastUpdated' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'greaterThan' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'newerThan' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isOverdue' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'isOverdue' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assignedTo' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'assignedTo' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'connection' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'key' },
                    value: {
                      kind: 'StringValue',
                      value: 'conversations',
                      block: false,
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ConversationItemStub',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnassignedConversationsQuery,
  UnassignedConversationsQueryVariables
>;
export const GetUsablePhonelinesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUsablePhonelines' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phonelines' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lineType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hostedSmsPort' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smsChannel' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'TwilioChannelQL' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mdn' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outboundSmsMdn' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdOn' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nryChannel' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'TwilioChannelQL' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mdn' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outboundSmsMdn' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUsablePhonelinesQuery,
  GetUsablePhonelinesQueryVariables
>;
export const GetUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'UserItemAndNotificationFields',
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AwayModeFields' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'InboxBehaviourFields' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'jobRole' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signature' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'signaturePreference' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasStatusItems' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasExternalIdentity' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewPreferences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'UserViewPreferencesFields',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'missedOutboundCallFollowUpEnabled',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'skuEntitlements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SkuEntitlementsFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SystemMessageSettingsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SystemMessageSettings' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showSystemMessages' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemAndNotificationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailOnAssignment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pushNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignmentClaimSetting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'swipeRightSetting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'swipeLeftSetting' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AwayModeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAway' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isScheduleEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftStart' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextShiftEnd' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showAwayModeBannerAfter' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canManageOwnAwayModeSettings' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InboxBehaviourFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hideSharedInboxViews' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'statusBoardView' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultView' } },
          { kind: 'Field', name: { kind: 'Name', value: 'defaultYouView' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pushNotificationSetting' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserNotificationSetting' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserViewPreferencesFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserViewPreferences' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'systemMessageSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SystemMessageSettingsFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SkuEntitlementsFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SkuEntitlementsQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'assignments' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'escalations' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assignmentRouting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'awayMode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const UsersWithServiceAdvisorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'usersWithServiceAdvisors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'activeIntegrationId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'serviceAdvisorType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ServiceAdvisorType' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cdkClearCache' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'skipRos' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placesUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisors' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'serviceAdvisorType' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'serviceAdvisorType' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ServiceAdvisorQL' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'serviceAdvisorId' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'serviceAdvisorName',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'CDKServiceAdvisorQL' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'serviceAdvisorId' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'serviceAdvisorName',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'DealerTrackServiceAdvisorQL',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'serviceAdvisorId' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'serviceAdvisorName',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'employees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'activeIntegrationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'activeIntegrationId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cdkClearCache' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cdkClearCache' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serviceAdvisorType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'serviceAdvisorType' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skipRos' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'skipRos' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'advisorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UsersWithServiceAdvisorsQuery,
  UsersWithServiceAdvisorsQueryVariables
>;
export const GetUserConversationCountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserConversationCounts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'openConversationCount' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'placeId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'placeId' },
                      },
                    },
                  ],
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedConversationCount' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'placeId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'placeId' },
                      },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserConversationCountsQuery,
  GetUserConversationCountsQueryVariables
>;
export const GetUserMfaSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserMfaSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enforceMfa' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserMfaSettingsQuery,
  GetUserMfaSettingsQueryVariables
>;
export const UserIdsByTeamIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'userIdsByTeamId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'teamId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userIdsByTeamId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'teamId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'teamId' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserIdsByTeamIdQuery,
  UserIdsByTeamIdQueryVariables
>;
export const GetUserMissedOutboundCallFollowUpSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserMissedOutboundCallFollowUpSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'missedOutboundCallFollowUpEnabled',
                  },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'missedOutboundCallFollowUpMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'missedOutboundCallFollowUpRenderedMessage',
                  },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'placeId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'placeId' },
                      },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserMissedOutboundCallFollowUpSettingQuery,
  GetUserMissedOutboundCallFollowUpSettingQueryVariables
>;
export const GetUserPersonalizationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserPersonalization' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'namePronunciation' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'namePronunciationUrl' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pronouns' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserPersonalizationQuery,
  GetUserPersonalizationQueryVariables
>;
export const GetUserPhonesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserPhones' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userPhones' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mdn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enabledWhenAway' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sipAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sipPriorityFirst' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserPhonesQuery, GetUserPhonesQueryVariables>;
export const GetUserScheduleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserSchedule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schedule' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isScheduleEnabled' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserScheduleQuery,
  GetUserScheduleQueryVariables
>;
export const UserStatusLeaderboardColorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'userStatusLeaderboardColors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusLeaderboardColors' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'placeId' },
                      value: { kind: 'StringValue', value: '', block: false },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'green' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'yellow' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'red' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserStatusLeaderboardColorsQuery,
  UserStatusLeaderboardColorsQueryVariables
>;
export const UsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'users' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UserModelFilter' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasPreviousPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mdn' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const GeVideoUploadLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'geVideoUploadLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoUploadLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VideoUploadLinkFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VideoUploadLinkFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoUploadLinkQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readyToStream' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'playbackHls' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasBeenSent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GeVideoUploadLinkQuery,
  GeVideoUploadLinkQueryVariables
>;
export const GetVoiceAppointmentAgentSettingsAudioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getVoiceAppointmentAgentSettingsAudio' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'audioField' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'voiceAppointmentAgentSettingsAudio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'audioField' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'audioField' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetVoiceAppointmentAgentSettingsAudioQuery,
  GetVoiceAppointmentAgentSettingsAudioQueryVariables
>;
export const GetVoiceScriptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getVoiceScript' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'voiceScript' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VoiceScriptFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canToggle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'executionOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renderedSpeech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stepType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customAudioOverrides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VoiceScriptStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TextOptinStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AskYesNoQuestionStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IntentQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpecialQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QualifyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PressAnyKeyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudio' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudioForAfterHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GreetingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softOpenSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectNewPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'collectPhonenumberFallbackSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarificationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCorrectQuestionSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retrySpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmationSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoAssignStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoAssignNextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallForwardingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'callTimeout' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'forwardingMdns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMdn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNumaCallerId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onConnectedStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoAnsweringStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallRecordingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PickupStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callerRecognizedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StatusUpdaterStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusGivenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noStatusGivenStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelConversationStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckForLabelStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasLabelId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onMissingLabelId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpeakStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QuestionBotStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NoteTakerStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'noteTakerId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedRecallStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedOtherStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedRecallSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedOtherSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'outcomeNotBookedWantsHumanSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notAnAppointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cantServiceCustomerStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyIntentFirstEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationStateStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'desiredConversationState' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckBusinessHoursStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onOpenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onClosedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmPromptOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmModelOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextStepId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalContext' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noMatchStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ConversationalSchedulingAgentStepQl',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmIntentSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shouldConfirmIntent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'greetingSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OperatorAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceScriptFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'afterHoursEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scriptType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowCustomAudio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstStepId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dirty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VoiceStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetVoiceScriptQuery, GetVoiceScriptQueryVariables>;
export const GetVoiceScriptsForAnsweringScriptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getVoiceScriptsForAnsweringScript' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeringScript' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'answeringScriptId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'voiceScript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'VoiceScriptFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'draftVoiceScript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'VoiceScriptFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canToggle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledAfterBusinessHours' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledDuringBusinessHours' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'executionOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renderedSpeech' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stepType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uiHints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customAudioOverrides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'speech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VoiceScriptStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TextOptinStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AskYesNoQuestionStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IntentQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpecialQuestionQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedMessageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'messageToSend' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'canWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyCanWeTextSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onFailureSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'onYesStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onNoStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onYesButNoTextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QualifyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoResponseId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PressAnyKeyStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedOptinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'renderedAfterHoursTextMessage',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optinTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useAfterHoursTextMessage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudio' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useCustomAudioForAfterHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GreetingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softOpenSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectNewPhonenumberSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'collectPhonenumberFallbackSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarificationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isCorrectQuestionSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retrySpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmationSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AutoAssignStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'respectExistingAssignment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserItemFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'team' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TeamFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'autoAssignNextStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallForwardingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'callTimeout' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'forwardingMdns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMdn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingMode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'useNumaCallerId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noAnswerSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onConnectedStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onNoAnsweringStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CallRecordingStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'playDisclosureRecording' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disclosureContent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PickupStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callerRecognizedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StatusUpdaterStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusGivenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noStatusGivenStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LabelConversationStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expirationHours' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckForLabelStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onHasLabelId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onMissingLabelId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SpeakStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'afterHoursSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renderedAfterHoursSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'QuestionBotStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questionAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NoteTakerStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'noteTakerId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AppointmentAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedRecallStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notBookedOtherStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finishedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedRecallSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outcomeNotBookedOtherSpeech' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'outcomeNotBookedWantsHumanSpeech',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notAnAppointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cantServiceCustomerStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifyIntentFirstEnabled' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clarifySpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'yesSpeech' } },
                { kind: 'Field', name: { kind: 'Name', value: 'noSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureSpeech' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ConversationStateStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'desiredConversationState' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CheckBusinessHoursStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onOpenStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onClosedStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmPromptOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'llmModelOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextStepId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalContext' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'acknowledgementSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'noMatchStepId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ConversationalSchedulingAgentStepQl',
              },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentLeadStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failureStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationStepId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'humanEscalationSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmIntentSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shouldConfirmIntent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'greetingSpeech' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'leadSpeech' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookedSpeech' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OperatorAgentStepQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nextStepId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VoiceScriptFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VoiceScriptQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'afterHoursEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scriptType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allowCustomAudio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstStepId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dirty' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'VoiceStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetVoiceScriptsForAnsweringScriptQuery,
  GetVoiceScriptsForAnsweringScriptQueryVariables
>;
export const GetVoiceStepAudioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getVoiceStepAudio' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'stepId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'audioField' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'voiceStepAudio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stepId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'stepId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'audioField' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'audioField' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetVoiceStepAudioQuery,
  GetVoiceStepAudioQueryVariables
>;
export const GetXtimeServicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getXtimeServices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'make' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'model' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'xtimeServices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'appointmentAgentSettingsId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vehicleMake' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'make' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vehicleModel' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'model' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'serviceName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'opcode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceCategoryId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceCategoryName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sabCode' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetXtimeServicesQuery,
  GetXtimeServicesQueryVariables
>;
export const LoadChatHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'loadChatHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'messageFormatsToExclude' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withScheduledMessages' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'conversationId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'id' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'messageFormat' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'notIn' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'messageFormatsToExclude',
                              },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'EnumValue', value: 'created_on_desc' },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'connection' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'key' },
                    value: {
                      kind: 'StringValue',
                      value: 'messages',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'filter' },
                    value: {
                      kind: 'ListValue',
                      values: [
                        {
                          kind: 'StringValue',
                          value: 'queryFilter',
                          block: false,
                        },
                        { kind: 'StringValue', value: 'sort', block: false },
                      ],
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'MessageItemFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'ConversationSignatureStateFields',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activePhoneCallsWithoutMessages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scheduledMessages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'conversationId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'id' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'EnumValue', value: 'created_on_desc' },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'connection' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'key' },
                    value: {
                      kind: 'StringValue',
                      value: 'scheduledMessages',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'filter' },
                    value: {
                      kind: 'ListValue',
                      values: [
                        {
                          kind: 'StringValue',
                          value: 'queryFilter',
                          block: false,
                        },
                        { kind: 'StringValue', value: 'sort', block: false },
                      ],
                    },
                  },
                ],
              },
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withScheduledMessages' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ScheduledMessageFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationSignatureStateFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isNextOutboundMessageSigned' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ScheduledMessageFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ScheduledMessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sendAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryAttempted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LoadChatHistoryQuery,
  LoadChatHistoryQueryVariables
>;
export const SearchConversationByContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchConversationByContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchTerm' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastAppointment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: true },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastRepairOrder' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: true },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autocompleteConversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchTerm' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'connection' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'key' },
                    value: {
                      kind: 'StringValue',
                      value: 'searchConversation',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'filter' },
                    value: { kind: 'ListValue', values: [] },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ConversationItemFields',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'place' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryMdn' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewIsInbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewServerGenerated' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewSource' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subPreview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serverGeneratedPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessageItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastAppointment' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastRepairOrder' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdateTime' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastEngagement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mySummaryRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myStatusRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'engagementId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completionSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissalSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actionData' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'amIMentioned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMentionedConversation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMentionedTimestamp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mentionedPreview' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentionedDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optInStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationLabels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasRecentHeatCase' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchConversationByContactQuery,
  SearchConversationByContactQueryVariables
>;
export const SearchConversationByMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchConversationByMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchTerm' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastAppointment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: true },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastChannel' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'withLastRepairOrder' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: true },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchMessagesByContent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchTerm' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'EnumValue', value: 'created_on_desc' },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'connection' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'key' },
                    value: {
                      kind: 'StringValue',
                      value: 'searchContent',
                      block: false,
                    },
                  },
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'filter' },
                    value: { kind: 'ListValue', values: [] },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'MessageItemFields',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conversation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'ConversationItemFields',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachmentItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attachment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Attachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachmentType' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FileAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OpenVoiceQuestionAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'words' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shorthandPrompt' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ImageAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VCardAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizeBytes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TranslatedMessage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fieldName' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'YelpAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReviewAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'review' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedback' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'opened' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SmartTopicAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rationale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VideoUploadLinkAttachment' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoUploadLinkId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'videoMicrositeLinkId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReasonSentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReasonSentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentGreetingQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentIntentQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReasonSentHangupResponseQL' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TranscriptAnalysisFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TranscriptAnalysisQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingTip' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coachingSample' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scores' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhoneCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PhoneCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasReturnCallsRouting' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutingOutcome' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedTo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'returnCallsRoutedUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectedFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OutboundConferenceCallQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caller' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transcript' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'analysis' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TranscriptAnalysisFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outboundCallSid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostMdn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recipientMdn' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBeingRecorded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasCallAssist' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'callRecording' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answeredByVoicemail' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostConnectedTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RepairOrderFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RepairOrder' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'repairOrderType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tagNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openedTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dmsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'promisedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transportationFlags' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDmsUpdate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceAdvisor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceAdvisorId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleMakeFriendly' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleModelFriendly' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleVin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentRequestFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PaymentRequestQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'encodedId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'captureMethod' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amountCaptured' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastOpened' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canceledAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationReason' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'holdExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'billingMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingLastFourDigits' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRefundedAmount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failureMessage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outcomeSellerMessage' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcomeReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attachmentUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachmentFilename' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'netAmount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canceledBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DialogFlowBotDataQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentWasBooked' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'agentDuration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customerInDms' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NumboxAgentSessionQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QualificationSurveyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'QualificationSurveyQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'buyoutAmountRange' } },
          { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentLoanAmountRange' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestedInTrading' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaseRemainingTimeRange' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ownershipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'score' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'equityTradeOpportunity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'closedByParticipant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ParticipantFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ParticipantQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayNameConfidence' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'spamStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crmContacts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contactType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestCustomer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediumType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrimary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceEntityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessageQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canTeachNuma' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'channelId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deliveryError' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInbound' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'messageFormat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'capsLockFixed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttachmentItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayNameConfidence' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastAppointment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feedbackSubmitted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numboxAgentSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outcome' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reasonSent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ReasonSentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'call' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhoneCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundProxyCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endtime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callDuration' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transcript' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'events' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'analysis' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TranscriptAnalysisFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'callRecording' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outboundConferenceCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutboundConferenceCallFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loggedCallInteraction' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repairOrder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PaymentRequestFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'NumboxAgentSessionFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qualificationSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'QualificationSurveyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHeatCase' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AppointmentQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appointmentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numboxAgentSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outcome' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalServiceAdvisorId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'enrichedFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedbackSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dialogFlowBotData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DialogFlowBotDataFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationHours' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationLabelFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationLabelQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'label' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeamFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TeamQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'language' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'place' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryMdn' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'participant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ParticipantFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewIsInbound' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewServerGenerated' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewSource' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subPreview' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewFormat' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewDisplayName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subPreviewMentions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serverGeneratedPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOverdue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'snoozedUntil' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserItemFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessageItemFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAppointment' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastAppointment' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AppointmentFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastChannel' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastChannel' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastRepairOrder' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withLastRepairOrder' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RepairOrderFields' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastUpdateTime' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastEngagement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summaryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mySummaryRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myStatusRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tasks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'engagementId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completionSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissedByParticipant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissalSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendedActions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actionData' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'amIMentioned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isMentionedConversation' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMentionedTimestamp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mentionedPreview' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mentionedDisplayName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'escalated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'optInStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversationLabels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationLabelFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'team' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TeamFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasRecentHeatCase' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchConversationByMessageQuery,
  SearchConversationByMessageQueryVariables
>;
export const VerifyPubnubDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'verifyPubnub' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversationId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'messageFormatsToExclude' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastUpdated' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'conversationId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'conversationId' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'messageFormat' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'notIn' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'messageFormatsToExclude',
                              },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'EnumValue', value: 'created_on_desc' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activePhoneCallsWithoutMessages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversationId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerifyPubnubQuery, VerifyPubnubQueryVariables>;
export const ConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'conversations' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ConversationItemStub',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationItemStub' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConversationQL' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inboxId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'waitingSince' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConversationsQuery, ConversationsQueryVariables>;

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    Attachment: [
      'AssignmentDetailsAttachment',
      'FileAttachment',
      'ImageAttachment',
      'MultiChoiceAttachment',
      'NoteAttachment',
      'OpenVoiceQuestionAttachment',
      'ReviewAttachment',
      'SmartTopicAttachment',
      'TranslatedMessage',
      'VCardAttachment',
      'VideoUploadLinkAttachment',
      'YelpAttachment',
    ],
    AutomationAction: [
      'AssignConversationActionQL',
      'ChangeConversationStateActionQL',
      'CheckOpportunityStatusActionQL',
      'CheckRepairOrderDetailsActionQL',
      'EscalateConversationActionQL',
      'HandToOpportunityAgentActionQL',
      'HasLabelActionQL',
      'IsBusinessHoursActionQL',
      'LeaveNoteActionQL',
      'ManageLabelActionQL',
      'NotifyTeamMemberActionQL',
      'ScheduleMessageActionQL',
      'SendFeedbackActionQL',
      'SendMessageActionQL',
      'SendReviewActionQL',
      'SummarizeConversationActionQL',
      'UpdateOpportunityActionQL',
      'WaitActionQL',
    ],
    AutomationTrigger: [
      'AppointmentLeadCreatedTriggerQL',
      'AppointmentLeadUpdatedTriggerQL',
      'ConversationArchivedTriggerQL',
      'ConversationMarkedAsHeatCaseTriggerQL',
      'ConversationStartedTriggerQL',
      'CustomerContactedTriggerQL',
      'EquityTradeOpportunityCreatedTriggerQL',
      'LabelAddedTriggerQL',
      'LabelRemovedTriggerQL',
      'ManualOpportunityTriggerQL',
      'MessageReceivedTriggerQL',
      'OpportunityServiceAppointmentConfirmationTriggerQL',
      'OpportunityServiceAppointmentReminderTriggerQL',
      'RepairOrderClosedTriggerQL',
      'RepairOrderOpenedTriggerQL',
      'RepairOrderUpdatedTriggerQL',
      'StaffMemberCallGoesPoorlyTriggerQL',
      'SurveyAnsweredTriggerQL',
    ],
    BaseQL: [
      'AccountQL',
      'ActiveIntegrationQL',
      'AddressConsentStatusModelQL',
      'AddressQL',
      'AnsweringScriptsQL',
      'AppliedIntentQL',
      'AppointmentAgentSettingLabelQL',
      'AppointmentAgentSettingsQL',
      'AppointmentQL',
      'AssignmentRoutingSettingQL',
      'AutomationGroupQL',
      'AutomationJobQL',
      'AutomationQL',
      'AutopilotJobQL',
      'AutopilotQL',
      'AutopilotScheduledMessageQL',
      'AvailableIntegrationQL',
      'AvailableVoiceScript',
      'AvailableVoiceStep',
      'BillingIdentityQL',
      'BillingMetadataQL',
      'BrandThemeQL',
      'BusinessIdentityModelQL',
      'BusinessProfileQL',
      'CDKServiceAdvisorQL',
      'CallIntelligenceSettingQL',
      'CallRecordingQL',
      'ComplianceSettingsQL',
      'ConversationLabelQL',
      'ConversationQL',
      'ConversationRepairOrderSmartStatusUpdateSettingsQL',
      'ConversationTagQL',
      'CrmUserModelQL',
      'CurbsideSettingsQL',
      'CustomDirectoryEntryModelQL',
      'CustomerQL',
      'DMSHistoryQL',
      'DealerTrackServiceAdvisorQL',
      'DepartmentDeviceQL',
      'DepartmentQL',
      'DialogFlowBotDataQL',
      'DisputeQL',
      'DisruptionsQL',
      'ETOSettingsQL',
      'EquityTradeOpportunityQL',
      'ExternalOpcodeQL',
      'ExternalVehicleQL',
      'FortellisSubscriptionQL',
      'HostedSmsPortQL',
      'IdentityPromptAddressQL',
      'InboxQL',
      'IntentClassifierQL',
      'LabelQL',
      'LibraryIntentQL',
      'MentionQL',
      'MessageQL',
      'NoteTakerQL',
      'NumaServiceQL',
      'NumboxAgentSessionQL',
      'OpCodeQL',
      'OperatorChannelQL',
      'OperatorPlaceQL',
      'OperatorQL',
      'OperatorSessionQL',
      'OperatorSettingsQL',
      'OperatorTranscriptQL',
      'OutboundCallCustomizationQL',
      'OutboundConferenceCallQL',
      'OutboundProxyCallQL',
      'ParticipantQL',
      'PaymentRequestCustomizationQL',
      'PaymentRequestQL',
      'PhoneCallQL',
      'PhoneLinePolicyQL',
      'PhoneLineQL',
      'PlaceGroupQL',
      'PlaceInfoQL',
      'PlaceQL',
      'PlacesUsersQL',
      'QualificationSurveyQL',
      'QuestionAgentSettingsQL',
      'RefundQL',
      'RegisteredFortellisServiceAdvisorQL',
      'RepairOrderSmartStatusUpdateSettingsQL',
      'RepairServiceQL',
      'ReviewFeedbackQL',
      'ReviewJobQL',
      'ReviewQL',
      'ScheduledMessageQL',
      'SchedulerLogQL',
      'SchedulerSyncQL',
      'ServiceAdvisorQL',
      'ShortcutQL',
      'SkuQL',
      'StageQL',
      'StatusItemQL',
      'StripeIntegrationQL',
      'SubscriptionQL',
      'SupportedVehiclesOpcodesQL',
      'SupportedVehiclesQL',
      'TeamQL',
      'TranscriptAnalysisQL',
      'TranscriptEventQL',
      'TranscriptQL',
      'TranscriptScoreQL',
      'TranscriptSectionQL',
      'TransportationSetOptionQL',
      'TransportationSetQL',
      'TransportationSetRepairServiceQL',
      'TwilioA2PCampaignQL',
      'TwilioBrandRegistrationQL',
      'TwilioTrustProductQL',
      'UserPhoneQL',
      'UserQL',
      'VideoUploadLinkQL',
      'XTimeLogModelQl',
      'XTimeLogQL',
      'XTimeSyncModelQL',
      'XTimeSyncQL',
    ],
    Channel: [
      'BandwidthChannelQL',
      'BaseChannel',
      'FacebookChannelQL',
      'GoogleChannelQL',
      'NoteChannelQL',
      'NumboxChannelQL',
      'TwilioChannelQL',
    ],
    DirectoryEntryQL: [
      'CustomDirectoryEntryQL',
      'DepartmentDirectoryEntryQL',
      'UserDirectoryEntryQL',
    ],
    LegacyCrmContactQL: [
      'CrmContactCdkQL',
      'CrmContactCnamQL',
      'CrmContactDealertrackQL',
      'CrmContactFortellisQL',
      'CrmContactQL',
    ],
    Node: [
      'AccountQL',
      'ActiveIntegrationQL',
      'AddressConsentStatusModelQL',
      'AddressQL',
      'AnsweringScriptsQL',
      'AppliedIntentQL',
      'AppointmentAgentSettingLabelQL',
      'AppointmentAgentSettingsQL',
      'AppointmentAgentStepQL',
      'AppointmentLeadCreatedTriggerQL',
      'AppointmentLeadUpdatedTriggerQL',
      'AppointmentQL',
      'AskYesNoQuestionStepQL',
      'AssignConversationActionQL',
      'AssignmentDetailsAttachment',
      'AssignmentRoutingSettingQL',
      'AutoAssignStepQL',
      'AutomationGroupQL',
      'AutomationJobQL',
      'AutomationQL',
      'AutopilotJobQL',
      'AutopilotQL',
      'AutopilotScheduledMessageQL',
      'AvailableIntegrationQL',
      'AvailableVoiceScript',
      'AvailableVoiceStep',
      'BandwidthChannelQL',
      'BaseChannel',
      'BaseOutboundProxyNumber',
      'BaseRepairOrder',
      'BillingIdentityQL',
      'BillingMetadataQL',
      'BrandThemeQL',
      'BusinessIdentityModelQL',
      'BusinessProfileQL',
      'CDKServiceAdvisorQL',
      'CallForwardingStepQL',
      'CallIntelligenceSettingQL',
      'CallRecordQL',
      'CallRecordingQL',
      'CallRecordingStepQL',
      'ChangeConversationStateActionQL',
      'CheckBusinessHoursStepQL',
      'CheckForLabelStepQL',
      'CheckOpportunityStatusActionQL',
      'CheckRepairOrderDetailsActionQL',
      'ComplianceSettingsQL',
      'ConversationArchivedTriggerQL',
      'ConversationLabelQL',
      'ConversationMarkedAsHeatCaseTriggerQL',
      'ConversationQL',
      'ConversationRepairOrderSmartStatusUpdateSettingsQL',
      'ConversationStartedTriggerQL',
      'ConversationStateStepQL',
      'ConversationTagQL',
      'ConversationalSchedulingAgentStepQl',
      'CrmContactCdkQL',
      'CrmContactCnamQL',
      'CrmContactDealertrackQL',
      'CrmContactFortellisQL',
      'CrmContactQL',
      'CrmUserModelQL',
      'CurbsideSettingsQL',
      'CustomDirectoryEntryModelQL',
      'CustomDirectoryEntryQL',
      'CustomerContactedTriggerQL',
      'CustomerQL',
      'DMSHistoryQL',
      'DealerTrackServiceAdvisorQL',
      'DepartmentDeviceQL',
      'DepartmentDirectoryEntryQL',
      'DepartmentQL',
      'DialogFlowBotDataQL',
      'DisputeQL',
      'DisruptionsQL',
      'ETOSettingsQL',
      'EquityTradeOpportunityCreatedTriggerQL',
      'EquityTradeOpportunityQL',
      'EscalateConversationActionQL',
      'ExternalOpcodeQL',
      'ExternalVehicleOverrideQL',
      'ExternalVehicleQL',
      'FacebookChannelQL',
      'FileAttachment',
      'FortellisSubscriptionQL',
      'GoogleChannelQL',
      'GreetingStepQL',
      'HandToOpportunityAgentActionQL',
      'HasLabelActionQL',
      'HostedSmsPortQL',
      'IdentityPromptAddressQL',
      'ImageAttachment',
      'InboxQL',
      'IntentClassifierQL',
      'IntentQuestionQL',
      'IsBusinessHoursActionQL',
      'LabelAddedTriggerQL',
      'LabelConversationStepQL',
      'LabelQL',
      'LabelRemovedTriggerQL',
      'LeaveNoteActionQL',
      'LibraryIntentQL',
      'ManageLabelActionQL',
      'ManualOpportunityTriggerQL',
      'MentionQL',
      'MessageQL',
      'MessageReceivedTriggerQL',
      'MultiChoiceAttachment',
      'NoteAttachment',
      'NoteChannelQL',
      'NoteTakerQL',
      'NoteTakerStepQL',
      'NotifyTeamMemberActionQL',
      'NumaServiceQL',
      'NumboxAgentSessionQL',
      'NumboxChannelQL',
      'OpCodeQL',
      'OpenVoiceQuestionAttachment',
      'OperatorAgentStepQL',
      'OperatorChannelQL',
      'OperatorPlaceQL',
      'OperatorQL',
      'OperatorSessionQL',
      'OperatorSettingsQL',
      'OperatorTranscriptQL',
      'OpportunityServiceAppointmentConfirmationTriggerQL',
      'OpportunityServiceAppointmentReminderTriggerQL',
      'OutboundCallCustomizationQL',
      'OutboundConferenceCallQL',
      'OutboundProxyCallQL',
      'OutboundProxyTwilioNumberQL',
      'ParticipantQL',
      'PaymentRequestCustomizationQL',
      'PaymentRequestQL',
      'PhoneCallQL',
      'PhoneLinePolicyQL',
      'PhoneLineQL',
      'PickupStepQL',
      'PlaceGroupQL',
      'PlaceInfoQL',
      'PlaceMetrics',
      'PlaceQL',
      'PlacesUsersQL',
      'PressAnyKeyStepQL',
      'QualificationSurveyQL',
      'QualifyStepQL',
      'QuestionAgentSettingsQL',
      'QuestionBotStepQL',
      'RefundQL',
      'RegisteredFortellisServiceAdvisorQL',
      'RepairOrderClosedTriggerQL',
      'RepairOrderFortellisQL',
      'RepairOrderOpenedTriggerQL',
      'RepairOrderSmartStatusUpdateSettingsQL',
      'RepairOrderUpdatedTriggerQL',
      'RepairServiceQL',
      'ReviewAttachment',
      'ReviewFeedbackQL',
      'ReviewJobQL',
      'ReviewQL',
      'ScheduleMessageActionQL',
      'ScheduledMessageQL',
      'SchedulerLogQL',
      'SchedulerSyncQL',
      'SendFeedbackActionQL',
      'SendMessageActionQL',
      'SendReviewActionQL',
      'ServiceAdvisorQL',
      'ShortcutQL',
      'SkuQL',
      'SmartTopicAttachment',
      'SmartTopicStepQL',
      'SpeakStepQL',
      'SpecialQuestionQL',
      'StaffMemberCallGoesPoorlyTriggerQL',
      'StageQL',
      'StatusItemQL',
      'StatusUpdaterStepQL',
      'StripeIntegrationQL',
      'SubscriptionQL',
      'SummarizeConversationActionQL',
      'SupportedVehiclesOpcodesQL',
      'SupportedVehiclesQL',
      'SurveyAnsweredTriggerQL',
      'TeamQL',
      'TextOptinStepQL',
      'TranscriptAnalysisQL',
      'TranscriptEventQL',
      'TranscriptQL',
      'TranscriptScoreQL',
      'TranscriptSectionQL',
      'TranslatedMessage',
      'TransportationSetOptionQL',
      'TransportationSetQL',
      'TransportationSetRepairServiceQL',
      'TwilioA2PCampaignQL',
      'TwilioBrandRegistrationQL',
      'TwilioChannelQL',
      'TwilioTrustProductQL',
      'UpdateOpportunityActionQL',
      'UserDirectoryEntryQL',
      'UserMetrics',
      'UserPhoneQL',
      'UserQL',
      'VCardAttachment',
      'VideoUploadLinkAttachment',
      'VideoUploadLinkQL',
      'VoiceScriptStepQL',
      'WaitActionQL',
      'XTimeLogModelQl',
      'XTimeLogQL',
      'XTimeSyncModelQL',
      'XTimeSyncQL',
      'YelpAttachment',
    ],
    OutboundProxyNumber: [
      'BaseOutboundProxyNumber',
      'OutboundProxyTwilioNumberQL',
    ],
    ReasonSentQL: [
      'ReasonSentGreetingQL',
      'ReasonSentHangupResponseQL',
      'ReasonSentIntentQL',
    ],
    RepairOrder: ['BaseRepairOrder', 'RepairOrderFortellisQL'],
    ReviewSiteInterface: [
      'FacebookReviewSite',
      'GoogleReviewSite',
      'ReviewSite',
    ],
    ServiceAdvisors: [
      'CDKServiceAdvisorQL',
      'DealerTrackServiceAdvisorQL',
      'ServiceAdvisorQL',
    ],
    TranscriptCall: [
      'OutboundConferenceCallQL',
      'OutboundProxyCallQL',
      'PhoneCallQL',
    ],
    VoiceScriptStep: [
      'AppointmentAgentStepQL',
      'AskYesNoQuestionStepQL',
      'AutoAssignStepQL',
      'CallForwardingStepQL',
      'CallRecordingStepQL',
      'CheckBusinessHoursStepQL',
      'CheckForLabelStepQL',
      'ConversationStateStepQL',
      'ConversationalSchedulingAgentStepQl',
      'GreetingStepQL',
      'IntentQuestionQL',
      'LabelConversationStepQL',
      'NoteTakerStepQL',
      'OperatorAgentStepQL',
      'PickupStepQL',
      'PressAnyKeyStepQL',
      'QualifyStepQL',
      'QuestionBotStepQL',
      'SmartTopicStepQL',
      'SpeakStepQL',
      'SpecialQuestionQL',
      'StatusUpdaterStepQL',
      'TextOptinStepQL',
      'VoiceScriptStepQL',
    ],
  },
};
export default result;

export type AccountConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | AccountConnectionKeySpecifier
)[];
export type AccountConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AccountEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | AccountEdgeKeySpecifier
)[];
export type AccountEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AccountPermissionsQLKeySpecifier = (
  | 'accountId'
  | 'permissions'
  | AccountPermissionsQLKeySpecifier
)[];
export type AccountPermissionsQLFieldPolicy = {
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  permissions?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AccountQLKeySpecifier = (
  | 'AssignmentRetention'
  | 'EscalationsEnabled'
  | 'EscalationsThreshold'
  | 'ResetOngoingOptin'
  | 'ResetOptinDays'
  | 'appointments'
  | 'archiveMissedCalls'
  | 'assignmentRetention'
  | 'assignmentRetentionChoices'
  | 'billingIdentity'
  | 'billingIdentityId'
  | 'brand'
  | 'businessProfiles'
  | 'businessVertical'
  | 'callForwardingStatus'
  | 'channels'
  | 'complianceSettings'
  | 'createdOn'
  | 'curbsideEnabledAtPlaces'
  | 'customers'
  | 'dialogFlowBotDatas'
  | 'escalationsEnabled'
  | 'escalationsThreshold'
  | 'fortellisSubscriptions'
  | 'hangupSuggestion'
  | 'id'
  | 'isAutotestAccount'
  | 'isDemo'
  | 'lastUpdated'
  | 'name'
  | 'nudgesEnabled'
  | 'nudgesThreshold'
  | 'operators'
  | 'owners'
  | 'participantCount'
  | 'participants'
  | 'placeGroups'
  | 'places'
  | 'referralUrl'
  | 'resetOngoingOptin'
  | 'resetOptinDays'
  | 'resilienceEnabledAtPlaces'
  | 'status'
  | 'twilioMessagingServiceSid'
  | 'twilioSubaccountSid'
  | 'twilioSubaccountToken'
  | 'useNewNumber'
  | 'users'
  | 'verified'
  | AccountQLKeySpecifier
)[];
export type AccountQLFieldPolicy = {
  AssignmentRetention?: FieldPolicy<any> | FieldReadFunction<any>;
  EscalationsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  EscalationsThreshold?: FieldPolicy<any> | FieldReadFunction<any>;
  ResetOngoingOptin?: FieldPolicy<any> | FieldReadFunction<any>;
  ResetOptinDays?: FieldPolicy<any> | FieldReadFunction<any>;
  appointments?: FieldPolicy<any> | FieldReadFunction<any>;
  archiveMissedCalls?: FieldPolicy<any> | FieldReadFunction<any>;
  assignmentRetention?: FieldPolicy<any> | FieldReadFunction<any>;
  assignmentRetentionChoices?: FieldPolicy<any> | FieldReadFunction<any>;
  billingIdentity?: FieldPolicy<any> | FieldReadFunction<any>;
  billingIdentityId?: FieldPolicy<any> | FieldReadFunction<any>;
  brand?: FieldPolicy<any> | FieldReadFunction<any>;
  businessProfiles?: FieldPolicy<any> | FieldReadFunction<any>;
  businessVertical?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  channels?: FieldPolicy<any> | FieldReadFunction<any>;
  complianceSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  curbsideEnabledAtPlaces?: FieldPolicy<any> | FieldReadFunction<any>;
  customers?: FieldPolicy<any> | FieldReadFunction<any>;
  dialogFlowBotDatas?: FieldPolicy<any> | FieldReadFunction<any>;
  escalationsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  escalationsThreshold?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisSubscriptions?: FieldPolicy<any> | FieldReadFunction<any>;
  hangupSuggestion?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isAutotestAccount?: FieldPolicy<any> | FieldReadFunction<any>;
  isDemo?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  nudgesEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  nudgesThreshold?: FieldPolicy<any> | FieldReadFunction<any>;
  operators?: FieldPolicy<any> | FieldReadFunction<any>;
  owners?: FieldPolicy<any> | FieldReadFunction<any>;
  participantCount?: FieldPolicy<any> | FieldReadFunction<any>;
  participants?: FieldPolicy<any> | FieldReadFunction<any>;
  placeGroups?: FieldPolicy<any> | FieldReadFunction<any>;
  places?: FieldPolicy<any> | FieldReadFunction<any>;
  referralUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  resetOngoingOptin?: FieldPolicy<any> | FieldReadFunction<any>;
  resetOptinDays?: FieldPolicy<any> | FieldReadFunction<any>;
  resilienceEnabledAtPlaces?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioMessagingServiceSid?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioSubaccountSid?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioSubaccountToken?: FieldPolicy<any> | FieldReadFunction<any>;
  useNewNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  users?: FieldPolicy<any> | FieldReadFunction<any>;
  verified?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AccountSettingsQLKeySpecifier = (
  | 'accountId'
  | 'archiveMissedCalls'
  | 'assignmentRetention'
  | 'assignmentRetentionChoices'
  | 'escalationsEnabled'
  | 'escalationsThreshold'
  | 'fortellisSubscriptions'
  | 'hangupSuggestion'
  | 'nudgesEnabled'
  | 'nudgesThreshold'
  | AccountSettingsQLKeySpecifier
)[];
export type AccountSettingsQLFieldPolicy = {
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  archiveMissedCalls?: FieldPolicy<any> | FieldReadFunction<any>;
  assignmentRetention?: FieldPolicy<any> | FieldReadFunction<any>;
  assignmentRetentionChoices?: FieldPolicy<any> | FieldReadFunction<any>;
  escalationsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  escalationsThreshold?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisSubscriptions?: FieldPolicy<any> | FieldReadFunction<any>;
  hangupSuggestion?: FieldPolicy<any> | FieldReadFunction<any>;
  nudgesEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  nudgesThreshold?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ActiveInboxKeySpecifier = (
  | 'inboxId'
  | 'isOverdue'
  | 'options'
  | 'sort'
  | 'state'
  | ActiveInboxKeySpecifier
)[];
export type ActiveInboxFieldPolicy = {
  inboxId?: FieldPolicy<any> | FieldReadFunction<any>;
  isOverdue?: FieldPolicy<any> | FieldReadFunction<any>;
  options?: FieldPolicy<any> | FieldReadFunction<any>;
  sort?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ActiveInboxOptionsKeySpecifier = (
  | 'unreadOnly'
  | ActiveInboxOptionsKeySpecifier
)[];
export type ActiveInboxOptionsFieldPolicy = {
  unreadOnly?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ActiveIntegrationQLKeySpecifier = (
  | 'appointmentAgentSettings'
  | 'appointmentLeads'
  | 'configuration'
  | 'createdOn'
  | 'customers'
  | 'friendlyName'
  | 'id'
  | 'integration'
  | 'integrationId'
  | 'lastUpdated'
  | 'opCodes'
  | 'pendingOpcodeSync'
  | 'place'
  | 'placeGroup'
  | 'placeGroupId'
  | 'placeId'
  | 'questionAgentSettings'
  | 'repairOrders'
  | 'repairServices'
  | 'schedulerSyncs'
  | 'serviceAdvisors'
  | 'status'
  | 'xtimeSyncs'
  | ActiveIntegrationQLKeySpecifier
)[];
export type ActiveIntegrationQLFieldPolicy = {
  appointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeads?: FieldPolicy<any> | FieldReadFunction<any>;
  configuration?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customers?: FieldPolicy<any> | FieldReadFunction<any>;
  friendlyName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  integration?: FieldPolicy<any> | FieldReadFunction<any>;
  integrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  opCodes?: FieldPolicy<any> | FieldReadFunction<any>;
  pendingOpcodeSync?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeGroup?: FieldPolicy<any> | FieldReadFunction<any>;
  placeGroupId?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrders?: FieldPolicy<any> | FieldReadFunction<any>;
  repairServices?: FieldPolicy<any> | FieldReadFunction<any>;
  schedulerSyncs?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisors?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  xtimeSyncs?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ActiveIntegrationQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | ActiveIntegrationQLConnectionKeySpecifier
)[];
export type ActiveIntegrationQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ActiveIntegrationQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | ActiveIntegrationQLEdgeKeySpecifier
)[];
export type ActiveIntegrationQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ActivePaymentsCollectionKeySpecifier = (
  | 'collectionId'
  | 'status'
  | ActivePaymentsCollectionKeySpecifier
)[];
export type ActivePaymentsCollectionFieldPolicy = {
  collectionId?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddAnsweringScriptToPolicyKeySpecifier = (
  | 'phoneLinePolicy'
  | AddAnsweringScriptToPolicyKeySpecifier
)[];
export type AddAnsweringScriptToPolicyFieldPolicy = {
  phoneLinePolicy?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddAutomationExitTriggerKeySpecifier = (
  | 'automation'
  | AddAutomationExitTriggerKeySpecifier
)[];
export type AddAutomationExitTriggerFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddAvailableIntegrationKeySpecifier = (
  | 'availableIntegration'
  | AddAvailableIntegrationKeySpecifier
)[];
export type AddAvailableIntegrationFieldPolicy = {
  availableIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddCustomLinkKeySpecifier = (
  | 'placeInfo'
  | AddCustomLinkKeySpecifier
)[];
export type AddCustomLinkFieldPolicy = {
  placeInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddCustomerKeySpecifier = ('customer' | AddCustomerKeySpecifier)[];
export type AddCustomerFieldPolicy = {
  customer?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddFortellisSubscriptionKeySpecifier = (
  | 'subscription'
  | AddFortellisSubscriptionKeySpecifier
)[];
export type AddFortellisSubscriptionFieldPolicy = {
  subscription?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddLabelToConversationKeySpecifier = (
  | 'conversation'
  | 'conversationLabel'
  | AddLabelToConversationKeySpecifier
)[];
export type AddLabelToConversationFieldPolicy = {
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationLabel?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddOperatorChannelKeySpecifier = (
  | 'operator'
  | 'operatorChannel'
  | AddOperatorChannelKeySpecifier
)[];
export type AddOperatorChannelFieldPolicy = {
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorChannel?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddOperatorPlaceKeySpecifier = (
  | 'operator'
  | 'operatorPlace'
  | AddOperatorPlaceKeySpecifier
)[];
export type AddOperatorPlaceFieldPolicy = {
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorPlace?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddOutboundCallCustomizationKeySpecifier = (
  | 'outboundCallCustomization'
  | AddOutboundCallCustomizationKeySpecifier
)[];
export type AddOutboundCallCustomizationFieldPolicy = {
  outboundCallCustomization?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddPlaceGroupKeySpecifier = (
  | 'placeGroup'
  | AddPlaceGroupKeySpecifier
)[];
export type AddPlaceGroupFieldPolicy = {
  placeGroup?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddServiceAdvisorKeySpecifier = (
  | 'serviceAdvisor'
  | AddServiceAdvisorKeySpecifier
)[];
export type AddServiceAdvisorFieldPolicy = {
  serviceAdvisor?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddStageKeySpecifier = ('stage' | AddStageKeySpecifier)[];
export type AddStageFieldPolicy = {
  stage?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddStatusItemKeySpecifier = (
  | 'statusItem'
  | AddStatusItemKeySpecifier
)[];
export type AddStatusItemFieldPolicy = {
  statusItem?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddSubscriptionKeySpecifier = (
  | 'billingIdentity'
  | AddSubscriptionKeySpecifier
)[];
export type AddSubscriptionFieldPolicy = {
  billingIdentity?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddUserToTeamKeySpecifier = ('team' | AddUserToTeamKeySpecifier)[];
export type AddUserToTeamFieldPolicy = {
  team?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddVoiceStepKeySpecifier = (
  | 'voiceScript'
  | AddVoiceStepKeySpecifier
)[];
export type AddVoiceStepFieldPolicy = {
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddressConsentStatusModelQLKeySpecifier = (
  | 'address'
  | 'consentCategory'
  | 'consentType'
  | 'createdOn'
  | 'customer'
  | 'customerId'
  | 'deletedAt'
  | 'id'
  | 'isActive'
  | 'isDeleted'
  | 'isPrimary'
  | 'lastUpdated'
  | 'mediumType'
  | 'sourceEntityId'
  | 'sourceEntityType'
  | AddressConsentStatusModelQLKeySpecifier
)[];
export type AddressConsentStatusModelQLFieldPolicy = {
  address?: FieldPolicy<any> | FieldReadFunction<any>;
  consentCategory?: FieldPolicy<any> | FieldReadFunction<any>;
  consentType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customer?: FieldPolicy<any> | FieldReadFunction<any>;
  customerId?: FieldPolicy<any> | FieldReadFunction<any>;
  deletedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isDeleted?: FieldPolicy<any> | FieldReadFunction<any>;
  isPrimary?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  mediumType?: FieldPolicy<any> | FieldReadFunction<any>;
  sourceEntityId?: FieldPolicy<any> | FieldReadFunction<any>;
  sourceEntityType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddressQLKeySpecifier = (
  | 'address'
  | 'addressConsentStatuses'
  | 'createdOn'
  | 'customer'
  | 'customerId'
  | 'deletedAt'
  | 'id'
  | 'isActive'
  | 'isDeleted'
  | 'isPrimary'
  | 'lastUpdated'
  | 'mediumType'
  | 'sourceEntityId'
  | 'sourceEntityType'
  | AddressQLKeySpecifier
)[];
export type AddressQLFieldPolicy = {
  address?: FieldPolicy<any> | FieldReadFunction<any>;
  addressConsentStatuses?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customer?: FieldPolicy<any> | FieldReadFunction<any>;
  customerId?: FieldPolicy<any> | FieldReadFunction<any>;
  deletedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isDeleted?: FieldPolicy<any> | FieldReadFunction<any>;
  isPrimary?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  mediumType?: FieldPolicy<any> | FieldReadFunction<any>;
  sourceEntityId?: FieldPolicy<any> | FieldReadFunction<any>;
  sourceEntityType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AgentChitChatResponseKeySpecifier = (
  | 'conversation'
  | 'currentStep'
  | 'isComplete'
  | 'reply'
  | 'sessionId'
  | 'slots'
  | AgentChitChatResponseKeySpecifier
)[];
export type AgentChitChatResponseFieldPolicy = {
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  currentStep?: FieldPolicy<any> | FieldReadFunction<any>;
  isComplete?: FieldPolicy<any> | FieldReadFunction<any>;
  reply?: FieldPolicy<any> | FieldReadFunction<any>;
  sessionId?: FieldPolicy<any> | FieldReadFunction<any>;
  slots?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AnswerOptionKeySpecifier = (
  | 'id'
  | 'nextQuestionId'
  | 'text'
  | AnswerOptionKeySpecifier
)[];
export type AnswerOptionFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  nextQuestionId?: FieldPolicy<any> | FieldReadFunction<any>;
  text?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AnsweringScriptsQLKeySpecifier = (
  | 'createdOn'
  | 'draftVoiceScript'
  | 'draftVoiceScriptId'
  | 'id'
  | 'lastUpdated'
  | 'order'
  | 'phoneLinePolicy'
  | 'phoneLinePolicyId'
  | 'place'
  | 'placeId'
  | 'publishedScriptJson'
  | 'scriptType'
  | 'voiceScript'
  | 'voiceScriptId'
  | AnsweringScriptsQLKeySpecifier
)[];
export type AnsweringScriptsQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  draftVoiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  draftVoiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  order?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneLinePolicy?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneLinePolicyId?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  publishedScriptJson?: FieldPolicy<any> | FieldReadFunction<any>;
  scriptType?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AnsweringScriptsQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | AnsweringScriptsQLConnectionKeySpecifier
)[];
export type AnsweringScriptsQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AnsweringScriptsQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | AnsweringScriptsQLEdgeKeySpecifier
)[];
export type AnsweringScriptsQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppliedIntentQLKeySpecifier = (
  | 'autoSendConfidenceThreshold'
  | 'createdOn'
  | 'displayName'
  | 'handling'
  | 'id'
  | 'isManaged'
  | 'lastUpdated'
  | 'libraryIntent'
  | 'libraryIntentId'
  | 'name'
  | 'numaGeneratedResponse'
  | 'place'
  | 'placeId'
  | 'renderedResponse'
  | 'response'
  | 'suggestConfidenceThreshold'
  | 'syncInWatson'
  | 'voiceStep'
  | AppliedIntentQLKeySpecifier
)[];
export type AppliedIntentQLFieldPolicy = {
  autoSendConfidenceThreshold?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  displayName?: FieldPolicy<any> | FieldReadFunction<any>;
  handling?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isManaged?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  libraryIntent?: FieldPolicy<any> | FieldReadFunction<any>;
  libraryIntentId?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  numaGeneratedResponse?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedResponse?: FieldPolicy<any> | FieldReadFunction<any>;
  response?: FieldPolicy<any> | FieldReadFunction<any>;
  suggestConfidenceThreshold?: FieldPolicy<any> | FieldReadFunction<any>;
  syncInWatson?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceStep?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppliedIntentQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | AppliedIntentQLConnectionKeySpecifier
)[];
export type AppliedIntentQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppliedIntentQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | AppliedIntentQLEdgeKeySpecifier
)[];
export type AppliedIntentQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppointmentAgentNoteRatingQLKeySpecifier = (
  | 'details'
  | 'reason'
  | 'value'
  | AppointmentAgentNoteRatingQLKeySpecifier
)[];
export type AppointmentAgentNoteRatingQLFieldPolicy = {
  details?: FieldPolicy<any> | FieldReadFunction<any>;
  reason?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppointmentAgentSettingLabelQLKeySpecifier = (
  | 'appointmentAgentSetting'
  | 'appointmentAgentSettingId'
  | 'category'
  | 'createdOn'
  | 'id'
  | 'label'
  | 'labelId'
  | 'lastUpdated'
  | AppointmentAgentSettingLabelQLKeySpecifier
)[];
export type AppointmentAgentSettingLabelQLFieldPolicy = {
  appointmentAgentSetting?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSettingId?: FieldPolicy<any> | FieldReadFunction<any>;
  category?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelId?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppointmentAgentSettingsQLKeySpecifier = (
  | 'activeIntegration'
  | 'activeIntegrationId'
  | 'agentProfile'
  | 'appointmentAgentSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'defaultExternalOpcode'
  | 'defaultExternalOpcodeId'
  | 'dialogFlowAgentId'
  | 'enableHangupRecovery'
  | 'id'
  | 'labels'
  | 'lastUpdated'
  | 'latestSchedulerSync'
  | 'latestXtimeSync'
  | 'maximumBookingHorizonInDays'
  | 'minimumLeadTimeInMinutes'
  | 'name'
  | 'numaInCallFlow'
  | 'optionalPrompts'
  | 'overallEmphasis'
  | 'place'
  | 'placeId'
  | 'renderedTextingHangupRecovery'
  | 'renderedTextingMessageToSend'
  | 'settings'
  | 'textingCanWeTextSpeech'
  | 'textingHangupRecovery'
  | 'textingMessageToSend'
  | 'textingMessageToSendEndOfCall'
  | 'textingOnNoSpeechCanWeText'
  | 'textingOnYesSpeechCanWeText'
  | 'transportationSets'
  | 'webSchedulerReliability'
  | AppointmentAgentSettingsQLKeySpecifier
)[];
export type AppointmentAgentSettingsQLFieldPolicy = {
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  agentProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultExternalOpcode?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultExternalOpcodeId?: FieldPolicy<any> | FieldReadFunction<any>;
  dialogFlowAgentId?: FieldPolicy<any> | FieldReadFunction<any>;
  enableHangupRecovery?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  labels?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  latestSchedulerSync?: FieldPolicy<any> | FieldReadFunction<any>;
  latestXtimeSync?: FieldPolicy<any> | FieldReadFunction<any>;
  maximumBookingHorizonInDays?: FieldPolicy<any> | FieldReadFunction<any>;
  minimumLeadTimeInMinutes?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  numaInCallFlow?: FieldPolicy<any> | FieldReadFunction<any>;
  optionalPrompts?: FieldPolicy<any> | FieldReadFunction<any>;
  overallEmphasis?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedTextingHangupRecovery?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedTextingMessageToSend?: FieldPolicy<any> | FieldReadFunction<any>;
  settings?: FieldPolicy<any> | FieldReadFunction<any>;
  textingCanWeTextSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  textingHangupRecovery?: FieldPolicy<any> | FieldReadFunction<any>;
  textingMessageToSend?: FieldPolicy<any> | FieldReadFunction<any>;
  textingMessageToSendEndOfCall?: FieldPolicy<any> | FieldReadFunction<any>;
  textingOnNoSpeechCanWeText?: FieldPolicy<any> | FieldReadFunction<any>;
  textingOnYesSpeechCanWeText?: FieldPolicy<any> | FieldReadFunction<any>;
  transportationSets?: FieldPolicy<any> | FieldReadFunction<any>;
  webSchedulerReliability?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppointmentAgentSettingsQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | AppointmentAgentSettingsQLConnectionKeySpecifier
)[];
export type AppointmentAgentSettingsQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppointmentAgentSettingsQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | AppointmentAgentSettingsQLEdgeKeySpecifier
)[];
export type AppointmentAgentSettingsQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppointmentAgentStepQLKeySpecifier = (
  | 'appointmentAgentSettings'
  | 'appointmentAgentSettingsId'
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'appointmentLeadStepId'
  | 'appointmentLeadStepRelationship'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'cantServiceCustomerStepId'
  | 'cantServiceCustomerStepRelationship'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'clarifyIntentFirstEnabled'
  | 'clarifySpeech'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'exceptionFoundSpeech'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'failureSpeech'
  | 'failureStepId'
  | 'failureStepRelationship'
  | 'finishedSpeech'
  | 'finishedSpeechAudioUrl'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'modelNotSupportedSpeech'
  | 'nextStepId'
  | 'nextStepRelationship'
  | 'noAvailableTimesSpeech'
  | 'noServiceTypeSpeech'
  | 'noSpeech'
  | 'notAnAppointmentLeadAgentSteps'
  | 'notAnAppointmentLeadStepId'
  | 'notAnAppointmentLeadStepRelationship'
  | 'notBookedOtherStepId'
  | 'notBookedOtherStepRelationship'
  | 'notBookedRecallStepId'
  | 'notBookedRecallStepRelationship'
  | 'noteTakerSteps'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'outcomeNotBookedOtherSpeech'
  | 'outcomeNotBookedOtherSpeechAudioUrl'
  | 'outcomeNotBookedRecallSpeech'
  | 'outcomeNotBookedRecallSpeechAudioUrl'
  | 'outcomeNotBookedWantsHumanSpeech'
  | 'outcomeNotBookedWantsHumanSpeechAudioUrl'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | 'yesSpeech'
  | AppointmentAgentStepQLKeySpecifier
)[];
export type AppointmentAgentStepQLFieldPolicy = {
  appointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSettingsId?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  appointmentLeadStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerStepRelationship?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  clarifyIntentFirstEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  clarifySpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  exceptionFoundSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  failureStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  failureStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  finishedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  finishedSpeechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  modelNotSupportedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  noAvailableTimesSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  noServiceTypeSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  noSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadStepRelationship?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  notBookedOtherStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  notBookedOtherStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  notBookedRecallStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  notBookedRecallStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  outcomeNotBookedOtherSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  outcomeNotBookedOtherSpeechAudioUrl?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  outcomeNotBookedRecallSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  outcomeNotBookedRecallSpeechAudioUrl?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  outcomeNotBookedWantsHumanSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  outcomeNotBookedWantsHumanSpeechAudioUrl?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppointmentAgentStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | AppointmentAgentStepQLConnectionKeySpecifier
)[];
export type AppointmentAgentStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppointmentAgentStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | AppointmentAgentStepQLEdgeKeySpecifier
)[];
export type AppointmentAgentStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppointmentLeadCreatedTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'rulesQuery'
  | 'triggerType'
  | 'uiHints'
  | AppointmentLeadCreatedTriggerQLKeySpecifier
)[];
export type AppointmentLeadCreatedTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  rulesQuery?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppointmentLeadUpdatedTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'rulesQuery'
  | 'triggerType'
  | 'uiHints'
  | AppointmentLeadUpdatedTriggerQLKeySpecifier
)[];
export type AppointmentLeadUpdatedTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  rulesQuery?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppointmentQLKeySpecifier = (
  | 'account'
  | 'accountId'
  | 'appointmentDate'
  | 'appointmentId'
  | 'bookingDetails'
  | 'conversation'
  | 'conversationId'
  | 'createdOn'
  | 'customer'
  | 'customerId'
  | 'dialogFlowBotData'
  | 'dialogFlowBotDataId'
  | 'enrichedFrom'
  | 'expiresAt'
  | 'externalId'
  | 'externalServiceAdvisorId'
  | 'externalServiceAdvisorName'
  | 'feedbackSubmitted'
  | 'id'
  | 'isScheduled'
  | 'lastUpdated'
  | 'numboxAgentSession'
  | 'participant'
  | 'participantId'
  | 'place'
  | 'placeId'
  | 'rawData'
  | 'repairServices'
  | 'schedulerActiveIntegration'
  | 'schedulerActiveIntegrationId'
  | 'schedulerIntegrationInternalType'
  | 'source'
  | 'state'
  | AppointmentQLKeySpecifier
)[];
export type AppointmentQLFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentDate?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentId?: FieldPolicy<any> | FieldReadFunction<any>;
  bookingDetails?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customer?: FieldPolicy<any> | FieldReadFunction<any>;
  customerId?: FieldPolicy<any> | FieldReadFunction<any>;
  dialogFlowBotData?: FieldPolicy<any> | FieldReadFunction<any>;
  dialogFlowBotDataId?: FieldPolicy<any> | FieldReadFunction<any>;
  enrichedFrom?: FieldPolicy<any> | FieldReadFunction<any>;
  expiresAt?: FieldPolicy<any> | FieldReadFunction<any>;
  externalId?: FieldPolicy<any> | FieldReadFunction<any>;
  externalServiceAdvisorId?: FieldPolicy<any> | FieldReadFunction<any>;
  externalServiceAdvisorName?: FieldPolicy<any> | FieldReadFunction<any>;
  feedbackSubmitted?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isScheduled?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  numboxAgentSession?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  participantId?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  rawData?: FieldPolicy<any> | FieldReadFunction<any>;
  repairServices?: FieldPolicy<any> | FieldReadFunction<any>;
  schedulerActiveIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  schedulerActiveIntegrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  schedulerIntegrationInternalType?: FieldPolicy<any> | FieldReadFunction<any>;
  source?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppointmentQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | AppointmentQLConnectionKeySpecifier
)[];
export type AppointmentQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppointmentQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | AppointmentQLEdgeKeySpecifier
)[];
export type AppointmentQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ArchiveMissedCallsKeySpecifier = (
  | 'accountSettings'
  | 'channel'
  | 'currentAccount'
  | 'phoneLinePolicy'
  | ArchiveMissedCallsKeySpecifier
)[];
export type ArchiveMissedCallsFieldPolicy = {
  accountSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
  currentAccount?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneLinePolicy?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AskYesNoQuestionStepQLKeySpecifier = (
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'clarifySpeech'
  | 'clarifySpeechUrl'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onFailureSpeech'
  | 'onFailureSpeechUrl'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'onNoSpeech'
  | 'onNoSpeechUrl'
  | 'onNoStep'
  | 'onNoStepId'
  | 'onYesSpeech'
  | 'onYesSpeechUrl'
  | 'onYesStep'
  | 'onYesStepId'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | AskYesNoQuestionStepQLKeySpecifier
)[];
export type AskYesNoQuestionStepQLFieldPolicy = {
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  clarifySpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  clarifySpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onFailureSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onFailureSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoStep?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesStep?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AskYesNoQuestionStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | AskYesNoQuestionStepQLConnectionKeySpecifier
)[];
export type AskYesNoQuestionStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AskYesNoQuestionStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | AskYesNoQuestionStepQLEdgeKeySpecifier
)[];
export type AskYesNoQuestionStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AssignConversationActionQLKeySpecifier = (
  | 'actionType'
  | 'assignee'
  | 'assigneeId'
  | 'automation'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'id'
  | 'lastUpdated'
  | 'nextActionId'
  | 'respectExistingAssignments'
  | 'team'
  | 'teamId'
  | 'uiHints'
  | AssignConversationActionQLKeySpecifier
)[];
export type AssignConversationActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  assigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  respectExistingAssignments?: FieldPolicy<any> | FieldReadFunction<any>;
  team?: FieldPolicy<any> | FieldReadFunction<any>;
  teamId?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AssignConversationsKeySpecifier = (
  | 'conversations'
  | AssignConversationsKeySpecifier
)[];
export type AssignConversationsFieldPolicy = {
  conversations?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AssignmentDetailsAttachmentKeySpecifier = (
  | 'after'
  | 'attachmentType'
  | 'before'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'message'
  | 'messageId'
  | 'url'
  | AssignmentDetailsAttachmentKeySpecifier
)[];
export type AssignmentDetailsAttachmentFieldPolicy = {
  after?: FieldPolicy<any> | FieldReadFunction<any>;
  attachmentType?: FieldPolicy<any> | FieldReadFunction<any>;
  before?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  messageId?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AssignmentRetentionChoiceQLKeySpecifier = (
  | 'label'
  | 'value'
  | AssignmentRetentionChoiceQLKeySpecifier
)[];
export type AssignmentRetentionChoiceQLFieldPolicy = {
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AssignmentRoutingSettingQLKeySpecifier = (
  | 'callTimeout'
  | 'createdOn'
  | 'enabled'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'enabledWhenAway'
  | 'forwardingMdn'
  | 'globalOverride'
  | 'id'
  | 'lastUpdated'
  | 'placesUsers'
  | 'placesUsersId'
  | 'useNumaCallerId'
  | AssignmentRoutingSettingQLKeySpecifier
)[];
export type AssignmentRoutingSettingQLFieldPolicy = {
  callTimeout?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledWhenAway?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingMdn?: FieldPolicy<any> | FieldReadFunction<any>;
  globalOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  placesUsers?: FieldPolicy<any> | FieldReadFunction<any>;
  placesUsersId?: FieldPolicy<any> | FieldReadFunction<any>;
  useNumaCallerId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AssistedResponseRatingQLKeySpecifier = (
  | 'createdOn'
  | 'details'
  | 'engagementId'
  | 'engagementInboxAgentResultId'
  | 'lastUpdated'
  | 'questionTree'
  | 'reason'
  | 'responseGeneration'
  | 'userId'
  | 'value'
  | AssistedResponseRatingQLKeySpecifier
)[];
export type AssistedResponseRatingQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  details?: FieldPolicy<any> | FieldReadFunction<any>;
  engagementId?: FieldPolicy<any> | FieldReadFunction<any>;
  engagementInboxAgentResultId?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  questionTree?: FieldPolicy<any> | FieldReadFunction<any>;
  reason?: FieldPolicy<any> | FieldReadFunction<any>;
  responseGeneration?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AttachmentKeySpecifier = (
  | 'attachmentType'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | AttachmentKeySpecifier
)[];
export type AttachmentFieldPolicy = {
  attachmentType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AuthTokensKeySpecifier = (
  | 'accessToken'
  | 'featureFlags'
  | 'refreshToken'
  | AuthTokensKeySpecifier
)[];
export type AuthTokensFieldPolicy = {
  accessToken?: FieldPolicy<any> | FieldReadFunction<any>;
  featureFlags?: FieldPolicy<any> | FieldReadFunction<any>;
  refreshToken?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutoAssignStepQLKeySpecifier = (
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'assignee'
  | 'assigneeId'
  | 'autoAssignNextStepId'
  | 'autoAssignNextStepRelationship'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'respectExistingAssignment'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'team'
  | 'teamId'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | AutoAssignStepQLKeySpecifier
)[];
export type AutoAssignStepQLFieldPolicy = {
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  assigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  autoAssignNextStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  autoAssignNextStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  respectExistingAssignment?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  team?: FieldPolicy<any> | FieldReadFunction<any>;
  teamId?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutoAssignStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | AutoAssignStepQLConnectionKeySpecifier
)[];
export type AutoAssignStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutoAssignStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | AutoAssignStepQLEdgeKeySpecifier
)[];
export type AutoAssignStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutomationActionKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'id'
  | 'lastUpdated'
  | 'nextActionId'
  | 'uiHints'
  | AutomationActionKeySpecifier
)[];
export type AutomationActionFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutomationChannelsKeySpecifier = (
  | 'id'
  | AutomationChannelsKeySpecifier
)[];
export type AutomationChannelsFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutomationConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | AutomationConnectionKeySpecifier
)[];
export type AutomationConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutomationEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | AutomationEdgeKeySpecifier
)[];
export type AutomationEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutomationGroupQLKeySpecifier = (
  | 'automations'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'status'
  | AutomationGroupQLKeySpecifier
)[];
export type AutomationGroupQLFieldPolicy = {
  automations?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutomationJobConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | AutomationJobConnectionKeySpecifier
)[];
export type AutomationJobConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutomationJobEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | AutomationJobEdgeKeySpecifier
)[];
export type AutomationJobEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutomationJobQLKeySpecifier = (
  | 'automationId'
  | 'completedAt'
  | 'conversation'
  | 'conversationId'
  | 'createdOn'
  | 'currentAction'
  | 'currentActionId'
  | 'id'
  | 'lastUpdated'
  | 'startingEventId'
  | 'startingEventType'
  | 'status'
  | 'waitingUntil'
  | AutomationJobQLKeySpecifier
)[];
export type AutomationJobQLFieldPolicy = {
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  completedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  currentAction?: FieldPolicy<any> | FieldReadFunction<any>;
  currentActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  startingEventId?: FieldPolicy<any> | FieldReadFunction<any>;
  startingEventType?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  waitingUntil?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutomationJobQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | AutomationJobQLConnectionKeySpecifier
)[];
export type AutomationJobQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutomationJobQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | AutomationJobQLEdgeKeySpecifier
)[];
export type AutomationJobQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutomationQLKeySpecifier = (
  | 'actions'
  | 'automationGroupId'
  | 'createdOn'
  | 'dateLastPublished'
  | 'enrollmentCriteria'
  | 'exitTriggers'
  | 'firstAction'
  | 'firstActionId'
  | 'id'
  | 'lastUpdated'
  | 'latestVersion'
  | 'name'
  | 'placeId'
  | 'publishedVersion'
  | 'startTrigger'
  | 'state'
  | AutomationQLKeySpecifier
)[];
export type AutomationQLFieldPolicy = {
  actions?: FieldPolicy<any> | FieldReadFunction<any>;
  automationGroupId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  dateLastPublished?: FieldPolicy<any> | FieldReadFunction<any>;
  enrollmentCriteria?: FieldPolicy<any> | FieldReadFunction<any>;
  exitTriggers?: FieldPolicy<any> | FieldReadFunction<any>;
  firstAction?: FieldPolicy<any> | FieldReadFunction<any>;
  firstActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  latestVersion?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  publishedVersion?: FieldPolicy<any> | FieldReadFunction<any>;
  startTrigger?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutomationTriggerKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'triggerType'
  | 'uiHints'
  | AutomationTriggerKeySpecifier
)[];
export type AutomationTriggerFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutomationUIHintsKeySpecifier = (
  | 'x'
  | 'y'
  | AutomationUIHintsKeySpecifier
)[];
export type AutomationUIHintsFieldPolicy = {
  x?: FieldPolicy<any> | FieldReadFunction<any>;
  y?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutopilotJobQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'inspection'
  | 'lastUpdated'
  | 'pickup'
  | 'place'
  | 'placeId'
  | 'qualityControl'
  | 'service'
  | 'welcome'
  | AutopilotJobQLKeySpecifier
)[];
export type AutopilotJobQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  inspection?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  pickup?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  qualityControl?: FieldPolicy<any> | FieldReadFunction<any>;
  service?: FieldPolicy<any> | FieldReadFunction<any>;
  welcome?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutopilotQLKeySpecifier = (
  | 'assignee'
  | 'assigneeId'
  | 'autopilotScheduleMessages'
  | 'autopilotStatus'
  | 'conversation'
  | 'conversationId'
  | 'createdBy'
  | 'createdById'
  | 'createdOn'
  | 'customerName'
  | 'eta'
  | 'id'
  | 'identifier'
  | 'lastUpdated'
  | 'previewInspection'
  | 'previewPickup'
  | 'previewQualityControl'
  | 'previewService'
  | 'previewWelcome'
  | AutopilotQLKeySpecifier
)[];
export type AutopilotQLFieldPolicy = {
  assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  assigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  autopilotScheduleMessages?: FieldPolicy<any> | FieldReadFunction<any>;
  autopilotStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdBy?: FieldPolicy<any> | FieldReadFunction<any>;
  createdById?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customerName?: FieldPolicy<any> | FieldReadFunction<any>;
  eta?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  previewInspection?: FieldPolicy<any> | FieldReadFunction<any>;
  previewPickup?: FieldPolicy<any> | FieldReadFunction<any>;
  previewQualityControl?: FieldPolicy<any> | FieldReadFunction<any>;
  previewService?: FieldPolicy<any> | FieldReadFunction<any>;
  previewWelcome?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutopilotQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | AutopilotQLConnectionKeySpecifier
)[];
export type AutopilotQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutopilotQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | AutopilotQLEdgeKeySpecifier
)[];
export type AutopilotQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AutopilotScheduledMessageQLKeySpecifier = (
  | 'autopilot'
  | 'autopilotId'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'milestoneName'
  | 'scheduled'
  | 'scheduledId'
  | AutopilotScheduledMessageQLKeySpecifier
)[];
export type AutopilotScheduledMessageQLFieldPolicy = {
  autopilot?: FieldPolicy<any> | FieldReadFunction<any>;
  autopilotId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  milestoneName?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduled?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduledId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AvailableIntegrationQLKeySpecifier = (
  | 'categories'
  | 'configurationSchema'
  | 'createdOn'
  | 'defaultConfiguration'
  | 'description'
  | 'featureFlag'
  | 'id'
  | 'internalId'
  | 'lastUpdated'
  | 'name'
  | 'settingsUrl'
  | 'setupType'
  | AvailableIntegrationQLKeySpecifier
)[];
export type AvailableIntegrationQLFieldPolicy = {
  categories?: FieldPolicy<any> | FieldReadFunction<any>;
  configurationSchema?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultConfiguration?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  featureFlag?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  internalId?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  settingsUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  setupType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AvailableVoiceScriptKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'place'
  | 'previewScript'
  | 'scriptSteps'
  | 'scriptType'
  | AvailableVoiceScriptKeySpecifier
)[];
export type AvailableVoiceScriptFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  previewScript?: FieldPolicy<any> | FieldReadFunction<any>;
  scriptSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  scriptType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AvailableVoiceStepKeySpecifier = (
  | 'canToggle'
  | 'createdOn'
  | 'id'
  | 'label'
  | 'lastUpdated'
  | AvailableVoiceStepKeySpecifier
)[];
export type AvailableVoiceStepFieldPolicy = {
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BandwidthChannelQLKeySpecifier = (
  | 'account'
  | 'accountId'
  | 'assignee'
  | 'assigneeId'
  | 'channelType'
  | 'createdOn'
  | 'id'
  | 'identityPromptOption'
  | 'isActive'
  | 'isBotEnabled'
  | 'lastUpdated'
  | 'mdn'
  | 'name'
  | 'place'
  | 'placeId'
  | 'respectExistingAssignments'
  | 'team'
  | 'teamId'
  | 'userId'
  | BandwidthChannelQLKeySpecifier
)[];
export type BandwidthChannelQLFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  assigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  channelType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptOption?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isBotEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  mdn?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  respectExistingAssignments?: FieldPolicy<any> | FieldReadFunction<any>;
  team?: FieldPolicy<any> | FieldReadFunction<any>;
  teamId?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BaseChannelKeySpecifier = (
  | 'Assignee'
  | 'AssigneeId'
  | 'RespectExistingAssignments'
  | 'Team'
  | 'TeamId'
  | 'account'
  | 'accountId'
  | 'assignTextReplies'
  | 'assignee'
  | 'assigneeId'
  | 'channelType'
  | 'createdOn'
  | 'id'
  | 'identityPromptAddresses'
  | 'identityPromptOption'
  | 'isActive'
  | 'isBotEnabled'
  | 'isNryChannel'
  | 'lastUpdated'
  | 'messages'
  | 'name'
  | 'operator'
  | 'operatorId'
  | 'operatorSessions'
  | 'outboundConferenceCall'
  | 'outboundProxyCall'
  | 'phonecalls'
  | 'place'
  | 'placeId'
  | 'respectExistingAssignments'
  | 'scheduled'
  | 'smsChannel'
  | 'smsPhonelines'
  | 'supportsVoicemail'
  | 'team'
  | 'teamId'
  | 'userId'
  | BaseChannelKeySpecifier
)[];
export type BaseChannelFieldPolicy = {
  Assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  AssigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  RespectExistingAssignments?: FieldPolicy<any> | FieldReadFunction<any>;
  Team?: FieldPolicy<any> | FieldReadFunction<any>;
  TeamId?: FieldPolicy<any> | FieldReadFunction<any>;
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  assignTextReplies?: FieldPolicy<any> | FieldReadFunction<any>;
  assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  assigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  channelType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptAddresses?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptOption?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isBotEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  isNryChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorId?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSessions?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundConferenceCall?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundProxyCall?: FieldPolicy<any> | FieldReadFunction<any>;
  phonecalls?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  respectExistingAssignments?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduled?: FieldPolicy<any> | FieldReadFunction<any>;
  smsChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  smsPhonelines?: FieldPolicy<any> | FieldReadFunction<any>;
  supportsVoicemail?: FieldPolicy<any> | FieldReadFunction<any>;
  team?: FieldPolicy<any> | FieldReadFunction<any>;
  teamId?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BaseChannelConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | BaseChannelConnectionKeySpecifier
)[];
export type BaseChannelConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BaseChannelEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | BaseChannelEdgeKeySpecifier
)[];
export type BaseChannelEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BaseOutboundProxyNumberKeySpecifier = (
  | 'carrierType'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | BaseOutboundProxyNumberKeySpecifier
)[];
export type BaseOutboundProxyNumberFieldPolicy = {
  carrierType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BaseQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | BaseQLKeySpecifier
)[];
export type BaseQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BaseRepairOrderKeySpecifier = (
  | 'activeIntegration'
  | 'activeIntegrationId'
  | 'completedTime'
  | 'conversation'
  | 'conversationId'
  | 'createdOn'
  | 'customer'
  | 'customerId'
  | 'data'
  | 'dmsStatus'
  | 'externalServiceAdvisorId'
  | 'id'
  | 'isActive'
  | 'isCompleted'
  | 'lastDmsUpdate'
  | 'lastSeenAt'
  | 'lastUpdated'
  | 'messages'
  | 'opCodes'
  | 'openedTime'
  | 'orderNumber'
  | 'participant'
  | 'place'
  | 'placeId'
  | 'promisedTime'
  | 'repairOrderType'
  | 'roStatus'
  | 'serviceAdvisor'
  | 'serviceAdvisorName'
  | 'status'
  | 'statusItem'
  | 'tagNumber'
  | 'transportationFlags'
  | 'user'
  | 'userId'
  | 'vehicleMake'
  | 'vehicleMakeFriendly'
  | 'vehicleMileage'
  | 'vehicleModel'
  | 'vehicleModelFriendly'
  | 'vehicleVin'
  | 'vehicleYear'
  | BaseRepairOrderKeySpecifier
)[];
export type BaseRepairOrderFieldPolicy = {
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  completedTime?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customer?: FieldPolicy<any> | FieldReadFunction<any>;
  customerId?: FieldPolicy<any> | FieldReadFunction<any>;
  data?: FieldPolicy<any> | FieldReadFunction<any>;
  dmsStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  externalServiceAdvisorId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isCompleted?: FieldPolicy<any> | FieldReadFunction<any>;
  lastDmsUpdate?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSeenAt?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  opCodes?: FieldPolicy<any> | FieldReadFunction<any>;
  openedTime?: FieldPolicy<any> | FieldReadFunction<any>;
  orderNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  promisedTime?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderType?: FieldPolicy<any> | FieldReadFunction<any>;
  roStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisor?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisorName?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  statusItem?: FieldPolicy<any> | FieldReadFunction<any>;
  tagNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  transportationFlags?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleMake?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleMakeFriendly?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleMileage?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleModel?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleModelFriendly?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleVin?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleYear?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BillingIdentityConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | BillingIdentityConnectionKeySpecifier
)[];
export type BillingIdentityConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BillingIdentityEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | BillingIdentityEdgeKeySpecifier
)[];
export type BillingIdentityEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BillingIdentityQLKeySpecifier = (
  | 'account'
  | 'billingOrderId'
  | 'brand'
  | 'createdOn'
  | 'email'
  | 'eulaAcceptanceDate'
  | 'firstPaymentDate'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'notifiedDelinquent'
  | 'paymentSource'
  | 'paymentSourceId'
  | 'phone'
  | 'productOffering'
  | 'resellerId'
  | 'signupMode'
  | 'signupParams'
  | 'signupUser'
  | 'source'
  | 'subscriptions'
  | BillingIdentityQLKeySpecifier
)[];
export type BillingIdentityQLFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  billingOrderId?: FieldPolicy<any> | FieldReadFunction<any>;
  brand?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  eulaAcceptanceDate?: FieldPolicy<any> | FieldReadFunction<any>;
  firstPaymentDate?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  notifiedDelinquent?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentSource?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentSourceId?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  productOffering?: FieldPolicy<any> | FieldReadFunction<any>;
  resellerId?: FieldPolicy<any> | FieldReadFunction<any>;
  signupMode?: FieldPolicy<any> | FieldReadFunction<any>;
  signupParams?: FieldPolicy<any> | FieldReadFunction<any>;
  signupUser?: FieldPolicy<any> | FieldReadFunction<any>;
  source?: FieldPolicy<any> | FieldReadFunction<any>;
  subscriptions?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BillingMetadataQLKeySpecifier = (
  | 'chargebeeCustomerId'
  | 'chargebeeSubscriptionId'
  | 'createdOn'
  | 'hubspotCompanyId'
  | 'hubspotContactId'
  | 'hubspotDealId'
  | 'id'
  | 'lastUpdated'
  | 'place'
  | 'placeId'
  | BillingMetadataQLKeySpecifier
)[];
export type BillingMetadataQLFieldPolicy = {
  chargebeeCustomerId?: FieldPolicy<any> | FieldReadFunction<any>;
  chargebeeSubscriptionId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  hubspotCompanyId?: FieldPolicy<any> | FieldReadFunction<any>;
  hubspotContactId?: FieldPolicy<any> | FieldReadFunction<any>;
  hubspotDealId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BrandThemeQLKeySpecifier = (
  | 'bodyBackgroundColor'
  | 'bodyBorderColor'
  | 'bodyTextColor'
  | 'buttonColor'
  | 'buttonPrimaryBackgroundColor'
  | 'buttonPrimaryBorderColor'
  | 'buttonPrimaryTextColor'
  | 'buttonSecondaryBackgroundColor'
  | 'buttonSecondaryBorderColor'
  | 'buttonSecondaryTextColor'
  | 'buttonTextColor'
  | 'createdOn'
  | 'headerBackgroundColor'
  | 'headerBorderColor'
  | 'headerTextColor'
  | 'id'
  | 'lastUpdated'
  | 'logoUrl'
  | 'paletteType'
  | 'place'
  | 'placeId'
  | 'stylesheetOverride'
  | 'supportedPaletteTypes'
  | BrandThemeQLKeySpecifier
)[];
export type BrandThemeQLFieldPolicy = {
  bodyBackgroundColor?: FieldPolicy<any> | FieldReadFunction<any>;
  bodyBorderColor?: FieldPolicy<any> | FieldReadFunction<any>;
  bodyTextColor?: FieldPolicy<any> | FieldReadFunction<any>;
  buttonColor?: FieldPolicy<any> | FieldReadFunction<any>;
  buttonPrimaryBackgroundColor?: FieldPolicy<any> | FieldReadFunction<any>;
  buttonPrimaryBorderColor?: FieldPolicy<any> | FieldReadFunction<any>;
  buttonPrimaryTextColor?: FieldPolicy<any> | FieldReadFunction<any>;
  buttonSecondaryBackgroundColor?: FieldPolicy<any> | FieldReadFunction<any>;
  buttonSecondaryBorderColor?: FieldPolicy<any> | FieldReadFunction<any>;
  buttonSecondaryTextColor?: FieldPolicy<any> | FieldReadFunction<any>;
  buttonTextColor?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  headerBackgroundColor?: FieldPolicy<any> | FieldReadFunction<any>;
  headerBorderColor?: FieldPolicy<any> | FieldReadFunction<any>;
  headerTextColor?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  logoUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  paletteType?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  stylesheetOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  supportedPaletteTypes?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BuildRepairOrderAssistedStatusQuestionTreeKeySpecifier = (
  | 'questionTree'
  | BuildRepairOrderAssistedStatusQuestionTreeKeySpecifier
)[];
export type BuildRepairOrderAssistedStatusQuestionTreeFieldPolicy = {
  questionTree?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BuildWriteItForMeQuestionTreeKeySpecifier = (
  | 'questionTree'
  | 'tones'
  | BuildWriteItForMeQuestionTreeKeySpecifier
)[];
export type BuildWriteItForMeQuestionTreeFieldPolicy = {
  questionTree?: FieldPolicy<any> | FieldReadFunction<any>;
  tones?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BulkUpdateSupportedVehiclesKeySpecifier = (
  | 'supportedVehicles'
  | BulkUpdateSupportedVehiclesKeySpecifier
)[];
export type BulkUpdateSupportedVehiclesFieldPolicy = {
  supportedVehicles?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessIdentityModelQLKeySpecifier = (
  | 'businessType'
  | 'city'
  | 'country'
  | 'createdOn'
  | 'email'
  | 'entityType'
  | 'firstName'
  | 'id'
  | 'industry'
  | 'jobTitle'
  | 'lastName'
  | 'lastUpdated'
  | 'legalName'
  | 'mobilePhone'
  | 'phone'
  | 'secondaryStreet'
  | 'state'
  | 'stockExchange'
  | 'stockTickerSymbol'
  | 'street'
  | 'taxId'
  | 'twilioTrustProductId'
  | 'websiteUrl'
  | 'zipCode'
  | BusinessIdentityModelQLKeySpecifier
)[];
export type BusinessIdentityModelQLFieldPolicy = {
  businessType?: FieldPolicy<any> | FieldReadFunction<any>;
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  entityType?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  industry?: FieldPolicy<any> | FieldReadFunction<any>;
  jobTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  legalName?: FieldPolicy<any> | FieldReadFunction<any>;
  mobilePhone?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  secondaryStreet?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  stockExchange?: FieldPolicy<any> | FieldReadFunction<any>;
  stockTickerSymbol?: FieldPolicy<any> | FieldReadFunction<any>;
  street?: FieldPolicy<any> | FieldReadFunction<any>;
  taxId?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioTrustProductId?: FieldPolicy<any> | FieldReadFunction<any>;
  websiteUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  zipCode?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessProfileQLKeySpecifier = (
  | 'account'
  | 'accountId'
  | 'brandSid'
  | 'businessIndustry'
  | 'businessRegionsOfOperations'
  | 'businessRegistrationIdType'
  | 'businessRegistrationNumber'
  | 'businessRegistrationNumberType'
  | 'businessType'
  | 'campaignSid'
  | 'companyStatus'
  | 'contact1BusinessTitle'
  | 'contact1Email'
  | 'contact1FirstName'
  | 'contact1JobPosition'
  | 'contact1LastName'
  | 'contact1PhoneNumber'
  | 'contact2BusinessTitle'
  | 'contact2Email'
  | 'contact2FirstName'
  | 'contact2JobPosition'
  | 'contact2LastName'
  | 'contact2PhoneNumber'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'legalBusinessName'
  | 'physicalAddress'
  | 'places'
  | 'registrationStatus'
  | 'registrationType'
  | 'socialMediaUrl'
  | 'stockTickerExchange'
  | 'websiteUrl'
  | BusinessProfileQLKeySpecifier
)[];
export type BusinessProfileQLFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  brandSid?: FieldPolicy<any> | FieldReadFunction<any>;
  businessIndustry?: FieldPolicy<any> | FieldReadFunction<any>;
  businessRegionsOfOperations?: FieldPolicy<any> | FieldReadFunction<any>;
  businessRegistrationIdType?: FieldPolicy<any> | FieldReadFunction<any>;
  businessRegistrationNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  businessRegistrationNumberType?: FieldPolicy<any> | FieldReadFunction<any>;
  businessType?: FieldPolicy<any> | FieldReadFunction<any>;
  campaignSid?: FieldPolicy<any> | FieldReadFunction<any>;
  companyStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  contact1BusinessTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  contact1Email?: FieldPolicy<any> | FieldReadFunction<any>;
  contact1FirstName?: FieldPolicy<any> | FieldReadFunction<any>;
  contact1JobPosition?: FieldPolicy<any> | FieldReadFunction<any>;
  contact1LastName?: FieldPolicy<any> | FieldReadFunction<any>;
  contact1PhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  contact2BusinessTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  contact2Email?: FieldPolicy<any> | FieldReadFunction<any>;
  contact2FirstName?: FieldPolicy<any> | FieldReadFunction<any>;
  contact2JobPosition?: FieldPolicy<any> | FieldReadFunction<any>;
  contact2LastName?: FieldPolicy<any> | FieldReadFunction<any>;
  contact2PhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  legalBusinessName?: FieldPolicy<any> | FieldReadFunction<any>;
  physicalAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  places?: FieldPolicy<any> | FieldReadFunction<any>;
  registrationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  registrationType?: FieldPolicy<any> | FieldReadFunction<any>;
  socialMediaUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  stockTickerExchange?: FieldPolicy<any> | FieldReadFunction<any>;
  websiteUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessProfileQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | BusinessProfileQLConnectionKeySpecifier
)[];
export type BusinessProfileQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BusinessProfileQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | BusinessProfileQLEdgeKeySpecifier
)[];
export type BusinessProfileQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CDKServiceAdvisorQLKeySpecifier = (
  | 'activeIntegration'
  | 'activeIntegrationId'
  | 'createdOn'
  | 'fortellisSubscription'
  | 'fortellisSubscriptionId'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'nextFetchTime'
  | 'placeId'
  | 'placesUser'
  | 'placesUsersId'
  | 'rawData'
  | 'repairOrderSchedule'
  | 'serviceAdvisorId'
  | 'serviceAdvisorName'
  | 'type'
  | 'user'
  | 'userId'
  | CDKServiceAdvisorQLKeySpecifier
)[];
export type CDKServiceAdvisorQLFieldPolicy = {
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisSubscriptionId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  nextFetchTime?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  placesUser?: FieldPolicy<any> | FieldReadFunction<any>;
  placesUsersId?: FieldPolicy<any> | FieldReadFunction<any>;
  rawData?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderSchedule?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisorId?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisorName?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CDKServiceAdvisorQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | CDKServiceAdvisorQLConnectionKeySpecifier
)[];
export type CDKServiceAdvisorQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CDKServiceAdvisorQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | CDKServiceAdvisorQLEdgeKeySpecifier
)[];
export type CDKServiceAdvisorQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CRMEmailQLKeySpecifier = ('address' | CRMEmailQLKeySpecifier)[];
export type CRMEmailQLFieldPolicy = {
  address?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CallForwardingStepMdnQLKeySpecifier = (
  | 'forwardingMdn'
  | 'forwardingMode'
  | CallForwardingStepMdnQLKeySpecifier
)[];
export type CallForwardingStepMdnQLFieldPolicy = {
  forwardingMdn?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingMode?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CallForwardingStepQLKeySpecifier = (
  | 'ForwardingMdn'
  | 'ForwardingMode'
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'callTimeout'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingMdn'
  | 'forwardingMdns'
  | 'forwardingMode'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'noAnswerSpeech'
  | 'noAnswerSpeechUrl'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onConnectedStep'
  | 'onConnectedStepId'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoAnsweringStep'
  | 'onNoAnsweringStepId'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'useNumaCallerId'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | CallForwardingStepQLKeySpecifier
)[];
export type CallForwardingStepQLFieldPolicy = {
  ForwardingMdn?: FieldPolicy<any> | FieldReadFunction<any>;
  ForwardingMode?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callTimeout?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingMdn?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingMdns?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingMode?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  noAnswerSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  noAnswerSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onConnectedStep?: FieldPolicy<any> | FieldReadFunction<any>;
  onConnectedStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoAnsweringStep?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoAnsweringStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  useNumaCallerId?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CallForwardingStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | CallForwardingStepQLConnectionKeySpecifier
)[];
export type CallForwardingStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CallForwardingStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | CallForwardingStepQLEdgeKeySpecifier
)[];
export type CallForwardingStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CallIntelligenceRatingQLKeySpecifier = (
  | 'createdOn'
  | 'details'
  | 'lastUpdated'
  | 'reason'
  | 'source'
  | 'transcriptAnalysisId'
  | 'userId'
  | 'value'
  | CallIntelligenceRatingQLKeySpecifier
)[];
export type CallIntelligenceRatingQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  details?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  reason?: FieldPolicy<any> | FieldReadFunction<any>;
  source?: FieldPolicy<any> | FieldReadFunction<any>;
  transcriptAnalysisId?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CallIntelligenceSettingQLKeySpecifier = (
  | 'activeUserSeatsSettings'
  | 'availableSeats'
  | 'createdOn'
  | 'customDisclosureSpeech'
  | 'customDisclosureSpeechOverride'
  | 'customDisclosureSpeechUrl'
  | 'disclosureContent'
  | 'disclosureSpeechUrl'
  | 'enabled'
  | 'id'
  | 'lastUpdated'
  | 'permissions'
  | 'place'
  | 'placeId'
  | 'playDisclosureSpeech'
  | 'renderedDisclosureContent'
  | 'seatLimit'
  | CallIntelligenceSettingQLKeySpecifier
)[];
export type CallIntelligenceSettingQLFieldPolicy = {
  activeUserSeatsSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  availableSeats?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customDisclosureSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  customDisclosureSpeechOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  customDisclosureSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  disclosureContent?: FieldPolicy<any> | FieldReadFunction<any>;
  disclosureSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  permissions?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  playDisclosureSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedDisclosureContent?: FieldPolicy<any> | FieldReadFunction<any>;
  seatLimit?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CallRecordConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | 'totalCount'
  | CallRecordConnectionKeySpecifier
)[];
export type CallRecordConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CallRecordEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | CallRecordEdgeKeySpecifier
)[];
export type CallRecordEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CallRecordQLKeySpecifier = (
  | 'callDuration'
  | 'callType'
  | 'createdOn'
  | 'customerDisplayName'
  | 'customerPhoneNumber'
  | 'id'
  | 'isCallIntelligenceEligible'
  | 'placeName'
  | 'returnCallsRoutingOutcome'
  | 'staffDisplayName'
  | 'transcript'
  | CallRecordQLKeySpecifier
)[];
export type CallRecordQLFieldPolicy = {
  callDuration?: FieldPolicy<any> | FieldReadFunction<any>;
  callType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customerDisplayName?: FieldPolicy<any> | FieldReadFunction<any>;
  customerPhoneNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isCallIntelligenceEligible?: FieldPolicy<any> | FieldReadFunction<any>;
  placeName?: FieldPolicy<any> | FieldReadFunction<any>;
  returnCallsRoutingOutcome?: FieldPolicy<any> | FieldReadFunction<any>;
  staffDisplayName?: FieldPolicy<any> | FieldReadFunction<any>;
  transcript?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CallRecordingQLKeySpecifier = (
  | 'callRecordingSid'
  | 'confidence'
  | 'createdOn'
  | 'deepgramBlob'
  | 'dialog'
  | 'id'
  | 'lastUpdated'
  | 'numboxAgentSession'
  | 'operatorSession'
  | 'outboundConferenceCall'
  | 'outboundProxyCall'
  | 'pauseIntervals'
  | 'phonecall'
  | 'sizeBytes'
  | 'stereoUrl'
  | 'url'
  | CallRecordingQLKeySpecifier
)[];
export type CallRecordingQLFieldPolicy = {
  callRecordingSid?: FieldPolicy<any> | FieldReadFunction<any>;
  confidence?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  deepgramBlob?: FieldPolicy<any> | FieldReadFunction<any>;
  dialog?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  numboxAgentSession?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSession?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundConferenceCall?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundProxyCall?: FieldPolicy<any> | FieldReadFunction<any>;
  pauseIntervals?: FieldPolicy<any> | FieldReadFunction<any>;
  phonecall?: FieldPolicy<any> | FieldReadFunction<any>;
  sizeBytes?: FieldPolicy<any> | FieldReadFunction<any>;
  stereoUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CallRecordingStepQLKeySpecifier = (
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'disclosureContent'
  | 'disclosureContentUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'nextStepId'
  | 'nextStepRelationship'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'playDisclosureRecording'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'startRecording'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | CallRecordingStepQLKeySpecifier
)[];
export type CallRecordingStepQLFieldPolicy = {
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  disclosureContent?: FieldPolicy<any> | FieldReadFunction<any>;
  disclosureContentUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  playDisclosureRecording?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  startRecording?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CallRecordingStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | CallRecordingStepQLConnectionKeySpecifier
)[];
export type CallRecordingStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CallRecordingStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | CallRecordingStepQLEdgeKeySpecifier
)[];
export type CallRecordingStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CampaignAutomationQLKeySpecifier = (
  | 'id'
  | 'name'
  | CampaignAutomationQLKeySpecifier
)[];
export type CampaignAutomationQLFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CampaignPlaceQLKeySpecifier = (
  | 'id'
  | 'name'
  | CampaignPlaceQLKeySpecifier
)[];
export type CampaignPlaceQLFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CampaignQLKeySpecifier = (
  | 'automation'
  | 'automationId'
  | 'campaignSettings'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'place'
  | 'placeId'
  | 'settings'
  | 'status'
  | CampaignQLKeySpecifier
)[];
export type CampaignQLFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  campaignSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  settings?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CampaignSettingsQLKeySpecifier = (
  | 'campaign'
  | 'campaignId'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'maxEnrolement'
  | 'maxPerPeriod'
  | 'periodInDays'
  | CampaignSettingsQLKeySpecifier
)[];
export type CampaignSettingsQLFieldPolicy = {
  campaign?: FieldPolicy<any> | FieldReadFunction<any>;
  campaignId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  maxEnrolement?: FieldPolicy<any> | FieldReadFunction<any>;
  maxPerPeriod?: FieldPolicy<any> | FieldReadFunction<any>;
  periodInDays?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CancelPaymentRequestKeySpecifier = (
  | 'paymentRequest'
  | CancelPaymentRequestKeySpecifier
)[];
export type CancelPaymentRequestFieldPolicy = {
  paymentRequest?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CancelScheduledMessageKeySpecifier = (
  | 'scheduledMessage'
  | CancelScheduledMessageKeySpecifier
)[];
export type CancelScheduledMessageFieldPolicy = {
  scheduledMessage?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CapturePaymentAmountKeySpecifier = (
  | 'paymentRequest'
  | CapturePaymentAmountKeySpecifier
)[];
export type CapturePaymentAmountFieldPolicy = {
  paymentRequest?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CardInfoKeySpecifier = (
  | 'cardStatus'
  | 'last4'
  | 'type'
  | CardInfoKeySpecifier
)[];
export type CardInfoFieldPolicy = {
  cardStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  last4?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChangeAccountSubscriptionKeySpecifier = (
  | 'account'
  | ChangeAccountSubscriptionKeySpecifier
)[];
export type ChangeAccountSubscriptionFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChangeAllowCustomAudioKeySpecifier = (
  | 'place'
  | ChangeAllowCustomAudioKeySpecifier
)[];
export type ChangeAllowCustomAudioFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChangeBusinessVerticalKeySpecifier = (
  | 'account'
  | ChangeBusinessVerticalKeySpecifier
)[];
export type ChangeBusinessVerticalFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChangeConversationStateActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'desiredConversationState'
  | 'id'
  | 'lastUpdated'
  | 'nextActionId'
  | 'uiHints'
  | ChangeConversationStateActionQLKeySpecifier
)[];
export type ChangeConversationStateActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  desiredConversationState?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChangeInboxTypeKeySpecifier = (
  | 'place'
  | ChangeInboxTypeKeySpecifier
)[];
export type ChangeInboxTypeFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChangeNotificationSettingsKeySpecifier = (
  | 'currentUser'
  | ChangeNotificationSettingsKeySpecifier
)[];
export type ChangeNotificationSettingsFieldPolicy = {
  currentUser?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChangePlaceGroupKeySpecifier = (
  | 'place'
  | ChangePlaceGroupKeySpecifier
)[];
export type ChangePlaceGroupFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChangePlaceHoursKeySpecifier = (
  | 'success'
  | ChangePlaceHoursKeySpecifier
)[];
export type ChangePlaceHoursFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChangePlaceSubscriptionKeySpecifier = (
  | 'place'
  | ChangePlaceSubscriptionKeySpecifier
)[];
export type ChangePlaceSubscriptionFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChangeRepairOrderScheduleKeySpecifier = (
  | 'registeredFortellisServiceAdvisor'
  | ChangeRepairOrderScheduleKeySpecifier
)[];
export type ChangeRepairOrderScheduleFieldPolicy = {
  registeredFortellisServiceAdvisor?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChangeSignupModeKeySpecifier = (
  | 'account'
  | ChangeSignupModeKeySpecifier
)[];
export type ChangeSignupModeFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChangeSwipeActionSettingsKeySpecifier = (
  | 'currentUser'
  | ChangeSwipeActionSettingsKeySpecifier
)[];
export type ChangeSwipeActionSettingsFieldPolicy = {
  currentUser?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChangeTwilioChannelMDNKeySpecifier = (
  | 'channel'
  | ChangeTwilioChannelMDNKeySpecifier
)[];
export type ChangeTwilioChannelMDNFieldPolicy = {
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChangeUserPasswordKeySpecifier = (
  | 'currentUser'
  | ChangeUserPasswordKeySpecifier
)[];
export type ChangeUserPasswordFieldPolicy = {
  currentUser?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChangeUserSettingsKeySpecifier = (
  | 'user'
  | ChangeUserSettingsKeySpecifier
)[];
export type ChangeUserSettingsFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChangeUserVideoConferenceUrlKeySpecifier = (
  | 'currentUser'
  | ChangeUserVideoConferenceUrlKeySpecifier
)[];
export type ChangeUserVideoConferenceUrlFieldPolicy = {
  currentUser?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChannelKeySpecifier = (
  | 'account'
  | 'accountId'
  | 'assignee'
  | 'assigneeId'
  | 'channelType'
  | 'createdOn'
  | 'id'
  | 'identityPromptOption'
  | 'isActive'
  | 'isBotEnabled'
  | 'lastUpdated'
  | 'name'
  | 'place'
  | 'placeId'
  | 'respectExistingAssignments'
  | 'team'
  | 'teamId'
  | 'userId'
  | ChannelKeySpecifier
)[];
export type ChannelFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  assigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  channelType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptOption?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isBotEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  respectExistingAssignments?: FieldPolicy<any> | FieldReadFunction<any>;
  team?: FieldPolicy<any> | FieldReadFunction<any>;
  teamId?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ChargeBeeSubscriptionKeySpecifier = (
  | 'billingStatus'
  | 'cardInfo'
  | 'dueSince'
  | 'trialDaysLeft'
  | ChargeBeeSubscriptionKeySpecifier
)[];
export type ChargeBeeSubscriptionFieldPolicy = {
  billingStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  cardInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  dueSince?: FieldPolicy<any> | FieldReadFunction<any>;
  trialDaysLeft?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CheckBusinessHoursStepQLKeySpecifier = (
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onClosedStep'
  | 'onClosedStepId'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'onOpenStep'
  | 'onOpenStepId'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | CheckBusinessHoursStepQLKeySpecifier
)[];
export type CheckBusinessHoursStepQLFieldPolicy = {
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onClosedStep?: FieldPolicy<any> | FieldReadFunction<any>;
  onClosedStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onOpenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  onOpenStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CheckBusinessHoursStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | CheckBusinessHoursStepQLConnectionKeySpecifier
)[];
export type CheckBusinessHoursStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CheckBusinessHoursStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | CheckBusinessHoursStepQLEdgeKeySpecifier
)[];
export type CheckBusinessHoursStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CheckForLabelStepQLKeySpecifier = (
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'labelName'
  | 'lastUpdated'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onHasLabel'
  | 'onHasLabelId'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabel'
  | 'onMissingLabelId'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | CheckForLabelStepQLKeySpecifier
)[];
export type CheckForLabelStepQLFieldPolicy = {
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  labelName?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabel?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelId?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabel?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelId?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CheckForLabelStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | CheckForLabelStepQLConnectionKeySpecifier
)[];
export type CheckForLabelStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CheckForLabelStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | CheckForLabelStepQLEdgeKeySpecifier
)[];
export type CheckForLabelStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CheckOpportunityStatusActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'id'
  | 'lastUpdated'
  | 'nextActionId'
  | 'onNoActionId'
  | 'onYesActionId'
  | 'opportunity'
  | 'uiHints'
  | CheckOpportunityStatusActionQLKeySpecifier
)[];
export type CheckOpportunityStatusActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  opportunity?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CheckRepairOrderDetailsActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'id'
  | 'lastUpdated'
  | 'nextActionId'
  | 'rulesQuery'
  | 'uiHints'
  | CheckRepairOrderDetailsActionQLKeySpecifier
)[];
export type CheckRepairOrderDetailsActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  rulesQuery?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CloseStatusItemKeySpecifier = (
  | 'statusItem'
  | CloseStatusItemKeySpecifier
)[];
export type CloseStatusItemFieldPolicy = {
  statusItem?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompleteAutopilotKeySpecifier = (
  | 'autopilot'
  | CompleteAutopilotKeySpecifier
)[];
export type CompleteAutopilotFieldPolicy = {
  autopilot?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CompleteTaskKeySpecifier = ('task' | CompleteTaskKeySpecifier)[];
export type CompleteTaskFieldPolicy = {
  task?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ComplianceReminderKeySpecifier = (
  | 'guidelinesReminder'
  | ComplianceReminderKeySpecifier
)[];
export type ComplianceReminderFieldPolicy = {
  guidelinesReminder?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ComplianceSettingsQLKeySpecifier = (
  | 'account'
  | 'accountId'
  | 'createdOn'
  | 'detailedGuidelines'
  | 'doubleOptInPrompt'
  | 'guidelinesReminder'
  | 'id'
  | 'lastUpdated'
  | 'onCompose'
  | 'onHangup'
  | 'onRevivedConversations'
  | 'onVoicemail'
  | 'ongoingOptOutInstructions'
  | 'optOutConfirmation'
  | 'optOutInstructions'
  | 'optOutResubscribe'
  | 'requireDoubleOptIn'
  | 'requireExplicitOptIn'
  | 'sendOptOutInstructions'
  | 'suppressOptOutInstructions'
  | ComplianceSettingsQLKeySpecifier
)[];
export type ComplianceSettingsQLFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  detailedGuidelines?: FieldPolicy<any> | FieldReadFunction<any>;
  doubleOptInPrompt?: FieldPolicy<any> | FieldReadFunction<any>;
  guidelinesReminder?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  onCompose?: FieldPolicy<any> | FieldReadFunction<any>;
  onHangup?: FieldPolicy<any> | FieldReadFunction<any>;
  onRevivedConversations?: FieldPolicy<any> | FieldReadFunction<any>;
  onVoicemail?: FieldPolicy<any> | FieldReadFunction<any>;
  ongoingOptOutInstructions?: FieldPolicy<any> | FieldReadFunction<any>;
  optOutConfirmation?: FieldPolicy<any> | FieldReadFunction<any>;
  optOutInstructions?: FieldPolicy<any> | FieldReadFunction<any>;
  optOutResubscribe?: FieldPolicy<any> | FieldReadFunction<any>;
  requireDoubleOptIn?: FieldPolicy<any> | FieldReadFunction<any>;
  requireExplicitOptIn?: FieldPolicy<any> | FieldReadFunction<any>;
  sendOptOutInstructions?: FieldPolicy<any> | FieldReadFunction<any>;
  suppressOptOutInstructions?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConnectAutomationActionKeySpecifier = (
  | 'automation'
  | ConnectAutomationActionKeySpecifier
)[];
export type ConnectAutomationActionFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConnectAutomationActionEdgeKeySpecifier = (
  | 'automation'
  | ConnectAutomationActionEdgeKeySpecifier
)[];
export type ConnectAutomationActionEdgeFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ContentSummaryQLKeySpecifier = (
  | 'contentTypes'
  | 'totalRecords'
  | ContentSummaryQLKeySpecifier
)[];
export type ContentSummaryQLFieldPolicy = {
  contentTypes?: FieldPolicy<any> | FieldReadFunction<any>;
  totalRecords?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ContentTypesQLKeySpecifier = (
  | 'recordsWithMakeModel'
  | 'recordsWithPhone'
  | 'recordsWithVin'
  | ContentTypesQLKeySpecifier
)[];
export type ContentTypesQLFieldPolicy = {
  recordsWithMakeModel?: FieldPolicy<any> | FieldReadFunction<any>;
  recordsWithPhone?: FieldPolicy<any> | FieldReadFunction<any>;
  recordsWithVin?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationArchivedTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'daysSinceInbound'
  | 'daysSinceOutbound'
  | 'id'
  | 'includeActiveConversations'
  | 'includeClosedByNuma'
  | 'lastUpdated'
  | 'triggerType'
  | 'uiHints'
  | ConversationArchivedTriggerQLKeySpecifier
)[];
export type ConversationArchivedTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  daysSinceInbound?: FieldPolicy<any> | FieldReadFunction<any>;
  daysSinceOutbound?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  includeActiveConversations?: FieldPolicy<any> | FieldReadFunction<any>;
  includeClosedByNuma?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationBreakdownEntryQLKeySpecifier = (
  | 'conversationId'
  | 'customerInformation'
  | 'firstStarted'
  | 'hasEarlyExit'
  | 'jobCount'
  | 'lastUpdated'
  | 'statuses'
  | ConversationBreakdownEntryQLKeySpecifier
)[];
export type ConversationBreakdownEntryQLFieldPolicy = {
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  customerInformation?: FieldPolicy<any> | FieldReadFunction<any>;
  firstStarted?: FieldPolicy<any> | FieldReadFunction<any>;
  hasEarlyExit?: FieldPolicy<any> | FieldReadFunction<any>;
  jobCount?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  statuses?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | 'totalCount'
  | ConversationConnectionKeySpecifier
)[];
export type ConversationConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | ConversationEdgeKeySpecifier
)[];
export type ConversationEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationLabelQLKeySpecifier = (
  | 'conversation'
  | 'conversationId'
  | 'createdOn'
  | 'expiresAt'
  | 'hidden'
  | 'id'
  | 'label'
  | 'labelId'
  | 'lastUpdated'
  | 'participant'
  | 'participantId'
  | ConversationLabelQLKeySpecifier
)[];
export type ConversationLabelQLFieldPolicy = {
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  expiresAt?: FieldPolicy<any> | FieldReadFunction<any>;
  hidden?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelId?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  participantId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationLabelQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | ConversationLabelQLConnectionKeySpecifier
)[];
export type ConversationLabelQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationLabelQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | ConversationLabelQLEdgeKeySpecifier
)[];
export type ConversationLabelQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationMarkedAsHeatCaseTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'triggerType'
  | 'uiHints'
  | ConversationMarkedAsHeatCaseTriggerQLKeySpecifier
)[];
export type ConversationMarkedAsHeatCaseTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationPreviewContentQLKeySpecifier = (
  | 'preview'
  | 'previewDisplayName'
  | 'previewFormat'
  | 'previewIsInbound'
  | 'previewMentions'
  | 'previewServerGenerated'
  | 'previewSource'
  | 'subPreview'
  | 'subPreviewDisplayName'
  | 'subPreviewFormat'
  | 'subPreviewMentions'
  | ConversationPreviewContentQLKeySpecifier
)[];
export type ConversationPreviewContentQLFieldPolicy = {
  preview?: FieldPolicy<any> | FieldReadFunction<any>;
  previewDisplayName?: FieldPolicy<any> | FieldReadFunction<any>;
  previewFormat?: FieldPolicy<any> | FieldReadFunction<any>;
  previewIsInbound?: FieldPolicy<any> | FieldReadFunction<any>;
  previewMentions?: FieldPolicy<any> | FieldReadFunction<any>;
  previewServerGenerated?: FieldPolicy<any> | FieldReadFunction<any>;
  previewSource?: FieldPolicy<any> | FieldReadFunction<any>;
  subPreview?: FieldPolicy<any> | FieldReadFunction<any>;
  subPreviewDisplayName?: FieldPolicy<any> | FieldReadFunction<any>;
  subPreviewFormat?: FieldPolicy<any> | FieldReadFunction<any>;
  subPreviewMentions?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationQLKeySpecifier = (
  | 'allMessagesArchived'
  | 'allMessagesDeleted'
  | 'amIMentioned'
  | 'appointments'
  | 'assignee'
  | 'assigneeId'
  | 'automationJobs'
  | 'autopilots'
  | 'conversationLabels'
  | 'conversationState'
  | 'conversationTags'
  | 'createdOn'
  | 'customer'
  | 'customerId'
  | 'customerWaiting'
  | 'dialogFlowBotDatas'
  | 'engagements'
  | 'escalated'
  | 'firstChannel'
  | 'firstChannelId'
  | 'firstMessageTimestamp'
  | 'hasRecentHeatCase'
  | 'id'
  | 'inbox'
  | 'inboxId'
  | 'isMentionedConversation'
  | 'isNextOutboundMessageSigned'
  | 'isOverdue'
  | 'language'
  | 'lastAppointment'
  | 'lastChannel'
  | 'lastEngagement'
  | 'lastInboundMessage'
  | 'lastMentionedTimestamp'
  | 'lastMessage'
  | 'lastOrder'
  | 'lastRepairOrder'
  | 'lastUpdated'
  | 'mentionedDisplayName'
  | 'mentionedPreview'
  | 'mentions'
  | 'messages'
  | 'nudged'
  | 'optInStatus'
  | 'outboundConferenceCalls'
  | 'outboundProxyCalls'
  | 'participant'
  | 'paymentRequests'
  | 'place'
  | 'placeId'
  | 'preview'
  | 'previewData'
  | 'repairOrderSmartStatusUpdateSettings'
  | 'repairOrders'
  | 'requestedOptIn'
  | 'serverGeneratedPreview'
  | 'snoozedUntil'
  | 'source'
  | 'state'
  | 'team'
  | 'teamId'
  | 'transcripts'
  | 'unreadCount'
  | 'waitingSince'
  | ConversationQLKeySpecifier
)[];
export type ConversationQLFieldPolicy = {
  allMessagesArchived?: FieldPolicy<any> | FieldReadFunction<any>;
  allMessagesDeleted?: FieldPolicy<any> | FieldReadFunction<any>;
  amIMentioned?: FieldPolicy<any> | FieldReadFunction<any>;
  appointments?: FieldPolicy<any> | FieldReadFunction<any>;
  assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  assigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  automationJobs?: FieldPolicy<any> | FieldReadFunction<any>;
  autopilots?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationLabels?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationState?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationTags?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customer?: FieldPolicy<any> | FieldReadFunction<any>;
  customerId?: FieldPolicy<any> | FieldReadFunction<any>;
  customerWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  dialogFlowBotDatas?: FieldPolicy<any> | FieldReadFunction<any>;
  engagements?: FieldPolicy<any> | FieldReadFunction<any>;
  escalated?: FieldPolicy<any> | FieldReadFunction<any>;
  firstChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  firstChannelId?: FieldPolicy<any> | FieldReadFunction<any>;
  firstMessageTimestamp?: FieldPolicy<any> | FieldReadFunction<any>;
  hasRecentHeatCase?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  inbox?: FieldPolicy<any> | FieldReadFunction<any>;
  inboxId?: FieldPolicy<any> | FieldReadFunction<any>;
  isMentionedConversation?: FieldPolicy<any> | FieldReadFunction<any>;
  isNextOutboundMessageSigned?: FieldPolicy<any> | FieldReadFunction<any>;
  isOverdue?: FieldPolicy<any> | FieldReadFunction<any>;
  language?: FieldPolicy<any> | FieldReadFunction<any>;
  lastAppointment?: FieldPolicy<any> | FieldReadFunction<any>;
  lastChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  lastEngagement?: FieldPolicy<any> | FieldReadFunction<any>;
  lastInboundMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  lastMentionedTimestamp?: FieldPolicy<any> | FieldReadFunction<any>;
  lastMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  lastOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  lastRepairOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  mentionedDisplayName?: FieldPolicy<any> | FieldReadFunction<any>;
  mentionedPreview?: FieldPolicy<any> | FieldReadFunction<any>;
  mentions?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  nudged?: FieldPolicy<any> | FieldReadFunction<any>;
  optInStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundConferenceCalls?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundProxyCalls?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentRequests?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  preview?: FieldPolicy<any> | FieldReadFunction<any>;
  previewData?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderSmartStatusUpdateSettings?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  repairOrders?: FieldPolicy<any> | FieldReadFunction<any>;
  requestedOptIn?: FieldPolicy<any> | FieldReadFunction<any>;
  serverGeneratedPreview?: FieldPolicy<any> | FieldReadFunction<any>;
  snoozedUntil?: FieldPolicy<any> | FieldReadFunction<any>;
  source?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  team?: FieldPolicy<any> | FieldReadFunction<any>;
  teamId?: FieldPolicy<any> | FieldReadFunction<any>;
  transcripts?: FieldPolicy<any> | FieldReadFunction<any>;
  unreadCount?: FieldPolicy<any> | FieldReadFunction<any>;
  waitingSince?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | ConversationQLConnectionKeySpecifier
)[];
export type ConversationQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | ConversationQLEdgeKeySpecifier
)[];
export type ConversationQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationRepairOrderSmartStatusUpdateSettingsQLKeySpecifier = (
  | 'conversation'
  | 'conversationId'
  | 'createdOn'
  | 'customInstructions'
  | 'id'
  | 'isEnabled'
  | 'lastUpdated'
  | ConversationRepairOrderSmartStatusUpdateSettingsQLKeySpecifier
)[];
export type ConversationRepairOrderSmartStatusUpdateSettingsQLFieldPolicy = {
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customInstructions?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationStartedTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'triggerType'
  | 'uiHints'
  | ConversationStartedTriggerQLKeySpecifier
)[];
export type ConversationStartedTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationStateStepQLKeySpecifier = (
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'desiredConversationState'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'nextStepId'
  | 'nextStepRelationship'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | ConversationStateStepQLKeySpecifier
)[];
export type ConversationStateStepQLFieldPolicy = {
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  desiredConversationState?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationStateStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | ConversationStateStepQLConnectionKeySpecifier
)[];
export type ConversationStateStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationStateStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | ConversationStateStepQLEdgeKeySpecifier
)[];
export type ConversationStateStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationStatsQLKeySpecifier = (
  | 'inboundInInbox'
  | 'numaHidAMessage'
  | ConversationStatsQLKeySpecifier
)[];
export type ConversationStatsQLFieldPolicy = {
  inboundInInbox?: FieldPolicy<any> | FieldReadFunction<any>;
  numaHidAMessage?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationTagQLKeySpecifier = (
  | 'createdOn'
  | 'expiresAt'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | ConversationTagQLKeySpecifier
)[];
export type ConversationTagQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  expiresAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationalSchedulingAgentStepQlKeySpecifier = (
  | 'appointmentAgentSettings'
  | 'appointmentAgentSettingsId'
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'appointmentLeadStepId'
  | 'appointmentLeadStepRelationship'
  | 'autoAssignSteps'
  | 'bookedSpeech'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'confirmIntentSpeech'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'failureStepId'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSpeech'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'humanEscalationSpeech'
  | 'humanEscalationStepId'
  | 'humanEscalationStepRelationship'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'leadSpeech'
  | 'nextStepId'
  | 'nextStepRelationship'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'numboxAgentSessions'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'shouldConfirmIntent'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'unserviceableSpeech'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | ConversationalSchedulingAgentStepQlKeySpecifier
)[];
export type ConversationalSchedulingAgentStepQlFieldPolicy = {
  appointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSettingsId?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  appointmentLeadStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  bookedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  confirmIntentSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  humanEscalationSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  leadSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  numboxAgentSessions?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  shouldConfirmIntent?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  unserviceableSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationalSchedulingAgentStepQlConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | ConversationalSchedulingAgentStepQlConnectionKeySpecifier
)[];
export type ConversationalSchedulingAgentStepQlConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConversationalSchedulingAgentStepQlEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | ConversationalSchedulingAgentStepQlEdgeKeySpecifier
)[];
export type ConversationalSchedulingAgentStepQlEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateA2PCampaignForPlaceKeySpecifier = (
  | 'tenDlcProcess'
  | CreateA2PCampaignForPlaceKeySpecifier
)[];
export type CreateA2PCampaignForPlaceFieldPolicy = {
  tenDlcProcess?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateAgentChitChatKeySpecifier = (
  | 'chitchat'
  | CreateAgentChitChatKeySpecifier
)[];
export type CreateAgentChitChatFieldPolicy = {
  chitchat?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateAppointmentAgentSettingLabelKeySpecifier = (
  | 'appointmentAgentSetting'
  | 'category'
  | 'id'
  | 'label'
  | CreateAppointmentAgentSettingLabelKeySpecifier
)[];
export type CreateAppointmentAgentSettingLabelFieldPolicy = {
  appointmentAgentSetting?: FieldPolicy<any> | FieldReadFunction<any>;
  category?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateAppointmentAgentSettingsKeySpecifier = (
  | 'appointmentAgentSettings'
  | CreateAppointmentAgentSettingsKeySpecifier
)[];
export type CreateAppointmentAgentSettingsFieldPolicy = {
  appointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateAutomationKeySpecifier = (
  | 'automation'
  | CreateAutomationKeySpecifier
)[];
export type CreateAutomationFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateAutomationActionKeySpecifier = (
  | 'automation'
  | CreateAutomationActionKeySpecifier
)[];
export type CreateAutomationActionFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateAutomationFromBlueprintKeySpecifier = (
  | 'automation'
  | CreateAutomationFromBlueprintKeySpecifier
)[];
export type CreateAutomationFromBlueprintFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateAutopilotKeySpecifier = (
  | 'autopilot'
  | CreateAutopilotKeySpecifier
)[];
export type CreateAutopilotFieldPolicy = {
  autopilot?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateBillingIdentityKeySpecifier = (
  | 'billingIdentity'
  | CreateBillingIdentityKeySpecifier
)[];
export type CreateBillingIdentityFieldPolicy = {
  billingIdentity?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateCampaignKeySpecifier = (
  | 'result'
  | CreateCampaignKeySpecifier
)[];
export type CreateCampaignFieldPolicy = {
  result?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateCampaignResultKeySpecifier = (
  | 'message'
  | 'success'
  | CreateCampaignResultKeySpecifier
)[];
export type CreateCampaignResultFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateChatExpansionKeySpecifier = (
  | 'textExpansion'
  | CreateChatExpansionKeySpecifier
)[];
export type CreateChatExpansionFieldPolicy = {
  textExpansion?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateConversationKeySpecifier = (
  | 'conversation'
  | CreateConversationKeySpecifier
)[];
export type CreateConversationFieldPolicy = {
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateConversationSummaryKeySpecifier = (
  | 'textSummary'
  | CreateConversationSummaryKeySpecifier
)[];
export type CreateConversationSummaryFieldPolicy = {
  textSummary?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateConversationTextExpansionKeySpecifier = (
  | 'textExpansion'
  | CreateConversationTextExpansionKeySpecifier
)[];
export type CreateConversationTextExpansionFieldPolicy = {
  textExpansion?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateCustomDirectoryEntryKeySpecifier = (
  | 'directoryEntry'
  | CreateCustomDirectoryEntryKeySpecifier
)[];
export type CreateCustomDirectoryEntryFieldPolicy = {
  directoryEntry?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateDepartmentDeviceKeySpecifier = (
  | 'device'
  | CreateDepartmentDeviceKeySpecifier
)[];
export type CreateDepartmentDeviceFieldPolicy = {
  device?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateIdentityPromptAddressKeySpecifier = (
  | 'identityPromptAddress'
  | CreateIdentityPromptAddressKeySpecifier
)[];
export type CreateIdentityPromptAddressFieldPolicy = {
  identityPromptAddress?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateLabelKeySpecifier = ('label' | CreateLabelKeySpecifier)[];
export type CreateLabelFieldPolicy = {
  label?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateManualCampaignUploadKeySpecifier = (
  | 'result'
  | CreateManualCampaignUploadKeySpecifier
)[];
export type CreateManualCampaignUploadFieldPolicy = {
  result?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateManualCampaignUploadResultKeySpecifier = (
  | 'message'
  | 'success'
  | CreateManualCampaignUploadResultKeySpecifier
)[];
export type CreateManualCampaignUploadResultFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateNoteTakerKeySpecifier = (
  | 'noteTaker'
  | CreateNoteTakerKeySpecifier
)[];
export type CreateNoteTakerFieldPolicy = {
  noteTaker?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateOperatorKeySpecifier = (
  | 'operator'
  | CreateOperatorKeySpecifier
)[];
export type CreateOperatorFieldPolicy = {
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateOutboundConferenceCallKeySpecifier = (
  | 'outboundConferenceCall'
  | CreateOutboundConferenceCallKeySpecifier
)[];
export type CreateOutboundConferenceCallFieldPolicy = {
  outboundConferenceCall?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateOutboundProxyCallKeySpecifier = (
  | 'outboundProxyCall'
  | CreateOutboundProxyCallKeySpecifier
)[];
export type CreateOutboundProxyCallFieldPolicy = {
  outboundProxyCall?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateParticipantKeySpecifier = (
  | 'participant'
  | CreateParticipantKeySpecifier
)[];
export type CreateParticipantFieldPolicy = {
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateParticipantPaymentRequestKeySpecifier = (
  | 'paymentRequest'
  | CreateParticipantPaymentRequestKeySpecifier
)[];
export type CreateParticipantPaymentRequestFieldPolicy = {
  paymentRequest?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreatePaymentRequestKeySpecifier = (
  | 'paymentRequest'
  | CreatePaymentRequestKeySpecifier
)[];
export type CreatePaymentRequestFieldPolicy = {
  paymentRequest?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreatePhoneLineKeySpecifier = (
  | 'phoneline'
  | CreatePhoneLineKeySpecifier
)[];
export type CreatePhoneLineFieldPolicy = {
  phoneline?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreatePlaceKeySpecifier = ('place' | CreatePlaceKeySpecifier)[];
export type CreatePlaceFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreatePortalSessionKeySpecifier = (
  | 'portalSession'
  | CreatePortalSessionKeySpecifier
)[];
export type CreatePortalSessionFieldPolicy = {
  portalSession?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateScheduledMessageKeySpecifier = (
  | 'scheduledMessage'
  | CreateScheduledMessageKeySpecifier
)[];
export type CreateScheduledMessageFieldPolicy = {
  scheduledMessage?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateShortcutKeySpecifier = (
  | 'shortcut'
  | CreateShortcutKeySpecifier
)[];
export type CreateShortcutFieldPolicy = {
  shortcut?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateStripeAccountKeySpecifier = (
  | 'accountLinkUrl'
  | 'refreshUrl'
  | 'returnUrl'
  | CreateStripeAccountKeySpecifier
)[];
export type CreateStripeAccountFieldPolicy = {
  accountLinkUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  refreshUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  returnUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateStripeRefundKeySpecifier = (
  | 'paymentRequest'
  | CreateStripeRefundKeySpecifier
)[];
export type CreateStripeRefundFieldPolicy = {
  paymentRequest?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateTaskForEngagementKeySpecifier = (
  | 'engagement'
  | 'task'
  | CreateTaskForEngagementKeySpecifier
)[];
export type CreateTaskForEngagementFieldPolicy = {
  engagement?: FieldPolicy<any> | FieldReadFunction<any>;
  task?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateTeamKeySpecifier = ('team' | CreateTeamKeySpecifier)[];
export type CreateTeamFieldPolicy = {
  team?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateTextExpansionKeySpecifier = (
  | 'textExpansion'
  | CreateTextExpansionKeySpecifier
)[];
export type CreateTextExpansionFieldPolicy = {
  textExpansion?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateUserKeySpecifier = (
  | 'phoneline'
  | 'user'
  | CreateUserKeySpecifier
)[];
export type CreateUserFieldPolicy = {
  phoneline?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateUserPhoneKeySpecifier = (
  | 'userPhone'
  | CreateUserPhoneKeySpecifier
)[];
export type CreateUserPhoneFieldPolicy = {
  userPhone?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateVideoUploadLinkKeySpecifier = (
  | 'videoUploadLink'
  | CreateVideoUploadLinkKeySpecifier
)[];
export type CreateVideoUploadLinkFieldPolicy = {
  videoUploadLink?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CrmContactCdkQLKeySpecifier = (
  | 'companyName'
  | 'contactType'
  | 'createdOn'
  | 'customerId'
  | 'data'
  | 'email'
  | 'firstName'
  | 'id'
  | 'lastName'
  | 'lastUpdated'
  | 'participant'
  | 'participantId'
  | 'phoneNumber'
  | CrmContactCdkQLKeySpecifier
)[];
export type CrmContactCdkQLFieldPolicy = {
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  contactType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customerId?: FieldPolicy<any> | FieldReadFunction<any>;
  data?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  participantId?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CrmContactCnamQLKeySpecifier = (
  | 'contactType'
  | 'createdOn'
  | 'customerId'
  | 'data'
  | 'firstName'
  | 'id'
  | 'lastName'
  | 'lastUpdated'
  | 'participant'
  | 'participantId'
  | CrmContactCnamQLKeySpecifier
)[];
export type CrmContactCnamQLFieldPolicy = {
  contactType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customerId?: FieldPolicy<any> | FieldReadFunction<any>;
  data?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  participantId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CrmContactDealertrackQLKeySpecifier = (
  | 'companyName'
  | 'contactType'
  | 'createdOn'
  | 'customerId'
  | 'data'
  | 'email'
  | 'firstName'
  | 'id'
  | 'lastName'
  | 'lastUpdated'
  | 'participant'
  | 'participantId'
  | 'phoneNumber'
  | CrmContactDealertrackQLKeySpecifier
)[];
export type CrmContactDealertrackQLFieldPolicy = {
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  contactType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customerId?: FieldPolicy<any> | FieldReadFunction<any>;
  data?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  participantId?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CrmContactFortellisQLKeySpecifier = (
  | 'companyName'
  | 'contactType'
  | 'createdOn'
  | 'customerId'
  | 'data'
  | 'email'
  | 'firstName'
  | 'id'
  | 'lastName'
  | 'lastUpdated'
  | 'participant'
  | 'participantId'
  | 'phoneNumber'
  | CrmContactFortellisQLKeySpecifier
)[];
export type CrmContactFortellisQLFieldPolicy = {
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  contactType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customerId?: FieldPolicy<any> | FieldReadFunction<any>;
  data?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  participantId?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CrmContactQLKeySpecifier = (
  | 'companyName'
  | 'contactType'
  | 'createdOn'
  | 'customerId'
  | 'data'
  | 'email'
  | 'firstName'
  | 'id'
  | 'lastName'
  | 'lastUpdated'
  | 'participant'
  | 'participantId'
  | 'phoneNumber'
  | CrmContactQLKeySpecifier
)[];
export type CrmContactQLFieldPolicy = {
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  contactType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customerId?: FieldPolicy<any> | FieldReadFunction<any>;
  data?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  participantId?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CrmUserModelQLKeySpecifier = (
  | 'createdOn'
  | 'data'
  | 'externalCrmUserId'
  | 'externalTenantId'
  | 'firstName'
  | 'id'
  | 'integrationInternalType'
  | 'lastName'
  | 'lastUpdated'
  | 'user'
  | 'userId'
  | CrmUserModelQLKeySpecifier
)[];
export type CrmUserModelQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  data?: FieldPolicy<any> | FieldReadFunction<any>;
  externalCrmUserId?: FieldPolicy<any> | FieldReadFunction<any>;
  externalTenantId?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  integrationInternalType?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CrmUserModelQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | CrmUserModelQLConnectionKeySpecifier
)[];
export type CrmUserModelQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CrmUserModelQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | CrmUserModelQLEdgeKeySpecifier
)[];
export type CrmUserModelQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CubeJwtTokenQLKeySpecifier = (
  | 'cubeApiHost'
  | 'cubeJwtToken'
  | CubeJwtTokenQLKeySpecifier
)[];
export type CubeJwtTokenQLFieldPolicy = {
  cubeApiHost?: FieldPolicy<any> | FieldReadFunction<any>;
  cubeJwtToken?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CurbsideSettingsQLKeySpecifier = (
  | 'createdOn'
  | 'customHandoffIsAutoreply'
  | 'customHandoffMethod'
  | 'customHereIsAutoreply'
  | 'customOrderIdentifier'
  | 'enabled'
  | 'handoffMethod'
  | 'handoffMethodIntentResponse'
  | 'id'
  | 'lastUpdated'
  | 'orderIdentifierIntentResponse'
  | 'orderIdentifierType'
  | 'pickupPattern'
  | 'place'
  | 'placeId'
  | CurbsideSettingsQLKeySpecifier
)[];
export type CurbsideSettingsQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customHandoffIsAutoreply?: FieldPolicy<any> | FieldReadFunction<any>;
  customHandoffMethod?: FieldPolicy<any> | FieldReadFunction<any>;
  customHereIsAutoreply?: FieldPolicy<any> | FieldReadFunction<any>;
  customOrderIdentifier?: FieldPolicy<any> | FieldReadFunction<any>;
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
  handoffMethod?: FieldPolicy<any> | FieldReadFunction<any>;
  handoffMethodIntentResponse?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  orderIdentifierIntentResponse?: FieldPolicy<any> | FieldReadFunction<any>;
  orderIdentifierType?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupPattern?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomAudioOverridesKeySpecifier = (
  | 'acknowledgementSpeech'
  | 'afterHoursSpeech'
  | 'canWeTextSpeech'
  | 'clarifyCanWeTextSpeech'
  | 'clarifySpeech'
  | 'disclosureContent'
  | 'finishedSpeech'
  | 'noAnswerSpeech'
  | 'onFailCanWeTextSpeech'
  | 'onFailureSpeech'
  | 'onNoCanWeTextSpeech'
  | 'onNoSpeech'
  | 'onYesCanWeTextSpeech'
  | 'onYesSpeech'
  | 'speech'
  | CustomAudioOverridesKeySpecifier
)[];
export type CustomAudioOverridesFieldPolicy = {
  acknowledgementSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  afterHoursSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  canWeTextSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  clarifyCanWeTextSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  clarifySpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  disclosureContent?: FieldPolicy<any> | FieldReadFunction<any>;
  finishedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  noAnswerSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onFailCanWeTextSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onFailureSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoCanWeTextSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesCanWeTextSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomDirectoryEntryModelQLKeySpecifier = (
  | 'createdOn'
  | 'directoryEntries'
  | 'id'
  | 'lastUpdated'
  | 'mdn'
  | 'name'
  | 'sip'
  | CustomDirectoryEntryModelQLKeySpecifier
)[];
export type CustomDirectoryEntryModelQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  directoryEntries?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  mdn?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  sip?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomDirectoryEntryQLKeySpecifier = (
  | 'createdOn'
  | 'customDirectoryEntry'
  | 'customDirectoryEntryId'
  | 'department'
  | 'departmentId'
  | 'description'
  | 'devices'
  | 'displayName'
  | 'entryType'
  | 'id'
  | 'isDiscoverable'
  | 'lastUpdated'
  | 'placeGroup'
  | 'placeGroupId'
  | 'user'
  | 'userId'
  | CustomDirectoryEntryQLKeySpecifier
)[];
export type CustomDirectoryEntryQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customDirectoryEntry?: FieldPolicy<any> | FieldReadFunction<any>;
  customDirectoryEntryId?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  departmentId?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  devices?: FieldPolicy<any> | FieldReadFunction<any>;
  displayName?: FieldPolicy<any> | FieldReadFunction<any>;
  entryType?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isDiscoverable?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  placeGroup?: FieldPolicy<any> | FieldReadFunction<any>;
  placeGroupId?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomDisclosureSpeechKeySpecifier = (
  | 'data'
  | 'filename'
  | CustomDisclosureSpeechKeySpecifier
)[];
export type CustomDisclosureSpeechFieldPolicy = {
  data?: FieldPolicy<any> | FieldReadFunction<any>;
  filename?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomOutboundCallAudioOverridesKeySpecifier = (
  | 'disclosureSpeech'
  | 'hostNoAnswerSpeech'
  | 'voicemailSpeech'
  | CustomOutboundCallAudioOverridesKeySpecifier
)[];
export type CustomOutboundCallAudioOverridesFieldPolicy = {
  disclosureSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  hostNoAnswerSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  voicemailSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomerContactedTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'customerContactType'
  | 'id'
  | 'lastUpdated'
  | 'triggerType'
  | 'uiHints'
  | CustomerContactedTriggerQLKeySpecifier
)[];
export type CustomerContactedTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customerContactType?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomerQLKeySpecifier = (
  | 'account'
  | 'accountId'
  | 'activeIntegration'
  | 'activeIntegrationId'
  | 'addresses'
  | 'appointments'
  | 'createdOn'
  | 'displayName'
  | 'duplicates'
  | 'externalCustomerId'
  | 'externalCustomerSource'
  | 'firstName'
  | 'id'
  | 'lastAppointment'
  | 'lastName'
  | 'lastRepairOrder'
  | 'lastUpdated'
  | 'participants'
  | 'placeGroup'
  | 'placeGroupId'
  | 'repairOrders'
  | 'salutation'
  | 'status'
  | 'statusItems'
  | CustomerQLKeySpecifier
)[];
export type CustomerQLFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  addresses?: FieldPolicy<any> | FieldReadFunction<any>;
  appointments?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  displayName?: FieldPolicy<any> | FieldReadFunction<any>;
  duplicates?: FieldPolicy<any> | FieldReadFunction<any>;
  externalCustomerId?: FieldPolicy<any> | FieldReadFunction<any>;
  externalCustomerSource?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastAppointment?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  lastRepairOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  participants?: FieldPolicy<any> | FieldReadFunction<any>;
  placeGroup?: FieldPolicy<any> | FieldReadFunction<any>;
  placeGroupId?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrders?: FieldPolicy<any> | FieldReadFunction<any>;
  salutation?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  statusItems?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomerQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | CustomerQLConnectionKeySpecifier
)[];
export type CustomerQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomerQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | CustomerQLEdgeKeySpecifier
)[];
export type CustomerQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizedIntentQLKeySpecifier = (
  | 'first'
  | 'intents'
  | 'placeId'
  | 'total'
  | CustomizedIntentQLKeySpecifier
)[];
export type CustomizedIntentQLFieldPolicy = {
  first?: FieldPolicy<any> | FieldReadFunction<any>;
  intents?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  total?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DMSHistoryConnectionKeySpecifier = (
  | 'edges'
  | 'lastData'
  | 'pageInfo'
  | DMSHistoryConnectionKeySpecifier
)[];
export type DMSHistoryConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  lastData?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DMSHistoryEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | DMSHistoryEdgeKeySpecifier
)[];
export type DMSHistoryEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DMSHistoryQLKeySpecifier = (
  | 'createdOn'
  | 'dmsHistoryType'
  | 'id'
  | 'lastUpdated'
  | DMSHistoryQLKeySpecifier
)[];
export type DMSHistoryQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  dmsHistoryType?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeactivateAccountKeySpecifier = (
  | 'account'
  | DeactivateAccountKeySpecifier
)[];
export type DeactivateAccountFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DealerTrackServiceAdvisorQLKeySpecifier = (
  | 'activeIntegration'
  | 'activeIntegrationId'
  | 'createdOn'
  | 'fortellisSubscription'
  | 'fortellisSubscriptionId'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'nextFetchTime'
  | 'placeId'
  | 'placesUser'
  | 'placesUsersId'
  | 'rawData'
  | 'repairOrderSchedule'
  | 'serviceAdvisorId'
  | 'serviceAdvisorName'
  | 'type'
  | 'user'
  | 'userId'
  | DealerTrackServiceAdvisorQLKeySpecifier
)[];
export type DealerTrackServiceAdvisorQLFieldPolicy = {
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisSubscriptionId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  nextFetchTime?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  placesUser?: FieldPolicy<any> | FieldReadFunction<any>;
  placesUsersId?: FieldPolicy<any> | FieldReadFunction<any>;
  rawData?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderSchedule?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisorId?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisorName?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DefaultBroadcastInputsQLKeySpecifier = (
  | 'channelId'
  | 'participantAddresses'
  | 'placeId'
  | DefaultBroadcastInputsQLKeySpecifier
)[];
export type DefaultBroadcastInputsQLFieldPolicy = {
  channelId?: FieldPolicy<any> | FieldReadFunction<any>;
  participantAddresses?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteAppointmentAgentSettingLabelKeySpecifier = (
  | 'id'
  | DeleteAppointmentAgentSettingLabelKeySpecifier
)[];
export type DeleteAppointmentAgentSettingLabelFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteAppointmentAgentSettingsKeySpecifier = (
  | 'appointmentAgentSettings'
  | DeleteAppointmentAgentSettingsKeySpecifier
)[];
export type DeleteAppointmentAgentSettingsFieldPolicy = {
  appointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteAutomationKeySpecifier = (
  | 'automation'
  | DeleteAutomationKeySpecifier
)[];
export type DeleteAutomationFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteConversationKeySpecifier = (
  | 'conversation'
  | DeleteConversationKeySpecifier
)[];
export type DeleteConversationFieldPolicy = {
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteCustomDirectoryEntryKeySpecifier = (
  | 'message'
  | 'success'
  | DeleteCustomDirectoryEntryKeySpecifier
)[];
export type DeleteCustomDirectoryEntryFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteCustomLinkKeySpecifier = (
  | 'placeInfo'
  | DeleteCustomLinkKeySpecifier
)[];
export type DeleteCustomLinkFieldPolicy = {
  placeInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteDepartmentDeviceKeySpecifier = (
  | 'message'
  | 'success'
  | DeleteDepartmentDeviceKeySpecifier
)[];
export type DeleteDepartmentDeviceFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteIdentityPromptAddressKeySpecifier = (
  | 'identityPromptAddress'
  | DeleteIdentityPromptAddressKeySpecifier
)[];
export type DeleteIdentityPromptAddressFieldPolicy = {
  identityPromptAddress?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteNoteTakerKeySpecifier = (
  | 'id'
  | 'message'
  | DeleteNoteTakerKeySpecifier
)[];
export type DeleteNoteTakerFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteOutboundCallCustomizationKeySpecifier = (
  | 'success'
  | DeleteOutboundCallCustomizationKeySpecifier
)[];
export type DeleteOutboundCallCustomizationFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeletePhoneLineKeySpecifier = (
  | 'success'
  | DeletePhoneLineKeySpecifier
)[];
export type DeletePhoneLineFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeletePlaceKeySpecifier = ('success' | DeletePlaceKeySpecifier)[];
export type DeletePlaceFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteScheduledMessageKeySpecifier = (
  | 'success'
  | DeleteScheduledMessageKeySpecifier
)[];
export type DeleteScheduledMessageFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteShortcutKeySpecifier = (
  | 'response'
  | DeleteShortcutKeySpecifier
)[];
export type DeleteShortcutFieldPolicy = {
  response?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteStageKeySpecifier = ('stage' | DeleteStageKeySpecifier)[];
export type DeleteStageFieldPolicy = {
  stage?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteStatusItemKeySpecifier = (
  | 'statusItem'
  | DeleteStatusItemKeySpecifier
)[];
export type DeleteStatusItemFieldPolicy = {
  statusItem?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteTeamKeySpecifier = ('team' | DeleteTeamKeySpecifier)[];
export type DeleteTeamFieldPolicy = {
  team?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteUserPhoneKeySpecifier = (
  | 'userPhone'
  | DeleteUserPhoneKeySpecifier
)[];
export type DeleteUserPhoneFieldPolicy = {
  userPhone?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeleteVoiceStepKeySpecifier = (
  | 'voiceScript'
  | DeleteVoiceStepKeySpecifier
)[];
export type DeleteVoiceStepFieldPolicy = {
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DepartmentDeviceQLKeySpecifier = (
  | 'createdOn'
  | 'department'
  | 'departmentId'
  | 'deviceType'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'id'
  | 'lastUpdated'
  | 'mdn'
  | 'name'
  | 'sipAddress'
  | 'sipPriorityFirst'
  | 'type'
  | DepartmentDeviceQLKeySpecifier
)[];
export type DepartmentDeviceQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  departmentId?: FieldPolicy<any> | FieldReadFunction<any>;
  deviceType?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  mdn?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  sipAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  sipPriorityFirst?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DepartmentDeviceQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | DepartmentDeviceQLConnectionKeySpecifier
)[];
export type DepartmentDeviceQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DepartmentDeviceQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | DepartmentDeviceQLEdgeKeySpecifier
)[];
export type DepartmentDeviceQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DepartmentDirectoryEntryQLKeySpecifier = (
  | 'createdOn'
  | 'customDirectoryEntry'
  | 'customDirectoryEntryId'
  | 'department'
  | 'departmentId'
  | 'description'
  | 'devices'
  | 'displayName'
  | 'entryType'
  | 'id'
  | 'isDiscoverable'
  | 'lastUpdated'
  | 'placeGroup'
  | 'placeGroupId'
  | 'user'
  | 'userId'
  | DepartmentDirectoryEntryQLKeySpecifier
)[];
export type DepartmentDirectoryEntryQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customDirectoryEntry?: FieldPolicy<any> | FieldReadFunction<any>;
  customDirectoryEntryId?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  departmentId?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  devices?: FieldPolicy<any> | FieldReadFunction<any>;
  displayName?: FieldPolicy<any> | FieldReadFunction<any>;
  entryType?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isDiscoverable?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  placeGroup?: FieldPolicy<any> | FieldReadFunction<any>;
  placeGroupId?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DepartmentDirectoryEntryQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | DepartmentDirectoryEntryQLConnectionKeySpecifier
)[];
export type DepartmentDirectoryEntryQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DepartmentDirectoryEntryQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | DepartmentDirectoryEntryQLEdgeKeySpecifier
)[];
export type DepartmentDirectoryEntryQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DepartmentQLKeySpecifier = (
  | 'createdOn'
  | 'devices'
  | 'directoryEntries'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'phoneline'
  | 'phonelineId'
  | 'place'
  | 'placeId'
  | DepartmentQLKeySpecifier
)[];
export type DepartmentQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  devices?: FieldPolicy<any> | FieldReadFunction<any>;
  directoryEntries?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneline?: FieldPolicy<any> | FieldReadFunction<any>;
  phonelineId?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DepartmentQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | DepartmentQLConnectionKeySpecifier
)[];
export type DepartmentQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DepartmentQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | DepartmentQLEdgeKeySpecifier
)[];
export type DepartmentQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DialogFlowBotDataQLKeySpecifier = (
  | 'account'
  | 'accountId'
  | 'agentDuration'
  | 'agentReason'
  | 'appointment'
  | 'appointmentWasBooked'
  | 'conversation'
  | 'conversationId'
  | 'createdOn'
  | 'customerInDms'
  | 'data'
  | 'dialogflowOutcome'
  | 'id'
  | 'lastUpdated'
  | 'messages'
  | 'outcome'
  | 'phonecall'
  | 'phonecallId'
  | 'place'
  | 'placeId'
  | DialogFlowBotDataQLKeySpecifier
)[];
export type DialogFlowBotDataQLFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  agentDuration?: FieldPolicy<any> | FieldReadFunction<any>;
  agentReason?: FieldPolicy<any> | FieldReadFunction<any>;
  appointment?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentWasBooked?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customerInDms?: FieldPolicy<any> | FieldReadFunction<any>;
  data?: FieldPolicy<any> | FieldReadFunction<any>;
  dialogflowOutcome?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  outcome?: FieldPolicy<any> | FieldReadFunction<any>;
  phonecall?: FieldPolicy<any> | FieldReadFunction<any>;
  phonecallId?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DialogFlowBotDataQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | DialogFlowBotDataQLConnectionKeySpecifier
)[];
export type DialogFlowBotDataQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DialogFlowBotDataQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | DialogFlowBotDataQLEdgeKeySpecifier
)[];
export type DialogFlowBotDataQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DirectoryDeviceQLKeySpecifier = (
  | 'deviceId'
  | 'deviceType'
  | 'mdn'
  | 'sipAddress'
  | DirectoryDeviceQLKeySpecifier
)[];
export type DirectoryDeviceQLFieldPolicy = {
  deviceId?: FieldPolicy<any> | FieldReadFunction<any>;
  deviceType?: FieldPolicy<any> | FieldReadFunction<any>;
  mdn?: FieldPolicy<any> | FieldReadFunction<any>;
  sipAddress?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DirectoryEntryQLKeySpecifier = (
  | 'createdOn'
  | 'description'
  | 'devices'
  | 'displayName'
  | 'entryType'
  | 'id'
  | 'isDiscoverable'
  | 'lastUpdated'
  | DirectoryEntryQLKeySpecifier
)[];
export type DirectoryEntryQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  devices?: FieldPolicy<any> | FieldReadFunction<any>;
  displayName?: FieldPolicy<any> | FieldReadFunction<any>;
  entryType?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isDiscoverable?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DisableAutopilotKeySpecifier = (
  | 'autopilot'
  | DisableAutopilotKeySpecifier
)[];
export type DisableAutopilotFieldPolicy = {
  autopilot?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DisableFortellisSubscriptionKeySpecifier = (
  | 'fortellisSubscription'
  | DisableFortellisSubscriptionKeySpecifier
)[];
export type DisableFortellisSubscriptionFieldPolicy = {
  fortellisSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DiscardAutomationEditsKeySpecifier = (
  | 'automation'
  | DiscardAutomationEditsKeySpecifier
)[];
export type DiscardAutomationEditsFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DiscardDisruptionVoiceScriptKeySpecifier = (
  | 'place'
  | DiscardDisruptionVoiceScriptKeySpecifier
)[];
export type DiscardDisruptionVoiceScriptFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DiscardVoiceScriptKeySpecifier = (
  | 'answeringScript'
  | DiscardVoiceScriptKeySpecifier
)[];
export type DiscardVoiceScriptFieldPolicy = {
  answeringScript?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DismissTaskKeySpecifier = ('task' | DismissTaskKeySpecifier)[];
export type DismissTaskFieldPolicy = {
  task?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DisputeQLKeySpecifier = (
  | 'createdOn'
  | 'disputeObject'
  | 'disputeObjectId'
  | 'id'
  | 'lastUpdated'
  | 'paymentRequest'
  | 'paymentRequestId'
  | 'reason'
  | 'status'
  | DisputeQLKeySpecifier
)[];
export type DisputeQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  disputeObject?: FieldPolicy<any> | FieldReadFunction<any>;
  disputeObjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentRequest?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentRequestId?: FieldPolicy<any> | FieldReadFunction<any>;
  reason?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DisruptionsQLKeySpecifier = (
  | 'createdOn'
  | 'disruptionDepartmentVoiceScript'
  | 'disruptionDepartmentVoiceScriptId'
  | 'disruptionStaffVoiceScript'
  | 'disruptionStaffVoiceScriptId'
  | 'disruptionsActive'
  | 'disruptionsGreeting'
  | 'draftDisruptionDepartmentVoiceScript'
  | 'draftDisruptionDepartmentVoiceScriptId'
  | 'draftDisruptionStaffVoiceScript'
  | 'draftDisruptionStaffVoiceScriptId'
  | 'draftHolidayDepartmentVoiceScript'
  | 'draftHolidayDepartmentVoiceScriptId'
  | 'draftHolidayStaffVoiceScript'
  | 'draftHolidayStaffVoiceScriptId'
  | 'holidayDepartmentVoiceScript'
  | 'holidayDepartmentVoiceScriptId'
  | 'holidayStaffVoiceScript'
  | 'holidayStaffVoiceScriptId'
  | 'id'
  | 'lastUpdated'
  | 'place'
  | 'placeId'
  | DisruptionsQLKeySpecifier
)[];
export type DisruptionsQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  disruptionDepartmentVoiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  disruptionDepartmentVoiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  disruptionStaffVoiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  disruptionStaffVoiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  disruptionsActive?: FieldPolicy<any> | FieldReadFunction<any>;
  disruptionsGreeting?: FieldPolicy<any> | FieldReadFunction<any>;
  draftDisruptionDepartmentVoiceScript?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  draftDisruptionDepartmentVoiceScriptId?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  draftDisruptionStaffVoiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  draftDisruptionStaffVoiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  draftHolidayDepartmentVoiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  draftHolidayDepartmentVoiceScriptId?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  draftHolidayStaffVoiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  draftHolidayStaffVoiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  holidayDepartmentVoiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  holidayDepartmentVoiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  holidayStaffVoiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  holidayStaffVoiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DuplicateAppointmentAgentSettingsKeySpecifier = (
  | 'appointmentAgentSettings'
  | DuplicateAppointmentAgentSettingsKeySpecifier
)[];
export type DuplicateAppointmentAgentSettingsFieldPolicy = {
  appointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ETOSettingsQLKeySpecifier = (
  | 'automationGroup'
  | 'automationGroupId'
  | 'createdOn'
  | 'daysFrequency'
  | 'eligibilityCriteria'
  | 'id'
  | 'isInboxLabelEnabled'
  | 'lastUpdated'
  | 'leadCreationEmail'
  | 'minimumQualifyingScore'
  | 'noRepeat'
  | 'oneAtATime'
  | 'place'
  | 'placeId'
  | 'qualifiedNotificationEmailRecipient'
  | ETOSettingsQLKeySpecifier
)[];
export type ETOSettingsQLFieldPolicy = {
  automationGroup?: FieldPolicy<any> | FieldReadFunction<any>;
  automationGroupId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  daysFrequency?: FieldPolicy<any> | FieldReadFunction<any>;
  eligibilityCriteria?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isInboxLabelEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  leadCreationEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  minimumQualifyingScore?: FieldPolicy<any> | FieldReadFunction<any>;
  noRepeat?: FieldPolicy<any> | FieldReadFunction<any>;
  oneAtATime?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  qualifiedNotificationEmailRecipient?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
};
export type EarlyExitAnalysisQLKeySpecifier = (
  | 'details'
  | 'exitTypes'
  | 'totalEarlyExits'
  | EarlyExitAnalysisQLKeySpecifier
)[];
export type EarlyExitAnalysisQLFieldPolicy = {
  details?: FieldPolicy<any> | FieldReadFunction<any>;
  exitTypes?: FieldPolicy<any> | FieldReadFunction<any>;
  totalEarlyExits?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EarlyExitDetailQLKeySpecifier = (
  | 'completedAt'
  | 'conversationId'
  | 'customerInformation'
  | 'durationBeforeExit'
  | 'jobId'
  | 'possibleExitTriggers'
  | EarlyExitDetailQLKeySpecifier
)[];
export type EarlyExitDetailQLFieldPolicy = {
  completedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  customerInformation?: FieldPolicy<any> | FieldReadFunction<any>;
  durationBeforeExit?: FieldPolicy<any> | FieldReadFunction<any>;
  jobId?: FieldPolicy<any> | FieldReadFunction<any>;
  possibleExitTriggers?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EmployeeQLKeySpecifier = (
  | 'advisorId'
  | 'cdkServiceAdvisor'
  | 'dealertrackServiceAdvisor'
  | 'name'
  | 'roCount'
  | 'serviceAdvisor'
  | EmployeeQLKeySpecifier
)[];
export type EmployeeQLFieldPolicy = {
  advisorId?: FieldPolicy<any> | FieldReadFunction<any>;
  cdkServiceAdvisor?: FieldPolicy<any> | FieldReadFunction<any>;
  dealertrackServiceAdvisor?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  roCount?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisor?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EnableInboxLanguageOverrideKeySpecifier = (
  | 'phoneline'
  | EnableInboxLanguageOverrideKeySpecifier
)[];
export type EnableInboxLanguageOverrideFieldPolicy = {
  phoneline?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EnableNudgesKeySpecifier = (
  | 'accountSettings'
  | 'currentAccount'
  | EnableNudgesKeySpecifier
)[];
export type EnableNudgesFieldPolicy = {
  accountSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  currentAccount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EnablePlaceMessagingHoursKeySpecifier = (
  | 'success'
  | EnablePlaceMessagingHoursKeySpecifier
)[];
export type EnablePlaceMessagingHoursFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EndOutboundConferenceCallKeySpecifier = (
  | 'outboundConferenceCall'
  | EndOutboundConferenceCallKeySpecifier
)[];
export type EndOutboundConferenceCallFieldPolicy = {
  outboundConferenceCall?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EngagementInboxAgentResultQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'myAssistedResponseRating'
  | 'predictedMessageIntents'
  | 'promptHash'
  | 'sentiment'
  | 'sentimentValue'
  | 'summary'
  | 'topics'
  | EngagementInboxAgentResultQLKeySpecifier
)[];
export type EngagementInboxAgentResultQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  myAssistedResponseRating?: FieldPolicy<any> | FieldReadFunction<any>;
  predictedMessageIntents?: FieldPolicy<any> | FieldReadFunction<any>;
  promptHash?: FieldPolicy<any> | FieldReadFunction<any>;
  sentiment?: FieldPolicy<any> | FieldReadFunction<any>;
  sentimentValue?: FieldPolicy<any> | FieldReadFunction<any>;
  summary?: FieldPolicy<any> | FieldReadFunction<any>;
  topics?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EngagementQLKeySpecifier = (
  | 'boundsEnd'
  | 'boundsStart'
  | 'conversation'
  | 'conversationId'
  | 'createdOn'
  | 'id'
  | 'lastConsideredActivityTime'
  | 'lastUpdated'
  | 'latestInboxAgentResult'
  | 'myStatusRating'
  | 'mySummaryRating'
  | 'status'
  | 'summary'
  | 'summaryCreatedOn'
  | 'summaryId'
  | 'tasks'
  | EngagementQLKeySpecifier
)[];
export type EngagementQLFieldPolicy = {
  boundsEnd?: FieldPolicy<any> | FieldReadFunction<any>;
  boundsStart?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastConsideredActivityTime?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  latestInboxAgentResult?: FieldPolicy<any> | FieldReadFunction<any>;
  myStatusRating?: FieldPolicy<any> | FieldReadFunction<any>;
  mySummaryRating?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  summary?: FieldPolicy<any> | FieldReadFunction<any>;
  summaryCreatedOn?: FieldPolicy<any> | FieldReadFunction<any>;
  summaryId?: FieldPolicy<any> | FieldReadFunction<any>;
  tasks?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EngagementStatusRatingQLKeySpecifier = (
  | 'createdOn'
  | 'details'
  | 'lastUpdated'
  | 'reason'
  | 'value'
  | EngagementStatusRatingQLKeySpecifier
)[];
export type EngagementStatusRatingQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  details?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  reason?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EngagementSummaryRatingQLKeySpecifier = (
  | 'createdAt'
  | 'details'
  | 'reason'
  | 'updatedAt'
  | 'value'
  | EngagementSummaryRatingQLKeySpecifier
)[];
export type EngagementSummaryRatingQLFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  details?: FieldPolicy<any> | FieldReadFunction<any>;
  reason?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EnrollmentCriteriaQLKeySpecifier = (
  | 'duration'
  | 'executionLimit'
  | 'id'
  | 'preventConcurrentEnrollment'
  | EnrollmentCriteriaQLKeySpecifier
)[];
export type EnrollmentCriteriaQLFieldPolicy = {
  duration?: FieldPolicy<any> | FieldReadFunction<any>;
  executionLimit?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  preventConcurrentEnrollment?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EquityTradeOpportunityCreatedTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'triggerType'
  | 'uiHints'
  | EquityTradeOpportunityCreatedTriggerQLKeySpecifier
)[];
export type EquityTradeOpportunityCreatedTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EquityTradeOpportunityQLKeySpecifier = (
  | 'closeReason'
  | 'closedByParticipant'
  | 'closedByParticipantId'
  | 'conversation'
  | 'createdOn'
  | 'expirationDate'
  | 'id'
  | 'lastUpdated'
  | 'qualificationSurvey'
  | 'repairOrder'
  | 'repairOrderId'
  | 'settings'
  | 'source'
  | 'stage'
  | 'status'
  | EquityTradeOpportunityQLKeySpecifier
)[];
export type EquityTradeOpportunityQLFieldPolicy = {
  closeReason?: FieldPolicy<any> | FieldReadFunction<any>;
  closedByParticipant?: FieldPolicy<any> | FieldReadFunction<any>;
  closedByParticipantId?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  expirationDate?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  qualificationSurvey?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderId?: FieldPolicy<any> | FieldReadFunction<any>;
  settings?: FieldPolicy<any> | FieldReadFunction<any>;
  source?: FieldPolicy<any> | FieldReadFunction<any>;
  stage?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EquityTradeOpportunityQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | EquityTradeOpportunityQLConnectionKeySpecifier
)[];
export type EquityTradeOpportunityQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EquityTradeOpportunityQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | EquityTradeOpportunityQLEdgeKeySpecifier
)[];
export type EquityTradeOpportunityQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EscalateConversationActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'id'
  | 'lastUpdated'
  | 'messageToSend'
  | 'nextActionId'
  | 'uiHints'
  | EscalateConversationActionQLKeySpecifier
)[];
export type EscalateConversationActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messageToSend?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EvaluateBusinessIdentityKeySpecifier = (
  | 'tenDlcProcess'
  | EvaluateBusinessIdentityKeySpecifier
)[];
export type EvaluateBusinessIdentityFieldPolicy = {
  tenDlcProcess?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EvaluationTimeQLKeySpecifier = (
  | 'time'
  | EvaluationTimeQLKeySpecifier
)[];
export type EvaluationTimeQLFieldPolicy = {
  time?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ExportConversationToArchiveKeySpecifier = (
  | 'taskId'
  | ExportConversationToArchiveKeySpecifier
)[];
export type ExportConversationToArchiveFieldPolicy = {
  taskId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ExternalCRMUserQLKeySpecifier = (
  | 'emails'
  | 'firstName'
  | 'id'
  | 'lastName'
  | ExternalCRMUserQLKeySpecifier
)[];
export type ExternalCRMUserQLFieldPolicy = {
  emails?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ExternalOpcodeQLKeySpecifier = (
  | 'createdOn'
  | 'dmsId'
  | 'id'
  | 'lastUpdated'
  | 'serviceName'
  | ExternalOpcodeQLKeySpecifier
)[];
export type ExternalOpcodeQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  dmsId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ExternalVehicleConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | ExternalVehicleConnectionKeySpecifier
)[];
export type ExternalVehicleConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ExternalVehicleEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | ExternalVehicleEdgeKeySpecifier
)[];
export type ExternalVehicleEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ExternalVehicleOverrideQLKeySpecifier = (
  | 'id'
  | 'numaServiceName'
  | 'opcodes'
  | 'type'
  | ExternalVehicleOverrideQLKeySpecifier
)[];
export type ExternalVehicleOverrideQLFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  numaServiceName?: FieldPolicy<any> | FieldReadFunction<any>;
  opcodes?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ExternalVehicleQLKeySpecifier = (
  | 'activeIntegration'
  | 'activeIntegrationId'
  | 'createdOn'
  | 'id'
  | 'lastSyncTime'
  | 'lastUpdated'
  | 'make'
  | 'manufacturerId'
  | 'model'
  | 'overrides'
  | 'rawData'
  | 'year'
  | ExternalVehicleQLKeySpecifier
)[];
export type ExternalVehicleQLFieldPolicy = {
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSyncTime?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  make?: FieldPolicy<any> | FieldReadFunction<any>;
  manufacturerId?: FieldPolicy<any> | FieldReadFunction<any>;
  model?: FieldPolicy<any> | FieldReadFunction<any>;
  overrides?: FieldPolicy<any> | FieldReadFunction<any>;
  rawData?: FieldPolicy<any> | FieldReadFunction<any>;
  year?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FacebookChannelQLKeySpecifier = (
  | 'Assignee'
  | 'AssigneeId'
  | 'RespectExistingAssignments'
  | 'Team'
  | 'TeamId'
  | 'account'
  | 'accountId'
  | 'assignTextReplies'
  | 'assignee'
  | 'assigneeId'
  | 'channelType'
  | 'createdOn'
  | 'fbUserId'
  | 'id'
  | 'identityPromptAddresses'
  | 'identityPromptOption'
  | 'isActive'
  | 'isBotEnabled'
  | 'isNryChannel'
  | 'lastUpdated'
  | 'link'
  | 'messages'
  | 'name'
  | 'operator'
  | 'operatorId'
  | 'operatorSessions'
  | 'outboundConferenceCall'
  | 'outboundProxyCall'
  | 'page'
  | 'pageAccessToken'
  | 'phonecalls'
  | 'place'
  | 'placeId'
  | 'respectExistingAssignments'
  | 'scheduled'
  | 'smsChannel'
  | 'smsPhonelines'
  | 'supportsVoicemail'
  | 'team'
  | 'teamId'
  | 'tokenExpiresOn'
  | 'tokenValid'
  | 'userId'
  | 'username'
  | FacebookChannelQLKeySpecifier
)[];
export type FacebookChannelQLFieldPolicy = {
  Assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  AssigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  RespectExistingAssignments?: FieldPolicy<any> | FieldReadFunction<any>;
  Team?: FieldPolicy<any> | FieldReadFunction<any>;
  TeamId?: FieldPolicy<any> | FieldReadFunction<any>;
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  assignTextReplies?: FieldPolicy<any> | FieldReadFunction<any>;
  assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  assigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  channelType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  fbUserId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptAddresses?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptOption?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isBotEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  isNryChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  link?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorId?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSessions?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundConferenceCall?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundProxyCall?: FieldPolicy<any> | FieldReadFunction<any>;
  page?: FieldPolicy<any> | FieldReadFunction<any>;
  pageAccessToken?: FieldPolicy<any> | FieldReadFunction<any>;
  phonecalls?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  respectExistingAssignments?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduled?: FieldPolicy<any> | FieldReadFunction<any>;
  smsChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  smsPhonelines?: FieldPolicy<any> | FieldReadFunction<any>;
  supportsVoicemail?: FieldPolicy<any> | FieldReadFunction<any>;
  team?: FieldPolicy<any> | FieldReadFunction<any>;
  teamId?: FieldPolicy<any> | FieldReadFunction<any>;
  tokenExpiresOn?: FieldPolicy<any> | FieldReadFunction<any>;
  tokenValid?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
  username?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FacebookReviewSiteKeySpecifier = (
  | 'facebookPageId'
  | 'serviceName'
  | 'url'
  | FacebookReviewSiteKeySpecifier
)[];
export type FacebookReviewSiteFieldPolicy = {
  facebookPageId?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceName?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FileAttachmentKeySpecifier = (
  | 'attachmentType'
  | 'createdOn'
  | 'filename'
  | 'id'
  | 'lastUpdated'
  | 'message'
  | 'messageId'
  | 'primaryMimetype'
  | 'sizeBytes'
  | 'url'
  | 'words'
  | FileAttachmentKeySpecifier
)[];
export type FileAttachmentFieldPolicy = {
  attachmentType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  filename?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  messageId?: FieldPolicy<any> | FieldReadFunction<any>;
  primaryMimetype?: FieldPolicy<any> | FieldReadFunction<any>;
  sizeBytes?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
  words?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ForceActiveIntegrationSyncKeySpecifier = (
  | 'activeIntegration'
  | ForceActiveIntegrationSyncKeySpecifier
)[];
export type ForceActiveIntegrationSyncFieldPolicy = {
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FortellisServiceAdvisorQLKeySpecifier = (
  | 'id'
  | 'name'
  | 'serviceAdvisorId'
  | FortellisServiceAdvisorQLKeySpecifier
)[];
export type FortellisServiceAdvisorQLFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisorId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FortellisSubscriptionConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | FortellisSubscriptionConnectionKeySpecifier
)[];
export type FortellisSubscriptionConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FortellisSubscriptionEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | FortellisSubscriptionEdgeKeySpecifier
)[];
export type FortellisSubscriptionEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FortellisSubscriptionQLKeySpecifier = (
  | 'account'
  | 'accountId'
  | 'createdOn'
  | 'crmLookupEnabledPlaces'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'registeredServiceAdvisors'
  | 'repairOrderPlace'
  | 'repairOrderPlaceId'
  | 'serviceAdvisorCache'
  | 'serviceAdvisorCacheTimestamp'
  | 'serviceAdvisors'
  | 'status'
  | 'subscriptionId'
  | FortellisSubscriptionQLKeySpecifier
)[];
export type FortellisSubscriptionQLFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  crmLookupEnabledPlaces?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  registeredServiceAdvisors?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderPlace?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderPlaceId?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisorCache?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisorCacheTimestamp?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisors?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  subscriptionId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FortellisSubscriptionQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | FortellisSubscriptionQLConnectionKeySpecifier
)[];
export type FortellisSubscriptionQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FortellisSubscriptionQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | FortellisSubscriptionQLEdgeKeySpecifier
)[];
export type FortellisSubscriptionQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type GenerateRepairOrderAssistedStatusContentKeySpecifier = (
  | 'statusContent'
  | GenerateRepairOrderAssistedStatusContentKeySpecifier
)[];
export type GenerateRepairOrderAssistedStatusContentFieldPolicy = {
  statusContent?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type GenerateRepairOrderNotesSummaryKeySpecifier = (
  | 'repairOrderNotesSummary'
  | GenerateRepairOrderNotesSummaryKeySpecifier
)[];
export type GenerateRepairOrderNotesSummaryFieldPolicy = {
  repairOrderNotesSummary?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type GenerateWriteItForMeContentKeySpecifier = (
  | 'content'
  | GenerateWriteItForMeContentKeySpecifier
)[];
export type GenerateWriteItForMeContentFieldPolicy = {
  content?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type GlobalSyncXtimeServicesKeySpecifier = (
  | 'activeIntegration'
  | 'latestSchedulerSync'
  | 'latestXtimeSync'
  | 'supportedVehicles'
  | GlobalSyncXtimeServicesKeySpecifier
)[];
export type GlobalSyncXtimeServicesFieldPolicy = {
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  latestSchedulerSync?: FieldPolicy<any> | FieldReadFunction<any>;
  latestXtimeSync?: FieldPolicy<any> | FieldReadFunction<any>;
  supportedVehicles?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type GoogleChannelQLKeySpecifier = (
  | 'Assignee'
  | 'AssigneeId'
  | 'RespectExistingAssignments'
  | 'Team'
  | 'TeamId'
  | 'account'
  | 'accountId'
  | 'assignTextReplies'
  | 'assignee'
  | 'assigneeId'
  | 'businessId'
  | 'channelType'
  | 'createdOn'
  | 'googlePlaceId'
  | 'id'
  | 'identityPromptAddresses'
  | 'identityPromptOption'
  | 'isActive'
  | 'isBotEnabled'
  | 'isNryChannel'
  | 'lastUpdated'
  | 'messages'
  | 'name'
  | 'operator'
  | 'operatorId'
  | 'operatorSessions'
  | 'outboundConferenceCall'
  | 'outboundProxyCall'
  | 'phonecalls'
  | 'place'
  | 'placeId'
  | 'respectExistingAssignments'
  | 'scheduled'
  | 'smsChannel'
  | 'smsPhonelines'
  | 'supportsVoicemail'
  | 'team'
  | 'teamId'
  | 'userId'
  | 'version'
  | GoogleChannelQLKeySpecifier
)[];
export type GoogleChannelQLFieldPolicy = {
  Assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  AssigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  RespectExistingAssignments?: FieldPolicy<any> | FieldReadFunction<any>;
  Team?: FieldPolicy<any> | FieldReadFunction<any>;
  TeamId?: FieldPolicy<any> | FieldReadFunction<any>;
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  assignTextReplies?: FieldPolicy<any> | FieldReadFunction<any>;
  assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  assigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  businessId?: FieldPolicy<any> | FieldReadFunction<any>;
  channelType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  googlePlaceId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptAddresses?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptOption?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isBotEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  isNryChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorId?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSessions?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundConferenceCall?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundProxyCall?: FieldPolicy<any> | FieldReadFunction<any>;
  phonecalls?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  respectExistingAssignments?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduled?: FieldPolicy<any> | FieldReadFunction<any>;
  smsChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  smsPhonelines?: FieldPolicy<any> | FieldReadFunction<any>;
  supportsVoicemail?: FieldPolicy<any> | FieldReadFunction<any>;
  team?: FieldPolicy<any> | FieldReadFunction<any>;
  teamId?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
  version?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type GoogleReviewSiteKeySpecifier = (
  | 'googlePlaceId'
  | 'serviceName'
  | 'url'
  | GoogleReviewSiteKeySpecifier
)[];
export type GoogleReviewSiteFieldPolicy = {
  googlePlaceId?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceName?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type GreetingQLKeySpecifier = (
  | 'afterHoursContent'
  | 'afterHoursContentTemplate'
  | 'content'
  | 'contentTemplate'
  | 'createdOn'
  | 'id'
  | 'kind'
  | 'lastUpdated'
  | 'place'
  | 'placeId'
  | GreetingQLKeySpecifier
)[];
export type GreetingQLFieldPolicy = {
  afterHoursContent?: FieldPolicy<any> | FieldReadFunction<any>;
  afterHoursContentTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  contentTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  kind?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type GreetingStepQLKeySpecifier = (
  | 'affirmationSpeech'
  | 'affirmationSpeechUrl'
  | 'afterHoursSpeech'
  | 'afterHoursSpeechUrl'
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'clarificationSpeech'
  | 'clarificationSpeechUrl'
  | 'collectNewPhonenumberSpeech'
  | 'collectNewPhonenumberSpeechUrl'
  | 'collectPhonenumberFallbackSpeech'
  | 'confirmPhonenumberSpeech'
  | 'confirmPhonenumberSpeechUrl'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'disclosureContent'
  | 'disclosureContentUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'isCorrectQuestionSpeech'
  | 'isCorrectQuestionSpeechUrl'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'nextStepId'
  | 'nextStepRelationship'
  | 'noSpeech'
  | 'noSpeechUrl'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'playDisclosureRecording'
  | 'questionBotSteps'
  | 'renderedAfterHoursSpeech'
  | 'renderedSpeech'
  | 'retrySpeech'
  | 'retrySpeechUrl'
  | 'smartTopicNoMatchSteps'
  | 'softOpenSpeech'
  | 'softOpenSpeechUrl'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | 'yesSpeech'
  | 'yesSpeechUrl'
  | GreetingStepQLKeySpecifier
)[];
export type GreetingStepQLFieldPolicy = {
  affirmationSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  affirmationSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  afterHoursSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  afterHoursSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  clarificationSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  clarificationSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  collectNewPhonenumberSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  collectNewPhonenumberSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  collectPhonenumberFallbackSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  confirmPhonenumberSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  confirmPhonenumberSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  disclosureContent?: FieldPolicy<any> | FieldReadFunction<any>;
  disclosureContentUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  isCorrectQuestionSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  isCorrectQuestionSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  noSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  noSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  playDisclosureRecording?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedAfterHoursSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  retrySpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  retrySpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  softOpenSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  softOpenSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  yesSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type GreetingStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | GreetingStepQLConnectionKeySpecifier
)[];
export type GreetingStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type GreetingStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | GreetingStepQLEdgeKeySpecifier
)[];
export type GreetingStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type GuideChecklistQLKeySpecifier = (
  | 'customizedIntents'
  | 'hasBroadcastEnabled'
  | 'hasCallForwarding'
  | 'hasDismissedGuideChecklist'
  | 'hasViewedRefer'
  | 'placeId'
  | 'textingPhonelines'
  | GuideChecklistQLKeySpecifier
)[];
export type GuideChecklistQLFieldPolicy = {
  customizedIntents?: FieldPolicy<any> | FieldReadFunction<any>;
  hasBroadcastEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  hasCallForwarding?: FieldPolicy<any> | FieldReadFunction<any>;
  hasDismissedGuideChecklist?: FieldPolicy<any> | FieldReadFunction<any>;
  hasViewedRefer?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  textingPhonelines?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HandToOpportunityAgentActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'id'
  | 'lastUpdated'
  | 'nextActionId'
  | 'opportunity'
  | 'uiHints'
  | HandToOpportunityAgentActionQLKeySpecifier
)[];
export type HandToOpportunityAgentActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  opportunity?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HasLabelActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'id'
  | 'labelCheckOperation'
  | 'labelsToCheck'
  | 'lastUpdated'
  | 'nextActionId'
  | 'onNoActionId'
  | 'onYesActionId'
  | 'uiHints'
  | HasLabelActionQLKeySpecifier
)[];
export type HasLabelActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  labelCheckOperation?: FieldPolicy<any> | FieldReadFunction<any>;
  labelsToCheck?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HostedPageKeySpecifier = ('hostedPage' | HostedPageKeySpecifier)[];
export type HostedPageFieldPolicy = {
  hostedPage?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HostedSmsCompletedKeySpecifier = (
  | 'hostedSmsPort'
  | HostedSmsCompletedKeySpecifier
)[];
export type HostedSmsCompletedFieldPolicy = {
  hostedSmsPort?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HostedSmsPortQLKeySpecifier = (
  | 'addressSid'
  | 'createdOn'
  | 'customerEmail'
  | 'customerName'
  | 'id'
  | 'lastUpdated'
  | 'loaSid'
  | 'mdn'
  | 'phoneline'
  | 'phonelineId'
  | 'place'
  | 'placeId'
  | 'sid'
  | 'status'
  | 'twilioChannel'
  | 'twilioChannelId'
  | 'url'
  | 'verificationAttempts'
  | 'verificationCode'
  | HostedSmsPortQLKeySpecifier
)[];
export type HostedSmsPortQLFieldPolicy = {
  addressSid?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customerEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  customerName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  loaSid?: FieldPolicy<any> | FieldReadFunction<any>;
  mdn?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneline?: FieldPolicy<any> | FieldReadFunction<any>;
  phonelineId?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  sid?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioChannelId?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
  verificationAttempts?: FieldPolicy<any> | FieldReadFunction<any>;
  verificationCode?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HostedSmsPortQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | HostedSmsPortQLConnectionKeySpecifier
)[];
export type HostedSmsPortQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HostedSmsPortQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | HostedSmsPortQLEdgeKeySpecifier
)[];
export type HostedSmsPortQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type IdentityPromptAddressQLKeySpecifier = (
  | 'address'
  | 'channel'
  | 'channelId'
  | 'createdBy'
  | 'createdById'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | IdentityPromptAddressQLKeySpecifier
)[];
export type IdentityPromptAddressQLFieldPolicy = {
  address?: FieldPolicy<any> | FieldReadFunction<any>;
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
  channelId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdBy?: FieldPolicy<any> | FieldReadFunction<any>;
  createdById?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type IdentityPromptAddressQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | IdentityPromptAddressQLConnectionKeySpecifier
)[];
export type IdentityPromptAddressQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type IdentityPromptAddressQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | IdentityPromptAddressQLEdgeKeySpecifier
)[];
export type IdentityPromptAddressQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ImageAttachmentKeySpecifier = (
  | 'attachmentType'
  | 'createdOn'
  | 'filename'
  | 'height'
  | 'id'
  | 'lastUpdated'
  | 'message'
  | 'messageId'
  | 'primaryMimetype'
  | 'sizeBytes'
  | 'url'
  | 'width'
  | 'words'
  | ImageAttachmentKeySpecifier
)[];
export type ImageAttachmentFieldPolicy = {
  attachmentType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  filename?: FieldPolicy<any> | FieldReadFunction<any>;
  height?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  messageId?: FieldPolicy<any> | FieldReadFunction<any>;
  primaryMimetype?: FieldPolicy<any> | FieldReadFunction<any>;
  sizeBytes?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
  width?: FieldPolicy<any> | FieldReadFunction<any>;
  words?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ImpersonateKeySpecifier = (
  | 'refreshToken'
  | ImpersonateKeySpecifier
)[];
export type ImpersonateFieldPolicy = {
  refreshToken?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ImportHostedSmsKeySpecifier = (
  | 'hostedSmsPort'
  | ImportHostedSmsKeySpecifier
)[];
export type ImportHostedSmsFieldPolicy = {
  hostedSmsPort?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InboxConnectionKeySpecifier = (
  | 'activeRos'
  | 'conversationMentions'
  | 'conversationsAssignedToMe'
  | 'edges'
  | 'hideSharedInboxViews'
  | 'pageInfo'
  | 'statusBoardView'
  | 'totalConversations'
  | 'totalUnassigned'
  | InboxConnectionKeySpecifier
)[];
export type InboxConnectionFieldPolicy = {
  activeRos?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationMentions?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationsAssignedToMe?: FieldPolicy<any> | FieldReadFunction<any>;
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  hideSharedInboxViews?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  statusBoardView?: FieldPolicy<any> | FieldReadFunction<any>;
  totalConversations?: FieldPolicy<any> | FieldReadFunction<any>;
  totalUnassigned?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InboxEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | InboxEdgeKeySpecifier
)[];
export type InboxEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InboxQLKeySpecifier = (
  | 'conversationCount'
  | 'conversations'
  | 'createdOn'
  | 'id'
  | 'isPlaceInbox'
  | 'lastUpdated'
  | 'name'
  | 'place'
  | 'placeId'
  | InboxQLKeySpecifier
)[];
export type InboxQLFieldPolicy = {
  conversationCount?: FieldPolicy<any> | FieldReadFunction<any>;
  conversations?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isPlaceInbox?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type IncreaseShortcutCountKeySpecifier = (
  | 'shortcut'
  | IncreaseShortcutCountKeySpecifier
)[];
export type IncreaseShortcutCountFieldPolicy = {
  shortcut?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type IntentClassifierQLKeySpecifier = (
  | 'advertiseIntents'
  | 'classifierConfiguration'
  | 'classifierName'
  | 'clientName'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'place'
  | 'placeId'
  | IntentClassifierQLKeySpecifier
)[];
export type IntentClassifierQLFieldPolicy = {
  advertiseIntents?: FieldPolicy<any> | FieldReadFunction<any>;
  classifierConfiguration?: FieldPolicy<any> | FieldReadFunction<any>;
  classifierName?: FieldPolicy<any> | FieldReadFunction<any>;
  clientName?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type IntentClassifierQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | IntentClassifierQLConnectionKeySpecifier
)[];
export type IntentClassifierQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type IntentClassifierQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | IntentClassifierQLEdgeKeySpecifier
)[];
export type IntentClassifierQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type IntentQuestionQLKeySpecifier = (
  | 'appliedIntent'
  | 'appliedIntentId'
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'canWeTextSpeech'
  | 'canWeTextSpeechUrl'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'clarifyCanWeTextSpeech'
  | 'clarifyCanWeTextSpeechUrl'
  | 'clarifySpeech'
  | 'clarifySpeechUrl'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'messageToSend'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onFailCanWeTextSpeech'
  | 'onFailCanWeTextSpeechUrl'
  | 'onFailureSpeech'
  | 'onFailureSpeechUrl'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoCanWeTextSpeech'
  | 'onNoCanWeTextSpeechUrl'
  | 'onNoResponseSteps'
  | 'onNoSpeech'
  | 'onNoSpeechUrl'
  | 'onNoStep'
  | 'onNoStepId'
  | 'onYesButNoTextStep'
  | 'onYesButNoTextStepId'
  | 'onYesCanWeTextSpeech'
  | 'onYesCanWeTextSpeechUrl'
  | 'onYesSpeech'
  | 'onYesSpeechUrl'
  | 'onYesStep'
  | 'onYesStepId'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'purpose'
  | 'questionBotSteps'
  | 'renderedMessageToSend'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | IntentQuestionQLKeySpecifier
)[];
export type IntentQuestionQLFieldPolicy = {
  appliedIntent?: FieldPolicy<any> | FieldReadFunction<any>;
  appliedIntentId?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  canWeTextSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  canWeTextSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  clarifyCanWeTextSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  clarifyCanWeTextSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  clarifySpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  clarifySpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messageToSend?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onFailCanWeTextSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onFailCanWeTextSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onFailureSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onFailureSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoCanWeTextSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoCanWeTextSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoStep?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesButNoTextStep?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesButNoTextStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesCanWeTextSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesCanWeTextSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesStep?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  purpose?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedMessageToSend?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type IntentQuestionQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | IntentQuestionQLConnectionKeySpecifier
)[];
export type IntentQuestionQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type IntentQuestionQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | IntentQuestionQLEdgeKeySpecifier
)[];
export type IntentQuestionQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type IsBusinessHoursActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'id'
  | 'lastUpdated'
  | 'nextActionId'
  | 'onNoActionId'
  | 'onYesActionId'
  | 'uiHints'
  | IsBusinessHoursActionQLKeySpecifier
)[];
export type IsBusinessHoursActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LabelAddedTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'labelsToWatch'
  | 'lastUpdated'
  | 'triggerType'
  | 'uiHints'
  | LabelAddedTriggerQLKeySpecifier
)[];
export type LabelAddedTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  labelsToWatch?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LabelConversationStepQLKeySpecifier = (
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'expirationHours'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'labelName'
  | 'lastUpdated'
  | 'nextStepId'
  | 'nextStepRelationship'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | LabelConversationStepQLKeySpecifier
)[];
export type LabelConversationStepQLFieldPolicy = {
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  expirationHours?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  labelName?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LabelConversationStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | LabelConversationStepQLConnectionKeySpecifier
)[];
export type LabelConversationStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LabelConversationStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | LabelConversationStepQLEdgeKeySpecifier
)[];
export type LabelConversationStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LabelQLKeySpecifier = (
  | 'archived'
  | 'category'
  | 'color'
  | 'conversationLabels'
  | 'createdOn'
  | 'expirationHours'
  | 'hidden'
  | 'icon'
  | 'iconType'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'place'
  | 'placeId'
  | LabelQLKeySpecifier
)[];
export type LabelQLFieldPolicy = {
  archived?: FieldPolicy<any> | FieldReadFunction<any>;
  category?: FieldPolicy<any> | FieldReadFunction<any>;
  color?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationLabels?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  expirationHours?: FieldPolicy<any> | FieldReadFunction<any>;
  hidden?: FieldPolicy<any> | FieldReadFunction<any>;
  icon?: FieldPolicy<any> | FieldReadFunction<any>;
  iconType?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LabelQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | LabelQLConnectionKeySpecifier
)[];
export type LabelQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LabelQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | LabelQLEdgeKeySpecifier
)[];
export type LabelQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LabelRemovedTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'labelsToWatch'
  | 'lastUpdated'
  | 'triggerType'
  | 'uiHints'
  | LabelRemovedTriggerQLKeySpecifier
)[];
export type LabelRemovedTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  labelsToWatch?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LeaderboardColorsQLKeySpecifier = (
  | 'green'
  | 'red'
  | 'yellow'
  | LeaderboardColorsQLKeySpecifier
)[];
export type LeaderboardColorsQLFieldPolicy = {
  green?: FieldPolicy<any> | FieldReadFunction<any>;
  red?: FieldPolicy<any> | FieldReadFunction<any>;
  yellow?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LeaveAllConversationsKeySpecifier = (
  | 'success'
  | LeaveAllConversationsKeySpecifier
)[];
export type LeaveAllConversationsFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LeaveConversationsKeySpecifier = (
  | 'success'
  | LeaveConversationsKeySpecifier
)[];
export type LeaveConversationsFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LeaveNoteActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'desiredConversationState'
  | 'id'
  | 'lastUpdated'
  | 'messageToSend'
  | 'nextActionId'
  | 'uiHints'
  | LeaveNoteActionQLKeySpecifier
)[];
export type LeaveNoteActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  desiredConversationState?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messageToSend?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LegacyCrmContactQLKeySpecifier = (
  | 'contactType'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | LegacyCrmContactQLKeySpecifier
)[];
export type LegacyCrmContactQLFieldPolicy = {
  contactType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LibraryIntentQLKeySpecifier = (
  | 'appliedIntents'
  | 'categories'
  | 'createdOn'
  | 'defaultAutosend'
  | 'defaultCategories'
  | 'defaultResponse'
  | 'displayExamples'
  | 'displayName'
  | 'id'
  | 'isManagedByDefault'
  | 'isVisible'
  | 'lastUpdated'
  | 'name'
  | 'source'
  | 'trainingExamples'
  | LibraryIntentQLKeySpecifier
)[];
export type LibraryIntentQLFieldPolicy = {
  appliedIntents?: FieldPolicy<any> | FieldReadFunction<any>;
  categories?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultAutosend?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultCategories?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultResponse?: FieldPolicy<any> | FieldReadFunction<any>;
  displayExamples?: FieldPolicy<any> | FieldReadFunction<any>;
  displayName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isManagedByDefault?: FieldPolicy<any> | FieldReadFunction<any>;
  isVisible?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  source?: FieldPolicy<any> | FieldReadFunction<any>;
  trainingExamples?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LinkKeySpecifier = ('name' | 'tag' | 'url' | LinkKeySpecifier)[];
export type LinkFieldPolicy = {
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  tag?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LinkGroupKeySpecifier = (
  | 'groupLabel'
  | 'links'
  | LinkGroupKeySpecifier
)[];
export type LinkGroupFieldPolicy = {
  groupLabel?: FieldPolicy<any> | FieldReadFunction<any>;
  links?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ManageLabelActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'id'
  | 'labels'
  | 'lastUpdated'
  | 'nextActionId'
  | 'uiHints'
  | ManageLabelActionQLKeySpecifier
)[];
export type ManageLabelActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  labels?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ManageLabelsOperationKeySpecifier = (
  | 'label'
  | 'operation'
  | ManageLabelsOperationKeySpecifier
)[];
export type ManageLabelsOperationFieldPolicy = {
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  operation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ManagerDashboardKeySpecifier = (
  | 'placeMetrics'
  | 'pollingIntervalMs'
  | 'userMetrics'
  | ManagerDashboardKeySpecifier
)[];
export type ManagerDashboardFieldPolicy = {
  placeMetrics?: FieldPolicy<any> | FieldReadFunction<any>;
  pollingIntervalMs?: FieldPolicy<any> | FieldReadFunction<any>;
  userMetrics?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ManualOpportunityKeySpecifier = (
  | 'result'
  | ManualOpportunityKeySpecifier
)[];
export type ManualOpportunityFieldPolicy = {
  result?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ManualOpportunityCustomerInformationQLKeySpecifier = (
  | 'name'
  | 'phoneNumber'
  | ManualOpportunityCustomerInformationQLKeySpecifier
)[];
export type ManualOpportunityCustomerInformationQLFieldPolicy = {
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ManualOpportunityQLKeySpecifier = (
  | 'automationId'
  | 'automationName'
  | 'completeTime'
  | 'createdOn'
  | 'fileContent'
  | 'fileName'
  | 'filePath'
  | 'id'
  | 'lastUpdated'
  | 'placeId'
  | 'startTime'
  | 'status'
  | 'userId'
  | ManualOpportunityQLKeySpecifier
)[];
export type ManualOpportunityQLFieldPolicy = {
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  automationName?: FieldPolicy<any> | FieldReadFunction<any>;
  completeTime?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  fileContent?: FieldPolicy<any> | FieldReadFunction<any>;
  fileName?: FieldPolicy<any> | FieldReadFunction<any>;
  filePath?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  startTime?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ManualOpportunityReportQLKeySpecifier = (
  | 'automationId'
  | 'automationName'
  | 'completeTime'
  | 'contentSummary'
  | 'conversationBreakdown'
  | 'earlyExitAnalysis'
  | 'fileName'
  | 'manualOpportunityId'
  | 'manualOpportunityStatus'
  | 'startTime'
  | 'statusSummary'
  | 'totalAutomationsTriggered'
  | 'uniqueConversationsAffected'
  | ManualOpportunityReportQLKeySpecifier
)[];
export type ManualOpportunityReportQLFieldPolicy = {
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  automationName?: FieldPolicy<any> | FieldReadFunction<any>;
  completeTime?: FieldPolicy<any> | FieldReadFunction<any>;
  contentSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationBreakdown?: FieldPolicy<any> | FieldReadFunction<any>;
  earlyExitAnalysis?: FieldPolicy<any> | FieldReadFunction<any>;
  fileName?: FieldPolicy<any> | FieldReadFunction<any>;
  manualOpportunityId?: FieldPolicy<any> | FieldReadFunction<any>;
  manualOpportunityStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  startTime?: FieldPolicy<any> | FieldReadFunction<any>;
  statusSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  totalAutomationsTriggered?: FieldPolicy<any> | FieldReadFunction<any>;
  uniqueConversationsAffected?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ManualOpportunityResultKeySpecifier = (
  | 'message'
  | 'success'
  | ManualOpportunityResultKeySpecifier
)[];
export type ManualOpportunityResultFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ManualOpportunityTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'triggerType'
  | 'uiHints'
  | ManualOpportunityTriggerQLKeySpecifier
)[];
export type ManualOpportunityTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MapCrmUserToUserKeySpecifier = (
  | 'user'
  | MapCrmUserToUserKeySpecifier
)[];
export type MapCrmUserToUserFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MarkMessagesReadKeySpecifier = (
  | 'messages'
  | MarkMessagesReadKeySpecifier
)[];
export type MarkMessagesReadFieldPolicy = {
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MentionQLKeySpecifier = (
  | 'conversation'
  | 'conversationId'
  | 'createdOn'
  | 'hasLeftConversation'
  | 'id'
  | 'isEscalated'
  | 'lastUpdated'
  | 'message'
  | 'messageId'
  | 'tag'
  | 'user'
  | 'userId'
  | MentionQLKeySpecifier
)[];
export type MentionQLFieldPolicy = {
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  hasLeftConversation?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isEscalated?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  messageId?: FieldPolicy<any> | FieldReadFunction<any>;
  tag?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MentionQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | MentionQLConnectionKeySpecifier
)[];
export type MentionQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MentionQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | MentionQLEdgeKeySpecifier
)[];
export type MentionQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MessageConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | MessageConnectionKeySpecifier
)[];
export type MessageConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MessageEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | MessageEdgeKeySpecifier
)[];
export type MessageEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MessageMetadataQLKeySpecifier = (
  | 'mdn'
  | 'name'
  | MessageMetadataQLKeySpecifier
)[];
export type MessageMetadataQLFieldPolicy = {
  mdn?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MessageQLKeySpecifier = (
  | 'IsArchived'
  | 'attachments'
  | 'call'
  | 'callId'
  | 'canTeachNuma'
  | 'capsLockFixed'
  | 'channel'
  | 'channelData'
  | 'channelId'
  | 'channelType'
  | 'confidence'
  | 'content'
  | 'conversation'
  | 'conversationId'
  | 'createdOn'
  | 'deletedBy'
  | 'deletedById'
  | 'deliveryError'
  | 'deliveryStatus'
  | 'dialogFlowBotData'
  | 'dialogFlowBotDataId'
  | 'id'
  | 'intentControlId'
  | 'intentDisplayName'
  | 'intentId'
  | 'intentName'
  | 'isActive'
  | 'isDeleted'
  | 'isFailure'
  | 'isFromBot'
  | 'isGoldCase'
  | 'isGreeting'
  | 'isHeatCase'
  | 'isInbound'
  | 'isSuggestion'
  | 'lastUpdated'
  | 'libraryIntentDisplayName'
  | 'libraryIntentName'
  | 'loggedCallInteraction'
  | 'mentions'
  | 'messageDescription'
  | 'messageFormat'
  | 'messageType'
  | 'notePreview'
  | 'numSegments'
  | 'numboxAgentSession'
  | 'numboxAgentSessionId'
  | 'outboundConferenceCall'
  | 'outboundProxyCall'
  | 'paymentRequest'
  | 'paymentRequestId'
  | 'place'
  | 'placeId'
  | 'possibleBotAction'
  | 'previewable'
  | 'qualificationSurvey'
  | 'qualificationSurveyId'
  | 'readStatus'
  | 'reasonSent'
  | 'recipient'
  | 'recipientId'
  | 'repairOrder'
  | 'repairOrderId'
  | 'review'
  | 'sender'
  | 'senderId'
  | 'sentFromMdn'
  | 'sentimentInvalidatedAt'
  | 'sentimentLabel'
  | 'sentimentValue'
  | 'statusItem'
  | 'statusItemId'
  | 'timestamp'
  | 'title'
  | MessageQLKeySpecifier
)[];
export type MessageQLFieldPolicy = {
  IsArchived?: FieldPolicy<any> | FieldReadFunction<any>;
  attachments?: FieldPolicy<any> | FieldReadFunction<any>;
  call?: FieldPolicy<any> | FieldReadFunction<any>;
  callId?: FieldPolicy<any> | FieldReadFunction<any>;
  canTeachNuma?: FieldPolicy<any> | FieldReadFunction<any>;
  capsLockFixed?: FieldPolicy<any> | FieldReadFunction<any>;
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
  channelData?: FieldPolicy<any> | FieldReadFunction<any>;
  channelId?: FieldPolicy<any> | FieldReadFunction<any>;
  channelType?: FieldPolicy<any> | FieldReadFunction<any>;
  confidence?: FieldPolicy<any> | FieldReadFunction<any>;
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  deletedBy?: FieldPolicy<any> | FieldReadFunction<any>;
  deletedById?: FieldPolicy<any> | FieldReadFunction<any>;
  deliveryError?: FieldPolicy<any> | FieldReadFunction<any>;
  deliveryStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  dialogFlowBotData?: FieldPolicy<any> | FieldReadFunction<any>;
  dialogFlowBotDataId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentControlId?: FieldPolicy<any> | FieldReadFunction<any>;
  intentDisplayName?: FieldPolicy<any> | FieldReadFunction<any>;
  intentId?: FieldPolicy<any> | FieldReadFunction<any>;
  intentName?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isDeleted?: FieldPolicy<any> | FieldReadFunction<any>;
  isFailure?: FieldPolicy<any> | FieldReadFunction<any>;
  isFromBot?: FieldPolicy<any> | FieldReadFunction<any>;
  isGoldCase?: FieldPolicy<any> | FieldReadFunction<any>;
  isGreeting?: FieldPolicy<any> | FieldReadFunction<any>;
  isHeatCase?: FieldPolicy<any> | FieldReadFunction<any>;
  isInbound?: FieldPolicy<any> | FieldReadFunction<any>;
  isSuggestion?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  libraryIntentDisplayName?: FieldPolicy<any> | FieldReadFunction<any>;
  libraryIntentName?: FieldPolicy<any> | FieldReadFunction<any>;
  loggedCallInteraction?: FieldPolicy<any> | FieldReadFunction<any>;
  mentions?: FieldPolicy<any> | FieldReadFunction<any>;
  messageDescription?: FieldPolicy<any> | FieldReadFunction<any>;
  messageFormat?: FieldPolicy<any> | FieldReadFunction<any>;
  messageType?: FieldPolicy<any> | FieldReadFunction<any>;
  notePreview?: FieldPolicy<any> | FieldReadFunction<any>;
  numSegments?: FieldPolicy<any> | FieldReadFunction<any>;
  numboxAgentSession?: FieldPolicy<any> | FieldReadFunction<any>;
  numboxAgentSessionId?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundConferenceCall?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundProxyCall?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentRequest?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentRequestId?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  possibleBotAction?: FieldPolicy<any> | FieldReadFunction<any>;
  previewable?: FieldPolicy<any> | FieldReadFunction<any>;
  qualificationSurvey?: FieldPolicy<any> | FieldReadFunction<any>;
  qualificationSurveyId?: FieldPolicy<any> | FieldReadFunction<any>;
  readStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  reasonSent?: FieldPolicy<any> | FieldReadFunction<any>;
  recipient?: FieldPolicy<any> | FieldReadFunction<any>;
  recipientId?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderId?: FieldPolicy<any> | FieldReadFunction<any>;
  review?: FieldPolicy<any> | FieldReadFunction<any>;
  sender?: FieldPolicy<any> | FieldReadFunction<any>;
  senderId?: FieldPolicy<any> | FieldReadFunction<any>;
  sentFromMdn?: FieldPolicy<any> | FieldReadFunction<any>;
  sentimentInvalidatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  sentimentLabel?: FieldPolicy<any> | FieldReadFunction<any>;
  sentimentValue?: FieldPolicy<any> | FieldReadFunction<any>;
  statusItem?: FieldPolicy<any> | FieldReadFunction<any>;
  statusItemId?: FieldPolicy<any> | FieldReadFunction<any>;
  timestamp?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MessageQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | MessageQLConnectionKeySpecifier
)[];
export type MessageQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MessageQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | MessageQLEdgeKeySpecifier
)[];
export type MessageQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MessageReceivedTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'triggerType'
  | 'uiHints'
  | MessageReceivedTriggerQLKeySpecifier
)[];
export type MessageReceivedTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MessageTypeKeySpecifier = (
  | 'content'
  | 'role'
  | MessageTypeKeySpecifier
)[];
export type MessageTypeFieldPolicy = {
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  role?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MoveStatusItemKeySpecifier = (
  | 'statusItem'
  | MoveStatusItemKeySpecifier
)[];
export type MoveStatusItemFieldPolicy = {
  statusItem?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MultiChoiceAttachmentKeySpecifier = (
  | 'Data'
  | 'attachmentType'
  | 'createdOn'
  | 'data'
  | 'id'
  | 'lastUpdated'
  | 'message'
  | 'messageId'
  | 'url'
  | MultiChoiceAttachmentKeySpecifier
)[];
export type MultiChoiceAttachmentFieldPolicy = {
  Data?: FieldPolicy<any> | FieldReadFunction<any>;
  attachmentType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  data?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  messageId?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MutationsKeySpecifier = (
  | 'PubNubAppointmentEnriched'
  | 'PubNubArchiveConversation'
  | 'PubNubArchiveConversations'
  | 'PubNubAssignConversation'
  | 'PubNubAwayModeChanged'
  | 'PubNubConversationDeleted'
  | 'PubNubConversationEngagementUpdated'
  | 'PubNubConversationLanguageReset'
  | 'PubNubConversationRecovered'
  | 'PubNubDegradedInboxExperienceUpdated'
  | 'PubNubDialogFlowBotDataUpdated'
  | 'PubNubEquityTradeOpportunityUpdated'
  | 'PubNubInboundCallStatusUpdated'
  | 'PubNubLabelCreated'
  | 'PubNubLabelUpdated'
  | 'PubNubLeaveConversations'
  | 'PubNubMessageReceived'
  | 'PubNubMessageSent'
  | 'PubNubNumboxAgentSessionUpdated'
  | 'PubNubOutboundConferenceCallStatusUpdated'
  | 'PubNubOutboundProxyCallStatusUpdated'
  | 'PubNubPaymentRequestCreated'
  | 'PubNubPaymentRequestUpdated'
  | 'PubNubPlaceUpdated'
  | 'PubNubRestoreConversation'
  | 'PubNubRestoreConversations'
  | 'PubNubStatusItemCreated'
  | 'PubNubStatusItemDeleted'
  | 'PubNubStatusItemUpdated'
  | 'PubNubStripeIntegrationUpdated'
  | 'PubNubTaskCreated'
  | 'PubNubTaskUpdated'
  | 'PubNubTeamCreated'
  | 'PubNubTeamDeleted'
  | 'PubNubTeamUpdated'
  | 'PubNubTranscriptUpdated'
  | 'PubNubVideoUploadLinkUpdated'
  | 'addAnsweringScriptToPolicy'
  | 'addAutomationExitTrigger'
  | 'addAvailableIntegration'
  | 'addCustomLink'
  | 'addCustomer'
  | 'addFortellisSubscription'
  | 'addLabelToConversation'
  | 'addOperatorChannel'
  | 'addOperatorPlace'
  | 'addOutboundCallCustomization'
  | 'addPlaceGroup'
  | 'addServiceAdvisor'
  | 'addStage'
  | 'addStatusItem'
  | 'addSubscription'
  | 'addUserToTeam'
  | 'addVoiceStep'
  | 'archiveMissedCalls'
  | 'assignConversations'
  | 'buildRepairOrderAssistedStatusQuestionTree'
  | 'buildWriteItForMeQuestionTree'
  | 'bulkUpdateSupportedVehicles'
  | 'cancelPaymentRequest'
  | 'cancelScheduledMessage'
  | 'capturePaymentAmount'
  | 'changeAccountSubscription'
  | 'changeAllowCustomAudio'
  | 'changeBusinessVertical'
  | 'changeInboxType'
  | 'changeNotificationSettings'
  | 'changePlaceGroup'
  | 'changePlaceHours'
  | 'changePlaceSubscriptions'
  | 'changeRepairOrderSchedule'
  | 'changeSignupMode'
  | 'changeSwipeActionSettings'
  | 'changeTwilioChannelMdn'
  | 'changeUserPassword'
  | 'changeUserSettings'
  | 'changeUserVideoConferenceUrl'
  | 'closeStatusItem'
  | 'completeAutopilot'
  | 'completeTask'
  | 'connectAutomationAction'
  | 'connectAutomationActionEdge'
  | 'createA2pCampaignForPlace'
  | 'createAppointmentAgentSettingLabel'
  | 'createAppointmentAgentSettings'
  | 'createAutomation'
  | 'createAutomationAction'
  | 'createAutomationFromBlueprint'
  | 'createAutopilot'
  | 'createBillingIdentity'
  | 'createCampaign'
  | 'createChatExpansion'
  | 'createChitchat'
  | 'createConversation'
  | 'createConversationSummary'
  | 'createConversationTextExpansion'
  | 'createCustomDirectoryEntry'
  | 'createDepartmentDevice'
  | 'createIdentityPromptAddress'
  | 'createLabel'
  | 'createManualCampaignUpload'
  | 'createNoteTaker'
  | 'createOperator'
  | 'createOutboundConferenceCall'
  | 'createOutboundProxyCall'
  | 'createParticipant'
  | 'createParticipantPaymentRequest'
  | 'createPaymentRequest'
  | 'createPhoneLine'
  | 'createPlace'
  | 'createPortalSession'
  | 'createScheduledMessage'
  | 'createShortcut'
  | 'createStripeAccount'
  | 'createStripeRefund'
  | 'createTaskForEngagement'
  | 'createTeam'
  | 'createTextExpansion'
  | 'createUser'
  | 'createUserPhone'
  | 'createVideoUploadLink'
  | 'deactivateAccount'
  | 'deleteAppointmentAgentSettingLabel'
  | 'deleteAppointmentAgentSettings'
  | 'deleteAutomation'
  | 'deleteConversation'
  | 'deleteCustomDirectoryEntry'
  | 'deleteCustomLink'
  | 'deleteDepartmentDevice'
  | 'deleteIdentityPromptAddress'
  | 'deleteNoteTaker'
  | 'deleteOutboundCallCustomization'
  | 'deletePhoneLine'
  | 'deletePlace'
  | 'deleteScheduledMessage'
  | 'deleteShortcut'
  | 'deleteStage'
  | 'deleteStatusItem'
  | 'deleteTeam'
  | 'deleteUserPhone'
  | 'deleteVoiceStep'
  | 'disableAutopilot'
  | 'disableFortellisSubscription'
  | 'discardAutomationEdits'
  | 'discardDisruptionVoiceScript'
  | 'discardVoiceScript'
  | 'dismissTask'
  | 'duplicateAppointmentAgentSettings'
  | 'enableInboxLanguageOverride'
  | 'enableNudges'
  | 'enablePlaceMessagingHours'
  | 'endOutboundConferenceCall'
  | 'evaluateBusinessIdentity'
  | 'exportConversationToArchive'
  | 'forceActiveIntegrationSync'
  | 'generateRepairOrderAssistedStatusContent'
  | 'generateRepairOrderNotesSummary'
  | 'generateWriteItForMeContent'
  | 'globalSyncXtimeServices'
  | 'hostedPage'
  | 'hostedSmsCompleted'
  | 'impersonate'
  | 'importHostedSms'
  | 'increaseShortcutCount'
  | 'leaveAllConversations'
  | 'leaveConversations'
  | 'login'
  | 'manualOpportunity'
  | 'mapCrmUserToUser'
  | 'markMessagesRead'
  | 'moveStatusItem'
  | 'pokeUser'
  | 'populateBusinessProfileWithChargebeeInfo'
  | 'portInPhoneLine'
  | 'publishAutomation'
  | 'publishDisruptionVoiceScript'
  | 'publishVoiceScript'
  | 'rateAppointmentAgentNote'
  | 'rateAssistedResponse'
  | 'rateCallIntelligenceSummary'
  | 'rateEngagementStatus'
  | 'rateEngagementSummary'
  | 'recoverConversation'
  | 'refreshCarrierInfo'
  | 'refreshFortellisServiceAdvisors'
  | 'registerFortellisServiceAdvisor'
  | 'removeAutomationAction'
  | 'removeAutomationExitTrigger'
  | 'removeLabelFromConversation'
  | 'removePlaceGroup'
  | 'removeServiceAdvisor'
  | 'removeUserFromPlace'
  | 'removeUserFromTeam'
  | 'removeVideoUploadLink'
  | 'renameAccount'
  | 'renamePlace'
  | 'reopenStatusItem'
  | 'requestAvailableIntegration'
  | 'resetAppointmentAgentSettings'
  | 'resetBrandTheme'
  | 'resetConversationLanguage'
  | 'resetOutboundChannels'
  | 'resetTaskStatus'
  | 'resetVoiceScript'
  | 'sendBroadcast'
  | 'sendLoa'
  | 'sendMessage'
  | 'sendReviewRequest'
  | 'sendScheduledMessageNow'
  | 'sendStatusItemMessage'
  | 'sendVcard'
  | 'setAssignmentRetention'
  | 'setBusinessTimezone'
  | 'setFortellisLookupId'
  | 'setHangupSuggestion'
  | 'setOptInStatus'
  | 'setResetOngoingOptin'
  | 'setResetOptinDays'
  | 'setupEquityTradeOpportunityCampaign'
  | 'snoozeConversation'
  | 'startConversation'
  | 'startConversationWithScheduledMessage'
  | 'submit10DlcStarterProfile'
  | 'submitBusinessIdentity'
  | 'syncXtimeServices'
  | 'teachNuma'
  | 'toggleCustomPhoneLinePolicy'
  | 'toggleOutboundProxyCallRecording'
  | 'unmapCrmUserFromUser'
  | 'updateActiveIntegration'
  | 'updateAllowedSpeechLanguages'
  | 'updateAnsweringScriptOrder'
  | 'updateAppointment'
  | 'updateAppointmentAgentSettingLabel'
  | 'updateAppointmentAgentSettings'
  | 'updateAssignmentRoutingSettings'
  | 'updateAutomation'
  | 'updateAutomationAction'
  | 'updateAutomationEnrollmentCriteria'
  | 'updateAutomationExitTrigger'
  | 'updateAutomationStartTrigger'
  | 'updateAutomationUIHints'
  | 'updateAutopilotEta'
  | 'updateAutopilotJob'
  | 'updateAutopilotScheduledMessage'
  | 'updateAvailableIntegration'
  | 'updateAwayMode'
  | 'updateAwayModeAssignee'
  | 'updateAwayModeManagingPermission'
  | 'updateAwayModeWithTime'
  | 'updateBillingMetadata'
  | 'updateBrandLogo'
  | 'updateBrandTheme'
  | 'updateBusinessIdentity'
  | 'updateBusinessProfile'
  | 'updateCallForwardingStatus'
  | 'updateCallIntelligenceEnabled'
  | 'updateCallIntelligenceSetting'
  | 'updateCampaignStatus'
  | 'updateChannel'
  | 'updateChitchat'
  | 'updateComplianceSettings'
  | 'updateConversationLabel'
  | 'updateConversations'
  | 'updateCurbsideSettings'
  | 'updateCustomDirectoryEntry'
  | 'updateDefaultView'
  | 'updateDefaultYouView'
  | 'updateDepartmentDevice'
  | 'updateDirectoryEntry'
  | 'updateEdgesVoiceStep'
  | 'updateEquityTradeOpportunityStage'
  | 'updateEscalationSettings'
  | 'updateEtoSettings'
  | 'updateGreeting'
  | 'updateHasDismissedGuideChecklist'
  | 'updateHasViewedRefer'
  | 'updateHideSharedInboxViews'
  | 'updateHostedSms'
  | 'updateIsScheduleEnabled'
  | 'updateIsUnassigningInboundMessages'
  | 'updateLabel'
  | 'updateLink'
  | 'updateLinkUrls'
  | 'updateLoggedCall'
  | 'updateLogos'
  | 'updateMissedCallFollowUpSetting'
  | 'updateNamePronunciation'
  | 'updateNewConversationsPerDay'
  | 'updateOperator'
  | 'updateOperatorChannel'
  | 'updateOperatorPlaceDescription'
  | 'updateOperatorPlaceSettings'
  | 'updateOperatorSettings'
  | 'updateOutboundCallCustomization'
  | 'updateOutboundConferenceCall'
  | 'updateParticipant'
  | 'updatePaymentRequestAttachment'
  | 'updatePaymentRequestCustomization'
  | 'updatePhoneCall'
  | 'updatePhoneLine'
  | 'updatePhoneLineLanguageSettings'
  | 'updatePhoneLineName'
  | 'updatePhoneLinePolicy'
  | 'updatePlaceDisruptionSettings'
  | 'updatePlaceGroup'
  | 'updatePlaceInfo'
  | 'updatePlaceMessageSettings'
  | 'updatePlaceMfaSettings'
  | 'updatePlaceOutboundCallSettings'
  | 'updatePlaceQuota'
  | 'updatePlaceStatus'
  | 'updatePlaceVoice'
  | 'updatePublicListing'
  | 'updateQuestionAgentSettings'
  | 'updateReceivesEscalations'
  | 'updateRepairServicesOpCodes'
  | 'updateReviewJob'
  | 'updateServiceAdvisor'
  | 'updateServiceOverride'
  | 'updateShortcut'
  | 'updateShowBannerAfter'
  | 'updateStage'
  | 'updateStatusBoardView'
  | 'updateStatusItem'
  | 'updateSubscription'
  | 'updateTeam'
  | 'updateTransportationSet'
  | 'updateTwilioChannel'
  | 'updateUseNewNumber'
  | 'updateUser'
  | 'updateUserInformation'
  | 'updateUserMfaSettings'
  | 'updateUserPersonalization'
  | 'updateUserPhone'
  | 'updateUserPhonePreference'
  | 'updateUserSchedule'
  | 'updateUserViewPreferences'
  | 'updateVideoUploadLink'
  | 'updateVoiceScript'
  | 'updateVoiceStep'
  | 'updateVoiceStepUIHints'
  | 'updateWriteItForMeConfig'
  | 'uploadCustomAudio'
  | 'uploadCustomOutboundCallAudio'
  | 'upsertConversationRepairOrderSmartStatusUpdateSettings'
  | 'upsertRepairOrderSmartStatusUpdateSettings'
  | 'useAfterHoursGreeting'
  | MutationsKeySpecifier
)[];
export type MutationsFieldPolicy = {
  PubNubAppointmentEnriched?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubArchiveConversation?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubArchiveConversations?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubAssignConversation?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubAwayModeChanged?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubConversationDeleted?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubConversationEngagementUpdated?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  PubNubConversationLanguageReset?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubConversationRecovered?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubDegradedInboxExperienceUpdated?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  PubNubDialogFlowBotDataUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubEquityTradeOpportunityUpdated?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  PubNubInboundCallStatusUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubLabelCreated?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubLabelUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubLeaveConversations?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubMessageReceived?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubMessageSent?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubNumboxAgentSessionUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubOutboundConferenceCallStatusUpdated?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  PubNubOutboundProxyCallStatusUpdated?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  PubNubPaymentRequestCreated?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubPaymentRequestUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubPlaceUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubRestoreConversation?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubRestoreConversations?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubStatusItemCreated?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubStatusItemDeleted?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubStatusItemUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubStripeIntegrationUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubTaskCreated?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubTaskUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubTeamCreated?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubTeamDeleted?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubTeamUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubTranscriptUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  PubNubVideoUploadLinkUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  addAnsweringScriptToPolicy?: FieldPolicy<any> | FieldReadFunction<any>;
  addAutomationExitTrigger?: FieldPolicy<any> | FieldReadFunction<any>;
  addAvailableIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  addCustomLink?: FieldPolicy<any> | FieldReadFunction<any>;
  addCustomer?: FieldPolicy<any> | FieldReadFunction<any>;
  addFortellisSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  addLabelToConversation?: FieldPolicy<any> | FieldReadFunction<any>;
  addOperatorChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  addOperatorPlace?: FieldPolicy<any> | FieldReadFunction<any>;
  addOutboundCallCustomization?: FieldPolicy<any> | FieldReadFunction<any>;
  addPlaceGroup?: FieldPolicy<any> | FieldReadFunction<any>;
  addServiceAdvisor?: FieldPolicy<any> | FieldReadFunction<any>;
  addStage?: FieldPolicy<any> | FieldReadFunction<any>;
  addStatusItem?: FieldPolicy<any> | FieldReadFunction<any>;
  addSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  addUserToTeam?: FieldPolicy<any> | FieldReadFunction<any>;
  addVoiceStep?: FieldPolicy<any> | FieldReadFunction<any>;
  archiveMissedCalls?: FieldPolicy<any> | FieldReadFunction<any>;
  assignConversations?: FieldPolicy<any> | FieldReadFunction<any>;
  buildRepairOrderAssistedStatusQuestionTree?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  buildWriteItForMeQuestionTree?: FieldPolicy<any> | FieldReadFunction<any>;
  bulkUpdateSupportedVehicles?: FieldPolicy<any> | FieldReadFunction<any>;
  cancelPaymentRequest?: FieldPolicy<any> | FieldReadFunction<any>;
  cancelScheduledMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  capturePaymentAmount?: FieldPolicy<any> | FieldReadFunction<any>;
  changeAccountSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  changeAllowCustomAudio?: FieldPolicy<any> | FieldReadFunction<any>;
  changeBusinessVertical?: FieldPolicy<any> | FieldReadFunction<any>;
  changeInboxType?: FieldPolicy<any> | FieldReadFunction<any>;
  changeNotificationSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  changePlaceGroup?: FieldPolicy<any> | FieldReadFunction<any>;
  changePlaceHours?: FieldPolicy<any> | FieldReadFunction<any>;
  changePlaceSubscriptions?: FieldPolicy<any> | FieldReadFunction<any>;
  changeRepairOrderSchedule?: FieldPolicy<any> | FieldReadFunction<any>;
  changeSignupMode?: FieldPolicy<any> | FieldReadFunction<any>;
  changeSwipeActionSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  changeTwilioChannelMdn?: FieldPolicy<any> | FieldReadFunction<any>;
  changeUserPassword?: FieldPolicy<any> | FieldReadFunction<any>;
  changeUserSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  changeUserVideoConferenceUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  closeStatusItem?: FieldPolicy<any> | FieldReadFunction<any>;
  completeAutopilot?: FieldPolicy<any> | FieldReadFunction<any>;
  completeTask?: FieldPolicy<any> | FieldReadFunction<any>;
  connectAutomationAction?: FieldPolicy<any> | FieldReadFunction<any>;
  connectAutomationActionEdge?: FieldPolicy<any> | FieldReadFunction<any>;
  createA2pCampaignForPlace?: FieldPolicy<any> | FieldReadFunction<any>;
  createAppointmentAgentSettingLabel?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createAppointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  createAutomation?: FieldPolicy<any> | FieldReadFunction<any>;
  createAutomationAction?: FieldPolicy<any> | FieldReadFunction<any>;
  createAutomationFromBlueprint?: FieldPolicy<any> | FieldReadFunction<any>;
  createAutopilot?: FieldPolicy<any> | FieldReadFunction<any>;
  createBillingIdentity?: FieldPolicy<any> | FieldReadFunction<any>;
  createCampaign?: FieldPolicy<any> | FieldReadFunction<any>;
  createChatExpansion?: FieldPolicy<any> | FieldReadFunction<any>;
  createChitchat?: FieldPolicy<any> | FieldReadFunction<any>;
  createConversation?: FieldPolicy<any> | FieldReadFunction<any>;
  createConversationSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  createConversationTextExpansion?: FieldPolicy<any> | FieldReadFunction<any>;
  createCustomDirectoryEntry?: FieldPolicy<any> | FieldReadFunction<any>;
  createDepartmentDevice?: FieldPolicy<any> | FieldReadFunction<any>;
  createIdentityPromptAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  createLabel?: FieldPolicy<any> | FieldReadFunction<any>;
  createManualCampaignUpload?: FieldPolicy<any> | FieldReadFunction<any>;
  createNoteTaker?: FieldPolicy<any> | FieldReadFunction<any>;
  createOperator?: FieldPolicy<any> | FieldReadFunction<any>;
  createOutboundConferenceCall?: FieldPolicy<any> | FieldReadFunction<any>;
  createOutboundProxyCall?: FieldPolicy<any> | FieldReadFunction<any>;
  createParticipant?: FieldPolicy<any> | FieldReadFunction<any>;
  createParticipantPaymentRequest?: FieldPolicy<any> | FieldReadFunction<any>;
  createPaymentRequest?: FieldPolicy<any> | FieldReadFunction<any>;
  createPhoneLine?: FieldPolicy<any> | FieldReadFunction<any>;
  createPlace?: FieldPolicy<any> | FieldReadFunction<any>;
  createPortalSession?: FieldPolicy<any> | FieldReadFunction<any>;
  createScheduledMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  createShortcut?: FieldPolicy<any> | FieldReadFunction<any>;
  createStripeAccount?: FieldPolicy<any> | FieldReadFunction<any>;
  createStripeRefund?: FieldPolicy<any> | FieldReadFunction<any>;
  createTaskForEngagement?: FieldPolicy<any> | FieldReadFunction<any>;
  createTeam?: FieldPolicy<any> | FieldReadFunction<any>;
  createTextExpansion?: FieldPolicy<any> | FieldReadFunction<any>;
  createUser?: FieldPolicy<any> | FieldReadFunction<any>;
  createUserPhone?: FieldPolicy<any> | FieldReadFunction<any>;
  createVideoUploadLink?: FieldPolicy<any> | FieldReadFunction<any>;
  deactivateAccount?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteAppointmentAgentSettingLabel?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  deleteAppointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteAutomation?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteConversation?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteCustomDirectoryEntry?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteCustomLink?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteDepartmentDevice?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteIdentityPromptAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteNoteTaker?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteOutboundCallCustomization?: FieldPolicy<any> | FieldReadFunction<any>;
  deletePhoneLine?: FieldPolicy<any> | FieldReadFunction<any>;
  deletePlace?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteScheduledMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteShortcut?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteStage?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteStatusItem?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteTeam?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteUserPhone?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteVoiceStep?: FieldPolicy<any> | FieldReadFunction<any>;
  disableAutopilot?: FieldPolicy<any> | FieldReadFunction<any>;
  disableFortellisSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  discardAutomationEdits?: FieldPolicy<any> | FieldReadFunction<any>;
  discardDisruptionVoiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  discardVoiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  dismissTask?: FieldPolicy<any> | FieldReadFunction<any>;
  duplicateAppointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  enableInboxLanguageOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  enableNudges?: FieldPolicy<any> | FieldReadFunction<any>;
  enablePlaceMessagingHours?: FieldPolicy<any> | FieldReadFunction<any>;
  endOutboundConferenceCall?: FieldPolicy<any> | FieldReadFunction<any>;
  evaluateBusinessIdentity?: FieldPolicy<any> | FieldReadFunction<any>;
  exportConversationToArchive?: FieldPolicy<any> | FieldReadFunction<any>;
  forceActiveIntegrationSync?: FieldPolicy<any> | FieldReadFunction<any>;
  generateRepairOrderAssistedStatusContent?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  generateRepairOrderNotesSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  generateWriteItForMeContent?: FieldPolicy<any> | FieldReadFunction<any>;
  globalSyncXtimeServices?: FieldPolicy<any> | FieldReadFunction<any>;
  hostedPage?: FieldPolicy<any> | FieldReadFunction<any>;
  hostedSmsCompleted?: FieldPolicy<any> | FieldReadFunction<any>;
  impersonate?: FieldPolicy<any> | FieldReadFunction<any>;
  importHostedSms?: FieldPolicy<any> | FieldReadFunction<any>;
  increaseShortcutCount?: FieldPolicy<any> | FieldReadFunction<any>;
  leaveAllConversations?: FieldPolicy<any> | FieldReadFunction<any>;
  leaveConversations?: FieldPolicy<any> | FieldReadFunction<any>;
  login?: FieldPolicy<any> | FieldReadFunction<any>;
  manualOpportunity?: FieldPolicy<any> | FieldReadFunction<any>;
  mapCrmUserToUser?: FieldPolicy<any> | FieldReadFunction<any>;
  markMessagesRead?: FieldPolicy<any> | FieldReadFunction<any>;
  moveStatusItem?: FieldPolicy<any> | FieldReadFunction<any>;
  pokeUser?: FieldPolicy<any> | FieldReadFunction<any>;
  populateBusinessProfileWithChargebeeInfo?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  portInPhoneLine?: FieldPolicy<any> | FieldReadFunction<any>;
  publishAutomation?: FieldPolicy<any> | FieldReadFunction<any>;
  publishDisruptionVoiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  publishVoiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  rateAppointmentAgentNote?: FieldPolicy<any> | FieldReadFunction<any>;
  rateAssistedResponse?: FieldPolicy<any> | FieldReadFunction<any>;
  rateCallIntelligenceSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  rateEngagementStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  rateEngagementSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  recoverConversation?: FieldPolicy<any> | FieldReadFunction<any>;
  refreshCarrierInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  refreshFortellisServiceAdvisors?: FieldPolicy<any> | FieldReadFunction<any>;
  registerFortellisServiceAdvisor?: FieldPolicy<any> | FieldReadFunction<any>;
  removeAutomationAction?: FieldPolicy<any> | FieldReadFunction<any>;
  removeAutomationExitTrigger?: FieldPolicy<any> | FieldReadFunction<any>;
  removeLabelFromConversation?: FieldPolicy<any> | FieldReadFunction<any>;
  removePlaceGroup?: FieldPolicy<any> | FieldReadFunction<any>;
  removeServiceAdvisor?: FieldPolicy<any> | FieldReadFunction<any>;
  removeUserFromPlace?: FieldPolicy<any> | FieldReadFunction<any>;
  removeUserFromTeam?: FieldPolicy<any> | FieldReadFunction<any>;
  removeVideoUploadLink?: FieldPolicy<any> | FieldReadFunction<any>;
  renameAccount?: FieldPolicy<any> | FieldReadFunction<any>;
  renamePlace?: FieldPolicy<any> | FieldReadFunction<any>;
  reopenStatusItem?: FieldPolicy<any> | FieldReadFunction<any>;
  requestAvailableIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  resetAppointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  resetBrandTheme?: FieldPolicy<any> | FieldReadFunction<any>;
  resetConversationLanguage?: FieldPolicy<any> | FieldReadFunction<any>;
  resetOutboundChannels?: FieldPolicy<any> | FieldReadFunction<any>;
  resetTaskStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  resetVoiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  sendBroadcast?: FieldPolicy<any> | FieldReadFunction<any>;
  sendLoa?: FieldPolicy<any> | FieldReadFunction<any>;
  sendMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  sendReviewRequest?: FieldPolicy<any> | FieldReadFunction<any>;
  sendScheduledMessageNow?: FieldPolicy<any> | FieldReadFunction<any>;
  sendStatusItemMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  sendVcard?: FieldPolicy<any> | FieldReadFunction<any>;
  setAssignmentRetention?: FieldPolicy<any> | FieldReadFunction<any>;
  setBusinessTimezone?: FieldPolicy<any> | FieldReadFunction<any>;
  setFortellisLookupId?: FieldPolicy<any> | FieldReadFunction<any>;
  setHangupSuggestion?: FieldPolicy<any> | FieldReadFunction<any>;
  setOptInStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  setResetOngoingOptin?: FieldPolicy<any> | FieldReadFunction<any>;
  setResetOptinDays?: FieldPolicy<any> | FieldReadFunction<any>;
  setupEquityTradeOpportunityCampaign?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  snoozeConversation?: FieldPolicy<any> | FieldReadFunction<any>;
  startConversation?: FieldPolicy<any> | FieldReadFunction<any>;
  startConversationWithScheduledMessage?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  submit10DlcStarterProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  submitBusinessIdentity?: FieldPolicy<any> | FieldReadFunction<any>;
  syncXtimeServices?: FieldPolicy<any> | FieldReadFunction<any>;
  teachNuma?: FieldPolicy<any> | FieldReadFunction<any>;
  toggleCustomPhoneLinePolicy?: FieldPolicy<any> | FieldReadFunction<any>;
  toggleOutboundProxyCallRecording?: FieldPolicy<any> | FieldReadFunction<any>;
  unmapCrmUserFromUser?: FieldPolicy<any> | FieldReadFunction<any>;
  updateActiveIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAllowedSpeechLanguages?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAnsweringScriptOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAppointment?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAppointmentAgentSettingLabel?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  updateAppointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAssignmentRoutingSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAutomation?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAutomationAction?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAutomationEnrollmentCriteria?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  updateAutomationExitTrigger?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAutomationStartTrigger?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAutomationUIHints?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAutopilotEta?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAutopilotJob?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAutopilotScheduledMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAvailableIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAwayMode?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAwayModeAssignee?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAwayModeManagingPermission?: FieldPolicy<any> | FieldReadFunction<any>;
  updateAwayModeWithTime?: FieldPolicy<any> | FieldReadFunction<any>;
  updateBillingMetadata?: FieldPolicy<any> | FieldReadFunction<any>;
  updateBrandLogo?: FieldPolicy<any> | FieldReadFunction<any>;
  updateBrandTheme?: FieldPolicy<any> | FieldReadFunction<any>;
  updateBusinessIdentity?: FieldPolicy<any> | FieldReadFunction<any>;
  updateBusinessProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCallForwardingStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCallIntelligenceEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCallIntelligenceSetting?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCampaignStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  updateChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateChitchat?: FieldPolicy<any> | FieldReadFunction<any>;
  updateComplianceSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updateConversationLabel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateConversations?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCurbsideSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCustomDirectoryEntry?: FieldPolicy<any> | FieldReadFunction<any>;
  updateDefaultView?: FieldPolicy<any> | FieldReadFunction<any>;
  updateDefaultYouView?: FieldPolicy<any> | FieldReadFunction<any>;
  updateDepartmentDevice?: FieldPolicy<any> | FieldReadFunction<any>;
  updateDirectoryEntry?: FieldPolicy<any> | FieldReadFunction<any>;
  updateEdgesVoiceStep?: FieldPolicy<any> | FieldReadFunction<any>;
  updateEquityTradeOpportunityStage?: FieldPolicy<any> | FieldReadFunction<any>;
  updateEscalationSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updateEtoSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updateGreeting?: FieldPolicy<any> | FieldReadFunction<any>;
  updateHasDismissedGuideChecklist?: FieldPolicy<any> | FieldReadFunction<any>;
  updateHasViewedRefer?: FieldPolicy<any> | FieldReadFunction<any>;
  updateHideSharedInboxViews?: FieldPolicy<any> | FieldReadFunction<any>;
  updateHostedSms?: FieldPolicy<any> | FieldReadFunction<any>;
  updateIsScheduleEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  updateIsUnassigningInboundMessages?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  updateLabel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateLink?: FieldPolicy<any> | FieldReadFunction<any>;
  updateLinkUrls?: FieldPolicy<any> | FieldReadFunction<any>;
  updateLoggedCall?: FieldPolicy<any> | FieldReadFunction<any>;
  updateLogos?: FieldPolicy<any> | FieldReadFunction<any>;
  updateMissedCallFollowUpSetting?: FieldPolicy<any> | FieldReadFunction<any>;
  updateNamePronunciation?: FieldPolicy<any> | FieldReadFunction<any>;
  updateNewConversationsPerDay?: FieldPolicy<any> | FieldReadFunction<any>;
  updateOperator?: FieldPolicy<any> | FieldReadFunction<any>;
  updateOperatorChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateOperatorPlaceDescription?: FieldPolicy<any> | FieldReadFunction<any>;
  updateOperatorPlaceSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updateOperatorSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updateOutboundCallCustomization?: FieldPolicy<any> | FieldReadFunction<any>;
  updateOutboundConferenceCall?: FieldPolicy<any> | FieldReadFunction<any>;
  updateParticipant?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePaymentRequestAttachment?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePaymentRequestCustomization?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePhoneCall?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePhoneLine?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePhoneLineLanguageSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePhoneLineName?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePhoneLinePolicy?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePlaceDisruptionSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePlaceGroup?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePlaceInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePlaceMessageSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePlaceMfaSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePlaceOutboundCallSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePlaceQuota?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePlaceStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePlaceVoice?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePublicListing?: FieldPolicy<any> | FieldReadFunction<any>;
  updateQuestionAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updateReceivesEscalations?: FieldPolicy<any> | FieldReadFunction<any>;
  updateRepairServicesOpCodes?: FieldPolicy<any> | FieldReadFunction<any>;
  updateReviewJob?: FieldPolicy<any> | FieldReadFunction<any>;
  updateServiceAdvisor?: FieldPolicy<any> | FieldReadFunction<any>;
  updateServiceOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  updateShortcut?: FieldPolicy<any> | FieldReadFunction<any>;
  updateShowBannerAfter?: FieldPolicy<any> | FieldReadFunction<any>;
  updateStage?: FieldPolicy<any> | FieldReadFunction<any>;
  updateStatusBoardView?: FieldPolicy<any> | FieldReadFunction<any>;
  updateStatusItem?: FieldPolicy<any> | FieldReadFunction<any>;
  updateSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  updateTeam?: FieldPolicy<any> | FieldReadFunction<any>;
  updateTransportationSet?: FieldPolicy<any> | FieldReadFunction<any>;
  updateTwilioChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  updateUseNewNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  updateUser?: FieldPolicy<any> | FieldReadFunction<any>;
  updateUserInformation?: FieldPolicy<any> | FieldReadFunction<any>;
  updateUserMfaSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  updateUserPersonalization?: FieldPolicy<any> | FieldReadFunction<any>;
  updateUserPhone?: FieldPolicy<any> | FieldReadFunction<any>;
  updateUserPhonePreference?: FieldPolicy<any> | FieldReadFunction<any>;
  updateUserSchedule?: FieldPolicy<any> | FieldReadFunction<any>;
  updateUserViewPreferences?: FieldPolicy<any> | FieldReadFunction<any>;
  updateVideoUploadLink?: FieldPolicy<any> | FieldReadFunction<any>;
  updateVoiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  updateVoiceStep?: FieldPolicy<any> | FieldReadFunction<any>;
  updateVoiceStepUIHints?: FieldPolicy<any> | FieldReadFunction<any>;
  updateWriteItForMeConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadCustomAudio?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadCustomOutboundCallAudio?: FieldPolicy<any> | FieldReadFunction<any>;
  upsertConversationRepairOrderSmartStatusUpdateSettings?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  upsertRepairOrderSmartStatusUpdateSettings?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  useAfterHoursGreeting?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NodeKeySpecifier = ('id' | NodeKeySpecifier)[];
export type NodeFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NoteAttachmentKeySpecifier = (
  | 'attachmentType'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'message'
  | 'messageId'
  | 'note'
  | 'url'
  | NoteAttachmentKeySpecifier
)[];
export type NoteAttachmentFieldPolicy = {
  attachmentType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  messageId?: FieldPolicy<any> | FieldReadFunction<any>;
  note?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NoteChannelQLKeySpecifier = (
  | 'Assignee'
  | 'AssigneeId'
  | 'RespectExistingAssignments'
  | 'Team'
  | 'TeamId'
  | 'account'
  | 'accountId'
  | 'assignTextReplies'
  | 'assignee'
  | 'assigneeId'
  | 'channelType'
  | 'createdOn'
  | 'id'
  | 'identityPromptAddresses'
  | 'identityPromptOption'
  | 'isActive'
  | 'isBotEnabled'
  | 'isNryChannel'
  | 'lastUpdated'
  | 'messages'
  | 'name'
  | 'operator'
  | 'operatorId'
  | 'operatorSessions'
  | 'outboundConferenceCall'
  | 'outboundProxyCall'
  | 'phonecalls'
  | 'place'
  | 'placeId'
  | 'respectExistingAssignments'
  | 'scheduled'
  | 'smsChannel'
  | 'smsPhonelines'
  | 'supportsVoicemail'
  | 'team'
  | 'teamId'
  | 'userId'
  | NoteChannelQLKeySpecifier
)[];
export type NoteChannelQLFieldPolicy = {
  Assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  AssigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  RespectExistingAssignments?: FieldPolicy<any> | FieldReadFunction<any>;
  Team?: FieldPolicy<any> | FieldReadFunction<any>;
  TeamId?: FieldPolicy<any> | FieldReadFunction<any>;
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  assignTextReplies?: FieldPolicy<any> | FieldReadFunction<any>;
  assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  assigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  channelType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptAddresses?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptOption?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isBotEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  isNryChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorId?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSessions?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundConferenceCall?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundProxyCall?: FieldPolicy<any> | FieldReadFunction<any>;
  phonecalls?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  respectExistingAssignments?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduled?: FieldPolicy<any> | FieldReadFunction<any>;
  smsChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  smsPhonelines?: FieldPolicy<any> | FieldReadFunction<any>;
  supportsVoicemail?: FieldPolicy<any> | FieldReadFunction<any>;
  team?: FieldPolicy<any> | FieldReadFunction<any>;
  teamId?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NoteTakerConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | NoteTakerConnectionKeySpecifier
)[];
export type NoteTakerConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NoteTakerEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | NoteTakerEdgeKeySpecifier
)[];
export type NoteTakerEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NoteTakerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'noteTakerSteps'
  | 'place'
  | 'placeId'
  | 'settings'
  | NoteTakerQLKeySpecifier
)[];
export type NoteTakerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  settings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NoteTakerQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | NoteTakerQLConnectionKeySpecifier
)[];
export type NoteTakerQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NoteTakerQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | NoteTakerQLEdgeKeySpecifier
)[];
export type NoteTakerQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NoteTakerStepQLKeySpecifier = (
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'failureStepId'
  | 'failureStepRelationship'
  | 'finishedSpeech'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'nextStepId'
  | 'nextStepRelationship'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTaker'
  | 'noteTakerId'
  | 'noteTakerSteps'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | NoteTakerStepQLKeySpecifier
)[];
export type NoteTakerStepQLFieldPolicy = {
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  failureStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  finishedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTaker?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerId?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NoteTakerStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | NoteTakerStepQLConnectionKeySpecifier
)[];
export type NoteTakerStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NoteTakerStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | NoteTakerStepQLEdgeKeySpecifier
)[];
export type NoteTakerStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NotifyTeamMemberActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'desiredConversationState'
  | 'id'
  | 'lastUpdated'
  | 'messageToSend'
  | 'nextActionId'
  | 'notifyOwner'
  | 'teamIdsMentioned'
  | 'uiHints'
  | 'userIdsMentioned'
  | NotifyTeamMemberActionQLKeySpecifier
)[];
export type NotifyTeamMemberActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  desiredConversationState?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messageToSend?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  notifyOwner?: FieldPolicy<any> | FieldReadFunction<any>;
  teamIdsMentioned?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  userIdsMentioned?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NumaServiceQLKeySpecifier = (
  | 'createdOn'
  | 'description'
  | 'howIsHandled'
  | 'id'
  | 'lastUpdated'
  | 'manualCodeSelection'
  | 'name'
  | NumaServiceQLKeySpecifier
)[];
export type NumaServiceQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  howIsHandled?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  manualCodeSelection?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NumboxAgentSessionQLKeySpecifier = (
  | 'appointment'
  | 'appointmentId'
  | 'conversationalSchedulingAgentStep'
  | 'conversationalSchedulingAgentStepId'
  | 'covalRunId'
  | 'createdOn'
  | 'endTime'
  | 'id'
  | 'lastUpdated'
  | 'messages'
  | 'operatorSession'
  | 'operatorSessionId'
  | 'outcome'
  | 'phonecall'
  | 'phonecallId'
  | 'sessionRecording'
  | 'sessionRecordingId'
  | 'slots'
  | 'startTime'
  | 'summary'
  | 'taskId'
  | NumboxAgentSessionQLKeySpecifier
)[];
export type NumboxAgentSessionQLFieldPolicy = {
  appointment?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentId?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentStep?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentStepId?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  covalRunId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  endTime?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSession?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSessionId?: FieldPolicy<any> | FieldReadFunction<any>;
  outcome?: FieldPolicy<any> | FieldReadFunction<any>;
  phonecall?: FieldPolicy<any> | FieldReadFunction<any>;
  phonecallId?: FieldPolicy<any> | FieldReadFunction<any>;
  sessionRecording?: FieldPolicy<any> | FieldReadFunction<any>;
  sessionRecordingId?: FieldPolicy<any> | FieldReadFunction<any>;
  slots?: FieldPolicy<any> | FieldReadFunction<any>;
  startTime?: FieldPolicy<any> | FieldReadFunction<any>;
  summary?: FieldPolicy<any> | FieldReadFunction<any>;
  taskId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NumboxAgentSessionQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | NumboxAgentSessionQLConnectionKeySpecifier
)[];
export type NumboxAgentSessionQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NumboxAgentSessionQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | NumboxAgentSessionQLEdgeKeySpecifier
)[];
export type NumboxAgentSessionQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NumboxChannelQLKeySpecifier = (
  | 'Assignee'
  | 'AssigneeId'
  | 'RespectExistingAssignments'
  | 'Team'
  | 'TeamId'
  | 'account'
  | 'accountId'
  | 'assignTextReplies'
  | 'assignee'
  | 'assigneeId'
  | 'channelType'
  | 'createdOn'
  | 'id'
  | 'identityPromptAddresses'
  | 'identityPromptOption'
  | 'isActive'
  | 'isBotEnabled'
  | 'isNryChannel'
  | 'lastUpdated'
  | 'messages'
  | 'name'
  | 'operator'
  | 'operatorId'
  | 'operatorSessions'
  | 'outboundConferenceCall'
  | 'outboundProxyCall'
  | 'phonecalls'
  | 'place'
  | 'placeId'
  | 'respectExistingAssignments'
  | 'scheduled'
  | 'smsChannel'
  | 'smsPhonelines'
  | 'supportsVoicemail'
  | 'team'
  | 'teamId'
  | 'userId'
  | NumboxChannelQLKeySpecifier
)[];
export type NumboxChannelQLFieldPolicy = {
  Assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  AssigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  RespectExistingAssignments?: FieldPolicy<any> | FieldReadFunction<any>;
  Team?: FieldPolicy<any> | FieldReadFunction<any>;
  TeamId?: FieldPolicy<any> | FieldReadFunction<any>;
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  assignTextReplies?: FieldPolicy<any> | FieldReadFunction<any>;
  assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  assigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  channelType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptAddresses?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptOption?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isBotEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  isNryChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorId?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSessions?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundConferenceCall?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundProxyCall?: FieldPolicy<any> | FieldReadFunction<any>;
  phonecalls?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  respectExistingAssignments?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduled?: FieldPolicy<any> | FieldReadFunction<any>;
  smsChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  smsPhonelines?: FieldPolicy<any> | FieldReadFunction<any>;
  supportsVoicemail?: FieldPolicy<any> | FieldReadFunction<any>;
  team?: FieldPolicy<any> | FieldReadFunction<any>;
  teamId?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ObjectionKeySpecifier = (
  | 'objection'
  | 'resolution'
  | ObjectionKeySpecifier
)[];
export type ObjectionFieldPolicy = {
  objection?: FieldPolicy<any> | FieldReadFunction<any>;
  resolution?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OpCodeQLKeySpecifier = (
  | 'activeIntegration'
  | 'activeIntegrationId'
  | 'correctionCode'
  | 'createdOn'
  | 'description'
  | 'dmsId'
  | 'duration'
  | 'flatCostRate'
  | 'flatHours'
  | 'flatSellRate'
  | 'id'
  | 'lastUpdated'
  | 'rawData'
  | 'repairServices'
  | 'supportedVehiclesOpcodes'
  | 'xtimeLogs'
  | OpCodeQLKeySpecifier
)[];
export type OpCodeQLFieldPolicy = {
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  correctionCode?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  dmsId?: FieldPolicy<any> | FieldReadFunction<any>;
  duration?: FieldPolicy<any> | FieldReadFunction<any>;
  flatCostRate?: FieldPolicy<any> | FieldReadFunction<any>;
  flatHours?: FieldPolicy<any> | FieldReadFunction<any>;
  flatSellRate?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  rawData?: FieldPolicy<any> | FieldReadFunction<any>;
  repairServices?: FieldPolicy<any> | FieldReadFunction<any>;
  supportedVehiclesOpcodes?: FieldPolicy<any> | FieldReadFunction<any>;
  xtimeLogs?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OpCodeQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | OpCodeQLConnectionKeySpecifier
)[];
export type OpCodeQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OpCodeQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | OpCodeQLEdgeKeySpecifier
)[];
export type OpCodeQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OpCodesFilterKeySpecifier = (
  | 'category'
  | 'code'
  | OpCodesFilterKeySpecifier
)[];
export type OpCodesFilterFieldPolicy = {
  category?: FieldPolicy<any> | FieldReadFunction<any>;
  code?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OpcodeOutputQLKeySpecifier = (
  | 'dmsId'
  | 'serviceName'
  | OpcodeOutputQLKeySpecifier
)[];
export type OpcodeOutputQLFieldPolicy = {
  dmsId?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OpenVoiceQuestionAttachmentKeySpecifier = (
  | 'attachmentType'
  | 'createdOn'
  | 'filename'
  | 'id'
  | 'lastUpdated'
  | 'message'
  | 'messageId'
  | 'primaryMimetype'
  | 'shorthandPrompt'
  | 'sizeBytes'
  | 'url'
  | 'words'
  | OpenVoiceQuestionAttachmentKeySpecifier
)[];
export type OpenVoiceQuestionAttachmentFieldPolicy = {
  attachmentType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  filename?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  messageId?: FieldPolicy<any> | FieldReadFunction<any>;
  primaryMimetype?: FieldPolicy<any> | FieldReadFunction<any>;
  shorthandPrompt?: FieldPolicy<any> | FieldReadFunction<any>;
  sizeBytes?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
  words?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OperatorAgentStepQLKeySpecifier = (
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'nextStepId'
  | 'nextStepRelationship'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operator'
  | 'operatorAgentSteps'
  | 'operatorId'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | OperatorAgentStepQLKeySpecifier
)[];
export type OperatorAgentStepQLFieldPolicy = {
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorId?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OperatorAgentStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | OperatorAgentStepQLConnectionKeySpecifier
)[];
export type OperatorAgentStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OperatorAgentStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | OperatorAgentStepQLEdgeKeySpecifier
)[];
export type OperatorAgentStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OperatorChannelQLKeySpecifier = (
  | 'channel'
  | 'channelId'
  | 'createdOn'
  | 'description'
  | 'id'
  | 'lastUpdated'
  | 'operator'
  | 'operatorId'
  | 'settings'
  | OperatorChannelQLKeySpecifier
)[];
export type OperatorChannelQLFieldPolicy = {
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
  channelId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorId?: FieldPolicy<any> | FieldReadFunction<any>;
  settings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OperatorPlaceQLKeySpecifier = (
  | 'createdOn'
  | 'description'
  | 'id'
  | 'lastUpdated'
  | 'operator'
  | 'operatorId'
  | 'place'
  | 'placeId'
  | 'settings'
  | OperatorPlaceQLKeySpecifier
)[];
export type OperatorPlaceQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorId?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  settings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OperatorQLKeySpecifier = (
  | 'account'
  | 'accountId'
  | 'channels'
  | 'createdOn'
  | 'dealershipInfoBlob'
  | 'faq'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'operatorFaq'
  | 'operatorSessions'
  | 'operatorSettings'
  | 'operatorSettingsId'
  | 'places'
  | 'spokenGreetingName'
  | OperatorQLKeySpecifier
)[];
export type OperatorQLFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  channels?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  dealershipInfoBlob?: FieldPolicy<any> | FieldReadFunction<any>;
  faq?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorFaq?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSessions?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSettingsId?: FieldPolicy<any> | FieldReadFunction<any>;
  places?: FieldPolicy<any> | FieldReadFunction<any>;
  spokenGreetingName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OperatorQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | OperatorQLConnectionKeySpecifier
)[];
export type OperatorQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OperatorQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | OperatorQLEdgeKeySpecifier
)[];
export type OperatorQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OperatorSessionConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | 'totalCount'
  | OperatorSessionConnectionKeySpecifier
)[];
export type OperatorSessionConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OperatorSessionEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | OperatorSessionEdgeKeySpecifier
)[];
export type OperatorSessionEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OperatorSessionQLKeySpecifier = (
  | 'callDuration'
  | 'callRecording'
  | 'callRecordingId'
  | 'callSid'
  | 'channel'
  | 'channelId'
  | 'covalRunId'
  | 'createdOn'
  | 'endTime'
  | 'id'
  | 'isActive'
  | 'lastUpdated'
  | 'numboxAgentSessions'
  | 'operator'
  | 'operatorId'
  | 'operatorTranscript'
  | 'operatorTranscriptId'
  | 'outcome'
  | 'participant'
  | 'participantId'
  | 'phonecall'
  | 'phonecallId'
  | 'slots'
  | 'startTime'
  | 'summary'
  | 'transferredToMdn'
  | 'transferredToName'
  | OperatorSessionQLKeySpecifier
)[];
export type OperatorSessionQLFieldPolicy = {
  callDuration?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecording?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingId?: FieldPolicy<any> | FieldReadFunction<any>;
  callSid?: FieldPolicy<any> | FieldReadFunction<any>;
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
  channelId?: FieldPolicy<any> | FieldReadFunction<any>;
  covalRunId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  endTime?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  numboxAgentSessions?: FieldPolicy<any> | FieldReadFunction<any>;
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorId?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorTranscript?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorTranscriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  outcome?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  participantId?: FieldPolicy<any> | FieldReadFunction<any>;
  phonecall?: FieldPolicy<any> | FieldReadFunction<any>;
  phonecallId?: FieldPolicy<any> | FieldReadFunction<any>;
  slots?: FieldPolicy<any> | FieldReadFunction<any>;
  startTime?: FieldPolicy<any> | FieldReadFunction<any>;
  summary?: FieldPolicy<any> | FieldReadFunction<any>;
  transferredToMdn?: FieldPolicy<any> | FieldReadFunction<any>;
  transferredToName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OperatorSessionQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | OperatorSessionQLConnectionKeySpecifier
)[];
export type OperatorSessionQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OperatorSessionQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | OperatorSessionQLEdgeKeySpecifier
)[];
export type OperatorSessionQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OperatorSettingsQLKeySpecifier = (
  | 'appointmentAgentSettings'
  | 'appointmentAgentSettingsId'
  | 'createdOn'
  | 'enableEvaluation'
  | 'id'
  | 'lastUpdated'
  | 'operator'
  | 'settings'
  | 'voiceId'
  | 'voiceProvider'
  | OperatorSettingsQLKeySpecifier
)[];
export type OperatorSettingsQLFieldPolicy = {
  appointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSettingsId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  enableEvaluation?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  settings?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceId?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceProvider?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OperatorTranscriptQLKeySpecifier = (
  | 'createdOn'
  | 'events'
  | 'id'
  | 'lastUpdated'
  | 'operatorSession'
  | OperatorTranscriptQLKeySpecifier
)[];
export type OperatorTranscriptQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  events?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSession?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OpportunityInfoKeySpecifier = (
  | 'closeReason'
  | 'createIfNotExists'
  | 'reason'
  | 'stage'
  | 'type'
  | OpportunityInfoKeySpecifier
)[];
export type OpportunityInfoFieldPolicy = {
  closeReason?: FieldPolicy<any> | FieldReadFunction<any>;
  createIfNotExists?: FieldPolicy<any> | FieldReadFunction<any>;
  reason?: FieldPolicy<any> | FieldReadFunction<any>;
  stage?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OpportunityServiceAppointmentConfirmationTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'triggerType'
  | 'uiHints'
  | OpportunityServiceAppointmentConfirmationTriggerQLKeySpecifier
)[];
export type OpportunityServiceAppointmentConfirmationTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OpportunityServiceAppointmentReminderTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'triggerType'
  | 'uiHints'
  | OpportunityServiceAppointmentReminderTriggerQLKeySpecifier
)[];
export type OpportunityServiceAppointmentReminderTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrderQLKeySpecifier = ('status' | OrderQLKeySpecifier)[];
export type OrderQLFieldPolicy = {
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OutboundCallCustomizationQLKeySpecifier = (
  | 'createdOn'
  | 'customAudioOverrides'
  | 'disclosureSpeech'
  | 'disclosureSpeechUrl'
  | 'hostNoAnswerSpeech'
  | 'hostNoAnswerSpeechUrl'
  | 'id'
  | 'lastUpdated'
  | 'leaveVoicemail'
  | 'outboundConferenceCalls'
  | 'renderedDisclosureSpeech'
  | 'renderedHostNoAnswerSpeech'
  | 'renderedVoicemailSpeech'
  | 'user'
  | 'userId'
  | 'voice'
  | 'voicemailSpeech'
  | 'voicemailSpeechUrl'
  | OutboundCallCustomizationQLKeySpecifier
)[];
export type OutboundCallCustomizationQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  disclosureSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  disclosureSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  hostNoAnswerSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  hostNoAnswerSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  leaveVoicemail?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundConferenceCalls?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedDisclosureSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedHostNoAnswerSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedVoicemailSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
  voice?: FieldPolicy<any> | FieldReadFunction<any>;
  voicemailSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  voicemailSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OutboundCallCustomizationQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | OutboundCallCustomizationQLConnectionKeySpecifier
)[];
export type OutboundCallCustomizationQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OutboundCallCustomizationQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | OutboundCallCustomizationQLEdgeKeySpecifier
)[];
export type OutboundCallCustomizationQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OutboundCallSettingQLKeySpecifier = (
  | 'id'
  | 'mdn'
  | OutboundCallSettingQLKeySpecifier
)[];
export type OutboundCallSettingQLFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  mdn?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OutboundConferenceCallQLKeySpecifier = (
  | 'amdAnsweredBy'
  | 'amdDurationMs'
  | 'answeredByVoicemail'
  | 'callDuration'
  | 'callRecording'
  | 'callRecordingId'
  | 'callSid'
  | 'callStatus'
  | 'caller'
  | 'callerId'
  | 'channel'
  | 'channelId'
  | 'conversation'
  | 'conversationId'
  | 'createdOn'
  | 'endTime'
  | 'hasCallAssist'
  | 'hostConnectedTo'
  | 'hostMdn'
  | 'hostSipAddress'
  | 'id'
  | 'isBeingRecorded'
  | 'isCallIntelligenceEligible'
  | 'lastUpdated'
  | 'leaveVoicemail'
  | 'message'
  | 'messageId'
  | 'outboundCallCustomization'
  | 'outboundCallCustomizationId'
  | 'outboundCallSid'
  | 'place'
  | 'placeId'
  | 'recipientDisplayName'
  | 'recipientMdn'
  | 'startTime'
  | 'transcript'
  | 'transcriptId'
  | 'userDevice'
  | 'userDeviceId'
  | OutboundConferenceCallQLKeySpecifier
)[];
export type OutboundConferenceCallQLFieldPolicy = {
  amdAnsweredBy?: FieldPolicy<any> | FieldReadFunction<any>;
  amdDurationMs?: FieldPolicy<any> | FieldReadFunction<any>;
  answeredByVoicemail?: FieldPolicy<any> | FieldReadFunction<any>;
  callDuration?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecording?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingId?: FieldPolicy<any> | FieldReadFunction<any>;
  callSid?: FieldPolicy<any> | FieldReadFunction<any>;
  callStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  caller?: FieldPolicy<any> | FieldReadFunction<any>;
  callerId?: FieldPolicy<any> | FieldReadFunction<any>;
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
  channelId?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  endTime?: FieldPolicy<any> | FieldReadFunction<any>;
  hasCallAssist?: FieldPolicy<any> | FieldReadFunction<any>;
  hostConnectedTo?: FieldPolicy<any> | FieldReadFunction<any>;
  hostMdn?: FieldPolicy<any> | FieldReadFunction<any>;
  hostSipAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isBeingRecorded?: FieldPolicy<any> | FieldReadFunction<any>;
  isCallIntelligenceEligible?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  leaveVoicemail?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  messageId?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundCallCustomization?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundCallCustomizationId?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundCallSid?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  recipientDisplayName?: FieldPolicy<any> | FieldReadFunction<any>;
  recipientMdn?: FieldPolicy<any> | FieldReadFunction<any>;
  startTime?: FieldPolicy<any> | FieldReadFunction<any>;
  transcript?: FieldPolicy<any> | FieldReadFunction<any>;
  transcriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  userDevice?: FieldPolicy<any> | FieldReadFunction<any>;
  userDeviceId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OutboundConferenceCallQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | OutboundConferenceCallQLConnectionKeySpecifier
)[];
export type OutboundConferenceCallQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OutboundConferenceCallQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | OutboundConferenceCallQLEdgeKeySpecifier
)[];
export type OutboundConferenceCallQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OutboundProxyCallQLKeySpecifier = (
  | 'callDuration'
  | 'callRecording'
  | 'callRecordingId'
  | 'callSid'
  | 'callStatus'
  | 'caller'
  | 'callerId'
  | 'channel'
  | 'channelId'
  | 'conversation'
  | 'conversationId'
  | 'createdOn'
  | 'endtime'
  | 'id'
  | 'isBeingRecorded'
  | 'lastUpdated'
  | 'mdnWithCode'
  | 'message'
  | 'messageId'
  | 'outboundCallSid'
  | 'outboundProxyNumber'
  | 'outboundProxyNumberId'
  | 'pinCode'
  | 'place'
  | 'placeId'
  | 'recipientMdn'
  | 'startTime'
  | 'transcript'
  | 'transcriptId'
  | OutboundProxyCallQLKeySpecifier
)[];
export type OutboundProxyCallQLFieldPolicy = {
  callDuration?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecording?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingId?: FieldPolicy<any> | FieldReadFunction<any>;
  callSid?: FieldPolicy<any> | FieldReadFunction<any>;
  callStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  caller?: FieldPolicy<any> | FieldReadFunction<any>;
  callerId?: FieldPolicy<any> | FieldReadFunction<any>;
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
  channelId?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  endtime?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isBeingRecorded?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  mdnWithCode?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  messageId?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundCallSid?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundProxyNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundProxyNumberId?: FieldPolicy<any> | FieldReadFunction<any>;
  pinCode?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  recipientMdn?: FieldPolicy<any> | FieldReadFunction<any>;
  startTime?: FieldPolicy<any> | FieldReadFunction<any>;
  transcript?: FieldPolicy<any> | FieldReadFunction<any>;
  transcriptId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OutboundProxyCallQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | OutboundProxyCallQLConnectionKeySpecifier
)[];
export type OutboundProxyCallQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OutboundProxyCallQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | OutboundProxyCallQLEdgeKeySpecifier
)[];
export type OutboundProxyCallQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OutboundProxyNumberKeySpecifier = (
  | 'carrierType'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | OutboundProxyNumberKeySpecifier
)[];
export type OutboundProxyNumberFieldPolicy = {
  carrierType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OutboundProxyTwilioNumberQLKeySpecifier = (
  | 'accountSid'
  | 'apiKey'
  | 'carrierType'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'mdn'
  | 'name'
  | 'sid'
  | 'token'
  | OutboundProxyTwilioNumberQLKeySpecifier
)[];
export type OutboundProxyTwilioNumberQLFieldPolicy = {
  accountSid?: FieldPolicy<any> | FieldReadFunction<any>;
  apiKey?: FieldPolicy<any> | FieldReadFunction<any>;
  carrierType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  mdn?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  sid?: FieldPolicy<any> | FieldReadFunction<any>;
  token?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PageInfoKeySpecifier = (
  | 'endCursor'
  | 'hasNextPage'
  | 'hasPreviousPage'
  | 'startCursor'
  | PageInfoKeySpecifier
)[];
export type PageInfoFieldPolicy = {
  endCursor?: FieldPolicy<any> | FieldReadFunction<any>;
  hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>;
  hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>;
  startCursor?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PaletteQLKeySpecifier = (
  | 'bodyBackgroundColor'
  | 'bodyBorderColor'
  | 'bodyTextColor'
  | 'buttonPrimaryBackgroundColor'
  | 'buttonPrimaryBorderColor'
  | 'buttonPrimaryTextColor'
  | 'buttonSecondaryBackgroundColor'
  | 'buttonSecondaryBorderColor'
  | 'buttonSecondaryTextColor'
  | 'headerBackgroundColor'
  | 'headerBorderColor'
  | 'headerTextColor'
  | 'name'
  | PaletteQLKeySpecifier
)[];
export type PaletteQLFieldPolicy = {
  bodyBackgroundColor?: FieldPolicy<any> | FieldReadFunction<any>;
  bodyBorderColor?: FieldPolicy<any> | FieldReadFunction<any>;
  bodyTextColor?: FieldPolicy<any> | FieldReadFunction<any>;
  buttonPrimaryBackgroundColor?: FieldPolicy<any> | FieldReadFunction<any>;
  buttonPrimaryBorderColor?: FieldPolicy<any> | FieldReadFunction<any>;
  buttonPrimaryTextColor?: FieldPolicy<any> | FieldReadFunction<any>;
  buttonSecondaryBackgroundColor?: FieldPolicy<any> | FieldReadFunction<any>;
  buttonSecondaryBorderColor?: FieldPolicy<any> | FieldReadFunction<any>;
  buttonSecondaryTextColor?: FieldPolicy<any> | FieldReadFunction<any>;
  headerBackgroundColor?: FieldPolicy<any> | FieldReadFunction<any>;
  headerBorderColor?: FieldPolicy<any> | FieldReadFunction<any>;
  headerTextColor?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ParticipantConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | ParticipantConnectionKeySpecifier
)[];
export type ParticipantConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ParticipantEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | ParticipantEdgeKeySpecifier
)[];
export type ParticipantEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ParticipantQLKeySpecifier = (
  | 'account'
  | 'accountId'
  | 'address'
  | 'appointments'
  | 'avatarUrl'
  | 'canceledByPaymentRequests'
  | 'cdkContact'
  | 'chargedByPaymentRequests'
  | 'closedEquityTradeOpportunities'
  | 'cnamContact'
  | 'comment'
  | 'completedTasks'
  | 'conversationLabels'
  | 'conversations'
  | 'createdOn'
  | 'createdTasks'
  | 'crmContacts'
  | 'customer'
  | 'customerCount'
  | 'customerId'
  | 'customerPaymentRequests'
  | 'dealerbuiltContact'
  | 'dealertrackContact'
  | 'deletedByVideoUploadLinks'
  | 'deliveryAddress'
  | 'dismissedTasks'
  | 'displayName'
  | 'displayNameConfidence'
  | 'firstName'
  | 'fortellisContact'
  | 'id'
  | 'identityPromptAddresses'
  | 'isEmployee'
  | 'language'
  | 'lastName'
  | 'lastNomoroboDate'
  | 'lastUpdated'
  | 'latestCustomer'
  | 'nomoroboScore'
  | 'operatorSession'
  | 'pbsContact'
  | 'phonecalls'
  | 'piplData'
  | 'redirectedPhonecalls'
  | 'refunds'
  | 'reynoldsContact'
  | 'senderPaymentRequests'
  | 'source'
  | 'spamStatus'
  | 'tekionContact'
  | 'uploadedVideoUploadLinks'
  | 'user'
  | 'videoUploadLinks'
  | ParticipantQLKeySpecifier
)[];
export type ParticipantQLFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  address?: FieldPolicy<any> | FieldReadFunction<any>;
  appointments?: FieldPolicy<any> | FieldReadFunction<any>;
  avatarUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  canceledByPaymentRequests?: FieldPolicy<any> | FieldReadFunction<any>;
  cdkContact?: FieldPolicy<any> | FieldReadFunction<any>;
  chargedByPaymentRequests?: FieldPolicy<any> | FieldReadFunction<any>;
  closedEquityTradeOpportunities?: FieldPolicy<any> | FieldReadFunction<any>;
  cnamContact?: FieldPolicy<any> | FieldReadFunction<any>;
  comment?: FieldPolicy<any> | FieldReadFunction<any>;
  completedTasks?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationLabels?: FieldPolicy<any> | FieldReadFunction<any>;
  conversations?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  createdTasks?: FieldPolicy<any> | FieldReadFunction<any>;
  crmContacts?: FieldPolicy<any> | FieldReadFunction<any>;
  customer?: FieldPolicy<any> | FieldReadFunction<any>;
  customerCount?: FieldPolicy<any> | FieldReadFunction<any>;
  customerId?: FieldPolicy<any> | FieldReadFunction<any>;
  customerPaymentRequests?: FieldPolicy<any> | FieldReadFunction<any>;
  dealerbuiltContact?: FieldPolicy<any> | FieldReadFunction<any>;
  dealertrackContact?: FieldPolicy<any> | FieldReadFunction<any>;
  deletedByVideoUploadLinks?: FieldPolicy<any> | FieldReadFunction<any>;
  deliveryAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  dismissedTasks?: FieldPolicy<any> | FieldReadFunction<any>;
  displayName?: FieldPolicy<any> | FieldReadFunction<any>;
  displayNameConfidence?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisContact?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptAddresses?: FieldPolicy<any> | FieldReadFunction<any>;
  isEmployee?: FieldPolicy<any> | FieldReadFunction<any>;
  language?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  lastNomoroboDate?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  latestCustomer?: FieldPolicy<any> | FieldReadFunction<any>;
  nomoroboScore?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSession?: FieldPolicy<any> | FieldReadFunction<any>;
  pbsContact?: FieldPolicy<any> | FieldReadFunction<any>;
  phonecalls?: FieldPolicy<any> | FieldReadFunction<any>;
  piplData?: FieldPolicy<any> | FieldReadFunction<any>;
  redirectedPhonecalls?: FieldPolicy<any> | FieldReadFunction<any>;
  refunds?: FieldPolicy<any> | FieldReadFunction<any>;
  reynoldsContact?: FieldPolicy<any> | FieldReadFunction<any>;
  senderPaymentRequests?: FieldPolicy<any> | FieldReadFunction<any>;
  source?: FieldPolicy<any> | FieldReadFunction<any>;
  spamStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  tekionContact?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadedVideoUploadLinks?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  videoUploadLinks?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ParticipantQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | ParticipantQLConnectionKeySpecifier
)[];
export type ParticipantQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ParticipantQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | ParticipantQLEdgeKeySpecifier
)[];
export type ParticipantQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PaymentRequestConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | PaymentRequestConnectionKeySpecifier
)[];
export type PaymentRequestConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PaymentRequestCustomizationQLKeySpecifier = (
  | 'canceledAutoSend'
  | 'canceledTemplate'
  | 'createAutoSend'
  | 'createHoldAutoSend'
  | 'createHoldTemplate'
  | 'createTemplate'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'partialRefundAutoSend'
  | 'partialRefundTemplate'
  | 'place'
  | 'placeId'
  | 'refundAutoSend'
  | 'refundTemplate'
  | 'renderedCanceledTemplate'
  | 'renderedCreateHoldTemplate'
  | 'renderedCreateTemplate'
  | 'renderedPartialRefundTemplate'
  | 'renderedRefundTemplate'
  | 'renderedSuccessTemplate'
  | 'successAutoSend'
  | 'successTemplate'
  | PaymentRequestCustomizationQLKeySpecifier
)[];
export type PaymentRequestCustomizationQLFieldPolicy = {
  canceledAutoSend?: FieldPolicy<any> | FieldReadFunction<any>;
  canceledTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  createAutoSend?: FieldPolicy<any> | FieldReadFunction<any>;
  createHoldAutoSend?: FieldPolicy<any> | FieldReadFunction<any>;
  createHoldTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  createTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  partialRefundAutoSend?: FieldPolicy<any> | FieldReadFunction<any>;
  partialRefundTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  refundAutoSend?: FieldPolicy<any> | FieldReadFunction<any>;
  refundTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedCanceledTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedCreateHoldTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedCreateTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedPartialRefundTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedRefundTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSuccessTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  successAutoSend?: FieldPolicy<any> | FieldReadFunction<any>;
  successTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PaymentRequestEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | PaymentRequestEdgeKeySpecifier
)[];
export type PaymentRequestEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PaymentRequestQLKeySpecifier = (
  | 'amount'
  | 'amountCaptured'
  | 'applicationId'
  | 'attachmentFilename'
  | 'attachmentUrl'
  | 'billingAddress'
  | 'billingAddressObject'
  | 'billingEmail'
  | 'billingLastFourDigits'
  | 'billingMethod'
  | 'billingName'
  | 'canceledAt'
  | 'canceledBy'
  | 'canceledById'
  | 'cancellationReason'
  | 'captureMethod'
  | 'charged'
  | 'chargedBy'
  | 'chargedById'
  | 'clientSecret'
  | 'conversation'
  | 'conversationId'
  | 'createdOn'
  | 'currency'
  | 'customer'
  | 'customerId'
  | 'description'
  | 'disputes'
  | 'encodedId'
  | 'externalId'
  | 'failureCode'
  | 'failureMessage'
  | 'holdApproved'
  | 'holdExpiration'
  | 'id'
  | 'lastOpened'
  | 'lastUpdated'
  | 'messages'
  | 'netAmount'
  | 'note'
  | 'orderId'
  | 'outcomeReason'
  | 'outcomeSellerMessage'
  | 'outcomeType'
  | 'paymentIntentId'
  | 'paymentIntentObject'
  | 'paymentIntentStatus'
  | 'place'
  | 'placeId'
  | 'receiptMessage'
  | 'receiptUrl'
  | 'refunds'
  | 'requested'
  | 'sender'
  | 'senderId'
  | 'sessionId'
  | 'sessionObject'
  | 'status'
  | 'stripeIntegration'
  | 'stripeIntegrationId'
  | 'stripeUrl'
  | 'totalRefundedAmount'
  | PaymentRequestQLKeySpecifier
)[];
export type PaymentRequestQLFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  amountCaptured?: FieldPolicy<any> | FieldReadFunction<any>;
  applicationId?: FieldPolicy<any> | FieldReadFunction<any>;
  attachmentFilename?: FieldPolicy<any> | FieldReadFunction<any>;
  attachmentUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  billingAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  billingAddressObject?: FieldPolicy<any> | FieldReadFunction<any>;
  billingEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  billingLastFourDigits?: FieldPolicy<any> | FieldReadFunction<any>;
  billingMethod?: FieldPolicy<any> | FieldReadFunction<any>;
  billingName?: FieldPolicy<any> | FieldReadFunction<any>;
  canceledAt?: FieldPolicy<any> | FieldReadFunction<any>;
  canceledBy?: FieldPolicy<any> | FieldReadFunction<any>;
  canceledById?: FieldPolicy<any> | FieldReadFunction<any>;
  cancellationReason?: FieldPolicy<any> | FieldReadFunction<any>;
  captureMethod?: FieldPolicy<any> | FieldReadFunction<any>;
  charged?: FieldPolicy<any> | FieldReadFunction<any>;
  chargedBy?: FieldPolicy<any> | FieldReadFunction<any>;
  chargedById?: FieldPolicy<any> | FieldReadFunction<any>;
  clientSecret?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  currency?: FieldPolicy<any> | FieldReadFunction<any>;
  customer?: FieldPolicy<any> | FieldReadFunction<any>;
  customerId?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  disputes?: FieldPolicy<any> | FieldReadFunction<any>;
  encodedId?: FieldPolicy<any> | FieldReadFunction<any>;
  externalId?: FieldPolicy<any> | FieldReadFunction<any>;
  failureCode?: FieldPolicy<any> | FieldReadFunction<any>;
  failureMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  holdApproved?: FieldPolicy<any> | FieldReadFunction<any>;
  holdExpiration?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastOpened?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  netAmount?: FieldPolicy<any> | FieldReadFunction<any>;
  note?: FieldPolicy<any> | FieldReadFunction<any>;
  orderId?: FieldPolicy<any> | FieldReadFunction<any>;
  outcomeReason?: FieldPolicy<any> | FieldReadFunction<any>;
  outcomeSellerMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  outcomeType?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentIntentId?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentIntentObject?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentIntentStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  receiptMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  receiptUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  refunds?: FieldPolicy<any> | FieldReadFunction<any>;
  requested?: FieldPolicy<any> | FieldReadFunction<any>;
  sender?: FieldPolicy<any> | FieldReadFunction<any>;
  senderId?: FieldPolicy<any> | FieldReadFunction<any>;
  sessionId?: FieldPolicy<any> | FieldReadFunction<any>;
  sessionObject?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  stripeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  stripeIntegrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  stripeUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  totalRefundedAmount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PaymentRequestQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | PaymentRequestQLConnectionKeySpecifier
)[];
export type PaymentRequestQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PaymentRequestQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | PaymentRequestQLEdgeKeySpecifier
)[];
export type PaymentRequestQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PhoneCallQLKeySpecifier = (
  | 'answeredByScriptType'
  | 'callCount'
  | 'callDuration'
  | 'callOutcome'
  | 'callPurpose'
  | 'callQualityRecordingSid'
  | 'callRecording'
  | 'callRecordingId'
  | 'callSid'
  | 'channel'
  | 'channelId'
  | 'channelReceivedType'
  | 'childCallDuration'
  | 'childCallSid'
  | 'childCallStatus'
  | 'conversation'
  | 'conversationId'
  | 'createdOn'
  | 'dialogFlowBotData'
  | 'endtime'
  | 'hasIdentityPrompt'
  | 'hasReturnCallsRouting'
  | 'id'
  | 'identityPromptAttempts'
  | 'isActive'
  | 'isBeingRecorded'
  | 'isCallIntelligenceEligible'
  | 'language'
  | 'lastUpdated'
  | 'messages'
  | 'numboxAgentSession'
  | 'onHold'
  | 'operatorSession'
  | 'operatorSessionId'
  | 'optedInForText'
  | 'originalScriptType'
  | 'participant'
  | 'participantId'
  | 'place'
  | 'placeId'
  | 'redirectReason'
  | 'redirectedFrom'
  | 'redirectedFromId'
  | 'returnCallsRoutedTo'
  | 'returnCallsRoutedUser'
  | 'returnCallsRoutedUserId'
  | 'returnCallsRoutingOutcome'
  | 'sentGreeting'
  | 'startTime'
  | 'tagsApplied'
  | 'transcript'
  | 'transcriptId'
  | PhoneCallQLKeySpecifier
)[];
export type PhoneCallQLFieldPolicy = {
  answeredByScriptType?: FieldPolicy<any> | FieldReadFunction<any>;
  callCount?: FieldPolicy<any> | FieldReadFunction<any>;
  callDuration?: FieldPolicy<any> | FieldReadFunction<any>;
  callOutcome?: FieldPolicy<any> | FieldReadFunction<any>;
  callPurpose?: FieldPolicy<any> | FieldReadFunction<any>;
  callQualityRecordingSid?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecording?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingId?: FieldPolicy<any> | FieldReadFunction<any>;
  callSid?: FieldPolicy<any> | FieldReadFunction<any>;
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
  channelId?: FieldPolicy<any> | FieldReadFunction<any>;
  channelReceivedType?: FieldPolicy<any> | FieldReadFunction<any>;
  childCallDuration?: FieldPolicy<any> | FieldReadFunction<any>;
  childCallSid?: FieldPolicy<any> | FieldReadFunction<any>;
  childCallStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  dialogFlowBotData?: FieldPolicy<any> | FieldReadFunction<any>;
  endtime?: FieldPolicy<any> | FieldReadFunction<any>;
  hasIdentityPrompt?: FieldPolicy<any> | FieldReadFunction<any>;
  hasReturnCallsRouting?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptAttempts?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isBeingRecorded?: FieldPolicy<any> | FieldReadFunction<any>;
  isCallIntelligenceEligible?: FieldPolicy<any> | FieldReadFunction<any>;
  language?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  numboxAgentSession?: FieldPolicy<any> | FieldReadFunction<any>;
  onHold?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSession?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSessionId?: FieldPolicy<any> | FieldReadFunction<any>;
  optedInForText?: FieldPolicy<any> | FieldReadFunction<any>;
  originalScriptType?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  participantId?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  redirectReason?: FieldPolicy<any> | FieldReadFunction<any>;
  redirectedFrom?: FieldPolicy<any> | FieldReadFunction<any>;
  redirectedFromId?: FieldPolicy<any> | FieldReadFunction<any>;
  returnCallsRoutedTo?: FieldPolicy<any> | FieldReadFunction<any>;
  returnCallsRoutedUser?: FieldPolicy<any> | FieldReadFunction<any>;
  returnCallsRoutedUserId?: FieldPolicy<any> | FieldReadFunction<any>;
  returnCallsRoutingOutcome?: FieldPolicy<any> | FieldReadFunction<any>;
  sentGreeting?: FieldPolicy<any> | FieldReadFunction<any>;
  startTime?: FieldPolicy<any> | FieldReadFunction<any>;
  tagsApplied?: FieldPolicy<any> | FieldReadFunction<any>;
  transcript?: FieldPolicy<any> | FieldReadFunction<any>;
  transcriptId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PhoneCallQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | PhoneCallQLConnectionKeySpecifier
)[];
export type PhoneCallQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PhoneCallQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | PhoneCallQLEdgeKeySpecifier
)[];
export type PhoneCallQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PhoneLinePolicyQLKeySpecifier = (
  | 'allowDisruptions'
  | 'answerWithKeys'
  | 'answeringScripts'
  | 'archiveMissedCalls'
  | 'assistantPhrase'
  | 'autoOptin'
  | 'autoOptinMessage'
  | 'autoSendHangupReplies'
  | 'category'
  | 'createdOn'
  | 'delayAnswerDuration'
  | 'fixInternalDialing'
  | 'hangupSuggestion'
  | 'hasIdentityPrompt'
  | 'id'
  | 'lastUpdated'
  | 'nryCallForwardingPickUpTimeoutSecs'
  | 'nryCallForwardingUserScreenInteractionTimeoutSecs'
  | 'place'
  | 'placeId'
  | 'twilioChannels'
  | PhoneLinePolicyQLKeySpecifier
)[];
export type PhoneLinePolicyQLFieldPolicy = {
  allowDisruptions?: FieldPolicy<any> | FieldReadFunction<any>;
  answerWithKeys?: FieldPolicy<any> | FieldReadFunction<any>;
  answeringScripts?: FieldPolicy<any> | FieldReadFunction<any>;
  archiveMissedCalls?: FieldPolicy<any> | FieldReadFunction<any>;
  assistantPhrase?: FieldPolicy<any> | FieldReadFunction<any>;
  autoOptin?: FieldPolicy<any> | FieldReadFunction<any>;
  autoOptinMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSendHangupReplies?: FieldPolicy<any> | FieldReadFunction<any>;
  category?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  delayAnswerDuration?: FieldPolicy<any> | FieldReadFunction<any>;
  fixInternalDialing?: FieldPolicy<any> | FieldReadFunction<any>;
  hangupSuggestion?: FieldPolicy<any> | FieldReadFunction<any>;
  hasIdentityPrompt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nryCallForwardingPickUpTimeoutSecs?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  nryCallForwardingUserScreenInteractionTimeoutSecs?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioChannels?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PhoneLinePolicyQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | PhoneLinePolicyQLConnectionKeySpecifier
)[];
export type PhoneLinePolicyQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PhoneLinePolicyQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | PhoneLinePolicyQLEdgeKeySpecifier
)[];
export type PhoneLinePolicyQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PhoneLineQLKeySpecifier = (
  | 'allowedSpeechLanguages'
  | 'canForwardReturnCalls'
  | 'carrierName'
  | 'category'
  | 'createHostedSmsUrl'
  | 'createdOn'
  | 'department'
  | 'hostedSmsPort'
  | 'id'
  | 'kind'
  | 'language'
  | 'lastUpdated'
  | 'lineType'
  | 'mdn'
  | 'name'
  | 'nryChannel'
  | 'nryChannelId'
  | 'nryForwardingMdn'
  | 'overridesInboxLanguage'
  | 'place'
  | 'placeId'
  | 'policy'
  | 'policyId'
  | 'returnCallsForwardingMdn'
  | 'returnCallsForwardingMode'
  | 'returnCallsMdn'
  | 'returnCallsMode'
  | 'returnCallsRoutingHours'
  | 'smsChannel'
  | 'smsChannelId'
  | 'speechLanguage'
  | 'user'
  | 'userId'
  | 'voiceChannel'
  | 'voiceChannelId'
  | PhoneLineQLKeySpecifier
)[];
export type PhoneLineQLFieldPolicy = {
  allowedSpeechLanguages?: FieldPolicy<any> | FieldReadFunction<any>;
  canForwardReturnCalls?: FieldPolicy<any> | FieldReadFunction<any>;
  carrierName?: FieldPolicy<any> | FieldReadFunction<any>;
  category?: FieldPolicy<any> | FieldReadFunction<any>;
  createHostedSmsUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  hostedSmsPort?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  kind?: FieldPolicy<any> | FieldReadFunction<any>;
  language?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  lineType?: FieldPolicy<any> | FieldReadFunction<any>;
  mdn?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  nryChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  nryChannelId?: FieldPolicy<any> | FieldReadFunction<any>;
  nryForwardingMdn?: FieldPolicy<any> | FieldReadFunction<any>;
  overridesInboxLanguage?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  policy?: FieldPolicy<any> | FieldReadFunction<any>;
  policyId?: FieldPolicy<any> | FieldReadFunction<any>;
  returnCallsForwardingMdn?: FieldPolicy<any> | FieldReadFunction<any>;
  returnCallsForwardingMode?: FieldPolicy<any> | FieldReadFunction<any>;
  returnCallsMdn?: FieldPolicy<any> | FieldReadFunction<any>;
  returnCallsMode?: FieldPolicy<any> | FieldReadFunction<any>;
  returnCallsRoutingHours?: FieldPolicy<any> | FieldReadFunction<any>;
  smsChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  smsChannelId?: FieldPolicy<any> | FieldReadFunction<any>;
  speechLanguage?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceChannelId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PhoneLineQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | PhoneLineQLConnectionKeySpecifier
)[];
export type PhoneLineQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PhoneLineQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | PhoneLineQLEdgeKeySpecifier
)[];
export type PhoneLineQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PickupStepQLKeySpecifier = (
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'callerRecognizedStep'
  | 'callerRecognizedStepId'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | PickupStepQLKeySpecifier
)[];
export type PickupStepQLFieldPolicy = {
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callerRecognizedStep?: FieldPolicy<any> | FieldReadFunction<any>;
  callerRecognizedStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PickupStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | PickupStepQLConnectionKeySpecifier
)[];
export type PickupStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PickupStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | PickupStepQLEdgeKeySpecifier
)[];
export type PickupStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | PlaceConnectionKeySpecifier
)[];
export type PlaceConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | PlaceEdgeKeySpecifier
)[];
export type PlaceEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceGroupConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | PlaceGroupConnectionKeySpecifier
)[];
export type PlaceGroupConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceGroupEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | PlaceGroupEdgeKeySpecifier
)[];
export type PlaceGroupEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceGroupQLKeySpecifier = (
  | 'account'
  | 'accountId'
  | 'activeIntegrations'
  | 'createdOn'
  | 'customers'
  | 'directoryEntries'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'places'
  | 'zendeskId'
  | PlaceGroupQLKeySpecifier
)[];
export type PlaceGroupQLFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrations?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customers?: FieldPolicy<any> | FieldReadFunction<any>;
  directoryEntries?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  places?: FieldPolicy<any> | FieldReadFunction<any>;
  zendeskId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceGroupQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | PlaceGroupQLConnectionKeySpecifier
)[];
export type PlaceGroupQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceGroupQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | PlaceGroupQLEdgeKeySpecifier
)[];
export type PlaceGroupQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceInfoQLKeySpecifier = (
  | 'WebsiteUrl'
  | 'address'
  | 'city'
  | 'createdOn'
  | 'email'
  | 'id'
  | 'imageUrl'
  | 'lastUpdated'
  | 'linkGroups'
  | 'logoUrl'
  | 'meta'
  | 'name'
  | 'openhours'
  | 'phonenumber'
  | 'place'
  | 'placeId'
  | 'price'
  | 'rating'
  | 'state'
  | 'streetAddress1'
  | 'streetAddress2'
  | 'websiteUrl'
  | 'yelpAttachments'
  | 'yelpCategories'
  | 'yelpUrl'
  | 'zipCode'
  | PlaceInfoQLKeySpecifier
)[];
export type PlaceInfoQLFieldPolicy = {
  WebsiteUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  address?: FieldPolicy<any> | FieldReadFunction<any>;
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  imageUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  linkGroups?: FieldPolicy<any> | FieldReadFunction<any>;
  logoUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  meta?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  openhours?: FieldPolicy<any> | FieldReadFunction<any>;
  phonenumber?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  rating?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  streetAddress1?: FieldPolicy<any> | FieldReadFunction<any>;
  streetAddress2?: FieldPolicy<any> | FieldReadFunction<any>;
  websiteUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  yelpAttachments?: FieldPolicy<any> | FieldReadFunction<any>;
  yelpCategories?: FieldPolicy<any> | FieldReadFunction<any>;
  yelpUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  zipCode?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceMetricsKeySpecifier = (
  | 'id'
  | 'openConversationsCount'
  | 'overdueConversationsCount'
  | 'place'
  | 'unassignedConversationsCount'
  | PlaceMetricsKeySpecifier
)[];
export type PlaceMetricsFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  openConversationsCount?: FieldPolicy<any> | FieldReadFunction<any>;
  overdueConversationsCount?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  unassignedConversationsCount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceMetricsConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | PlaceMetricsConnectionKeySpecifier
)[];
export type PlaceMetricsConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceMetricsEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | PlaceMetricsEdgeKeySpecifier
)[];
export type PlaceMetricsEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlacePermissionsQLKeySpecifier = (
  | 'permissions'
  | 'placeId'
  | PlacePermissionsQLKeySpecifier
)[];
export type PlacePermissionsQLFieldPolicy = {
  permissions?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceQLKeySpecifier = (
  | 'BusinessTz'
  | 'account'
  | 'accountId'
  | 'activeIntegrations'
  | 'address'
  | 'allowCustomAudio'
  | 'allowedSpeechLanguages'
  | 'answeringMode'
  | 'answeringModeFrom'
  | 'answeringModeUntil'
  | 'answeringScripts'
  | 'appliedIntents'
  | 'appointmentAgentSettings'
  | 'appointments'
  | 'assignmentRetention'
  | 'autopilotJob'
  | 'billingMetadata'
  | 'botParticipant'
  | 'botParticipantId'
  | 'brandTheme'
  | 'businessProfile'
  | 'businessProfileId'
  | 'businessTz'
  | 'callForwardingStatus'
  | 'callIntelligenceSetting'
  | 'campaigns'
  | 'channels'
  | 'checkCallQuality'
  | 'conversations'
  | 'createdOn'
  | 'curbsideSettings'
  | 'departmentPhoneLinePolicy'
  | 'departments'
  | 'dialogFlowBotDatas'
  | 'discoverFaqs'
  | 'disruptions'
  | 'enforceMfa'
  | 'escalationUsers'
  | 'escalationsEnabled'
  | 'escalationsThreshold'
  | 'externalName'
  | 'externalPlaceInfo'
  | 'fortellisLookup'
  | 'fortellisLookupId'
  | 'fortellisRepairOrderSubscription'
  | 'fortellisRepairOrderSubscriptionId'
  | 'fortellisSubscriptions'
  | 'greetings'
  | 'hasDegradedInboxExperience'
  | 'hasDismissedGuideChecklist'
  | 'hasExternalIdentity'
  | 'hasViewedRefer'
  | 'hours'
  | 'id'
  | 'inbox'
  | 'inboxType'
  | 'intentClassifiers'
  | 'labels'
  | 'language'
  | 'lastUpdated'
  | 'managers'
  | 'messages'
  | 'messagingHours'
  | 'name'
  | 'namePronunciation'
  | 'namePronunciationUrl'
  | 'newConversationsPerDay'
  | 'noteTakers'
  | 'numaTrained'
  | 'operators'
  | 'outboundCallSettings'
  | 'outboundConversationsToday'
  | 'participant'
  | 'participantId'
  | 'paymentRequests'
  | 'phoneCalls'
  | 'phonelinePolicies'
  | 'phonelines'
  | 'placeGroup'
  | 'placeGroupId'
  | 'placeInfo'
  | 'placePaymentRequestCustomization'
  | 'placesUsers'
  | 'primaryMdn'
  | 'primaryVoiceScript'
  | 'primaryVoiceScriptId'
  | 'publicListings'
  | 'questionAgentSettings'
  | 'repairOrderSmartStatusUpdateSettings'
  | 'repairServices'
  | 'reportingTimezone'
  | 'resetOngoingOptin'
  | 'resetOptinDays'
  | 'review'
  | 'reviewJob'
  | 'scheduledMessages'
  | 'shortcuts'
  | 'speechLanguage'
  | 'staffPhoneLinePolicy'
  | 'stages'
  | 'status'
  | 'statusItems'
  | 'stripeIntegrations'
  | 'subscriptions'
  | 'teams'
  | 'translationEnabled'
  | 'transportationSets'
  | 'twilioBrandRegistration'
  | 'twilioBrandRegistrationId'
  | 'twilioMessagingServiceSid'
  | 'unreadEscalationsThreshold'
  | 'useAfterHoursGreeting'
  | 'useMessagingHours'
  | 'videos'
  | 'voice'
  | 'voiceFrench'
  | 'voiceScripts'
  | 'voiceSpanish'
  | 'voiceSteps'
  | 'watsonClassifier'
  | PlaceQLKeySpecifier
)[];
export type PlaceQLFieldPolicy = {
  BusinessTz?: FieldPolicy<any> | FieldReadFunction<any>;
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrations?: FieldPolicy<any> | FieldReadFunction<any>;
  address?: FieldPolicy<any> | FieldReadFunction<any>;
  allowCustomAudio?: FieldPolicy<any> | FieldReadFunction<any>;
  allowedSpeechLanguages?: FieldPolicy<any> | FieldReadFunction<any>;
  answeringMode?: FieldPolicy<any> | FieldReadFunction<any>;
  answeringModeFrom?: FieldPolicy<any> | FieldReadFunction<any>;
  answeringModeUntil?: FieldPolicy<any> | FieldReadFunction<any>;
  answeringScripts?: FieldPolicy<any> | FieldReadFunction<any>;
  appliedIntents?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  appointments?: FieldPolicy<any> | FieldReadFunction<any>;
  assignmentRetention?: FieldPolicy<any> | FieldReadFunction<any>;
  autopilotJob?: FieldPolicy<any> | FieldReadFunction<any>;
  billingMetadata?: FieldPolicy<any> | FieldReadFunction<any>;
  botParticipant?: FieldPolicy<any> | FieldReadFunction<any>;
  botParticipantId?: FieldPolicy<any> | FieldReadFunction<any>;
  brandTheme?: FieldPolicy<any> | FieldReadFunction<any>;
  businessProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  businessProfileId?: FieldPolicy<any> | FieldReadFunction<any>;
  businessTz?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  callIntelligenceSetting?: FieldPolicy<any> | FieldReadFunction<any>;
  campaigns?: FieldPolicy<any> | FieldReadFunction<any>;
  channels?: FieldPolicy<any> | FieldReadFunction<any>;
  checkCallQuality?: FieldPolicy<any> | FieldReadFunction<any>;
  conversations?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  curbsideSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  departmentPhoneLinePolicy?: FieldPolicy<any> | FieldReadFunction<any>;
  departments?: FieldPolicy<any> | FieldReadFunction<any>;
  dialogFlowBotDatas?: FieldPolicy<any> | FieldReadFunction<any>;
  discoverFaqs?: FieldPolicy<any> | FieldReadFunction<any>;
  disruptions?: FieldPolicy<any> | FieldReadFunction<any>;
  enforceMfa?: FieldPolicy<any> | FieldReadFunction<any>;
  escalationUsers?: FieldPolicy<any> | FieldReadFunction<any>;
  escalationsEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  escalationsThreshold?: FieldPolicy<any> | FieldReadFunction<any>;
  externalName?: FieldPolicy<any> | FieldReadFunction<any>;
  externalPlaceInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisLookup?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisLookupId?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisRepairOrderSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisRepairOrderSubscriptionId?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  fortellisSubscriptions?: FieldPolicy<any> | FieldReadFunction<any>;
  greetings?: FieldPolicy<any> | FieldReadFunction<any>;
  hasDegradedInboxExperience?: FieldPolicy<any> | FieldReadFunction<any>;
  hasDismissedGuideChecklist?: FieldPolicy<any> | FieldReadFunction<any>;
  hasExternalIdentity?: FieldPolicy<any> | FieldReadFunction<any>;
  hasViewedRefer?: FieldPolicy<any> | FieldReadFunction<any>;
  hours?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  inbox?: FieldPolicy<any> | FieldReadFunction<any>;
  inboxType?: FieldPolicy<any> | FieldReadFunction<any>;
  intentClassifiers?: FieldPolicy<any> | FieldReadFunction<any>;
  labels?: FieldPolicy<any> | FieldReadFunction<any>;
  language?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  managers?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  messagingHours?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  namePronunciation?: FieldPolicy<any> | FieldReadFunction<any>;
  namePronunciationUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  newConversationsPerDay?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakers?: FieldPolicy<any> | FieldReadFunction<any>;
  numaTrained?: FieldPolicy<any> | FieldReadFunction<any>;
  operators?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundCallSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundConversationsToday?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  participantId?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentRequests?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneCalls?: FieldPolicy<any> | FieldReadFunction<any>;
  phonelinePolicies?: FieldPolicy<any> | FieldReadFunction<any>;
  phonelines?: FieldPolicy<any> | FieldReadFunction<any>;
  placeGroup?: FieldPolicy<any> | FieldReadFunction<any>;
  placeGroupId?: FieldPolicy<any> | FieldReadFunction<any>;
  placeInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  placePaymentRequestCustomization?: FieldPolicy<any> | FieldReadFunction<any>;
  placesUsers?: FieldPolicy<any> | FieldReadFunction<any>;
  primaryMdn?: FieldPolicy<any> | FieldReadFunction<any>;
  primaryVoiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  primaryVoiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  publicListings?: FieldPolicy<any> | FieldReadFunction<any>;
  questionAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderSmartStatusUpdateSettings?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  repairServices?: FieldPolicy<any> | FieldReadFunction<any>;
  reportingTimezone?: FieldPolicy<any> | FieldReadFunction<any>;
  resetOngoingOptin?: FieldPolicy<any> | FieldReadFunction<any>;
  resetOptinDays?: FieldPolicy<any> | FieldReadFunction<any>;
  review?: FieldPolicy<any> | FieldReadFunction<any>;
  reviewJob?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduledMessages?: FieldPolicy<any> | FieldReadFunction<any>;
  shortcuts?: FieldPolicy<any> | FieldReadFunction<any>;
  speechLanguage?: FieldPolicy<any> | FieldReadFunction<any>;
  staffPhoneLinePolicy?: FieldPolicy<any> | FieldReadFunction<any>;
  stages?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  statusItems?: FieldPolicy<any> | FieldReadFunction<any>;
  stripeIntegrations?: FieldPolicy<any> | FieldReadFunction<any>;
  subscriptions?: FieldPolicy<any> | FieldReadFunction<any>;
  teams?: FieldPolicy<any> | FieldReadFunction<any>;
  translationEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  transportationSets?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioBrandRegistration?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioBrandRegistrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioMessagingServiceSid?: FieldPolicy<any> | FieldReadFunction<any>;
  unreadEscalationsThreshold?: FieldPolicy<any> | FieldReadFunction<any>;
  useAfterHoursGreeting?: FieldPolicy<any> | FieldReadFunction<any>;
  useMessagingHours?: FieldPolicy<any> | FieldReadFunction<any>;
  videos?: FieldPolicy<any> | FieldReadFunction<any>;
  voice?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceFrench?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScripts?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceSpanish?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  watsonClassifier?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | PlaceQLConnectionKeySpecifier
)[];
export type PlaceQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | PlaceQLEdgeKeySpecifier
)[];
export type PlaceQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceVoiceSettingsQLKeySpecifier = (
  | 'allowedSpeechLanguages'
  | 'id'
  | 'speechLanguage'
  | 'voice'
  | 'voiceFrench'
  | 'voiceSpanish'
  | PlaceVoiceSettingsQLKeySpecifier
)[];
export type PlaceVoiceSettingsQLFieldPolicy = {
  allowedSpeechLanguages?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  speechLanguage?: FieldPolicy<any> | FieldReadFunction<any>;
  voice?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceFrench?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceSpanish?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlacesUsersQLKeySpecifier = (
  | 'assignmentRoutingSettings'
  | 'awayModeAssigneeTeam'
  | 'awayModeAssigneeTeamId'
  | 'awayModeAssigneeUser'
  | 'awayModeAssigneeUserId'
  | 'callIntelligenceEnabled'
  | 'cdkServiceAdvisors'
  | 'createdOn'
  | 'dealertrackServiceAdvisors'
  | 'id'
  | 'isReassigningInboundMessages'
  | 'lastUpdated'
  | 'place'
  | 'placeId'
  | 'receivesEscalations'
  | 'registeredFortellisServiceAdvisor'
  | 'role'
  | 'serviceAdvisors'
  | 'status'
  | 'user'
  | 'userId'
  | PlacesUsersQLKeySpecifier
)[];
export type PlacesUsersQLFieldPolicy = {
  assignmentRoutingSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  awayModeAssigneeTeam?: FieldPolicy<any> | FieldReadFunction<any>;
  awayModeAssigneeTeamId?: FieldPolicy<any> | FieldReadFunction<any>;
  awayModeAssigneeUser?: FieldPolicy<any> | FieldReadFunction<any>;
  awayModeAssigneeUserId?: FieldPolicy<any> | FieldReadFunction<any>;
  callIntelligenceEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  cdkServiceAdvisors?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  dealertrackServiceAdvisors?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isReassigningInboundMessages?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  receivesEscalations?: FieldPolicy<any> | FieldReadFunction<any>;
  registeredFortellisServiceAdvisor?: FieldPolicy<any> | FieldReadFunction<any>;
  role?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisors?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlacesUsersQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | PlacesUsersQLConnectionKeySpecifier
)[];
export type PlacesUsersQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlacesUsersQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | PlacesUsersQLEdgeKeySpecifier
)[];
export type PlacesUsersQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PokeUserKeySpecifier = ('user' | PokeUserKeySpecifier)[];
export type PokeUserFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PopulateBusinessProfileWithChargebeeInfoKeySpecifier = (
  | 'businessProfile'
  | PopulateBusinessProfileWithChargebeeInfoKeySpecifier
)[];
export type PopulateBusinessProfileWithChargebeeInfoFieldPolicy = {
  businessProfile?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PortInPhoneLineKeySpecifier = (
  | 'channel'
  | 'phoneline'
  | PortInPhoneLineKeySpecifier
)[];
export type PortInPhoneLineFieldPolicy = {
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneline?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PredictedMessageIntentQLKeySpecifier = (
  | 'confidence'
  | 'intent'
  | PredictedMessageIntentQLKeySpecifier
)[];
export type PredictedMessageIntentQLFieldPolicy = {
  confidence?: FieldPolicy<any> | FieldReadFunction<any>;
  intent?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PressAnyKeyStepQLKeySpecifier = (
  | 'afterHoursSpeech'
  | 'afterHoursSpeechUrl'
  | 'afterHoursTextMessage'
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'optinGreetingId'
  | 'optinTextMessage'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedAfterHoursSpeech'
  | 'renderedAfterHoursTextMessage'
  | 'renderedOptinTextMessage'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinGreeting'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'useAfterHoursTextMessage'
  | 'useCustomAudio'
  | 'useCustomAudioForAfterHours'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | PressAnyKeyStepQLKeySpecifier
)[];
export type PressAnyKeyStepQLFieldPolicy = {
  afterHoursSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  afterHoursSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  afterHoursTextMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  optinGreetingId?: FieldPolicy<any> | FieldReadFunction<any>;
  optinTextMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedAfterHoursSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedAfterHoursTextMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedOptinTextMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinGreeting?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  useAfterHoursTextMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  useCustomAudio?: FieldPolicy<any> | FieldReadFunction<any>;
  useCustomAudioForAfterHours?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PubNubConfigQLKeySpecifier = (
  | 'browserPushChannels'
  | 'channelGroups'
  | 'channels'
  | 'deviceToken'
  | 'pamKey'
  | 'pamToken'
  | 'publishKey'
  | 'pushChannels'
  | 'subscribeKey'
  | 'typingIndicator'
  | 'userId'
  | 'userParticipantId'
  | PubNubConfigQLKeySpecifier
)[];
export type PubNubConfigQLFieldPolicy = {
  browserPushChannels?: FieldPolicy<any> | FieldReadFunction<any>;
  channelGroups?: FieldPolicy<any> | FieldReadFunction<any>;
  channels?: FieldPolicy<any> | FieldReadFunction<any>;
  deviceToken?: FieldPolicy<any> | FieldReadFunction<any>;
  pamKey?: FieldPolicy<any> | FieldReadFunction<any>;
  pamToken?: FieldPolicy<any> | FieldReadFunction<any>;
  publishKey?: FieldPolicy<any> | FieldReadFunction<any>;
  pushChannels?: FieldPolicy<any> | FieldReadFunction<any>;
  subscribeKey?: FieldPolicy<any> | FieldReadFunction<any>;
  typingIndicator?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
  userParticipantId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PublicListingQLKeySpecifier = (
  | 'id'
  | 'isPublished'
  | 'name'
  | PublicListingQLKeySpecifier
)[];
export type PublicListingQLFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isPublished?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PublishAutomationKeySpecifier = (
  | 'automation'
  | PublishAutomationKeySpecifier
)[];
export type PublishAutomationFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PublishDisruptionVoiceScriptKeySpecifier = (
  | 'place'
  | PublishDisruptionVoiceScriptKeySpecifier
)[];
export type PublishDisruptionVoiceScriptFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PublishVoiceScriptKeySpecifier = (
  | 'answeringScript'
  | PublishVoiceScriptKeySpecifier
)[];
export type PublishVoiceScriptFieldPolicy = {
  answeringScript?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QualificationSurveyQLKeySpecifier = (
  | 'buyoutAmountRange'
  | 'condition'
  | 'createdOn'
  | 'currentLoanAmountRange'
  | 'equityTradeOpportunity'
  | 'equityTradeOpportunityId'
  | 'externalId'
  | 'id'
  | 'interestedInTrading'
  | 'isComplete'
  | 'lastUpdated'
  | 'leaseRemainingTimeRange'
  | 'messages'
  | 'ownershipStatus'
  | 'score'
  | 'status'
  | QualificationSurveyQLKeySpecifier
)[];
export type QualificationSurveyQLFieldPolicy = {
  buyoutAmountRange?: FieldPolicy<any> | FieldReadFunction<any>;
  condition?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  currentLoanAmountRange?: FieldPolicy<any> | FieldReadFunction<any>;
  equityTradeOpportunity?: FieldPolicy<any> | FieldReadFunction<any>;
  equityTradeOpportunityId?: FieldPolicy<any> | FieldReadFunction<any>;
  externalId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  interestedInTrading?: FieldPolicy<any> | FieldReadFunction<any>;
  isComplete?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  leaseRemainingTimeRange?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  ownershipStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  score?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QualifyStepQLKeySpecifier = (
  | 'acknowledgeResponseSpeechUrl'
  | 'acknowledgementSpeech'
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onHasLabelSteps'
  | 'onHasResponse'
  | 'onHasResponseId'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponse'
  | 'onNoResponseId'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'responseMappings'
  | 'shorthandPrompt'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | QualifyStepQLKeySpecifier
)[];
export type QualifyStepQLFieldPolicy = {
  acknowledgeResponseSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  acknowledgementSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponse?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseId?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponse?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseId?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  responseMappings?: FieldPolicy<any> | FieldReadFunction<any>;
  shorthandPrompt?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QualifyStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | QualifyStepQLConnectionKeySpecifier
)[];
export type QualifyStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QualifyStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | QualifyStepQLEdgeKeySpecifier
)[];
export type QualifyStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QueryKeySpecifier = (
  | 'account'
  | 'accountSettings'
  | 'accounts'
  | 'activeAdvisorId'
  | 'activeInboundPhoneCalls'
  | 'activeInbox'
  | 'activeIntegration'
  | 'activeIntegrations'
  | 'activePaymentsCollection'
  | 'activePhoneCallsWithoutMessages'
  | 'answeringScript'
  | 'appointmentAgentNoteRating'
  | 'appointmentAgentSettings'
  | 'appointmentAgents'
  | 'assignmentRoutingSettings'
  | 'attachment'
  | 'autocompleteConversations'
  | 'autocompleteParticipants'
  | 'autocompleteShortcuts'
  | 'autocompleteTeams'
  | 'autocompleteUsers'
  | 'automation'
  | 'automationJobs'
  | 'automations'
  | 'autopilot'
  | 'autopilotJob'
  | 'availableIntegrations'
  | 'availableVoiceScripts'
  | 'billingIdentities'
  | 'billingMetadata'
  | 'brandTheme'
  | 'businessProfile'
  | 'businessProfiles'
  | 'callIntelligenceRating'
  | 'callIntelligenceSetting'
  | 'callRecords'
  | 'campaign'
  | 'channel'
  | 'channels'
  | 'chargebeeSubscriptions'
  | 'complianceReminder'
  | 'complianceSettings'
  | 'conversation'
  | 'conversationByPhoneNumberAndPlace'
  | 'conversationStats'
  | 'conversations'
  | 'cube'
  | 'currentAccount'
  | 'currentUser'
  | 'customer'
  | 'department'
  | 'departmentDevices'
  | 'departmentDirectoryEntry'
  | 'directoryEntries'
  | 'directoryEntry'
  | 'dmsObjectHistory'
  | 'employees'
  | 'equityTradeOpportunity'
  | 'etoSettings'
  | 'externalCrmUsers'
  | 'externalVehicles'
  | 'fortellisSubscription'
  | 'fortellisSubscriptions'
  | 'getDefaultBroadcastInput'
  | 'guideChecklist'
  | 'hostedSmsPorts'
  | 'identityPromptAddresses'
  | 'inbox'
  | 'inboxes'
  | 'knownIntegrationCategories'
  | 'labels'
  | 'listCampaigns'
  | 'manualOpportunitiesByPlace'
  | 'manualOpportunityReport'
  | 'mentionedConversations'
  | 'messageMetadata'
  | 'messages'
  | 'myInboxes'
  | 'myManagerDashboard'
  | 'noteTaker'
  | 'noteTakers'
  | 'numaServices'
  | 'operator'
  | 'operatorChannel'
  | 'operatorChannels'
  | 'operatorPlace'
  | 'operatorPlaces'
  | 'operatorSession'
  | 'operatorSessions'
  | 'operatorSettings'
  | 'operators'
  | 'outboundCallCustomization'
  | 'outboundCallCustomizationAudio'
  | 'outboundCallCustomizations'
  | 'outboundConferenceCall'
  | 'outboundConferenceCalls'
  | 'outboundPhoneChannels'
  | 'outboundProxyCall'
  | 'participant'
  | 'participantVideoUploadLinks'
  | 'paymentRequest'
  | 'paymentRequestCustomization'
  | 'paymentRequests'
  | 'phoneLinePolicy'
  | 'phoneline'
  | 'phonelines'
  | 'place'
  | 'placeAllowsCustomAudio'
  | 'placeGroup'
  | 'placeGroups'
  | 'placeInbox'
  | 'placeInfo'
  | 'placeRepairOrderSmartStatusUpdateSettings'
  | 'placeVoiceSettings'
  | 'places'
  | 'placesUser'
  | 'placesUsers'
  | 'pubnub'
  | 'questionAgentSettings'
  | 'questionAgents'
  | 'repairOrderNotes'
  | 'repairOrderNotesSummary'
  | 'repairOrders'
  | 'repairServices'
  | 'reviewJob'
  | 'scheduledMessages'
  | 'schedulerLogs'
  | 'schedulerSync'
  | 'searchMessagesByContent'
  | 'shortcut'
  | 'shortcuts'
  | 'skuEntitlements'
  | 'skus'
  | 'stages'
  | 'statusItem'
  | 'statusItems'
  | 'stripeIntegration'
  | 'supportedVehicleSet'
  | 'supportedVehicles'
  | 'team'
  | 'teams'
  | 'tenDlcProcessById'
  | 'tenDlcProcessByPlace'
  | 'tenDlcProcesses'
  | 'tenDlcStatus'
  | 'transcript'
  | 'transportationSetOptionSpeech'
  | 'transportationSetSpeech'
  | 'transportationSets'
  | 'trustProducts'
  | 'uploadedVideoUploadLinks'
  | 'user'
  | 'userAssignedPhonelines'
  | 'userDirectoryEntry'
  | 'userIdsByTeamId'
  | 'userPhones'
  | 'users'
  | 'usersAccount'
  | 'videoUploadLink'
  | 'voiceAppointmentAgentSettingsAudio'
  | 'voiceConfigurations'
  | 'voiceScript'
  | 'voiceScripts'
  | 'voiceStepAppointmentAgent'
  | 'voiceStepAudio'
  | 'voiceStepConversationalSchedulingAgent'
  | 'voices'
  | 'writeItForMeConfig'
  | 'xtimeLogs'
  | 'xtimeServices'
  | 'xtimeSync'
  | QueryKeySpecifier
)[];
export type QueryFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  accounts?: FieldPolicy<any> | FieldReadFunction<any>;
  activeAdvisorId?: FieldPolicy<any> | FieldReadFunction<any>;
  activeInboundPhoneCalls?: FieldPolicy<any> | FieldReadFunction<any>;
  activeInbox?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrations?: FieldPolicy<any> | FieldReadFunction<any>;
  activePaymentsCollection?: FieldPolicy<any> | FieldReadFunction<any>;
  activePhoneCallsWithoutMessages?: FieldPolicy<any> | FieldReadFunction<any>;
  answeringScript?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentNoteRating?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgents?: FieldPolicy<any> | FieldReadFunction<any>;
  assignmentRoutingSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  attachment?: FieldPolicy<any> | FieldReadFunction<any>;
  autocompleteConversations?: FieldPolicy<any> | FieldReadFunction<any>;
  autocompleteParticipants?: FieldPolicy<any> | FieldReadFunction<any>;
  autocompleteShortcuts?: FieldPolicy<any> | FieldReadFunction<any>;
  autocompleteTeams?: FieldPolicy<any> | FieldReadFunction<any>;
  autocompleteUsers?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationJobs?: FieldPolicy<any> | FieldReadFunction<any>;
  automations?: FieldPolicy<any> | FieldReadFunction<any>;
  autopilot?: FieldPolicy<any> | FieldReadFunction<any>;
  autopilotJob?: FieldPolicy<any> | FieldReadFunction<any>;
  availableIntegrations?: FieldPolicy<any> | FieldReadFunction<any>;
  availableVoiceScripts?: FieldPolicy<any> | FieldReadFunction<any>;
  billingIdentities?: FieldPolicy<any> | FieldReadFunction<any>;
  billingMetadata?: FieldPolicy<any> | FieldReadFunction<any>;
  brandTheme?: FieldPolicy<any> | FieldReadFunction<any>;
  businessProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  businessProfiles?: FieldPolicy<any> | FieldReadFunction<any>;
  callIntelligenceRating?: FieldPolicy<any> | FieldReadFunction<any>;
  callIntelligenceSetting?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecords?: FieldPolicy<any> | FieldReadFunction<any>;
  campaign?: FieldPolicy<any> | FieldReadFunction<any>;
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
  channels?: FieldPolicy<any> | FieldReadFunction<any>;
  chargebeeSubscriptions?: FieldPolicy<any> | FieldReadFunction<any>;
  complianceReminder?: FieldPolicy<any> | FieldReadFunction<any>;
  complianceSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationByPhoneNumberAndPlace?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStats?: FieldPolicy<any> | FieldReadFunction<any>;
  conversations?: FieldPolicy<any> | FieldReadFunction<any>;
  cube?: FieldPolicy<any> | FieldReadFunction<any>;
  currentAccount?: FieldPolicy<any> | FieldReadFunction<any>;
  currentUser?: FieldPolicy<any> | FieldReadFunction<any>;
  customer?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  departmentDevices?: FieldPolicy<any> | FieldReadFunction<any>;
  departmentDirectoryEntry?: FieldPolicy<any> | FieldReadFunction<any>;
  directoryEntries?: FieldPolicy<any> | FieldReadFunction<any>;
  directoryEntry?: FieldPolicy<any> | FieldReadFunction<any>;
  dmsObjectHistory?: FieldPolicy<any> | FieldReadFunction<any>;
  employees?: FieldPolicy<any> | FieldReadFunction<any>;
  equityTradeOpportunity?: FieldPolicy<any> | FieldReadFunction<any>;
  etoSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  externalCrmUsers?: FieldPolicy<any> | FieldReadFunction<any>;
  externalVehicles?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisSubscriptions?: FieldPolicy<any> | FieldReadFunction<any>;
  getDefaultBroadcastInput?: FieldPolicy<any> | FieldReadFunction<any>;
  guideChecklist?: FieldPolicy<any> | FieldReadFunction<any>;
  hostedSmsPorts?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptAddresses?: FieldPolicy<any> | FieldReadFunction<any>;
  inbox?: FieldPolicy<any> | FieldReadFunction<any>;
  inboxes?: FieldPolicy<any> | FieldReadFunction<any>;
  knownIntegrationCategories?: FieldPolicy<any> | FieldReadFunction<any>;
  labels?: FieldPolicy<any> | FieldReadFunction<any>;
  listCampaigns?: FieldPolicy<any> | FieldReadFunction<any>;
  manualOpportunitiesByPlace?: FieldPolicy<any> | FieldReadFunction<any>;
  manualOpportunityReport?: FieldPolicy<any> | FieldReadFunction<any>;
  mentionedConversations?: FieldPolicy<any> | FieldReadFunction<any>;
  messageMetadata?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  myInboxes?: FieldPolicy<any> | FieldReadFunction<any>;
  myManagerDashboard?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTaker?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakers?: FieldPolicy<any> | FieldReadFunction<any>;
  numaServices?: FieldPolicy<any> | FieldReadFunction<any>;
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorChannels?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorPlace?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorPlaces?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSession?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSessions?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  operators?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundCallCustomization?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundCallCustomizationAudio?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundCallCustomizations?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundConferenceCall?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundConferenceCalls?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundPhoneChannels?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundProxyCall?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  participantVideoUploadLinks?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentRequest?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentRequestCustomization?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentRequests?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneLinePolicy?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneline?: FieldPolicy<any> | FieldReadFunction<any>;
  phonelines?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeAllowsCustomAudio?: FieldPolicy<any> | FieldReadFunction<any>;
  placeGroup?: FieldPolicy<any> | FieldReadFunction<any>;
  placeGroups?: FieldPolicy<any> | FieldReadFunction<any>;
  placeInbox?: FieldPolicy<any> | FieldReadFunction<any>;
  placeInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  placeRepairOrderSmartStatusUpdateSettings?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  placeVoiceSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  places?: FieldPolicy<any> | FieldReadFunction<any>;
  placesUser?: FieldPolicy<any> | FieldReadFunction<any>;
  placesUsers?: FieldPolicy<any> | FieldReadFunction<any>;
  pubnub?: FieldPolicy<any> | FieldReadFunction<any>;
  questionAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  questionAgents?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderNotes?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderNotesSummary?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrders?: FieldPolicy<any> | FieldReadFunction<any>;
  repairServices?: FieldPolicy<any> | FieldReadFunction<any>;
  reviewJob?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduledMessages?: FieldPolicy<any> | FieldReadFunction<any>;
  schedulerLogs?: FieldPolicy<any> | FieldReadFunction<any>;
  schedulerSync?: FieldPolicy<any> | FieldReadFunction<any>;
  searchMessagesByContent?: FieldPolicy<any> | FieldReadFunction<any>;
  shortcut?: FieldPolicy<any> | FieldReadFunction<any>;
  shortcuts?: FieldPolicy<any> | FieldReadFunction<any>;
  skuEntitlements?: FieldPolicy<any> | FieldReadFunction<any>;
  skus?: FieldPolicy<any> | FieldReadFunction<any>;
  stages?: FieldPolicy<any> | FieldReadFunction<any>;
  statusItem?: FieldPolicy<any> | FieldReadFunction<any>;
  statusItems?: FieldPolicy<any> | FieldReadFunction<any>;
  stripeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  supportedVehicleSet?: FieldPolicy<any> | FieldReadFunction<any>;
  supportedVehicles?: FieldPolicy<any> | FieldReadFunction<any>;
  team?: FieldPolicy<any> | FieldReadFunction<any>;
  teams?: FieldPolicy<any> | FieldReadFunction<any>;
  tenDlcProcessById?: FieldPolicy<any> | FieldReadFunction<any>;
  tenDlcProcessByPlace?: FieldPolicy<any> | FieldReadFunction<any>;
  tenDlcProcesses?: FieldPolicy<any> | FieldReadFunction<any>;
  tenDlcStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  transcript?: FieldPolicy<any> | FieldReadFunction<any>;
  transportationSetOptionSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  transportationSetSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  transportationSets?: FieldPolicy<any> | FieldReadFunction<any>;
  trustProducts?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadedVideoUploadLinks?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  userAssignedPhonelines?: FieldPolicy<any> | FieldReadFunction<any>;
  userDirectoryEntry?: FieldPolicy<any> | FieldReadFunction<any>;
  userIdsByTeamId?: FieldPolicy<any> | FieldReadFunction<any>;
  userPhones?: FieldPolicy<any> | FieldReadFunction<any>;
  users?: FieldPolicy<any> | FieldReadFunction<any>;
  usersAccount?: FieldPolicy<any> | FieldReadFunction<any>;
  videoUploadLink?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceAppointmentAgentSettingsAudio?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  voiceConfigurations?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScripts?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceStepAppointmentAgent?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceStepAudio?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceStepConversationalSchedulingAgent?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  voices?: FieldPolicy<any> | FieldReadFunction<any>;
  writeItForMeConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  xtimeLogs?: FieldPolicy<any> | FieldReadFunction<any>;
  xtimeServices?: FieldPolicy<any> | FieldReadFunction<any>;
  xtimeSync?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QuestionAgentSettingsQLKeySpecifier = (
  | 'activeIntegration'
  | 'activeIntegrationId'
  | 'createdOn'
  | 'dialogFlowAgentId'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'settings'
  | QuestionAgentSettingsQLKeySpecifier
)[];
export type QuestionAgentSettingsQLFieldPolicy = {
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  dialogFlowAgentId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  settings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QuestionAgentSettingsQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | QuestionAgentSettingsQLConnectionKeySpecifier
)[];
export type QuestionAgentSettingsQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QuestionAgentSettingsQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | QuestionAgentSettingsQLEdgeKeySpecifier
)[];
export type QuestionAgentSettingsQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QuestionBotStepQLKeySpecifier = (
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'failureStepId'
  | 'failureStepRelationship'
  | 'finishedSpeech'
  | 'finishedSpeechAudioUrl'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'nextStepId'
  | 'nextStepRelationship'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionAgentSettings'
  | 'questionAgentSettingsId'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | QuestionBotStepQLKeySpecifier
)[];
export type QuestionBotStepQLFieldPolicy = {
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  failureStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  finishedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  finishedSpeechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  questionAgentSettingsId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QuestionBotStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | QuestionBotStepQLConnectionKeySpecifier
)[];
export type QuestionBotStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QuestionBotStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | QuestionBotStepQLEdgeKeySpecifier
)[];
export type QuestionBotStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QuestionNodeKeySpecifier = (
  | 'answers'
  | 'defaultAnswer'
  | 'id'
  | 'text'
  | QuestionNodeKeySpecifier
)[];
export type QuestionNodeFieldPolicy = {
  answers?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultAnswer?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  text?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QuestionTreeKeySpecifier = (
  | 'questions'
  | QuestionTreeKeySpecifier
)[];
export type QuestionTreeFieldPolicy = {
  questions?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReasonSentGreetingQLKeySpecifier = (
  | 'kind'
  | 'name'
  | ReasonSentGreetingQLKeySpecifier
)[];
export type ReasonSentGreetingQLFieldPolicy = {
  kind?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReasonSentHangupResponseQLKeySpecifier = (
  | 'channel'
  | 'kind'
  | ReasonSentHangupResponseQLKeySpecifier
)[];
export type ReasonSentHangupResponseQLFieldPolicy = {
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
  kind?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReasonSentIntentQLKeySpecifier = (
  | 'intent'
  | 'kind'
  | ReasonSentIntentQLKeySpecifier
)[];
export type ReasonSentIntentQLFieldPolicy = {
  intent?: FieldPolicy<any> | FieldReadFunction<any>;
  kind?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReasonSentQLKeySpecifier = ('kind' | ReasonSentQLKeySpecifier)[];
export type ReasonSentQLFieldPolicy = {
  kind?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RecoverConversationKeySpecifier = (
  | 'conversation'
  | RecoverConversationKeySpecifier
)[];
export type RecoverConversationFieldPolicy = {
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RefreshCarrierInfoKeySpecifier = (
  | 'phoneline'
  | RefreshCarrierInfoKeySpecifier
)[];
export type RefreshCarrierInfoFieldPolicy = {
  phoneline?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RefreshFortellisServiceAdvisorsKeySpecifier = (
  | 'fortellisSubscription'
  | RefreshFortellisServiceAdvisorsKeySpecifier
)[];
export type RefreshFortellisServiceAdvisorsFieldPolicy = {
  fortellisSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RefundQLKeySpecifier = (
  | 'amount'
  | 'completedOn'
  | 'createdOn'
  | 'id'
  | 'issuer'
  | 'issuerId'
  | 'lastUpdated'
  | 'netAmount'
  | 'note'
  | 'paymentRequest'
  | 'paymentRequestId'
  | 'reason'
  | 'refundObject'
  | 'refundObjectId'
  | 'status'
  | 'type'
  | RefundQLKeySpecifier
)[];
export type RefundQLFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  completedOn?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  issuer?: FieldPolicy<any> | FieldReadFunction<any>;
  issuerId?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  netAmount?: FieldPolicy<any> | FieldReadFunction<any>;
  note?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentRequest?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentRequestId?: FieldPolicy<any> | FieldReadFunction<any>;
  reason?: FieldPolicy<any> | FieldReadFunction<any>;
  refundObject?: FieldPolicy<any> | FieldReadFunction<any>;
  refundObjectId?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RefundQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | RefundQLConnectionKeySpecifier
)[];
export type RefundQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RefundQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | RefundQLEdgeKeySpecifier
)[];
export type RefundQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RegisterFortellisServiceAdvisorKeySpecifier = (
  | 'placesUser'
  | 'serviceAdvisor'
  | RegisterFortellisServiceAdvisorKeySpecifier
)[];
export type RegisterFortellisServiceAdvisorFieldPolicy = {
  placesUser?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisor?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RegisteredFortellisServiceAdvisorQLKeySpecifier = (
  | 'activeIntegration'
  | 'activeIntegrationId'
  | 'createdOn'
  | 'fortellisSubscription'
  | 'fortellisSubscriptionId'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'nextFetchTime'
  | 'placesUser'
  | 'placesUsersId'
  | 'rawData'
  | 'repairOrderSchedule'
  | 'serviceAdvisorId'
  | 'type'
  | RegisteredFortellisServiceAdvisorQLKeySpecifier
)[];
export type RegisteredFortellisServiceAdvisorQLFieldPolicy = {
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisSubscriptionId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  nextFetchTime?: FieldPolicy<any> | FieldReadFunction<any>;
  placesUser?: FieldPolicy<any> | FieldReadFunction<any>;
  placesUsersId?: FieldPolicy<any> | FieldReadFunction<any>;
  rawData?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderSchedule?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisorId?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RemoveAutomationActionKeySpecifier = (
  | 'automation'
  | RemoveAutomationActionKeySpecifier
)[];
export type RemoveAutomationActionFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RemoveAutomationExitTriggerKeySpecifier = (
  | 'automation'
  | RemoveAutomationExitTriggerKeySpecifier
)[];
export type RemoveAutomationExitTriggerFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RemoveLabelFromConversationKeySpecifier = (
  | 'conversation'
  | RemoveLabelFromConversationKeySpecifier
)[];
export type RemoveLabelFromConversationFieldPolicy = {
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RemovePlaceGroupKeySpecifier = (
  | 'account'
  | RemovePlaceGroupKeySpecifier
)[];
export type RemovePlaceGroupFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RemoveServiceAdvisorKeySpecifier = (
  | 'id'
  | RemoveServiceAdvisorKeySpecifier
)[];
export type RemoveServiceAdvisorFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RemoveUserFromPlaceKeySpecifier = (
  | 'user'
  | RemoveUserFromPlaceKeySpecifier
)[];
export type RemoveUserFromPlaceFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RemoveUserFromTeamKeySpecifier = (
  | 'team'
  | RemoveUserFromTeamKeySpecifier
)[];
export type RemoveUserFromTeamFieldPolicy = {
  team?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RemoveVideoUploadLinkKeySpecifier = (
  | 'videoUploadLink'
  | RemoveVideoUploadLinkKeySpecifier
)[];
export type RemoveVideoUploadLinkFieldPolicy = {
  videoUploadLink?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RenameAccountKeySpecifier = (
  | 'account'
  | RenameAccountKeySpecifier
)[];
export type RenameAccountFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RenamePlaceKeySpecifier = ('place' | RenamePlaceKeySpecifier)[];
export type RenamePlaceFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReopenStatusItemKeySpecifier = (
  | 'statusItem'
  | ReopenStatusItemKeySpecifier
)[];
export type ReopenStatusItemFieldPolicy = {
  statusItem?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairOrderKeySpecifier = (
  | 'completedTime'
  | 'createdOn'
  | 'dmsStatus'
  | 'id'
  | 'lastDmsUpdate'
  | 'lastUpdated'
  | 'openedTime'
  | 'orderNumber'
  | 'promisedTime'
  | 'repairOrderType'
  | 'serviceAdvisor'
  | 'serviceAdvisorName'
  | 'status'
  | 'statusItem'
  | 'tagNumber'
  | 'transportationFlags'
  | 'vehicleMakeFriendly'
  | 'vehicleModelFriendly'
  | 'vehicleVin'
  | 'vehicleYear'
  | RepairOrderKeySpecifier
)[];
export type RepairOrderFieldPolicy = {
  completedTime?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  dmsStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastDmsUpdate?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  openedTime?: FieldPolicy<any> | FieldReadFunction<any>;
  orderNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  promisedTime?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderType?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisor?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisorName?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  statusItem?: FieldPolicy<any> | FieldReadFunction<any>;
  tagNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  transportationFlags?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleMakeFriendly?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleModelFriendly?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleVin?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleYear?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairOrderClosedTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'includeWhenMatched'
  | 'lastUpdated'
  | 'opcodesFilter'
  | 'rulesQuery'
  | 'triggerType'
  | 'uiHints'
  | RepairOrderClosedTriggerQLKeySpecifier
)[];
export type RepairOrderClosedTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  includeWhenMatched?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  opcodesFilter?: FieldPolicy<any> | FieldReadFunction<any>;
  rulesQuery?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairOrderConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | RepairOrderConnectionKeySpecifier
)[];
export type RepairOrderConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairOrderEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | RepairOrderEdgeKeySpecifier
)[];
export type RepairOrderEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairOrderFortellisQLKeySpecifier = (
  | 'activeIntegration'
  | 'activeIntegrationId'
  | 'completedTime'
  | 'conversation'
  | 'conversationId'
  | 'createdOn'
  | 'customer'
  | 'customerId'
  | 'data'
  | 'dmsStatus'
  | 'externalServiceAdvisorId'
  | 'id'
  | 'isActive'
  | 'isCompleted'
  | 'lastDmsUpdate'
  | 'lastSeenAt'
  | 'lastUpdated'
  | 'messages'
  | 'opCodes'
  | 'openedTime'
  | 'orderNumber'
  | 'participant'
  | 'place'
  | 'placeId'
  | 'promisedTime'
  | 'repairOrderType'
  | 'roStatus'
  | 'serviceAdvisor'
  | 'serviceAdvisorName'
  | 'status'
  | 'statusItem'
  | 'tagNumber'
  | 'transportationFlags'
  | 'user'
  | 'userId'
  | 'vehicleMake'
  | 'vehicleMakeFriendly'
  | 'vehicleMileage'
  | 'vehicleModel'
  | 'vehicleModelFriendly'
  | 'vehicleVin'
  | 'vehicleYear'
  | RepairOrderFortellisQLKeySpecifier
)[];
export type RepairOrderFortellisQLFieldPolicy = {
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  completedTime?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customer?: FieldPolicy<any> | FieldReadFunction<any>;
  customerId?: FieldPolicy<any> | FieldReadFunction<any>;
  data?: FieldPolicy<any> | FieldReadFunction<any>;
  dmsStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  externalServiceAdvisorId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isCompleted?: FieldPolicy<any> | FieldReadFunction<any>;
  lastDmsUpdate?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSeenAt?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  opCodes?: FieldPolicy<any> | FieldReadFunction<any>;
  openedTime?: FieldPolicy<any> | FieldReadFunction<any>;
  orderNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  promisedTime?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderType?: FieldPolicy<any> | FieldReadFunction<any>;
  roStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisor?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisorName?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  statusItem?: FieldPolicy<any> | FieldReadFunction<any>;
  tagNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  transportationFlags?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleMake?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleMakeFriendly?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleMileage?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleModel?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleModelFriendly?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleVin?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleYear?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairOrderFortellisQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | RepairOrderFortellisQLConnectionKeySpecifier
)[];
export type RepairOrderFortellisQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairOrderFortellisQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | RepairOrderFortellisQLEdgeKeySpecifier
)[];
export type RepairOrderFortellisQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairOrderNotesSummaryQLKeySpecifier = (
  | 'createdOn'
  | 'lastUpdated'
  | 'notEnoughInfo'
  | 'notes'
  | 'repairOrderId'
  | 'serviceSummaries'
  | 'upsell'
  | RepairOrderNotesSummaryQLKeySpecifier
)[];
export type RepairOrderNotesSummaryQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  notEnoughInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  notes?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderId?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceSummaries?: FieldPolicy<any> | FieldReadFunction<any>;
  upsell?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairOrderOpenedTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'includeWhenMatched'
  | 'lastUpdated'
  | 'opcodesFilter'
  | 'rulesQuery'
  | 'triggerType'
  | 'uiHints'
  | RepairOrderOpenedTriggerQLKeySpecifier
)[];
export type RepairOrderOpenedTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  includeWhenMatched?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  opcodesFilter?: FieldPolicy<any> | FieldReadFunction<any>;
  rulesQuery?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairOrderSmartStatusUpdateSettingsQLKeySpecifier = (
  | 'createdOn'
  | 'customInstructions'
  | 'detailLevel'
  | 'evaluationTimes'
  | 'id'
  | 'isEnabled'
  | 'lastUpdated'
  | 'place'
  | 'placeId'
  | RepairOrderSmartStatusUpdateSettingsQLKeySpecifier
)[];
export type RepairOrderSmartStatusUpdateSettingsQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customInstructions?: FieldPolicy<any> | FieldReadFunction<any>;
  detailLevel?: FieldPolicy<any> | FieldReadFunction<any>;
  evaluationTimes?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairOrderUpdateFilterKeySpecifier = (
  | 'conditions'
  | 'operator'
  | RepairOrderUpdateFilterKeySpecifier
)[];
export type RepairOrderUpdateFilterFieldPolicy = {
  conditions?: FieldPolicy<any> | FieldReadFunction<any>;
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairOrderUpdatedConditionKeySpecifier = (
  | 'function'
  | 'keyName'
  | 'newValue'
  | 'oldValue'
  | RepairOrderUpdatedConditionKeySpecifier
)[];
export type RepairOrderUpdatedConditionFieldPolicy = {
  function?: FieldPolicy<any> | FieldReadFunction<any>;
  keyName?: FieldPolicy<any> | FieldReadFunction<any>;
  newValue?: FieldPolicy<any> | FieldReadFunction<any>;
  oldValue?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairOrderUpdatedConditionValueKeySpecifier = (
  | 'type'
  | 'value'
  | RepairOrderUpdatedConditionValueKeySpecifier
)[];
export type RepairOrderUpdatedConditionValueFieldPolicy = {
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairOrderUpdatedTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'includeWhenMatched'
  | 'lastUpdated'
  | 'opcodesFilter'
  | 'rulesQuery'
  | 'triggerType'
  | 'uiHints'
  | 'updateFilter'
  | RepairOrderUpdatedTriggerQLKeySpecifier
)[];
export type RepairOrderUpdatedTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  includeWhenMatched?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  opcodesFilter?: FieldPolicy<any> | FieldReadFunction<any>;
  rulesQuery?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  updateFilter?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairServiceQLKeySpecifier = (
  | 'activeIntegration'
  | 'activeIntegrationId'
  | 'appointments'
  | 'configuration'
  | 'createdOn'
  | 'disabledSupportedVehiclesCount'
  | 'enabledSupportedVehiclesCount'
  | 'id'
  | 'lastUpdated'
  | 'maxCapacity'
  | 'name'
  | 'opCodes'
  | 'place'
  | 'placeId'
  | 'supportedVehicles'
  | 'transportationSets'
  | RepairServiceQLKeySpecifier
)[];
export type RepairServiceQLFieldPolicy = {
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  appointments?: FieldPolicy<any> | FieldReadFunction<any>;
  configuration?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  disabledSupportedVehiclesCount?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledSupportedVehiclesCount?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  maxCapacity?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  opCodes?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  supportedVehicles?: FieldPolicy<any> | FieldReadFunction<any>;
  transportationSets?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairServiceQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | RepairServiceQLConnectionKeySpecifier
)[];
export type RepairServiceQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RepairServiceQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | RepairServiceQLEdgeKeySpecifier
)[];
export type RepairServiceQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RequestAvailableIntegrationKeySpecifier = (
  | 'activeIntegration'
  | RequestAvailableIntegrationKeySpecifier
)[];
export type RequestAvailableIntegrationFieldPolicy = {
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ResetAppointmentAgentSettingsKeySpecifier = (
  | 'appointmentAgentSettings'
  | ResetAppointmentAgentSettingsKeySpecifier
)[];
export type ResetAppointmentAgentSettingsFieldPolicy = {
  appointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ResetBrandThemeKeySpecifier = (
  | 'brandTheme'
  | ResetBrandThemeKeySpecifier
)[];
export type ResetBrandThemeFieldPolicy = {
  brandTheme?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ResetConversationLanguageKeySpecifier = (
  | 'conversation'
  | ResetConversationLanguageKeySpecifier
)[];
export type ResetConversationLanguageFieldPolicy = {
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ResetOutboundChannelsKeySpecifier = (
  | 'automation'
  | ResetOutboundChannelsKeySpecifier
)[];
export type ResetOutboundChannelsFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ResetTaskStatusKeySpecifier = (
  | 'task'
  | ResetTaskStatusKeySpecifier
)[];
export type ResetTaskStatusFieldPolicy = {
  task?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ResetVoiceScriptKeySpecifier = (
  | 'voiceScript'
  | ResetVoiceScriptKeySpecifier
)[];
export type ResetVoiceScriptFieldPolicy = {
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ResolutionStepKeySpecifier = (
  | 'solution'
  | 'step'
  | ResolutionStepKeySpecifier
)[];
export type ResolutionStepFieldPolicy = {
  solution?: FieldPolicy<any> | FieldReadFunction<any>;
  step?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReviewAttachmentKeySpecifier = (
  | 'attachmentType'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'message'
  | 'messageId'
  | 'review'
  | 'reviewId'
  | 'url'
  | ReviewAttachmentKeySpecifier
)[];
export type ReviewAttachmentFieldPolicy = {
  attachmentType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  messageId?: FieldPolicy<any> | FieldReadFunction<any>;
  review?: FieldPolicy<any> | FieldReadFunction<any>;
  reviewId?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReviewAttachmentConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | ReviewAttachmentConnectionKeySpecifier
)[];
export type ReviewAttachmentConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReviewAttachmentEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | ReviewAttachmentEdgeKeySpecifier
)[];
export type ReviewAttachmentEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReviewFeedbackQLKeySpecifier = (
  | 'completed'
  | 'content'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'opened'
  | 'rated'
  | 'rating'
  | 'review'
  | 'reviewId'
  | 'serviceName'
  | 'started'
  | ReviewFeedbackQLKeySpecifier
)[];
export type ReviewFeedbackQLFieldPolicy = {
  completed?: FieldPolicy<any> | FieldReadFunction<any>;
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  opened?: FieldPolicy<any> | FieldReadFunction<any>;
  rated?: FieldPolicy<any> | FieldReadFunction<any>;
  rating?: FieldPolicy<any> | FieldReadFunction<any>;
  review?: FieldPolicy<any> | FieldReadFunction<any>;
  reviewId?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceName?: FieldPolicy<any> | FieldReadFunction<any>;
  started?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReviewJobQLKeySpecifier = (
  | 'backgroundColor'
  | 'buttonColor'
  | 'buttonTextColor'
  | 'createdOn'
  | 'fallbackChannel'
  | 'fallbackChannelId'
  | 'headerColor'
  | 'headerTextColor'
  | 'id'
  | 'lastUpdated'
  | 'logoUrl'
  | 'messageBody'
  | 'messageImageSizeBytes'
  | 'messageImageUrl'
  | 'overrideStylesheet'
  | 'place'
  | 'placeId'
  | 'renderedMessageBody'
  | 'review'
  | 'reviewMode'
  | 'reviewSites'
  | 'skipRatingsScreen'
  | 'textColor'
  | ReviewJobQLKeySpecifier
)[];
export type ReviewJobQLFieldPolicy = {
  backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>;
  buttonColor?: FieldPolicy<any> | FieldReadFunction<any>;
  buttonTextColor?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  fallbackChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  fallbackChannelId?: FieldPolicy<any> | FieldReadFunction<any>;
  headerColor?: FieldPolicy<any> | FieldReadFunction<any>;
  headerTextColor?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  logoUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  messageBody?: FieldPolicy<any> | FieldReadFunction<any>;
  messageImageSizeBytes?: FieldPolicy<any> | FieldReadFunction<any>;
  messageImageUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  overrideStylesheet?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedMessageBody?: FieldPolicy<any> | FieldReadFunction<any>;
  review?: FieldPolicy<any> | FieldReadFunction<any>;
  reviewMode?: FieldPolicy<any> | FieldReadFunction<any>;
  reviewSites?: FieldPolicy<any> | FieldReadFunction<any>;
  skipRatingsScreen?: FieldPolicy<any> | FieldReadFunction<any>;
  textColor?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReviewJobQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | ReviewJobQLConnectionKeySpecifier
)[];
export type ReviewJobQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReviewJobQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | ReviewJobQLEdgeKeySpecifier
)[];
export type ReviewJobQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReviewQLKeySpecifier = (
  | 'attachments'
  | 'createdOn'
  | 'externalId'
  | 'feedback'
  | 'id'
  | 'lastUpdated'
  | 'message'
  | 'messageId'
  | 'participant'
  | 'participantId'
  | 'place'
  | 'placeId'
  | 'reviewJob'
  | 'reviewJobId'
  | 'reviewMode'
  | 'sender'
  | 'senderId'
  | 'transactionId'
  | ReviewQLKeySpecifier
)[];
export type ReviewQLFieldPolicy = {
  attachments?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  externalId?: FieldPolicy<any> | FieldReadFunction<any>;
  feedback?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  messageId?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  participantId?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  reviewJob?: FieldPolicy<any> | FieldReadFunction<any>;
  reviewJobId?: FieldPolicy<any> | FieldReadFunction<any>;
  reviewMode?: FieldPolicy<any> | FieldReadFunction<any>;
  sender?: FieldPolicy<any> | FieldReadFunction<any>;
  senderId?: FieldPolicy<any> | FieldReadFunction<any>;
  transactionId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReviewQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | ReviewQLConnectionKeySpecifier
)[];
export type ReviewQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReviewQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | ReviewQLEdgeKeySpecifier
)[];
export type ReviewQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReviewSiteKeySpecifier = (
  | 'serviceName'
  | 'url'
  | ReviewSiteKeySpecifier
)[];
export type ReviewSiteFieldPolicy = {
  serviceName?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReviewSiteInterfaceKeySpecifier = (
  | 'serviceName'
  | 'url'
  | ReviewSiteInterfaceKeySpecifier
)[];
export type ReviewSiteInterfaceFieldPolicy = {
  serviceName?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ScheduleMessageActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationChannels'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'desiredConversationState'
  | 'friendlyTime'
  | 'id'
  | 'lastUpdated'
  | 'messageToSend'
  | 'minutesUntilSent'
  | 'nextActionId'
  | 'selectedChannelId'
  | 'textWithCare'
  | 'uiHints'
  | ScheduleMessageActionQLKeySpecifier
)[];
export type ScheduleMessageActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationChannels?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  desiredConversationState?: FieldPolicy<any> | FieldReadFunction<any>;
  friendlyTime?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messageToSend?: FieldPolicy<any> | FieldReadFunction<any>;
  minutesUntilSent?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedChannelId?: FieldPolicy<any> | FieldReadFunction<any>;
  textWithCare?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ScheduleMessageConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | ScheduleMessageConnectionKeySpecifier
)[];
export type ScheduleMessageConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ScheduleMessageEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | ScheduleMessageEdgeKeySpecifier
)[];
export type ScheduleMessageEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ScheduledMessageQLKeySpecifier = (
  | 'autopilotScheduleMessage'
  | 'capsLockFixed'
  | 'channel'
  | 'channelId'
  | 'content'
  | 'conversation'
  | 'conversationId'
  | 'createdOn'
  | 'deliveryAttempted'
  | 'id'
  | 'lastUpdated'
  | 'place'
  | 'placeId'
  | 'sendAt'
  | 'sender'
  | 'senderId'
  | 'status'
  | ScheduledMessageQLKeySpecifier
)[];
export type ScheduledMessageQLFieldPolicy = {
  autopilotScheduleMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  capsLockFixed?: FieldPolicy<any> | FieldReadFunction<any>;
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
  channelId?: FieldPolicy<any> | FieldReadFunction<any>;
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  deliveryAttempted?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  sendAt?: FieldPolicy<any> | FieldReadFunction<any>;
  sender?: FieldPolicy<any> | FieldReadFunction<any>;
  senderId?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ScheduledMessageQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | ScheduledMessageQLConnectionKeySpecifier
)[];
export type ScheduledMessageQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ScheduledMessageQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | ScheduledMessageQLEdgeKeySpecifier
)[];
export type ScheduledMessageQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SchedulerLogQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'notes'
  | 'schedulerSync'
  | 'schedulerSyncId'
  | SchedulerLogQLKeySpecifier
)[];
export type SchedulerLogQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  notes?: FieldPolicy<any> | FieldReadFunction<any>;
  schedulerSync?: FieldPolicy<any> | FieldReadFunction<any>;
  schedulerSyncId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SchedulerSyncConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | SchedulerSyncConnectionKeySpecifier
)[];
export type SchedulerSyncConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SchedulerSyncEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | SchedulerSyncEdgeKeySpecifier
)[];
export type SchedulerSyncEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SchedulerSyncQLKeySpecifier = (
  | 'createdOn'
  | 'endDate'
  | 'id'
  | 'lastUpdated'
  | 'schedulerLogs'
  | SchedulerSyncQLKeySpecifier
)[];
export type SchedulerSyncQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  endDate?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  schedulerLogs?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SendBroadcastKeySpecifier = (
  | 'broadcastTask'
  | SendBroadcastKeySpecifier
)[];
export type SendBroadcastFieldPolicy = {
  broadcastTask?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SendFeedbackActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationChannels'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'desiredConversationState'
  | 'friendlyTime'
  | 'id'
  | 'lastUpdated'
  | 'nextActionId'
  | 'selectedChannelId'
  | 'textWithCare'
  | 'uiHints'
  | SendFeedbackActionQLKeySpecifier
)[];
export type SendFeedbackActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationChannels?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  desiredConversationState?: FieldPolicy<any> | FieldReadFunction<any>;
  friendlyTime?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedChannelId?: FieldPolicy<any> | FieldReadFunction<any>;
  textWithCare?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SendLoaKeySpecifier = ('hostedSmsPort' | SendLoaKeySpecifier)[];
export type SendLoaFieldPolicy = {
  hostedSmsPort?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SendMessageKeySpecifier = ('message' | SendMessageKeySpecifier)[];
export type SendMessageFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SendMessageActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationChannels'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'desiredConversationState'
  | 'friendlyTime'
  | 'id'
  | 'lastUpdated'
  | 'messageToSend'
  | 'nextActionId'
  | 'selectedChannelId'
  | 'textWithCare'
  | 'uiHints'
  | SendMessageActionQLKeySpecifier
)[];
export type SendMessageActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationChannels?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  desiredConversationState?: FieldPolicy<any> | FieldReadFunction<any>;
  friendlyTime?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messageToSend?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedChannelId?: FieldPolicy<any> | FieldReadFunction<any>;
  textWithCare?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SendReviewActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationChannels'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'desiredConversationState'
  | 'friendlyTime'
  | 'id'
  | 'lastUpdated'
  | 'messageToSend'
  | 'nextActionId'
  | 'selectedChannelId'
  | 'textWithCare'
  | 'uiHints'
  | SendReviewActionQLKeySpecifier
)[];
export type SendReviewActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationChannels?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  desiredConversationState?: FieldPolicy<any> | FieldReadFunction<any>;
  friendlyTime?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messageToSend?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedChannelId?: FieldPolicy<any> | FieldReadFunction<any>;
  textWithCare?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SendReviewRequestKeySpecifier = (
  | 'message'
  | SendReviewRequestKeySpecifier
)[];
export type SendReviewRequestFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SendScheduledMessageNowKeySpecifier = (
  | 'message'
  | 'scheduledMessage'
  | SendScheduledMessageNowKeySpecifier
)[];
export type SendScheduledMessageNowFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduledMessage?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SendStatusItemMessageKeySpecifier = (
  | 'statusItem'
  | SendStatusItemMessageKeySpecifier
)[];
export type SendStatusItemMessageFieldPolicy = {
  statusItem?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SendVCardKeySpecifier = ('message' | SendVCardKeySpecifier)[];
export type SendVCardFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ServiceAdvisorQLKeySpecifier = (
  | 'activeIntegration'
  | 'activeIntegrationId'
  | 'createdOn'
  | 'fortellisSubscription'
  | 'fortellisSubscriptionId'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'nextFetchTime'
  | 'placeId'
  | 'placesUser'
  | 'placesUsersId'
  | 'rawData'
  | 'repairOrderSchedule'
  | 'serviceAdvisorId'
  | 'serviceAdvisorName'
  | 'type'
  | 'user'
  | 'userId'
  | ServiceAdvisorQLKeySpecifier
)[];
export type ServiceAdvisorQLFieldPolicy = {
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  fortellisSubscriptionId?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  nextFetchTime?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  placesUser?: FieldPolicy<any> | FieldReadFunction<any>;
  placesUsersId?: FieldPolicy<any> | FieldReadFunction<any>;
  rawData?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderSchedule?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisorId?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceAdvisorName?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ServiceSubItemSummaryKeySpecifier = (
  | 'confidence'
  | 'description'
  | 'priority'
  | ServiceSubItemSummaryKeySpecifier
)[];
export type ServiceSubItemSummaryFieldPolicy = {
  confidence?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  priority?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ServiceSummariesItemKeySpecifier = (
  | 'content'
  | 'item'
  | ServiceSummariesItemKeySpecifier
)[];
export type ServiceSummariesItemFieldPolicy = {
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  item?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ServiceSummariesQLKeySpecifier = (
  | 'general'
  | 'serviceItems'
  | ServiceSummariesQLKeySpecifier
)[];
export type ServiceSummariesQLFieldPolicy = {
  general?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceItems?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SetAssignmentRetentionKeySpecifier = (
  | 'accountSettings'
  | 'currentAccount'
  | SetAssignmentRetentionKeySpecifier
)[];
export type SetAssignmentRetentionFieldPolicy = {
  accountSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  currentAccount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SetBusinessTimezoneKeySpecifier = (
  | 'success'
  | SetBusinessTimezoneKeySpecifier
)[];
export type SetBusinessTimezoneFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SetFortellisLookupIdKeySpecifier = (
  | 'place'
  | SetFortellisLookupIdKeySpecifier
)[];
export type SetFortellisLookupIdFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SetHangupSuggestionKeySpecifier = (
  | 'accountSettings'
  | 'channel'
  | 'currentAccount'
  | 'phoneLinePolicy'
  | SetHangupSuggestionKeySpecifier
)[];
export type SetHangupSuggestionFieldPolicy = {
  accountSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
  currentAccount?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneLinePolicy?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SetOptInStatusKeySpecifier = (
  | 'conversation'
  | SetOptInStatusKeySpecifier
)[];
export type SetOptInStatusFieldPolicy = {
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SetResetOngoingOptinKeySpecifier = (
  | 'currentAccount'
  | SetResetOngoingOptinKeySpecifier
)[];
export type SetResetOngoingOptinFieldPolicy = {
  currentAccount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SetResetOptinDaysKeySpecifier = (
  | 'currentAccount'
  | SetResetOptinDaysKeySpecifier
)[];
export type SetResetOptinDaysFieldPolicy = {
  currentAccount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SetupEquityTradeOpportunityCampaignKeySpecifier = (
  | 'etoSettings'
  | SetupEquityTradeOpportunityCampaignKeySpecifier
)[];
export type SetupEquityTradeOpportunityCampaignFieldPolicy = {
  etoSettings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShortcutConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | ShortcutConnectionKeySpecifier
)[];
export type ShortcutConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShortcutEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | ShortcutEdgeKeySpecifier
)[];
export type ShortcutEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShortcutQLKeySpecifier = (
  | 'content'
  | 'count'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'place'
  | 'placeId'
  | 'tag'
  | ShortcutQLKeySpecifier
)[];
export type ShortcutQLFieldPolicy = {
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  tag?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SkuConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | SkuConnectionKeySpecifier
)[];
export type SkuConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SkuEdgeKeySpecifier = ('cursor' | 'node' | SkuEdgeKeySpecifier)[];
export type SkuEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SkuEntitlementsQLKeySpecifier = (
  | 'assignmentRouting'
  | 'assignments'
  | 'awayMode'
  | 'doNotDisturb'
  | 'escalations'
  | 'ordering'
  | 'translation'
  | SkuEntitlementsQLKeySpecifier
)[];
export type SkuEntitlementsQLFieldPolicy = {
  assignmentRouting?: FieldPolicy<any> | FieldReadFunction<any>;
  assignments?: FieldPolicy<any> | FieldReadFunction<any>;
  awayMode?: FieldPolicy<any> | FieldReadFunction<any>;
  doNotDisturb?: FieldPolicy<any> | FieldReadFunction<any>;
  escalations?: FieldPolicy<any> | FieldReadFunction<any>;
  ordering?: FieldPolicy<any> | FieldReadFunction<any>;
  translation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SkuQLKeySpecifier = (
  | 'amount'
  | 'assignmentRouting'
  | 'assignments'
  | 'awayMode'
  | 'callRescue'
  | 'callerId'
  | 'createdOn'
  | 'devicesPerPlace'
  | 'doNotDisturb'
  | 'employeesPerPlace'
  | 'escalations'
  | 'facebook'
  | 'googleMyBusiness'
  | 'hasAppointments'
  | 'hasReputationMgmt'
  | 'id'
  | 'interval'
  | 'intervalDuration'
  | 'isActive'
  | 'lastUpdated'
  | 'managePermissions'
  | 'maxPhoneLines'
  | 'messageRecovery'
  | 'messageRetention'
  | 'name'
  | 'nativeApps'
  | 'numaAssistant'
  | 'paymentProvider'
  | 'reports'
  | 'skuType'
  | 'sms'
  | 'subscriptions'
  | 'transcriptions'
  | 'translation'
  | 'voicemail'
  | 'webWidget'
  | SkuQLKeySpecifier
)[];
export type SkuQLFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  assignmentRouting?: FieldPolicy<any> | FieldReadFunction<any>;
  assignments?: FieldPolicy<any> | FieldReadFunction<any>;
  awayMode?: FieldPolicy<any> | FieldReadFunction<any>;
  callRescue?: FieldPolicy<any> | FieldReadFunction<any>;
  callerId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  devicesPerPlace?: FieldPolicy<any> | FieldReadFunction<any>;
  doNotDisturb?: FieldPolicy<any> | FieldReadFunction<any>;
  employeesPerPlace?: FieldPolicy<any> | FieldReadFunction<any>;
  escalations?: FieldPolicy<any> | FieldReadFunction<any>;
  facebook?: FieldPolicy<any> | FieldReadFunction<any>;
  googleMyBusiness?: FieldPolicy<any> | FieldReadFunction<any>;
  hasAppointments?: FieldPolicy<any> | FieldReadFunction<any>;
  hasReputationMgmt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  interval?: FieldPolicy<any> | FieldReadFunction<any>;
  intervalDuration?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  managePermissions?: FieldPolicy<any> | FieldReadFunction<any>;
  maxPhoneLines?: FieldPolicy<any> | FieldReadFunction<any>;
  messageRecovery?: FieldPolicy<any> | FieldReadFunction<any>;
  messageRetention?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  nativeApps?: FieldPolicy<any> | FieldReadFunction<any>;
  numaAssistant?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  reports?: FieldPolicy<any> | FieldReadFunction<any>;
  skuType?: FieldPolicy<any> | FieldReadFunction<any>;
  sms?: FieldPolicy<any> | FieldReadFunction<any>;
  subscriptions?: FieldPolicy<any> | FieldReadFunction<any>;
  transcriptions?: FieldPolicy<any> | FieldReadFunction<any>;
  translation?: FieldPolicy<any> | FieldReadFunction<any>;
  voicemail?: FieldPolicy<any> | FieldReadFunction<any>;
  webWidget?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SmartTopicAttachmentKeySpecifier = (
  | 'attachmentType'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'message'
  | 'messageId'
  | 'outcome'
  | 'prompt'
  | 'rationale'
  | 'transcript'
  | 'url'
  | SmartTopicAttachmentKeySpecifier
)[];
export type SmartTopicAttachmentFieldPolicy = {
  attachmentType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  messageId?: FieldPolicy<any> | FieldReadFunction<any>;
  outcome?: FieldPolicy<any> | FieldReadFunction<any>;
  prompt?: FieldPolicy<any> | FieldReadFunction<any>;
  rationale?: FieldPolicy<any> | FieldReadFunction<any>;
  transcript?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SmartTopicLinksQLKeySpecifier = (
  | 'id'
  | 'nextStepId'
  | 'order'
  | 'topic'
  | SmartTopicLinksQLKeySpecifier
)[];
export type SmartTopicLinksQLFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  order?: FieldPolicy<any> | FieldReadFunction<any>;
  topic?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SmartTopicStepQLKeySpecifier = (
  | 'acknowledgementSpeech'
  | 'acknowledgementSpeechUrl'
  | 'additionalContext'
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'llmModelOverride'
  | 'llmPromptOverride'
  | 'noMatchStep'
  | 'noMatchStepId'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'purpose'
  | 'questionBotSteps'
  | 'renderedAcknowledgementSpeech'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'topics'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | SmartTopicStepQLKeySpecifier
)[];
export type SmartTopicStepQLFieldPolicy = {
  acknowledgementSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  acknowledgementSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  additionalContext?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  llmModelOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  llmPromptOverride?: FieldPolicy<any> | FieldReadFunction<any>;
  noMatchStep?: FieldPolicy<any> | FieldReadFunction<any>;
  noMatchStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  purpose?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedAcknowledgementSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  topics?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SmartTopicStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | SmartTopicStepQLConnectionKeySpecifier
)[];
export type SmartTopicStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SmartTopicStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | SmartTopicStepQLEdgeKeySpecifier
)[];
export type SmartTopicStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SnoozeConversationKeySpecifier = (
  | 'conversation'
  | SnoozeConversationKeySpecifier
)[];
export type SnoozeConversationFieldPolicy = {
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SpeakStepQLKeySpecifier = (
  | 'afterHoursSpeech'
  | 'afterHoursSpeechUrl'
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'nextStepId'
  | 'nextStepRelationship'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedAfterHoursSpeech'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | SpeakStepQLKeySpecifier
)[];
export type SpeakStepQLFieldPolicy = {
  afterHoursSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  afterHoursSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  nextStepRelationship?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedAfterHoursSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SpeakStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | SpeakStepQLConnectionKeySpecifier
)[];
export type SpeakStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SpeakStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | SpeakStepQLEdgeKeySpecifier
)[];
export type SpeakStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SpecialQuestionQLKeySpecifier = (
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'canWeTextSpeech'
  | 'canWeTextSpeechUrl'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'clarifyCanWeTextSpeech'
  | 'clarifyCanWeTextSpeechUrl'
  | 'clarifySpeech'
  | 'clarifySpeechUrl'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'messageToSend'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onFailCanWeTextSpeech'
  | 'onFailCanWeTextSpeechUrl'
  | 'onFailureSpeech'
  | 'onFailureSpeechUrl'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoCanWeTextSpeech'
  | 'onNoCanWeTextSpeechUrl'
  | 'onNoResponseSteps'
  | 'onNoSpeech'
  | 'onNoSpeechUrl'
  | 'onNoStep'
  | 'onNoStepId'
  | 'onYesButNoTextStep'
  | 'onYesButNoTextStepId'
  | 'onYesCanWeTextSpeech'
  | 'onYesCanWeTextSpeechUrl'
  | 'onYesSpeech'
  | 'onYesSpeechUrl'
  | 'onYesStep'
  | 'onYesStepId'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedMessageToSend'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | SpecialQuestionQLKeySpecifier
)[];
export type SpecialQuestionQLFieldPolicy = {
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  canWeTextSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  canWeTextSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  clarifyCanWeTextSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  clarifyCanWeTextSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  clarifySpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  clarifySpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messageToSend?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onFailCanWeTextSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onFailCanWeTextSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onFailureSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onFailureSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoCanWeTextSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoCanWeTextSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoStep?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesButNoTextStep?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesButNoTextStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesCanWeTextSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesCanWeTextSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesStep?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedMessageToSend?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SpecialQuestionQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | SpecialQuestionQLConnectionKeySpecifier
)[];
export type SpecialQuestionQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SpecialQuestionQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | SpecialQuestionQLEdgeKeySpecifier
)[];
export type SpecialQuestionQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StaffMemberCallGoesPoorlyTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'triggerType'
  | 'uiHints'
  | StaffMemberCallGoesPoorlyTriggerQLKeySpecifier
)[];
export type StaffMemberCallGoesPoorlyTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StageQLKeySpecifier = (
  | 'createdOn'
  | 'icon'
  | 'id'
  | 'lastUpdated'
  | 'messageTemplate'
  | 'name'
  | 'place'
  | 'placeId'
  | 'renderedMessageTemplate'
  | 'renderedUpdateMessageTemplate'
  | 'sortOrder'
  | 'speechUpdate'
  | 'speechUrl'
  | 'statusItems'
  | 'updateMessageTemplate'
  | StageQLKeySpecifier
)[];
export type StageQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  icon?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messageTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedMessageTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedUpdateMessageTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
  sortOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  speechUpdate?: FieldPolicy<any> | FieldReadFunction<any>;
  speechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusItems?: FieldPolicy<any> | FieldReadFunction<any>;
  updateMessageTemplate?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StageQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | StageQLConnectionKeySpecifier
)[];
export type StageQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StageQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | StageQLEdgeKeySpecifier
)[];
export type StageQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StartConversationKeySpecifier = (
  | 'conversation'
  | 'message'
  | StartConversationKeySpecifier
)[];
export type StartConversationFieldPolicy = {
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StartConversationWithScheduledMessageKeySpecifier = (
  | 'conversation'
  | 'scheduledMessage'
  | StartConversationWithScheduledMessageKeySpecifier
)[];
export type StartConversationWithScheduledMessageFieldPolicy = {
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduledMessage?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StatusItemConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | StatusItemConnectionKeySpecifier
)[];
export type StatusItemConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StatusItemEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | StatusItemEdgeKeySpecifier
)[];
export type StatusItemEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StatusItemQLKeySpecifier = (
  | 'assignee'
  | 'assigneeId'
  | 'color'
  | 'conversation'
  | 'createdOn'
  | 'customer'
  | 'customerId'
  | 'description'
  | 'eta'
  | 'heldSince'
  | 'id'
  | 'lastNotification'
  | 'lastUpdateTime'
  | 'lastUpdated'
  | 'messages'
  | 'orderNumber'
  | 'participant'
  | 'place'
  | 'placeId'
  | 'repairOrder'
  | 'repairOrderId'
  | 'stage'
  | 'stageId'
  | 'stagesHaveSent'
  | 'status'
  | 'tag'
  | StatusItemQLKeySpecifier
)[];
export type StatusItemQLFieldPolicy = {
  assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  assigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  color?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customer?: FieldPolicy<any> | FieldReadFunction<any>;
  customerId?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  eta?: FieldPolicy<any> | FieldReadFunction<any>;
  heldSince?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastNotification?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdateTime?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  orderNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  repairOrderId?: FieldPolicy<any> | FieldReadFunction<any>;
  stage?: FieldPolicy<any> | FieldReadFunction<any>;
  stageId?: FieldPolicy<any> | FieldReadFunction<any>;
  stagesHaveSent?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  tag?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StatusItemQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | StatusItemQLConnectionKeySpecifier
)[];
export type StatusItemQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StatusItemQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | StatusItemQLEdgeKeySpecifier
)[];
export type StatusItemQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StatusSummaryQLKeySpecifier = (
  | 'aborted'
  | 'completedEarlyExit'
  | 'completedSuccessfully'
  | 'currentlyRunning'
  | 'currentlyWaiting'
  | 'totalStarted'
  | StatusSummaryQLKeySpecifier
)[];
export type StatusSummaryQLFieldPolicy = {
  aborted?: FieldPolicy<any> | FieldReadFunction<any>;
  completedEarlyExit?: FieldPolicy<any> | FieldReadFunction<any>;
  completedSuccessfully?: FieldPolicy<any> | FieldReadFunction<any>;
  currentlyRunning?: FieldPolicy<any> | FieldReadFunction<any>;
  currentlyWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  totalStarted?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StatusUpdaterStepQLKeySpecifier = (
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'noStatusGivenStep'
  | 'noStatusGivenStepId'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusGivenStep'
  | 'statusGivenStepId'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | StatusUpdaterStepQLKeySpecifier
)[];
export type StatusUpdaterStepQLFieldPolicy = {
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  noStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  noStatusGivenStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusGivenStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StatusUpdaterStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | StatusUpdaterStepQLConnectionKeySpecifier
)[];
export type StatusUpdaterStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StatusUpdaterStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | StatusUpdaterStepQLEdgeKeySpecifier
)[];
export type StatusUpdaterStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StripeIntegrationQLKeySpecifier = (
  | 'closedOn'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'openedOn'
  | 'paymentRequests'
  | 'place'
  | 'placeId'
  | 'stripeAccountId'
  | 'stripeAccountObject'
  | 'stripeAccountStatus'
  | 'stripeAccountType'
  | StripeIntegrationQLKeySpecifier
)[];
export type StripeIntegrationQLFieldPolicy = {
  closedOn?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  openedOn?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentRequests?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  stripeAccountId?: FieldPolicy<any> | FieldReadFunction<any>;
  stripeAccountObject?: FieldPolicy<any> | FieldReadFunction<any>;
  stripeAccountStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  stripeAccountType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StripeIntegrationQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | StripeIntegrationQLConnectionKeySpecifier
)[];
export type StripeIntegrationQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StripeIntegrationQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | StripeIntegrationQLEdgeKeySpecifier
)[];
export type StripeIntegrationQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type Submit10DLCStarterProfileKeySpecifier = (
  | 'businessProfile'
  | 'campaignStatus'
  | Submit10DLCStarterProfileKeySpecifier
)[];
export type Submit10DLCStarterProfileFieldPolicy = {
  businessProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  campaignStatus?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SubmitBusinessIdentityKeySpecifier = (
  | 'tenDlcProcess'
  | SubmitBusinessIdentityKeySpecifier
)[];
export type SubmitBusinessIdentityFieldPolicy = {
  tenDlcProcess?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SubscriptionQLKeySpecifier = (
  | 'available'
  | 'billingIdentity'
  | 'billingIdentityId'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'quantity'
  | 'sku'
  | 'skuId'
  | 'usedLicenses'
  | SubscriptionQLKeySpecifier
)[];
export type SubscriptionQLFieldPolicy = {
  available?: FieldPolicy<any> | FieldReadFunction<any>;
  billingIdentity?: FieldPolicy<any> | FieldReadFunction<any>;
  billingIdentityId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  skuId?: FieldPolicy<any> | FieldReadFunction<any>;
  usedLicenses?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SubscriptionQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | SubscriptionQLConnectionKeySpecifier
)[];
export type SubscriptionQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SubscriptionQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | SubscriptionQLEdgeKeySpecifier
)[];
export type SubscriptionQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SummarizeConversationActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'desiredConversationState'
  | 'id'
  | 'lastUpdated'
  | 'nextActionId'
  | 'uiHints'
  | SummarizeConversationActionQLKeySpecifier
)[];
export type SummarizeConversationActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  desiredConversationState?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SupportedVehiclesConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | SupportedVehiclesConnectionKeySpecifier
)[];
export type SupportedVehiclesConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SupportedVehiclesEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | SupportedVehiclesEdgeKeySpecifier
)[];
export type SupportedVehiclesEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SupportedVehiclesOpcodesQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'isEnabled'
  | 'lastUpdated'
  | 'opCode'
  | 'opCodeId'
  | 'state'
  | 'supportedVehicle'
  | 'supportedVehicleId'
  | SupportedVehiclesOpcodesQLKeySpecifier
)[];
export type SupportedVehiclesOpcodesQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  opCode?: FieldPolicy<any> | FieldReadFunction<any>;
  opCodeId?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  supportedVehicle?: FieldPolicy<any> | FieldReadFunction<any>;
  supportedVehicleId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SupportedVehiclesOpcodesQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | SupportedVehiclesOpcodesQLConnectionKeySpecifier
)[];
export type SupportedVehiclesOpcodesQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SupportedVehiclesOpcodesQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | SupportedVehiclesOpcodesQLEdgeKeySpecifier
)[];
export type SupportedVehiclesOpcodesQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SupportedVehiclesQLKeySpecifier = (
  | 'availableOpCodes'
  | 'createdOn'
  | 'embeddingId'
  | 'firstEnabledOpCode'
  | 'id'
  | 'lastUpdated'
  | 'make'
  | 'model'
  | 'opCodes'
  | 'outcome'
  | 'repairService'
  | 'repairServiceId'
  | 'supportedYears'
  | 'useOverrides'
  | 'xtimeLogs'
  | SupportedVehiclesQLKeySpecifier
)[];
export type SupportedVehiclesQLFieldPolicy = {
  availableOpCodes?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  embeddingId?: FieldPolicy<any> | FieldReadFunction<any>;
  firstEnabledOpCode?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  make?: FieldPolicy<any> | FieldReadFunction<any>;
  model?: FieldPolicy<any> | FieldReadFunction<any>;
  opCodes?: FieldPolicy<any> | FieldReadFunction<any>;
  outcome?: FieldPolicy<any> | FieldReadFunction<any>;
  repairService?: FieldPolicy<any> | FieldReadFunction<any>;
  repairServiceId?: FieldPolicy<any> | FieldReadFunction<any>;
  supportedYears?: FieldPolicy<any> | FieldReadFunction<any>;
  useOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  xtimeLogs?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SurveyAnsweredTriggerQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'surveyAnsweredFilter'
  | 'triggerType'
  | 'uiHints'
  | SurveyAnsweredTriggerQLKeySpecifier
)[];
export type SurveyAnsweredTriggerQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  surveyAnsweredFilter?: FieldPolicy<any> | FieldReadFunction<any>;
  triggerType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SurveyAnsweredUpdateFilterKeySpecifier = (
  | 'inequalityFilter'
  | 'ratingChoice'
  | 'surveyType'
  | SurveyAnsweredUpdateFilterKeySpecifier
)[];
export type SurveyAnsweredUpdateFilterFieldPolicy = {
  inequalityFilter?: FieldPolicy<any> | FieldReadFunction<any>;
  ratingChoice?: FieldPolicy<any> | FieldReadFunction<any>;
  surveyType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SyncXtimeServicesKeySpecifier = (
  | 'supportedVehicles'
  | SyncXtimeServicesKeySpecifier
)[];
export type SyncXtimeServicesFieldPolicy = {
  supportedVehicles?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SystemMessageSettingsKeySpecifier = (
  | 'showSystemMessages'
  | SystemMessageSettingsKeySpecifier
)[];
export type SystemMessageSettingsFieldPolicy = {
  showSystemMessages?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TaskActionQLKeySpecifier = (
  | 'actionData'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'task'
  | 'taskId'
  | 'type'
  | TaskActionQLKeySpecifier
)[];
export type TaskActionQLFieldPolicy = {
  actionData?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  task?: FieldPolicy<any> | FieldReadFunction<any>;
  taskId?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TaskQLKeySpecifier = (
  | 'DueDate'
  | 'category'
  | 'completedAt'
  | 'completedByParticipant'
  | 'completedByParticipantId'
  | 'completionSource'
  | 'createdByParticipant'
  | 'createdByParticipantId'
  | 'createdOn'
  | 'creationSource'
  | 'dismissalReason'
  | 'dismissalSource'
  | 'dismissedAt'
  | 'dismissedByParticipant'
  | 'dismissedByParticipantId'
  | 'dueDate'
  | 'engagementId'
  | 'expiresAt'
  | 'id'
  | 'lastUpdated'
  | 'recommendedActions'
  | 'status'
  | 'title'
  | TaskQLKeySpecifier
)[];
export type TaskQLFieldPolicy = {
  DueDate?: FieldPolicy<any> | FieldReadFunction<any>;
  category?: FieldPolicy<any> | FieldReadFunction<any>;
  completedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  completedByParticipant?: FieldPolicy<any> | FieldReadFunction<any>;
  completedByParticipantId?: FieldPolicy<any> | FieldReadFunction<any>;
  completionSource?: FieldPolicy<any> | FieldReadFunction<any>;
  createdByParticipant?: FieldPolicy<any> | FieldReadFunction<any>;
  createdByParticipantId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  creationSource?: FieldPolicy<any> | FieldReadFunction<any>;
  dismissalReason?: FieldPolicy<any> | FieldReadFunction<any>;
  dismissalSource?: FieldPolicy<any> | FieldReadFunction<any>;
  dismissedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  dismissedByParticipant?: FieldPolicy<any> | FieldReadFunction<any>;
  dismissedByParticipantId?: FieldPolicy<any> | FieldReadFunction<any>;
  dueDate?: FieldPolicy<any> | FieldReadFunction<any>;
  engagementId?: FieldPolicy<any> | FieldReadFunction<any>;
  expiresAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  recommendedActions?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TeachNumaKeySpecifier = ('appliedIntent' | TeachNumaKeySpecifier)[];
export type TeachNumaFieldPolicy = {
  appliedIntent?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TeamConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | TeamConnectionKeySpecifier
)[];
export type TeamConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TeamEdgeKeySpecifier = ('cursor' | 'node' | TeamEdgeKeySpecifier)[];
export type TeamEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TeamQLKeySpecifier = (
  | 'assignmentStyle'
  | 'autoAssignSteps'
  | 'avatar'
  | 'conversations'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'place'
  | 'placeId'
  | 'state'
  | 'userCount'
  | 'users'
  | TeamQLKeySpecifier
)[];
export type TeamQLFieldPolicy = {
  assignmentStyle?: FieldPolicy<any> | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  avatar?: FieldPolicy<any> | FieldReadFunction<any>;
  conversations?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  userCount?: FieldPolicy<any> | FieldReadFunction<any>;
  users?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TeamQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | TeamQLConnectionKeySpecifier
)[];
export type TeamQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TeamQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | TeamQLEdgeKeySpecifier
)[];
export type TeamQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TenDLCProcessQLKeySpecifier = (
  | 'errors'
  | 'id'
  | 'place'
  | 'registrationOptions'
  | 'twilioA2pCampaign'
  | 'twilioBrandRegistration'
  | 'twilioTrustProduct'
  | TenDLCProcessQLKeySpecifier
)[];
export type TenDLCProcessQLFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  registrationOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioA2pCampaign?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioBrandRegistration?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioTrustProduct?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TenDLCStatusQLKeySpecifier = (
  | 'a2pStatus'
  | 'businessVerificationStatus'
  | TenDLCStatusQLKeySpecifier
)[];
export type TenDLCStatusQLFieldPolicy = {
  a2pStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  businessVerificationStatus?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TextGenerationChatMessageQLKeySpecifier = (
  | 'content'
  | 'role'
  | TextGenerationChatMessageQLKeySpecifier
)[];
export type TextGenerationChatMessageQLFieldPolicy = {
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  role?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TextGenerationQLKeySpecifier = (
  | 'data'
  | 'messages'
  | 'prompt'
  | 'responses'
  | TextGenerationQLKeySpecifier
)[];
export type TextGenerationQLFieldPolicy = {
  data?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  prompt?: FieldPolicy<any> | FieldReadFunction<any>;
  responses?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TextOptinStepQLKeySpecifier = (
  | 'afterHoursTextMessage'
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'clarifySpeech'
  | 'clarifySpeechUrl'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onFailureSpeech'
  | 'onFailureSpeechUrl'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'onNoSpeech'
  | 'onNoSpeechUrl'
  | 'onNoStep'
  | 'onNoStepId'
  | 'onYesSpeech'
  | 'onYesSpeechUrl'
  | 'onYesStep'
  | 'onYesStepId'
  | 'operatorAgentSteps'
  | 'optinGreetingId'
  | 'optinTextMessage'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedAfterHoursTextMessage'
  | 'renderedOptinTextMessage'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinGreeting'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'useAfterHoursTextMessage'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | TextOptinStepQLKeySpecifier
)[];
export type TextOptinStepQLFieldPolicy = {
  afterHoursTextMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  clarifySpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  clarifySpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onFailureSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onFailureSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoStep?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesSpeechUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesStep?: FieldPolicy<any> | FieldReadFunction<any>;
  onYesStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  optinGreetingId?: FieldPolicy<any> | FieldReadFunction<any>;
  optinTextMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedAfterHoursTextMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedOptinTextMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinGreeting?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  useAfterHoursTextMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TextOptinStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | TextOptinStepQLConnectionKeySpecifier
)[];
export type TextOptinStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TextOptinStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | TextOptinStepQLEdgeKeySpecifier
)[];
export type TextOptinStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ToggleCustomPhoneLinePolicyKeySpecifier = (
  | 'phoneline'
  | ToggleCustomPhoneLinePolicyKeySpecifier
)[];
export type ToggleCustomPhoneLinePolicyFieldPolicy = {
  phoneline?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ToggleOutboundProxyCallRecordingKeySpecifier = (
  | 'outboundProxyCall'
  | ToggleOutboundProxyCallRecordingKeySpecifier
)[];
export type ToggleOutboundProxyCallRecordingFieldPolicy = {
  outboundProxyCall?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TranscriptAnalysisQLKeySpecifier = (
  | 'callOutcome'
  | 'callType'
  | 'coachingImpact'
  | 'coachingSample'
  | 'coachingTip'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'nextSteps'
  | 'numboxMlModel'
  | 'positiveCoachingImpact'
  | 'positiveCoachingTip'
  | 'scores'
  | 'sections'
  | 'subject'
  | 'summary'
  | 'timestamp'
  | 'transcript'
  | 'transcriptId'
  | TranscriptAnalysisQLKeySpecifier
)[];
export type TranscriptAnalysisQLFieldPolicy = {
  callOutcome?: FieldPolicy<any> | FieldReadFunction<any>;
  callType?: FieldPolicy<any> | FieldReadFunction<any>;
  coachingImpact?: FieldPolicy<any> | FieldReadFunction<any>;
  coachingSample?: FieldPolicy<any> | FieldReadFunction<any>;
  coachingTip?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  numboxMlModel?: FieldPolicy<any> | FieldReadFunction<any>;
  positiveCoachingImpact?: FieldPolicy<any> | FieldReadFunction<any>;
  positiveCoachingTip?: FieldPolicy<any> | FieldReadFunction<any>;
  scores?: FieldPolicy<any> | FieldReadFunction<any>;
  sections?: FieldPolicy<any> | FieldReadFunction<any>;
  subject?: FieldPolicy<any> | FieldReadFunction<any>;
  summary?: FieldPolicy<any> | FieldReadFunction<any>;
  timestamp?: FieldPolicy<any> | FieldReadFunction<any>;
  transcript?: FieldPolicy<any> | FieldReadFunction<any>;
  transcriptId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TranscriptEventQLKeySpecifier = (
  | 'confidence'
  | 'createdOn'
  | 'end'
  | 'id'
  | 'lastUpdated'
  | 'speaker'
  | 'speakerConfidence'
  | 'start'
  | 'text'
  | 'timestamp'
  | 'transcript'
  | 'transcriptId'
  | 'transcriptType'
  | 'type'
  | TranscriptEventQLKeySpecifier
)[];
export type TranscriptEventQLFieldPolicy = {
  confidence?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  end?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  speaker?: FieldPolicy<any> | FieldReadFunction<any>;
  speakerConfidence?: FieldPolicy<any> | FieldReadFunction<any>;
  start?: FieldPolicy<any> | FieldReadFunction<any>;
  text?: FieldPolicy<any> | FieldReadFunction<any>;
  timestamp?: FieldPolicy<any> | FieldReadFunction<any>;
  transcript?: FieldPolicy<any> | FieldReadFunction<any>;
  transcriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  transcriptType?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TranscriptQLKeySpecifier = (
  | 'analysis'
  | 'call'
  | 'conversation'
  | 'conversationId'
  | 'createdOn'
  | 'events'
  | 'id'
  | 'lastUpdated'
  | 'place'
  | 'placeId'
  | 'subject'
  | 'summary'
  | TranscriptQLKeySpecifier
)[];
export type TranscriptQLFieldPolicy = {
  analysis?: FieldPolicy<any> | FieldReadFunction<any>;
  call?: FieldPolicy<any> | FieldReadFunction<any>;
  conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  events?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  subject?: FieldPolicy<any> | FieldReadFunction<any>;
  summary?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TranscriptQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | TranscriptQLConnectionKeySpecifier
)[];
export type TranscriptQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TranscriptQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | TranscriptQLEdgeKeySpecifier
)[];
export type TranscriptQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TranscriptScoreQLKeySpecifier = (
  | 'analysis'
  | 'analysisId'
  | 'createdOn'
  | 'description'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'rating'
  | TranscriptScoreQLKeySpecifier
)[];
export type TranscriptScoreQLFieldPolicy = {
  analysis?: FieldPolicy<any> | FieldReadFunction<any>;
  analysisId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  rating?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TranscriptSectionQLKeySpecifier = (
  | 'analysis'
  | 'analysisId'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'name'
  | 'timestamp'
  | TranscriptSectionQLKeySpecifier
)[];
export type TranscriptSectionQLFieldPolicy = {
  analysis?: FieldPolicy<any> | FieldReadFunction<any>;
  analysisId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  timestamp?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TranslatedMessageKeySpecifier = (
  | 'attachmentType'
  | 'createdOn'
  | 'fieldName'
  | 'id'
  | 'language'
  | 'lastUpdated'
  | 'message'
  | 'messageId'
  | 'text'
  | 'url'
  | TranslatedMessageKeySpecifier
)[];
export type TranslatedMessageFieldPolicy = {
  attachmentType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  fieldName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  language?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  messageId?: FieldPolicy<any> | FieldReadFunction<any>;
  text?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TransportationSetOptionQLKeySpecifier = (
  | 'createdOn'
  | 'enabled'
  | 'id'
  | 'kind'
  | 'lastUpdated'
  | 'minimumServiceItems'
  | 'order'
  | 'speechLong'
  | 'speechShort'
  | 'transportationSet'
  | 'transportationSetId'
  | TransportationSetOptionQLKeySpecifier
)[];
export type TransportationSetOptionQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  kind?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  minimumServiceItems?: FieldPolicy<any> | FieldReadFunction<any>;
  order?: FieldPolicy<any> | FieldReadFunction<any>;
  speechLong?: FieldPolicy<any> | FieldReadFunction<any>;
  speechShort?: FieldPolicy<any> | FieldReadFunction<any>;
  transportationSet?: FieldPolicy<any> | FieldReadFunction<any>;
  transportationSetId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TransportationSetQLKeySpecifier = (
  | 'appointmentAgentSettings'
  | 'appointmentAgentSettingsId'
  | 'createdOn'
  | 'enabled'
  | 'id'
  | 'kind'
  | 'lastUpdated'
  | 'name'
  | 'place'
  | 'placeId'
  | 'repairServices'
  | 'rules'
  | 'speechUtterance'
  | 'transportationOptions'
  | TransportationSetQLKeySpecifier
)[];
export type TransportationSetQLFieldPolicy = {
  appointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSettingsId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  kind?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  repairServices?: FieldPolicy<any> | FieldReadFunction<any>;
  rules?: FieldPolicy<any> | FieldReadFunction<any>;
  speechUtterance?: FieldPolicy<any> | FieldReadFunction<any>;
  transportationOptions?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TransportationSetQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | TransportationSetQLConnectionKeySpecifier
)[];
export type TransportationSetQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TransportationSetQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | TransportationSetQLEdgeKeySpecifier
)[];
export type TransportationSetQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TransportationSetRepairServiceQLKeySpecifier = (
  | 'createdOn'
  | 'enabled'
  | 'id'
  | 'lastUpdated'
  | 'repairService'
  | 'repairServiceId'
  | 'transportationSet'
  | 'transportationSetId'
  | TransportationSetRepairServiceQLKeySpecifier
)[];
export type TransportationSetRepairServiceQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  enabled?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  repairService?: FieldPolicy<any> | FieldReadFunction<any>;
  repairServiceId?: FieldPolicy<any> | FieldReadFunction<any>;
  transportationSet?: FieldPolicy<any> | FieldReadFunction<any>;
  transportationSetId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TransportationSetRepairServiceQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | TransportationSetRepairServiceQLConnectionKeySpecifier
)[];
export type TransportationSetRepairServiceQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TransportationSetRepairServiceQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | TransportationSetRepairServiceQLEdgeKeySpecifier
)[];
export type TransportationSetRepairServiceQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TwilioA2PCampaignQLKeySpecifier = (
  | 'accountId'
  | 'campaignId'
  | 'campaignStatus'
  | 'campaignVerifiedOn'
  | 'createdOn'
  | 'description'
  | 'id'
  | 'lastSync'
  | 'lastUpdated'
  | 'twilioBrandRegistrationSid'
  | 'twilioMessagingServiceSid'
  | TwilioA2PCampaignQLKeySpecifier
)[];
export type TwilioA2PCampaignQLFieldPolicy = {
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  campaignId?: FieldPolicy<any> | FieldReadFunction<any>;
  campaignStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  campaignVerifiedOn?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioBrandRegistrationSid?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioMessagingServiceSid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TwilioBrandRegistrationQLKeySpecifier = (
  | 'accountId'
  | 'createdOn'
  | 'id'
  | 'lastSync'
  | 'lastUpdated'
  | 'places'
  | 'status'
  | 'twilioA2pProfileBundleSid'
  | 'twilioBusinessProfileSid'
  | 'twilioSid'
  | TwilioBrandRegistrationQLKeySpecifier
)[];
export type TwilioBrandRegistrationQLFieldPolicy = {
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  places?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioA2pProfileBundleSid?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioBusinessProfileSid?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioSid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TwilioChannelQLKeySpecifier = (
  | 'Assignee'
  | 'AssigneeId'
  | 'RespectExistingAssignments'
  | 'Team'
  | 'TeamId'
  | 'account'
  | 'accountId'
  | 'accountSid'
  | 'answerWithKeys'
  | 'archiveMissedCalls'
  | 'assignTextReplies'
  | 'assignee'
  | 'assigneeId'
  | 'assistantPhrase'
  | 'autoOptin'
  | 'autoOptinMessage'
  | 'autoSendHangupReplies'
  | 'channelType'
  | 'createdOn'
  | 'delayAnswerDuration'
  | 'hangupSuggestion'
  | 'hasCustomPolicy'
  | 'hasIdentityPrompt'
  | 'hostedSmsPorts'
  | 'id'
  | 'identityPromptAddresses'
  | 'identityPromptOption'
  | 'isActive'
  | 'isBotEnabled'
  | 'isNryChannel'
  | 'lastUpdated'
  | 'mdn'
  | 'messages'
  | 'name'
  | 'nryPhonelines'
  | 'operator'
  | 'operatorId'
  | 'operatorSessions'
  | 'outboundConferenceCall'
  | 'outboundProxyCall'
  | 'outboundSmsMdn'
  | 'phoneLinePolicy'
  | 'phoneLinePolicyId'
  | 'phonecalls'
  | 'place'
  | 'placeId'
  | 'renderedHangupSuggestion'
  | 'respectExistingAssignments'
  | 'scheduled'
  | 'sendOutboundsWithShadowTollfree'
  | 'shadowTollfreePhonenumber'
  | 'shadowTollfreeProvisionedAt'
  | 'shadowTollfreeSid'
  | 'sid'
  | 'smsChannel'
  | 'smsPhonelines'
  | 'supportsMms'
  | 'supportsVoicemail'
  | 'team'
  | 'teamId'
  | 'useLookup'
  | 'userId'
  | 'voicePhonelines'
  | TwilioChannelQLKeySpecifier
)[];
export type TwilioChannelQLFieldPolicy = {
  Assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  AssigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  RespectExistingAssignments?: FieldPolicy<any> | FieldReadFunction<any>;
  Team?: FieldPolicy<any> | FieldReadFunction<any>;
  TeamId?: FieldPolicy<any> | FieldReadFunction<any>;
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  accountSid?: FieldPolicy<any> | FieldReadFunction<any>;
  answerWithKeys?: FieldPolicy<any> | FieldReadFunction<any>;
  archiveMissedCalls?: FieldPolicy<any> | FieldReadFunction<any>;
  assignTextReplies?: FieldPolicy<any> | FieldReadFunction<any>;
  assignee?: FieldPolicy<any> | FieldReadFunction<any>;
  assigneeId?: FieldPolicy<any> | FieldReadFunction<any>;
  assistantPhrase?: FieldPolicy<any> | FieldReadFunction<any>;
  autoOptin?: FieldPolicy<any> | FieldReadFunction<any>;
  autoOptinMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  autoSendHangupReplies?: FieldPolicy<any> | FieldReadFunction<any>;
  channelType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  delayAnswerDuration?: FieldPolicy<any> | FieldReadFunction<any>;
  hangupSuggestion?: FieldPolicy<any> | FieldReadFunction<any>;
  hasCustomPolicy?: FieldPolicy<any> | FieldReadFunction<any>;
  hasIdentityPrompt?: FieldPolicy<any> | FieldReadFunction<any>;
  hostedSmsPorts?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptAddresses?: FieldPolicy<any> | FieldReadFunction<any>;
  identityPromptOption?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isBotEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  isNryChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  mdn?: FieldPolicy<any> | FieldReadFunction<any>;
  messages?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  nryPhonelines?: FieldPolicy<any> | FieldReadFunction<any>;
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorId?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorSessions?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundConferenceCall?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundProxyCall?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundSmsMdn?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneLinePolicy?: FieldPolicy<any> | FieldReadFunction<any>;
  phoneLinePolicyId?: FieldPolicy<any> | FieldReadFunction<any>;
  phonecalls?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedHangupSuggestion?: FieldPolicy<any> | FieldReadFunction<any>;
  respectExistingAssignments?: FieldPolicy<any> | FieldReadFunction<any>;
  scheduled?: FieldPolicy<any> | FieldReadFunction<any>;
  sendOutboundsWithShadowTollfree?: FieldPolicy<any> | FieldReadFunction<any>;
  shadowTollfreePhonenumber?: FieldPolicy<any> | FieldReadFunction<any>;
  shadowTollfreeProvisionedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  shadowTollfreeSid?: FieldPolicy<any> | FieldReadFunction<any>;
  sid?: FieldPolicy<any> | FieldReadFunction<any>;
  smsChannel?: FieldPolicy<any> | FieldReadFunction<any>;
  smsPhonelines?: FieldPolicy<any> | FieldReadFunction<any>;
  supportsMms?: FieldPolicy<any> | FieldReadFunction<any>;
  supportsVoicemail?: FieldPolicy<any> | FieldReadFunction<any>;
  team?: FieldPolicy<any> | FieldReadFunction<any>;
  teamId?: FieldPolicy<any> | FieldReadFunction<any>;
  useLookup?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
  voicePhonelines?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TwilioChannelQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | TwilioChannelQLConnectionKeySpecifier
)[];
export type TwilioChannelQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TwilioChannelQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | TwilioChannelQLEdgeKeySpecifier
)[];
export type TwilioChannelQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TwilioTrustProductErrorKeySpecifier = (
  | 'errorCode'
  | 'failureReason'
  | 'friendlyName'
  | 'objectField'
  | 'passed'
  | TwilioTrustProductErrorKeySpecifier
)[];
export type TwilioTrustProductErrorFieldPolicy = {
  errorCode?: FieldPolicy<any> | FieldReadFunction<any>;
  failureReason?: FieldPolicy<any> | FieldReadFunction<any>;
  friendlyName?: FieldPolicy<any> | FieldReadFunction<any>;
  objectField?: FieldPolicy<any> | FieldReadFunction<any>;
  passed?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TwilioTrustProductQLKeySpecifier = (
  | 'accountId'
  | 'businessIdentity'
  | 'createdOn'
  | 'friendlyName'
  | 'id'
  | 'lastSync'
  | 'lastUpdated'
  | 'productType'
  | 'status'
  | 'twilioAccountSid'
  | 'twilioSid'
  | TwilioTrustProductQLKeySpecifier
)[];
export type TwilioTrustProductQLFieldPolicy = {
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
  businessIdentity?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  friendlyName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastSync?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  productType?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioAccountSid?: FieldPolicy<any> | FieldReadFunction<any>;
  twilioSid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TypingIndicatorQLKeySpecifier = (
  | 'discardEventTimeout'
  | 'inactivityTimeout'
  | 'sendStillTyping'
  | 'typingIndicatorChannel'
  | TypingIndicatorQLKeySpecifier
)[];
export type TypingIndicatorQLFieldPolicy = {
  discardEventTimeout?: FieldPolicy<any> | FieldReadFunction<any>;
  inactivityTimeout?: FieldPolicy<any> | FieldReadFunction<any>;
  sendStillTyping?: FieldPolicy<any> | FieldReadFunction<any>;
  typingIndicatorChannel?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UnmapCrmUserFromUserKeySpecifier = (
  | 'user'
  | UnmapCrmUserFromUserKeySpecifier
)[];
export type UnmapCrmUserFromUserFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateActiveIntegrationKeySpecifier = (
  | 'activeIntegration'
  | UpdateActiveIntegrationKeySpecifier
)[];
export type UpdateActiveIntegrationFieldPolicy = {
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAgentChitChatKeySpecifier = (
  | 'chitchat'
  | UpdateAgentChitChatKeySpecifier
)[];
export type UpdateAgentChitChatFieldPolicy = {
  chitchat?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAnsweringScriptOrderKeySpecifier = (
  | 'answeringScripts'
  | UpdateAnsweringScriptOrderKeySpecifier
)[];
export type UpdateAnsweringScriptOrderFieldPolicy = {
  answeringScripts?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAppointmentKeySpecifier = (
  | 'appointment'
  | UpdateAppointmentKeySpecifier
)[];
export type UpdateAppointmentFieldPolicy = {
  appointment?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAppointmentAgentSettingLabelKeySpecifier = (
  | 'appointmentAgentSetting'
  | 'category'
  | 'id'
  | 'label'
  | UpdateAppointmentAgentSettingLabelKeySpecifier
)[];
export type UpdateAppointmentAgentSettingLabelFieldPolicy = {
  appointmentAgentSetting?: FieldPolicy<any> | FieldReadFunction<any>;
  category?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAppointmentAgentSettingsKeySpecifier = (
  | 'appointmentAgentSettings'
  | UpdateAppointmentAgentSettingsKeySpecifier
)[];
export type UpdateAppointmentAgentSettingsFieldPolicy = {
  appointmentAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAssignmentRoutingSettingsKeySpecifier = (
  | 'assignmentRoutingSettings'
  | UpdateAssignmentRoutingSettingsKeySpecifier
)[];
export type UpdateAssignmentRoutingSettingsFieldPolicy = {
  assignmentRoutingSettings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAutomationKeySpecifier = (
  | 'automation'
  | UpdateAutomationKeySpecifier
)[];
export type UpdateAutomationFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAutomationActionKeySpecifier = (
  | 'automation'
  | UpdateAutomationActionKeySpecifier
)[];
export type UpdateAutomationActionFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAutomationEnrollmentCriteriaKeySpecifier = (
  | 'automation'
  | UpdateAutomationEnrollmentCriteriaKeySpecifier
)[];
export type UpdateAutomationEnrollmentCriteriaFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAutomationExitTriggerKeySpecifier = (
  | 'automation'
  | UpdateAutomationExitTriggerKeySpecifier
)[];
export type UpdateAutomationExitTriggerFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAutomationStartTriggerKeySpecifier = (
  | 'automation'
  | UpdateAutomationStartTriggerKeySpecifier
)[];
export type UpdateAutomationStartTriggerFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAutomationUIHintsKeySpecifier = (
  | 'automation'
  | UpdateAutomationUIHintsKeySpecifier
)[];
export type UpdateAutomationUIHintsFieldPolicy = {
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAutopilotEtaKeySpecifier = (
  | 'autopilot'
  | UpdateAutopilotEtaKeySpecifier
)[];
export type UpdateAutopilotEtaFieldPolicy = {
  autopilot?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAutopilotJobKeySpecifier = (
  | 'autopilotJob'
  | UpdateAutopilotJobKeySpecifier
)[];
export type UpdateAutopilotJobFieldPolicy = {
  autopilotJob?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAutopilotScheduledMessageKeySpecifier = (
  | 'autopilot'
  | UpdateAutopilotScheduledMessageKeySpecifier
)[];
export type UpdateAutopilotScheduledMessageFieldPolicy = {
  autopilot?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAvailableIntegrationKeySpecifier = (
  | 'availableIntegration'
  | UpdateAvailableIntegrationKeySpecifier
)[];
export type UpdateAvailableIntegrationFieldPolicy = {
  availableIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAwayModeKeySpecifier = (
  | 'user'
  | UpdateAwayModeKeySpecifier
)[];
export type UpdateAwayModeFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAwayModeAssigneeKeySpecifier = (
  | 'user'
  | UpdateAwayModeAssigneeKeySpecifier
)[];
export type UpdateAwayModeAssigneeFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAwayModeManagingPermissionKeySpecifier = (
  | 'user'
  | UpdateAwayModeManagingPermissionKeySpecifier
)[];
export type UpdateAwayModeManagingPermissionFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateAwayModeWithTimeKeySpecifier = (
  | 'user'
  | UpdateAwayModeWithTimeKeySpecifier
)[];
export type UpdateAwayModeWithTimeFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateBillingMetadataKeySpecifier = (
  | 'place'
  | UpdateBillingMetadataKeySpecifier
)[];
export type UpdateBillingMetadataFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateBrandLogoKeySpecifier = (
  | 'brandTheme'
  | UpdateBrandLogoKeySpecifier
)[];
export type UpdateBrandLogoFieldPolicy = {
  brandTheme?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateBrandThemeKeySpecifier = (
  | 'brandTheme'
  | UpdateBrandThemeKeySpecifier
)[];
export type UpdateBrandThemeFieldPolicy = {
  brandTheme?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateBusinessIdentityKeySpecifier = (
  | 'tenDlcProcess'
  | UpdateBusinessIdentityKeySpecifier
)[];
export type UpdateBusinessIdentityFieldPolicy = {
  tenDlcProcess?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateBusinessProfileKeySpecifier = (
  | 'businessProfile'
  | UpdateBusinessProfileKeySpecifier
)[];
export type UpdateBusinessProfileFieldPolicy = {
  businessProfile?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateCallForwardingStatusKeySpecifier = (
  | 'success'
  | UpdateCallForwardingStatusKeySpecifier
)[];
export type UpdateCallForwardingStatusFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateCallIntelligenceEnabledKeySpecifier = (
  | 'placesUser'
  | UpdateCallIntelligenceEnabledKeySpecifier
)[];
export type UpdateCallIntelligenceEnabledFieldPolicy = {
  placesUser?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateCallIntelligenceSettingKeySpecifier = (
  | 'callIntelligenceSetting'
  | UpdateCallIntelligenceSettingKeySpecifier
)[];
export type UpdateCallIntelligenceSettingFieldPolicy = {
  callIntelligenceSetting?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateCampaignStatusKeySpecifier = (
  | 'result'
  | UpdateCampaignStatusKeySpecifier
)[];
export type UpdateCampaignStatusFieldPolicy = {
  result?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateCampaignStatusResultKeySpecifier = (
  | 'message'
  | 'success'
  | UpdateCampaignStatusResultKeySpecifier
)[];
export type UpdateCampaignStatusResultFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateChannelKeySpecifier = (
  | 'channel'
  | UpdateChannelKeySpecifier
)[];
export type UpdateChannelFieldPolicy = {
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateComplianceSettingsKeySpecifier = (
  | 'complianceSettings'
  | UpdateComplianceSettingsKeySpecifier
)[];
export type UpdateComplianceSettingsFieldPolicy = {
  complianceSettings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateConversationLabelKeySpecifier = (
  | 'conversationLabel'
  | UpdateConversationLabelKeySpecifier
)[];
export type UpdateConversationLabelFieldPolicy = {
  conversationLabel?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateConversationsKeySpecifier = (
  | 'conversations'
  | UpdateConversationsKeySpecifier
)[];
export type UpdateConversationsFieldPolicy = {
  conversations?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateCurbsideSettingsKeySpecifier = (
  | 'curbsideSettings'
  | UpdateCurbsideSettingsKeySpecifier
)[];
export type UpdateCurbsideSettingsFieldPolicy = {
  curbsideSettings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateCustomDirectoryEntryKeySpecifier = (
  | 'directoryEntry'
  | UpdateCustomDirectoryEntryKeySpecifier
)[];
export type UpdateCustomDirectoryEntryFieldPolicy = {
  directoryEntry?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateDefaultViewKeySpecifier = (
  | 'user'
  | UpdateDefaultViewKeySpecifier
)[];
export type UpdateDefaultViewFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateDefaultYouViewKeySpecifier = (
  | 'user'
  | UpdateDefaultYouViewKeySpecifier
)[];
export type UpdateDefaultYouViewFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateDepartmentDeviceKeySpecifier = (
  | 'device'
  | UpdateDepartmentDeviceKeySpecifier
)[];
export type UpdateDepartmentDeviceFieldPolicy = {
  device?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateDirectoryEntryKeySpecifier = (
  | 'directoryEntry'
  | UpdateDirectoryEntryKeySpecifier
)[];
export type UpdateDirectoryEntryFieldPolicy = {
  directoryEntry?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateETOSettingsKeySpecifier = (
  | 'etoSettings'
  | UpdateETOSettingsKeySpecifier
)[];
export type UpdateETOSettingsFieldPolicy = {
  etoSettings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateEdgesVoiceStepKeySpecifier = (
  | 'voiceScript'
  | UpdateEdgesVoiceStepKeySpecifier
)[];
export type UpdateEdgesVoiceStepFieldPolicy = {
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateEquityTradeOpportunityStageKeySpecifier = (
  | 'equityTradeOpportunity'
  | UpdateEquityTradeOpportunityStageKeySpecifier
)[];
export type UpdateEquityTradeOpportunityStageFieldPolicy = {
  equityTradeOpportunity?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateEscalationSettingsKeySpecifier = (
  | 'accountSettings'
  | 'currentAccount'
  | UpdateEscalationSettingsKeySpecifier
)[];
export type UpdateEscalationSettingsFieldPolicy = {
  accountSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  currentAccount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateGreetingKeySpecifier = (
  | 'greeting'
  | UpdateGreetingKeySpecifier
)[];
export type UpdateGreetingFieldPolicy = {
  greeting?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateHasDismissedGuideChecklistKeySpecifier = (
  | 'success'
  | UpdateHasDismissedGuideChecklistKeySpecifier
)[];
export type UpdateHasDismissedGuideChecklistFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateHasViewedReferKeySpecifier = (
  | 'success'
  | UpdateHasViewedReferKeySpecifier
)[];
export type UpdateHasViewedReferFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateHideSharedInboxViewsKeySpecifier = (
  | 'user'
  | UpdateHideSharedInboxViewsKeySpecifier
)[];
export type UpdateHideSharedInboxViewsFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateHostedSmsKeySpecifier = (
  | 'hostedSmsPort'
  | UpdateHostedSmsKeySpecifier
)[];
export type UpdateHostedSmsFieldPolicy = {
  hostedSmsPort?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateIsScheduleEnabledKeySpecifier = (
  | 'user'
  | UpdateIsScheduleEnabledKeySpecifier
)[];
export type UpdateIsScheduleEnabledFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateIsUnassigningInboundMessagesKeySpecifier = (
  | 'user'
  | UpdateIsUnassigningInboundMessagesKeySpecifier
)[];
export type UpdateIsUnassigningInboundMessagesFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateLabelKeySpecifier = ('label' | UpdateLabelKeySpecifier)[];
export type UpdateLabelFieldPolicy = {
  label?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateLanguageSettingsKeySpecifier = (
  | 'place'
  | UpdateLanguageSettingsKeySpecifier
)[];
export type UpdateLanguageSettingsFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateLinkKeySpecifier = ('placeInfo' | UpdateLinkKeySpecifier)[];
export type UpdateLinkFieldPolicy = {
  placeInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateLinkUrlsKeySpecifier = (
  | 'placeInfo'
  | UpdateLinkUrlsKeySpecifier
)[];
export type UpdateLinkUrlsFieldPolicy = {
  placeInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateLoggedCallKeySpecifier = (
  | 'message'
  | UpdateLoggedCallKeySpecifier
)[];
export type UpdateLoggedCallFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateLogosKeySpecifier = ('placeInfo' | UpdateLogosKeySpecifier)[];
export type UpdateLogosFieldPolicy = {
  placeInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateMissedCallFollowUpSettingKeySpecifier = (
  | 'user'
  | UpdateMissedCallFollowUpSettingKeySpecifier
)[];
export type UpdateMissedCallFollowUpSettingFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateNamePronunciationKeySpecifier = (
  | 'place'
  | UpdateNamePronunciationKeySpecifier
)[];
export type UpdateNamePronunciationFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateNewConversationsPerDayKeySpecifier = (
  | 'place'
  | UpdateNewConversationsPerDayKeySpecifier
)[];
export type UpdateNewConversationsPerDayFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateOperatorKeySpecifier = (
  | 'operator'
  | UpdateOperatorKeySpecifier
)[];
export type UpdateOperatorFieldPolicy = {
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateOperatorChannelKeySpecifier = (
  | 'operator'
  | 'operatorChannel'
  | UpdateOperatorChannelKeySpecifier
)[];
export type UpdateOperatorChannelFieldPolicy = {
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorChannel?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateOperatorPlaceDescriptionKeySpecifier = (
  | 'operator'
  | 'operatorPlace'
  | UpdateOperatorPlaceDescriptionKeySpecifier
)[];
export type UpdateOperatorPlaceDescriptionFieldPolicy = {
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorPlace?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateOperatorPlaceSettingsKeySpecifier = (
  | 'operator'
  | 'operatorPlace'
  | UpdateOperatorPlaceSettingsKeySpecifier
)[];
export type UpdateOperatorPlaceSettingsFieldPolicy = {
  operator?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorPlace?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateOperatorSettingsKeySpecifier = (
  | 'operatorSettings'
  | UpdateOperatorSettingsKeySpecifier
)[];
export type UpdateOperatorSettingsFieldPolicy = {
  operatorSettings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateOpportunityActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'id'
  | 'lastUpdated'
  | 'nextActionId'
  | 'opportunity'
  | 'uiHints'
  | UpdateOpportunityActionQLKeySpecifier
)[];
export type UpdateOpportunityActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  opportunity?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateOutboundCallCustomizationKeySpecifier = (
  | 'outboundCallCustomization'
  | UpdateOutboundCallCustomizationKeySpecifier
)[];
export type UpdateOutboundCallCustomizationFieldPolicy = {
  outboundCallCustomization?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateOutboundConferenceCallKeySpecifier = (
  | 'outboundConferenceCall'
  | UpdateOutboundConferenceCallKeySpecifier
)[];
export type UpdateOutboundConferenceCallFieldPolicy = {
  outboundConferenceCall?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateParticipantKeySpecifier = (
  | 'participant'
  | UpdateParticipantKeySpecifier
)[];
export type UpdateParticipantFieldPolicy = {
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePaymentRequestAttachmentKeySpecifier = (
  | 'paymentRequest'
  | UpdatePaymentRequestAttachmentKeySpecifier
)[];
export type UpdatePaymentRequestAttachmentFieldPolicy = {
  paymentRequest?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePaymentRequestCustomizationKeySpecifier = (
  | 'paymentRequestCustomization'
  | UpdatePaymentRequestCustomizationKeySpecifier
)[];
export type UpdatePaymentRequestCustomizationFieldPolicy = {
  paymentRequestCustomization?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePhoneCallKeySpecifier = (
  | 'phonecall'
  | UpdatePhoneCallKeySpecifier
)[];
export type UpdatePhoneCallFieldPolicy = {
  phonecall?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePhoneLineKeySpecifier = (
  | 'phoneline'
  | UpdatePhoneLineKeySpecifier
)[];
export type UpdatePhoneLineFieldPolicy = {
  phoneline?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePhoneLineLanguageSettingsKeySpecifier = (
  | 'phoneline'
  | UpdatePhoneLineLanguageSettingsKeySpecifier
)[];
export type UpdatePhoneLineLanguageSettingsFieldPolicy = {
  phoneline?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePhoneLineNameKeySpecifier = (
  | 'phoneline'
  | UpdatePhoneLineNameKeySpecifier
)[];
export type UpdatePhoneLineNameFieldPolicy = {
  phoneline?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePhoneLinePolicyKeySpecifier = (
  | 'phoneLinePolicy'
  | UpdatePhoneLinePolicyKeySpecifier
)[];
export type UpdatePhoneLinePolicyFieldPolicy = {
  phoneLinePolicy?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePlaceDisruptionSettingsKeySpecifier = (
  | 'place'
  | UpdatePlaceDisruptionSettingsKeySpecifier
)[];
export type UpdatePlaceDisruptionSettingsFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePlaceGroupKeySpecifier = (
  | 'placeGroup'
  | UpdatePlaceGroupKeySpecifier
)[];
export type UpdatePlaceGroupFieldPolicy = {
  placeGroup?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePlaceInfoKeySpecifier = (
  | 'placeInfo'
  | UpdatePlaceInfoKeySpecifier
)[];
export type UpdatePlaceInfoFieldPolicy = {
  placeInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePlaceMFASettingsKeySpecifier = (
  | 'place'
  | UpdatePlaceMFASettingsKeySpecifier
)[];
export type UpdatePlaceMFASettingsFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePlaceMessageSettingsKeySpecifier = (
  | 'place'
  | UpdatePlaceMessageSettingsKeySpecifier
)[];
export type UpdatePlaceMessageSettingsFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePlaceOutboundCallSettingsKeySpecifier = (
  | 'place'
  | UpdatePlaceOutboundCallSettingsKeySpecifier
)[];
export type UpdatePlaceOutboundCallSettingsFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePlaceQuotaKeySpecifier = (
  | 'place'
  | UpdatePlaceQuotaKeySpecifier
)[];
export type UpdatePlaceQuotaFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePlaceStatusKeySpecifier = (
  | 'place'
  | UpdatePlaceStatusKeySpecifier
)[];
export type UpdatePlaceStatusFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePlaceVoiceKeySpecifier = (
  | 'place'
  | UpdatePlaceVoiceKeySpecifier
)[];
export type UpdatePlaceVoiceFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePublicListingKeySpecifier = (
  | 'place'
  | UpdatePublicListingKeySpecifier
)[];
export type UpdatePublicListingFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateQuestionAgentSettingsKeySpecifier = (
  | 'questionAgentSettings'
  | UpdateQuestionAgentSettingsKeySpecifier
)[];
export type UpdateQuestionAgentSettingsFieldPolicy = {
  questionAgentSettings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateReceivesEscalationsKeySpecifier = (
  | 'placesUser'
  | UpdateReceivesEscalationsKeySpecifier
)[];
export type UpdateReceivesEscalationsFieldPolicy = {
  placesUser?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateRepairServicesOpCodesKeySpecifier = (
  | 'repairServices'
  | UpdateRepairServicesOpCodesKeySpecifier
)[];
export type UpdateRepairServicesOpCodesFieldPolicy = {
  repairServices?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateReviewJobKeySpecifier = (
  | 'reviewJob'
  | UpdateReviewJobKeySpecifier
)[];
export type UpdateReviewJobFieldPolicy = {
  reviewJob?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateServiceAdvisorKeySpecifier = (
  | 'serviceAdvisor'
  | UpdateServiceAdvisorKeySpecifier
)[];
export type UpdateServiceAdvisorFieldPolicy = {
  serviceAdvisor?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateServiceOverrideKeySpecifier = (
  | 'allSelected'
  | 'appointmentAgentSettingsId'
  | 'howIsHandled'
  | 'numaServiceName'
  | 'opcodes'
  | 'search'
  | 'vehicles'
  | UpdateServiceOverrideKeySpecifier
)[];
export type UpdateServiceOverrideFieldPolicy = {
  allSelected?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentAgentSettingsId?: FieldPolicy<any> | FieldReadFunction<any>;
  howIsHandled?: FieldPolicy<any> | FieldReadFunction<any>;
  numaServiceName?: FieldPolicy<any> | FieldReadFunction<any>;
  opcodes?: FieldPolicy<any> | FieldReadFunction<any>;
  search?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicles?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateShortcutKeySpecifier = (
  | 'shortcut'
  | UpdateShortcutKeySpecifier
)[];
export type UpdateShortcutFieldPolicy = {
  shortcut?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateShowBannerAfterKeySpecifier = (
  | 'currentUser'
  | UpdateShowBannerAfterKeySpecifier
)[];
export type UpdateShowBannerAfterFieldPolicy = {
  currentUser?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateStageKeySpecifier = ('stage' | UpdateStageKeySpecifier)[];
export type UpdateStageFieldPolicy = {
  stage?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateStatusBoardViewKeySpecifier = (
  | 'user'
  | UpdateStatusBoardViewKeySpecifier
)[];
export type UpdateStatusBoardViewFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateStatusItemKeySpecifier = (
  | 'statusItem'
  | UpdateStatusItemKeySpecifier
)[];
export type UpdateStatusItemFieldPolicy = {
  statusItem?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateTeamKeySpecifier = ('team' | UpdateTeamKeySpecifier)[];
export type UpdateTeamFieldPolicy = {
  team?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateTransportationSetKeySpecifier = (
  | 'transportationSet'
  | UpdateTransportationSetKeySpecifier
)[];
export type UpdateTransportationSetFieldPolicy = {
  transportationSet?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateTwilioChannelKeySpecifier = (
  | 'channel'
  | UpdateTwilioChannelKeySpecifier
)[];
export type UpdateTwilioChannelFieldPolicy = {
  channel?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateUseNewNumberKeySpecifier = (
  | 'account'
  | UpdateUseNewNumberKeySpecifier
)[];
export type UpdateUseNewNumberFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateUserKeySpecifier = ('user' | UpdateUserKeySpecifier)[];
export type UpdateUserFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateUserInformationKeySpecifier = (
  | 'currentUser'
  | 'user'
  | UpdateUserInformationKeySpecifier
)[];
export type UpdateUserInformationFieldPolicy = {
  currentUser?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateUserMFASettingsKeySpecifier = (
  | 'user'
  | UpdateUserMFASettingsKeySpecifier
)[];
export type UpdateUserMFASettingsFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateUserPersonalizationKeySpecifier = (
  | 'user'
  | UpdateUserPersonalizationKeySpecifier
)[];
export type UpdateUserPersonalizationFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateUserPhoneKeySpecifier = (
  | 'userPhone'
  | UpdateUserPhoneKeySpecifier
)[];
export type UpdateUserPhoneFieldPolicy = {
  userPhone?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateUserPhonePreferenceKeySpecifier = (
  | 'user'
  | UpdateUserPhonePreferenceKeySpecifier
)[];
export type UpdateUserPhonePreferenceFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateUserScheduleKeySpecifier = (
  | 'user'
  | UpdateUserScheduleKeySpecifier
)[];
export type UpdateUserScheduleFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateUserViewPreferencesKeySpecifier = (
  | 'user'
  | UpdateUserViewPreferencesKeySpecifier
)[];
export type UpdateUserViewPreferencesFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateVideoUploadLinkKeySpecifier = (
  | 'videoUploadLink'
  | UpdateVideoUploadLinkKeySpecifier
)[];
export type UpdateVideoUploadLinkFieldPolicy = {
  videoUploadLink?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateVoiceScriptKeySpecifier = (
  | 'voiceScript'
  | UpdateVoiceScriptKeySpecifier
)[];
export type UpdateVoiceScriptFieldPolicy = {
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateVoiceStepKeySpecifier = (
  | 'script'
  | 'step'
  | UpdateVoiceStepKeySpecifier
)[];
export type UpdateVoiceStepFieldPolicy = {
  script?: FieldPolicy<any> | FieldReadFunction<any>;
  step?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateVoiceStepUIHintsKeySpecifier = (
  | 'voiceScript'
  | UpdateVoiceStepUIHintsKeySpecifier
)[];
export type UpdateVoiceStepUIHintsFieldPolicy = {
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateWriteItForMeConfigKeySpecifier = (
  | 'writeItForMeConfig'
  | UpdateWriteItForMeConfigKeySpecifier
)[];
export type UpdateWriteItForMeConfigFieldPolicy = {
  writeItForMeConfig?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UploadCustomAudioKeySpecifier = (
  | 'script'
  | 'step'
  | UploadCustomAudioKeySpecifier
)[];
export type UploadCustomAudioFieldPolicy = {
  script?: FieldPolicy<any> | FieldReadFunction<any>;
  step?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UploadCustomOutboundCallAudioKeySpecifier = (
  | 'outboundCallCustomization'
  | UploadCustomOutboundCallAudioKeySpecifier
)[];
export type UploadCustomOutboundCallAudioFieldPolicy = {
  outboundCallCustomization?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpsellQLKeySpecifier = (
  | 'objections'
  | 'strategies'
  | UpsellQLKeySpecifier
)[];
export type UpsellQLFieldPolicy = {
  objections?: FieldPolicy<any> | FieldReadFunction<any>;
  strategies?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpsellStrategyKeySpecifier = (
  | 'name'
  | 'strategy'
  | UpsellStrategyKeySpecifier
)[];
export type UpsellStrategyFieldPolicy = {
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  strategy?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpsertConversationRepairOrderSmartStatusUpdateSettingsKeySpecifier =
  (
    | 'conversation'
    | UpsertConversationRepairOrderSmartStatusUpdateSettingsKeySpecifier
  )[];
export type UpsertConversationRepairOrderSmartStatusUpdateSettingsFieldPolicy =
  {
    conversation?: FieldPolicy<any> | FieldReadFunction<any>;
  };
export type UpsertRepairOrderSmartStatusUpdateSettingsKeySpecifier = (
  | 'repairOrderSmartStatusUpdateSettings'
  | UpsertRepairOrderSmartStatusUpdateSettingsKeySpecifier
)[];
export type UpsertRepairOrderSmartStatusUpdateSettingsFieldPolicy = {
  repairOrderSmartStatusUpdateSettings?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
};
export type UpsertSubscriptionKeySpecifier = (
  | 'subscription'
  | UpsertSubscriptionKeySpecifier
)[];
export type UpsertSubscriptionFieldPolicy = {
  subscription?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UseAfterHoursGreetingKeySpecifier = (
  | 'place'
  | UseAfterHoursGreetingKeySpecifier
)[];
export type UseAfterHoursGreetingFieldPolicy = {
  place?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | UserConnectionKeySpecifier
)[];
export type UserConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserDirectoryEntryQLKeySpecifier = (
  | 'createdOn'
  | 'customDirectoryEntry'
  | 'customDirectoryEntryId'
  | 'department'
  | 'departmentId'
  | 'description'
  | 'devices'
  | 'displayName'
  | 'entryType'
  | 'id'
  | 'isDiscoverable'
  | 'lastUpdated'
  | 'placeGroup'
  | 'placeGroupId'
  | 'user'
  | 'userId'
  | UserDirectoryEntryQLKeySpecifier
)[];
export type UserDirectoryEntryQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customDirectoryEntry?: FieldPolicy<any> | FieldReadFunction<any>;
  customDirectoryEntryId?: FieldPolicy<any> | FieldReadFunction<any>;
  department?: FieldPolicy<any> | FieldReadFunction<any>;
  departmentId?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  devices?: FieldPolicy<any> | FieldReadFunction<any>;
  displayName?: FieldPolicy<any> | FieldReadFunction<any>;
  entryType?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isDiscoverable?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  placeGroup?: FieldPolicy<any> | FieldReadFunction<any>;
  placeGroupId?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserEdgeKeySpecifier = ('cursor' | 'node' | UserEdgeKeySpecifier)[];
export type UserEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserMetricsKeySpecifier = (
  | 'id'
  | 'lastMessageSentAt'
  | 'openConversationsCount'
  | 'overdueConversationsCount'
  | 'user'
  | UserMetricsKeySpecifier
)[];
export type UserMetricsFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastMessageSentAt?: FieldPolicy<any> | FieldReadFunction<any>;
  openConversationsCount?: FieldPolicy<any> | FieldReadFunction<any>;
  overdueConversationsCount?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserMetricsConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | UserMetricsConnectionKeySpecifier
)[];
export type UserMetricsConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserMetricsEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | UserMetricsEdgeKeySpecifier
)[];
export type UserMetricsEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserPhoneQLKeySpecifier = (
  | 'allowRoutingCalls'
  | 'createdOn'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'enabledWhenAway'
  | 'id'
  | 'lastUpdated'
  | 'mdn'
  | 'name'
  | 'sipAddress'
  | 'sipPriorityFirst'
  | 'type'
  | 'useNumaCallerId'
  | 'user'
  | 'userId'
  | UserPhoneQLKeySpecifier
)[];
export type UserPhoneQLFieldPolicy = {
  allowRoutingCalls?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledWhenAway?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  mdn?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  sipAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  sipPriorityFirst?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  useNumaCallerId?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  userId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserQLKeySpecifier = (
  | 'accountPermissions'
  | 'accountStatus'
  | 'active'
  | 'assignedAutopilots'
  | 'assignmentClaimSetting'
  | 'autoAssignSteps'
  | 'badgeCount'
  | 'billingIdentity'
  | 'billingIdentityId'
  | 'browserNotificationSetting'
  | 'canManageOwnAwayModeSettings'
  | 'closedConversationCount'
  | 'createdAutopilots'
  | 'createdOn'
  | 'crmUser'
  | 'crmUsers'
  | 'currentLoginAt'
  | 'currentLoginIp'
  | 'defaultView'
  | 'defaultYouView'
  | 'directoryEntries'
  | 'displayName'
  | 'email'
  | 'emailNotificationSetting'
  | 'emailOnAssignment'
  | 'enforceMfa'
  | 'firstName'
  | 'fullName'
  | 'hasExternalIdentity'
  | 'hasMobileLogin'
  | 'hasStatusItems'
  | 'hideSharedInboxViews'
  | 'id'
  | 'inboxes'
  | 'isAway'
  | 'isScheduleEnabled'
  | 'isUnassigningInboundMessages'
  | 'jobRole'
  | 'jobTitle'
  | 'language'
  | 'lastLoginAt'
  | 'lastLoginIp'
  | 'lastName'
  | 'lastUpdated'
  | 'localTimezone'
  | 'loginCount'
  | 'mdn'
  | 'mentions'
  | 'missedOutboundCallFollowUpEnabled'
  | 'missedOutboundCallFollowUpMessage'
  | 'missedOutboundCallFollowUpRenderedMessage'
  | 'namePronunciation'
  | 'namePronunciationUrl'
  | 'nextShiftEnd'
  | 'nextShiftStart'
  | 'openConversationCount'
  | 'outboundCallCustomizations'
  | 'outboundProxyNumber'
  | 'outboundProxyNumberId'
  | 'outboundProxyPinCode'
  | 'overdueConversationsPollingIntervalMsec'
  | 'participant'
  | 'participantId'
  | 'permissionsUpdated'
  | 'phonelines'
  | 'placePermissions'
  | 'placesUsers'
  | 'pronouns'
  | 'pushNotificationSetting'
  | 'roles'
  | 'schedule'
  | 'showAwayModeBannerAfter'
  | 'signature'
  | 'signaturePreference'
  | 'status'
  | 'statusBoardView'
  | 'statusItems'
  | 'statusLeaderboardColors'
  | 'swipeLeftSetting'
  | 'swipeRightSetting'
  | 'userPhonePreference'
  | 'userPhones'
  | 'videoConferenceUrl'
  | 'viewPreferences'
  | 'zendeskId'
  | UserQLKeySpecifier
)[];
export type UserQLFieldPolicy = {
  accountPermissions?: FieldPolicy<any> | FieldReadFunction<any>;
  accountStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  active?: FieldPolicy<any> | FieldReadFunction<any>;
  assignedAutopilots?: FieldPolicy<any> | FieldReadFunction<any>;
  assignmentClaimSetting?: FieldPolicy<any> | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  badgeCount?: FieldPolicy<any> | FieldReadFunction<any>;
  billingIdentity?: FieldPolicy<any> | FieldReadFunction<any>;
  billingIdentityId?: FieldPolicy<any> | FieldReadFunction<any>;
  browserNotificationSetting?: FieldPolicy<any> | FieldReadFunction<any>;
  canManageOwnAwayModeSettings?: FieldPolicy<any> | FieldReadFunction<any>;
  closedConversationCount?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAutopilots?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  crmUser?: FieldPolicy<any> | FieldReadFunction<any>;
  crmUsers?: FieldPolicy<any> | FieldReadFunction<any>;
  currentLoginAt?: FieldPolicy<any> | FieldReadFunction<any>;
  currentLoginIp?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultView?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultYouView?: FieldPolicy<any> | FieldReadFunction<any>;
  directoryEntries?: FieldPolicy<any> | FieldReadFunction<any>;
  displayName?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  emailNotificationSetting?: FieldPolicy<any> | FieldReadFunction<any>;
  emailOnAssignment?: FieldPolicy<any> | FieldReadFunction<any>;
  enforceMfa?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  fullName?: FieldPolicy<any> | FieldReadFunction<any>;
  hasExternalIdentity?: FieldPolicy<any> | FieldReadFunction<any>;
  hasMobileLogin?: FieldPolicy<any> | FieldReadFunction<any>;
  hasStatusItems?: FieldPolicy<any> | FieldReadFunction<any>;
  hideSharedInboxViews?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  inboxes?: FieldPolicy<any> | FieldReadFunction<any>;
  isAway?: FieldPolicy<any> | FieldReadFunction<any>;
  isScheduleEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  isUnassigningInboundMessages?: FieldPolicy<any> | FieldReadFunction<any>;
  jobRole?: FieldPolicy<any> | FieldReadFunction<any>;
  jobTitle?: FieldPolicy<any> | FieldReadFunction<any>;
  language?: FieldPolicy<any> | FieldReadFunction<any>;
  lastLoginAt?: FieldPolicy<any> | FieldReadFunction<any>;
  lastLoginIp?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  localTimezone?: FieldPolicy<any> | FieldReadFunction<any>;
  loginCount?: FieldPolicy<any> | FieldReadFunction<any>;
  mdn?: FieldPolicy<any> | FieldReadFunction<any>;
  mentions?: FieldPolicy<any> | FieldReadFunction<any>;
  missedOutboundCallFollowUpEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  missedOutboundCallFollowUpMessage?: FieldPolicy<any> | FieldReadFunction<any>;
  missedOutboundCallFollowUpRenderedMessage?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  namePronunciation?: FieldPolicy<any> | FieldReadFunction<any>;
  namePronunciationUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  nextShiftEnd?: FieldPolicy<any> | FieldReadFunction<any>;
  nextShiftStart?: FieldPolicy<any> | FieldReadFunction<any>;
  openConversationCount?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundCallCustomizations?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundProxyNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundProxyNumberId?: FieldPolicy<any> | FieldReadFunction<any>;
  outboundProxyPinCode?: FieldPolicy<any> | FieldReadFunction<any>;
  overdueConversationsPollingIntervalMsec?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  participantId?: FieldPolicy<any> | FieldReadFunction<any>;
  permissionsUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  phonelines?: FieldPolicy<any> | FieldReadFunction<any>;
  placePermissions?: FieldPolicy<any> | FieldReadFunction<any>;
  placesUsers?: FieldPolicy<any> | FieldReadFunction<any>;
  pronouns?: FieldPolicy<any> | FieldReadFunction<any>;
  pushNotificationSetting?: FieldPolicy<any> | FieldReadFunction<any>;
  roles?: FieldPolicy<any> | FieldReadFunction<any>;
  schedule?: FieldPolicy<any> | FieldReadFunction<any>;
  showAwayModeBannerAfter?: FieldPolicy<any> | FieldReadFunction<any>;
  signature?: FieldPolicy<any> | FieldReadFunction<any>;
  signaturePreference?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  statusBoardView?: FieldPolicy<any> | FieldReadFunction<any>;
  statusItems?: FieldPolicy<any> | FieldReadFunction<any>;
  statusLeaderboardColors?: FieldPolicy<any> | FieldReadFunction<any>;
  swipeLeftSetting?: FieldPolicy<any> | FieldReadFunction<any>;
  swipeRightSetting?: FieldPolicy<any> | FieldReadFunction<any>;
  userPhonePreference?: FieldPolicy<any> | FieldReadFunction<any>;
  userPhones?: FieldPolicy<any> | FieldReadFunction<any>;
  videoConferenceUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  viewPreferences?: FieldPolicy<any> | FieldReadFunction<any>;
  zendeskId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | UserQLConnectionKeySpecifier
)[];
export type UserQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | UserQLEdgeKeySpecifier
)[];
export type UserQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserViewPreferencesKeySpecifier = (
  | 'systemMessageSettings'
  | UserViewPreferencesKeySpecifier
)[];
export type UserViewPreferencesFieldPolicy = {
  systemMessageSettings?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VCardAttachmentKeySpecifier = (
  | 'attachmentType'
  | 'createdOn'
  | 'filename'
  | 'id'
  | 'lastUpdated'
  | 'message'
  | 'messageId'
  | 'primaryMimetype'
  | 'sizeBytes'
  | 'url'
  | 'words'
  | VCardAttachmentKeySpecifier
)[];
export type VCardAttachmentFieldPolicy = {
  attachmentType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  filename?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  messageId?: FieldPolicy<any> | FieldReadFunction<any>;
  primaryMimetype?: FieldPolicy<any> | FieldReadFunction<any>;
  sizeBytes?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
  words?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VehicleOutputQLKeySpecifier = (
  | 'make'
  | 'model'
  | 'year'
  | VehicleOutputQLKeySpecifier
)[];
export type VehicleOutputQLFieldPolicy = {
  make?: FieldPolicy<any> | FieldReadFunction<any>;
  model?: FieldPolicy<any> | FieldReadFunction<any>;
  year?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VideoUploadLinkAttachmentKeySpecifier = (
  | 'attachmentType'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'message'
  | 'messageId'
  | 'url'
  | 'videoMicrositeLinkId'
  | 'videoUploadLink'
  | 'videoUploadLinkId'
  | VideoUploadLinkAttachmentKeySpecifier
)[];
export type VideoUploadLinkAttachmentFieldPolicy = {
  attachmentType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  messageId?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
  videoMicrositeLinkId?: FieldPolicy<any> | FieldReadFunction<any>;
  videoUploadLink?: FieldPolicy<any> | FieldReadFunction<any>;
  videoUploadLinkId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VideoUploadLinkAttachmentConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | VideoUploadLinkAttachmentConnectionKeySpecifier
)[];
export type VideoUploadLinkAttachmentConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VideoUploadLinkAttachmentEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | VideoUploadLinkAttachmentEdgeKeySpecifier
)[];
export type VideoUploadLinkAttachmentEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VideoUploadLinkQLKeySpecifier = (
  | 'attachments'
  | 'createdOn'
  | 'deletedAt'
  | 'deletedBy'
  | 'deletedById'
  | 'duration'
  | 'externalId'
  | 'fileName'
  | 'fileSize'
  | 'hasBeenSent'
  | 'id'
  | 'lastUpdated'
  | 'micrositeId'
  | 'note'
  | 'participant'
  | 'participantId'
  | 'payload'
  | 'place'
  | 'placeId'
  | 'playbackDash'
  | 'playbackHls'
  | 'previewUrl'
  | 'readyToStream'
  | 'status'
  | 'thumbnailUrl'
  | 'uploadUrl'
  | 'uploader'
  | 'uploaderId'
  | VideoUploadLinkQLKeySpecifier
)[];
export type VideoUploadLinkQLFieldPolicy = {
  attachments?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  deletedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  deletedBy?: FieldPolicy<any> | FieldReadFunction<any>;
  deletedById?: FieldPolicy<any> | FieldReadFunction<any>;
  duration?: FieldPolicy<any> | FieldReadFunction<any>;
  externalId?: FieldPolicy<any> | FieldReadFunction<any>;
  fileName?: FieldPolicy<any> | FieldReadFunction<any>;
  fileSize?: FieldPolicy<any> | FieldReadFunction<any>;
  hasBeenSent?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  micrositeId?: FieldPolicy<any> | FieldReadFunction<any>;
  note?: FieldPolicy<any> | FieldReadFunction<any>;
  participant?: FieldPolicy<any> | FieldReadFunction<any>;
  participantId?: FieldPolicy<any> | FieldReadFunction<any>;
  payload?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  playbackDash?: FieldPolicy<any> | FieldReadFunction<any>;
  playbackHls?: FieldPolicy<any> | FieldReadFunction<any>;
  previewUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  readyToStream?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  thumbnailUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  uploadUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  uploader?: FieldPolicy<any> | FieldReadFunction<any>;
  uploaderId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VideoUploadLinkQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | VideoUploadLinkQLConnectionKeySpecifier
)[];
export type VideoUploadLinkQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VideoUploadLinkQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | VideoUploadLinkQLEdgeKeySpecifier
)[];
export type VideoUploadLinkQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VoiceKeySpecifier = (
  | 'displayName'
  | 'language'
  | 'name'
  | 'service'
  | VoiceKeySpecifier
)[];
export type VoiceFieldPolicy = {
  displayName?: FieldPolicy<any> | FieldReadFunction<any>;
  language?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  service?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VoiceConfigurationQLKeySpecifier = (
  | 'imgUrl'
  | 'language'
  | 'service'
  | 'voiceAudio'
  | 'voiceType'
  | VoiceConfigurationQLKeySpecifier
)[];
export type VoiceConfigurationQLFieldPolicy = {
  imgUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  language?: FieldPolicy<any> | FieldReadFunction<any>;
  service?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceAudio?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VoiceScriptQLKeySpecifier = (
  | 'Voice'
  | 'afterHoursEnabled'
  | 'allowCustomAudio'
  | 'answeringScripts'
  | 'createdOn'
  | 'dirty'
  | 'disruptionDepartmentDisruption'
  | 'disruptionStaffDisruption'
  | 'draftAnsweringScripts'
  | 'draftDisruptionDepartmentDisruption'
  | 'draftDisruptionStaffDisruption'
  | 'draftHolidayDepartmentDisruption'
  | 'draftHolidayStaffDisruption'
  | 'firstStep'
  | 'firstStepId'
  | 'holidayDepartmentDisruption'
  | 'holidayStaffDisruption'
  | 'id'
  | 'lastUpdated'
  | 'place'
  | 'placeId'
  | 'previewScript'
  | 'previewVoicemailScript'
  | 'primaryVoiceScriptVoiceScripts'
  | 'scriptType'
  | 'steps'
  | 'voice'
  | VoiceScriptQLKeySpecifier
)[];
export type VoiceScriptQLFieldPolicy = {
  Voice?: FieldPolicy<any> | FieldReadFunction<any>;
  afterHoursEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  allowCustomAudio?: FieldPolicy<any> | FieldReadFunction<any>;
  answeringScripts?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  dirty?: FieldPolicy<any> | FieldReadFunction<any>;
  disruptionDepartmentDisruption?: FieldPolicy<any> | FieldReadFunction<any>;
  disruptionStaffDisruption?: FieldPolicy<any> | FieldReadFunction<any>;
  draftAnsweringScripts?: FieldPolicy<any> | FieldReadFunction<any>;
  draftDisruptionDepartmentDisruption?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  draftDisruptionStaffDisruption?: FieldPolicy<any> | FieldReadFunction<any>;
  draftHolidayDepartmentDisruption?: FieldPolicy<any> | FieldReadFunction<any>;
  draftHolidayStaffDisruption?: FieldPolicy<any> | FieldReadFunction<any>;
  firstStep?: FieldPolicy<any> | FieldReadFunction<any>;
  firstStepId?: FieldPolicy<any> | FieldReadFunction<any>;
  holidayDepartmentDisruption?: FieldPolicy<any> | FieldReadFunction<any>;
  holidayStaffDisruption?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  previewScript?: FieldPolicy<any> | FieldReadFunction<any>;
  previewVoicemailScript?: FieldPolicy<any> | FieldReadFunction<any>;
  primaryVoiceScriptVoiceScripts?: FieldPolicy<any> | FieldReadFunction<any>;
  scriptType?: FieldPolicy<any> | FieldReadFunction<any>;
  steps?: FieldPolicy<any> | FieldReadFunction<any>;
  voice?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VoiceScriptStepKeySpecifier = (
  | 'canToggle'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'id'
  | 'label'
  | 'lastUpdated'
  | 'place'
  | 'placeId'
  | 'renderedSpeech'
  | 'speech'
  | 'speechAudioUrl'
  | 'stepType'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | VoiceScriptStepKeySpecifier
)[];
export type VoiceScriptStepFieldPolicy = {
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VoiceScriptStepQLKeySpecifier = (
  | 'appointmentAgentSteps'
  | 'appointmentLeadAgentSteps'
  | 'appointmentLeadConversationalSchedulingAgentSteps'
  | 'autoAssignSteps'
  | 'callForwardingConnectedSteps'
  | 'callRecordingSteps'
  | 'canToggle'
  | 'cantServiceCustomerAgentSteps'
  | 'checkBusinessHoursOnClosedSteps'
  | 'checkBusinessHoursOnOpenSteps'
  | 'conversationStateSteps'
  | 'conversationalSchedulingAgentSteps'
  | 'createdOn'
  | 'customAfterHoursAudioUrl'
  | 'customAudioOverrides'
  | 'customAudioUrl'
  | 'enabledAfterBusinessHours'
  | 'enabledDuringBusinessHours'
  | 'executionOrder'
  | 'failureAppointmentAgentSteps'
  | 'failureConversationalSchedulingAgentSteps'
  | 'failureNoteTakerSteps'
  | 'failureQuestionBotSteps'
  | 'failureRecallAppointmentAgentSteps'
  | 'firstInScript'
  | 'forwardingNoAnsweringSteps'
  | 'greetingSteps'
  | 'humanEscalationConversationalSchedulingAgentSteps'
  | 'id'
  | 'intentQuestionOnNoSteps'
  | 'intentQuestionOnYesButNoTextSteps'
  | 'intentQuestionOnYesSteps'
  | 'label'
  | 'labelConversationSteps'
  | 'lastUpdated'
  | 'notAnAppointmentLeadAgentSteps'
  | 'noteTakerSteps'
  | 'onHasLabelSteps'
  | 'onHasResponseSteps'
  | 'onMissingLabelSteps'
  | 'onNoResponseSteps'
  | 'operatorAgentSteps'
  | 'otherFailureAppointmentAgentSteps'
  | 'pickupSteps'
  | 'place'
  | 'placeId'
  | 'questionBotSteps'
  | 'renderedSpeech'
  | 'smartTopicNoMatchSteps'
  | 'speakSteps'
  | 'specialQuestionOnNoSteps'
  | 'specialQuestionOnYesButNoTextSteps'
  | 'specialQuestionOnYesSteps'
  | 'speech'
  | 'speechAudioUrl'
  | 'statusUpdaterStatusGivenStep'
  | 'statusUpdaterStatusGivenSteps'
  | 'stepType'
  | 'textOptinOnNoSteps'
  | 'textOptinOnYesSteps'
  | 'uiHints'
  | 'voiceScript'
  | 'voiceScriptId'
  | 'yesNoQuestionOnNoSteps'
  | 'yesNoQuestionOnYesSteps'
  | VoiceScriptStepQLKeySpecifier
)[];
export type VoiceScriptStepQLFieldPolicy = {
  appointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  appointmentLeadConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  autoAssignSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callForwardingConnectedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  callRecordingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  canToggle?: FieldPolicy<any> | FieldReadFunction<any>;
  cantServiceCustomerAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnClosedSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  checkBusinessHoursOnOpenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationStateSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  conversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customAfterHoursAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioOverrides?: FieldPolicy<any> | FieldReadFunction<any>;
  customAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledAfterBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  enabledDuringBusinessHours?: FieldPolicy<any> | FieldReadFunction<any>;
  executionOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  failureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  failureNoteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureQuestionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  failureRecallAppointmentAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  firstInScript?: FieldPolicy<any> | FieldReadFunction<any>;
  forwardingNoAnsweringSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  greetingSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  humanEscalationConversationalSchedulingAgentSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesButNoTextSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  intentQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  labelConversationSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  notAnAppointmentLeadAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  noteTakerSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onHasResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onMissingLabelSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  onNoResponseSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  operatorAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  otherFailureAppointmentAgentSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
  questionBotSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  renderedSpeech?: FieldPolicy<any> | FieldReadFunction<any>;
  smartTopicNoMatchSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speakSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  specialQuestionOnYesButNoTextSteps?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  specialQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  speech?: FieldPolicy<any> | FieldReadFunction<any>;
  speechAudioUrl?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenStep?: FieldPolicy<any> | FieldReadFunction<any>;
  statusUpdaterStatusGivenSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  stepType?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  textOptinOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScript?: FieldPolicy<any> | FieldReadFunction<any>;
  voiceScriptId?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnNoSteps?: FieldPolicy<any> | FieldReadFunction<any>;
  yesNoQuestionOnYesSteps?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VoiceScriptStepQLConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | VoiceScriptStepQLConnectionKeySpecifier
)[];
export type VoiceScriptStepQLConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VoiceScriptStepQLEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | VoiceScriptStepQLEdgeKeySpecifier
)[];
export type VoiceScriptStepQLEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VoiceStepUIHintsKeySpecifier = (
  | 'x'
  | 'y'
  | VoiceStepUIHintsKeySpecifier
)[];
export type VoiceStepUIHintsFieldPolicy = {
  x?: FieldPolicy<any> | FieldReadFunction<any>;
  y?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WaitActionQLKeySpecifier = (
  | 'actionType'
  | 'automation'
  | 'automationId'
  | 'createdOn'
  | 'customersWaiting'
  | 'id'
  | 'lastUpdated'
  | 'minutesToWait'
  | 'nextActionId'
  | 'uiHints'
  | WaitActionQLKeySpecifier
)[];
export type WaitActionQLFieldPolicy = {
  actionType?: FieldPolicy<any> | FieldReadFunction<any>;
  automation?: FieldPolicy<any> | FieldReadFunction<any>;
  automationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  customersWaiting?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  minutesToWait?: FieldPolicy<any> | FieldReadFunction<any>;
  nextActionId?: FieldPolicy<any> | FieldReadFunction<any>;
  uiHints?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WriteItForMeAnswerOptionKeySpecifier = (
  | 'id'
  | 'nextQuestionId'
  | 'text'
  | WriteItForMeAnswerOptionKeySpecifier
)[];
export type WriteItForMeAnswerOptionFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  nextQuestionId?: FieldPolicy<any> | FieldReadFunction<any>;
  text?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WriteItForMeConfigQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'instructions'
  | 'lastUpdated'
  | 'place'
  | 'placeId'
  | WriteItForMeConfigQLKeySpecifier
)[];
export type WriteItForMeConfigQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  instructions?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  place?: FieldPolicy<any> | FieldReadFunction<any>;
  placeId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WriteItForMeQuestionNodeKeySpecifier = (
  | 'answers'
  | 'defaultAnswer'
  | 'id'
  | 'text'
  | WriteItForMeQuestionNodeKeySpecifier
)[];
export type WriteItForMeQuestionNodeFieldPolicy = {
  answers?: FieldPolicy<any> | FieldReadFunction<any>;
  defaultAnswer?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  text?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WriteItForMeQuestionTreeKeySpecifier = (
  | 'questions'
  | WriteItForMeQuestionTreeKeySpecifier
)[];
export type WriteItForMeQuestionTreeFieldPolicy = {
  questions?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type XTimeLogModelQlKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'notes'
  | 'opCode'
  | 'opCodeId'
  | 'supportedVehicles'
  | 'supportedVehiclesId'
  | 'xtimeLog'
  | 'xtimeSync'
  | 'xtimeSyncId'
  | XTimeLogModelQlKeySpecifier
)[];
export type XTimeLogModelQlFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  notes?: FieldPolicy<any> | FieldReadFunction<any>;
  opCode?: FieldPolicy<any> | FieldReadFunction<any>;
  opCodeId?: FieldPolicy<any> | FieldReadFunction<any>;
  supportedVehicles?: FieldPolicy<any> | FieldReadFunction<any>;
  supportedVehiclesId?: FieldPolicy<any> | FieldReadFunction<any>;
  xtimeLog?: FieldPolicy<any> | FieldReadFunction<any>;
  xtimeSync?: FieldPolicy<any> | FieldReadFunction<any>;
  xtimeSyncId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type XTimeLogModelQlConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | XTimeLogModelQlConnectionKeySpecifier
)[];
export type XTimeLogModelQlConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type XTimeLogModelQlEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | XTimeLogModelQlEdgeKeySpecifier
)[];
export type XTimeLogModelQlEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type XTimeLogQLKeySpecifier = (
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'notes'
  | 'opCode'
  | 'opCodeId'
  | 'supportedVehicles'
  | 'supportedVehiclesId'
  | 'xtimeSync'
  | 'xtimeSyncId'
  | XTimeLogQLKeySpecifier
)[];
export type XTimeLogQLFieldPolicy = {
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  notes?: FieldPolicy<any> | FieldReadFunction<any>;
  opCode?: FieldPolicy<any> | FieldReadFunction<any>;
  opCodeId?: FieldPolicy<any> | FieldReadFunction<any>;
  supportedVehicles?: FieldPolicy<any> | FieldReadFunction<any>;
  supportedVehiclesId?: FieldPolicy<any> | FieldReadFunction<any>;
  xtimeSync?: FieldPolicy<any> | FieldReadFunction<any>;
  xtimeSyncId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type XTimeSyncConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | XTimeSyncConnectionKeySpecifier
)[];
export type XTimeSyncConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type XTimeSyncEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | XTimeSyncEdgeKeySpecifier
)[];
export type XTimeSyncEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type XTimeSyncModelQLKeySpecifier = (
  | 'Status'
  | 'activeIntegration'
  | 'activeIntegrationId'
  | 'createdOn'
  | 'endDate'
  | 'id'
  | 'lastUpdated'
  | 'startDate'
  | 'status'
  | 'taskIds'
  | 'xtimeLogs'
  | 'xtimeSync'
  | XTimeSyncModelQLKeySpecifier
)[];
export type XTimeSyncModelQLFieldPolicy = {
  Status?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  endDate?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  startDate?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  taskIds?: FieldPolicy<any> | FieldReadFunction<any>;
  xtimeLogs?: FieldPolicy<any> | FieldReadFunction<any>;
  xtimeSync?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type XTimeSyncQLKeySpecifier = (
  | 'activeIntegration'
  | 'activeIntegrationId'
  | 'createdOn'
  | 'endDate'
  | 'id'
  | 'lastUpdated'
  | 'startDate'
  | 'status'
  | 'taskIds'
  | 'xtimeLogs'
  | XTimeSyncQLKeySpecifier
)[];
export type XTimeSyncQLFieldPolicy = {
  activeIntegration?: FieldPolicy<any> | FieldReadFunction<any>;
  activeIntegrationId?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  endDate?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  startDate?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  taskIds?: FieldPolicy<any> | FieldReadFunction<any>;
  xtimeLogs?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type XtimeServiceQLKeySpecifier = (
  | 'comment'
  | 'opcode'
  | 'price'
  | 'sabCode'
  | 'serviceCategoryId'
  | 'serviceCategoryName'
  | 'serviceName'
  | XtimeServiceQLKeySpecifier
)[];
export type XtimeServiceQLFieldPolicy = {
  comment?: FieldPolicy<any> | FieldReadFunction<any>;
  opcode?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  sabCode?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceCategoryId?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceCategoryName?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceName?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type YelpAttachmentKeySpecifier = (
  | 'attachmentType'
  | 'createdOn'
  | 'id'
  | 'lastUpdated'
  | 'message'
  | 'messageId'
  | 'placeInfo'
  | 'placeInfoId'
  | 'url'
  | YelpAttachmentKeySpecifier
)[];
export type YelpAttachmentFieldPolicy = {
  attachmentType?: FieldPolicy<any> | FieldReadFunction<any>;
  createdOn?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  messageId?: FieldPolicy<any> | FieldReadFunction<any>;
  placeInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  placeInfoId?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type YelpAttachmentConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | YelpAttachmentConnectionKeySpecifier
)[];
export type YelpAttachmentConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type YelpAttachmentEdgeKeySpecifier = (
  | 'cursor'
  | 'node'
  | YelpAttachmentEdgeKeySpecifier
)[];
export type YelpAttachmentEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StrictTypedTypePolicies = {
  AccountConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AccountConnectionKeySpecifier
      | (() => undefined | AccountConnectionKeySpecifier);
    fields?: AccountConnectionFieldPolicy;
  };
  AccountEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AccountEdgeKeySpecifier
      | (() => undefined | AccountEdgeKeySpecifier);
    fields?: AccountEdgeFieldPolicy;
  };
  AccountPermissionsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AccountPermissionsQLKeySpecifier
      | (() => undefined | AccountPermissionsQLKeySpecifier);
    fields?: AccountPermissionsQLFieldPolicy;
  };
  AccountQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AccountQLKeySpecifier
      | (() => undefined | AccountQLKeySpecifier);
    fields?: AccountQLFieldPolicy;
  };
  AccountSettingsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AccountSettingsQLKeySpecifier
      | (() => undefined | AccountSettingsQLKeySpecifier);
    fields?: AccountSettingsQLFieldPolicy;
  };
  ActiveInbox?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ActiveInboxKeySpecifier
      | (() => undefined | ActiveInboxKeySpecifier);
    fields?: ActiveInboxFieldPolicy;
  };
  ActiveInboxOptions?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ActiveInboxOptionsKeySpecifier
      | (() => undefined | ActiveInboxOptionsKeySpecifier);
    fields?: ActiveInboxOptionsFieldPolicy;
  };
  ActiveIntegrationQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ActiveIntegrationQLKeySpecifier
      | (() => undefined | ActiveIntegrationQLKeySpecifier);
    fields?: ActiveIntegrationQLFieldPolicy;
  };
  ActiveIntegrationQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ActiveIntegrationQLConnectionKeySpecifier
      | (() => undefined | ActiveIntegrationQLConnectionKeySpecifier);
    fields?: ActiveIntegrationQLConnectionFieldPolicy;
  };
  ActiveIntegrationQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ActiveIntegrationQLEdgeKeySpecifier
      | (() => undefined | ActiveIntegrationQLEdgeKeySpecifier);
    fields?: ActiveIntegrationQLEdgeFieldPolicy;
  };
  ActivePaymentsCollection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ActivePaymentsCollectionKeySpecifier
      | (() => undefined | ActivePaymentsCollectionKeySpecifier);
    fields?: ActivePaymentsCollectionFieldPolicy;
  };
  AddAnsweringScriptToPolicy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddAnsweringScriptToPolicyKeySpecifier
      | (() => undefined | AddAnsweringScriptToPolicyKeySpecifier);
    fields?: AddAnsweringScriptToPolicyFieldPolicy;
  };
  AddAutomationExitTrigger?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddAutomationExitTriggerKeySpecifier
      | (() => undefined | AddAutomationExitTriggerKeySpecifier);
    fields?: AddAutomationExitTriggerFieldPolicy;
  };
  AddAvailableIntegration?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddAvailableIntegrationKeySpecifier
      | (() => undefined | AddAvailableIntegrationKeySpecifier);
    fields?: AddAvailableIntegrationFieldPolicy;
  };
  AddCustomLink?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddCustomLinkKeySpecifier
      | (() => undefined | AddCustomLinkKeySpecifier);
    fields?: AddCustomLinkFieldPolicy;
  };
  AddCustomer?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddCustomerKeySpecifier
      | (() => undefined | AddCustomerKeySpecifier);
    fields?: AddCustomerFieldPolicy;
  };
  AddFortellisSubscription?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddFortellisSubscriptionKeySpecifier
      | (() => undefined | AddFortellisSubscriptionKeySpecifier);
    fields?: AddFortellisSubscriptionFieldPolicy;
  };
  AddLabelToConversation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddLabelToConversationKeySpecifier
      | (() => undefined | AddLabelToConversationKeySpecifier);
    fields?: AddLabelToConversationFieldPolicy;
  };
  AddOperatorChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddOperatorChannelKeySpecifier
      | (() => undefined | AddOperatorChannelKeySpecifier);
    fields?: AddOperatorChannelFieldPolicy;
  };
  AddOperatorPlace?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddOperatorPlaceKeySpecifier
      | (() => undefined | AddOperatorPlaceKeySpecifier);
    fields?: AddOperatorPlaceFieldPolicy;
  };
  AddOutboundCallCustomization?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddOutboundCallCustomizationKeySpecifier
      | (() => undefined | AddOutboundCallCustomizationKeySpecifier);
    fields?: AddOutboundCallCustomizationFieldPolicy;
  };
  AddPlaceGroup?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddPlaceGroupKeySpecifier
      | (() => undefined | AddPlaceGroupKeySpecifier);
    fields?: AddPlaceGroupFieldPolicy;
  };
  AddServiceAdvisor?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddServiceAdvisorKeySpecifier
      | (() => undefined | AddServiceAdvisorKeySpecifier);
    fields?: AddServiceAdvisorFieldPolicy;
  };
  AddStage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddStageKeySpecifier
      | (() => undefined | AddStageKeySpecifier);
    fields?: AddStageFieldPolicy;
  };
  AddStatusItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddStatusItemKeySpecifier
      | (() => undefined | AddStatusItemKeySpecifier);
    fields?: AddStatusItemFieldPolicy;
  };
  AddSubscription?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddSubscriptionKeySpecifier
      | (() => undefined | AddSubscriptionKeySpecifier);
    fields?: AddSubscriptionFieldPolicy;
  };
  AddUserToTeam?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddUserToTeamKeySpecifier
      | (() => undefined | AddUserToTeamKeySpecifier);
    fields?: AddUserToTeamFieldPolicy;
  };
  AddVoiceStep?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddVoiceStepKeySpecifier
      | (() => undefined | AddVoiceStepKeySpecifier);
    fields?: AddVoiceStepFieldPolicy;
  };
  AddressConsentStatusModelQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddressConsentStatusModelQLKeySpecifier
      | (() => undefined | AddressConsentStatusModelQLKeySpecifier);
    fields?: AddressConsentStatusModelQLFieldPolicy;
  };
  AddressQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddressQLKeySpecifier
      | (() => undefined | AddressQLKeySpecifier);
    fields?: AddressQLFieldPolicy;
  };
  AgentChitChatResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AgentChitChatResponseKeySpecifier
      | (() => undefined | AgentChitChatResponseKeySpecifier);
    fields?: AgentChitChatResponseFieldPolicy;
  };
  AnswerOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AnswerOptionKeySpecifier
      | (() => undefined | AnswerOptionKeySpecifier);
    fields?: AnswerOptionFieldPolicy;
  };
  AnsweringScriptsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AnsweringScriptsQLKeySpecifier
      | (() => undefined | AnsweringScriptsQLKeySpecifier);
    fields?: AnsweringScriptsQLFieldPolicy;
  };
  AnsweringScriptsQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AnsweringScriptsQLConnectionKeySpecifier
      | (() => undefined | AnsweringScriptsQLConnectionKeySpecifier);
    fields?: AnsweringScriptsQLConnectionFieldPolicy;
  };
  AnsweringScriptsQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AnsweringScriptsQLEdgeKeySpecifier
      | (() => undefined | AnsweringScriptsQLEdgeKeySpecifier);
    fields?: AnsweringScriptsQLEdgeFieldPolicy;
  };
  AppliedIntentQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppliedIntentQLKeySpecifier
      | (() => undefined | AppliedIntentQLKeySpecifier);
    fields?: AppliedIntentQLFieldPolicy;
  };
  AppliedIntentQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppliedIntentQLConnectionKeySpecifier
      | (() => undefined | AppliedIntentQLConnectionKeySpecifier);
    fields?: AppliedIntentQLConnectionFieldPolicy;
  };
  AppliedIntentQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppliedIntentQLEdgeKeySpecifier
      | (() => undefined | AppliedIntentQLEdgeKeySpecifier);
    fields?: AppliedIntentQLEdgeFieldPolicy;
  };
  AppointmentAgentNoteRatingQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppointmentAgentNoteRatingQLKeySpecifier
      | (() => undefined | AppointmentAgentNoteRatingQLKeySpecifier);
    fields?: AppointmentAgentNoteRatingQLFieldPolicy;
  };
  AppointmentAgentSettingLabelQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppointmentAgentSettingLabelQLKeySpecifier
      | (() => undefined | AppointmentAgentSettingLabelQLKeySpecifier);
    fields?: AppointmentAgentSettingLabelQLFieldPolicy;
  };
  AppointmentAgentSettingsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppointmentAgentSettingsQLKeySpecifier
      | (() => undefined | AppointmentAgentSettingsQLKeySpecifier);
    fields?: AppointmentAgentSettingsQLFieldPolicy;
  };
  AppointmentAgentSettingsQLConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | AppointmentAgentSettingsQLConnectionKeySpecifier
      | (() => undefined | AppointmentAgentSettingsQLConnectionKeySpecifier);
    fields?: AppointmentAgentSettingsQLConnectionFieldPolicy;
  };
  AppointmentAgentSettingsQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppointmentAgentSettingsQLEdgeKeySpecifier
      | (() => undefined | AppointmentAgentSettingsQLEdgeKeySpecifier);
    fields?: AppointmentAgentSettingsQLEdgeFieldPolicy;
  };
  AppointmentAgentStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppointmentAgentStepQLKeySpecifier
      | (() => undefined | AppointmentAgentStepQLKeySpecifier);
    fields?: AppointmentAgentStepQLFieldPolicy;
  };
  AppointmentAgentStepQLConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | AppointmentAgentStepQLConnectionKeySpecifier
      | (() => undefined | AppointmentAgentStepQLConnectionKeySpecifier);
    fields?: AppointmentAgentStepQLConnectionFieldPolicy;
  };
  AppointmentAgentStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppointmentAgentStepQLEdgeKeySpecifier
      | (() => undefined | AppointmentAgentStepQLEdgeKeySpecifier);
    fields?: AppointmentAgentStepQLEdgeFieldPolicy;
  };
  AppointmentLeadCreatedTriggerQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppointmentLeadCreatedTriggerQLKeySpecifier
      | (() => undefined | AppointmentLeadCreatedTriggerQLKeySpecifier);
    fields?: AppointmentLeadCreatedTriggerQLFieldPolicy;
  };
  AppointmentLeadUpdatedTriggerQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppointmentLeadUpdatedTriggerQLKeySpecifier
      | (() => undefined | AppointmentLeadUpdatedTriggerQLKeySpecifier);
    fields?: AppointmentLeadUpdatedTriggerQLFieldPolicy;
  };
  AppointmentQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppointmentQLKeySpecifier
      | (() => undefined | AppointmentQLKeySpecifier);
    fields?: AppointmentQLFieldPolicy;
  };
  AppointmentQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppointmentQLConnectionKeySpecifier
      | (() => undefined | AppointmentQLConnectionKeySpecifier);
    fields?: AppointmentQLConnectionFieldPolicy;
  };
  AppointmentQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppointmentQLEdgeKeySpecifier
      | (() => undefined | AppointmentQLEdgeKeySpecifier);
    fields?: AppointmentQLEdgeFieldPolicy;
  };
  ArchiveMissedCalls?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ArchiveMissedCallsKeySpecifier
      | (() => undefined | ArchiveMissedCallsKeySpecifier);
    fields?: ArchiveMissedCallsFieldPolicy;
  };
  AskYesNoQuestionStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AskYesNoQuestionStepQLKeySpecifier
      | (() => undefined | AskYesNoQuestionStepQLKeySpecifier);
    fields?: AskYesNoQuestionStepQLFieldPolicy;
  };
  AskYesNoQuestionStepQLConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | AskYesNoQuestionStepQLConnectionKeySpecifier
      | (() => undefined | AskYesNoQuestionStepQLConnectionKeySpecifier);
    fields?: AskYesNoQuestionStepQLConnectionFieldPolicy;
  };
  AskYesNoQuestionStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AskYesNoQuestionStepQLEdgeKeySpecifier
      | (() => undefined | AskYesNoQuestionStepQLEdgeKeySpecifier);
    fields?: AskYesNoQuestionStepQLEdgeFieldPolicy;
  };
  AssignConversationActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AssignConversationActionQLKeySpecifier
      | (() => undefined | AssignConversationActionQLKeySpecifier);
    fields?: AssignConversationActionQLFieldPolicy;
  };
  AssignConversations?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AssignConversationsKeySpecifier
      | (() => undefined | AssignConversationsKeySpecifier);
    fields?: AssignConversationsFieldPolicy;
  };
  AssignmentDetailsAttachment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AssignmentDetailsAttachmentKeySpecifier
      | (() => undefined | AssignmentDetailsAttachmentKeySpecifier);
    fields?: AssignmentDetailsAttachmentFieldPolicy;
  };
  AssignmentRetentionChoiceQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AssignmentRetentionChoiceQLKeySpecifier
      | (() => undefined | AssignmentRetentionChoiceQLKeySpecifier);
    fields?: AssignmentRetentionChoiceQLFieldPolicy;
  };
  AssignmentRoutingSettingQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AssignmentRoutingSettingQLKeySpecifier
      | (() => undefined | AssignmentRoutingSettingQLKeySpecifier);
    fields?: AssignmentRoutingSettingQLFieldPolicy;
  };
  AssistedResponseRatingQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AssistedResponseRatingQLKeySpecifier
      | (() => undefined | AssistedResponseRatingQLKeySpecifier);
    fields?: AssistedResponseRatingQLFieldPolicy;
  };
  Attachment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AttachmentKeySpecifier
      | (() => undefined | AttachmentKeySpecifier);
    fields?: AttachmentFieldPolicy;
  };
  AuthTokens?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AuthTokensKeySpecifier
      | (() => undefined | AuthTokensKeySpecifier);
    fields?: AuthTokensFieldPolicy;
  };
  AutoAssignStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutoAssignStepQLKeySpecifier
      | (() => undefined | AutoAssignStepQLKeySpecifier);
    fields?: AutoAssignStepQLFieldPolicy;
  };
  AutoAssignStepQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutoAssignStepQLConnectionKeySpecifier
      | (() => undefined | AutoAssignStepQLConnectionKeySpecifier);
    fields?: AutoAssignStepQLConnectionFieldPolicy;
  };
  AutoAssignStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutoAssignStepQLEdgeKeySpecifier
      | (() => undefined | AutoAssignStepQLEdgeKeySpecifier);
    fields?: AutoAssignStepQLEdgeFieldPolicy;
  };
  AutomationAction?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutomationActionKeySpecifier
      | (() => undefined | AutomationActionKeySpecifier);
    fields?: AutomationActionFieldPolicy;
  };
  AutomationChannels?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutomationChannelsKeySpecifier
      | (() => undefined | AutomationChannelsKeySpecifier);
    fields?: AutomationChannelsFieldPolicy;
  };
  AutomationConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutomationConnectionKeySpecifier
      | (() => undefined | AutomationConnectionKeySpecifier);
    fields?: AutomationConnectionFieldPolicy;
  };
  AutomationEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutomationEdgeKeySpecifier
      | (() => undefined | AutomationEdgeKeySpecifier);
    fields?: AutomationEdgeFieldPolicy;
  };
  AutomationGroupQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutomationGroupQLKeySpecifier
      | (() => undefined | AutomationGroupQLKeySpecifier);
    fields?: AutomationGroupQLFieldPolicy;
  };
  AutomationJobConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutomationJobConnectionKeySpecifier
      | (() => undefined | AutomationJobConnectionKeySpecifier);
    fields?: AutomationJobConnectionFieldPolicy;
  };
  AutomationJobEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutomationJobEdgeKeySpecifier
      | (() => undefined | AutomationJobEdgeKeySpecifier);
    fields?: AutomationJobEdgeFieldPolicy;
  };
  AutomationJobQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutomationJobQLKeySpecifier
      | (() => undefined | AutomationJobQLKeySpecifier);
    fields?: AutomationJobQLFieldPolicy;
  };
  AutomationJobQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutomationJobQLConnectionKeySpecifier
      | (() => undefined | AutomationJobQLConnectionKeySpecifier);
    fields?: AutomationJobQLConnectionFieldPolicy;
  };
  AutomationJobQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutomationJobQLEdgeKeySpecifier
      | (() => undefined | AutomationJobQLEdgeKeySpecifier);
    fields?: AutomationJobQLEdgeFieldPolicy;
  };
  AutomationQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutomationQLKeySpecifier
      | (() => undefined | AutomationQLKeySpecifier);
    fields?: AutomationQLFieldPolicy;
  };
  AutomationTrigger?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutomationTriggerKeySpecifier
      | (() => undefined | AutomationTriggerKeySpecifier);
    fields?: AutomationTriggerFieldPolicy;
  };
  AutomationUIHints?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutomationUIHintsKeySpecifier
      | (() => undefined | AutomationUIHintsKeySpecifier);
    fields?: AutomationUIHintsFieldPolicy;
  };
  AutopilotJobQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutopilotJobQLKeySpecifier
      | (() => undefined | AutopilotJobQLKeySpecifier);
    fields?: AutopilotJobQLFieldPolicy;
  };
  AutopilotQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutopilotQLKeySpecifier
      | (() => undefined | AutopilotQLKeySpecifier);
    fields?: AutopilotQLFieldPolicy;
  };
  AutopilotQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutopilotQLConnectionKeySpecifier
      | (() => undefined | AutopilotQLConnectionKeySpecifier);
    fields?: AutopilotQLConnectionFieldPolicy;
  };
  AutopilotQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutopilotQLEdgeKeySpecifier
      | (() => undefined | AutopilotQLEdgeKeySpecifier);
    fields?: AutopilotQLEdgeFieldPolicy;
  };
  AutopilotScheduledMessageQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AutopilotScheduledMessageQLKeySpecifier
      | (() => undefined | AutopilotScheduledMessageQLKeySpecifier);
    fields?: AutopilotScheduledMessageQLFieldPolicy;
  };
  AvailableIntegrationQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AvailableIntegrationQLKeySpecifier
      | (() => undefined | AvailableIntegrationQLKeySpecifier);
    fields?: AvailableIntegrationQLFieldPolicy;
  };
  AvailableVoiceScript?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AvailableVoiceScriptKeySpecifier
      | (() => undefined | AvailableVoiceScriptKeySpecifier);
    fields?: AvailableVoiceScriptFieldPolicy;
  };
  AvailableVoiceStep?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AvailableVoiceStepKeySpecifier
      | (() => undefined | AvailableVoiceStepKeySpecifier);
    fields?: AvailableVoiceStepFieldPolicy;
  };
  BandwidthChannelQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BandwidthChannelQLKeySpecifier
      | (() => undefined | BandwidthChannelQLKeySpecifier);
    fields?: BandwidthChannelQLFieldPolicy;
  };
  BaseChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BaseChannelKeySpecifier
      | (() => undefined | BaseChannelKeySpecifier);
    fields?: BaseChannelFieldPolicy;
  };
  BaseChannelConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BaseChannelConnectionKeySpecifier
      | (() => undefined | BaseChannelConnectionKeySpecifier);
    fields?: BaseChannelConnectionFieldPolicy;
  };
  BaseChannelEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BaseChannelEdgeKeySpecifier
      | (() => undefined | BaseChannelEdgeKeySpecifier);
    fields?: BaseChannelEdgeFieldPolicy;
  };
  BaseOutboundProxyNumber?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BaseOutboundProxyNumberKeySpecifier
      | (() => undefined | BaseOutboundProxyNumberKeySpecifier);
    fields?: BaseOutboundProxyNumberFieldPolicy;
  };
  BaseQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BaseQLKeySpecifier
      | (() => undefined | BaseQLKeySpecifier);
    fields?: BaseQLFieldPolicy;
  };
  BaseRepairOrder?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BaseRepairOrderKeySpecifier
      | (() => undefined | BaseRepairOrderKeySpecifier);
    fields?: BaseRepairOrderFieldPolicy;
  };
  BillingIdentityConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BillingIdentityConnectionKeySpecifier
      | (() => undefined | BillingIdentityConnectionKeySpecifier);
    fields?: BillingIdentityConnectionFieldPolicy;
  };
  BillingIdentityEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BillingIdentityEdgeKeySpecifier
      | (() => undefined | BillingIdentityEdgeKeySpecifier);
    fields?: BillingIdentityEdgeFieldPolicy;
  };
  BillingIdentityQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BillingIdentityQLKeySpecifier
      | (() => undefined | BillingIdentityQLKeySpecifier);
    fields?: BillingIdentityQLFieldPolicy;
  };
  BillingMetadataQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BillingMetadataQLKeySpecifier
      | (() => undefined | BillingMetadataQLKeySpecifier);
    fields?: BillingMetadataQLFieldPolicy;
  };
  BrandThemeQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BrandThemeQLKeySpecifier
      | (() => undefined | BrandThemeQLKeySpecifier);
    fields?: BrandThemeQLFieldPolicy;
  };
  BuildRepairOrderAssistedStatusQuestionTree?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | BuildRepairOrderAssistedStatusQuestionTreeKeySpecifier
      | (() =>
          | undefined
          | BuildRepairOrderAssistedStatusQuestionTreeKeySpecifier);
    fields?: BuildRepairOrderAssistedStatusQuestionTreeFieldPolicy;
  };
  BuildWriteItForMeQuestionTree?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BuildWriteItForMeQuestionTreeKeySpecifier
      | (() => undefined | BuildWriteItForMeQuestionTreeKeySpecifier);
    fields?: BuildWriteItForMeQuestionTreeFieldPolicy;
  };
  BulkUpdateSupportedVehicles?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BulkUpdateSupportedVehiclesKeySpecifier
      | (() => undefined | BulkUpdateSupportedVehiclesKeySpecifier);
    fields?: BulkUpdateSupportedVehiclesFieldPolicy;
  };
  BusinessIdentityModelQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessIdentityModelQLKeySpecifier
      | (() => undefined | BusinessIdentityModelQLKeySpecifier);
    fields?: BusinessIdentityModelQLFieldPolicy;
  };
  BusinessProfileQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessProfileQLKeySpecifier
      | (() => undefined | BusinessProfileQLKeySpecifier);
    fields?: BusinessProfileQLFieldPolicy;
  };
  BusinessProfileQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessProfileQLConnectionKeySpecifier
      | (() => undefined | BusinessProfileQLConnectionKeySpecifier);
    fields?: BusinessProfileQLConnectionFieldPolicy;
  };
  BusinessProfileQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BusinessProfileQLEdgeKeySpecifier
      | (() => undefined | BusinessProfileQLEdgeKeySpecifier);
    fields?: BusinessProfileQLEdgeFieldPolicy;
  };
  CDKServiceAdvisorQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CDKServiceAdvisorQLKeySpecifier
      | (() => undefined | CDKServiceAdvisorQLKeySpecifier);
    fields?: CDKServiceAdvisorQLFieldPolicy;
  };
  CDKServiceAdvisorQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CDKServiceAdvisorQLConnectionKeySpecifier
      | (() => undefined | CDKServiceAdvisorQLConnectionKeySpecifier);
    fields?: CDKServiceAdvisorQLConnectionFieldPolicy;
  };
  CDKServiceAdvisorQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CDKServiceAdvisorQLEdgeKeySpecifier
      | (() => undefined | CDKServiceAdvisorQLEdgeKeySpecifier);
    fields?: CDKServiceAdvisorQLEdgeFieldPolicy;
  };
  CRMEmailQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CRMEmailQLKeySpecifier
      | (() => undefined | CRMEmailQLKeySpecifier);
    fields?: CRMEmailQLFieldPolicy;
  };
  CallForwardingStepMdnQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CallForwardingStepMdnQLKeySpecifier
      | (() => undefined | CallForwardingStepMdnQLKeySpecifier);
    fields?: CallForwardingStepMdnQLFieldPolicy;
  };
  CallForwardingStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CallForwardingStepQLKeySpecifier
      | (() => undefined | CallForwardingStepQLKeySpecifier);
    fields?: CallForwardingStepQLFieldPolicy;
  };
  CallForwardingStepQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CallForwardingStepQLConnectionKeySpecifier
      | (() => undefined | CallForwardingStepQLConnectionKeySpecifier);
    fields?: CallForwardingStepQLConnectionFieldPolicy;
  };
  CallForwardingStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CallForwardingStepQLEdgeKeySpecifier
      | (() => undefined | CallForwardingStepQLEdgeKeySpecifier);
    fields?: CallForwardingStepQLEdgeFieldPolicy;
  };
  CallIntelligenceRatingQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CallIntelligenceRatingQLKeySpecifier
      | (() => undefined | CallIntelligenceRatingQLKeySpecifier);
    fields?: CallIntelligenceRatingQLFieldPolicy;
  };
  CallIntelligenceSettingQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CallIntelligenceSettingQLKeySpecifier
      | (() => undefined | CallIntelligenceSettingQLKeySpecifier);
    fields?: CallIntelligenceSettingQLFieldPolicy;
  };
  CallRecordConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CallRecordConnectionKeySpecifier
      | (() => undefined | CallRecordConnectionKeySpecifier);
    fields?: CallRecordConnectionFieldPolicy;
  };
  CallRecordEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CallRecordEdgeKeySpecifier
      | (() => undefined | CallRecordEdgeKeySpecifier);
    fields?: CallRecordEdgeFieldPolicy;
  };
  CallRecordQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CallRecordQLKeySpecifier
      | (() => undefined | CallRecordQLKeySpecifier);
    fields?: CallRecordQLFieldPolicy;
  };
  CallRecordingQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CallRecordingQLKeySpecifier
      | (() => undefined | CallRecordingQLKeySpecifier);
    fields?: CallRecordingQLFieldPolicy;
  };
  CallRecordingStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CallRecordingStepQLKeySpecifier
      | (() => undefined | CallRecordingStepQLKeySpecifier);
    fields?: CallRecordingStepQLFieldPolicy;
  };
  CallRecordingStepQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CallRecordingStepQLConnectionKeySpecifier
      | (() => undefined | CallRecordingStepQLConnectionKeySpecifier);
    fields?: CallRecordingStepQLConnectionFieldPolicy;
  };
  CallRecordingStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CallRecordingStepQLEdgeKeySpecifier
      | (() => undefined | CallRecordingStepQLEdgeKeySpecifier);
    fields?: CallRecordingStepQLEdgeFieldPolicy;
  };
  CampaignAutomationQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CampaignAutomationQLKeySpecifier
      | (() => undefined | CampaignAutomationQLKeySpecifier);
    fields?: CampaignAutomationQLFieldPolicy;
  };
  CampaignPlaceQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CampaignPlaceQLKeySpecifier
      | (() => undefined | CampaignPlaceQLKeySpecifier);
    fields?: CampaignPlaceQLFieldPolicy;
  };
  CampaignQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CampaignQLKeySpecifier
      | (() => undefined | CampaignQLKeySpecifier);
    fields?: CampaignQLFieldPolicy;
  };
  CampaignSettingsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CampaignSettingsQLKeySpecifier
      | (() => undefined | CampaignSettingsQLKeySpecifier);
    fields?: CampaignSettingsQLFieldPolicy;
  };
  CancelPaymentRequest?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CancelPaymentRequestKeySpecifier
      | (() => undefined | CancelPaymentRequestKeySpecifier);
    fields?: CancelPaymentRequestFieldPolicy;
  };
  CancelScheduledMessage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CancelScheduledMessageKeySpecifier
      | (() => undefined | CancelScheduledMessageKeySpecifier);
    fields?: CancelScheduledMessageFieldPolicy;
  };
  CapturePaymentAmount?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CapturePaymentAmountKeySpecifier
      | (() => undefined | CapturePaymentAmountKeySpecifier);
    fields?: CapturePaymentAmountFieldPolicy;
  };
  CardInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CardInfoKeySpecifier
      | (() => undefined | CardInfoKeySpecifier);
    fields?: CardInfoFieldPolicy;
  };
  ChangeAccountSubscription?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeAccountSubscriptionKeySpecifier
      | (() => undefined | ChangeAccountSubscriptionKeySpecifier);
    fields?: ChangeAccountSubscriptionFieldPolicy;
  };
  ChangeAllowCustomAudio?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeAllowCustomAudioKeySpecifier
      | (() => undefined | ChangeAllowCustomAudioKeySpecifier);
    fields?: ChangeAllowCustomAudioFieldPolicy;
  };
  ChangeBusinessVertical?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeBusinessVerticalKeySpecifier
      | (() => undefined | ChangeBusinessVerticalKeySpecifier);
    fields?: ChangeBusinessVerticalFieldPolicy;
  };
  ChangeConversationStateActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeConversationStateActionQLKeySpecifier
      | (() => undefined | ChangeConversationStateActionQLKeySpecifier);
    fields?: ChangeConversationStateActionQLFieldPolicy;
  };
  ChangeInboxType?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeInboxTypeKeySpecifier
      | (() => undefined | ChangeInboxTypeKeySpecifier);
    fields?: ChangeInboxTypeFieldPolicy;
  };
  ChangeNotificationSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeNotificationSettingsKeySpecifier
      | (() => undefined | ChangeNotificationSettingsKeySpecifier);
    fields?: ChangeNotificationSettingsFieldPolicy;
  };
  ChangePlaceGroup?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangePlaceGroupKeySpecifier
      | (() => undefined | ChangePlaceGroupKeySpecifier);
    fields?: ChangePlaceGroupFieldPolicy;
  };
  ChangePlaceHours?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangePlaceHoursKeySpecifier
      | (() => undefined | ChangePlaceHoursKeySpecifier);
    fields?: ChangePlaceHoursFieldPolicy;
  };
  ChangePlaceSubscription?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangePlaceSubscriptionKeySpecifier
      | (() => undefined | ChangePlaceSubscriptionKeySpecifier);
    fields?: ChangePlaceSubscriptionFieldPolicy;
  };
  ChangeRepairOrderSchedule?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeRepairOrderScheduleKeySpecifier
      | (() => undefined | ChangeRepairOrderScheduleKeySpecifier);
    fields?: ChangeRepairOrderScheduleFieldPolicy;
  };
  ChangeSignupMode?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeSignupModeKeySpecifier
      | (() => undefined | ChangeSignupModeKeySpecifier);
    fields?: ChangeSignupModeFieldPolicy;
  };
  ChangeSwipeActionSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeSwipeActionSettingsKeySpecifier
      | (() => undefined | ChangeSwipeActionSettingsKeySpecifier);
    fields?: ChangeSwipeActionSettingsFieldPolicy;
  };
  ChangeTwilioChannelMDN?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeTwilioChannelMDNKeySpecifier
      | (() => undefined | ChangeTwilioChannelMDNKeySpecifier);
    fields?: ChangeTwilioChannelMDNFieldPolicy;
  };
  ChangeUserPassword?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeUserPasswordKeySpecifier
      | (() => undefined | ChangeUserPasswordKeySpecifier);
    fields?: ChangeUserPasswordFieldPolicy;
  };
  ChangeUserSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeUserSettingsKeySpecifier
      | (() => undefined | ChangeUserSettingsKeySpecifier);
    fields?: ChangeUserSettingsFieldPolicy;
  };
  ChangeUserVideoConferenceUrl?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeUserVideoConferenceUrlKeySpecifier
      | (() => undefined | ChangeUserVideoConferenceUrlKeySpecifier);
    fields?: ChangeUserVideoConferenceUrlFieldPolicy;
  };
  Channel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChannelKeySpecifier
      | (() => undefined | ChannelKeySpecifier);
    fields?: ChannelFieldPolicy;
  };
  ChargeBeeSubscription?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChargeBeeSubscriptionKeySpecifier
      | (() => undefined | ChargeBeeSubscriptionKeySpecifier);
    fields?: ChargeBeeSubscriptionFieldPolicy;
  };
  CheckBusinessHoursStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CheckBusinessHoursStepQLKeySpecifier
      | (() => undefined | CheckBusinessHoursStepQLKeySpecifier);
    fields?: CheckBusinessHoursStepQLFieldPolicy;
  };
  CheckBusinessHoursStepQLConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | CheckBusinessHoursStepQLConnectionKeySpecifier
      | (() => undefined | CheckBusinessHoursStepQLConnectionKeySpecifier);
    fields?: CheckBusinessHoursStepQLConnectionFieldPolicy;
  };
  CheckBusinessHoursStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CheckBusinessHoursStepQLEdgeKeySpecifier
      | (() => undefined | CheckBusinessHoursStepQLEdgeKeySpecifier);
    fields?: CheckBusinessHoursStepQLEdgeFieldPolicy;
  };
  CheckForLabelStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CheckForLabelStepQLKeySpecifier
      | (() => undefined | CheckForLabelStepQLKeySpecifier);
    fields?: CheckForLabelStepQLFieldPolicy;
  };
  CheckForLabelStepQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CheckForLabelStepQLConnectionKeySpecifier
      | (() => undefined | CheckForLabelStepQLConnectionKeySpecifier);
    fields?: CheckForLabelStepQLConnectionFieldPolicy;
  };
  CheckForLabelStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CheckForLabelStepQLEdgeKeySpecifier
      | (() => undefined | CheckForLabelStepQLEdgeKeySpecifier);
    fields?: CheckForLabelStepQLEdgeFieldPolicy;
  };
  CheckOpportunityStatusActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CheckOpportunityStatusActionQLKeySpecifier
      | (() => undefined | CheckOpportunityStatusActionQLKeySpecifier);
    fields?: CheckOpportunityStatusActionQLFieldPolicy;
  };
  CheckRepairOrderDetailsActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CheckRepairOrderDetailsActionQLKeySpecifier
      | (() => undefined | CheckRepairOrderDetailsActionQLKeySpecifier);
    fields?: CheckRepairOrderDetailsActionQLFieldPolicy;
  };
  CloseStatusItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CloseStatusItemKeySpecifier
      | (() => undefined | CloseStatusItemKeySpecifier);
    fields?: CloseStatusItemFieldPolicy;
  };
  CompleteAutopilot?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompleteAutopilotKeySpecifier
      | (() => undefined | CompleteAutopilotKeySpecifier);
    fields?: CompleteAutopilotFieldPolicy;
  };
  CompleteTask?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CompleteTaskKeySpecifier
      | (() => undefined | CompleteTaskKeySpecifier);
    fields?: CompleteTaskFieldPolicy;
  };
  ComplianceReminder?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ComplianceReminderKeySpecifier
      | (() => undefined | ComplianceReminderKeySpecifier);
    fields?: ComplianceReminderFieldPolicy;
  };
  ComplianceSettingsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ComplianceSettingsQLKeySpecifier
      | (() => undefined | ComplianceSettingsQLKeySpecifier);
    fields?: ComplianceSettingsQLFieldPolicy;
  };
  ConnectAutomationAction?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConnectAutomationActionKeySpecifier
      | (() => undefined | ConnectAutomationActionKeySpecifier);
    fields?: ConnectAutomationActionFieldPolicy;
  };
  ConnectAutomationActionEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConnectAutomationActionEdgeKeySpecifier
      | (() => undefined | ConnectAutomationActionEdgeKeySpecifier);
    fields?: ConnectAutomationActionEdgeFieldPolicy;
  };
  ContentSummaryQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ContentSummaryQLKeySpecifier
      | (() => undefined | ContentSummaryQLKeySpecifier);
    fields?: ContentSummaryQLFieldPolicy;
  };
  ContentTypesQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ContentTypesQLKeySpecifier
      | (() => undefined | ContentTypesQLKeySpecifier);
    fields?: ContentTypesQLFieldPolicy;
  };
  ConversationArchivedTriggerQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConversationArchivedTriggerQLKeySpecifier
      | (() => undefined | ConversationArchivedTriggerQLKeySpecifier);
    fields?: ConversationArchivedTriggerQLFieldPolicy;
  };
  ConversationBreakdownEntryQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConversationBreakdownEntryQLKeySpecifier
      | (() => undefined | ConversationBreakdownEntryQLKeySpecifier);
    fields?: ConversationBreakdownEntryQLFieldPolicy;
  };
  ConversationConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConversationConnectionKeySpecifier
      | (() => undefined | ConversationConnectionKeySpecifier);
    fields?: ConversationConnectionFieldPolicy;
  };
  ConversationEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConversationEdgeKeySpecifier
      | (() => undefined | ConversationEdgeKeySpecifier);
    fields?: ConversationEdgeFieldPolicy;
  };
  ConversationLabelQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConversationLabelQLKeySpecifier
      | (() => undefined | ConversationLabelQLKeySpecifier);
    fields?: ConversationLabelQLFieldPolicy;
  };
  ConversationLabelQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConversationLabelQLConnectionKeySpecifier
      | (() => undefined | ConversationLabelQLConnectionKeySpecifier);
    fields?: ConversationLabelQLConnectionFieldPolicy;
  };
  ConversationLabelQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConversationLabelQLEdgeKeySpecifier
      | (() => undefined | ConversationLabelQLEdgeKeySpecifier);
    fields?: ConversationLabelQLEdgeFieldPolicy;
  };
  ConversationMarkedAsHeatCaseTriggerQL?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ConversationMarkedAsHeatCaseTriggerQLKeySpecifier
      | (() => undefined | ConversationMarkedAsHeatCaseTriggerQLKeySpecifier);
    fields?: ConversationMarkedAsHeatCaseTriggerQLFieldPolicy;
  };
  ConversationPreviewContentQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConversationPreviewContentQLKeySpecifier
      | (() => undefined | ConversationPreviewContentQLKeySpecifier);
    fields?: ConversationPreviewContentQLFieldPolicy;
  };
  ConversationQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConversationQLKeySpecifier
      | (() => undefined | ConversationQLKeySpecifier);
    fields?: ConversationQLFieldPolicy;
  };
  ConversationQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConversationQLConnectionKeySpecifier
      | (() => undefined | ConversationQLConnectionKeySpecifier);
    fields?: ConversationQLConnectionFieldPolicy;
  };
  ConversationQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConversationQLEdgeKeySpecifier
      | (() => undefined | ConversationQLEdgeKeySpecifier);
    fields?: ConversationQLEdgeFieldPolicy;
  };
  ConversationRepairOrderSmartStatusUpdateSettingsQL?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ConversationRepairOrderSmartStatusUpdateSettingsQLKeySpecifier
      | (() =>
          | undefined
          | ConversationRepairOrderSmartStatusUpdateSettingsQLKeySpecifier);
    fields?: ConversationRepairOrderSmartStatusUpdateSettingsQLFieldPolicy;
  };
  ConversationStartedTriggerQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConversationStartedTriggerQLKeySpecifier
      | (() => undefined | ConversationStartedTriggerQLKeySpecifier);
    fields?: ConversationStartedTriggerQLFieldPolicy;
  };
  ConversationStateStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConversationStateStepQLKeySpecifier
      | (() => undefined | ConversationStateStepQLKeySpecifier);
    fields?: ConversationStateStepQLFieldPolicy;
  };
  ConversationStateStepQLConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ConversationStateStepQLConnectionKeySpecifier
      | (() => undefined | ConversationStateStepQLConnectionKeySpecifier);
    fields?: ConversationStateStepQLConnectionFieldPolicy;
  };
  ConversationStateStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConversationStateStepQLEdgeKeySpecifier
      | (() => undefined | ConversationStateStepQLEdgeKeySpecifier);
    fields?: ConversationStateStepQLEdgeFieldPolicy;
  };
  ConversationStatsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConversationStatsQLKeySpecifier
      | (() => undefined | ConversationStatsQLKeySpecifier);
    fields?: ConversationStatsQLFieldPolicy;
  };
  ConversationTagQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConversationTagQLKeySpecifier
      | (() => undefined | ConversationTagQLKeySpecifier);
    fields?: ConversationTagQLFieldPolicy;
  };
  ConversationalSchedulingAgentStepQl?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ConversationalSchedulingAgentStepQlKeySpecifier
      | (() => undefined | ConversationalSchedulingAgentStepQlKeySpecifier);
    fields?: ConversationalSchedulingAgentStepQlFieldPolicy;
  };
  ConversationalSchedulingAgentStepQlConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ConversationalSchedulingAgentStepQlConnectionKeySpecifier
      | (() =>
          | undefined
          | ConversationalSchedulingAgentStepQlConnectionKeySpecifier);
    fields?: ConversationalSchedulingAgentStepQlConnectionFieldPolicy;
  };
  ConversationalSchedulingAgentStepQlEdge?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ConversationalSchedulingAgentStepQlEdgeKeySpecifier
      | (() => undefined | ConversationalSchedulingAgentStepQlEdgeKeySpecifier);
    fields?: ConversationalSchedulingAgentStepQlEdgeFieldPolicy;
  };
  CreateA2PCampaignForPlace?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateA2PCampaignForPlaceKeySpecifier
      | (() => undefined | CreateA2PCampaignForPlaceKeySpecifier);
    fields?: CreateA2PCampaignForPlaceFieldPolicy;
  };
  CreateAgentChitChat?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateAgentChitChatKeySpecifier
      | (() => undefined | CreateAgentChitChatKeySpecifier);
    fields?: CreateAgentChitChatFieldPolicy;
  };
  CreateAppointmentAgentSettingLabel?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | CreateAppointmentAgentSettingLabelKeySpecifier
      | (() => undefined | CreateAppointmentAgentSettingLabelKeySpecifier);
    fields?: CreateAppointmentAgentSettingLabelFieldPolicy;
  };
  CreateAppointmentAgentSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateAppointmentAgentSettingsKeySpecifier
      | (() => undefined | CreateAppointmentAgentSettingsKeySpecifier);
    fields?: CreateAppointmentAgentSettingsFieldPolicy;
  };
  CreateAutomation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateAutomationKeySpecifier
      | (() => undefined | CreateAutomationKeySpecifier);
    fields?: CreateAutomationFieldPolicy;
  };
  CreateAutomationAction?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateAutomationActionKeySpecifier
      | (() => undefined | CreateAutomationActionKeySpecifier);
    fields?: CreateAutomationActionFieldPolicy;
  };
  CreateAutomationFromBlueprint?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateAutomationFromBlueprintKeySpecifier
      | (() => undefined | CreateAutomationFromBlueprintKeySpecifier);
    fields?: CreateAutomationFromBlueprintFieldPolicy;
  };
  CreateAutopilot?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateAutopilotKeySpecifier
      | (() => undefined | CreateAutopilotKeySpecifier);
    fields?: CreateAutopilotFieldPolicy;
  };
  CreateBillingIdentity?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateBillingIdentityKeySpecifier
      | (() => undefined | CreateBillingIdentityKeySpecifier);
    fields?: CreateBillingIdentityFieldPolicy;
  };
  CreateCampaign?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateCampaignKeySpecifier
      | (() => undefined | CreateCampaignKeySpecifier);
    fields?: CreateCampaignFieldPolicy;
  };
  CreateCampaignResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateCampaignResultKeySpecifier
      | (() => undefined | CreateCampaignResultKeySpecifier);
    fields?: CreateCampaignResultFieldPolicy;
  };
  CreateChatExpansion?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateChatExpansionKeySpecifier
      | (() => undefined | CreateChatExpansionKeySpecifier);
    fields?: CreateChatExpansionFieldPolicy;
  };
  CreateConversation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateConversationKeySpecifier
      | (() => undefined | CreateConversationKeySpecifier);
    fields?: CreateConversationFieldPolicy;
  };
  CreateConversationSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateConversationSummaryKeySpecifier
      | (() => undefined | CreateConversationSummaryKeySpecifier);
    fields?: CreateConversationSummaryFieldPolicy;
  };
  CreateConversationTextExpansion?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateConversationTextExpansionKeySpecifier
      | (() => undefined | CreateConversationTextExpansionKeySpecifier);
    fields?: CreateConversationTextExpansionFieldPolicy;
  };
  CreateCustomDirectoryEntry?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateCustomDirectoryEntryKeySpecifier
      | (() => undefined | CreateCustomDirectoryEntryKeySpecifier);
    fields?: CreateCustomDirectoryEntryFieldPolicy;
  };
  CreateDepartmentDevice?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateDepartmentDeviceKeySpecifier
      | (() => undefined | CreateDepartmentDeviceKeySpecifier);
    fields?: CreateDepartmentDeviceFieldPolicy;
  };
  CreateIdentityPromptAddress?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateIdentityPromptAddressKeySpecifier
      | (() => undefined | CreateIdentityPromptAddressKeySpecifier);
    fields?: CreateIdentityPromptAddressFieldPolicy;
  };
  CreateLabel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateLabelKeySpecifier
      | (() => undefined | CreateLabelKeySpecifier);
    fields?: CreateLabelFieldPolicy;
  };
  CreateManualCampaignUpload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateManualCampaignUploadKeySpecifier
      | (() => undefined | CreateManualCampaignUploadKeySpecifier);
    fields?: CreateManualCampaignUploadFieldPolicy;
  };
  CreateManualCampaignUploadResult?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | CreateManualCampaignUploadResultKeySpecifier
      | (() => undefined | CreateManualCampaignUploadResultKeySpecifier);
    fields?: CreateManualCampaignUploadResultFieldPolicy;
  };
  CreateNoteTaker?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateNoteTakerKeySpecifier
      | (() => undefined | CreateNoteTakerKeySpecifier);
    fields?: CreateNoteTakerFieldPolicy;
  };
  CreateOperator?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateOperatorKeySpecifier
      | (() => undefined | CreateOperatorKeySpecifier);
    fields?: CreateOperatorFieldPolicy;
  };
  CreateOutboundConferenceCall?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateOutboundConferenceCallKeySpecifier
      | (() => undefined | CreateOutboundConferenceCallKeySpecifier);
    fields?: CreateOutboundConferenceCallFieldPolicy;
  };
  CreateOutboundProxyCall?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateOutboundProxyCallKeySpecifier
      | (() => undefined | CreateOutboundProxyCallKeySpecifier);
    fields?: CreateOutboundProxyCallFieldPolicy;
  };
  CreateParticipant?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateParticipantKeySpecifier
      | (() => undefined | CreateParticipantKeySpecifier);
    fields?: CreateParticipantFieldPolicy;
  };
  CreateParticipantPaymentRequest?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateParticipantPaymentRequestKeySpecifier
      | (() => undefined | CreateParticipantPaymentRequestKeySpecifier);
    fields?: CreateParticipantPaymentRequestFieldPolicy;
  };
  CreatePaymentRequest?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreatePaymentRequestKeySpecifier
      | (() => undefined | CreatePaymentRequestKeySpecifier);
    fields?: CreatePaymentRequestFieldPolicy;
  };
  CreatePhoneLine?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreatePhoneLineKeySpecifier
      | (() => undefined | CreatePhoneLineKeySpecifier);
    fields?: CreatePhoneLineFieldPolicy;
  };
  CreatePlace?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreatePlaceKeySpecifier
      | (() => undefined | CreatePlaceKeySpecifier);
    fields?: CreatePlaceFieldPolicy;
  };
  CreatePortalSession?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreatePortalSessionKeySpecifier
      | (() => undefined | CreatePortalSessionKeySpecifier);
    fields?: CreatePortalSessionFieldPolicy;
  };
  CreateScheduledMessage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateScheduledMessageKeySpecifier
      | (() => undefined | CreateScheduledMessageKeySpecifier);
    fields?: CreateScheduledMessageFieldPolicy;
  };
  CreateShortcut?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateShortcutKeySpecifier
      | (() => undefined | CreateShortcutKeySpecifier);
    fields?: CreateShortcutFieldPolicy;
  };
  CreateStripeAccount?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateStripeAccountKeySpecifier
      | (() => undefined | CreateStripeAccountKeySpecifier);
    fields?: CreateStripeAccountFieldPolicy;
  };
  CreateStripeRefund?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateStripeRefundKeySpecifier
      | (() => undefined | CreateStripeRefundKeySpecifier);
    fields?: CreateStripeRefundFieldPolicy;
  };
  CreateTaskForEngagement?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateTaskForEngagementKeySpecifier
      | (() => undefined | CreateTaskForEngagementKeySpecifier);
    fields?: CreateTaskForEngagementFieldPolicy;
  };
  CreateTeam?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateTeamKeySpecifier
      | (() => undefined | CreateTeamKeySpecifier);
    fields?: CreateTeamFieldPolicy;
  };
  CreateTextExpansion?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateTextExpansionKeySpecifier
      | (() => undefined | CreateTextExpansionKeySpecifier);
    fields?: CreateTextExpansionFieldPolicy;
  };
  CreateUser?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateUserKeySpecifier
      | (() => undefined | CreateUserKeySpecifier);
    fields?: CreateUserFieldPolicy;
  };
  CreateUserPhone?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateUserPhoneKeySpecifier
      | (() => undefined | CreateUserPhoneKeySpecifier);
    fields?: CreateUserPhoneFieldPolicy;
  };
  CreateVideoUploadLink?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateVideoUploadLinkKeySpecifier
      | (() => undefined | CreateVideoUploadLinkKeySpecifier);
    fields?: CreateVideoUploadLinkFieldPolicy;
  };
  CrmContactCdkQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CrmContactCdkQLKeySpecifier
      | (() => undefined | CrmContactCdkQLKeySpecifier);
    fields?: CrmContactCdkQLFieldPolicy;
  };
  CrmContactCnamQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CrmContactCnamQLKeySpecifier
      | (() => undefined | CrmContactCnamQLKeySpecifier);
    fields?: CrmContactCnamQLFieldPolicy;
  };
  CrmContactDealertrackQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CrmContactDealertrackQLKeySpecifier
      | (() => undefined | CrmContactDealertrackQLKeySpecifier);
    fields?: CrmContactDealertrackQLFieldPolicy;
  };
  CrmContactFortellisQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CrmContactFortellisQLKeySpecifier
      | (() => undefined | CrmContactFortellisQLKeySpecifier);
    fields?: CrmContactFortellisQLFieldPolicy;
  };
  CrmContactQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CrmContactQLKeySpecifier
      | (() => undefined | CrmContactQLKeySpecifier);
    fields?: CrmContactQLFieldPolicy;
  };
  CrmUserModelQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CrmUserModelQLKeySpecifier
      | (() => undefined | CrmUserModelQLKeySpecifier);
    fields?: CrmUserModelQLFieldPolicy;
  };
  CrmUserModelQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CrmUserModelQLConnectionKeySpecifier
      | (() => undefined | CrmUserModelQLConnectionKeySpecifier);
    fields?: CrmUserModelQLConnectionFieldPolicy;
  };
  CrmUserModelQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CrmUserModelQLEdgeKeySpecifier
      | (() => undefined | CrmUserModelQLEdgeKeySpecifier);
    fields?: CrmUserModelQLEdgeFieldPolicy;
  };
  CubeJwtTokenQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CubeJwtTokenQLKeySpecifier
      | (() => undefined | CubeJwtTokenQLKeySpecifier);
    fields?: CubeJwtTokenQLFieldPolicy;
  };
  CurbsideSettingsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CurbsideSettingsQLKeySpecifier
      | (() => undefined | CurbsideSettingsQLKeySpecifier);
    fields?: CurbsideSettingsQLFieldPolicy;
  };
  CustomAudioOverrides?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomAudioOverridesKeySpecifier
      | (() => undefined | CustomAudioOverridesKeySpecifier);
    fields?: CustomAudioOverridesFieldPolicy;
  };
  CustomDirectoryEntryModelQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomDirectoryEntryModelQLKeySpecifier
      | (() => undefined | CustomDirectoryEntryModelQLKeySpecifier);
    fields?: CustomDirectoryEntryModelQLFieldPolicy;
  };
  CustomDirectoryEntryQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomDirectoryEntryQLKeySpecifier
      | (() => undefined | CustomDirectoryEntryQLKeySpecifier);
    fields?: CustomDirectoryEntryQLFieldPolicy;
  };
  CustomDisclosureSpeech?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomDisclosureSpeechKeySpecifier
      | (() => undefined | CustomDisclosureSpeechKeySpecifier);
    fields?: CustomDisclosureSpeechFieldPolicy;
  };
  CustomOutboundCallAudioOverrides?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | CustomOutboundCallAudioOverridesKeySpecifier
      | (() => undefined | CustomOutboundCallAudioOverridesKeySpecifier);
    fields?: CustomOutboundCallAudioOverridesFieldPolicy;
  };
  CustomerContactedTriggerQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerContactedTriggerQLKeySpecifier
      | (() => undefined | CustomerContactedTriggerQLKeySpecifier);
    fields?: CustomerContactedTriggerQLFieldPolicy;
  };
  CustomerQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerQLKeySpecifier
      | (() => undefined | CustomerQLKeySpecifier);
    fields?: CustomerQLFieldPolicy;
  };
  CustomerQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerQLConnectionKeySpecifier
      | (() => undefined | CustomerQLConnectionKeySpecifier);
    fields?: CustomerQLConnectionFieldPolicy;
  };
  CustomerQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerQLEdgeKeySpecifier
      | (() => undefined | CustomerQLEdgeKeySpecifier);
    fields?: CustomerQLEdgeFieldPolicy;
  };
  CustomizedIntentQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizedIntentQLKeySpecifier
      | (() => undefined | CustomizedIntentQLKeySpecifier);
    fields?: CustomizedIntentQLFieldPolicy;
  };
  DMSHistoryConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DMSHistoryConnectionKeySpecifier
      | (() => undefined | DMSHistoryConnectionKeySpecifier);
    fields?: DMSHistoryConnectionFieldPolicy;
  };
  DMSHistoryEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DMSHistoryEdgeKeySpecifier
      | (() => undefined | DMSHistoryEdgeKeySpecifier);
    fields?: DMSHistoryEdgeFieldPolicy;
  };
  DMSHistoryQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DMSHistoryQLKeySpecifier
      | (() => undefined | DMSHistoryQLKeySpecifier);
    fields?: DMSHistoryQLFieldPolicy;
  };
  DeactivateAccount?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeactivateAccountKeySpecifier
      | (() => undefined | DeactivateAccountKeySpecifier);
    fields?: DeactivateAccountFieldPolicy;
  };
  DealerTrackServiceAdvisorQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DealerTrackServiceAdvisorQLKeySpecifier
      | (() => undefined | DealerTrackServiceAdvisorQLKeySpecifier);
    fields?: DealerTrackServiceAdvisorQLFieldPolicy;
  };
  DefaultBroadcastInputsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DefaultBroadcastInputsQLKeySpecifier
      | (() => undefined | DefaultBroadcastInputsQLKeySpecifier);
    fields?: DefaultBroadcastInputsQLFieldPolicy;
  };
  DeleteAppointmentAgentSettingLabel?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | DeleteAppointmentAgentSettingLabelKeySpecifier
      | (() => undefined | DeleteAppointmentAgentSettingLabelKeySpecifier);
    fields?: DeleteAppointmentAgentSettingLabelFieldPolicy;
  };
  DeleteAppointmentAgentSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteAppointmentAgentSettingsKeySpecifier
      | (() => undefined | DeleteAppointmentAgentSettingsKeySpecifier);
    fields?: DeleteAppointmentAgentSettingsFieldPolicy;
  };
  DeleteAutomation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteAutomationKeySpecifier
      | (() => undefined | DeleteAutomationKeySpecifier);
    fields?: DeleteAutomationFieldPolicy;
  };
  DeleteConversation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteConversationKeySpecifier
      | (() => undefined | DeleteConversationKeySpecifier);
    fields?: DeleteConversationFieldPolicy;
  };
  DeleteCustomDirectoryEntry?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteCustomDirectoryEntryKeySpecifier
      | (() => undefined | DeleteCustomDirectoryEntryKeySpecifier);
    fields?: DeleteCustomDirectoryEntryFieldPolicy;
  };
  DeleteCustomLink?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteCustomLinkKeySpecifier
      | (() => undefined | DeleteCustomLinkKeySpecifier);
    fields?: DeleteCustomLinkFieldPolicy;
  };
  DeleteDepartmentDevice?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteDepartmentDeviceKeySpecifier
      | (() => undefined | DeleteDepartmentDeviceKeySpecifier);
    fields?: DeleteDepartmentDeviceFieldPolicy;
  };
  DeleteIdentityPromptAddress?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteIdentityPromptAddressKeySpecifier
      | (() => undefined | DeleteIdentityPromptAddressKeySpecifier);
    fields?: DeleteIdentityPromptAddressFieldPolicy;
  };
  DeleteNoteTaker?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteNoteTakerKeySpecifier
      | (() => undefined | DeleteNoteTakerKeySpecifier);
    fields?: DeleteNoteTakerFieldPolicy;
  };
  DeleteOutboundCallCustomization?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteOutboundCallCustomizationKeySpecifier
      | (() => undefined | DeleteOutboundCallCustomizationKeySpecifier);
    fields?: DeleteOutboundCallCustomizationFieldPolicy;
  };
  DeletePhoneLine?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeletePhoneLineKeySpecifier
      | (() => undefined | DeletePhoneLineKeySpecifier);
    fields?: DeletePhoneLineFieldPolicy;
  };
  DeletePlace?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeletePlaceKeySpecifier
      | (() => undefined | DeletePlaceKeySpecifier);
    fields?: DeletePlaceFieldPolicy;
  };
  DeleteScheduledMessage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteScheduledMessageKeySpecifier
      | (() => undefined | DeleteScheduledMessageKeySpecifier);
    fields?: DeleteScheduledMessageFieldPolicy;
  };
  DeleteShortcut?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteShortcutKeySpecifier
      | (() => undefined | DeleteShortcutKeySpecifier);
    fields?: DeleteShortcutFieldPolicy;
  };
  DeleteStage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteStageKeySpecifier
      | (() => undefined | DeleteStageKeySpecifier);
    fields?: DeleteStageFieldPolicy;
  };
  DeleteStatusItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteStatusItemKeySpecifier
      | (() => undefined | DeleteStatusItemKeySpecifier);
    fields?: DeleteStatusItemFieldPolicy;
  };
  DeleteTeam?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteTeamKeySpecifier
      | (() => undefined | DeleteTeamKeySpecifier);
    fields?: DeleteTeamFieldPolicy;
  };
  DeleteUserPhone?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteUserPhoneKeySpecifier
      | (() => undefined | DeleteUserPhoneKeySpecifier);
    fields?: DeleteUserPhoneFieldPolicy;
  };
  DeleteVoiceStep?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteVoiceStepKeySpecifier
      | (() => undefined | DeleteVoiceStepKeySpecifier);
    fields?: DeleteVoiceStepFieldPolicy;
  };
  DepartmentDeviceQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DepartmentDeviceQLKeySpecifier
      | (() => undefined | DepartmentDeviceQLKeySpecifier);
    fields?: DepartmentDeviceQLFieldPolicy;
  };
  DepartmentDeviceQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DepartmentDeviceQLConnectionKeySpecifier
      | (() => undefined | DepartmentDeviceQLConnectionKeySpecifier);
    fields?: DepartmentDeviceQLConnectionFieldPolicy;
  };
  DepartmentDeviceQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DepartmentDeviceQLEdgeKeySpecifier
      | (() => undefined | DepartmentDeviceQLEdgeKeySpecifier);
    fields?: DepartmentDeviceQLEdgeFieldPolicy;
  };
  DepartmentDirectoryEntryQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DepartmentDirectoryEntryQLKeySpecifier
      | (() => undefined | DepartmentDirectoryEntryQLKeySpecifier);
    fields?: DepartmentDirectoryEntryQLFieldPolicy;
  };
  DepartmentDirectoryEntryQLConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | DepartmentDirectoryEntryQLConnectionKeySpecifier
      | (() => undefined | DepartmentDirectoryEntryQLConnectionKeySpecifier);
    fields?: DepartmentDirectoryEntryQLConnectionFieldPolicy;
  };
  DepartmentDirectoryEntryQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DepartmentDirectoryEntryQLEdgeKeySpecifier
      | (() => undefined | DepartmentDirectoryEntryQLEdgeKeySpecifier);
    fields?: DepartmentDirectoryEntryQLEdgeFieldPolicy;
  };
  DepartmentQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DepartmentQLKeySpecifier
      | (() => undefined | DepartmentQLKeySpecifier);
    fields?: DepartmentQLFieldPolicy;
  };
  DepartmentQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DepartmentQLConnectionKeySpecifier
      | (() => undefined | DepartmentQLConnectionKeySpecifier);
    fields?: DepartmentQLConnectionFieldPolicy;
  };
  DepartmentQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DepartmentQLEdgeKeySpecifier
      | (() => undefined | DepartmentQLEdgeKeySpecifier);
    fields?: DepartmentQLEdgeFieldPolicy;
  };
  DialogFlowBotDataQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DialogFlowBotDataQLKeySpecifier
      | (() => undefined | DialogFlowBotDataQLKeySpecifier);
    fields?: DialogFlowBotDataQLFieldPolicy;
  };
  DialogFlowBotDataQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DialogFlowBotDataQLConnectionKeySpecifier
      | (() => undefined | DialogFlowBotDataQLConnectionKeySpecifier);
    fields?: DialogFlowBotDataQLConnectionFieldPolicy;
  };
  DialogFlowBotDataQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DialogFlowBotDataQLEdgeKeySpecifier
      | (() => undefined | DialogFlowBotDataQLEdgeKeySpecifier);
    fields?: DialogFlowBotDataQLEdgeFieldPolicy;
  };
  DirectoryDeviceQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DirectoryDeviceQLKeySpecifier
      | (() => undefined | DirectoryDeviceQLKeySpecifier);
    fields?: DirectoryDeviceQLFieldPolicy;
  };
  DirectoryEntryQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DirectoryEntryQLKeySpecifier
      | (() => undefined | DirectoryEntryQLKeySpecifier);
    fields?: DirectoryEntryQLFieldPolicy;
  };
  DisableAutopilot?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DisableAutopilotKeySpecifier
      | (() => undefined | DisableAutopilotKeySpecifier);
    fields?: DisableAutopilotFieldPolicy;
  };
  DisableFortellisSubscription?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DisableFortellisSubscriptionKeySpecifier
      | (() => undefined | DisableFortellisSubscriptionKeySpecifier);
    fields?: DisableFortellisSubscriptionFieldPolicy;
  };
  DiscardAutomationEdits?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DiscardAutomationEditsKeySpecifier
      | (() => undefined | DiscardAutomationEditsKeySpecifier);
    fields?: DiscardAutomationEditsFieldPolicy;
  };
  DiscardDisruptionVoiceScript?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DiscardDisruptionVoiceScriptKeySpecifier
      | (() => undefined | DiscardDisruptionVoiceScriptKeySpecifier);
    fields?: DiscardDisruptionVoiceScriptFieldPolicy;
  };
  DiscardVoiceScript?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DiscardVoiceScriptKeySpecifier
      | (() => undefined | DiscardVoiceScriptKeySpecifier);
    fields?: DiscardVoiceScriptFieldPolicy;
  };
  DismissTask?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DismissTaskKeySpecifier
      | (() => undefined | DismissTaskKeySpecifier);
    fields?: DismissTaskFieldPolicy;
  };
  DisputeQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DisputeQLKeySpecifier
      | (() => undefined | DisputeQLKeySpecifier);
    fields?: DisputeQLFieldPolicy;
  };
  DisruptionsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DisruptionsQLKeySpecifier
      | (() => undefined | DisruptionsQLKeySpecifier);
    fields?: DisruptionsQLFieldPolicy;
  };
  DuplicateAppointmentAgentSettings?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | DuplicateAppointmentAgentSettingsKeySpecifier
      | (() => undefined | DuplicateAppointmentAgentSettingsKeySpecifier);
    fields?: DuplicateAppointmentAgentSettingsFieldPolicy;
  };
  ETOSettingsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ETOSettingsQLKeySpecifier
      | (() => undefined | ETOSettingsQLKeySpecifier);
    fields?: ETOSettingsQLFieldPolicy;
  };
  EarlyExitAnalysisQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EarlyExitAnalysisQLKeySpecifier
      | (() => undefined | EarlyExitAnalysisQLKeySpecifier);
    fields?: EarlyExitAnalysisQLFieldPolicy;
  };
  EarlyExitDetailQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EarlyExitDetailQLKeySpecifier
      | (() => undefined | EarlyExitDetailQLKeySpecifier);
    fields?: EarlyExitDetailQLFieldPolicy;
  };
  EmployeeQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EmployeeQLKeySpecifier
      | (() => undefined | EmployeeQLKeySpecifier);
    fields?: EmployeeQLFieldPolicy;
  };
  EnableInboxLanguageOverride?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EnableInboxLanguageOverrideKeySpecifier
      | (() => undefined | EnableInboxLanguageOverrideKeySpecifier);
    fields?: EnableInboxLanguageOverrideFieldPolicy;
  };
  EnableNudges?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EnableNudgesKeySpecifier
      | (() => undefined | EnableNudgesKeySpecifier);
    fields?: EnableNudgesFieldPolicy;
  };
  EnablePlaceMessagingHours?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EnablePlaceMessagingHoursKeySpecifier
      | (() => undefined | EnablePlaceMessagingHoursKeySpecifier);
    fields?: EnablePlaceMessagingHoursFieldPolicy;
  };
  EndOutboundConferenceCall?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EndOutboundConferenceCallKeySpecifier
      | (() => undefined | EndOutboundConferenceCallKeySpecifier);
    fields?: EndOutboundConferenceCallFieldPolicy;
  };
  EngagementInboxAgentResultQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EngagementInboxAgentResultQLKeySpecifier
      | (() => undefined | EngagementInboxAgentResultQLKeySpecifier);
    fields?: EngagementInboxAgentResultQLFieldPolicy;
  };
  EngagementQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EngagementQLKeySpecifier
      | (() => undefined | EngagementQLKeySpecifier);
    fields?: EngagementQLFieldPolicy;
  };
  EngagementStatusRatingQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EngagementStatusRatingQLKeySpecifier
      | (() => undefined | EngagementStatusRatingQLKeySpecifier);
    fields?: EngagementStatusRatingQLFieldPolicy;
  };
  EngagementSummaryRatingQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EngagementSummaryRatingQLKeySpecifier
      | (() => undefined | EngagementSummaryRatingQLKeySpecifier);
    fields?: EngagementSummaryRatingQLFieldPolicy;
  };
  EnrollmentCriteriaQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EnrollmentCriteriaQLKeySpecifier
      | (() => undefined | EnrollmentCriteriaQLKeySpecifier);
    fields?: EnrollmentCriteriaQLFieldPolicy;
  };
  EquityTradeOpportunityCreatedTriggerQL?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | EquityTradeOpportunityCreatedTriggerQLKeySpecifier
      | (() => undefined | EquityTradeOpportunityCreatedTriggerQLKeySpecifier);
    fields?: EquityTradeOpportunityCreatedTriggerQLFieldPolicy;
  };
  EquityTradeOpportunityQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EquityTradeOpportunityQLKeySpecifier
      | (() => undefined | EquityTradeOpportunityQLKeySpecifier);
    fields?: EquityTradeOpportunityQLFieldPolicy;
  };
  EquityTradeOpportunityQLConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | EquityTradeOpportunityQLConnectionKeySpecifier
      | (() => undefined | EquityTradeOpportunityQLConnectionKeySpecifier);
    fields?: EquityTradeOpportunityQLConnectionFieldPolicy;
  };
  EquityTradeOpportunityQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EquityTradeOpportunityQLEdgeKeySpecifier
      | (() => undefined | EquityTradeOpportunityQLEdgeKeySpecifier);
    fields?: EquityTradeOpportunityQLEdgeFieldPolicy;
  };
  EscalateConversationActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EscalateConversationActionQLKeySpecifier
      | (() => undefined | EscalateConversationActionQLKeySpecifier);
    fields?: EscalateConversationActionQLFieldPolicy;
  };
  EvaluateBusinessIdentity?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EvaluateBusinessIdentityKeySpecifier
      | (() => undefined | EvaluateBusinessIdentityKeySpecifier);
    fields?: EvaluateBusinessIdentityFieldPolicy;
  };
  EvaluationTimeQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EvaluationTimeQLKeySpecifier
      | (() => undefined | EvaluationTimeQLKeySpecifier);
    fields?: EvaluationTimeQLFieldPolicy;
  };
  ExportConversationToArchive?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ExportConversationToArchiveKeySpecifier
      | (() => undefined | ExportConversationToArchiveKeySpecifier);
    fields?: ExportConversationToArchiveFieldPolicy;
  };
  ExternalCRMUserQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ExternalCRMUserQLKeySpecifier
      | (() => undefined | ExternalCRMUserQLKeySpecifier);
    fields?: ExternalCRMUserQLFieldPolicy;
  };
  ExternalOpcodeQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ExternalOpcodeQLKeySpecifier
      | (() => undefined | ExternalOpcodeQLKeySpecifier);
    fields?: ExternalOpcodeQLFieldPolicy;
  };
  ExternalVehicleConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ExternalVehicleConnectionKeySpecifier
      | (() => undefined | ExternalVehicleConnectionKeySpecifier);
    fields?: ExternalVehicleConnectionFieldPolicy;
  };
  ExternalVehicleEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ExternalVehicleEdgeKeySpecifier
      | (() => undefined | ExternalVehicleEdgeKeySpecifier);
    fields?: ExternalVehicleEdgeFieldPolicy;
  };
  ExternalVehicleOverrideQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ExternalVehicleOverrideQLKeySpecifier
      | (() => undefined | ExternalVehicleOverrideQLKeySpecifier);
    fields?: ExternalVehicleOverrideQLFieldPolicy;
  };
  ExternalVehicleQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ExternalVehicleQLKeySpecifier
      | (() => undefined | ExternalVehicleQLKeySpecifier);
    fields?: ExternalVehicleQLFieldPolicy;
  };
  FacebookChannelQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FacebookChannelQLKeySpecifier
      | (() => undefined | FacebookChannelQLKeySpecifier);
    fields?: FacebookChannelQLFieldPolicy;
  };
  FacebookReviewSite?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FacebookReviewSiteKeySpecifier
      | (() => undefined | FacebookReviewSiteKeySpecifier);
    fields?: FacebookReviewSiteFieldPolicy;
  };
  FileAttachment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FileAttachmentKeySpecifier
      | (() => undefined | FileAttachmentKeySpecifier);
    fields?: FileAttachmentFieldPolicy;
  };
  ForceActiveIntegrationSync?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ForceActiveIntegrationSyncKeySpecifier
      | (() => undefined | ForceActiveIntegrationSyncKeySpecifier);
    fields?: ForceActiveIntegrationSyncFieldPolicy;
  };
  FortellisServiceAdvisorQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FortellisServiceAdvisorQLKeySpecifier
      | (() => undefined | FortellisServiceAdvisorQLKeySpecifier);
    fields?: FortellisServiceAdvisorQLFieldPolicy;
  };
  FortellisSubscriptionConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FortellisSubscriptionConnectionKeySpecifier
      | (() => undefined | FortellisSubscriptionConnectionKeySpecifier);
    fields?: FortellisSubscriptionConnectionFieldPolicy;
  };
  FortellisSubscriptionEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FortellisSubscriptionEdgeKeySpecifier
      | (() => undefined | FortellisSubscriptionEdgeKeySpecifier);
    fields?: FortellisSubscriptionEdgeFieldPolicy;
  };
  FortellisSubscriptionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FortellisSubscriptionQLKeySpecifier
      | (() => undefined | FortellisSubscriptionQLKeySpecifier);
    fields?: FortellisSubscriptionQLFieldPolicy;
  };
  FortellisSubscriptionQLConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | FortellisSubscriptionQLConnectionKeySpecifier
      | (() => undefined | FortellisSubscriptionQLConnectionKeySpecifier);
    fields?: FortellisSubscriptionQLConnectionFieldPolicy;
  };
  FortellisSubscriptionQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FortellisSubscriptionQLEdgeKeySpecifier
      | (() => undefined | FortellisSubscriptionQLEdgeKeySpecifier);
    fields?: FortellisSubscriptionQLEdgeFieldPolicy;
  };
  GenerateRepairOrderAssistedStatusContent?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | GenerateRepairOrderAssistedStatusContentKeySpecifier
      | (() =>
          | undefined
          | GenerateRepairOrderAssistedStatusContentKeySpecifier);
    fields?: GenerateRepairOrderAssistedStatusContentFieldPolicy;
  };
  GenerateRepairOrderNotesSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | GenerateRepairOrderNotesSummaryKeySpecifier
      | (() => undefined | GenerateRepairOrderNotesSummaryKeySpecifier);
    fields?: GenerateRepairOrderNotesSummaryFieldPolicy;
  };
  GenerateWriteItForMeContent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | GenerateWriteItForMeContentKeySpecifier
      | (() => undefined | GenerateWriteItForMeContentKeySpecifier);
    fields?: GenerateWriteItForMeContentFieldPolicy;
  };
  GlobalSyncXtimeServices?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | GlobalSyncXtimeServicesKeySpecifier
      | (() => undefined | GlobalSyncXtimeServicesKeySpecifier);
    fields?: GlobalSyncXtimeServicesFieldPolicy;
  };
  GoogleChannelQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | GoogleChannelQLKeySpecifier
      | (() => undefined | GoogleChannelQLKeySpecifier);
    fields?: GoogleChannelQLFieldPolicy;
  };
  GoogleReviewSite?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | GoogleReviewSiteKeySpecifier
      | (() => undefined | GoogleReviewSiteKeySpecifier);
    fields?: GoogleReviewSiteFieldPolicy;
  };
  GreetingQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | GreetingQLKeySpecifier
      | (() => undefined | GreetingQLKeySpecifier);
    fields?: GreetingQLFieldPolicy;
  };
  GreetingStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | GreetingStepQLKeySpecifier
      | (() => undefined | GreetingStepQLKeySpecifier);
    fields?: GreetingStepQLFieldPolicy;
  };
  GreetingStepQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | GreetingStepQLConnectionKeySpecifier
      | (() => undefined | GreetingStepQLConnectionKeySpecifier);
    fields?: GreetingStepQLConnectionFieldPolicy;
  };
  GreetingStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | GreetingStepQLEdgeKeySpecifier
      | (() => undefined | GreetingStepQLEdgeKeySpecifier);
    fields?: GreetingStepQLEdgeFieldPolicy;
  };
  GuideChecklistQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | GuideChecklistQLKeySpecifier
      | (() => undefined | GuideChecklistQLKeySpecifier);
    fields?: GuideChecklistQLFieldPolicy;
  };
  HandToOpportunityAgentActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HandToOpportunityAgentActionQLKeySpecifier
      | (() => undefined | HandToOpportunityAgentActionQLKeySpecifier);
    fields?: HandToOpportunityAgentActionQLFieldPolicy;
  };
  HasLabelActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HasLabelActionQLKeySpecifier
      | (() => undefined | HasLabelActionQLKeySpecifier);
    fields?: HasLabelActionQLFieldPolicy;
  };
  HostedPage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HostedPageKeySpecifier
      | (() => undefined | HostedPageKeySpecifier);
    fields?: HostedPageFieldPolicy;
  };
  HostedSmsCompleted?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HostedSmsCompletedKeySpecifier
      | (() => undefined | HostedSmsCompletedKeySpecifier);
    fields?: HostedSmsCompletedFieldPolicy;
  };
  HostedSmsPortQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HostedSmsPortQLKeySpecifier
      | (() => undefined | HostedSmsPortQLKeySpecifier);
    fields?: HostedSmsPortQLFieldPolicy;
  };
  HostedSmsPortQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HostedSmsPortQLConnectionKeySpecifier
      | (() => undefined | HostedSmsPortQLConnectionKeySpecifier);
    fields?: HostedSmsPortQLConnectionFieldPolicy;
  };
  HostedSmsPortQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HostedSmsPortQLEdgeKeySpecifier
      | (() => undefined | HostedSmsPortQLEdgeKeySpecifier);
    fields?: HostedSmsPortQLEdgeFieldPolicy;
  };
  IdentityPromptAddressQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | IdentityPromptAddressQLKeySpecifier
      | (() => undefined | IdentityPromptAddressQLKeySpecifier);
    fields?: IdentityPromptAddressQLFieldPolicy;
  };
  IdentityPromptAddressQLConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | IdentityPromptAddressQLConnectionKeySpecifier
      | (() => undefined | IdentityPromptAddressQLConnectionKeySpecifier);
    fields?: IdentityPromptAddressQLConnectionFieldPolicy;
  };
  IdentityPromptAddressQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | IdentityPromptAddressQLEdgeKeySpecifier
      | (() => undefined | IdentityPromptAddressQLEdgeKeySpecifier);
    fields?: IdentityPromptAddressQLEdgeFieldPolicy;
  };
  ImageAttachment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ImageAttachmentKeySpecifier
      | (() => undefined | ImageAttachmentKeySpecifier);
    fields?: ImageAttachmentFieldPolicy;
  };
  Impersonate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ImpersonateKeySpecifier
      | (() => undefined | ImpersonateKeySpecifier);
    fields?: ImpersonateFieldPolicy;
  };
  ImportHostedSms?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ImportHostedSmsKeySpecifier
      | (() => undefined | ImportHostedSmsKeySpecifier);
    fields?: ImportHostedSmsFieldPolicy;
  };
  InboxConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InboxConnectionKeySpecifier
      | (() => undefined | InboxConnectionKeySpecifier);
    fields?: InboxConnectionFieldPolicy;
  };
  InboxEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InboxEdgeKeySpecifier
      | (() => undefined | InboxEdgeKeySpecifier);
    fields?: InboxEdgeFieldPolicy;
  };
  InboxQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InboxQLKeySpecifier
      | (() => undefined | InboxQLKeySpecifier);
    fields?: InboxQLFieldPolicy;
  };
  IncreaseShortcutCount?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | IncreaseShortcutCountKeySpecifier
      | (() => undefined | IncreaseShortcutCountKeySpecifier);
    fields?: IncreaseShortcutCountFieldPolicy;
  };
  IntentClassifierQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | IntentClassifierQLKeySpecifier
      | (() => undefined | IntentClassifierQLKeySpecifier);
    fields?: IntentClassifierQLFieldPolicy;
  };
  IntentClassifierQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | IntentClassifierQLConnectionKeySpecifier
      | (() => undefined | IntentClassifierQLConnectionKeySpecifier);
    fields?: IntentClassifierQLConnectionFieldPolicy;
  };
  IntentClassifierQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | IntentClassifierQLEdgeKeySpecifier
      | (() => undefined | IntentClassifierQLEdgeKeySpecifier);
    fields?: IntentClassifierQLEdgeFieldPolicy;
  };
  IntentQuestionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | IntentQuestionQLKeySpecifier
      | (() => undefined | IntentQuestionQLKeySpecifier);
    fields?: IntentQuestionQLFieldPolicy;
  };
  IntentQuestionQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | IntentQuestionQLConnectionKeySpecifier
      | (() => undefined | IntentQuestionQLConnectionKeySpecifier);
    fields?: IntentQuestionQLConnectionFieldPolicy;
  };
  IntentQuestionQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | IntentQuestionQLEdgeKeySpecifier
      | (() => undefined | IntentQuestionQLEdgeKeySpecifier);
    fields?: IntentQuestionQLEdgeFieldPolicy;
  };
  IsBusinessHoursActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | IsBusinessHoursActionQLKeySpecifier
      | (() => undefined | IsBusinessHoursActionQLKeySpecifier);
    fields?: IsBusinessHoursActionQLFieldPolicy;
  };
  LabelAddedTriggerQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LabelAddedTriggerQLKeySpecifier
      | (() => undefined | LabelAddedTriggerQLKeySpecifier);
    fields?: LabelAddedTriggerQLFieldPolicy;
  };
  LabelConversationStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LabelConversationStepQLKeySpecifier
      | (() => undefined | LabelConversationStepQLKeySpecifier);
    fields?: LabelConversationStepQLFieldPolicy;
  };
  LabelConversationStepQLConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | LabelConversationStepQLConnectionKeySpecifier
      | (() => undefined | LabelConversationStepQLConnectionKeySpecifier);
    fields?: LabelConversationStepQLConnectionFieldPolicy;
  };
  LabelConversationStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LabelConversationStepQLEdgeKeySpecifier
      | (() => undefined | LabelConversationStepQLEdgeKeySpecifier);
    fields?: LabelConversationStepQLEdgeFieldPolicy;
  };
  LabelQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LabelQLKeySpecifier
      | (() => undefined | LabelQLKeySpecifier);
    fields?: LabelQLFieldPolicy;
  };
  LabelQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LabelQLConnectionKeySpecifier
      | (() => undefined | LabelQLConnectionKeySpecifier);
    fields?: LabelQLConnectionFieldPolicy;
  };
  LabelQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LabelQLEdgeKeySpecifier
      | (() => undefined | LabelQLEdgeKeySpecifier);
    fields?: LabelQLEdgeFieldPolicy;
  };
  LabelRemovedTriggerQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LabelRemovedTriggerQLKeySpecifier
      | (() => undefined | LabelRemovedTriggerQLKeySpecifier);
    fields?: LabelRemovedTriggerQLFieldPolicy;
  };
  LeaderboardColorsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LeaderboardColorsQLKeySpecifier
      | (() => undefined | LeaderboardColorsQLKeySpecifier);
    fields?: LeaderboardColorsQLFieldPolicy;
  };
  LeaveAllConversations?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LeaveAllConversationsKeySpecifier
      | (() => undefined | LeaveAllConversationsKeySpecifier);
    fields?: LeaveAllConversationsFieldPolicy;
  };
  LeaveConversations?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LeaveConversationsKeySpecifier
      | (() => undefined | LeaveConversationsKeySpecifier);
    fields?: LeaveConversationsFieldPolicy;
  };
  LeaveNoteActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LeaveNoteActionQLKeySpecifier
      | (() => undefined | LeaveNoteActionQLKeySpecifier);
    fields?: LeaveNoteActionQLFieldPolicy;
  };
  LegacyCrmContactQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LegacyCrmContactQLKeySpecifier
      | (() => undefined | LegacyCrmContactQLKeySpecifier);
    fields?: LegacyCrmContactQLFieldPolicy;
  };
  LibraryIntentQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LibraryIntentQLKeySpecifier
      | (() => undefined | LibraryIntentQLKeySpecifier);
    fields?: LibraryIntentQLFieldPolicy;
  };
  Link?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | LinkKeySpecifier | (() => undefined | LinkKeySpecifier);
    fields?: LinkFieldPolicy;
  };
  LinkGroup?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LinkGroupKeySpecifier
      | (() => undefined | LinkGroupKeySpecifier);
    fields?: LinkGroupFieldPolicy;
  };
  ManageLabelActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ManageLabelActionQLKeySpecifier
      | (() => undefined | ManageLabelActionQLKeySpecifier);
    fields?: ManageLabelActionQLFieldPolicy;
  };
  ManageLabelsOperation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ManageLabelsOperationKeySpecifier
      | (() => undefined | ManageLabelsOperationKeySpecifier);
    fields?: ManageLabelsOperationFieldPolicy;
  };
  ManagerDashboard?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ManagerDashboardKeySpecifier
      | (() => undefined | ManagerDashboardKeySpecifier);
    fields?: ManagerDashboardFieldPolicy;
  };
  ManualOpportunity?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ManualOpportunityKeySpecifier
      | (() => undefined | ManualOpportunityKeySpecifier);
    fields?: ManualOpportunityFieldPolicy;
  };
  ManualOpportunityCustomerInformationQL?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ManualOpportunityCustomerInformationQLKeySpecifier
      | (() => undefined | ManualOpportunityCustomerInformationQLKeySpecifier);
    fields?: ManualOpportunityCustomerInformationQLFieldPolicy;
  };
  ManualOpportunityQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ManualOpportunityQLKeySpecifier
      | (() => undefined | ManualOpportunityQLKeySpecifier);
    fields?: ManualOpportunityQLFieldPolicy;
  };
  ManualOpportunityReportQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ManualOpportunityReportQLKeySpecifier
      | (() => undefined | ManualOpportunityReportQLKeySpecifier);
    fields?: ManualOpportunityReportQLFieldPolicy;
  };
  ManualOpportunityResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ManualOpportunityResultKeySpecifier
      | (() => undefined | ManualOpportunityResultKeySpecifier);
    fields?: ManualOpportunityResultFieldPolicy;
  };
  ManualOpportunityTriggerQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ManualOpportunityTriggerQLKeySpecifier
      | (() => undefined | ManualOpportunityTriggerQLKeySpecifier);
    fields?: ManualOpportunityTriggerQLFieldPolicy;
  };
  MapCrmUserToUser?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MapCrmUserToUserKeySpecifier
      | (() => undefined | MapCrmUserToUserKeySpecifier);
    fields?: MapCrmUserToUserFieldPolicy;
  };
  MarkMessagesRead?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MarkMessagesReadKeySpecifier
      | (() => undefined | MarkMessagesReadKeySpecifier);
    fields?: MarkMessagesReadFieldPolicy;
  };
  MentionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MentionQLKeySpecifier
      | (() => undefined | MentionQLKeySpecifier);
    fields?: MentionQLFieldPolicy;
  };
  MentionQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MentionQLConnectionKeySpecifier
      | (() => undefined | MentionQLConnectionKeySpecifier);
    fields?: MentionQLConnectionFieldPolicy;
  };
  MentionQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MentionQLEdgeKeySpecifier
      | (() => undefined | MentionQLEdgeKeySpecifier);
    fields?: MentionQLEdgeFieldPolicy;
  };
  MessageConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MessageConnectionKeySpecifier
      | (() => undefined | MessageConnectionKeySpecifier);
    fields?: MessageConnectionFieldPolicy;
  };
  MessageEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MessageEdgeKeySpecifier
      | (() => undefined | MessageEdgeKeySpecifier);
    fields?: MessageEdgeFieldPolicy;
  };
  MessageMetadataQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MessageMetadataQLKeySpecifier
      | (() => undefined | MessageMetadataQLKeySpecifier);
    fields?: MessageMetadataQLFieldPolicy;
  };
  MessageQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MessageQLKeySpecifier
      | (() => undefined | MessageQLKeySpecifier);
    fields?: MessageQLFieldPolicy;
  };
  MessageQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MessageQLConnectionKeySpecifier
      | (() => undefined | MessageQLConnectionKeySpecifier);
    fields?: MessageQLConnectionFieldPolicy;
  };
  MessageQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MessageQLEdgeKeySpecifier
      | (() => undefined | MessageQLEdgeKeySpecifier);
    fields?: MessageQLEdgeFieldPolicy;
  };
  MessageReceivedTriggerQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MessageReceivedTriggerQLKeySpecifier
      | (() => undefined | MessageReceivedTriggerQLKeySpecifier);
    fields?: MessageReceivedTriggerQLFieldPolicy;
  };
  MessageType?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MessageTypeKeySpecifier
      | (() => undefined | MessageTypeKeySpecifier);
    fields?: MessageTypeFieldPolicy;
  };
  MoveStatusItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MoveStatusItemKeySpecifier
      | (() => undefined | MoveStatusItemKeySpecifier);
    fields?: MoveStatusItemFieldPolicy;
  };
  MultiChoiceAttachment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MultiChoiceAttachmentKeySpecifier
      | (() => undefined | MultiChoiceAttachmentKeySpecifier);
    fields?: MultiChoiceAttachmentFieldPolicy;
  };
  Mutations?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MutationsKeySpecifier
      | (() => undefined | MutationsKeySpecifier);
    fields?: MutationsFieldPolicy;
  };
  Node?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | NodeKeySpecifier | (() => undefined | NodeKeySpecifier);
    fields?: NodeFieldPolicy;
  };
  NoteAttachment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NoteAttachmentKeySpecifier
      | (() => undefined | NoteAttachmentKeySpecifier);
    fields?: NoteAttachmentFieldPolicy;
  };
  NoteChannelQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NoteChannelQLKeySpecifier
      | (() => undefined | NoteChannelQLKeySpecifier);
    fields?: NoteChannelQLFieldPolicy;
  };
  NoteTakerConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NoteTakerConnectionKeySpecifier
      | (() => undefined | NoteTakerConnectionKeySpecifier);
    fields?: NoteTakerConnectionFieldPolicy;
  };
  NoteTakerEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NoteTakerEdgeKeySpecifier
      | (() => undefined | NoteTakerEdgeKeySpecifier);
    fields?: NoteTakerEdgeFieldPolicy;
  };
  NoteTakerQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NoteTakerQLKeySpecifier
      | (() => undefined | NoteTakerQLKeySpecifier);
    fields?: NoteTakerQLFieldPolicy;
  };
  NoteTakerQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NoteTakerQLConnectionKeySpecifier
      | (() => undefined | NoteTakerQLConnectionKeySpecifier);
    fields?: NoteTakerQLConnectionFieldPolicy;
  };
  NoteTakerQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NoteTakerQLEdgeKeySpecifier
      | (() => undefined | NoteTakerQLEdgeKeySpecifier);
    fields?: NoteTakerQLEdgeFieldPolicy;
  };
  NoteTakerStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NoteTakerStepQLKeySpecifier
      | (() => undefined | NoteTakerStepQLKeySpecifier);
    fields?: NoteTakerStepQLFieldPolicy;
  };
  NoteTakerStepQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NoteTakerStepQLConnectionKeySpecifier
      | (() => undefined | NoteTakerStepQLConnectionKeySpecifier);
    fields?: NoteTakerStepQLConnectionFieldPolicy;
  };
  NoteTakerStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NoteTakerStepQLEdgeKeySpecifier
      | (() => undefined | NoteTakerStepQLEdgeKeySpecifier);
    fields?: NoteTakerStepQLEdgeFieldPolicy;
  };
  NotifyTeamMemberActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NotifyTeamMemberActionQLKeySpecifier
      | (() => undefined | NotifyTeamMemberActionQLKeySpecifier);
    fields?: NotifyTeamMemberActionQLFieldPolicy;
  };
  NumaServiceQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NumaServiceQLKeySpecifier
      | (() => undefined | NumaServiceQLKeySpecifier);
    fields?: NumaServiceQLFieldPolicy;
  };
  NumboxAgentSessionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NumboxAgentSessionQLKeySpecifier
      | (() => undefined | NumboxAgentSessionQLKeySpecifier);
    fields?: NumboxAgentSessionQLFieldPolicy;
  };
  NumboxAgentSessionQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NumboxAgentSessionQLConnectionKeySpecifier
      | (() => undefined | NumboxAgentSessionQLConnectionKeySpecifier);
    fields?: NumboxAgentSessionQLConnectionFieldPolicy;
  };
  NumboxAgentSessionQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NumboxAgentSessionQLEdgeKeySpecifier
      | (() => undefined | NumboxAgentSessionQLEdgeKeySpecifier);
    fields?: NumboxAgentSessionQLEdgeFieldPolicy;
  };
  NumboxChannelQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NumboxChannelQLKeySpecifier
      | (() => undefined | NumboxChannelQLKeySpecifier);
    fields?: NumboxChannelQLFieldPolicy;
  };
  Objection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ObjectionKeySpecifier
      | (() => undefined | ObjectionKeySpecifier);
    fields?: ObjectionFieldPolicy;
  };
  OpCodeQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OpCodeQLKeySpecifier
      | (() => undefined | OpCodeQLKeySpecifier);
    fields?: OpCodeQLFieldPolicy;
  };
  OpCodeQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OpCodeQLConnectionKeySpecifier
      | (() => undefined | OpCodeQLConnectionKeySpecifier);
    fields?: OpCodeQLConnectionFieldPolicy;
  };
  OpCodeQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OpCodeQLEdgeKeySpecifier
      | (() => undefined | OpCodeQLEdgeKeySpecifier);
    fields?: OpCodeQLEdgeFieldPolicy;
  };
  OpCodesFilter?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OpCodesFilterKeySpecifier
      | (() => undefined | OpCodesFilterKeySpecifier);
    fields?: OpCodesFilterFieldPolicy;
  };
  OpcodeOutputQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OpcodeOutputQLKeySpecifier
      | (() => undefined | OpcodeOutputQLKeySpecifier);
    fields?: OpcodeOutputQLFieldPolicy;
  };
  OpenVoiceQuestionAttachment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OpenVoiceQuestionAttachmentKeySpecifier
      | (() => undefined | OpenVoiceQuestionAttachmentKeySpecifier);
    fields?: OpenVoiceQuestionAttachmentFieldPolicy;
  };
  OperatorAgentStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OperatorAgentStepQLKeySpecifier
      | (() => undefined | OperatorAgentStepQLKeySpecifier);
    fields?: OperatorAgentStepQLFieldPolicy;
  };
  OperatorAgentStepQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OperatorAgentStepQLConnectionKeySpecifier
      | (() => undefined | OperatorAgentStepQLConnectionKeySpecifier);
    fields?: OperatorAgentStepQLConnectionFieldPolicy;
  };
  OperatorAgentStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OperatorAgentStepQLEdgeKeySpecifier
      | (() => undefined | OperatorAgentStepQLEdgeKeySpecifier);
    fields?: OperatorAgentStepQLEdgeFieldPolicy;
  };
  OperatorChannelQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OperatorChannelQLKeySpecifier
      | (() => undefined | OperatorChannelQLKeySpecifier);
    fields?: OperatorChannelQLFieldPolicy;
  };
  OperatorPlaceQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OperatorPlaceQLKeySpecifier
      | (() => undefined | OperatorPlaceQLKeySpecifier);
    fields?: OperatorPlaceQLFieldPolicy;
  };
  OperatorQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OperatorQLKeySpecifier
      | (() => undefined | OperatorQLKeySpecifier);
    fields?: OperatorQLFieldPolicy;
  };
  OperatorQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OperatorQLConnectionKeySpecifier
      | (() => undefined | OperatorQLConnectionKeySpecifier);
    fields?: OperatorQLConnectionFieldPolicy;
  };
  OperatorQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OperatorQLEdgeKeySpecifier
      | (() => undefined | OperatorQLEdgeKeySpecifier);
    fields?: OperatorQLEdgeFieldPolicy;
  };
  OperatorSessionConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OperatorSessionConnectionKeySpecifier
      | (() => undefined | OperatorSessionConnectionKeySpecifier);
    fields?: OperatorSessionConnectionFieldPolicy;
  };
  OperatorSessionEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OperatorSessionEdgeKeySpecifier
      | (() => undefined | OperatorSessionEdgeKeySpecifier);
    fields?: OperatorSessionEdgeFieldPolicy;
  };
  OperatorSessionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OperatorSessionQLKeySpecifier
      | (() => undefined | OperatorSessionQLKeySpecifier);
    fields?: OperatorSessionQLFieldPolicy;
  };
  OperatorSessionQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OperatorSessionQLConnectionKeySpecifier
      | (() => undefined | OperatorSessionQLConnectionKeySpecifier);
    fields?: OperatorSessionQLConnectionFieldPolicy;
  };
  OperatorSessionQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OperatorSessionQLEdgeKeySpecifier
      | (() => undefined | OperatorSessionQLEdgeKeySpecifier);
    fields?: OperatorSessionQLEdgeFieldPolicy;
  };
  OperatorSettingsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OperatorSettingsQLKeySpecifier
      | (() => undefined | OperatorSettingsQLKeySpecifier);
    fields?: OperatorSettingsQLFieldPolicy;
  };
  OperatorTranscriptQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OperatorTranscriptQLKeySpecifier
      | (() => undefined | OperatorTranscriptQLKeySpecifier);
    fields?: OperatorTranscriptQLFieldPolicy;
  };
  OpportunityInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OpportunityInfoKeySpecifier
      | (() => undefined | OpportunityInfoKeySpecifier);
    fields?: OpportunityInfoFieldPolicy;
  };
  OpportunityServiceAppointmentConfirmationTriggerQL?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | OpportunityServiceAppointmentConfirmationTriggerQLKeySpecifier
      | (() =>
          | undefined
          | OpportunityServiceAppointmentConfirmationTriggerQLKeySpecifier);
    fields?: OpportunityServiceAppointmentConfirmationTriggerQLFieldPolicy;
  };
  OpportunityServiceAppointmentReminderTriggerQL?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | OpportunityServiceAppointmentReminderTriggerQLKeySpecifier
      | (() =>
          | undefined
          | OpportunityServiceAppointmentReminderTriggerQLKeySpecifier);
    fields?: OpportunityServiceAppointmentReminderTriggerQLFieldPolicy;
  };
  OrderQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrderQLKeySpecifier
      | (() => undefined | OrderQLKeySpecifier);
    fields?: OrderQLFieldPolicy;
  };
  OutboundCallCustomizationQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OutboundCallCustomizationQLKeySpecifier
      | (() => undefined | OutboundCallCustomizationQLKeySpecifier);
    fields?: OutboundCallCustomizationQLFieldPolicy;
  };
  OutboundCallCustomizationQLConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | OutboundCallCustomizationQLConnectionKeySpecifier
      | (() => undefined | OutboundCallCustomizationQLConnectionKeySpecifier);
    fields?: OutboundCallCustomizationQLConnectionFieldPolicy;
  };
  OutboundCallCustomizationQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OutboundCallCustomizationQLEdgeKeySpecifier
      | (() => undefined | OutboundCallCustomizationQLEdgeKeySpecifier);
    fields?: OutboundCallCustomizationQLEdgeFieldPolicy;
  };
  OutboundCallSettingQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OutboundCallSettingQLKeySpecifier
      | (() => undefined | OutboundCallSettingQLKeySpecifier);
    fields?: OutboundCallSettingQLFieldPolicy;
  };
  OutboundConferenceCallQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OutboundConferenceCallQLKeySpecifier
      | (() => undefined | OutboundConferenceCallQLKeySpecifier);
    fields?: OutboundConferenceCallQLFieldPolicy;
  };
  OutboundConferenceCallQLConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | OutboundConferenceCallQLConnectionKeySpecifier
      | (() => undefined | OutboundConferenceCallQLConnectionKeySpecifier);
    fields?: OutboundConferenceCallQLConnectionFieldPolicy;
  };
  OutboundConferenceCallQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OutboundConferenceCallQLEdgeKeySpecifier
      | (() => undefined | OutboundConferenceCallQLEdgeKeySpecifier);
    fields?: OutboundConferenceCallQLEdgeFieldPolicy;
  };
  OutboundProxyCallQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OutboundProxyCallQLKeySpecifier
      | (() => undefined | OutboundProxyCallQLKeySpecifier);
    fields?: OutboundProxyCallQLFieldPolicy;
  };
  OutboundProxyCallQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OutboundProxyCallQLConnectionKeySpecifier
      | (() => undefined | OutboundProxyCallQLConnectionKeySpecifier);
    fields?: OutboundProxyCallQLConnectionFieldPolicy;
  };
  OutboundProxyCallQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OutboundProxyCallQLEdgeKeySpecifier
      | (() => undefined | OutboundProxyCallQLEdgeKeySpecifier);
    fields?: OutboundProxyCallQLEdgeFieldPolicy;
  };
  OutboundProxyNumber?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OutboundProxyNumberKeySpecifier
      | (() => undefined | OutboundProxyNumberKeySpecifier);
    fields?: OutboundProxyNumberFieldPolicy;
  };
  OutboundProxyTwilioNumberQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OutboundProxyTwilioNumberQLKeySpecifier
      | (() => undefined | OutboundProxyTwilioNumberQLKeySpecifier);
    fields?: OutboundProxyTwilioNumberQLFieldPolicy;
  };
  PageInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PageInfoKeySpecifier
      | (() => undefined | PageInfoKeySpecifier);
    fields?: PageInfoFieldPolicy;
  };
  PaletteQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PaletteQLKeySpecifier
      | (() => undefined | PaletteQLKeySpecifier);
    fields?: PaletteQLFieldPolicy;
  };
  ParticipantConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ParticipantConnectionKeySpecifier
      | (() => undefined | ParticipantConnectionKeySpecifier);
    fields?: ParticipantConnectionFieldPolicy;
  };
  ParticipantEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ParticipantEdgeKeySpecifier
      | (() => undefined | ParticipantEdgeKeySpecifier);
    fields?: ParticipantEdgeFieldPolicy;
  };
  ParticipantQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ParticipantQLKeySpecifier
      | (() => undefined | ParticipantQLKeySpecifier);
    fields?: ParticipantQLFieldPolicy;
  };
  ParticipantQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ParticipantQLConnectionKeySpecifier
      | (() => undefined | ParticipantQLConnectionKeySpecifier);
    fields?: ParticipantQLConnectionFieldPolicy;
  };
  ParticipantQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ParticipantQLEdgeKeySpecifier
      | (() => undefined | ParticipantQLEdgeKeySpecifier);
    fields?: ParticipantQLEdgeFieldPolicy;
  };
  PaymentRequestConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PaymentRequestConnectionKeySpecifier
      | (() => undefined | PaymentRequestConnectionKeySpecifier);
    fields?: PaymentRequestConnectionFieldPolicy;
  };
  PaymentRequestCustomizationQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PaymentRequestCustomizationQLKeySpecifier
      | (() => undefined | PaymentRequestCustomizationQLKeySpecifier);
    fields?: PaymentRequestCustomizationQLFieldPolicy;
  };
  PaymentRequestEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PaymentRequestEdgeKeySpecifier
      | (() => undefined | PaymentRequestEdgeKeySpecifier);
    fields?: PaymentRequestEdgeFieldPolicy;
  };
  PaymentRequestQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PaymentRequestQLKeySpecifier
      | (() => undefined | PaymentRequestQLKeySpecifier);
    fields?: PaymentRequestQLFieldPolicy;
  };
  PaymentRequestQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PaymentRequestQLConnectionKeySpecifier
      | (() => undefined | PaymentRequestQLConnectionKeySpecifier);
    fields?: PaymentRequestQLConnectionFieldPolicy;
  };
  PaymentRequestQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PaymentRequestQLEdgeKeySpecifier
      | (() => undefined | PaymentRequestQLEdgeKeySpecifier);
    fields?: PaymentRequestQLEdgeFieldPolicy;
  };
  PhoneCallQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PhoneCallQLKeySpecifier
      | (() => undefined | PhoneCallQLKeySpecifier);
    fields?: PhoneCallQLFieldPolicy;
  };
  PhoneCallQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PhoneCallQLConnectionKeySpecifier
      | (() => undefined | PhoneCallQLConnectionKeySpecifier);
    fields?: PhoneCallQLConnectionFieldPolicy;
  };
  PhoneCallQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PhoneCallQLEdgeKeySpecifier
      | (() => undefined | PhoneCallQLEdgeKeySpecifier);
    fields?: PhoneCallQLEdgeFieldPolicy;
  };
  PhoneLinePolicyQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PhoneLinePolicyQLKeySpecifier
      | (() => undefined | PhoneLinePolicyQLKeySpecifier);
    fields?: PhoneLinePolicyQLFieldPolicy;
  };
  PhoneLinePolicyQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PhoneLinePolicyQLConnectionKeySpecifier
      | (() => undefined | PhoneLinePolicyQLConnectionKeySpecifier);
    fields?: PhoneLinePolicyQLConnectionFieldPolicy;
  };
  PhoneLinePolicyQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PhoneLinePolicyQLEdgeKeySpecifier
      | (() => undefined | PhoneLinePolicyQLEdgeKeySpecifier);
    fields?: PhoneLinePolicyQLEdgeFieldPolicy;
  };
  PhoneLineQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PhoneLineQLKeySpecifier
      | (() => undefined | PhoneLineQLKeySpecifier);
    fields?: PhoneLineQLFieldPolicy;
  };
  PhoneLineQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PhoneLineQLConnectionKeySpecifier
      | (() => undefined | PhoneLineQLConnectionKeySpecifier);
    fields?: PhoneLineQLConnectionFieldPolicy;
  };
  PhoneLineQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PhoneLineQLEdgeKeySpecifier
      | (() => undefined | PhoneLineQLEdgeKeySpecifier);
    fields?: PhoneLineQLEdgeFieldPolicy;
  };
  PickupStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PickupStepQLKeySpecifier
      | (() => undefined | PickupStepQLKeySpecifier);
    fields?: PickupStepQLFieldPolicy;
  };
  PickupStepQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PickupStepQLConnectionKeySpecifier
      | (() => undefined | PickupStepQLConnectionKeySpecifier);
    fields?: PickupStepQLConnectionFieldPolicy;
  };
  PickupStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PickupStepQLEdgeKeySpecifier
      | (() => undefined | PickupStepQLEdgeKeySpecifier);
    fields?: PickupStepQLEdgeFieldPolicy;
  };
  PlaceConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceConnectionKeySpecifier
      | (() => undefined | PlaceConnectionKeySpecifier);
    fields?: PlaceConnectionFieldPolicy;
  };
  PlaceEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceEdgeKeySpecifier
      | (() => undefined | PlaceEdgeKeySpecifier);
    fields?: PlaceEdgeFieldPolicy;
  };
  PlaceGroupConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceGroupConnectionKeySpecifier
      | (() => undefined | PlaceGroupConnectionKeySpecifier);
    fields?: PlaceGroupConnectionFieldPolicy;
  };
  PlaceGroupEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceGroupEdgeKeySpecifier
      | (() => undefined | PlaceGroupEdgeKeySpecifier);
    fields?: PlaceGroupEdgeFieldPolicy;
  };
  PlaceGroupQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceGroupQLKeySpecifier
      | (() => undefined | PlaceGroupQLKeySpecifier);
    fields?: PlaceGroupQLFieldPolicy;
  };
  PlaceGroupQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceGroupQLConnectionKeySpecifier
      | (() => undefined | PlaceGroupQLConnectionKeySpecifier);
    fields?: PlaceGroupQLConnectionFieldPolicy;
  };
  PlaceGroupQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceGroupQLEdgeKeySpecifier
      | (() => undefined | PlaceGroupQLEdgeKeySpecifier);
    fields?: PlaceGroupQLEdgeFieldPolicy;
  };
  PlaceInfoQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceInfoQLKeySpecifier
      | (() => undefined | PlaceInfoQLKeySpecifier);
    fields?: PlaceInfoQLFieldPolicy;
  };
  PlaceMetrics?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceMetricsKeySpecifier
      | (() => undefined | PlaceMetricsKeySpecifier);
    fields?: PlaceMetricsFieldPolicy;
  };
  PlaceMetricsConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceMetricsConnectionKeySpecifier
      | (() => undefined | PlaceMetricsConnectionKeySpecifier);
    fields?: PlaceMetricsConnectionFieldPolicy;
  };
  PlaceMetricsEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceMetricsEdgeKeySpecifier
      | (() => undefined | PlaceMetricsEdgeKeySpecifier);
    fields?: PlaceMetricsEdgeFieldPolicy;
  };
  PlacePermissionsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlacePermissionsQLKeySpecifier
      | (() => undefined | PlacePermissionsQLKeySpecifier);
    fields?: PlacePermissionsQLFieldPolicy;
  };
  PlaceQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceQLKeySpecifier
      | (() => undefined | PlaceQLKeySpecifier);
    fields?: PlaceQLFieldPolicy;
  };
  PlaceQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceQLConnectionKeySpecifier
      | (() => undefined | PlaceQLConnectionKeySpecifier);
    fields?: PlaceQLConnectionFieldPolicy;
  };
  PlaceQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceQLEdgeKeySpecifier
      | (() => undefined | PlaceQLEdgeKeySpecifier);
    fields?: PlaceQLEdgeFieldPolicy;
  };
  PlaceVoiceSettingsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceVoiceSettingsQLKeySpecifier
      | (() => undefined | PlaceVoiceSettingsQLKeySpecifier);
    fields?: PlaceVoiceSettingsQLFieldPolicy;
  };
  PlacesUsersQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlacesUsersQLKeySpecifier
      | (() => undefined | PlacesUsersQLKeySpecifier);
    fields?: PlacesUsersQLFieldPolicy;
  };
  PlacesUsersQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlacesUsersQLConnectionKeySpecifier
      | (() => undefined | PlacesUsersQLConnectionKeySpecifier);
    fields?: PlacesUsersQLConnectionFieldPolicy;
  };
  PlacesUsersQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlacesUsersQLEdgeKeySpecifier
      | (() => undefined | PlacesUsersQLEdgeKeySpecifier);
    fields?: PlacesUsersQLEdgeFieldPolicy;
  };
  PokeUser?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PokeUserKeySpecifier
      | (() => undefined | PokeUserKeySpecifier);
    fields?: PokeUserFieldPolicy;
  };
  PopulateBusinessProfileWithChargebeeInfo?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | PopulateBusinessProfileWithChargebeeInfoKeySpecifier
      | (() =>
          | undefined
          | PopulateBusinessProfileWithChargebeeInfoKeySpecifier);
    fields?: PopulateBusinessProfileWithChargebeeInfoFieldPolicy;
  };
  PortInPhoneLine?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PortInPhoneLineKeySpecifier
      | (() => undefined | PortInPhoneLineKeySpecifier);
    fields?: PortInPhoneLineFieldPolicy;
  };
  PredictedMessageIntentQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PredictedMessageIntentQLKeySpecifier
      | (() => undefined | PredictedMessageIntentQLKeySpecifier);
    fields?: PredictedMessageIntentQLFieldPolicy;
  };
  PressAnyKeyStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PressAnyKeyStepQLKeySpecifier
      | (() => undefined | PressAnyKeyStepQLKeySpecifier);
    fields?: PressAnyKeyStepQLFieldPolicy;
  };
  PubNubConfigQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PubNubConfigQLKeySpecifier
      | (() => undefined | PubNubConfigQLKeySpecifier);
    fields?: PubNubConfigQLFieldPolicy;
  };
  PublicListingQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublicListingQLKeySpecifier
      | (() => undefined | PublicListingQLKeySpecifier);
    fields?: PublicListingQLFieldPolicy;
  };
  PublishAutomation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublishAutomationKeySpecifier
      | (() => undefined | PublishAutomationKeySpecifier);
    fields?: PublishAutomationFieldPolicy;
  };
  PublishDisruptionVoiceScript?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublishDisruptionVoiceScriptKeySpecifier
      | (() => undefined | PublishDisruptionVoiceScriptKeySpecifier);
    fields?: PublishDisruptionVoiceScriptFieldPolicy;
  };
  PublishVoiceScript?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublishVoiceScriptKeySpecifier
      | (() => undefined | PublishVoiceScriptKeySpecifier);
    fields?: PublishVoiceScriptFieldPolicy;
  };
  QualificationSurveyQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QualificationSurveyQLKeySpecifier
      | (() => undefined | QualificationSurveyQLKeySpecifier);
    fields?: QualificationSurveyQLFieldPolicy;
  };
  QualifyStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QualifyStepQLKeySpecifier
      | (() => undefined | QualifyStepQLKeySpecifier);
    fields?: QualifyStepQLFieldPolicy;
  };
  QualifyStepQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QualifyStepQLConnectionKeySpecifier
      | (() => undefined | QualifyStepQLConnectionKeySpecifier);
    fields?: QualifyStepQLConnectionFieldPolicy;
  };
  QualifyStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QualifyStepQLEdgeKeySpecifier
      | (() => undefined | QualifyStepQLEdgeKeySpecifier);
    fields?: QualifyStepQLEdgeFieldPolicy;
  };
  Query?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QueryKeySpecifier
      | (() => undefined | QueryKeySpecifier);
    fields?: QueryFieldPolicy;
  };
  QuestionAgentSettingsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QuestionAgentSettingsQLKeySpecifier
      | (() => undefined | QuestionAgentSettingsQLKeySpecifier);
    fields?: QuestionAgentSettingsQLFieldPolicy;
  };
  QuestionAgentSettingsQLConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | QuestionAgentSettingsQLConnectionKeySpecifier
      | (() => undefined | QuestionAgentSettingsQLConnectionKeySpecifier);
    fields?: QuestionAgentSettingsQLConnectionFieldPolicy;
  };
  QuestionAgentSettingsQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QuestionAgentSettingsQLEdgeKeySpecifier
      | (() => undefined | QuestionAgentSettingsQLEdgeKeySpecifier);
    fields?: QuestionAgentSettingsQLEdgeFieldPolicy;
  };
  QuestionBotStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QuestionBotStepQLKeySpecifier
      | (() => undefined | QuestionBotStepQLKeySpecifier);
    fields?: QuestionBotStepQLFieldPolicy;
  };
  QuestionBotStepQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QuestionBotStepQLConnectionKeySpecifier
      | (() => undefined | QuestionBotStepQLConnectionKeySpecifier);
    fields?: QuestionBotStepQLConnectionFieldPolicy;
  };
  QuestionBotStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QuestionBotStepQLEdgeKeySpecifier
      | (() => undefined | QuestionBotStepQLEdgeKeySpecifier);
    fields?: QuestionBotStepQLEdgeFieldPolicy;
  };
  QuestionNode?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QuestionNodeKeySpecifier
      | (() => undefined | QuestionNodeKeySpecifier);
    fields?: QuestionNodeFieldPolicy;
  };
  QuestionTree?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QuestionTreeKeySpecifier
      | (() => undefined | QuestionTreeKeySpecifier);
    fields?: QuestionTreeFieldPolicy;
  };
  ReasonSentGreetingQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReasonSentGreetingQLKeySpecifier
      | (() => undefined | ReasonSentGreetingQLKeySpecifier);
    fields?: ReasonSentGreetingQLFieldPolicy;
  };
  ReasonSentHangupResponseQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReasonSentHangupResponseQLKeySpecifier
      | (() => undefined | ReasonSentHangupResponseQLKeySpecifier);
    fields?: ReasonSentHangupResponseQLFieldPolicy;
  };
  ReasonSentIntentQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReasonSentIntentQLKeySpecifier
      | (() => undefined | ReasonSentIntentQLKeySpecifier);
    fields?: ReasonSentIntentQLFieldPolicy;
  };
  ReasonSentQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReasonSentQLKeySpecifier
      | (() => undefined | ReasonSentQLKeySpecifier);
    fields?: ReasonSentQLFieldPolicy;
  };
  RecoverConversation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RecoverConversationKeySpecifier
      | (() => undefined | RecoverConversationKeySpecifier);
    fields?: RecoverConversationFieldPolicy;
  };
  RefreshCarrierInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RefreshCarrierInfoKeySpecifier
      | (() => undefined | RefreshCarrierInfoKeySpecifier);
    fields?: RefreshCarrierInfoFieldPolicy;
  };
  RefreshFortellisServiceAdvisors?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RefreshFortellisServiceAdvisorsKeySpecifier
      | (() => undefined | RefreshFortellisServiceAdvisorsKeySpecifier);
    fields?: RefreshFortellisServiceAdvisorsFieldPolicy;
  };
  RefundQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RefundQLKeySpecifier
      | (() => undefined | RefundQLKeySpecifier);
    fields?: RefundQLFieldPolicy;
  };
  RefundQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RefundQLConnectionKeySpecifier
      | (() => undefined | RefundQLConnectionKeySpecifier);
    fields?: RefundQLConnectionFieldPolicy;
  };
  RefundQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RefundQLEdgeKeySpecifier
      | (() => undefined | RefundQLEdgeKeySpecifier);
    fields?: RefundQLEdgeFieldPolicy;
  };
  RegisterFortellisServiceAdvisor?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RegisterFortellisServiceAdvisorKeySpecifier
      | (() => undefined | RegisterFortellisServiceAdvisorKeySpecifier);
    fields?: RegisterFortellisServiceAdvisorFieldPolicy;
  };
  RegisteredFortellisServiceAdvisorQL?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | RegisteredFortellisServiceAdvisorQLKeySpecifier
      | (() => undefined | RegisteredFortellisServiceAdvisorQLKeySpecifier);
    fields?: RegisteredFortellisServiceAdvisorQLFieldPolicy;
  };
  RemoveAutomationAction?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemoveAutomationActionKeySpecifier
      | (() => undefined | RemoveAutomationActionKeySpecifier);
    fields?: RemoveAutomationActionFieldPolicy;
  };
  RemoveAutomationExitTrigger?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemoveAutomationExitTriggerKeySpecifier
      | (() => undefined | RemoveAutomationExitTriggerKeySpecifier);
    fields?: RemoveAutomationExitTriggerFieldPolicy;
  };
  RemoveLabelFromConversation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemoveLabelFromConversationKeySpecifier
      | (() => undefined | RemoveLabelFromConversationKeySpecifier);
    fields?: RemoveLabelFromConversationFieldPolicy;
  };
  RemovePlaceGroup?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemovePlaceGroupKeySpecifier
      | (() => undefined | RemovePlaceGroupKeySpecifier);
    fields?: RemovePlaceGroupFieldPolicy;
  };
  RemoveServiceAdvisor?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemoveServiceAdvisorKeySpecifier
      | (() => undefined | RemoveServiceAdvisorKeySpecifier);
    fields?: RemoveServiceAdvisorFieldPolicy;
  };
  RemoveUserFromPlace?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemoveUserFromPlaceKeySpecifier
      | (() => undefined | RemoveUserFromPlaceKeySpecifier);
    fields?: RemoveUserFromPlaceFieldPolicy;
  };
  RemoveUserFromTeam?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemoveUserFromTeamKeySpecifier
      | (() => undefined | RemoveUserFromTeamKeySpecifier);
    fields?: RemoveUserFromTeamFieldPolicy;
  };
  RemoveVideoUploadLink?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemoveVideoUploadLinkKeySpecifier
      | (() => undefined | RemoveVideoUploadLinkKeySpecifier);
    fields?: RemoveVideoUploadLinkFieldPolicy;
  };
  RenameAccount?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RenameAccountKeySpecifier
      | (() => undefined | RenameAccountKeySpecifier);
    fields?: RenameAccountFieldPolicy;
  };
  RenamePlace?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RenamePlaceKeySpecifier
      | (() => undefined | RenamePlaceKeySpecifier);
    fields?: RenamePlaceFieldPolicy;
  };
  ReopenStatusItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReopenStatusItemKeySpecifier
      | (() => undefined | ReopenStatusItemKeySpecifier);
    fields?: ReopenStatusItemFieldPolicy;
  };
  RepairOrder?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RepairOrderKeySpecifier
      | (() => undefined | RepairOrderKeySpecifier);
    fields?: RepairOrderFieldPolicy;
  };
  RepairOrderClosedTriggerQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RepairOrderClosedTriggerQLKeySpecifier
      | (() => undefined | RepairOrderClosedTriggerQLKeySpecifier);
    fields?: RepairOrderClosedTriggerQLFieldPolicy;
  };
  RepairOrderConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RepairOrderConnectionKeySpecifier
      | (() => undefined | RepairOrderConnectionKeySpecifier);
    fields?: RepairOrderConnectionFieldPolicy;
  };
  RepairOrderEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RepairOrderEdgeKeySpecifier
      | (() => undefined | RepairOrderEdgeKeySpecifier);
    fields?: RepairOrderEdgeFieldPolicy;
  };
  RepairOrderFortellisQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RepairOrderFortellisQLKeySpecifier
      | (() => undefined | RepairOrderFortellisQLKeySpecifier);
    fields?: RepairOrderFortellisQLFieldPolicy;
  };
  RepairOrderFortellisQLConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | RepairOrderFortellisQLConnectionKeySpecifier
      | (() => undefined | RepairOrderFortellisQLConnectionKeySpecifier);
    fields?: RepairOrderFortellisQLConnectionFieldPolicy;
  };
  RepairOrderFortellisQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RepairOrderFortellisQLEdgeKeySpecifier
      | (() => undefined | RepairOrderFortellisQLEdgeKeySpecifier);
    fields?: RepairOrderFortellisQLEdgeFieldPolicy;
  };
  RepairOrderNotesSummaryQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RepairOrderNotesSummaryQLKeySpecifier
      | (() => undefined | RepairOrderNotesSummaryQLKeySpecifier);
    fields?: RepairOrderNotesSummaryQLFieldPolicy;
  };
  RepairOrderOpenedTriggerQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RepairOrderOpenedTriggerQLKeySpecifier
      | (() => undefined | RepairOrderOpenedTriggerQLKeySpecifier);
    fields?: RepairOrderOpenedTriggerQLFieldPolicy;
  };
  RepairOrderSmartStatusUpdateSettingsQL?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | RepairOrderSmartStatusUpdateSettingsQLKeySpecifier
      | (() => undefined | RepairOrderSmartStatusUpdateSettingsQLKeySpecifier);
    fields?: RepairOrderSmartStatusUpdateSettingsQLFieldPolicy;
  };
  RepairOrderUpdateFilter?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RepairOrderUpdateFilterKeySpecifier
      | (() => undefined | RepairOrderUpdateFilterKeySpecifier);
    fields?: RepairOrderUpdateFilterFieldPolicy;
  };
  RepairOrderUpdatedCondition?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RepairOrderUpdatedConditionKeySpecifier
      | (() => undefined | RepairOrderUpdatedConditionKeySpecifier);
    fields?: RepairOrderUpdatedConditionFieldPolicy;
  };
  RepairOrderUpdatedConditionValue?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | RepairOrderUpdatedConditionValueKeySpecifier
      | (() => undefined | RepairOrderUpdatedConditionValueKeySpecifier);
    fields?: RepairOrderUpdatedConditionValueFieldPolicy;
  };
  RepairOrderUpdatedTriggerQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RepairOrderUpdatedTriggerQLKeySpecifier
      | (() => undefined | RepairOrderUpdatedTriggerQLKeySpecifier);
    fields?: RepairOrderUpdatedTriggerQLFieldPolicy;
  };
  RepairServiceQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RepairServiceQLKeySpecifier
      | (() => undefined | RepairServiceQLKeySpecifier);
    fields?: RepairServiceQLFieldPolicy;
  };
  RepairServiceQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RepairServiceQLConnectionKeySpecifier
      | (() => undefined | RepairServiceQLConnectionKeySpecifier);
    fields?: RepairServiceQLConnectionFieldPolicy;
  };
  RepairServiceQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RepairServiceQLEdgeKeySpecifier
      | (() => undefined | RepairServiceQLEdgeKeySpecifier);
    fields?: RepairServiceQLEdgeFieldPolicy;
  };
  RequestAvailableIntegration?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RequestAvailableIntegrationKeySpecifier
      | (() => undefined | RequestAvailableIntegrationKeySpecifier);
    fields?: RequestAvailableIntegrationFieldPolicy;
  };
  ResetAppointmentAgentSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ResetAppointmentAgentSettingsKeySpecifier
      | (() => undefined | ResetAppointmentAgentSettingsKeySpecifier);
    fields?: ResetAppointmentAgentSettingsFieldPolicy;
  };
  ResetBrandTheme?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ResetBrandThemeKeySpecifier
      | (() => undefined | ResetBrandThemeKeySpecifier);
    fields?: ResetBrandThemeFieldPolicy;
  };
  ResetConversationLanguage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ResetConversationLanguageKeySpecifier
      | (() => undefined | ResetConversationLanguageKeySpecifier);
    fields?: ResetConversationLanguageFieldPolicy;
  };
  ResetOutboundChannels?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ResetOutboundChannelsKeySpecifier
      | (() => undefined | ResetOutboundChannelsKeySpecifier);
    fields?: ResetOutboundChannelsFieldPolicy;
  };
  ResetTaskStatus?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ResetTaskStatusKeySpecifier
      | (() => undefined | ResetTaskStatusKeySpecifier);
    fields?: ResetTaskStatusFieldPolicy;
  };
  ResetVoiceScript?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ResetVoiceScriptKeySpecifier
      | (() => undefined | ResetVoiceScriptKeySpecifier);
    fields?: ResetVoiceScriptFieldPolicy;
  };
  ResolutionStep?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ResolutionStepKeySpecifier
      | (() => undefined | ResolutionStepKeySpecifier);
    fields?: ResolutionStepFieldPolicy;
  };
  ReviewAttachment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReviewAttachmentKeySpecifier
      | (() => undefined | ReviewAttachmentKeySpecifier);
    fields?: ReviewAttachmentFieldPolicy;
  };
  ReviewAttachmentConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReviewAttachmentConnectionKeySpecifier
      | (() => undefined | ReviewAttachmentConnectionKeySpecifier);
    fields?: ReviewAttachmentConnectionFieldPolicy;
  };
  ReviewAttachmentEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReviewAttachmentEdgeKeySpecifier
      | (() => undefined | ReviewAttachmentEdgeKeySpecifier);
    fields?: ReviewAttachmentEdgeFieldPolicy;
  };
  ReviewFeedbackQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReviewFeedbackQLKeySpecifier
      | (() => undefined | ReviewFeedbackQLKeySpecifier);
    fields?: ReviewFeedbackQLFieldPolicy;
  };
  ReviewJobQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReviewJobQLKeySpecifier
      | (() => undefined | ReviewJobQLKeySpecifier);
    fields?: ReviewJobQLFieldPolicy;
  };
  ReviewJobQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReviewJobQLConnectionKeySpecifier
      | (() => undefined | ReviewJobQLConnectionKeySpecifier);
    fields?: ReviewJobQLConnectionFieldPolicy;
  };
  ReviewJobQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReviewJobQLEdgeKeySpecifier
      | (() => undefined | ReviewJobQLEdgeKeySpecifier);
    fields?: ReviewJobQLEdgeFieldPolicy;
  };
  ReviewQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReviewQLKeySpecifier
      | (() => undefined | ReviewQLKeySpecifier);
    fields?: ReviewQLFieldPolicy;
  };
  ReviewQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReviewQLConnectionKeySpecifier
      | (() => undefined | ReviewQLConnectionKeySpecifier);
    fields?: ReviewQLConnectionFieldPolicy;
  };
  ReviewQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReviewQLEdgeKeySpecifier
      | (() => undefined | ReviewQLEdgeKeySpecifier);
    fields?: ReviewQLEdgeFieldPolicy;
  };
  ReviewSite?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReviewSiteKeySpecifier
      | (() => undefined | ReviewSiteKeySpecifier);
    fields?: ReviewSiteFieldPolicy;
  };
  ReviewSiteInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReviewSiteInterfaceKeySpecifier
      | (() => undefined | ReviewSiteInterfaceKeySpecifier);
    fields?: ReviewSiteInterfaceFieldPolicy;
  };
  ScheduleMessageActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ScheduleMessageActionQLKeySpecifier
      | (() => undefined | ScheduleMessageActionQLKeySpecifier);
    fields?: ScheduleMessageActionQLFieldPolicy;
  };
  ScheduleMessageConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ScheduleMessageConnectionKeySpecifier
      | (() => undefined | ScheduleMessageConnectionKeySpecifier);
    fields?: ScheduleMessageConnectionFieldPolicy;
  };
  ScheduleMessageEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ScheduleMessageEdgeKeySpecifier
      | (() => undefined | ScheduleMessageEdgeKeySpecifier);
    fields?: ScheduleMessageEdgeFieldPolicy;
  };
  ScheduledMessageQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ScheduledMessageQLKeySpecifier
      | (() => undefined | ScheduledMessageQLKeySpecifier);
    fields?: ScheduledMessageQLFieldPolicy;
  };
  ScheduledMessageQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ScheduledMessageQLConnectionKeySpecifier
      | (() => undefined | ScheduledMessageQLConnectionKeySpecifier);
    fields?: ScheduledMessageQLConnectionFieldPolicy;
  };
  ScheduledMessageQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ScheduledMessageQLEdgeKeySpecifier
      | (() => undefined | ScheduledMessageQLEdgeKeySpecifier);
    fields?: ScheduledMessageQLEdgeFieldPolicy;
  };
  SchedulerLogQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SchedulerLogQLKeySpecifier
      | (() => undefined | SchedulerLogQLKeySpecifier);
    fields?: SchedulerLogQLFieldPolicy;
  };
  SchedulerSyncConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SchedulerSyncConnectionKeySpecifier
      | (() => undefined | SchedulerSyncConnectionKeySpecifier);
    fields?: SchedulerSyncConnectionFieldPolicy;
  };
  SchedulerSyncEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SchedulerSyncEdgeKeySpecifier
      | (() => undefined | SchedulerSyncEdgeKeySpecifier);
    fields?: SchedulerSyncEdgeFieldPolicy;
  };
  SchedulerSyncQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SchedulerSyncQLKeySpecifier
      | (() => undefined | SchedulerSyncQLKeySpecifier);
    fields?: SchedulerSyncQLFieldPolicy;
  };
  SendBroadcast?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SendBroadcastKeySpecifier
      | (() => undefined | SendBroadcastKeySpecifier);
    fields?: SendBroadcastFieldPolicy;
  };
  SendFeedbackActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SendFeedbackActionQLKeySpecifier
      | (() => undefined | SendFeedbackActionQLKeySpecifier);
    fields?: SendFeedbackActionQLFieldPolicy;
  };
  SendLoa?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SendLoaKeySpecifier
      | (() => undefined | SendLoaKeySpecifier);
    fields?: SendLoaFieldPolicy;
  };
  SendMessage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SendMessageKeySpecifier
      | (() => undefined | SendMessageKeySpecifier);
    fields?: SendMessageFieldPolicy;
  };
  SendMessageActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SendMessageActionQLKeySpecifier
      | (() => undefined | SendMessageActionQLKeySpecifier);
    fields?: SendMessageActionQLFieldPolicy;
  };
  SendReviewActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SendReviewActionQLKeySpecifier
      | (() => undefined | SendReviewActionQLKeySpecifier);
    fields?: SendReviewActionQLFieldPolicy;
  };
  SendReviewRequest?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SendReviewRequestKeySpecifier
      | (() => undefined | SendReviewRequestKeySpecifier);
    fields?: SendReviewRequestFieldPolicy;
  };
  SendScheduledMessageNow?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SendScheduledMessageNowKeySpecifier
      | (() => undefined | SendScheduledMessageNowKeySpecifier);
    fields?: SendScheduledMessageNowFieldPolicy;
  };
  SendStatusItemMessage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SendStatusItemMessageKeySpecifier
      | (() => undefined | SendStatusItemMessageKeySpecifier);
    fields?: SendStatusItemMessageFieldPolicy;
  };
  SendVCard?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SendVCardKeySpecifier
      | (() => undefined | SendVCardKeySpecifier);
    fields?: SendVCardFieldPolicy;
  };
  ServiceAdvisorQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ServiceAdvisorQLKeySpecifier
      | (() => undefined | ServiceAdvisorQLKeySpecifier);
    fields?: ServiceAdvisorQLFieldPolicy;
  };
  ServiceSubItemSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ServiceSubItemSummaryKeySpecifier
      | (() => undefined | ServiceSubItemSummaryKeySpecifier);
    fields?: ServiceSubItemSummaryFieldPolicy;
  };
  ServiceSummariesItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ServiceSummariesItemKeySpecifier
      | (() => undefined | ServiceSummariesItemKeySpecifier);
    fields?: ServiceSummariesItemFieldPolicy;
  };
  ServiceSummariesQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ServiceSummariesQLKeySpecifier
      | (() => undefined | ServiceSummariesQLKeySpecifier);
    fields?: ServiceSummariesQLFieldPolicy;
  };
  SetAssignmentRetention?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SetAssignmentRetentionKeySpecifier
      | (() => undefined | SetAssignmentRetentionKeySpecifier);
    fields?: SetAssignmentRetentionFieldPolicy;
  };
  SetBusinessTimezone?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SetBusinessTimezoneKeySpecifier
      | (() => undefined | SetBusinessTimezoneKeySpecifier);
    fields?: SetBusinessTimezoneFieldPolicy;
  };
  SetFortellisLookupId?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SetFortellisLookupIdKeySpecifier
      | (() => undefined | SetFortellisLookupIdKeySpecifier);
    fields?: SetFortellisLookupIdFieldPolicy;
  };
  SetHangupSuggestion?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SetHangupSuggestionKeySpecifier
      | (() => undefined | SetHangupSuggestionKeySpecifier);
    fields?: SetHangupSuggestionFieldPolicy;
  };
  SetOptInStatus?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SetOptInStatusKeySpecifier
      | (() => undefined | SetOptInStatusKeySpecifier);
    fields?: SetOptInStatusFieldPolicy;
  };
  SetResetOngoingOptin?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SetResetOngoingOptinKeySpecifier
      | (() => undefined | SetResetOngoingOptinKeySpecifier);
    fields?: SetResetOngoingOptinFieldPolicy;
  };
  SetResetOptinDays?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SetResetOptinDaysKeySpecifier
      | (() => undefined | SetResetOptinDaysKeySpecifier);
    fields?: SetResetOptinDaysFieldPolicy;
  };
  SetupEquityTradeOpportunityCampaign?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | SetupEquityTradeOpportunityCampaignKeySpecifier
      | (() => undefined | SetupEquityTradeOpportunityCampaignKeySpecifier);
    fields?: SetupEquityTradeOpportunityCampaignFieldPolicy;
  };
  ShortcutConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShortcutConnectionKeySpecifier
      | (() => undefined | ShortcutConnectionKeySpecifier);
    fields?: ShortcutConnectionFieldPolicy;
  };
  ShortcutEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShortcutEdgeKeySpecifier
      | (() => undefined | ShortcutEdgeKeySpecifier);
    fields?: ShortcutEdgeFieldPolicy;
  };
  ShortcutQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShortcutQLKeySpecifier
      | (() => undefined | ShortcutQLKeySpecifier);
    fields?: ShortcutQLFieldPolicy;
  };
  SkuConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SkuConnectionKeySpecifier
      | (() => undefined | SkuConnectionKeySpecifier);
    fields?: SkuConnectionFieldPolicy;
  };
  SkuEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SkuEdgeKeySpecifier
      | (() => undefined | SkuEdgeKeySpecifier);
    fields?: SkuEdgeFieldPolicy;
  };
  SkuEntitlementsQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SkuEntitlementsQLKeySpecifier
      | (() => undefined | SkuEntitlementsQLKeySpecifier);
    fields?: SkuEntitlementsQLFieldPolicy;
  };
  SkuQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SkuQLKeySpecifier
      | (() => undefined | SkuQLKeySpecifier);
    fields?: SkuQLFieldPolicy;
  };
  SmartTopicAttachment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SmartTopicAttachmentKeySpecifier
      | (() => undefined | SmartTopicAttachmentKeySpecifier);
    fields?: SmartTopicAttachmentFieldPolicy;
  };
  SmartTopicLinksQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SmartTopicLinksQLKeySpecifier
      | (() => undefined | SmartTopicLinksQLKeySpecifier);
    fields?: SmartTopicLinksQLFieldPolicy;
  };
  SmartTopicStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SmartTopicStepQLKeySpecifier
      | (() => undefined | SmartTopicStepQLKeySpecifier);
    fields?: SmartTopicStepQLFieldPolicy;
  };
  SmartTopicStepQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SmartTopicStepQLConnectionKeySpecifier
      | (() => undefined | SmartTopicStepQLConnectionKeySpecifier);
    fields?: SmartTopicStepQLConnectionFieldPolicy;
  };
  SmartTopicStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SmartTopicStepQLEdgeKeySpecifier
      | (() => undefined | SmartTopicStepQLEdgeKeySpecifier);
    fields?: SmartTopicStepQLEdgeFieldPolicy;
  };
  SnoozeConversation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SnoozeConversationKeySpecifier
      | (() => undefined | SnoozeConversationKeySpecifier);
    fields?: SnoozeConversationFieldPolicy;
  };
  SpeakStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SpeakStepQLKeySpecifier
      | (() => undefined | SpeakStepQLKeySpecifier);
    fields?: SpeakStepQLFieldPolicy;
  };
  SpeakStepQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SpeakStepQLConnectionKeySpecifier
      | (() => undefined | SpeakStepQLConnectionKeySpecifier);
    fields?: SpeakStepQLConnectionFieldPolicy;
  };
  SpeakStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SpeakStepQLEdgeKeySpecifier
      | (() => undefined | SpeakStepQLEdgeKeySpecifier);
    fields?: SpeakStepQLEdgeFieldPolicy;
  };
  SpecialQuestionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SpecialQuestionQLKeySpecifier
      | (() => undefined | SpecialQuestionQLKeySpecifier);
    fields?: SpecialQuestionQLFieldPolicy;
  };
  SpecialQuestionQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SpecialQuestionQLConnectionKeySpecifier
      | (() => undefined | SpecialQuestionQLConnectionKeySpecifier);
    fields?: SpecialQuestionQLConnectionFieldPolicy;
  };
  SpecialQuestionQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SpecialQuestionQLEdgeKeySpecifier
      | (() => undefined | SpecialQuestionQLEdgeKeySpecifier);
    fields?: SpecialQuestionQLEdgeFieldPolicy;
  };
  StaffMemberCallGoesPoorlyTriggerQL?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | StaffMemberCallGoesPoorlyTriggerQLKeySpecifier
      | (() => undefined | StaffMemberCallGoesPoorlyTriggerQLKeySpecifier);
    fields?: StaffMemberCallGoesPoorlyTriggerQLFieldPolicy;
  };
  StageQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StageQLKeySpecifier
      | (() => undefined | StageQLKeySpecifier);
    fields?: StageQLFieldPolicy;
  };
  StageQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StageQLConnectionKeySpecifier
      | (() => undefined | StageQLConnectionKeySpecifier);
    fields?: StageQLConnectionFieldPolicy;
  };
  StageQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StageQLEdgeKeySpecifier
      | (() => undefined | StageQLEdgeKeySpecifier);
    fields?: StageQLEdgeFieldPolicy;
  };
  StartConversation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StartConversationKeySpecifier
      | (() => undefined | StartConversationKeySpecifier);
    fields?: StartConversationFieldPolicy;
  };
  StartConversationWithScheduledMessage?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | StartConversationWithScheduledMessageKeySpecifier
      | (() => undefined | StartConversationWithScheduledMessageKeySpecifier);
    fields?: StartConversationWithScheduledMessageFieldPolicy;
  };
  StatusItemConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StatusItemConnectionKeySpecifier
      | (() => undefined | StatusItemConnectionKeySpecifier);
    fields?: StatusItemConnectionFieldPolicy;
  };
  StatusItemEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StatusItemEdgeKeySpecifier
      | (() => undefined | StatusItemEdgeKeySpecifier);
    fields?: StatusItemEdgeFieldPolicy;
  };
  StatusItemQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StatusItemQLKeySpecifier
      | (() => undefined | StatusItemQLKeySpecifier);
    fields?: StatusItemQLFieldPolicy;
  };
  StatusItemQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StatusItemQLConnectionKeySpecifier
      | (() => undefined | StatusItemQLConnectionKeySpecifier);
    fields?: StatusItemQLConnectionFieldPolicy;
  };
  StatusItemQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StatusItemQLEdgeKeySpecifier
      | (() => undefined | StatusItemQLEdgeKeySpecifier);
    fields?: StatusItemQLEdgeFieldPolicy;
  };
  StatusSummaryQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StatusSummaryQLKeySpecifier
      | (() => undefined | StatusSummaryQLKeySpecifier);
    fields?: StatusSummaryQLFieldPolicy;
  };
  StatusUpdaterStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StatusUpdaterStepQLKeySpecifier
      | (() => undefined | StatusUpdaterStepQLKeySpecifier);
    fields?: StatusUpdaterStepQLFieldPolicy;
  };
  StatusUpdaterStepQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StatusUpdaterStepQLConnectionKeySpecifier
      | (() => undefined | StatusUpdaterStepQLConnectionKeySpecifier);
    fields?: StatusUpdaterStepQLConnectionFieldPolicy;
  };
  StatusUpdaterStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StatusUpdaterStepQLEdgeKeySpecifier
      | (() => undefined | StatusUpdaterStepQLEdgeKeySpecifier);
    fields?: StatusUpdaterStepQLEdgeFieldPolicy;
  };
  StripeIntegrationQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StripeIntegrationQLKeySpecifier
      | (() => undefined | StripeIntegrationQLKeySpecifier);
    fields?: StripeIntegrationQLFieldPolicy;
  };
  StripeIntegrationQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StripeIntegrationQLConnectionKeySpecifier
      | (() => undefined | StripeIntegrationQLConnectionKeySpecifier);
    fields?: StripeIntegrationQLConnectionFieldPolicy;
  };
  StripeIntegrationQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StripeIntegrationQLEdgeKeySpecifier
      | (() => undefined | StripeIntegrationQLEdgeKeySpecifier);
    fields?: StripeIntegrationQLEdgeFieldPolicy;
  };
  Submit10DLCStarterProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | Submit10DLCStarterProfileKeySpecifier
      | (() => undefined | Submit10DLCStarterProfileKeySpecifier);
    fields?: Submit10DLCStarterProfileFieldPolicy;
  };
  SubmitBusinessIdentity?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SubmitBusinessIdentityKeySpecifier
      | (() => undefined | SubmitBusinessIdentityKeySpecifier);
    fields?: SubmitBusinessIdentityFieldPolicy;
  };
  SubscriptionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SubscriptionQLKeySpecifier
      | (() => undefined | SubscriptionQLKeySpecifier);
    fields?: SubscriptionQLFieldPolicy;
  };
  SubscriptionQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SubscriptionQLConnectionKeySpecifier
      | (() => undefined | SubscriptionQLConnectionKeySpecifier);
    fields?: SubscriptionQLConnectionFieldPolicy;
  };
  SubscriptionQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SubscriptionQLEdgeKeySpecifier
      | (() => undefined | SubscriptionQLEdgeKeySpecifier);
    fields?: SubscriptionQLEdgeFieldPolicy;
  };
  SummarizeConversationActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SummarizeConversationActionQLKeySpecifier
      | (() => undefined | SummarizeConversationActionQLKeySpecifier);
    fields?: SummarizeConversationActionQLFieldPolicy;
  };
  SupportedVehiclesConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SupportedVehiclesConnectionKeySpecifier
      | (() => undefined | SupportedVehiclesConnectionKeySpecifier);
    fields?: SupportedVehiclesConnectionFieldPolicy;
  };
  SupportedVehiclesEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SupportedVehiclesEdgeKeySpecifier
      | (() => undefined | SupportedVehiclesEdgeKeySpecifier);
    fields?: SupportedVehiclesEdgeFieldPolicy;
  };
  SupportedVehiclesOpcodesQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SupportedVehiclesOpcodesQLKeySpecifier
      | (() => undefined | SupportedVehiclesOpcodesQLKeySpecifier);
    fields?: SupportedVehiclesOpcodesQLFieldPolicy;
  };
  SupportedVehiclesOpcodesQLConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | SupportedVehiclesOpcodesQLConnectionKeySpecifier
      | (() => undefined | SupportedVehiclesOpcodesQLConnectionKeySpecifier);
    fields?: SupportedVehiclesOpcodesQLConnectionFieldPolicy;
  };
  SupportedVehiclesOpcodesQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SupportedVehiclesOpcodesQLEdgeKeySpecifier
      | (() => undefined | SupportedVehiclesOpcodesQLEdgeKeySpecifier);
    fields?: SupportedVehiclesOpcodesQLEdgeFieldPolicy;
  };
  SupportedVehiclesQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SupportedVehiclesQLKeySpecifier
      | (() => undefined | SupportedVehiclesQLKeySpecifier);
    fields?: SupportedVehiclesQLFieldPolicy;
  };
  SurveyAnsweredTriggerQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SurveyAnsweredTriggerQLKeySpecifier
      | (() => undefined | SurveyAnsweredTriggerQLKeySpecifier);
    fields?: SurveyAnsweredTriggerQLFieldPolicy;
  };
  SurveyAnsweredUpdateFilter?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SurveyAnsweredUpdateFilterKeySpecifier
      | (() => undefined | SurveyAnsweredUpdateFilterKeySpecifier);
    fields?: SurveyAnsweredUpdateFilterFieldPolicy;
  };
  SyncXtimeServices?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SyncXtimeServicesKeySpecifier
      | (() => undefined | SyncXtimeServicesKeySpecifier);
    fields?: SyncXtimeServicesFieldPolicy;
  };
  SystemMessageSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SystemMessageSettingsKeySpecifier
      | (() => undefined | SystemMessageSettingsKeySpecifier);
    fields?: SystemMessageSettingsFieldPolicy;
  };
  TaskActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TaskActionQLKeySpecifier
      | (() => undefined | TaskActionQLKeySpecifier);
    fields?: TaskActionQLFieldPolicy;
  };
  TaskQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TaskQLKeySpecifier
      | (() => undefined | TaskQLKeySpecifier);
    fields?: TaskQLFieldPolicy;
  };
  TeachNuma?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TeachNumaKeySpecifier
      | (() => undefined | TeachNumaKeySpecifier);
    fields?: TeachNumaFieldPolicy;
  };
  TeamConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TeamConnectionKeySpecifier
      | (() => undefined | TeamConnectionKeySpecifier);
    fields?: TeamConnectionFieldPolicy;
  };
  TeamEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TeamEdgeKeySpecifier
      | (() => undefined | TeamEdgeKeySpecifier);
    fields?: TeamEdgeFieldPolicy;
  };
  TeamQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TeamQLKeySpecifier
      | (() => undefined | TeamQLKeySpecifier);
    fields?: TeamQLFieldPolicy;
  };
  TeamQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TeamQLConnectionKeySpecifier
      | (() => undefined | TeamQLConnectionKeySpecifier);
    fields?: TeamQLConnectionFieldPolicy;
  };
  TeamQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TeamQLEdgeKeySpecifier
      | (() => undefined | TeamQLEdgeKeySpecifier);
    fields?: TeamQLEdgeFieldPolicy;
  };
  TenDLCProcessQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TenDLCProcessQLKeySpecifier
      | (() => undefined | TenDLCProcessQLKeySpecifier);
    fields?: TenDLCProcessQLFieldPolicy;
  };
  TenDLCStatusQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TenDLCStatusQLKeySpecifier
      | (() => undefined | TenDLCStatusQLKeySpecifier);
    fields?: TenDLCStatusQLFieldPolicy;
  };
  TextGenerationChatMessageQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TextGenerationChatMessageQLKeySpecifier
      | (() => undefined | TextGenerationChatMessageQLKeySpecifier);
    fields?: TextGenerationChatMessageQLFieldPolicy;
  };
  TextGenerationQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TextGenerationQLKeySpecifier
      | (() => undefined | TextGenerationQLKeySpecifier);
    fields?: TextGenerationQLFieldPolicy;
  };
  TextOptinStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TextOptinStepQLKeySpecifier
      | (() => undefined | TextOptinStepQLKeySpecifier);
    fields?: TextOptinStepQLFieldPolicy;
  };
  TextOptinStepQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TextOptinStepQLConnectionKeySpecifier
      | (() => undefined | TextOptinStepQLConnectionKeySpecifier);
    fields?: TextOptinStepQLConnectionFieldPolicy;
  };
  TextOptinStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TextOptinStepQLEdgeKeySpecifier
      | (() => undefined | TextOptinStepQLEdgeKeySpecifier);
    fields?: TextOptinStepQLEdgeFieldPolicy;
  };
  ToggleCustomPhoneLinePolicy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ToggleCustomPhoneLinePolicyKeySpecifier
      | (() => undefined | ToggleCustomPhoneLinePolicyKeySpecifier);
    fields?: ToggleCustomPhoneLinePolicyFieldPolicy;
  };
  ToggleOutboundProxyCallRecording?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ToggleOutboundProxyCallRecordingKeySpecifier
      | (() => undefined | ToggleOutboundProxyCallRecordingKeySpecifier);
    fields?: ToggleOutboundProxyCallRecordingFieldPolicy;
  };
  TranscriptAnalysisQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TranscriptAnalysisQLKeySpecifier
      | (() => undefined | TranscriptAnalysisQLKeySpecifier);
    fields?: TranscriptAnalysisQLFieldPolicy;
  };
  TranscriptEventQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TranscriptEventQLKeySpecifier
      | (() => undefined | TranscriptEventQLKeySpecifier);
    fields?: TranscriptEventQLFieldPolicy;
  };
  TranscriptQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TranscriptQLKeySpecifier
      | (() => undefined | TranscriptQLKeySpecifier);
    fields?: TranscriptQLFieldPolicy;
  };
  TranscriptQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TranscriptQLConnectionKeySpecifier
      | (() => undefined | TranscriptQLConnectionKeySpecifier);
    fields?: TranscriptQLConnectionFieldPolicy;
  };
  TranscriptQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TranscriptQLEdgeKeySpecifier
      | (() => undefined | TranscriptQLEdgeKeySpecifier);
    fields?: TranscriptQLEdgeFieldPolicy;
  };
  TranscriptScoreQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TranscriptScoreQLKeySpecifier
      | (() => undefined | TranscriptScoreQLKeySpecifier);
    fields?: TranscriptScoreQLFieldPolicy;
  };
  TranscriptSectionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TranscriptSectionQLKeySpecifier
      | (() => undefined | TranscriptSectionQLKeySpecifier);
    fields?: TranscriptSectionQLFieldPolicy;
  };
  TranslatedMessage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TranslatedMessageKeySpecifier
      | (() => undefined | TranslatedMessageKeySpecifier);
    fields?: TranslatedMessageFieldPolicy;
  };
  TransportationSetOptionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TransportationSetOptionQLKeySpecifier
      | (() => undefined | TransportationSetOptionQLKeySpecifier);
    fields?: TransportationSetOptionQLFieldPolicy;
  };
  TransportationSetQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TransportationSetQLKeySpecifier
      | (() => undefined | TransportationSetQLKeySpecifier);
    fields?: TransportationSetQLFieldPolicy;
  };
  TransportationSetQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TransportationSetQLConnectionKeySpecifier
      | (() => undefined | TransportationSetQLConnectionKeySpecifier);
    fields?: TransportationSetQLConnectionFieldPolicy;
  };
  TransportationSetQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TransportationSetQLEdgeKeySpecifier
      | (() => undefined | TransportationSetQLEdgeKeySpecifier);
    fields?: TransportationSetQLEdgeFieldPolicy;
  };
  TransportationSetRepairServiceQL?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | TransportationSetRepairServiceQLKeySpecifier
      | (() => undefined | TransportationSetRepairServiceQLKeySpecifier);
    fields?: TransportationSetRepairServiceQLFieldPolicy;
  };
  TransportationSetRepairServiceQLConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | TransportationSetRepairServiceQLConnectionKeySpecifier
      | (() =>
          | undefined
          | TransportationSetRepairServiceQLConnectionKeySpecifier);
    fields?: TransportationSetRepairServiceQLConnectionFieldPolicy;
  };
  TransportationSetRepairServiceQLEdge?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | TransportationSetRepairServiceQLEdgeKeySpecifier
      | (() => undefined | TransportationSetRepairServiceQLEdgeKeySpecifier);
    fields?: TransportationSetRepairServiceQLEdgeFieldPolicy;
  };
  TwilioA2PCampaignQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TwilioA2PCampaignQLKeySpecifier
      | (() => undefined | TwilioA2PCampaignQLKeySpecifier);
    fields?: TwilioA2PCampaignQLFieldPolicy;
  };
  TwilioBrandRegistrationQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TwilioBrandRegistrationQLKeySpecifier
      | (() => undefined | TwilioBrandRegistrationQLKeySpecifier);
    fields?: TwilioBrandRegistrationQLFieldPolicy;
  };
  TwilioChannelQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TwilioChannelQLKeySpecifier
      | (() => undefined | TwilioChannelQLKeySpecifier);
    fields?: TwilioChannelQLFieldPolicy;
  };
  TwilioChannelQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TwilioChannelQLConnectionKeySpecifier
      | (() => undefined | TwilioChannelQLConnectionKeySpecifier);
    fields?: TwilioChannelQLConnectionFieldPolicy;
  };
  TwilioChannelQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TwilioChannelQLEdgeKeySpecifier
      | (() => undefined | TwilioChannelQLEdgeKeySpecifier);
    fields?: TwilioChannelQLEdgeFieldPolicy;
  };
  TwilioTrustProductError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TwilioTrustProductErrorKeySpecifier
      | (() => undefined | TwilioTrustProductErrorKeySpecifier);
    fields?: TwilioTrustProductErrorFieldPolicy;
  };
  TwilioTrustProductQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TwilioTrustProductQLKeySpecifier
      | (() => undefined | TwilioTrustProductQLKeySpecifier);
    fields?: TwilioTrustProductQLFieldPolicy;
  };
  TypingIndicatorQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TypingIndicatorQLKeySpecifier
      | (() => undefined | TypingIndicatorQLKeySpecifier);
    fields?: TypingIndicatorQLFieldPolicy;
  };
  UnmapCrmUserFromUser?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UnmapCrmUserFromUserKeySpecifier
      | (() => undefined | UnmapCrmUserFromUserKeySpecifier);
    fields?: UnmapCrmUserFromUserFieldPolicy;
  };
  UpdateActiveIntegration?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateActiveIntegrationKeySpecifier
      | (() => undefined | UpdateActiveIntegrationKeySpecifier);
    fields?: UpdateActiveIntegrationFieldPolicy;
  };
  UpdateAgentChitChat?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAgentChitChatKeySpecifier
      | (() => undefined | UpdateAgentChitChatKeySpecifier);
    fields?: UpdateAgentChitChatFieldPolicy;
  };
  UpdateAnsweringScriptOrder?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAnsweringScriptOrderKeySpecifier
      | (() => undefined | UpdateAnsweringScriptOrderKeySpecifier);
    fields?: UpdateAnsweringScriptOrderFieldPolicy;
  };
  UpdateAppointment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAppointmentKeySpecifier
      | (() => undefined | UpdateAppointmentKeySpecifier);
    fields?: UpdateAppointmentFieldPolicy;
  };
  UpdateAppointmentAgentSettingLabel?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpdateAppointmentAgentSettingLabelKeySpecifier
      | (() => undefined | UpdateAppointmentAgentSettingLabelKeySpecifier);
    fields?: UpdateAppointmentAgentSettingLabelFieldPolicy;
  };
  UpdateAppointmentAgentSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAppointmentAgentSettingsKeySpecifier
      | (() => undefined | UpdateAppointmentAgentSettingsKeySpecifier);
    fields?: UpdateAppointmentAgentSettingsFieldPolicy;
  };
  UpdateAssignmentRoutingSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAssignmentRoutingSettingsKeySpecifier
      | (() => undefined | UpdateAssignmentRoutingSettingsKeySpecifier);
    fields?: UpdateAssignmentRoutingSettingsFieldPolicy;
  };
  UpdateAutomation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAutomationKeySpecifier
      | (() => undefined | UpdateAutomationKeySpecifier);
    fields?: UpdateAutomationFieldPolicy;
  };
  UpdateAutomationAction?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAutomationActionKeySpecifier
      | (() => undefined | UpdateAutomationActionKeySpecifier);
    fields?: UpdateAutomationActionFieldPolicy;
  };
  UpdateAutomationEnrollmentCriteria?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpdateAutomationEnrollmentCriteriaKeySpecifier
      | (() => undefined | UpdateAutomationEnrollmentCriteriaKeySpecifier);
    fields?: UpdateAutomationEnrollmentCriteriaFieldPolicy;
  };
  UpdateAutomationExitTrigger?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAutomationExitTriggerKeySpecifier
      | (() => undefined | UpdateAutomationExitTriggerKeySpecifier);
    fields?: UpdateAutomationExitTriggerFieldPolicy;
  };
  UpdateAutomationStartTrigger?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAutomationStartTriggerKeySpecifier
      | (() => undefined | UpdateAutomationStartTriggerKeySpecifier);
    fields?: UpdateAutomationStartTriggerFieldPolicy;
  };
  UpdateAutomationUIHints?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAutomationUIHintsKeySpecifier
      | (() => undefined | UpdateAutomationUIHintsKeySpecifier);
    fields?: UpdateAutomationUIHintsFieldPolicy;
  };
  UpdateAutopilotEta?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAutopilotEtaKeySpecifier
      | (() => undefined | UpdateAutopilotEtaKeySpecifier);
    fields?: UpdateAutopilotEtaFieldPolicy;
  };
  UpdateAutopilotJob?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAutopilotJobKeySpecifier
      | (() => undefined | UpdateAutopilotJobKeySpecifier);
    fields?: UpdateAutopilotJobFieldPolicy;
  };
  UpdateAutopilotScheduledMessage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAutopilotScheduledMessageKeySpecifier
      | (() => undefined | UpdateAutopilotScheduledMessageKeySpecifier);
    fields?: UpdateAutopilotScheduledMessageFieldPolicy;
  };
  UpdateAvailableIntegration?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAvailableIntegrationKeySpecifier
      | (() => undefined | UpdateAvailableIntegrationKeySpecifier);
    fields?: UpdateAvailableIntegrationFieldPolicy;
  };
  UpdateAwayMode?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAwayModeKeySpecifier
      | (() => undefined | UpdateAwayModeKeySpecifier);
    fields?: UpdateAwayModeFieldPolicy;
  };
  UpdateAwayModeAssignee?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAwayModeAssigneeKeySpecifier
      | (() => undefined | UpdateAwayModeAssigneeKeySpecifier);
    fields?: UpdateAwayModeAssigneeFieldPolicy;
  };
  UpdateAwayModeManagingPermission?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpdateAwayModeManagingPermissionKeySpecifier
      | (() => undefined | UpdateAwayModeManagingPermissionKeySpecifier);
    fields?: UpdateAwayModeManagingPermissionFieldPolicy;
  };
  UpdateAwayModeWithTime?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateAwayModeWithTimeKeySpecifier
      | (() => undefined | UpdateAwayModeWithTimeKeySpecifier);
    fields?: UpdateAwayModeWithTimeFieldPolicy;
  };
  UpdateBillingMetadata?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateBillingMetadataKeySpecifier
      | (() => undefined | UpdateBillingMetadataKeySpecifier);
    fields?: UpdateBillingMetadataFieldPolicy;
  };
  UpdateBrandLogo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateBrandLogoKeySpecifier
      | (() => undefined | UpdateBrandLogoKeySpecifier);
    fields?: UpdateBrandLogoFieldPolicy;
  };
  UpdateBrandTheme?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateBrandThemeKeySpecifier
      | (() => undefined | UpdateBrandThemeKeySpecifier);
    fields?: UpdateBrandThemeFieldPolicy;
  };
  UpdateBusinessIdentity?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateBusinessIdentityKeySpecifier
      | (() => undefined | UpdateBusinessIdentityKeySpecifier);
    fields?: UpdateBusinessIdentityFieldPolicy;
  };
  UpdateBusinessProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateBusinessProfileKeySpecifier
      | (() => undefined | UpdateBusinessProfileKeySpecifier);
    fields?: UpdateBusinessProfileFieldPolicy;
  };
  UpdateCallForwardingStatus?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateCallForwardingStatusKeySpecifier
      | (() => undefined | UpdateCallForwardingStatusKeySpecifier);
    fields?: UpdateCallForwardingStatusFieldPolicy;
  };
  UpdateCallIntelligenceEnabled?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateCallIntelligenceEnabledKeySpecifier
      | (() => undefined | UpdateCallIntelligenceEnabledKeySpecifier);
    fields?: UpdateCallIntelligenceEnabledFieldPolicy;
  };
  UpdateCallIntelligenceSetting?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateCallIntelligenceSettingKeySpecifier
      | (() => undefined | UpdateCallIntelligenceSettingKeySpecifier);
    fields?: UpdateCallIntelligenceSettingFieldPolicy;
  };
  UpdateCampaignStatus?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateCampaignStatusKeySpecifier
      | (() => undefined | UpdateCampaignStatusKeySpecifier);
    fields?: UpdateCampaignStatusFieldPolicy;
  };
  UpdateCampaignStatusResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateCampaignStatusResultKeySpecifier
      | (() => undefined | UpdateCampaignStatusResultKeySpecifier);
    fields?: UpdateCampaignStatusResultFieldPolicy;
  };
  UpdateChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateChannelKeySpecifier
      | (() => undefined | UpdateChannelKeySpecifier);
    fields?: UpdateChannelFieldPolicy;
  };
  UpdateComplianceSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateComplianceSettingsKeySpecifier
      | (() => undefined | UpdateComplianceSettingsKeySpecifier);
    fields?: UpdateComplianceSettingsFieldPolicy;
  };
  UpdateConversationLabel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateConversationLabelKeySpecifier
      | (() => undefined | UpdateConversationLabelKeySpecifier);
    fields?: UpdateConversationLabelFieldPolicy;
  };
  UpdateConversations?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateConversationsKeySpecifier
      | (() => undefined | UpdateConversationsKeySpecifier);
    fields?: UpdateConversationsFieldPolicy;
  };
  UpdateCurbsideSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateCurbsideSettingsKeySpecifier
      | (() => undefined | UpdateCurbsideSettingsKeySpecifier);
    fields?: UpdateCurbsideSettingsFieldPolicy;
  };
  UpdateCustomDirectoryEntry?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateCustomDirectoryEntryKeySpecifier
      | (() => undefined | UpdateCustomDirectoryEntryKeySpecifier);
    fields?: UpdateCustomDirectoryEntryFieldPolicy;
  };
  UpdateDefaultView?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateDefaultViewKeySpecifier
      | (() => undefined | UpdateDefaultViewKeySpecifier);
    fields?: UpdateDefaultViewFieldPolicy;
  };
  UpdateDefaultYouView?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateDefaultYouViewKeySpecifier
      | (() => undefined | UpdateDefaultYouViewKeySpecifier);
    fields?: UpdateDefaultYouViewFieldPolicy;
  };
  UpdateDepartmentDevice?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateDepartmentDeviceKeySpecifier
      | (() => undefined | UpdateDepartmentDeviceKeySpecifier);
    fields?: UpdateDepartmentDeviceFieldPolicy;
  };
  UpdateDirectoryEntry?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateDirectoryEntryKeySpecifier
      | (() => undefined | UpdateDirectoryEntryKeySpecifier);
    fields?: UpdateDirectoryEntryFieldPolicy;
  };
  UpdateETOSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateETOSettingsKeySpecifier
      | (() => undefined | UpdateETOSettingsKeySpecifier);
    fields?: UpdateETOSettingsFieldPolicy;
  };
  UpdateEdgesVoiceStep?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateEdgesVoiceStepKeySpecifier
      | (() => undefined | UpdateEdgesVoiceStepKeySpecifier);
    fields?: UpdateEdgesVoiceStepFieldPolicy;
  };
  UpdateEquityTradeOpportunityStage?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpdateEquityTradeOpportunityStageKeySpecifier
      | (() => undefined | UpdateEquityTradeOpportunityStageKeySpecifier);
    fields?: UpdateEquityTradeOpportunityStageFieldPolicy;
  };
  UpdateEscalationSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateEscalationSettingsKeySpecifier
      | (() => undefined | UpdateEscalationSettingsKeySpecifier);
    fields?: UpdateEscalationSettingsFieldPolicy;
  };
  UpdateGreeting?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateGreetingKeySpecifier
      | (() => undefined | UpdateGreetingKeySpecifier);
    fields?: UpdateGreetingFieldPolicy;
  };
  UpdateHasDismissedGuideChecklist?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpdateHasDismissedGuideChecklistKeySpecifier
      | (() => undefined | UpdateHasDismissedGuideChecklistKeySpecifier);
    fields?: UpdateHasDismissedGuideChecklistFieldPolicy;
  };
  UpdateHasViewedRefer?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateHasViewedReferKeySpecifier
      | (() => undefined | UpdateHasViewedReferKeySpecifier);
    fields?: UpdateHasViewedReferFieldPolicy;
  };
  UpdateHideSharedInboxViews?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateHideSharedInboxViewsKeySpecifier
      | (() => undefined | UpdateHideSharedInboxViewsKeySpecifier);
    fields?: UpdateHideSharedInboxViewsFieldPolicy;
  };
  UpdateHostedSms?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateHostedSmsKeySpecifier
      | (() => undefined | UpdateHostedSmsKeySpecifier);
    fields?: UpdateHostedSmsFieldPolicy;
  };
  UpdateIsScheduleEnabled?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateIsScheduleEnabledKeySpecifier
      | (() => undefined | UpdateIsScheduleEnabledKeySpecifier);
    fields?: UpdateIsScheduleEnabledFieldPolicy;
  };
  UpdateIsUnassigningInboundMessages?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpdateIsUnassigningInboundMessagesKeySpecifier
      | (() => undefined | UpdateIsUnassigningInboundMessagesKeySpecifier);
    fields?: UpdateIsUnassigningInboundMessagesFieldPolicy;
  };
  UpdateLabel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateLabelKeySpecifier
      | (() => undefined | UpdateLabelKeySpecifier);
    fields?: UpdateLabelFieldPolicy;
  };
  UpdateLanguageSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateLanguageSettingsKeySpecifier
      | (() => undefined | UpdateLanguageSettingsKeySpecifier);
    fields?: UpdateLanguageSettingsFieldPolicy;
  };
  UpdateLink?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateLinkKeySpecifier
      | (() => undefined | UpdateLinkKeySpecifier);
    fields?: UpdateLinkFieldPolicy;
  };
  UpdateLinkUrls?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateLinkUrlsKeySpecifier
      | (() => undefined | UpdateLinkUrlsKeySpecifier);
    fields?: UpdateLinkUrlsFieldPolicy;
  };
  UpdateLoggedCall?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateLoggedCallKeySpecifier
      | (() => undefined | UpdateLoggedCallKeySpecifier);
    fields?: UpdateLoggedCallFieldPolicy;
  };
  UpdateLogos?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateLogosKeySpecifier
      | (() => undefined | UpdateLogosKeySpecifier);
    fields?: UpdateLogosFieldPolicy;
  };
  UpdateMissedCallFollowUpSetting?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateMissedCallFollowUpSettingKeySpecifier
      | (() => undefined | UpdateMissedCallFollowUpSettingKeySpecifier);
    fields?: UpdateMissedCallFollowUpSettingFieldPolicy;
  };
  UpdateNamePronunciation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateNamePronunciationKeySpecifier
      | (() => undefined | UpdateNamePronunciationKeySpecifier);
    fields?: UpdateNamePronunciationFieldPolicy;
  };
  UpdateNewConversationsPerDay?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateNewConversationsPerDayKeySpecifier
      | (() => undefined | UpdateNewConversationsPerDayKeySpecifier);
    fields?: UpdateNewConversationsPerDayFieldPolicy;
  };
  UpdateOperator?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateOperatorKeySpecifier
      | (() => undefined | UpdateOperatorKeySpecifier);
    fields?: UpdateOperatorFieldPolicy;
  };
  UpdateOperatorChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateOperatorChannelKeySpecifier
      | (() => undefined | UpdateOperatorChannelKeySpecifier);
    fields?: UpdateOperatorChannelFieldPolicy;
  };
  UpdateOperatorPlaceDescription?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateOperatorPlaceDescriptionKeySpecifier
      | (() => undefined | UpdateOperatorPlaceDescriptionKeySpecifier);
    fields?: UpdateOperatorPlaceDescriptionFieldPolicy;
  };
  UpdateOperatorPlaceSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateOperatorPlaceSettingsKeySpecifier
      | (() => undefined | UpdateOperatorPlaceSettingsKeySpecifier);
    fields?: UpdateOperatorPlaceSettingsFieldPolicy;
  };
  UpdateOperatorSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateOperatorSettingsKeySpecifier
      | (() => undefined | UpdateOperatorSettingsKeySpecifier);
    fields?: UpdateOperatorSettingsFieldPolicy;
  };
  UpdateOpportunityActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateOpportunityActionQLKeySpecifier
      | (() => undefined | UpdateOpportunityActionQLKeySpecifier);
    fields?: UpdateOpportunityActionQLFieldPolicy;
  };
  UpdateOutboundCallCustomization?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateOutboundCallCustomizationKeySpecifier
      | (() => undefined | UpdateOutboundCallCustomizationKeySpecifier);
    fields?: UpdateOutboundCallCustomizationFieldPolicy;
  };
  UpdateOutboundConferenceCall?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateOutboundConferenceCallKeySpecifier
      | (() => undefined | UpdateOutboundConferenceCallKeySpecifier);
    fields?: UpdateOutboundConferenceCallFieldPolicy;
  };
  UpdateParticipant?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateParticipantKeySpecifier
      | (() => undefined | UpdateParticipantKeySpecifier);
    fields?: UpdateParticipantFieldPolicy;
  };
  UpdatePaymentRequestAttachment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePaymentRequestAttachmentKeySpecifier
      | (() => undefined | UpdatePaymentRequestAttachmentKeySpecifier);
    fields?: UpdatePaymentRequestAttachmentFieldPolicy;
  };
  UpdatePaymentRequestCustomization?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpdatePaymentRequestCustomizationKeySpecifier
      | (() => undefined | UpdatePaymentRequestCustomizationKeySpecifier);
    fields?: UpdatePaymentRequestCustomizationFieldPolicy;
  };
  UpdatePhoneCall?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePhoneCallKeySpecifier
      | (() => undefined | UpdatePhoneCallKeySpecifier);
    fields?: UpdatePhoneCallFieldPolicy;
  };
  UpdatePhoneLine?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePhoneLineKeySpecifier
      | (() => undefined | UpdatePhoneLineKeySpecifier);
    fields?: UpdatePhoneLineFieldPolicy;
  };
  UpdatePhoneLineLanguageSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePhoneLineLanguageSettingsKeySpecifier
      | (() => undefined | UpdatePhoneLineLanguageSettingsKeySpecifier);
    fields?: UpdatePhoneLineLanguageSettingsFieldPolicy;
  };
  UpdatePhoneLineName?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePhoneLineNameKeySpecifier
      | (() => undefined | UpdatePhoneLineNameKeySpecifier);
    fields?: UpdatePhoneLineNameFieldPolicy;
  };
  UpdatePhoneLinePolicy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePhoneLinePolicyKeySpecifier
      | (() => undefined | UpdatePhoneLinePolicyKeySpecifier);
    fields?: UpdatePhoneLinePolicyFieldPolicy;
  };
  UpdatePlaceDisruptionSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePlaceDisruptionSettingsKeySpecifier
      | (() => undefined | UpdatePlaceDisruptionSettingsKeySpecifier);
    fields?: UpdatePlaceDisruptionSettingsFieldPolicy;
  };
  UpdatePlaceGroup?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePlaceGroupKeySpecifier
      | (() => undefined | UpdatePlaceGroupKeySpecifier);
    fields?: UpdatePlaceGroupFieldPolicy;
  };
  UpdatePlaceInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePlaceInfoKeySpecifier
      | (() => undefined | UpdatePlaceInfoKeySpecifier);
    fields?: UpdatePlaceInfoFieldPolicy;
  };
  UpdatePlaceMFASettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePlaceMFASettingsKeySpecifier
      | (() => undefined | UpdatePlaceMFASettingsKeySpecifier);
    fields?: UpdatePlaceMFASettingsFieldPolicy;
  };
  UpdatePlaceMessageSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePlaceMessageSettingsKeySpecifier
      | (() => undefined | UpdatePlaceMessageSettingsKeySpecifier);
    fields?: UpdatePlaceMessageSettingsFieldPolicy;
  };
  UpdatePlaceOutboundCallSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePlaceOutboundCallSettingsKeySpecifier
      | (() => undefined | UpdatePlaceOutboundCallSettingsKeySpecifier);
    fields?: UpdatePlaceOutboundCallSettingsFieldPolicy;
  };
  UpdatePlaceQuota?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePlaceQuotaKeySpecifier
      | (() => undefined | UpdatePlaceQuotaKeySpecifier);
    fields?: UpdatePlaceQuotaFieldPolicy;
  };
  UpdatePlaceStatus?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePlaceStatusKeySpecifier
      | (() => undefined | UpdatePlaceStatusKeySpecifier);
    fields?: UpdatePlaceStatusFieldPolicy;
  };
  UpdatePlaceVoice?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePlaceVoiceKeySpecifier
      | (() => undefined | UpdatePlaceVoiceKeySpecifier);
    fields?: UpdatePlaceVoiceFieldPolicy;
  };
  UpdatePublicListing?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePublicListingKeySpecifier
      | (() => undefined | UpdatePublicListingKeySpecifier);
    fields?: UpdatePublicListingFieldPolicy;
  };
  UpdateQuestionAgentSettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateQuestionAgentSettingsKeySpecifier
      | (() => undefined | UpdateQuestionAgentSettingsKeySpecifier);
    fields?: UpdateQuestionAgentSettingsFieldPolicy;
  };
  UpdateReceivesEscalations?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateReceivesEscalationsKeySpecifier
      | (() => undefined | UpdateReceivesEscalationsKeySpecifier);
    fields?: UpdateReceivesEscalationsFieldPolicy;
  };
  UpdateRepairServicesOpCodes?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateRepairServicesOpCodesKeySpecifier
      | (() => undefined | UpdateRepairServicesOpCodesKeySpecifier);
    fields?: UpdateRepairServicesOpCodesFieldPolicy;
  };
  UpdateReviewJob?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateReviewJobKeySpecifier
      | (() => undefined | UpdateReviewJobKeySpecifier);
    fields?: UpdateReviewJobFieldPolicy;
  };
  UpdateServiceAdvisor?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateServiceAdvisorKeySpecifier
      | (() => undefined | UpdateServiceAdvisorKeySpecifier);
    fields?: UpdateServiceAdvisorFieldPolicy;
  };
  UpdateServiceOverride?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateServiceOverrideKeySpecifier
      | (() => undefined | UpdateServiceOverrideKeySpecifier);
    fields?: UpdateServiceOverrideFieldPolicy;
  };
  UpdateShortcut?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateShortcutKeySpecifier
      | (() => undefined | UpdateShortcutKeySpecifier);
    fields?: UpdateShortcutFieldPolicy;
  };
  UpdateShowBannerAfter?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateShowBannerAfterKeySpecifier
      | (() => undefined | UpdateShowBannerAfterKeySpecifier);
    fields?: UpdateShowBannerAfterFieldPolicy;
  };
  UpdateStage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateStageKeySpecifier
      | (() => undefined | UpdateStageKeySpecifier);
    fields?: UpdateStageFieldPolicy;
  };
  UpdateStatusBoardView?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateStatusBoardViewKeySpecifier
      | (() => undefined | UpdateStatusBoardViewKeySpecifier);
    fields?: UpdateStatusBoardViewFieldPolicy;
  };
  UpdateStatusItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateStatusItemKeySpecifier
      | (() => undefined | UpdateStatusItemKeySpecifier);
    fields?: UpdateStatusItemFieldPolicy;
  };
  UpdateTeam?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateTeamKeySpecifier
      | (() => undefined | UpdateTeamKeySpecifier);
    fields?: UpdateTeamFieldPolicy;
  };
  UpdateTransportationSet?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateTransportationSetKeySpecifier
      | (() => undefined | UpdateTransportationSetKeySpecifier);
    fields?: UpdateTransportationSetFieldPolicy;
  };
  UpdateTwilioChannel?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateTwilioChannelKeySpecifier
      | (() => undefined | UpdateTwilioChannelKeySpecifier);
    fields?: UpdateTwilioChannelFieldPolicy;
  };
  UpdateUseNewNumber?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateUseNewNumberKeySpecifier
      | (() => undefined | UpdateUseNewNumberKeySpecifier);
    fields?: UpdateUseNewNumberFieldPolicy;
  };
  UpdateUser?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateUserKeySpecifier
      | (() => undefined | UpdateUserKeySpecifier);
    fields?: UpdateUserFieldPolicy;
  };
  UpdateUserInformation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateUserInformationKeySpecifier
      | (() => undefined | UpdateUserInformationKeySpecifier);
    fields?: UpdateUserInformationFieldPolicy;
  };
  UpdateUserMFASettings?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateUserMFASettingsKeySpecifier
      | (() => undefined | UpdateUserMFASettingsKeySpecifier);
    fields?: UpdateUserMFASettingsFieldPolicy;
  };
  UpdateUserPersonalization?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateUserPersonalizationKeySpecifier
      | (() => undefined | UpdateUserPersonalizationKeySpecifier);
    fields?: UpdateUserPersonalizationFieldPolicy;
  };
  UpdateUserPhone?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateUserPhoneKeySpecifier
      | (() => undefined | UpdateUserPhoneKeySpecifier);
    fields?: UpdateUserPhoneFieldPolicy;
  };
  UpdateUserPhonePreference?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateUserPhonePreferenceKeySpecifier
      | (() => undefined | UpdateUserPhonePreferenceKeySpecifier);
    fields?: UpdateUserPhonePreferenceFieldPolicy;
  };
  UpdateUserSchedule?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateUserScheduleKeySpecifier
      | (() => undefined | UpdateUserScheduleKeySpecifier);
    fields?: UpdateUserScheduleFieldPolicy;
  };
  UpdateUserViewPreferences?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateUserViewPreferencesKeySpecifier
      | (() => undefined | UpdateUserViewPreferencesKeySpecifier);
    fields?: UpdateUserViewPreferencesFieldPolicy;
  };
  UpdateVideoUploadLink?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateVideoUploadLinkKeySpecifier
      | (() => undefined | UpdateVideoUploadLinkKeySpecifier);
    fields?: UpdateVideoUploadLinkFieldPolicy;
  };
  UpdateVoiceScript?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateVoiceScriptKeySpecifier
      | (() => undefined | UpdateVoiceScriptKeySpecifier);
    fields?: UpdateVoiceScriptFieldPolicy;
  };
  UpdateVoiceStep?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateVoiceStepKeySpecifier
      | (() => undefined | UpdateVoiceStepKeySpecifier);
    fields?: UpdateVoiceStepFieldPolicy;
  };
  UpdateVoiceStepUIHints?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateVoiceStepUIHintsKeySpecifier
      | (() => undefined | UpdateVoiceStepUIHintsKeySpecifier);
    fields?: UpdateVoiceStepUIHintsFieldPolicy;
  };
  UpdateWriteItForMeConfig?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateWriteItForMeConfigKeySpecifier
      | (() => undefined | UpdateWriteItForMeConfigKeySpecifier);
    fields?: UpdateWriteItForMeConfigFieldPolicy;
  };
  UploadCustomAudio?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UploadCustomAudioKeySpecifier
      | (() => undefined | UploadCustomAudioKeySpecifier);
    fields?: UploadCustomAudioFieldPolicy;
  };
  UploadCustomOutboundCallAudio?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UploadCustomOutboundCallAudioKeySpecifier
      | (() => undefined | UploadCustomOutboundCallAudioKeySpecifier);
    fields?: UploadCustomOutboundCallAudioFieldPolicy;
  };
  UpsellQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpsellQLKeySpecifier
      | (() => undefined | UpsellQLKeySpecifier);
    fields?: UpsellQLFieldPolicy;
  };
  UpsellStrategy?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpsellStrategyKeySpecifier
      | (() => undefined | UpsellStrategyKeySpecifier);
    fields?: UpsellStrategyFieldPolicy;
  };
  UpsertConversationRepairOrderSmartStatusUpdateSettings?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpsertConversationRepairOrderSmartStatusUpdateSettingsKeySpecifier
      | (() =>
          | undefined
          | UpsertConversationRepairOrderSmartStatusUpdateSettingsKeySpecifier);
    fields?: UpsertConversationRepairOrderSmartStatusUpdateSettingsFieldPolicy;
  };
  UpsertRepairOrderSmartStatusUpdateSettings?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpsertRepairOrderSmartStatusUpdateSettingsKeySpecifier
      | (() =>
          | undefined
          | UpsertRepairOrderSmartStatusUpdateSettingsKeySpecifier);
    fields?: UpsertRepairOrderSmartStatusUpdateSettingsFieldPolicy;
  };
  UpsertSubscription?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpsertSubscriptionKeySpecifier
      | (() => undefined | UpsertSubscriptionKeySpecifier);
    fields?: UpsertSubscriptionFieldPolicy;
  };
  UseAfterHoursGreeting?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UseAfterHoursGreetingKeySpecifier
      | (() => undefined | UseAfterHoursGreetingKeySpecifier);
    fields?: UseAfterHoursGreetingFieldPolicy;
  };
  UserConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserConnectionKeySpecifier
      | (() => undefined | UserConnectionKeySpecifier);
    fields?: UserConnectionFieldPolicy;
  };
  UserDirectoryEntryQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserDirectoryEntryQLKeySpecifier
      | (() => undefined | UserDirectoryEntryQLKeySpecifier);
    fields?: UserDirectoryEntryQLFieldPolicy;
  };
  UserEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserEdgeKeySpecifier
      | (() => undefined | UserEdgeKeySpecifier);
    fields?: UserEdgeFieldPolicy;
  };
  UserMetrics?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserMetricsKeySpecifier
      | (() => undefined | UserMetricsKeySpecifier);
    fields?: UserMetricsFieldPolicy;
  };
  UserMetricsConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserMetricsConnectionKeySpecifier
      | (() => undefined | UserMetricsConnectionKeySpecifier);
    fields?: UserMetricsConnectionFieldPolicy;
  };
  UserMetricsEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserMetricsEdgeKeySpecifier
      | (() => undefined | UserMetricsEdgeKeySpecifier);
    fields?: UserMetricsEdgeFieldPolicy;
  };
  UserPhoneQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserPhoneQLKeySpecifier
      | (() => undefined | UserPhoneQLKeySpecifier);
    fields?: UserPhoneQLFieldPolicy;
  };
  UserQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserQLKeySpecifier
      | (() => undefined | UserQLKeySpecifier);
    fields?: UserQLFieldPolicy;
  };
  UserQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserQLConnectionKeySpecifier
      | (() => undefined | UserQLConnectionKeySpecifier);
    fields?: UserQLConnectionFieldPolicy;
  };
  UserQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserQLEdgeKeySpecifier
      | (() => undefined | UserQLEdgeKeySpecifier);
    fields?: UserQLEdgeFieldPolicy;
  };
  UserViewPreferences?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserViewPreferencesKeySpecifier
      | (() => undefined | UserViewPreferencesKeySpecifier);
    fields?: UserViewPreferencesFieldPolicy;
  };
  VCardAttachment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VCardAttachmentKeySpecifier
      | (() => undefined | VCardAttachmentKeySpecifier);
    fields?: VCardAttachmentFieldPolicy;
  };
  VehicleOutputQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VehicleOutputQLKeySpecifier
      | (() => undefined | VehicleOutputQLKeySpecifier);
    fields?: VehicleOutputQLFieldPolicy;
  };
  VideoUploadLinkAttachment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VideoUploadLinkAttachmentKeySpecifier
      | (() => undefined | VideoUploadLinkAttachmentKeySpecifier);
    fields?: VideoUploadLinkAttachmentFieldPolicy;
  };
  VideoUploadLinkAttachmentConnection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | VideoUploadLinkAttachmentConnectionKeySpecifier
      | (() => undefined | VideoUploadLinkAttachmentConnectionKeySpecifier);
    fields?: VideoUploadLinkAttachmentConnectionFieldPolicy;
  };
  VideoUploadLinkAttachmentEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VideoUploadLinkAttachmentEdgeKeySpecifier
      | (() => undefined | VideoUploadLinkAttachmentEdgeKeySpecifier);
    fields?: VideoUploadLinkAttachmentEdgeFieldPolicy;
  };
  VideoUploadLinkQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VideoUploadLinkQLKeySpecifier
      | (() => undefined | VideoUploadLinkQLKeySpecifier);
    fields?: VideoUploadLinkQLFieldPolicy;
  };
  VideoUploadLinkQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VideoUploadLinkQLConnectionKeySpecifier
      | (() => undefined | VideoUploadLinkQLConnectionKeySpecifier);
    fields?: VideoUploadLinkQLConnectionFieldPolicy;
  };
  VideoUploadLinkQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VideoUploadLinkQLEdgeKeySpecifier
      | (() => undefined | VideoUploadLinkQLEdgeKeySpecifier);
    fields?: VideoUploadLinkQLEdgeFieldPolicy;
  };
  Voice?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VoiceKeySpecifier
      | (() => undefined | VoiceKeySpecifier);
    fields?: VoiceFieldPolicy;
  };
  VoiceConfigurationQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VoiceConfigurationQLKeySpecifier
      | (() => undefined | VoiceConfigurationQLKeySpecifier);
    fields?: VoiceConfigurationQLFieldPolicy;
  };
  VoiceScriptQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VoiceScriptQLKeySpecifier
      | (() => undefined | VoiceScriptQLKeySpecifier);
    fields?: VoiceScriptQLFieldPolicy;
  };
  VoiceScriptStep?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VoiceScriptStepKeySpecifier
      | (() => undefined | VoiceScriptStepKeySpecifier);
    fields?: VoiceScriptStepFieldPolicy;
  };
  VoiceScriptStepQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VoiceScriptStepQLKeySpecifier
      | (() => undefined | VoiceScriptStepQLKeySpecifier);
    fields?: VoiceScriptStepQLFieldPolicy;
  };
  VoiceScriptStepQLConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VoiceScriptStepQLConnectionKeySpecifier
      | (() => undefined | VoiceScriptStepQLConnectionKeySpecifier);
    fields?: VoiceScriptStepQLConnectionFieldPolicy;
  };
  VoiceScriptStepQLEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VoiceScriptStepQLEdgeKeySpecifier
      | (() => undefined | VoiceScriptStepQLEdgeKeySpecifier);
    fields?: VoiceScriptStepQLEdgeFieldPolicy;
  };
  VoiceStepUIHints?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VoiceStepUIHintsKeySpecifier
      | (() => undefined | VoiceStepUIHintsKeySpecifier);
    fields?: VoiceStepUIHintsFieldPolicy;
  };
  WaitActionQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WaitActionQLKeySpecifier
      | (() => undefined | WaitActionQLKeySpecifier);
    fields?: WaitActionQLFieldPolicy;
  };
  WriteItForMeAnswerOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WriteItForMeAnswerOptionKeySpecifier
      | (() => undefined | WriteItForMeAnswerOptionKeySpecifier);
    fields?: WriteItForMeAnswerOptionFieldPolicy;
  };
  WriteItForMeConfigQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WriteItForMeConfigQLKeySpecifier
      | (() => undefined | WriteItForMeConfigQLKeySpecifier);
    fields?: WriteItForMeConfigQLFieldPolicy;
  };
  WriteItForMeQuestionNode?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WriteItForMeQuestionNodeKeySpecifier
      | (() => undefined | WriteItForMeQuestionNodeKeySpecifier);
    fields?: WriteItForMeQuestionNodeFieldPolicy;
  };
  WriteItForMeQuestionTree?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WriteItForMeQuestionTreeKeySpecifier
      | (() => undefined | WriteItForMeQuestionTreeKeySpecifier);
    fields?: WriteItForMeQuestionTreeFieldPolicy;
  };
  XTimeLogModelQl?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | XTimeLogModelQlKeySpecifier
      | (() => undefined | XTimeLogModelQlKeySpecifier);
    fields?: XTimeLogModelQlFieldPolicy;
  };
  XTimeLogModelQlConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | XTimeLogModelQlConnectionKeySpecifier
      | (() => undefined | XTimeLogModelQlConnectionKeySpecifier);
    fields?: XTimeLogModelQlConnectionFieldPolicy;
  };
  XTimeLogModelQlEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | XTimeLogModelQlEdgeKeySpecifier
      | (() => undefined | XTimeLogModelQlEdgeKeySpecifier);
    fields?: XTimeLogModelQlEdgeFieldPolicy;
  };
  XTimeLogQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | XTimeLogQLKeySpecifier
      | (() => undefined | XTimeLogQLKeySpecifier);
    fields?: XTimeLogQLFieldPolicy;
  };
  XTimeSyncConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | XTimeSyncConnectionKeySpecifier
      | (() => undefined | XTimeSyncConnectionKeySpecifier);
    fields?: XTimeSyncConnectionFieldPolicy;
  };
  XTimeSyncEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | XTimeSyncEdgeKeySpecifier
      | (() => undefined | XTimeSyncEdgeKeySpecifier);
    fields?: XTimeSyncEdgeFieldPolicy;
  };
  XTimeSyncModelQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | XTimeSyncModelQLKeySpecifier
      | (() => undefined | XTimeSyncModelQLKeySpecifier);
    fields?: XTimeSyncModelQLFieldPolicy;
  };
  XTimeSyncQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | XTimeSyncQLKeySpecifier
      | (() => undefined | XTimeSyncQLKeySpecifier);
    fields?: XTimeSyncQLFieldPolicy;
  };
  XtimeServiceQL?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | XtimeServiceQLKeySpecifier
      | (() => undefined | XtimeServiceQLKeySpecifier);
    fields?: XtimeServiceQLFieldPolicy;
  };
  YelpAttachment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | YelpAttachmentKeySpecifier
      | (() => undefined | YelpAttachmentKeySpecifier);
    fields?: YelpAttachmentFieldPolicy;
  };
  YelpAttachmentConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | YelpAttachmentConnectionKeySpecifier
      | (() => undefined | YelpAttachmentConnectionKeySpecifier);
    fields?: YelpAttachmentConnectionFieldPolicy;
  };
  YelpAttachmentEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | YelpAttachmentEdgeKeySpecifier
      | (() => undefined | YelpAttachmentEdgeKeySpecifier);
    fields?: YelpAttachmentEdgeFieldPolicy;
  };
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;
/* This is an auto-generated file by generateApolloMergeableTypes.js */

export const mergeableTypesArray = [
  'AccountConnection',
  'AccountEdge',
  'AccountPermissionsQL',
  'AccountQL',
  'AccountSettingsQL',
  'ActiveInbox',
  'ActiveInboxOptions',
  'ActiveIntegrationQL',
  'ActiveIntegrationQLConnection',
  'ActiveIntegrationQLEdge',
  'ActivePaymentsCollection',
  'AddAnsweringScriptToPolicy',
  'AddAutomationExitTrigger',
  'AddAvailableIntegration',
  'AddCustomLink',
  'AddCustomer',
  'AddFortellisSubscription',
  'AddLabelToConversation',
  'AddOperatorChannel',
  'AddOperatorPlace',
  'AddOutboundCallCustomization',
  'AddPlaceGroup',
  'AddServiceAdvisor',
  'AddStage',
  'AddStatusItem',
  'AddSubscription',
  'AddUserToTeam',
  'AddVoiceStep',
  'AddressConsentStatusModelQL',
  'AddressQL',
  'AgentChitChatResponse',
  'AnswerOption',
  'AnsweringScriptsQL',
  'AnsweringScriptsQLConnection',
  'AnsweringScriptsQLEdge',
  'AppliedIntentQL',
  'AppliedIntentQLConnection',
  'AppliedIntentQLEdge',
  'AppointmentAgentNoteRatingQL',
  'AppointmentAgentSettingLabelQL',
  'AppointmentAgentSettingsQL',
  'AppointmentAgentSettingsQLConnection',
  'AppointmentAgentSettingsQLEdge',
  'AppointmentAgentStepQL',
  'AppointmentAgentStepQLConnection',
  'AppointmentAgentStepQLEdge',
  'AppointmentLeadCreatedTriggerQL',
  'AppointmentLeadUpdatedTriggerQL',
  'AppointmentQL',
  'AppointmentQLConnection',
  'AppointmentQLEdge',
  'ArchiveMissedCalls',
  'AskYesNoQuestionStepQL',
  'AskYesNoQuestionStepQLConnection',
  'AskYesNoQuestionStepQLEdge',
  'AssignConversationActionQL',
  'AssignConversations',
  'AssignmentDetailsAttachment',
  'AssignmentRetentionChoiceQL',
  'AssignmentRoutingSettingQL',
  'AssistedResponseRatingQL',
  'Attachment',
  'AuthTokens',
  'AutoAssignStepQL',
  'AutoAssignStepQLConnection',
  'AutoAssignStepQLEdge',
  'AutomationAction',
  'AutomationChannels',
  'AutomationConnection',
  'AutomationEdge',
  'AutomationGroupQL',
  'AutomationJobConnection',
  'AutomationJobEdge',
  'AutomationJobQL',
  'AutomationJobQLConnection',
  'AutomationJobQLEdge',
  'AutomationQL',
  'AutomationTrigger',
  'AutomationUIHints',
  'AutopilotJobQL',
  'AutopilotQL',
  'AutopilotQLConnection',
  'AutopilotQLEdge',
  'AutopilotScheduledMessageQL',
  'AvailableIntegrationQL',
  'AvailableVoiceScript',
  'AvailableVoiceStep',
  'BandwidthChannelQL',
  'BaseChannel',
  'BaseChannelConnection',
  'BaseChannelEdge',
  'BaseOutboundProxyNumber',
  'BaseQL',
  'BaseRepairOrder',
  'BillingIdentityConnection',
  'BillingIdentityEdge',
  'BillingIdentityQL',
  'BillingMetadataQL',
  'BrandThemeQL',
  'BuildRepairOrderAssistedStatusQuestionTree',
  'BuildWriteItForMeQuestionTree',
  'BulkUpdateSupportedVehicles',
  'BusinessIdentityModelQL',
  'BusinessProfileQL',
  'BusinessProfileQLConnection',
  'BusinessProfileQLEdge',
  'CDKServiceAdvisorQL',
  'CDKServiceAdvisorQLConnection',
  'CDKServiceAdvisorQLEdge',
  'CRMEmailQL',
  'CallForwardingStepMdnQL',
  'CallForwardingStepQL',
  'CallForwardingStepQLConnection',
  'CallForwardingStepQLEdge',
  'CallIntelligenceRatingQL',
  'CallIntelligenceSettingQL',
  'CallRecordConnection',
  'CallRecordEdge',
  'CallRecordQL',
  'CallRecordingQL',
  'CallRecordingStepQL',
  'CallRecordingStepQLConnection',
  'CallRecordingStepQLEdge',
  'CampaignAutomationQL',
  'CampaignPlaceQL',
  'CampaignQL',
  'CampaignSettingsQL',
  'CancelPaymentRequest',
  'CancelScheduledMessage',
  'CapturePaymentAmount',
  'CardInfo',
  'ChangeAccountSubscription',
  'ChangeAllowCustomAudio',
  'ChangeBusinessVertical',
  'ChangeConversationStateActionQL',
  'ChangeInboxType',
  'ChangeNotificationSettings',
  'ChangePlaceGroup',
  'ChangePlaceHours',
  'ChangePlaceSubscription',
  'ChangeRepairOrderSchedule',
  'ChangeSignupMode',
  'ChangeSwipeActionSettings',
  'ChangeTwilioChannelMDN',
  'ChangeUserPassword',
  'ChangeUserSettings',
  'ChangeUserVideoConferenceUrl',
  'Channel',
  'ChargeBeeSubscription',
  'CheckBusinessHoursStepQL',
  'CheckBusinessHoursStepQLConnection',
  'CheckBusinessHoursStepQLEdge',
  'CheckForLabelStepQL',
  'CheckForLabelStepQLConnection',
  'CheckForLabelStepQLEdge',
  'CheckOpportunityStatusActionQL',
  'CheckRepairOrderDetailsActionQL',
  'CloseStatusItem',
  'CompleteAutopilot',
  'CompleteTask',
  'ComplianceReminder',
  'ComplianceSettingsQL',
  'ConnectAutomationAction',
  'ConnectAutomationActionEdge',
  'ContentSummaryQL',
  'ContentTypesQL',
  'ConversationArchivedTriggerQL',
  'ConversationBreakdownEntryQL',
  'ConversationConnection',
  'ConversationEdge',
  'ConversationLabelQL',
  'ConversationLabelQLConnection',
  'ConversationLabelQLEdge',
  'ConversationMarkedAsHeatCaseTriggerQL',
  'ConversationPreviewContentQL',
  'ConversationQL',
  'ConversationQLConnection',
  'ConversationQLEdge',
  'ConversationRepairOrderSmartStatusUpdateSettingsQL',
  'ConversationStartedTriggerQL',
  'ConversationStateStepQL',
  'ConversationStateStepQLConnection',
  'ConversationStateStepQLEdge',
  'ConversationStatsQL',
  'ConversationTagQL',
  'ConversationalSchedulingAgentStepQl',
  'ConversationalSchedulingAgentStepQlConnection',
  'ConversationalSchedulingAgentStepQlEdge',
  'CreateA2PCampaignForPlace',
  'CreateAgentChitChat',
  'CreateAppointmentAgentSettingLabel',
  'CreateAppointmentAgentSettings',
  'CreateAutomation',
  'CreateAutomationAction',
  'CreateAutomationFromBlueprint',
  'CreateAutopilot',
  'CreateBillingIdentity',
  'CreateCampaign',
  'CreateCampaignResult',
  'CreateChatExpansion',
  'CreateConversation',
  'CreateConversationSummary',
  'CreateConversationTextExpansion',
  'CreateCustomDirectoryEntry',
  'CreateDepartmentDevice',
  'CreateIdentityPromptAddress',
  'CreateLabel',
  'CreateManualCampaignUpload',
  'CreateManualCampaignUploadResult',
  'CreateNoteTaker',
  'CreateOperator',
  'CreateOutboundConferenceCall',
  'CreateOutboundProxyCall',
  'CreateParticipant',
  'CreateParticipantPaymentRequest',
  'CreatePaymentRequest',
  'CreatePhoneLine',
  'CreatePlace',
  'CreatePortalSession',
  'CreateScheduledMessage',
  'CreateShortcut',
  'CreateStripeAccount',
  'CreateStripeRefund',
  'CreateTaskForEngagement',
  'CreateTeam',
  'CreateTextExpansion',
  'CreateUser',
  'CreateUserPhone',
  'CreateVideoUploadLink',
  'CrmContactCdkQL',
  'CrmContactCnamQL',
  'CrmContactDealertrackQL',
  'CrmContactFortellisQL',
  'CrmContactQL',
  'CrmUserModelQL',
  'CrmUserModelQLConnection',
  'CrmUserModelQLEdge',
  'CubeJwtTokenQL',
  'CurbsideSettingsQL',
  'CustomAudioOverrides',
  'CustomDirectoryEntryModelQL',
  'CustomDirectoryEntryQL',
  'CustomDisclosureSpeech',
  'CustomOutboundCallAudioOverrides',
  'CustomerContactedTriggerQL',
  'CustomerQL',
  'CustomerQLConnection',
  'CustomerQLEdge',
  'CustomizedIntentQL',
  'DMSHistoryConnection',
  'DMSHistoryEdge',
  'DMSHistoryQL',
  'DeactivateAccount',
  'DealerTrackServiceAdvisorQL',
  'DefaultBroadcastInputsQL',
  'DeleteAppointmentAgentSettingLabel',
  'DeleteAppointmentAgentSettings',
  'DeleteAutomation',
  'DeleteConversation',
  'DeleteCustomDirectoryEntry',
  'DeleteCustomLink',
  'DeleteDepartmentDevice',
  'DeleteIdentityPromptAddress',
  'DeleteNoteTaker',
  'DeleteOutboundCallCustomization',
  'DeletePhoneLine',
  'DeletePlace',
  'DeleteScheduledMessage',
  'DeleteShortcut',
  'DeleteStage',
  'DeleteStatusItem',
  'DeleteTeam',
  'DeleteUserPhone',
  'DeleteVoiceStep',
  'DepartmentDeviceQL',
  'DepartmentDeviceQLConnection',
  'DepartmentDeviceQLEdge',
  'DepartmentDirectoryEntryQL',
  'DepartmentDirectoryEntryQLConnection',
  'DepartmentDirectoryEntryQLEdge',
  'DepartmentQL',
  'DepartmentQLConnection',
  'DepartmentQLEdge',
  'DialogFlowBotDataQL',
  'DialogFlowBotDataQLConnection',
  'DialogFlowBotDataQLEdge',
  'DirectoryDeviceQL',
  'DirectoryEntryQL',
  'DisableAutopilot',
  'DisableFortellisSubscription',
  'DiscardAutomationEdits',
  'DiscardDisruptionVoiceScript',
  'DiscardVoiceScript',
  'DismissTask',
  'DisputeQL',
  'DisruptionsQL',
  'DuplicateAppointmentAgentSettings',
  'ETOSettingsQL',
  'EarlyExitAnalysisQL',
  'EarlyExitDetailQL',
  'EmployeeQL',
  'EnableInboxLanguageOverride',
  'EnableNudges',
  'EnablePlaceMessagingHours',
  'EndOutboundConferenceCall',
  'EngagementInboxAgentResultQL',
  'EngagementQL',
  'EngagementStatusRatingQL',
  'EngagementSummaryRatingQL',
  'EnrollmentCriteriaQL',
  'EquityTradeOpportunityCreatedTriggerQL',
  'EquityTradeOpportunityQL',
  'EquityTradeOpportunityQLConnection',
  'EquityTradeOpportunityQLEdge',
  'EscalateConversationActionQL',
  'EvaluateBusinessIdentity',
  'EvaluationTimeQL',
  'ExportConversationToArchive',
  'ExternalCRMUserQL',
  'ExternalOpcodeQL',
  'ExternalVehicleConnection',
  'ExternalVehicleEdge',
  'ExternalVehicleOverrideQL',
  'ExternalVehicleQL',
  'FacebookChannelQL',
  'FacebookReviewSite',
  'FileAttachment',
  'ForceActiveIntegrationSync',
  'FortellisServiceAdvisorQL',
  'FortellisSubscriptionConnection',
  'FortellisSubscriptionEdge',
  'FortellisSubscriptionQL',
  'FortellisSubscriptionQLConnection',
  'FortellisSubscriptionQLEdge',
  'GenerateRepairOrderAssistedStatusContent',
  'GenerateRepairOrderNotesSummary',
  'GenerateWriteItForMeContent',
  'GlobalSyncXtimeServices',
  'GoogleChannelQL',
  'GoogleReviewSite',
  'GreetingQL',
  'GreetingStepQL',
  'GreetingStepQLConnection',
  'GreetingStepQLEdge',
  'GuideChecklistQL',
  'HandToOpportunityAgentActionQL',
  'HasLabelActionQL',
  'HostedPage',
  'HostedSmsCompleted',
  'HostedSmsPortQL',
  'HostedSmsPortQLConnection',
  'HostedSmsPortQLEdge',
  'IdentityPromptAddressQL',
  'IdentityPromptAddressQLConnection',
  'IdentityPromptAddressQLEdge',
  'ImageAttachment',
  'Impersonate',
  'ImportHostedSms',
  'InboxConnection',
  'InboxEdge',
  'InboxQL',
  'IncreaseShortcutCount',
  'IntentClassifierQL',
  'IntentClassifierQLConnection',
  'IntentClassifierQLEdge',
  'IntentQuestionQL',
  'IntentQuestionQLConnection',
  'IntentQuestionQLEdge',
  'IsBusinessHoursActionQL',
  'LabelAddedTriggerQL',
  'LabelConversationStepQL',
  'LabelConversationStepQLConnection',
  'LabelConversationStepQLEdge',
  'LabelQL',
  'LabelQLConnection',
  'LabelQLEdge',
  'LabelRemovedTriggerQL',
  'LeaderboardColorsQL',
  'LeaveAllConversations',
  'LeaveConversations',
  'LeaveNoteActionQL',
  'LegacyCrmContactQL',
  'LibraryIntentQL',
  'Link',
  'LinkGroup',
  'ManageLabelActionQL',
  'ManageLabelsOperation',
  'ManagerDashboard',
  'ManualOpportunity',
  'ManualOpportunityCustomerInformationQL',
  'ManualOpportunityQL',
  'ManualOpportunityReportQL',
  'ManualOpportunityResult',
  'ManualOpportunityTriggerQL',
  'MapCrmUserToUser',
  'MarkMessagesRead',
  'MentionQL',
  'MentionQLConnection',
  'MentionQLEdge',
  'MessageConnection',
  'MessageEdge',
  'MessageMetadataQL',
  'MessageQL',
  'MessageQLConnection',
  'MessageQLEdge',
  'MessageReceivedTriggerQL',
  'MessageType',
  'MoveStatusItem',
  'MultiChoiceAttachment',
  'Mutations',
  'Node',
  'NoteAttachment',
  'NoteChannelQL',
  'NoteTakerConnection',
  'NoteTakerEdge',
  'NoteTakerQL',
  'NoteTakerQLConnection',
  'NoteTakerQLEdge',
  'NoteTakerStepQL',
  'NoteTakerStepQLConnection',
  'NoteTakerStepQLEdge',
  'NotifyTeamMemberActionQL',
  'NumaServiceQL',
  'NumboxAgentSessionQL',
  'NumboxAgentSessionQLConnection',
  'NumboxAgentSessionQLEdge',
  'NumboxChannelQL',
  'Objection',
  'OpCodeQL',
  'OpCodeQLConnection',
  'OpCodeQLEdge',
  'OpCodesFilter',
  'OpcodeOutputQL',
  'OpenVoiceQuestionAttachment',
  'OperatorAgentStepQL',
  'OperatorAgentStepQLConnection',
  'OperatorAgentStepQLEdge',
  'OperatorChannelQL',
  'OperatorPlaceQL',
  'OperatorQL',
  'OperatorQLConnection',
  'OperatorQLEdge',
  'OperatorSessionConnection',
  'OperatorSessionEdge',
  'OperatorSessionQL',
  'OperatorSessionQLConnection',
  'OperatorSessionQLEdge',
  'OperatorSettingsQL',
  'OperatorTranscriptQL',
  'OpportunityInfo',
  'OpportunityServiceAppointmentConfirmationTriggerQL',
  'OpportunityServiceAppointmentReminderTriggerQL',
  'OrderQL',
  'OutboundCallCustomizationQL',
  'OutboundCallCustomizationQLConnection',
  'OutboundCallCustomizationQLEdge',
  'OutboundCallSettingQL',
  'OutboundConferenceCallQL',
  'OutboundConferenceCallQLConnection',
  'OutboundConferenceCallQLEdge',
  'OutboundProxyCallQL',
  'OutboundProxyCallQLConnection',
  'OutboundProxyCallQLEdge',
  'OutboundProxyNumber',
  'OutboundProxyTwilioNumberQL',
  'PageInfo',
  'PaletteQL',
  'ParticipantConnection',
  'ParticipantEdge',
  'ParticipantQL',
  'ParticipantQLConnection',
  'ParticipantQLEdge',
  'PaymentRequestConnection',
  'PaymentRequestCustomizationQL',
  'PaymentRequestEdge',
  'PaymentRequestQL',
  'PaymentRequestQLConnection',
  'PaymentRequestQLEdge',
  'PhoneCallQL',
  'PhoneCallQLConnection',
  'PhoneCallQLEdge',
  'PhoneLinePolicyQL',
  'PhoneLinePolicyQLConnection',
  'PhoneLinePolicyQLEdge',
  'PhoneLineQL',
  'PhoneLineQLConnection',
  'PhoneLineQLEdge',
  'PickupStepQL',
  'PickupStepQLConnection',
  'PickupStepQLEdge',
  'PlaceConnection',
  'PlaceEdge',
  'PlaceGroupConnection',
  'PlaceGroupEdge',
  'PlaceGroupQL',
  'PlaceGroupQLConnection',
  'PlaceGroupQLEdge',
  'PlaceInfoQL',
  'PlaceMetrics',
  'PlaceMetricsConnection',
  'PlaceMetricsEdge',
  'PlacePermissionsQL',
  'PlaceQL',
  'PlaceQLConnection',
  'PlaceQLEdge',
  'PlaceVoiceSettingsQL',
  'PlacesUsersQL',
  'PlacesUsersQLConnection',
  'PlacesUsersQLEdge',
  'PokeUser',
  'PopulateBusinessProfileWithChargebeeInfo',
  'PortInPhoneLine',
  'PredictedMessageIntentQL',
  'PressAnyKeyStepQL',
  'PubNubConfigQL',
  'PublicListingQL',
  'PublishAutomation',
  'PublishDisruptionVoiceScript',
  'PublishVoiceScript',
  'QualificationSurveyQL',
  'QualifyStepQL',
  'QualifyStepQLConnection',
  'QualifyStepQLEdge',
  'Query',
  'QuestionAgentSettingsQL',
  'QuestionAgentSettingsQLConnection',
  'QuestionAgentSettingsQLEdge',
  'QuestionBotStepQL',
  'QuestionBotStepQLConnection',
  'QuestionBotStepQLEdge',
  'QuestionNode',
  'QuestionTree',
  'ReasonSentGreetingQL',
  'ReasonSentHangupResponseQL',
  'ReasonSentIntentQL',
  'ReasonSentQL',
  'RecoverConversation',
  'RefreshCarrierInfo',
  'RefreshFortellisServiceAdvisors',
  'RefundQL',
  'RefundQLConnection',
  'RefundQLEdge',
  'RegisterFortellisServiceAdvisor',
  'RegisteredFortellisServiceAdvisorQL',
  'RemoveAutomationAction',
  'RemoveAutomationExitTrigger',
  'RemoveLabelFromConversation',
  'RemovePlaceGroup',
  'RemoveServiceAdvisor',
  'RemoveUserFromPlace',
  'RemoveUserFromTeam',
  'RemoveVideoUploadLink',
  'RenameAccount',
  'RenamePlace',
  'ReopenStatusItem',
  'RepairOrder',
  'RepairOrderClosedTriggerQL',
  'RepairOrderConnection',
  'RepairOrderEdge',
  'RepairOrderFortellisQL',
  'RepairOrderFortellisQLConnection',
  'RepairOrderFortellisQLEdge',
  'RepairOrderNotesSummaryQL',
  'RepairOrderOpenedTriggerQL',
  'RepairOrderSmartStatusUpdateSettingsQL',
  'RepairOrderUpdateFilter',
  'RepairOrderUpdatedCondition',
  'RepairOrderUpdatedConditionValue',
  'RepairOrderUpdatedTriggerQL',
  'RepairServiceQL',
  'RepairServiceQLConnection',
  'RepairServiceQLEdge',
  'RequestAvailableIntegration',
  'ResetAppointmentAgentSettings',
  'ResetBrandTheme',
  'ResetConversationLanguage',
  'ResetOutboundChannels',
  'ResetTaskStatus',
  'ResetVoiceScript',
  'ResolutionStep',
  'ReviewAttachment',
  'ReviewAttachmentConnection',
  'ReviewAttachmentEdge',
  'ReviewFeedbackQL',
  'ReviewJobQL',
  'ReviewJobQLConnection',
  'ReviewJobQLEdge',
  'ReviewQL',
  'ReviewQLConnection',
  'ReviewQLEdge',
  'ReviewSite',
  'ReviewSiteInterface',
  'ScheduleMessageActionQL',
  'ScheduleMessageConnection',
  'ScheduleMessageEdge',
  'ScheduledMessageQL',
  'ScheduledMessageQLConnection',
  'ScheduledMessageQLEdge',
  'SchedulerLogQL',
  'SchedulerSyncConnection',
  'SchedulerSyncEdge',
  'SchedulerSyncQL',
  'SendBroadcast',
  'SendFeedbackActionQL',
  'SendLoa',
  'SendMessage',
  'SendMessageActionQL',
  'SendReviewActionQL',
  'SendReviewRequest',
  'SendScheduledMessageNow',
  'SendStatusItemMessage',
  'SendVCard',
  'ServiceAdvisorQL',
  'ServiceSubItemSummary',
  'ServiceSummariesItem',
  'ServiceSummariesQL',
  'SetAssignmentRetention',
  'SetBusinessTimezone',
  'SetFortellisLookupId',
  'SetHangupSuggestion',
  'SetOptInStatus',
  'SetResetOngoingOptin',
  'SetResetOptinDays',
  'SetupEquityTradeOpportunityCampaign',
  'ShortcutConnection',
  'ShortcutEdge',
  'ShortcutQL',
  'SkuConnection',
  'SkuEdge',
  'SkuEntitlementsQL',
  'SkuQL',
  'SmartTopicAttachment',
  'SmartTopicLinksQL',
  'SmartTopicStepQL',
  'SmartTopicStepQLConnection',
  'SmartTopicStepQLEdge',
  'SnoozeConversation',
  'SpeakStepQL',
  'SpeakStepQLConnection',
  'SpeakStepQLEdge',
  'SpecialQuestionQL',
  'SpecialQuestionQLConnection',
  'SpecialQuestionQLEdge',
  'StaffMemberCallGoesPoorlyTriggerQL',
  'StageQL',
  'StageQLConnection',
  'StageQLEdge',
  'StartConversation',
  'StartConversationWithScheduledMessage',
  'StatusItemConnection',
  'StatusItemEdge',
  'StatusItemQL',
  'StatusItemQLConnection',
  'StatusItemQLEdge',
  'StatusSummaryQL',
  'StatusUpdaterStepQL',
  'StatusUpdaterStepQLConnection',
  'StatusUpdaterStepQLEdge',
  'StripeIntegrationQL',
  'StripeIntegrationQLConnection',
  'StripeIntegrationQLEdge',
  'Submit10DLCStarterProfile',
  'SubmitBusinessIdentity',
  'SubscriptionQL',
  'SubscriptionQLConnection',
  'SubscriptionQLEdge',
  'SummarizeConversationActionQL',
  'SupportedVehiclesConnection',
  'SupportedVehiclesEdge',
  'SupportedVehiclesOpcodesQL',
  'SupportedVehiclesOpcodesQLConnection',
  'SupportedVehiclesOpcodesQLEdge',
  'SupportedVehiclesQL',
  'SurveyAnsweredTriggerQL',
  'SurveyAnsweredUpdateFilter',
  'SyncXtimeServices',
  'SystemMessageSettings',
  'TaskActionQL',
  'TaskQL',
  'TeachNuma',
  'TeamConnection',
  'TeamEdge',
  'TeamQL',
  'TeamQLConnection',
  'TeamQLEdge',
  'TenDLCProcessQL',
  'TenDLCStatusQL',
  'TextGenerationChatMessageQL',
  'TextGenerationQL',
  'TextOptinStepQL',
  'TextOptinStepQLConnection',
  'TextOptinStepQLEdge',
  'ToggleCustomPhoneLinePolicy',
  'ToggleOutboundProxyCallRecording',
  'TranscriptAnalysisQL',
  'TranscriptEventQL',
  'TranscriptQL',
  'TranscriptQLConnection',
  'TranscriptQLEdge',
  'TranscriptScoreQL',
  'TranscriptSectionQL',
  'TranslatedMessage',
  'TransportationSetOptionQL',
  'TransportationSetQL',
  'TransportationSetQLConnection',
  'TransportationSetQLEdge',
  'TransportationSetRepairServiceQL',
  'TransportationSetRepairServiceQLConnection',
  'TransportationSetRepairServiceQLEdge',
  'TwilioA2PCampaignQL',
  'TwilioBrandRegistrationQL',
  'TwilioChannelQL',
  'TwilioChannelQLConnection',
  'TwilioChannelQLEdge',
  'TwilioTrustProductError',
  'TwilioTrustProductQL',
  'TypingIndicatorQL',
  'UnmapCrmUserFromUser',
  'UpdateActiveIntegration',
  'UpdateAgentChitChat',
  'UpdateAnsweringScriptOrder',
  'UpdateAppointment',
  'UpdateAppointmentAgentSettingLabel',
  'UpdateAppointmentAgentSettings',
  'UpdateAssignmentRoutingSettings',
  'UpdateAutomation',
  'UpdateAutomationAction',
  'UpdateAutomationEnrollmentCriteria',
  'UpdateAutomationExitTrigger',
  'UpdateAutomationStartTrigger',
  'UpdateAutomationUIHints',
  'UpdateAutopilotEta',
  'UpdateAutopilotJob',
  'UpdateAutopilotScheduledMessage',
  'UpdateAvailableIntegration',
  'UpdateAwayMode',
  'UpdateAwayModeAssignee',
  'UpdateAwayModeManagingPermission',
  'UpdateAwayModeWithTime',
  'UpdateBillingMetadata',
  'UpdateBrandLogo',
  'UpdateBrandTheme',
  'UpdateBusinessIdentity',
  'UpdateBusinessProfile',
  'UpdateCallForwardingStatus',
  'UpdateCallIntelligenceEnabled',
  'UpdateCallIntelligenceSetting',
  'UpdateCampaignStatus',
  'UpdateCampaignStatusResult',
  'UpdateChannel',
  'UpdateComplianceSettings',
  'UpdateConversationLabel',
  'UpdateConversations',
  'UpdateCurbsideSettings',
  'UpdateCustomDirectoryEntry',
  'UpdateDefaultView',
  'UpdateDefaultYouView',
  'UpdateDepartmentDevice',
  'UpdateDirectoryEntry',
  'UpdateETOSettings',
  'UpdateEdgesVoiceStep',
  'UpdateEquityTradeOpportunityStage',
  'UpdateEscalationSettings',
  'UpdateGreeting',
  'UpdateHasDismissedGuideChecklist',
  'UpdateHasViewedRefer',
  'UpdateHideSharedInboxViews',
  'UpdateHostedSms',
  'UpdateIsScheduleEnabled',
  'UpdateIsUnassigningInboundMessages',
  'UpdateLabel',
  'UpdateLanguageSettings',
  'UpdateLink',
  'UpdateLinkUrls',
  'UpdateLoggedCall',
  'UpdateLogos',
  'UpdateMissedCallFollowUpSetting',
  'UpdateNamePronunciation',
  'UpdateNewConversationsPerDay',
  'UpdateOperator',
  'UpdateOperatorChannel',
  'UpdateOperatorPlaceDescription',
  'UpdateOperatorPlaceSettings',
  'UpdateOperatorSettings',
  'UpdateOpportunityActionQL',
  'UpdateOutboundCallCustomization',
  'UpdateOutboundConferenceCall',
  'UpdateParticipant',
  'UpdatePaymentRequestAttachment',
  'UpdatePaymentRequestCustomization',
  'UpdatePhoneCall',
  'UpdatePhoneLine',
  'UpdatePhoneLineLanguageSettings',
  'UpdatePhoneLineName',
  'UpdatePhoneLinePolicy',
  'UpdatePlaceDisruptionSettings',
  'UpdatePlaceGroup',
  'UpdatePlaceInfo',
  'UpdatePlaceMFASettings',
  'UpdatePlaceMessageSettings',
  'UpdatePlaceOutboundCallSettings',
  'UpdatePlaceQuota',
  'UpdatePlaceStatus',
  'UpdatePlaceVoice',
  'UpdatePublicListing',
  'UpdateQuestionAgentSettings',
  'UpdateReceivesEscalations',
  'UpdateRepairServicesOpCodes',
  'UpdateReviewJob',
  'UpdateServiceAdvisor',
  'UpdateServiceOverride',
  'UpdateShortcut',
  'UpdateShowBannerAfter',
  'UpdateStage',
  'UpdateStatusBoardView',
  'UpdateStatusItem',
  'UpdateTeam',
  'UpdateTransportationSet',
  'UpdateTwilioChannel',
  'UpdateUseNewNumber',
  'UpdateUser',
  'UpdateUserInformation',
  'UpdateUserMFASettings',
  'UpdateUserPersonalization',
  'UpdateUserPhone',
  'UpdateUserPhonePreference',
  'UpdateUserSchedule',
  'UpdateUserViewPreferences',
  'UpdateVideoUploadLink',
  'UpdateVoiceScript',
  'UpdateVoiceStep',
  'UpdateVoiceStepUIHints',
  'UpdateWriteItForMeConfig',
  'UploadCustomAudio',
  'UploadCustomOutboundCallAudio',
  'UpsellQL',
  'UpsellStrategy',
  'UpsertConversationRepairOrderSmartStatusUpdateSettings',
  'UpsertRepairOrderSmartStatusUpdateSettings',
  'UpsertSubscription',
  'UseAfterHoursGreeting',
  'UserConnection',
  'UserDirectoryEntryQL',
  'UserEdge',
  'UserMetrics',
  'UserMetricsConnection',
  'UserMetricsEdge',
  'UserPhoneQL',
  'UserQL',
  'UserQLConnection',
  'UserQLEdge',
  'UserViewPreferences',
  'VCardAttachment',
  'VehicleOutputQL',
  'VideoUploadLinkAttachment',
  'VideoUploadLinkAttachmentConnection',
  'VideoUploadLinkAttachmentEdge',
  'VideoUploadLinkQL',
  'VideoUploadLinkQLConnection',
  'VideoUploadLinkQLEdge',
  'Voice',
  'VoiceConfigurationQL',
  'VoiceScriptQL',
  'VoiceScriptStep',
  'VoiceScriptStepQL',
  'VoiceScriptStepQLConnection',
  'VoiceScriptStepQLEdge',
  'VoiceStepUIHints',
  'WaitActionQL',
  'WriteItForMeAnswerOption',
  'WriteItForMeConfigQL',
  'WriteItForMeQuestionNode',
  'WriteItForMeQuestionTree',
  'XTimeLogModelQl',
  'XTimeLogModelQlConnection',
  'XTimeLogModelQlEdge',
  'XTimeLogQL',
  'XTimeSyncConnection',
  'XTimeSyncEdge',
  'XTimeSyncModelQL',
  'XTimeSyncQL',
  'XtimeServiceQL',
  'YelpAttachment',
  'YelpAttachmentConnection',
  'YelpAttachmentEdge',
];
